
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0dc9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0dc9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $72b03fdf46effee2$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.1.1";

});

parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 256, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194048) && ($dca0ddb82b882518$var$nextTransitionLane = 256);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_417) {
            var $dca0ddb82b882518$var$element$jscomp$inline_418 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_418.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = $dca0ddb82b882518$var$isSupported$jscomp$inline_417;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState$1 = null);
        $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$38);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, $dca0ddb82b882518$var$createEffectInstance(), create, createDeps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, createDeps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateEffect(create, createDeps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$41 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$41, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(init);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, init = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = init, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = init), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState = null;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects(wasDelayedCommit) {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects(wasDelayedCommit);
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$174, root$174 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1528 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1528 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1528++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1529 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1528], $dca0ddb82b882518$var$domEventName$jscomp$inline_1530 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1529.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1530, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $dca0ddb82b882518$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$244 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$244 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $dca0ddb82b882518$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$250)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane();
                            lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $acw62.version;
if ("19.1.1" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.1"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2257.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2257.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2257.inject($dca0ddb82b882518$var$internals$jscomp$inline_2256), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});


parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $6b3372b60d35b33f$export$998bcd577473dd93, (v) => $6b3372b60d35b33f$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $6b3372b60d35b33f$export$3d6c20d97e46b957, (v) => $6b3372b60d35b33f$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$998bcd577473dd93;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$3d6c20d97e46b957;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = Symbol.for("react.element"), $6b3372b60d35b33f$var$c = Symbol.for("react.portal"), $6b3372b60d35b33f$var$d = Symbol.for("react.fragment"), $6b3372b60d35b33f$var$e = Symbol.for("react.strict_mode"), $6b3372b60d35b33f$var$f = Symbol.for("react.profiler"), $6b3372b60d35b33f$var$g = Symbol.for("react.provider"), $6b3372b60d35b33f$var$h = Symbol.for("react.context"), $6b3372b60d35b33f$var$k = Symbol.for("react.server_context"), $6b3372b60d35b33f$var$l = Symbol.for("react.forward_ref"), $6b3372b60d35b33f$var$m = Symbol.for("react.suspense"), $6b3372b60d35b33f$var$n = Symbol.for("react.suspense_list"), $6b3372b60d35b33f$var$p = Symbol.for("react.memo"), $6b3372b60d35b33f$var$q = Symbol.for("react.lazy"), $6b3372b60d35b33f$var$t = Symbol.for("react.offscreen"), $6b3372b60d35b33f$var$u;
$6b3372b60d35b33f$var$u = Symbol.for("react.module.reference");
function $6b3372b60d35b33f$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$l:
                            case $6b3372b60d35b33f$var$q:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return r;
        }
    }
}
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$b;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$q;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$998bcd577473dd93 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$q;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$m;
};
$6b3372b60d35b33f$export$3d6c20d97e46b957 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$n || a === $6b3372b60d35b33f$var$t || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$q || a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$l || a.$$typeof === $6b3372b60d35b33f$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$v;

});

parcelRegister("3hCk4", function(module, exports) {
/*! https://mths.be/punycode v1.4.0 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.3.2',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("2Nl4L", function(module, exports) {
/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    'use strict';
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (module.exports) // Node
    module.exports = factory();
    else if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // Browser globals (root is window)
    root.IPv6 = factory(root);
})(module.exports, function(root) {
    'use strict';
    /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */ // save current IPv6 variable, if any
    var _IPv6 = root && root.IPv6;
    function bestPresentation(address) {
        // based on:
        // Javascript to test an IPv6 address for proper format, and to
        // present the "best text representation" according to IETF Draft RFC at
        // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
        // 8 Feb 2010 Rich Brown, Dartware, LLC
        // Please feel free to use this code as long as you provide a link to
        // http://www.intermapper.com
        // http://intermapper.com/support/tools/IPV6-Validator.aspx
        // http://download.dartware.com/thirdparty/ipv6validator.js
        var _address = address.toLowerCase();
        var segments = _address.split(':');
        var length = segments.length;
        var total = 8;
        // trim colons (:: or ::a:b:c… or …a:b:c::)
        if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
            // must have been ::
            // remove first two items
            segments.shift();
            segments.shift();
        } else if (segments[0] === '' && segments[1] === '') // must have been ::xxxx
        // remove the first item
        segments.shift();
        else if (segments[length - 1] === '' && segments[length - 2] === '') // must have been xxxx::
        segments.pop();
        length = segments.length;
        // adjust total segments for IPv4 trailer
        if (segments[length - 1].indexOf('.') !== -1) // found a "." which means IPv4
        total = 7;
        // fill empty segments them with "0000"
        var pos;
        for(pos = 0; pos < length; pos++){
            if (segments[pos] === '') break;
        }
        if (pos < total) {
            segments.splice(pos, 1, '0000');
            while(segments.length < total)segments.splice(pos, 0, '0000');
        }
        // strip leading zeros
        var _segments;
        for(var i = 0; i < total; i++){
            _segments = segments[i].split('');
            for(var j = 0; j < 3; j++){
                if (_segments[0] === '0' && _segments.length > 1) _segments.splice(0, 1);
                else break;
            }
            segments[i] = _segments.join('');
        }
        // find longest sequence of zeroes and coalesce them into one segment
        var best = -1;
        var _best = 0;
        var _current = 0;
        var current = -1;
        var inzeroes = false;
        // i; already declared
        for(i = 0; i < total; i++){
            if (inzeroes) {
                if (segments[i] === '0') _current += 1;
                else {
                    inzeroes = false;
                    if (_current > _best) {
                        best = current;
                        _best = _current;
                    }
                }
            } else if (segments[i] === '0') {
                inzeroes = true;
                current = i;
                _current = 1;
            }
        }
        if (_current > _best) {
            best = current;
            _best = _current;
        }
        if (_best > 1) segments.splice(best, _best, '');
        length = segments.length;
        // assemble remaining segments
        var result = '';
        if (segments[0] === '') result = ':';
        for(i = 0; i < length; i++){
            result += segments[i];
            if (i === length - 1) break;
            result += ':';
        }
        if (segments[length - 1] === '') result += ':';
        return result;
    }
    function noConflict() {
        /*jshint validthis: true */ if (root.IPv6 === this) root.IPv6 = _IPv6;
        return this;
    }
    return {
        best: bestPresentation,
        noConflict: noConflict
    };
});

});

parcelRegister("3PMOQ", function(module, exports) {
/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    'use strict';
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (module.exports) // Node
    module.exports = factory();
    else if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
})(module.exports, function(root) {
    'use strict';
    // save current SecondLevelDomains variable, if any
    var _SecondLevelDomains = root && root.SecondLevelDomains;
    var SLD = {
        // list of known Second Level Domains
        // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
        // ----
        // publicsuffix.org is more current and actually used by a couple of browsers internally.
        // downside is it also contains domains like "dyndns.org" - which is fine for the security
        // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
        // ----
        list: {
            'ac': ' com gov mil net org ',
            'ae': ' ac co gov mil name net org pro sch ',
            'af': ' com edu gov net org ',
            'al': ' com edu gov mil net org ',
            'ao': ' co ed gv it og pb ',
            'ar': ' com edu gob gov int mil net org tur ',
            'at': ' ac co gv or ',
            'au': ' asn com csiro edu gov id net org ',
            'ba': ' co com edu gov mil net org rs unbi unmo unsa untz unze ',
            'bb': ' biz co com edu gov info net org store tv ',
            'bh': ' biz cc com edu gov info net org ',
            'bn': ' com edu gov net org ',
            'bo': ' com edu gob gov int mil net org tv ',
            'br': ' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
            'bs': ' com edu gov net org ',
            'bz': ' du et om ov rg ',
            'ca': ' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
            'ck': ' biz co edu gen gov info net org ',
            'cn': ' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
            'co': ' com edu gov mil net nom org ',
            'cr': ' ac c co ed fi go or sa ',
            'cy': ' ac biz com ekloges gov ltd name net org parliament press pro tm ',
            'do': ' art com edu gob gov mil net org sld web ',
            'dz': ' art asso com edu gov net org pol ',
            'ec': ' com edu fin gov info med mil net org pro ',
            'eg': ' com edu eun gov mil name net org sci ',
            'er': ' com edu gov ind mil net org rochest w ',
            'es': ' com edu gob nom org ',
            'et': ' biz com edu gov info name net org ',
            'fj': ' ac biz com info mil name net org pro ',
            'fk': ' ac co gov net nom org ',
            'fr': ' asso com f gouv nom prd presse tm ',
            'gg': ' co net org ',
            'gh': ' com edu gov mil org ',
            'gn': ' ac com gov net org ',
            'gr': ' com edu gov mil net org ',
            'gt': ' com edu gob ind mil net org ',
            'gu': ' com edu gov net org ',
            'hk': ' com edu gov idv net org ',
            'hu': ' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
            'id': ' ac co go mil net or sch web ',
            'il': ' ac co gov idf k12 muni net org ',
            'in': ' ac co edu ernet firm gen gov i ind mil net nic org res ',
            'iq': ' com edu gov i mil net org ',
            'ir': ' ac co dnssec gov i id net org sch ',
            'it': ' edu gov ',
            'je': ' co net org ',
            'jo': ' com edu gov mil name net org sch ',
            'jp': ' ac ad co ed go gr lg ne or ',
            'ke': ' ac co go info me mobi ne or sc ',
            'kh': ' com edu gov mil net org per ',
            'ki': ' biz com de edu gov info mob net org tel ',
            'km': ' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
            'kn': ' edu gov net org ',
            'kr': ' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
            'kw': ' com edu gov net org ',
            'ky': ' com edu gov net org ',
            'kz': ' com edu gov mil net org ',
            'lb': ' com edu gov net org ',
            'lk': ' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
            'lr': ' com edu gov net org ',
            'lv': ' asn com conf edu gov id mil net org ',
            'ly': ' com edu gov id med net org plc sch ',
            'ma': ' ac co gov m net org press ',
            'mc': ' asso tm ',
            'me': ' ac co edu gov its net org priv ',
            'mg': ' com edu gov mil nom org prd tm ',
            'mk': ' com edu gov inf name net org pro ',
            'ml': ' com edu gov net org presse ',
            'mn': ' edu gov org ',
            'mo': ' com edu gov net org ',
            'mt': ' com edu gov net org ',
            'mv': ' aero biz com coop edu gov info int mil museum name net org pro ',
            'mw': ' ac co com coop edu gov int museum net org ',
            'mx': ' com edu gob net org ',
            'my': ' com edu gov mil name net org sch ',
            'nf': ' arts com firm info net other per rec store web ',
            'ng': ' biz com edu gov mil mobi name net org sch ',
            'ni': ' ac co com edu gob mil net nom org ',
            'np': ' com edu gov mil net org ',
            'nr': ' biz com edu gov info net org ',
            'om': ' ac biz co com edu gov med mil museum net org pro sch ',
            'pe': ' com edu gob mil net nom org sld ',
            'ph': ' com edu gov i mil net ngo org ',
            'pk': ' biz com edu fam gob gok gon gop gos gov net org web ',
            'pl': ' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
            'pr': ' ac biz com edu est gov info isla name net org pro prof ',
            'ps': ' com edu gov net org plo sec ',
            'pw': ' belau co ed go ne or ',
            'ro': ' arts com firm info nom nt org rec store tm www ',
            'rs': ' ac co edu gov in org ',
            'sb': ' com edu gov net org ',
            'sc': ' com edu gov net org ',
            'sh': ' co com edu gov net nom org ',
            'sl': ' com edu gov net org ',
            'st': ' co com consulado edu embaixada gov mil net org principe saotome store ',
            'sv': ' com edu gob org red ',
            'sz': ' ac co org ',
            'tr': ' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
            'tt': ' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
            'tw': ' club com ebiz edu game gov idv mil net org ',
            'mu': ' ac co com gov net or org ',
            'mz': ' ac co edu gov org ',
            'na': ' co com ',
            'nz': ' ac co cri geek gen govt health iwi maori mil net org parliament school ',
            'pa': ' abo ac com edu gob ing med net nom org sld ',
            'pt': ' com edu gov int net nome org publ ',
            'py': ' com edu gov mil net org ',
            'qa': ' com edu gov mil net org ',
            're': ' asso com nom ',
            'ru': ' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
            'rw': ' ac co com edu gouv gov int mil net ',
            'sa': ' com edu gov med net org pub sch ',
            'sd': ' com edu gov info med net org tv ',
            'se': ' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
            'sg': ' com edu gov idn net org per ',
            'sn': ' art com edu gouv org perso univ ',
            'sy': ' com edu gov mil net news org ',
            'th': ' ac co go in mi net or ',
            'tj': ' ac biz co com edu go gov info int mil name net nic org test web ',
            'tn': ' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
            'tz': ' ac co go ne or ',
            'ua': ' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
            'ug': ' ac co go ne or org sc ',
            'uk': ' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
            'us': ' dni fed isa kids nsn ',
            'uy': ' com edu gub mil net org ',
            've': ' co com edu gob info mil net org web ',
            'vi': ' co com k12 net org ',
            'vn': ' ac biz com edu gov health info int name net org pro ',
            'ye': ' co com gov ltd me net org plc ',
            'yu': ' ac co edu gov org ',
            'za': ' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
            'zm': ' ac co com edu gov net org sch ',
            // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
            'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
            'net': 'gb jp se uk ',
            'org': 'ae',
            'de': 'com '
        },
        // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
        // in both performance and memory footprint. No initialization required.
        // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
        // Following methods use lastIndexOf() rather than array.split() in order
        // to avoid any memory allocations.
        has: function(domain) {
            var tldOffset = domain.lastIndexOf('.');
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return false;
            var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
            if (sldOffset <= 0 || sldOffset >= tldOffset - 1) return false;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return false;
            return sldList.indexOf(' ' + domain.slice(sldOffset + 1, tldOffset) + ' ') >= 0;
        },
        is: function(domain) {
            var tldOffset = domain.lastIndexOf('.');
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return false;
            var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
            if (sldOffset >= 0) return false;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return false;
            return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
        },
        get: function(domain) {
            var tldOffset = domain.lastIndexOf('.');
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return null;
            var sldOffset = domain.lastIndexOf('.', tldOffset - 1);
            if (sldOffset <= 0 || sldOffset >= tldOffset - 1) return null;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return null;
            if (sldList.indexOf(' ' + domain.slice(sldOffset + 1, tldOffset) + ' ') < 0) return null;
            return domain.slice(sldOffset + 1);
        },
        noConflict: function() {
            if (root.SecondLevelDomains === this) root.SecondLevelDomains = _SecondLevelDomains;
            return this;
        }
    };
    return SLD;
});

});

parcelRegister("i2cYP", function(module, exports) {
module.exports = import("ffmuA").then(()=>parcelRequire('5UUfm'));

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("am8tN", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $78a2894df6e7a220$export$a143d493d941bafc, (v) => $78a2894df6e7a220$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $78a2894df6e7a220$export$e4cf37d7f6fb9e0a, (v) => $78a2894df6e7a220$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $78a2894df6e7a220$export$f99ded8fe4b79145, (v) => $78a2894df6e7a220$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $78a2894df6e7a220$export$599f31c3813fae4d, (v) => $78a2894df6e7a220$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $78a2894df6e7a220$export$a143d493d941bafc;
var $78a2894df6e7a220$export$e4cf37d7f6fb9e0a;
var $78a2894df6e7a220$export$f99ded8fe4b79145;
var $78a2894df6e7a220$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $78a2894df6e7a220$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$78a2894df6e7a220$export$a143d493d941bafc = $78a2894df6e7a220$var$Buffer;
$78a2894df6e7a220$export$e4cf37d7f6fb9e0a = $78a2894df6e7a220$var$SlowBuffer;
$78a2894df6e7a220$export$f99ded8fe4b79145 = 50;
var $78a2894df6e7a220$var$K_MAX_LENGTH = 0x7fffffff;
$78a2894df6e7a220$export$599f31c3813fae4d = $78a2894df6e7a220$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $78a2894df6e7a220$var$Buffer.TYPED_ARRAY_SUPPORT = $78a2894df6e7a220$var$typedArraySupport();
if (!$78a2894df6e7a220$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $78a2894df6e7a220$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($78a2894df6e7a220$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$78a2894df6e7a220$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($78a2894df6e7a220$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$78a2894df6e7a220$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $78a2894df6e7a220$var$createBuffer(length) {
    if (length > $78a2894df6e7a220$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $78a2894df6e7a220$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $78a2894df6e7a220$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $78a2894df6e7a220$var$allocUnsafe(arg);
    }
    return $78a2894df6e7a220$var$from(arg, encodingOrOffset, length);
}
$78a2894df6e7a220$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $78a2894df6e7a220$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $78a2894df6e7a220$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $78a2894df6e7a220$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($78a2894df6e7a220$var$isInstance(value, ArrayBuffer) || value && $78a2894df6e7a220$var$isInstance(value.buffer, ArrayBuffer)) return $78a2894df6e7a220$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($78a2894df6e7a220$var$isInstance(value, SharedArrayBuffer) || value && $78a2894df6e7a220$var$isInstance(value.buffer, SharedArrayBuffer))) return $78a2894df6e7a220$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $78a2894df6e7a220$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $78a2894df6e7a220$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $78a2894df6e7a220$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $78a2894df6e7a220$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $78a2894df6e7a220$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($78a2894df6e7a220$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($78a2894df6e7a220$var$Buffer, Uint8Array);
function $78a2894df6e7a220$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $78a2894df6e7a220$var$alloc(size, fill, encoding) {
    $78a2894df6e7a220$var$assertSize(size);
    if (size <= 0) return $78a2894df6e7a220$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $78a2894df6e7a220$var$createBuffer(size).fill(fill, encoding) : $78a2894df6e7a220$var$createBuffer(size).fill(fill);
    return $78a2894df6e7a220$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $78a2894df6e7a220$var$Buffer.alloc = function(size, fill, encoding) {
    return $78a2894df6e7a220$var$alloc(size, fill, encoding);
};
function $78a2894df6e7a220$var$allocUnsafe(size) {
    $78a2894df6e7a220$var$assertSize(size);
    return $78a2894df6e7a220$var$createBuffer(size < 0 ? 0 : $78a2894df6e7a220$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $78a2894df6e7a220$var$Buffer.allocUnsafe = function(size) {
    return $78a2894df6e7a220$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $78a2894df6e7a220$var$Buffer.allocUnsafeSlow = function(size) {
    return $78a2894df6e7a220$var$allocUnsafe(size);
};
function $78a2894df6e7a220$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$78a2894df6e7a220$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $78a2894df6e7a220$var$byteLength(string, encoding) | 0;
    var buf = $78a2894df6e7a220$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $78a2894df6e7a220$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $78a2894df6e7a220$var$checked(array.length) | 0;
    var buf = $78a2894df6e7a220$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $78a2894df6e7a220$var$fromArrayView(arrayView) {
    if ($78a2894df6e7a220$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $78a2894df6e7a220$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $78a2894df6e7a220$var$fromArrayLike(arrayView);
}
function $78a2894df6e7a220$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $78a2894df6e7a220$var$Buffer.prototype);
    return buf;
}
function $78a2894df6e7a220$var$fromObject(obj) {
    if ($78a2894df6e7a220$var$Buffer.isBuffer(obj)) {
        var len = $78a2894df6e7a220$var$checked(obj.length) | 0;
        var buf = $78a2894df6e7a220$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $78a2894df6e7a220$var$numberIsNaN(obj.length)) return $78a2894df6e7a220$var$createBuffer(0);
        return $78a2894df6e7a220$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $78a2894df6e7a220$var$fromArrayLike(obj.data);
}
function $78a2894df6e7a220$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $78a2894df6e7a220$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $78a2894df6e7a220$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $78a2894df6e7a220$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $78a2894df6e7a220$var$Buffer.alloc(+length);
}
$78a2894df6e7a220$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $78a2894df6e7a220$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$78a2894df6e7a220$var$Buffer.compare = function compare(a, b) {
    if ($78a2894df6e7a220$var$isInstance(a, Uint8Array)) a = $78a2894df6e7a220$var$Buffer.from(a, a.offset, a.byteLength);
    if ($78a2894df6e7a220$var$isInstance(b, Uint8Array)) b = $78a2894df6e7a220$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$78a2894df6e7a220$var$Buffer.isBuffer(a) || !$78a2894df6e7a220$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$78a2894df6e7a220$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$78a2894df6e7a220$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $78a2894df6e7a220$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $78a2894df6e7a220$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($78a2894df6e7a220$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $78a2894df6e7a220$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$78a2894df6e7a220$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $78a2894df6e7a220$var$byteLength(string, encoding) {
    if ($78a2894df6e7a220$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $78a2894df6e7a220$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $78a2894df6e7a220$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $78a2894df6e7a220$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $78a2894df6e7a220$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$78a2894df6e7a220$var$Buffer.byteLength = $78a2894df6e7a220$var$byteLength;
function $78a2894df6e7a220$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $78a2894df6e7a220$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $78a2894df6e7a220$var$utf8Slice(this, start, end);
        case 'ascii':
            return $78a2894df6e7a220$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $78a2894df6e7a220$var$latin1Slice(this, start, end);
        case 'base64':
            return $78a2894df6e7a220$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $78a2894df6e7a220$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$78a2894df6e7a220$var$Buffer.prototype._isBuffer = true;
function $78a2894df6e7a220$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$78a2894df6e7a220$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$78a2894df6e7a220$var$swap(this, i, i + 1);
    return this;
};
$78a2894df6e7a220$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $78a2894df6e7a220$var$swap(this, i, i + 3);
        $78a2894df6e7a220$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$78a2894df6e7a220$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $78a2894df6e7a220$var$swap(this, i, i + 7);
        $78a2894df6e7a220$var$swap(this, i + 1, i + 6);
        $78a2894df6e7a220$var$swap(this, i + 2, i + 5);
        $78a2894df6e7a220$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$78a2894df6e7a220$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $78a2894df6e7a220$var$utf8Slice(this, 0, length);
    return $78a2894df6e7a220$var$slowToString.apply(this, arguments);
};
$78a2894df6e7a220$var$Buffer.prototype.toLocaleString = $78a2894df6e7a220$var$Buffer.prototype.toString;
$78a2894df6e7a220$var$Buffer.prototype.equals = function equals(b) {
    if (!$78a2894df6e7a220$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $78a2894df6e7a220$var$Buffer.compare(this, b) === 0;
};
$78a2894df6e7a220$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $78a2894df6e7a220$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($78a2894df6e7a220$var$customInspectSymbol) $78a2894df6e7a220$var$Buffer.prototype[$78a2894df6e7a220$var$customInspectSymbol] = $78a2894df6e7a220$var$Buffer.prototype.inspect;
$78a2894df6e7a220$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($78a2894df6e7a220$var$isInstance(target, Uint8Array)) target = $78a2894df6e7a220$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$78a2894df6e7a220$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $78a2894df6e7a220$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($78a2894df6e7a220$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $78a2894df6e7a220$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($78a2894df6e7a220$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $78a2894df6e7a220$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $78a2894df6e7a220$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $78a2894df6e7a220$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$78a2894df6e7a220$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$78a2894df6e7a220$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $78a2894df6e7a220$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$78a2894df6e7a220$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $78a2894df6e7a220$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $78a2894df6e7a220$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($78a2894df6e7a220$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $78a2894df6e7a220$var$utf8Write(buf, string, offset, length) {
    return $78a2894df6e7a220$var$blitBuffer($78a2894df6e7a220$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $78a2894df6e7a220$var$asciiWrite(buf, string, offset, length) {
    return $78a2894df6e7a220$var$blitBuffer($78a2894df6e7a220$var$asciiToBytes(string), buf, offset, length);
}
function $78a2894df6e7a220$var$base64Write(buf, string, offset, length) {
    return $78a2894df6e7a220$var$blitBuffer($78a2894df6e7a220$var$base64ToBytes(string), buf, offset, length);
}
function $78a2894df6e7a220$var$ucs2Write(buf, string, offset, length) {
    return $78a2894df6e7a220$var$blitBuffer($78a2894df6e7a220$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$78a2894df6e7a220$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $78a2894df6e7a220$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $78a2894df6e7a220$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $78a2894df6e7a220$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $78a2894df6e7a220$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $78a2894df6e7a220$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$78a2894df6e7a220$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $78a2894df6e7a220$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $78a2894df6e7a220$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $78a2894df6e7a220$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $78a2894df6e7a220$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $78a2894df6e7a220$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $78a2894df6e7a220$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $78a2894df6e7a220$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $78a2894df6e7a220$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $78a2894df6e7a220$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $78a2894df6e7a220$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $78a2894df6e7a220$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $78a2894df6e7a220$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$78a2894df6e7a220$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $78a2894df6e7a220$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $78a2894df6e7a220$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$78a2894df6e7a220$var$Buffer.prototype.readUintLE = $78a2894df6e7a220$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$78a2894df6e7a220$var$Buffer.prototype.readUintBE = $78a2894df6e7a220$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$78a2894df6e7a220$var$Buffer.prototype.readUint8 = $78a2894df6e7a220$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$78a2894df6e7a220$var$Buffer.prototype.readUint16LE = $78a2894df6e7a220$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$78a2894df6e7a220$var$Buffer.prototype.readUint16BE = $78a2894df6e7a220$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$78a2894df6e7a220$var$Buffer.prototype.readUint32LE = $78a2894df6e7a220$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$78a2894df6e7a220$var$Buffer.prototype.readUint32BE = $78a2894df6e7a220$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$78a2894df6e7a220$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$78a2894df6e7a220$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$78a2894df6e7a220$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$78a2894df6e7a220$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$78a2894df6e7a220$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$78a2894df6e7a220$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$78a2894df6e7a220$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$78a2894df6e7a220$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$78a2894df6e7a220$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$78a2894df6e7a220$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$78a2894df6e7a220$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $78a2894df6e7a220$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$78a2894df6e7a220$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$78a2894df6e7a220$var$Buffer.prototype.writeUintLE = $78a2894df6e7a220$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $78a2894df6e7a220$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$78a2894df6e7a220$var$Buffer.prototype.writeUintBE = $78a2894df6e7a220$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $78a2894df6e7a220$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$78a2894df6e7a220$var$Buffer.prototype.writeUint8 = $78a2894df6e7a220$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$78a2894df6e7a220$var$Buffer.prototype.writeUint16LE = $78a2894df6e7a220$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$78a2894df6e7a220$var$Buffer.prototype.writeUint16BE = $78a2894df6e7a220$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$78a2894df6e7a220$var$Buffer.prototype.writeUint32LE = $78a2894df6e7a220$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$78a2894df6e7a220$var$Buffer.prototype.writeUint32BE = $78a2894df6e7a220$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$78a2894df6e7a220$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $78a2894df6e7a220$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$78a2894df6e7a220$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $78a2894df6e7a220$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$78a2894df6e7a220$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$78a2894df6e7a220$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$78a2894df6e7a220$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$78a2894df6e7a220$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$78a2894df6e7a220$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $78a2894df6e7a220$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $78a2894df6e7a220$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$78a2894df6e7a220$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $78a2894df6e7a220$var$writeFloat(this, value, offset, true, noAssert);
};
$78a2894df6e7a220$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $78a2894df6e7a220$var$writeFloat(this, value, offset, false, noAssert);
};
function $78a2894df6e7a220$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $78a2894df6e7a220$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$78a2894df6e7a220$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $78a2894df6e7a220$var$writeDouble(this, value, offset, true, noAssert);
};
$78a2894df6e7a220$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $78a2894df6e7a220$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$78a2894df6e7a220$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$78a2894df6e7a220$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$78a2894df6e7a220$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$78a2894df6e7a220$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $78a2894df6e7a220$var$Buffer.isBuffer(val) ? val : $78a2894df6e7a220$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $78a2894df6e7a220$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $78a2894df6e7a220$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($78a2894df6e7a220$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $78a2894df6e7a220$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $78a2894df6e7a220$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $78a2894df6e7a220$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $78a2894df6e7a220$var$base64ToBytes(str) {
    return $kuxul.toByteArray($78a2894df6e7a220$var$base64clean(str));
}
function $78a2894df6e7a220$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $78a2894df6e7a220$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $78a2894df6e7a220$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $78a2894df6e7a220$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


parcelRequire("acw62");
parcelRequire("1u0KT");
function $112972238ba0eede$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $112972238ba0eede$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $112972238ba0eede$export$2e2bcd8739ae039(o);
}


function $d24a8cfe21a2513b$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $d24a8cfe21a2513b$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $112972238ba0eede$export$2e2bcd8739ae039)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $112972238ba0eede$export$2e2bcd8739ae039)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}


function $e038e0eb2ba52a9b$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $e038e0eb2ba52a9b$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $e038e0eb2ba52a9b$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $e038e0eb2ba52a9b$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}





function $3f5ee0e8b937ea9b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $112972238ba0eede$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $112972238ba0eede$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $746b7193d8776adc$export$2e2bcd8739ae039(t) {
    var i = (0, $3f5ee0e8b937ea9b$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $112972238ba0eede$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $488ba5108a07ecf1$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $746b7193d8776adc$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $784b8130b41ca462$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $784b8130b41ca462$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $784b8130b41ca462$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $488ba5108a07ecf1$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $784b8130b41ca462$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}



var $1u0KT = parcelRequire("1u0KT");
// Let compiler not to search module usage
var $3ec3eeae112266bf$var$fullClone = (0, $784b8130b41ca462$export$2e2bcd8739ae039)({}, $1u0KT);
var $3ec3eeae112266bf$var$version = $3ec3eeae112266bf$var$fullClone.version, $3ec3eeae112266bf$var$reactRender = $3ec3eeae112266bf$var$fullClone.render, $3ec3eeae112266bf$var$unmountComponentAtNode = $3ec3eeae112266bf$var$fullClone.unmountComponentAtNode;
var $3ec3eeae112266bf$var$createRoot;
try {
    var $3ec3eeae112266bf$var$mainVersion = Number(($3ec3eeae112266bf$var$version || '').split('.')[0]);
    if ($3ec3eeae112266bf$var$mainVersion >= 18) $3ec3eeae112266bf$var$createRoot = $3ec3eeae112266bf$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $3ec3eeae112266bf$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $3ec3eeae112266bf$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $112972238ba0eede$export$2e2bcd8739ae039)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === 'object') __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $3ec3eeae112266bf$var$MARK = '__rc_react_root__';
// ========================== Render ==========================
function $3ec3eeae112266bf$var$modernRender(node, container) {
    $3ec3eeae112266bf$var$toggleWarning(true);
    var root = container[$3ec3eeae112266bf$var$MARK] || $3ec3eeae112266bf$var$createRoot(container);
    $3ec3eeae112266bf$var$toggleWarning(false);
    root.render(node);
    container[$3ec3eeae112266bf$var$MARK] = root;
}
function $3ec3eeae112266bf$var$legacyRender(node, container) {
    $3ec3eeae112266bf$var$reactRender === null || $3ec3eeae112266bf$var$reactRender === void 0 || $3ec3eeae112266bf$var$reactRender(node, container);
}
function $3ec3eeae112266bf$export$892c6608f54d7438(node, container) {}
function $3ec3eeae112266bf$export$b3890eb0ae9dca99(node, container) {
    if ($3ec3eeae112266bf$var$createRoot) {
        $3ec3eeae112266bf$var$modernRender(node, container);
        return;
    }
    $3ec3eeae112266bf$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $3ec3eeae112266bf$var$modernUnmount(_x) {
    return $3ec3eeae112266bf$var$_modernUnmount.apply(this, arguments);
}
function $3ec3eeae112266bf$var$_modernUnmount() {
    $3ec3eeae112266bf$var$_modernUnmount = (0, $e038e0eb2ba52a9b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $d24a8cfe21a2513b$export$2e2bcd8739ae039)().mark(function _callee(container) {
        return (0, $d24a8cfe21a2513b$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$3ec3eeae112266bf$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$3ec3eeae112266bf$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $3ec3eeae112266bf$var$_modernUnmount.apply(this, arguments);
}
function $3ec3eeae112266bf$var$legacyUnmount(container) {
    $3ec3eeae112266bf$var$unmountComponentAtNode(container);
}
function $3ec3eeae112266bf$export$fd39fe14445b207a(container) {}
function $3ec3eeae112266bf$export$121e2d597d222bad(_x2) {
    return $3ec3eeae112266bf$var$_unmount.apply(this, arguments);
}
function $3ec3eeae112266bf$var$_unmount() {
    $3ec3eeae112266bf$var$_unmount = (0, $e038e0eb2ba52a9b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $d24a8cfe21a2513b$export$2e2bcd8739ae039)().mark(function _callee2(container) {
        return (0, $d24a8cfe21a2513b$export$2e2bcd8739ae039)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($3ec3eeae112266bf$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $3ec3eeae112266bf$var$modernUnmount(container));
                case 2:
                    $3ec3eeae112266bf$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $3ec3eeae112266bf$var$_unmount.apply(this, arguments);
}



"use client";
const $f76949e1bc95fa3b$var$defaultReactRender = (node, container)=>{
    (0, $3ec3eeae112266bf$export$b3890eb0ae9dca99)(node, container);
    return ()=>{
        return (0, $3ec3eeae112266bf$export$121e2d597d222bad)(container);
    };
};
let $f76949e1bc95fa3b$var$unstableRender = $f76949e1bc95fa3b$var$defaultReactRender;
function $f76949e1bc95fa3b$export$4d4bf8843d204cca(render) {
    if (render) $f76949e1bc95fa3b$var$unstableRender = render;
    return $f76949e1bc95fa3b$var$unstableRender;
}


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


'use client';
(0, $f76949e1bc95fa3b$export$4d4bf8843d204cca)(function(node, container) {
    container._reactRoot || (container._reactRoot = (0, $7e96a608cb33bf79$exports.createRoot)(container));
    var root = container._reactRoot;
    root.render(node);
    return function() {
        return new Promise(function(resolve) {
            setTimeout(function() {
                root.unmount();
                resolve();
            }, 0);
        });
    };
});



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $ec30be32576c1d45$export$264c6064649f9206 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
const $ec30be32576c1d45$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    message: {},
    notification: {},
    modal: {}
});
var $ec30be32576c1d45$export$2e2bcd8739ae039 = $ec30be32576c1d45$var$AppContext;



var $acw62 = parcelRequire("acw62");
function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(r) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(r, e) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r, e) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}




function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(r) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(r) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $c0f5cb12993018cc$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $c0f5cb12993018cc$export$2e2bcd8739ae039 = $c0f5cb12993018cc$var$murmur2;



function $c6daeb3adc2b0e60$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


function $97b4b0194c593c05$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


var $3a22468320d7d808$var$APPEND_ORDER = 'data-rc-order';
var $3a22468320d7d808$var$APPEND_PRIORITY = 'data-rc-priority';
var $3a22468320d7d808$var$MARK_KEY = "rc-util-key";
var $3a22468320d7d808$var$containerCache = new Map();
function $3a22468320d7d808$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith('data-') ? mark : "data-".concat(mark);
    return $3a22468320d7d808$var$MARK_KEY;
}
function $3a22468320d7d808$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector('head');
    return head || document.body;
}
function $3a22468320d7d808$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $3a22468320d7d808$var$findStyles(container) {
    return Array.from(($3a22468320d7d808$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === 'STYLE';
    });
}
function $3a22468320d7d808$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $3a22468320d7d808$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === 'prependQueue';
    var styleNode = document.createElement('style');
    styleNode.setAttribute($3a22468320d7d808$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($3a22468320d7d808$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $3a22468320d7d808$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $3a22468320d7d808$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($3a22468320d7d808$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($3a22468320d7d808$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $3a22468320d7d808$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $3a22468320d7d808$var$getContainer(option);
    return (option.styles || $3a22468320d7d808$var$findStyles(container)).find(function(node) {
        return node.getAttribute($3a22468320d7d808$var$getMark(option)) === key;
    });
}
function $3a22468320d7d808$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $3a22468320d7d808$var$findExistNode(key, option);
    if (existNode) {
        var container = $3a22468320d7d808$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $3a22468320d7d808$var$syncRealContainer(container, option) {
    var cachedRealContainer = $3a22468320d7d808$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $97b4b0194c593c05$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        var placeholderStyle = $3a22468320d7d808$export$1ab5838465dbd10a('', option);
        var parentNode = placeholderStyle.parentNode;
        $3a22468320d7d808$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $3a22468320d7d808$export$f80df667f2f5a272() {
    $3a22468320d7d808$var$containerCache.clear();
}
function $3a22468320d7d808$export$4d99a2890bb989f0(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $3a22468320d7d808$var$getContainer(originOption);
    var styles = $3a22468320d7d808$var$findStyles(container);
    var option = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $3a22468320d7d808$var$syncRealContainer(container, option);
    var existNode = $3a22468320d7d808$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $3a22468320d7d808$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($3a22468320d7d808$var$getMark(option), key);
    return newNode;
}



var $acw62 = parcelRequire("acw62");

function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $acw62 = parcelRequire("acw62");
function $2e4d16a6147a082d$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $acw62.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}



/* eslint-disable no-console */ var $05a5f2c645683a81$var$warned = {};
var $05a5f2c645683a81$var$preWarningFns = [];
var $05a5f2c645683a81$export$61616f168f0e5a05 = function preMessage(fn) {
    $05a5f2c645683a81$var$preWarningFns.push(fn);
};
function $05a5f2c645683a81$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $05a5f2c645683a81$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $05a5f2c645683a81$export$60eef1277fe463e4() {
    $05a5f2c645683a81$var$warned = {};
}
function $05a5f2c645683a81$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$05a5f2c645683a81$var$warned[message]) {
        method(false, message);
        $05a5f2c645683a81$var$warned[message] = true;
    }
}
function $05a5f2c645683a81$export$82934adf09101657(valid, message) {
    $05a5f2c645683a81$export$848feb93d8f32b9b($05a5f2c645683a81$export$491112666e282270, valid, message);
}
function $05a5f2c645683a81$export$89ff31684837bbbf(valid, message) {
    $05a5f2c645683a81$export$848feb93d8f32b9b($05a5f2c645683a81$export$a92e4c44d367d0af, valid, message);
}
$05a5f2c645683a81$export$82934adf09101657.preMessage = $05a5f2c645683a81$export$61616f168f0e5a05;
$05a5f2c645683a81$export$82934adf09101657.resetWarned = $05a5f2c645683a81$export$60eef1277fe463e4;
$05a5f2c645683a81$export$82934adf09101657.noteOnce = $05a5f2c645683a81$export$89ff31684837bbbf;
var $05a5f2c645683a81$export$2e2bcd8739ae039 = $05a5f2c645683a81$export$82934adf09101657;


/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $357adc8667cde522$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(a) === 'object' && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $357adc8667cde522$export$2e2bcd8739ae039 = $357adc8667cde522$var$isEqual;



var $acw62 = parcelRequire("acw62");
function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



// [times, realValue]
var $7399254758448c39$var$SPLIT = '%';
function $7399254758448c39$export$1d14e1d8187b9aad(keys) {
    return keys.join($7399254758448c39$var$SPLIT);
}
var $7399254758448c39$var$Entity = /*#__PURE__*/ function() {
    function Entity(instanceId) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Entity);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "instanceId", void 0);
        /** @private Internal cache map. Do not access this directly */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "cache", new Map());
        this.instanceId = instanceId;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Entity, [
        {
            key: "get",
            value: function get(keys) {
                return this.opGet($7399254758448c39$export$1d14e1d8187b9aad(keys));
            }
        },
        {
            key: "opGet",
            value: function opGet(keyPathStr) {
                return this.cache.get(keyPathStr) || null;
            }
        },
        {
            key: "update",
            value: function update(keys, valueFn) {
                return this.opUpdate($7399254758448c39$export$1d14e1d8187b9aad(keys), valueFn);
            }
        },
        {
            key: "opUpdate",
            value: function opUpdate(keyPathStr, valueFn) {
                var prevValue = this.cache.get(keyPathStr);
                var nextValue = valueFn(prevValue);
                if (nextValue === null) this.cache.delete(keyPathStr);
                else this.cache.set(keyPathStr, nextValue);
            }
        }
    ]);
    return Entity;
}();
var $7399254758448c39$export$2e2bcd8739ae039 = $7399254758448c39$var$Entity;


var $182b356f02bf1b9b$var$_excluded = [
    "children"
];
var $182b356f02bf1b9b$export$5d99297dcd5476ac = 'data-token-hash';
var $182b356f02bf1b9b$export$89ce1123b3c0bd9e = 'data-css-hash';
var $182b356f02bf1b9b$export$36f8a6c9fa24262a = 'data-cache-path';
var $182b356f02bf1b9b$export$4c16a0c02134a7dc = '__cssinjs_instance__';
function $182b356f02bf1b9b$export$cf6fa0bbcc94b912() {
    var cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== 'undefined' && document.head && document.body) {
        var styles = document.body.querySelectorAll("style[".concat($182b356f02bf1b9b$export$89ce1123b3c0bd9e, "]")) || [];
        var firstChild = document.head.firstChild;
        Array.from(styles).forEach(function(style) {
            style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] = style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] || cssinjsInstanceId;
            // Not force move if no head
            if (style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        var styleHash = {};
        Array.from(document.querySelectorAll("style[".concat($182b356f02bf1b9b$export$89ce1123b3c0bd9e, "]"))).forEach(function(style) {
            var hash = style.getAttribute($182b356f02bf1b9b$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] === cssinjsInstanceId) {
                    var _style$parentNode;
                    (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
                }
            } else styleHash[hash] = true;
        });
    }
    return new (0, $7399254758448c39$export$2e2bcd8739ae039)(cssinjsInstanceId);
}
var $182b356f02bf1b9b$var$StyleContext = /*#__PURE__*/ $acw62.createContext({
    hashPriority: 'low',
    cache: $182b356f02bf1b9b$export$cf6fa0bbcc94b912(),
    defaultCache: true
});
var $182b356f02bf1b9b$export$6aedb87c7b665270 = function StyleProvider(props) {
    var children = props.children, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $182b356f02bf1b9b$var$_excluded);
    var parentContext = $acw62.useContext($182b356f02bf1b9b$var$StyleContext);
    var context = (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        var mergedContext = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, parentContext);
        Object.keys(restProps).forEach(function(key) {
            var value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        var cache = restProps.cache;
        mergedContext.cache = mergedContext.cache || $182b356f02bf1b9b$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], function(prev, next) {
        return !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prev[0], next[0], true) || !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prev[1], next[1], true);
    });
    return /*#__PURE__*/ $acw62.createElement($182b356f02bf1b9b$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $182b356f02bf1b9b$export$2e2bcd8739ae039 = $182b356f02bf1b9b$var$StyleContext;












function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, e);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(t);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, e);
    };
}





var $1a755235d4cd9d8d$var$AbstractCalculator = /*#__PURE__*/ (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $1a755235d4cd9d8d$export$2e2bcd8739ae039 = $1a755235d4cd9d8d$var$AbstractCalculator;


var $96067c2c1122b921$var$CALC_UNIT = 'CALC_UNIT';
var $96067c2c1122b921$var$regexp = new RegExp($96067c2c1122b921$var$CALC_UNIT, 'g');
function $96067c2c1122b921$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($96067c2c1122b921$var$CALC_UNIT);
    return value;
}
var $96067c2c1122b921$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "result", '');
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $96067c2c1122b921$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($96067c2c1122b921$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($96067c2c1122b921$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($96067c2c1122b921$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $1a755235d4cd9d8d$export$2e2bcd8739ae039));









var $189b9ffa4e9f1d1f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $1a755235d4cd9d8d$export$2e2bcd8739ae039));


var $f7688ec948540519$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $96067c2c1122b921$export$2e2bcd8739ae039) : (0, $189b9ffa4e9f1d1f$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $f7688ec948540519$export$2e2bcd8739ae039 = $f7688ec948540519$var$genCalc;






function $06e75d38ebf58c74$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(var i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
var $06e75d38ebf58c74$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeCache() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ThemeCache);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "cache", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "keys", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "cacheCallTimes", void 0);
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ThemeCache, [
        {
            key: "size",
            value: function size() {
                return this.keys.length;
            }
        },
        {
            key: "internalGet",
            value: function internalGet(derivativeOption) {
                var _cache2, _cache3;
                var updateCallTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var cache = {
                    map: this.cache
                };
                derivativeOption.forEach(function(derivative) {
                    if (!cache) cache = undefined;
                    else {
                        var _cache;
                        cache = (_cache = cache) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative);
                    }
                });
                if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
                return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
            }
        },
        {
            key: "get",
            value: function get(derivativeOption) {
                var _this$internalGet;
                return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
            }
        },
        {
            key: "has",
            value: function has(derivativeOption) {
                return !!this.internalGet(derivativeOption);
            }
        },
        {
            key: "set",
            value: function set(derivativeOption, value) {
                var _this = this;
                // New cache
                if (!this.has(derivativeOption)) {
                    if (this.size() + 1 > ThemeCache.MAX_CACHE_SIZE + ThemeCache.MAX_CACHE_OFFSET) {
                        var _this$keys$reduce = this.keys.reduce(function(result, key) {
                            var _result = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(result, 2), callTimes = _result[1];
                            if (_this.internalGet(key)[1] < callTimes) return [
                                key,
                                _this.internalGet(key)[1]
                            ];
                            return result;
                        }, [
                            this.keys[0],
                            this.cacheCallTimes
                        ]), _this$keys$reduce2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
                        this.delete(targetKey);
                    }
                    this.keys.push(derivativeOption);
                }
                var cache = this.cache;
                derivativeOption.forEach(function(derivative, index) {
                    if (index === derivativeOption.length - 1) cache.set(derivative, {
                        value: [
                            value,
                            _this.cacheCallTimes++
                        ]
                    });
                    else {
                        var cacheValue = cache.get(derivative);
                        if (!cacheValue) cache.set(derivative, {
                            map: new Map()
                        });
                        else if (!cacheValue.map) cacheValue.map = new Map();
                        cache = cache.get(derivative).map;
                    }
                });
            }
        },
        {
            key: "deleteByPath",
            value: function deleteByPath(currentCache, derivatives) {
                var cache = currentCache.get(derivatives[0]);
                if (derivatives.length === 1) {
                    var _cache$value;
                    if (!cache.map) currentCache.delete(derivatives[0]);
                    else currentCache.set(derivatives[0], {
                        map: cache.map
                    });
                    return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
                }
                var result = this.deleteByPath(cache.map, derivatives.slice(1));
                if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
                return result;
            }
        },
        {
            key: "delete",
            value: function _delete(derivativeOption) {
                // If cache exists
                if (this.has(derivativeOption)) {
                    this.keys = this.keys.filter(function(item) {
                        return !$06e75d38ebf58c74$export$dd65e95e99ed0739(item, derivativeOption);
                    });
                    return this.deleteByPath(this.cache, derivativeOption);
                }
                return undefined;
            }
        }
    ]);
    return ThemeCache;
}();
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($06e75d38ebf58c74$export$2e2bcd8739ae039, "MAX_CACHE_SIZE", 20);
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($06e75d38ebf58c74$export$2e2bcd8739ae039, "MAX_CACHE_OFFSET", 5);






var $3dd697ea901030c8$var$uuid = 0;
/**
 * Theme with algorithms to derive tokens from design tokens.
 * Use `createTheme` first which will help to manage the theme instance cache.
 */ var $3dd697ea901030c8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Theme(derivatives) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Theme);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "derivatives", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "id", void 0);
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $3dd697ea901030c8$var$uuid;
        if (derivatives.length === 0) (0, $05a5f2c645683a81$export$491112666e282270)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
        $3dd697ea901030c8$var$uuid += 1;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Theme, [
        {
            key: "getDerivativeToken",
            value: function getDerivativeToken(token) {
                return this.derivatives.reduce(function(result, derivative) {
                    return derivative(token, result);
                }, undefined);
            }
        }
    ]);
    return Theme;
}();


var $db48c74b3367fd88$var$cacheThemes = new (0, $06e75d38ebf58c74$export$2e2bcd8739ae039)();
function $db48c74b3367fd88$export$2e2bcd8739ae039(derivatives) {
    var derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$db48c74b3367fd88$var$cacheThemes.has(derivativeArr)) $db48c74b3367fd88$var$cacheThemes.set(derivativeArr, new (0, $3dd697ea901030c8$export$2e2bcd8739ae039)(derivativeArr));
    // Get theme from cache and return
    return $db48c74b3367fd88$var$cacheThemes.get(derivativeArr);
}






// Create a cache for memo concat
var $f97444ff16d95e90$var$resultCache = new WeakMap();
var $f97444ff16d95e90$var$RESULT_VALUE = {};
function $f97444ff16d95e90$export$6aabcc1951563d93(callback, deps) {
    var current = $f97444ff16d95e90$var$resultCache;
    for(var i = 0; i < deps.length; i += 1){
        var dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($f97444ff16d95e90$var$RESULT_VALUE)) current.set($f97444ff16d95e90$var$RESULT_VALUE, callback());
    return current.get($f97444ff16d95e90$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
var $f97444ff16d95e90$var$flattenTokenCache = new WeakMap();
function $f97444ff16d95e90$export$597374558a261efc(token) {
    var str = $f97444ff16d95e90$var$flattenTokenCache.get(token) || '';
    if (!str) {
        Object.keys(token).forEach(function(key) {
            var value = token[key];
            str += key;
            if (value instanceof (0, $3dd697ea901030c8$export$2e2bcd8739ae039)) str += value.id;
            else if (value && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object') str += $f97444ff16d95e90$export$597374558a261efc(value);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        str = (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(str);
        // Put in cache
        $f97444ff16d95e90$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $f97444ff16d95e90$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)("".concat(salt, "_").concat($f97444ff16d95e90$export$597374558a261efc(token)));
}
var $f97444ff16d95e90$var$randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, '');
// Magic `content` for detect selector support
var $f97444ff16d95e90$var$checkContent = '_bAmBoO_';
function $f97444ff16d95e90$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
        var _getComputedStyle$con, _ele$parentNode;
        (0, $3a22468320d7d808$export$4d99a2890bb989f0)(styleStr, $f97444ff16d95e90$var$randomSelectorKey);
        var _ele = document.createElement('div');
        _ele.style.position = 'fixed';
        _ele.style.left = '0';
        _ele.style.top = '0';
        handleElement === null || handleElement === void 0 || handleElement(_ele);
        document.body.appendChild(_ele);
        var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes($f97444ff16d95e90$var$checkContent);
        (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
        (0, $3a22468320d7d808$export$2232e336aecaa80a)($f97444ff16d95e90$var$randomSelectorKey);
        return support;
    }
    return false;
}
var $f97444ff16d95e90$var$canLayer = undefined;
function $f97444ff16d95e90$export$ac8d3fd9840e20dd() {
    if ($f97444ff16d95e90$var$canLayer === undefined) $f97444ff16d95e90$var$canLayer = $f97444ff16d95e90$var$supportSelector("@layer ".concat($f97444ff16d95e90$var$randomSelectorKey, " { .").concat($f97444ff16d95e90$var$randomSelectorKey, " { content: \"").concat($f97444ff16d95e90$var$checkContent, "\"!important; } }"), function(ele) {
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    });
    return $f97444ff16d95e90$var$canLayer;
}
var $f97444ff16d95e90$var$canWhere = undefined;
function $f97444ff16d95e90$export$f51d3b8ac4ac9ed1() {
    if ($f97444ff16d95e90$var$canWhere === undefined) $f97444ff16d95e90$var$canWhere = $f97444ff16d95e90$var$supportSelector(":where(.".concat($f97444ff16d95e90$var$randomSelectorKey, ") { content: \"").concat($f97444ff16d95e90$var$checkContent, "\"!important; }"), function(ele) {
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    });
    return $f97444ff16d95e90$var$canWhere;
}
var $f97444ff16d95e90$var$canLogic = undefined;
function $f97444ff16d95e90$export$64a912f57d5de48e() {
    if ($f97444ff16d95e90$var$canLogic === undefined) $f97444ff16d95e90$var$canLogic = $f97444ff16d95e90$var$supportSelector(".".concat($f97444ff16d95e90$var$randomSelectorKey, " { inset-block: 93px !important; }"), function(ele) {
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    }, function(ele) {
        return getComputedStyle(ele).bottom === '93px';
    });
    return $f97444ff16d95e90$var$canLogic;
}
var $f97444ff16d95e90$export$9542afab8c2a5f48 = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)();
function $f97444ff16d95e90$export$523c0b569236b342(num) {
    if (typeof num === 'number') return "".concat(num, "px");
    return num;
}
function $f97444ff16d95e90$export$71c98ec84f0481d3(style, tokenKey, styleId) {
    var _objectSpread2;
    var customizeAttrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (plain) return style;
    var attrs = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, customizeAttrs), {}, (_objectSpread2 = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, (0, $182b356f02bf1b9b$export$5d99297dcd5476ac), tokenKey), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e), styleId), _objectSpread2));
    var attrStr = Object.keys(attrs).map(function(attr) {
        var val = attrs[attr];
        return val ? "".concat(attr, "=\"").concat(val, "\"") : null;
    }).filter(function(v) {
        return v;
    }).join(' ');
    return "<style ".concat(attrStr, ">").concat(style, "</style>");
}



var $5a4d26b111585357$export$309b3b095f0c7662 = function token2CSSVar(token) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return "--".concat(prefix ? "".concat(prefix, "-") : '').concat(token).replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
var $5a4d26b111585357$export$a27ef1ee9bbc757e = function serializeCSSVar(cssVars, hashId, options) {
    if (!Object.keys(cssVars).length) return '';
    return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : '', "{").concat(Object.entries(cssVars).map(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "".concat(key, ":").concat(value, ";");
    }).join(''), "}");
};
var $5a4d26b111585357$export$67858afe85bce49f = function transformToken(token, themeKey, config) {
    var cssVars = {};
    var result = {};
    Object.entries(token).forEach(function(_ref3) {
        var _config$preserve, _config$ignore;
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], value = _ref4[1];
        if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) result[key] = value;
        else if ((typeof value === 'string' || typeof value === 'number') && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
            var _config$unitless;
            var cssVar = $5a4d26b111585357$export$309b3b095f0c7662(key, config === null || config === void 0 ? void 0 : config.prefix);
            cssVars[cssVar] = typeof value === 'number' && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
            result[key] = "var(".concat(cssVar, ")");
        }
    });
    return [
        result,
        $5a4d26b111585357$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config === null || config === void 0 ? void 0 : config.scope
        })
    ];
};





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $493347a9fd5d8394$var$useInternalLayoutEffect = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() ? $acw62.useLayoutEffect : $acw62.useEffect;
var $493347a9fd5d8394$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $acw62.useRef(true);
    $493347a9fd5d8394$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $493347a9fd5d8394$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $493347a9fd5d8394$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $493347a9fd5d8394$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $493347a9fd5d8394$export$2e2bcd8739ae039 = $493347a9fd5d8394$var$useLayoutEffect;



var $acw62 = parcelRequire("acw62");
// We need fully clone React function here
// to avoid webpack warning React 17 do not export `useId`
var $dbf330e0793a2d94$var$fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $acw62);
var $dbf330e0793a2d94$var$useInsertionEffect = $dbf330e0793a2d94$var$fullClone.useInsertionEffect;
/**
 * Polyfill `useInsertionEffect` for React < 18
 * @param renderEffect will be executed in `useMemo`, and do not have callback
 * @param effect will be executed in `useLayoutEffect`
 * @param deps
 */ var $dbf330e0793a2d94$var$useInsertionEffectPolyfill = function useInsertionEffectPolyfill(renderEffect, effect, deps) {
    $acw62.useMemo(renderEffect, deps);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        return effect(true);
    }, deps);
};
/**
 * Compatible `useInsertionEffect`
 * will use `useInsertionEffect` if React version >= 18,
 * otherwise use `useInsertionEffectPolyfill`.
 */ var $dbf330e0793a2d94$var$useCompatibleInsertionEffect = $dbf330e0793a2d94$var$useInsertionEffect ? function(renderEffect, effect, deps) {
    return $dbf330e0793a2d94$var$useInsertionEffect(function() {
        renderEffect();
        return effect();
    }, deps);
} : $dbf330e0793a2d94$var$useInsertionEffectPolyfill;
var $dbf330e0793a2d94$export$2e2bcd8739ae039 = $dbf330e0793a2d94$var$useCompatibleInsertionEffect;





var $acw62 = parcelRequire("acw62");
var $7ee590fd65ab0539$var$fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $acw62);
var $7ee590fd65ab0539$var$useInsertionEffect = $7ee590fd65ab0539$var$fullClone.useInsertionEffect;
// DO NOT register functions in useEffect cleanup function, or functions that registered will never be called.
var $7ee590fd65ab0539$var$useCleanupRegister = function useCleanupRegister(deps) {
    var effectCleanups = [];
    var cleanupFlag = false;
    function register(fn) {
        if (cleanupFlag) return;
        effectCleanups.push(fn);
    }
    $acw62.useEffect(function() {
        // Compatible with strict mode
        cleanupFlag = false;
        return function() {
            cleanupFlag = true;
            if (effectCleanups.length) effectCleanups.forEach(function(fn) {
                return fn();
            });
        };
    }, deps);
    return register;
};
var $7ee590fd65ab0539$var$useRun = function useRun() {
    return function(fn) {
        fn();
    };
};
// Only enable register in React 18
var $7ee590fd65ab0539$var$useEffectCleanupRegister = typeof $7ee590fd65ab0539$var$useInsertionEffect !== 'undefined' ? $7ee590fd65ab0539$var$useCleanupRegister : $7ee590fd65ab0539$var$useRun;
var $7ee590fd65ab0539$export$2e2bcd8739ae039 = $7ee590fd65ab0539$var$useEffectCleanupRegister;


function $89824b6453bf0586$var$useProdHMR() {
    return false;
}
var $89824b6453bf0586$var$webpackHMR = false;
function $89824b6453bf0586$var$useDevHMR() {
    return $89824b6453bf0586$var$webpackHMR;
}
var $89824b6453bf0586$export$2e2bcd8739ae039 = $89824b6453bf0586$var$useProdHMR;
var $89824b6453bf0586$var$win, $89824b6453bf0586$var$originWebpackHotUpdate;


function $5cf8f09379a7b7de$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    var _React$useContext = $acw62.useContext((0, $182b356f02bf1b9b$export$2e2bcd8739ae039)), globalCache = _React$useContext.cache;
    var fullPath = [
        prefix
    ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keyPath));
    var fullPathStr = (0, $7399254758448c39$export$1d14e1d8187b9aad)(fullPath);
    var register = (0, $7ee590fd65ab0539$export$2e2bcd8739ae039)([
        fullPathStr
    ]);
    var HMRUpdate = (0, $89824b6453bf0586$export$2e2bcd8739ae039)();
    var buildCache = function buildCache(updater) {
        globalCache.opUpdate(fullPathStr, function(prevCache) {
            var _ref = prevCache || [
                undefined,
                undefined
            ], _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache = _ref2[1];
            // HMR should always ignore cache since developer may change it
            var tmpCache = cache;
            var mergedCache = tmpCache || cacheFn();
            var data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $acw62.useMemo(function() {
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    var cacheEntity = globalCache.opGet(fullPathStr);
    var cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $dbf330e0793a2d94$export$2e2bcd8739ae039)(function() {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
    }, function(polyfill) {
        // It's bad to call build again in effect.
        // But we have to do this since StrictMode will call effect twice
        // which will clear cache on the first time.
        buildCache(function(_ref3) {
            var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), times = _ref4[0], cache = _ref4[1];
            if (polyfill && times === 0) onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
            return [
                times + 1,
                cache
            ];
        });
        return function() {
            globalCache.opUpdate(fullPathStr, function(prevCache) {
                var _ref5 = prevCache || [], _ref6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache = _ref6[1];
                var nextCount = times - 1;
                if (nextCount === 0) {
                    // Always remove styles in useEffect callback
                    register(function() {
                        // With polyfill, registered callback will always be called synchronously
                        // But without polyfill, it will be called in effect clean up,
                        // And by that time this cache is cleaned up.
                        if (polyfill || !globalCache.opGet(fullPathStr)) onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
                    });
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}


var $fb047830d7776fb2$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
var $fb047830d7776fb2$var$hashPrefix = 'css';
var $fb047830d7776fb2$var$tokenKeys = new Map();
function $fb047830d7776fb2$var$recordCleanToken(tokenKey) {
    $fb047830d7776fb2$var$tokenKeys.set(tokenKey, ($fb047830d7776fb2$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $fb047830d7776fb2$var$removeStyleTags(key, instanceId) {
    if (typeof document !== 'undefined') {
        var styles = document.querySelectorAll("style[".concat((0, $182b356f02bf1b9b$export$5d99297dcd5476ac), "=\"").concat(key, "\"]"));
        styles.forEach(function(style) {
            if (style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] === instanceId) {
                var _style$parentNode;
                (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
            }
        });
    }
}
var $fb047830d7776fb2$var$TOKEN_THRESHOLD = 0;
// Remove will check current keys first
function $fb047830d7776fb2$var$cleanTokenStyle(tokenKey, instanceId) {
    $fb047830d7776fb2$var$tokenKeys.set(tokenKey, ($fb047830d7776fb2$var$tokenKeys.get(tokenKey) || 0) - 1);
    var tokenKeyList = Array.from($fb047830d7776fb2$var$tokenKeys.keys());
    var cleanableKeyList = tokenKeyList.filter(function(key) {
        var count = $fb047830d7776fb2$var$tokenKeys.get(key) || 0;
        return count <= 0;
    });
    // Should keep tokens under threshold for not to insert style too often
    if (tokenKeyList.length - cleanableKeyList.length > $fb047830d7776fb2$var$TOKEN_THRESHOLD) cleanableKeyList.forEach(function(key) {
        $fb047830d7776fb2$var$removeStyleTags(key, instanceId);
        $fb047830d7776fb2$var$tokenKeys.delete(key);
    });
}
var $fb047830d7776fb2$export$18602cb46ae80b62 = function getComputedToken(originToken, overrideToken, theme, format) {
    var derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    var mergedDerivativeToken = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, derivativeToken), overrideToken);
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
var $fb047830d7776fb2$export$270fba097347f4fa = 'token';
function $fb047830d7776fb2$export$2e2bcd8739ae039(theme, tokens) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _useContext = (0, $acw62.useContext)((0, $182b356f02bf1b9b$export$2e2bcd8739ae039)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var _option$salt = option.salt, salt = _option$salt === void 0 ? '' : _option$salt, _option$override = option.override, override = _option$override === void 0 ? $fb047830d7776fb2$var$EMPTY_OVERRIDE : _option$override, formatToken = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
    // Basic - We do basic cache here
    var mergedToken = (0, $f97444ff16d95e90$export$6aabcc1951563d93)(function() {
        return Object.assign.apply(Object, [
            {}
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(tokens)));
    }, tokens);
    var tokenStr = (0, $f97444ff16d95e90$export$597374558a261efc)(mergedToken);
    var overrideTokenStr = (0, $f97444ff16d95e90$export$597374558a261efc)(override);
    var cssVarStr = cssVar ? (0, $f97444ff16d95e90$export$597374558a261efc)(cssVar) : '';
    var cachedToken = (0, $5cf8f09379a7b7de$export$2e2bcd8739ae039)($fb047830d7776fb2$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], function() {
        var _cssVar$key;
        var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $fb047830d7776fb2$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        // Replace token value with css variables
        var actualToken = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedDerivativeToken);
        var cssVarsStr = '';
        if (!!cssVar) {
            var _transformToken = (0, $5a4d26b111585357$export$67858afe85bce49f)(mergedDerivativeToken, cssVar.key, {
                prefix: cssVar.prefix,
                ignore: cssVar.ignore,
                unitless: cssVar.unitless,
                preserve: cssVar.preserve
            });
            var _transformToken2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_transformToken, 2);
            mergedDerivativeToken = _transformToken2[0];
            cssVarsStr = _transformToken2[1];
        }
        // Optimize for `useStyleRegister` performance
        var tokenKey = (0, $f97444ff16d95e90$export$6c82d0ebe8f2ea2c)(mergedDerivativeToken, salt);
        mergedDerivativeToken._tokenKey = tokenKey;
        actualToken._tokenKey = (0, $f97444ff16d95e90$export$6c82d0ebe8f2ea2c)(actualToken, salt);
        var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
        mergedDerivativeToken._themeKey = themeKey;
        $fb047830d7776fb2$var$recordCleanToken(themeKey);
        var hashId = "".concat($fb047830d7776fb2$var$hashPrefix, "-").concat((0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(tokenKey));
        mergedDerivativeToken._hashId = hashId; // Not used
        return [
            mergedDerivativeToken,
            hashId,
            actualToken,
            cssVarsStr,
            (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ''
        ];
    }, function(cache) {
        // Remove token will remove all related style
        $fb047830d7776fb2$var$cleanTokenStyle(cache[0]._themeKey, instanceId);
    }, function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 4), token = _ref2[0], cssVarsStr = _ref2[3];
        if (cssVar && cssVarsStr) {
            var style = (0, $3a22468320d7d808$export$4d99a2890bb989f0)(cssVarsStr, (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)("css-variables-".concat(token._themeKey)), {
                mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
                prepend: 'queue',
                attachTo: container,
                priority: -999
            });
            style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] = instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $182b356f02bf1b9b$export$5d99297dcd5476ac), token._themeKey);
        }
    });
    return cachedToken;
}
var $fb047830d7776fb2$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cache, 5), realToken = _cache[2], styleStr = _cache[3], cssVarKey = _cache[4];
    var _ref3 = options || {}, plain = _ref3.plain;
    if (!styleStr) return null;
    var styleId = realToken._tokenKey;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    var styleText = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};






var $acw62 = parcelRequire("acw62");




function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}










var $acw62 = parcelRequire("acw62");
var $d9263a4c6739b952$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d9263a4c6739b952$export$2e2bcd8739ae039 = $d9263a4c6739b952$var$unitlessKeys;


var $e853ac0080e24cb4$export$71ad59f2e432cfe8 = '-ms-';
var $e853ac0080e24cb4$export$2c0f367103c8d01c = '-moz-';
var $e853ac0080e24cb4$export$39dfd62a25e0fe93 = '-webkit-';
var $e853ac0080e24cb4$export$a29989082612d0d9 = 'comm';
var $e853ac0080e24cb4$export$aa3a2e812ca8570d = 'rule';
var $e853ac0080e24cb4$export$527d108ccf083c2b = 'decl';
var $e853ac0080e24cb4$export$d3d35020fa5b54f0 = '@page';
var $e853ac0080e24cb4$export$500415a86c544f73 = '@media';
var $e853ac0080e24cb4$export$a763edbf796b780a = '@import';
var $e853ac0080e24cb4$export$2790aeb8b4e5c826 = '@charset';
var $e853ac0080e24cb4$export$1cc683e23b84b133 = '@viewport';
var $e853ac0080e24cb4$export$9447a5efea57e862 = '@supports';
var $e853ac0080e24cb4$export$ef011b4e114b1fba = '@document';
var $e853ac0080e24cb4$export$6aad947bda0f3f46 = '@namespace';
var $e853ac0080e24cb4$export$b44a8529a35fcb60 = '@keyframes';
var $e853ac0080e24cb4$export$2c16de31893252e6 = '@font-face';
var $e853ac0080e24cb4$export$3d846dd52e150c6f = '@counter-style';
var $e853ac0080e24cb4$export$22314bfbb57653fe = '@font-feature-values';
var $e853ac0080e24cb4$export$d773506282b3cfe6 = '@layer';
var $e853ac0080e24cb4$export$1c5a554c78c0cd12 = '@scope';


/**
 * @param {number}
 * @return {number}
 */ var $5e4f012072913cb4$export$2335f513bbd82c6d = Math.abs;
var $5e4f012072913cb4$export$6788812c4e6611e6 = String.fromCharCode;
var $5e4f012072913cb4$export$e6e34fd1f2686227 = Object.assign;
function $5e4f012072913cb4$export$d6af199866bfb566(value, length) {
    return $5e4f012072913cb4$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 0)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 1)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 2)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 3) : 0;
}
function $5e4f012072913cb4$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $5e4f012072913cb4$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $5e4f012072913cb4$export$f8e21b1e77979a08(value, search, position) {
    return value.indexOf(search, position);
}
function $5e4f012072913cb4$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $5e4f012072913cb4$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $5e4f012072913cb4$export$36776f635604f274(value) {
    return value.length;
}
function $5e4f012072913cb4$export$f9084667e487ed46(value) {
    return value.length;
}
function $5e4f012072913cb4$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $5e4f012072913cb4$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $5e4f012072913cb4$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern);
    });
}



var $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = 1;
var $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1;
var $f4f4fca9115ed8bd$export$f24224f1c91d8156 = 0;
var $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0;
var $f4f4fca9115ed8bd$export$c0306caf338ac095 = 0;
var $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '';
function $f4f4fca9115ed8bd$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c,
        column: $f4f4fca9115ed8bd$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $f4f4fca9115ed8bd$export$784d13d8ee351f07(root, props) {
    return (0, $5e4f012072913cb4$export$e6e34fd1f2686227)($f4f4fca9115ed8bd$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $f4f4fca9115ed8bd$export$590e8b2c435046d9(root) {
    while(root.root)root = $f4f4fca9115ed8bd$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(root, root.siblings);
}
function $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7() {
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$232faf9add678146() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 > 0 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, --$f4f4fca9115ed8bd$export$5880b8b5730aff45) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3--, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c--;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 < $f4f4fca9115ed8bd$export$f24224f1c91d8156 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45++) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3++, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c++;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() {
    return (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}
function $f4f4fca9115ed8bd$export$e88cb2efb12ae807() {
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$58adb3bec8346d0f(begin, end) {
    return (0, $5e4f012072913cb4$export$2f35ab04d2335697)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, begin, end);
}
function $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f4f4fca9115ed8bd$export$2de70f21292aac9e(value) {
    return $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$f24224f1c91d8156 = (0, $5e4f012072913cb4$export$36776f635604f274)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = value), $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0, [];
}
function $f4f4fca9115ed8bd$export$45918ac1574455b1(value) {
    return $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '', value;
}
function $f4f4fca9115ed8bd$export$410ac95b9ec204b8(type) {
    return (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)($f4f4fca9115ed8bd$export$58adb3bec8346d0f($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1, $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff(value) {
    return $f4f4fca9115ed8bd$export$45918ac1574455b1($f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1($f4f4fca9115ed8bd$export$2de70f21292aac9e(value)));
}
function $f4f4fca9115ed8bd$export$7af1228ff777d175(type) {
    while($f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$4d3fb11e950abb9e())if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 33) $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    else break;
    return $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) > 2 || $f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1(children) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095)){
        case 0:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$c2ab62c7bf24634($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$410ac95b9ec204b8($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
            break;
        default:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)((0, $5e4f012072913cb4$export$6788812c4e6611e6)($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
    }
    return children;
}
function $f4f4fca9115ed8bd$export$955ba06d119e085e(index, count) {
    while(--count && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 48 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 102 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 57 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 65 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 70 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 97) break;
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$e88cb2efb12ae807() + (count < 6 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() == 32 && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() == 32));
}
function $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12($f4f4fca9115ed8bd$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
            break;
    }
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$4254d4e2b3745c4c(type, index) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// //
    if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 57) break;
    else if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 84 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1) + '*' + (0, $5e4f012072913cb4$export$6788812c4e6611e6)(type === 47 ? type : $f4f4fca9115ed8bd$export$48cfd1e771a65c4f());
}
function $f4f4fca9115ed8bd$export$c2ab62c7bf24634(index) {
    while(!$f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$4d3fb11e950abb9e()))$f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}


function $36ea00327b41abe1$export$ef7acd7185315e22(value) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($36ea00327b41abe1$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $36ea00327b41abe1$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $5e4f012072913cb4$export$f8e21b1e77979a08)(characters += (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f', (0, $5e4f012072913cb4$export$2335f513bbd82c6d)(index ? points[index - 1] : 0)) != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $f4f4fca9115ed8bd$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $f4f4fca9115ed8bd$export$955ba06d119e085e)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$4a34f930e789283c((0, $f4f4fca9115ed8bd$export$4254d4e2b3745c4c)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)(), (0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)()), root, parent, declarations), declarations);
                    if (((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(previous || 1) == 5 || (0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() || 1) == 5) && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) && (0, $5e4f012072913cb4$export$2f35ab04d2335697)(characters, -1, void 0) !== ' ') characters += ' ';
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $5e4f012072913cb4$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && ((0, $5e4f012072913cb4$export$36776f635604f274)(characters) - length || variable === 0 && previous === 47)) (0, $5e4f012072913cb4$export$10d8903dec122b9d)(property > 32 ? $36ea00327b41abe1$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $36ea00327b41abe1$export$f8483753829ec8f3((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(reference = $36ea00327b41abe1$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $36ea00327b41abe1$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else {
                            switch(atrule){
                                // c(ontainer)
                                case 99:
                                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, 3) === 110) break;
                                // l(ayer)
                                case 108:
                                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, 2) === 97) break;
                                default:
                                    offset = 0;
                                // d(ocument) m(edia) s(upports)
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (offset) $36ea00327b41abe1$export$98e6a39c04603d36(value, reference, reference, rule && (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                            else $36ea00327b41abe1$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                ''
                            ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $5e4f012072913cb4$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $f4f4fca9115ed8bd$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $5e4f012072913cb4$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 45) characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
                    atrule = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(), offset = length = (0, $5e4f012072913cb4$export$36776f635604f274)(type = characters += (0, $f4f4fca9115ed8bd$export$c2ab62c7bf24634)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $36ea00327b41abe1$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $5e4f012072913cb4$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, post + 1, post = (0, $5e4f012072913cb4$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $e853ac0080e24cb4$export$aa3a2e812ca8570d) : type, props, children, length, siblings);
}
function $36ea00327b41abe1$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$a29989082612d0d9), (0, $5e4f012072913cb4$export$6788812c4e6611e6)((0, $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7)()), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 2, -2), 0, siblings);
}
function $36ea00327b41abe1$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$527d108ccf083c2b), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 0, length), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length + 1, -1), length, siblings);
}



function $8f2522f8594faa86$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $8f2522f8594faa86$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $e853ac0080e24cb4$export$a763edbf796b780a:
        case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $e853ac0080e24cb4$export$a29989082612d0d9:
            return '';
        case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            if (!(0, $5e4f012072913cb4$export$36776f635604f274)(element.value = element.props.join(','))) return '';
    }
    return (0, $5e4f012072913cb4$export$36776f635604f274)(children = $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}



function $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03(message, info) {
    var path = info.path, parentSelectors = info.parentSelectors;
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "[Ant Design CSS-in-JS] ".concat(path ? "Error in ".concat(path, ": ") : '').concat(message).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(' | ')) : ''));
}


var $e6dfef8f0af50f8c$var$linter = function linter(key, value, info) {
    if (key === 'content') {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        var contentValues = [
            'normal',
            'none',
            'initial',
            'inherit',
            'unset'
        ];
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
};
var $e6dfef8f0af50f8c$export$2e2bcd8739ae039 = $e6dfef8f0af50f8c$var$linter;



var $ce6167d258bd4ce8$var$linter = function linter(key, value, info) {
    if (key === 'animation') {
        if (info.hashId && value !== 'none') (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
};
var $ce6167d258bd4ce8$export$2e2bcd8739ae039 = $ce6167d258bd4ce8$var$linter;



function $0f2f0342ec57fd4c$var$isConcatSelector(selector) {
    var _selector$match;
    var notContent = ((_selector$match = selector.match(/:not\(([^)]*)\)/)) === null || _selector$match === void 0 ? void 0 : _selector$match[1]) || '';
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    var splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter(function(str) {
        return str;
    });
    return splitCells.length > 1;
}
function $0f2f0342ec57fd4c$var$parsePath(info) {
    return info.parentSelectors.reduce(function(prev, cur) {
        if (!prev) return cur;
        return cur.includes('&') ? cur.replace(/&/g, prev) : "".concat(prev, " ").concat(cur);
    }, '');
}
var $0f2f0342ec57fd4c$var$linter = function linter(key, value, info) {
    var parentSelectorPath = $0f2f0342ec57fd4c$var$parsePath(info);
    var notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($0f2f0342ec57fd4c$var$isConcatSelector)) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("Concat ':not' selector not support in legacy browsers.", info);
};
var $0f2f0342ec57fd4c$export$2e2bcd8739ae039 = $0f2f0342ec57fd4c$var$linter;



var $dfba7bff08539c12$var$linter = function linter(key, value, info) {
    switch(key){
        case 'marginLeft':
        case 'marginRight':
        case 'paddingLeft':
        case 'paddingRight':
        case 'left':
        case 'right':
        case 'borderLeft':
        case 'borderLeftWidth':
        case 'borderLeftStyle':
        case 'borderLeftColor':
        case 'borderRight':
        case 'borderRightWidth':
        case 'borderRightStyle':
        case 'borderRightColor':
        case 'borderTopLeftRadius':
        case 'borderTopRightRadius':
        case 'borderBottomLeftRadius':
        case 'borderBottomRightRadius':
            (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using non-logical property '".concat(key, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case 'margin':
        case 'padding':
        case 'borderWidth':
        case 'borderStyle':
            // case 'borderColor':
            if (typeof value === 'string') {
                var valueArr = value.split(' ').map(function(item) {
                    return item.trim();
                });
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using '".concat(key, "' property with different left ").concat(key, " and right ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        case 'clear':
        case 'textAlign':
            if (value === 'left' || value === 'right') (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case 'borderRadius':
            if (typeof value === 'string') {
                var radiusGroups = value.split('/').map(function(item) {
                    return item.trim();
                });
                var invalid = radiusGroups.reduce(function(result, group) {
                    if (result) return result;
                    var radiusArr = group.split(' ').map(function(item) {
                        return item.trim();
                    });
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        default:
    }
};
var $dfba7bff08539c12$export$2e2bcd8739ae039 = $dfba7bff08539c12$var$linter;



var $c9b112fad2a88d07$var$linter = function linter(key, value, info) {
    if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
};
var $c9b112fad2a88d07$export$2e2bcd8739ae039 = $c9b112fad2a88d07$var$linter;



var $71a97720875b4c78$var$linter = function linter(key, value, info) {
    if (info.parentSelectors.some(function(selector) {
        var selectors = selector.split(',');
        return selectors.some(function(item) {
            return item.split('&').length > 2;
        });
    })) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)('Should not use more than one `&` in a selector.', info);
};
var $71a97720875b4c78$export$2e2bcd8739ae039 = $71a97720875b4c78$var$linter;









var $535d769197131042$export$1c054aa01963e47e = 'data-ant-cssinjs-cache-path';
var $535d769197131042$export$e0a2f8ff7fc63361 = '_FILE_STYLE__';
function $535d769197131042$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map(function(path) {
        var hash = cachePathMap[path];
        return "".concat(path, ":").concat(hash);
    }).join(';');
}
var $535d769197131042$var$cachePathMap;
var $535d769197131042$var$fromCSSFile = true;
function $535d769197131042$export$aad8462122ac592b(mockCache) {
    var fromFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $535d769197131042$var$cachePathMap = mockCache;
    $535d769197131042$var$fromCSSFile = fromFile;
}
function $535d769197131042$export$18298bb220d85216() {
    if (!$535d769197131042$var$cachePathMap) {
        $535d769197131042$var$cachePathMap = {};
        if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
            var div = document.createElement('div');
            div.className = $535d769197131042$export$1c054aa01963e47e;
            div.style.position = 'fixed';
            div.style.visibility = 'hidden';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            var content = getComputedStyle(div).content || '';
            content = content.replace(/^"/, '').replace(/"$/, '');
            // Fill data
            content.split(';').forEach(function(item) {
                var _item$split = item.split(':'), _item$split2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_item$split, 2), path = _item$split2[0], hash = _item$split2[1];
                $535d769197131042$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            var inlineMapStyle = document.querySelector("style[".concat($535d769197131042$export$1c054aa01963e47e, "]"));
            if (inlineMapStyle) {
                var _inlineMapStyle$paren;
                $535d769197131042$var$fromCSSFile = false;
                (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $535d769197131042$export$5aa0d776d676ab98(path) {
    $535d769197131042$export$18298bb220d85216();
    return !!$535d769197131042$var$cachePathMap[path];
}
function $535d769197131042$export$d3851dfd3659b2ce(path) {
    var hash = $535d769197131042$var$cachePathMap[path];
    var styleStr = null;
    if (hash && (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
        if ($535d769197131042$var$fromCSSFile) styleStr = $535d769197131042$export$e0a2f8ff7fc63361;
        else {
            var _style = document.querySelector("style[".concat((0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e), "=\"").concat($535d769197131042$var$cachePathMap[path], "\"]"));
            if (_style) styleStr = _style.innerHTML;
            else // Clean up since not exist anymore
            delete $535d769197131042$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}



var $7927865cee518bb3$var$SKIP_CHECK = '_skip_check_';
var $7927865cee518bb3$var$MULTI_VALUE = '_multi_value_';
function $7927865cee518bb3$export$8756898546458274(styleStr) {
    var serialized = (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)((0, $36ea00327b41abe1$export$ef7acd7185315e22)(styleStr), (0, $8f2522f8594faa86$export$fac44ee5b035f737));
    return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function $7927865cee518bb3$var$isCompoundCSSProperty(value) {
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && value && ($7927865cee518bb3$var$SKIP_CHECK in value || $7927865cee518bb3$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $7927865cee518bb3$var$injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    var hashClassName = ".".concat(hashId);
    var hashSelector = hashPriority === 'low' ? ":where(".concat(hashClassName, ")") : hashClassName;
    // 注入 hashId
    var keys = key.split(',').map(function(k) {
        var _firstPath$match;
        var fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        var firstPath = fullPath[0] || '';
        var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || '';
        firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
        return [
            firstPath
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(fullPath.slice(1))).join(' ');
    });
    return keys.join(',');
}
var $7927865cee518bb3$export$e13dc740254f53d7 = function parseStyle(interpolation) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        root: true,
        parentSelectors: []
    }, root = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
    var hashId = config.hashId, layer = config.layer, path = config.path, hashPriority = config.hashPriority, _config$transformers = config.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config.linters, linters = _config$linters === void 0 ? [] : _config$linters;
    var styleStr = '';
    var effectStyle = {};
    function parseKeyframes(keyframes) {
        var animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            var _parseStyle = parseStyle(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            }), _parseStyle2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_parseStyle, 1), _parsedStr = _parseStyle2[0];
            effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
        }
    }
    function flattenList(list) {
        var fullList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        list.forEach(function(item) {
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach(function(originStyle) {
        // Only root level can use raw string
        var style = typeof originStyle === 'string' && !root ? {} : originStyle;
        if (typeof style === 'string') styleStr += "".concat(style, "\n");
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            var mergedStyle = transformers.reduce(function(prev, trans) {
                var _trans$visit;
                return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev)) || prev;
            }, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach(function(key) {
                var value = mergedStyle[key];
                if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && value && (key !== 'animationName' || !value._keyframe) && !$7927865cee518bb3$var$isCompoundCSSProperty(value)) {
                    var subInjectHash = false;
                    // 当成嵌套对象来处理
                    var mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    var nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith('@')) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else if (mergedKey === '&') // 抹掉 root selector 上的单个 &
                        mergedKey = $7927865cee518bb3$var$injectSelectorHash('', hashId, hashPriority);
                        else // 注入 hashId
                        mergedKey = $7927865cee518bb3$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = '';
                        nextRoot = true;
                    }
                    var _parseStyle3 = parseStyle(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(parentSelectors), [
                            mergedKey
                        ])
                    }), _parseStyle4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
                    effectStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, effectStyle), childEffectStyle);
                    styleStr += "".concat(mergedKey).concat(_parsedStr2);
                } else {
                    var _value;
                    function appendStyle(cssKey, cssValue) {
                        // 如果是样式则直接插入
                        var styleName = cssKey.replace(/[A-Z]/g, function(match) {
                            return "-".concat(match.toLowerCase());
                        });
                        // Auto suffix with px
                        var formatValue = cssValue;
                        if (!(0, $d9263a4c6739b952$export$2e2bcd8739ae039)[cssKey] && typeof formatValue === 'number' && formatValue !== 0) formatValue = "".concat(formatValue, "px");
                        // handle animationName & Keyframe value
                        if (cssKey === 'animationName' && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += "".concat(styleName, ":").concat(formatValue, ";");
                    }
                    var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
                    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && value !== null && value !== void 0 && value[$7927865cee518bb3$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach(function(item) {
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = "{".concat(styleStr, "}");
    else if (layer) {
        // fixme: https://github.com/thysultan/stylis/pull/339
        if (styleStr) styleStr = "@layer ".concat(layer.name, " {").concat(styleStr, "}");
        if (layer.dependencies) effectStyle["@layer ".concat(layer.name)] = layer.dependencies.map(function(deps) {
            return "@layer ".concat(deps, ", ").concat(layer.name, ";");
        }).join('\n');
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $7927865cee518bb3$export$412618713057f6ca(path, styleStr) {
    return (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)("".concat(path.join('%')).concat(styleStr));
}
function $7927865cee518bb3$var$Empty() {
    return null;
}
var $7927865cee518bb3$export$1e6d9f0d06c7ec14 = 'style';
function $7927865cee518bb3$export$2e2bcd8739ae039(info, styleFn) {
    var token = info.token, path = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
    var _React$useContext = $acw62.useContext((0, $182b356f02bf1b9b$export$2e2bcd8739ae039)), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache = _React$useContext.cache, enableLayer = _React$useContext.layer;
    var tokenKey = token._tokenKey;
    var fullPath = [
        tokenKey
    ];
    if (enableLayer) fullPath.push('layer');
    fullPath.push.apply(fullPath, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(path));
    // Check if need insert style
    var isMergedClientSide = (0, $f97444ff16d95e90$export$9542afab8c2a5f48);
    var _useGlobalCache = (0, $5cf8f09379a7b7de$export$2e2bcd8739ae039)($7927865cee518bb3$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    function() {
        var cachePath = fullPath.join('|');
        // Get style from SSR inline style directly
        if ((0, $535d769197131042$export$5aa0d776d676ab98)(cachePath)) {
            var _getStyleAndHash = (0, $535d769197131042$export$d3851dfd3659b2ce)(cachePath), _getStyleAndHash2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                tokenKey,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        var styleObj = styleFn();
        var _parseStyle5 = $7927865cee518bb3$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join('-'),
            transformers: transformers,
            linters: linters
        }), _parseStyle6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
        var styleStr = $7927865cee518bb3$export$8756898546458274(parsedStyle);
        var styleId = $7927865cee518bb3$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            tokenKey,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    function(_ref2, fromHMR) {
        var _ref3 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref2, 3), styleId = _ref3[2];
        if ((fromHMR || autoClear) && (0, $f97444ff16d95e90$export$9542afab8c2a5f48)) (0, $3a22468320d7d808$export$2232e336aecaa80a)(styleId, {
            mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e)
        });
    }, // Effect: Inject style here
    function(_ref4) {
        var _ref5 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref4, 4), styleStr = _ref5[0], _ = _ref5[1], styleId = _ref5[2], effectStyle = _ref5[3];
        if (isMergedClientSide && styleStr !== (0, $535d769197131042$export$e0a2f8ff7fc63361)) {
            var mergedCSSConfig = {
                mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
                prepend: enableLayer ? false : 'queue',
                attachTo: container,
                priority: order
            };
            var nonceStr = typeof nonce === 'function' ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            var effectLayerKeys = [];
            var effectRestKeys = [];
            Object.keys(effectStyle).forEach(function(key) {
                if (key.startsWith('@layer')) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach(function(effectKey) {
                (0, $3a22468320d7d808$export$4d99a2890bb989f0)($7927865cee518bb3$export$8756898546458274(effectStyle[effectKey]), "_layer-".concat(effectKey), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedCSSConfig), {}, {
                    prepend: true
                }));
            });
            // ==================== Inject Style ====================
            // Inject style
            var style = (0, $3a22468320d7d808$export$4d99a2890bb989f0)(styleStr, styleId, mergedCSSConfig);
            style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] = cache.instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $182b356f02bf1b9b$export$5d99297dcd5476ac), tokenKey);
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach(function(effectKey) {
                (0, $3a22468320d7d808$export$4d99a2890bb989f0)($7927865cee518bb3$export$8756898546458274(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
            });
        }
    }), _useGlobalCache2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
    return function(node) {
        var styleNode;
        if (!ssrInline || isMergedClientSide || !defaultCache) styleNode = /*#__PURE__*/ $acw62.createElement($7927865cee518bb3$var$Empty, null);
        else {
            var _ref6;
            styleNode = /*#__PURE__*/ $acw62.createElement("style", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (_ref6 = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref6, (0, $182b356f02bf1b9b$export$5d99297dcd5476ac), cachedTokenKey), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_ref6, (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e), cachedStyleId), _ref6), {
                dangerouslySetInnerHTML: {
                    __html: cachedStyleStr
                }
            }));
        }
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, styleNode, node);
    };
}
var $7927865cee518bb3$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cache, 6), styleStr = _cache[0], tokenKey = _cache[1], styleId = _cache[2], effectStyle = _cache[3], clientOnly = _cache[4], order = _cache[5];
    var _ref7 = options || {}, plain = _ref7.plain;
    // Skip client only style
    if (clientOnly) return null;
    var keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    // ====================== Style ======================
    keyStyleText = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(styleStr, tokenKey, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach(function(effectKey) {
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            var effectStyleStr = $7927865cee518bb3$export$8756898546458274(effectStyle[effectKey]);
            var effectStyleHTML = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
            if (effectKey.startsWith('@layer')) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};


var $4766d7657208f51d$export$d96c342855c5e1fc = 'cssVar';
var $4766d7657208f51d$var$useCSSVarRegister = function useCSSVarRegister(config, fn) {
    var key = config.key, prefix = config.prefix, unitless = config.unitless, ignore = config.ignore, token = config.token, _config$scope = config.scope, scope = _config$scope === void 0 ? '' : _config$scope;
    var _useContext = (0, $acw62.useContext)((0, $182b356f02bf1b9b$export$2e2bcd8739ae039)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var tokenKey = token._tokenKey;
    var stylePath = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(config.path), [
        key,
        scope,
        tokenKey
    ]);
    var cache = (0, $5cf8f09379a7b7de$export$2e2bcd8739ae039)($4766d7657208f51d$export$d96c342855c5e1fc, stylePath, function() {
        var originToken = fn();
        var _transformToken = (0, $5a4d26b111585357$export$67858afe85bce49f)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope
        }), _transformToken2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
        var styleId = (0, $7927865cee518bb3$export$412618713057f6ca)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 3), styleId = _ref2[2];
        if (0, $f97444ff16d95e90$export$9542afab8c2a5f48) (0, $3a22468320d7d808$export$2232e336aecaa80a)(styleId, {
            mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e)
        });
    }, function(_ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
        if (!cssVarsStr) return;
        var style = (0, $3a22468320d7d808$export$4d99a2890bb989f0)(cssVarsStr, styleId, {
            mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $182b356f02bf1b9b$export$5d99297dcd5476ac), key);
    });
    return cache;
};
var $4766d7657208f51d$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cache, 4), styleStr = _cache[1], styleId = _cache[2], cssVarKey = _cache[3];
    var _ref5 = options || {}, plain = _ref5.plain;
    if (!styleStr) return null;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    var styleText = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $4766d7657208f51d$export$2e2bcd8739ae039 = $4766d7657208f51d$var$useCSSVarRegister;





var $0c1aa9cd61c22229$var$_ExtractStyleFns;
var $0c1aa9cd61c22229$var$ExtractStyleFns = ($0c1aa9cd61c22229$var$_ExtractStyleFns = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($0c1aa9cd61c22229$var$_ExtractStyleFns, (0, $7927865cee518bb3$export$1e6d9f0d06c7ec14), (0, $7927865cee518bb3$export$f9380c9a627682d3)), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($0c1aa9cd61c22229$var$_ExtractStyleFns, (0, $fb047830d7776fb2$export$270fba097347f4fa), (0, $fb047830d7776fb2$export$f9380c9a627682d3)), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($0c1aa9cd61c22229$var$_ExtractStyleFns, (0, $4766d7657208f51d$export$d96c342855c5e1fc), (0, $4766d7657208f51d$export$f9380c9a627682d3)), $0c1aa9cd61c22229$var$_ExtractStyleFns);
function $0c1aa9cd61c22229$var$isNotNull(value) {
    return value !== null;
}
function $0c1aa9cd61c22229$export$2e2bcd8739ae039(cache, options) {
    var _ref = typeof options === 'boolean' ? {
        plain: options
    } : options || {}, _ref$plain = _ref.plain, plain = _ref$plain === void 0 ? false : _ref$plain, _ref$types = _ref.types, types = _ref$types === void 0 ? [
        'style',
        'token',
        'cssVar'
    ] : _ref$types;
    var matchPrefixRegexp = new RegExp("^(".concat((typeof types === 'string' ? [
        types
    ] : types).join('|'), ")%"));
    // prefix with `style` is used for `useStyleRegister` to cache style context
    var styleKeys = Array.from(cache.cache.keys()).filter(function(key) {
        return matchPrefixRegexp.test(key);
    });
    // Common effect styles like animation
    var effectStyles = {};
    // Mapping of cachePath to style hash
    var cachePathMap = {};
    var styleText = '';
    styleKeys.map(function(key) {
        var cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
        var _key$split = key.split('%'), _key$split2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_key$split, 1), prefix = _key$split2[0];
        var extractFn = $0c1aa9cd61c22229$var$ExtractStyleFns[prefix];
        var extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        var _extractedStyle = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(extractedStyle, 3), order = _extractedStyle[0], styleId = _extractedStyle[1], styleStr = _extractedStyle[2];
        if (key.startsWith('style')) cachePathMap[cachePath] = styleId;
        return [
            order,
            styleStr
        ];
    }).filter($0c1aa9cd61c22229$var$isNotNull).sort(function(_ref2, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref2, 1), o1 = _ref4[0];
        var _ref5 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 1), o2 = _ref5[0];
        return o1 - o2;
    }).forEach(function(_ref6) {
        var _ref7 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref6, 2), style = _ref7[1];
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(".".concat((0, $535d769197131042$export$1c054aa01963e47e), "{content:\"").concat((0, $535d769197131042$export$dfdc1655ccc5b9cb)(cachePathMap), "\";}"), undefined, undefined, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $535d769197131042$export$1c054aa01963e47e), (0, $535d769197131042$export$1c054aa01963e47e)), plain);
    return styleText;
}








var $cb64545ddf8f118e$var$Keyframe = /*#__PURE__*/ function() {
    function Keyframe(name, style) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Keyframe);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "name", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "style", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_keyframe", true);
        this.name = name;
        this.style = style;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Keyframe, [
        {
            key: "getName",
            value: function getName() {
                var hashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
            }
        }
    ]);
    return Keyframe;
}();
var $cb64545ddf8f118e$export$2e2bcd8739ae039 = $cb64545ddf8f118e$var$Keyframe;






function $c8e2e5c3988aca39$var$splitValues(value) {
    if (typeof value === 'number') return [
        [
            value
        ],
        false
    ];
    var rawStyle = String(value).trim();
    var importantCells = rawStyle.match(/(.*)(!important)/);
    var splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    var temp = [];
    var brackets = 0;
    return [
        splitStyle.reduce(function(list, item) {
            if (item.includes('(') || item.includes(')')) {
                var left = item.split('(').length - 1;
                var right = item.split(')').length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(' '));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $c8e2e5c3988aca39$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
var $c8e2e5c3988aca39$var$keyMap = {
    // Inset
    inset: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    insetBlock: [
        'top',
        'bottom'
    ],
    insetBlockStart: [
        'top'
    ],
    insetBlockEnd: [
        'bottom'
    ],
    insetInline: [
        'left',
        'right'
    ],
    insetInlineStart: [
        'left'
    ],
    insetInlineEnd: [
        'right'
    ],
    // Margin
    marginBlock: [
        'marginTop',
        'marginBottom'
    ],
    marginBlockStart: [
        'marginTop'
    ],
    marginBlockEnd: [
        'marginBottom'
    ],
    marginInline: [
        'marginLeft',
        'marginRight'
    ],
    marginInlineStart: [
        'marginLeft'
    ],
    marginInlineEnd: [
        'marginRight'
    ],
    // Padding
    paddingBlock: [
        'paddingTop',
        'paddingBottom'
    ],
    paddingBlockStart: [
        'paddingTop'
    ],
    paddingBlockEnd: [
        'paddingBottom'
    ],
    paddingInline: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingInlineStart: [
        'paddingLeft'
    ],
    paddingInlineEnd: [
        'paddingRight'
    ],
    // Border
    borderBlock: $c8e2e5c3988aca39$var$noSplit([
        'borderTop',
        'borderBottom'
    ]),
    borderBlockStart: $c8e2e5c3988aca39$var$noSplit([
        'borderTop'
    ]),
    borderBlockEnd: $c8e2e5c3988aca39$var$noSplit([
        'borderBottom'
    ]),
    borderInline: $c8e2e5c3988aca39$var$noSplit([
        'borderLeft',
        'borderRight'
    ]),
    borderInlineStart: $c8e2e5c3988aca39$var$noSplit([
        'borderLeft'
    ]),
    borderInlineEnd: $c8e2e5c3988aca39$var$noSplit([
        'borderRight'
    ]),
    // Border width
    borderBlockWidth: [
        'borderTopWidth',
        'borderBottomWidth'
    ],
    borderBlockStartWidth: [
        'borderTopWidth'
    ],
    borderBlockEndWidth: [
        'borderBottomWidth'
    ],
    borderInlineWidth: [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    borderInlineStartWidth: [
        'borderLeftWidth'
    ],
    borderInlineEndWidth: [
        'borderRightWidth'
    ],
    // Border style
    borderBlockStyle: [
        'borderTopStyle',
        'borderBottomStyle'
    ],
    borderBlockStartStyle: [
        'borderTopStyle'
    ],
    borderBlockEndStyle: [
        'borderBottomStyle'
    ],
    borderInlineStyle: [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    borderInlineStartStyle: [
        'borderLeftStyle'
    ],
    borderInlineEndStyle: [
        'borderRightStyle'
    ],
    // Border color
    borderBlockColor: [
        'borderTopColor',
        'borderBottomColor'
    ],
    borderBlockStartColor: [
        'borderTopColor'
    ],
    borderBlockEndColor: [
        'borderBottomColor'
    ],
    borderInlineColor: [
        'borderLeftColor',
        'borderRightColor'
    ],
    borderInlineStartColor: [
        'borderLeftColor'
    ],
    borderInlineEndColor: [
        'borderRightColor'
    ],
    // Border radius
    borderStartStartRadius: [
        'borderTopLeftRadius'
    ],
    borderStartEndRadius: [
        'borderTopRightRadius'
    ],
    borderEndStartRadius: [
        'borderBottomLeftRadius'
    ],
    borderEndEndRadius: [
        'borderBottomRightRadius'
    ]
};
function $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(value, important) {
    var parsedValue = value;
    if (important) parsedValue = "".concat(parsedValue, " !important");
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ var $c8e2e5c3988aca39$var$transform = {
    visit: function visit(cssObj) {
        var clone = {};
        Object.keys(cssObj).forEach(function(key) {
            var value = cssObj[key];
            var matchValue = $c8e2e5c3988aca39$var$keyMap[key];
            if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
                var _splitValues = $c8e2e5c3988aca39$var$splitValues(value), _splitValues2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_splitValues, 2), _values = _splitValues2[0], _important = _splitValues2[1];
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach(function(matchKey) {
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(value, _important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(_values[0], _important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach(function(matchKey, index) {
                    var _values$index;
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck((_values$index = _values[index]) !== null && _values$index !== void 0 ? _values$index : _values[0], _important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach(function(matchKey, index) {
                    var _ref, _values$index2;
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck((_ref = (_values$index2 = _values[index]) !== null && _values$index2 !== void 0 ? _values$index2 : _values[index - 2]) !== null && _ref !== void 0 ? _ref : _values[0], _important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $c8e2e5c3988aca39$export$2e2bcd8739ae039 = $c8e2e5c3988aca39$var$transform;





var $3d71e62b1d8dd17b$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $3d71e62b1d8dd17b$var$toFixed(number, precision) {
    var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
var $3d71e62b1d8dd17b$var$transform = function transform() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$rootValue = options.rootValue, rootValue = _options$rootValue === void 0 ? 16 : _options$rootValue, _options$precision = options.precision, precision = _options$precision === void 0 ? 5 : _options$precision, _options$mediaQuery = options.mediaQuery, mediaQuery = _options$mediaQuery === void 0 ? false : _options$mediaQuery;
    var pxReplace = function pxReplace(m, $1) {
        if (!$1) return m;
        var pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        var fixedVal = $3d71e62b1d8dd17b$var$toFixed(pixels / rootValue, precision);
        return "".concat(fixedVal, "rem");
    };
    var visit = function visit(cssObj) {
        var clone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, cssObj);
        Object.entries(cssObj).forEach(function(_ref) {
            var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
            if (typeof value === 'string' && value.includes('px')) {
                var newValue = value.replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $d9263a4c6739b952$export$2e2bcd8739ae039)[key] && typeof value === 'number' && value !== 0) clone[key] = "".concat(value, "px").replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
            // Media queries
            var mergedKey = key.trim();
            if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
                var newKey = key.replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $3d71e62b1d8dd17b$export$2e2bcd8739ae039 = $3d71e62b1d8dd17b$var$transform;




var $26595656c8972ad7$export$73abaea5066f503b = {
    supportModernCSS: function supportModernCSS() {
        return (0, $f97444ff16d95e90$export$f51d3b8ac4ac9ed1)() && (0, $f97444ff16d95e90$export$64a912f57d5de48e)();
    }
};



var $acw62 = parcelRequire("acw62");
var $6bacc63174d40f3c$var$IconContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $6bacc63174d40f3c$export$2e2bcd8739ae039 = $6bacc63174d40f3c$var$IconContext;



var $acw62 = parcelRequire("acw62");
function $3f3c7e3b4529c133$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $acw62.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}




function $99416d52921e7282$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $cb7756f32760f64a$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $99416d52921e7282$export$2e2bcd8739ae039)(r);
}


function $25a21422b5053b80$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $5feeebb680a9ff13$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $99416d52921e7282$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $99416d52921e7282$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $50d628198c1e8c18$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $2363349811ac7bbe$export$2e2bcd8739ae039(r) {
    return (0, $cb7756f32760f64a$export$2e2bcd8739ae039)(r) || (0, $25a21422b5053b80$export$2e2bcd8739ae039)(r) || (0, $5feeebb680a9ff13$export$2e2bcd8739ae039)(r) || (0, $50d628198c1e8c18$export$2e2bcd8739ae039)();
}


function $4773d38aff43ad26$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}




function $16921dce7a746d22$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $cd5cae10fc3d2ebd$export$2e2bcd8739ae039(r) {
    return (0, $4773d38aff43ad26$export$2e2bcd8739ae039)(r) || (0, $25a21422b5053b80$export$2e2bcd8739ae039)(r) || (0, $5feeebb680a9ff13$export$2e2bcd8739ae039)(r) || (0, $16921dce7a746d22$export$2e2bcd8739ae039)();
}


function $fa6bae2921213688$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}


function $3478506a110abe5a$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $cd5cae10fc3d2ebd$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $2363349811ac7bbe$export$2e2bcd8739ae039)(entity);
    else clone = (0, $784b8130b41ca462$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $3478506a110abe5a$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $3478506a110abe5a$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $fa6bae2921213688$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $3478506a110abe5a$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $3478506a110abe5a$var$isObject(obj) {
    return (0, $112972238ba0eede$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $3478506a110abe5a$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $3478506a110abe5a$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $3478506a110abe5a$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $3478506a110abe5a$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $fa6bae2921213688$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $3478506a110abe5a$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $fa6bae2921213688$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $3478506a110abe5a$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $112972238ba0eede$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $3478506a110abe5a$export$2e2bcd8739ae039(clone, path, $3478506a110abe5a$var$createEmpty(value));
                    $3478506a110abe5a$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $2363349811ac7bbe$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $3478506a110abe5a$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}



var $acw62 = parcelRequire("acw62");
/* eslint-disable no-console */ var $07c2c6c8bd840836$var$warned = {};
var $07c2c6c8bd840836$var$preWarningFns = [];
var $07c2c6c8bd840836$export$61616f168f0e5a05 = function preMessage(fn) {
    $07c2c6c8bd840836$var$preWarningFns.push(fn);
};
function $07c2c6c8bd840836$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $07c2c6c8bd840836$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $07c2c6c8bd840836$export$60eef1277fe463e4() {
    $07c2c6c8bd840836$var$warned = {};
}
function $07c2c6c8bd840836$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$07c2c6c8bd840836$var$warned[message]) {
        method(false, message);
        $07c2c6c8bd840836$var$warned[message] = true;
    }
}
function $07c2c6c8bd840836$export$82934adf09101657(valid, message) {
    $07c2c6c8bd840836$export$848feb93d8f32b9b($07c2c6c8bd840836$export$491112666e282270, valid, message);
}
function $07c2c6c8bd840836$export$89ff31684837bbbf(valid, message) {
    $07c2c6c8bd840836$export$848feb93d8f32b9b($07c2c6c8bd840836$export$a92e4c44d367d0af, valid, message);
}
$07c2c6c8bd840836$export$82934adf09101657.preMessage = $07c2c6c8bd840836$export$61616f168f0e5a05;
$07c2c6c8bd840836$export$82934adf09101657.resetWarned = $07c2c6c8bd840836$export$60eef1277fe463e4;
$07c2c6c8bd840836$export$82934adf09101657.noteOnce = $07c2c6c8bd840836$export$89ff31684837bbbf;
var $07c2c6c8bd840836$export$2e2bcd8739ae039 = $07c2c6c8bd840836$export$82934adf09101657;


function $5bd796dbed593bbb$export$8793edee2d425525() {}
let $5bd796dbed593bbb$var$deprecatedWarnList = null;
function $5bd796dbed593bbb$export$60eef1277fe463e4() {
    $5bd796dbed593bbb$var$deprecatedWarnList = null;
    (0, $07c2c6c8bd840836$export$60eef1277fe463e4)();
}
let $5bd796dbed593bbb$var$_warning = $5bd796dbed593bbb$export$8793edee2d425525;
var $5bd796dbed593bbb$var$valid, $5bd796dbed593bbb$var$component, $5bd796dbed593bbb$var$message;
const $5bd796dbed593bbb$var$warning = $5bd796dbed593bbb$var$_warning;
const $5bd796dbed593bbb$export$11b88c75b33aa1fd = /*#__PURE__*/ $acw62.createContext({});
const $5bd796dbed593bbb$export$cf977aa92c751e61 = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = $5bd796dbed593bbb$export$8793edee2d425525;
    return noopWarning;
};
var $5bd796dbed593bbb$export$2e2bcd8739ae039 = $5bd796dbed593bbb$var$warning;



var $acw62 = parcelRequire("acw62");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$efabd6732f69a6da$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);



var $acw62 = parcelRequire("acw62");

var $864f21d08855a737$var$locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
var $864f21d08855a737$export$2e2bcd8739ae039 = $864f21d08855a737$var$locale;



var $356a0e30a0e99b1e$export$bdd78c3fd9633c1e = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};


var $0309ef2dc8eb0939$var$locale = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $356a0e30a0e99b1e$export$bdd78c3fd9633c1e)), {}, {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    dateFormat: 'M/D/YYYY',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
});
var $0309ef2dc8eb0939$export$2e2bcd8739ae039 = $0309ef2dc8eb0939$var$locale;


const $594a5cf7899ad7e1$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $594a5cf7899ad7e1$export$2e2bcd8739ae039 = $594a5cf7899ad7e1$var$locale;


// Merge into a locale object
const $74a89c57a3cfafd2$var$locale = {
    lang: Object.assign({
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ]
    }, (0, $0309ef2dc8eb0939$export$2e2bcd8739ae039)),
    timePickerLocale: Object.assign({}, (0, $594a5cf7899ad7e1$export$2e2bcd8739ae039))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$74a89c57a3cfafd2$export$2e2bcd8739ae039 = $74a89c57a3cfafd2$var$locale;


var $32ded69f6ae6c615$export$2e2bcd8739ae039 = (0, $74a89c57a3cfafd2$export$2e2bcd8739ae039);




const $c7d8dfeaf08e9faa$var$typeTemplate = '${label} is not a valid ${type}';
const $c7d8dfeaf08e9faa$var$localeValues = {
    locale: 'en',
    Pagination: $864f21d08855a737$export$2e2bcd8739ae039,
    DatePicker: $74a89c57a3cfafd2$export$2e2bcd8739ae039,
    TimePicker: $594a5cf7899ad7e1$export$2e2bcd8739ae039,
    Calendar: $32ded69f6ae6c615$export$2e2bcd8739ae039,
    global: {
        placeholder: 'Please select',
        close: 'Close'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckAll: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        deselectAll: 'Deselect all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand',
        collapse: 'Collapse'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $c7d8dfeaf08e9faa$var$typeTemplate,
                method: $c7d8dfeaf08e9faa$var$typeTemplate,
                array: $c7d8dfeaf08e9faa$var$typeTemplate,
                object: $c7d8dfeaf08e9faa$var$typeTemplate,
                number: $c7d8dfeaf08e9faa$var$typeTemplate,
                date: $c7d8dfeaf08e9faa$var$typeTemplate,
                boolean: $c7d8dfeaf08e9faa$var$typeTemplate,
                integer: $c7d8dfeaf08e9faa$var$typeTemplate,
                float: $c7d8dfeaf08e9faa$var$typeTemplate,
                regexp: $c7d8dfeaf08e9faa$var$typeTemplate,
                email: $c7d8dfeaf08e9faa$var$typeTemplate,
                url: $c7d8dfeaf08e9faa$var$typeTemplate,
                hex: $c7d8dfeaf08e9faa$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    Image: {
        preview: 'Preview'
    },
    QRCode: {
        expired: 'QR code expired',
        refresh: 'Refresh',
        scanned: 'Scanned'
    },
    ColorPicker: {
        presetEmpty: 'Empty',
        transparent: 'Transparent',
        singleColor: 'Single',
        gradientColor: 'Gradient'
    }
};
var $c7d8dfeaf08e9faa$export$2e2bcd8739ae039 = $c7d8dfeaf08e9faa$var$localeValues;


let $466e4bebfd7443ca$var$runtimeLocale = Object.assign({}, (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Modal);
let $466e4bebfd7443ca$var$localeList = [];
const $466e4bebfd7443ca$var$generateLocale = ()=>$466e4bebfd7443ca$var$localeList.reduce((merged, locale)=>Object.assign(Object.assign({}, merged), locale), (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Modal);
function $466e4bebfd7443ca$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = Object.assign({}, newLocale);
        $466e4bebfd7443ca$var$localeList.push(cloneLocale);
        $466e4bebfd7443ca$var$runtimeLocale = $466e4bebfd7443ca$var$generateLocale();
        return ()=>{
            $466e4bebfd7443ca$var$localeList = $466e4bebfd7443ca$var$localeList.filter((locale)=>locale !== cloneLocale);
            $466e4bebfd7443ca$var$runtimeLocale = $466e4bebfd7443ca$var$generateLocale();
        };
    }
    $466e4bebfd7443ca$var$runtimeLocale = Object.assign({}, (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Modal);
}
function $466e4bebfd7443ca$export$1b6004afda18cd51() {
    return $466e4bebfd7443ca$var$runtimeLocale;
}



var $acw62 = parcelRequire("acw62");
const $6dd9227cba6de9ce$var$LocaleContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $6dd9227cba6de9ce$export$2e2bcd8739ae039 = $6dd9227cba6de9ce$var$LocaleContext;



var $acw62 = parcelRequire("acw62");


const $0020add6ec984361$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $acw62.useContext((0, $6dd9227cba6de9ce$export$2e2bcd8739ae039));
    const getLocale = $acw62.useMemo(()=>{
        var _a;
        const locale = defaultLocale || (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039)[componentName];
        const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return Object.assign(Object.assign({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $acw62.useMemo(()=>{
        const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) return (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $0020add6ec984361$export$2e2bcd8739ae039 = $0020add6ec984361$var$useLocale;


"use client";
const $766ff256ac32087c$export$b2f162cd5c15ea3e = 'internalMark';
const $766ff256ac32087c$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    $acw62.useEffect(()=>{
        const clearLocale = (0, $466e4bebfd7443ca$export$9485ecb9d81a550c)(locale === null || locale === void 0 ? void 0 : locale.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $acw62.useMemo(()=>Object.assign(Object.assign({}, locale), {
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $6dd9227cba6de9ce$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $766ff256ac32087c$export$2e2bcd8739ae039 = $766ff256ac32087c$var$LocaleProvider;






const $ea19b77d77fd8663$var$round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function $ea19b77d77fd8663$var$splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, '$1')// Remove str after `)`
    .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const $ea19b77d77fd8663$var$parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function $ea19b77d77fd8663$var$limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class $ea19b77d77fd8663$export$2c4f38d6c0ecc25a {
    constructor(input){
        /**
     * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isValid", true);
        /**
     * Red, R in RGB
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "r", 0);
        /**
     * Green, G in RGB
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "g", 0);
        /**
     * Blue, B in RGB
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "b", 0);
        /**
     * Alpha/Opacity, A in RGBA/HSLA
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "a", 1);
        // HSV privates
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_h", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_s", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_l", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_v", void 0);
        // intermediate variables to calculate HSL/HSV
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_max", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_min", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_brightness", void 0);
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === 'string') {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix('rgb')) this.fromRgbString(trimStr);
            else if (matchPrefix('hsl')) this.fromHslString(trimStr);
            else if (matchPrefix('hsv') || matchPrefix('hsb')) this.fromHsvString(trimStr);
        } else if (input instanceof $ea19b77d77fd8663$export$2c4f38d6c0ecc25a) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._s = input._s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat('rgb')) {
            this.r = $ea19b77d77fd8663$var$limitRange(input.r);
            this.g = $ea19b77d77fd8663$var$limitRange(input.g);
            this.b = $ea19b77d77fd8663$var$limitRange(input.b);
            this.a = typeof input.a === 'number' ? $ea19b77d77fd8663$var$limitRange(input.a, 1) : 1;
        } else if (matchFormat('hsl')) this.fromHsl(input);
        else if (matchFormat('hsv')) this.fromHsv(input);
        else throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc('r', value);
    }
    setG(value) {
        return this._sc('g', value);
    }
    setB(value) {
        return this._sc('b', value);
    }
    setA(value) {
        return this._sc('a', value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = $ea19b77d77fd8663$var$round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    getSaturation() {
        if (typeof this._s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._s = 0;
            else this._s = delta / this.getMax();
        }
        return this._s;
    }
    getLightness() {
        if (typeof this._l === 'undefined') this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === 'undefined') this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === 'undefined') this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: $ea19b77d77fd8663$var$round(calc('r')),
            g: $ea19b77d77fd8663$var$round(calc('g')),
            b: $ea19b77d77fd8663$var$round(calc('b')),
            a: $ea19b77d77fd8663$var$round(calc('a') * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return $ea19b77d77fd8663$var$round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc('r'),
            g: calc('g'),
            b: calc('b'),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = '#';
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : '0' + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : '0' + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : '0' + bHex;
        if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
            const aHex = $ea19b77d77fd8663$var$round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : '0' + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = $ea19b77d77fd8663$var$round(this.getSaturation() * 100);
        const l = $ea19b77d77fd8663$var$round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = $ea19b77d77fd8663$var$limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === 'undefined') this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === 'undefined') this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace('#', '');
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h: h, s: s, l: l, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._l = l;
        this.a = typeof a === 'number' ? a : 1;
        if (s <= 0) {
            const rgb = $ea19b77d77fd8663$var$round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = $ea19b77d77fd8663$var$round((r + lightnessModification) * 255);
        this.g = $ea19b77d77fd8663$var$round((g + lightnessModification) * 255);
        this.b = $ea19b77d77fd8663$var$round((b + lightnessModification) * 255);
    }
    fromHsv({ h: h, s: s, v: v, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._v = v;
        this.a = typeof a === 'number' ? a : 1;
        const vv = $ea19b77d77fd8663$var$round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = $ea19b77d77fd8663$var$round(v * (1.0 - s) * 255);
        const q = $ea19b77d77fd8663$var$round(v * (1.0 - s * ff) * 255);
        const t = $ea19b77d77fd8663$var$round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = $ea19b77d77fd8663$var$splitColorStr(trimStr, $ea19b77d77fd8663$var$parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = $ea19b77d77fd8663$var$splitColorStr(trimStr, $ea19b77d77fd8663$var$parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = $ea19b77d77fd8663$var$splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes('%') ? $ea19b77d77fd8663$var$round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}






var $d1dea01cb419bab7$var$hueStep = 2; // 色相阶梯
var $d1dea01cb419bab7$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $d1dea01cb419bab7$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $d1dea01cb419bab7$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $d1dea01cb419bab7$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $d1dea01cb419bab7$var$lightColorCount = 5; // 浅色数量，主色上
var $d1dea01cb419bab7$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $d1dea01cb419bab7$var$darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function $d1dea01cb419bab7$var$getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $d1dea01cb419bab7$var$hueStep * i : Math.round(hsv.h) + $d1dea01cb419bab7$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $d1dea01cb419bab7$var$hueStep * i : Math.round(hsv.h) - $d1dea01cb419bab7$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $d1dea01cb419bab7$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $d1dea01cb419bab7$var$saturationStep * i;
    else if (i === $d1dea01cb419bab7$var$darkColorCount) saturation = hsv.s + $d1dea01cb419bab7$var$saturationStep;
    else saturation = hsv.s + $d1dea01cb419bab7$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $d1dea01cb419bab7$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function $d1dea01cb419bab7$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $d1dea01cb419bab7$var$brightnessStep1 * i;
    else value = hsv.v - $d1dea01cb419bab7$var$brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function $d1dea01cb419bab7$export$2e2bcd8739ae039(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(color);
    var hsv = pColor.toHsv();
    for(var i = $d1dea01cb419bab7$var$lightColorCount; i > 0; i -= 1){
        var c = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)({
            h: $d1dea01cb419bab7$var$getHue(hsv, i, true),
            s: $d1dea01cb419bab7$var$getSaturation(hsv, i, true),
            v: $d1dea01cb419bab7$var$getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(var _i = 1; _i <= $d1dea01cb419bab7$var$darkColorCount; _i += 1){
        var _c = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)({
            h: $d1dea01cb419bab7$var$getHue(hsv, _i),
            s: $d1dea01cb419bab7$var$getSaturation(hsv, _i),
            v: $d1dea01cb419bab7$var$getValue(hsv, _i)
        });
        patterns.push(_c);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $d1dea01cb419bab7$var$darkColorMap.map(function(_ref) {
        var index = _ref.index, amount = _ref.amount;
        return new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString();
    });
    return patterns.map(function(c) {
        return c.toHexString();
    });
}


// Generated by script. Do NOT modify!
var $0b4842326956570d$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
var $0b4842326956570d$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$0b4842326956570d$export$a90204d1394caf30.primary = $0b4842326956570d$export$a90204d1394caf30[5];
var $0b4842326956570d$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$0b4842326956570d$export$e63a1643b2f79b16.primary = $0b4842326956570d$export$e63a1643b2f79b16[5];
var $0b4842326956570d$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$0b4842326956570d$export$ad766f34ace1cafd.primary = $0b4842326956570d$export$ad766f34ace1cafd[5];
var $0b4842326956570d$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$0b4842326956570d$export$c24201f7fe3571d8.primary = $0b4842326956570d$export$c24201f7fe3571d8[5];
var $0b4842326956570d$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$0b4842326956570d$export$594c5a8758200c32.primary = $0b4842326956570d$export$594c5a8758200c32[5];
var $0b4842326956570d$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$0b4842326956570d$export$221d31baf2636aad.primary = $0b4842326956570d$export$221d31baf2636aad[5];
var $0b4842326956570d$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$0b4842326956570d$export$955a2ebd2fb142ae.primary = $0b4842326956570d$export$955a2ebd2fb142ae[5];
var $0b4842326956570d$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$0b4842326956570d$export$7474046f446842ee.primary = $0b4842326956570d$export$7474046f446842ee[5];
var $0b4842326956570d$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$0b4842326956570d$export$2aa0182783e7e9de.primary = $0b4842326956570d$export$2aa0182783e7e9de[5];
var $0b4842326956570d$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$0b4842326956570d$export$4138d3aeddcbf415.primary = $0b4842326956570d$export$4138d3aeddcbf415[5];
var $0b4842326956570d$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$0b4842326956570d$export$e13cce2a2d16a9d4.primary = $0b4842326956570d$export$e13cce2a2d16a9d4[5];
var $0b4842326956570d$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$0b4842326956570d$export$2a9ca2e383622e18.primary = $0b4842326956570d$export$2a9ca2e383622e18[5];
var $0b4842326956570d$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$0b4842326956570d$export$e4c89085febbc618.primary = $0b4842326956570d$export$e4c89085febbc618[5];
var $0b4842326956570d$export$3e2c219d3ab79d01 = $0b4842326956570d$export$e4c89085febbc618;
var $0b4842326956570d$export$36ad6df0f83f284d = {
    red: $0b4842326956570d$export$a90204d1394caf30,
    volcano: $0b4842326956570d$export$e63a1643b2f79b16,
    orange: $0b4842326956570d$export$ad766f34ace1cafd,
    gold: $0b4842326956570d$export$c24201f7fe3571d8,
    yellow: $0b4842326956570d$export$594c5a8758200c32,
    lime: $0b4842326956570d$export$221d31baf2636aad,
    green: $0b4842326956570d$export$955a2ebd2fb142ae,
    cyan: $0b4842326956570d$export$7474046f446842ee,
    blue: $0b4842326956570d$export$2aa0182783e7e9de,
    geekblue: $0b4842326956570d$export$4138d3aeddcbf415,
    purple: $0b4842326956570d$export$e13cce2a2d16a9d4,
    magenta: $0b4842326956570d$export$2a9ca2e383622e18,
    grey: $0b4842326956570d$export$e4c89085febbc618
};
var $0b4842326956570d$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$0b4842326956570d$export$e984d34fc144caa1.primary = $0b4842326956570d$export$e984d34fc144caa1[5];
var $0b4842326956570d$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$0b4842326956570d$export$360e10f78e17a865.primary = $0b4842326956570d$export$360e10f78e17a865[5];
var $0b4842326956570d$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$0b4842326956570d$export$d5a12c698b31fa45.primary = $0b4842326956570d$export$d5a12c698b31fa45[5];
var $0b4842326956570d$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$0b4842326956570d$export$2330427fb6a6af6f.primary = $0b4842326956570d$export$2330427fb6a6af6f[5];
var $0b4842326956570d$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$0b4842326956570d$export$67d203119f0ecec.primary = $0b4842326956570d$export$67d203119f0ecec[5];
var $0b4842326956570d$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$0b4842326956570d$export$51ed2a10d86576ed.primary = $0b4842326956570d$export$51ed2a10d86576ed[5];
var $0b4842326956570d$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$0b4842326956570d$export$76a3d804058f9b5f.primary = $0b4842326956570d$export$76a3d804058f9b5f[5];
var $0b4842326956570d$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$0b4842326956570d$export$dee6c7c6683c0d88.primary = $0b4842326956570d$export$dee6c7c6683c0d88[5];
var $0b4842326956570d$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$0b4842326956570d$export$10e0fd027e632624.primary = $0b4842326956570d$export$10e0fd027e632624[5];
var $0b4842326956570d$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$0b4842326956570d$export$abdd57ab473bba66.primary = $0b4842326956570d$export$abdd57ab473bba66[5];
var $0b4842326956570d$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$0b4842326956570d$export$7a65e68792738764.primary = $0b4842326956570d$export$7a65e68792738764[5];
var $0b4842326956570d$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$0b4842326956570d$export$d260a9321db4ab86.primary = $0b4842326956570d$export$d260a9321db4ab86[5];
var $0b4842326956570d$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$0b4842326956570d$export$515283ba400ffa6c.primary = $0b4842326956570d$export$515283ba400ffa6c[5];
var $0b4842326956570d$export$24617255e4daf647 = {
    red: $0b4842326956570d$export$e984d34fc144caa1,
    volcano: $0b4842326956570d$export$360e10f78e17a865,
    orange: $0b4842326956570d$export$d5a12c698b31fa45,
    gold: $0b4842326956570d$export$2330427fb6a6af6f,
    yellow: $0b4842326956570d$export$67d203119f0ecec,
    lime: $0b4842326956570d$export$51ed2a10d86576ed,
    green: $0b4842326956570d$export$76a3d804058f9b5f,
    cyan: $0b4842326956570d$export$dee6c7c6683c0d88,
    blue: $0b4842326956570d$export$10e0fd027e632624,
    geekblue: $0b4842326956570d$export$abdd57ab473bba66,
    purple: $0b4842326956570d$export$7a65e68792738764,
    magenta: $0b4842326956570d$export$d260a9321db4ab86,
    grey: $0b4842326956570d$export$515283ba400ffa6c
};




const $b1208bbc03407e2e$export$37e27b43af4d16eb = {
    blue: '#1677FF',
    purple: '#722ED1',
    cyan: '#13C2C2',
    green: '#52C41A',
    magenta: '#EB2F96',
    /**
   * @deprecated Use magenta instead
   */ pink: '#EB2F96',
    red: '#F5222D',
    orange: '#FA8C16',
    yellow: '#FADB14',
    volcano: '#FA541C',
    geekblue: '#2F54EB',
    gold: '#FAAD14',
    lime: '#A0D911'
};
const $b1208bbc03407e2e$var$seedToken = Object.assign(Object.assign({}, $b1208bbc03407e2e$export$37e27b43af4d16eb), {
    // Color
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorLink: '',
    colorTextBase: '',
    colorBgBase: '',
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: 'solid',
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
    motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
    motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
    motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
});
var $b1208bbc03407e2e$export$2e2bcd8739ae039 = $b1208bbc03407e2e$var$seedToken;



function $f9a7789ccb5ebec2$export$2e2bcd8739ae039(seed, { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes }) {
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(errorColors[1]).mix(new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(errorColors[3]), 50).toHexString();
    return Object.assign(Object.assign({}, neutralColors), {
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover: colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)('#000').setA(0.45).toRgbString(),
        colorWhite: '#fff'
    });
}


const $74d509d83ea2ceca$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $74d509d83ea2ceca$export$2e2bcd8739ae039 = $74d509d83ea2ceca$var$genRadius;


function $17649d51225b21b7$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return Object.assign({
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1
    }, (0, $74d509d83ea2ceca$export$2e2bcd8739ae039)(borderRadius));
}


const $7163539f10d66a74$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $7163539f10d66a74$export$2e2bcd8739ae039 = $7163539f10d66a74$var$genControlHeight;


function $239826517175299d$export$56204a27a2958a55(fontSize) {
    return (fontSize + 8) / fontSize;
}
function $239826517175299d$export$2e2bcd8739ae039(base) {
    const fontSizes = Array.from({
        length: 10
    }).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.pow(Math.E, i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $239826517175299d$export$56204a27a2958a55(size)
        }));
}


const $10537aa233bce652$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $239826517175299d$export$2e2bcd8739ae039)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $10537aa233bce652$export$2e2bcd8739ae039 = $10537aa233bce652$var$genFontMapToken;


function $c9ee1fc436061bcb$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}




const $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(baseColor).setA(alpha).toRgbString();
const $4c3fbe9a4ea0d6be$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(baseColor);
    return instance.darken(brightness).toHexString();
};


const $8cc6ca3a04c40fcf$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $8cc6ca3a04c40fcf$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || '#fff';
    const colorTextBase = textBaseColor || '#000';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.88),
        colorTextSecondary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.15),
        colorFillSecondary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.06),
        colorFillTertiary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.02),
        colorBgSolid: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 1),
        colorBgSolidHover: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.75),
        colorBgSolidActive: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.95),
        colorBgLayout: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 4),
        colorBgContainer: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgElevated: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorBgBlur: 'transparent',
        colorBorder: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderSecondary: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 6)
    };
};


function $11cb018871a499d7$export$2e2bcd8739ae039(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, $0b4842326956570d$export$3968a3afc810b5f5).pink = (0, $0b4842326956570d$export$3968a3afc810b5f5).magenta;
    (0, $0b4842326956570d$export$36ad6df0f83f284d).pink = (0, $0b4842326956570d$export$36ad6df0f83f284d).magenta;
    const colorPalettes = Object.keys((0, $b1208bbc03407e2e$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = token[colorKey] === (0, $0b4842326956570d$export$3968a3afc810b5f5)[colorKey] ? (0, $0b4842326956570d$export$36ad6df0f83f284d)[colorKey] : (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(token[colorKey]);
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), (0, $f9a7789ccb5ebec2$export$2e2bcd8739ae039)(token, {
        generateColorPalettes: $8cc6ca3a04c40fcf$export$da275153033f4ec1,
        generateNeutralColorPalettes: $8cc6ca3a04c40fcf$export$3e0cb0c1d9c1b691
    })), (0, $10537aa233bce652$export$2e2bcd8739ae039)(token.fontSize)), (0, $c9ee1fc436061bcb$export$2e2bcd8739ae039)(token)), (0, $7163539f10d66a74$export$2e2bcd8739ae039)(token)), (0, $17649d51225b21b7$export$2e2bcd8739ae039)(token));
}


const $16712192479069fd$var$defaultTheme = (0, $db48c74b3367fd88$export$2e2bcd8739ae039)((0, $11cb018871a499d7$export$2e2bcd8739ae039));
var $16712192479069fd$export$2e2bcd8739ae039 = $16712192479069fd$var$defaultTheme;


var $acw62 = parcelRequire("acw62");


const $d6a0cd0c670c9aed$export$f84bd70098573c5c = {
    token: (0, $b1208bbc03407e2e$export$2e2bcd8739ae039),
    override: {
        override: (0, $b1208bbc03407e2e$export$2e2bcd8739ae039)
    },
    hashed: true
};
const $d6a0cd0c670c9aed$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($d6a0cd0c670c9aed$export$f84bd70098573c5c);




var $acw62 = parcelRequire("acw62");
const $a18b2f6f56546238$export$e4ec87ea71f29b41 = 'ant';
const $a18b2f6f56546238$export$eaca8ee5ed21b4e9 = 'anticon';
const $a18b2f6f56546238$export$fa216ce2679a073b = [
    'outlined',
    'borderless',
    'filled',
    'underlined'
];
const $a18b2f6f56546238$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${$a18b2f6f56546238$export$e4ec87ea71f29b41}-${suffixCls}` : $a18b2f6f56546238$export$e4ec87ea71f29b41;
};
const $a18b2f6f56546238$export$a92f85ab3e9ad68b = /*#__PURE__*/ $acw62.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $a18b2f6f56546238$var$defaultGetPrefixCls,
    iconPrefixCls: $a18b2f6f56546238$export$eaca8ee5ed21b4e9
});
const { Consumer: $a18b2f6f56546238$export$cd5442f2b8da7663 } = $a18b2f6f56546238$export$a92f85ab3e9ad68b;
const $a18b2f6f56546238$var$EMPTY_OBJECT = {};
function $a18b2f6f56546238$export$46f4bd6436a25a31(propName) {
    const context = $acw62.useContext($a18b2f6f56546238$export$a92f85ab3e9ad68b);
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer } = context;
    const propValue = context[propName];
    return Object.assign(Object.assign({
        classNames: $a18b2f6f56546238$var$EMPTY_OBJECT,
        styles: $a18b2f6f56546238$var$EMPTY_OBJECT
    }, propValue), {
        getPrefixCls: getPrefixCls,
        direction: direction,
        getPopupContainer: getPopupContainer
    });
}




function $af1813123da22276$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}




function $865aaac1f59b4d62$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


var $e341688b64d7fba4$var$APPEND_ORDER = 'data-rc-order';
var $e341688b64d7fba4$var$APPEND_PRIORITY = 'data-rc-priority';
var $e341688b64d7fba4$var$MARK_KEY = "rc-util-key";
var $e341688b64d7fba4$var$containerCache = new Map();
function $e341688b64d7fba4$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith('data-') ? mark : "data-".concat(mark);
    return $e341688b64d7fba4$var$MARK_KEY;
}
function $e341688b64d7fba4$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector('head');
    return head || document.body;
}
function $e341688b64d7fba4$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $e341688b64d7fba4$var$findStyles(container) {
    return Array.from(($e341688b64d7fba4$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === 'STYLE';
    });
}
function $e341688b64d7fba4$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $af1813123da22276$export$2e2bcd8739ae039)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $e341688b64d7fba4$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === 'prependQueue';
    var styleNode = document.createElement('style');
    styleNode.setAttribute($e341688b64d7fba4$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($e341688b64d7fba4$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $e341688b64d7fba4$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $e341688b64d7fba4$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($e341688b64d7fba4$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($e341688b64d7fba4$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $e341688b64d7fba4$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $e341688b64d7fba4$var$getContainer(option);
    return (option.styles || $e341688b64d7fba4$var$findStyles(container)).find(function(node) {
        return node.getAttribute($e341688b64d7fba4$var$getMark(option)) === key;
    });
}
function $e341688b64d7fba4$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $e341688b64d7fba4$var$findExistNode(key, option);
    if (existNode) {
        var container = $e341688b64d7fba4$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $e341688b64d7fba4$var$syncRealContainer(container, option) {
    var cachedRealContainer = $e341688b64d7fba4$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $865aaac1f59b4d62$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        var placeholderStyle = $e341688b64d7fba4$export$1ab5838465dbd10a('', option);
        var parentNode = placeholderStyle.parentNode;
        $e341688b64d7fba4$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $e341688b64d7fba4$export$f80df667f2f5a272() {
    $e341688b64d7fba4$var$containerCache.clear();
}
function $e341688b64d7fba4$export$4d99a2890bb989f0(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $e341688b64d7fba4$var$getContainer(originOption);
    var styles = $e341688b64d7fba4$var$findStyles(container);
    var option = (0, $784b8130b41ca462$export$2e2bcd8739ae039)((0, $784b8130b41ca462$export$2e2bcd8739ae039)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $e341688b64d7fba4$var$syncRealContainer(container, option);
    var existNode = $e341688b64d7fba4$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $e341688b64d7fba4$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($e341688b64d7fba4$var$getMark(option), key);
    return newNode;
}



const $e1ca56936d2d2b32$var$dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function $e1ca56936d2d2b32$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    const variables = {};
    const formatColor = (color, updater)=>{
        let clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    const fillColor = (colorVal, type)=>{
        const baseColor = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorVal);
        const colorPalettes = (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(baseColor.toRgbString());
        variables[`${type}-color`] = formatColor(baseColor);
        variables[`${type}-color-disabled`] = colorPalettes[1];
        variables[`${type}-color-hover`] = colorPalettes[4];
        variables[`${type}-color-active`] = colorPalettes[6];
        variables[`${type}-color-outline`] = baseColor.clone().setA(0.2).toRgbString();
        variables[`${type}-color-deprecated-bg`] = colorPalettes[0];
        variables[`${type}-color-deprecated-border`] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, 'primary');
        const primaryColor = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(theme.primaryColor);
        const primaryColors = (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach((color, index)=>{
            variables[`primary-${index + 1}`] = color;
        });
        // Deprecated
        variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, (c)=>c.lighten(35));
        variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, (c)=>c.lighten(20));
        variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, (c)=>c.tint(20));
        variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, (c)=>c.tint(50));
        variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, (c)=>c.setA(c.a * 0.12));
        const primaryActiveColor = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(primaryColors[0]);
        variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, (c)=>c.setA(c.a * 0.3));
        variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, (c)=>c.darken(2));
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, 'success');
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, 'warning');
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, 'error');
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, 'info');
    // Convert to css variables
    const cssList = Object.keys(variables).map((key)=>`--${globalPrefixCls}-${key}: ${variables[key]};`);
    return `
  :root {
    ${cssList.join('\n')}
  }
  `.trim();
}
function $e1ca56936d2d2b32$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    const style = $e1ca56936d2d2b32$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $af1813123da22276$export$2e2bcd8739ae039)()) (0, $e341688b64d7fba4$export$4d99a2890bb989f0)(style, `${$e1ca56936d2d2b32$var$dynamicStyleMark}-dynamic-theme`);
}



var $acw62 = parcelRequire("acw62");
"use client";
const $6ba6819805fb0a44$var$DisabledContext = /*#__PURE__*/ $acw62.createContext(false);
const $6ba6819805fb0a44$export$6adb5f3b918b11bb = ({ children: children, disabled: disabled })=>{
    const originDisabled = $acw62.useContext($6ba6819805fb0a44$var$DisabledContext);
    return /*#__PURE__*/ $acw62.createElement($6ba6819805fb0a44$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $6ba6819805fb0a44$export$2e2bcd8739ae039 = $6ba6819805fb0a44$var$DisabledContext;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
"use client";
const $3e100f55cf8f3689$var$SizeContext = /*#__PURE__*/ $acw62.createContext(undefined);
const $3e100f55cf8f3689$export$dbc92d89fabc8ebe = ({ children: children, size: size })=>{
    const originSize = $acw62.useContext($3e100f55cf8f3689$var$SizeContext);
    return /*#__PURE__*/ $acw62.createElement($3e100f55cf8f3689$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $3e100f55cf8f3689$export$2e2bcd8739ae039 = $3e100f55cf8f3689$var$SizeContext;


function $1e1ca3bea54a77f7$var$useConfig() {
    const componentDisabled = (0, $acw62.useContext)((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const componentSize = (0, $acw62.useContext)((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $1e1ca3bea54a77f7$export$2e2bcd8739ae039 = $1e1ca3bea54a77f7$var$useConfig;





/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $1742d5b465b36ce2$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $07c2c6c8bd840836$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $112972238ba0eede$export$2e2bcd8739ae039)(a) === 'object' && (0, $112972238ba0eede$export$2e2bcd8739ae039)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $1742d5b465b36ce2$export$2e2bcd8739ae039 = $1742d5b465b36ce2$var$isEqual;





var $acw62 = parcelRequire("acw62");
const $52df818a8259ef26$var$fullClone = Object.assign({}, $acw62);
const { useId: $52df818a8259ef26$var$useId } = $52df818a8259ef26$var$fullClone;
const $52df818a8259ef26$var$useEmptyId = ()=>'';
const $52df818a8259ef26$var$useThemeKey = typeof $52df818a8259ef26$var$useId === 'undefined' ? $52df818a8259ef26$var$useEmptyId : $52df818a8259ef26$var$useId;
var $52df818a8259ef26$export$2e2bcd8739ae039 = $52df818a8259ef26$var$useThemeKey;


function $a1000671d52972e2$export$2e2bcd8739ae039(theme, parentTheme, config) {
    var _a, _b;
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('ConfigProvider');
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? Object.assign(Object.assign({}, (0, $d6a0cd0c670c9aed$export$f84bd70098573c5c)), {
        hashed: (_a = parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.hashed) !== null && _a !== void 0 ? _a : (0, $d6a0cd0c670c9aed$export$f84bd70098573c5c).hashed,
        cssVar: parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.cssVar
    }) : parentTheme;
    const themeKey = (0, $52df818a8259ef26$export$2e2bcd8739ae039)();
    return (0, $3f3c7e3b4529c133$export$2e2bcd8739ae039)(()=>{
        var _a, _b;
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = Object.assign({}, parentThemeConfig.components);
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
        const mergedCssVar = ((_a = themeConfig.cssVar) !== null && _a !== void 0 ? _a : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
            prefix: config === null || config === void 0 ? void 0 : config.prefixCls
        }, typeof parentThemeConfig.cssVar === 'object' ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === 'object' ? themeConfig.cssVar : {}), {
            key: typeof themeConfig.cssVar === 'object' && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
        });
        // Base token
        return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
            token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
            components: mergedComponents,
            cssVar: mergedCssVar
        });
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $1742d5b465b36ce2$export$2e2bcd8739ae039)(prevTheme, nextTheme, true);
        }));
}



var $acw62 = parcelRequire("acw62");
function $73215532ec02117d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $73215532ec02117d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $73215532ec02117d$export$2e2bcd8739ae039(o);
}



function $b10a08d57fa86b34$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $73215532ec02117d$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $73215532ec02117d$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $9972477a6d893f47$export$2e2bcd8739ae039(t) {
    var i = (0, $b10a08d57fa86b34$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $73215532ec02117d$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $bed6054f049803b5$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $9972477a6d893f47$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



function $c7c2970d910dc882$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c7c2970d910dc882$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c7c2970d910dc882$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $bed6054f049803b5$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c7c2970d910dc882$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $cea23bd0f43e189c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $9aaf516864ec4439$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $226f0bde7c63890e$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $c860fe1eba731b97$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $226f0bde7c63890e$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $226f0bde7c63890e$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $ab5982f86a8e340c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $626d5c7e7cf8637d$export$2e2bcd8739ae039(r, e) {
    return (0, $cea23bd0f43e189c$export$2e2bcd8739ae039)(r) || (0, $9aaf516864ec4439$export$2e2bcd8739ae039)(r, e) || (0, $c860fe1eba731b97$export$2e2bcd8739ae039)(r, e) || (0, $ab5982f86a8e340c$export$2e2bcd8739ae039)();
}



var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $cdb3b0cecbf9f6a9$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $cdb3b0cecbf9f6a9$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $73215532ec02117d$export$2e2bcd8739ae039)(node) === 'object' && $cdb3b0cecbf9f6a9$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($cdb3b0cecbf9f6a9$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $cdb3b0cecbf9f6a9$export$2e2bcd8739ae039(node) {
    var domNode = $cdb3b0cecbf9f6a9$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))), node);
    }
    return null;
}




var $acw62 = parcelRequire("acw62");
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));



var $acw62 = parcelRequire("acw62");
function $1017ab7836992dda$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $acw62.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


var $c0a7f4ede2f66c40$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $73215532ec02117d$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $c0a7f4ede2f66c40$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $c0a7f4ede2f66c40$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $c0a7f4ede2f66c40$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $1017ab7836992dda$export$2e2bcd8739ae039)(function() {
        return $c0a7f4ede2f66c40$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $c0a7f4ede2f66c40$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($c0a7f4ede2f66c40$var$isReactElement(nodeOrComponent) && nodeOrComponent.props.propertyIsEnumerable('ref')) return true;
    var type = (0, $3251146683c5d714$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    return true;
};
function $c0a7f4ede2f66c40$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(node) && !(0, $3251146683c5d714$exports.isFragment)(node);
}
var $c0a7f4ede2f66c40$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $c0a7f4ede2f66c40$var$isReactElement(node) && $c0a7f4ede2f66c40$export$c1cec34af06bcf7(node);
};
var $c0a7f4ede2f66c40$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $c0a7f4ede2f66c40$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};



var $acw62 = parcelRequire("acw62");
function $805fe8b031c54d31$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $87c86a08040b5a0f$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $805fe8b031c54d31$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $acw62 = parcelRequire("acw62");
var $947ae6057ca8be84$var$_excluded = [
    "children"
];
var $947ae6057ca8be84$export$841858b892ce1f4c = /*#__PURE__*/ $acw62.createContext({});
function $947ae6057ca8be84$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $87c86a08040b5a0f$export$2e2bcd8739ae039)(_ref, $947ae6057ca8be84$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement($947ae6057ca8be84$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}


function $6936235e53f7192d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $d275428d1fbb363c$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $9972477a6d893f47$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $d275428d1fbb363c$export$2e2bcd8739ae039(e, r, t) {
    return r && $d275428d1fbb363c$var$_defineProperties(e.prototype, r), t && $d275428d1fbb363c$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $6990b757d27199de$export$2e2bcd8739ae039(t, e) {
    return $6990b757d27199de$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $6990b757d27199de$export$2e2bcd8739ae039(t, e);
}


function $76ef65aa015cc984$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $6990b757d27199de$export$2e2bcd8739ae039)(t, e);
}


function $199b21f91a6fd7fd$export$2e2bcd8739ae039(t) {
    return $199b21f91a6fd7fd$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $199b21f91a6fd7fd$export$2e2bcd8739ae039(t);
}


function $673b61f0c3f69ffa$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($673b61f0c3f69ffa$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $792eef7d3827ddfd$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $3bf37925727f0601$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $73215532ec02117d$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $792eef7d3827ddfd$export$2e2bcd8739ae039)(t);
}


function $a6f27c25a8818c77$export$2e2bcd8739ae039(t) {
    var r = (0, $673b61f0c3f69ffa$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $199b21f91a6fd7fd$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $199b21f91a6fd7fd$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $3bf37925727f0601$export$2e2bcd8739ae039)(this, e);
    };
}



var $acw62 = parcelRequire("acw62");
var $d2704f0e3b0242af$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $76ef65aa015cc984$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $a6f27c25a8818c77$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $6936235e53f7192d$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $d275428d1fbb363c$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);
var $d2704f0e3b0242af$export$2e2bcd8739ae039 = $d2704f0e3b0242af$var$DomWrapper;






var $acw62 = parcelRequire("acw62");
function $0e65e2a7ebd6441c$export$2e2bcd8739ae039(callback) {
    var fnRef = $acw62.useRef();
    fnRef.current = callback;
    var memoFn = $acw62.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}





var $acw62 = parcelRequire("acw62");
function $f08e6ef39163b112$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $ea4c158c17ec5a71$var$useInternalLayoutEffect = (0, $f08e6ef39163b112$export$2e2bcd8739ae039)() ? $acw62.useLayoutEffect : $acw62.useEffect;
var $ea4c158c17ec5a71$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $acw62.useRef(true);
    $ea4c158c17ec5a71$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $ea4c158c17ec5a71$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $ea4c158c17ec5a71$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $ea4c158c17ec5a71$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $ea4c158c17ec5a71$export$2e2bcd8739ae039 = $ea4c158c17ec5a71$var$useLayoutEffect;




var $acw62 = parcelRequire("acw62");
function $0512eda23710375d$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $acw62.useRef(false);
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $acw62.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $2ca98c4b3d83cef9$var$hasValue(value) {
    return value !== undefined;
}
function $2ca98c4b3d83cef9$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $0512eda23710375d$export$2e2bcd8739ae039)(function() {
        if ($2ca98c4b3d83cef9$var$hasValue(value)) return value;
        else if ($2ca98c4b3d83cef9$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $0e65e2a7ebd6441c$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $0512eda23710375d$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $ea4c158c17ec5a71$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $ea4c158c17ec5a71$export$9283e56bae2f7b0f)(function() {
        if (!$2ca98c4b3d83cef9$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $0e65e2a7ebd6441c$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



function $ab5914878fc7ed2f$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}





function $92b7eedae3a8e3f5$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $226f0bde7c63890e$export$2e2bcd8739ae039)(r);
}


function $d239beab8822c4c9$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $e80f50f62913c4e5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $7293646674524164$export$2e2bcd8739ae039(r) {
    return (0, $92b7eedae3a8e3f5$export$2e2bcd8739ae039)(r) || (0, $d239beab8822c4c9$export$2e2bcd8739ae039)(r) || (0, $c860fe1eba731b97$export$2e2bcd8739ae039)(r) || (0, $e80f50f62913c4e5$export$2e2bcd8739ae039)();
}






function $264e98c288b8ccb6$export$2e2bcd8739ae039(r) {
    return (0, $cea23bd0f43e189c$export$2e2bcd8739ae039)(r) || (0, $d239beab8822c4c9$export$2e2bcd8739ae039)(r) || (0, $c860fe1eba731b97$export$2e2bcd8739ae039)(r) || (0, $ab5982f86a8e340c$export$2e2bcd8739ae039)();
}



function $d084419975605a27$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $264e98c288b8ccb6$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $7293646674524164$export$2e2bcd8739ae039)(entity);
    else clone = (0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $d084419975605a27$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $d084419975605a27$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $ab5914878fc7ed2f$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $d084419975605a27$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $d084419975605a27$var$isObject(obj) {
    return (0, $73215532ec02117d$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $d084419975605a27$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $d084419975605a27$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $d084419975605a27$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $d084419975605a27$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $ab5914878fc7ed2f$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $d084419975605a27$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $ab5914878fc7ed2f$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $d084419975605a27$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $73215532ec02117d$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $d084419975605a27$export$2e2bcd8739ae039(clone, path, $d084419975605a27$var$createEmpty(value));
                    $d084419975605a27$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $7293646674524164$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $d084419975605a27$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}


/* eslint-disable no-console */ var $ddea425757fc0ebc$var$warned = {};
var $ddea425757fc0ebc$var$preWarningFns = [];
var $ddea425757fc0ebc$export$61616f168f0e5a05 = function preMessage(fn) {
    $ddea425757fc0ebc$var$preWarningFns.push(fn);
};
function $ddea425757fc0ebc$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $ddea425757fc0ebc$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $ddea425757fc0ebc$export$60eef1277fe463e4() {
    $ddea425757fc0ebc$var$warned = {};
}
function $ddea425757fc0ebc$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$ddea425757fc0ebc$var$warned[message]) {
        method(false, message);
        $ddea425757fc0ebc$var$warned[message] = true;
    }
}
function $ddea425757fc0ebc$export$82934adf09101657(valid, message) {
    $ddea425757fc0ebc$export$848feb93d8f32b9b($ddea425757fc0ebc$export$491112666e282270, valid, message);
}
function $ddea425757fc0ebc$export$89ff31684837bbbf(valid, message) {
    $ddea425757fc0ebc$export$848feb93d8f32b9b($ddea425757fc0ebc$export$a92e4c44d367d0af, valid, message);
}
$ddea425757fc0ebc$export$82934adf09101657.preMessage = $ddea425757fc0ebc$export$61616f168f0e5a05;
$ddea425757fc0ebc$export$82934adf09101657.resetWarned = $ddea425757fc0ebc$export$60eef1277fe463e4;
$ddea425757fc0ebc$export$82934adf09101657.noteOnce = $ddea425757fc0ebc$export$89ff31684837bbbf;
var $ddea425757fc0ebc$export$2e2bcd8739ae039 = $ddea425757fc0ebc$export$82934adf09101657;







var $acw62 = parcelRequire("acw62");

function $e1c10c1c389ca7ec$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $acw62.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $acw62.useRef(defaultValue);
    var getValue = (0, $0e65e2a7ebd6441c$export$2e2bcd8739ae039)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $0e65e2a7ebd6441c$export$2e2bcd8739ae039)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}



var $acw62 = parcelRequire("acw62");
var $c4993e8779cac80a$export$de71442bbf2143da = 'none';
var $c4993e8779cac80a$export$4fc3521687bcacd2 = 'appear';
var $c4993e8779cac80a$export$5d6af549241fe2e8 = 'enter';
var $c4993e8779cac80a$export$59b1c493d29f68e4 = 'leave';
var $c4993e8779cac80a$export$40b34dd77d5522bf = 'none';
var $c4993e8779cac80a$export$1b792916a5fac4fc = 'prepare';
var $c4993e8779cac80a$export$9563153dd25a3ce8 = 'start';
var $c4993e8779cac80a$export$e205886172277ec6 = 'active';
var $c4993e8779cac80a$export$3a846c3d2fac10b8 = 'end';
var $c4993e8779cac80a$export$98351fa4e6b4f204 = 'prepared';



var $acw62 = parcelRequire("acw62");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $1288da83b27c71ce$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $1288da83b27c71ce$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $1288da83b27c71ce$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $1288da83b27c71ce$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $1288da83b27c71ce$var$vendorPrefixes = $1288da83b27c71ce$export$6e8b350b1a8958a0((0, $f08e6ef39163b112$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
var $1288da83b27c71ce$var$style = {};
if ((0, $f08e6ef39163b112$export$2e2bcd8739ae039)()) {
    var $1288da83b27c71ce$var$_document$createEleme = document.createElement('div');
    $1288da83b27c71ce$var$style = $1288da83b27c71ce$var$_document$createEleme.style;
}
var $1288da83b27c71ce$var$prefixedEventNames = {};
function $1288da83b27c71ce$export$a032e4f39350c1d8(eventName) {
    if ($1288da83b27c71ce$var$prefixedEventNames[eventName]) return $1288da83b27c71ce$var$prefixedEventNames[eventName];
    var prefixMap = $1288da83b27c71ce$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $1288da83b27c71ce$var$style) {
                $1288da83b27c71ce$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $1288da83b27c71ce$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $1288da83b27c71ce$var$internalAnimationEndName = $1288da83b27c71ce$export$a032e4f39350c1d8('animationend');
var $1288da83b27c71ce$var$internalTransitionEndName = $1288da83b27c71ce$export$a032e4f39350c1d8('transitionend');
var $1288da83b27c71ce$export$d28133ed3ad06c8b = !!($1288da83b27c71ce$var$internalAnimationEndName && $1288da83b27c71ce$var$internalTransitionEndName);
var $1288da83b27c71ce$export$760cc9769c51b738 = $1288da83b27c71ce$var$internalAnimationEndName || 'animationend';
var $1288da83b27c71ce$export$44baea64b8602e3c = $1288da83b27c71ce$var$internalTransitionEndName || 'transitionend';
function $1288da83b27c71ce$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $73215532ec02117d$export$2e2bcd8739ae039)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $9773d0c8c4650868$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $acw62.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $1288da83b27c71ce$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $1288da83b27c71ce$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $1288da83b27c71ce$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $1288da83b27c71ce$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $acw62.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $acw62 = parcelRequire("acw62");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $eb33797b182c7516$var$useIsomorphicLayoutEffect = (0, $f08e6ef39163b112$export$2e2bcd8739ae039)() ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $eb33797b182c7516$export$2e2bcd8739ae039 = $eb33797b182c7516$var$useIsomorphicLayoutEffect;





var $acw62 = parcelRequire("acw62");


var $362dc0cea72d6ac4$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $362dc0cea72d6ac4$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $362dc0cea72d6ac4$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $362dc0cea72d6ac4$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $362dc0cea72d6ac4$var$rafUUID = 0;
var $362dc0cea72d6ac4$var$rafIds = new Map();
function $362dc0cea72d6ac4$var$cleanup(id) {
    $362dc0cea72d6ac4$var$rafIds.delete(id);
}
var $362dc0cea72d6ac4$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $362dc0cea72d6ac4$var$rafUUID += 1;
    var id = $362dc0cea72d6ac4$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $362dc0cea72d6ac4$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $362dc0cea72d6ac4$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $362dc0cea72d6ac4$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$362dc0cea72d6ac4$var$wrapperRaf.cancel = function(id) {
    var realId = $362dc0cea72d6ac4$var$rafIds.get(id);
    $362dc0cea72d6ac4$var$cleanup(id);
    return $362dc0cea72d6ac4$var$caf(realId);
};
var $362dc0cea72d6ac4$export$2e2bcd8739ae039 = $362dc0cea72d6ac4$var$wrapperRaf;



var $acw62 = parcelRequire("acw62");
var $81ce5f7c1b57f3e5$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $acw62.useRef(null);
    function cancelNextFrame() {
        (0, $362dc0cea72d6ac4$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $362dc0cea72d6ac4$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $f22d652148ee6225$var$FULL_STEP_QUEUE = [
    (0, $c4993e8779cac80a$export$1b792916a5fac4fc),
    (0, $c4993e8779cac80a$export$9563153dd25a3ce8),
    (0, $c4993e8779cac80a$export$e205886172277ec6),
    (0, $c4993e8779cac80a$export$3a846c3d2fac10b8)
];
var $f22d652148ee6225$var$SIMPLE_STEP_QUEUE = [
    (0, $c4993e8779cac80a$export$1b792916a5fac4fc),
    (0, $c4993e8779cac80a$export$98351fa4e6b4f204)
];
var $f22d652148ee6225$export$c2029bf6cfdbc28a = false;
var $f22d652148ee6225$export$dbee1e282e8c4830 = true;
function $f22d652148ee6225$export$39e04e72f972b885(step) {
    return step === (0, $c4993e8779cac80a$export$e205886172277ec6) || step === (0, $c4993e8779cac80a$export$3a846c3d2fac10b8);
}
var $f22d652148ee6225$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $0512eda23710375d$export$2e2bcd8739ae039)((0, $c4993e8779cac80a$export$40b34dd77d5522bf)), _useState2 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $81ce5f7c1b57f3e5$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $c4993e8779cac80a$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $f22d652148ee6225$var$SIMPLE_STEP_QUEUE : $f22d652148ee6225$var$FULL_STEP_QUEUE;
    (0, $eb33797b182c7516$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $c4993e8779cac80a$export$40b34dd77d5522bf) && step !== (0, $c4993e8779cac80a$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $f22d652148ee6225$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $366ddb910518c677$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $0512eda23710375d$export$2e2bcd8739ae039)(), _useState2 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $e1c10c1c389ca7ec$export$2e2bcd8739ae039)((0, $c4993e8779cac80a$export$de71442bbf2143da)), _useSyncState2 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $0512eda23710375d$export$2e2bcd8739ae039)(null), _useState4 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $acw62.useRef)(false);
    var deadlineRef = (0, $acw62.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $acw62.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $c4993e8779cac80a$export$de71442bbf2143da));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $0e65e2a7ebd6441c$export$2e2bcd8739ae039)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $c4993e8779cac80a$export$de71442bbf2143da)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $c4993e8779cac80a$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $c4993e8779cac80a$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $c4993e8779cac80a$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $9773d0c8c4650868$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $c4993e8779cac80a$export$4fc3521687bcacd2:
                return (0, $bed6054f049803b5$export$2e2bcd8739ae039)((0, $bed6054f049803b5$export$2e2bcd8739ae039)((0, $bed6054f049803b5$export$2e2bcd8739ae039)({}, (0, $c4993e8779cac80a$export$1b792916a5fac4fc), onAppearPrepare), (0, $c4993e8779cac80a$export$9563153dd25a3ce8), onAppearStart), (0, $c4993e8779cac80a$export$e205886172277ec6), onAppearActive);
            case 0, $c4993e8779cac80a$export$5d6af549241fe2e8:
                return (0, $bed6054f049803b5$export$2e2bcd8739ae039)((0, $bed6054f049803b5$export$2e2bcd8739ae039)((0, $bed6054f049803b5$export$2e2bcd8739ae039)({}, (0, $c4993e8779cac80a$export$1b792916a5fac4fc), onEnterPrepare), (0, $c4993e8779cac80a$export$9563153dd25a3ce8), onEnterStart), (0, $c4993e8779cac80a$export$e205886172277ec6), onEnterActive);
            case 0, $c4993e8779cac80a$export$59b1c493d29f68e4:
                return (0, $bed6054f049803b5$export$2e2bcd8739ae039)((0, $bed6054f049803b5$export$2e2bcd8739ae039)((0, $bed6054f049803b5$export$2e2bcd8739ae039)({}, (0, $c4993e8779cac80a$export$1b792916a5fac4fc), onLeavePrepare), (0, $c4993e8779cac80a$export$9563153dd25a3ce8), onLeaveStart), (0, $c4993e8779cac80a$export$e205886172277ec6), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $acw62.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $f22d652148ee6225$export$2e2bcd8739ae039)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $c4993e8779cac80a$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $c4993e8779cac80a$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $f22d652148ee6225$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $c4993e8779cac80a$export$e205886172277ec6) && currentStatus !== (0, $c4993e8779cac80a$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $c4993e8779cac80a$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $f22d652148ee6225$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $f22d652148ee6225$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    var visibleRef = (0, $acw62.useRef)(null);
    // Update with new status
    (0, $eb33797b182c7516$export$2e2bcd8739ae039)(function() {
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $c4993e8779cac80a$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $c4993e8779cac80a$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $c4993e8779cac80a$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $c4993e8779cac80a$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $c4993e8779cac80a$export$de71442bbf2143da));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $acw62.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $c4993e8779cac80a$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $c4993e8779cac80a$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $c4993e8779cac80a$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $c4993e8779cac80a$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $acw62.useRef(false);
    (0, $acw62.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $c4993e8779cac80a$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $c4993e8779cac80a$export$1b792916a5fac4fc] && step === (0, $c4993e8779cac80a$export$9563153dd25a3ce8)) mergedStyle = (0, $c7c2970d910dc882$export$2e2bcd8739ae039)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $2c96736cf19c2171$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $73215532ec02117d$export$2e2bcd8739ae039)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $acw62.useContext((0, $947ae6057ca8be84$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $acw62.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $acw62.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $cdb3b0cecbf9f6a9$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $366ddb910518c677$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $626d5c7e7cf8637d$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $acw62.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $acw62.useCallback(function(node) {
            nodeRef.current = node;
            (0, $c0a7f4ede2f66c40$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $c4993e8779cac80a$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $c4993e8779cac80a$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
            else if ((0, $f22d652148ee6225$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $c4993e8779cac80a$export$9563153dd25a3ce8)) statusSuffix = 'start';
            var motionCls = (0, $1288da83b27c71ce$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $1288da83b27c71ce$export$27c72201b1d09951)(motionName, status), (0, $bed6054f049803b5$export$2e2bcd8739ae039)((0, $bed6054f049803b5$export$2e2bcd8739ae039)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $acw62.isValidElement(motionChildren) && (0, $c0a7f4ede2f66c40$export$c1cec34af06bcf7)(motionChildren)) {
            var originNodeRef = (0, $c0a7f4ede2f66c40$export$7465e5c0bf44f19a)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $acw62.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $acw62.createElement((0, $d2704f0e3b0242af$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $2c96736cf19c2171$export$2e2bcd8739ae039 = $2c96736cf19c2171$export$e265d52a86a9f199((0, $1288da83b27c71ce$export$d28133ed3ad06c8b));


function $3d6f95d168a772f1$export$2e2bcd8739ae039() {
    return $3d6f95d168a772f1$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3d6f95d168a772f1$export$2e2bcd8739ae039.apply(null, arguments);
}











var $acw62 = parcelRequire("acw62");



var $187dad3ff165e975$export$3904baa009bc026e = 'add';
var $187dad3ff165e975$export$851162f0adad2cbc = 'keep';
var $187dad3ff165e975$export$c8b3fb08b68cfc85 = 'remove';
var $187dad3ff165e975$export$2ac1bd1808d2e43a = 'removed';
function $187dad3ff165e975$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $73215532ec02117d$export$2e2bcd8739ae039)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $187dad3ff165e975$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($187dad3ff165e975$export$c47fd798e598c85c);
}
function $187dad3ff165e975$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $187dad3ff165e975$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $187dad3ff165e975$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $187dad3ff165e975$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $187dad3ff165e975$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $187dad3ff165e975$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $187dad3ff165e975$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $187dad3ff165e975$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $187dad3ff165e975$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $f36605d1ab9f0a14$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $f36605d1ab9f0a14$var$_excluded2 = [
    "status"
];
var $f36605d1ab9f0a14$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $f36605d1ab9f0a14$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $2c96736cf19c2171$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $76ef65aa015cc984$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $a6f27c25a8818c77$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $6936235e53f7192d$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $bed6054f049803b5$export$2e2bcd8739ae039)((0, $792eef7d3827ddfd$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $bed6054f049803b5$export$2e2bcd8739ae039)((0, $792eef7d3827ddfd$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, entity), {}, {
                            status: (0, $187dad3ff165e975$export$2ac1bd1808d2e43a)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $187dad3ff165e975$export$2ac1bd1808d2e43a);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $d275428d1fbb363c$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $87c86a08040b5a0f$export$2e2bcd8739ae039)(_this$props, $f36605d1ab9f0a14$var$_excluded);
                    var Component = component || $acw62.Fragment;
                    var motionProps = {};
                    $f36605d1ab9f0a14$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $acw62.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $87c86a08040b5a0f$export$2e2bcd8739ae039)(_ref2, $f36605d1ab9f0a14$var$_excluded2);
                        var visible = status === (0, $187dad3ff165e975$export$3904baa009bc026e) || status === (0, $187dad3ff165e975$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $acw62.createElement(CSSMotion, (0, $3d6f95d168a772f1$export$2e2bcd8739ae039)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $c7c2970d910dc882$export$2e2bcd8739ae039)((0, $c7c2970d910dc882$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $187dad3ff165e975$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $187dad3ff165e975$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $187dad3ff165e975$export$2ac1bd1808d2e43a) && entity.status === (0, $187dad3ff165e975$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($acw62.Component);
    (0, $bed6054f049803b5$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $f36605d1ab9f0a14$export$2e2bcd8739ae039 = $f36605d1ab9f0a14$export$fcfc62c1d33d5e2e((0, $1288da83b27c71ce$export$d28133ed3ad06c8b));



var $d222a6d97472f88c$export$2e2bcd8739ae039 = (0, $2c96736cf19c2171$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $aadef4b21b7a3672$export$2e2bcd8739ae039 = '5.26.7';


"use client";
var $d8781535a68aa2aa$export$2e2bcd8739ae039 = (0, $aadef4b21b7a3672$export$2e2bcd8739ae039);







function $49cdc08d8072d4ba$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $49cdc08d8072d4ba$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($49cdc08d8072d4ba$var$isStableColor(r) && $49cdc08d8072d4ba$var$isStableColor(g) && $49cdc08d8072d4ba$var$isStableColor(b)) return new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $49cdc08d8072d4ba$export$2e2bcd8739ae039 = $49cdc08d8072d4ba$var$getAlphaColor;


var $e6266db79468900d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $e6266db79468900d$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override } = derivativeToken, restToken = $e6266db79468900d$var$__rest(derivativeToken, [
        "override"
    ]);
    const overrideTokens = Object.assign({}, override);
    Object.keys((0, $b1208bbc03407e2e$export$2e2bcd8739ae039)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = '0s';
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: 'none',
        linkHoverDecoration: 'none',
        linkFocusDecoration: 'none',
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: '2px 2px 5px rgba(0, 0, 0, 0.05)',
        boxShadowCard: `
      0 1px 2px -2px ${new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.16)').toRgbString()},
      0 3px 6px 0 ${new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.12)').toRgbString()},
      0 5px 12px 4px ${new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)('rgba(0, 0, 0, 0.09)').toRgbString()}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTabsOverflowLeft: 'inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowRight: 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowTop: 'inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowBottom: 'inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)'
    }), overrideTokens);
    return aliasToken;
}


var $d014fefdb4420ef5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $d014fefdb4420ef5$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const $d014fefdb4420ef5$export$738b109e247a462c = {
    size: true,
    sizeSM: true,
    sizeLG: true,
    sizeMD: true,
    sizeXS: true,
    sizeXXS: true,
    sizeMS: true,
    sizeXL: true,
    sizeXXL: true,
    sizeUnit: true,
    sizeStep: true,
    motionBase: true,
    motionUnit: true
};
const $d014fefdb4420ef5$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
const $d014fefdb4420ef5$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override } = overrideToken, components = $d014fefdb4420ef5$var$__rest(overrideToken, [
        "override"
    ]);
    // Merge with override
    let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
        override: override
    });
    // Format if needed
    mergedDerivativeToken = (0, $e6266db79468900d$export$2e2bcd8739ae039)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach(([key, value])=>{
        const { theme: componentTheme } = value, componentTokens = $d014fefdb4420ef5$var$__rest(value, [
            "theme"
        ]);
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $d014fefdb4420ef5$export$18602cb46ae80b62(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $d014fefdb4420ef5$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: cssVar } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $d6a0cd0c670c9aed$export$69b0ebb9efcddb30));
    const salt = `${(0, $d8781535a68aa2aa$export$2e2bcd8739ae039)}-${hashed || ''}`;
    const mergedTheme = theme || (0, $16712192479069fd$export$2e2bcd8739ae039);
    const [token, hashId, realToken] = (0, $fb047830d7776fb2$export$2e2bcd8739ae039)(mergedTheme, [
        (0, $b1208bbc03407e2e$export$2e2bcd8739ae039),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $d014fefdb4420ef5$export$18602cb46ae80b62,
        formatToken: // formatToken will not be consumed after 1.15.0 with getComputedToken.
        // But token will break if @ant-design/cssinjs is under 1.15.0 without it
        $e6266db79468900d$export$2e2bcd8739ae039,
        cssVar: cssVar && {
            prefix: cssVar.prefix,
            key: cssVar.key,
            unitless: $d014fefdb4420ef5$export$c6b9faa6b723d31a,
            ignore: $d014fefdb4420ef5$export$738b109e247a462c,
            preserve: $d014fefdb4420ef5$var$preserve
        }
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : '',
        token,
        cssVar
    ];
}


"use client";
const $57278e23ed3ca8fa$var$MotionCacheContext = /*#__PURE__*/ $acw62.createContext(true);
function $57278e23ed3ca8fa$export$2e2bcd8739ae039(props) {
    const parentMotion = $acw62.useContext($57278e23ed3ca8fa$var$MotionCacheContext);
    const { children: children } = props;
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $acw62.useRef(false);
    needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $acw62.createElement($57278e23ed3ca8fa$var$MotionCacheContext.Provider, {
        value: motion
    }, /*#__PURE__*/ $acw62.createElement((0, $947ae6057ca8be84$export$2e2bcd8739ae039), {
        motion: motion
    }, children));
    return children;
}



var $acw62 = parcelRequire("acw62");

"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $a098b6503d6d9fdd$var$PropWarning = /*#__PURE__*/ $acw62.memo(({ dropdownMatchSelectWidth: dropdownMatchSelectWidth })=>{
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('ConfigProvider');
    warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
    return null;
});
var $a098b6503d6d9fdd$export$2e2bcd8739ae039 = ()=>null;





"use client";
const $4733a3b3eb18f80d$export$b2b65df0d0824629 = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
};
const $4733a3b3eb18f80d$export$23997c3e44cc1c59 = (token, needInheritFontFamily = false)=>({
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: 'none',
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
    });
const $4733a3b3eb18f80d$export$171ccda7bc085e59 = ()=>({
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '> *': {
            lineHeight: 1
        },
        svg: {
            display: 'inline-block'
        }
    });
const $4733a3b3eb18f80d$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        '&::before': {
            display: 'table',
            content: '""'
        },
        '&::after': {
            // https://github.com/ant-design/ant-design/issues/21864
            display: 'table',
            clear: 'both',
            content: '""'
        }
    });
const $4733a3b3eb18f80d$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: 'transparent',
            // remove the gray background on active links in IE 10.
            outline: 'none',
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            '-webkit-text-decoration-skip': 'objects',
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            '&:hover': {
                color: token.colorLinkHover
            },
            '&:active': {
                color: token.colorLinkActive
            },
            '&:active, &:hover': {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            '&:focus': {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            '&[disabled]': {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    });
const $4733a3b3eb18f80d$export$689382c111559cd9 = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: 'border-box',
        '&::before, &::after': {
            boxSizing: 'border-box'
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: Object.assign(Object.assign(Object.assign({}, resetFontStyle), resetStyle), {
            [prefixSelector]: resetStyle
        })
    };
};
const $4733a3b3eb18f80d$export$6539948f0a737e39 = (token, offset)=>({
        outline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset !== null && offset !== void 0 ? offset : 1,
        transition: 'outline-offset 0s, outline 0s'
    });
const $4733a3b3eb18f80d$export$a44db842bcb28231 = (token, offset)=>({
        '&:focus-visible': Object.assign({}, $4733a3b3eb18f80d$export$6539948f0a737e39(token, offset))
    });
const $4733a3b3eb18f80d$export$f1a0b31dfb234e7e = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, $4733a3b3eb18f80d$export$171ccda7bc085e59()), {
            [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                display: 'block'
            }
        })
    });
const $4733a3b3eb18f80d$export$9a16e7694a707ab4 = (token)=>Object.assign(Object.assign({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: 'none',
        userSelect: 'none'
    }, $4733a3b3eb18f80d$export$a44db842bcb28231(token)), {
        '&:focus, &:hover': {
            color: token.colorLinkHover
        },
        '&:active': {
            color: token.colorLinkActive
        }
    });



const $af55bb63f7325a53$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    // Generate style for icons
    return (0, $7927865cee518bb3$export$2e2bcd8739ae039)({
        theme: theme,
        token: token,
        hashId: '',
        path: [
            'ant-design-icons',
            iconPrefixCls
        ],
        nonce: ()=>csp === null || csp === void 0 ? void 0 : csp.nonce,
        layer: {
            name: 'antd'
        }
    }, ()=>[
            (0, $4733a3b3eb18f80d$export$f1a0b31dfb234e7e)(iconPrefixCls)
        ]);
};
var $af55bb63f7325a53$export$2e2bcd8739ae039 = $af55bb63f7325a53$var$useResetIconStyle;


"use client";
var $7ed5e10e08c170f8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $7ed5e10e08c170f8$var$existThemeConfig = false;
const $7ed5e10e08c170f8$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
const $7ed5e10e08c170f8$export$e7f14a745e5c386a = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale'
];
// These props is used by `useContext` directly in sub component
const $7ed5e10e08c170f8$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'input',
    'pagination',
    'form',
    'select',
    'button'
];
let $7ed5e10e08c170f8$var$globalPrefixCls;
let $7ed5e10e08c170f8$var$globalIconPrefixCls;
let $7ed5e10e08c170f8$var$globalTheme;
let $7ed5e10e08c170f8$var$globalHolderRender;
function $7ed5e10e08c170f8$var$getGlobalPrefixCls() {
    return $7ed5e10e08c170f8$var$globalPrefixCls || (0, $a18b2f6f56546238$export$e4ec87ea71f29b41);
}
function $7ed5e10e08c170f8$var$getGlobalIconPrefixCls() {
    return $7ed5e10e08c170f8$var$globalIconPrefixCls || (0, $a18b2f6f56546238$export$eaca8ee5ed21b4e9);
}
function $7ed5e10e08c170f8$var$isLegacyTheme(theme) {
    return Object.keys(theme).some((key)=>key.endsWith('Color'));
}
const $7ed5e10e08c170f8$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $7ed5e10e08c170f8$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $7ed5e10e08c170f8$var$globalIconPrefixCls = iconPrefixCls;
    if ('holderRender' in props) $7ed5e10e08c170f8$var$globalHolderRender = holderRender;
    if (theme) {
        if ($7ed5e10e08c170f8$var$isLegacyTheme(theme)) (0, $e1ca56936d2d2b32$export$f9c59eed5de5ff80)($7ed5e10e08c170f8$var$getGlobalPrefixCls(), theme);
        else $7ed5e10e08c170f8$var$globalTheme = theme;
    }
};
const $7ed5e10e08c170f8$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$7ed5e10e08c170f8$var$getGlobalPrefixCls()}-${suffixCls}` : $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $7ed5e10e08c170f8$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($7ed5e10e08c170f8$var$globalPrefixCls) return $7ed5e10e08c170f8$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$7ed5e10e08c170f8$var$globalTheme,
        holderRender: $7ed5e10e08c170f8$var$globalHolderRender
    });
const $7ed5e10e08c170f8$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, anchor: anchor, form: form, locale: locale, componentSize: componentSize, direction: direction, space: space, splitter: splitter, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, menu: menu, pagination: pagination, input: input, textArea: textArea, empty: empty, badge: badge, radio: radio, rate: rate, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, tooltip: tooltip, popover: popover, popconfirm: popconfirm, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect } = props;
    // =================================== Context ===================================
    const getPrefixCls = $acw62.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $a18b2f6f56546238$export$eaca8ee5ed21b4e9);
    const csp = customCsp || parentContext.csp;
    (0, $af55bb63f7325a53$export$2e2bcd8739ae039)(iconPrefixCls, csp);
    const mergedTheme = (0, $a1000671d52972e2$export$2e2bcd8739ae039)(theme, parentContext.theme, {
        prefixCls: getPrefixCls('')
    });
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        anchor: anchor,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        splitter: splitter,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        textArea: textArea,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        tooltip: tooltip,
        popover: popover,
        popconfirm: popconfirm,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect
    };
    const config = Object.assign({}, parentContext);
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $7ed5e10e08c170f8$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== 'undefined') // merge deprecated api
    config.button = Object.assign({
        autoInsertSpace: autoInsertSpaceInButton
    }, config.button);
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $3f3c7e3b4529c133$export$2e2bcd8739ae039)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer: layer } = $acw62.useContext((0, $182b356f02bf1b9b$export$2e2bcd8739ae039));
    const memoIconContextValue = $acw62.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp,
            layer: layer ? 'antd' : undefined
        }), [
        iconPrefixCls,
        csp,
        layer
    ]);
    let childNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $a098b6503d6d9fdd$export$2e2bcd8739ae039), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $acw62.useMemo(()=>{
        var _a, _b, _c, _d;
        return (0, $3478506a110abe5a$export$4950aa0f605343fb)(((_a = (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $acw62.createElement((0, $efabd6732f69a6da$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $acw62.createElement((0, $766ff256ac32087c$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $766ff256ac32087c$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $acw62.createElement((0, $6bacc63174d40f3c$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $acw62.createElement((0, $3e100f55cf8f3689$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $acw62.createElement((0, $57278e23ed3ca8fa$export$2e2bcd8739ae039), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $acw62.useMemo(()=>{
        const _a = mergedTheme || {}, { algorithm: algorithm, token: token, components: components, cssVar: cssVar } = _a, rest = $7ed5e10e08c170f8$var$__rest(_a, [
            "algorithm",
            "token",
            "components",
            "cssVar"
        ]);
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $db48c74b3367fd88$export$2e2bcd8739ae039)(algorithm) : (0, $16712192479069fd$export$2e2bcd8739ae039);
        const parsedComponents = {};
        Object.entries(components || {}).forEach(([componentName, componentToken])=>{
            const parsedToken = Object.assign({}, componentToken);
            if ('algorithm' in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') parsedToken.theme = (0, $db48c74b3367fd88$export$2e2bcd8739ae039)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = Object.assign(Object.assign({}, (0, $b1208bbc03407e2e$export$2e2bcd8739ae039)), token);
        return Object.assign(Object.assign({}, rest), {
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: Object.assign({
                override: mergedToken
            }, parsedComponents),
            cssVar: cssVar
        });
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $acw62.createElement((0, $d6a0cd0c670c9aed$export$69b0ebb9efcddb30).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $acw62.createElement((0, $5bd796dbed593bbb$export$11b88c75b33aa1fd).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $acw62.createElement((0, $6ba6819805fb0a44$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
const $7ed5e10e08c170f8$var$ConfigProvider = (props)=>{
    const context = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const antLocale = $acw62.useContext((0, $6dd9227cba6de9ce$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $acw62.createElement($7ed5e10e08c170f8$var$ProviderChildren, Object.assign({
        parentContext: context,
        legacyLocale: antLocale
    }, props));
};
$7ed5e10e08c170f8$var$ConfigProvider.ConfigContext = (0, $a18b2f6f56546238$export$a92f85ab3e9ad68b);
$7ed5e10e08c170f8$var$ConfigProvider.SizeContext = (0, $3e100f55cf8f3689$export$2e2bcd8739ae039);
$7ed5e10e08c170f8$var$ConfigProvider.config = $7ed5e10e08c170f8$var$setGlobalConfig;
$7ed5e10e08c170f8$var$ConfigProvider.useConfig = (0, $1e1ca3bea54a77f7$export$2e2bcd8739ae039);
Object.defineProperty($7ed5e10e08c170f8$var$ConfigProvider, 'SizeContext', {
    get: ()=>{
        return 0, $3e100f55cf8f3689$export$2e2bcd8739ae039;
    }
});
var $7ed5e10e08c170f8$export$2e2bcd8739ae039 = $7ed5e10e08c170f8$var$ConfigProvider;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8e7f784a29e9449d$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $8e7f784a29e9449d$export$2e2bcd8739ae039 = $8e7f784a29e9449d$var$CheckCircleFilled;







var $acw62 = parcelRequire("acw62");

/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ /**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $89c3f0c2cde0477f$export$b0e60b43d1d059f0(n, max) {
    if ($89c3f0c2cde0477f$export$7bf7d6849640691b(n)) n = '100%';
    var isPercent = $89c3f0c2cde0477f$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $89c3f0c2cde0477f$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $89c3f0c2cde0477f$export$7bf7d6849640691b(n) {
    return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
}
function $89c3f0c2cde0477f$export$d86432a85610ea90(n) {
    return typeof n === 'string' && n.indexOf('%') !== -1;
}
function $89c3f0c2cde0477f$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $89c3f0c2cde0477f$export$8ba0754c08bd5ca8(n) {
    if (n <= 1) return "".concat(Number(n) * 100, "%");
    return n;
}
function $89c3f0c2cde0477f$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? '0' + c : String(c);
}


function $5dbaaddf372549d4$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(r, 255) * 255,
        g: (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(g, 255) * 255,
        b: (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(b, 255) * 255
    };
}
function $5dbaaddf372549d4$export$c85ca4f4753af384(r, g, b) {
    r = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $5dbaaddf372549d4$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5dbaaddf372549d4$export$29fb7152bd3f781a(h, s, l) {
    var r;
    var g;
    var b;
    h = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(h, 360);
    s = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(s, 100);
    l = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $5dbaaddf372549d4$var$hue2rgb(p, q, h + 1 / 3);
        g = $5dbaaddf372549d4$var$hue2rgb(p, q, h);
        b = $5dbaaddf372549d4$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $5dbaaddf372549d4$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $5dbaaddf372549d4$export$210753cfeec758a5(h, s, v) {
    h = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(h, 360) * 6;
    s = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(s, 100);
    v = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    var g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    var b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $5dbaaddf372549d4$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    var hex = [
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join('');
}
function $5dbaaddf372549d4$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    var hex = [
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(b).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)($5dbaaddf372549d4$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join('');
}
function $5dbaaddf372549d4$export$ce6645f7d73030f4(r, g, b, a) {
    var hex = [
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)($5dbaaddf372549d4$export$51dcdea396f3aff6(a)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    return hex.join('');
}
function $5dbaaddf372549d4$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $5dbaaddf372549d4$export$616da979ad1c2414(h) {
    return $5dbaaddf372549d4$export$262b3ba788b4d07c(h) / 255;
}
function $5dbaaddf372549d4$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $5dbaaddf372549d4$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}


// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ var $7c1331a6b98e7de3$export$e4b2ac9215619f8d = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    goldenrod: '#daa520',
    gold: '#ffd700',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavenderblush: '#fff0f5',
    lavender: '#e6e6fa',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};



function $4146cacf0fc753c3$export$87de337d8199f22c(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === 'string') color = $4146cacf0fc753c3$export$56237d872eed15a0(color);
    if (typeof color === 'object') {
        if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.r) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.g) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $5dbaaddf372549d4$export$1a0d7f039f803cb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === '%' ? 'prgb' : 'rgb';
        } else if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.h) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.s) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.v)) {
            s = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.s);
            v = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.v);
            rgb = (0, $5dbaaddf372549d4$export$210753cfeec758a5)(color.h, s, v);
            ok = true;
            format = 'hsv';
        } else if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.h) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.s) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.l)) {
            s = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.s);
            l = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.l);
            rgb = (0, $5dbaaddf372549d4$export$29fb7152bd3f781a)(color.h, s, l);
            ok = true;
            format = 'hsl';
        }
        if (Object.prototype.hasOwnProperty.call(color, 'a')) a = color.a;
    }
    a = (0, $89c3f0c2cde0477f$export$3ae665204365318d)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var $4146cacf0fc753c3$var$CSS_INTEGER = '[-\\+]?\\d+%?';
// <http://www.w3.org/TR/css3-values/#number-value>
var $4146cacf0fc753c3$var$CSS_NUMBER = '[-\\+]?\\d*\\.\\d+%?';
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var $4146cacf0fc753c3$var$CSS_UNIT = "(?:".concat($4146cacf0fc753c3$var$CSS_NUMBER, ")|(?:").concat($4146cacf0fc753c3$var$CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var $4146cacf0fc753c3$var$PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")\\s*\\)?");
var $4146cacf0fc753c3$var$PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")\\s*\\)?");
var $4146cacf0fc753c3$var$matchers = {
    CSS_UNIT: new RegExp($4146cacf0fc753c3$var$CSS_UNIT),
    rgb: new RegExp('rgb' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    rgba: new RegExp('rgba' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hsl: new RegExp('hsl' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    hsla: new RegExp('hsla' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hsv: new RegExp('hsv' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    hsva: new RegExp('hsva' + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $4146cacf0fc753c3$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    var named = false;
    if ((0, $7c1331a6b98e7de3$export$e4b2ac9215619f8d)[color]) {
        color = (0, $7c1331a6b98e7de3$export$e4b2ac9215619f8d)[color];
        named = true;
    } else if (color === 'transparent') return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: 'name'
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = $4146cacf0fc753c3$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3]),
        a: (0, $5dbaaddf372549d4$export$616da979ad1c2414)(match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $4146cacf0fc753c3$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3]),
        format: named ? 'name' : 'hex'
    };
    match = $4146cacf0fc753c3$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3] + match[3]),
        a: (0, $5dbaaddf372549d4$export$616da979ad1c2414)(match[4] + match[4]),
        format: named ? 'name' : 'hex8'
    };
    match = $4146cacf0fc753c3$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3] + match[3]),
        format: named ? 'name' : 'hex'
    };
    return false;
}
function $4146cacf0fc753c3$export$80d4d71a83d4526d(color) {
    return Boolean($4146cacf0fc753c3$var$matchers.CSS_UNIT.exec(String(color)));
}


var $e7a4b3773ef5acd1$var$hueStep = 2; // 色相阶梯
var $e7a4b3773ef5acd1$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $e7a4b3773ef5acd1$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $e7a4b3773ef5acd1$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $e7a4b3773ef5acd1$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $e7a4b3773ef5acd1$var$lightColorCount = 5; // 浅色数量，主色上
var $e7a4b3773ef5acd1$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $e7a4b3773ef5acd1$var$darkColorMap = [
    {
        index: 7,
        opacity: 0.15
    },
    {
        index: 6,
        opacity: 0.25
    },
    {
        index: 5,
        opacity: 0.3
    },
    {
        index: 5,
        opacity: 0.45
    },
    {
        index: 5,
        opacity: 0.65
    },
    {
        index: 5,
        opacity: 0.85
    },
    {
        index: 4,
        opacity: 0.9
    },
    {
        index: 3,
        opacity: 0.95
    },
    {
        index: 2,
        opacity: 0.97
    },
    {
        index: 1,
        opacity: 0.98
    }
];
// Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`
function $e7a4b3773ef5acd1$var$toHsv(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var hsv = (0, $5dbaaddf372549d4$export$f76e85ca00a47f5c)(r, g, b);
    return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v
    };
}
// Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`
function $e7a4b3773ef5acd1$var$toHex(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b;
    return "#".concat((0, $5dbaaddf372549d4$export$34d09c4a771c46ef)(r, g, b, false));
}
// Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.
function $e7a4b3773ef5acd1$var$mix(rgb1, rgb2, amount) {
    var p = amount / 100;
    var rgb = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b
    };
    return rgb;
}
function $e7a4b3773ef5acd1$var$getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $e7a4b3773ef5acd1$var$hueStep * i : Math.round(hsv.h) + $e7a4b3773ef5acd1$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $e7a4b3773ef5acd1$var$hueStep * i : Math.round(hsv.h) - $e7a4b3773ef5acd1$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $e7a4b3773ef5acd1$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $e7a4b3773ef5acd1$var$saturationStep * i;
    else if (i === $e7a4b3773ef5acd1$var$darkColorCount) saturation = hsv.s + $e7a4b3773ef5acd1$var$saturationStep;
    else saturation = hsv.s + $e7a4b3773ef5acd1$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $e7a4b3773ef5acd1$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Number(saturation.toFixed(2));
}
function $e7a4b3773ef5acd1$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $e7a4b3773ef5acd1$var$brightnessStep1 * i;
    else value = hsv.v - $e7a4b3773ef5acd1$var$brightnessStep2 * i;
    if (value > 1) value = 1;
    return Number(value.toFixed(2));
}
function $e7a4b3773ef5acd1$export$2e2bcd8739ae039(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = (0, $4146cacf0fc753c3$export$87de337d8199f22c)(color);
    for(var i = $e7a4b3773ef5acd1$var$lightColorCount; i > 0; i -= 1){
        var hsv = $e7a4b3773ef5acd1$var$toHsv(pColor);
        var colorString = $e7a4b3773ef5acd1$var$toHex((0, $4146cacf0fc753c3$export$87de337d8199f22c)({
            h: $e7a4b3773ef5acd1$var$getHue(hsv, i, true),
            s: $e7a4b3773ef5acd1$var$getSaturation(hsv, i, true),
            v: $e7a4b3773ef5acd1$var$getValue(hsv, i, true)
        }));
        patterns.push(colorString);
    }
    patterns.push($e7a4b3773ef5acd1$var$toHex(pColor));
    for(var _i = 1; _i <= $e7a4b3773ef5acd1$var$darkColorCount; _i += 1){
        var _hsv = $e7a4b3773ef5acd1$var$toHsv(pColor);
        var _colorString = $e7a4b3773ef5acd1$var$toHex((0, $4146cacf0fc753c3$export$87de337d8199f22c)({
            h: $e7a4b3773ef5acd1$var$getHue(_hsv, _i),
            s: $e7a4b3773ef5acd1$var$getSaturation(_hsv, _i),
            v: $e7a4b3773ef5acd1$var$getValue(_hsv, _i)
        }));
        patterns.push(_colorString);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $e7a4b3773ef5acd1$var$darkColorMap.map(function(_ref3) {
        var index = _ref3.index, opacity = _ref3.opacity;
        var darkColorString = $e7a4b3773ef5acd1$var$toHex($e7a4b3773ef5acd1$var$mix((0, $4146cacf0fc753c3$export$87de337d8199f22c)(opts.backgroundColor || '#141414'), (0, $4146cacf0fc753c3$export$87de337d8199f22c)(patterns[index]), opacity * 100));
        return darkColorString;
    });
    return patterns;
}


// Generated by script. Do NOT modify!
var $aa60f7fc7c3f5884$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
var $aa60f7fc7c3f5884$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$aa60f7fc7c3f5884$export$a90204d1394caf30.primary = $aa60f7fc7c3f5884$export$a90204d1394caf30[5];
var $aa60f7fc7c3f5884$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$aa60f7fc7c3f5884$export$e63a1643b2f79b16.primary = $aa60f7fc7c3f5884$export$e63a1643b2f79b16[5];
var $aa60f7fc7c3f5884$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$aa60f7fc7c3f5884$export$ad766f34ace1cafd.primary = $aa60f7fc7c3f5884$export$ad766f34ace1cafd[5];
var $aa60f7fc7c3f5884$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$aa60f7fc7c3f5884$export$c24201f7fe3571d8.primary = $aa60f7fc7c3f5884$export$c24201f7fe3571d8[5];
var $aa60f7fc7c3f5884$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$aa60f7fc7c3f5884$export$594c5a8758200c32.primary = $aa60f7fc7c3f5884$export$594c5a8758200c32[5];
var $aa60f7fc7c3f5884$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$aa60f7fc7c3f5884$export$221d31baf2636aad.primary = $aa60f7fc7c3f5884$export$221d31baf2636aad[5];
var $aa60f7fc7c3f5884$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$aa60f7fc7c3f5884$export$955a2ebd2fb142ae.primary = $aa60f7fc7c3f5884$export$955a2ebd2fb142ae[5];
var $aa60f7fc7c3f5884$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$aa60f7fc7c3f5884$export$7474046f446842ee.primary = $aa60f7fc7c3f5884$export$7474046f446842ee[5];
var $aa60f7fc7c3f5884$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$aa60f7fc7c3f5884$export$2aa0182783e7e9de.primary = $aa60f7fc7c3f5884$export$2aa0182783e7e9de[5];
var $aa60f7fc7c3f5884$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$aa60f7fc7c3f5884$export$4138d3aeddcbf415.primary = $aa60f7fc7c3f5884$export$4138d3aeddcbf415[5];
var $aa60f7fc7c3f5884$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$aa60f7fc7c3f5884$export$e13cce2a2d16a9d4.primary = $aa60f7fc7c3f5884$export$e13cce2a2d16a9d4[5];
var $aa60f7fc7c3f5884$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$aa60f7fc7c3f5884$export$2a9ca2e383622e18.primary = $aa60f7fc7c3f5884$export$2a9ca2e383622e18[5];
var $aa60f7fc7c3f5884$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$aa60f7fc7c3f5884$export$e4c89085febbc618.primary = $aa60f7fc7c3f5884$export$e4c89085febbc618[5];
var $aa60f7fc7c3f5884$export$3e2c219d3ab79d01 = $aa60f7fc7c3f5884$export$e4c89085febbc618;
var $aa60f7fc7c3f5884$export$36ad6df0f83f284d = {
    red: $aa60f7fc7c3f5884$export$a90204d1394caf30,
    volcano: $aa60f7fc7c3f5884$export$e63a1643b2f79b16,
    orange: $aa60f7fc7c3f5884$export$ad766f34ace1cafd,
    gold: $aa60f7fc7c3f5884$export$c24201f7fe3571d8,
    yellow: $aa60f7fc7c3f5884$export$594c5a8758200c32,
    lime: $aa60f7fc7c3f5884$export$221d31baf2636aad,
    green: $aa60f7fc7c3f5884$export$955a2ebd2fb142ae,
    cyan: $aa60f7fc7c3f5884$export$7474046f446842ee,
    blue: $aa60f7fc7c3f5884$export$2aa0182783e7e9de,
    geekblue: $aa60f7fc7c3f5884$export$4138d3aeddcbf415,
    purple: $aa60f7fc7c3f5884$export$e13cce2a2d16a9d4,
    magenta: $aa60f7fc7c3f5884$export$2a9ca2e383622e18,
    grey: $aa60f7fc7c3f5884$export$e4c89085febbc618
};
var $aa60f7fc7c3f5884$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$aa60f7fc7c3f5884$export$e984d34fc144caa1.primary = $aa60f7fc7c3f5884$export$e984d34fc144caa1[5];
var $aa60f7fc7c3f5884$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$aa60f7fc7c3f5884$export$360e10f78e17a865.primary = $aa60f7fc7c3f5884$export$360e10f78e17a865[5];
var $aa60f7fc7c3f5884$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$aa60f7fc7c3f5884$export$d5a12c698b31fa45.primary = $aa60f7fc7c3f5884$export$d5a12c698b31fa45[5];
var $aa60f7fc7c3f5884$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$aa60f7fc7c3f5884$export$2330427fb6a6af6f.primary = $aa60f7fc7c3f5884$export$2330427fb6a6af6f[5];
var $aa60f7fc7c3f5884$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$aa60f7fc7c3f5884$export$67d203119f0ecec.primary = $aa60f7fc7c3f5884$export$67d203119f0ecec[5];
var $aa60f7fc7c3f5884$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$aa60f7fc7c3f5884$export$51ed2a10d86576ed.primary = $aa60f7fc7c3f5884$export$51ed2a10d86576ed[5];
var $aa60f7fc7c3f5884$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$aa60f7fc7c3f5884$export$76a3d804058f9b5f.primary = $aa60f7fc7c3f5884$export$76a3d804058f9b5f[5];
var $aa60f7fc7c3f5884$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$aa60f7fc7c3f5884$export$dee6c7c6683c0d88.primary = $aa60f7fc7c3f5884$export$dee6c7c6683c0d88[5];
var $aa60f7fc7c3f5884$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$aa60f7fc7c3f5884$export$10e0fd027e632624.primary = $aa60f7fc7c3f5884$export$10e0fd027e632624[5];
var $aa60f7fc7c3f5884$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$aa60f7fc7c3f5884$export$abdd57ab473bba66.primary = $aa60f7fc7c3f5884$export$abdd57ab473bba66[5];
var $aa60f7fc7c3f5884$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$aa60f7fc7c3f5884$export$7a65e68792738764.primary = $aa60f7fc7c3f5884$export$7a65e68792738764[5];
var $aa60f7fc7c3f5884$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$aa60f7fc7c3f5884$export$d260a9321db4ab86.primary = $aa60f7fc7c3f5884$export$d260a9321db4ab86[5];
var $aa60f7fc7c3f5884$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$aa60f7fc7c3f5884$export$515283ba400ffa6c.primary = $aa60f7fc7c3f5884$export$515283ba400ffa6c[5];
var $aa60f7fc7c3f5884$export$24617255e4daf647 = {
    red: $aa60f7fc7c3f5884$export$e984d34fc144caa1,
    volcano: $aa60f7fc7c3f5884$export$360e10f78e17a865,
    orange: $aa60f7fc7c3f5884$export$d5a12c698b31fa45,
    gold: $aa60f7fc7c3f5884$export$2330427fb6a6af6f,
    yellow: $aa60f7fc7c3f5884$export$67d203119f0ecec,
    lime: $aa60f7fc7c3f5884$export$51ed2a10d86576ed,
    green: $aa60f7fc7c3f5884$export$76a3d804058f9b5f,
    cyan: $aa60f7fc7c3f5884$export$dee6c7c6683c0d88,
    blue: $aa60f7fc7c3f5884$export$10e0fd027e632624,
    geekblue: $aa60f7fc7c3f5884$export$abdd57ab473bba66,
    purple: $aa60f7fc7c3f5884$export$7a65e68792738764,
    magenta: $aa60f7fc7c3f5884$export$d260a9321db4ab86,
    grey: $aa60f7fc7c3f5884$export$515283ba400ffa6c
};










var $acw62 = parcelRequire("acw62");




function $b9f59244e9def868$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function $b9f59244e9def868$export$cca82218ea4431a(ele) {
    return $b9f59244e9def868$var$getRoot(ele) instanceof ShadowRoot;
}
function $b9f59244e9def868$export$70e8259662bb498b(ele) {
    return $b9f59244e9def868$export$cca82218ea4431a(ele) ? $b9f59244e9def868$var$getRoot(ele) : null;
}




var $acw62 = parcelRequire("acw62");

function $1beccdf56290315b$var$camelCase(input) {
    return input.replace(/-(.)/g, function(match, g) {
        return g.toUpperCase();
    });
}
function $1beccdf56290315b$export$491112666e282270(valid, message) {
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(valid, "[@ant-design/icons] ".concat(message));
}
function $1beccdf56290315b$export$ab652842c37578f4(target) {
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(target.icon) === 'object' || typeof target.icon === 'function');
}
function $1beccdf56290315b$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$1beccdf56290315b$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $1beccdf56290315b$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        key: key
    }, $1beccdf56290315b$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $1beccdf56290315b$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        key: key
    }, $1beccdf56290315b$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $1beccdf56290315b$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $1beccdf56290315b$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $e7a4b3773ef5acd1$export$2e2bcd8739ae039)(primaryColor)[0];
}
function $1beccdf56290315b$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $1beccdf56290315b$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
var $1beccdf56290315b$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $1beccdf56290315b$export$938b1f86b61613d0 = function useInsertStyles(eleRef) {
    var _useContext = (0, $acw62.useContext)((0, $6bacc63174d40f3c$export$2e2bcd8739ae039)), csp = _useContext.csp, prefixCls = _useContext.prefixCls, layer = _useContext.layer;
    var mergedStyleStr = $1beccdf56290315b$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = "@layer ".concat(layer, " {\n").concat(mergedStyleStr, "\n}");
    (0, $acw62.useEffect)(function() {
        var ele = eleRef.current;
        var shadowRoot = (0, $b9f59244e9def868$export$70e8259662bb498b)(ele);
        (0, $3a22468320d7d808$export$4d99a2890bb989f0)(mergedStyleStr, '@ant-design-icons', {
            prepend: !layer,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


var $c52e7cd4d4f30fad$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $c52e7cd4d4f30fad$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $c52e7cd4d4f30fad$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $c52e7cd4d4f30fad$var$twoToneColorPalette.primaryColor = primaryColor;
    $c52e7cd4d4f30fad$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $1beccdf56290315b$export$b71c93f469694483)(primaryColor);
    $c52e7cd4d4f30fad$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $c52e7cd4d4f30fad$var$getTwoToneColors() {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $c52e7cd4d4f30fad$var$twoToneColorPalette);
}
var $c52e7cd4d4f30fad$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $c52e7cd4d4f30fad$var$_excluded);
    var svgRef = $acw62.useRef();
    var colors = $c52e7cd4d4f30fad$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $1beccdf56290315b$export$b71c93f469694483)(primaryColor)
    };
    (0, $1beccdf56290315b$export$938b1f86b61613d0)(svgRef);
    (0, $1beccdf56290315b$export$491112666e282270)((0, $1beccdf56290315b$export$ab652842c37578f4)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $1beccdf56290315b$export$ab652842c37578f4)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === 'function') target = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $1beccdf56290315b$export$80d376111cc09ad7)(target.icon, "svg-".concat(target.name), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true'
    }, restProps), {}, {
        ref: svgRef
    }));
};
$c52e7cd4d4f30fad$var$IconBase.displayName = 'IconReact';
$c52e7cd4d4f30fad$var$IconBase.getTwoToneColors = $c52e7cd4d4f30fad$var$getTwoToneColors;
$c52e7cd4d4f30fad$var$IconBase.setTwoToneColors = $c52e7cd4d4f30fad$var$setTwoToneColors;
var $c52e7cd4d4f30fad$export$2e2bcd8739ae039 = $c52e7cd4d4f30fad$var$IconBase;





function $27dd37ce58e7c6e8$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $1beccdf56290315b$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $27dd37ce58e7c6e8$export$abc7c554784cb4a7() {
    var colors = (0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



'use client';
var $7714637e9c1f1f3f$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $27dd37ce58e7c6e8$export$8a145f34580ff02b)((0, $aa60f7fc7c3f5884$export$2aa0182783e7e9de).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
var $7714637e9c1f1f3f$var$Icon = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $7714637e9c1f1f3f$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $6bacc63174d40f3c$export$2e2bcd8739ae039)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(rootClassName, prefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $1beccdf56290315b$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $acw62.createElement("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $acw62.createElement((0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$7714637e9c1f1f3f$var$Icon.displayName = 'AntdIcon';
$7714637e9c1f1f3f$var$Icon.getTwoToneColor = (0, $27dd37ce58e7c6e8$export$abc7c554784cb4a7);
$7714637e9c1f1f3f$var$Icon.setTwoToneColor = (0, $27dd37ce58e7c6e8$export$8a145f34580ff02b);
var $7714637e9c1f1f3f$export$2e2bcd8739ae039 = $7714637e9c1f1f3f$var$Icon;


var $9149fdfb4424d1d9$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $8e7f784a29e9449d$export$2e2bcd8739ae039)
    }));
};
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ var $9149fdfb4424d1d9$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($9149fdfb4424d1d9$var$CheckCircleFilled);
var $9149fdfb4424d1d9$export$2e2bcd8739ae039 = $9149fdfb4424d1d9$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $0c349e8b6d22460f$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $0c349e8b6d22460f$export$2e2bcd8739ae039 = $0c349e8b6d22460f$var$CloseCircleFilled;



var $81ff9dc68eb84eda$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $0c349e8b6d22460f$export$2e2bcd8739ae039)
    }));
};
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ var $81ff9dc68eb84eda$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($81ff9dc68eb84eda$var$CloseCircleFilled);
var $81ff9dc68eb84eda$export$2e2bcd8739ae039 = $81ff9dc68eb84eda$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $91321edc6c28da63$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $91321edc6c28da63$export$2e2bcd8739ae039 = $91321edc6c28da63$var$CloseOutlined;



var $06f117eb9481f34c$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $91321edc6c28da63$export$2e2bcd8739ae039)
    }));
};
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ var $06f117eb9481f34c$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($06f117eb9481f34c$var$CloseOutlined);
var $06f117eb9481f34c$export$2e2bcd8739ae039 = $06f117eb9481f34c$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $ce0f95a23ea8b20d$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $ce0f95a23ea8b20d$export$2e2bcd8739ae039 = $ce0f95a23ea8b20d$var$ExclamationCircleFilled;



var $2444f6da62064575$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $ce0f95a23ea8b20d$export$2e2bcd8739ae039)
    }));
};
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $2444f6da62064575$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2444f6da62064575$var$ExclamationCircleFilled);
var $2444f6da62064575$export$2e2bcd8739ae039 = $2444f6da62064575$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $57a9c466662aed09$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $57a9c466662aed09$export$2e2bcd8739ae039 = $57a9c466662aed09$var$InfoCircleFilled;



var $b5d5d018bfa4ba6e$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $57a9c466662aed09$export$2e2bcd8739ae039)
    }));
};
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $b5d5d018bfa4ba6e$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($b5d5d018bfa4ba6e$var$InfoCircleFilled);
var $b5d5d018bfa4ba6e$export$2e2bcd8739ae039 = $b5d5d018bfa4ba6e$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $2b0f3084756e08d0$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $2b0f3084756e08d0$export$2e2bcd8739ae039 = $2b0f3084756e08d0$var$LoadingOutlined;



var $d8d56e1090f62915$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $2b0f3084756e08d0$export$2e2bcd8739ae039)
    }));
};
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ var $d8d56e1090f62915$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($d8d56e1090f62915$var$LoadingOutlined);
var $d8d56e1090f62915$export$2e2bcd8739ae039 = $d8d56e1090f62915$var$RefIcon;







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");







var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $808ab7b8a87ab771$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $808ab7b8a87ab771$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(node) === 'object' && $808ab7b8a87ab771$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($808ab7b8a87ab771$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $808ab7b8a87ab771$export$2e2bcd8739ae039(node) {
    var domNode = $808ab7b8a87ab771$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))), node);
    }
    return null;
}




var $acw62 = parcelRequire("acw62");


var $5e297877593af644$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $5e297877593af644$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $5e297877593af644$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $5e297877593af644$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        return $5e297877593af644$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $5e297877593af644$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $3251146683c5d714$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    return true;
};
function $5e297877593af644$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(node) && !(0, $3251146683c5d714$exports.isFragment)(node);
}
var $5e297877593af644$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $5e297877593af644$var$isReactElement(node) && $5e297877593af644$export$c1cec34af06bcf7(node);
};
var $5e297877593af644$export$7465e5c0bf44f19a = Number((0, $acw62.version).split('.')[0]) >= 19 ? // >= React 19
function(node) {
    if ($5e297877593af644$var$isReactElement(node)) return node.props.ref;
    return null;
} : // < React 19
function(node) {
    if ($5e297877593af644$var$isReactElement(node)) return node.ref;
    return null;
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $7b776f21b7918d7b$var$_excluded = [
    "children"
];
var $7b776f21b7918d7b$export$841858b892ce1f4c = /*#__PURE__*/ $acw62.createContext({});
function $7b776f21b7918d7b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $7b776f21b7918d7b$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement($7b776f21b7918d7b$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $acw62 = parcelRequire("acw62");
var $e37a565edd3e4d81$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);
var $e37a565edd3e4d81$export$2e2bcd8739ae039 = $e37a565edd3e4d81$var$DomWrapper;






var $acw62 = parcelRequire("acw62");
function $01e43e72865dc583$export$2e2bcd8739ae039(callback) {
    var fnRef = $acw62.useRef();
    fnRef.current = callback;
    var memoFn = $acw62.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}







var $acw62 = parcelRequire("acw62");
function $25e137fc56329ad1$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $acw62.useRef(false);
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $acw62.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $dbf5d1f4f4ecbb6a$var$hasValue(value) {
    return value !== undefined;
}
function $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(function() {
        if ($dbf5d1f4f4ecbb6a$var$hasValue(value)) return value;
        else if ($dbf5d1f4f4ecbb6a$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $493347a9fd5d8394$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $493347a9fd5d8394$export$9283e56bae2f7b0f)(function() {
        if (!$dbf5d1f4f4ecbb6a$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



function $17fcde5782384c29$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}









function $7d110e739ae14cc6$export$2e2bcd8739ae039(r) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(r) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(r) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}



function $4bc24eaedd2a47a4$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $7d110e739ae14cc6$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(entity);
    else clone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $4bc24eaedd2a47a4$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $4bc24eaedd2a47a4$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $17fcde5782384c29$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $4bc24eaedd2a47a4$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $4bc24eaedd2a47a4$var$isObject(obj) {
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $4bc24eaedd2a47a4$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $4bc24eaedd2a47a4$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $4bc24eaedd2a47a4$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $4bc24eaedd2a47a4$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $4bc24eaedd2a47a4$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, $4bc24eaedd2a47a4$var$createEmpty(value));
                    $4bc24eaedd2a47a4$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}








var $acw62 = parcelRequire("acw62");

function $fe03a404cc9d1454$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $acw62.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $acw62.useRef(defaultValue);
    var getValue = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}



var $acw62 = parcelRequire("acw62");
var $0e817525d7f1f474$export$de71442bbf2143da = 'none';
var $0e817525d7f1f474$export$4fc3521687bcacd2 = 'appear';
var $0e817525d7f1f474$export$5d6af549241fe2e8 = 'enter';
var $0e817525d7f1f474$export$59b1c493d29f68e4 = 'leave';
var $0e817525d7f1f474$export$40b34dd77d5522bf = 'none';
var $0e817525d7f1f474$export$1b792916a5fac4fc = 'prepare';
var $0e817525d7f1f474$export$9563153dd25a3ce8 = 'start';
var $0e817525d7f1f474$export$e205886172277ec6 = 'active';
var $0e817525d7f1f474$export$3a846c3d2fac10b8 = 'end';
var $0e817525d7f1f474$export$98351fa4e6b4f204 = 'prepared';



var $acw62 = parcelRequire("acw62");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $c24d790a085c6d93$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $c24d790a085c6d93$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $c24d790a085c6d93$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $c24d790a085c6d93$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $c24d790a085c6d93$var$vendorPrefixes = $c24d790a085c6d93$export$6e8b350b1a8958a0((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
var $c24d790a085c6d93$var$style = {};
if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
    var $c24d790a085c6d93$var$_document$createEleme = document.createElement('div');
    $c24d790a085c6d93$var$style = $c24d790a085c6d93$var$_document$createEleme.style;
}
var $c24d790a085c6d93$var$prefixedEventNames = {};
function $c24d790a085c6d93$export$a032e4f39350c1d8(eventName) {
    if ($c24d790a085c6d93$var$prefixedEventNames[eventName]) return $c24d790a085c6d93$var$prefixedEventNames[eventName];
    var prefixMap = $c24d790a085c6d93$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $c24d790a085c6d93$var$style) {
                $c24d790a085c6d93$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $c24d790a085c6d93$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $c24d790a085c6d93$var$internalAnimationEndName = $c24d790a085c6d93$export$a032e4f39350c1d8('animationend');
var $c24d790a085c6d93$var$internalTransitionEndName = $c24d790a085c6d93$export$a032e4f39350c1d8('transitionend');
var $c24d790a085c6d93$export$d28133ed3ad06c8b = !!($c24d790a085c6d93$var$internalAnimationEndName && $c24d790a085c6d93$var$internalTransitionEndName);
var $c24d790a085c6d93$export$760cc9769c51b738 = $c24d790a085c6d93$var$internalAnimationEndName || 'animationend';
var $c24d790a085c6d93$export$44baea64b8602e3c = $c24d790a085c6d93$var$internalTransitionEndName || 'transitionend';
function $c24d790a085c6d93$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $7ccb217d091ef41f$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $acw62.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $c24d790a085c6d93$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $c24d790a085c6d93$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $c24d790a085c6d93$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $c24d790a085c6d93$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $acw62.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $acw62 = parcelRequire("acw62");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $fb24c0ebe270f6f6$var$useIsomorphicLayoutEffect = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $fb24c0ebe270f6f6$export$2e2bcd8739ae039 = $fb24c0ebe270f6f6$var$useIsomorphicLayoutEffect;





var $acw62 = parcelRequire("acw62");


var $a1ced7b983ea61a4$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $a1ced7b983ea61a4$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $a1ced7b983ea61a4$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $a1ced7b983ea61a4$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $a1ced7b983ea61a4$var$rafUUID = 0;
var $a1ced7b983ea61a4$var$rafIds = new Map();
function $a1ced7b983ea61a4$var$cleanup(id) {
    $a1ced7b983ea61a4$var$rafIds.delete(id);
}
var $a1ced7b983ea61a4$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $a1ced7b983ea61a4$var$rafUUID += 1;
    var id = $a1ced7b983ea61a4$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $a1ced7b983ea61a4$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $a1ced7b983ea61a4$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $a1ced7b983ea61a4$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$a1ced7b983ea61a4$var$wrapperRaf.cancel = function(id) {
    var realId = $a1ced7b983ea61a4$var$rafIds.get(id);
    $a1ced7b983ea61a4$var$cleanup(id);
    return $a1ced7b983ea61a4$var$caf(realId);
};
var $a1ced7b983ea61a4$export$2e2bcd8739ae039 = $a1ced7b983ea61a4$var$wrapperRaf;



var $acw62 = parcelRequire("acw62");
var $dd21c0d0173075f3$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $acw62.useRef(null);
    function cancelNextFrame() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $1e0427d97d69e92c$var$FULL_STEP_QUEUE = [
    (0, $0e817525d7f1f474$export$1b792916a5fac4fc),
    (0, $0e817525d7f1f474$export$9563153dd25a3ce8),
    (0, $0e817525d7f1f474$export$e205886172277ec6),
    (0, $0e817525d7f1f474$export$3a846c3d2fac10b8)
];
var $1e0427d97d69e92c$var$SIMPLE_STEP_QUEUE = [
    (0, $0e817525d7f1f474$export$1b792916a5fac4fc),
    (0, $0e817525d7f1f474$export$98351fa4e6b4f204)
];
var $1e0427d97d69e92c$export$c2029bf6cfdbc28a = false;
var $1e0427d97d69e92c$export$dbee1e282e8c4830 = true;
function $1e0427d97d69e92c$export$39e04e72f972b885(step) {
    return step === (0, $0e817525d7f1f474$export$e205886172277ec6) || step === (0, $0e817525d7f1f474$export$3a846c3d2fac10b8);
}
var $1e0427d97d69e92c$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)((0, $0e817525d7f1f474$export$40b34dd77d5522bf)), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $dd21c0d0173075f3$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $0e817525d7f1f474$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $1e0427d97d69e92c$var$SIMPLE_STEP_QUEUE : $1e0427d97d69e92c$var$FULL_STEP_QUEUE;
    (0, $fb24c0ebe270f6f6$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $0e817525d7f1f474$export$40b34dd77d5522bf) && step !== (0, $0e817525d7f1f474$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $1e0427d97d69e92c$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $1df598d21d8025e6$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $fe03a404cc9d1454$export$2e2bcd8739ae039)((0, $0e817525d7f1f474$export$de71442bbf2143da)), _useSyncState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $acw62.useRef)(false);
    var deadlineRef = (0, $acw62.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $acw62.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $0e817525d7f1f474$export$de71442bbf2143da));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $0e817525d7f1f474$export$de71442bbf2143da)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $0e817525d7f1f474$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $0e817525d7f1f474$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $0e817525d7f1f474$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $7ccb217d091ef41f$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $0e817525d7f1f474$export$4fc3521687bcacd2:
                return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $0e817525d7f1f474$export$1b792916a5fac4fc), onAppearPrepare), (0, $0e817525d7f1f474$export$9563153dd25a3ce8), onAppearStart), (0, $0e817525d7f1f474$export$e205886172277ec6), onAppearActive);
            case 0, $0e817525d7f1f474$export$5d6af549241fe2e8:
                return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $0e817525d7f1f474$export$1b792916a5fac4fc), onEnterPrepare), (0, $0e817525d7f1f474$export$9563153dd25a3ce8), onEnterStart), (0, $0e817525d7f1f474$export$e205886172277ec6), onEnterActive);
            case 0, $0e817525d7f1f474$export$59b1c493d29f68e4:
                return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $0e817525d7f1f474$export$1b792916a5fac4fc), onLeavePrepare), (0, $0e817525d7f1f474$export$9563153dd25a3ce8), onLeaveStart), (0, $0e817525d7f1f474$export$e205886172277ec6), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $acw62.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $1e0427d97d69e92c$export$2e2bcd8739ae039)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $0e817525d7f1f474$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $0e817525d7f1f474$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $1e0427d97d69e92c$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $0e817525d7f1f474$export$e205886172277ec6) && currentStatus !== (0, $0e817525d7f1f474$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $0e817525d7f1f474$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $1e0427d97d69e92c$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $1e0427d97d69e92c$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    // Update with new status
    (0, $fb24c0ebe270f6f6$export$2e2bcd8739ae039)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $0e817525d7f1f474$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $0e817525d7f1f474$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $0e817525d7f1f474$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $0e817525d7f1f474$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $0e817525d7f1f474$export$de71442bbf2143da));
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $acw62.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $0e817525d7f1f474$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $0e817525d7f1f474$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $0e817525d7f1f474$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $0e817525d7f1f474$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $acw62.useRef(false);
    (0, $acw62.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $0e817525d7f1f474$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $0e817525d7f1f474$export$1b792916a5fac4fc] && step === (0, $0e817525d7f1f474$export$9563153dd25a3ce8)) mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $084772fb8d80df29$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $acw62.useContext((0, $7b776f21b7918d7b$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $acw62.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $acw62.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $1df598d21d8025e6$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $acw62.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $acw62.useCallback(function(node) {
            nodeRef.current = node;
            (0, $5e297877593af644$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $0e817525d7f1f474$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $0e817525d7f1f474$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
            else if ((0, $1e0427d97d69e92c$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $0e817525d7f1f474$export$9563153dd25a3ce8)) statusSuffix = 'start';
            var motionCls = (0, $c24d790a085c6d93$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $c24d790a085c6d93$export$27c72201b1d09951)(motionName, status), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $acw62.isValidElement(motionChildren) && (0, $5e297877593af644$export$c1cec34af06bcf7)(motionChildren)) {
            var _ref = motionChildren, originNodeRef = _ref.ref;
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $acw62.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $acw62.createElement((0, $e37a565edd3e4d81$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $084772fb8d80df29$export$2e2bcd8739ae039 = $084772fb8d80df29$export$e265d52a86a9f199((0, $c24d790a085c6d93$export$d28133ed3ad06c8b));












var $acw62 = parcelRequire("acw62");



var $16994a73d43ee3a4$export$3904baa009bc026e = 'add';
var $16994a73d43ee3a4$export$851162f0adad2cbc = 'keep';
var $16994a73d43ee3a4$export$c8b3fb08b68cfc85 = 'remove';
var $16994a73d43ee3a4$export$2ac1bd1808d2e43a = 'removed';
function $16994a73d43ee3a4$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $16994a73d43ee3a4$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($16994a73d43ee3a4$export$c47fd798e598c85c);
}
function $16994a73d43ee3a4$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $16994a73d43ee3a4$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $16994a73d43ee3a4$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $16994a73d43ee3a4$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $16994a73d43ee3a4$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $16994a73d43ee3a4$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $16994a73d43ee3a4$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $16994a73d43ee3a4$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $16994a73d43ee3a4$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $ab0f5c5a9767e13d$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $ab0f5c5a9767e13d$var$_excluded2 = [
    "status"
];
var $ab0f5c5a9767e13d$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $ab0f5c5a9767e13d$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $084772fb8d80df29$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                var keyEntities = _this.state.keyEntities;
                var nextKeyEntities = keyEntities.map(function(entity) {
                    if (entity.key !== removeKey) return entity;
                    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, entity), {}, {
                        status: (0, $16994a73d43ee3a4$export$2ac1bd1808d2e43a)
                    });
                });
                _this.setState({
                    keyEntities: nextKeyEntities
                });
                return nextKeyEntities.filter(function(_ref) {
                    var status = _ref.status;
                    return status !== (0, $16994a73d43ee3a4$export$2ac1bd1808d2e43a);
                }).length;
            });
            return _this;
        }
        (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_this$props, $ab0f5c5a9767e13d$var$_excluded);
                    var Component = component || $acw62.Fragment;
                    var motionProps = {};
                    $ab0f5c5a9767e13d$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $acw62.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref2, $ab0f5c5a9767e13d$var$_excluded2);
                        var visible = status === (0, $16994a73d43ee3a4$export$3904baa009bc026e) || status === (0, $16994a73d43ee3a4$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $acw62.createElement(CSSMotion, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) {
                                    var restKeysCount = _this2.removeKey(eventProps.key);
                                    if (restKeysCount === 0 && onAllRemoved) onAllRemoved();
                                }
                            }
                        }), function(props, ref) {
                            return children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $16994a73d43ee3a4$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $16994a73d43ee3a4$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $16994a73d43ee3a4$export$2ac1bd1808d2e43a) && entity.status === (0, $16994a73d43ee3a4$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($acw62.Component);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $ab0f5c5a9767e13d$export$2e2bcd8739ae039 = $ab0f5c5a9767e13d$export$fcfc62c1d33d5e2e((0, $c24d790a085c6d93$export$d28133ed3ad06c8b));



var $609e894acbce1933$export$2e2bcd8739ae039 = (0, $084772fb8d80df29$export$2e2bcd8739ae039);







/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $d8d9cb1a28007639$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $d8d9cb1a28007639$var$KeyCode.F1 && keyCode <= $d8d9cb1a28007639$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $d8d9cb1a28007639$var$KeyCode.ALT:
            case $d8d9cb1a28007639$var$KeyCode.CAPS_LOCK:
            case $d8d9cb1a28007639$var$KeyCode.CONTEXT_MENU:
            case $d8d9cb1a28007639$var$KeyCode.CTRL:
            case $d8d9cb1a28007639$var$KeyCode.DOWN:
            case $d8d9cb1a28007639$var$KeyCode.END:
            case $d8d9cb1a28007639$var$KeyCode.ESC:
            case $d8d9cb1a28007639$var$KeyCode.HOME:
            case $d8d9cb1a28007639$var$KeyCode.INSERT:
            case $d8d9cb1a28007639$var$KeyCode.LEFT:
            case $d8d9cb1a28007639$var$KeyCode.MAC_FF_META:
            case $d8d9cb1a28007639$var$KeyCode.META:
            case $d8d9cb1a28007639$var$KeyCode.NUMLOCK:
            case $d8d9cb1a28007639$var$KeyCode.NUM_CENTER:
            case $d8d9cb1a28007639$var$KeyCode.PAGE_DOWN:
            case $d8d9cb1a28007639$var$KeyCode.PAGE_UP:
            case $d8d9cb1a28007639$var$KeyCode.PAUSE:
            case $d8d9cb1a28007639$var$KeyCode.PRINT_SCREEN:
            case $d8d9cb1a28007639$var$KeyCode.RIGHT:
            case $d8d9cb1a28007639$var$KeyCode.SHIFT:
            case $d8d9cb1a28007639$var$KeyCode.UP:
            case $d8d9cb1a28007639$var$KeyCode.WIN_KEY:
            case $d8d9cb1a28007639$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.ZERO && keyCode <= $d8d9cb1a28007639$var$KeyCode.NINE) return true;
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.NUM_ZERO && keyCode <= $d8d9cb1a28007639$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.A && keyCode <= $d8d9cb1a28007639$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $d8d9cb1a28007639$var$KeyCode.SPACE:
            case $d8d9cb1a28007639$var$KeyCode.QUESTION_MARK:
            case $d8d9cb1a28007639$var$KeyCode.NUM_PLUS:
            case $d8d9cb1a28007639$var$KeyCode.NUM_MINUS:
            case $d8d9cb1a28007639$var$KeyCode.NUM_PERIOD:
            case $d8d9cb1a28007639$var$KeyCode.NUM_DIVISION:
            case $d8d9cb1a28007639$var$KeyCode.SEMICOLON:
            case $d8d9cb1a28007639$var$KeyCode.DASH:
            case $d8d9cb1a28007639$var$KeyCode.EQUALS:
            case $d8d9cb1a28007639$var$KeyCode.COMMA:
            case $d8d9cb1a28007639$var$KeyCode.PERIOD:
            case $d8d9cb1a28007639$var$KeyCode.SLASH:
            case $d8d9cb1a28007639$var$KeyCode.APOSTROPHE:
            case $d8d9cb1a28007639$var$KeyCode.SINGLE_QUOTE:
            case $d8d9cb1a28007639$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $d8d9cb1a28007639$var$KeyCode.BACKSLASH:
            case $d8d9cb1a28007639$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $d8d9cb1a28007639$export$2e2bcd8739ae039 = $d8d9cb1a28007639$var$KeyCode;



var $acw62 = parcelRequire("acw62");

var $281efe5882c936de$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $281efe5882c936de$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $281efe5882c936de$var$propList = "".concat($281efe5882c936de$var$attributes, " ").concat($281efe5882c936de$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $281efe5882c936de$var$ariaPrefix = 'aria-';
var $281efe5882c936de$var$dataPrefix = 'data-';
function $281efe5882c936de$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $281efe5882c936de$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === 'role' || $281efe5882c936de$var$match(key, $281efe5882c936de$var$ariaPrefix)) || // Data
        mergedConfig.data && $281efe5882c936de$var$match(key, $281efe5882c936de$var$dataPrefix) || // Attr
        mergedConfig.attr && $281efe5882c936de$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}


var $6be5862818f90611$var$Notify = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, style = props.style, className = props.className, _props$duration = props.duration, duration = _props$duration === void 0 ? 4.5 : _props$duration, showProgress = props.showProgress, _props$pauseOnHover = props.pauseOnHover, pauseOnHover = _props$pauseOnHover === void 0 ? true : _props$pauseOnHover, eventKey = props.eventKey, content = props.content, closable = props.closable, _props$closeIcon = props.closeIcon, closeIcon = _props$closeIcon === void 0 ? 'x' : _props$closeIcon, divProps = props.props, onClick = props.onClick, onNoticeClose = props.onNoticeClose, times = props.times, forcedHovering = props.hovering;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), hovering = _React$useState2[0], setHovering = _React$useState2[1];
    var _React$useState3 = $acw62.useState(0), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), percent = _React$useState4[0], setPercent = _React$useState4[1];
    var _React$useState5 = $acw62.useState(0), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), spentTime = _React$useState6[0], setSpentTime = _React$useState6[1];
    var mergedHovering = forcedHovering || hovering;
    var mergedShowProgress = duration > 0 && showProgress;
    // ======================== Close =========================
    var onInternalClose = function onInternalClose() {
        onNoticeClose(eventKey);
    };
    var onCloseKeyDown = function onCloseKeyDown(e) {
        if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) onInternalClose();
    };
    // ======================== Effect ========================
    $acw62.useEffect(function() {
        if (!mergedHovering && duration > 0) {
            var start = Date.now() - spentTime;
            var timeout = setTimeout(function() {
                onInternalClose();
            }, duration * 1000 - spentTime);
            return function() {
                if (pauseOnHover) clearTimeout(timeout);
                setSpentTime(Date.now() - start);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        duration,
        mergedHovering,
        times
    ]);
    $acw62.useEffect(function() {
        if (!mergedHovering && mergedShowProgress && (pauseOnHover || spentTime === 0)) {
            var start = performance.now();
            var animationFrame;
            var calculate = function calculate() {
                cancelAnimationFrame(animationFrame);
                animationFrame = requestAnimationFrame(function(timestamp) {
                    var runtime = timestamp + spentTime - start;
                    var progress = Math.min(runtime / (duration * 1000), 1);
                    setPercent(progress * 100);
                    if (progress < 1) calculate();
                });
            };
            calculate();
            return function() {
                if (pauseOnHover) cancelAnimationFrame(animationFrame);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        duration,
        spentTime,
        mergedHovering,
        mergedShowProgress,
        times
    ]);
    // ======================== Closable ========================
    var closableObj = $acw62.useMemo(function() {
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(closable) === 'object' && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon
        };
        return {};
    }, [
        closable,
        closeIcon
    ]);
    var ariaProps = (0, $281efe5882c936de$export$2e2bcd8739ae039)(closableObj, true);
    // ======================== Progress ========================
    var validPercent = 100 - (!percent || percent < 0 ? 0 : percent > 100 ? 100 : percent);
    // ======================== Render ========================
    var noticePrefixCls = "".concat(prefixCls, "-notice");
    return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, divProps, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(noticePrefixCls, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(noticePrefixCls, "-closable"), closable)),
        style: style,
        onMouseEnter: function onMouseEnter(e) {
            var _divProps$onMouseEnte;
            setHovering(true);
            divProps === null || divProps === void 0 || (_divProps$onMouseEnte = divProps.onMouseEnter) === null || _divProps$onMouseEnte === void 0 || _divProps$onMouseEnte.call(divProps, e);
        },
        onMouseLeave: function onMouseLeave(e) {
            var _divProps$onMouseLeav;
            setHovering(false);
            divProps === null || divProps === void 0 || (_divProps$onMouseLeav = divProps.onMouseLeave) === null || _divProps$onMouseLeav === void 0 || _divProps$onMouseLeav.call(divProps, e);
        },
        onClick: onClick
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(noticePrefixCls, "-content")
    }, content), closable && /*#__PURE__*/ $acw62.createElement("a", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: 0,
        className: "".concat(noticePrefixCls, "-close"),
        onKeyDown: onCloseKeyDown,
        "aria-label": "Close"
    }, ariaProps, {
        onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();
            onInternalClose();
        }
    }), closableObj.closeIcon), mergedShowProgress && /*#__PURE__*/ $acw62.createElement("progress", {
        className: "".concat(noticePrefixCls, "-progress"),
        max: "100",
        value: validPercent
    }, validPercent + '%'));
});
var $6be5862818f90611$export$2e2bcd8739ae039 = $6be5862818f90611$var$Notify;



var $acw62 = parcelRequire("acw62");
var $189ebb65137099c1$export$a6e93d8cb5d50678 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
var $189ebb65137099c1$var$NotificationProvider = function NotificationProvider(_ref) {
    var children = _ref.children, classNames = _ref.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($189ebb65137099c1$export$a6e93d8cb5d50678.Provider, {
        value: {
            classNames: classNames
        }
    }, children);
};
var $189ebb65137099c1$export$2e2bcd8739ae039 = $189ebb65137099c1$var$NotificationProvider;



var $f0f0b4f717b22ee3$var$DEFAULT_OFFSET = 8;
var $f0f0b4f717b22ee3$var$DEFAULT_THRESHOLD = 3;
var $f0f0b4f717b22ee3$var$DEFAULT_GAP = 16;
var $f0f0b4f717b22ee3$var$useStack = function useStack(config) {
    var result = {
        offset: $f0f0b4f717b22ee3$var$DEFAULT_OFFSET,
        threshold: $f0f0b4f717b22ee3$var$DEFAULT_THRESHOLD,
        gap: $f0f0b4f717b22ee3$var$DEFAULT_GAP
    };
    if (config && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(config) === 'object') {
        var _config$offset, _config$threshold, _config$gap;
        result.offset = (_config$offset = config.offset) !== null && _config$offset !== void 0 ? _config$offset : $f0f0b4f717b22ee3$var$DEFAULT_OFFSET;
        result.threshold = (_config$threshold = config.threshold) !== null && _config$threshold !== void 0 ? _config$threshold : $f0f0b4f717b22ee3$var$DEFAULT_THRESHOLD;
        result.gap = (_config$gap = config.gap) !== null && _config$gap !== void 0 ? _config$gap : $f0f0b4f717b22ee3$var$DEFAULT_GAP;
    }
    return [
        !!config,
        result
    ];
};
var $f0f0b4f717b22ee3$export$2e2bcd8739ae039 = $f0f0b4f717b22ee3$var$useStack;


var $d47dcfb349f9c499$var$_excluded = [
    "className",
    "style",
    "classNames",
    "styles"
];
var $d47dcfb349f9c499$var$NoticeList = function NoticeList(props) {
    var configList = props.configList, placement = props.placement, prefixCls = props.prefixCls, className = props.className, style = props.style, motion = props.motion, onAllNoticeRemoved = props.onAllNoticeRemoved, onNoticeClose = props.onNoticeClose, stackConfig = props.stack;
    var _useContext = (0, $acw62.useContext)((0, $189ebb65137099c1$export$a6e93d8cb5d50678)), ctxCls = _useContext.classNames;
    var dictRef = (0, $acw62.useRef)({});
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), latestNotice = _useState2[0], setLatestNotice = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), hoverKeys = _useState4[0], setHoverKeys = _useState4[1];
    var keys = configList.map(function(config) {
        return {
            config: config,
            key: String(config.key)
        };
    });
    var _useStack = (0, $f0f0b4f717b22ee3$export$2e2bcd8739ae039)(stackConfig), _useStack2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStack, 2), stack = _useStack2[0], _useStack2$ = _useStack2[1], offset = _useStack2$.offset, threshold = _useStack2$.threshold, gap = _useStack2$.gap;
    var expanded = stack && (hoverKeys.length > 0 || keys.length <= threshold);
    var placementMotion = typeof motion === 'function' ? motion(placement) : motion;
    // Clean hover key
    (0, $acw62.useEffect)(function() {
        if (stack && hoverKeys.length > 1) setHoverKeys(function(prev) {
            return prev.filter(function(key) {
                return keys.some(function(_ref) {
                    var dataKey = _ref.key;
                    return key === dataKey;
                });
            });
        });
    }, [
        hoverKeys,
        keys,
        stack
    ]);
    // Force update latest notice
    (0, $acw62.useEffect)(function() {
        var _keys;
        if (stack && dictRef.current[(_keys = keys[keys.length - 1]) === null || _keys === void 0 ? void 0 : _keys.key]) {
            var _keys2;
            setLatestNotice(dictRef.current[(_keys2 = keys[keys.length - 1]) === null || _keys2 === void 0 ? void 0 : _keys2.key]);
        }
    }, [
        keys,
        stack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ab0f5c5a9767e13d$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        key: placement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, "".concat(prefixCls, "-").concat(placement), ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.list, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-stack"), !!stack), "".concat(prefixCls, "-stack-expanded"), expanded)),
        style: style,
        keys: keys,
        motionAppear: true
    }, placementMotion, {
        onAllRemoved: function onAllRemoved() {
            onAllNoticeRemoved(placement);
        }
    }), function(_ref2, nodeRef) {
        var config = _ref2.config, motionClassName = _ref2.className, motionStyle = _ref2.style, motionIndex = _ref2.index;
        var _ref3 = config, key = _ref3.key, times = _ref3.times;
        var strKey = String(key);
        var _ref4 = config, configClassName = _ref4.className, configStyle = _ref4.style, configClassNames = _ref4.classNames, configStyles = _ref4.styles, restConfig = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref4, $d47dcfb349f9c499$var$_excluded);
        var dataIndex = keys.findIndex(function(item) {
            return item.key === strKey;
        });
        // If dataIndex is -1, that means this notice has been removed in data, but still in dom
        // Should minus (motionIndex - 1) to get the correct index because keys.length is not the same as dom length
        var stackStyle = {};
        if (stack) {
            var index = keys.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
            var transformX = placement === 'top' || placement === 'bottom' ? '-50%' : '0';
            if (index > 0) {
                var _dictRef$current$strK, _dictRef$current$strK2, _dictRef$current$strK3;
                stackStyle.height = expanded ? (_dictRef$current$strK = dictRef.current[strKey]) === null || _dictRef$current$strK === void 0 ? void 0 : _dictRef$current$strK.offsetHeight : latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetHeight;
                // Transform
                var verticalOffset = 0;
                for(var i = 0; i < index; i++){
                    var _dictRef$current$keys;
                    verticalOffset += ((_dictRef$current$keys = dictRef.current[keys[keys.length - 1 - i].key]) === null || _dictRef$current$keys === void 0 ? void 0 : _dictRef$current$keys.offsetHeight) + gap;
                }
                var transformY = (expanded ? verticalOffset : index * offset) * (placement.startsWith('top') ? 1 : -1);
                var scaleX = !expanded && latestNotice !== null && latestNotice !== void 0 && latestNotice.offsetWidth && (_dictRef$current$strK2 = dictRef.current[strKey]) !== null && _dictRef$current$strK2 !== void 0 && _dictRef$current$strK2.offsetWidth ? ((latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetWidth) - offset * 2 * (index < 3 ? index : 3)) / ((_dictRef$current$strK3 = dictRef.current[strKey]) === null || _dictRef$current$strK3 === void 0 ? void 0 : _dictRef$current$strK3.offsetWidth) : 1;
                stackStyle.transform = "translate3d(".concat(transformX, ", ").concat(transformY, "px, 0) scaleX(").concat(scaleX, ")");
            } else stackStyle.transform = "translate3d(".concat(transformX, ", 0, 0)");
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: nodeRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-notice-wrapper"), motionClassName, configClassNames === null || configClassNames === void 0 ? void 0 : configClassNames.wrapper),
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionStyle), stackStyle), configStyles === null || configStyles === void 0 ? void 0 : configStyles.wrapper),
            onMouseEnter: function onMouseEnter() {
                return setHoverKeys(function(prev) {
                    return prev.includes(strKey) ? prev : [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prev), [
                        strKey
                    ]);
                });
            },
            onMouseLeave: function onMouseLeave() {
                return setHoverKeys(function(prev) {
                    return prev.filter(function(k) {
                        return k !== strKey;
                    });
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6be5862818f90611$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restConfig, {
            ref: function ref(node) {
                if (dataIndex > -1) dictRef.current[strKey] = node;
                else delete dictRef.current[strKey];
            },
            prefixCls: prefixCls,
            classNames: configClassNames,
            styles: configStyles,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(configClassName, ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.notice),
            style: configStyle,
            times: times,
            key: key,
            eventKey: key,
            onNoticeClose: onNoticeClose,
            hovering: stack && hoverKeys.length > 0
        })));
    });
};
var $d47dcfb349f9c499$export$2e2bcd8739ae039 = $d47dcfb349f9c499$var$NoticeList;


// ant-notification ant-notification-topRight
var $08224a65c5b0e7df$var$Notifications = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-notification' : _props$prefixCls, container = props.container, motion = props.motion, maxCount = props.maxCount, className = props.className, style = props.style, onAllRemoved = props.onAllRemoved, stack = props.stack, renderNotifications = props.renderNotifications;
    var _React$useState = $acw62.useState([]), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), configList = _React$useState2[0], setConfigList = _React$useState2[1];
    // ======================== Close =========================
    var onNoticeClose = function onNoticeClose(key) {
        var _config$onClose;
        // Trigger close event
        var config = configList.find(function(item) {
            return item.key === key;
        });
        config === null || config === void 0 || (_config$onClose = config.onClose) === null || _config$onClose === void 0 || _config$onClose.call(config);
        setConfigList(function(list) {
            return list.filter(function(item) {
                return item.key !== key;
            });
        });
    };
    // ========================= Refs =========================
    $acw62.useImperativeHandle(ref, function() {
        return {
            open: function open(config) {
                setConfigList(function(list) {
                    var clone = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(list);
                    // Replace if exist
                    var index = clone.findIndex(function(item) {
                        return item.key === config.key;
                    });
                    var innerConfig = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, config);
                    if (index >= 0) {
                        var _list$index;
                        innerConfig.times = (((_list$index = list[index]) === null || _list$index === void 0 ? void 0 : _list$index.times) || 0) + 1;
                        clone[index] = innerConfig;
                    } else {
                        innerConfig.times = 0;
                        clone.push(innerConfig);
                    }
                    if (maxCount > 0 && clone.length > maxCount) clone = clone.slice(-maxCount);
                    return clone;
                });
            },
            close: function close(key) {
                onNoticeClose(key);
            },
            destroy: function destroy() {
                setConfigList([]);
            }
        };
    });
    // ====================== Placements ======================
    var _React$useState3 = $acw62.useState({}), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), placements = _React$useState4[0], setPlacements = _React$useState4[1];
    $acw62.useEffect(function() {
        var nextPlacements = {};
        configList.forEach(function(config) {
            var _config$placement = config.placement, placement = _config$placement === void 0 ? 'topRight' : _config$placement;
            if (placement) {
                nextPlacements[placement] = nextPlacements[placement] || [];
                nextPlacements[placement].push(config);
            }
        });
        // Fill exist placements to avoid empty list causing remove without motion
        Object.keys(placements).forEach(function(placement) {
            nextPlacements[placement] = nextPlacements[placement] || [];
        });
        setPlacements(nextPlacements);
    }, [
        configList
    ]);
    // Clean up container if all notices fade out
    var onAllNoticeRemoved = function onAllNoticeRemoved(placement) {
        setPlacements(function(originPlacements) {
            var clone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originPlacements);
            var list = clone[placement] || [];
            if (!list.length) delete clone[placement];
            return clone;
        });
    };
    // Effect tell that placements is empty now
    var emptyRef = $acw62.useRef(false);
    $acw62.useEffect(function() {
        if (Object.keys(placements).length > 0) emptyRef.current = true;
        else if (emptyRef.current) {
            // Trigger only when from exist to empty
            onAllRemoved === null || onAllRemoved === void 0 || onAllRemoved();
            emptyRef.current = false;
        }
    }, [
        placements
    ]);
    // ======================== Render ========================
    if (!container) return null;
    var placementList = Object.keys(placements);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, placementList.map(function(placement) {
        var placementConfigList = placements[placement];
        var list = /*#__PURE__*/ $acw62.createElement((0, $d47dcfb349f9c499$export$2e2bcd8739ae039), {
            key: placement,
            configList: placementConfigList,
            placement: placement,
            prefixCls: prefixCls,
            className: className === null || className === void 0 ? void 0 : className(placement),
            style: style === null || style === void 0 ? void 0 : style(placement),
            motion: motion,
            onNoticeClose: onNoticeClose,
            onAllNoticeRemoved: onAllNoticeRemoved,
            stack: stack
        });
        return renderNotifications ? renderNotifications(list, {
            prefixCls: prefixCls,
            key: placement
        }) : list;
    })), container);
});
var $08224a65c5b0e7df$export$2e2bcd8739ae039 = $08224a65c5b0e7df$var$Notifications;



var $4fb0b9c84003ea9f$var$_excluded = [
    "getContainer",
    "motion",
    "prefixCls",
    "maxCount",
    "className",
    "style",
    "onAllRemoved",
    "stack",
    "renderNotifications"
];
var $4fb0b9c84003ea9f$var$defaultGetContainer = function defaultGetContainer() {
    return document.body;
};
var $4fb0b9c84003ea9f$var$uniqueKey = 0;
function $4fb0b9c84003ea9f$var$mergeConfig() {
    var clone = {};
    for(var _len = arguments.length, objList = new Array(_len), _key = 0; _key < _len; _key++)objList[_key] = arguments[_key];
    objList.forEach(function(obj) {
        if (obj) Object.keys(obj).forEach(function(key) {
            var val = obj[key];
            if (val !== undefined) clone[key] = val;
        });
    });
    return clone;
}
function $4fb0b9c84003ea9f$export$2e2bcd8739ae039() {
    var rootConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _rootConfig$getContai = rootConfig.getContainer, getContainer = _rootConfig$getContai === void 0 ? $4fb0b9c84003ea9f$var$defaultGetContainer : _rootConfig$getContai, motion = rootConfig.motion, prefixCls = rootConfig.prefixCls, maxCount = rootConfig.maxCount, className = rootConfig.className, style = rootConfig.style, onAllRemoved = rootConfig.onAllRemoved, stack = rootConfig.stack, renderNotifications = rootConfig.renderNotifications, shareConfig = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(rootConfig, $4fb0b9c84003ea9f$var$_excluded);
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), container = _React$useState2[0], setContainer = _React$useState2[1];
    var notificationsRef = $acw62.useRef();
    var contextHolder = /*#__PURE__*/ $acw62.createElement((0, $08224a65c5b0e7df$export$2e2bcd8739ae039), {
        container: container,
        ref: notificationsRef,
        prefixCls: prefixCls,
        motion: motion,
        maxCount: maxCount,
        className: className,
        style: style,
        onAllRemoved: onAllRemoved,
        stack: stack,
        renderNotifications: renderNotifications
    });
    var _React$useState3 = $acw62.useState([]), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), taskQueue = _React$useState4[0], setTaskQueue = _React$useState4[1];
    var open = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(config) {
        var mergedConfig = $4fb0b9c84003ea9f$var$mergeConfig(shareConfig, config);
        if (mergedConfig.key === null || mergedConfig.key === undefined) {
            mergedConfig.key = "rc-notification-".concat($4fb0b9c84003ea9f$var$uniqueKey);
            $4fb0b9c84003ea9f$var$uniqueKey += 1;
        }
        setTaskQueue(function(queue) {
            return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(queue), [
                {
                    type: 'open',
                    config: mergedConfig
                }
            ]);
        });
    });
    // ========================= Refs =========================
    var api = $acw62.useMemo(function() {
        return {
            open: open,
            close: function close(key) {
                setTaskQueue(function(queue) {
                    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(queue), [
                        {
                            type: 'close',
                            key: key
                        }
                    ]);
                });
            },
            destroy: function destroy() {
                setTaskQueue(function(queue) {
                    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(queue), [
                        {
                            type: 'destroy'
                        }
                    ]);
                });
            }
        };
    }, []);
    // ======================= Container ======================
    // React 18 should all in effect that we will check container in each render
    // Which means getContainer should be stable.
    $acw62.useEffect(function() {
        setContainer(getContainer());
    });
    // ======================== Effect ========================
    $acw62.useEffect(function() {
        // Flush task when node ready
        if (notificationsRef.current && taskQueue.length) {
            taskQueue.forEach(function(task) {
                switch(task.type){
                    case 'open':
                        notificationsRef.current.open(task.config);
                        break;
                    case 'close':
                        notificationsRef.current.close(task.key);
                        break;
                    case 'destroy':
                        notificationsRef.current.destroy();
                        break;
                }
            });
            // https://github.com/ant-design/ant-design/issues/52590
            // React `startTransition` will run once `useEffect` but many times `setState`,
            // So `setTaskQueue` with filtered array will cause infinite loop.
            // We cache the first match queue instead.
            var oriTaskQueue;
            var tgtTaskQueue;
            // React 17 will mix order of effect & setState in async
            // - open: setState[0]
            // - effect[0]
            // - open: setState[1]
            // - effect setState([]) * here will clean up [0, 1] in React 17
            setTaskQueue(function(oriQueue) {
                if (oriTaskQueue !== oriQueue || !tgtTaskQueue) {
                    oriTaskQueue = oriQueue;
                    tgtTaskQueue = oriQueue.filter(function(task) {
                        return !taskQueue.includes(task);
                    });
                }
                return tgtTaskQueue;
            });
        }
    }, [
        taskQueue
    ]);
    // ======================== Return ========================
    return [
        api,
        contextHolder
    ];
}









/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $9be8217fdbca7dca$var$useCSSVarCls = (prefixCls)=>{
    const [, , , , cssVar] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    return cssVar ? `${prefixCls}-css-var` : '';
};
var $9be8217fdbca7dca$export$2e2bcd8739ae039 = $9be8217fdbca7dca$var$useCSSVarCls;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $2adf0f811816efa6$var$zIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
var $2adf0f811816efa6$export$2e2bcd8739ae039 = $2adf0f811816efa6$var$zIndexContext;


// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $8552b358f1d5b0a4$var$CONTAINER_OFFSET = 100;
const $8552b358f1d5b0a4$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $8552b358f1d5b0a4$export$33ada7d8845f7e5 = $8552b358f1d5b0a4$var$CONTAINER_OFFSET * $8552b358f1d5b0a4$var$CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */ const $8552b358f1d5b0a4$var$CONTAINER_MAX_OFFSET_WITH_CHILDREN = $8552b358f1d5b0a4$export$33ada7d8845f7e5 + $8552b358f1d5b0a4$var$CONTAINER_OFFSET;
const $8552b358f1d5b0a4$export$1658852af8bb2a55 = {
    Modal: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Drawer: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Popover: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Popconfirm: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Tooltip: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Tour: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    FloatButton: $8552b358f1d5b0a4$var$CONTAINER_OFFSET
};
const $8552b358f1d5b0a4$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
function $8552b358f1d5b0a4$var$isContainerType(type) {
    return type in $8552b358f1d5b0a4$export$1658852af8bb2a55;
}
const $8552b358f1d5b0a4$export$3e7906d4075187a4 = (componentType, customZIndex)=>{
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $2adf0f811816efa6$export$2e2bcd8739ae039));
    const isContainer = $8552b358f1d5b0a4$var$isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $8552b358f1d5b0a4$export$1658852af8bb2a55[componentType];
        else zIndex += $8552b358f1d5b0a4$export$3f7a364c708f940b[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    return result;
};




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



// [times, realValue]
var $2712048b9c4f8450$var$SPLIT = '%';
function $2712048b9c4f8450$export$1d14e1d8187b9aad(keys) {
    return keys.join($2712048b9c4f8450$var$SPLIT);
}
var $2712048b9c4f8450$var$Entity = /*#__PURE__*/ function() {
    function Entity(instanceId) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Entity);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "instanceId", void 0);
        /** @private Internal cache map. Do not access this directly */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "cache", new Map());
        this.instanceId = instanceId;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Entity, [
        {
            key: "get",
            value: function get(keys) {
                return this.opGet($2712048b9c4f8450$export$1d14e1d8187b9aad(keys));
            }
        },
        {
            key: "opGet",
            value: function opGet(keyPathStr) {
                return this.cache.get(keyPathStr) || null;
            }
        },
        {
            key: "update",
            value: function update(keys, valueFn) {
                return this.opUpdate($2712048b9c4f8450$export$1d14e1d8187b9aad(keys), valueFn);
            }
        },
        {
            key: "opUpdate",
            value: function opUpdate(keyPathStr, valueFn) {
                var prevValue = this.cache.get(keyPathStr);
                var nextValue = valueFn(prevValue);
                if (nextValue === null) this.cache.delete(keyPathStr);
                else this.cache.set(keyPathStr, nextValue);
            }
        }
    ]);
    return Entity;
}();
var $2712048b9c4f8450$export$2e2bcd8739ae039 = $2712048b9c4f8450$var$Entity;


var $03e1c8118629977a$var$_excluded = [
    "children"
];
var $03e1c8118629977a$export$5d99297dcd5476ac = 'data-token-hash';
var $03e1c8118629977a$export$89ce1123b3c0bd9e = 'data-css-hash';
var $03e1c8118629977a$export$36f8a6c9fa24262a = 'data-cache-path';
var $03e1c8118629977a$export$4c16a0c02134a7dc = '__cssinjs_instance__';
function $03e1c8118629977a$export$cf6fa0bbcc94b912() {
    var cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== 'undefined' && document.head && document.body) {
        var styles = document.body.querySelectorAll("style[".concat($03e1c8118629977a$export$89ce1123b3c0bd9e, "]")) || [];
        var firstChild = document.head.firstChild;
        Array.from(styles).forEach(function(style) {
            style[$03e1c8118629977a$export$4c16a0c02134a7dc] = style[$03e1c8118629977a$export$4c16a0c02134a7dc] || cssinjsInstanceId;
            // Not force move if no head
            if (style[$03e1c8118629977a$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        var styleHash = {};
        Array.from(document.querySelectorAll("style[".concat($03e1c8118629977a$export$89ce1123b3c0bd9e, "]"))).forEach(function(style) {
            var hash = style.getAttribute($03e1c8118629977a$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$03e1c8118629977a$export$4c16a0c02134a7dc] === cssinjsInstanceId) {
                    var _style$parentNode;
                    (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
                }
            } else styleHash[hash] = true;
        });
    }
    return new (0, $2712048b9c4f8450$export$2e2bcd8739ae039)(cssinjsInstanceId);
}
var $03e1c8118629977a$var$StyleContext = /*#__PURE__*/ $acw62.createContext({
    hashPriority: 'low',
    cache: $03e1c8118629977a$export$cf6fa0bbcc94b912(),
    defaultCache: true
});
var $03e1c8118629977a$export$6aedb87c7b665270 = function StyleProvider(props) {
    var children = props.children, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $03e1c8118629977a$var$_excluded);
    var parentContext = $acw62.useContext($03e1c8118629977a$var$StyleContext);
    var context = (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        var mergedContext = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, parentContext);
        Object.keys(restProps).forEach(function(key) {
            var value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        var cache = restProps.cache;
        mergedContext.cache = mergedContext.cache || $03e1c8118629977a$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], function(prev, next) {
        return !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prev[0], next[0], true) || !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prev[1], next[1], true);
    });
    return /*#__PURE__*/ $acw62.createElement($03e1c8118629977a$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $03e1c8118629977a$export$2e2bcd8739ae039 = $03e1c8118629977a$var$StyleContext;


















var $be019f0d79f62d2a$var$AbstractCalculator = /*#__PURE__*/ (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $be019f0d79f62d2a$export$2e2bcd8739ae039 = $be019f0d79f62d2a$var$AbstractCalculator;


var $1b1f5f0393cdb55a$var$CALC_UNIT = 'CALC_UNIT';
var $1b1f5f0393cdb55a$var$regexp = new RegExp($1b1f5f0393cdb55a$var$CALC_UNIT, 'g');
function $1b1f5f0393cdb55a$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($1b1f5f0393cdb55a$var$CALC_UNIT);
    return value;
}
var $1b1f5f0393cdb55a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "result", '');
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $1b1f5f0393cdb55a$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($1b1f5f0393cdb55a$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($1b1f5f0393cdb55a$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($1b1f5f0393cdb55a$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $be019f0d79f62d2a$export$2e2bcd8739ae039));









var $ec51285fbecc8be6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $be019f0d79f62d2a$export$2e2bcd8739ae039));


var $d2271f4897bc4423$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $1b1f5f0393cdb55a$export$2e2bcd8739ae039) : (0, $ec51285fbecc8be6$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $d2271f4897bc4423$export$2e2bcd8739ae039 = $d2271f4897bc4423$var$genCalc;






function $9e86e9c371e14455$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(var i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
var $9e86e9c371e14455$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeCache() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ThemeCache);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "cache", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "keys", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "cacheCallTimes", void 0);
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ThemeCache, [
        {
            key: "size",
            value: function size() {
                return this.keys.length;
            }
        },
        {
            key: "internalGet",
            value: function internalGet(derivativeOption) {
                var _cache2, _cache3;
                var updateCallTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var cache = {
                    map: this.cache
                };
                derivativeOption.forEach(function(derivative) {
                    if (!cache) cache = undefined;
                    else {
                        var _cache;
                        cache = (_cache = cache) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative);
                    }
                });
                if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
                return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
            }
        },
        {
            key: "get",
            value: function get(derivativeOption) {
                var _this$internalGet;
                return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
            }
        },
        {
            key: "has",
            value: function has(derivativeOption) {
                return !!this.internalGet(derivativeOption);
            }
        },
        {
            key: "set",
            value: function set(derivativeOption, value) {
                var _this = this;
                // New cache
                if (!this.has(derivativeOption)) {
                    if (this.size() + 1 > ThemeCache.MAX_CACHE_SIZE + ThemeCache.MAX_CACHE_OFFSET) {
                        var _this$keys$reduce = this.keys.reduce(function(result, key) {
                            var _result = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(result, 2), callTimes = _result[1];
                            if (_this.internalGet(key)[1] < callTimes) return [
                                key,
                                _this.internalGet(key)[1]
                            ];
                            return result;
                        }, [
                            this.keys[0],
                            this.cacheCallTimes
                        ]), _this$keys$reduce2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
                        this.delete(targetKey);
                    }
                    this.keys.push(derivativeOption);
                }
                var cache = this.cache;
                derivativeOption.forEach(function(derivative, index) {
                    if (index === derivativeOption.length - 1) cache.set(derivative, {
                        value: [
                            value,
                            _this.cacheCallTimes++
                        ]
                    });
                    else {
                        var cacheValue = cache.get(derivative);
                        if (!cacheValue) cache.set(derivative, {
                            map: new Map()
                        });
                        else if (!cacheValue.map) cacheValue.map = new Map();
                        cache = cache.get(derivative).map;
                    }
                });
            }
        },
        {
            key: "deleteByPath",
            value: function deleteByPath(currentCache, derivatives) {
                var cache = currentCache.get(derivatives[0]);
                if (derivatives.length === 1) {
                    var _cache$value;
                    if (!cache.map) currentCache.delete(derivatives[0]);
                    else currentCache.set(derivatives[0], {
                        map: cache.map
                    });
                    return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
                }
                var result = this.deleteByPath(cache.map, derivatives.slice(1));
                if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
                return result;
            }
        },
        {
            key: "delete",
            value: function _delete(derivativeOption) {
                // If cache exists
                if (this.has(derivativeOption)) {
                    this.keys = this.keys.filter(function(item) {
                        return !$9e86e9c371e14455$export$dd65e95e99ed0739(item, derivativeOption);
                    });
                    return this.deleteByPath(this.cache, derivativeOption);
                }
                return undefined;
            }
        }
    ]);
    return ThemeCache;
}();
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($9e86e9c371e14455$export$2e2bcd8739ae039, "MAX_CACHE_SIZE", 20);
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($9e86e9c371e14455$export$2e2bcd8739ae039, "MAX_CACHE_OFFSET", 5);






var $5170fd983f68444c$var$uuid = 0;
/**
 * Theme with algorithms to derive tokens from design tokens.
 * Use `createTheme` first which will help to manage the theme instance cache.
 */ var $5170fd983f68444c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Theme(derivatives) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Theme);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "derivatives", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "id", void 0);
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $5170fd983f68444c$var$uuid;
        if (derivatives.length === 0) (0, $05a5f2c645683a81$export$491112666e282270)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
        $5170fd983f68444c$var$uuid += 1;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Theme, [
        {
            key: "getDerivativeToken",
            value: function getDerivativeToken(token) {
                return this.derivatives.reduce(function(result, derivative) {
                    return derivative(token, result);
                }, undefined);
            }
        }
    ]);
    return Theme;
}();


var $fb1ee33ddb4489b5$var$cacheThemes = new (0, $9e86e9c371e14455$export$2e2bcd8739ae039)();
function $fb1ee33ddb4489b5$export$2e2bcd8739ae039(derivatives) {
    var derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$fb1ee33ddb4489b5$var$cacheThemes.has(derivativeArr)) $fb1ee33ddb4489b5$var$cacheThemes.set(derivativeArr, new (0, $5170fd983f68444c$export$2e2bcd8739ae039)(derivativeArr));
    // Get theme from cache and return
    return $fb1ee33ddb4489b5$var$cacheThemes.get(derivativeArr);
}






// Create a cache for memo concat
var $4812ae2d3005362e$var$resultCache = new WeakMap();
var $4812ae2d3005362e$var$RESULT_VALUE = {};
function $4812ae2d3005362e$export$6aabcc1951563d93(callback, deps) {
    var current = $4812ae2d3005362e$var$resultCache;
    for(var i = 0; i < deps.length; i += 1){
        var dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($4812ae2d3005362e$var$RESULT_VALUE)) current.set($4812ae2d3005362e$var$RESULT_VALUE, callback());
    return current.get($4812ae2d3005362e$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
var $4812ae2d3005362e$var$flattenTokenCache = new WeakMap();
function $4812ae2d3005362e$export$597374558a261efc(token) {
    var hashed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var str = $4812ae2d3005362e$var$flattenTokenCache.get(token) || '';
    if (!str) {
        Object.keys(token).forEach(function(key) {
            var value = token[key];
            str += key;
            if (value instanceof (0, $5170fd983f68444c$export$2e2bcd8739ae039)) str += value.id;
            else if (value && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object') str += $4812ae2d3005362e$export$597374558a261efc(value, hashed);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        if (hashed) str = (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(str);
        // Put in cache
        $4812ae2d3005362e$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $4812ae2d3005362e$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)("".concat(salt, "_").concat($4812ae2d3005362e$export$597374558a261efc(token, true)));
}
var $4812ae2d3005362e$var$randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, '');
// Magic `content` for detect selector support
var $4812ae2d3005362e$var$checkContent = '_bAmBoO_';
function $4812ae2d3005362e$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
        var _getComputedStyle$con, _ele$parentNode;
        (0, $3a22468320d7d808$export$4d99a2890bb989f0)(styleStr, $4812ae2d3005362e$var$randomSelectorKey);
        var _ele = document.createElement('div');
        _ele.style.position = 'fixed';
        _ele.style.left = '0';
        _ele.style.top = '0';
        handleElement === null || handleElement === void 0 || handleElement(_ele);
        document.body.appendChild(_ele);
        var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes($4812ae2d3005362e$var$checkContent);
        (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
        (0, $3a22468320d7d808$export$2232e336aecaa80a)($4812ae2d3005362e$var$randomSelectorKey);
        return support;
    }
    return false;
}
var $4812ae2d3005362e$var$canLayer = undefined;
function $4812ae2d3005362e$export$ac8d3fd9840e20dd() {
    if ($4812ae2d3005362e$var$canLayer === undefined) $4812ae2d3005362e$var$canLayer = $4812ae2d3005362e$var$supportSelector("@layer ".concat($4812ae2d3005362e$var$randomSelectorKey, " { .").concat($4812ae2d3005362e$var$randomSelectorKey, " { content: \"").concat($4812ae2d3005362e$var$checkContent, "\"!important; } }"), function(ele) {
        ele.className = $4812ae2d3005362e$var$randomSelectorKey;
    });
    return $4812ae2d3005362e$var$canLayer;
}
var $4812ae2d3005362e$var$canWhere = undefined;
function $4812ae2d3005362e$export$f51d3b8ac4ac9ed1() {
    if ($4812ae2d3005362e$var$canWhere === undefined) $4812ae2d3005362e$var$canWhere = $4812ae2d3005362e$var$supportSelector(":where(.".concat($4812ae2d3005362e$var$randomSelectorKey, ") { content: \"").concat($4812ae2d3005362e$var$checkContent, "\"!important; }"), function(ele) {
        ele.className = $4812ae2d3005362e$var$randomSelectorKey;
    });
    return $4812ae2d3005362e$var$canWhere;
}
var $4812ae2d3005362e$var$canLogic = undefined;
function $4812ae2d3005362e$export$64a912f57d5de48e() {
    if ($4812ae2d3005362e$var$canLogic === undefined) $4812ae2d3005362e$var$canLogic = $4812ae2d3005362e$var$supportSelector(".".concat($4812ae2d3005362e$var$randomSelectorKey, " { inset-block: 93px !important; }"), function(ele) {
        ele.className = $4812ae2d3005362e$var$randomSelectorKey;
    }, function(ele) {
        return getComputedStyle(ele).bottom === '93px';
    });
    return $4812ae2d3005362e$var$canLogic;
}
var $4812ae2d3005362e$export$9542afab8c2a5f48 = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)();
function $4812ae2d3005362e$export$523c0b569236b342(num) {
    if (typeof num === 'number') return "".concat(num, "px");
    return num;
}
function $4812ae2d3005362e$export$71c98ec84f0481d3(style, tokenKey, styleId) {
    var customizeAttrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (plain) return style;
    var attrs = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, customizeAttrs), {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $03e1c8118629977a$export$5d99297dcd5476ac), tokenKey), (0, $03e1c8118629977a$export$89ce1123b3c0bd9e), styleId));
    var attrStr = Object.keys(attrs).map(function(attr) {
        var val = attrs[attr];
        return val ? "".concat(attr, "=\"").concat(val, "\"") : null;
    }).filter(function(v) {
        return v;
    }).join(' ');
    return "<style ".concat(attrStr, ">").concat(style, "</style>");
}



var $a0db7e13ef2c68c5$export$309b3b095f0c7662 = function token2CSSVar(token) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return "--".concat(prefix ? "".concat(prefix, "-") : '').concat(token).replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
var $a0db7e13ef2c68c5$export$a27ef1ee9bbc757e = function serializeCSSVar(cssVars, hashId, options) {
    if (!Object.keys(cssVars).length) return '';
    return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : '', "{").concat(Object.entries(cssVars).map(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "".concat(key, ":").concat(value, ";");
    }).join(''), "}");
};
var $a0db7e13ef2c68c5$export$67858afe85bce49f = function transformToken(token, themeKey, config) {
    var cssVars = {};
    var result = {};
    Object.entries(token).forEach(function(_ref3) {
        var _config$preserve, _config$ignore;
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], value = _ref4[1];
        if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) result[key] = value;
        else if ((typeof value === 'string' || typeof value === 'number') && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
            var _config$unitless;
            var cssVar = $a0db7e13ef2c68c5$export$309b3b095f0c7662(key, config === null || config === void 0 ? void 0 : config.prefix);
            cssVars[cssVar] = typeof value === 'number' && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
            result[key] = "var(".concat(cssVar, ")");
        }
    });
    return [
        result,
        $a0db7e13ef2c68c5$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config === null || config === void 0 ? void 0 : config.scope
        })
    ];
};





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
// We need fully clone React function here
// to avoid webpack warning React 17 do not export `useId`
var $7193efec6de2c7d4$var$fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $acw62);
var $7193efec6de2c7d4$var$useInsertionEffect = $7193efec6de2c7d4$var$fullClone.useInsertionEffect;
/**
 * Polyfill `useInsertionEffect` for React < 18
 * @param renderEffect will be executed in `useMemo`, and do not have callback
 * @param effect will be executed in `useLayoutEffect`
 * @param deps
 */ var $7193efec6de2c7d4$var$useInsertionEffectPolyfill = function useInsertionEffectPolyfill(renderEffect, effect, deps) {
    $acw62.useMemo(renderEffect, deps);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        return effect(true);
    }, deps);
};
/**
 * Compatible `useInsertionEffect`
 * will use `useInsertionEffect` if React version >= 18,
 * otherwise use `useInsertionEffectPolyfill`.
 */ var $7193efec6de2c7d4$var$useCompatibleInsertionEffect = $7193efec6de2c7d4$var$useInsertionEffect ? function(renderEffect, effect, deps) {
    return $7193efec6de2c7d4$var$useInsertionEffect(function() {
        renderEffect();
        return effect();
    }, deps);
} : $7193efec6de2c7d4$var$useInsertionEffectPolyfill;
var $7193efec6de2c7d4$export$2e2bcd8739ae039 = $7193efec6de2c7d4$var$useCompatibleInsertionEffect;





var $acw62 = parcelRequire("acw62");
var $a1e2ae8cce797135$var$fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $acw62);
var $a1e2ae8cce797135$var$useInsertionEffect = $a1e2ae8cce797135$var$fullClone.useInsertionEffect;
// DO NOT register functions in useEffect cleanup function, or functions that registered will never be called.
var $a1e2ae8cce797135$var$useCleanupRegister = function useCleanupRegister(deps) {
    var effectCleanups = [];
    var cleanupFlag = false;
    function register(fn) {
        if (cleanupFlag) return;
        effectCleanups.push(fn);
    }
    $acw62.useEffect(function() {
        // Compatible with strict mode
        cleanupFlag = false;
        return function() {
            cleanupFlag = true;
            if (effectCleanups.length) effectCleanups.forEach(function(fn) {
                return fn();
            });
        };
    }, deps);
    return register;
};
var $a1e2ae8cce797135$var$useRun = function useRun() {
    return function(fn) {
        fn();
    };
};
// Only enable register in React 18
var $a1e2ae8cce797135$var$useEffectCleanupRegister = typeof $a1e2ae8cce797135$var$useInsertionEffect !== 'undefined' ? $a1e2ae8cce797135$var$useCleanupRegister : $a1e2ae8cce797135$var$useRun;
var $a1e2ae8cce797135$export$2e2bcd8739ae039 = $a1e2ae8cce797135$var$useEffectCleanupRegister;


function $48816a3df9c3d2d0$var$useProdHMR() {
    return false;
}
var $48816a3df9c3d2d0$var$webpackHMR = false;
function $48816a3df9c3d2d0$var$useDevHMR() {
    return $48816a3df9c3d2d0$var$webpackHMR;
}
var $48816a3df9c3d2d0$export$2e2bcd8739ae039 = $48816a3df9c3d2d0$var$useProdHMR;
var $48816a3df9c3d2d0$var$win, $48816a3df9c3d2d0$var$originWebpackHotUpdate;


function $ada7bd6df4047ef6$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    var _React$useContext = $acw62.useContext((0, $03e1c8118629977a$export$2e2bcd8739ae039)), globalCache = _React$useContext.cache;
    var fullPath = [
        prefix
    ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keyPath));
    var fullPathStr = (0, $2712048b9c4f8450$export$1d14e1d8187b9aad)(fullPath);
    var register = (0, $a1e2ae8cce797135$export$2e2bcd8739ae039)([
        fullPathStr
    ]);
    var HMRUpdate = (0, $48816a3df9c3d2d0$export$2e2bcd8739ae039)();
    var buildCache = function buildCache(updater) {
        globalCache.opUpdate(fullPathStr, function(prevCache) {
            var _ref = prevCache || [
                undefined,
                undefined
            ], _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache = _ref2[1];
            // HMR should always ignore cache since developer may change it
            var tmpCache = cache;
            var mergedCache = tmpCache || cacheFn();
            var data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $acw62.useMemo(function() {
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    var cacheEntity = globalCache.opGet(fullPathStr);
    var cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $7193efec6de2c7d4$export$2e2bcd8739ae039)(function() {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
    }, function(polyfill) {
        // It's bad to call build again in effect.
        // But we have to do this since StrictMode will call effect twice
        // which will clear cache on the first time.
        buildCache(function(_ref3) {
            var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), times = _ref4[0], cache = _ref4[1];
            if (polyfill && times === 0) onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
            return [
                times + 1,
                cache
            ];
        });
        return function() {
            globalCache.opUpdate(fullPathStr, function(prevCache) {
                var _ref5 = prevCache || [], _ref6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache = _ref6[1];
                var nextCount = times - 1;
                if (nextCount === 0) {
                    // Always remove styles in useEffect callback
                    register(function() {
                        // With polyfill, registered callback will always be called synchronously
                        // But without polyfill, it will be called in effect clean up,
                        // And by that time this cache is cleaned up.
                        if (polyfill || !globalCache.opGet(fullPathStr)) onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
                    });
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}


var $bcdbf65ffca51ddb$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
var $bcdbf65ffca51ddb$var$hashPrefix = 'css';
var $bcdbf65ffca51ddb$var$tokenKeys = new Map();
function $bcdbf65ffca51ddb$var$recordCleanToken(tokenKey) {
    $bcdbf65ffca51ddb$var$tokenKeys.set(tokenKey, ($bcdbf65ffca51ddb$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $bcdbf65ffca51ddb$var$removeStyleTags(key, instanceId) {
    if (typeof document !== 'undefined') {
        var styles = document.querySelectorAll("style[".concat((0, $03e1c8118629977a$export$5d99297dcd5476ac), "=\"").concat(key, "\"]"));
        styles.forEach(function(style) {
            if (style[0, $03e1c8118629977a$export$4c16a0c02134a7dc] === instanceId) {
                var _style$parentNode;
                (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
            }
        });
    }
}
var $bcdbf65ffca51ddb$var$TOKEN_THRESHOLD = 0;
// Remove will check current keys first
function $bcdbf65ffca51ddb$var$cleanTokenStyle(tokenKey, instanceId) {
    $bcdbf65ffca51ddb$var$tokenKeys.set(tokenKey, ($bcdbf65ffca51ddb$var$tokenKeys.get(tokenKey) || 0) - 1);
    var tokenKeyList = Array.from($bcdbf65ffca51ddb$var$tokenKeys.keys());
    var cleanableKeyList = tokenKeyList.filter(function(key) {
        var count = $bcdbf65ffca51ddb$var$tokenKeys.get(key) || 0;
        return count <= 0;
    });
    // Should keep tokens under threshold for not to insert style too often
    if (tokenKeyList.length - cleanableKeyList.length > $bcdbf65ffca51ddb$var$TOKEN_THRESHOLD) cleanableKeyList.forEach(function(key) {
        $bcdbf65ffca51ddb$var$removeStyleTags(key, instanceId);
        $bcdbf65ffca51ddb$var$tokenKeys.delete(key);
    });
}
var $bcdbf65ffca51ddb$export$18602cb46ae80b62 = function getComputedToken(originToken, overrideToken, theme, format) {
    var derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    var mergedDerivativeToken = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, derivativeToken), overrideToken);
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
var $bcdbf65ffca51ddb$export$270fba097347f4fa = 'token';
function $bcdbf65ffca51ddb$export$2e2bcd8739ae039(theme, tokens) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _useContext = (0, $acw62.useContext)((0, $03e1c8118629977a$export$2e2bcd8739ae039)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var _option$salt = option.salt, salt = _option$salt === void 0 ? '' : _option$salt, _option$override = option.override, override = _option$override === void 0 ? $bcdbf65ffca51ddb$var$EMPTY_OVERRIDE : _option$override, formatToken = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
    // Basic - We do basic cache here
    var mergedToken = (0, $4812ae2d3005362e$export$6aabcc1951563d93)(function() {
        return Object.assign.apply(Object, [
            {}
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(tokens)));
    }, tokens);
    var tokenStr = (0, $4812ae2d3005362e$export$597374558a261efc)(mergedToken);
    var overrideTokenStr = (0, $4812ae2d3005362e$export$597374558a261efc)(override);
    var cssVarStr = cssVar ? (0, $4812ae2d3005362e$export$597374558a261efc)(cssVar) : '';
    var cachedToken = (0, $ada7bd6df4047ef6$export$2e2bcd8739ae039)($bcdbf65ffca51ddb$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], function() {
        var _cssVar$key;
        var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $bcdbf65ffca51ddb$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        // Replace token value with css variables
        var actualToken = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedDerivativeToken);
        var cssVarsStr = '';
        if (!!cssVar) {
            var _transformToken = (0, $a0db7e13ef2c68c5$export$67858afe85bce49f)(mergedDerivativeToken, cssVar.key, {
                prefix: cssVar.prefix,
                ignore: cssVar.ignore,
                unitless: cssVar.unitless,
                preserve: cssVar.preserve
            });
            var _transformToken2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_transformToken, 2);
            mergedDerivativeToken = _transformToken2[0];
            cssVarsStr = _transformToken2[1];
        }
        // Optimize for `useStyleRegister` performance
        var tokenKey = (0, $4812ae2d3005362e$export$6c82d0ebe8f2ea2c)(mergedDerivativeToken, salt);
        mergedDerivativeToken._tokenKey = tokenKey;
        actualToken._tokenKey = (0, $4812ae2d3005362e$export$6c82d0ebe8f2ea2c)(actualToken, salt);
        var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
        mergedDerivativeToken._themeKey = themeKey;
        $bcdbf65ffca51ddb$var$recordCleanToken(themeKey);
        var hashId = "".concat($bcdbf65ffca51ddb$var$hashPrefix, "-").concat((0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(tokenKey));
        mergedDerivativeToken._hashId = hashId; // Not used
        return [
            mergedDerivativeToken,
            hashId,
            actualToken,
            cssVarsStr,
            (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ''
        ];
    }, function(cache) {
        // Remove token will remove all related style
        $bcdbf65ffca51ddb$var$cleanTokenStyle(cache[0]._themeKey, instanceId);
    }, function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 4), token = _ref2[0], cssVarsStr = _ref2[3];
        if (cssVar && cssVarsStr) {
            var style = (0, $3a22468320d7d808$export$4d99a2890bb989f0)(cssVarsStr, (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)("css-variables-".concat(token._themeKey)), {
                mark: (0, $03e1c8118629977a$export$89ce1123b3c0bd9e),
                prepend: 'queue',
                attachTo: container,
                priority: -999
            });
            style[0, $03e1c8118629977a$export$4c16a0c02134a7dc] = instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $03e1c8118629977a$export$5d99297dcd5476ac), token._themeKey);
        }
    });
    return cachedToken;
}
var $bcdbf65ffca51ddb$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cache, 5), realToken = _cache[2], styleStr = _cache[3], cssVarKey = _cache[4];
    var _ref3 = options || {}, plain = _ref3.plain;
    if (!styleStr) return null;
    var styleId = realToken._tokenKey;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    var styleText = (0, $4812ae2d3005362e$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};






var $acw62 = parcelRequire("acw62");













var $acw62 = parcelRequire("acw62");

var $569a2951990997db$export$71ad59f2e432cfe8 = '-ms-';
var $569a2951990997db$export$2c0f367103c8d01c = '-moz-';
var $569a2951990997db$export$39dfd62a25e0fe93 = '-webkit-';
var $569a2951990997db$export$a29989082612d0d9 = 'comm';
var $569a2951990997db$export$aa3a2e812ca8570d = 'rule';
var $569a2951990997db$export$527d108ccf083c2b = 'decl';
var $569a2951990997db$export$d3d35020fa5b54f0 = '@page';
var $569a2951990997db$export$500415a86c544f73 = '@media';
var $569a2951990997db$export$a763edbf796b780a = '@import';
var $569a2951990997db$export$2790aeb8b4e5c826 = '@charset';
var $569a2951990997db$export$1cc683e23b84b133 = '@viewport';
var $569a2951990997db$export$9447a5efea57e862 = '@supports';
var $569a2951990997db$export$ef011b4e114b1fba = '@document';
var $569a2951990997db$export$6aad947bda0f3f46 = '@namespace';
var $569a2951990997db$export$b44a8529a35fcb60 = '@keyframes';
var $569a2951990997db$export$2c16de31893252e6 = '@font-face';
var $569a2951990997db$export$3d846dd52e150c6f = '@counter-style';
var $569a2951990997db$export$22314bfbb57653fe = '@font-feature-values';
var $569a2951990997db$export$d773506282b3cfe6 = '@layer';
var $569a2951990997db$export$1c5a554c78c0cd12 = '@scope';


/**
 * @param {number}
 * @return {number}
 */ var $884bb82e02bc8b18$export$2335f513bbd82c6d = Math.abs;
var $884bb82e02bc8b18$export$6788812c4e6611e6 = String.fromCharCode;
var $884bb82e02bc8b18$export$e6e34fd1f2686227 = Object.assign;
function $884bb82e02bc8b18$export$d6af199866bfb566(value, length) {
    return $884bb82e02bc8b18$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $884bb82e02bc8b18$export$a9db5e087081082d(value, 0)) << 2 ^ $884bb82e02bc8b18$export$a9db5e087081082d(value, 1)) << 2 ^ $884bb82e02bc8b18$export$a9db5e087081082d(value, 2)) << 2 ^ $884bb82e02bc8b18$export$a9db5e087081082d(value, 3) : 0;
}
function $884bb82e02bc8b18$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $884bb82e02bc8b18$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $884bb82e02bc8b18$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $884bb82e02bc8b18$export$f8e21b1e77979a08(value, search, position) {
    return value.indexOf(search, position);
}
function $884bb82e02bc8b18$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $884bb82e02bc8b18$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $884bb82e02bc8b18$export$36776f635604f274(value) {
    return value.length;
}
function $884bb82e02bc8b18$export$f9084667e487ed46(value) {
    return value.length;
}
function $884bb82e02bc8b18$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $884bb82e02bc8b18$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $884bb82e02bc8b18$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$884bb82e02bc8b18$export$4659b591c19bdf3d(value, pattern);
    });
}



var $4ecff1e62642f100$export$53f1d5ea8de3d7c = 1;
var $4ecff1e62642f100$export$4e0c71f277ca26b3 = 1;
var $4ecff1e62642f100$export$f24224f1c91d8156 = 0;
var $4ecff1e62642f100$export$5880b8b5730aff45 = 0;
var $4ecff1e62642f100$export$c0306caf338ac095 = 0;
var $4ecff1e62642f100$export$30a86d91af8ff6e6 = '';
function $4ecff1e62642f100$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $4ecff1e62642f100$export$53f1d5ea8de3d7c,
        column: $4ecff1e62642f100$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $4ecff1e62642f100$export$784d13d8ee351f07(root, props) {
    return (0, $884bb82e02bc8b18$export$e6e34fd1f2686227)($4ecff1e62642f100$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $4ecff1e62642f100$export$590e8b2c435046d9(root) {
    while(root.root)root = $4ecff1e62642f100$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $884bb82e02bc8b18$export$10d8903dec122b9d)(root, root.siblings);
}
function $4ecff1e62642f100$export$eba6f6f03b0a92e7() {
    return $4ecff1e62642f100$export$c0306caf338ac095;
}
function $4ecff1e62642f100$export$232faf9add678146() {
    $4ecff1e62642f100$export$c0306caf338ac095 = $4ecff1e62642f100$export$5880b8b5730aff45 > 0 ? (0, $884bb82e02bc8b18$export$a9db5e087081082d)($4ecff1e62642f100$export$30a86d91af8ff6e6, --$4ecff1e62642f100$export$5880b8b5730aff45) : 0;
    if ($4ecff1e62642f100$export$4e0c71f277ca26b3--, $4ecff1e62642f100$export$c0306caf338ac095 === 10) $4ecff1e62642f100$export$4e0c71f277ca26b3 = 1, $4ecff1e62642f100$export$53f1d5ea8de3d7c--;
    return $4ecff1e62642f100$export$c0306caf338ac095;
}
function $4ecff1e62642f100$export$48cfd1e771a65c4f() {
    $4ecff1e62642f100$export$c0306caf338ac095 = $4ecff1e62642f100$export$5880b8b5730aff45 < $4ecff1e62642f100$export$f24224f1c91d8156 ? (0, $884bb82e02bc8b18$export$a9db5e087081082d)($4ecff1e62642f100$export$30a86d91af8ff6e6, $4ecff1e62642f100$export$5880b8b5730aff45++) : 0;
    if ($4ecff1e62642f100$export$4e0c71f277ca26b3++, $4ecff1e62642f100$export$c0306caf338ac095 === 10) $4ecff1e62642f100$export$4e0c71f277ca26b3 = 1, $4ecff1e62642f100$export$53f1d5ea8de3d7c++;
    return $4ecff1e62642f100$export$c0306caf338ac095;
}
function $4ecff1e62642f100$export$4d3fb11e950abb9e() {
    return (0, $884bb82e02bc8b18$export$a9db5e087081082d)($4ecff1e62642f100$export$30a86d91af8ff6e6, $4ecff1e62642f100$export$5880b8b5730aff45);
}
function $4ecff1e62642f100$export$e88cb2efb12ae807() {
    return $4ecff1e62642f100$export$5880b8b5730aff45;
}
function $4ecff1e62642f100$export$58adb3bec8346d0f(begin, end) {
    return (0, $884bb82e02bc8b18$export$2f35ab04d2335697)($4ecff1e62642f100$export$30a86d91af8ff6e6, begin, end);
}
function $4ecff1e62642f100$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $4ecff1e62642f100$export$2de70f21292aac9e(value) {
    return $4ecff1e62642f100$export$53f1d5ea8de3d7c = $4ecff1e62642f100$export$4e0c71f277ca26b3 = 1, $4ecff1e62642f100$export$f24224f1c91d8156 = (0, $884bb82e02bc8b18$export$36776f635604f274)($4ecff1e62642f100$export$30a86d91af8ff6e6 = value), $4ecff1e62642f100$export$5880b8b5730aff45 = 0, [];
}
function $4ecff1e62642f100$export$45918ac1574455b1(value) {
    return $4ecff1e62642f100$export$30a86d91af8ff6e6 = '', value;
}
function $4ecff1e62642f100$export$410ac95b9ec204b8(type) {
    return (0, $884bb82e02bc8b18$export$87c2784dc9fc4ab)($4ecff1e62642f100$export$58adb3bec8346d0f($4ecff1e62642f100$export$5880b8b5730aff45 - 1, $4ecff1e62642f100$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $4ecff1e62642f100$export$660b2ee2d4fb4eff(value) {
    return $4ecff1e62642f100$export$45918ac1574455b1($4ecff1e62642f100$export$5f8c09e3ae6f64e1($4ecff1e62642f100$export$2de70f21292aac9e(value)));
}
function $4ecff1e62642f100$export$7af1228ff777d175(type) {
    while($4ecff1e62642f100$export$c0306caf338ac095 = $4ecff1e62642f100$export$4d3fb11e950abb9e())if ($4ecff1e62642f100$export$c0306caf338ac095 < 33) $4ecff1e62642f100$export$48cfd1e771a65c4f();
    else break;
    return $4ecff1e62642f100$export$9e1725a4cfeada27(type) > 2 || $4ecff1e62642f100$export$9e1725a4cfeada27($4ecff1e62642f100$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $4ecff1e62642f100$export$5f8c09e3ae6f64e1(children) {
    while($4ecff1e62642f100$export$48cfd1e771a65c4f())switch($4ecff1e62642f100$export$9e1725a4cfeada27($4ecff1e62642f100$export$c0306caf338ac095)){
        case 0:
            (0, $884bb82e02bc8b18$export$10d8903dec122b9d)($4ecff1e62642f100$export$c2ab62c7bf24634($4ecff1e62642f100$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $884bb82e02bc8b18$export$10d8903dec122b9d)($4ecff1e62642f100$export$410ac95b9ec204b8($4ecff1e62642f100$export$c0306caf338ac095), children);
            break;
        default:
            (0, $884bb82e02bc8b18$export$10d8903dec122b9d)((0, $884bb82e02bc8b18$export$6788812c4e6611e6)($4ecff1e62642f100$export$c0306caf338ac095), children);
    }
    return children;
}
function $4ecff1e62642f100$export$955ba06d119e085e(index, count) {
    while(--count && $4ecff1e62642f100$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($4ecff1e62642f100$export$c0306caf338ac095 < 48 || $4ecff1e62642f100$export$c0306caf338ac095 > 102 || $4ecff1e62642f100$export$c0306caf338ac095 > 57 && $4ecff1e62642f100$export$c0306caf338ac095 < 65 || $4ecff1e62642f100$export$c0306caf338ac095 > 70 && $4ecff1e62642f100$export$c0306caf338ac095 < 97) break;
    return $4ecff1e62642f100$export$58adb3bec8346d0f(index, $4ecff1e62642f100$export$e88cb2efb12ae807() + (count < 6 && $4ecff1e62642f100$export$4d3fb11e950abb9e() == 32 && $4ecff1e62642f100$export$48cfd1e771a65c4f() == 32));
}
function $4ecff1e62642f100$export$c889f2fcc19dbf12(type) {
    while($4ecff1e62642f100$export$48cfd1e771a65c4f())switch($4ecff1e62642f100$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $4ecff1e62642f100$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $4ecff1e62642f100$export$c889f2fcc19dbf12($4ecff1e62642f100$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $4ecff1e62642f100$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $4ecff1e62642f100$export$48cfd1e771a65c4f();
            break;
    }
    return $4ecff1e62642f100$export$5880b8b5730aff45;
}
function $4ecff1e62642f100$export$4254d4e2b3745c4c(type, index) {
    while($4ecff1e62642f100$export$48cfd1e771a65c4f())// //
    if (type + $4ecff1e62642f100$export$c0306caf338ac095 === 57) break;
    else if (type + $4ecff1e62642f100$export$c0306caf338ac095 === 84 && $4ecff1e62642f100$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $4ecff1e62642f100$export$58adb3bec8346d0f(index, $4ecff1e62642f100$export$5880b8b5730aff45 - 1) + '*' + (0, $884bb82e02bc8b18$export$6788812c4e6611e6)(type === 47 ? type : $4ecff1e62642f100$export$48cfd1e771a65c4f());
}
function $4ecff1e62642f100$export$c2ab62c7bf24634(index) {
    while(!$4ecff1e62642f100$export$9e1725a4cfeada27($4ecff1e62642f100$export$4d3fb11e950abb9e()))$4ecff1e62642f100$export$48cfd1e771a65c4f();
    return $4ecff1e62642f100$export$58adb3bec8346d0f(index, $4ecff1e62642f100$export$5880b8b5730aff45);
}


function $893aa91c085274b1$export$ef7acd7185315e22(value) {
    return (0, $4ecff1e62642f100$export$45918ac1574455b1)($893aa91c085274b1$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $4ecff1e62642f100$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $893aa91c085274b1$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $4ecff1e62642f100$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $884bb82e02bc8b18$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $884bb82e02bc8b18$export$f8e21b1e77979a08)(characters += (0, $884bb82e02bc8b18$export$77ad94ebf1c2b9ed)((0, $4ecff1e62642f100$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f', (0, $884bb82e02bc8b18$export$2335f513bbd82c6d)(index ? points[index - 1] : 0)) != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $4ecff1e62642f100$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $4ecff1e62642f100$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $4ecff1e62642f100$export$955ba06d119e085e)((0, $4ecff1e62642f100$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $4ecff1e62642f100$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $884bb82e02bc8b18$export$10d8903dec122b9d)($893aa91c085274b1$export$4a34f930e789283c((0, $4ecff1e62642f100$export$4254d4e2b3745c4c)((0, $4ecff1e62642f100$export$48cfd1e771a65c4f)(), (0, $4ecff1e62642f100$export$e88cb2efb12ae807)()), root, parent, declarations), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $884bb82e02bc8b18$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $884bb82e02bc8b18$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $884bb82e02bc8b18$export$36776f635604f274)(characters) - length) (0, $884bb82e02bc8b18$export$10d8903dec122b9d)(property > 32 ? $893aa91c085274b1$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $893aa91c085274b1$export$f8483753829ec8f3((0, $884bb82e02bc8b18$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $884bb82e02bc8b18$export$10d8903dec122b9d)(reference = $893aa91c085274b1$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $893aa91c085274b1$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $884bb82e02bc8b18$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $893aa91c085274b1$export$98e6a39c04603d36(value, reference, reference, rule && (0, $884bb82e02bc8b18$export$10d8903dec122b9d)($893aa91c085274b1$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $893aa91c085274b1$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $884bb82e02bc8b18$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $4ecff1e62642f100$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $884bb82e02bc8b18$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $884bb82e02bc8b18$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $4ecff1e62642f100$export$4d3fb11e950abb9e)() === 45) characters += (0, $4ecff1e62642f100$export$410ac95b9ec204b8)((0, $4ecff1e62642f100$export$48cfd1e771a65c4f)());
                    atrule = (0, $4ecff1e62642f100$export$4d3fb11e950abb9e)(), offset = length = (0, $884bb82e02bc8b18$export$36776f635604f274)(type = characters += (0, $4ecff1e62642f100$export$c2ab62c7bf24634)((0, $4ecff1e62642f100$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $884bb82e02bc8b18$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $893aa91c085274b1$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $884bb82e02bc8b18$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $884bb82e02bc8b18$export$2f35ab04d2335697)(value, post + 1, post = (0, $884bb82e02bc8b18$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $884bb82e02bc8b18$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $884bb82e02bc8b18$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $4ecff1e62642f100$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $569a2951990997db$export$aa3a2e812ca8570d) : type, props, children, length, siblings);
}
function $893aa91c085274b1$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $4ecff1e62642f100$export$35059013cd4a06db)(value, root, parent, (0, $569a2951990997db$export$a29989082612d0d9), (0, $884bb82e02bc8b18$export$6788812c4e6611e6)((0, $4ecff1e62642f100$export$eba6f6f03b0a92e7)()), (0, $884bb82e02bc8b18$export$2f35ab04d2335697)(value, 2, -2), 0, siblings);
}
function $893aa91c085274b1$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $4ecff1e62642f100$export$35059013cd4a06db)(value, root, parent, (0, $569a2951990997db$export$527d108ccf083c2b), (0, $884bb82e02bc8b18$export$2f35ab04d2335697)(value, 0, length), (0, $884bb82e02bc8b18$export$2f35ab04d2335697)(value, length + 1, -1), length, siblings);
}



function $a8ee8209128bc75b$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $a8ee8209128bc75b$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $569a2951990997db$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $569a2951990997db$export$a763edbf796b780a:
        case 0, $569a2951990997db$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $569a2951990997db$export$a29989082612d0d9:
            return '';
        case 0, $569a2951990997db$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $a8ee8209128bc75b$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $569a2951990997db$export$aa3a2e812ca8570d:
            if (!(0, $884bb82e02bc8b18$export$36776f635604f274)(element.value = element.props.join(','))) return '';
    }
    return (0, $884bb82e02bc8b18$export$36776f635604f274)(children = $a8ee8209128bc75b$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}



function $a53c9437384cdb16$export$e7b7955c4f1f8c03(message, info) {
    var path = info.path, parentSelectors = info.parentSelectors;
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "[Ant Design CSS-in-JS] ".concat(path ? "Error in ".concat(path, ": ") : '').concat(message).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(' | ')) : ''));
}


var $d7b6f952035f0c1e$var$linter = function linter(key, value, info) {
    if (key === 'content') {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        var contentValues = [
            'normal',
            'none',
            'initial',
            'inherit',
            'unset'
        ];
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $a53c9437384cdb16$export$e7b7955c4f1f8c03)("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
};
var $d7b6f952035f0c1e$export$2e2bcd8739ae039 = $d7b6f952035f0c1e$var$linter;



var $86f010e58340c047$var$linter = function linter(key, value, info) {
    if (key === 'animation') {
        if (info.hashId && value !== 'none') (0, $a53c9437384cdb16$export$e7b7955c4f1f8c03)("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
};
var $86f010e58340c047$export$2e2bcd8739ae039 = $86f010e58340c047$var$linter;



function $9d03748d62942c13$var$isConcatSelector(selector) {
    var _selector$match;
    var notContent = ((_selector$match = selector.match(/:not\(([^)]*)\)/)) === null || _selector$match === void 0 ? void 0 : _selector$match[1]) || '';
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    var splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter(function(str) {
        return str;
    });
    return splitCells.length > 1;
}
function $9d03748d62942c13$var$parsePath(info) {
    return info.parentSelectors.reduce(function(prev, cur) {
        if (!prev) return cur;
        return cur.includes('&') ? cur.replace(/&/g, prev) : "".concat(prev, " ").concat(cur);
    }, '');
}
var $9d03748d62942c13$var$linter = function linter(key, value, info) {
    var parentSelectorPath = $9d03748d62942c13$var$parsePath(info);
    var notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($9d03748d62942c13$var$isConcatSelector)) (0, $a53c9437384cdb16$export$e7b7955c4f1f8c03)("Concat ':not' selector not support in legacy browsers.", info);
};
var $9d03748d62942c13$export$2e2bcd8739ae039 = $9d03748d62942c13$var$linter;



var $58259d46cb6fe9f7$var$linter = function linter(key, value, info) {
    switch(key){
        case 'marginLeft':
        case 'marginRight':
        case 'paddingLeft':
        case 'paddingRight':
        case 'left':
        case 'right':
        case 'borderLeft':
        case 'borderLeftWidth':
        case 'borderLeftStyle':
        case 'borderLeftColor':
        case 'borderRight':
        case 'borderRightWidth':
        case 'borderRightStyle':
        case 'borderRightColor':
        case 'borderTopLeftRadius':
        case 'borderTopRightRadius':
        case 'borderBottomLeftRadius':
        case 'borderBottomRightRadius':
            (0, $a53c9437384cdb16$export$e7b7955c4f1f8c03)("You seem to be using non-logical property '".concat(key, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case 'margin':
        case 'padding':
        case 'borderWidth':
        case 'borderStyle':
            // case 'borderColor':
            if (typeof value === 'string') {
                var valueArr = value.split(' ').map(function(item) {
                    return item.trim();
                });
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $a53c9437384cdb16$export$e7b7955c4f1f8c03)("You seem to be using '".concat(key, "' property with different left ").concat(key, " and right ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        case 'clear':
        case 'textAlign':
            if (value === 'left' || value === 'right') (0, $a53c9437384cdb16$export$e7b7955c4f1f8c03)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case 'borderRadius':
            if (typeof value === 'string') {
                var radiusGroups = value.split('/').map(function(item) {
                    return item.trim();
                });
                var invalid = radiusGroups.reduce(function(result, group) {
                    if (result) return result;
                    var radiusArr = group.split(' ').map(function(item) {
                        return item.trim();
                    });
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $a53c9437384cdb16$export$e7b7955c4f1f8c03)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        default:
    }
};
var $58259d46cb6fe9f7$export$2e2bcd8739ae039 = $58259d46cb6fe9f7$var$linter;



var $b0d2ffb4bcfccc1c$var$linter = function linter(key, value, info) {
    if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) (0, $a53c9437384cdb16$export$e7b7955c4f1f8c03)("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
};
var $b0d2ffb4bcfccc1c$export$2e2bcd8739ae039 = $b0d2ffb4bcfccc1c$var$linter;



var $a6068121fb3705a7$var$linter = function linter(key, value, info) {
    if (info.parentSelectors.some(function(selector) {
        var selectors = selector.split(',');
        return selectors.some(function(item) {
            return item.split('&').length > 2;
        });
    })) (0, $a53c9437384cdb16$export$e7b7955c4f1f8c03)('Should not use more than one `&` in a selector.', info);
};
var $a6068121fb3705a7$export$2e2bcd8739ae039 = $a6068121fb3705a7$var$linter;









var $ae15f8ce1a700f56$export$1c054aa01963e47e = 'data-ant-cssinjs-cache-path';
var $ae15f8ce1a700f56$export$e0a2f8ff7fc63361 = '_FILE_STYLE__';
function $ae15f8ce1a700f56$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map(function(path) {
        var hash = cachePathMap[path];
        return "".concat(path, ":").concat(hash);
    }).join(';');
}
var $ae15f8ce1a700f56$var$cachePathMap;
var $ae15f8ce1a700f56$var$fromCSSFile = true;
function $ae15f8ce1a700f56$export$aad8462122ac592b(mockCache) {
    var fromFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $ae15f8ce1a700f56$var$cachePathMap = mockCache;
    $ae15f8ce1a700f56$var$fromCSSFile = fromFile;
}
function $ae15f8ce1a700f56$export$18298bb220d85216() {
    if (!$ae15f8ce1a700f56$var$cachePathMap) {
        $ae15f8ce1a700f56$var$cachePathMap = {};
        if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
            var div = document.createElement('div');
            div.className = $ae15f8ce1a700f56$export$1c054aa01963e47e;
            div.style.position = 'fixed';
            div.style.visibility = 'hidden';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            var content = getComputedStyle(div).content || '';
            content = content.replace(/^"/, '').replace(/"$/, '');
            // Fill data
            content.split(';').forEach(function(item) {
                var _item$split = item.split(':'), _item$split2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_item$split, 2), path = _item$split2[0], hash = _item$split2[1];
                $ae15f8ce1a700f56$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            var inlineMapStyle = document.querySelector("style[".concat($ae15f8ce1a700f56$export$1c054aa01963e47e, "]"));
            if (inlineMapStyle) {
                var _inlineMapStyle$paren;
                $ae15f8ce1a700f56$var$fromCSSFile = false;
                (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $ae15f8ce1a700f56$export$5aa0d776d676ab98(path) {
    $ae15f8ce1a700f56$export$18298bb220d85216();
    return !!$ae15f8ce1a700f56$var$cachePathMap[path];
}
function $ae15f8ce1a700f56$export$d3851dfd3659b2ce(path) {
    var hash = $ae15f8ce1a700f56$var$cachePathMap[path];
    var styleStr = null;
    if (hash && (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
        if ($ae15f8ce1a700f56$var$fromCSSFile) styleStr = $ae15f8ce1a700f56$export$e0a2f8ff7fc63361;
        else {
            var _style = document.querySelector("style[".concat((0, $03e1c8118629977a$export$89ce1123b3c0bd9e), "=\"").concat($ae15f8ce1a700f56$var$cachePathMap[path], "\"]"));
            if (_style) styleStr = _style.innerHTML;
            else // Clean up since not exist anymore
            delete $ae15f8ce1a700f56$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}



var $74aa6c6ff0731162$var$SKIP_CHECK = '_skip_check_';
var $74aa6c6ff0731162$var$MULTI_VALUE = '_multi_value_';
function $74aa6c6ff0731162$export$8756898546458274(styleStr) {
    var serialized = (0, $a8ee8209128bc75b$export$dfdc1655ccc5b9cb)((0, $893aa91c085274b1$export$ef7acd7185315e22)(styleStr), (0, $a8ee8209128bc75b$export$fac44ee5b035f737));
    return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function $74aa6c6ff0731162$var$isCompoundCSSProperty(value) {
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && value && ($74aa6c6ff0731162$var$SKIP_CHECK in value || $74aa6c6ff0731162$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $74aa6c6ff0731162$var$injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    var hashClassName = ".".concat(hashId);
    var hashSelector = hashPriority === 'low' ? ":where(".concat(hashClassName, ")") : hashClassName;
    // 注入 hashId
    var keys = key.split(',').map(function(k) {
        var _firstPath$match;
        var fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        var firstPath = fullPath[0] || '';
        var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || '';
        firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
        return [
            firstPath
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(fullPath.slice(1))).join(' ');
    });
    return keys.join(',');
}
var $74aa6c6ff0731162$export$e13dc740254f53d7 = function parseStyle(interpolation) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        root: true,
        parentSelectors: []
    }, root = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
    var hashId = config.hashId, layer = config.layer, path = config.path, hashPriority = config.hashPriority, _config$transformers = config.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config.linters, linters = _config$linters === void 0 ? [] : _config$linters;
    var styleStr = '';
    var effectStyle = {};
    function parseKeyframes(keyframes) {
        var animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            var _parseStyle = parseStyle(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            }), _parseStyle2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_parseStyle, 1), _parsedStr = _parseStyle2[0];
            effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
        }
    }
    function flattenList(list) {
        var fullList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        list.forEach(function(item) {
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach(function(originStyle) {
        // Only root level can use raw string
        var style = typeof originStyle === 'string' && !root ? {} : originStyle;
        if (typeof style === 'string') styleStr += "".concat(style, "\n");
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            var mergedStyle = transformers.reduce(function(prev, trans) {
                var _trans$visit;
                return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev)) || prev;
            }, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach(function(key) {
                var value = mergedStyle[key];
                if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && value && (key !== 'animationName' || !value._keyframe) && !$74aa6c6ff0731162$var$isCompoundCSSProperty(value)) {
                    var subInjectHash = false;
                    // 当成嵌套对象来处理
                    var mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    var nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith('@')) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else // 注入 hashId
                        mergedKey = $74aa6c6ff0731162$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = '';
                        nextRoot = true;
                    }
                    var _parseStyle3 = parseStyle(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(parentSelectors), [
                            mergedKey
                        ])
                    }), _parseStyle4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
                    effectStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, effectStyle), childEffectStyle);
                    styleStr += "".concat(mergedKey).concat(_parsedStr2);
                } else {
                    var _value;
                    function appendStyle(cssKey, cssValue) {
                        // 如果是样式则直接插入
                        var styleName = cssKey.replace(/[A-Z]/g, function(match) {
                            return "-".concat(match.toLowerCase());
                        });
                        // Auto suffix with px
                        var formatValue = cssValue;
                        if (!(0, $d9263a4c6739b952$export$2e2bcd8739ae039)[cssKey] && typeof formatValue === 'number' && formatValue !== 0) formatValue = "".concat(formatValue, "px");
                        // handle animationName & Keyframe value
                        if (cssKey === 'animationName' && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += "".concat(styleName, ":").concat(formatValue, ";");
                    }
                    var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
                    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && value !== null && value !== void 0 && value[$74aa6c6ff0731162$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach(function(item) {
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = "{".concat(styleStr, "}");
    else if (layer) {
        styleStr = "@layer ".concat(layer.name, " {").concat(styleStr, "}");
        if (layer.dependencies) effectStyle["@layer ".concat(layer.name)] = layer.dependencies.map(function(deps) {
            return "@layer ".concat(deps, ", ").concat(layer.name, ";");
        }).join('\n');
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $74aa6c6ff0731162$export$412618713057f6ca(path, styleStr) {
    return (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)("".concat(path.join('%')).concat(styleStr));
}
function $74aa6c6ff0731162$var$Empty() {
    return null;
}
var $74aa6c6ff0731162$export$1e6d9f0d06c7ec14 = 'style';
function $74aa6c6ff0731162$export$2e2bcd8739ae039(info, styleFn) {
    var token = info.token, path = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
    var _React$useContext = $acw62.useContext((0, $03e1c8118629977a$export$2e2bcd8739ae039)), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache = _React$useContext.cache, enableLayer = _React$useContext.layer;
    var tokenKey = token._tokenKey;
    var fullPath = [
        tokenKey
    ];
    if (enableLayer) fullPath.push('layer');
    fullPath.push.apply(fullPath, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(path));
    // Check if need insert style
    var isMergedClientSide = (0, $4812ae2d3005362e$export$9542afab8c2a5f48);
    var _useGlobalCache = (0, $ada7bd6df4047ef6$export$2e2bcd8739ae039)($74aa6c6ff0731162$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    function() {
        var cachePath = fullPath.join('|');
        // Get style from SSR inline style directly
        if ((0, $ae15f8ce1a700f56$export$5aa0d776d676ab98)(cachePath)) {
            var _getStyleAndHash = (0, $ae15f8ce1a700f56$export$d3851dfd3659b2ce)(cachePath), _getStyleAndHash2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                tokenKey,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        var styleObj = styleFn();
        var _parseStyle5 = $74aa6c6ff0731162$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join('-'),
            transformers: transformers,
            linters: linters
        }), _parseStyle6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
        var styleStr = $74aa6c6ff0731162$export$8756898546458274(parsedStyle);
        var styleId = $74aa6c6ff0731162$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            tokenKey,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    function(_ref2, fromHMR) {
        var _ref3 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref2, 3), styleId = _ref3[2];
        if ((fromHMR || autoClear) && (0, $4812ae2d3005362e$export$9542afab8c2a5f48)) (0, $3a22468320d7d808$export$2232e336aecaa80a)(styleId, {
            mark: (0, $03e1c8118629977a$export$89ce1123b3c0bd9e)
        });
    }, // Effect: Inject style here
    function(_ref4) {
        var _ref5 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref4, 4), styleStr = _ref5[0], _ = _ref5[1], styleId = _ref5[2], effectStyle = _ref5[3];
        if (isMergedClientSide && styleStr !== (0, $ae15f8ce1a700f56$export$e0a2f8ff7fc63361)) {
            var mergedCSSConfig = {
                mark: (0, $03e1c8118629977a$export$89ce1123b3c0bd9e),
                prepend: enableLayer ? false : 'queue',
                attachTo: container,
                priority: order
            };
            var nonceStr = typeof nonce === 'function' ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            var effectLayerKeys = [];
            var effectRestKeys = [];
            Object.keys(effectStyle).forEach(function(key) {
                if (key.startsWith('@layer')) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach(function(effectKey) {
                (0, $3a22468320d7d808$export$4d99a2890bb989f0)($74aa6c6ff0731162$export$8756898546458274(effectStyle[effectKey]), "_layer-".concat(effectKey), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedCSSConfig), {}, {
                    prepend: true
                }));
            });
            // ==================== Inject Style ====================
            // Inject style
            var style = (0, $3a22468320d7d808$export$4d99a2890bb989f0)(styleStr, styleId, mergedCSSConfig);
            style[0, $03e1c8118629977a$export$4c16a0c02134a7dc] = cache.instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $03e1c8118629977a$export$5d99297dcd5476ac), tokenKey);
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach(function(effectKey) {
                (0, $3a22468320d7d808$export$4d99a2890bb989f0)($74aa6c6ff0731162$export$8756898546458274(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
            });
        }
    }), _useGlobalCache2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
    return function(node) {
        var styleNode;
        if (!ssrInline || isMergedClientSide || !defaultCache) styleNode = /*#__PURE__*/ $acw62.createElement($74aa6c6ff0731162$var$Empty, null);
        else styleNode = /*#__PURE__*/ $acw62.createElement("style", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $03e1c8118629977a$export$5d99297dcd5476ac), cachedTokenKey), (0, $03e1c8118629977a$export$89ce1123b3c0bd9e), cachedStyleId), {
            dangerouslySetInnerHTML: {
                __html: cachedStyleStr
            }
        }));
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, styleNode, node);
    };
}
var $74aa6c6ff0731162$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cache, 6), styleStr = _cache[0], tokenKey = _cache[1], styleId = _cache[2], effectStyle = _cache[3], clientOnly = _cache[4], order = _cache[5];
    var _ref7 = options || {}, plain = _ref7.plain;
    // Skip client only style
    if (clientOnly) return null;
    var keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    // ====================== Style ======================
    keyStyleText = (0, $4812ae2d3005362e$export$71c98ec84f0481d3)(styleStr, tokenKey, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach(function(effectKey) {
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            var effectStyleStr = $74aa6c6ff0731162$export$8756898546458274(effectStyle[effectKey]);
            var effectStyleHTML = (0, $4812ae2d3005362e$export$71c98ec84f0481d3)(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
            if (effectKey.startsWith('@layer')) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};


var $2af2d1075ed848a9$export$d96c342855c5e1fc = 'cssVar';
var $2af2d1075ed848a9$var$useCSSVarRegister = function useCSSVarRegister(config, fn) {
    var key = config.key, prefix = config.prefix, unitless = config.unitless, ignore = config.ignore, token = config.token, _config$scope = config.scope, scope = _config$scope === void 0 ? '' : _config$scope;
    var _useContext = (0, $acw62.useContext)((0, $03e1c8118629977a$export$2e2bcd8739ae039)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var tokenKey = token._tokenKey;
    var stylePath = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(config.path), [
        key,
        scope,
        tokenKey
    ]);
    var cache = (0, $ada7bd6df4047ef6$export$2e2bcd8739ae039)($2af2d1075ed848a9$export$d96c342855c5e1fc, stylePath, function() {
        var originToken = fn();
        var _transformToken = (0, $a0db7e13ef2c68c5$export$67858afe85bce49f)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope
        }), _transformToken2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
        var styleId = (0, $74aa6c6ff0731162$export$412618713057f6ca)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 3), styleId = _ref2[2];
        if (0, $4812ae2d3005362e$export$9542afab8c2a5f48) (0, $3a22468320d7d808$export$2232e336aecaa80a)(styleId, {
            mark: (0, $03e1c8118629977a$export$89ce1123b3c0bd9e)
        });
    }, function(_ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
        if (!cssVarsStr) return;
        var style = (0, $3a22468320d7d808$export$4d99a2890bb989f0)(cssVarsStr, styleId, {
            mark: (0, $03e1c8118629977a$export$89ce1123b3c0bd9e),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, $03e1c8118629977a$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $03e1c8118629977a$export$5d99297dcd5476ac), key);
    });
    return cache;
};
var $2af2d1075ed848a9$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cache, 4), styleStr = _cache[1], styleId = _cache[2], cssVarKey = _cache[3];
    var _ref5 = options || {}, plain = _ref5.plain;
    if (!styleStr) return null;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    var styleText = (0, $4812ae2d3005362e$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $2af2d1075ed848a9$export$2e2bcd8739ae039 = $2af2d1075ed848a9$var$useCSSVarRegister;





var $59593ae21b81362a$var$ExtractStyleFns = (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $74aa6c6ff0731162$export$1e6d9f0d06c7ec14), (0, $74aa6c6ff0731162$export$f9380c9a627682d3)), (0, $bcdbf65ffca51ddb$export$270fba097347f4fa), (0, $bcdbf65ffca51ddb$export$f9380c9a627682d3)), (0, $2af2d1075ed848a9$export$d96c342855c5e1fc), (0, $2af2d1075ed848a9$export$f9380c9a627682d3));
function $59593ae21b81362a$var$isNotNull(value) {
    return value !== null;
}
function $59593ae21b81362a$export$2e2bcd8739ae039(cache, options) {
    var _ref = typeof options === 'boolean' ? {
        plain: options
    } : options || {}, _ref$plain = _ref.plain, plain = _ref$plain === void 0 ? false : _ref$plain, _ref$types = _ref.types, types = _ref$types === void 0 ? [
        'style',
        'token',
        'cssVar'
    ] : _ref$types;
    var matchPrefixRegexp = new RegExp("^(".concat((typeof types === 'string' ? [
        types
    ] : types).join('|'), ")%"));
    // prefix with `style` is used for `useStyleRegister` to cache style context
    var styleKeys = Array.from(cache.cache.keys()).filter(function(key) {
        return matchPrefixRegexp.test(key);
    });
    // Common effect styles like animation
    var effectStyles = {};
    // Mapping of cachePath to style hash
    var cachePathMap = {};
    var styleText = '';
    styleKeys.map(function(key) {
        var cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
        var _key$split = key.split('%'), _key$split2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_key$split, 1), prefix = _key$split2[0];
        var extractFn = $59593ae21b81362a$var$ExtractStyleFns[prefix];
        var extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        var _extractedStyle = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(extractedStyle, 3), order = _extractedStyle[0], styleId = _extractedStyle[1], styleStr = _extractedStyle[2];
        if (key.startsWith('style')) cachePathMap[cachePath] = styleId;
        return [
            order,
            styleStr
        ];
    }).filter($59593ae21b81362a$var$isNotNull).sort(function(_ref2, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref2, 1), o1 = _ref4[0];
        var _ref5 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 1), o2 = _ref5[0];
        return o1 - o2;
    }).forEach(function(_ref6) {
        var _ref7 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref6, 2), style = _ref7[1];
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $4812ae2d3005362e$export$71c98ec84f0481d3)(".".concat((0, $ae15f8ce1a700f56$export$1c054aa01963e47e), "{content:\"").concat((0, $ae15f8ce1a700f56$export$dfdc1655ccc5b9cb)(cachePathMap), "\";}"), undefined, undefined, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $ae15f8ce1a700f56$export$1c054aa01963e47e), (0, $ae15f8ce1a700f56$export$1c054aa01963e47e)), plain);
    return styleText;
}








var $74f421ff21a8d71d$var$Keyframe = /*#__PURE__*/ function() {
    function Keyframe(name, style) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Keyframe);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "name", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "style", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_keyframe", true);
        this.name = name;
        this.style = style;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Keyframe, [
        {
            key: "getName",
            value: function getName() {
                var hashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
            }
        }
    ]);
    return Keyframe;
}();
var $74f421ff21a8d71d$export$2e2bcd8739ae039 = $74f421ff21a8d71d$var$Keyframe;






function $77b3a2277e9a9d39$var$splitValues(value) {
    if (typeof value === 'number') return [
        [
            value
        ],
        false
    ];
    var rawStyle = String(value).trim();
    var importantCells = rawStyle.match(/(.*)(!important)/);
    var splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    var temp = [];
    var brackets = 0;
    return [
        splitStyle.reduce(function(list, item) {
            if (item.includes('(') || item.includes(')')) {
                var left = item.split('(').length - 1;
                var right = item.split(')').length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(' '));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $77b3a2277e9a9d39$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
var $77b3a2277e9a9d39$var$keyMap = {
    // Inset
    inset: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    insetBlock: [
        'top',
        'bottom'
    ],
    insetBlockStart: [
        'top'
    ],
    insetBlockEnd: [
        'bottom'
    ],
    insetInline: [
        'left',
        'right'
    ],
    insetInlineStart: [
        'left'
    ],
    insetInlineEnd: [
        'right'
    ],
    // Margin
    marginBlock: [
        'marginTop',
        'marginBottom'
    ],
    marginBlockStart: [
        'marginTop'
    ],
    marginBlockEnd: [
        'marginBottom'
    ],
    marginInline: [
        'marginLeft',
        'marginRight'
    ],
    marginInlineStart: [
        'marginLeft'
    ],
    marginInlineEnd: [
        'marginRight'
    ],
    // Padding
    paddingBlock: [
        'paddingTop',
        'paddingBottom'
    ],
    paddingBlockStart: [
        'paddingTop'
    ],
    paddingBlockEnd: [
        'paddingBottom'
    ],
    paddingInline: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingInlineStart: [
        'paddingLeft'
    ],
    paddingInlineEnd: [
        'paddingRight'
    ],
    // Border
    borderBlock: $77b3a2277e9a9d39$var$noSplit([
        'borderTop',
        'borderBottom'
    ]),
    borderBlockStart: $77b3a2277e9a9d39$var$noSplit([
        'borderTop'
    ]),
    borderBlockEnd: $77b3a2277e9a9d39$var$noSplit([
        'borderBottom'
    ]),
    borderInline: $77b3a2277e9a9d39$var$noSplit([
        'borderLeft',
        'borderRight'
    ]),
    borderInlineStart: $77b3a2277e9a9d39$var$noSplit([
        'borderLeft'
    ]),
    borderInlineEnd: $77b3a2277e9a9d39$var$noSplit([
        'borderRight'
    ]),
    // Border width
    borderBlockWidth: [
        'borderTopWidth',
        'borderBottomWidth'
    ],
    borderBlockStartWidth: [
        'borderTopWidth'
    ],
    borderBlockEndWidth: [
        'borderBottomWidth'
    ],
    borderInlineWidth: [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    borderInlineStartWidth: [
        'borderLeftWidth'
    ],
    borderInlineEndWidth: [
        'borderRightWidth'
    ],
    // Border style
    borderBlockStyle: [
        'borderTopStyle',
        'borderBottomStyle'
    ],
    borderBlockStartStyle: [
        'borderTopStyle'
    ],
    borderBlockEndStyle: [
        'borderBottomStyle'
    ],
    borderInlineStyle: [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    borderInlineStartStyle: [
        'borderLeftStyle'
    ],
    borderInlineEndStyle: [
        'borderRightStyle'
    ],
    // Border color
    borderBlockColor: [
        'borderTopColor',
        'borderBottomColor'
    ],
    borderBlockStartColor: [
        'borderTopColor'
    ],
    borderBlockEndColor: [
        'borderBottomColor'
    ],
    borderInlineColor: [
        'borderLeftColor',
        'borderRightColor'
    ],
    borderInlineStartColor: [
        'borderLeftColor'
    ],
    borderInlineEndColor: [
        'borderRightColor'
    ],
    // Border radius
    borderStartStartRadius: [
        'borderTopLeftRadius'
    ],
    borderStartEndRadius: [
        'borderTopRightRadius'
    ],
    borderEndStartRadius: [
        'borderBottomLeftRadius'
    ],
    borderEndEndRadius: [
        'borderBottomRightRadius'
    ]
};
function $77b3a2277e9a9d39$var$wrapImportantAndSkipCheck(value, important) {
    var parsedValue = value;
    if (important) parsedValue = "".concat(parsedValue, " !important");
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ var $77b3a2277e9a9d39$var$transform = {
    visit: function visit(cssObj) {
        var clone = {};
        Object.keys(cssObj).forEach(function(key) {
            var value = cssObj[key];
            var matchValue = $77b3a2277e9a9d39$var$keyMap[key];
            if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
                var _splitValues = $77b3a2277e9a9d39$var$splitValues(value), _splitValues2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_splitValues, 2), _values = _splitValues2[0], _important = _splitValues2[1];
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach(function(matchKey) {
                    clone[matchKey] = $77b3a2277e9a9d39$var$wrapImportantAndSkipCheck(value, _important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $77b3a2277e9a9d39$var$wrapImportantAndSkipCheck(_values[0], _important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach(function(matchKey, index) {
                    var _values$index;
                    clone[matchKey] = $77b3a2277e9a9d39$var$wrapImportantAndSkipCheck((_values$index = _values[index]) !== null && _values$index !== void 0 ? _values$index : _values[0], _important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach(function(matchKey, index) {
                    var _ref, _values$index2;
                    clone[matchKey] = $77b3a2277e9a9d39$var$wrapImportantAndSkipCheck((_ref = (_values$index2 = _values[index]) !== null && _values$index2 !== void 0 ? _values$index2 : _values[index - 2]) !== null && _ref !== void 0 ? _ref : _values[0], _important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $77b3a2277e9a9d39$export$2e2bcd8739ae039 = $77b3a2277e9a9d39$var$transform;





var $4ada60d45bf62ee2$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $4ada60d45bf62ee2$var$toFixed(number, precision) {
    var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
var $4ada60d45bf62ee2$var$transform = function transform() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$rootValue = options.rootValue, rootValue = _options$rootValue === void 0 ? 16 : _options$rootValue, _options$precision = options.precision, precision = _options$precision === void 0 ? 5 : _options$precision, _options$mediaQuery = options.mediaQuery, mediaQuery = _options$mediaQuery === void 0 ? false : _options$mediaQuery;
    var pxReplace = function pxReplace(m, $1) {
        if (!$1) return m;
        var pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        var fixedVal = $4ada60d45bf62ee2$var$toFixed(pixels / rootValue, precision);
        return "".concat(fixedVal, "rem");
    };
    var visit = function visit(cssObj) {
        var clone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, cssObj);
        Object.entries(cssObj).forEach(function(_ref) {
            var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
            if (typeof value === 'string' && value.includes('px')) {
                var newValue = value.replace($4ada60d45bf62ee2$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $d9263a4c6739b952$export$2e2bcd8739ae039)[key] && typeof value === 'number' && value !== 0) clone[key] = "".concat(value, "px").replace($4ada60d45bf62ee2$var$pxRegex, pxReplace);
            // Media queries
            var mergedKey = key.trim();
            if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
                var newKey = key.replace($4ada60d45bf62ee2$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $4ada60d45bf62ee2$export$2e2bcd8739ae039 = $4ada60d45bf62ee2$var$transform;




var $00bf51c3d8587265$export$73abaea5066f503b = {
    supportModernCSS: function supportModernCSS() {
        return (0, $4812ae2d3005362e$export$f51d3b8ac4ac9ed1)() && (0, $4812ae2d3005362e$export$64a912f57d5de48e)();
    }
};











var $a7862c0e3a5a168d$var$AbstractCalculator = /*#__PURE__*/ (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $a7862c0e3a5a168d$export$2e2bcd8739ae039 = $a7862c0e3a5a168d$var$AbstractCalculator;


var $2a874be19a32c8c7$var$CALC_UNIT = 'CALC_UNIT';
var $2a874be19a32c8c7$var$regexp = new RegExp($2a874be19a32c8c7$var$CALC_UNIT, 'g');
function $2a874be19a32c8c7$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($2a874be19a32c8c7$var$CALC_UNIT);
    return value;
}
var $2a874be19a32c8c7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "result", '');
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $2a874be19a32c8c7$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($2a874be19a32c8c7$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($2a874be19a32c8c7$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($2a874be19a32c8c7$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $a7862c0e3a5a168d$export$2e2bcd8739ae039));









var $5e6928769c8bf532$var$NumCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $a7862c0e3a5a168d$export$2e2bcd8739ae039));
var $5e6928769c8bf532$export$2e2bcd8739ae039 = $5e6928769c8bf532$var$NumCalculator;


var $dc9da9f8a3dae284$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $2a874be19a32c8c7$export$2e2bcd8739ae039) : (0, $5e6928769c8bf532$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $dc9da9f8a3dae284$export$2e2bcd8739ae039 = $dc9da9f8a3dae284$var$genCalc;


var $cea91e68076a573d$var$getCompVarPrefix = function getCompVarPrefix(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')
    ].filter(Boolean).join('-'));
};
var $cea91e68076a573d$export$2e2bcd8739ae039 = $cea91e68076a573d$var$getCompVarPrefix;





function $e6f0d963e7f65a73$var$getComponentToken(component, token, defaultToken, options) {
    var customToken = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, token[component]);
    if (options !== null && options !== void 0 && options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
                var _customToken$newToken;
                (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
            }
        });
    }
    var mergedToken = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
}
var $e6f0d963e7f65a73$export$2e2bcd8739ae039 = $e6f0d963e7f65a73$var$getComponentToken;




var $6f8035da4ba7a5b0$var$enableStatistic = typeof CSSINJS_STATISTIC !== 'undefined';
var $6f8035da4ba7a5b0$var$recording = true;
function $6f8035da4ba7a5b0$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$6f8035da4ba7a5b0$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $6f8035da4ba7a5b0$var$recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(obj) !== 'object') return;
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return obj[key];
                }
            });
        });
    });
    $6f8035da4ba7a5b0$var$recording = true;
    return ret;
}
var $6f8035da4ba7a5b0$export$754a5e2d36c5fa7a = {};
var $6f8035da4ba7a5b0$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $6f8035da4ba7a5b0$var$noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ var $6f8035da4ba7a5b0$var$statisticToken = function statisticToken(token) {
    var tokenKeys;
    var proxy = token;
    var flush = $6f8035da4ba7a5b0$var$noop;
    if ($6f8035da4ba7a5b0$var$enableStatistic && typeof Proxy !== 'undefined') {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function get(obj, prop) {
                if ($6f8035da4ba7a5b0$var$recording) {
                    var _tokenKeys;
                    (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
                }
                return obj[prop];
            }
        });
        flush = function flush(componentName, componentToken) {
            var _statistic$componentN;
            $6f8035da4ba7a5b0$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (_statistic$componentN = $6f8035da4ba7a5b0$export$754a5e2d36c5fa7a[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
var $6f8035da4ba7a5b0$export$2e2bcd8739ae039 = $6f8035da4ba7a5b0$var$statisticToken;


function $0b5032654026988b$var$getDefaultComponentToken(component, token, getDefaultToken) {
    if (typeof getDefaultToken === 'function') {
        var _token$component;
        return getDefaultToken((0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
    }
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
var $0b5032654026988b$export$2e2bcd8739ae039 = $0b5032654026988b$var$getDefaultComponentToken;



function $60c98148595dbf83$var$genMaxMin(type) {
    if (type === 'js') return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, $4812ae2d3005362e$export$523c0b569236b342)(value);
            }).join(','), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, $4812ae2d3005362e$export$523c0b569236b342)(value);
            }).join(','), ")");
        }
    };
}
var $60c98148595dbf83$export$2e2bcd8739ae039 = $60c98148595dbf83$var$genMaxMin;








var $acw62 = parcelRequire("acw62");
var $270f255e5d3fe4f5$var$BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ var $270f255e5d3fe4f5$var$ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ArrayKeyMap);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "map", new Map());
        // Use WeakMap to avoid memory leak
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "objectIDMap", new WeakMap());
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "nextID", 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "lastAccessBeat", new Map());
        // We will clean up the cache when reach the limit
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "accessBeat", 0);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                var compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var compositeKey = this.getCompositeKey(keys);
                var cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                var _this = this;
                var ids = keys.map(function(key) {
                    if (key && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === 'object') return "obj_".concat(_this.getObjectID(key));
                    return "".concat((0, $b8f57191916382d3$export$2e2bcd8739ae039)(key), "_").concat(key);
                });
                return ids.join('|');
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                var id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this2 = this;
                if (this.accessBeat > 10000) {
                    var now = Date.now();
                    this.lastAccessBeat.forEach(function(beat, key) {
                        if (now - beat > $270f255e5d3fe4f5$var$BEAT_LIMIT) {
                            _this2.map.delete(key);
                            _this2.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
    return ArrayKeyMap;
}();
var $270f255e5d3fe4f5$var$uniqueMap = new $270f255e5d3fe4f5$var$ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function $270f255e5d3fe4f5$var$useUniqueMemo(memoFn, deps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        var cachedValue = $270f255e5d3fe4f5$var$uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        var newValue = memoFn();
        $270f255e5d3fe4f5$var$uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
var $270f255e5d3fe4f5$export$2e2bcd8739ae039 = $270f255e5d3fe4f5$var$useUniqueMemo;


/**
 * Provide a default hook since not everyone needs to config this.
 */ var $21b691332eabc800$var$useDefaultCSP = function useDefaultCSP() {
    return {};
};
var $21b691332eabc800$export$2e2bcd8739ae039 = $21b691332eabc800$var$useDefaultCSP;


function $b5ac6ed04e4484e1$var$genStyleUtils(config) {
    // Dependency inversion for preparing basic config.
    var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? (0, $21b691332eabc800$export$2e2bcd8739ae039) : _config$useCSP, useToken = config.useToken, usePrefix = config.usePrefix, getResetStyles = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
    function genStyleHooks(component, styleFn, getDefaultToken, options) {
        var componentName = Array.isArray(component) ? component[0] : component;
        function prefixToken(key) {
            return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
        }
        // Fill unitless
        var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
        var originCompUnitless = typeof getCompUnitless === 'function' ? getCompUnitless(component) : {};
        var compUnitless = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originCompUnitless), {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, prefixToken('zIndexPopup'), true));
        Object.keys(originUnitless).forEach(function(key) {
            compUnitless[prefixToken(key)] = originUnitless[key];
        });
        // Options
        var mergedOptions = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, options), {}, {
            unitless: compUnitless,
            prefixToken: prefixToken
        });
        // Hooks
        var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
        var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useStyle = useStyle(prefixCls, rootCls), _useStyle2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStyle, 2), hashId = _useStyle2[1];
            var _useCSSVar = useCSSVar(rootCls), _useCSSVar2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useCSSVar, 2), wrapCSSVar = _useCSSVar2[0], cssVarCls = _useCSSVar2[1];
            return [
                wrapCSSVar,
                hashId,
                cssVarCls
            ];
        };
    }
    function genCSSVarRegister(component, getDefaultToken, options) {
        var compUnitless = options.unitless, _options$injectStyle = options.injectStyle, injectStyle = _options$injectStyle === void 0 ? true : _options$injectStyle, prefixToken = options.prefixToken, ignore = options.ignore;
        var CSSVarRegister = function CSSVarRegister(_ref) {
            var rootCls = _ref.rootCls, _ref$cssVar = _ref.cssVar, cssVar = _ref$cssVar === void 0 ? {} : _ref$cssVar;
            var _useToken = useToken(), realToken = _useToken.realToken;
            (0, $2af2d1075ed848a9$export$2e2bcd8739ae039)({
                path: [
                    component
                ],
                prefix: cssVar.prefix,
                key: cssVar.key,
                unitless: compUnitless,
                ignore: ignore,
                token: realToken,
                scope: rootCls
            }, function() {
                var defaultToken = (0, $0b5032654026988b$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentToken = (0, $e6f0d963e7f65a73$export$2e2bcd8739ae039)(component, realToken, defaultToken, {
                    deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
                });
                Object.keys(defaultToken).forEach(function(key) {
                    componentToken[prefixToken(key)] = componentToken[key];
                    delete componentToken[key];
                });
                return componentToken;
            });
            return null;
        };
        var useCSSVar = function useCSSVar(rootCls) {
            var _useToken2 = useToken(), cssVar = _useToken2.cssVar;
            return [
                function(node) {
                    return injectStyle && cssVar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CSSVarRegister, {
                        rootCls: rootCls,
                        cssVar: cssVar,
                        component: component
                    }), node) : node;
                },
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.key
            ];
        };
        return useCSSVar;
    }
    function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var cells = Array.isArray(componentName) ? componentName : [
            componentName,
            componentName
        ];
        var _cells = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cells, 1), component = _cells[0];
        var concatComponent = cells.join('-');
        var mergedLayer = config.layer || {
            name: 'antd'
        };
        // Return new style hook
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useToken3 = useToken(), theme = _useToken3.theme, realToken = _useToken3.realToken, hashId = _useToken3.hashId, token = _useToken3.token, cssVar = _useToken3.cssVar;
            var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
            var csp = useCSP();
            var type = cssVar ? 'css' : 'js';
            // Use unique memo to share the result across all instances
            var calc = (0, $270f255e5d3fe4f5$export$2e2bcd8739ae039)(function() {
                var unitlessCssVar = new Set();
                if (cssVar) Object.keys(options.unitless || {}).forEach(function(key) {
                    // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                    // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                    unitlessCssVar.add((0, $a0db7e13ef2c68c5$export$309b3b095f0c7662)(key, cssVar.prefix));
                    unitlessCssVar.add((0, $a0db7e13ef2c68c5$export$309b3b095f0c7662)(key, (0, $cea91e68076a573d$export$2e2bcd8739ae039)(component, cssVar.prefix)));
                });
                return (0, $dc9da9f8a3dae284$export$2e2bcd8739ae039)(type, unitlessCssVar);
            }, [
                type,
                component,
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
            ]);
            var _genMaxMin = (0, $60c98148595dbf83$export$2e2bcd8739ae039)(type), max = _genMaxMin.max, min = _genMaxMin.min;
            // Shared config
            var sharedConfig = {
                theme: theme,
                token: token,
                hashId: hashId,
                nonce: function nonce() {
                    return csp.nonce;
                },
                clientOnly: options.clientOnly,
                layer: mergedLayer,
                // antd is always at top of styles
                order: options.order || -999
            };
            // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
            if (typeof getResetStyles === 'function') // Generate style for all need reset tags.
            (0, $74aa6c6ff0731162$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                clientOnly: false,
                path: [
                    'Shared',
                    rootPrefixCls
                ]
            }), function() {
                return getResetStyles(token, {
                    prefix: {
                        rootPrefixCls: rootPrefixCls,
                        iconPrefixCls: iconPrefixCls
                    },
                    csp: csp
                });
            });
            var wrapSSR = (0, $74aa6c6ff0731162$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                path: [
                    concatComponent,
                    prefixCls,
                    iconPrefixCls
                ]
            }), function() {
                if (options.injectStyle === false) return [];
                var _statisticToken = (0, $6f8035da4ba7a5b0$export$2e2bcd8739ae039)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
                var defaultComponentToken = (0, $0b5032654026988b$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentCls = ".".concat(prefixCls);
                var componentToken = (0, $e6f0d963e7f65a73$export$2e2bcd8739ae039)(component, realToken, defaultComponentToken, {
                    deprecatedTokens: options.deprecatedTokens
                });
                if (cssVar && defaultComponentToken && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(defaultComponentToken) === 'object') Object.keys(defaultComponentToken).forEach(function(key) {
                    defaultComponentToken[key] = "var(".concat((0, $a0db7e13ef2c68c5$export$309b3b095f0c7662)(key, (0, $cea91e68076a573d$export$2e2bcd8739ae039)(component, cssVar.prefix)), ")");
                });
                var mergedToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(proxyToken, {
                    componentCls: componentCls,
                    prefixCls: prefixCls,
                    iconCls: ".".concat(iconPrefixCls),
                    antCls: ".".concat(rootPrefixCls),
                    calc: calc,
                    // @ts-ignore
                    max: max,
                    // @ts-ignore
                    min: min
                }, cssVar ? defaultComponentToken : componentToken);
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls
                });
                flush(component, componentToken);
                var commonStyle = typeof getCommonStyle === 'function' ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
                return [
                    options.resetStyle === false ? null : commonStyle,
                    styleInterpolation
                ];
            });
            return [
                wrapSSR,
                hashId
            ];
        };
    }
    function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            resetStyle: false,
            // Sub Style should default after root one
            order: -998
        }, options));
        var StyledComponent = function StyledComponent(_ref2) {
            var prefixCls = _ref2.prefixCls, _ref2$rootCls = _ref2.rootCls, rootCls = _ref2$rootCls === void 0 ? prefixCls : _ref2$rootCls;
            useStyle(prefixCls, rootCls);
            return null;
        };
        return StyledComponent;
    }
    return {
        genStyleHooks: genStyleHooks,
        genSubStyleComponent: genSubStyleComponent,
        genComponentStyleHook: genComponentStyleHook
    };
}
var $b5ac6ed04e4484e1$export$2e2bcd8739ae039 = $b5ac6ed04e4484e1$var$genStyleUtils;









const { genStyleHooks: $0f84270bd7498f9c$export$51ec95de45185b42, genComponentStyleHook: $0f84270bd7498f9c$export$b8cc4ee2ee8cfbc8, genSubStyleComponent: $0f84270bd7498f9c$export$1537386bc155ea56 } = (0, $b5ac6ed04e4484e1$export$2e2bcd8739ae039)({
    usePrefix: ()=>{
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
        return {
            theme: theme,
            realToken: realToken,
            hashId: hashId,
            token: token,
            cssVar: cssVar
        };
    },
    useCSP: ()=>{
        const { csp: csp } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
        return csp !== null && csp !== void 0 ? csp : {};
    },
    getResetStyles: (token, config)=>{
        var _a;
        const linkStyle = (0, $4733a3b3eb18f80d$export$905d771977096614)(token);
        return [
            linkStyle,
            {
                '&': linkStyle
            },
            (0, $4733a3b3eb18f80d$export$f1a0b31dfb234e7e)((_a = config === null || config === void 0 ? void 0 : config.prefix.iconPrefixCls) !== null && _a !== void 0 ? _a : (0, $a18b2f6f56546238$export$eaca8ee5ed21b4e9))
        ];
    },
    getCommonStyle: (0, $4733a3b3eb18f80d$export$689382c111559cd9),
    getCompUnitless: ()=>(0, $d014fefdb4420ef5$export$c6b9faa6b723d31a)
});



const $66f8f9a1d129a793$var$genNotificationPlacementStyle = (token)=>{
    const { componentCls: componentCls, notificationMarginEdge: notificationMarginEdge, animationMaxHeight: animationMaxHeight } = token;
    const noticeCls = `${componentCls}-notice`;
    const rightFadeIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antNotificationFadeIn', {
        '0%': {
            transform: `translate3d(100%, 0, 0)`,
            opacity: 0
        },
        '100%': {
            transform: `translate3d(0, 0, 0)`,
            opacity: 1
        }
    });
    const topFadeIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antNotificationTopFadeIn', {
        '0%': {
            top: -animationMaxHeight,
            opacity: 0
        },
        '100%': {
            top: 0,
            opacity: 1
        }
    });
    const bottomFadeIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antNotificationBottomFadeIn', {
        '0%': {
            bottom: token.calc(animationMaxHeight).mul(-1).equal(),
            opacity: 0
        },
        '100%': {
            bottom: 0,
            opacity: 1
        }
    });
    const leftFadeIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antNotificationLeftFadeIn', {
        '0%': {
            transform: `translate3d(-100%, 0, 0)`,
            opacity: 0
        },
        '100%': {
            transform: `translate3d(0, 0, 0)`,
            opacity: 1
        }
    });
    return {
        [componentCls]: {
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                marginInline: 0,
                [noticeCls]: {
                    marginInline: 'auto auto'
                }
            },
            [`&${componentCls}-top`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: topFadeIn
                }
            },
            [`&${componentCls}-bottom`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: bottomFadeIn
                }
            },
            [`&${componentCls}-topRight, &${componentCls}-bottomRight`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: rightFadeIn
                }
            },
            [`&${componentCls}-topLeft, &${componentCls}-bottomLeft`]: {
                marginRight: {
                    value: 0,
                    _skip_check_: true
                },
                marginLeft: {
                    value: notificationMarginEdge,
                    _skip_check_: true
                },
                [noticeCls]: {
                    marginInlineEnd: 'auto',
                    marginInlineStart: 0
                },
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: leftFadeIn
                }
            }
        }
    };
};
var $66f8f9a1d129a793$export$2e2bcd8739ae039 = $66f8f9a1d129a793$var$genNotificationPlacementStyle;


const $01651aebb62eb0bb$export$617a29b5d3b30216 = [
    'top',
    'topLeft',
    'topRight',
    'bottom',
    'bottomLeft',
    'bottomRight'
];


const $c1b06690b031502a$var$placementAlignProperty = {
    topLeft: 'left',
    topRight: 'right',
    bottomLeft: 'left',
    bottomRight: 'right',
    top: 'left',
    bottom: 'left'
};
const $c1b06690b031502a$var$genPlacementStackStyle = (token, placement)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-${placement}`]: {
            [`&${componentCls}-stack > ${componentCls}-notice-wrapper`]: {
                [placement.startsWith('top') ? 'top' : 'bottom']: 0,
                [$c1b06690b031502a$var$placementAlignProperty[placement]]: {
                    value: 0,
                    _skip_check_: true
                }
            }
        }
    };
};
const $c1b06690b031502a$var$genStackChildrenStyle = (token)=>{
    const childrenStyle = {};
    for(let i = 1; i < token.notificationStackLayer; i++)childrenStyle[`&:nth-last-child(${i + 1})`] = {
        overflow: 'hidden',
        [`& > ${token.componentCls}-notice`]: {
            opacity: 0,
            transition: `opacity ${token.motionDurationMid}`
        }
    };
    return Object.assign({
        [`&:not(:nth-last-child(-n+${token.notificationStackLayer}))`]: {
            opacity: 0,
            overflow: 'hidden',
            color: 'transparent',
            pointerEvents: 'none'
        }
    }, childrenStyle);
};
const $c1b06690b031502a$var$genStackedNoticeStyle = (token)=>{
    const childrenStyle = {};
    for(let i = 1; i < token.notificationStackLayer; i++)childrenStyle[`&:nth-last-child(${i + 1})`] = {
        background: token.colorBgBlur,
        backdropFilter: 'blur(10px)',
        '-webkit-backdrop-filter': 'blur(10px)'
    };
    return Object.assign({}, childrenStyle);
};
const $c1b06690b031502a$var$genStackStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return Object.assign({
        [`${componentCls}-stack`]: {
            [`& > ${componentCls}-notice-wrapper`]: Object.assign({
                transition: `transform ${token.motionDurationSlow}, backdrop-filter 0s`,
                willChange: 'transform, opacity',
                position: 'absolute'
            }, $c1b06690b031502a$var$genStackChildrenStyle(token))
        },
        [`${componentCls}-stack:not(${componentCls}-stack-expanded)`]: {
            [`& > ${componentCls}-notice-wrapper`]: Object.assign({}, $c1b06690b031502a$var$genStackedNoticeStyle(token))
        },
        [`${componentCls}-stack${componentCls}-stack-expanded`]: {
            [`& > ${componentCls}-notice-wrapper`]: {
                '&:not(:nth-last-child(-n + 1))': {
                    opacity: 1,
                    overflow: 'unset',
                    color: 'inherit',
                    pointerEvents: 'auto',
                    [`& > ${token.componentCls}-notice`]: {
                        opacity: 1
                    }
                },
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    height: token.margin,
                    width: '100%',
                    insetInline: 0,
                    bottom: token.calc(token.margin).mul(-1).equal(),
                    background: 'transparent',
                    pointerEvents: 'auto'
                }
            }
        }
    }, (0, $01651aebb62eb0bb$export$617a29b5d3b30216).map((placement)=>$c1b06690b031502a$var$genPlacementStackStyle(token, placement)).reduce((acc, cur)=>Object.assign(Object.assign({}, acc), cur), {}));
};
var $c1b06690b031502a$export$2e2bcd8739ae039 = $c1b06690b031502a$var$genStackStyle;


const $6aed65619be1a08f$export$341e3ef8ee9ea7d6 = (token)=>{
    const { iconCls: iconCls, componentCls: componentCls, boxShadow: // .ant-notification
    boxShadow, fontSizeLG: fontSizeLG, notificationMarginBottom: notificationMarginBottom, borderRadiusLG: borderRadiusLG, colorSuccess: colorSuccess, colorInfo: colorInfo, colorWarning: colorWarning, colorError: colorError, colorTextHeading: colorTextHeading, notificationBg: notificationBg, notificationPadding: notificationPadding, notificationMarginEdge: notificationMarginEdge, notificationProgressBg: notificationProgressBg, notificationProgressHeight: notificationProgressHeight, fontSize: fontSize, lineHeight: lineHeight, width: width, notificationIconSize: notificationIconSize, colorText: colorText } = token;
    const noticeCls = `${componentCls}-notice`;
    return {
        position: 'relative',
        marginBottom: notificationMarginBottom,
        marginInlineStart: 'auto',
        background: notificationBg,
        borderRadius: borderRadiusLG,
        boxShadow: boxShadow,
        [noticeCls]: {
            padding: notificationPadding,
            width: width,
            maxWidth: `calc(100vw - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(notificationMarginEdge).mul(2).equal())})`,
            overflow: 'hidden',
            lineHeight: lineHeight,
            wordWrap: 'break-word'
        },
        [`${noticeCls}-message`]: {
            color: colorTextHeading,
            fontSize: fontSizeLG,
            lineHeight: token.lineHeightLG
        },
        [`${noticeCls}-description`]: {
            fontSize: fontSize,
            color: colorText,
            marginTop: token.marginXS
        },
        [`${noticeCls}-closable ${noticeCls}-message`]: {
            paddingInlineEnd: token.paddingLG
        },
        [`${noticeCls}-with-icon ${noticeCls}-message`]: {
            marginInlineStart: token.calc(token.marginSM).add(notificationIconSize).equal(),
            fontSize: fontSizeLG
        },
        [`${noticeCls}-with-icon ${noticeCls}-description`]: {
            marginInlineStart: token.calc(token.marginSM).add(notificationIconSize).equal(),
            fontSize: fontSize
        },
        // Icon & color style in different selector level
        // https://github.com/ant-design/ant-design/issues/16503
        // https://github.com/ant-design/ant-design/issues/15512
        [`${noticeCls}-icon`]: {
            position: 'absolute',
            fontSize: notificationIconSize,
            lineHeight: 1,
            // icon-font
            [`&-success${iconCls}`]: {
                color: colorSuccess
            },
            [`&-info${iconCls}`]: {
                color: colorInfo
            },
            [`&-warning${iconCls}`]: {
                color: colorWarning
            },
            [`&-error${iconCls}`]: {
                color: colorError
            }
        },
        [`${noticeCls}-close`]: Object.assign({
            position: 'absolute',
            top: token.notificationPaddingVertical,
            insetInlineEnd: token.notificationPaddingHorizontal,
            color: token.colorIcon,
            outline: 'none',
            width: token.notificationCloseButtonSize,
            height: token.notificationCloseButtonSize,
            borderRadius: token.borderRadiusSM,
            transition: `background-color ${token.motionDurationMid}, color ${token.motionDurationMid}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'none',
            border: 'none',
            '&:hover': {
                color: token.colorIconHover,
                backgroundColor: token.colorBgTextHover
            },
            '&:active': {
                backgroundColor: token.colorBgTextActive
            }
        }, (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)),
        [`${noticeCls}-progress`]: {
            position: 'absolute',
            display: 'block',
            appearance: 'none',
            inlineSize: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(borderRadiusLG)} * 2)`,
            left: {
                _skip_check_: true,
                value: borderRadiusLG
            },
            right: {
                _skip_check_: true,
                value: borderRadiusLG
            },
            bottom: 0,
            blockSize: notificationProgressHeight,
            border: 0,
            '&, &::-webkit-progress-bar': {
                borderRadius: borderRadiusLG,
                backgroundColor: `rgba(0, 0, 0, 0.04)`
            },
            '&::-moz-progress-bar': {
                background: notificationProgressBg
            },
            '&::-webkit-progress-value': {
                borderRadius: borderRadiusLG,
                background: notificationProgressBg
            }
        },
        [`${noticeCls}-actions`]: {
            float: 'right',
            marginTop: token.marginSM
        }
    };
};
const $6aed65619be1a08f$var$genNotificationStyle = (token)=>{
    const { componentCls: componentCls, notificationMarginBottom: // .ant-notification
    notificationMarginBottom, notificationMarginEdge: notificationMarginEdge, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut } = token;
    const noticeCls = `${componentCls}-notice`;
    const fadeOut = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antNotificationFadeOut', {
        '0%': {
            maxHeight: token.animationMaxHeight,
            marginBottom: notificationMarginBottom
        },
        '100%': {
            maxHeight: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
            opacity: 0
        }
    });
    return [
        // ============================ Holder ============================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                position: 'fixed',
                zIndex: token.zIndexPopup,
                marginRight: {
                    value: notificationMarginEdge,
                    _skip_check_: true
                },
                [`${componentCls}-hook-holder`]: {
                    position: 'relative'
                },
                //  animation
                [`${componentCls}-fade-appear-prepare`]: {
                    opacity: '0 !important'
                },
                [`${componentCls}-fade-enter, ${componentCls}-fade-appear`]: {
                    animationDuration: token.motionDurationMid,
                    animationTimingFunction: motionEaseInOut,
                    animationFillMode: 'both',
                    opacity: 0,
                    animationPlayState: 'paused'
                },
                [`${componentCls}-fade-leave`]: {
                    animationTimingFunction: motionEaseInOut,
                    animationFillMode: 'both',
                    animationDuration: motionDurationMid,
                    animationPlayState: 'paused'
                },
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-fade-leave${componentCls}-fade-leave-active`]: {
                    animationName: fadeOut,
                    animationPlayState: 'running'
                },
                // RTL
                '&-rtl': {
                    direction: 'rtl',
                    [`${noticeCls}-actions`]: {
                        float: 'left'
                    }
                }
            })
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: Object.assign({}, $6aed65619be1a08f$export$341e3ef8ee9ea7d6(token))
            }
        }
    ];
};
const $6aed65619be1a08f$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $8552b358f1d5b0a4$export$33ada7d8845f7e5) + 50,
        width: 384
    });
const $6aed65619be1a08f$export$9e25a4f60ca05a04 = (token)=>{
    const notificationPaddingVertical = token.paddingMD;
    const notificationPaddingHorizontal = token.paddingLG;
    const notificationToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        notificationBg: token.colorBgElevated,
        notificationPaddingVertical: notificationPaddingVertical,
        notificationPaddingHorizontal: notificationPaddingHorizontal,
        notificationIconSize: token.calc(token.fontSizeLG).mul(token.lineHeightLG).equal(),
        notificationCloseButtonSize: token.calc(token.controlHeightLG).mul(0.55).equal(),
        notificationMarginBottom: token.margin,
        notificationPadding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingMD)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        notificationMarginEdge: token.marginLG,
        animationMaxHeight: 150,
        notificationStackLayer: 3,
        notificationProgressHeight: 2,
        notificationProgressBg: `linear-gradient(90deg, ${token.colorPrimaryBorderHover}, ${token.colorPrimary})`
    });
    return notificationToken;
};
var $6aed65619be1a08f$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Notification', (token)=>{
    const notificationToken = $6aed65619be1a08f$export$9e25a4f60ca05a04(token);
    return [
        $6aed65619be1a08f$var$genNotificationStyle(notificationToken),
        (0, $66f8f9a1d129a793$export$2e2bcd8739ae039)(notificationToken),
        (0, $c1b06690b031502a$export$2e2bcd8739ae039)(notificationToken)
    ];
}, $6aed65619be1a08f$export$9ca1be8807fe0675);





var $e2090bda964c1495$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$1537386bc155ea56)([
    'Notification',
    'PurePanel'
], (token)=>{
    const noticeCls = `${token.componentCls}-notice`;
    const notificationToken = (0, $6aed65619be1a08f$export$9e25a4f60ca05a04)(token);
    return {
        [`${noticeCls}-pure-panel`]: Object.assign(Object.assign({}, (0, $6aed65619be1a08f$export$341e3ef8ee9ea7d6)(notificationToken)), {
            width: notificationToken.width,
            maxWidth: `calc(100vw - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(notificationToken.notificationMarginEdge).mul(2).equal())})`,
            margin: 0
        })
    };
}, (0, $6aed65619be1a08f$export$9ca1be8807fe0675));


"use client";
var $6e8caff8ed978edf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $6e8caff8ed978edf$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $acw62.createElement((0, $b5d5d018bfa4ba6e$export$2e2bcd8739ae039), null),
    success: /*#__PURE__*/ $acw62.createElement((0, $9149fdfb4424d1d9$export$2e2bcd8739ae039), null),
    error: /*#__PURE__*/ $acw62.createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null),
    warning: /*#__PURE__*/ $acw62.createElement((0, $2444f6da62064575$export$2e2bcd8739ae039), null),
    loading: /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), null)
};
function $6e8caff8ed978edf$export$a6cccece9dc8d76a(prefixCls, closeIcon) {
    if (closeIcon === null || closeIcon === false) return null;
    return closeIcon || /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    });
}
const $6e8caff8ed978edf$var$typeToIcon = {
    success: (0, $9149fdfb4424d1d9$export$2e2bcd8739ae039),
    info: (0, $b5d5d018bfa4ba6e$export$2e2bcd8739ae039),
    error: (0, $81ff9dc68eb84eda$export$2e2bcd8739ae039),
    warning: (0, $2444f6da62064575$export$2e2bcd8739ae039)
};
const $6e8caff8ed978edf$export$429c001938db3a78 = (props)=>{
    const { prefixCls: prefixCls, icon: icon, type: type, message: message, description: description, actions: actions, role: role = 'alert' } = props;
    let iconNode = null;
    if (icon) iconNode = /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-icon`
    }, icon);
    else if (type) iconNode = /*#__PURE__*/ $acw62.createElement($6e8caff8ed978edf$var$typeToIcon[type] || null, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-icon`, `${prefixCls}-icon-${type}`)
    });
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            [`${prefixCls}-with-icon`]: iconNode
        }),
        role: role
    }, iconNode, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-message`
    }, message), description && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-description`
    }, description), actions && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-actions`
    }, actions));
};
/** @private Internal Component. Do not use in your production. */ const $6e8caff8ed978edf$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className: className, icon: icon, type: type, message: message, description: description, btn: btn, actions: actions, closable: closable = true, closeIcon: closeIcon, className: notificationClassName } = props, restProps = $6e8caff8ed978edf$var$__rest(props, [
        "prefixCls",
        "className",
        "icon",
        "type",
        "message",
        "description",
        "btn",
        "actions",
        "closable",
        "closeIcon",
        "className"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const mergedActions = actions !== null && actions !== void 0 ? actions : btn;
    const prefixCls = staticPrefixCls || getPrefixCls('notification');
    const noticePrefixCls = `${prefixCls}-notice`;
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $6aed65619be1a08f$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${noticePrefixCls}-pure-panel`, hashId, className, cssVarCls, rootCls)
    }, /*#__PURE__*/ $acw62.createElement((0, $e2090bda964c1495$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $acw62.createElement((0, $6be5862818f90611$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        prefixCls: prefixCls,
        eventKey: "pure",
        duration: null,
        closable: closable,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            notificationClassName: notificationClassName
        }),
        closeIcon: $6e8caff8ed978edf$export$a6cccece9dc8d76a(prefixCls, closeIcon),
        content: /*#__PURE__*/ $acw62.createElement($6e8caff8ed978edf$export$429c001938db3a78, {
            prefixCls: noticePrefixCls,
            icon: icon,
            type: type,
            message: message,
            description: description,
            actions: mergedActions
        })
    }))));
};
var $6e8caff8ed978edf$export$2e2bcd8739ae039 = $6e8caff8ed978edf$var$PurePanel;



var $acw62 = parcelRequire("acw62");








function $8bf840a7558ead07$export$c3e7864cecc29b16(placement, top, bottom) {
    let style;
    switch(placement){
        case 'top':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topLeft':
            style = {
                left: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'topRight':
            style = {
                right: 0,
                top: top,
                bottom: 'auto'
            };
            break;
        case 'bottom':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: 'auto',
                bottom: bottom
            };
            break;
        case 'bottomLeft':
            style = {
                left: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
        default:
            style = {
                right: 0,
                top: 'auto',
                bottom: bottom
            };
            break;
    }
    return style;
}
function $8bf840a7558ead07$export$7b8936ddc277a29a(prefixCls) {
    return {
        motionName: `${prefixCls}-fade`
    };
}
function $8bf840a7558ead07$export$2c2219e7042654(closeIcon, notificationConfig, notification) {
    if (typeof closeIcon !== 'undefined') return closeIcon;
    if (typeof (notificationConfig === null || notificationConfig === void 0 ? void 0 : notificationConfig.closeIcon) !== 'undefined') return notificationConfig.closeIcon;
    return notification === null || notification === void 0 ? void 0 : notification.closeIcon;
}


"use client";
var $80154990762b3945$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $80154990762b3945$var$DEFAULT_OFFSET = 24;
const $80154990762b3945$var$DEFAULT_DURATION = 4.5;
const $80154990762b3945$var$DEFAULT_PLACEMENT = 'topRight';
const $80154990762b3945$var$Wrapper = ({ children: children, prefixCls: prefixCls })=>{
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $6aed65619be1a08f$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $189ebb65137099c1$export$2e2bcd8739ae039), {
        classNames: {
            list: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, cssVarCls, rootCls)
        }
    }, children));
};
const $80154990762b3945$var$renderNotifications = (node, { prefixCls: prefixCls, key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($80154990762b3945$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
const $80154990762b3945$var$Holder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { top: top, bottom: bottom, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, rtl: rtl, onAllRemoved: onAllRemoved, stack: stack, duration: duration, pauseOnHover: pauseOnHover = true, showProgress: showProgress } = props;
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, notification: notification, direction: direction } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const prefixCls = staticPrefixCls || getPrefixCls('notification');
    // =============================== Style ===============================
    const getStyle = (placement)=>(0, $8bf840a7558ead07$export$c3e7864cecc29b16)(placement, top !== null && top !== void 0 ? top : $80154990762b3945$var$DEFAULT_OFFSET, bottom !== null && bottom !== void 0 ? bottom : $80154990762b3945$var$DEFAULT_OFFSET);
    const getClassName = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $8bf840a7558ead07$export$7b8936ddc277a29a)(prefixCls);
    // ============================== Origin ===============================
    const [api, holder] = (0, $4fb0b9c84003ea9f$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        closable: true,
        closeIcon: (0, $6e8caff8ed978edf$export$a6cccece9dc8d76a)(prefixCls),
        duration: duration !== null && duration !== void 0 ? duration : $80154990762b3945$var$DEFAULT_DURATION,
        getContainer: ()=>(staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
        maxCount: maxCount,
        pauseOnHover: pauseOnHover,
        showProgress: showProgress,
        onAllRemoved: onAllRemoved,
        renderNotifications: $80154990762b3945$var$renderNotifications,
        stack: stack === false ? false : {
            threshold: typeof stack === 'object' ? stack === null || stack === void 0 ? void 0 : stack.threshold : undefined,
            offset: 8,
            gap: token.margin
        }
    });
    // ================================ Ref ================================
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>Object.assign(Object.assign({}, api), {
            prefixCls: prefixCls,
            notification: notification
        }));
    return holder;
});
function $80154990762b3945$export$c5a84bd16043292a(notificationConfig) {
    const holderRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('Notification');
    // ================================ API ================================
    const wrapAPI = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        // Wrap with notification content
        // >>> Open
        const open = (config)=>{
            var _a;
            if (!holderRef.current) return;
            const { open: originOpen, prefixCls: prefixCls, notification: notification } = holderRef.current;
            const noticePrefixCls = `${prefixCls}-notice`;
            const { message: message, description: description, icon: icon, type: type, btn: btn, actions: actions, className: className, style: style, role: role = 'alert', closeIcon: closeIcon, closable: closable } = config, restConfig = $80154990762b3945$var$__rest(config, [
                "message",
                "description",
                "icon",
                "type",
                "btn",
                "actions",
                "className",
                "style",
                "role",
                "closeIcon",
                "closable"
            ]);
            const mergedActions = actions !== null && actions !== void 0 ? actions : btn;
            const realCloseIcon = (0, $6e8caff8ed978edf$export$a6cccece9dc8d76a)(noticePrefixCls, (0, $8bf840a7558ead07$export$2c2219e7042654)(closeIcon, notificationConfig, notification));
            return originOpen(Object.assign(Object.assign({
                // use placement from props instead of hard-coding "topRight"
                placement: (_a = notificationConfig === null || notificationConfig === void 0 ? void 0 : notificationConfig.placement) !== null && _a !== void 0 ? _a : $80154990762b3945$var$DEFAULT_PLACEMENT
            }, restConfig), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6e8caff8ed978edf$export$429c001938db3a78), {
                    prefixCls: noticePrefixCls,
                    icon: icon,
                    type: type,
                    message: message,
                    description: description,
                    actions: mergedActions,
                    role: role
                }),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(type && `${noticePrefixCls}-${type}`, className, notification === null || notification === void 0 ? void 0 : notification.className),
                style: Object.assign(Object.assign({}, notification === null || notification === void 0 ? void 0 : notification.style), style),
                closeIcon: realCloseIcon,
                closable: closable !== null && closable !== void 0 ? closable : !!realCloseIcon
            }));
        };
        // >>> destroy
        const destroy = (key)=>{
            var _a, _b;
            if (key !== undefined) (_a = holderRef.current) === null || _a === void 0 || _a.close(key);
            else (_b = holderRef.current) === null || _b === void 0 || _b.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            'success',
            'info',
            'warning',
            'error'
        ];
        keys.forEach((type)=>{
            clone[type] = (config)=>open(Object.assign(Object.assign({}, config), {
                    type: type
                }));
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($80154990762b3945$var$Holder, Object.assign({
            key: "notification-holder"
        }, notificationConfig, {
            ref: holderRef
        }))
    ];
}
function $80154990762b3945$export$2e2bcd8739ae039(notificationConfig) {
    return $80154990762b3945$export$c5a84bd16043292a(notificationConfig);
}


"use client";
let $b5c555d97e03a3da$var$notification = null;
let $b5c555d97e03a3da$var$act = (callback)=>callback();
let $b5c555d97e03a3da$var$taskQueue = [];
let $b5c555d97e03a3da$var$defaultGlobalConfig = {};
function $b5c555d97e03a3da$var$getGlobalContext() {
    const { getContainer: getContainer, rtl: rtl, maxCount: maxCount, top: top, bottom: bottom, showProgress: showProgress, pauseOnHover: pauseOnHover } = $b5c555d97e03a3da$var$defaultGlobalConfig;
    const mergedContainer = (getContainer === null || getContainer === void 0 ? void 0 : getContainer()) || document.body;
    return {
        getContainer: ()=>mergedContainer,
        rtl: rtl,
        maxCount: maxCount,
        top: top,
        bottom: bottom,
        showProgress: showProgress,
        pauseOnHover: pauseOnHover
    };
}
const $b5c555d97e03a3da$var$GlobalHolder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { notificationConfig: notificationConfig, sync: sync } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = $b5c555d97e03a3da$var$defaultGlobalConfig.prefixCls || getPrefixCls('notification');
    const appConfig = (0, $acw62.useContext)((0, $ec30be32576c1d45$export$264c6064649f9206));
    const [api, holder] = (0, $80154990762b3945$export$c5a84bd16043292a)(Object.assign(Object.assign(Object.assign({}, notificationConfig), {
        prefixCls: prefixCls
    }), appConfig.notification));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(sync, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>{
        const instance = Object.assign({}, api);
        Object.keys(instance).forEach((method)=>{
            instance[method] = (...args)=>{
                sync();
                return api[method].apply(api, args);
            };
        });
        return {
            instance: instance,
            sync: sync
        };
    });
    return holder;
});
const $b5c555d97e03a3da$var$GlobalHolderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_, ref)=>{
    const [notificationConfig, setNotificationConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($b5c555d97e03a3da$var$getGlobalContext);
    const sync = ()=>{
        setNotificationConfig($b5c555d97e03a3da$var$getGlobalContext);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(sync, []);
    const global = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5c555d97e03a3da$var$GlobalHolder, {
        ref: ref,
        sync: sync,
        notificationConfig: notificationConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
function $b5c555d97e03a3da$var$flushNotice() {
    if (!$b5c555d97e03a3da$var$notification) {
        const holderFragment = document.createDocumentFragment();
        const newNotification = {
            fragment: holderFragment
        };
        $b5c555d97e03a3da$var$notification = newNotification;
        // Delay render to avoid sync issue
        $b5c555d97e03a3da$var$act(()=>{
            const reactRender = (0, $f76949e1bc95fa3b$export$4d4bf8843d204cca)();
            reactRender(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b5c555d97e03a3da$var$GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance: instance, sync: sync } = node || {};
                    Promise.resolve().then(()=>{
                        if (!newNotification.instance && instance) {
                            newNotification.instance = instance;
                            newNotification.sync = sync;
                            $b5c555d97e03a3da$var$flushNotice();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!$b5c555d97e03a3da$var$notification.instance) return;
    // >>> Execute task
    $b5c555d97e03a3da$var$taskQueue.forEach((task)=>{
        switch(task.type){
            case 'open':
                $b5c555d97e03a3da$var$act(()=>{
                    $b5c555d97e03a3da$var$notification.instance.open(Object.assign(Object.assign({}, $b5c555d97e03a3da$var$defaultGlobalConfig), task.config));
                });
                break;
            case 'destroy':
                $b5c555d97e03a3da$var$act(()=>{
                    $b5c555d97e03a3da$var$notification === null || $b5c555d97e03a3da$var$notification === void 0 || $b5c555d97e03a3da$var$notification.instance.destroy(task.key);
                });
                break;
        }
    });
    // Clean up
    $b5c555d97e03a3da$var$taskQueue = [];
}
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function $b5c555d97e03a3da$var$setNotificationGlobalConfig(config) {
    $b5c555d97e03a3da$var$defaultGlobalConfig = Object.assign(Object.assign({}, $b5c555d97e03a3da$var$defaultGlobalConfig), config);
    // Trigger sync for it
    $b5c555d97e03a3da$var$act(()=>{
        var _a;
        (_a = $b5c555d97e03a3da$var$notification === null || $b5c555d97e03a3da$var$notification === void 0 ? void 0 : $b5c555d97e03a3da$var$notification.sync) === null || _a === void 0 || _a.call($b5c555d97e03a3da$var$notification);
    });
}
function $b5c555d97e03a3da$var$open(config) {
    const global = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)();
    $b5c555d97e03a3da$var$taskQueue.push({
        type: 'open',
        config: config
    });
    $b5c555d97e03a3da$var$flushNotice();
}
const $b5c555d97e03a3da$var$destroy = (key)=>{
    $b5c555d97e03a3da$var$taskQueue.push({
        type: 'destroy',
        key: key
    });
    $b5c555d97e03a3da$var$flushNotice();
};
const $b5c555d97e03a3da$var$methods = [
    'success',
    'info',
    'warning',
    'error'
];
const $b5c555d97e03a3da$var$baseStaticMethods = {
    open: $b5c555d97e03a3da$var$open,
    destroy: $b5c555d97e03a3da$var$destroy,
    config: $b5c555d97e03a3da$var$setNotificationGlobalConfig,
    useNotification: $80154990762b3945$export$2e2bcd8739ae039,
    _InternalPanelDoNotUseOrYouWillBeFired: (0, $6e8caff8ed978edf$export$2e2bcd8739ae039)
};
const $b5c555d97e03a3da$var$staticMethods = $b5c555d97e03a3da$var$baseStaticMethods;
$b5c555d97e03a3da$var$methods.forEach((type)=>{
    $b5c555d97e03a3da$var$staticMethods[type] = (config)=>$b5c555d97e03a3da$var$open(Object.assign(Object.assign({}, config), {
            type: type
        }));
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const $b5c555d97e03a3da$var$noop = ()=>{};
let $b5c555d97e03a3da$var$_actWrapper = $b5c555d97e03a3da$var$noop;
var $b5c555d97e03a3da$var$wrapper;
const $b5c555d97e03a3da$export$71ceb3dabb09f455 = $b5c555d97e03a3da$var$_actWrapper;
let $b5c555d97e03a3da$var$_actDestroy = $b5c555d97e03a3da$var$noop;
const $b5c555d97e03a3da$export$43de32c50edff050 = $b5c555d97e03a3da$var$_actDestroy;
var $b5c555d97e03a3da$export$2e2bcd8739ae039 = $b5c555d97e03a3da$var$staticMethods;


var $acw62 = parcelRequire("acw62");

function $45dd1fc1f7b05965$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $5d1ee4070463e68c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $45dd1fc1f7b05965$export$2e2bcd8739ae039)(r);
}


function $468c951dbd78e5ea$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $9b50b9172a9c6fa1$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $45dd1fc1f7b05965$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $45dd1fc1f7b05965$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $decceeae8a34651e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $df4024303de6487a$export$2e2bcd8739ae039(r) {
    return (0, $5d1ee4070463e68c$export$2e2bcd8739ae039)(r) || (0, $468c951dbd78e5ea$export$2e2bcd8739ae039)(r) || (0, $9b50b9172a9c6fa1$export$2e2bcd8739ae039)(r) || (0, $decceeae8a34651e$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $20d973f7249e2921$var$EditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "edit",
    "theme": "outlined"
};
var $20d973f7249e2921$export$2e2bcd8739ae039 = $20d973f7249e2921$var$EditOutlined;



var $498b707c3c04dc0a$var$EditOutlined = function EditOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $20d973f7249e2921$export$2e2bcd8739ae039)
    }));
};
/**![edit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1Ny43IDc1MmMyIDAgNC0uMiA2LS41TDQzMS45IDcyMmMyLS40IDMuOS0xLjMgNS4zLTIuOGw0MjMuOS00MjMuOWE5Ljk2IDkuOTYgMCAwMDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAwOS40IDI5LjhjNi42IDYuNCAxNC45IDkuOSAyMy44IDkuOXptNjcuNC0xNzQuNEw2ODcuOCAyMTVsNzMuMyA3My4zLTM2Mi43IDM2Mi42LTg4LjkgMTUuNyAxNS42LTg5ek04ODAgODM2SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzZjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTM2YzAtMTcuNy0xNC4zLTMyLTMyLTMyeiIgLz48L3N2Zz4=) */ var $498b707c3c04dc0a$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($498b707c3c04dc0a$var$EditOutlined);
var $498b707c3c04dc0a$export$2e2bcd8739ae039 = $498b707c3c04dc0a$var$RefIcon;



function $a28919e70671c4d7$export$2e2bcd8739ae039() {
    return $a28919e70671c4d7$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a28919e70671c4d7$export$2e2bcd8739ae039.apply(null, arguments);
}



var $acw62 = parcelRequire("acw62");
function $7bd10b9589fceb70$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $7bd10b9589fceb70$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7bd10b9589fceb70$export$2e2bcd8739ae039(o);
}


var $8a016890af4a680d$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $8a016890af4a680d$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $8a016890af4a680d$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $8a016890af4a680d$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $7bd10b9589fceb70$export$2e2bcd8739ae039)(object) === 'object' && // React Element type
    (object.$$typeof === $8a016890af4a680d$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $8a016890af4a680d$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $8a016890af4a680d$var$REACT_FRAGMENT_TYPE);
}



var $acw62 = parcelRequire("acw62");
function $b467bced09f42b7b$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($b467bced09f42b7b$export$2e2bcd8739ae039(child));
        else if ((0, $8a016890af4a680d$export$2e2bcd8739ae039)(child) && child.props) ret = ret.concat($b467bced09f42b7b$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}


/* eslint-disable no-console */ var $50069a258bab3672$var$warned = {};
var $50069a258bab3672$var$preWarningFns = [];
var $50069a258bab3672$export$61616f168f0e5a05 = function preMessage(fn) {
    $50069a258bab3672$var$preWarningFns.push(fn);
};
function $50069a258bab3672$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $50069a258bab3672$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $50069a258bab3672$export$60eef1277fe463e4() {
    $50069a258bab3672$var$warned = {};
}
function $50069a258bab3672$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$50069a258bab3672$var$warned[message]) {
        method(false, message);
        $50069a258bab3672$var$warned[message] = true;
    }
}
function $50069a258bab3672$export$82934adf09101657(valid, message) {
    $50069a258bab3672$export$848feb93d8f32b9b($50069a258bab3672$export$491112666e282270, valid, message);
}
function $50069a258bab3672$export$89ff31684837bbbf(valid, message) {
    $50069a258bab3672$export$848feb93d8f32b9b($50069a258bab3672$export$a92e4c44d367d0af, valid, message);
}
$50069a258bab3672$export$82934adf09101657.preMessage = $50069a258bab3672$export$61616f168f0e5a05;
$50069a258bab3672$export$82934adf09101657.resetWarned = $50069a258bab3672$export$60eef1277fe463e4;
$50069a258bab3672$export$82934adf09101657.noteOnce = $50069a258bab3672$export$89ff31684837bbbf;
var $50069a258bab3672$export$2e2bcd8739ae039 = $50069a258bab3672$export$82934adf09101657;




function $146cadc3a77c9fa4$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7bd10b9589fceb70$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7bd10b9589fceb70$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $2a124f45b156ab3e$export$2e2bcd8739ae039(t) {
    var i = (0, $146cadc3a77c9fa4$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $7bd10b9589fceb70$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $e728f92b1e739c85$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $2a124f45b156ab3e$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $5f93abf8e8c42df1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f93abf8e8c42df1$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f93abf8e8c42df1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $e728f92b1e739c85$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f93abf8e8c42df1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}





var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $8651abcde2323e74$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $8651abcde2323e74$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $7bd10b9589fceb70$export$2e2bcd8739ae039)(node) === 'object' && $8651abcde2323e74$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($8651abcde2323e74$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $8651abcde2323e74$export$2e2bcd8739ae039(node) {
    var domNode = $8651abcde2323e74$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))), node);
    }
    return null;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $46ba0244747e8116$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $acw62.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}



var $45cbe9b172c384ee$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $7bd10b9589fceb70$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $45cbe9b172c384ee$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $45cbe9b172c384ee$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $45cbe9b172c384ee$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $46ba0244747e8116$export$2e2bcd8739ae039)(function() {
        return $45cbe9b172c384ee$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $45cbe9b172c384ee$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($45cbe9b172c384ee$var$isReactElement(nodeOrComponent) && nodeOrComponent.props.propertyIsEnumerable('ref')) return true;
    var type = (0, $3251146683c5d714$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    return true;
};
function $45cbe9b172c384ee$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(node) && !(0, $8a016890af4a680d$export$2e2bcd8739ae039)(node);
}
var $45cbe9b172c384ee$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $45cbe9b172c384ee$var$isReactElement(node) && $45cbe9b172c384ee$export$c1cec34af06bcf7(node);
};
var $45cbe9b172c384ee$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $45cbe9b172c384ee$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $23337ef780f50970$export$db36075d98ba73d3 = /*#__PURE__*/ $acw62.createContext(null);
function $23337ef780f50970$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $acw62.useRef(0);
    var resizeInfosRef = $acw62.useRef([]);
    var onCollectionResize = $acw62.useContext($23337ef780f50970$export$db36075d98ba73d3);
    var onResize = $acw62.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $acw62.createElement($23337ef780f50970$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}


/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $87c2a74187854fda$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $87c2a74187854fda$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $87c2a74187854fda$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $87c2a74187854fda$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($87c2a74187854fda$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $87c2a74187854fda$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $87c2a74187854fda$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $87c2a74187854fda$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $87c2a74187854fda$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $87c2a74187854fda$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $87c2a74187854fda$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $87c2a74187854fda$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $87c2a74187854fda$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $87c2a74187854fda$var$throttle(this.refresh.bind(this), $87c2a74187854fda$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$87c2a74187854fda$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($87c2a74187854fda$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$87c2a74187854fda$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $87c2a74187854fda$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $87c2a74187854fda$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $87c2a74187854fda$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $87c2a74187854fda$var$global$1;
};
// Placeholder of an empty content rectangle.
var $87c2a74187854fda$var$emptyRect = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $87c2a74187854fda$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $87c2a74187854fda$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $87c2a74187854fda$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $87c2a74187854fda$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $87c2a74187854fda$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $87c2a74187854fda$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $87c2a74187854fda$var$emptyRect;
    var styles = $87c2a74187854fda$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $87c2a74187854fda$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $87c2a74187854fda$var$toFloat(styles.width), height = $87c2a74187854fda$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $87c2a74187854fda$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $87c2a74187854fda$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$87c2a74187854fda$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $87c2a74187854fda$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $87c2a74187854fda$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $87c2a74187854fda$var$isDocumentElement(target) {
    return target === $87c2a74187854fda$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getContentRect(target) {
    if (!$87c2a74187854fda$var$isBrowser) return $87c2a74187854fda$var$emptyRect;
    if ($87c2a74187854fda$var$isSVGGraphicsElement(target)) return $87c2a74187854fda$var$getSVGContentRect(target);
    return $87c2a74187854fda$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $87c2a74187854fda$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $87c2a74187854fda$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $87c2a74187854fda$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $87c2a74187854fda$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $87c2a74187854fda$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $87c2a74187854fda$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $87c2a74187854fda$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $87c2a74187854fda$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $87c2a74187854fda$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $87c2a74187854fda$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $87c2a74187854fda$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $87c2a74187854fda$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $87c2a74187854fda$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $87c2a74187854fda$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $87c2a74187854fda$var$ResizeObserverController.getInstance();
        var observer = new $87c2a74187854fda$var$ResizeObserverSPI(callback, controller, this);
        $87c2a74187854fda$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $87c2a74187854fda$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $87c2a74187854fda$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $87c2a74187854fda$var$index = function() {
    // Export existing implementation if available.
    if (typeof $87c2a74187854fda$var$global$1.ResizeObserver !== 'undefined') return $87c2a74187854fda$var$global$1.ResizeObserver;
    return $87c2a74187854fda$var$ResizeObserver;
}();
var $87c2a74187854fda$export$2e2bcd8739ae039 = $87c2a74187854fda$var$index;


// =============================== Const ===============================
var $b5a1ccaa8a732edf$var$elementListeners = new Map();
function $b5a1ccaa8a732edf$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $b5a1ccaa8a732edf$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $b5a1ccaa8a732edf$var$resizeObserver = new (0, $87c2a74187854fda$export$2e2bcd8739ae039)($b5a1ccaa8a732edf$var$onResize);
var $b5a1ccaa8a732edf$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $b5a1ccaa8a732edf$export$524f0fd3b47831a = null; // eslint-disable-line
function $b5a1ccaa8a732edf$export$d1203567a167490e(element, callback) {
    if (!$b5a1ccaa8a732edf$var$elementListeners.has(element)) {
        $b5a1ccaa8a732edf$var$elementListeners.set(element, new Set());
        $b5a1ccaa8a732edf$var$resizeObserver.observe(element);
    }
    $b5a1ccaa8a732edf$var$elementListeners.get(element).add(callback);
}
function $b5a1ccaa8a732edf$export$23a2283368c55ea2(element, callback) {
    if ($b5a1ccaa8a732edf$var$elementListeners.has(element)) {
        $b5a1ccaa8a732edf$var$elementListeners.get(element).delete(callback);
        if (!$b5a1ccaa8a732edf$var$elementListeners.get(element).size) {
            $b5a1ccaa8a732edf$var$resizeObserver.unobserve(element);
            $b5a1ccaa8a732edf$var$elementListeners.delete(element);
        }
    }
}


function $d33e8b8afe44fc07$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $205e8fa603298455$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $2a124f45b156ab3e$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $205e8fa603298455$export$2e2bcd8739ae039(e, r, t) {
    return r && $205e8fa603298455$var$_defineProperties(e.prototype, r), t && $205e8fa603298455$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $a35f6decaa978ac7$export$2e2bcd8739ae039(t, e) {
    return $a35f6decaa978ac7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a35f6decaa978ac7$export$2e2bcd8739ae039(t, e);
}


function $a0befb397bacfecf$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $a35f6decaa978ac7$export$2e2bcd8739ae039)(t, e);
}


function $d946dcd3934d699f$export$2e2bcd8739ae039(t) {
    return $d946dcd3934d699f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d946dcd3934d699f$export$2e2bcd8739ae039(t);
}


function $045b2d40d27580e8$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($045b2d40d27580e8$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $cc617d000884bdcb$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $e608ffe7c655ba47$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $7bd10b9589fceb70$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cc617d000884bdcb$export$2e2bcd8739ae039)(t);
}


function $d9805b8af65a6de4$export$2e2bcd8739ae039(t) {
    var r = (0, $045b2d40d27580e8$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $d946dcd3934d699f$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $d946dcd3934d699f$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $e608ffe7c655ba47$export$2e2bcd8739ae039)(this, e);
    };
}



var $acw62 = parcelRequire("acw62");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $fc43b75a6f115f08$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $a0befb397bacfecf$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $d9805b8af65a6de4$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $d33e8b8afe44fc07$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $205e8fa603298455$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);


function $3031692a0391fb9d$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $acw62.useRef(null);
    var wrapperRef = $acw62.useRef(null);
    var onCollectionResize = $acw62.useContext((0, $23337ef780f50970$export$db36075d98ba73d3));
    // =========================== Children ===========================
    var isRenderProps = typeof children === 'function';
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $acw62.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $acw62.isValidElement(mergedChildren) && (0, $45cbe9b172c384ee$export$c1cec34af06bcf7)(mergedChildren);
    var originRef = canRef ? (0, $45cbe9b172c384ee$export$7465e5c0bf44f19a)(mergedChildren) : null;
    var mergedRef = (0, $45cbe9b172c384ee$export$1d1c999670a1285d)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $8651abcde2323e74$export$2e2bcd8739ae039)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $7bd10b9589fceb70$export$2e2bcd8739ae039)(elementRef.current) === 'object' ? (0, $8651abcde2323e74$export$2e2bcd8739ae039)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $8651abcde2323e74$export$2e2bcd8739ae039)(wrapperRef.current);
    };
    $acw62.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $acw62.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $acw62.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $5f93abf8e8c42df1$export$2e2bcd8739ae039)((0, $5f93abf8e8c42df1$export$2e2bcd8739ae039)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $acw62.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $b5a1ccaa8a732edf$export$d1203567a167490e)(currentElement, onInternalResize);
        return function() {
            return (0, $b5a1ccaa8a732edf$export$23a2283368c55ea2)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement((0, $fc43b75a6f115f08$export$2e2bcd8739ae039), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $acw62.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $3031692a0391fb9d$var$RefSingleObserver = /*#__PURE__*/ $acw62.forwardRef($3031692a0391fb9d$var$SingleObserver);
var $3031692a0391fb9d$export$2e2bcd8739ae039 = $3031692a0391fb9d$var$RefSingleObserver;




var $bdd6dfb958d0e5e7$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $bdd6dfb958d0e5e7$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === 'function' ? [
        children
    ] : (0, $b467bced09f42b7b$export$2e2bcd8739ae039)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($bdd6dfb958d0e5e7$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $acw62.createElement((0, $3031692a0391fb9d$export$2e2bcd8739ae039), (0, $a28919e70671c4d7$export$2e2bcd8739ae039)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $bdd6dfb958d0e5e7$var$RefResizeObserver = /*#__PURE__*/ $acw62.forwardRef($bdd6dfb958d0e5e7$var$ResizeObserver);
$bdd6dfb958d0e5e7$var$RefResizeObserver.Collection = (0, $23337ef780f50970$export$fb8073518f34e6ec);
var $bdd6dfb958d0e5e7$export$2e2bcd8739ae039 = $bdd6dfb958d0e5e7$var$RefResizeObserver;



var $b2fe8e7d2b657500$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $b2fe8e7d2b657500$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $b2fe8e7d2b657500$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $b2fe8e7d2b657500$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $112972238ba0eede$export$2e2bcd8739ae039)(object) === 'object' && // React Element type
    (object.$$typeof === $b2fe8e7d2b657500$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $b2fe8e7d2b657500$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $b2fe8e7d2b657500$var$REACT_FRAGMENT_TYPE);
}



var $acw62 = parcelRequire("acw62");
function $5aa78504b8a12848$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($5aa78504b8a12848$export$2e2bcd8739ae039(child));
        else if ((0, $b2fe8e7d2b657500$export$2e2bcd8739ae039)(child) && child.props) ret = ret.concat($5aa78504b8a12848$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}



var $acw62 = parcelRequire("acw62");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $16cc62d9173c0916$var$useInternalLayoutEffect = (0, $af1813123da22276$export$2e2bcd8739ae039)() ? $acw62.useLayoutEffect : $acw62.useEffect;
var $16cc62d9173c0916$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $acw62.useRef(true);
    $16cc62d9173c0916$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $16cc62d9173c0916$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $16cc62d9173c0916$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $16cc62d9173c0916$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $16cc62d9173c0916$export$2e2bcd8739ae039 = $16cc62d9173c0916$var$useLayoutEffect;



function $0911d7f0ee1d61f3$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}




function $1d7475242e810a11$export$2e2bcd8739ae039(r, e) {
    return (0, $4773d38aff43ad26$export$2e2bcd8739ae039)(r) || (0, $0911d7f0ee1d61f3$export$2e2bcd8739ae039)(r, e) || (0, $5feeebb680a9ff13$export$2e2bcd8739ae039)(r, e) || (0, $16921dce7a746d22$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");
function $e294208d67c27cfa$export$2e2bcd8739ae039(callback) {
    var fnRef = $acw62.useRef();
    fnRef.current = callback;
    var memoFn = $acw62.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}





var $acw62 = parcelRequire("acw62");
function $2afda9bbeda7c3e0$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $acw62.useRef(false);
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $1d7475242e810a11$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $acw62.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $fbd33e1a3c597913$var$hasValue(value) {
    return value !== undefined;
}
function $fbd33e1a3c597913$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $2afda9bbeda7c3e0$export$2e2bcd8739ae039)(function() {
        if ($fbd33e1a3c597913$var$hasValue(value)) return value;
        else if ($fbd33e1a3c597913$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $1d7475242e810a11$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $e294208d67c27cfa$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $2afda9bbeda7c3e0$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $1d7475242e810a11$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $16cc62d9173c0916$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $16cc62d9173c0916$export$9283e56bae2f7b0f)(function() {
        if (!$fbd33e1a3c597913$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $e294208d67c27cfa$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}


function $57c22a5a2f343bca$export$2e2bcd8739ae039(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}




var $acw62 = parcelRequire("acw62");



var $f1965a9a7a1fe067$var$ReactMajorVersion = Number((0, $acw62.version).split('.')[0]);
var $f1965a9a7a1fe067$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $112972238ba0eede$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $f1965a9a7a1fe067$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $f1965a9a7a1fe067$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $f1965a9a7a1fe067$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $3f3c7e3b4529c133$export$2e2bcd8739ae039)(function() {
        return $f1965a9a7a1fe067$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $f1965a9a7a1fe067$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($f1965a9a7a1fe067$var$isReactElement(nodeOrComponent) && $f1965a9a7a1fe067$var$ReactMajorVersion >= 19) return true;
    var type = (0, $3251146683c5d714$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    return true;
};
function $f1965a9a7a1fe067$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(node) && !(0, $b2fe8e7d2b657500$export$2e2bcd8739ae039)(node);
}
var $f1965a9a7a1fe067$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $f1965a9a7a1fe067$var$isReactElement(node) && $f1965a9a7a1fe067$export$c1cec34af06bcf7(node);
};
var $f1965a9a7a1fe067$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $f1965a9a7a1fe067$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};



var $09220ac933008db9$var$isStyleNameSupport = function isStyleNameSupport(styleName) {
    if ((0, $af1813123da22276$export$2e2bcd8739ae039)() && window.document.documentElement) {
        var styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        var documentElement = window.document.documentElement;
        return styleNameList.some(function(name) {
            return name in documentElement.style;
        });
    }
    return false;
};
var $09220ac933008db9$var$isStyleValueSupport = function isStyleValueSupport(styleName, value) {
    if (!$09220ac933008db9$var$isStyleNameSupport(styleName)) return false;
    var ele = document.createElement('div');
    var origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $09220ac933008db9$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $09220ac933008db9$var$isStyleValueSupport(styleName, styleValue);
    return $09220ac933008db9$var$isStyleNameSupport(styleName);
}





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $576260377b469890$export$2e2bcd8739ae039(props) {
    var children = props.children, prefixCls = props.prefixCls, id = props.id, innerStyle = props.overlayInnerStyle, bodyClassName = props.bodyClassName, className = props.className, style = props.style;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-inner"), bodyClassName),
        id: id,
        role: "tooltip",
        style: innerStyle
    }, typeof children === 'function' ? children() : children));
}










var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");




var $acw62 = parcelRequire("acw62");
var $b422cebf586837cd$var$OrderContext = /*#__PURE__*/ $acw62.createContext(null);
var $b422cebf586837cd$export$2e2bcd8739ae039 = $b422cebf586837cd$var$OrderContext;





var $acw62 = parcelRequire("acw62");



var $172bd5bc03f91d44$var$EMPTY_LIST = [];
function $172bd5bc03f91d44$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $acw62.useState(function() {
        if (!(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) return null;
        var defaultEle = document.createElement('div');
        return defaultEle;
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 1), ele = _React$useState2[0];
    // ========================== Order ==========================
    var appendedRef = $acw62.useRef(false);
    var queueCreate = $acw62.useContext((0, $b422cebf586837cd$export$2e2bcd8739ae039));
    var _React$useState3 = $acw62.useState($172bd5bc03f91d44$var$EMPTY_LIST), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(origin));
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($172bd5bc03f91d44$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}




var $acw62 = parcelRequire("acw62");


/* eslint-disable no-param-reassign */ 
var $217fa5593a6718d2$var$cached;
function $217fa5593a6718d2$var$measureScrollbarSize(ele) {
    var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
    var measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    var measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    var fallbackWidth;
    var fallbackHeight;
    if (ele) {
        var targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        var width = parseInt(webkitScrollbarStyle.width, 10);
        var height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
            var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
            (0, $3a22468320d7d808$export$4d99a2890bb989f0)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $3a22468320d7d808$export$2232e336aecaa80a)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $217fa5593a6718d2$export$2e2bcd8739ae039(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $217fa5593a6718d2$var$cached === undefined) $217fa5593a6718d2$var$cached = $217fa5593a6718d2$var$measureScrollbarSize();
    return $217fa5593a6718d2$var$cached.width;
}
function $217fa5593a6718d2$export$4f3ef2310365b56a(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $217fa5593a6718d2$var$measureScrollbarSize(target);
}


/**
 * Test usage export. Do not use in your production
 */ function $c9634f2c2418b2d0$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


var $66bc1eccb2a603c3$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $66bc1eccb2a603c3$var$uuid = 0;
function $66bc1eccb2a603c3$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $acw62.useState(function() {
        $66bc1eccb2a603c3$var$uuid += 1;
        return "".concat($66bc1eccb2a603c3$var$UNIQUE_ID, "_").concat($66bc1eccb2a603c3$var$uuid);
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 1), id = _React$useState2[0];
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $217fa5593a6718d2$export$4f3ef2310365b56a)(document.body).width;
            var isOverflow = (0, $c9634f2c2418b2d0$export$31b5c8f1131a3a52)();
            (0, $3a22468320d7d808$export$4d99a2890bb989f0)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : '', "\n}"), id);
        } else (0, $3a22468320d7d808$export$2232e336aecaa80a)(id);
        return function() {
            (0, $3a22468320d7d808$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


var $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = false;
function $2ccc34741b4bb73f$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === 'boolean') $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = nextInline;
    return $2ccc34741b4bb73f$export$18c8ad048e32c7d5;
}


var $ae492a4c7ad9d4f3$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
var $ae492a4c7ad9d4f3$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $acw62.useState(open), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $acw62.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    var _React$useState3 = $acw62.useState(function() {
        return $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $acw62.useEffect(function() {
        var customizeContainer = $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $172bd5bc03f91d44$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug), _useDom2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
    // ========================= Locker ==========================
    (0, $66bc1eccb2a603c3$export$2e2bcd8739ae039)(autoLock && open && (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $5e297877593af644$export$c1cec34af06bcf7)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
    // Render inline
    var renderInline = mergedContainer === false || (0, $2ccc34741b4bb73f$export$121d9fd0ca615463)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $acw62.createElement((0, $b422cebf586837cd$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $1u0KT.createPortal)(reffedChildren, mergedContainer));
});
var $ae492a4c7ad9d4f3$export$2e2bcd8739ae039 = $ae492a4c7ad9d4f3$var$Portal;



var $5b46218595a40828$export$2e2bcd8739ae039 = (0, $ae492a4c7ad9d4f3$export$2e2bcd8739ae039);





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $e85c9ef0f09d251f$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($e85c9ef0f09d251f$export$2e2bcd8739ae039(child));
        else if ((0, $3251146683c5d714$exports.isFragment)(child) && child.props) ret = ret.concat($e85c9ef0f09d251f$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}








var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $3b6981416c8ff0a7$export$db36075d98ba73d3 = /*#__PURE__*/ $acw62.createContext(null);
function $3b6981416c8ff0a7$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $acw62.useRef(0);
    var resizeInfosRef = $acw62.useRef([]);
    var onCollectionResize = $acw62.useContext($3b6981416c8ff0a7$export$db36075d98ba73d3);
    var onResize = $acw62.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $acw62.createElement($3b6981416c8ff0a7$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}



// =============================== Const ===============================
var $ed69d4f7f0510fbd$var$elementListeners = new Map();
function $ed69d4f7f0510fbd$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $ed69d4f7f0510fbd$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $ed69d4f7f0510fbd$var$resizeObserver = new (0, $87c2a74187854fda$export$2e2bcd8739ae039)($ed69d4f7f0510fbd$var$onResize);
var $ed69d4f7f0510fbd$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $ed69d4f7f0510fbd$export$524f0fd3b47831a = null; // eslint-disable-line
function $ed69d4f7f0510fbd$export$d1203567a167490e(element, callback) {
    if (!$ed69d4f7f0510fbd$var$elementListeners.has(element)) {
        $ed69d4f7f0510fbd$var$elementListeners.set(element, new Set());
        $ed69d4f7f0510fbd$var$resizeObserver.observe(element);
    }
    $ed69d4f7f0510fbd$var$elementListeners.get(element).add(callback);
}
function $ed69d4f7f0510fbd$export$23a2283368c55ea2(element, callback) {
    if ($ed69d4f7f0510fbd$var$elementListeners.has(element)) {
        $ed69d4f7f0510fbd$var$elementListeners.get(element).delete(callback);
        if (!$ed69d4f7f0510fbd$var$elementListeners.get(element).size) {
            $ed69d4f7f0510fbd$var$resizeObserver.unobserve(element);
            $ed69d4f7f0510fbd$var$elementListeners.delete(element);
        }
    }
}







var $acw62 = parcelRequire("acw62");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $1b24e2207f75c1d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);


function $2f1485708e9ce0e2$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $acw62.useRef(null);
    var wrapperRef = $acw62.useRef(null);
    var onCollectionResize = $acw62.useContext((0, $3b6981416c8ff0a7$export$db36075d98ba73d3));
    // =========================== Children ===========================
    var isRenderProps = typeof children === 'function';
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $acw62.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $acw62.isValidElement(mergedChildren) && (0, $5e297877593af644$export$c1cec34af06bcf7)(mergedChildren);
    var originRef = canRef ? mergedChildren.ref : null;
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(elementRef.current) === 'object' ? (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(wrapperRef.current);
    };
    $acw62.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $acw62.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $acw62.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $acw62.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $ed69d4f7f0510fbd$export$d1203567a167490e)(currentElement, onInternalResize);
        return function() {
            return (0, $ed69d4f7f0510fbd$export$23a2283368c55ea2)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement((0, $1b24e2207f75c1d9$export$2e2bcd8739ae039), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $acw62.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $2f1485708e9ce0e2$var$RefSingleObserver = /*#__PURE__*/ $acw62.forwardRef($2f1485708e9ce0e2$var$SingleObserver);
var $2f1485708e9ce0e2$export$2e2bcd8739ae039 = $2f1485708e9ce0e2$var$RefSingleObserver;




var $8aeee349dead8f85$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $8aeee349dead8f85$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === 'function' ? [
        children
    ] : (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($8aeee349dead8f85$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $acw62.createElement((0, $2f1485708e9ce0e2$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $8aeee349dead8f85$var$RefResizeObserver = /*#__PURE__*/ $acw62.forwardRef($8aeee349dead8f85$var$ResizeObserver);
$8aeee349dead8f85$var$RefResizeObserver.Collection = (0, $3b6981416c8ff0a7$export$fb8073518f34e6ec);
var $8aeee349dead8f85$export$2e2bcd8739ae039 = $8aeee349dead8f85$var$RefResizeObserver;








var $acw62 = parcelRequire("acw62");
function $d23d006593dfab9c$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $acw62);
    return fullClone.useId;
}
var $d23d006593dfab9c$var$uuid = 0;
function $d23d006593dfab9c$export$2f0435a662835942() {}
var $d23d006593dfab9c$var$useOriginId = $d23d006593dfab9c$var$getUseId();
var $d23d006593dfab9c$export$2e2bcd8739ae039 = $d23d006593dfab9c$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $d23d006593dfab9c$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState('ssr-id'), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        var nextId = $d23d006593dfab9c$var$uuid;
        $d23d006593dfab9c$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};



var $066d1680709fcf3c$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};



var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $c2c51b639b0318a5$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, align = props.align, arrow = props.arrow, arrowPos = props.arrowPos;
    var _ref = arrow || {}, className = _ref.className, content = _ref.content;
    var _arrowPos$x = arrowPos.x, x = _arrowPos$x === void 0 ? 0 : _arrowPos$x, _arrowPos$y = arrowPos.y, y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
    var arrowRef = $acw62.useRef();
    // Skip if no align
    if (!align || !align.points) return null;
    var alignStyle = {
        position: 'absolute'
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        var popupPoints = align.points[0];
        var targetPoints = align.points[1];
        var popupTB = popupPoints[0];
        var popupLR = popupPoints[1];
        var targetTB = targetPoints[0];
        var targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            't',
            'b'
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === 't') alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            'l',
            'r'
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === 'l') alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: arrowRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-arrow"), className),
        style: alignStyle
    }, content);
}






var $acw62 = parcelRequire("acw62");
function $c69e7bbf660984b6$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, open = props.open, zIndex = props.zIndex, mask = props.mask, motion = props.motion;
    if (!mask) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $acw62.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}



var $acw62 = parcelRequire("acw62");
var $20a13834bc71bb31$var$PopupContent = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, next) {
    return next.cache;
});
var $20a13834bc71bb31$export$2e2bcd8739ae039 = $20a13834bc71bb31$var$PopupContent;


var $d8446137fd226eb8$var$Popup = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var popup = props.popup, className = props.className, prefixCls = props.prefixCls, style = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open = props.open, keepDom = props.keepDom, fresh = props.fresh, onClick = props.onClick, mask = props.mask, arrow = props.arrow, arrowPos = props.arrowPos, align = props.align, motion = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onPointerEnter = props.onPointerEnter, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, offsetR = props.offsetR, offsetB = props.offsetB, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
    var childNode = typeof popup === 'function' ? popup() : popup;
    // We can not remove holder only when motion finished.
    var isNodeVisible = open || keepDom;
    // ======================= Container ========================
    var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
    var _React$useState = $acw62.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
    // Delay to show since `getPopupContainer` need target element
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Offset
    var AUTO = 'auto';
    var offsetStyle = {
        left: '-1000vw',
        top: '-1000vh',
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (ready || !open) {
        var _experimental;
        var points = align.points;
        var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
        var alignRight = dynamicInset && points[0][1] === 'r';
        var alignBottom = dynamicInset && points[0][0] === 'b';
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    // >>>>> Misc
    var miscStyle = {};
    if (stretch) {
        if (stretch.includes('height') && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes('minHeight') && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes('width') && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes('minWidth') && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = 'none';
    return /*#__PURE__*/ $acw62.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && function() {
            return getPopupContainer(target);
        },
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $acw62.createElement((0, $c69e7bbf660984b6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mask,
        motion: maskMotion
    }), /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onAlign,
        disabled: !open
    }, function(resizeObserverRef) {
        return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: "".concat(prefixCls, "-hidden")
        }, motion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: function onVisibleChanged(nextVisible) {
                var _motion$onVisibleChan;
                motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
                _onVisibleChanged(nextVisible);
            }
        }), function(_ref, motionRef) {
            var motionClassName = _ref.className, motionStyle = _ref.style;
            var cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, motionClassName, className);
            return /*#__PURE__*/ $acw62.createElement("div", {
                ref: (0, $5e297877593af644$export$ab452c34e8e05029)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    '--arrow-x': "".concat(arrowPos.x || 0, "px"),
                    '--arrow-y': "".concat(arrowPos.y || 0, "px")
                }, offsetStyle), miscStyle), motionStyle), {}, {
                    boxSizing: 'border-box',
                    zIndex: zIndex
                }, style),
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick
            }, arrow && /*#__PURE__*/ $acw62.createElement((0, $c2c51b639b0318a5$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $acw62.createElement((0, $20a13834bc71bb31$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, childNode));
        });
    }));
});
var $d8446137fd226eb8$export$2e2bcd8739ae039 = $d8446137fd226eb8$var$Popup;




var $acw62 = parcelRequire("acw62");
var $afb5ff905a8de769$var$TriggerWrapper = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
    var canUseRef = (0, $5e297877593af644$export$c1cec34af06bcf7)(children);
    // When use `getTriggerDOMNode`, we should do additional work to get the real dom
    var setRef = $acw62.useCallback(function(node) {
        (0, $5e297877593af644$export$f17fd18fa51dcb5b)(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
    }, [
        getTriggerDOMNode
    ]);
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(setRef, children.ref);
    return canUseRef ? /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    }) : children;
});
var $afb5ff905a8de769$export$2e2bcd8739ae039 = $afb5ff905a8de769$var$TriggerWrapper;



var $acw62 = parcelRequire("acw62");
var $f9b439e1e53d6d59$var$TriggerContext = /*#__PURE__*/ $acw62.createContext(null);
var $f9b439e1e53d6d59$export$2e2bcd8739ae039 = $f9b439e1e53d6d59$var$TriggerContext;



var $acw62 = parcelRequire("acw62");
function $65f8789299df97eb$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $65f8789299df97eb$export$2e2bcd8739ae039(mobile, action, showAction, hideAction) {
    return $acw62.useMemo(function() {
        var mergedShowAction = $65f8789299df97eb$var$toArray(showAction !== null && showAction !== void 0 ? showAction : action);
        var mergedHideAction = $65f8789299df97eb$var$toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
        var showActionSet = new Set(mergedShowAction);
        var hideActionSet = new Set(mergedHideAction);
        if (mobile) {
            if (showActionSet.has('hover')) {
                showActionSet.delete('hover');
                showActionSet.add('click');
            }
            if (hideActionSet.has('hover')) {
                hideActionSet.delete('hover');
                hideActionSet.add('click');
            }
        }
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        mobile,
        action,
        showAction,
        hideAction
    ]);
}





var $555b4eee2695f264$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};





var $acw62 = parcelRequire("acw62");

function $140ec2a5382714e1$var$isPointsEq() {
    var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $140ec2a5382714e1$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var _builtinPlacements$pl;
        var placement = placements[i];
        if ($140ec2a5382714e1$var$isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return '';
}
function $140ec2a5382714e1$export$7b8936ddc277a29a(prefixCls, motion, animation, transitionName) {
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}
function $140ec2a5382714e1$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $140ec2a5382714e1$export$ba21ed9400ca485b(ele) {
    var scrollerList = [];
    var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
    var scrollStyle = [
        'hidden',
        'scroll',
        'clip',
        'auto'
    ];
    while(current){
        var _getWin$getComputedSt = $140ec2a5382714e1$export$9c0584a7cc24d9e(current).getComputedStyle(current), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY, overflow = _getWin$getComputedSt.overflow;
        if ([
            overflowX,
            overflowY,
            overflow
        ].some(function(o) {
            return scrollStyle.includes(o);
        })) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $140ec2a5382714e1$export$34dfc8f73bbb64ae(num) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Number.isNaN(num) ? defaultValue : num;
}
function $140ec2a5382714e1$var$getPxValue(val) {
    return $140ec2a5382714e1$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $140ec2a5382714e1$export$94be9d7985092f2d(initArea, scrollerList) {
    var visibleArea = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, initArea);
    (scrollerList || []).forEach(function(ele) {
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        var _getWin$getComputedSt2 = $140ec2a5382714e1$export$9c0584a7cc24d9e(ele).getComputedStyle(ele), overflow = _getWin$getComputedSt2.overflow, overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin, borderTopWidth = _getWin$getComputedSt2.borderTopWidth, borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth, borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth, borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
        var eleRect = ele.getBoundingClientRect();
        var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
        var borderTopNum = $140ec2a5382714e1$var$getPxValue(borderTopWidth);
        var borderBottomNum = $140ec2a5382714e1$var$getPxValue(borderBottomWidth);
        var borderLeftNum = $140ec2a5382714e1$var$getPxValue(borderLeftWidth);
        var borderRightNum = $140ec2a5382714e1$var$getPxValue(borderRightWidth);
        var scaleX = $140ec2a5382714e1$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        var scaleY = $140ec2a5382714e1$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        var scaledBorderTopWidth = borderTopNum * scaleY;
        var scaledBorderBottomWidth = borderBottomNum * scaleY;
        var scaledBorderLeftWidth = borderLeftNum * scaleX;
        var scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        var clipMarginWidth = 0;
        var clipMarginHeight = 0;
        if (overflow === 'clip') {
            var clipNum = $140ec2a5382714e1$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $a3ab468f9842aab3$var$getUnitOffset(size) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var offsetStr = "".concat(offset);
    var cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $a3ab468f9842aab3$var$getNumberOffset(rect, offset) {
    var _ref = offset || [], _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), offsetX = _ref2[0], offsetY = _ref2[1];
    return [
        $a3ab468f9842aab3$var$getUnitOffset(rect.width, offsetX),
        $a3ab468f9842aab3$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $a3ab468f9842aab3$var$splitPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        points[0],
        points[1]
    ];
}
function $a3ab468f9842aab3$var$getAlignPoint(rect, points) {
    var topBottom = points[0];
    var leftRight = points[1];
    var x;
    var y;
    // Top & Bottom
    if (topBottom === 't') y = rect.y;
    else if (topBottom === 'b') y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === 'l') x = rect.x;
    else if (leftRight === 'r') x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $a3ab468f9842aab3$var$reversePoints(points, index) {
    var reverseMap = {
        t: 'b',
        b: 't',
        l: 'r',
        r: 'l'
    };
    return points.map(function(point, i) {
        if (i === index) return reverseMap[point] || 'c';
        return point;
    }).join('');
}
function $a3ab468f9842aab3$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
    var _React$useState = $acw62.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
    var alignCountRef = $acw62.useRef(0);
    var scrollerList = $acw62.useMemo(function() {
        if (!popupEle) return [];
        return (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    var prevFlipRef = $acw62.useRef({});
    var resetFlipCache = function resetFlipCache() {
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    var onAlign = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function() {
        if (popupEle && target && open) {
            var _popupElement$parentE, _popupElement$parentE2;
            var popupElement = popupEle;
            var doc = popupElement.ownerDocument;
            var win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupElement);
            var _win$getComputedStyle = win.getComputedStyle(popupElement), width = _win$getComputedStyle.width, height = _win$getComputedStyle.height, popupPosition = _win$getComputedStyle.position;
            var originLeft = popupElement.style.left;
            var originTop = popupElement.style.top;
            var originRight = popupElement.style.right;
            var originBottom = popupElement.style.bottom;
            var originOverflow = popupElement.style.overflow;
            // Placement
            var placementInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, builtinPlacements[placement]), popupAlign);
            // placeholder element
            var placeholderElement = doc.createElement('div');
            (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
            placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
            placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
            placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");
            // Reset first
            popupElement.style.left = '0';
            popupElement.style.top = '0';
            popupElement.style.right = 'auto';
            popupElement.style.bottom = 'auto';
            popupElement.style.overflow = 'hidden';
            // Calculate align style, we should consider `transform` case
            var targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                var rect = target.getBoundingClientRect();
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            var popupRect = popupElement.getBoundingClientRect();
            var _doc$documentElement = doc.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight, scrollWidth = _doc$documentElement.scrollWidth, scrollHeight = _doc$documentElement.scrollHeight, scrollTop = _doc$documentElement.scrollTop, scrollLeft = _doc$documentElement.scrollLeft;
            var popupHeight = popupRect.height;
            var popupWidth = popupRect.width;
            var targetHeight = targetRect.height;
            var targetWidth = targetRect.width;
            // Get bounding of visible area
            var visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            var scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            var htmlRegion = placementInfo.htmlRegion;
            var VISIBLE = 'visible';
            var VISIBLE_FIRST = 'visibleFirst';
            if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            var scrollRegionArea = (0, $140ec2a5382714e1$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            var visibleRegionArea = (0, $140ec2a5382714e1$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = 'auto';
            popupElement.style.top = 'auto';
            popupElement.style.right = '0';
            popupElement.style.bottom = '0';
            var popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);
            // Calculate scale
            var _scaleX = (0, $140ec2a5382714e1$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            var _scaleY = (0, $140ec2a5382714e1$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (_scaleX === 0 || _scaleY === 0 || (0, $808ab7b8a87ab771$export$41e30d8dd0ba7a50)(target) && !(0, $555b4eee2695f264$export$2e2bcd8739ae039)(target)) return;
            // Offset
            var offset = placementInfo.offset, targetOffset = placementInfo.targetOffset;
            var _getNumberOffset = $a3ab468f9842aab3$var$getNumberOffset(popupRect, offset), _getNumberOffset2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getNumberOffset, 2), popupOffsetX = _getNumberOffset2[0], popupOffsetY = _getNumberOffset2[1];
            var _getNumberOffset3 = $a3ab468f9842aab3$var$getNumberOffset(targetRect, targetOffset), _getNumberOffset4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getNumberOffset3, 2), targetOffsetX = _getNumberOffset4[0], targetOffsetY = _getNumberOffset4[1];
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            var _ref3 = placementInfo.points || [], _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), popupPoint = _ref4[0], targetPoint = _ref4[1];
            var targetPoints = $a3ab468f9842aab3$var$splitPoints(targetPoint);
            var popupPoints = $a3ab468f9842aab3$var$splitPoints(popupPoint);
            var targetAlignPoint = $a3ab468f9842aab3$var$getAlignPoint(targetRect, targetPoints);
            var popupAlignPoint = $a3ab468f9842aab3$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            var nextAlignInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, placementInfo);
            // Next Offset
            var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY) {
                var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : visibleArea;
                var l = popupRect.x + offsetX;
                var t = popupRect.y + offsetY;
                var r = l + popupWidth;
                var b = t + popupHeight;
                var visibleL = Math.max(l, area.left);
                var visibleT = Math.max(t, area.top);
                var visibleR = Math.min(r, area.right);
                var visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            var targetAlignPointTL = $a3ab468f9842aab3$var$getAlignPoint(targetRect, [
                't',
                'l'
            ]);
            var popupAlignPointTL = $a3ab468f9842aab3$var$getAlignPoint(popupRect, [
                't',
                'l'
            ]);
            var targetAlignPointBR = $a3ab468f9842aab3$var$getAlignPoint(targetRect, [
                'b',
                'r'
            ]);
            var popupAlignPointBR = $a3ab468f9842aab3$var$getAlignPoint(popupRect, [
                'b',
                'r'
            ]);
            var overflow = placementInfo.overflow || {};
            var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
            var supportAdjust = function supportAdjust(val) {
                if (typeof val === 'boolean') return val;
                return val >= 0;
            };
            // Prepare position
            var nextPopupY;
            var nextPopupBottom;
            var nextPopupX;
            var nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            var needAdjustY = supportAdjust(adjustY);
            var sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                var tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 0),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                var _tmpNextOffsetY = nextOffsetY;
                if (sameTB) _tmpNextOffsetY += popupHeight - targetHeight;
                else _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
                var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = _tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 0),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            var needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            var sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                var tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea2 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 1),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                var _tmpNextOffsetX = nextOffsetX;
                if (sameLR) _tmpNextOffsetX += popupWidth - targetWidth;
                else _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea3 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = _tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 1),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            // ============================ Shift ============================
            syncNextPopupPosition();
            var numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === 'number') {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            var numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === 'number') {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            var popupLeft = popupRect.x + nextOffsetX;
            var popupRight = popupLeft + popupWidth;
            var popupTop = popupRect.y + nextOffsetY;
            var popupBottom = popupTop + popupHeight;
            var targetLeft = targetRect.x;
            var targetRight = targetLeft + targetWidth;
            var targetTop = targetRect.y;
            var targetBottom = targetTop + targetHeight;
            var maxLeft = Math.max(popupLeft, targetLeft);
            var minRight = Math.min(popupRight, targetRight);
            var xCenter = (maxLeft + minRight) / 2;
            var nextArrowX = xCenter - popupLeft;
            var maxTop = Math.max(popupTop, targetTop);
            var minBottom = Math.min(popupBottom, targetBottom);
            var yCenter = (maxTop + minBottom) / 2;
            var nextArrowY = yCenter - popupTop;
            onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (_scaleX === 1) {
                nextOffsetX = Math.round(nextOffsetX);
                offsetX4Right = Math.round(offsetX4Right);
            }
            if (_scaleY === 1) {
                nextOffsetY = Math.round(nextOffsetY);
                offsetY4Bottom = Math.round(offsetY4Bottom);
            }
            var nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / _scaleX,
                offsetY: nextOffsetY / _scaleY,
                offsetR: offsetX4Right / _scaleX,
                offsetB: offsetY4Bottom / _scaleY,
                arrowX: nextArrowX / _scaleX,
                arrowY: nextArrowY / _scaleY,
                scaleX: _scaleX,
                scaleY: _scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    var triggerAlign = function triggerAlign() {
        alignCountRef.current += 1;
        var id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(function() {
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    var resetReady = function resetReady() {
        setOffsetInfo(function(ori) {
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, ori), {}, {
                ready: false
            });
        });
    };
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}





function $02923bfaa4b78dec$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (open && target && popup) {
            var targetElement = target;
            var popupElement = popup;
            var targetScrollList = (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(targetElement);
            var popupScrollList = (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(popupElement);
            var win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupElement);
            var mergedList = new Set([
                win
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(targetScrollList), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(popupScrollList)));
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach(function(scroller) {
                scroller.addEventListener('scroll', notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener('resize', notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return function() {
                mergedList.forEach(function(scroller) {
                    scroller.removeEventListener('scroll', notifyScroll);
                    win.removeEventListener('resize', notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}





var $acw62 = parcelRequire("acw62");

function $81078b27d1014ac5$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    var openRef = $acw62.useRef(open);
    openRef.current = open;
    // Click to hide is special action since click popup element should not hide
    $acw62.useEffect(function() {
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            var onTriggerClose = function onTriggerClose(e) {
                var _e$composedPath;
                if (openRef.current && !inPopupOrChild(((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 || (_e$composedPath = _e$composedPath.call(e)) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath[0]) || e.target)) triggerOpen(false);
            };
            var win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener('mousedown', onTriggerClose, true);
            win.addEventListener('contextmenu', onTriggerClose, true);
            // shadow root
            var targetShadowRoot = (0, $b9f59244e9def868$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
                targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
            }
            var _targetEle$getRootNod, _popupEle$getRootNode, targetRoot, popupRoot;
            return function() {
                win.removeEventListener('mousedown', onTriggerClose, true);
                win.removeEventListener('contextmenu', onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
                    targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
}



var $a99c76d30a1f506f$var$_excluded = [
    "prefixCls",
    "children",
    "action",
    "showAction",
    "hideAction",
    "popupVisible",
    "defaultPopupVisible",
    "onPopupVisibleChange",
    "afterPopupVisibleChange",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "focusDelay",
    "blurDelay",
    "mask",
    "maskClosable",
    "getPopupContainer",
    "forceRender",
    "autoDestroy",
    "destroyPopupOnHide",
    "popup",
    "popupClassName",
    "popupStyle",
    "popupPlacement",
    "builtinPlacements",
    "popupAlign",
    "zIndex",
    "stretch",
    "getPopupClassNameFromAlign",
    "fresh",
    "alignPoint",
    "onPopupClick",
    "onPopupAlign",
    "arrow",
    "popupMotion",
    "maskMotion",
    "popupTransitionName",
    "popupAnimation",
    "maskTransitionName",
    "maskAnimation",
    "className",
    "getTriggerDOMNode"
];
function $a99c76d30a1f506f$export$55e99723d7f71b47() {
    var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $5b46218595a40828$export$2e2bcd8739ae039);
    var Trigger = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-trigger-popup' : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? 'hover' : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, fresh = props.fresh, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $a99c76d30a1f506f$var$_excluded);
        var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
        // =========================== Mobile ===========================
        var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            setMobile((0, $066d1680709fcf3c$export$2e2bcd8739ae039)());
        }, []);
        // ========================== Context ===========================
        var subPopupElements = $acw62.useRef({});
        var parentContext = $acw62.useContext((0, $f9b439e1e53d6d59$export$2e2bcd8739ae039));
        var context = $acw62.useMemo(function() {
            return {
                registerSubPopup: function registerSubPopup(id, subPopupEle) {
                    subPopupElements.current[id] = subPopupEle;
                    parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // =========================== Popup ============================
        var id = (0, $d23d006593dfab9c$export$2e2bcd8739ae039)();
        var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), popupEle = _React$useState4[0], setPopupEle = _React$useState4[1];
        // Used for forwardRef popup. Not use internal
        var externalPopupRef = $acw62.useRef(null);
        var setPopupRef = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(node) {
            externalPopupRef.current = node;
            if ((0, $808ab7b8a87ab771$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
            parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        var _React$useState5 = $acw62.useState(null), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), targetEle = _React$useState6[0], setTargetEle = _React$useState6[1];
        // Used for forwardRef target. Not use internal
        var externalForwardRef = $acw62.useRef(null);
        var setTargetRef = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(node) {
            if ((0, $808ab7b8a87ab771$export$41e30d8dd0ba7a50)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        // ========================== Children ==========================
        var child = $acw62.Children.only(children);
        var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var cloneProps = {};
        var inPopupOrChild = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(ele) {
            var _getShadowRoot, _getShadowRoot2;
            var childDOM = targetEle;
            return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = (0, $b9f59244e9def868$export$70e8259662bb498b)(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = (0, $b9f59244e9def868$export$70e8259662bb498b)(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
                return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
            });
        });
        // =========================== Motion ===========================
        var mergePopupMotion = (0, $140ec2a5382714e1$export$7b8936ddc277a29a)(prefixCls, popupMotion, popupAnimation, popupTransitionName);
        var mergeMaskMotion = (0, $140ec2a5382714e1$export$7b8936ddc277a29a)(prefixCls, maskMotion, maskAnimation, maskTransitionName);
        // ============================ Open ============================
        var _React$useState7 = $acw62.useState(defaultPopupVisible || false), _React$useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState7, 2), internalOpen = _React$useState8[0], setInternalOpen = _React$useState8[1];
        // Render still use props as first priority
        var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;
        // We use effect sync here in case `popupVisible` back to `undefined`
        var setMergedOpen = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(nextOpen) {
            if (popupVisible === undefined) setInternalOpen(nextOpen);
        });
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            setInternalOpen(popupVisible || false);
        }, [
            popupVisible
        ]);
        var openRef = $acw62.useRef(mergedOpen);
        openRef.current = mergedOpen;
        var lastTriggerRef = $acw62.useRef([]);
        lastTriggerRef.current = [];
        var internalTriggerOpen = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(nextOpen) {
            var _lastTriggerRef$curre;
            setMergedOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
            }
        });
        // Trigger for delay
        var delayRef = $acw62.useRef();
        var clearDelay = function clearDelay() {
            clearTimeout(delayRef.current);
        };
        var triggerOpen = function triggerOpen(nextOpen) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            clearDelay();
            if (delay === 0) internalTriggerOpen(nextOpen);
            else delayRef.current = setTimeout(function() {
                internalTriggerOpen(nextOpen);
            }, delay * 1000);
        };
        $acw62.useEffect(function() {
            return clearDelay;
        }, []);
        // ========================== Motion ============================
        var _React$useState9 = $acw62.useState(false), _React$useState10 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState9, 2), inMotion = _React$useState10[0], setInMotion = _React$useState10[1];
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function(firstMount) {
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        var _React$useState11 = $acw62.useState(null), _React$useState12 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState11, 2), motionPrepareResolve = _React$useState12[0], setMotionPrepareResolve = _React$useState12[1];
        // =========================== Align ============================
        var _React$useState13 = $acw62.useState([
            0,
            0
        ]), _React$useState14 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState13, 2), mousePos = _React$useState14[0], setMousePos = _React$useState14[1];
        var setMousePosByEvent = function setMousePosByEvent(event) {
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        var _useAlign = (0, $a3ab468f9842aab3$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useAlign, 11), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], offsetR = _useAlign2[3], offsetB = _useAlign2[4], arrowX = _useAlign2[5], arrowY = _useAlign2[6], scaleX = _useAlign2[7], scaleY = _useAlign2[8], alignInfo = _useAlign2[9], onAlign = _useAlign2[10];
        var _useAction = (0, $65f8789299df97eb$export$2e2bcd8739ae039)(mobile, action, showAction, hideAction), _useAction2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
        var clickToShow = showActions.has('click');
        var clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
        var triggerAlign = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function() {
            if (!inMotion) onAlign();
        });
        var onScroll = function onScroll() {
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $02923bfaa4b78dec$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        var alignedClassName = $acw62.useMemo(function() {
            var baseClassName = (0, $140ec2a5382714e1$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $acw62.useImperativeHandle(ref, function() {
            return {
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            };
        });
        // ========================== Stretch ===========================
        var _React$useState15 = $acw62.useState(0), _React$useState16 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState15, 2), targetWidth = _React$useState16[0], setTargetWidth = _React$useState16[1];
        var _React$useState17 = $acw62.useState(0), _React$useState18 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState17, 2), targetHeight = _React$useState18[0], setTargetHeight = _React$useState18[1];
        var syncTargetSize = function syncTargetSize() {
            if (stretch && targetEle) {
                var rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        var onTargetResize = function onTargetResize() {
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        var onVisibleChanged = function onVisibleChanged(visible) {
            setInMotion(false);
            onAlign();
            afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
        };
        // We will trigger align when motion is in prepare
        var onPrepare = function onPrepare() {
            return new Promise(function(resolve) {
                syncTargetSize();
                setMotionPrepareResolve(function() {
                    return resolve;
                });
            });
        };
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     */ function wrapperAction(eventName, nextOpen, delay, preEvent) {
            cloneProps[eventName] = function(event) {
                var _originChildProps$eve;
                preEvent === null || preEvent === void 0 || preEvent(event);
                triggerOpen(nextOpen, delay);
                // Pass to origin
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [
                    originChildProps,
                    event
                ].concat(args));
            };
        }
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = function(event) {
            var _originChildProps$onC;
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [
                originChildProps,
                event
            ].concat(args));
        };
        // Click to hide is special action since click popup element should not hide
        (0, $81078b27d1014ac5$export$2e2bcd8739ae039)(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        var hoverToShow = showActions.has('hover');
        var hoverToHide = hideActions.has('hover');
        var onPopupMouseEnter;
        var onPopupMouseLeave;
        if (hoverToShow) {
            // Compatible with old browser which not support pointer event
            wrapperAction('onMouseEnter', true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            wrapperAction('onPointerEnter', true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            onPopupMouseEnter = function onPopupMouseEnter(event) {
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle !== null && popupEle !== void 0 && popupEle.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = function(event) {
                var _originChildProps$onM;
                // setMousePosByEvent(event);
                (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
            };
        }
        if (hoverToHide) {
            wrapperAction('onMouseLeave', false, mouseLeaveDelay);
            wrapperAction('onPointerLeave', false, mouseLeaveDelay);
            onPopupMouseLeave = function onPopupMouseLeave() {
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has('focus')) wrapperAction('onFocus', true, focusDelay);
        if (hideActions.has('focus')) wrapperAction('onBlur', false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has('contextMenu')) cloneProps.onContextMenu = function(event) {
            var _originChildProps$onC2;
            if (openRef.current && hideActions.has('contextMenu')) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [
                originChildProps,
                event
            ].concat(args));
        };
        // ========================= ClassName ==========================
        if (className) cloneProps.className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(originChildProps.className, className);
        // =========================== Render ===========================
        var mergedChildrenProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originChildProps), cloneProps);
        // Pass props into cloneProps for nest usage
        var passedProps = {};
        var passedEventList = [
            'onContextMenu',
            'onClick',
            'onMouseDown',
            'onTouchStart',
            'onMouseEnter',
            'onMouseLeave',
            'onFocus',
            'onBlur'
        ];
        passedEventList.forEach(function(eventName) {
            if (restProps[eventName]) passedProps[eventName] = function() {
                var _mergedChildrenProps$;
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [
                    mergedChildrenProps
                ].concat(args));
                restProps[eventName].apply(restProps, args);
            };
        });
        // Child Node
        var triggerNode = /*#__PURE__*/ $acw62.cloneElement(child, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedChildrenProps), passedProps));
        var arrowPos = {
            x: arrowX,
            y: arrowY
        };
        var innerArrow = arrow ? (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, arrow !== true ? arrow : {}) : null;
        // Render
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, /*#__PURE__*/ $acw62.createElement((0, $afb5ff905a8de769$export$2e2bcd8739ae039), {
            getTriggerDOMNode: getTriggerDOMNode
        }, triggerNode)), /*#__PURE__*/ $acw62.createElement((0, $f9b439e1e53d6d59$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $acw62.createElement((0, $d8446137fd226eb8$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(popupClassName, alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            mask: mask,
            motion: mergePopupMotion,
            maskMotion: mergeMaskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY
        })));
    });
    return Trigger;
}
var $a99c76d30a1f506f$export$2e2bcd8739ae039 = $a99c76d30a1f506f$export$55e99723d7f71b47((0, $5b46218595a40828$export$2e2bcd8739ae039));




var $acw62 = parcelRequire("acw62");
var $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
var $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
var $6c7c9d120875ff76$var$targetOffset = [
    0,
    0
];
var $6c7c9d120875ff76$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    }
};
var $6c7c9d120875ff76$export$2e2bcd8739ae039 = $6c7c9d120875ff76$export$803cd8101b6c182b;






var $acw62 = parcelRequire("acw62");
function $55a5a4c89e2c04a2$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $acw62);
    return fullClone.useId;
}
var $55a5a4c89e2c04a2$var$uuid = 0;
function $55a5a4c89e2c04a2$export$2f0435a662835942() {}
var $55a5a4c89e2c04a2$var$useOriginId = $55a5a4c89e2c04a2$var$getUseId();
var $55a5a4c89e2c04a2$export$2e2bcd8739ae039 = $55a5a4c89e2c04a2$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $55a5a4c89e2c04a2$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState('ssr-id'), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        var nextId = $55a5a4c89e2c04a2$var$uuid;
        $55a5a4c89e2c04a2$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};


var $870014fb7370caba$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow",
    "classNames",
    "styles"
];
var $870014fb7370caba$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, tooltipClassNames = props.classNames, tooltipStyles = props.styles, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $870014fb7370caba$var$_excluded);
    var mergedId = (0, $55a5a4c89e2c04a2$export$2e2bcd8739ae039)(id);
    var triggerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return triggerRef.current;
    });
    var extraProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps);
    if ('visible' in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $acw62.createElement((0, $576260377b469890$export$2e2bcd8739ae039), {
            key: "content",
            prefixCls: prefixCls,
            id: mergedId,
            bodyClassName: tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body,
            overlayInnerStyle: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, overlayInnerStyle), tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.body)
        }, overlay);
    };
    var getChildren = function getChildren() {
        var child = $acw62.Children.only(children);
        var originalProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var childProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originalProps), {}, {
            'aria-describedby': overlay ? mergedId : null
        });
        return /*#__PURE__*/ $acw62.cloneElement(children, childProps);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $a99c76d30a1f506f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlayClassName, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root),
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $6c7c9d120875ff76$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, overlayStyle), tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.root),
        mouseEnterDelay: mouseEnterDelay,
        arrow: showArrow
    }, extraProps), getChildren());
};
var $870014fb7370caba$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.forwardRef)($870014fb7370caba$var$Tooltip);


var $d0136ab94ce7f56e$export$2e2bcd8739ae039 = (0, $870014fb7370caba$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



function $90d00d496f52c75c$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $90d00d496f52c75c$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $b8f57191916382d3$export$2e2bcd8739ae039)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}


function $4051039ece381ef4$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $4051039ece381ef4$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $4051039ece381ef4$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $4051039ece381ef4$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}














var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $186c9d6ed579317b$export$24829b7c0e49e9f7 = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $186c9d6ed579317b$var$warningFunc = function warningFunc() {
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
var $186c9d6ed579317b$var$Context = /*#__PURE__*/ $acw62.createContext({
    getFieldValue: $186c9d6ed579317b$var$warningFunc,
    getFieldsValue: $186c9d6ed579317b$var$warningFunc,
    getFieldError: $186c9d6ed579317b$var$warningFunc,
    getFieldWarning: $186c9d6ed579317b$var$warningFunc,
    getFieldsError: $186c9d6ed579317b$var$warningFunc,
    isFieldsTouched: $186c9d6ed579317b$var$warningFunc,
    isFieldTouched: $186c9d6ed579317b$var$warningFunc,
    isFieldValidating: $186c9d6ed579317b$var$warningFunc,
    isFieldsValidating: $186c9d6ed579317b$var$warningFunc,
    resetFields: $186c9d6ed579317b$var$warningFunc,
    setFields: $186c9d6ed579317b$var$warningFunc,
    setFieldValue: $186c9d6ed579317b$var$warningFunc,
    setFieldsValue: $186c9d6ed579317b$var$warningFunc,
    validateFields: $186c9d6ed579317b$var$warningFunc,
    submit: $186c9d6ed579317b$var$warningFunc,
    getInternalHooks: function getInternalHooks() {
        $186c9d6ed579317b$var$warningFunc();
        return {
            dispatch: $186c9d6ed579317b$var$warningFunc,
            initEntityValue: $186c9d6ed579317b$var$warningFunc,
            registerField: $186c9d6ed579317b$var$warningFunc,
            useSubscribe: $186c9d6ed579317b$var$warningFunc,
            setInitialValues: $186c9d6ed579317b$var$warningFunc,
            destroyForm: $186c9d6ed579317b$var$warningFunc,
            setCallbacks: $186c9d6ed579317b$var$warningFunc,
            registerWatch: $186c9d6ed579317b$var$warningFunc,
            getFields: $186c9d6ed579317b$var$warningFunc,
            setValidateMessages: $186c9d6ed579317b$var$warningFunc,
            setPreserve: $186c9d6ed579317b$var$warningFunc,
            getInitialValue: $186c9d6ed579317b$var$warningFunc
        };
    }
});
var $186c9d6ed579317b$export$2e2bcd8739ae039 = $186c9d6ed579317b$var$Context;



var $acw62 = parcelRequire("acw62");
var $f81400e90cbb2e33$var$ListContext = /*#__PURE__*/ $acw62.createContext(null);
var $f81400e90cbb2e33$export$2e2bcd8739ae039 = $f81400e90cbb2e33$var$ListContext;


function $c9624fc8667843e4$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $c9624fc8667843e4$export$717b316e73068e8d(form) {
    return form && !!form._init;
}













function $561ee5dfc4dc516a$export$f77fd0c3b25d8534() {
    return {
        default: 'Validation error on field %s',
        required: '%s is required',
        enum: '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            boolean: '%s is not a %s',
            integer: '%s is not an %s',
            float: '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $561ee5dfc4dc516a$export$defe85febe8b728c = $561ee5dfc4dc516a$export$f77fd0c3b25d8534();











function $7fc69e80a314c4c3$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}




function $a01f1d6c8bd49d36$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $b2099f49db83e2df$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $b6acf1c5cac9dbb2$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $7fc69e80a314c4c3$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $a01f1d6c8bd49d36$export$2e2bcd8739ae039)(t, arguments, (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(Wrapper, t);
    }, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t);
}




/* eslint no-console:0 */ var $5666056929fa6d0a$var$formatRegExp = /%[sdj%]/g;
var $5666056929fa6d0a$export$491112666e282270 = function warning() {};
function $5666056929fa6d0a$export$e85887f5ceeacced(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $5666056929fa6d0a$export$d9468344d3651243(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === 'function') // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === 'string') {
        var str = template.replace($5666056929fa6d0a$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $5666056929fa6d0a$var$isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}
function $5666056929fa6d0a$export$141eca273a04dc3e(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if ($5666056929fa6d0a$var$isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function $5666056929fa6d0a$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $5666056929fa6d0a$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors || []));
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $5666056929fa6d0a$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $5666056929fa6d0a$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(objArr[k] || []));
    });
    return ret;
}
var $5666056929fa6d0a$export$188f48b73534b6f0 = /*#__PURE__*/ function(_Error) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(AsyncValidationError, _Error);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(AsyncValidationError);
    function AsyncValidationError(errors, fields) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AsyncValidationError);
        _this = _super.call(this, 'Async Validation Error');
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "errors", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "fields", void 0);
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(AsyncValidationError);
}(/*#__PURE__*/ (0, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039)(Error));
function $5666056929fa6d0a$export$707ee4c4c95d39e3(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $5666056929fa6d0a$export$188f48b73534b6f0(errors, $5666056929fa6d0a$export$e85887f5ceeacced(errors))) : resolve(source);
            };
            var flattenArr = $5666056929fa6d0a$var$flattenObjArr(objArr);
            $5666056929fa6d0a$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending.catch(function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $5666056929fa6d0a$export$188f48b73534b6f0(results, $5666056929fa6d0a$export$e85887f5ceeacced(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $5666056929fa6d0a$var$asyncSerialArray(arr, func, next);
            else $5666056929fa6d0a$var$asyncParallelArray(arr, func, next);
        });
    });
    pending.catch(function(e) {
        return e;
    });
    return pending;
}
function $5666056929fa6d0a$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $5666056929fa6d0a$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $5666056929fa6d0a$export$34d5fe50d2616cee(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $5666056929fa6d0a$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($5666056929fa6d0a$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $5666056929fa6d0a$export$6969335ea1e4e77c(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(target[s]) === 'object') target[s] = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, target[s]), value);
            else target[s] = value;
        }
    }
    return target;
}



var $488acc05b055d7b8$var$ENUM = 'enum';
var $488acc05b055d7b8$var$enumerable = function enumerable(rule, value, source, errors, options) {
    rule[$488acc05b055d7b8$var$ENUM] = Array.isArray(rule[$488acc05b055d7b8$var$ENUM]) ? rule[$488acc05b055d7b8$var$ENUM] : [];
    if (rule[$488acc05b055d7b8$var$ENUM].indexOf(value) === -1) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[$488acc05b055d7b8$var$ENUM], rule.fullField, rule[$488acc05b055d7b8$var$ENUM].join(', ')));
};
var $488acc05b055d7b8$export$2e2bcd8739ae039 = $488acc05b055d7b8$var$enumerable;



var $a35cdee3e4b23caa$var$pattern = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $a35cdee3e4b23caa$export$2e2bcd8739ae039 = $a35cdee3e4b23caa$var$pattern;



var $0c32d438c85e52c5$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === 'number';
    var min = typeof rule.min === 'number';
    var max = typeof rule.max === 'number';
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === 'number';
    var str = typeof value === 'string';
    var arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $0c32d438c85e52c5$export$2e2bcd8739ae039 = $0c32d438c85e52c5$var$range;



var $367d23b7d6b626de$var$required = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, type || rule.type))) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.required, rule.fullField));
};
var $367d23b7d6b626de$export$2e2bcd8739ae039 = $367d23b7d6b626de$var$required;





// https://github.com/kevva/url-regex/blob/master/index.js
var $717e29c17bb36fc4$var$urlReg;
var $717e29c17bb36fc4$export$2e2bcd8739ae039 = function() {
    if ($717e29c17bb36fc4$var$urlReg) return $717e29c17bb36fc4$var$urlReg;
    var word = '[a-fA-F\\d:]';
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : '';
    };
    var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    var v6seg = '[a-fA-F\\d]{1,4}';
    var v6List = [
        "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
        "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
        "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
        "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
        "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
        "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))") // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?"; // %eth0            %1
    var v6 = "(?:".concat(v6List.join('|'), ")").concat(v6Eth0);
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
    var v4exact = new RegExp("^".concat(v4, "$"));
    var v6exact = new RegExp("^".concat(v6, "$"));
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), 'g');
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), 'g');
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), 'g');
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path);
    $717e29c17bb36fc4$var$urlReg = new RegExp("(?:^".concat(regex, "$)"), 'i');
    return $717e29c17bb36fc4$var$urlReg;
};


/* eslint max-len:0 */ var $a5d3e25a95ca0fb0$var$pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $a5d3e25a95ca0fb0$var$types = {
    integer: function integer(value) {
        return $a5d3e25a95ca0fb0$var$types.number(value) && parseInt(value, 10) === value;
    },
    float: function float(value) {
        return $a5d3e25a95ca0fb0$var$types.number(value) && !$a5d3e25a95ca0fb0$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object: function object(value) {
        return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && !$a5d3e25a95ca0fb0$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === 'function';
    },
    email: function email(value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match($a5d3e25a95ca0fb0$var$pattern.email);
    },
    url: function url(value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match((0, $717e29c17bb36fc4$export$2e2bcd8739ae039)());
    },
    hex: function hex(value) {
        return typeof value === 'string' && !!value.match($a5d3e25a95ca0fb0$var$pattern.hex);
    }
};
var $a5d3e25a95ca0fb0$var$type = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        (0, $367d23b7d6b626de$export$2e2bcd8739ae039)(rule, value, source, errors, options);
        return;
    }
    var custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'number',
        'date',
        'url',
        'hex'
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$a5d3e25a95ca0fb0$var$types[ruleType](value)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) !== rule.type) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $a5d3e25a95ca0fb0$export$2e2bcd8739ae039 = $a5d3e25a95ca0fb0$var$type;



/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $14b0862e76234af4$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === '') errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.whitespace, rule.fullField));
};
var $14b0862e76234af4$export$2e2bcd8739ae039 = $14b0862e76234af4$var$whitespace;


var $0347bc150d6f2e32$export$2e2bcd8739ae039 = {
    required: (0, $367d23b7d6b626de$export$2e2bcd8739ae039),
    whitespace: (0, $14b0862e76234af4$export$2e2bcd8739ae039),
    type: (0, $a5d3e25a95ca0fb0$export$2e2bcd8739ae039),
    range: (0, $0c32d438c85e52c5$export$2e2bcd8739ae039),
    enum: (0, $488acc05b055d7b8$export$2e2bcd8739ae039),
    pattern: (0, $a35cdee3e4b23caa$export$2e2bcd8739ae039)
};



var $857fca5fb1675ca6$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $857fca5fb1675ca6$export$2e2bcd8739ae039 = $857fca5fb1675ca6$var$any;



var $e1df68b6ecc210d4$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $e1df68b6ecc210d4$export$2e2bcd8739ae039 = $e1df68b6ecc210d4$var$array;




var $02baf34e66bc03aa$var$boolean = function boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $02baf34e66bc03aa$export$2e2bcd8739ae039 = $02baf34e66bc03aa$var$boolean;




var $1138e96dc48b4fc5$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'date') && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'date')) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $1138e96dc48b4fc5$export$2e2bcd8739ae039 = $1138e96dc48b4fc5$var$date;




var $a22ed5dbeaeb8c02$var$ENUM = 'enum';
var $a22ed5dbeaeb8c02$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039)[$a22ed5dbeaeb8c02$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $a22ed5dbeaeb8c02$export$2e2bcd8739ae039 = $a22ed5dbeaeb8c02$var$enumerable;




var $4b57481f55e2d7bb$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $4b57481f55e2d7bb$export$2e2bcd8739ae039 = $4b57481f55e2d7bb$var$floatFn;




var $64c62bbb3fde492f$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $64c62bbb3fde492f$export$2e2bcd8739ae039 = $64c62bbb3fde492f$var$integer;




var $eb8f17d9362978d2$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $eb8f17d9362978d2$export$2e2bcd8739ae039 = $eb8f17d9362978d2$var$method;




var $c0807ef45346ad43$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $c0807ef45346ad43$export$2e2bcd8739ae039 = $c0807ef45346ad43$var$number;




var $04bb6b410c7a206f$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $04bb6b410c7a206f$export$2e2bcd8739ae039 = $04bb6b410c7a206f$var$object;




var $51bdf3a9527552af$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'string')) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $51bdf3a9527552af$export$2e2bcd8739ae039 = $51bdf3a9527552af$var$pattern;




var $81e7b9249a6aadc4$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value)) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $81e7b9249a6aadc4$export$2e2bcd8739ae039 = $81e7b9249a6aadc4$var$regexp;




var $9f32c5d072c41c33$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? 'array' : (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value);
    (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, type);
    callback(errors);
};
var $9f32c5d072c41c33$export$2e2bcd8739ae039 = $9f32c5d072c41c33$var$required;




var $b12128c8b08da777$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'string') && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, 'string');
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, 'string')) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $b12128c8b08da777$export$2e2bcd8739ae039 = $b12128c8b08da777$var$string;




var $a937786d6e0818eb$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, ruleType) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, ruleType);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, ruleType)) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $a937786d6e0818eb$export$2e2bcd8739ae039 = $a937786d6e0818eb$var$type;


var $562afa29da428a80$export$2e2bcd8739ae039 = {
    string: (0, $b12128c8b08da777$export$2e2bcd8739ae039),
    method: (0, $eb8f17d9362978d2$export$2e2bcd8739ae039),
    number: (0, $c0807ef45346ad43$export$2e2bcd8739ae039),
    boolean: (0, $02baf34e66bc03aa$export$2e2bcd8739ae039),
    regexp: (0, $81e7b9249a6aadc4$export$2e2bcd8739ae039),
    integer: (0, $64c62bbb3fde492f$export$2e2bcd8739ae039),
    float: (0, $4b57481f55e2d7bb$export$2e2bcd8739ae039),
    array: (0, $e1df68b6ecc210d4$export$2e2bcd8739ae039),
    object: (0, $04bb6b410c7a206f$export$2e2bcd8739ae039),
    enum: (0, $a22ed5dbeaeb8c02$export$2e2bcd8739ae039),
    pattern: (0, $51bdf3a9527552af$export$2e2bcd8739ae039),
    date: (0, $1138e96dc48b4fc5$export$2e2bcd8739ae039),
    url: (0, $a937786d6e0818eb$export$2e2bcd8739ae039),
    hex: (0, $a937786d6e0818eb$export$2e2bcd8739ae039),
    email: (0, $a937786d6e0818eb$export$2e2bcd8739ae039),
    required: (0, $9f32c5d072c41c33$export$2e2bcd8739ae039),
    any: (0, $857fca5fb1675ca6$export$2e2bcd8739ae039)
};




/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $4b94184ce2afa17e$var$Schema = /*#__PURE__*/ function() {
    function Schema(descriptor) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Schema);
        // ======================== Instance ========================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "rules", null);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_messages", (0, $561ee5dfc4dc516a$export$defe85febe8b728c));
        this.define(descriptor);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Schema, [
        {
            key: "define",
            value: function define(rules) {
                var _this = this;
                if (!rules) throw new Error('Cannot configure a schema with no rules');
                if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(rules) !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
                this.rules = {};
                Object.keys(rules).forEach(function(name) {
                    var item = rules[name];
                    _this.rules[name] = Array.isArray(item) ? item : [
                        item
                    ];
                });
            }
        },
        {
            key: "messages",
            value: function messages(_messages) {
                if (_messages) this._messages = (0, $5666056929fa6d0a$export$6969335ea1e4e77c)((0, $561ee5dfc4dc516a$export$f77fd0c3b25d8534)(), _messages);
                return this._messages;
            }
        },
        {
            key: "validate",
            value: function validate(source_) {
                var _this2 = this;
                var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                var source = source_;
                var options = o;
                var callback = oc;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!this.rules || Object.keys(this.rules).length === 0) {
                    if (callback) callback(null, source);
                    return Promise.resolve(source);
                }
                function complete(results) {
                    var errors = [];
                    var fields = {};
                    function add(e) {
                        if (Array.isArray(e)) {
                            var _errors;
                            errors = (_errors = errors).concat.apply(_errors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(e));
                        } else errors.push(e);
                    }
                    for(var i = 0; i < results.length; i++)add(results[i]);
                    if (!errors.length) callback(null, source);
                    else {
                        fields = (0, $5666056929fa6d0a$export$e85887f5ceeacced)(errors);
                        callback(errors, fields);
                    }
                }
                if (options.messages) {
                    var messages = this.messages();
                    if (messages === (0, $561ee5dfc4dc516a$export$defe85febe8b728c)) messages = (0, $561ee5dfc4dc516a$export$f77fd0c3b25d8534)();
                    (0, $5666056929fa6d0a$export$6969335ea1e4e77c)(messages, options.messages);
                    options.messages = messages;
                } else options.messages = this.messages();
                var series = {};
                var keys = options.keys || Object.keys(this.rules);
                keys.forEach(function(z) {
                    var arr = _this2.rules[z];
                    var value = source[z];
                    arr.forEach(function(r) {
                        var rule = r;
                        if (typeof rule.transform === 'function') {
                            if (source === source_) source = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
                            value = source[z] = rule.transform(value);
                            if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? 'array' : (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value));
                        }
                        if (typeof rule === 'function') rule = {
                            validator: rule
                        };
                        else rule = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rule);
                        // Fill validator. Skip if nothing need to validate
                        rule.validator = _this2.getValidationMethod(rule);
                        if (!rule.validator) return;
                        rule.field = z;
                        rule.fullField = rule.fullField || z;
                        rule.type = _this2.getType(rule);
                        series[z] = series[z] || [];
                        series[z].push({
                            rule: rule,
                            value: value,
                            source: source,
                            field: z
                        });
                    });
                });
                var errorFields = {};
                return (0, $5666056929fa6d0a$export$707ee4c4c95d39e3)(series, options, function(data, doIt) {
                    var rule = data.rule;
                    var deep = (rule.type === 'object' || rule.type === 'array') && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(rule.fields) === 'object' || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(rule.defaultField) === 'object');
                    deep = deep && (rule.required || !rule.required && data.value);
                    rule.field = data.field;
                    function addFullField(key, schema) {
                        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, schema), {}, {
                            fullField: "".concat(rule.fullField, ".").concat(key),
                            fullFields: rule.fullFields ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(rule.fullFields), [
                                key
                            ]) : [
                                key
                            ]
                        });
                    }
                    function cb() {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var errorList = Array.isArray(e) ? e : [
                            e
                        ];
                        if (!options.suppressWarning && errorList.length) Schema.warning('async-validator:', errorList);
                        if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                        // Fill error info
                        var filledErrors = errorList.map((0, $5666056929fa6d0a$export$34d5fe50d2616cee)(rule, source));
                        if (options.first && filledErrors.length) {
                            errorFields[rule.field] = 1;
                            return doIt(filledErrors);
                        }
                        if (!deep) doIt(filledErrors);
                        else {
                            // if rule is required but the target object
                            // does not exist fail at the rule level and don't
                            // go deeper
                            if (rule.required && !data.value) {
                                if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, $5666056929fa6d0a$export$34d5fe50d2616cee)(rule, source));
                                else if (options.error) filledErrors = [
                                    options.error(rule, (0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.required, rule.field))
                                ];
                                return doIt(filledErrors);
                            }
                            var fieldsSchema = {};
                            if (rule.defaultField) Object.keys(data.value).map(function(key) {
                                fieldsSchema[key] = rule.defaultField;
                            });
                            fieldsSchema = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, fieldsSchema), data.rule.fields);
                            var paredFieldsSchema = {};
                            Object.keys(fieldsSchema).forEach(function(field) {
                                var fieldSchema = fieldsSchema[field];
                                var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                                    fieldSchema
                                ];
                                paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                            });
                            var schema = new Schema(paredFieldsSchema);
                            schema.messages(options.messages);
                            if (data.rule.options) {
                                data.rule.options.messages = options.messages;
                                data.rule.options.error = options.error;
                            }
                            schema.validate(data.value, data.rule.options || options, function(errs) {
                                var finalErrors = [];
                                if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(filledErrors));
                                if (errs && errs.length) finalErrors.push.apply(finalErrors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errs));
                                doIt(finalErrors.length ? finalErrors : null);
                            });
                        }
                    }
                    var res;
                    if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
                    else if (rule.validator) {
                        try {
                            res = rule.validator(rule, data.value, cb, data.source, options);
                        } catch (error) {
                            var _console$error, _console;
                            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error);
                            // rethrow to report error
                            if (!options.suppressValidatorError) setTimeout(function() {
                                throw error;
                            }, 0);
                            cb(error.message);
                        }
                        if (res === true) cb();
                        else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
                        else if (res instanceof Array) cb(res);
                        else if (res instanceof Error) cb(res.message);
                    }
                    if (res && res.then) res.then(function() {
                        return cb();
                    }, function(e) {
                        return cb(e);
                    });
                }, function(results) {
                    complete(results);
                }, source);
            }
        },
        {
            key: "getType",
            value: function getType(rule) {
                if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
                if (typeof rule.validator !== 'function' && rule.type && !(0, $562afa29da428a80$export$2e2bcd8739ae039).hasOwnProperty(rule.type)) throw new Error((0, $5666056929fa6d0a$export$d9468344d3651243)('Unknown rule type %s', rule.type));
                return rule.type || 'string';
            }
        },
        {
            key: "getValidationMethod",
            value: function getValidationMethod(rule) {
                if (typeof rule.validator === 'function') return rule.validator;
                var keys = Object.keys(rule);
                var messageIndex = keys.indexOf('message');
                if (messageIndex !== -1) keys.splice(messageIndex, 1);
                if (keys.length === 1 && keys[0] === 'required') return (0, $562afa29da428a80$export$2e2bcd8739ae039).required;
                return (0, $562afa29da428a80$export$2e2bcd8739ae039)[this.getType(rule)] || undefined;
            }
        }
    ]);
    return Schema;
}();
// ========================= Static =========================
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "register", function register(type, validator) {
    if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
    (0, $562afa29da428a80$export$2e2bcd8739ae039)[type] = validator;
});
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "warning", (0, $5666056929fa6d0a$export$491112666e282270));
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "messages", (0, $561ee5dfc4dc516a$export$defe85febe8b728c));
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "validators", (0, $562afa29da428a80$export$2e2bcd8739ae039));
var $4b94184ce2afa17e$export$2e2bcd8739ae039 = $4b94184ce2afa17e$var$Schema;



var $acw62 = parcelRequire("acw62");

var $ebfc45d3b86f29a2$var$typeTemplate = "'${name}' is not a valid ${type}";
var $ebfc45d3b86f29a2$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $ebfc45d3b86f29a2$var$typeTemplate,
        method: $ebfc45d3b86f29a2$var$typeTemplate,
        array: $ebfc45d3b86f29a2$var$typeTemplate,
        object: $ebfc45d3b86f29a2$var$typeTemplate,
        number: $ebfc45d3b86f29a2$var$typeTemplate,
        date: $ebfc45d3b86f29a2$var$typeTemplate,
        boolean: $ebfc45d3b86f29a2$var$typeTemplate,
        integer: $ebfc45d3b86f29a2$var$typeTemplate,
        float: $ebfc45d3b86f29a2$var$typeTemplate,
        regexp: $ebfc45d3b86f29a2$var$typeTemplate,
        email: $ebfc45d3b86f29a2$var$typeTemplate,
        url: $ebfc45d3b86f29a2$var$typeTemplate,
        hex: $ebfc45d3b86f29a2$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};



// Remove incorrect original ts define
var $66537bc44202668a$var$AsyncValidator = (0, $4b94184ce2afa17e$export$2e2bcd8739ae039);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $66537bc44202668a$var$replaceMessage(template, kv) {
    return template.replace(/\\?\$\{\w+\}/g, function(str) {
        if (str.startsWith('\\')) return str.slice(1);
        var key = str.slice(2, -1);
        return kv[key];
    });
}
var $66537bc44202668a$var$CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
function $66537bc44202668a$var$validateRule(_x, _x2, _x3, _x4, _x5) {
    return $66537bc44202668a$var$_validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ function $66537bc44202668a$var$_validateRule() {
    $66537bc44202668a$var$_validateRule = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee2(name, value, rule, options, messageVariables) {
        var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cloneRule = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rule); // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
                    $66537bc44202668a$var$AsyncValidator.warning = function() {
                        return void 0;
                    };
                    if (cloneRule.validator) {
                        originValidator = cloneRule.validator;
                        cloneRule.validator = function() {
                            try {
                                return originValidator.apply(void 0, arguments);
                            } catch (error) {
                                console.error(error);
                                return Promise.reject($66537bc44202668a$var$CODE_LOGIC_ERROR);
                            }
                        };
                    }
                    // We should special handle array validate
                    subRuleField = null;
                    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
                        subRuleField = cloneRule.defaultField;
                        delete cloneRule.defaultField;
                    }
                    validator = new $66537bc44202668a$var$AsyncValidator((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, name, [
                        cloneRule
                    ]));
                    messages = (0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)((0, $ebfc45d3b86f29a2$export$c86b939816b8fbf8), options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _context2.prev = 10;
                    _context2.next = 13;
                    return Promise.resolve(validator.validate((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, name, value), (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, options)));
                case 13:
                    _context2.next = 18;
                    break;
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](10);
                    if (_context2.t0.errors) result = _context2.t0.errors.map(function(_ref4, index) {
                        var message = _ref4.message;
                        var mergedMessage = message === $66537bc44202668a$var$CODE_LOGIC_ERROR ? messages.default : message;
                        return /*#__PURE__*/ $acw62.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
                        $acw62.cloneElement(mergedMessage, {
                            key: "error_".concat(index)
                        }) : mergedMessage;
                    });
                case 18:
                    if (!(!result.length && subRuleField)) {
                        _context2.next = 23;
                        break;
                    }
                    _context2.next = 21;
                    return Promise.all(value.map(function(subValue, i) {
                        return $66537bc44202668a$var$validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
                    }));
                case 21:
                    subResults = _context2.sent;
                    return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
                        return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prev), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors));
                    }, []));
                case 23:
                    // Replace message with variables
                    kv = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rule), {}, {
                        name: name,
                        enum: (rule.enum || []).join(', ')
                    }, messageVariables);
                    fillVariableResult = result.map(function(error) {
                        if (typeof error === 'string') return $66537bc44202668a$var$replaceMessage(error, kv);
                        return error;
                    });
                    return _context2.abrupt("return", fillVariableResult);
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                10,
                15
            ]
        ]);
    }));
    return $66537bc44202668a$var$_validateRule.apply(this, arguments);
}
function $66537bc44202668a$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    var name = namePath.join('.');
    // Fill rule with context
    var filledRules = rules.map(function(currentRule, ruleIndex) {
        var originValidatorFunc = currentRule.validator;
        var cloneRule = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, currentRule), {}, {
            ruleIndex: ruleIndex
        });
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = function(rule, val, callback) {
            var hasPromise = false;
            // Wrap callback only accept when promise not provided
            var wrappedCallback = function wrappedCallback() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(function() {
                    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback.apply(void 0, args);
                });
            };
            // Get promise
            var promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(function() {
                callback();
            }).catch(function(err) {
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(function(_ref, _ref2) {
        var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
        var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    var summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/ function() {
        var _ref3 = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee(resolve, reject) {
            var i, rule, errors;
            return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < filledRules.length)) {
                            _context.next = 12;
                            break;
                        }
                        rule = filledRules[i];
                        _context.next = 5;
                        return $66537bc44202668a$var$validateRule(name, value, rule, options, messageVariables);
                    case 5:
                        errors = _context.sent;
                        if (!errors.length) {
                            _context.next = 9;
                            break;
                        }
                        reject([
                            {
                                errors: errors,
                                rule: rule
                            }
                        ]);
                        return _context.abrupt("return");
                    case 9:
                        i += 1;
                        _context.next = 1;
                        break;
                    case 12:
                        /* eslint-enable */ resolve([]);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }());
    else {
        // >>>>> Validate by parallel
        var rulePromises = filledRules.map(function(rule) {
            return $66537bc44202668a$var$validateRule(name, value, rule, options, messageVariables).then(function(errors) {
                return {
                    errors: errors,
                    rule: rule
                };
            });
        });
        summaryPromise = (validateFirst ? $66537bc44202668a$var$finishOnFirstFailed(rulePromises) : $66537bc44202668a$var$finishOnAllFailed(rulePromises)).then(function(errors) {
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch(function(e) {
        return e;
    });
    return summaryPromise;
}
function $66537bc44202668a$var$finishOnAllFailed(_x8) {
    return $66537bc44202668a$var$_finishOnAllFailed.apply(this, arguments);
}
function $66537bc44202668a$var$_finishOnAllFailed() {
    $66537bc44202668a$var$_finishOnAllFailed = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee3(rulePromises) {
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
                        var _ref5;
                        var errors = (_ref5 = []).concat.apply(_ref5, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errorsList));
                        return errors;
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $66537bc44202668a$var$_finishOnAllFailed.apply(this, arguments);
}
function $66537bc44202668a$var$finishOnFirstFailed(_x9) {
    return $66537bc44202668a$var$_finishOnFirstFailed.apply(this, arguments);
}
function $66537bc44202668a$var$_finishOnFirstFailed() {
    $66537bc44202668a$var$_finishOnFirstFailed = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee4(rulePromises) {
        var count;
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    count = 0;
                    return _context4.abrupt("return", new Promise(function(resolve) {
                        rulePromises.forEach(function(promise) {
                            promise.then(function(ruleError) {
                                if (ruleError.errors.length) resolve([
                                    ruleError
                                ]);
                                count += 1;
                                if (count === rulePromises.length) resolve([]);
                            });
                        });
                    }));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $66537bc44202668a$var$_finishOnFirstFailed.apply(this, arguments);
}







function $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9(path) {
    return (0, $c9624fc8667843e4$export$45b10814cc054894)(path);
}
function $f0c87cef6ee60bcb$export$f5be6dfb30403c59(store, namePathList) {
    var newStore = {};
    namePathList.forEach(function(namePath) {
        var value = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(store, namePath);
        newStore = (0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(newStore, namePath, value);
    });
    return newStore;
}
function $f0c87cef6ee60bcb$export$646d5504364ae55b(namePathList, namePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return namePathList && namePathList.some(function(path) {
        return $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a(namePath, path, partialMatch);
    });
}
function $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a(namePath, subNamePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every(function(nameUnit, i) {
        return namePath[i] === nameUnit;
    });
}
function $f0c87cef6ee60bcb$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(source) !== 'object' || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(target) !== 'object') return false;
    var sourceKeys = Object.keys(source);
    var targetKeys = Object.keys(target);
    var keys = new Set([].concat(sourceKeys, targetKeys));
    return (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keys).every(function(key) {
        var sourceValue = source[key];
        var targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function $f0c87cef6ee60bcb$export$6eeac3c5b406fb30(valuePropName) {
    var event = arguments.length <= 1 ? undefined : arguments[1];
    if (event && event.target && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(event.target) === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $f0c87cef6ee60bcb$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    var length = array.length;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    var item = array[moveIndex];
    var diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(0, toIndex)), [
        item
    ], (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(toIndex, moveIndex)), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(moveIndex + 1, length)));
    if (diff < 0) // move right
    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(0, moveIndex)), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(moveIndex + 1, toIndex + 1)), [
        item
    ], (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(toIndex + 1, length)));
    return array;
}


var $3299c229146a7fb5$var$_excluded = [
    "name"
];
var $3299c229146a7fb5$var$EMPTY_ERRORS = [];
function $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var $3299c229146a7fb5$var$Field = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Field, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Field);
    // ============================== Subscriptions ==============================
    function Field(props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Field);
        _this = _super.call(this, props);
        // Register on init
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            resetCount: 0
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "cancelRegisterFunc", null);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "mounted", false);
        /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "touched", false);
        /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "dirty", false);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "validatePromise", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "prevValidating", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "errors", $3299c229146a7fb5$var$EMPTY_ERRORS);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "warnings", $3299c229146a7fb5$var$EMPTY_ERRORS);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "cancelRegister", function() {
            var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
            if (_this.cancelRegisterFunc) _this.cancelRegisterFunc(isListField, preserve, (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name));
            _this.cancelRegisterFunc = null;
        });
        // ================================== Utils ==================================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getNamePath", function() {
            var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
            var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
            return name !== undefined ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prefixName), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(name)) : [];
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getRules", function() {
            var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
            return rules.map(function(rule) {
                if (typeof rule === 'function') return rule(fieldContext);
                return rule;
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "refresh", function() {
            if (!_this.mounted) return;
            /**
       * Clean up current node.
       */ _this.setState(function(_ref) {
                var resetCount = _ref.resetCount;
                return {
                    resetCount: resetCount + 1
                };
            });
        });
        // Event should only trigger when meta changed
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "metaCache", null);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "triggerMetaEvent", function(destroy) {
            var onMetaChange = _this.props.onMetaChange;
            if (onMetaChange) {
                var _meta = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.getMeta()), {}, {
                    destroy: destroy
                });
                if (!(0, $357adc8667cde522$export$2e2bcd8739ae039)(_this.metaCache, _meta)) onMetaChange(_meta);
                _this.metaCache = _meta;
            } else _this.metaCache = null;
        });
        // ========================= Field Entity Interfaces =========================
        // Trigger by store update. Check if need update the component
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onStoreChange", function(prevStore, namePathList, info) {
            var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
            var store = info.store;
            var namePath = _this.getNamePath();
            var prevValue = _this.getValue(prevStore);
            var curValue = _this.getValue(store);
            var namePathMatch = namePathList && (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(namePathList, namePath);
            // `setFieldsValue` is a quick access to update related status
            if (info.type === 'valueUpdate' && info.source === 'external' && !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prevValue, curValue)) {
                _this.touched = true;
                _this.dirty = true;
                _this.validatePromise = null;
                _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
                _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
                _this.triggerMetaEvent();
            }
            switch(info.type){
                case 'reset':
                    if (!namePathList || namePathMatch) {
                        // Clean up state
                        _this.touched = false;
                        _this.dirty = false;
                        _this.validatePromise = undefined;
                        _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.triggerMetaEvent();
                        onReset === null || onReset === void 0 || onReset();
                        _this.refresh();
                        return;
                    }
                    break;
                /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */ case 'remove':
                    if (shouldUpdate && $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'setField':
                    var data = info.data;
                    if (namePathMatch) {
                        if ('touched' in data) _this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) _this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) _this.errors = data.errors || $3299c229146a7fb5$var$EMPTY_ERRORS;
                        if ('warnings' in data) _this.warnings = data.warnings || $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.dirty = true;
                        _this.triggerMetaEvent();
                        _this.reRender();
                        return;
                    } else if ('value' in data && (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        _this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'dependenciesUpdate':
                    /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */ var dependencyList = dependencies.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some(function(dependency) {
                        return (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(info.relatedFields, dependency);
                    })) {
                        _this.reRender();
                        return;
                    }
                    break;
                default:
                    // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                    //      For example <List name="list"><Field name={['list', 0]}></List>
                    //      If `namePathList` is [['list']] (List value update), Field should be updated
                    //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                    // 2.
                    //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                    //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                    //       is not provided
                    //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                    //       else to check if value changed
                    if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
            }
            if (shouldUpdate === true) _this.reRender();
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "validateRules", function(options) {
            // We should fixed namePath & value to avoid developer change then by form function
            var namePath = _this.getNamePath();
            var currentValue = _this.getValue();
            var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
            // Force change to async to avoid rule OOD under renderProps field
            var rootPromise = Promise.resolve().then(/*#__PURE__*/ (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee() {
                var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
                return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (_this.mounted) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 2:
                            _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
                            filteredRules = _this.getRules();
                            if (triggerName) filteredRules = filteredRules.filter(function(rule) {
                                return rule;
                            }).filter(function(rule) {
                                var validateTrigger = rule.validateTrigger;
                                if (!validateTrigger) return true;
                                var triggerList = (0, $c9624fc8667843e4$export$45b10814cc054894)(validateTrigger);
                                return triggerList.includes(triggerName);
                            });
                            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
                            if (!(validateDebounce && triggerName)) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 8;
                            return new Promise(function(resolve) {
                                setTimeout(resolve, validateDebounce);
                            });
                        case 8:
                            if (!(_this.validatePromise !== rootPromise)) {
                                _context.next = 10;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 10:
                            promise = (0, $66537bc44202668a$export$e1fc4b442d0297dd)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                            promise.catch(function(e) {
                                return e;
                            }).then(function() {
                                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $3299c229146a7fb5$var$EMPTY_ERRORS;
                                if (_this.validatePromise === rootPromise) {
                                    var _ruleErrors$forEach;
                                    _this.validatePromise = null;
                                    // Get errors & warnings
                                    var nextErrors = [];
                                    var nextWarnings = [];
                                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                                        var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? $3299c229146a7fb5$var$EMPTY_ERRORS : _ref4$errors;
                                        if (warningOnly) nextWarnings.push.apply(nextWarnings, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors));
                                        else nextErrors.push.apply(nextErrors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors));
                                    });
                                    _this.errors = nextErrors;
                                    _this.warnings = nextWarnings;
                                    _this.triggerMetaEvent();
                                    _this.reRender();
                                }
                            });
                            return _context.abrupt("return", promise);
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            if (validateOnly) return rootPromise;
            _this.validatePromise = rootPromise;
            _this.dirty = true;
            _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
            _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
            _this.triggerMetaEvent();
            // Force trigger re-render since we need sync renderProps with new meta
            _this.reRender();
            return rootPromise;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isFieldValidating", function() {
            return !!_this.validatePromise;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isFieldTouched", function() {
            return _this.touched;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isFieldDirty", function() {
            // Touched or validate or has initialValue
            if (_this.dirty || _this.props.initialValue !== undefined) return true;
            // Form set initialValue
            var fieldContext = _this.props.fieldContext;
            var _fieldContext$getInte = fieldContext.getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), getInitialValue = _fieldContext$getInte.getInitialValue;
            if (getInitialValue(_this.getNamePath()) !== undefined) return true;
            return false;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getErrors", function() {
            return _this.errors;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getWarnings", function() {
            return _this.warnings;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isListField", function() {
            return _this.props.isListField;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isList", function() {
            return _this.props.isList;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isPreserve", function() {
            return _this.props.preserve;
        });
        // ============================= Child Component =============================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getMeta", function() {
            // Make error & validating in cache to save perf
            _this.prevValidating = _this.isFieldValidating();
            var meta = {
                touched: _this.isFieldTouched(),
                validating: _this.prevValidating,
                errors: _this.errors,
                warnings: _this.warnings,
                name: _this.getNamePath(),
                validated: _this.validatePromise === null
            };
            return meta;
        });
        // Only return validate child node. If invalidate, will do nothing about field.
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getOnlyChild", function(children) {
            // Support render props
            if (typeof children === 'function') {
                var _meta2 = _this.getMeta();
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
                    isFunction: true
                });
            }
            // Filed element only
            var childList = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children);
            if (childList.length !== 1 || !/*#__PURE__*/ $acw62.isValidElement(childList[0])) return {
                child: childList,
                isFunction: false
            };
            return {
                child: childList[0],
                isFunction: false
            };
        });
        // ============================== Field Control ==============================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getValue", function(store) {
            var getFieldsValue = _this.props.fieldContext.getFieldsValue;
            var namePath = _this.getNamePath();
            return (0, $17fcde5782384c29$export$2e2bcd8739ae039)(store || getFieldsValue(true), namePath);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getControlled", function() {
            var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props6 = _this.props, name = _this$props6.name, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
            var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
            var namePath = _this.getNamePath();
            var getInternalHooks = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
            var _getInternalHooks = getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), dispatch = _getInternalHooks.dispatch;
            var value = _this.getValue();
            var mergedGetValueProps = getValueProps || function(val) {
                return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, valuePropName, val);
            };
            var originTriggerFunc = childProps[trigger];
            var valueProps = name !== undefined ? mergedGetValueProps(value) : {};
            var control = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, childProps), valueProps);
            // Add trigger
            control[trigger] = function() {
                // Mark as touched
                _this.touched = true;
                _this.dirty = true;
                _this.triggerMetaEvent();
                var newValue;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (getValueFromEvent) newValue = getValueFromEvent.apply(void 0, args);
                else newValue = (0, $f0c87cef6ee60bcb$export$6eeac3c5b406fb30).apply(void 0, [
                    valuePropName
                ].concat(args));
                if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
                if (newValue !== value) dispatch({
                    type: 'updateValue',
                    namePath: namePath,
                    value: newValue
                });
                if (originTriggerFunc) originTriggerFunc.apply(void 0, args);
            };
            // Add validateTrigger
            var validateTriggerList = (0, $c9624fc8667843e4$export$45b10814cc054894)(mergedValidateTrigger || []);
            validateTriggerList.forEach(function(triggerName) {
                // Wrap additional function of component, so that we can get latest value from store
                var originTrigger = control[triggerName];
                control[triggerName] = function() {
                    if (originTrigger) originTrigger.apply(void 0, arguments);
                    // Always use latest rules
                    var rules = _this.props.rules;
                    if (rules && rules.length) // We dispatch validate to root,
                    // since it will update related data with other field with same name
                    dispatch({
                        type: 'validateField',
                        namePath: namePath,
                        triggerName: triggerName
                    });
                };
            });
            return control;
        });
        if (props.fieldContext) {
            var getInternalHooks = props.fieldContext.getInternalHooks;
            var _getInternalHooks2 = getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), initEntityValue = _getInternalHooks2.initEntityValue;
            initEntityValue((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Field, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
                this.mounted = true;
                // Register on init
                if (fieldContext) {
                    var getInternalHooks = fieldContext.getInternalHooks;
                    var _getInternalHooks3 = getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), registerField = _getInternalHooks3.registerField;
                    this.cancelRegisterFunc = registerField(this);
                }
                // One more render for component in case fields not ready
                if (shouldUpdate === true) this.reRender();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRegister();
                this.triggerMetaEvent(true);
                this.mounted = false;
            }
        },
        {
            key: "reRender",
            value: function reRender() {
                if (!this.mounted) return;
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var resetCount = this.state.resetCount;
                var children = this.props.children;
                var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
                // Not need to `cloneElement` since user can handle this in render function self
                var returnChildNode;
                if (isFunction) returnChildNode = child;
                else if (/*#__PURE__*/ $acw62.isValidElement(child)) returnChildNode = /*#__PURE__*/ $acw62.cloneElement(child, this.getControlled(child.props));
                else {
                    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!child, '`children` of Field is not validate ReactElement.');
                    returnChildNode = child;
                }
                return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
                    key: resetCount
                }, returnChildNode);
            }
        }
    ]);
    return Field;
}($acw62.Component);
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($3299c229146a7fb5$var$Field, "contextType", (0, $186c9d6ed579317b$export$2e2bcd8739ae039));
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($3299c229146a7fb5$var$Field, "defaultProps", {
    trigger: 'onChange',
    valuePropName: 'value'
});
function $3299c229146a7fb5$var$WrapperField(_ref6) {
    var _restProps$isListFiel;
    var name = _ref6.name, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref6, $3299c229146a7fb5$var$_excluded);
    var fieldContext = $acw62.useContext((0, $186c9d6ed579317b$export$2e2bcd8739ae039));
    var listContext = $acw62.useContext((0, $f81400e90cbb2e33$export$2e2bcd8739ae039));
    var namePath = name !== undefined ? (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name) : undefined;
    var isMergedListField = (_restProps$isListFiel = restProps.isListField) !== null && _restProps$isListFiel !== void 0 ? _restProps$isListFiel : !!listContext;
    var key = 'keep';
    if (!isMergedListField) key = "_".concat((namePath || []).join('_'));
    return /*#__PURE__*/ $acw62.createElement($3299c229146a7fb5$var$Field, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        key: key,
        name: namePath,
        isListField: isMergedListField
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $3299c229146a7fb5$export$2e2bcd8739ae039 = $3299c229146a7fb5$var$WrapperField;





var $acw62 = parcelRequire("acw62");





function $1ad2b0235e0eb0b7$var$List(_ref) {
    var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
    var context = $acw62.useContext((0, $186c9d6ed579317b$export$2e2bcd8739ae039));
    var wrapperListContext = $acw62.useContext((0, $f81400e90cbb2e33$export$2e2bcd8739ae039));
    var keyRef = $acw62.useRef({
        keys: [],
        id: 0
    });
    var keyManager = keyRef.current;
    var prefixName = $acw62.useMemo(function() {
        var parentPrefixName = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(context.prefixName) || [];
        return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(parentPrefixName), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name)));
    }, [
        context.prefixName,
        name
    ]);
    var fieldContext = $acw62.useMemo(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, context), {}, {
            prefixName: prefixName
        });
    }, [
        context,
        prefixName
    ]);
    // List context
    var listContext = $acw62.useMemo(function() {
        return {
            getKey: function getKey(namePath) {
                var len = prefixName.length;
                var pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        };
    }, [
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, 'Form.List only accepts function as children.');
        return null;
    }
    var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
        var source = _ref2.source;
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $acw62.createElement((0, $f81400e90cbb2e33$export$2e2bcd8739ae039).Provider, {
        value: listContext
    }, /*#__PURE__*/ $acw62.createElement((0, $186c9d6ed579317b$export$2e2bcd8739ae039).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $acw62.createElement((0, $3299c229146a7fb5$export$2e2bcd8739ae039), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
    }, function(_ref3, meta) {
        var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
        var getFieldValue = context.getFieldValue;
        var getNewValue = function getNewValue() {
            var values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ var operations = {
            add: function add(defaultValue, index) {
                // Mapping keys
                var newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keyManager.keys.slice(0, index)), [
                        keyManager.id
                    ], (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keyManager.keys.slice(index)));
                    onChange([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(newValue.slice(0, index)), [
                        defaultValue
                    ], (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(newValue.slice(index))));
                } else {
                    keyManager.keys = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keyManager.keys), [
                        keyManager.id
                    ]);
                    onChange([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(newValue), [
                        defaultValue
                    ]));
                }
                keyManager.id += 1;
            },
            remove: function remove(index) {
                var newValue = getNewValue();
                var indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
                    return !indexSet.has(keysIndex);
                });
                // Trigger store change
                onChange(newValue.filter(function(_, valueIndex) {
                    return !indexSet.has(valueIndex);
                }));
            },
            move: function move(from, to) {
                if (from === to) return;
                var newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $f0c87cef6ee60bcb$export$d947e5f4f4c48d48)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $f0c87cef6ee60bcb$export$d947e5f4f4c48d48)(newValue, from, to));
            }
        };
        var listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map(function(__, index) {
            var key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $1ad2b0235e0eb0b7$export$2e2bcd8739ae039 = $1ad2b0235e0eb0b7$var$List;













var $acw62 = parcelRequire("acw62");

function $1db9f053670497ce$export$6152adfdcc6be2b5(promiseList) {
    var hasError = false;
    var count = promiseList.length;
    var results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise(function(resolve, reject) {
        promiseList.forEach(function(promise, index) {
            promise.catch(function(e) {
                hasError = true;
                return e;
            }).then(function(result) {
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}









var $bae1107165a0db1c$var$SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $bae1107165a0db1c$var$normalize(namePath) {
    return namePath.map(function(cell) {
        return "".concat((0, $b8f57191916382d3$export$2e2bcd8739ae039)(cell), ":").concat(cell);
    })// Magic split
    .join($bae1107165a0db1c$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ var $bae1107165a0db1c$var$NameMap = /*#__PURE__*/ function() {
    function NameMap() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, NameMap);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "kvs", new Map());
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(NameMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.kvs.set($bae1107165a0db1c$var$normalize(key), value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.kvs.get($bae1107165a0db1c$var$normalize(key));
            }
        },
        {
            key: "update",
            value: function update(key, updater) {
                var origin = this.get(key);
                var next = updater(origin);
                if (!next) this.delete(key);
                else this.set(key, next);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.kvs.delete($bae1107165a0db1c$var$normalize(key));
            }
        },
        {
            key: "map",
            value: function map(callback) {
                return (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(this.kvs.entries()).map(function(_ref) {
                    var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    var cells = key.split($bae1107165a0db1c$var$SPLIT);
                    return callback({
                        key: cells.map(function(cell) {
                            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_cell$match, 3), type = _cell$match2[1], unit = _cell$match2[2];
                            return type === 'number' ? Number(unit) : unit;
                        }),
                        value: value
                    });
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                this.map(function(_ref3) {
                    var key = _ref3.key, value = _ref3.value;
                    json[key.join('.')] = value;
                    return null;
                });
                return json;
            }
        }
    ]);
    return NameMap;
}();
var $bae1107165a0db1c$export$2e2bcd8739ae039 = $bae1107165a0db1c$var$NameMap;



var $a1708dc7c20669c0$var$_excluded = [
    "name"
];
var $a1708dc7c20669c0$export$75ff1ab1187e691 = /*#__PURE__*/ (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(function FormStore(forceRootUpdate) {
    var _this = this;
    (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, FormStore);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "formHooked", false);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "forceRootUpdate", void 0);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "subscribable", true);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "store", {});
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "fieldEntities", []);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "initialValues", {});
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "callbacks", {});
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "validateMessages", null);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "preserve", null);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "lastValidatePromise", null);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getForm", function() {
        return {
            getFieldValue: _this.getFieldValue,
            getFieldsValue: _this.getFieldsValue,
            getFieldError: _this.getFieldError,
            getFieldWarning: _this.getFieldWarning,
            getFieldsError: _this.getFieldsError,
            isFieldsTouched: _this.isFieldsTouched,
            isFieldTouched: _this.isFieldTouched,
            isFieldValidating: _this.isFieldValidating,
            isFieldsValidating: _this.isFieldsValidating,
            resetFields: _this.resetFields,
            setFields: _this.setFields,
            setFieldValue: _this.setFieldValue,
            setFieldsValue: _this.setFieldsValue,
            validateFields: _this.validateFields,
            submit: _this.submit,
            _init: true,
            getInternalHooks: _this.getInternalHooks
        };
    });
    // ======================== Internal Hooks ========================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getInternalHooks", function(key) {
        if (key === (0, $186c9d6ed579317b$export$24829b7c0e49e9f7)) {
            _this.formHooked = true;
            return {
                dispatch: _this.dispatch,
                initEntityValue: _this.initEntityValue,
                registerField: _this.registerField,
                useSubscribe: _this.useSubscribe,
                setInitialValues: _this.setInitialValues,
                destroyForm: _this.destroyForm,
                setCallbacks: _this.setCallbacks,
                setValidateMessages: _this.setValidateMessages,
                getFields: _this.getFields,
                setPreserve: _this.setPreserve,
                getInitialValue: _this.getInitialValue,
                registerWatch: _this.registerWatch
            };
        }
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "useSubscribe", function(subscribable) {
        _this.subscribable = subscribable;
    });
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "prevWithoutPreserves", null);
    /**
   * First time `setInitialValues` should update store with initial value
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setInitialValues", function(initialValues, init) {
        _this.initialValues = initialValues || {};
        if (init) {
            var _this$prevWithoutPres;
            var nextStore = (0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)(initialValues, _this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
                var namePath = _ref.key;
                nextStore = (0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(nextStore, namePath, (0, $17fcde5782384c29$export$2e2bcd8739ae039)(initialValues, namePath));
            });
            _this.prevWithoutPreserves = null;
            _this.updateStore(nextStore);
        }
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "destroyForm", function(clearOnDestroy) {
        if (clearOnDestroy) // destroy form reset store
        _this.updateStore({});
        else {
            // Fill preserve fields
            var prevWithoutPreserves = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
            _this.getFieldEntities(true).forEach(function(entity) {
                if (!_this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            _this.prevWithoutPreserves = prevWithoutPreserves;
        }
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getInitialValue", function(namePath) {
        var initValue = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(_this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)(initValue) : initValue;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setCallbacks", function(callbacks) {
        _this.callbacks = callbacks;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setValidateMessages", function(validateMessages) {
        _this.validateMessages = validateMessages;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setPreserve", function(preserve) {
        _this.preserve = preserve;
    });
    // ============================= Watch ============================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "watchList", []);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "registerWatch", function(callback) {
        _this.watchList.push(callback);
        return function() {
            _this.watchList = _this.watchList.filter(function(fn) {
                return fn !== callback;
            });
        };
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "notifyWatch", function() {
        var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // No need to cost perf when nothing need to watch
        if (_this.watchList.length) {
            var values = _this.getFieldsValue();
            var allValues = _this.getFieldsValue(true);
            _this.watchList.forEach(function(callback) {
                callback(values, allValues, namePath);
            });
        }
    });
    // ========================== Dev Warning =========================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "timeoutId", null);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "warningUnhooked", function() {});
    // ============================ Store =============================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "updateStore", function(nextStore) {
        _this.store = nextStore;
    });
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldEntities", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!pure) return _this.fieldEntities;
        return _this.fieldEntities.filter(function(field) {
            return field.getNamePath().length;
        });
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldsMap", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cache = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
        _this.getFieldEntities(pure).forEach(function(field) {
            var namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldEntitiesForNamePathList", function(nameList) {
        if (!nameList) return _this.getFieldEntities(true);
        var cache = _this.getFieldsMap(true);
        return nameList.map(function(name) {
            var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name)
            };
        });
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldsValue", function(nameList, filterFunc) {
        _this.warningUnhooked();
        // Fill args
        var mergedNameList;
        var mergedFilterFunc;
        var mergedStrict;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(nameList) === 'object') {
            mergedStrict = nameList.strict;
            mergedFilterFunc = nameList.filter;
        }
        if (mergedNameList === true && !mergedFilterFunc) return _this.store;
        var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        var filteredNameList = [];
        fieldEntities.forEach(function(entity) {
            var _isListField, _ref3;
            var namePath = 'INVALIDATE_NAME_PATH' in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (mergedStrict) {
                var _isList, _ref2;
                if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) return;
            } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) return;
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                var meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        return (0, $f0c87cef6ee60bcb$export$f5be6dfb30403c59)(_this.store, filteredNameList.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)));
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldValue", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
        return (0, $17fcde5782384c29$export$2e2bcd8739ae039)(_this.store, namePath);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldsError", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map(function(entity, index) {
            if (entity && !('INVALIDATE_NAME_PATH' in entity)) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldError", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldWarning", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isFieldsTouched", function() {
        _this.warningUnhooked();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var arg0 = args[0], arg1 = args[1];
        var namePathList;
        var isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9));
            isAllFieldsTouched = arg1;
        }
        var fieldEntities = _this.getFieldEntities(true);
        var isFieldTouched = function isFieldTouched(field) {
            return field.isFieldTouched();
        };
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every(function(entity) {
            return isFieldTouched(entity) || entity.isList();
        }) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        var map = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
        namePathList.forEach(function(shortNamePath) {
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach(function(field) {
            var fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach(function(shortNamePath) {
                if (shortNamePath.every(function(nameUnit, i) {
                    return fieldNamePath[i] === nameUnit;
                })) map.update(shortNamePath, function(list) {
                    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(list), [
                        field
                    ]);
                });
            });
        });
        // Check if NameMap value is touched
        var isNamePathListTouched = function isNamePathListTouched(entities) {
            return entities.some(isFieldTouched);
        };
        var namePathListEntities = map.map(function(_ref4) {
            var value = _ref4.value;
            return value;
        });
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isFieldTouched", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsTouched([
            name
        ]);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isFieldsValidating", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntities();
        if (!nameList) return fieldEntities.some(function(testField) {
            return testField.isFieldValidating();
        });
        var namePathList = nameList.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9));
        return fieldEntities.some(function(testField) {
            var fieldNamePath = testField.getNamePath();
            return (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isFieldValidating", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsValidating([
            name
        ]);
    });
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "resetWithFieldInitialValue", function() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create cache
        var cache = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
        var fieldEntities = _this.getFieldEntities(true);
        fieldEntities.forEach(function(field) {
            var initialValue = field.props.initialValue;
            var namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                var records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        var resetWithFields = function resetWithFields(entities) {
            entities.forEach(function(field) {
                var initialValue = field.props.initialValue;
                if (initialValue !== undefined) {
                    var namePath = field.getNamePath();
                    var formInitialValue = _this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Form already set 'initialValues' with path '".concat(namePath.join('.'), "'. Field can not overwrite it."));
                    else {
                        var records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Multiple Field with path '".concat(namePath.join('.'), "' set 'initialValue'. Can not decide which one to pick."));
                        else if (records) {
                            var originValue = _this.getFieldValue(namePath);
                            var isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_this.store, namePath, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(records)[0].value));
                        }
                    }
                }
            });
        };
        var requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach(function(namePath) {
                var records = cache.get(namePath);
                if (records) {
                    var _requiredFieldEntitie;
                    (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(records).map(function(r) {
                        return r.entity;
                    })));
                }
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "resetFields", function(nameList) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (!nameList) {
            _this.updateStore((0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)(_this.initialValues));
            _this.resetWithFieldInitialValue();
            _this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            _this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        var namePathList = nameList.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9));
        namePathList.forEach(function(namePath) {
            var initialValue = _this.getInitialValue(namePath);
            _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_this.store, namePath, initialValue));
        });
        _this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        _this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        _this.notifyWatch(namePathList);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setFields", function(fields) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        var namePathList = [];
        fields.forEach(function(fieldData) {
            var name = fieldData.name, data = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(fieldData, $a1708dc7c20669c0$var$_excluded);
            var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_this.store, namePath, data.value));
            _this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        _this.notifyWatch(namePathList);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFields", function() {
        var entities = _this.getFieldEntities(true);
        var fields = entities.map(function(field) {
            var namePath = field.getNamePath();
            var meta = field.getMeta();
            var fieldData = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, meta), {}, {
                name: namePath,
                value: _this.getFieldValue(namePath)
            });
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    });
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "initEntityValue", function(entity) {
        var initialValue = entity.props.initialValue;
        if (initialValue !== undefined) {
            var namePath = entity.getNamePath();
            var prevValue = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(_this.store, namePath);
            if (prevValue === undefined) _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_this.store, namePath, initialValue));
        }
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isMergedPreserve", function(fieldPreserve) {
        var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
        return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "registerField", function(entity) {
        _this.fieldEntities.push(entity);
        var namePath = entity.getNamePath();
        _this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            var prevStore = _this.store;
            _this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            _this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return function(isListField, preserve) {
            var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _this.fieldEntities = _this.fieldEntities.filter(function(item) {
                return item !== entity;
            });
            // Clean up store value if not preserve
            if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
                if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
                    return(// Only reset when no namePath exist
                    !(0, $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a)(field.getNamePath(), namePath));
                })) {
                    var _prevStore = _this.store;
                    _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    _this.notifyObservers(_prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    _this.triggerDependenciesUpdate(_prevStore, namePath);
                }
            }
            _this.notifyWatch([
                namePath
            ]);
        };
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "dispatch", function(action) {
        switch(action.type){
            case 'updateValue':
                var namePath = action.namePath, value = action.value;
                _this.updateValue(namePath, value);
                break;
            case 'validateField':
                var _namePath = action.namePath, triggerName = action.triggerName;
                _this.validateFields([
                    _namePath
                ], {
                    triggerName: triggerName
                });
                break;
            default:
        }
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "notifyObservers", function(prevStore, namePathList, info) {
        if (_this.subscribable) {
            var mergedInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, info), {}, {
                store: _this.getFieldsValue(true)
            });
            _this.getFieldEntities().forEach(function(_ref5) {
                var onStoreChange = _ref5.onStoreChange;
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else _this.forceRootUpdate();
    });
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
        var childrenFields = _this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) _this.validateFields(childrenFields);
        _this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(childrenFields))
        });
        return childrenFields;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "updateValue", function(name, value) {
        var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
        var prevStore = _this.store;
        _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_this.store, namePath, value));
        _this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        _this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        var onValuesChange = _this.callbacks.onValuesChange;
        if (onValuesChange) {
            var changedValues = (0, $f0c87cef6ee60bcb$export$f5be6dfb30403c59)(_this.store, [
                namePath
            ]);
            onValuesChange(changedValues, _this.getFieldsValue());
        }
        _this.triggerOnFieldsChange([
            namePath
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(childrenFields)));
    });
    // Let all child Field get update.
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setFieldsValue", function(store) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (store) {
            var nextStore = (0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)(_this.store, store);
            _this.updateStore(nextStore);
        }
        _this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        _this.notifyWatch();
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setFieldValue", function(name, value) {
        _this.setFields([
            {
                name: name,
                value: value,
                errors: [],
                warnings: []
            }
        ]);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getDependencyChildrenFields", function(rootNamePath) {
        var children = new Set();
        var childrenFields = [];
        var dependencies2fields = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ _this.getFieldEntities().forEach(function(field) {
            var dependencies = field.props.dependencies;
            (dependencies || []).forEach(function(dependency) {
                var dependencyNamePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(dependency);
                dependencies2fields.update(dependencyNamePath, function() {
                    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
                    fields.add(field);
                    return fields;
                });
            });
        });
        var fillChildren = function fillChildren(namePath) {
            var fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach(function(field) {
                if (!children.has(field)) {
                    children.add(field);
                    var fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
        var onFieldsChange = _this.callbacks.onFieldsChange;
        if (onFieldsChange) {
            var fields = _this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                var cache = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
                filedErrors.forEach(function(_ref6) {
                    var name = _ref6.name, errors = _ref6.errors;
                    cache.set(name, errors);
                });
                fields.forEach(function(field) {
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            var changedFields = fields.filter(function(_ref7) {
                var fieldName = _ref7.name;
                return (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(namePathList, fieldName);
            });
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    });
    // =========================== Validate ===========================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "validateFields", function(arg1, arg2) {
        _this.warningUnhooked();
        var nameList;
        var options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        var provideNameList = !!nameList;
        var namePathList = provideNameList ? nameList.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)) : [];
        // Collect result in promise list
        var promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        var TMP_SPLIT = String(Date.now());
        var validateNamePathList = new Set();
        var _ref8 = options || {}, recursive = _ref8.recursive, dirty = _ref8.dirty;
        _this.getFieldEntities(true).forEach(function(field) {
            // Add field if not provide `nameList`
            if (!provideNameList) namePathList.push(field.getNamePath());
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            var fieldNamePath = field.getNamePath();
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(namePathList, fieldNamePath, recursive)) {
                var promise = field.validateRules((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    validateMessages: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $ebfc45d3b86f29a2$export$c86b939816b8fbf8)), _this.validateMessages)
                }, options));
                // Wrap promise with field
                promiseList.push(promise.then(function() {
                    return {
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    };
                }).catch(function(ruleErrors) {
                    var _ruleErrors$forEach;
                    var mergedErrors = [];
                    var mergedWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref9) {
                        var warningOnly = _ref9.rule.warningOnly, errors = _ref9.errors;
                        if (warningOnly) mergedWarnings.push.apply(mergedWarnings, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors));
                        else mergedErrors.push.apply(mergedErrors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors));
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        var summaryPromise = (0, $1db9f053670497ce$export$6152adfdcc6be2b5)(promiseList);
        _this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch(function(results) {
            return results;
        }).then(function(results) {
            var resultNamePathList = results.map(function(_ref10) {
                var name = _ref10.name;
                return name;
            });
            _this.notifyObservers(_this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            _this.triggerOnFieldsChange(resultNamePathList, results);
        });
        var returnPromise = summaryPromise.then(function() {
            if (_this.lastValidatePromise === summaryPromise) return Promise.resolve(_this.getFieldsValue(namePathList));
            return Promise.reject([]);
        }).catch(function(results) {
            var errorList = results.filter(function(result) {
                return result && result.errors.length;
            });
            return Promise.reject({
                values: _this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: _this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch(function(e) {
            return e;
        });
        // `validating` changed. Trigger `onFieldsChange`
        var triggerNamePathList = namePathList.filter(function(namePath) {
            return validateNamePathList.has(namePath.join(TMP_SPLIT));
        });
        _this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    });
    // ============================ Submit ============================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "submit", function() {
        _this.warningUnhooked();
        _this.validateFields().then(function(values) {
            var onFinish = _this.callbacks.onFinish;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch(function(e) {
            var onFinishFailed = _this.callbacks.onFinishFailed;
            if (onFinishFailed) onFinishFailed(e);
        });
    });
    this.forceRootUpdate = forceRootUpdate;
});
function $a1708dc7c20669c0$var$useForm(form) {
    var formRef = $acw62.useRef();
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), forceUpdate = _React$useState2[1];
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            var forceReRender = function forceReRender() {
                forceUpdate({});
            };
            var formStore = new $a1708dc7c20669c0$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $a1708dc7c20669c0$export$2e2bcd8739ae039 = $a1708dc7c20669c0$var$useForm;







var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
var $0c69ed761f95e1b0$var$FormContext = /*#__PURE__*/ $acw62.createContext({
    triggerFormChange: function triggerFormChange() {},
    triggerFormFinish: function triggerFormFinish() {},
    registerForm: function registerForm() {},
    unregisterForm: function unregisterForm() {}
});
var $0c69ed761f95e1b0$export$8ce1ff4f94d08846 = function FormProvider(_ref) {
    var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
    var formContext = $acw62.useContext($0c69ed761f95e1b0$var$FormContext);
    var formsRef = $acw62.useRef({});
    return /*#__PURE__*/ $acw62.createElement($0c69ed761f95e1b0$var$FormContext.Provider, {
        value: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formContext), {}, {
            validateMessages: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formContext.validateMessages), validateMessages),
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: function triggerFormChange(name, changedFields) {
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: function triggerFormFinish(name, values) {
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: function registerForm(name, form) {
                if (name) formsRef.current = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formsRef.current), {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, name, form));
                formContext.registerForm(name, form);
            },
            unregisterForm: function unregisterForm(name) {
                var newForms = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formsRef.current);
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        })
    }, children);
};
var $0c69ed761f95e1b0$export$2e2bcd8739ae039 = $0c69ed761f95e1b0$var$FormContext;




var $7860f41d917f18d2$var$_excluded = [
    "name",
    "initialValues",
    "fields",
    "form",
    "preserve",
    "children",
    "component",
    "validateMessages",
    "validateTrigger",
    "onValuesChange",
    "onFieldsChange",
    "onFinish",
    "onFinishFailed",
    "clearOnDestroy"
];
var $7860f41d917f18d2$var$Form = function Form(_ref, ref) {
    var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component = _ref$component === void 0 ? 'form' : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? 'onChange' : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, clearOnDestroy = _ref.clearOnDestroy, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $7860f41d917f18d2$var$_excluded);
    var nativeElementRef = $acw62.useRef(null);
    var formContext = $acw62.useContext((0, $0c69ed761f95e1b0$export$2e2bcd8739ae039));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    var _useForm = (0, $a1708dc7c20669c0$export$2e2bcd8739ae039)(form), _useForm2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useForm, 1), formInstance = _useForm2[0];
    var _getInternalHooks = formInstance.getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
    // Pass ref with form instance
    $acw62.useImperativeHandle(ref, function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formInstance), {}, {
            nativeElement: nativeElementRef.current
        });
    });
    // Register form into Context
    $acw62.useEffect(function() {
        formContext.registerForm(name, formInstance);
        return function() {
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formContext.validateMessages), validateMessages));
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: function onFieldsChange(changedFields) {
            formContext.triggerFormChange(name, changedFields);
            if (_onFieldsChange) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
                _onFieldsChange.apply(void 0, [
                    changedFields
                ].concat(rest));
            }
        },
        onFinish: function onFinish(values) {
            formContext.triggerFormFinish(name, values);
            if (_onFinish) _onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    var mountRef = $acw62.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    $acw62.useEffect(function() {
        return function() {
            return destroyForm(clearOnDestroy);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    var childrenNode;
    var childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        var _values = formInstance.getFieldsValue(true);
        childrenNode = children(_values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    var prevFieldsRef = $acw62.useRef();
    $acw62.useEffect(function() {
        if (!(0, $f0c87cef6ee60bcb$export$dfcec05bb7372a54)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    var formContextValue = $acw62.useMemo(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formInstance), {}, {
            validateTrigger: validateTrigger
        });
    }, [
        formInstance,
        validateTrigger
    ]);
    var wrapperNode = /*#__PURE__*/ $acw62.createElement((0, $f81400e90cbb2e33$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $186c9d6ed579317b$export$2e2bcd8739ae039).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
        ref: nativeElementRef,
        onSubmit: function onSubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: function onReset(event) {
            var _restProps$onReset;
            event.preventDefault();
            formInstance.resetFields();
            (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
        }
    }), wrapperNode);
};
var $7860f41d917f18d2$export$2e2bcd8739ae039 = $7860f41d917f18d2$var$Form;








var $acw62 = parcelRequire("acw62");



function $c40fe08ecbe59c71$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch (err) {
        return Math.random();
    }
}
var $c40fe08ecbe59c71$var$useWatchWarning = function() {};
// ------- selector type -------
// ------- selector type end -------
function $c40fe08ecbe59c71$var$useWatch() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var dependencies = args[0], _args$ = args[1], _form = _args$ === void 0 ? {} : _args$;
    var options = (0, $c9624fc8667843e4$export$717b316e73068e8d)(_form) ? {
        form: _form
    } : _form;
    var form = options.form;
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueStr = (0, $acw62.useMemo)(function() {
        return $c40fe08ecbe59c71$export$fac44ee5b035f737(value);
    }, [
        value
    ]);
    var valueStrRef = (0, $acw62.useRef)(valueStr);
    valueStrRef.current = valueStr;
    var fieldContext = (0, $acw62.useContext)((0, $186c9d6ed579317b$export$2e2bcd8739ae039));
    var formInstance = form || fieldContext;
    var isValidForm = formInstance && formInstance._init;
    var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(dependencies);
    var namePathRef = (0, $acw62.useRef)(namePath);
    namePathRef.current = namePath;
    $c40fe08ecbe59c71$var$useWatchWarning(namePath);
    (0, $acw62.useEffect)(function() {
        // Skip if not exist form instance
        if (!isValidForm) return;
        var getFieldsValue = formInstance.getFieldsValue, getInternalHooks = formInstance.getInternalHooks;
        var _getInternalHooks = getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), registerWatch = _getInternalHooks.registerWatch;
        var getWatchValue = function getWatchValue(values, allValues) {
            var watchValue = options.preserve ? allValues : values;
            return typeof dependencies === 'function' ? dependencies(watchValue) : (0, $17fcde5782384c29$export$2e2bcd8739ae039)(watchValue, namePathRef.current);
        };
        var cancelRegister = registerWatch(function(values, allValues) {
            var newValue = getWatchValue(values, allValues);
            var nextValueStr = $c40fe08ecbe59c71$export$fac44ee5b035f737(newValue);
            // Compare stringify in case it's nest object
            if (valueStrRef.current !== nextValueStr) {
                valueStrRef.current = nextValueStr;
                setValue(newValue);
            }
        });
        // TODO: We can improve this perf in future
        var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));
        // React 18 has the bug that will queue update twice even the value is not changed
        // ref: https://github.com/facebook/react/issues/27213
        if (value !== initialValue) setValue(initialValue);
        return cancelRegister;
    }, // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isValidForm
    ]);
    return value;
}
var $c40fe08ecbe59c71$export$2e2bcd8739ae039 = $c40fe08ecbe59c71$var$useWatch;


var $5f1614ae44e69c1b$var$InternalForm = /*#__PURE__*/ $acw62.forwardRef((0, $7860f41d917f18d2$export$2e2bcd8739ae039));
var $5f1614ae44e69c1b$var$RefForm = $5f1614ae44e69c1b$var$InternalForm;
$5f1614ae44e69c1b$var$RefForm.FormProvider = (0, $0c69ed761f95e1b0$export$8ce1ff4f94d08846);
$5f1614ae44e69c1b$var$RefForm.Field = (0, $3299c229146a7fb5$export$2e2bcd8739ae039);
$5f1614ae44e69c1b$var$RefForm.List = (0, $1ad2b0235e0eb0b7$export$2e2bcd8739ae039);
$5f1614ae44e69c1b$var$RefForm.useForm = (0, $a1708dc7c20669c0$export$2e2bcd8739ae039);
$5f1614ae44e69c1b$var$RefForm.useWatch = (0, $c40fe08ecbe59c71$export$2e2bcd8739ae039);
var $5f1614ae44e69c1b$export$2e2bcd8739ae039 = $5f1614ae44e69c1b$var$RefForm;



"use client";
const $ad5d550b51ac8abd$export$c24727297075ec6a = /*#__PURE__*/ $acw62.createContext({
    labelAlign: 'right',
    vertical: false,
    itemRef: ()=>{}
});
const $ad5d550b51ac8abd$export$d718247e9f9b0b9e = /*#__PURE__*/ $acw62.createContext(null);
const $ad5d550b51ac8abd$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $57c22a5a2f343bca$export$2e2bcd8739ae039)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $0c69ed761f95e1b0$export$8ce1ff4f94d08846), Object.assign({}, providerProps));
};
const $ad5d550b51ac8abd$export$fb6582d3042cc879 = /*#__PURE__*/ $acw62.createContext({
    prefixCls: ''
});
const $ad5d550b51ac8abd$export$bbb5553c6c7a14ed = /*#__PURE__*/ $acw62.createContext({});
const $ad5d550b51ac8abd$export$80e4c53cb85dcab1 = ({ children: children, status: status, override: override })=>{
    const formItemInputContext = $acw62.useContext($ad5d550b51ac8abd$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = $acw62.useMemo(()=>{
        const newContext = Object.assign({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $acw62.createElement($ad5d550b51ac8abd$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};
const $ad5d550b51ac8abd$export$6f0555dad42725fb = /*#__PURE__*/ $acw62.createContext(undefined);



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

const $086416f743106ac8$var$useSize = (customSize)=>{
    const size = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    const mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === 'string') return customSize !== null && customSize !== void 0 ? customSize : size;
        if (typeof customSize === 'function') return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $086416f743106ac8$export$2e2bcd8739ae039 = $086416f743106ac8$var$useSize;



const $987474def15ea51b$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-block': {
                display: 'flex',
                width: '100%'
            },
            '&-vertical': {
                flexDirection: 'column'
            }
        }
    };
};
var // ============================== Export ==============================
$987474def15ea51b$export$2e2bcd8739ae039 = $987474def15ea51b$var$genSpaceCompactStyle;


const $8c6cd68a6974f2d0$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-align': {
                flexDirection: 'column',
                '&-center': {
                    alignItems: 'center'
                },
                '&-start': {
                    alignItems: 'flex-start'
                },
                '&-end': {
                    alignItems: 'flex-end'
                },
                '&-baseline': {
                    alignItems: 'baseline'
                }
            },
            [`${componentCls}-item:empty`]: {
                display: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: 'block'
            }
        }
    };
};
const $8c6cd68a6974f2d0$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-gap-row-small': {
                rowGap: token.spaceGapSmallSize
            },
            '&-gap-row-middle': {
                rowGap: token.spaceGapMiddleSize
            },
            '&-gap-row-large': {
                rowGap: token.spaceGapLargeSize
            },
            '&-gap-col-small': {
                columnGap: token.spaceGapSmallSize
            },
            '&-gap-col-middle': {
                columnGap: token.spaceGapMiddleSize
            },
            '&-gap-col-large': {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const $8c6cd68a6974f2d0$export$9ca1be8807fe0675 = ()=>({});
var $8c6cd68a6974f2d0$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Space', (token)=>{
    const spaceToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $8c6cd68a6974f2d0$var$genSpaceStyle(spaceToken),
        $8c6cd68a6974f2d0$var$genSpaceGapStyle(spaceToken),
        (0, $987474def15ea51b$export$2e2bcd8739ae039)(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
var $26050ef76e24a749$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $26050ef76e24a749$export$8d1c486ac0db0a7d = /*#__PURE__*/ $acw62.createContext(null);
const $26050ef76e24a749$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $acw62.useContext($26050ef76e24a749$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $acw62.useMemo(()=>{
        if (!compactItemContext) return '';
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $26050ef76e24a749$export$5f56e610a4afb685 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $26050ef76e24a749$var$CompactItem = (props)=>{
    const { children: children } = props, others = $26050ef76e24a749$var$__rest(props, [
        "children"
    ]);
    return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$export$8d1c486ac0db0a7d.Provider, {
        value: $acw62.useMemo(()=>others, [
            others
        ])
    }, children);
};
const $26050ef76e24a749$var$Compact = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { size: size, direction: direction, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children } = props, restProps = $26050ef76e24a749$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "rootClassName",
        "children"
    ]);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>size !== null && size !== void 0 ? size : ctx);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $8c6cd68a6974f2d0$export$2e2bcd8739ae039)(prefixCls);
    const clx = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: direction === 'vertical'
    }, className, rootClassName);
    const compactItemContext = $acw62.useContext($26050ef76e24a749$export$8d1c486ac0db0a7d);
    const childNodes = (0, $5aa78504b8a12848$export$2e2bcd8739ae039)(children);
    const nodes = $acw62.useMemo(()=>childNodes.map((child, i)=>{
            const key = (child === null || child === void 0 ? void 0 : child.key) || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        }), [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        className: clx
    }, restProps), nodes));
};
var $26050ef76e24a749$export$2e2bcd8739ae039 = $26050ef76e24a749$var$Compact;


"use client";
const $894cbe2fb0245b19$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (children === undefined || children === null) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad5d550b51ac8abd$export$80e4c53cb85dcab1), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26050ef76e24a749$export$5f56e610a4afb685), null, result);
    return result;
};
var $894cbe2fb0245b19$export$2e2bcd8739ae039 = $894cbe2fb0245b19$var$ContextIsolator;




// ================== Collapse Motion ==================
const $2efb522a5615f01e$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $2efb522a5615f01e$var$getRealHeight = (node)=>{
    const { scrollHeight: scrollHeight } = node;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
const $2efb522a5615f01e$var$getCurrentHeight = (node)=>({
        height: node ? node.offsetHeight : 0
    });
const $2efb522a5615f01e$var$skipOpacityTransition = (_, event)=>(event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
const $2efb522a5615f01e$var$initCollapseMotion = (rootCls = (0, $a18b2f6f56546238$export$e4ec87ea71f29b41))=>({
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $2efb522a5615f01e$var$getCollapsedHeight,
        onEnterStart: $2efb522a5615f01e$var$getCollapsedHeight,
        onAppearActive: $2efb522a5615f01e$var$getRealHeight,
        onEnterActive: $2efb522a5615f01e$var$getRealHeight,
        onLeaveStart: $2efb522a5615f01e$var$getCurrentHeight,
        onLeaveActive: $2efb522a5615f01e$var$getCollapsedHeight,
        onAppearEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        onEnterEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        onLeaveEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        motionDeadline: 500
    });
const $2efb522a5615f01e$var$_SelectPlacements = [
    'bottomLeft',
    'bottomRight',
    'topLeft',
    'topRight'
];
const $2efb522a5615f01e$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $2efb522a5615f01e$export$2e2bcd8739ae039 = $2efb522a5615f01e$var$initCollapseMotion;




function $0c0596420865f622$export$87e38ee403661ccc(token) {
    const { sizePopupArrow: sizePopupArrow, borderRadiusXS: borderRadiusXS, borderRadiusOuter: borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
const $0c0596420865f622$export$601fa0375eb80eec = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow: sizePopupArrow, arrowPolygon: arrowPolygon, arrowPath: arrowPath, arrowShadowWidth: arrowShadowWidth, borderRadiusXS: borderRadiusXS, calc: calc } = token;
    return {
        pointerEvents: 'none',
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: 'hidden',
        '&::before': {
            position: 'absolute',
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            width: arrowShadowWidth,
            height: arrowShadowWidth,
            bottom: 0,
            insetInline: 0,
            margin: 'auto',
            borderRadius: {
                _skip_check_: true,
                value: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(borderRadiusXS)} 0`
            },
            transform: 'translateY(50%) rotate(-135deg)',
            boxShadow: boxShadow,
            zIndex: 0,
            background: 'transparent'
        }
    };
};


const $13cd8c878b3c9176$export$de6e4ffc9ec3c089 = 8;
function $13cd8c878b3c9176$export$bddc192327bb9823(options) {
    const { contentRadius: contentRadius, limitVerticalRadius: limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? $13cd8c878b3c9176$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
function $13cd8c878b3c9176$var$isInject(valid, code) {
    if (!valid) return {};
    return code;
}
function $13cd8c878b3c9176$export$2e2bcd8739ae039(token, colorBg, options) {
    const { componentCls: componentCls, boxShadowPopoverArrow: boxShadowPopoverArrow, arrowOffsetVertical: arrowOffsetVertical, arrowOffsetHorizontal: arrowOffsetHorizontal } = token;
    const { arrowDistance: arrowDistance = 0, arrowPlacement: arrowPlacement = {
        left: true,
        right: true,
        top: true,
        bottom: true
    } } = options || {};
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                Object.assign(Object.assign({
                    position: 'absolute',
                    zIndex: 1,
                    display: 'block'
                }, (0, $0c0596420865f622$export$601fa0375eb80eec)(token, colorBg, boxShadowPopoverArrow)), {
                    '&:before': {
                        background: colorBg
                    }
                })
            ]
        }, $13cd8c878b3c9176$var$isInject(!!arrowPlacement.top, {
            [[
                `&-placement-top > ${componentCls}-arrow`,
                `&-placement-topLeft > ${componentCls}-arrow`,
                `&-placement-topRight > ${componentCls}-arrow`
            ].join(',')]: {
                bottom: arrowDistance,
                transform: 'translateY(100%) rotate(180deg)'
            },
            [`&-placement-top > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
            },
            '&-placement-topLeft': {
                '--arrow-offset-horizontal': arrowOffsetHorizontal,
                [`> ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            '&-placement-topRight': {
                '--arrow-offset-horizontal': `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                [`> ${componentCls}-arrow`]: {
                    right: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            }
        })), $13cd8c878b3c9176$var$isInject(!!arrowPlacement.bottom, {
            [[
                `&-placement-bottom > ${componentCls}-arrow`,
                `&-placement-bottomLeft > ${componentCls}-arrow`,
                `&-placement-bottomRight > ${componentCls}-arrow`
            ].join(',')]: {
                top: arrowDistance,
                transform: `translateY(-100%)`
            },
            [`&-placement-bottom > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: `translateX(-50%) translateY(-100%)`
            },
            '&-placement-bottomLeft': {
                '--arrow-offset-horizontal': arrowOffsetHorizontal,
                [`> ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            '&-placement-bottomRight': {
                '--arrow-offset-horizontal': `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                [`> ${componentCls}-arrow`]: {
                    right: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            }
        })), $13cd8c878b3c9176$var$isInject(!!arrowPlacement.left, {
            [[
                `&-placement-left > ${componentCls}-arrow`,
                `&-placement-leftTop > ${componentCls}-arrow`,
                `&-placement-leftBottom > ${componentCls}-arrow`
            ].join(',')]: {
                right: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: 'translateX(100%) rotate(90deg)'
            },
            [`&-placement-left > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
            },
            [`&-placement-leftTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-leftBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        })), $13cd8c878b3c9176$var$isInject(!!arrowPlacement.right, {
            [[
                `&-placement-right > ${componentCls}-arrow`,
                `&-placement-rightTop > ${componentCls}-arrow`,
                `&-placement-rightBottom > ${componentCls}-arrow`
            ].join(',')]: {
                left: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: 'translateX(-100%) rotate(-90deg)'
            },
            [`&-placement-right > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
            },
            [`&-placement-rightTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-rightBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        }))
    };
}


function $aa2151c32cec40fb$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === 'object' ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case 'top':
        case 'bottom':
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case 'left':
        case 'right':
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = Object.assign(Object.assign({}, baseOverflow), overflow);
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const $aa2151c32cec40fb$var$PlacementAlignMap = {
    left: {
        points: [
            'cr',
            'cl'
        ]
    },
    right: {
        points: [
            'cl',
            'cr'
        ]
    },
    top: {
        points: [
            'bc',
            'tc'
        ]
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ]
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tr'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ]
    }
};
const $aa2151c32cec40fb$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            'bl',
            'tc'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'cl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tc'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'cr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'bc'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'cr'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bc'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'cl'
        ]
    }
};
const $aa2151c32cec40fb$var$DisableAutoArrowList = new Set([
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom'
]);
function $aa2151c32cec40fb$export$2e2bcd8739ae039(config) {
    const { arrowWidth: arrowWidth, autoAdjustOverflow: autoAdjustOverflow, arrowPointAtCenter: arrowPointAtCenter, offset: offset, borderRadius: borderRadius, visibleFirst: visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    // Dynamic offset
    const arrowOffset = (0, $13cd8c878b3c9176$export$bddc192327bb9823)({
        contentRadius: borderRadius,
        limitVerticalRadius: true
    });
    Object.keys($aa2151c32cec40fb$var$PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && $aa2151c32cec40fb$var$ArrowCenterPlacementAlignMap[key] || $aa2151c32cec40fb$var$PlacementAlignMap[key];
        const placementInfo = Object.assign(Object.assign({}, template), {
            offset: [
                0,
                0
            ],
            dynamicInset: true
        });
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($aa2151c32cec40fb$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case 'top':
            case 'topLeft':
            case 'topRight':
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case 'bottom':
            case 'bottomLeft':
            case 'bottomRight':
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case 'left':
            case 'leftTop':
            case 'leftBottom':
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case 'right':
            case 'rightTop':
            case 'rightBottom':
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        if (arrowPointAtCenter) switch(key){
            case 'topLeft':
            case 'bottomLeft':
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case 'topRight':
            case 'bottomRight':
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case 'leftTop':
            case 'rightTop':
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
                break;
            case 'leftBottom':
            case 'rightBottom':
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $aa2151c32cec40fb$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = 'visibleFirst';
    });
    return placementMap;
}



var $acw62 = parcelRequire("acw62");
function $30796c32f374b477$export$9522e17588c12572(child) {
    return child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child) && child.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment;
}
const $30796c32f374b477$export$2dfe578f95754f6a = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
};
function $30796c32f374b477$export$e530037191fcd5d7(element, props) {
    return $30796c32f374b477$export$2dfe578f95754f6a(element, element, props);
}







var $acw62 = parcelRequire("acw62");






const $c05a1428f4a08fb2$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const $c05a1428f4a08fb2$var$initMotionCommonLeave = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
const $c05a1428f4a08fb2$export$83e1da9e09ec9112 = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false)=>{
    const sameLevelPrefix = sameLevel ? '&' : '';
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, $c05a1428f4a08fb2$var$initMotionCommon(duration)), {
            animationPlayState: 'paused'
        }),
        [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, $c05a1428f4a08fb2$var$initMotionCommonLeave(duration)), {
            animationPlayState: 'paused'
        }),
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: 'running'
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: 'running',
            pointerEvents: 'none'
        }
    };
};


const $d2082114d5952afb$export$3b71758b3ed5255f = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomIn', {
    '0%': {
        transform: 'scale(0.2)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $d2082114d5952afb$export$9fdb0a49c6b4b521 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.2)',
        opacity: 0
    }
});
const $d2082114d5952afb$export$be061d573c42e33a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomBigIn', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $d2082114d5952afb$export$582d93d613303da3 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomBigOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.8)',
        opacity: 0
    }
});
const $d2082114d5952afb$export$45eddd18c599b827 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomUpIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    }
});
const $d2082114d5952afb$export$a85c97750adaa37a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomUpOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    }
});
const $d2082114d5952afb$export$bd2378f7814f5f1a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomLeftIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    }
});
const $d2082114d5952afb$export$e58f88c751c4f04e = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomLeftOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    }
});
const $d2082114d5952afb$export$fee1456954aef331 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomRightIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    }
});
const $d2082114d5952afb$export$811ba6d3e2adb730 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomRightOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    }
});
const $d2082114d5952afb$export$633a68aa72dec21c = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomDownIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    }
});
const $d2082114d5952afb$export$1cf46a906e8dede4 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antZoomDownOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    }
});
const $d2082114d5952afb$var$zoomMotion = {
    zoom: {
        inKeyframes: $d2082114d5952afb$export$3b71758b3ed5255f,
        outKeyframes: $d2082114d5952afb$export$9fdb0a49c6b4b521
    },
    'zoom-big': {
        inKeyframes: $d2082114d5952afb$export$be061d573c42e33a,
        outKeyframes: $d2082114d5952afb$export$582d93d613303da3
    },
    'zoom-big-fast': {
        inKeyframes: $d2082114d5952afb$export$be061d573c42e33a,
        outKeyframes: $d2082114d5952afb$export$582d93d613303da3
    },
    'zoom-left': {
        inKeyframes: $d2082114d5952afb$export$bd2378f7814f5f1a,
        outKeyframes: $d2082114d5952afb$export$e58f88c751c4f04e
    },
    'zoom-right': {
        inKeyframes: $d2082114d5952afb$export$fee1456954aef331,
        outKeyframes: $d2082114d5952afb$export$811ba6d3e2adb730
    },
    'zoom-up': {
        inKeyframes: $d2082114d5952afb$export$45eddd18c599b827,
        outKeyframes: $d2082114d5952afb$export$a85c97750adaa37a
    },
    'zoom-down': {
        inKeyframes: $d2082114d5952afb$export$633a68aa72dec21c,
        outKeyframes: $d2082114d5952afb$export$1cf46a906e8dede4
    }
};
const $d2082114d5952afb$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $d2082114d5952afb$var$zoomMotion[motionName];
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: 'scale(0)',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                '&-prepare': {
                    transform: 'none'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};




const $8bbb48c728db3fab$export$6d4fe3a00a1811ad = [
    'blue',
    'purple',
    'cyan',
    'green',
    'magenta',
    'pink',
    'red',
    'orange',
    'yellow',
    'volcano',
    'geekblue',
    'lime',
    'gold'
];


function $69386722b4e8be32$export$2e2bcd8739ae039(token, genCss) {
    return (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return Object.assign(Object.assign({}, prev), genCss(colorKey, {
            lightColor: lightColor,
            lightBorderColor: lightBorderColor,
            darkColor: darkColor,
            textColor: textColor
        }));
    }, {});
}


const $8bcca9e8f96db88a$var$genTooltipStyle = (token)=>{
    const { calc: calc, componentCls: componentCls, tooltipMaxWidth: // ant-tooltip
    tooltipMaxWidth, tooltipColor: tooltipColor, tooltipBg: tooltipBg, tooltipBorderRadius: tooltipBorderRadius, zIndexPopup: zIndexPopup, controlHeight: controlHeight, boxShadowSecondary: boxShadowSecondary, paddingSM: paddingSM, paddingXS: paddingXS, arrowOffsetHorizontal: arrowOffsetHorizontal, sizePopupArrow: sizePopupArrow } = token;
    // arrowOffsetHorizontal + arrowWidth + borderRadius
    const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
    // borderRadius * 2 + arrowWidth
    const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
    return [
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                position: 'absolute',
                zIndex: zIndexPopup,
                display: 'block',
                width: 'max-content',
                maxWidth: tooltipMaxWidth,
                visibility: 'visible',
                // When use `autoArrow`, origin will follow the arrow position
                '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
                transformOrigin: [
                    `var(--valid-offset-x, 50%)`,
                    `var(--arrow-y, 50%)`
                ].join(' '),
                '&-hidden': {
                    display: 'none'
                },
                '--antd-arrow-background-color': tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-inner`]: {
                    minWidth: centerAlignMinWidth,
                    minHeight: controlHeight,
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(paddingSM).div(2).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)}`,
                    color: tooltipColor,
                    textAlign: 'start',
                    textDecoration: 'none',
                    wordWrap: 'break-word',
                    backgroundColor: tooltipBg,
                    borderRadius: tooltipBorderRadius,
                    boxShadow: boxShadowSecondary,
                    boxSizing: 'border-box'
                },
                // Align placement should have another min width
                [[
                    `&-placement-topLeft`,
                    `&-placement-topRight`,
                    `&-placement-bottomLeft`,
                    `&-placement-bottomRight`
                ].join(',')]: {
                    minWidth: edgeAlignMinWidth
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(',')]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, $13cd8c878b3c9176$export$de6e4ffc9ec3c089))
                    }
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                }
            }), (0, $69386722b4e8be32$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
                    [`&${componentCls}-${colorKey}`]: {
                        [`${componentCls}-inner`]: {
                            backgroundColor: darkColor
                        },
                        [`${componentCls}-arrow`]: {
                            '--antd-arrow-background-color': darkColor
                        }
                    }
                }))), {
                // RTL
                '&-rtl': {
                    direction: 'rtl'
                }
            })
        },
        // Arrow Style
        (0, $13cd8c878b3c9176$export$2e2bcd8739ae039)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow
            }
        }
    ];
};
const $8bcca9e8f96db88a$export$9ca1be8807fe0675 = (token)=>Object.assign(Object.assign({
        zIndexPopup: token.zIndexPopupBase + 70
    }, (0, $13cd8c878b3c9176$export$bddc192327bb9823)({
        contentRadius: token.borderRadius,
        limitVerticalRadius: true
    })), (0, $0c0596420865f622$export$87e38ee403661ccc)((0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
    })));
var $8bcca9e8f96db88a$export$2e2bcd8739ae039 = (prefixCls, injectStyle = true)=>{
    const useStyle = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Tooltip', (token)=>{
        const { borderRadius: borderRadius, colorTextLightSolid: colorTextLightSolid, colorBgSpotlight: colorBgSpotlight } = token;
        const TooltipToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
            // default variables
            tooltipMaxWidth: 250,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $8bcca9e8f96db88a$var$genTooltipStyle(TooltipToken),
            (0, $d2082114d5952afb$export$f5d123412490d9dc)(token, 'zoom-big-fast')
        ];
    }, $8bcca9e8f96db88a$export$9ca1be8807fe0675, {
        resetStyle: false,
        injectStyle: // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls);
};





const $1513ceb924eda9b6$var$inverseColors = (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).map((color)=>`${color}-inverse`);
const $1513ceb924eda9b6$export$bb684163c94c55ae = [
    'success',
    'processing',
    'error',
    'default',
    'warning'
];
function $1513ceb924eda9b6$export$ee62ebd6a58c4884(color, includeInverse = true) {
    if (includeInverse) return [].concat((0, $df4024303de6487a$export$2e2bcd8739ae039)($1513ceb924eda9b6$var$inverseColors), (0, $df4024303de6487a$export$2e2bcd8739ae039)((0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad))).includes(color);
    return (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).includes(color);
}
function $1513ceb924eda9b6$export$88a0ba1f7d1ea40e(color) {
    return $1513ceb924eda9b6$export$bb684163c94c55ae.includes(color);
}


function $080c438853985df7$export$6e865ea70d7724f(prefixCls, color) {
    const isInternalColor = (0, $1513ceb924eda9b6$export$ee62ebd6a58c4884)(color);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        // @ts-ignore
        arrowStyle['--antd-arrow-background-color'] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
}


"use client";
/** @private Internal Component. Do not use in your production. */ const $e604628db2f2c0d3$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, placement: placement = 'top', title: title, color: color, overlayInnerStyle: overlayInnerStyle } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $8bcca9e8f96db88a$export$2e2bcd8739ae039)(prefixCls);
    // Color
    const colorInfo = (0, $080c438853985df7$export$6e865ea70d7724f)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls,
        style: arrowContentStyle
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $acw62.createElement((0, $576260377b469890$export$2e2bcd8739ae039), Object.assign({}, props, {
        className: hashId,
        prefixCls: prefixCls,
        overlayInnerStyle: formattedOverlayInnerStyle
    }), title)));
};
var $e604628db2f2c0d3$export$2e2bcd8739ae039 = $e604628db2f2c0d3$var$PurePanel;




"use client";
var $0ac88bf86814a6e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $0ac88bf86814a6e5$var$InternalTooltip = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, openClassName: openClassName, getTooltipContainer: getTooltipContainer, color: color, overlayInnerStyle: overlayInnerStyle, children: children, afterOpenChange: afterOpenChange, afterVisibleChange: afterVisibleChange, destroyTooltipOnHide: destroyTooltipOnHide, destroyOnHidden: destroyOnHidden, arrow: arrow = true, title: title, overlay: overlay, builtinPlacements: builtinPlacements, arrowPointAtCenter: arrowPointAtCenter = false, autoAdjustOverflow: autoAdjustOverflow = true, motion: motion, getPopupContainer: getPopupContainer, placement: placement = 'top', mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, overlayStyle: overlayStyle, rootClassName: rootClassName, overlayClassName: overlayClassName, styles: styles, classNames: tooltipClassNames } = props, restProps = $0ac88bf86814a6e5$var$__rest(props, [
        "prefixCls",
        "openClassName",
        "getTooltipContainer",
        "color",
        "overlayInnerStyle",
        "children",
        "afterOpenChange",
        "afterVisibleChange",
        "destroyTooltipOnHide",
        "destroyOnHidden",
        "arrow",
        "title",
        "overlay",
        "builtinPlacements",
        "arrowPointAtCenter",
        "autoAdjustOverflow",
        "motion",
        "getPopupContainer",
        "placement",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle",
        "rootClassName",
        "overlayClassName",
        "styles",
        "classNames"
    ]);
    const mergedShowArrow = !!arrow;
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('tooltip');
    // ============================== Ref ===============================
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('Tooltip');
    const tooltipRef = $acw62.useRef(null);
    const forceAlign = ()=>{
        var _a;
        (_a = tooltipRef.current) === null || _a === void 0 || _a.forceAlign();
    };
    $acw62.useImperativeHandle(ref, ()=>{
        var _a, _b;
        return {
            forceAlign: forceAlign,
            forcePopupAlign: ()=>{
                warning.deprecated(false, 'forcePopupAlign', 'forceAlign');
                forceAlign();
            },
            nativeElement: (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement,
            popupElement: (_b = tooltipRef.current) === null || _b === void 0 ? void 0 : _b.popupElement
        };
    });
    var deprecatedName, newName;
    // ============================== Open ==============================
    const [open, setOpen] = (0, $fbd33e1a3c597913$export$2e2bcd8739ae039)(false, {
        value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
        defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
    });
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onOpenChange = (vis)=>{
        var _a, _b;
        setOpen(noTitle ? false : vis);
        if (!noTitle) {
            (_a = props.onOpenChange) === null || _a === void 0 || _a.call(props, vis);
            (_b = props.onVisibleChange) === null || _b === void 0 || _b.call(props, vis);
        }
    };
    const tooltipPlacements = $acw62.useMemo(()=>{
        var _a, _b;
        let mergedArrowPointAtCenter = arrowPointAtCenter;
        if (typeof arrow === 'object') mergedArrowPointAtCenter = (_b = (_a = arrow.pointAtCenter) !== null && _a !== void 0 ? _a : arrow.arrowPointAtCenter) !== null && _b !== void 0 ? _b : arrowPointAtCenter;
        return builtinPlacements || (0, $aa2151c32cec40fb$export$2e2bcd8739ae039)({
            arrowPointAtCenter: mergedArrowPointAtCenter,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        arrowPointAtCenter,
        arrow,
        builtinPlacements,
        token
    ]);
    const memoOverlay = $acw62.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || '';
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ $acw62.createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
        space: true
    }, typeof memoOverlay === 'function' ? memoOverlay() : memoOverlay);
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const injectFromPopover = props['data-popover-inject'];
    let tempOpen = open;
    // Hide tooltip when there is no title
    if (!('open' in props) && !('visible' in props) && noTitle) tempOpen = false;
    // ============================= Render =============================
    const child = /*#__PURE__*/ $acw62.isValidElement(children) && !(0, $30796c32f374b477$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $acw62.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $8bcca9e8f96db88a$export$2e2bcd8739ae039)(prefixCls, !injectFromPopover);
    // Color
    const colorInfo = (0, $080c438853985df7$export$6e865ea70d7724f)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const rootClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, colorInfo.className, rootClassName, hashId, cssVarCls, contextClassName, contextClassNames.root, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root);
    const bodyClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(contextClassNames.body, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)('Tooltip', restProps.zIndex);
    const content = /*#__PURE__*/ $acw62.createElement((0, $d0136ab94ce7f56e$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            body: bodyClassNames
        },
        styles: {
            root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, arrowContentStyle), contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
            body: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.body), overlayInnerStyle), styles === null || styles === void 0 ? void 0 : styles.body), colorInfo.overlayStyle)
        },
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: tooltipRef,
        builtinPlacements: tooltipPlacements,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onOpenChange,
        afterVisibleChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
        arrowContent: /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big-fast', props.transitionName),
            motionDeadline: 1000
        },
        // TODO: In the future, destroyTooltipOnHide in rc-tooltip needs to be upgrade to destroyOnHidden
        destroyTooltipOnHide: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : !!destroyTooltipOnHide
    }), tempOpen ? (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $2adf0f811816efa6$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, content));
});
const $0ac88bf86814a6e5$var$Tooltip = $0ac88bf86814a6e5$var$InternalTooltip;
$0ac88bf86814a6e5$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $e604628db2f2c0d3$export$2e2bcd8739ae039);
var $0ac88bf86814a6e5$export$2e2bcd8739ae039 = $0ac88bf86814a6e5$var$Tooltip;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $579f6109eaa96326$var$EnterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "enter",
    "theme": "outlined"
};
var $579f6109eaa96326$export$2e2bcd8739ae039 = $579f6109eaa96326$var$EnterOutlined;



var $ac0f9536ca737b46$var$EnterOutlined = function EnterOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $579f6109eaa96326$export$2e2bcd8739ae039)
    }));
};
/**![enter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2NCAxNzBoLTYwYy00LjQgMC04IDMuNi04IDh2NTE4SDMxMHYtNzNjMC02LjctNy44LTEwLjUtMTMtNi4zbC0xNDEuOSAxMTJhOCA4IDAgMDAwIDEyLjZsMTQxLjkgMTEyYzUuMyA0LjIgMTMgLjQgMTMtNi4zdi03NWg0OThjMzUuMyAwIDY0LTI4LjcgNjQtNjRWMTc4YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ var $ac0f9536ca737b46$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ac0f9536ca737b46$var$EnterOutlined);
var $ac0f9536ca737b46$export$2e2bcd8739ae039 = $ac0f9536ca737b46$var$RefIcon;



/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $8804d91907a0eb43$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $8804d91907a0eb43$var$KeyCode.F1 && keyCode <= $8804d91907a0eb43$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $8804d91907a0eb43$var$KeyCode.ALT:
            case $8804d91907a0eb43$var$KeyCode.CAPS_LOCK:
            case $8804d91907a0eb43$var$KeyCode.CONTEXT_MENU:
            case $8804d91907a0eb43$var$KeyCode.CTRL:
            case $8804d91907a0eb43$var$KeyCode.DOWN:
            case $8804d91907a0eb43$var$KeyCode.END:
            case $8804d91907a0eb43$var$KeyCode.ESC:
            case $8804d91907a0eb43$var$KeyCode.HOME:
            case $8804d91907a0eb43$var$KeyCode.INSERT:
            case $8804d91907a0eb43$var$KeyCode.LEFT:
            case $8804d91907a0eb43$var$KeyCode.MAC_FF_META:
            case $8804d91907a0eb43$var$KeyCode.META:
            case $8804d91907a0eb43$var$KeyCode.NUMLOCK:
            case $8804d91907a0eb43$var$KeyCode.NUM_CENTER:
            case $8804d91907a0eb43$var$KeyCode.PAGE_DOWN:
            case $8804d91907a0eb43$var$KeyCode.PAGE_UP:
            case $8804d91907a0eb43$var$KeyCode.PAUSE:
            case $8804d91907a0eb43$var$KeyCode.PRINT_SCREEN:
            case $8804d91907a0eb43$var$KeyCode.RIGHT:
            case $8804d91907a0eb43$var$KeyCode.SHIFT:
            case $8804d91907a0eb43$var$KeyCode.UP:
            case $8804d91907a0eb43$var$KeyCode.WIN_KEY:
            case $8804d91907a0eb43$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $8804d91907a0eb43$var$KeyCode.ZERO && keyCode <= $8804d91907a0eb43$var$KeyCode.NINE) return true;
        if (keyCode >= $8804d91907a0eb43$var$KeyCode.NUM_ZERO && keyCode <= $8804d91907a0eb43$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $8804d91907a0eb43$var$KeyCode.A && keyCode <= $8804d91907a0eb43$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $8804d91907a0eb43$var$KeyCode.SPACE:
            case $8804d91907a0eb43$var$KeyCode.QUESTION_MARK:
            case $8804d91907a0eb43$var$KeyCode.NUM_PLUS:
            case $8804d91907a0eb43$var$KeyCode.NUM_MINUS:
            case $8804d91907a0eb43$var$KeyCode.NUM_PERIOD:
            case $8804d91907a0eb43$var$KeyCode.NUM_DIVISION:
            case $8804d91907a0eb43$var$KeyCode.SEMICOLON:
            case $8804d91907a0eb43$var$KeyCode.DASH:
            case $8804d91907a0eb43$var$KeyCode.EQUALS:
            case $8804d91907a0eb43$var$KeyCode.COMMA:
            case $8804d91907a0eb43$var$KeyCode.PERIOD:
            case $8804d91907a0eb43$var$KeyCode.SLASH:
            case $8804d91907a0eb43$var$KeyCode.APOSTROPHE:
            case $8804d91907a0eb43$var$KeyCode.SINGLE_QUOTE:
            case $8804d91907a0eb43$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $8804d91907a0eb43$var$KeyCode.BACKSLASH:
            case $8804d91907a0eb43$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $8804d91907a0eb43$export$2e2bcd8739ae039 = $8804d91907a0eb43$var$KeyCode;




var $acw62 = parcelRequire("acw62");














var $acw62 = parcelRequire("acw62");
function $fd5fdd8da073bd4e$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $fd5fdd8da073bd4e$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function $fd5fdd8da073bd4e$var$cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    var currentTarget = target.cloneNode(true);
    // click clear icon
    var newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number') {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = function() {
        target.setSelectionRange.apply(target, arguments);
    };
    return newEvent;
}
function $fd5fdd8da073bd4e$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = $fd5fdd8da073bd4e$var$cloneEvent(e, target, '');
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== 'file' && targetValue !== undefined) {
        event = $fd5fdd8da073bd4e$var$cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}
function $fd5fdd8da073bd4e$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}


var $32a5e8fad29dc207$var$BaseInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props, _props2, _props3;
    var inputEl = props.inputElement, children = props.children, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style = props.style, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden, classes = props.classes, classNames = props.classNames, dataAttrs = props.dataAttrs, styles = props.styles, components = props.components, onClear = props.onClear;
    var inputElement = children !== null && children !== void 0 ? children : inputEl;
    var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || 'span';
    var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || 'span';
    var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || 'span';
    var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || 'span';
    var containerRef = (0, $acw62.useRef)(null);
    var onInputClick = function onInputClick(e) {
        var _containerRef$current;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    };
    var hasAffix = (0, $fd5fdd8da073bd4e$export$a19010aeeaa0c7a)(props);
    var element = /*#__PURE__*/ (0, $acw62.cloneElement)(inputElement, {
        value: value,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((_props = inputElement.props) === null || _props === void 0 ? void 0 : _props.className, !hasAffix && (classNames === null || classNames === void 0 ? void 0 : classNames.variant)) || null
    });
    // ======================== Ref ======================== //
    var groupRef = (0, $acw62.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return {
            nativeElement: groupRef.current || containerRef.current
        };
    });
    // ================== Prefix & Suffix ================== //
    if (hasAffix) {
        // ================== Clear Icon ================== //
        var clearIcon = null;
        if (allowClear) {
            var needClear = !disabled && !readOnly && value;
            var clearIconCls = "".concat(prefixCls, "-clear-icon");
            var iconNode = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(allowClear) === 'object' && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
            clearIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                tabIndex: -1,
                onClick: function onClick(event) {
                    handleReset === null || handleReset === void 0 || handleReset(event);
                    onClear === null || onClear === void 0 || onClear();
                },
                onMouseDown: function onMouseDown(e) {
                    return e.preventDefault();
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(clearIconCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(clearIconCls, "-hidden"), !needClear), "".concat(clearIconCls, "-has-suffix"), !!suffix))
            }, iconNode);
        }
        var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(affixWrapperPrefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-focused"), focused), "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.variant);
        var suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-suffix"), classNames === null || classNames === void 0 ? void 0 : classNames.suffix),
            style: styles === null || styles === void 0 ? void 0 : styles.suffix
        }, clearIcon, suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(AffixWrapperComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            className: affixWrapperCls,
            style: styles === null || styles === void 0 ? void 0 : styles.affixWrapper,
            onClick: onInputClick
        }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-prefix"), classNames === null || classNames === void 0 ? void 0 : classNames.prefix),
            style: styles === null || styles === void 0 ? void 0 : styles.prefix
        }, prefix), element, suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $fd5fdd8da073bd4e$export$ae6255aa850a31d1)(props)) {
        var wrapperCls = "".concat(prefixCls, "-group");
        var addonCls = "".concat(wrapperCls, "-addon");
        var groupWrapperCls = "".concat(wrapperCls, "-wrapper");
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper, classNames === null || classNames === void 0 ? void 0 : classNames.wrapper);
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(groupWrapperCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(groupWrapperCls, "-disabled"), disabled), classes === null || classes === void 0 ? void 0 : classes.group, classNames === null || classNames === void 0 ? void 0 : classNames.groupWrapper);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            ref: groupRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), element, addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    // `className` and `style` are always on the root element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((_props2 = element.props) === null || _props2 === void 0 ? void 0 : _props2.className, className) || null,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (_props3 = element.props) === null || _props3 === void 0 ? void 0 : _props3.style), style),
        hidden: hidden
    });
});
var $32a5e8fad29dc207$export$2e2bcd8739ae039 = $32a5e8fad29dc207$var$BaseInput;










function $1061fbcb6f08086c$export$2e2bcd8739ae039(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
var $8d507ba491af0684$var$_excluded = [
    "show"
];
function $8d507ba491af0684$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    var count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $8d507ba491af0684$export$2e2bcd8739ae039(count, showCount) {
    return $acw62.useMemo(function() {
        var mergedConfig = {};
        if (showCount) mergedConfig.show = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(showCount) === 'object' && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedConfig), count);
        var _ref = mergedConfig, show = _ref.show, rest = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $8d507ba491af0684$var$_excluded);
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rest), {}, {
            show: !!show,
            showFormatter: typeof show === 'function' ? show : undefined,
            strategy: rest.strategy || function(value) {
                return value.length;
            }
        });
    }, [
        count,
        showCount
    ]);
}



var $9cda19a001f87ecf$var$_excluded = [
    "autoComplete",
    "onChange",
    "onFocus",
    "onBlur",
    "onPressEnter",
    "onKeyDown",
    "onKeyUp",
    "prefixCls",
    "disabled",
    "htmlSize",
    "className",
    "maxLength",
    "suffix",
    "showCount",
    "count",
    "type",
    "classes",
    "classNames",
    "styles",
    "onCompositionStart",
    "onCompositionEnd"
];
var $9cda19a001f87ecf$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-input' : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, count = props.count, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, classes = props.classes, classNames = props.classNames, styles = props.styles, _onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, rest = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $9cda19a001f87ecf$var$_excluded);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var compositionRef = (0, $acw62.useRef)(false);
    var keyLockRef = (0, $acw62.useRef)(false);
    var inputRef = (0, $acw62.useRef)(null);
    var holderRef = (0, $acw62.useRef)(null);
    var focus = function focus(option) {
        if (inputRef.current) (0, $fd5fdd8da073bd4e$export$2b92016deb0b7aad)(inputRef.current, option);
    };
    // ====================== Value =======================
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? '' : String(value);
    // =================== Select Range ===================
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), selection = _useState4[0], setSelection = _useState4[1];
    // ====================== Count =======================
    var countConfig = (0, $8d507ba491af0684$export$2e2bcd8739ae039)(count, showCount);
    var mergedMax = countConfig.max || maxLength;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ======================= Ref ========================
    (0, $acw62.useImperativeHandle)(ref, function() {
        var _holderRef$current;
        return {
            focus: focus,
            blur: function blur() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            },
            setSelectionRange: function setSelectionRange(start, end, direction) {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
            },
            select: function select() {
                var _inputRef$current3;
                (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
            },
            input: inputRef.current,
            nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || inputRef.current
        };
    });
    (0, $acw62.useEffect)(function() {
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(function(prev) {
            return prev && disabled ? false : prev;
        });
    }, [
        disabled
    ]);
    var triggerChange = function triggerChange(e, currentValue, info) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) {
                var _inputRef$current4, _inputRef$current5;
                setSelection([
                    ((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.selectionStart) || 0,
                    ((_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.selectionEnd) || 0
                ]);
            }
        } else if (info.source === 'compositionEnd') // Avoid triggering twice
        // https://github.com/ant-design/ant-design/issues/46587
        return;
        setValue(cutValue);
        if (inputRef.current) (0, $fd5fdd8da073bd4e$export$c28984794956ddc0)(inputRef.current, e, onChange, cutValue);
    };
    (0, $acw62.useEffect)(function() {
        if (selection) {
            var _inputRef$current6;
            (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 || _inputRef$current6.setSelectionRange.apply(_inputRef$current6, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selection));
        }
    }, [
        selection
    ]);
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value, {
            source: 'change'
        });
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value, {
            source: 'compositionEnd'
        });
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (onPressEnter && e.key === 'Enter' && !keyLockRef.current) {
            keyLockRef.current = true;
            onPressEnter(e);
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleKeyUp = function handleKeyUp(e) {
        if (e.key === 'Enter') keyLockRef.current = false;
        onKeyUp === null || onKeyUp === void 0 || onKeyUp(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleReset = function handleReset(e) {
        setValue('');
        focus();
        if (inputRef.current) (0, $fd5fdd8da073bd4e$export$c28984794956ddc0)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    var outOfRangeCls = isOutOfRange && "".concat(prefixCls, "-out-of-range");
    var getInputElement = function getInputElement() {
        // Fix https://fb.me/react-unknown-prop
        var otherProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'count',
            'classes',
            'htmlSize',
            'styles',
            'classNames',
            'onClear'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), disabled), classNames === null || classNames === void 0 ? void 0 : classNames.input),
            style: styles === null || styles === void 0 ? void 0 : styles.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: function onCompositionStart(e) {
                compositionRef.current = true;
                _onCompositionStart === null || _onCompositionStart === void 0 || _onCompositionStart(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    var getSuffix = function getSuffix() {
        // Max length value
        var hasMaxLength = Number(mergedMax) > 0;
        if (suffix || countConfig.show) {
            var dataCount = countConfig.showFormatter ? countConfig.showFormatter({
                value: formatValue,
                count: valueLength,
                maxLength: mergedMax
            }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : '');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, countConfig.show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-show-count-suffix"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix), classNames === null || classNames === void 0 ? void 0 : classNames.count),
                style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, styles === null || styles === void 0 ? void 0 : styles.count)
            }, dataCount), suffix);
        }
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32a5e8fad29dc207$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, outOfRangeCls),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles,
        ref: holderRef
    }), getInputElement());
});
var $9cda19a001f87ecf$export$2e2bcd8739ae039 = $9cda19a001f87ecf$var$Input;


var $93b8a86f8ed15614$export$2e2bcd8739ae039 = (0, $9cda19a001f87ecf$export$2e2bcd8739ae039);






var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var $e3bb0cd99ab7a8bc$var$HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var $e3bb0cd99ab7a8bc$var$SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
    'word-break',
    'white-space'
];
var $e3bb0cd99ab7a8bc$var$computedStyleCache = {};
var $e3bb0cd99ab7a8bc$var$hiddenTextarea;
function $e3bb0cd99ab7a8bc$export$1a56dc6a39385a18(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef]) return $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef];
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    var sizingStyle = $e3bb0cd99ab7a8bc$var$SIZING_STYLE.map(function(name) {
        return "".concat(name, ":").concat(style.getPropertyValue(name));
    }).join(';');
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $e3bb0cd99ab7a8bc$export$2e2bcd8739ae039(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$e3bb0cd99ab7a8bc$var$hiddenTextarea) {
        $e3bb0cd99ab7a8bc$var$hiddenTextarea = document.createElement('textarea');
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute('tab-index', '-1');
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        // fix: A form field element should have an id or name attribute
        // A form field element has neither an id nor a name attribute. This might prevent the browser from correctly autofilling the form.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute('name', 'hiddenTextarea');
        document.body.appendChild($e3bb0cd99ab7a8bc$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    else $e3bb0cd99ab7a8bc$var$hiddenTextarea.removeAttribute('wrap');
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _calculateNodeStyling = $e3bb0cd99ab7a8bc$export$1a56dc6a39385a18(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat($e3bb0cd99ab7a8bc$var$HIDDEN_TEXTAREA_STYLE));
    $e3bb0cd99ab7a8bc$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    var minHeight = undefined;
    var maxHeight = undefined;
    var overflowY;
    var height = $e3bb0cd99ab7a8bc$var$hiddenTextarea.scrollHeight;
    if (boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === 'content-box') // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.value = ' ';
        var singleRowHeight = $e3bb0cd99ab7a8bc$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    var style = {
        height: height,
        overflowY: overflowY,
        resize: 'none'
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}


var $30d6639cbca42aae$var$_excluded = [
    "prefixCls",
    "defaultValue",
    "value",
    "autoSize",
    "onResize",
    "className",
    "style",
    "disabled",
    "onChange",
    "onInternalAutoSize"
];
var $30d6639cbca42aae$var$RESIZE_START = 0;
var $30d6639cbca42aae$var$RESIZE_MEASURING = 1;
var $30d6639cbca42aae$var$RESIZE_STABLE = 2;
var $30d6639cbca42aae$var$ResizableTextArea = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _ref = props, prefixCls = _ref.prefixCls, defaultValue = _ref.defaultValue, value = _ref.value, autoSize = _ref.autoSize, onResize = _ref.onResize, className = _ref.className, style = _ref.style, disabled = _ref.disabled, onChange = _ref.onChange, onInternalAutoSize = _ref.onInternalAutoSize, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $30d6639cbca42aae$var$_excluded);
    // =============================== Value ================================
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultValue, {
        value: value,
        postState: function postState(val) {
            return val !== null && val !== void 0 ? val : '';
        }
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
    var onInternalChange = function onInternalChange(event) {
        setMergedValue(event.target.value);
        onChange === null || onChange === void 0 || onChange(event);
    };
    // ================================ Ref =================================
    var textareaRef = $acw62.useRef();
    $acw62.useImperativeHandle(ref, function() {
        return {
            textArea: textareaRef.current
        };
    });
    // ============================== AutoSize ==============================
    var _React$useMemo = $acw62.useMemo(function() {
        if (autoSize && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(autoSize) === 'object') return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]), _React$useMemo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
    var needAutoSize = !!autoSize;
    // =============================== Resize ===============================
    var _React$useState = $acw62.useState($30d6639cbca42aae$var$RESIZE_STABLE), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
    var startResize = function startResize() {
        setResizeState($30d6639cbca42aae$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (resizeState === $30d6639cbca42aae$var$RESIZE_START) setResizeState($30d6639cbca42aae$var$RESIZE_MEASURING);
        else if (resizeState === $30d6639cbca42aae$var$RESIZE_MEASURING) {
            var textareaStyles = (0, $e3bb0cd99ab7a8bc$export$2e2bcd8739ae039)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($30d6639cbca42aae$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        }
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    var resizeRafRef = $acw62.useRef();
    var cleanRaf = function cleanRaf() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(resizeRafRef.current);
    };
    var onInternalResize = function onInternalResize(size) {
        if (resizeState === $30d6639cbca42aae$var$RESIZE_STABLE) {
            onResize === null || onResize === void 0 || onResize(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
                    startResize();
                });
            }
        }
    };
    $acw62.useEffect(function() {
        return cleanRaf;
    }, []);
    // =============================== Render ===============================
    var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    var mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), mergedAutoSizeStyle);
    if (resizeState === $30d6639cbca42aae$var$RESIZE_START || resizeState === $30d6639cbca42aae$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = 'hidden';
        mergedStyle.overflowX = 'hidden';
    }
    return /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $acw62.createElement("textarea", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), disabled)),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $30d6639cbca42aae$export$2e2bcd8739ae039 = $30d6639cbca42aae$var$ResizableTextArea;


var $368a509879ccc1d0$var$_excluded = [
    "defaultValue",
    "value",
    "onFocus",
    "onBlur",
    "onChange",
    "allowClear",
    "maxLength",
    "onCompositionStart",
    "onCompositionEnd",
    "suffix",
    "prefixCls",
    "showCount",
    "count",
    "className",
    "style",
    "disabled",
    "hidden",
    "classNames",
    "styles",
    "onResize",
    "onClear",
    "onPressEnter",
    "readOnly",
    "autoSize",
    "onKeyDown"
];
var $368a509879ccc1d0$var$TextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(_ref, ref) {
    var _countConfig$max;
    var defaultValue = _ref.defaultValue, customValue = _ref.value, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onChange = _ref.onChange, allowClear = _ref.allowClear, maxLength = _ref.maxLength, onCompositionStart = _ref.onCompositionStart, onCompositionEnd = _ref.onCompositionEnd, suffix = _ref.suffix, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-textarea' : _ref$prefixCls, showCount = _ref.showCount, count = _ref.count, className = _ref.className, style = _ref.style, disabled = _ref.disabled, hidden = _ref.hidden, classNames = _ref.classNames, styles = _ref.styles, onResize = _ref.onResize, onClear = _ref.onClear, onPressEnter = _ref.onPressEnter, readOnly = _ref.readOnly, autoSize = _ref.autoSize, onKeyDown = _ref.onKeyDown, rest = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $368a509879ccc1d0$var$_excluded);
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultValue, {
        value: customValue,
        defaultValue: defaultValue
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? '' : String(value);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), textareaResized = _React$useState4[0], setTextareaResized = _React$useState4[1];
    // =============================== Ref ================================
    var holderRef = (0, $acw62.useRef)(null);
    var resizableTextAreaRef = (0, $acw62.useRef)(null);
    var getTextArea = function getTextArea() {
        var _resizableTextAreaRef;
        return (_resizableTextAreaRef = resizableTextAreaRef.current) === null || _resizableTextAreaRef === void 0 ? void 0 : _resizableTextAreaRef.textArea;
    };
    var focus = function focus() {
        getTextArea().focus();
    };
    (0, $acw62.useImperativeHandle)(ref, function() {
        var _holderRef$current;
        return {
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: function blur() {
                getTextArea().blur();
            },
            nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || getTextArea()
        };
    });
    (0, $acw62.useEffect)(function() {
        setFocused(function(prev) {
            return !disabled && prev;
        });
    }, [
        disabled
    ]);
    // =========================== Select Range ===========================
    var _React$useState5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), selection = _React$useState6[0], setSelection = _React$useState6[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (selection) {
            var _getTextArea;
            (_getTextArea = getTextArea()).setSelectionRange.apply(_getTextArea, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selection));
        }
    }, [
        selection
    ]);
    // ============================== Count ===============================
    var countConfig = (0, $8d507ba491af0684$export$2e2bcd8739ae039)(count, showCount);
    var mergedMax = (_countConfig$max = countConfig.max) !== null && _countConfig$max !== void 0 ? _countConfig$max : maxLength;
    // Max length value
    var hasMaxLength = Number(mergedMax) > 0;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ============================== Change ==============================
    var triggerChange = function triggerChange(e, currentValue) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                getTextArea().selectionStart || 0,
                getTextArea().selectionEnd || 0
            ]);
        }
        setValue(cutValue);
        (0, $fd5fdd8da073bd4e$export$c28984794956ddc0)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    var onInternalCompositionStart = function onInternalCompositionStart(e) {
        compositionRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && onPressEnter) onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    // ============================== Reset ===============================
    var handleReset = function handleReset(e) {
        setValue('');
        focus();
        (0, $fd5fdd8da073bd4e$export$c28984794956ddc0)(getTextArea(), e, onChange);
    };
    var suffixNode = suffix;
    var dataCount;
    if (countConfig.show) {
        if (countConfig.showFormatter) dataCount = countConfig.showFormatter({
            value: formatValue,
            count: valueLength,
            maxLength: mergedMax
        });
        else dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : '');
        suffixNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suffixNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-data-count"), classNames === null || classNames === void 0 ? void 0 : classNames.count),
            style: styles === null || styles === void 0 ? void 0 : styles.count
        }, dataCount));
    }
    var handleResize = function handleResize(size) {
        var _getTextArea2;
        onResize === null || onResize === void 0 || onResize(size);
        if ((_getTextArea2 = getTextArea()) !== null && _getTextArea2 !== void 0 && _getTextArea2.style.height) setTextareaResized(true);
    };
    var isPureTextArea = !autoSize && !showCount && !allowClear;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32a5e8fad29dc207$export$2e2bcd8739ae039), {
        ref: holderRef,
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classNames: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, classNames), {}, {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-show-count"), showCount), "".concat(prefixCls, "-textarea-allow-clear"), allowClear))
        }),
        disabled: disabled,
        focused: focused,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, isOutOfRange && "".concat(prefixCls, "-out-of-range")),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), textareaResized && !isPureTextArea ? {
            height: 'auto'
        } : {}),
        dataAttrs: {
            affixWrapper: {
                'data-count': typeof dataCount === 'string' ? dataCount : undefined
            }
        },
        hidden: hidden,
        readOnly: readOnly,
        onClear: onClear
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30d6639cbca42aae$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, {
        autoSize: autoSize,
        maxLength: maxLength,
        onKeyDown: handleKeyDown,
        onChange: onInternalChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onCompositionStart: onInternalCompositionStart,
        onCompositionEnd: onInternalCompositionEnd,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(classNames === null || classNames === void 0 ? void 0 : classNames.textarea),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, styles === null || styles === void 0 ? void 0 : styles.textarea), {}, {
            resize: style === null || style === void 0 ? void 0 : style.resize
        }),
        disabled: disabled,
        prefixCls: prefixCls,
        onResize: handleResize,
        ref: resizableTextAreaRef,
        readOnly: readOnly
    })));
});
var $368a509879ccc1d0$export$2e2bcd8739ae039 = $368a509879ccc1d0$var$TextArea;



var $36948fc6671d6b75$export$2e2bcd8739ae039 = (0, $368a509879ccc1d0$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

"use client";
const $f9fe093fa4df8f6d$var$getAllowClear = (allowClear)=>{
    let mergedAllowClear;
    if (typeof allowClear === 'object' && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null)
    };
    return mergedAllowClear;
};
var $f9fe093fa4df8f6d$export$2e2bcd8739ae039 = $f9fe093fa4df8f6d$var$getAllowClear;



const $67f89d06f52454a6$var$_InputStatuses = [
    'warning',
    'error',
    ''
];
function $67f89d06f52454a6$export$b08e7b47149942a2(prefixCls, status, hasFeedback) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-status-success`]: status === 'success',
        [`${prefixCls}-status-warning`]: status === 'warning',
        [`${prefixCls}-status-error`]: status === 'error',
        [`${prefixCls}-status-validating`]: status === 'validating',
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
}
const $67f89d06f52454a6$export$314e193082d7ba49 = (contextStatus, customStatus)=>customStatus || contextStatus;









var $acw62 = parcelRequire("acw62");


/**
 * Compatible for legacy `bordered` prop.
 */ const $ce4103032ab2fd5e$var$useVariant = (component, variant, legacyBordered)=>{
    var _a, _b;
    const { variant: configVariant, [component]: componentConfig } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const ctxVariant = $acw62.useContext((0, $ad5d550b51ac8abd$export$6f0555dad42725fb));
    const configComponentVariant = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.variant;
    let mergedVariant;
    if (typeof variant !== 'undefined') mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = 'borderless';
    else // form variant > component global variant > global variant
    mergedVariant = (_b = (_a = ctxVariant !== null && ctxVariant !== void 0 ? ctxVariant : configComponentVariant) !== null && _a !== void 0 ? _a : configVariant) !== null && _b !== void 0 ? _b : 'outlined';
    const enableVariantCls = (0, $a18b2f6f56546238$export$fa216ce2679a073b).includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls
    ];
};
var $ce4103032ab2fd5e$export$2e2bcd8739ae039 = $ce4103032ab2fd5e$var$useVariant;






// handle border collapse
function $0eabbafc4673511e$var$compactItemBorder(token, parentCls, options) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? '> *' : '';
    const hoverEffects = [
        'hover',
        focus ? 'focus' : null,
        'active'
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(',');
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        '&-item': Object.assign(Object.assign({
            [hoverEffects]: {
                zIndex: 2
            }
        }, focusElCls ? {
            [`&${focusElCls}`]: {
                zIndex: 2
            }
        } : {}), {
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        })
    };
}
// handle border-radius
function $0eabbafc4673511e$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : '';
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $0eabbafc4673511e$export$b1208b23589b4b73(token, options = {
    focus: true
}) {
    const { componentCls: componentCls } = token;
    const compactCls = `${componentCls}-compact`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $0eabbafc4673511e$var$compactItemBorder(token, compactCls, options)), $0eabbafc4673511e$var$compactItemBorderRadius(componentCls, compactCls, options))
    };
}




function $500d0ae39d0ead62$export$a157d95850191a12(token) {
    return (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $500d0ae39d0ead62$export$bd8b682992bc9781 = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline, colorBgContainer: colorBgContainer, inputFontSize: inputFontSize, inputFontSizeLG: inputFontSizeLG, inputFontSizeSM: inputFontSizeSM } = token;
    const mergedFontSize = inputFontSize || fontSize;
    const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
    const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
    const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
    return {
        paddingBlock: Math.max(paddingBlock, 0),
        paddingBlockSM: Math.max(paddingBlockSM, 0),
        paddingBlockLG: Math.max(paddingBlockLG, 0),
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: mergedFontSize,
        inputFontSizeLG: mergedFontSizeLG,
        inputFontSizeSM: mergedFontSizeSM
    };
};




const $26df503c9b7ea2eb$export$bf820fba296f2fd8 = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const $26df503c9b7ea2eb$export$12789f962d420a93 = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
        'input[disabled], textarea[disabled]': {
            cursor: 'not-allowed'
        },
        '&:hover:not([disabled])': Object.assign({}, $26df503c9b7ea2eb$export$bf820fba296f2fd8((0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
            hoverBorderColor: token.colorBorder,
            hoverBg: token.colorBgContainerDisabled
        })))
    });
const $26df503c9b7ea2eb$export$8c569e4cc3fd115f = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        '&:hover': {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $26df503c9b7ea2eb$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $26df503c9b7ea2eb$export$8c569e4cc3fd115f(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }),
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const $26df503c9b7ea2eb$export$53795bafd774ce02 = (token, extraStyles)=>({
        '&-outlined': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $26df503c9b7ea2eb$export$8c569e4cc3fd115f(token, {
            borderColor: token.colorBorder,
            hoverBorderColor: token.hoverBorderColor,
            activeBorderColor: token.activeBorderColor,
            activeShadow: token.activeShadow
        })), {
            [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, $26df503c9b7ea2eb$export$12789f962d420a93(token))
        }), $26df503c9b7ea2eb$var$genOutlinedStatusStyle(token, {
            status: 'error',
            borderColor: token.colorError,
            hoverBorderColor: token.colorErrorBorderHover,
            activeBorderColor: token.colorError,
            activeShadow: token.errorActiveShadow,
            affixColor: token.colorError
        })), $26df503c9b7ea2eb$var$genOutlinedStatusStyle(token, {
            status: 'warning',
            borderColor: token.colorWarning,
            hoverBorderColor: token.colorWarningBorderHover,
            activeBorderColor: token.colorWarning,
            activeShadow: token.warningActiveShadow,
            affixColor: token.colorWarning
        })), extraStyles)
    });
const $26df503c9b7ea2eb$var$genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const $26df503c9b7ea2eb$export$8f88f32c046ff727 = (token)=>({
        '&-outlined': Object.assign(Object.assign(Object.assign({
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.addonBg,
                    border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                '&-addon:first-child': {
                    borderInlineEnd: 0
                },
                '&-addon:last-child': {
                    borderInlineStart: 0
                }
            }
        }, $26df503c9b7ea2eb$var$genOutlinedGroupStatusStyle(token, {
            status: 'error',
            addonBorderColor: token.colorError,
            addonColor: token.colorErrorText
        })), $26df503c9b7ea2eb$var$genOutlinedGroupStatusStyle(token, {
            status: 'warning',
            addonBorderColor: token.colorWarning,
            addonColor: token.colorWarningText
        })), {
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: Object.assign({}, $26df503c9b7ea2eb$export$12789f962d420a93(token))
            }
        })
    });
const $26df503c9b7ea2eb$export$b6de5da7f39edfcb = (token, extraStyles)=>{
    const { componentCls: componentCls } = token;
    return {
        '&-borderless': Object.assign({
            background: 'transparent',
            border: 'none',
            '&:focus, &:focus-within': {
                outline: 'none'
            },
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: {
                '&, & input, & textarea': {
                    color: token.colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                '&, & input, & textarea': {
                    color: token.colorWarning
                }
            }
        }, extraStyles)
    };
};
/* ============== Filled ============== */ const $26df503c9b7ea2eb$var$genBaseFilledStyle = (token, options)=>{
    var _a;
    return {
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: 'transparent',
        'input&, & input, textarea&, & textarea': {
            color: (_a = options === null || options === void 0 ? void 0 : options.inputColor) !== null && _a !== void 0 ? _a : 'unset'
        },
        '&:hover': {
            background: options.hoverBg
        },
        '&:focus, &:focus-within': {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    };
};
const $26df503c9b7ea2eb$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $26df503c9b7ea2eb$var$genBaseFilledStyle(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        })
    });
const $26df503c9b7ea2eb$export$b8365cd7e6671d79 = (token, extraStyles)=>({
        '&-filled': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $26df503c9b7ea2eb$var$genBaseFilledStyle(token, {
            bg: token.colorFillTertiary,
            hoverBg: token.colorFillSecondary,
            activeBorderColor: token.activeBorderColor
        })), {
            [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, $26df503c9b7ea2eb$export$12789f962d420a93(token))
        }), $26df503c9b7ea2eb$var$genFilledStatusStyle(token, {
            status: 'error',
            bg: token.colorErrorBg,
            hoverBg: token.colorErrorBgHover,
            activeBorderColor: token.colorError,
            inputColor: token.colorErrorText,
            affixColor: token.colorError
        })), $26df503c9b7ea2eb$var$genFilledStatusStyle(token, {
            status: 'warning',
            bg: token.colorWarningBg,
            hoverBg: token.colorWarningBgHover,
            activeBorderColor: token.colorWarning,
            inputColor: token.colorWarningText,
            affixColor: token.colorWarning
        })), extraStyles)
    });
const $26df503c9b7ea2eb$var$genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const $26df503c9b7ea2eb$export$542c0fce51b1d515 = (token)=>({
        '&-filled': Object.assign(Object.assign(Object.assign({
            [`${token.componentCls}-group-addon`]: {
                background: token.colorFillTertiary,
                '&:last-child': {
                    position: 'static'
                }
            }
        }, $26df503c9b7ea2eb$var$genFilledGroupStatusStyle(token, {
            status: 'error',
            addonBg: token.colorErrorBg,
            addonColor: token.colorErrorText
        })), $26df503c9b7ea2eb$var$genFilledGroupStatusStyle(token, {
            status: 'warning',
            addonBg: token.colorWarningBg,
            addonColor: token.colorWarningText
        })), {
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    '&-addon': {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    '&-addon:first-child': {
                        borderInlineStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    '&-addon:last-child': {
                        borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        })
    });
const $26df503c9b7ea2eb$export$7617a11352d704b9 = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} 0`,
        borderStyle: `${token.lineType} none`,
        borderColor: `transparent transparent ${options.borderColor} transparent`,
        borderRadius: 0,
        '&:hover': {
            borderColor: `transparent transparent ${options.borderColor} transparent`,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: `transparent transparent ${options.activeBorderColor} transparent`,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $26df503c9b7ea2eb$var$genUnderlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $26df503c9b7ea2eb$export$7617a11352d704b9(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }),
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: `transparent transparent ${options.borderColor} transparent`
        }
    });
const $26df503c9b7ea2eb$export$34771e60e0439351 = (token, extraStyles)=>({
        '&-underlined': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $26df503c9b7ea2eb$export$7617a11352d704b9(token, {
            borderColor: token.colorBorder,
            hoverBorderColor: token.hoverBorderColor,
            activeBorderColor: token.activeBorderColor,
            activeShadow: token.activeShadow
        })), {
            // >>>>> Disabled
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                boxShadow: 'none',
                cursor: 'not-allowed',
                '&:hover': {
                    borderColor: `transparent transparent ${token.colorBorder} transparent`
                }
            },
            'input[disabled], textarea[disabled]': {
                cursor: 'not-allowed'
            }
        }), $26df503c9b7ea2eb$var$genUnderlinedStatusStyle(token, {
            status: 'error',
            borderColor: token.colorError,
            hoverBorderColor: token.colorErrorBorderHover,
            activeBorderColor: token.colorError,
            activeShadow: token.errorActiveShadow,
            affixColor: token.colorError
        })), $26df503c9b7ea2eb$var$genUnderlinedStatusStyle(token, {
            status: 'warning',
            borderColor: token.colorWarning,
            hoverBorderColor: token.colorWarningBorderHover,
            activeBorderColor: token.colorWarning,
            activeShadow: token.warningActiveShadow,
            affixColor: token.colorWarning
        })), extraStyles)
    });


const $232788b5c0fca573$export$92095d0f4c77bd56 = (color)=>({
        // Firefox
        '&::-moz-placeholder': {
            opacity: 1
        },
        '&::placeholder': {
            color: color,
            userSelect: 'none' // https://github.com/ant-design/ant-design/pull/32639
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        }
    });
const $232788b5c0fca573$export$3fe86db3643510f9 = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const $232788b5c0fca573$var$genInputLargeStyle = (token)=>{
    const { paddingBlockLG: paddingBlockLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlockLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $232788b5c0fca573$export$bb047f62c5a56f90 = (token)=>({
        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingBlockSM)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
const $232788b5c0fca573$export$8c9a381315f3ebcd = (token)=>Object.assign(Object.assign({
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        minWidth: 0,
        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingBlock)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`
    }, $232788b5c0fca573$export$92095d0f4c77bd56(token.colorTextPlaceholder)), {
        // Size
        '&-lg': Object.assign({}, $232788b5c0fca573$var$genInputLargeStyle(token)),
        '&-sm': Object.assign({}, $232788b5c0fca573$export$bb047f62c5a56f90(token)),
        // RTL
        '&-rtl, &-textarea-rtl': {
            direction: 'rtl'
        }
    });
const $232788b5c0fca573$export$ffe8b2a9bd2e5cfe = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: 'relative',
        display: 'table',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            '&:last-child': {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: Object.assign({}, $232788b5c0fca573$var$genInputLargeStyle(token)),
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: Object.assign({}, $232788b5c0fca573$export$bb047f62c5a56f90(token)),
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: 'table-cell',
            '&:not(:first-child):not(:last-child)': {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            '&-addon, &-wrap': {
                display: 'table-cell',
                width: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                '&:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                }
            },
            '&-wrap > *': {
                display: 'block !important'
            },
            '&-addon': {
                position: 'relative',
                padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.inputFontSize,
                textAlign: 'center',
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        [`${antCls}-select-selector`]: {
                            backgroundColor: 'inherit',
                            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                            boxShadow: 'none'
                        }
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: 'transparent',
                    [`${antCls}-cascader-input`]: {
                        textAlign: 'start',
                        border: 0,
                        boxShadow: 'none'
                    }
                }
            }
        },
        [componentCls]: {
            width: '100%',
            marginBottom: 0,
            textAlign: 'inherit',
            '&:focus': {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            '&:hover': {
                zIndex: 1,
                borderInlineEndWidth: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            '&:not(:last-child)': {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0,
                [`${componentCls}-search &`]: {
                    borderStartStartRadius: token.borderRadius,
                    borderEndStartRadius: token.borderRadius
                }
            },
            [`&:not(:first-child), ${componentCls}-search &:not(:first-child)`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: Object.assign(Object.assign({
            display: 'block'
        }, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()), {
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                '&:not(:first-child):not(:last-child)': {
                    borderInlineEndWidth: token.lineWidth,
                    '&:hover, &:focus': {
                        zIndex: 1
                    }
                }
            },
            '& > *': {
                display: 'inline-flex',
                float: 'none',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: 'inline-flex'
            },
            '& > *:not(:last-child)': {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [componentCls]: {
                float: 'none'
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child > ${antCls}-select-selector,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: 'top'
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                    borderRadius: 0
                }
            },
            [`${componentCls}-group-wrapper:not(:last-child)`]: {
                [`&${componentCls}-search > ${componentCls}-group`]: {
                    [`& > ${componentCls}-group-addon > ${componentCls}-search-button`]: {
                        borderRadius: 0
                    },
                    [`& > ${componentCls}`]: {
                        borderStartStartRadius: token.borderRadius,
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0,
                        borderEndStartRadius: token.borderRadius
                    }
                }
            }
        })
    };
};
const $232788b5c0fca573$export$9a752c3888370836 = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), $232788b5c0fca573$export$8c9a381315f3ebcd(token)), (0, $26df503c9b7ea2eb$export$53795bafd774ce02)(token)), (0, $26df503c9b7ea2eb$export$b8365cd7e6671d79)(token)), (0, $26df503c9b7ea2eb$export$b6de5da7f39edfcb)(token)), (0, $26df503c9b7ea2eb$export$34771e60e0439351)(token)), {
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                appearance: 'none'
            }
        })
    };
};
const $232788b5c0fca573$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            padding: 0,
            lineHeight: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            '&:hover': {
                color: token.colorIcon
            },
            '&:active': {
                color: token.colorText
            },
            '&-hidden': {
                visibility: 'hidden'
            },
            '&-has-suffix': {
                margin: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.inputAffixPadding)}`
            }
        }
    };
};
const $232788b5c0fca573$export$77a75da75a374eb9 = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover, iconCls: iconCls } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
    return {
        [affixCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, $232788b5c0fca573$export$8c9a381315f3ebcd(token)), {
            display: 'inline-flex',
            [`&:not(${componentCls}-disabled):hover`]: {
                zIndex: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            },
            '&-focused, &:focus': {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: 'inherit',
                border: 'none',
                borderRadius: 0,
                outline: 'none',
                background: 'transparent',
                color: 'inherit',
                '&::-ms-reveal': {
                    display: 'none'
                },
                '&:focus': {
                    boxShadow: 'none !important'
                }
            },
            '&::before': {
                display: 'inline-block',
                width: 0,
                visibility: 'hidden',
                content: '"\\a0"'
            },
            [componentCls]: {
                '&-prefix, &-suffix': {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    '> *:not(:last-child)': {
                        marginInlineEnd: token.paddingXS
                    }
                },
                '&-show-count-suffix': {
                    color: colorTextDescription,
                    direction: 'ltr'
                },
                '&-show-count-has-suffix': {
                    marginInlineEnd: token.paddingXXS
                },
                '&-prefix': {
                    marginInlineEnd: inputAffixPadding
                },
                '&-suffix': {
                    marginInlineStart: inputAffixPadding
                }
            }
        }), $232788b5c0fca573$var$genAllowClearStyle(token)), {
            // password
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'pointer',
                transition: `all ${motionDurationSlow}`,
                '&:hover': {
                    color: colorIconHover
                }
            }
        }),
        // 覆盖 affix-wrapper borderRadius！
        [`${componentCls}-underlined`]: {
            borderRadius: 0
        },
        [affixClsDisabled]: {
            // password disabled
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'not-allowed',
                '&:hover': {
                    color: colorIcon
                }
            }
        }
    };
};
const $232788b5c0fca573$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), $232788b5c0fca573$export$ffe8b2a9bd2e5cfe(token)), {
            '&-rtl': {
                direction: 'rtl'
            },
            '&-wrapper': Object.assign(Object.assign(Object.assign({
                display: 'inline-block',
                width: '100%',
                textAlign: 'start',
                verticalAlign: 'top',
                '&-rtl': {
                    direction: 'rtl'
                },
                // Size
                '&-lg': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                '&-sm': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                }
            }, (0, $26df503c9b7ea2eb$export$8f88f32c046ff727)(token)), (0, $26df503c9b7ea2eb$export$542c0fce51b1d515)(token)), {
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                // Fix the issue of input use `addonAfter` param in space compact mode
                // https://github.com/ant-design/ant-design/issues/52483
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            })
        })
    };
};
const $232788b5c0fca573$var$genSearchInputStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const searchPrefixCls = `${componentCls}-search`;
    return {
        [searchPrefixCls]: {
            [componentCls]: {
                '&:hover, &:focus': {
                    [`+ ${componentCls}-group-addon ${searchPrefixCls}-button:not(${antCls}-btn-color-primary):not(${antCls}-btn-variant-text)`]: {
                        borderInlineStartColor: token.colorPrimaryHover
                    }
                }
            },
            [`${componentCls}-affix-wrapper`]: {
                height: token.controlHeight,
                borderRadius: 0
            },
            // fix slight height diff in Firefox:
            // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
            [`${componentCls}-lg`]: {
                lineHeight: token.calc(token.lineHeightLG).sub(0.0002).equal()
            },
            [`> ${componentCls}-group`]: {
                [`> ${componentCls}-group-addon:last-child`]: {
                    insetInlineStart: -1,
                    padding: 0,
                    border: 0,
                    [`${searchPrefixCls}-button`]: {
                        // Fix https://github.com/ant-design/ant-design/issues/47150
                        marginInlineEnd: -1,
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0,
                        boxShadow: 'none'
                    },
                    [`${searchPrefixCls}-button:not(${antCls}-btn-color-primary)`]: {
                        color: token.colorTextDescription,
                        '&:hover': {
                            color: token.colorPrimaryHover
                        },
                        '&:active': {
                            color: token.colorPrimaryActive
                        },
                        [`&${antCls}-btn-loading::before`]: {
                            inset: 0
                        }
                    }
                }
            },
            [`${searchPrefixCls}-button`]: {
                height: token.controlHeight,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            '&-large': {
                [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
                    height: token.controlHeightLG
                }
            },
            '&-small': {
                [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
                    height: token.controlHeightSM
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            // ===================== Compact Item Customized Styles =====================
            [`&${componentCls}-compact-item`]: {
                [`&:not(${componentCls}-compact-last-item)`]: {
                    [`${componentCls}-group-addon`]: {
                        [`${componentCls}-search-button`]: {
                            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                            borderRadius: 0
                        }
                    }
                },
                [`&:not(${componentCls}-compact-first-item)`]: {
                    [`${componentCls},${componentCls}-affix-wrapper`]: {
                        borderRadius: 0
                    }
                },
                [`> ${componentCls}-group-addon ${componentCls}-search-button,
        > ${componentCls},
        ${componentCls}-affix-wrapper`]: {
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    }
                },
                [`> ${componentCls}-affix-wrapper-focused`]: {
                    zIndex: 2
                }
            }
        }
    };
};
// ============================== Range ===============================
const $232788b5c0fca573$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
const $232788b5c0fca573$export$de732caeaad5f68e = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Input',
    'Shared'
], (token)=>{
    const inputToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return [
        $232788b5c0fca573$export$9a752c3888370836(inputToken),
        $232788b5c0fca573$export$77a75da75a374eb9(inputToken)
    ];
}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781), {
    resetFont: false
});
var $232788b5c0fca573$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Input',
    'Component'
], (token)=>{
    const inputToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return [
        $232788b5c0fca573$var$genGroupStyle(inputToken),
        $232788b5c0fca573$var$genSearchInputStyle(inputToken),
        $232788b5c0fca573$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(inputToken)
    ];
}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781), {
    resetFont: false
});




const $7d6cde41567351b1$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        // Raw Textarea
        [`textarea${componentCls}`]: {
            maxWidth: '100%',
            // prevent textarea resize from coming out of its container
            height: 'auto',
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: 'bottom',
            transition: `all ${token.motionDurationSlow}`,
            resize: 'vertical',
            [`&${componentCls}-mouse-active`]: {
                transition: `all ${token.motionDurationSlow}, height 0s, width 0s`
            }
        },
        // Wrapper for resize
        [`${componentCls}-textarea-affix-wrapper-resize-dirty`]: {
            width: 'auto'
        },
        [textareaPrefixCls]: {
            position: 'relative',
            '&-show-count': {
                [`${componentCls}-data-count`]: {
                    position: 'absolute',
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: 'inherit',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    minHeight: token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal(),
                    '&:focus': {
                        boxShadow: 'none !important'
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    '> *:not(:last-child)': {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: 'absolute',
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: 'inline-flex',
                        alignItems: 'center',
                        margin: 'auto',
                        pointerEvents: 'none'
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-rtl`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-data-count`]: {
                        direction: 'ltr',
                        insetInlineStart: 0
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
var // ============================== Export ==============================
$7d6cde41567351b1$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Input',
    'TextArea'
], (token)=>{
    const inputToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return [
        $7d6cde41567351b1$var$genTextAreaStyle(inputToken)
    ];
}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
var $fc29eec8796e8593$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $fc29eec8796e8593$var$TextArea = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classes, rootClassName: rootClassName, className: className, style: style, styles: styles, variant: customVariant, showCount: showCount, onMouseDown: onMouseDown, onResize: onResize } = props, rest = $fc29eec8796e8593$var$__rest(props, [
        "prefixCls",
        "bordered",
        "size",
        "disabled",
        "status",
        "allowClear",
        "classNames",
        "rootClassName",
        "className",
        "style",
        "styles",
        "variant",
        "showCount",
        "onMouseDown",
        "onResize"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('textArea');
    // =================== Disabled ===================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ==================== Status ====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Ref ======================
    const innerRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>{
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: (option)=>{
                var _a, _b;
                (0, $fd5fdd8da073bd4e$export$2b92016deb0b7aad)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: ()=>{
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    // ==================== Style =====================
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapSharedCSSVar, hashId, cssVarCls] = (0, $232788b5c0fca573$export$de732caeaad5f68e)(prefixCls, rootClassName);
    const [wrapCSSVar] = (0, $7d6cde41567351b1$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ================= Compact Item =================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    const [variant, enableVariantCls] = (0, $ce4103032ab2fd5e$export$2e2bcd8739ae039)('textArea', customVariant, bordered);
    const mergedAllowClear = (0, $f9fe093fa4df8f6d$export$2e2bcd8739ae039)(allowClear !== null && allowClear !== void 0 ? allowClear : contextAllowClear);
    // ==================== Resize ====================
    // https://github.com/ant-design/ant-design/issues/51594
    const [isMouseDown, setIsMouseDown] = $acw62.useState(false);
    // When has wrapper, resize will make as dirty for `resize: both` style
    const [resizeDirty, setResizeDirty] = $acw62.useState(false);
    const onInternalMouseDown = (e)=>{
        setIsMouseDown(true);
        onMouseDown === null || onMouseDown === void 0 || onMouseDown(e);
        const onMouseUp = ()=>{
            setIsMouseDown(false);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mouseup', onMouseUp);
    };
    const onInternalResize = (size)=>{
        var _a, _b;
        onResize === null || onResize === void 0 || onResize(size);
        // Change to dirty since this maybe from the `resize: both` style
        if (isMouseDown && typeof getComputedStyle === 'function') {
            const ele = (_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.querySelector('textarea');
            if (ele && getComputedStyle(ele).resize === 'both') setResizeDirty(true);
        }
    };
    // ==================== Render ====================
    return wrapSharedCSSVar(wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $36948fc6671d6b75$export$2e2bcd8739ae039), Object.assign({
        autoComplete: contextAutoComplete
    }, rest, {
        style: Object.assign(Object.assign({}, contextStyle), style),
        styles: Object.assign(Object.assign({}, contextStyles), styles),
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(cssVarCls, rootCls, className, rootClassName, compactItemClassnames, contextClassName, // Only for wrapper
        resizeDirty && `${prefixCls}-textarea-affix-wrapper-resize-dirty`),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), contextClassNames), {
            textarea: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large'
            }, hashId, classes === null || classes === void 0 ? void 0 : classes.textarea, contextClassNames.textarea, isMouseDown && `${prefixCls}-mouse-active`),
            variant: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-textarea-show-count`]: showCount || ((_a = props.count) === null || _a === void 0 ? void 0 : _a.show)
            }, hashId)
        }),
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        showCount: showCount,
        ref: innerRef,
        onResize: onInternalResize,
        onMouseDown: onInternalMouseDown
    }))));
});
var $fc29eec8796e8593$export$2e2bcd8739ae039 = $fc29eec8796e8593$var$TextArea;




/*
.typography-title(@fontSize; @fontWeight; @lineHeight; @headingColor; @headingMarginBottom;) {
 margin-bottom: @headingMarginBottom;
 color: @headingColor;
 font-weight: @fontWeight;
 fontSize: @fontSize;
 line-height: @lineHeight;
}
*/ 


const $950f24b0c690e3c4$var$getTitleStyle = (fontSize, lineHeight, color, token)=>{
    const { titleMarginBottom: titleMarginBottom, fontWeightStrong: fontWeightStrong } = token;
    return {
        marginBottom: titleMarginBottom,
        color: color,
        fontWeight: fontWeightStrong,
        fontSize: fontSize,
        lineHeight: lineHeight
    };
};
const $950f24b0c690e3c4$export$83146cf7d1bec659 = (token)=>{
    const headings = [
        1,
        2,
        3,
        4,
        5
    ];
    const styles = {};
    headings.forEach((headingLevel)=>{
        styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = $950f24b0c690e3c4$var$getTitleStyle(token[`fontSizeHeading${headingLevel}`], token[`lineHeightHeading${headingLevel}`], token.colorTextHeading, token);
    });
    return styles;
};
const $950f24b0c690e3c4$export$566f4066c7caac18 = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        'a&, a': Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$9a16e7694a707ab4)(token)), {
            userSelect: 'text',
            [`&[disabled], &${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                '&:active, &:hover': {
                    color: token.colorTextDisabled
                },
                '&:active': {
                    pointerEvents: 'none'
                }
            }
        })
    };
};
const $950f24b0c690e3c4$export$977383a86f45014b = (token)=>({
        code: {
            margin: '0 0.2em',
            paddingInline: '0.4em',
            paddingBlock: '0.2em 0.1em',
            fontSize: '85%',
            fontFamily: token.fontFamilyCode,
            background: 'rgba(150, 150, 150, 0.1)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderRadius: 3
        },
        kbd: {
            margin: '0 0.2em',
            paddingInline: '0.4em',
            paddingBlock: '0.15em 0.1em',
            fontSize: '90%',
            fontFamily: token.fontFamilyCode,
            background: 'rgba(150, 150, 150, 0.06)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderBottomWidth: 2,
            borderRadius: 3
        },
        mark: {
            padding: 0,
            // FIXME hardcode in v4
            backgroundColor: (0, $0b4842326956570d$export$c24201f7fe3571d8)[2]
        },
        'u, ins': {
            textDecoration: 'underline',
            textDecorationSkipInk: 'auto'
        },
        's, del': {
            textDecoration: 'line-through'
        },
        strong: {
            fontWeight: token.fontWeightStrong
        },
        // list
        'ul, ol': {
            marginInline: 0,
            marginBlock: '0 1em',
            padding: 0,
            li: {
                marginInline: '20px 0',
                marginBlock: 0,
                paddingInline: '4px 0',
                paddingBlock: 0
            }
        },
        ul: {
            listStyleType: 'circle',
            ul: {
                listStyleType: 'disc'
            }
        },
        ol: {
            listStyleType: 'decimal'
        },
        // pre & block
        'pre, blockquote': {
            margin: '1em 0'
        },
        pre: {
            padding: '0.4em 0.6em',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            background: 'rgba(150, 150, 150, 0.1)',
            border: '1px solid rgba(100, 100, 100, 0.2)',
            borderRadius: 3,
            fontFamily: token.fontFamilyCode,
            // Compatible for marked
            code: {
                display: 'inline',
                margin: 0,
                padding: 0,
                fontSize: 'inherit',
                fontFamily: 'inherit',
                background: 'transparent',
                border: 0
            }
        },
        blockquote: {
            paddingInline: '0.6em 0',
            paddingBlock: 0,
            borderInlineStart: '4px solid rgba(100, 100, 100, 0.2)',
            opacity: 0.85
        }
    });
const $950f24b0c690e3c4$export$2667badb03518972 = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    const inputShift = paddingSM;
    return {
        '&-edit-content': {
            position: 'relative',
            'div&': {
                insetInlineStart: token.calc(token.paddingSM).mul(-1).equal(),
                marginTop: token.calc(inputShift).mul(-1).equal(),
                marginBottom: `calc(1em - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(inputShift)})`
            },
            [`${componentCls}-edit-content-confirm`]: {
                position: 'absolute',
                insetInlineEnd: token.calc(token.marginXS).add(2).equal(),
                insetBlockEnd: token.marginXS,
                color: token.colorIcon,
                // default style
                fontWeight: 'normal',
                fontSize: token.fontSize,
                fontStyle: 'normal',
                pointerEvents: 'none'
            },
            textarea: {
                margin: '0!important',
                // Fix Editable Textarea flash in Firefox
                MozTransition: 'none',
                height: '1em'
            }
        }
    };
};
const $950f24b0c690e3c4$export$34755446404037a5 = (token)=>({
        [`${token.componentCls}-copy-success`]: {
            [`
    &,
    &:hover,
    &:focus`]: {
                color: token.colorSuccess
            }
        },
        [`${token.componentCls}-copy-icon-only`]: {
            marginInlineStart: 0
        }
    });
const $950f24b0c690e3c4$export$d9556a50eba3003b = ()=>({
        [`
  a&-ellipsis,
  span&-ellipsis
  `]: {
            display: 'inline-block',
            maxWidth: '100%'
        },
        '&-ellipsis-single-line': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            // https://blog.csdn.net/iefreer/article/details/50421025
            'a&, span&': {
                verticalAlign: 'bottom'
            },
            '> code': {
                paddingBlock: 0,
                maxWidth: 'calc(100% - 1.2em)',
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                verticalAlign: 'bottom',
                // https://github.com/ant-design/ant-design/issues/45953
                boxSizing: 'content-box'
            }
        },
        '&-ellipsis-multiple-line': {
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical'
        }
    });


const $29a5bb3c87e057f0$var$genTypographyStyle = (token)=>{
    const { componentCls: componentCls, titleMarginTop: titleMarginTop } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
            color: token.colorText,
            wordBreak: 'break-word',
            lineHeight: token.lineHeight,
            [`&${componentCls}-secondary`]: {
                color: token.colorTextDescription
            },
            [`&${componentCls}-success`]: {
                color: token.colorSuccessText
            },
            [`&${componentCls}-warning`]: {
                color: token.colorWarningText
            },
            [`&${componentCls}-danger`]: {
                color: token.colorErrorText,
                'a&:active, a&:focus': {
                    color: token.colorErrorTextActive
                },
                'a&:hover': {
                    color: token.colorErrorTextHover
                }
            },
            [`&${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed',
                userSelect: 'none'
            },
            [`
        div&,
        p
      `]: {
                marginBottom: '1em'
            }
        }, (0, $950f24b0c690e3c4$export$83146cf7d1bec659)(token)), {
            [`
      & + h1${componentCls},
      & + h2${componentCls},
      & + h3${componentCls},
      & + h4${componentCls},
      & + h5${componentCls}
      `]: {
                marginTop: titleMarginTop
            },
            [`
      div,
      ul,
      li,
      p,
      h1,
      h2,
      h3,
      h4,
      h5`]: {
                [`
        + h1,
        + h2,
        + h3,
        + h4,
        + h5
        `]: {
                    marginTop: titleMarginTop
                }
            }
        }), (0, $950f24b0c690e3c4$export$977383a86f45014b)(token)), (0, $950f24b0c690e3c4$export$566f4066c7caac18)(token)), {
            // Operation
            [`
        ${componentCls}-expand,
        ${componentCls}-collapse,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$9a16e7694a707ab4)(token)), {
                marginInlineStart: token.marginXXS
            })
        }), (0, $950f24b0c690e3c4$export$2667badb03518972)(token)), (0, $950f24b0c690e3c4$export$34755446404037a5)(token)), (0, $950f24b0c690e3c4$export$d9556a50eba3003b)()), {
            '&-rtl': {
                direction: 'rtl'
            }
        })
    };
};
const $29a5bb3c87e057f0$export$9ca1be8807fe0675 = ()=>({
        titleMarginTop: '1.2em',
        titleMarginBottom: '0.5em'
    });
var // ============================== Export ==============================
$29a5bb3c87e057f0$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Typography', (token)=>[
        $29a5bb3c87e057f0$var$genTypographyStyle(token)
    ], $29a5bb3c87e057f0$export$9ca1be8807fe0675);


"use client";
const $8a5b8988dc6b65c3$var$Editable = (props)=>{
    const { prefixCls: prefixCls, 'aria-label': ariaLabel, className: className, style: style, direction: direction, maxLength: maxLength, autoSize: autoSize = true, value: value, onSave: onSave, onCancel: onCancel, onEnd: onEnd, component: component, enterIcon: enterIcon = /*#__PURE__*/ $acw62.createElement((0, $ac0f9536ca737b46$export$2e2bcd8739ae039), null) } = props;
    const ref = $acw62.useRef(null);
    const inComposition = $acw62.useRef(false);
    const lastKeyCode = $acw62.useRef(null);
    const [current, setCurrent] = $acw62.useState(value);
    $acw62.useEffect(()=>{
        setCurrent(value);
    }, [
        value
    ]);
    $acw62.useEffect(()=>{
        var _a;
        if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) {
            const { textArea: textArea } = ref.current.resizableTextArea;
            textArea.focus();
            const { length: length } = textArea.value;
            textArea.setSelectionRange(length, length);
        }
    }, []);
    const onChange = ({ target: target })=>{
        setCurrent(target.value.replace(/[\n\r]/g, ''));
    };
    const onCompositionStart = ()=>{
        inComposition.current = true;
    };
    const onCompositionEnd = ()=>{
        inComposition.current = false;
    };
    const onKeyDown = ({ keyCode: keyCode })=>{
        // We don't record keyCode when IME is using
        if (inComposition.current) return;
        lastKeyCode.current = keyCode;
    };
    const confirmChange = ()=>{
        onSave(current.trim());
    };
    const onKeyUp = ({ keyCode: keyCode, ctrlKey: ctrlKey, altKey: altKey, metaKey: metaKey, shiftKey: shiftKey })=>{
        // Check if it's a real key
        if (lastKeyCode.current !== keyCode || inComposition.current || ctrlKey || altKey || metaKey || shiftKey) return;
        if (keyCode === (0, $8804d91907a0eb43$export$2e2bcd8739ae039).ENTER) {
            confirmChange();
            onEnd === null || onEnd === void 0 || onEnd();
        } else if (keyCode === (0, $8804d91907a0eb43$export$2e2bcd8739ae039).ESC) onCancel();
    };
    const onBlur = ()=>{
        confirmChange();
    };
    const [wrapCSSVar, hashId, cssVarCls] = (0, $29a5bb3c87e057f0$export$2e2bcd8739ae039)(prefixCls);
    const textAreaClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-edit-content`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${component}`]: !!component
    }, className, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: textAreaClassName,
        style: style
    }, /*#__PURE__*/ $acw62.createElement((0, $fc29eec8796e8593$export$2e2bcd8739ae039), {
        ref: ref,
        maxLength: maxLength,
        value: current,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBlur: onBlur,
        "aria-label": ariaLabel,
        rows: 1,
        autoSize: autoSize
    }), enterIcon !== null ? (0, $30796c32f374b477$export$e530037191fcd5d7)(enterIcon, {
        className: `${prefixCls}-edit-content-confirm`
    }) : null));
};
var $8a5b8988dc6b65c3$export$2e2bcd8739ae039 = $8a5b8988dc6b65c3$var$Editable;



var $acw62 = parcelRequire("acw62");
var $e5a78797c4262d1f$exports = {};
"use strict";
var $9e6bd5018912b3a9$exports = {};
$9e6bd5018912b3a9$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $e5a78797c4262d1f$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $e5a78797c4262d1f$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $e5a78797c4262d1f$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $e5a78797c4262d1f$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $9e6bd5018912b3a9$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $e5a78797c4262d1f$var$clipboardToIE11Formatting[options.format] || $e5a78797c4262d1f$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $e5a78797c4262d1f$var$format("message" in options ? options.message : $e5a78797c4262d1f$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$e5a78797c4262d1f$exports = $e5a78797c4262d1f$var$copy;



const $c668f727bdc41d13$var$toList = (candidate, skipEmpty = false)=>{
    if (skipEmpty && (candidate === undefined || candidate === null)) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
};
var $c668f727bdc41d13$export$2e2bcd8739ae039 = $c668f727bdc41d13$var$toList;


var $03d6c4dc81f23be0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $03d6c4dc81f23be0$var$useCopyClick = ({ copyConfig: copyConfig, children: children })=>{
    const [copied, setCopied] = $acw62.useState(false);
    const [copyLoading, setCopyLoading] = $acw62.useState(false);
    const copyIdRef = $acw62.useRef(null);
    const cleanCopyId = ()=>{
        if (copyIdRef.current) clearTimeout(copyIdRef.current);
    };
    const copyOptions = {};
    if (copyConfig.format) copyOptions.format = copyConfig.format;
    $acw62.useEffect(()=>cleanCopyId, []);
    // Keep copy action up to date
    const onClick = (0, $e294208d67c27cfa$export$2e2bcd8739ae039)((e)=>$03d6c4dc81f23be0$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            e === null || e === void 0 || e.preventDefault();
            e === null || e === void 0 || e.stopPropagation();
            setCopyLoading(true);
            try {
                const text = typeof copyConfig.text === 'function' ? yield copyConfig.text() : copyConfig.text;
                (0, (/*@__PURE__*/$parcel$interopDefault($e5a78797c4262d1f$exports)))(text || (0, $c668f727bdc41d13$export$2e2bcd8739ae039)(children, true).join('') || '', copyOptions);
                setCopyLoading(false);
                setCopied(true);
                // Trigger tips update
                cleanCopyId();
                copyIdRef.current = setTimeout(()=>{
                    setCopied(false);
                }, 3000);
                (_a = copyConfig.onCopy) === null || _a === void 0 || _a.call(copyConfig, e);
            } catch (error) {
                setCopyLoading(false);
                throw error;
            }
        }));
    return {
        copied: copied,
        copyLoading: copyLoading,
        onClick: onClick
    };
};
var $03d6c4dc81f23be0$export$2e2bcd8739ae039 = $03d6c4dc81f23be0$var$useCopyClick;



var $acw62 = parcelRequire("acw62");
function $4f54d14ab15fca01$export$2e2bcd8739ae039(propConfig, templateConfig) {
    return $acw62.useMemo(()=>{
        const support = !!propConfig;
        return [
            support,
            Object.assign(Object.assign({}, templateConfig), support && typeof propConfig === 'object' ? propConfig : null)
        ];
    }, [
        propConfig
    ]);
}



var $acw62 = parcelRequire("acw62");
const $4564445e53d0f3b9$var$usePrevious = (value)=>{
    const ref = (0, $acw62.useRef)(undefined);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $4564445e53d0f3b9$export$2e2bcd8739ae039 = $4564445e53d0f3b9$var$usePrevious;



var $acw62 = parcelRequire("acw62");
const $ccc30a03cba8168b$var$useTooltipProps = (tooltip, editConfigText, children)=>(0, $acw62.useMemo)(()=>{
        if (tooltip === true) return {
            title: editConfigText !== null && editConfigText !== void 0 ? editConfigText : children
        };
        if (/*#__PURE__*/ (0, $acw62.isValidElement)(tooltip)) return {
            title: tooltip
        };
        if (typeof tooltip === 'object') return Object.assign({
            title: editConfigText !== null && editConfigText !== void 0 ? editConfigText : children
        }, tooltip);
        return {
            title: tooltip
        };
    }, [
        tooltip,
        editConfigText,
        children
    ]);
var $ccc30a03cba8168b$export$2e2bcd8739ae039 = $ccc30a03cba8168b$var$useTooltipProps;



var $acw62 = parcelRequire("acw62");





"use client";
var $a3673f44358dd6b6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $a3673f44358dd6b6$var$Typography = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, component: Component = 'article', className: className, rootClassName: rootClassName, setContentRef: setContentRef, children: children, direction: typographyDirection, style: style } = props, restProps = $a3673f44358dd6b6$var$__rest(props, [
        "prefixCls",
        "component",
        "className",
        "rootClassName",
        "setContentRef",
        "children",
        "direction",
        "style"
    ]);
    const { getPrefixCls: getPrefixCls, direction: contextDirection, className: contextClassName, style: contextStyle } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('typography');
    const direction = typographyDirection !== null && typographyDirection !== void 0 ? typographyDirection : contextDirection;
    const mergedRef = setContentRef ? (0, $f1965a9a7a1fe067$export$ab452c34e8e05029)(ref, setContentRef) : ref;
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $29a5bb3c87e057f0$export$2e2bcd8739ae039)(prefixCls);
    const componentClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, contextClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, contextStyle), style);
    return wrapCSSVar(/*#__PURE__*/ // @ts-expect-error: Expression produces a union type that is too complex to represent.
    $acw62.createElement(Component, Object.assign({
        className: componentClassName,
        style: mergedStyle,
        ref: mergedRef
    }, restProps), children));
});
var $a3673f44358dd6b6$export$2e2bcd8739ae039 = $a3673f44358dd6b6$var$Typography;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $94b215ba0d5fdf99$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $94b215ba0d5fdf99$export$2e2bcd8739ae039 = $94b215ba0d5fdf99$var$CheckOutlined;



var $731042e70a6ddd3b$var$CheckOutlined = function CheckOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $94b215ba0d5fdf99$export$2e2bcd8739ae039)
    }));
};
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ var $731042e70a6ddd3b$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($731042e70a6ddd3b$var$CheckOutlined);
var $731042e70a6ddd3b$export$2e2bcd8739ae039 = $731042e70a6ddd3b$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4da90ab6d25f30a4$var$CopyOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    "name": "copy",
    "theme": "outlined"
};
var $4da90ab6d25f30a4$export$2e2bcd8739ae039 = $4da90ab6d25f30a4$var$CopyOutlined;



var $cf161c40cf97635f$var$CopyOutlined = function CopyOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4da90ab6d25f30a4$export$2e2bcd8739ae039)
    }));
};
/**![copy](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgyOTZjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNDk2djY4OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04Vjk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MDQgMTkySDE5MmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NTMwLjdjMCA4LjUgMy40IDE2LjYgOS40IDIyLjZsMTczLjMgMTczLjNjMi4yIDIuMiA0LjcgNCA3LjQgNS41djEuOWg0LjJjMy41IDEuMyA3LjIgMiAxMSAySDcwNGMxNy43IDAgMzItMTQuMyAzMi0zMlYyMjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTM1MCA4NTYuMkwyNjMuOSA3NzBIMzUwdjg2LjJ6TTY2NCA4ODhINDE0Vjc0NmMwLTIyLjEtMTcuOS00MC00MC00MEgyMzJWMjY0aDQzMnY2MjR6IiAvPjwvc3ZnPg==) */ var $cf161c40cf97635f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($cf161c40cf97635f$var$CopyOutlined);
var $cf161c40cf97635f$export$2e2bcd8739ae039 = $cf161c40cf97635f$var$RefIcon;





function $670def8f8d6657a1$export$effcdbd76139450(val) {
    if (val === false) return [
        false,
        false
    ];
    return Array.isArray(val) ? val : [
        val
    ];
}
function $670def8f8d6657a1$export$3f778c4e796a1f9c(dom, defaultNode, needDom) {
    if (dom === true || dom === undefined) return defaultNode;
    return dom || needDom && defaultNode;
}
function $670def8f8d6657a1$export$5714fcf57d9d6988(ele) {
    // Create a new div to get the size
    const childDiv = document.createElement('em');
    ele.appendChild(childDiv);
    const rect = ele.getBoundingClientRect();
    const childRect = childDiv.getBoundingClientRect();
    // Reset
    ele.removeChild(childDiv);
    // Range checker
    return(// Horizontal out of range
    rect.left > childRect.left || childRect.right > rect.right || // Vertical out of range
    rect.top > childRect.top || childRect.bottom > rect.bottom);
}
const $670def8f8d6657a1$export$a748c1acb7702f51 = (val)=>[
        'string',
        'number'
    ].includes(typeof val);


"use client";
const $f52e626a12e29853$var$CopyBtn = ({ prefixCls: prefixCls, copied: copied, locale: locale, iconOnly: iconOnly, tooltips: tooltips, icon: icon, tabIndex: tabIndex, onCopy: onCopy, loading: btnLoading })=>{
    const tooltipNodes = (0, $670def8f8d6657a1$export$effcdbd76139450)(tooltips);
    const iconNodes = (0, $670def8f8d6657a1$export$effcdbd76139450)(icon);
    const { copied: copiedText, copy: copyText } = locale !== null && locale !== void 0 ? locale : {};
    const systemStr = copied ? copiedText : copyText;
    const copyTitle = (0, $670def8f8d6657a1$export$3f778c4e796a1f9c)(tooltipNodes[copied ? 1 : 0], systemStr);
    const ariaLabel = typeof copyTitle === 'string' ? copyTitle : systemStr;
    return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
        title: copyTitle
    }, /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-copy`, {
            [`${prefixCls}-copy-success`]: copied,
            [`${prefixCls}-copy-icon-only`]: iconOnly
        }),
        onClick: onCopy,
        "aria-label": ariaLabel,
        tabIndex: tabIndex
    }, copied ? (0, $670def8f8d6657a1$export$3f778c4e796a1f9c)(iconNodes[1], /*#__PURE__*/ $acw62.createElement((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), null), true) : (0, $670def8f8d6657a1$export$3f778c4e796a1f9c)(iconNodes[0], btnLoading ? /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $cf161c40cf97635f$export$2e2bcd8739ae039), null), true)));
};
var $f52e626a12e29853$export$2e2bcd8739ae039 = $f52e626a12e29853$var$CopyBtn;




var $acw62 = parcelRequire("acw62");



"use client";
const $89c852553f755dc1$var$MeasureText = /*#__PURE__*/ $acw62.forwardRef(({ style: style, children: children }, ref)=>{
    const spanRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>({
            isExceed: ()=>{
                const span = spanRef.current;
                return span.scrollHeight > span.clientHeight;
            },
            getHeight: ()=>spanRef.current.clientHeight
        }));
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": true,
        ref: spanRef,
        style: Object.assign({
            position: 'fixed',
            display: 'block',
            left: 0,
            top: 0,
            pointerEvents: 'none',
            backgroundColor: 'rgba(255, 0, 0, 0.65)'
        }, style)
    }, children);
});
const $89c852553f755dc1$var$getNodesLen = (nodeList)=>nodeList.reduce((totalLen, node)=>totalLen + ((0, $670def8f8d6657a1$export$a748c1acb7702f51)(node) ? String(node).length : 1), 0);
function $89c852553f755dc1$var$sliceNodes(nodeList, len) {
    let currLen = 0;
    const currentNodeList = [];
    for(let i = 0; i < nodeList.length; i += 1){
        // Match to return
        if (currLen === len) return currentNodeList;
        const node = nodeList[i];
        const canCut = (0, $670def8f8d6657a1$export$a748c1acb7702f51)(node);
        const nodeLen = canCut ? String(node).length : 1;
        const nextLen = currLen + nodeLen;
        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            const restLen = len - currLen;
            currentNodeList.push(String(node).slice(0, restLen));
            return currentNodeList;
        }
        currentNodeList.push(node);
        currLen = nextLen;
    }
    return nodeList;
}
// Measure for the `text` is exceed the `rows` or not
const $89c852553f755dc1$var$STATUS_MEASURE_NONE = 0;
const $89c852553f755dc1$var$STATUS_MEASURE_PREPARE = 1;
const $89c852553f755dc1$var$STATUS_MEASURE_START = 2;
const $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS = 3;
const $89c852553f755dc1$var$STATUS_MEASURE_NO_NEED_ELLIPSIS = 4;
const $89c852553f755dc1$var$lineClipStyle = {
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
};
function $89c852553f755dc1$export$2e2bcd8739ae039(props) {
    const { enableMeasure: enableMeasure, width: width, text: text, children: children, rows: rows, expanded: expanded, miscDeps: miscDeps, onEllipsis: onEllipsis } = props;
    const nodeList = $acw62.useMemo(()=>(0, $5aa78504b8a12848$export$2e2bcd8739ae039)(text), [
        text
    ]);
    const nodeLen = $acw62.useMemo(()=>$89c852553f755dc1$var$getNodesLen(nodeList), [
        text
    ]);
    // ========================= Full Content =========================
    // Used for measure only, which means it's always render as no need ellipsis
    const fullContent = $acw62.useMemo(()=>children(nodeList, false), [
        text
    ]);
    // ========================= Cut Content ==========================
    const [ellipsisCutIndex, setEllipsisCutIndex] = $acw62.useState(null);
    const cutMidRef = $acw62.useRef(null);
    // ========================= NeedEllipsis =========================
    const measureWhiteSpaceRef = $acw62.useRef(null);
    const needEllipsisRef = $acw62.useRef(null);
    // Measure for `rows-1` height, to avoid operation exceed the line height
    const descRowsEllipsisRef = $acw62.useRef(null);
    const symbolRowEllipsisRef = $acw62.useRef(null);
    const [canEllipsis, setCanEllipsis] = $acw62.useState(false);
    const [needEllipsis, setNeedEllipsis] = $acw62.useState($89c852553f755dc1$var$STATUS_MEASURE_NONE);
    const [ellipsisHeight, setEllipsisHeight] = $acw62.useState(0);
    const [parentWhiteSpace, setParentWhiteSpace] = $acw62.useState(null);
    // Trigger start measure
    (0, $16cc62d9173c0916$export$2e2bcd8739ae039)(()=>{
        if (enableMeasure && width && nodeLen) setNeedEllipsis($89c852553f755dc1$var$STATUS_MEASURE_PREPARE);
        else setNeedEllipsis($89c852553f755dc1$var$STATUS_MEASURE_NONE);
    }, [
        width,
        text,
        rows,
        enableMeasure,
        nodeList
    ]);
    // Measure process
    (0, $16cc62d9173c0916$export$2e2bcd8739ae039)(()=>{
        var _a, _b, _c, _d;
        if (needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_PREPARE) {
            setNeedEllipsis($89c852553f755dc1$var$STATUS_MEASURE_START);
            // Parent ref `white-space`
            const nextWhiteSpace = measureWhiteSpaceRef.current && getComputedStyle(measureWhiteSpaceRef.current).whiteSpace;
            setParentWhiteSpace(nextWhiteSpace);
        } else if (needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_START) {
            const isOverflow = !!((_a = needEllipsisRef.current) === null || _a === void 0 ? void 0 : _a.isExceed());
            setNeedEllipsis(isOverflow ? $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS : $89c852553f755dc1$var$STATUS_MEASURE_NO_NEED_ELLIPSIS);
            setEllipsisCutIndex(isOverflow ? [
                0,
                nodeLen
            ] : null);
            setCanEllipsis(isOverflow);
            // Get the basic height of ellipsis rows
            const baseRowsEllipsisHeight = ((_b = needEllipsisRef.current) === null || _b === void 0 ? void 0 : _b.getHeight()) || 0;
            // Get the height of `rows - 1` + symbol height
            const descRowsEllipsisHeight = rows === 1 ? 0 : ((_c = descRowsEllipsisRef.current) === null || _c === void 0 ? void 0 : _c.getHeight()) || 0;
            const symbolRowEllipsisHeight = ((_d = symbolRowEllipsisRef.current) === null || _d === void 0 ? void 0 : _d.getHeight()) || 0;
            const maxRowsHeight = Math.max(baseRowsEllipsisHeight, // height of rows with ellipsis
            descRowsEllipsisHeight + symbolRowEllipsisHeight);
            setEllipsisHeight(maxRowsHeight + 1);
            onEllipsis(isOverflow);
        }
    }, [
        needEllipsis
    ]);
    // ========================= Cut Measure ==========================
    const cutMidIndex = ellipsisCutIndex ? Math.ceil((ellipsisCutIndex[0] + ellipsisCutIndex[1]) / 2) : 0;
    (0, $16cc62d9173c0916$export$2e2bcd8739ae039)(()=>{
        var _a;
        const [minIndex, maxIndex] = ellipsisCutIndex || [
            0,
            0
        ];
        if (minIndex !== maxIndex) {
            const midHeight = ((_a = cutMidRef.current) === null || _a === void 0 ? void 0 : _a.getHeight()) || 0;
            const isOverflow = midHeight > ellipsisHeight;
            let targetMidIndex = cutMidIndex;
            if (maxIndex - minIndex === 1) targetMidIndex = isOverflow ? minIndex : maxIndex;
            setEllipsisCutIndex(isOverflow ? [
                minIndex,
                targetMidIndex
            ] : [
                targetMidIndex,
                maxIndex
            ]);
        }
    }, [
        ellipsisCutIndex,
        cutMidIndex
    ]);
    // ========================= Text Content =========================
    const finalContent = $acw62.useMemo(()=>{
        // Skip everything if `enableMeasure` is disabled
        if (!enableMeasure) return children(nodeList, false);
        if (needEllipsis !== $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS || !ellipsisCutIndex || ellipsisCutIndex[0] !== ellipsisCutIndex[1]) {
            const content = children(nodeList, false);
            // Limit the max line count to avoid scrollbar blink unless no need ellipsis
            // https://github.com/ant-design/ant-design/issues/42958
            if ([
                $89c852553f755dc1$var$STATUS_MEASURE_NO_NEED_ELLIPSIS,
                $89c852553f755dc1$var$STATUS_MEASURE_NONE
            ].includes(needEllipsis)) return content;
            return /*#__PURE__*/ $acw62.createElement("span", {
                style: Object.assign(Object.assign({}, $89c852553f755dc1$var$lineClipStyle), {
                    WebkitLineClamp: rows
                })
            }, content);
        }
        return children(expanded ? nodeList : $89c852553f755dc1$var$sliceNodes(nodeList, ellipsisCutIndex[0]), canEllipsis);
    }, [
        expanded,
        needEllipsis,
        ellipsisCutIndex,
        nodeList
    ].concat((0, $df4024303de6487a$export$2e2bcd8739ae039)(miscDeps)));
    // ============================ Render ============================
    const measureStyle = {
        width: width,
        margin: 0,
        padding: 0,
        whiteSpace: parentWhiteSpace === 'nowrap' ? 'normal' : 'inherit'
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, finalContent, needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_START && /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: Object.assign(Object.assign(Object.assign({}, measureStyle), $89c852553f755dc1$var$lineClipStyle), {
            WebkitLineClamp: rows
        }),
        ref: needEllipsisRef
    }, fullContent), /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: Object.assign(Object.assign(Object.assign({}, measureStyle), $89c852553f755dc1$var$lineClipStyle), {
            WebkitLineClamp: rows - 1
        }),
        ref: descRowsEllipsisRef
    }, fullContent), /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: Object.assign(Object.assign(Object.assign({}, measureStyle), $89c852553f755dc1$var$lineClipStyle), {
            WebkitLineClamp: 1
        }),
        ref: symbolRowEllipsisRef
    }, children([], true))), needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS && ellipsisCutIndex && ellipsisCutIndex[0] !== ellipsisCutIndex[1] && /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: Object.assign(Object.assign({}, measureStyle), {
            top: 400
        }),
        ref: cutMidRef
    }, children($89c852553f755dc1$var$sliceNodes(nodeList, cutMidIndex), true)), needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_PREPARE && /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            whiteSpace: 'inherit'
        },
        ref: measureWhiteSpaceRef
    }));
}



var $acw62 = parcelRequire("acw62");

"use client";
const $2c5f09c9102f607d$var$EllipsisTooltip = ({ enableEllipsis: enableEllipsis, isEllipsis: isEllipsis, children: children, tooltipProps: tooltipProps })=>{
    if (!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || !enableEllipsis) return children;
    return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), Object.assign({
        open: isEllipsis ? undefined : false
    }, tooltipProps), children);
};
var $2c5f09c9102f607d$export$2e2bcd8739ae039 = $2c5f09c9102f607d$var$EllipsisTooltip;



"use client";
var $c756fe581e322b8b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $c756fe581e322b8b$var$wrapperDecorations({ mark: mark, code: code, underline: underline, delete: del, strong: strong, keyboard: keyboard, italic: italic }, content) {
    let currentContent = content;
    function wrap(tag, needed) {
        if (!needed) return;
        currentContent = /*#__PURE__*/ $acw62.createElement(tag, {}, currentContent);
    }
    wrap('strong', strong);
    wrap('u', underline);
    wrap('del', del);
    wrap('code', code);
    wrap('mark', mark);
    wrap('kbd', keyboard);
    wrap('i', italic);
    return currentContent;
}
const $c756fe581e322b8b$var$ELLIPSIS_STR = '...';
const $c756fe581e322b8b$var$DECORATION_PROPS = [
    'delete',
    'mark',
    'code',
    'underline',
    'strong',
    'keyboard',
    'italic'
];
const $c756fe581e322b8b$var$Base = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, className: className, style: style, type: type, disabled: disabled, children: children, ellipsis: ellipsis, editable: editable, copyable: copyable, component: component, title: title } = props, restProps = $c756fe581e322b8b$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "type",
        "disabled",
        "children",
        "ellipsis",
        "editable",
        "copyable",
        "component",
        "title"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [textLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('Text');
    const typographyRef = $acw62.useRef(null);
    const editIconRef = $acw62.useRef(null);
    // ============================ MISC ============================
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    const textProps = (0, $57c22a5a2f343bca$export$2e2bcd8739ae039)(restProps, $c756fe581e322b8b$var$DECORATION_PROPS);
    // ========================== Editable ==========================
    const [enableEdit, editConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(editable);
    const [editing, setEditing] = (0, $fbd33e1a3c597913$export$2e2bcd8739ae039)(false, {
        value: editConfig.editing
    });
    const { triggerType: triggerType = [
        'icon'
    ] } = editConfig;
    const triggerEdit = (edit)=>{
        var _a;
        if (edit) (_a = editConfig.onStart) === null || _a === void 0 || _a.call(editConfig);
        setEditing(edit);
    };
    // Focus edit icon when back
    const prevEditing = (0, $4564445e53d0f3b9$export$2e2bcd8739ae039)(editing);
    (0, $16cc62d9173c0916$export$2e2bcd8739ae039)(()=>{
        var _a;
        if (!editing && prevEditing) (_a = editIconRef.current) === null || _a === void 0 || _a.focus();
    }, [
        editing
    ]);
    const onEditClick = (e)=>{
        e === null || e === void 0 || e.preventDefault();
        triggerEdit(true);
    };
    const onEditChange = (value)=>{
        var _a;
        (_a = editConfig.onChange) === null || _a === void 0 || _a.call(editConfig, value);
        triggerEdit(false);
    };
    const onEditCancel = ()=>{
        var _a;
        (_a = editConfig.onCancel) === null || _a === void 0 || _a.call(editConfig);
        triggerEdit(false);
    };
    // ========================== Copyable ==========================
    const [enableCopy, copyConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(copyable);
    const { copied: copied, copyLoading: copyLoading, onClick: onCopyClick } = (0, $03d6c4dc81f23be0$export$2e2bcd8739ae039)({
        copyConfig: copyConfig,
        children: children
    });
    // ========================== Ellipsis ==========================
    const [isLineClampSupport, setIsLineClampSupport] = $acw62.useState(false);
    const [isTextOverflowSupport, setIsTextOverflowSupport] = $acw62.useState(false);
    const [isJsEllipsis, setIsJsEllipsis] = $acw62.useState(false);
    const [isNativeEllipsis, setIsNativeEllipsis] = $acw62.useState(false);
    const [isNativeVisible, setIsNativeVisible] = $acw62.useState(true);
    const [enableEllipsis, ellipsisConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(ellipsis, {
        expandable: false,
        symbol: (isExpanded)=>isExpanded ? textLocale === null || textLocale === void 0 ? void 0 : textLocale.collapse : textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
    });
    const [expanded, setExpanded] = (0, $fbd33e1a3c597913$export$2e2bcd8739ae039)(ellipsisConfig.defaultExpanded || false, {
        value: ellipsisConfig.expanded
    });
    const mergedEnableEllipsis = enableEllipsis && (!expanded || ellipsisConfig.expandable === 'collapsible');
    // Shared prop to reduce bundle size
    const { rows: rows = 1 } = ellipsisConfig;
    const needMeasureEllipsis = $acw62.useMemo(()=>// Disable ellipsis
        mergedEnableEllipsis && // Provide suffix
        (ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
        ellipsisConfig.expandable || enableEdit || enableCopy), [
        mergedEnableEllipsis,
        ellipsisConfig,
        enableEdit,
        enableCopy
    ]);
    (0, $16cc62d9173c0916$export$2e2bcd8739ae039)(()=>{
        if (enableEllipsis && !needMeasureEllipsis) {
            setIsLineClampSupport((0, $09220ac933008db9$export$d616d7831008e86c)('webkitLineClamp'));
            setIsTextOverflowSupport((0, $09220ac933008db9$export$d616d7831008e86c)('textOverflow'));
        }
    }, [
        needMeasureEllipsis,
        enableEllipsis
    ]);
    const [cssEllipsis, setCssEllipsis] = $acw62.useState(mergedEnableEllipsis);
    const canUseCssEllipsis = $acw62.useMemo(()=>{
        if (needMeasureEllipsis) return false;
        if (rows === 1) return isTextOverflowSupport;
        return isLineClampSupport;
    }, [
        needMeasureEllipsis,
        isTextOverflowSupport,
        isLineClampSupport
    ]);
    // We use effect to change from css ellipsis to js ellipsis.
    // To make SSR still can see the ellipsis.
    (0, $16cc62d9173c0916$export$2e2bcd8739ae039)(()=>{
        setCssEllipsis(canUseCssEllipsis && mergedEnableEllipsis);
    }, [
        canUseCssEllipsis,
        mergedEnableEllipsis
    ]);
    const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? isNativeEllipsis : isJsEllipsis);
    const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
    const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
    // >>>>> Expand
    const onExpandClick = (e, info)=>{
        var _a;
        setExpanded(info.expanded);
        (_a = ellipsisConfig.onExpand) === null || _a === void 0 || _a.call(ellipsisConfig, e, info);
    };
    const [ellipsisWidth, setEllipsisWidth] = $acw62.useState(0);
    const onResize = ({ offsetWidth: offsetWidth })=>{
        setEllipsisWidth(offsetWidth);
    };
    // >>>>> JS Ellipsis
    const onJsEllipsis = (jsEllipsis)=>{
        var _a;
        setIsJsEllipsis(jsEllipsis);
        // Trigger if changed
        if (isJsEllipsis !== jsEllipsis) (_a = ellipsisConfig.onEllipsis) === null || _a === void 0 || _a.call(ellipsisConfig, jsEllipsis);
    };
    // >>>>> Native ellipsis
    $acw62.useEffect(()=>{
        const textEle = typographyRef.current;
        if (enableEllipsis && cssEllipsis && textEle) {
            const currentEllipsis = (0, $670def8f8d6657a1$export$5714fcf57d9d6988)(textEle);
            if (isNativeEllipsis !== currentEllipsis) setIsNativeEllipsis(currentEllipsis);
        }
    }, [
        enableEllipsis,
        cssEllipsis,
        children,
        cssLineClamp,
        isNativeVisible,
        ellipsisWidth
    ]);
    // https://github.com/ant-design/ant-design/issues/36786
    // Use IntersectionObserver to check if element is invisible
    $acw62.useEffect(()=>{
        const textEle = typographyRef.current;
        if (typeof IntersectionObserver === 'undefined' || !textEle || !cssEllipsis || !mergedEnableEllipsis) return;
        /* eslint-disable-next-line compat/compat */ const observer = new IntersectionObserver(()=>{
            setIsNativeVisible(!!textEle.offsetParent);
        });
        observer.observe(textEle);
        return ()=>{
            observer.disconnect();
        };
    }, [
        cssEllipsis,
        mergedEnableEllipsis
    ]);
    // ========================== Tooltip ===========================
    const tooltipProps = (0, $ccc30a03cba8168b$export$2e2bcd8739ae039)(ellipsisConfig.tooltip, editConfig.text, children);
    const topAriaLabel = $acw62.useMemo(()=>{
        if (!enableEllipsis || cssEllipsis) return undefined;
        return [
            editConfig.text,
            children,
            title,
            tooltipProps.title
        ].find((0, $670def8f8d6657a1$export$a748c1acb7702f51));
    }, [
        enableEllipsis,
        cssEllipsis,
        title,
        tooltipProps.title,
        isMergedEllipsis
    ]);
    // =========================== Render ===========================
    // >>>>>>>>>>> Editing input
    if (editing) return /*#__PURE__*/ $acw62.createElement((0, $8a5b8988dc6b65c3$export$2e2bcd8739ae039), {
        value: (_a = editConfig.text) !== null && _a !== void 0 ? _a : typeof children === 'string' ? children : '',
        onSave: onEditChange,
        onCancel: onEditCancel,
        onEnd: editConfig.onEnd,
        prefixCls: prefixCls,
        className: className,
        style: style,
        direction: direction,
        component: component,
        maxLength: editConfig.maxLength,
        autoSize: editConfig.autoSize,
        enterIcon: editConfig.enterIcon
    });
    // >>>>>>>>>>> Typography
    // Expand
    const renderExpand = ()=>{
        const { expandable: expandable, symbol: symbol } = ellipsisConfig;
        return expandable ? /*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            key: "expand",
            className: `${prefixCls}-${expanded ? 'collapse' : 'expand'}`,
            onClick: (e)=>onExpandClick(e, {
                    expanded: !expanded
                }),
            "aria-label": expanded ? textLocale.collapse : textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
        }, typeof symbol === 'function' ? symbol(expanded) : symbol) : null;
    };
    // Edit
    const renderEdit = ()=>{
        if (!enableEdit) return;
        const { icon: icon, tooltip: tooltip, tabIndex: tabIndex } = editConfig;
        const editTitle = (0, $5aa78504b8a12848$export$2e2bcd8739ae039)(tooltip)[0] || (textLocale === null || textLocale === void 0 ? void 0 : textLocale.edit);
        const ariaLabel = typeof editTitle === 'string' ? editTitle : '';
        return triggerType.includes('icon') ? /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
            key: "edit",
            title: tooltip === false ? '' : editTitle
        }, /*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            ref: editIconRef,
            className: `${prefixCls}-edit`,
            onClick: onEditClick,
            "aria-label": ariaLabel,
            tabIndex: tabIndex
        }, icon || /*#__PURE__*/ $acw62.createElement((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {
            role: "button"
        }))) : null;
    };
    // Copy
    const renderCopy = ()=>{
        if (!enableCopy) return null;
        return /*#__PURE__*/ $acw62.createElement((0, $f52e626a12e29853$export$2e2bcd8739ae039), Object.assign({
            key: "copy"
        }, copyConfig, {
            prefixCls: prefixCls,
            copied: copied,
            locale: textLocale,
            onCopy: onCopyClick,
            loading: copyLoading,
            iconOnly: children === null || children === undefined
        }));
    };
    const renderOperations = (canEllipsis)=>[
            canEllipsis && renderExpand(),
            renderEdit(),
            renderCopy()
        ];
    const renderEllipsis = (canEllipsis)=>[
            canEllipsis && !expanded && /*#__PURE__*/ $acw62.createElement("span", {
                "aria-hidden": true,
                key: "ellipsis"
            }, $c756fe581e322b8b$var$ELLIPSIS_STR),
            ellipsisConfig.suffix,
            renderOperations(canEllipsis)
        ];
    return /*#__PURE__*/ $acw62.createElement((0, $bdd6dfb958d0e5e7$export$2e2bcd8739ae039), {
        onResize: onResize,
        disabled: !mergedEnableEllipsis
    }, (resizeRef)=>/*#__PURE__*/ $acw62.createElement((0, $2c5f09c9102f607d$export$2e2bcd8739ae039), {
            tooltipProps: tooltipProps,
            enableEllipsis: mergedEnableEllipsis,
            isEllipsis: isMergedEllipsis
        }, /*#__PURE__*/ $acw62.createElement((0, $a3673f44358dd6b6$export$2e2bcd8739ae039), Object.assign({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-${type}`]: type,
                [`${prefixCls}-disabled`]: disabled,
                [`${prefixCls}-ellipsis`]: enableEllipsis,
                [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
                [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp
            }, className),
            prefixCls: customizePrefixCls,
            style: Object.assign(Object.assign({}, style), {
                WebkitLineClamp: cssLineClamp ? rows : undefined
            }),
            component: component,
            ref: (0, $f1965a9a7a1fe067$export$ab452c34e8e05029)(resizeRef, typographyRef, ref),
            direction: direction,
            onClick: triggerType.includes('text') ? onEditClick : undefined,
            "aria-label": topAriaLabel === null || topAriaLabel === void 0 ? void 0 : topAriaLabel.toString(),
            title: title
        }, textProps), /*#__PURE__*/ $acw62.createElement((0, $89c852553f755dc1$export$2e2bcd8739ae039), {
            enableMeasure: mergedEnableEllipsis && !cssEllipsis,
            text: children,
            rows: rows,
            width: ellipsisWidth,
            onEllipsis: onJsEllipsis,
            expanded: expanded,
            miscDeps: [
                copied,
                expanded,
                copyLoading,
                enableEdit,
                enableCopy,
                textLocale
            ].concat((0, $df4024303de6487a$export$2e2bcd8739ae039)($c756fe581e322b8b$var$DECORATION_PROPS.map((key)=>props[key])))
        }, (node, canEllipsis)=>$c756fe581e322b8b$var$wrapperDecorations(props, /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, node.length > 0 && canEllipsis && !expanded && topAriaLabel ? /*#__PURE__*/ $acw62.createElement("span", {
                key: "show-content",
                "aria-hidden": true
            }, node) : node, renderEllipsis(canEllipsis)))))));
});
var $c756fe581e322b8b$export$2e2bcd8739ae039 = $c756fe581e322b8b$var$Base;


"use client";
var $e59afc5fcefd918d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e59afc5fcefd918d$var$Link = /*#__PURE__*/ $acw62.forwardRef((_a, ref)=>{
    var { ellipsis: ellipsis, rel: rel } = _a, restProps = $e59afc5fcefd918d$var$__rest(_a, [
        "ellipsis",
        "rel"
    ]);
    const mergedProps = Object.assign(Object.assign({}, restProps), {
        rel: rel === undefined && restProps.target === '_blank' ? 'noopener noreferrer' : rel
    });
    // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
    delete mergedProps.navigate;
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({}, mergedProps, {
        ref: ref,
        ellipsis: !!ellipsis,
        component: "a"
    }));
});
var $e59afc5fcefd918d$export$2e2bcd8739ae039 = $e59afc5fcefd918d$var$Link;



var $acw62 = parcelRequire("acw62");

"use client";
const $32838ac41e3e19d1$var$Paragraph = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, props, {
        component: "div"
    })));
var $32838ac41e3e19d1$export$2e2bcd8739ae039 = $32838ac41e3e19d1$var$Paragraph;



var $acw62 = parcelRequire("acw62");



"use client";
var $3704098f38e9f562$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3704098f38e9f562$var$Text = (_a, ref)=>{
    var { ellipsis: ellipsis } = _a, restProps = $3704098f38e9f562$var$__rest(_a, [
        "ellipsis"
    ]);
    const mergedEllipsis = $acw62.useMemo(()=>{
        if (ellipsis && typeof ellipsis === 'object') return (0, $57c22a5a2f343bca$export$2e2bcd8739ae039)(ellipsis, [
            'expandable',
            'rows'
        ]);
        return ellipsis;
    }, [
        ellipsis
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, restProps, {
        ellipsis: mergedEllipsis,
        component: "span"
    }));
};
var $3704098f38e9f562$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($3704098f38e9f562$var$Text);



var $acw62 = parcelRequire("acw62");


"use client";
var $af44bdd0e8458ef3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $af44bdd0e8458ef3$var$TITLE_ELE_LIST = [
    1,
    2,
    3,
    4,
    5
];
const $af44bdd0e8458ef3$var$Title = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { level: level = 1 } = props, restProps = $af44bdd0e8458ef3$var$__rest(props, [
        "level"
    ]);
    const component = $af44bdd0e8458ef3$var$TITLE_ELE_LIST.includes(level) ? `h${level}` : `h1`;
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, restProps, {
        component: component
    }));
});
var $af44bdd0e8458ef3$export$2e2bcd8739ae039 = $af44bdd0e8458ef3$var$Title;



"use client";
const $69754065fe3b4b60$var$Typography = (0, $a3673f44358dd6b6$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Text = (0, $3704098f38e9f562$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Link = (0, $e59afc5fcefd918d$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Title = (0, $af44bdd0e8458ef3$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Paragraph = (0, $32838ac41e3e19d1$export$2e2bcd8739ae039);
var $69754065fe3b4b60$export$2e2bcd8739ae039 = $69754065fe3b4b60$var$Typography;



var $acw62 = parcelRequire("acw62");
class $3c0e93c0975aa561$var$WriteEmitter {
    writeLogs = new Set();
    ignoreCounter = 0;
    listeners = new Set();
    action(fn) {
        const runInAction = this.runInAction.bind(this);
        return function(...args) {
            return runInAction(()=>fn.apply(this, args))[0];
        };
    }
    runInAction(f) {
        const writeLog = new Map();
        this.writeLogs.add(writeLog);
        try {
            return [
                f(),
                writeLog
            ];
        } finally{
            this.writeLogs.delete(writeLog);
            if (this.writeLogs.size === 0 && writeLog.size > 0) this.listeners.forEach((listener)=>listener(writeLog));
        }
    }
    ignore(f) {
        this.ignoreCounter++;
        try {
            return f();
        } finally{
            this.ignoreCounter--;
        }
    }
    on(listener) {
        this.listeners.add(listener);
    }
    off(listener) {
        this.listeners.delete(listener);
    }
    emit(me) {
        if (this.ignoreCounter > 0) return;
        if (this.writeLogs.size === 0) this.listeners.forEach((listener)=>listener(new Map([
                [
                    me.target,
                    new Map([
                        [
                            me.prop,
                            me.value
                        ]
                    ])
                ]
            ])));
        else for (const writeLog of this.writeLogs.values()){
            if (!writeLog.has(me.target)) writeLog.set(me.target, new Map());
            const writeMap = writeLog.get(me.target);
            writeMap.set(me.prop, me.value + (writeMap.get(me.prop) ?? 0));
        }
    }
}
const $3c0e93c0975aa561$var$writeEmitter = new $3c0e93c0975aa561$var$WriteEmitter();
const $3c0e93c0975aa561$export$31eb53bd5b582a97 = $3c0e93c0975aa561$var$writeEmitter.action.bind($3c0e93c0975aa561$var$writeEmitter);
const $3c0e93c0975aa561$export$f443e47852576b4f = $3c0e93c0975aa561$var$writeEmitter.runInAction.bind($3c0e93c0975aa561$var$writeEmitter);
const $3c0e93c0975aa561$export$738b109e247a462c = $3c0e93c0975aa561$var$writeEmitter.ignore.bind($3c0e93c0975aa561$var$writeEmitter);
var $3c0e93c0975aa561$export$2e2bcd8739ae039 = $3c0e93c0975aa561$var$writeEmitter;


// deno-lint-ignore-file no-explicit-any
class $9975527c0402172a$var$ReadEmitter {
    readLogs = new Set();
    capture(f) {
        const readLog = new Map();
        this.readLogs.add(readLog);
        try {
            const r = f();
            return [
                r,
                readLog
            ];
        } finally{
            this.readLogs.delete(readLog);
        }
    }
    emitGet(ge) {
        for (const readLog of this.readLogs.values()){
            if (!readLog.has(ge.target)) readLog.set(ge.target, {});
            const readObj = readLog.get(ge.target);
            if (!readObj.get) readObj.get = new Map();
            readObj.get.set(ge.prop, ge.value);
        }
    }
    emitHas(he) {
        for (const readLog of this.readLogs.values()){
            if (!readLog.has(he.target)) readLog.set(he.target, {});
            const readObj = readLog.get(he.target);
            if (!readObj.has) readObj.has = new Map();
            readObj.has.set(he.prop, he.value);
        }
    }
    emitKeys(ke) {
        for (const readLog of this.readLogs.values()){
            if (!readLog.has(ke.target)) readLog.set(ke.target, {});
            readLog.get(ke.target).keys = true;
        }
    }
}
const $9975527c0402172a$var$readEmitter = new $9975527c0402172a$var$ReadEmitter();
const $9975527c0402172a$export$6f6534ba0edb1cf4 = $9975527c0402172a$var$readEmitter.capture.bind($9975527c0402172a$var$readEmitter);
var $9975527c0402172a$export$2e2bcd8739ae039 = $9975527c0402172a$var$readEmitter;



const $19c7c91c3db9a28d$var$getValue = (target, prop)=>{
    if (target instanceof Map) return target.get(prop);
    return Reflect.get(target, prop);
};
const $19c7c91c3db9a28d$var$hasValue = (target, prop)=>{
    if (target instanceof Map || target instanceof Set) return target.has(prop);
    return Reflect.has(target, prop);
};
const $19c7c91c3db9a28d$export$af03796d9eb10907 = (writeLog, readLog)=>{
    for (const [target, writeMap] of writeLog)if (readLog.has(target)) {
        const readObj = readLog.get(target);
        for (const prop of writeMap.keys()){
            if (readObj.get && readObj.get.has(prop) && readObj.get.get(prop) !== $19c7c91c3db9a28d$var$getValue(target, prop)) return true;
            if (readObj.has && readObj.has.has(prop) && readObj.has.get(prop) !== $19c7c91c3db9a28d$var$hasValue(target, prop)) return true;
        }
        if ("keys" in readObj && Array.from(writeMap.values()).some((i)=>i !== 0)) return true;
    }
    return false;
};
const $19c7c91c3db9a28d$export$889ea624f2cb2c57 = (fn)=>{
    const [r, readLog] = (0, $9975527c0402172a$export$6f6534ba0edb1cf4)(fn);
    const isTrigger = (writeLog)=>$19c7c91c3db9a28d$export$af03796d9eb10907(writeLog, readLog);
    return [
        r,
        isTrigger
    ];
};
const $19c7c91c3db9a28d$export$a73b5fdcdd74f27d = (fn, wrapper)=>{
    let isTrigger;
    let wrappedRun = ()=>{
        [runner.r, isTrigger] = (0, $3c0e93c0975aa561$export$738b109e247a462c)(()=>$19c7c91c3db9a28d$export$889ea624f2cb2c57(fn)); // ignore to avoid infinite loop
    };
    if (wrapper) wrappedRun = wrapper(wrappedRun);
    const listener = (e)=>{
        if (isTrigger(e)) wrappedRun();
    };
    const runner = {
        start: ()=>{
            [runner.r, isTrigger] = $19c7c91c3db9a28d$export$889ea624f2cb2c57(fn);
            (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).on(listener);
        },
        stop: ()=>{
            (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).off(listener);
        },
        r: undefined
    };
    return runner;
};
const $19c7c91c3db9a28d$export$2983e091f1a1e8e2 = (fn)=>{
    const cache = new WeakMap();
    return function() {
        if (cache.has(this)) return cache.get(this);
        const [r, isTrigger] = $19c7c91c3db9a28d$export$889ea624f2cb2c57(()=>fn.apply(this));
        cache.set(this, r);
        const listener = (writeLog)=>{
            if (isTrigger(writeLog)) {
                (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).off(listener);
                cache.delete(this);
            }
        };
        (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).on(listener);
        return r;
    };
};


const $9d5e52e8f220d71a$export$dfb5619354ba860 = (Component)=>{
    return (0, $acw62.memo)(function MyComponent(props) {
        const [, reRender] = (0, $acw62.useState)(0);
        const [r, isTrigger] = (0, $19c7c91c3db9a28d$export$889ea624f2cb2c57)(()=>Component(props));
        (0, $acw62.useEffect)(()=>{
            const listener = (writeLog)=>{
                if (isTrigger(writeLog)) reRender((n)=>n + 1);
            };
            (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).on(listener);
            return ()=>{
                (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).off(listener);
            };
        }, [
            isTrigger
        ]);
        return r;
    });
};


parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $f1b50e7ed1ad3c25$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};






const $92631131e38a19f0$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary } = token;
    return {
        [componentCls]: {
            position: 'absolute',
            background: 'transparent',
            pointerEvents: 'none',
            boxSizing: 'border-box',
            color: `var(--wave-color, ${colorPrimary})`,
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            '&.wave-motion-appear': {
                transition: [
                    `box-shadow 0.4s ${token.motionEaseOutCirc}`,
                    `opacity 2s ${token.motionEaseOutCirc}`
                ].join(','),
                '&-active': {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                '&.wave-quick': {
                    transition: [
                        `box-shadow ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                        `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`
                    ].join(',')
                }
            }
        }
    };
};
var $92631131e38a19f0$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$b8cc4ee2ee8cfbc8)('Wave', (token)=>[
        $92631131e38a19f0$var$genWaveStyle(token)
    ]);



var $acw62 = parcelRequire("acw62");

var $2b9f066ea00dd1c7$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $2b9f066ea00dd1c7$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $2b9f066ea00dd1c7$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $2b9f066ea00dd1c7$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $2b9f066ea00dd1c7$var$rafUUID = 0;
var $2b9f066ea00dd1c7$var$rafIds = new Map();
function $2b9f066ea00dd1c7$var$cleanup(id) {
    $2b9f066ea00dd1c7$var$rafIds.delete(id);
}
var $2b9f066ea00dd1c7$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $2b9f066ea00dd1c7$var$rafUUID += 1;
    var id = $2b9f066ea00dd1c7$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $2b9f066ea00dd1c7$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $2b9f066ea00dd1c7$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $2b9f066ea00dd1c7$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$2b9f066ea00dd1c7$var$wrapperRaf.cancel = function(id) {
    var realId = $2b9f066ea00dd1c7$var$rafIds.get(id);
    $2b9f066ea00dd1c7$var$cleanup(id);
    return $2b9f066ea00dd1c7$var$caf(realId);
};
var $2b9f066ea00dd1c7$export$2e2bcd8739ae039 = $2b9f066ea00dd1c7$var$wrapperRaf;





const $ede16c18199d1556$export$23466a5792b7a5d3 = `${(0, $a18b2f6f56546238$export$e4ec87ea71f29b41)}-wave-target`;



var $acw62 = parcelRequire("acw62");






function $fc14acdc17dc0f28$export$9d61ea039e87eb91(color) {
    return color && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== 'transparent';
}
function $fc14acdc17dc0f28$export$651d8e9c80304fc8(node) {
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = getComputedStyle(node);
    if ($fc14acdc17dc0f28$export$9d61ea039e87eb91(borderTopColor)) return borderTopColor;
    if ($fc14acdc17dc0f28$export$9d61ea039e87eb91(borderColor)) return borderColor;
    if ($fc14acdc17dc0f28$export$9d61ea039e87eb91(backgroundColor)) return backgroundColor;
    return null;
}


"use client";
function $1267f32cdb4173c5$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $1267f32cdb4173c5$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component, registerUnmount: registerUnmount } = props;
    const divRef = $acw62.useRef(null);
    // ====================== Refs ======================
    const unmountRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        unmountRef.current = registerUnmount();
    }, []);
    // ===================== Effect =====================
    const [color, setWaveColor] = $acw62.useState(null);
    const [borderRadius, setBorderRadius] = $acw62.useState([]);
    const [left, setLeft] = $acw62.useState(0);
    const [top, setTop] = $acw62.useState(0);
    const [width, setWidth] = $acw62.useState(0);
    const [height, setHeight] = $acw62.useState(0);
    const [enabled, setEnabled] = $acw62.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(' ')
    };
    if (color) waveStyle['--wave-color'] = color;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $fc14acdc17dc0f28$export$651d8e9c80304fc8)(target));
        const isStatic = nodeStyle.position === 'static';
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $1267f32cdb4173c5$var$validateNum(-parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $1267f32cdb4173c5$var$validateNum(-parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$1267f32cdb4173c5$var$validateNum(parseFloat(radius))));
    }
    $acw62.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $2b9f066ea00dd1c7$export$2e2bcd8739ae039)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $2b9f066ea00dd1c7$export$2e2bcd8739ae039).cancel(id);
                resizeObserver === null || resizeObserver === void 0 || resizeObserver.disconnect();
            };
        }
    }, []);
    if (!enabled) return null;
    const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && (target === null || target === void 0 ? void 0 : target.classList.contains((0, $ede16c18199d1556$export$23466a5792b7a5d3)));
    return /*#__PURE__*/ $acw62.createElement((0, $d222a6d97472f88c$export$2e2bcd8739ae039), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            var _a, _b;
            if (event.deadline || event.propertyName === 'opacity') {
                const holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
                (_b = unmountRef.current) === null || _b === void 0 || _b.call(unmountRef).then(()=>{
                    holder === null || holder === void 0 || holder.remove();
                });
            }
            return false;
        }
    }, ({ className: motionClassName }, ref)=>/*#__PURE__*/ $acw62.createElement("div", {
            ref: (0, $f1965a9a7a1fe067$export$ab452c34e8e05029)(divRef, ref),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, motionClassName, {
                'wave-quick': isSmallComponent
            }),
            style: waveStyle
        }));
};
const $1267f32cdb4173c5$var$showWaveEffect = (target, info)=>{
    var _a;
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === 'Checkbox' && !((_a = target.querySelector('input')) === null || _a === void 0 ? void 0 : _a.checked)) return;
    // Create holder
    const holder = document.createElement('div');
    holder.style.position = 'absolute';
    holder.style.left = '0px';
    holder.style.top = '0px';
    target === null || target === void 0 || target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
    const reactRender = (0, $f76949e1bc95fa3b$export$4d4bf8843d204cca)();
    let unmountCallback = null;
    function registerUnmount() {
        return unmountCallback;
    }
    unmountCallback = reactRender(/*#__PURE__*/ $acw62.createElement($1267f32cdb4173c5$var$WaveEffect, Object.assign({}, info, {
        target: target,
        registerUnmount: registerUnmount
    })), holder);
};
var $1267f32cdb4173c5$export$2e2bcd8739ae039 = $1267f32cdb4173c5$var$showWaveEffect;


const $20c8c8dba0bc4c2d$var$useWave = (nodeRef, className, component)=>{
    const { wave: wave } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [, token, hashId] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const showWave = (0, $e294208d67c27cfa$export$2e2bcd8739ae039)((event)=>{
        const node = nodeRef.current;
        if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) return;
        const targetNode = node.querySelector(`.${(0, $ede16c18199d1556$export$23466a5792b7a5d3)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $1267f32cdb4173c5$export$2e2bcd8739ae039))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId
        });
    });
    const rafId = $acw62.useRef(null);
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $2b9f066ea00dd1c7$export$2e2bcd8739ae039).cancel(rafId.current);
        rafId.current = (0, $2b9f066ea00dd1c7$export$2e2bcd8739ae039)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
var $20c8c8dba0bc4c2d$export$2e2bcd8739ae039 = $20c8c8dba0bc4c2d$var$useWave;


const $37e027257ee01609$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const containerRef = (0, $acw62.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('wave');
    const [, hashId] = (0, $92631131e38a19f0$export$2e2bcd8739ae039)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $20c8c8dba0bc4c2d$export$2e2bcd8739ae039)(containerRef, (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, hashId), component);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== 1 || disabled) return;
        // Click handler
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $f1b50e7ed1ad3c25$export$2e2bcd8739ae039)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') || node.className.includes('-leave')) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener('click', onClick, true);
        return ()=>{
            node.removeEventListener('click', onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children)) return children !== null && children !== void 0 ? children : null;
    const ref = (0, $f1965a9a7a1fe067$export$c1cec34af06bcf7)(children) ? (0, $f1965a9a7a1fe067$export$ab452c34e8e05029)((0, $f1965a9a7a1fe067$export$7465e5c0bf44f19a)(children), containerRef) : containerRef;
    return (0, $30796c32f374b477$export$e530037191fcd5d7)(children, {
        ref: ref
    });
};
var $37e027257ee01609$export$2e2bcd8739ae039 = $37e027257ee01609$var$Wave;







var $acw62 = parcelRequire("acw62");




"use client";
var $981d7d04085c8929$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $981d7d04085c8929$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $acw62.createContext(undefined);
const $981d7d04085c8929$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, size: size, className: className } = props, others = $981d7d04085c8929$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const [, , hashId] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const sizeCls = $acw62.useMemo(()=>{
        switch(size){
            case 'large':
                return 'lg';
            case 'small':
                return 'sm';
            default:
                return '';
        }
    }, [
        size
    ]);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId);
    return /*#__PURE__*/ $acw62.createElement($981d7d04085c8929$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, others, {
        className: classes
    })));
};
var $981d7d04085c8929$export$2e2bcd8739ae039 = $981d7d04085c8929$var$ButtonGroup;




var $acw62 = parcelRequire("acw62");


"use client";
const $891d27b465b97c91$var$rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const $891d27b465b97c91$export$c5dca2bf412dea0d = $891d27b465b97c91$var$rxTwoCNChar.test.bind($891d27b465b97c91$var$rxTwoCNChar);
function $891d27b465b97c91$export$19bc9a290855952(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
function $891d27b465b97c91$export$844ec244b1367d54(str) {
    return typeof str === 'string';
}
function $891d27b465b97c91$export$b120bc11c0d9c214(type) {
    return type === 'text' || type === 'link';
}
function $891d27b465b97c91$var$splitCNCharsBySpace(child, needInserted) {
    if (child === null || child === undefined) return;
    const SPACE = needInserted ? ' ' : '';
    if (typeof child !== 'string' && typeof child !== 'number' && $891d27b465b97c91$export$844ec244b1367d54(child.type) && $891d27b465b97c91$export$c5dca2bf412dea0d(child.props.children)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        children: child.props.children.split('').join(SPACE)
    });
    if ($891d27b465b97c91$export$844ec244b1367d54(child)) return $891d27b465b97c91$export$c5dca2bf412dea0d(child) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, child.split('').join(SPACE)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, child);
    if ((0, $30796c32f374b477$export$9522e17588c12572)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, child);
    return child;
}
function $891d27b465b97c91$export$b6ee00a7e7908bc(children, needInserted) {
    let isPrevChildPure = false;
    const childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
        const type = typeof child;
        const isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(childList, (child)=>$891d27b465b97c91$var$splitCNCharsBySpace(child, needInserted));
}
const $891d27b465b97c91$var$_ButtonTypes = [
    'default',
    'primary',
    'dashed',
    'link',
    'text'
];
const $891d27b465b97c91$var$_ButtonShapes = [
    'default',
    'circle',
    'round'
];
const $891d27b465b97c91$var$_ButtonHTMLTypes = [
    'submit',
    'button',
    'reset'
];
const $891d27b465b97c91$export$9870b52452f51da5 = [
    'outlined',
    'dashed',
    'solid',
    'filled',
    'text',
    'link'
];
const $891d27b465b97c91$export$760f16d96e091fc5 = [
    'default',
    'primary',
    'danger'
].concat((0, $df4024303de6487a$export$2e2bcd8739ae039)((0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad)));



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

"use client";
const $19bf9f13d1d4a6e4$var$IconWrapper = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $19bf9f13d1d4a6e4$export$2e2bcd8739ae039 = $19bf9f13d1d4a6e4$var$IconWrapper;


"use client";
const $bfeeb2467aaa0581$var$InnerLoadingIcon = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = props;
    const mergedIconCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19bf9f13d1d4a6e4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), {
        className: iconClassName
    }));
});
const $bfeeb2467aaa0581$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    });
const $bfeeb2467aaa0581$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    });
const $bfeeb2467aaa0581$var$DefaultLoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style, mount: mount } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($bfeeb2467aaa0581$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d222a6d97472f88c$export$2e2bcd8739ae039), {
        visible: visible,
        // Used for minus flex gap style only
        motionName: `${prefixCls}-loading-icon-motion`,
        motionAppear: !mount,
        motionEnter: !mount,
        motionLeave: !mount,
        removeOnLeave: true,
        onAppearStart: $bfeeb2467aaa0581$var$getCollapsedWidth,
        onAppearActive: $bfeeb2467aaa0581$var$getRealWidth,
        onEnterStart: $bfeeb2467aaa0581$var$getCollapsedWidth,
        onEnterActive: $bfeeb2467aaa0581$var$getRealWidth,
        onLeaveStart: $bfeeb2467aaa0581$var$getRealWidth,
        onLeaveActive: $bfeeb2467aaa0581$var$getCollapsedWidth
    }, ({ className: motionCls, style: motionStyle }, ref)=>{
        const mergedStyle = Object.assign(Object.assign({}, style), motionStyle);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($bfeeb2467aaa0581$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, motionCls),
            style: mergedStyle,
            ref: ref
        });
    });
};
var $bfeeb2467aaa0581$export$2e2bcd8739ae039 = $bfeeb2467aaa0581$var$DefaultLoadingIcon;







const $9b1a8aea1f437a60$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            '&:not(:last-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            '&:not(:first-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $9b1a8aea1f437a60$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: 'relative',
                display: 'inline-flex',
                // Border
                [`> span, > ${componentCls}`]: {
                    '&:not(:last-child)': {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    '&:not(:first-child)': {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: 'relative',
                    zIndex: 1,
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    },
                    '&[disabled]': {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $9b1a8aea1f437a60$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $9b1a8aea1f437a60$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $9b1a8aea1f437a60$export$2e2bcd8739ae039 = $9b1a8aea1f437a60$var$genGroupStyle;



function $b66860b680574309$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $05ec880f77819fe2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $05ec880f77819fe2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $05ec880f77819fe2$export$2e2bcd8739ae039(o);
}



function $6dc8500f32cd01d2$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $05ec880f77819fe2$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $05ec880f77819fe2$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $2eed747192c47e7f$export$2e2bcd8739ae039(t) {
    var i = (0, $6dc8500f32cd01d2$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $05ec880f77819fe2$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $10c6e702e77c118b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $2eed747192c47e7f$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $10c6e702e77c118b$export$2e2bcd8739ae039(e, r, t) {
    return r && $10c6e702e77c118b$var$_defineProperties(e.prototype, r), t && $10c6e702e77c118b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}






var $acw62 = parcelRequire("acw62");









var $af3cb82f75f48284$var$_excluded = [
    "b"
], $af3cb82f75f48284$var$_excluded2 = [
    "v"
];
var $af3cb82f75f48284$export$8d6531175688484b = function getRoundNumber(value) {
    return Math.round(Number(value || 0));
};
var $af3cb82f75f48284$var$convertHsb2Hsv = function convertHsb2Hsv(color) {
    if (color instanceof (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)) return color;
    if (color && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(color) === 'object' && 'h' in color && 'b' in color) {
        var _ref = color, b = _ref.b, resets = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $af3cb82f75f48284$var$_excluded);
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, resets), {}, {
            v: b
        });
    }
    if (typeof color === 'string' && /hsb/.test(color)) return color.replace(/hsb/, 'hsv');
    return color;
};
var $af3cb82f75f48284$export$892596cec99bc70e = /*#__PURE__*/ function(_FastColor) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Color, _FastColor);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Color);
    function Color(color) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Color);
        return _super.call(this, $af3cb82f75f48284$var$convertHsb2Hsv(color));
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Color, [
        {
            key: "toHsbString",
            value: function toHsbString() {
                var hsb = this.toHsb();
                var saturation = $af3cb82f75f48284$export$8d6531175688484b(hsb.s * 100);
                var lightness = $af3cb82f75f48284$export$8d6531175688484b(hsb.b * 100);
                var hue = $af3cb82f75f48284$export$8d6531175688484b(hsb.h);
                var alpha = hsb.a;
                var hsbString = "hsb(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%)");
                var hsbaString = "hsba(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%, ").concat(alpha.toFixed(alpha === 0 ? 0 : 2), ")");
                return alpha === 1 ? hsbString : hsbaString;
            }
        },
        {
            key: "toHsb",
            value: function toHsb() {
                var _this$toHsv = this.toHsv(), v = _this$toHsv.v, resets = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_this$toHsv, $af3cb82f75f48284$var$_excluded2);
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, resets), {}, {
                    b: v,
                    a: this.a
                });
            }
        }
    ]);
    return Color;
}((0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a));


var $de94e2fd9370c2d3$export$90004e2badfbdf1f = 'rc-color-picker';
var $de94e2fd9370c2d3$export$c844f5d21427d1ab = function generateColor(color) {
    if (color instanceof (0, $af3cb82f75f48284$export$892596cec99bc70e)) return color;
    return new (0, $af3cb82f75f48284$export$892596cec99bc70e)(color);
};
var $de94e2fd9370c2d3$export$f705f0fde43a55a = $de94e2fd9370c2d3$export$c844f5d21427d1ab('#1677ff');
var $de94e2fd9370c2d3$export$3a7095e9fd85a71d = function calculateColor(props) {
    var offset = props.offset, targetRef = props.targetRef, containerRef = props.containerRef, color = props.color, type = props.type;
    var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
    var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
    var centerOffsetX = targetWidth / 2;
    var centerOffsetY = targetHeight / 2;
    var saturation = (offset.x + centerOffsetX) / width;
    var bright = 1 - (offset.y + centerOffsetY) / height;
    var hsb = color.toHsb();
    var alphaOffset = saturation;
    var hueOffset = (offset.x + centerOffsetX) / width * 360;
    if (type) switch(type){
        case 'hue':
            return $de94e2fd9370c2d3$export$c844f5d21427d1ab((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, hsb), {}, {
                h: hueOffset <= 0 ? 0 : hueOffset
            }));
        case 'alpha':
            return $de94e2fd9370c2d3$export$c844f5d21427d1ab((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, hsb), {}, {
                a: alphaOffset <= 0 ? 0 : alphaOffset
            }));
    }
    return $de94e2fd9370c2d3$export$c844f5d21427d1ab({
        h: hsb.h,
        s: saturation <= 0 ? 0 : saturation,
        b: bright >= 1 ? 1 : bright,
        a: hsb.a
    });
};
var $de94e2fd9370c2d3$export$20165527867cbf14 = function calcOffset(color, type) {
    var hsb = color.toHsb();
    switch(type){
        case 'hue':
            return {
                x: hsb.h / 360 * 100,
                y: 50
            };
        case 'alpha':
            return {
                x: color.a * 100,
                y: 50
            };
        // Picker panel
        default:
            return {
                x: hsb.s * 100,
                y: (1 - hsb.b) * 100
            };
    }
};






var $acw62 = parcelRequire("acw62");
var $f5d5fed38984894d$var$ColorBlock = function ColorBlock(_ref) {
    var color = _ref.color, prefixCls = _ref.prefixCls, className = _ref.className, style = _ref.style, onClick = _ref.onClick;
    var colorBlockCls = "".concat(prefixCls, "-color-block");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(colorBlockCls, className),
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(colorBlockCls, "-inner"),
        style: {
            background: color
        }
    }));
};
var $f5d5fed38984894d$export$2e2bcd8739ae039 = $f5d5fed38984894d$var$ColorBlock;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $c9dd3e79e6416b90$var$getPosition(e) {
    var obj = 'touches' in e ? e.touches[0] : e;
    var scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
    var scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    return {
        pageX: obj.pageX - scrollXOffset,
        pageY: obj.pageY - scrollYOffset
    };
}
function $c9dd3e79e6416b90$var$useColorDrag(props) {
    var targetRef = props.targetRef, containerRef = props.containerRef, direction = props.direction, onDragChange = props.onDragChange, onDragChangeComplete = props.onDragChangeComplete, calculate = props.calculate, color = props.color, disabledDrag = props.disabledDrag;
    var _useState = (0, $acw62.useState)({
        x: 0,
        y: 0
    }), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), offsetValue = _useState2[0], setOffsetValue = _useState2[1];
    var mouseMoveRef = (0, $acw62.useRef)(null);
    var mouseUpRef = (0, $acw62.useRef)(null);
    // Always get position from `color`
    (0, $acw62.useEffect)(function() {
        setOffsetValue(calculate());
    }, [
        color
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            document.removeEventListener('mousemove', mouseMoveRef.current);
            document.removeEventListener('mouseup', mouseUpRef.current);
            document.removeEventListener('touchmove', mouseMoveRef.current);
            document.removeEventListener('touchend', mouseUpRef.current);
            mouseMoveRef.current = null;
            mouseUpRef.current = null;
        };
    }, []);
    var updateOffset = function updateOffset(e) {
        var _getPosition = $c9dd3e79e6416b90$var$getPosition(e), pageX = _getPosition.pageX, pageY = _getPosition.pageY;
        var _containerRef$current = containerRef.current.getBoundingClientRect(), rectX = _containerRef$current.x, rectY = _containerRef$current.y, width = _containerRef$current.width, height = _containerRef$current.height;
        var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
        var centerOffsetX = targetWidth / 2;
        var centerOffsetY = targetHeight / 2;
        var offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
        var offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
        var calcOffset = {
            x: offsetX,
            y: direction === 'x' ? offsetValue.y : offsetY
        };
        // Exclusion of boundary cases
        if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) return false;
        onDragChange === null || onDragChange === void 0 || onDragChange(calcOffset);
    };
    var onDragMove = function onDragMove(e) {
        e.preventDefault();
        updateOffset(e);
    };
    var onDragStop = function onDragStop(e) {
        e.preventDefault();
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        document.removeEventListener('touchmove', mouseMoveRef.current);
        document.removeEventListener('touchend', mouseUpRef.current);
        mouseMoveRef.current = null;
        mouseUpRef.current = null;
        onDragChangeComplete === null || onDragChangeComplete === void 0 || onDragChangeComplete();
    };
    var onDragStart = function onDragStart(e) {
        // https://github.com/ant-design/ant-design/issues/43529
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        if (disabledDrag) return;
        updateOffset(e);
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragStop);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragStop);
        mouseMoveRef.current = onDragMove;
        mouseUpRef.current = onDragStop;
    };
    return [
        offsetValue,
        onDragStart
    ];
}
var $c9dd3e79e6416b90$export$2e2bcd8739ae039 = $c9dd3e79e6416b90$var$useColorDrag;







var $acw62 = parcelRequire("acw62");
var $059db1141305b3dc$var$Handler = function Handler(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'default' : _ref$size, color = _ref.color, prefixCls = _ref.prefixCls;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-handler"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-handler-sm"), size === 'small')),
        style: {
            backgroundColor: color
        }
    });
};
var $059db1141305b3dc$export$2e2bcd8739ae039 = $059db1141305b3dc$var$Handler;




var $acw62 = parcelRequire("acw62");
var $24032ee754712889$var$Palette = function Palette(_ref) {
    var children = _ref.children, style = _ref.style, prefixCls = _ref.prefixCls;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-palette"),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            position: 'relative'
        }, style)
    }, children);
};
var $24032ee754712889$export$2e2bcd8739ae039 = $24032ee754712889$var$Palette;



var $acw62 = parcelRequire("acw62");
var $d8cc625bd7d7a2b3$var$Transform = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var children = props.children, x = props.x, y = props.y;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        style: {
            position: 'absolute',
            left: "".concat(x, "%"),
            top: "".concat(y, "%"),
            zIndex: 1,
            transform: 'translate(-50%, -50%)'
        }
    }, children);
});
var $d8cc625bd7d7a2b3$export$2e2bcd8739ae039 = $d8cc625bd7d7a2b3$var$Transform;


var $a9cc94252844d50e$var$Picker = function Picker(_ref) {
    var color = _ref.color, onChange = _ref.onChange, prefixCls = _ref.prefixCls, onChangeComplete = _ref.onChangeComplete, disabled = _ref.disabled;
    var pickerRef = (0, $acw62.useRef)();
    var transformRef = (0, $acw62.useRef)();
    var colorRef = (0, $acw62.useRef)(color);
    var onDragChange = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(offsetValue) {
        var calcColor = (0, $de94e2fd9370c2d3$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: pickerRef,
            color: color
        });
        colorRef.current = calcColor;
        onChange(calcColor);
    });
    var _useColorDrag = (0, $c9dd3e79e6416b90$export$2e2bcd8739ae039)({
        color: color,
        containerRef: pickerRef,
        targetRef: transformRef,
        calculate: function calculate() {
            return (0, $de94e2fd9370c2d3$export$20165527867cbf14)(color);
        },
        onDragChange: onDragChange,
        onDragChangeComplete: function onDragChangeComplete() {
            return onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(colorRef.current);
        },
        disabledDrag: disabled
    }), _useColorDrag2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useColorDrag, 2), offset = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: pickerRef,
        className: "".concat(prefixCls, "-select"),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24032ee754712889$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8cc625bd7d7a2b3$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $059db1141305b3dc$export$2e2bcd8739ae039), {
        color: color.toRgbString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-saturation"),
        style: {
            backgroundColor: "hsl(".concat(color.toHsb().h, ",100%, 50%)"),
            backgroundImage: 'linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))'
        }
    })));
};
var $a9cc94252844d50e$export$2e2bcd8739ae039 = $a9cc94252844d50e$var$Picker;





var $acw62 = parcelRequire("acw62");

var $095453fdc9330f5b$var$useColorState = function useColorState(defaultValue, value) {
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultValue, {
        value: value
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
    var color = (0, $acw62.useMemo)(function() {
        return (0, $de94e2fd9370c2d3$export$c844f5d21427d1ab)(mergedValue);
    }, [
        mergedValue
    ]);
    return [
        color,
        setValue
    ];
};
var $095453fdc9330f5b$export$2e2bcd8739ae039 = $095453fdc9330f5b$var$useColorState;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");


var $779ea332dfaf89e2$var$Gradient = function Gradient(_ref) {
    var colors = _ref.colors, children = _ref.children, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'to right' : _ref$direction, type = _ref.type, prefixCls = _ref.prefixCls;
    var gradientColors = (0, $acw62.useMemo)(function() {
        return colors.map(function(color, idx) {
            var result = (0, $de94e2fd9370c2d3$export$c844f5d21427d1ab)(color);
            if (type === 'alpha' && idx === colors.length - 1) result = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(result.setA(1));
            return result.toRgbString();
        }).join(',');
    }, [
        colors,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-gradient"),
        style: {
            position: 'absolute',
            inset: 0,
            background: "linear-gradient(".concat(direction, ", ").concat(gradientColors, ")")
        }
    }, children);
};
var $779ea332dfaf89e2$export$2e2bcd8739ae039 = $779ea332dfaf89e2$var$Gradient;




var $9b76597d540edf8a$var$Slider = function Slider(props) {
    var prefixCls = props.prefixCls, colors = props.colors, disabled = props.disabled, onChange = props.onChange, onChangeComplete = props.onChangeComplete, color = props.color, type = props.type;
    var sliderRef = (0, $acw62.useRef)();
    var transformRef = (0, $acw62.useRef)();
    var colorRef = (0, $acw62.useRef)(color);
    var getValue = function getValue(c) {
        return type === 'hue' ? c.getHue() : c.a * 100;
    };
    var onDragChange = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(offsetValue) {
        var calcColor = (0, $de94e2fd9370c2d3$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: sliderRef,
            color: color,
            type: type
        });
        colorRef.current = calcColor;
        onChange(getValue(calcColor));
    });
    var _useColorDrag = (0, $c9dd3e79e6416b90$export$2e2bcd8739ae039)({
        color: color,
        targetRef: transformRef,
        containerRef: sliderRef,
        calculate: function calculate() {
            return (0, $de94e2fd9370c2d3$export$20165527867cbf14)(color, type);
        },
        onDragChange: onDragChange,
        onDragChangeComplete: function onDragChangeComplete() {
            onChangeComplete(getValue(colorRef.current));
        },
        direction: 'x',
        disabledDrag: disabled
    }), _useColorDrag2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useColorDrag, 2), offset = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
    var handleColor = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        if (type === 'hue') {
            var hsb = color.toHsb();
            hsb.s = 1;
            hsb.b = 1;
            hsb.a = 1;
            var lightColor = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(hsb);
            return lightColor;
        }
        return color;
    }, [
        color,
        type
    ]);
    // ========================= Gradient =========================
    var gradientList = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return colors.map(function(info) {
            return "".concat(info.color, " ").concat(info.percent, "%");
        });
    }, [
        colors
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: sliderRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-slider"), "".concat(prefixCls, "-slider-").concat(type)),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24032ee754712889$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8cc625bd7d7a2b3$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $059db1141305b3dc$export$2e2bcd8739ae039), {
        size: "small",
        color: handleColor.toHexString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $779ea332dfaf89e2$export$2e2bcd8739ae039), {
        colors: gradientList,
        type: type,
        prefixCls: prefixCls
    })));
};
var $9b76597d540edf8a$export$2e2bcd8739ae039 = $9b76597d540edf8a$var$Slider;


function $730e0f8c893accac$export$2e2bcd8739ae039(components) {
    return $acw62.useMemo(function() {
        var _ref = components || {}, slider = _ref.slider;
        return [
            slider || (0, $9b76597d540edf8a$export$2e2bcd8739ae039)
        ];
    }, [
        components
    ]);
}


var $af5eb4327ab367e9$var$HUE_COLORS = [
    {
        color: 'rgb(255, 0, 0)',
        percent: 0
    },
    {
        color: 'rgb(255, 255, 0)',
        percent: 17
    },
    {
        color: 'rgb(0, 255, 0)',
        percent: 33
    },
    {
        color: 'rgb(0, 255, 255)',
        percent: 50
    },
    {
        color: 'rgb(0, 0, 255)',
        percent: 67
    },
    {
        color: 'rgb(255, 0, 255)',
        percent: 83
    },
    {
        color: 'rgb(255, 0, 0)',
        percent: 100
    }
];
var $af5eb4327ab367e9$var$ColorPicker = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var value = props.value, defaultValue = props.defaultValue, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? (0, $de94e2fd9370c2d3$export$90004e2badfbdf1f) : _props$prefixCls, onChange = props.onChange, onChangeComplete = props.onChangeComplete, className = props.className, style = props.style, panelRender = props.panelRender, _props$disabledAlpha = props.disabledAlpha, disabledAlpha = _props$disabledAlpha === void 0 ? false : _props$disabledAlpha, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, components = props.components;
    // ========================== Components ==========================
    var _useComponent = (0, $730e0f8c893accac$export$2e2bcd8739ae039)(components), _useComponent2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useComponent, 1), Slider = _useComponent2[0];
    // ============================ Color =============================
    var _useColorState = (0, $095453fdc9330f5b$export$2e2bcd8739ae039)(defaultValue || (0, $de94e2fd9370c2d3$export$f705f0fde43a55a), value), _useColorState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useColorState, 2), colorValue = _useColorState2[0], setColorValue = _useColorState2[1];
    var alphaColor = (0, $acw62.useMemo)(function() {
        return colorValue.setA(1).toRgbString();
    }, [
        colorValue
    ]);
    // ============================ Events ============================
    var handleChange = function handleChange(data, type) {
        if (!value) setColorValue(data);
        onChange === null || onChange === void 0 || onChange(data, type);
    };
    // Convert
    var getHueColor = function getHueColor(hue) {
        return new (0, $af3cb82f75f48284$export$892596cec99bc70e)(colorValue.setHue(hue));
    };
    var getAlphaColor = function getAlphaColor(alpha) {
        return new (0, $af3cb82f75f48284$export$892596cec99bc70e)(colorValue.setA(alpha / 100));
    };
    // Slider change
    var onHueChange = function onHueChange(hue) {
        handleChange(getHueColor(hue), {
            type: 'hue',
            value: hue
        });
    };
    var onAlphaChange = function onAlphaChange(alpha) {
        handleChange(getAlphaColor(alpha), {
            type: 'alpha',
            value: alpha
        });
    };
    // Complete
    var onHueChangeComplete = function onHueChangeComplete(hue) {
        if (onChangeComplete) onChangeComplete(getHueColor(hue));
    };
    var onAlphaChangeComplete = function onAlphaChangeComplete(alpha) {
        if (onChangeComplete) onChangeComplete(getAlphaColor(alpha));
    };
    // ============================ Render ============================
    var mergeCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-panel"), className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-panel-disabled"), disabled));
    var sharedSliderProps = {
        prefixCls: prefixCls,
        disabled: disabled,
        color: colorValue
    };
    var defaultPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a9cc94252844d50e$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        onChange: handleChange
    }, sharedSliderProps, {
        onChangeComplete: onChangeComplete
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-slider-container")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-slider-group"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-slider-group-disabled-alpha"), disabledAlpha))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Slider, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sharedSliderProps, {
        type: "hue",
        colors: $af5eb4327ab367e9$var$HUE_COLORS,
        min: 0,
        max: 359,
        value: colorValue.getHue(),
        onChange: onHueChange,
        onChangeComplete: onHueChangeComplete
    })), !disabledAlpha && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Slider, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sharedSliderProps, {
        type: "alpha",
        colors: [
            {
                percent: 0,
                color: 'rgba(255, 0, 4, 0)'
            },
            {
                percent: 100,
                color: alphaColor
            }
        ],
        min: 0,
        max: 100,
        value: colorValue.a * 100,
        onChange: onAlphaChange,
        onChangeComplete: onAlphaChangeComplete
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f5d5fed38984894d$export$2e2bcd8739ae039), {
        color: colorValue.toRgbString(),
        prefixCls: prefixCls
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: mergeCls,
        style: style,
        ref: ref
    }, typeof panelRender === 'function' ? panelRender(defaultPanel) : defaultPanel);
});
var $af5eb4327ab367e9$export$2e2bcd8739ae039 = $af5eb4327ab367e9$var$ColorPicker;






var $5639bde50d53abf9$export$2e2bcd8739ae039 = (0, $af5eb4327ab367e9$export$2e2bcd8739ae039);


const $078cdd44fbbd27df$export$d0aa8b5e56c9af06 = (value, alpha)=>(value === null || value === void 0 ? void 0 : value.replace(/[^\w/]/g, '').slice(0, alpha ? 8 : 6)) || '';
const $078cdd44fbbd27df$export$6c90ef703dcfba25 = (value, alpha)=>value ? $078cdd44fbbd27df$export$d0aa8b5e56c9af06(value, alpha) : '';
let $078cdd44fbbd27df$export$e8cc8a2e87e145b4 = /*#__PURE__*/ function() {
    function AggregationColor(color) {
        (0, $b66860b680574309$export$2e2bcd8739ae039)(this, AggregationColor);
        var _a;
        this.cleared = false;
        // Clone from another AggregationColor
        if (color instanceof AggregationColor) {
            this.metaColor = color.metaColor.clone();
            this.colors = (_a = color.colors) === null || _a === void 0 ? void 0 : _a.map((info)=>({
                    color: new AggregationColor(info.color),
                    percent: info.percent
                }));
            this.cleared = color.cleared;
            return;
        }
        const isArray = Array.isArray(color);
        if (isArray && color.length) {
            this.colors = color.map(({ color: c, percent: percent })=>({
                    color: new AggregationColor(c),
                    percent: percent
                }));
            this.metaColor = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(this.colors[0].color.metaColor);
        } else this.metaColor = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(isArray ? '' : color);
        if (!color || isArray && !this.colors) {
            this.metaColor = this.metaColor.setA(0);
            this.cleared = true;
        }
    }
    return (0, $10c6e702e77c118b$export$2e2bcd8739ae039)(AggregationColor, [
        {
            key: "toHsb",
            value: function toHsb() {
                return this.metaColor.toHsb();
            }
        },
        {
            key: "toHsbString",
            value: function toHsbString() {
                return this.metaColor.toHsbString();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return $078cdd44fbbd27df$export$6c90ef703dcfba25(this.toHexString(), this.metaColor.a < 1);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.metaColor.toHexString();
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return this.metaColor.toRgb();
            }
        },
        {
            key: "toRgbString",
            value: function toRgbString() {
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "isGradient",
            value: function isGradient() {
                return !!this.colors && !this.cleared;
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return this.colors || [
                    {
                        color: this,
                        percent: 0
                    }
                ];
            }
        },
        {
            key: "toCssString",
            value: function toCssString() {
                const { colors: colors } = this;
                // CSS line-gradient
                if (colors) {
                    const colorsStr = colors.map((c)=>`${c.color.toRgbString()} ${c.percent}%`).join(', ');
                    return `linear-gradient(90deg, ${colorsStr})`;
                }
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "equals",
            value: function equals(color) {
                if (!color || this.isGradient() !== color.isGradient()) return false;
                if (!this.isGradient()) return this.toHexString() === color.toHexString();
                return this.colors.length === color.colors.length && this.colors.every((c, i)=>{
                    const target = color.colors[i];
                    return c.percent === target.percent && c.color.equals(target.color);
                });
            }
        }
    ]);
}();



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $73624b371df38195$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $73624b371df38195$export$2e2bcd8739ae039 = $73624b371df38195$var$RightOutlined;



var $ae197ef38b34eab8$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $73624b371df38195$export$2e2bcd8739ae039)
    }));
};
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ var $ae197ef38b34eab8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ae197ef38b34eab8$var$RightOutlined);
var $ae197ef38b34eab8$export$2e2bcd8739ae039 = $ae197ef38b34eab8$var$RefIcon;











var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $3ec18031647490fe$var$PanelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, forceRender = props.forceRender, className = props.className, style = props.style, children = props.children, isActive = props.isActive, role = props.role, customizeClassNames = props.classNames, styles = props.styles;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(isActive || forceRender), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), rendered = _React$useState2[0], setRendered = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-content-active"), isActive), "".concat(prefixCls, "-content-inactive"), !isActive), className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content-box"), customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames.body),
        style: styles === null || styles === void 0 ? void 0 : styles.body
    }, children));
});
$3ec18031647490fe$var$PanelContent.displayName = 'PanelContent';
var $3ec18031647490fe$export$2e2bcd8739ae039 = $3ec18031647490fe$var$PanelContent;


var $350d18e6f82391e6$var$_excluded = [
    "showArrow",
    "headerClass",
    "isActive",
    "onItemClick",
    "forceRender",
    "className",
    "classNames",
    "styles",
    "prefixCls",
    "collapsible",
    "accordion",
    "panelKey",
    "extra",
    "header",
    "expandIcon",
    "openMotion",
    "destroyInactivePanel",
    "children"
];
var $350d18e6f82391e6$var$CollapsePanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, headerClass = props.headerClass, isActive = props.isActive, onItemClick = props.onItemClick, forceRender = props.forceRender, className = props.className, _props$classNames = props.classNames, customizeClassNames = _props$classNames === void 0 ? {} : _props$classNames, _props$styles = props.styles, styles = _props$styles === void 0 ? {} : _props$styles, prefixCls = props.prefixCls, collapsible = props.collapsible, accordion = props.accordion, panelKey = props.panelKey, extra = props.extra, header = props.header, expandIcon = props.expandIcon, openMotion = props.openMotion, destroyInactivePanel = props.destroyInactivePanel, children = props.children, resetProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $350d18e6f82391e6$var$_excluded);
    var disabled = collapsible === 'disabled';
    var ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean';
    var collapsibleProps = (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({
        onClick: function onClick() {
            onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
        },
        onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter' || e.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER || e.which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
        },
        role: accordion ? 'tab' : 'button'
    }, 'aria-expanded', isActive), 'aria-disabled', disabled), "tabIndex", disabled ? -1 : 0);
    // ======================== Icon ========================
    var iconNodeInner = typeof expandIcon === 'function' ? expandIcon(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "arrow"
    });
    var iconNode = iconNodeInner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: "".concat(prefixCls, "-expand-icon")
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
    var collapsePanelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-item"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-item-active"), isActive), "".concat(prefixCls, "-item-disabled"), disabled), className);
    var headerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(headerClass, "".concat(prefixCls, "-header"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-collapsible-").concat(collapsible), !!collapsible), customizeClassNames.header);
    // ======================== HeaderProps ========================
    var headerProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        className: headerClassName,
        style: styles.header
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? {} : collapsibleProps);
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: "".concat(prefixCls, "-header-text")
    }, collapsible === 'header' ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-extra")
    }, extra)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        visible: isActive,
        leavedClassName: "".concat(prefixCls, "-content-hidden")
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyInactivePanel
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3ec18031647490fe$export$2e2bcd8739ae039), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            classNames: customizeClassNames,
            style: motionStyle,
            styles: styles,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? 'tabpanel' : void 0
        }, children);
    }));
});
var $350d18e6f82391e6$export$2e2bcd8739ae039 = $350d18e6f82391e6$var$CollapsePanel;


var $5232ed645c6d7d63$var$_excluded = [
    "children",
    "label",
    "key",
    "collapsible",
    "onItemClick",
    "destroyInactivePanel"
];
var $5232ed645c6d7d63$var$convertItemsToNodes = function convertItemsToNodes(items, props) {
    var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
    return items.map(function(item, index) {
        var children = item.children, label = item.label, rawKey = item.key, rawCollapsible = item.collapsible, rawOnItemClick = item.onItemClick, rawDestroyInactivePanel = item.destroyInactivePanel, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(item, $5232ed645c6d7d63$var$_excluded);
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        var key = String(rawKey !== null && rawKey !== void 0 ? rawKey : index);
        var mergeCollapsible = rawCollapsible !== null && rawCollapsible !== void 0 ? rawCollapsible : collapsible;
        var mergeDestroyInactivePanel = rawDestroyInactivePanel !== null && rawDestroyInactivePanel !== void 0 ? rawDestroyInactivePanel : destroyInactivePanel;
        var handleItemClick = function handleItemClick(value) {
            if (mergeCollapsible === 'disabled') return;
            onItemClick(value);
            rawOnItemClick === null || rawOnItemClick === void 0 || rawOnItemClick(value);
        };
        var isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $350d18e6f82391e6$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyInactivePanel: mergeDestroyInactivePanel
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ var $5232ed645c6d7d63$var$getNewChild = function getNewChild(child, index, props) {
    if (!child) return null;
    var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
    var key = child.key || String(index);
    var _child$props = child.props, header = _child$props.header, headerClass = _child$props.headerClass, childDestroyInactivePanel = _child$props.destroyInactivePanel, childCollapsible = _child$props.collapsible, childOnItemClick = _child$props.onItemClick;
    var isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    var mergeCollapsible = childCollapsible !== null && childCollapsible !== void 0 ? childCollapsible : collapsible;
    var handleItemClick = function handleItemClick(value) {
        if (mergeCollapsible === 'disabled') return;
        onItemClick(value);
        childOnItemClick === null || childOnItemClick === void 0 || childOnItemClick(value);
    };
    var childProps = {
        key: key,
        panelKey: key,
        header: header,
        headerClass: headerClass,
        isActive: isActive,
        prefixCls: prefixCls,
        destroyInactivePanel: childDestroyInactivePanel !== null && childDestroyInactivePanel !== void 0 ? childDestroyInactivePanel : destroyInactivePanel,
        openMotion: openMotion,
        accordion: accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon: expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === 'string') return child;
    Object.keys(childProps).forEach(function(propName) {
        if (typeof childProps[propName] === 'undefined') delete childProps[propName];
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, childProps);
};
function $5232ed645c6d7d63$var$useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return $5232ed645c6d7d63$var$convertItemsToNodes(items, props);
    return (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(rawChildren).map(function(child, index) {
        return $5232ed645c6d7d63$var$getNewChild(child, index, props);
    });
}
var $5232ed645c6d7d63$export$2e2bcd8739ae039 = $5232ed645c6d7d63$var$useItems;




function $3311a7ce873bb787$var$getActiveKeysArray(activeKey) {
    var currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        var activeKeyType = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(currentActiveKey);
        currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map(function(key) {
        return String(key);
    });
}
var $3311a7ce873bb787$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-collapse' : _props$prefixCls, _props$destroyInactiv = props.destroyInactivePanel, destroyInactivePanel = _props$destroyInactiv === void 0 ? false : _props$destroyInactiv, style = props.style, accordion = props.accordion, className = props.className, children = props.children, collapsible = props.collapsible, openMotion = props.openMotion, expandIcon = props.expandIcon, rawActiveKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, _onChange = props.onChange, items = props.items;
    var collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className);
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)([], {
        value: rawActiveKey,
        onChange: function onChange(v) {
            return _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
        },
        defaultValue: defaultActiveKey,
        postState: $3311a7ce873bb787$var$getActiveKeysArray
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), activeKey = _useMergedState2[0], setActiveKey = _useMergedState2[1];
    var onItemClick = function onItemClick(key) {
        return setActiveKey(function() {
            if (accordion) return activeKey[0] === key ? [] : [
                key
            ];
            var index = activeKey.indexOf(key);
            var isActive = index > -1;
            if (isActive) return activeKey.filter(function(item) {
                return item !== key;
            });
            return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(activeKey), [
                key
            ]);
        });
    };
    // ======================== Children ========================
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!children, '[rc-collapse] `children` will be removed in next major version. Please use `items` instead.');
    var mergedChildren = (0, $5232ed645c6d7d63$export$2e2bcd8739ae039)(items, children, {
        prefixCls: prefixCls,
        accordion: accordion,
        openMotion: openMotion,
        expandIcon: expandIcon,
        collapsible: collapsible,
        destroyInactivePanel: destroyInactivePanel,
        onItemClick: onItemClick,
        activeKey: activeKey
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? 'tablist' : undefined
    }, (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    })), mergedChildren);
});
var $3311a7ce873bb787$export$2e2bcd8739ae039 = Object.assign($3311a7ce873bb787$var$Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, $350d18e6f82391e6$export$2e2bcd8739ae039)
});


var $c39a932f4146e741$export$2e2bcd8739ae039 = (0, $3311a7ce873bb787$export$2e2bcd8739ae039);
/**
 * @deprecated use `items` instead, will be removed in `v4.0.0`
 */ var $c39a932f4146e741$export$2ddb90ad54e5f587 = (0, $3311a7ce873bb787$export$2e2bcd8739ae039).Panel;










var $acw62 = parcelRequire("acw62");




"use client";
const $8247f3cd58331054$var$CollapsePanel = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showArrow: showArrow = true } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const collapsePanelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ $acw62.createElement((0, $c39a932f4146e741$export$2e2bcd8739ae039).Panel, Object.assign({
        ref: ref
    }, props, {
        prefixCls: prefixCls,
        className: collapsePanelClassName
    }));
});
var $8247f3cd58331054$export$2e2bcd8739ae039 = $8247f3cd58331054$var$CollapsePanel;




const $8eae2cab6b8e600b$var$genCollapseMotion = (token)=>({
        [token.componentCls]: {
            // For common/openAnimation
            [`${token.antCls}-motion-collapse-legacy`]: {
                overflow: 'hidden',
                '&-active': {
                    transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
                }
            },
            [`${token.antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
            }
        }
    });
var $8eae2cab6b8e600b$export$2e2bcd8739ae039 = $8eae2cab6b8e600b$var$genCollapseMotion;



const $f3a8b55181e5e7fb$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, contentBg: contentBg, padding: padding, headerBg: headerBg, headerPadding: headerPadding, collapseHeaderPaddingSM: collapseHeaderPaddingSM, collapseHeaderPaddingLG: collapseHeaderPaddingLG, collapsePanelBorderRadius: collapsePanelBorderRadius, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, colorText: colorText, colorTextHeading: colorTextHeading, colorTextDisabled: colorTextDisabled, fontSizeLG: fontSizeLG, lineHeight: lineHeight, lineHeightLG: lineHeightLG, marginSM: marginSM, paddingSM: paddingSM, paddingLG: paddingLG, paddingXS: paddingXS, motionDurationSlow: motionDurationSlow, fontSizeIcon: fontSizeIcon, contentPadding: contentPadding, fontHeight: fontHeight, fontHeightLG: fontHeightLG } = token;
    const borderBase = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            backgroundColor: headerBg,
            border: borderBase,
            borderRadius: collapsePanelBorderRadius,
            '&-rtl': {
                direction: 'rtl'
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                '&:first-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)} 0 0`
                    }
                },
                '&:last-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: Object.assign(Object.assign({
                    position: 'relative',
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight: lineHeight,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}, visibility 0s`
                }, (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)), {
                    [`> ${componentCls}-header-text`]: {
                        flex: 'auto'
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: 'flex',
                        alignItems: 'center',
                        paddingInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$171ccda7bc085e59)()), {
                        fontSize: fontSizeIcon,
                        // when `transform: rotate()` is applied to icon's root element
                        transition: `transform ${motionDurationSlow}`,
                        // when `transform: rotate()` is applied to icon's child element
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    }),
                    // >>>>> Text
                    [`${componentCls}-header-text`]: {
                        marginInlineEnd: 'auto'
                    }
                }),
                [`${componentCls}-collapsible-header`]: {
                    cursor: 'default',
                    [`${componentCls}-header-text`]: {
                        flex: 'none',
                        cursor: 'pointer'
                    }
                },
                [`${componentCls}-collapsible-icon`]: {
                    cursor: 'unset',
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                }
            },
            [`${componentCls}-content`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-content-box`]: {
                    padding: contentPadding
                },
                '&-hidden': {
                    display: 'none'
                }
            },
            '&-small': {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingSM,
                        paddingInlineStart: paddingXS,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-content > ${componentCls}-content-box`]: {
                        padding: paddingSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingLG,
                        paddingInlineStart: padding,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-content > ${componentCls}-content-box`]: {
                        padding: paddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                borderBottom: 0,
                [`> ${componentCls}-content`]: {
                    borderRadius: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                [`
          &,
          & > .arrow
        `]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            // ========================== Icon Position ==========================
            [`&${componentCls}-icon-position-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            paddingInlineEnd: 0,
                            paddingInlineStart: marginSM
                        }
                    }
                }
            }
        })
    };
};
const $f3a8b55181e5e7fb$var$genArrowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const $f3a8b55181e5e7fb$var$genBorderlessStyle = (token)=>{
    const { componentCls: componentCls, headerBg: headerBg, borderlessContentPadding: borderlessContentPadding, borderlessContentBg: borderlessContentBg, colorBorder: colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `1px solid ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-content`]: {
                backgroundColor: borderlessContentBg,
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-content > ${componentCls}-content-box`]: {
                padding: borderlessContentPadding
            }
        }
    };
};
const $f3a8b55181e5e7fb$var$genGhostStyle = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: 'transparent',
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-content`]: {
                    backgroundColor: 'transparent',
                    border: 0,
                    [`> ${componentCls}-content-box`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const $f3a8b55181e5e7fb$export$9ca1be8807fe0675 = (token)=>({
        headerPadding: `${token.paddingSM}px ${token.padding}px`,
        headerBg: token.colorFillAlter,
        contentPadding: `${token.padding}px 16px`,
        // Fixed Value
        contentBg: token.colorBgContainer,
        borderlessContentPadding: `${token.paddingXXS}px 16px ${token.padding}px`,
        borderlessContentBg: 'transparent'
    });
var $f3a8b55181e5e7fb$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Collapse', (token)=>{
    const collapseToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        collapseHeaderPaddingSM: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXS)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingSM)}`,
        collapseHeaderPaddingLG: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.padding)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingLG)}`,
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        $f3a8b55181e5e7fb$export$5ca74f7be820a85(collapseToken),
        $f3a8b55181e5e7fb$var$genBorderlessStyle(collapseToken),
        $f3a8b55181e5e7fb$var$genGhostStyle(collapseToken),
        $f3a8b55181e5e7fb$var$genArrowStyle(collapseToken),
        (0, $8eae2cab6b8e600b$export$2e2bcd8739ae039)(collapseToken)
    ];
}, $f3a8b55181e5e7fb$export$9ca1be8807fe0675);


"use client";
const $f9834ac36ee4cc31$var$Collapse = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, expandIcon: contextExpandIcon, className: contextClassName, style: contextStyle } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('collapse');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, bordered: bordered = true, ghost: ghost, size: customizeSize, expandIconPosition: expandIconPosition = 'start', children: children, destroyInactivePanel: destroyInactivePanel, destroyOnHidden: destroyOnHidden, expandIcon: expandIcon } = props;
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : ctx) !== null && _a !== void 0 ? _a : 'middle';
    });
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [wrapCSSVar, hashId, cssVarCls] = (0, $f3a8b55181e5e7fb$export$2e2bcd8739ae039)(prefixCls);
    // Align with logic position
    const mergedExpandIconPosition = $acw62.useMemo(()=>{
        if (expandIconPosition === 'left') return 'start';
        return expandIconPosition === 'right' ? 'end' : expandIconPosition;
    }, [
        expandIconPosition
    ]);
    const mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
    const renderExpandIcon = $acw62.useCallback((panelProps = {})=>{
        const icon = typeof mergedExpandIcon === 'function' ? mergedExpandIcon(panelProps) : /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), {
            rotate: panelProps.isActive ? direction === 'rtl' ? -90 : 90 : undefined,
            "aria-label": panelProps.isActive ? 'expanded' : 'collapsed'
        });
        return (0, $30796c32f374b477$export$e530037191fcd5d7)(icon, ()=>{
            var _a;
            return {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((_a = icon.props) === null || _a === void 0 ? void 0 : _a.className, `${prefixCls}-arrow`)
            };
        });
    }, [
        mergedExpandIcon,
        prefixCls,
        direction
    ]);
    const collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-icon-position-${mergedExpandIconPosition}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-${mergedSize}`]: mergedSize !== 'middle'
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    const openMotion = $acw62.useMemo(()=>Object.assign(Object.assign({}, (0, $2efb522a5615f01e$export$2e2bcd8739ae039)(rootPrefixCls)), {
            motionAppear: false,
            leavedClassName: `${prefixCls}-content-hidden`
        }), [
        rootPrefixCls,
        prefixCls
    ]);
    const items = $acw62.useMemo(()=>{
        if (!children) return null;
        return (0, $5aa78504b8a12848$export$2e2bcd8739ae039)(children).map((child, index)=>{
            var _a, _b;
            const childProps = child.props;
            if (childProps === null || childProps === void 0 ? void 0 : childProps.disabled) {
                const key = (_a = child.key) !== null && _a !== void 0 ? _a : String(index);
                const mergedChildProps = Object.assign(Object.assign({}, (0, $57c22a5a2f343bca$export$2e2bcd8739ae039)(child.props, [
                    'disabled'
                ])), {
                    key: key,
                    collapsible: (_b = childProps.collapsible) !== null && _b !== void 0 ? _b : 'disabled'
                });
                return (0, $30796c32f374b477$export$e530037191fcd5d7)(child, mergedChildProps);
            }
            return child;
        });
    }, [
        children
    ]);
    return wrapCSSVar(/*#__PURE__*/ // @ts-ignore
    $acw62.createElement((0, $c39a932f4146e741$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        openMotion: openMotion
    }, (0, $57c22a5a2f343bca$export$2e2bcd8739ae039)(props, [
        'rootClassName'
    ]), {
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: Object.assign(Object.assign({}, contextStyle), style),
        // TODO: In the future, destroyInactivePanel in rc-collapse needs to be upgrade to destroyOnHidden
        destroyInactivePanel: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyInactivePanel
    }), items));
});
var $f9834ac36ee4cc31$export$2e2bcd8739ae039 = Object.assign($f9834ac36ee4cc31$var$Collapse, {
    Panel: (0, $8247f3cd58331054$export$2e2bcd8739ae039)
});


"use client";
var $87069059c399a8f7$export$2e2bcd8739ae039 = (0, $f9834ac36ee4cc31$export$2e2bcd8739ae039);







const $6a06b7fa031c80c1$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $078cdd44fbbd27df$export$e8cc8a2e87e145b4)) return color;
    return new (0, $078cdd44fbbd27df$export$e8cc8a2e87e145b4)(color);
};
const $6a06b7fa031c80c1$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $6a06b7fa031c80c1$export$3c8ae3c73ab0e52a = (color)=>$6a06b7fa031c80c1$export$8d6531175688484b(color.toHsb().a * 100);
const $6a06b7fa031c80c1$export$f04e5f54cfbb466c = (color, alpha)=>{
    const rgba = color.toRgb();
    // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
    // So if rgb is empty, we should get from hsb
    if (!rgba.r && !rgba.g && !rgba.b) {
        const hsba = color.toHsb();
        hsba.a = alpha || 1;
        return $6a06b7fa031c80c1$export$c844f5d21427d1ab(hsba);
    }
    rgba.a = alpha || 1;
    return $6a06b7fa031c80c1$export$c844f5d21427d1ab(rgba);
};
const $6a06b7fa031c80c1$export$9dd6bfe648e14e97 = (colors, percent)=>{
    const filledColors = [
        {
            percent: 0,
            color: colors[0].color
        }
    ].concat((0, $df4024303de6487a$export$2e2bcd8739ae039)(colors), [
        {
            percent: 100,
            color: colors[colors.length - 1].color
        }
    ]);
    for(let i = 0; i < filledColors.length - 1; i += 1){
        const startPtg = filledColors[i].percent;
        const endPtg = filledColors[i + 1].percent;
        const startColor = filledColors[i].color;
        const endColor = filledColors[i + 1].color;
        if (startPtg <= percent && percent <= endPtg) {
            const dist = endPtg - startPtg;
            if (dist === 0) return startColor;
            const ratio = (percent - startPtg) / dist * 100;
            const startRcColor = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(startColor);
            const endRcColor = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(endColor);
            return startRcColor.mix(endRcColor, ratio).toRgbString();
        }
    }
    // This will never reach
    /* istanbul ignore next */ return '';
};


"use client";
const $d5221672d26ff0b4$var$genPresetColor = (list)=>list.map((value)=>{
        value.colors = value.colors.map((0, $6a06b7fa031c80c1$export$c844f5d21427d1ab));
        return value;
    });
const $d5221672d26ff0b4$export$6341b37cb79161da = (value, bgColorToken)=>{
    const { r: r, g: g, b: b, a: a } = value.toRgb();
    const hsv = new (0, $af3cb82f75f48284$export$892596cec99bc70e)(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) // Adapted to dark mode
    return hsv.v > 0.5;
    return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const $d5221672d26ff0b4$var$genCollapsePanelKey = (preset, index)=>{
    var _a;
    const mergedKey = (_a = preset.key) !== null && _a !== void 0 ? _a : index;
    return `panel-${mergedKey}`;
};
const $d5221672d26ff0b4$var$ColorPresets = ({ prefixCls: prefixCls, presets: presets, value: color, onChange: onChange })=>{
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('ColorPicker');
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const [presetsValue] = (0, $fbd33e1a3c597913$export$2e2bcd8739ae039)($d5221672d26ff0b4$var$genPresetColor(presets), {
        value: $d5221672d26ff0b4$var$genPresetColor(presets),
        postState: $d5221672d26ff0b4$var$genPresetColor
    });
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, $acw62.useMemo)(()=>presetsValue.reduce((acc, preset, index)=>{
            const { defaultOpen: defaultOpen = true } = preset;
            if (defaultOpen) acc.push($d5221672d26ff0b4$var$genCollapsePanelKey(preset, index));
            return acc;
        }, []), [
        presetsValue
    ]);
    const handleClick = (colorValue)=>{
        onChange === null || onChange === void 0 || onChange(colorValue);
    };
    const items = presetsValue.map((preset, index)=>{
        var _a;
        return {
            key: $d5221672d26ff0b4$var$genCollapsePanelKey(preset, index),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: `${colorPresetsPrefixCls}-label`
            }, preset === null || preset === void 0 ? void 0 : preset.label),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: `${colorPresetsPrefixCls}-items`
            }, Array.isArray(preset === null || preset === void 0 ? void 0 : preset.colors) && ((_a = preset.colors) === null || _a === void 0 ? void 0 : _a.length) > 0 ? preset.colors.map((presetColor, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f5d5fed38984894d$export$2e2bcd8739ae039), {
                    // eslint-disable-next-line react/no-array-index-key
                    key: `preset-${index}-${presetColor.toHexString()}`,
                    color: (0, $6a06b7fa031c80c1$export$c844f5d21427d1ab)(presetColor).toRgbString(),
                    prefixCls: prefixCls,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${colorPresetsPrefixCls}-color`, {
                        [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toHexString() === (color === null || color === void 0 ? void 0 : color.toHexString()),
                        [`${colorPresetsPrefixCls}-color-bright`]: $d5221672d26ff0b4$export$6341b37cb79161da(presetColor, token.colorBgElevated)
                    }),
                    onClick: ()=>handleClick(presetColor)
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: `${colorPresetsPrefixCls}-empty`
            }, locale.presetEmpty))
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: colorPresetsPrefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $87069059c399a8f7$export$2e2bcd8739ae039), {
        defaultActiveKey: activeKeys,
        ghost: true,
        items: items
    }));
};
var $d5221672d26ff0b4$export$2e2bcd8739ae039 = $d5221672d26ff0b4$var$ColorPresets;





const $528e850af07e6ac9$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize } = token;
    const buttonToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: 0,
        buttonIconOnlyFontSize: onlyIconSize
    });
    return buttonToken;
};
const $528e850af07e6ac9$export$9ca1be8807fe0675 = (token)=>{
    var _a, _b, _c, _d, _e, _f;
    const contentFontSize = (_a = token.contentFontSize) !== null && _a !== void 0 ? _a : token.fontSize;
    const contentFontSizeSM = (_b = token.contentFontSizeSM) !== null && _b !== void 0 ? _b : token.fontSize;
    const contentFontSizeLG = (_c = token.contentFontSizeLG) !== null && _c !== void 0 ? _c : token.fontSizeLG;
    const contentLineHeight = (_d = token.contentLineHeight) !== null && _d !== void 0 ? _d : (0, $239826517175299d$export$56204a27a2958a55)(contentFontSize);
    const contentLineHeightSM = (_e = token.contentLineHeightSM) !== null && _e !== void 0 ? _e : (0, $239826517175299d$export$56204a27a2958a55)(contentFontSizeSM);
    const contentLineHeightLG = (_f = token.contentLineHeightLG) !== null && _f !== void 0 ? _f : (0, $239826517175299d$export$56204a27a2958a55)(contentFontSizeLG);
    const solidTextColor = (0, $d5221672d26ff0b4$export$6341b37cb79161da)(new (0, $078cdd44fbbd27df$export$e8cc8a2e87e145b4)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    const shadowColorTokens = (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>Object.assign(Object.assign({}, prev), {
            [`${colorKey}ShadowColor`]: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.controlOutlineWidth)} 0 ${(0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(token[`${colorKey}1`], token.colorBgContainer)}`
        }), {});
    return Object.assign(Object.assign({}, shadowColorTokens), {
        fontWeight: 400,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorder,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: 'transparent',
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: 'inherit',
        onlyIconSizeSM: 'inherit',
        onlyIconSizeLG: 'inherit',
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: 'transparent',
        textTextColor: token.colorText,
        textTextHoverColor: token.colorText,
        textTextActiveColor: token.colorText,
        textHoverBg: token.colorFillTertiary,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        solidTextColor: solidTextColor,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG,
        contentLineHeight: contentLineHeight,
        contentLineHeightSM: contentLineHeightSM,
        contentLineHeightLG: contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0)
    });
};


// ============================== Shared ==============================
const $3fa444975abc8ac9$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight, opacityLoading: opacityLoading, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, marginXS: marginXS, calc: calc } = token;
    return {
        [componentCls]: {
            outline: 'none',
            position: 'relative',
            display: 'inline-flex',
            gap: token.marginXS,
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: fontWeight,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            backgroundImage: 'none',
            background: 'transparent',
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: 'none',
            touchAction: 'manipulation',
            color: token.colorText,
            '&:disabled > *': {
                pointerEvents: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/51380
            [`${componentCls}-icon > svg`]: (0, $4733a3b3eb18f80d$export$171ccda7bc085e59)(),
            '> a': {
                color: 'currentColor'
            },
            '&:not(:disabled)': (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: '-0.34em',
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-icon-only`]: {
                paddingInline: 0,
                // make `btn-icon-only` not too narrow
                [`&${componentCls}-compact-item`]: {
                    flex: 'none'
                },
                [`&${componentCls}-round`]: {
                    width: 'auto'
                }
            },
            // Loading
            [`&${componentCls}-loading`]: {
                opacity: opacityLoading,
                cursor: 'default'
            },
            [`${componentCls}-loading-icon`]: {
                transition: [
                    'width',
                    'opacity',
                    'margin'
                ].map((transition)=>`${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
            },
            // iconPosition
            [`&:not(${componentCls}-icon-end)`]: {
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineEnd: calc(marginXS).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineEnd: 0
                    },
                    '&-leave-start': {
                        marginInlineEnd: 0
                    },
                    '&-leave-active': {
                        marginInlineEnd: calc(marginXS).mul(-1).equal()
                    }
                }
            },
            '&-icon-end': {
                flexDirection: 'row-reverse',
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineStart: calc(marginXS).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineStart: 0
                    },
                    '&-leave-start': {
                        marginInlineStart: 0
                    },
                    '&-leave-active': {
                        marginInlineStart: calc(marginXS).mul(-1).equal()
                    }
                }
            }
        }
    };
};
const $3fa444975abc8ac9$var$genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle)=>({
        [`&:not(:disabled):not(${btnCls}-disabled)`]: {
            '&:hover': hoverStyle,
            '&:active': activeStyle
        }
    });
// ============================== Shape ===============================
const $3fa444975abc8ac9$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
        borderRadius: '50%'
    });
const $3fa444975abc8ac9$var$genRoundButtonStyle = (token)=>({
        borderRadius: token.controlHeight,
        paddingInlineStart: token.calc(token.controlHeight).div(2).equal(),
        paddingInlineEnd: token.calc(token.controlHeight).div(2).equal()
    });
const $3fa444975abc8ac9$var$genDisabledStyle = (token)=>({
        cursor: 'not-allowed',
        borderColor: token.borderColorDisabled,
        color: token.colorTextDisabled,
        background: token.colorBgContainerDisabled,
        boxShadow: 'none'
    });
const $3fa444975abc8ac9$var$genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle)=>({
        [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
            color: textColor || undefined,
            background: background,
            borderColor: borderColor || undefined,
            boxShadow: 'none'
        }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(btnCls, Object.assign({
            background: background
        }, hoverStyle), Object.assign({
            background: background
        }, activeStyle))), {
            '&:disabled': {
                cursor: 'not-allowed',
                color: textColorDisabled || undefined,
                borderColor: borderColorDisabled || undefined
            }
        })
    });
const $3fa444975abc8ac9$var$genSolidDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: Object.assign({}, $3fa444975abc8ac9$var$genDisabledStyle(token))
    });
const $3fa444975abc8ac9$var$genPureDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: {
            cursor: 'not-allowed',
            color: token.colorTextDisabled
        }
    });
// ============================== Variant =============================
const $3fa444975abc8ac9$var$genVariantButtonStyle = (token, hoverStyle, activeStyle, variant)=>{
    const isPureDisabled = variant && [
        'link',
        'text'
    ].includes(variant);
    const genDisabledButtonStyle = isPureDisabled ? $3fa444975abc8ac9$var$genPureDisabledButtonStyle : $3fa444975abc8ac9$var$genSolidDisabledButtonStyle;
    return Object.assign(Object.assign({}, genDisabledButtonStyle(token)), $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, hoverStyle, activeStyle));
};
const $3fa444975abc8ac9$var$genSolidButtonStyle = (token, textColor, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-solid`]: Object.assign({
            color: textColor,
            background: background
        }, $3fa444975abc8ac9$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $3fa444975abc8ac9$var$genOutlinedDashedButtonStyle = (token, borderColor, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-outlined, &${token.componentCls}-variant-dashed`]: Object.assign({
            borderColor: borderColor,
            background: background
        }, $3fa444975abc8ac9$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $3fa444975abc8ac9$var$genDashedButtonStyle = (token)=>({
        [`&${token.componentCls}-variant-dashed`]: {
            borderStyle: 'dashed'
        }
    });
const $3fa444975abc8ac9$var$genFilledButtonStyle = (token, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-filled`]: Object.assign({
            boxShadow: 'none',
            background: background
        }, $3fa444975abc8ac9$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $3fa444975abc8ac9$var$genTextLinkButtonStyle = (token, textColor, variant, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-${variant}`]: Object.assign({
            color: textColor,
            boxShadow: 'none'
        }, $3fa444975abc8ac9$var$genVariantButtonStyle(token, hoverStyle, activeStyle, variant))
    });
// =============================== Color ==============================
const $3fa444975abc8ac9$var$genPresetColorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const darkColor = token[`${colorKey}6`];
        const lightColor = token[`${colorKey}1`];
        const hoverColor = token[`${colorKey}5`];
        const lightHoverColor = token[`${colorKey}2`];
        const lightBorderColor = token[`${colorKey}3`];
        const activeColor = token[`${colorKey}7`];
        return Object.assign(Object.assign({}, prev), {
            [`&${componentCls}-color-${colorKey}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
                color: darkColor,
                boxShadow: token[`${colorKey}ShadowColor`]
            }, $3fa444975abc8ac9$var$genSolidButtonStyle(token, token.colorTextLightSolid, darkColor, {
                background: hoverColor
            }, {
                background: activeColor
            })), $3fa444975abc8ac9$var$genOutlinedDashedButtonStyle(token, darkColor, token.colorBgContainer, {
                color: hoverColor,
                borderColor: hoverColor,
                background: token.colorBgContainer
            }, {
                color: activeColor,
                borderColor: activeColor,
                background: token.colorBgContainer
            })), $3fa444975abc8ac9$var$genDashedButtonStyle(token)), $3fa444975abc8ac9$var$genFilledButtonStyle(token, lightColor, {
                background: lightHoverColor
            }, {
                background: lightBorderColor
            })), $3fa444975abc8ac9$var$genTextLinkButtonStyle(token, darkColor, 'link', {
                color: hoverColor
            }, {
                color: activeColor
            })), $3fa444975abc8ac9$var$genTextLinkButtonStyle(token, darkColor, 'text', {
                color: hoverColor,
                background: lightColor
            }, {
                color: activeColor,
                background: lightBorderColor
            }))
        });
    }, {});
};
const $3fa444975abc8ac9$var$genDefaultButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.defaultColor,
        boxShadow: token.defaultShadow
    }, $3fa444975abc8ac9$var$genSolidButtonStyle(token, token.solidTextColor, token.colorBgSolid, {
        color: token.solidTextColor,
        background: token.colorBgSolidHover
    }, {
        color: token.solidTextColor,
        background: token.colorBgSolidActive
    })), $3fa444975abc8ac9$var$genDashedButtonStyle(token)), $3fa444975abc8ac9$var$genFilledButtonStyle(token, token.colorFillTertiary, {
        background: token.colorFillSecondary
    }, {
        background: token.colorFill
    })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.defaultGhostColor, token.defaultGhostBorderColor, token.colorTextDisabled, token.colorBorder)), $3fa444975abc8ac9$var$genTextLinkButtonStyle(token, token.textTextColor, 'link', {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    }));
const $3fa444975abc8ac9$var$genPrimaryButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.colorPrimary,
        boxShadow: token.primaryShadow
    }, $3fa444975abc8ac9$var$genOutlinedDashedButtonStyle(token, token.colorPrimary, token.colorBgContainer, {
        color: token.colorPrimaryTextHover,
        borderColor: token.colorPrimaryHover,
        background: token.colorBgContainer
    }, {
        color: token.colorPrimaryTextActive,
        borderColor: token.colorPrimaryActive,
        background: token.colorBgContainer
    })), $3fa444975abc8ac9$var$genDashedButtonStyle(token)), $3fa444975abc8ac9$var$genFilledButtonStyle(token, token.colorPrimaryBg, {
        background: token.colorPrimaryBgHover
    }, {
        background: token.colorPrimaryBorder
    })), $3fa444975abc8ac9$var$genTextLinkButtonStyle(token, token.colorPrimaryText, 'text', {
        color: token.colorPrimaryTextHover,
        background: token.colorPrimaryBg
    }, {
        color: token.colorPrimaryTextActive,
        background: token.colorPrimaryBorder
    })), $3fa444975abc8ac9$var$genTextLinkButtonStyle(token, token.colorPrimaryText, 'link', {
        color: token.colorPrimaryTextHover,
        background: token.linkHoverBg
    }, {
        color: token.colorPrimaryTextActive
    })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorPrimary, token.colorPrimary, token.colorTextDisabled, token.colorBorder, {
        color: token.colorPrimaryHover,
        borderColor: token.colorPrimaryHover
    }, {
        color: token.colorPrimaryActive,
        borderColor: token.colorPrimaryActive
    }));
const $3fa444975abc8ac9$var$genDangerousStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.colorError,
        boxShadow: token.dangerShadow
    }, $3fa444975abc8ac9$var$genSolidButtonStyle(token, token.dangerColor, token.colorError, {
        background: token.colorErrorHover
    }, {
        background: token.colorErrorActive
    })), $3fa444975abc8ac9$var$genOutlinedDashedButtonStyle(token, token.colorError, token.colorBgContainer, {
        color: token.colorErrorHover,
        borderColor: token.colorErrorBorderHover
    }, {
        color: token.colorErrorActive,
        borderColor: token.colorErrorActive
    })), $3fa444975abc8ac9$var$genDashedButtonStyle(token)), $3fa444975abc8ac9$var$genFilledButtonStyle(token, token.colorErrorBg, {
        background: token.colorErrorBgFilledHover
    }, {
        background: token.colorErrorBgActive
    })), $3fa444975abc8ac9$var$genTextLinkButtonStyle(token, token.colorError, 'text', {
        color: token.colorErrorHover,
        background: token.colorErrorBg
    }, {
        color: token.colorErrorHover,
        background: token.colorErrorBgActive
    })), $3fa444975abc8ac9$var$genTextLinkButtonStyle(token, token.colorError, 'link', {
        color: token.colorErrorHover
    }, {
        color: token.colorErrorActive
    })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder, {
        color: token.colorErrorHover,
        borderColor: token.colorErrorHover
    }, {
        color: token.colorErrorActive,
        borderColor: token.colorErrorActive
    }));
const $3fa444975abc8ac9$var$genLinkStyle = (token)=>Object.assign(Object.assign({}, $3fa444975abc8ac9$var$genTextLinkButtonStyle(token, token.colorLink, 'link', {
        color: token.colorLinkHover
    }, {
        color: token.colorLinkActive
    })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorInfo, token.colorInfo, token.colorTextDisabled, token.colorBorder, {
        color: token.colorInfoHover,
        borderColor: token.colorInfoHover
    }, {
        color: token.colorInfoActive,
        borderColor: token.colorInfoActive
    }));
const $3fa444975abc8ac9$var$genColorButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return Object.assign({
        [`${componentCls}-color-default`]: $3fa444975abc8ac9$var$genDefaultButtonStyle(token),
        [`${componentCls}-color-primary`]: $3fa444975abc8ac9$var$genPrimaryButtonStyle(token),
        [`${componentCls}-color-dangerous`]: $3fa444975abc8ac9$var$genDangerousStyle(token),
        [`${componentCls}-color-link`]: $3fa444975abc8ac9$var$genLinkStyle(token)
    }, $3fa444975abc8ac9$var$genPresetColorStyle(token));
};
// =========== Compatible with versions earlier than 5.21.0 ===========
const $3fa444975abc8ac9$var$genCompatibleButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign({}, $3fa444975abc8ac9$var$genOutlinedDashedButtonStyle(token, token.defaultBorderColor, token.defaultBg, {
        color: token.defaultHoverColor,
        borderColor: token.defaultHoverBorderColor,
        background: token.defaultHoverBg
    }, {
        color: token.defaultActiveColor,
        borderColor: token.defaultActiveBorderColor,
        background: token.defaultActiveBg
    })), $3fa444975abc8ac9$var$genTextLinkButtonStyle(token, token.textTextColor, 'text', {
        color: token.textTextHoverColor,
        background: token.textHoverBg
    }, {
        color: token.textTextActiveColor,
        background: token.colorBgTextActive
    })), $3fa444975abc8ac9$var$genSolidButtonStyle(token, token.primaryColor, token.colorPrimary, {
        background: token.colorPrimaryHover,
        color: token.primaryColor
    }, {
        background: token.colorPrimaryActive,
        color: token.primaryColor
    })), $3fa444975abc8ac9$var$genTextLinkButtonStyle(token, token.colorLink, 'link', {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    }));
// =============================== Size ===============================
const $3fa444975abc8ac9$var$genButtonStyle = (token, prefixCls = '')=>{
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical, buttonIconOnlyFontSize: buttonIconOnlyFontSize } = token;
    return [
        {
            [prefixCls]: {
                fontSize: fontSize,
                height: controlHeight,
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(buttonPaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${componentCls}-icon-only`]: {
                    width: controlHeight,
                    [iconCls]: {
                        fontSize: buttonIconOnlyFontSize
                    }
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: $3fa444975abc8ac9$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: $3fa444975abc8ac9$var$genRoundButtonStyle(token)
        }
    ];
};
const $3fa444975abc8ac9$var$genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        fontSize: token.contentFontSize
    });
    return $3fa444975abc8ac9$var$genButtonStyle(baseToken, token.componentCls);
};
const $3fa444975abc8ac9$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $3fa444975abc8ac9$var$genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $3fa444975abc8ac9$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $3fa444975abc8ac9$var$genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $3fa444975abc8ac9$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: '100%'
            }
        }
    };
};
var // ============================== Export ==============================
$3fa444975abc8ac9$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Button', (token)=>{
    const buttonToken = (0, $528e850af07e6ac9$export$362fb92a8f81bbf9)(token);
    return [
        // Shared
        $3fa444975abc8ac9$var$genSharedButtonStyle(buttonToken),
        // Size
        $3fa444975abc8ac9$var$genSizeBaseButtonStyle(buttonToken),
        $3fa444975abc8ac9$var$genSizeSmallButtonStyle(buttonToken),
        $3fa444975abc8ac9$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $3fa444975abc8ac9$var$genBlockButtonStyle(buttonToken),
        // Color
        $3fa444975abc8ac9$var$genColorButtonStyle(buttonToken),
        // https://github.com/ant-design/ant-design/issues/50969
        $3fa444975abc8ac9$var$genCompatibleButtonStyle(buttonToken),
        // Button Group
        (0, $9b1a8aea1f437a60$export$2e2bcd8739ae039)(buttonToken)
    ];
}, (0, $528e850af07e6ac9$export$9ca1be8807fe0675), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});



function $6ef3f73594535ba5$var$compactItemVerticalBorder(token, parentCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        '&-item': {
            '&:hover,&:focus,&:active': {
                zIndex: 2
            },
            '&[disabled]': {
                zIndex: 0
            }
        }
    };
}
function $6ef3f73594535ba5$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $6ef3f73594535ba5$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $6ef3f73594535ba5$var$compactItemVerticalBorder(token, compactCls)), $6ef3f73594535ba5$var$compactItemBorderVerticalRadius(token.componentCls, compactCls))
    };
}




const $3971683be64d7459$var$genButtonCompactStyle = (token)=>{
    const { componentCls: componentCls, colorPrimaryHover: colorPrimaryHover, lineWidth: lineWidth, calc: calc } = token;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const getCompactBorderStyle = (vertical)=>{
        const selector = `${componentCls}-compact${vertical ? '-vertical' : ''}-item${componentCls}-primary:not([disabled])`;
        return {
            [`${selector} + ${selector}::before`]: {
                position: 'absolute',
                top: vertical ? insetOffset : 0,
                insetInlineStart: vertical ? 0 : insetOffset,
                backgroundColor: colorPrimaryHover,
                content: '""',
                width: vertical ? '100%' : lineWidth,
                height: vertical ? lineWidth : '100%'
            }
        };
    };
    // Special styles for Primary Button
    return Object.assign(Object.assign({}, getCompactBorderStyle()), getCompactBorderStyle(true));
};
var // ============================== Export ==============================
$3971683be64d7459$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$1537386bc155ea56)([
    'Button',
    'compact'
], (token)=>{
    const buttonToken = (0, $528e850af07e6ac9$export$362fb92a8f81bbf9)(token);
    return [
        // Space Compact
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(buttonToken),
        (0, $6ef3f73594535ba5$export$4dc87cb8ebf78ac6)(buttonToken),
        $3971683be64d7459$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $528e850af07e6ac9$export$9ca1be8807fe0675));


"use client";
var $c6609c7ee777e096$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $c6609c7ee777e096$var$getLoadingConfig(loading) {
    if (typeof loading === 'object' && loading) {
        let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
        delay = !Number.isNaN(delay) && typeof delay === 'number' ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $c6609c7ee777e096$var$ButtonTypeMap = {
    default: [
        'default',
        'outlined'
    ],
    primary: [
        'primary',
        'solid'
    ],
    dashed: [
        'default',
        'dashed'
    ],
    // `link` is not a real color but we should compatible with it
    link: [
        'link',
        'link'
    ],
    text: [
        'default',
        'text'
    ]
};
const $c6609c7ee777e096$var$InternalCompoundedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    var _a, _b;
    const { loading: loading = false, prefixCls: customizePrefixCls, color: color, variant: variant, type: type, danger: danger = false, shape: shape = 'default', size: customizeSize, styles: styles, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, iconPosition: iconPosition = 'start', ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = 'button', classNames: customClassNames, style: customStyle = {}, autoInsertSpace: autoInsertSpace, autoFocus: autoFocus } = props, rest = $c6609c7ee777e096$var$__rest(props, [
        "loading",
        "prefixCls",
        "color",
        "variant",
        "type",
        "danger",
        "shape",
        "size",
        "styles",
        "disabled",
        "className",
        "rootClassName",
        "children",
        "icon",
        "iconPosition",
        "ghost",
        "block",
        "htmlType",
        "classNames",
        "style",
        "autoInsertSpace",
        "autoFocus"
    ]);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || 'default';
    const { button: button } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [mergedColor, mergedVariant] = (0, $acw62.useMemo)(()=>{
        // >>>>> Local
        // Color & Variant
        if (color && variant) return [
            color,
            variant
        ];
        // Sugar syntax
        if (type || danger) {
            const colorVariantPair = $c6609c7ee777e096$var$ButtonTypeMap[mergedType] || [];
            if (danger) return [
                'danger',
                colorVariantPair[1]
            ];
            return colorVariantPair;
        }
        // >>> Context fallback
        if ((button === null || button === void 0 ? void 0 : button.color) && (button === null || button === void 0 ? void 0 : button.variant)) return [
            button.color,
            button.variant
        ];
        return [
            'default',
            'outlined'
        ];
    }, [
        type,
        color,
        variant,
        danger,
        button === null || button === void 0 ? void 0 : button.variant,
        button === null || button === void 0 ? void 0 : button.color
    ]);
    const isDanger = mergedColor === 'danger';
    const mergedColorText = isDanger ? 'dangerous' : mergedColor;
    const { getPrefixCls: getPrefixCls, direction: direction, autoInsertSpace: contextAutoInsertSpace, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('button');
    const mergedInsertSpace = (_a = autoInsertSpace !== null && autoInsertSpace !== void 0 ? autoInsertSpace : contextAutoInsertSpace) !== null && _a !== void 0 ? _a : true;
    const prefixCls = getPrefixCls('btn', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3fa444975abc8ac9$export$2e2bcd8739ae039)(prefixCls);
    const disabled = (0, $acw62.useContext)((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const groupSize = (0, $acw62.useContext)((0, $981d7d04085c8929$export$ed0cc8bd1f617d6d));
    const loadingOrDelay = (0, $acw62.useMemo)(()=>$c6609c7ee777e096$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setLoading] = (0, $acw62.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $acw62.useState)(false);
    const buttonRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $f1965a9a7a1fe067$export$1d1c999670a1285d)(ref, buttonRef);
    const needInserted = (0, $acw62.Children).count(children) === 1 && !icon && !(0, $891d27b465b97c91$export$b120bc11c0d9c214)(mergedVariant);
    // ========================= Mount ==========================
    // Record for mount status.
    // This will help to no to show the animation of loading on the first mount.
    const isMountRef = (0, $acw62.useRef)(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        isMountRef.current = false;
        return ()=>{
            isMountRef.current = true;
        };
    }, []);
    // ========================= Effect =========================
    // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
    // https://github.com/ant-design/ant-design/issues/51325
    (0, $acw62.useLayoutEffect)(()=>{
        let delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(()=>{
            delayTimer = null;
            setLoading(true);
        }, loadingOrDelay.delay);
        else setLoading(loadingOrDelay.loading);
        function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        return cleanupTimer;
    }, [
        loadingOrDelay.delay,
        loadingOrDelay.loading
    ]);
    // Two chinese characters check
    (0, $acw62.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent || '';
        if (needInserted && (0, $891d27b465b97c91$export$c5dca2bf412dea0d)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    });
    // Auto focus
    (0, $acw62.useEffect)(()=>{
        if (autoFocus && buttonRef.current) buttonRef.current.focus();
    }, []);
    // ========================= Events =========================
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        var _a;
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        (_a = props.onClick) === null || _a === void 0 || _a.call(props, 'href' in props ? e : e);
    }, [
        props.onClick,
        innerLoading,
        mergedDisabled
    ]);
    // ========================== Size ==========================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const sizeClassNameMap = {
        large: 'lg',
        small: 'sm',
        middle: undefined
    };
    const sizeFullName = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctxSize)=>{
        var _a, _b;
        return (_b = (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : groupSize) !== null && _b !== void 0 ? _b : ctxSize;
    });
    const sizeCls = sizeFullName ? (_b = sizeClassNameMap[sizeFullName]) !== null && _b !== void 0 ? _b : '' : '';
    const iconType = innerLoading ? 'loading' : icon;
    const linkButtonRestProps = (0, $57c22a5a2f343bca$export$2e2bcd8739ae039)(rest, [
        'navigate'
    ]);
    // ========================= Render =========================
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${shape}`]: shape !== 'default' && shape,
        // Compatible with versions earlier than 5.21.0
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
        [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $891d27b465b97c91$export$b120bc11c0d9c214)(mergedVariant),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-icon-end`]: iconPosition === 'end'
    }, compactItemClassnames, className, rootClassName, contextClassName);
    const fullStyle = Object.assign(Object.assign({}, contextStyle), customStyle);
    const iconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, contextClassNames.icon);
    const iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), contextStyles.icon || {});
    const iconNode = icon && !innerLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19bf9f13d1d4a6e4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: iconClasses,
        style: iconStyle
    }, icon) : loading && typeof loading === 'object' && loading.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19bf9f13d1d4a6e4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: iconClasses,
        style: iconStyle
    }, loading.icon) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bfeeb2467aaa0581$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: innerLoading,
        mount: isMountRef.current
    });
    const kids = children || children === 0 ? (0, $891d27b465b97c91$export$b6ee00a7e7908bc)(children, needInserted && mergedInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({}, linkButtonRestProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0
    }), iconNode, kids));
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, rest, {
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: mergedRef
    }), iconNode, kids, compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3971683be64d7459$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
    if (!(0, $891d27b465b97c91$export$b120bc11c0d9c214)(mergedVariant)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37e027257ee01609$export$2e2bcd8739ae039), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return wrapCSSVar(buttonNode);
});
const $c6609c7ee777e096$var$Button = $c6609c7ee777e096$var$InternalCompoundedButton;
$c6609c7ee777e096$var$Button.Group = (0, $981d7d04085c8929$export$2e2bcd8739ae039);
$c6609c7ee777e096$var$Button.__ANT_BUTTON = true;
var $c6609c7ee777e096$export$2e2bcd8739ae039 = $c6609c7ee777e096$var$Button;



"use client";
var $3929aafb948ac62c$export$2e2bcd8739ae039 = (0, $c6609c7ee777e096$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");







// ============================== Size ================================
const $798d9db240249fbb$var$genSizeDividerStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-horizontal': {
                [`&${componentCls}`]: {
                    '&-sm': {
                        marginBlock: token.marginXS
                    },
                    '&-md': {
                        marginBlock: token.margin
                    }
                }
            }
        }
    };
};
// ============================== Shared ==============================
const $798d9db240249fbb$var$genSharedDividerStyle = (token)=>{
    const { componentCls: componentCls, sizePaddingEdgeHorizontal: sizePaddingEdgeHorizontal, colorSplit: colorSplit, lineWidth: lineWidth, textPaddingInline: textPaddingInline, orientationMargin: orientationMargin, verticalMarginInline: verticalMarginInline } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            borderBlockStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} solid ${colorSplit}`,
            // vertical
            '&-vertical': {
                position: 'relative',
                top: '-0.06em',
                display: 'inline-block',
                height: '0.9em',
                marginInline: verticalMarginInline,
                marginBlock: 0,
                verticalAlign: 'middle',
                borderTop: 0,
                borderInlineStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} solid ${colorSplit}`
            },
            '&-horizontal': {
                display: 'flex',
                clear: 'both',
                width: '100%',
                minWidth: '100%',
                // Fix https://github.com/ant-design/ant-design/issues/10914
                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginLG)} 0`
            },
            [`&-horizontal${componentCls}-with-text`]: {
                display: 'flex',
                alignItems: 'center',
                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.dividerHorizontalWithTextGutterMargin)} 0`,
                color: token.colorTextHeading,
                fontWeight: 500,
                fontSize: token.fontSizeLG,
                whiteSpace: 'nowrap',
                textAlign: 'center',
                borderBlockStart: `0 ${colorSplit}`,
                '&::before, &::after': {
                    position: 'relative',
                    width: '50%',
                    borderBlockStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} solid transparent`,
                    // Chrome not accept `inherit` in `border-top`
                    borderBlockStartColor: 'inherit',
                    borderBlockEnd: 0,
                    transform: 'translateY(50%)',
                    content: "''"
                }
            },
            [`&-horizontal${componentCls}-with-text-start`]: {
                '&::before': {
                    width: `calc(${orientationMargin} * 100%)`
                },
                '&::after': {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                }
            },
            [`&-horizontal${componentCls}-with-text-end`]: {
                '&::before': {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                },
                '&::after': {
                    width: `calc(${orientationMargin} * 100%)`
                }
            },
            [`${componentCls}-inner-text`]: {
                display: 'inline-block',
                paddingBlock: 0,
                paddingInline: textPaddingInline
            },
            '&-dashed': {
                background: 'none',
                borderColor: colorSplit,
                borderStyle: 'dashed',
                borderWidth: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} 0 0`
            },
            [`&-horizontal${componentCls}-with-text${componentCls}-dashed`]: {
                '&::before, &::after': {
                    borderStyle: 'dashed none none'
                }
            },
            [`&-vertical${componentCls}-dashed`]: {
                borderInlineStartWidth: lineWidth,
                borderInlineEnd: 0,
                borderBlockStart: 0,
                borderBlockEnd: 0
            },
            '&-dotted': {
                background: 'none',
                borderColor: colorSplit,
                borderStyle: 'dotted',
                borderWidth: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} 0 0`
            },
            [`&-horizontal${componentCls}-with-text${componentCls}-dotted`]: {
                '&::before, &::after': {
                    borderStyle: 'dotted none none'
                }
            },
            [`&-vertical${componentCls}-dotted`]: {
                borderInlineStartWidth: lineWidth,
                borderInlineEnd: 0,
                borderBlockStart: 0,
                borderBlockEnd: 0
            },
            [`&-plain${componentCls}-with-text`]: {
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.fontSize
            },
            [`&-horizontal${componentCls}-with-text-start${componentCls}-no-default-orientation-margin-start`]: {
                '&::before': {
                    width: 0
                },
                '&::after': {
                    width: '100%'
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineStart: sizePaddingEdgeHorizontal
                }
            },
            [`&-horizontal${componentCls}-with-text-end${componentCls}-no-default-orientation-margin-end`]: {
                '&::before': {
                    width: '100%'
                },
                '&::after': {
                    width: 0
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineEnd: sizePaddingEdgeHorizontal
                }
            }
        })
    };
};
const $798d9db240249fbb$export$9ca1be8807fe0675 = (token)=>({
        textPaddingInline: '1em',
        orientationMargin: 0.05,
        verticalMarginInline: token.marginXS
    });
var // ============================== Export ==============================
$798d9db240249fbb$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Divider', (token)=>{
    const dividerToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        dividerHorizontalWithTextGutterMargin: token.margin,
        sizePaddingEdgeHorizontal: 0
    });
    return [
        $798d9db240249fbb$var$genSharedDividerStyle(dividerToken),
        $798d9db240249fbb$var$genSizeDividerStyle(dividerToken)
    ];
}, $798d9db240249fbb$export$9ca1be8807fe0675, {
    unitless: {
        orientationMargin: true
    }
});


"use client";
var $4728a501f42302e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4728a501f42302e5$var$sizeClassNameMap = {
    small: 'sm',
    middle: 'md'
};
const $4728a501f42302e5$var$Divider = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, className: dividerClassName, style: dividerStyle } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('divider');
    const { prefixCls: customizePrefixCls, type: type = 'horizontal', orientation: orientation = 'center', orientationMargin: orientationMargin, className: className, rootClassName: rootClassName, children: children, dashed: dashed, variant: variant = 'solid', plain: plain, style: style, size: customSize } = props, restProps = $4728a501f42302e5$var$__rest(props, [
        "prefixCls",
        "type",
        "orientation",
        "orientationMargin",
        "className",
        "rootClassName",
        "children",
        "dashed",
        "variant",
        "plain",
        "style",
        "size"
    ]);
    const prefixCls = getPrefixCls('divider', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $798d9db240249fbb$export$2e2bcd8739ae039)(prefixCls);
    const sizeFullName = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customSize);
    const sizeCls = $4728a501f42302e5$var$sizeClassNameMap[sizeFullName];
    const hasChildren = !!children;
    const mergedOrientation = $acw62.useMemo(()=>{
        if (orientation === 'left') return direction === 'rtl' ? 'end' : 'start';
        if (orientation === 'right') return direction === 'rtl' ? 'start' : 'end';
        return orientation;
    }, [
        direction,
        orientation
    ]);
    const hasMarginStart = mergedOrientation === 'start' && orientationMargin != null;
    const hasMarginEnd = mergedOrientation === 'end' && orientationMargin != null;
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, dividerClassName, hashId, cssVarCls, `${prefixCls}-${type}`, {
        [`${prefixCls}-with-text`]: hasChildren,
        [`${prefixCls}-with-text-${mergedOrientation}`]: hasChildren,
        [`${prefixCls}-dashed`]: !!dashed,
        [`${prefixCls}-${variant}`]: variant !== 'solid',
        [`${prefixCls}-plain`]: !!plain,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-no-default-orientation-margin-start`]: hasMarginStart,
        [`${prefixCls}-no-default-orientation-margin-end`]: hasMarginEnd,
        [`${prefixCls}-${sizeCls}`]: !!sizeCls
    }, className, rootClassName);
    const memoizedOrientationMargin = $acw62.useMemo(()=>{
        if (typeof orientationMargin === 'number') return orientationMargin;
        if (/^\d+$/.test(orientationMargin)) return Number(orientationMargin);
        return orientationMargin;
    }, [
        orientationMargin
    ]);
    const innerStyle = {
        marginInlineStart: hasMarginStart ? memoizedOrientationMargin : undefined,
        marginInlineEnd: hasMarginEnd ? memoizedOrientationMargin : undefined
    };
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        className: classString,
        style: Object.assign(Object.assign({}, dividerStyle), style)
    }, restProps, {
        role: "separator"
    }), children && type !== 'vertical' && /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-inner-text`,
        style: innerStyle
    }, children)));
};
var $4728a501f42302e5$export$2e2bcd8739ae039 = $4728a501f42302e5$var$Divider;





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
function $9ffe1c2756854ba4$export$2e2bcd8739ae039(value) {
    const [cacheValue, setCacheValue] = $acw62.useState(value);
    $acw62.useEffect(()=>{
        const timeout = setTimeout(()=>{
            setCacheValue(value);
        }, value.length ? 0 : 10);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        value
    ]);
    return cacheValue;
}






const $b632032085440de2$var$genFormValidateMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const helpCls = `${componentCls}-show-help`;
    const helpItemCls = `${componentCls}-show-help-item`;
    return {
        [helpCls]: {
            // Explain holder
            transition: `opacity ${token.motionDurationFast} ${token.motionEaseInOut}`,
            '&-appear, &-enter': {
                opacity: 0,
                '&-active': {
                    opacity: 1
                }
            },
            '&-leave': {
                opacity: 1,
                '&-active': {
                    opacity: 0
                }
            },
            // Explain
            [helpItemCls]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationFast} ${token.motionEaseInOut},
                     opacity ${token.motionDurationFast} ${token.motionEaseInOut},
                     transform ${token.motionDurationFast} ${token.motionEaseInOut} !important`,
                [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
                    transform: `translateY(-5px)`,
                    opacity: 0,
                    '&-active': {
                        transform: 'translateY(0)',
                        opacity: 1
                    }
                },
                [`&${helpItemCls}-leave-active`]: {
                    transform: `translateY(-5px)`
                }
            }
        }
    };
};
var $b632032085440de2$export$2e2bcd8739ae039 = $b632032085440de2$var$genFormValidateMotionStyle;


const $3f17b93d805dc813$var$resetForm = (token)=>({
        legend: {
            display: 'block',
            width: '100%',
            marginBottom: token.marginLG,
            padding: 0,
            color: token.colorTextDescription,
            fontSize: token.fontSizeLG,
            lineHeight: 'inherit',
            border: 0,
            borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        'input[type="search"]': {
            boxSizing: 'border-box'
        },
        // Position radios and checkboxes better
        'input[type="radio"], input[type="checkbox"]': {
            lineHeight: 'normal'
        },
        'input[type="file"]': {
            display: 'block'
        },
        // Make range inputs behave like textual form controls
        'input[type="range"]': {
            display: 'block',
            width: '100%'
        },
        // Make multiple select elements height not fixed
        'select[multiple], select[size]': {
            height: 'auto'
        },
        // Focus for file, radio, and checkbox
        [`input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus`]: {
            outline: 0,
            boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
        },
        // Adjust output element
        output: {
            display: 'block',
            paddingTop: 15,
            color: token.colorText,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight
        }
    });
const $3f17b93d805dc813$var$genFormSize = (token, height)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [formItemCls]: {
            [`${formItemCls}-label > label`]: {
                height: height
            },
            [`${formItemCls}-control-input`]: {
                minHeight: height
            }
        }
    };
};
const $3f17b93d805dc813$var$genFormStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [token.componentCls]: Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), $3f17b93d805dc813$var$resetForm(token)), {
            [`${componentCls}-text`]: {
                display: 'inline-block',
                paddingInlineEnd: token.paddingSM
            },
            // ================================================================
            // =                             Size                             =
            // ================================================================
            '&-small': Object.assign({}, $3f17b93d805dc813$var$genFormSize(token, token.controlHeightSM)),
            '&-large': Object.assign({}, $3f17b93d805dc813$var$genFormSize(token, token.controlHeightLG))
        })
    };
};
const $3f17b93d805dc813$var$genFormItemStyle = (token)=>{
    const { formItemCls: formItemCls, iconCls: iconCls, rootPrefixCls: rootPrefixCls, antCls: antCls, labelRequiredMarkColor: labelRequiredMarkColor, labelColor: labelColor, labelFontSize: labelFontSize, labelHeight: labelHeight, labelColonMarginInlineStart: labelColonMarginInlineStart, labelColonMarginInlineEnd: labelColonMarginInlineEnd, itemMarginBottom: itemMarginBottom } = token;
    return {
        [formItemCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            marginBottom: itemMarginBottom,
            verticalAlign: 'top',
            '&-with-help': {
                transition: 'none'
            },
            [`&-hidden,
        &-hidden${antCls}-row`]: {
                // https://github.com/ant-design/ant-design/issues/26141
                display: 'none'
            },
            '&-has-warning': {
                [`${formItemCls}-split`]: {
                    color: token.colorError
                }
            },
            '&-has-error': {
                [`${formItemCls}-split`]: {
                    color: token.colorWarning
                }
            },
            // ==============================================================
            // =                            Label                           =
            // ==============================================================
            [`${formItemCls}-label`]: {
                flexGrow: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textAlign: 'end',
                verticalAlign: 'middle',
                '&-left': {
                    textAlign: 'start'
                },
                '&-wrap': {
                    overflow: 'unset',
                    lineHeight: token.lineHeight,
                    whiteSpace: 'unset',
                    '> label': {
                        verticalAlign: 'middle',
                        textWrap: 'balance'
                    }
                },
                '> label': {
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    maxWidth: '100%',
                    height: labelHeight,
                    color: labelColor,
                    fontSize: labelFontSize,
                    [`> ${iconCls}`]: {
                        fontSize: token.fontSize,
                        verticalAlign: 'top'
                    },
                    [`&${formItemCls}-required`]: {
                        '&::before': {
                            display: 'inline-block',
                            marginInlineEnd: token.marginXXS,
                            color: labelRequiredMarkColor,
                            fontSize: token.fontSize,
                            fontFamily: 'SimSun, sans-serif',
                            lineHeight: 1,
                            content: '"*"'
                        },
                        [`&${formItemCls}-required-mark-hidden, &${formItemCls}-required-mark-optional`]: {
                            '&::before': {
                                display: 'none'
                            }
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-optional`]: {
                        display: 'inline-block',
                        marginInlineStart: token.marginXXS,
                        color: token.colorTextDescription,
                        [`&${formItemCls}-required-mark-hidden`]: {
                            display: 'none'
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-tooltip`]: {
                        color: token.colorTextDescription,
                        cursor: 'help',
                        writingMode: 'horizontal-tb',
                        marginInlineStart: token.marginXXS
                    },
                    '&::after': {
                        content: '":"',
                        position: 'relative',
                        marginBlock: 0,
                        marginInlineStart: labelColonMarginInlineStart,
                        marginInlineEnd: labelColonMarginInlineEnd
                    },
                    [`&${formItemCls}-no-colon::after`]: {
                        content: '"\\a0"'
                    }
                }
            },
            // ==============================================================
            // =                            Input                           =
            // ==============================================================
            [`${formItemCls}-control`]: {
                ['--ant-display']: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
                    width: '100%'
                },
                '&-input': {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: token.controlHeight,
                    '&-content': {
                        flex: 'auto',
                        maxWidth: '100%',
                        // Fix https://github.com/ant-design/ant-design/issues/54042
                        // Remove impact of whitespaces
                        [`&:has(> ${antCls}-switch:only-child, > ${antCls}-rate:only-child)`]: {
                            display: 'flex',
                            alignItems: 'center'
                        }
                    }
                }
            },
            // ==============================================================
            // =                           Explain                          =
            // ==============================================================
            [formItemCls]: {
                '&-additional': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                '&-explain, &-extra': {
                    clear: 'both',
                    color: token.colorTextDescription,
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight
                },
                '&-explain-connected': {
                    width: '100%'
                },
                '&-extra': {
                    minHeight: token.controlHeightSM,
                    transition: `color ${token.motionDurationMid} ${token.motionEaseOut}` // sync input color transition
                },
                '&-explain': {
                    '&-error': {
                        color: token.colorError
                    },
                    '&-warning': {
                        color: token.colorWarning
                    }
                }
            },
            [`&-with-help ${formItemCls}-explain`]: {
                height: 'auto',
                opacity: 1
            },
            // ==============================================================
            // =                        Feedback Icon                       =
            // ==============================================================
            [`${formItemCls}-feedback-icon`]: {
                fontSize: token.fontSize,
                textAlign: 'center',
                visibility: 'visible',
                animationName: (0, $d2082114d5952afb$export$3b71758b3ed5255f),
                animationDuration: token.motionDurationMid,
                animationTimingFunction: token.motionEaseOutBack,
                pointerEvents: 'none',
                '&-success': {
                    color: token.colorSuccess
                },
                '&-error': {
                    color: token.colorError
                },
                '&-warning': {
                    color: token.colorWarning
                },
                '&-validating': {
                    color: token.colorPrimary
                }
            }
        })
    };
};
const $3f17b93d805dc813$var$genHorizontalStyle = (token, className)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [`${className}-horizontal`]: {
            [`${formItemCls}-label`]: {
                flexGrow: 0
            },
            [`${formItemCls}-control`]: {
                flex: '1 1 0',
                // https://github.com/ant-design/ant-design/issues/32777
                // https://github.com/ant-design/ant-design/issues/33773
                minWidth: 0
            },
            // Do not change this to `ant-col-24`! `-24` match all the responsive rules
            // https://github.com/ant-design/ant-design/issues/32980
            // https://github.com/ant-design/ant-design/issues/34903
            // https://github.com/ant-design/ant-design/issues/44538
            [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
                [`& + ${formItemCls}-control`]: {
                    minWidth: 'unset'
                }
            }
        }
    };
};
const $3f17b93d805dc813$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, inlineItemMarginBottom: inlineItemMarginBottom } = token;
    return {
        [`${componentCls}-inline`]: {
            display: 'flex',
            flexWrap: 'wrap',
            [formItemCls]: {
                flex: 'none',
                marginInlineEnd: token.margin,
                marginBottom: inlineItemMarginBottom,
                '&-row': {
                    flexWrap: 'nowrap'
                },
                [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
                    display: 'inline-block',
                    verticalAlign: 'top'
                },
                [`> ${formItemCls}-label`]: {
                    flex: 'none'
                },
                [`${componentCls}-text`]: {
                    display: 'inline-block'
                },
                [`${formItemCls}-has-feedback`]: {
                    display: 'inline-block'
                }
            }
        }
    };
};
const $3f17b93d805dc813$var$makeVerticalLayoutLabel = (token)=>({
        padding: token.verticalLabelPadding,
        margin: token.verticalLabelMargin,
        whiteSpace: 'initial',
        textAlign: 'start',
        '> label': {
            margin: 0,
            '&::after': {
                // https://github.com/ant-design/ant-design/issues/43538
                visibility: 'hidden'
            }
        }
    });
const $3f17b93d805dc813$var$makeVerticalLayout = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, rootPrefixCls: rootPrefixCls } = token;
    return {
        [`${formItemCls} ${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token),
        // ref: https://github.com/ant-design/ant-design/issues/45122
        [`${componentCls}:not(${componentCls}-inline)`]: {
            [formItemCls]: {
                flexWrap: 'wrap',
                [`${formItemCls}-label, ${formItemCls}-control`]: {
                    // When developer pass `xs: { span }`,
                    // It should follow the `xs` screen config
                    // ref: https://github.com/ant-design/ant-design/issues/44386
                    [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
                        flex: '0 0 100%',
                        maxWidth: '100%'
                    }
                }
            }
        }
    };
};
const $3f17b93d805dc813$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${componentCls}-vertical`]: {
            [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                [`${formItemCls}-row`]: {
                    flexDirection: 'column'
                },
                [`${formItemCls}-label > label`]: {
                    height: 'auto'
                },
                [`${formItemCls}-control`]: {
                    width: '100%'
                },
                [`${formItemCls}-label,
        ${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenXSMax)})`]: [
            $3f17b93d805dc813$var$makeVerticalLayout(token),
            {
                [componentCls]: {
                    [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                        [`${antCls}-col-xs-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
                    }
                }
            }
        ],
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenSMMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-sm-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenMDMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-md-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenLGMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-lg-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
                }
            }
        }
    };
};
const $3f17b93d805dc813$var$genItemVerticalStyle = (token)=>{
    const { formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${formItemCls}-vertical`]: {
            [`${formItemCls}-row`]: {
                flexDirection: 'column'
            },
            [`${formItemCls}-label > label`]: {
                height: 'auto'
            },
            [`${formItemCls}-control`]: {
                width: '100%'
            }
        },
        [`${formItemCls}-vertical ${formItemCls}-label,
      ${antCls}-col-24${formItemCls}-label,
      ${antCls}-col-xl-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token),
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenXSMax)})`]: [
            $3f17b93d805dc813$var$makeVerticalLayout(token),
            {
                [formItemCls]: {
                    [`${antCls}-col-xs-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
                }
            }
        ],
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenSMMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-sm-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenMDMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-md-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenLGMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-lg-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
            }
        }
    };
};
const $3f17b93d805dc813$export$9ca1be8807fe0675 = (token)=>({
        labelRequiredMarkColor: token.colorError,
        labelColor: token.colorTextHeading,
        labelFontSize: token.fontSize,
        labelHeight: token.controlHeight,
        labelColonMarginInlineStart: token.marginXXS / 2,
        labelColonMarginInlineEnd: token.marginXS,
        itemMarginBottom: token.marginLG,
        verticalLabelPadding: `0 0 ${token.paddingXS}px`,
        verticalLabelMargin: 0,
        inlineItemMarginBottom: 0
    });
const $3f17b93d805dc813$export$362fb92a8f81bbf9 = (token, rootPrefixCls)=>{
    const formToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        formItemCls: `${token.componentCls}-item`,
        rootPrefixCls: rootPrefixCls
    });
    return formToken;
};
var $3f17b93d805dc813$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Form', (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = $3f17b93d805dc813$export$362fb92a8f81bbf9(token, rootPrefixCls);
    return [
        $3f17b93d805dc813$var$genFormStyle(formToken),
        $3f17b93d805dc813$var$genFormItemStyle(formToken),
        (0, $b632032085440de2$export$2e2bcd8739ae039)(formToken),
        $3f17b93d805dc813$var$genHorizontalStyle(formToken, formToken.componentCls),
        $3f17b93d805dc813$var$genHorizontalStyle(formToken, formToken.formItemCls),
        $3f17b93d805dc813$var$genInlineStyle(formToken),
        $3f17b93d805dc813$var$genVerticalStyle(formToken),
        $3f17b93d805dc813$var$genItemVerticalStyle(formToken),
        (0, $8eae2cab6b8e600b$export$2e2bcd8739ae039)(formToken),
        (0, $d2082114d5952afb$export$3b71758b3ed5255f)
    ];
}, $3f17b93d805dc813$export$9ca1be8807fe0675, {
    // Let From style before the Grid
    // ref https://github.com/ant-design/ant-design/issues/44386
    order: -1000
});


"use client";
const $2cd7502dce089e1a$var$EMPTY_LIST = [];
function $2cd7502dce089e1a$var$toErrorEntity(error, prefix, errorStatus, index = 0) {
    return {
        key: typeof error === 'string' ? error : `${prefix}-${index}`,
        error: error,
        errorStatus: errorStatus
    };
}
const $2cd7502dce089e1a$var$ErrorList = ({ help: help, helpStatus: helpStatus, errors: errors = $2cd7502dce089e1a$var$EMPTY_LIST, warnings: warnings = $2cd7502dce089e1a$var$EMPTY_LIST, className: rootClassName, fieldId: fieldId, onVisibleChanged: onVisibleChanged })=>{
    const { prefixCls: prefixCls } = $acw62.useContext((0, $ad5d550b51ac8abd$export$fb6582d3042cc879));
    const baseClassName = `${prefixCls}-item-explain`;
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3f17b93d805dc813$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const collapseMotion = $acw62.useMemo(()=>(0, $2efb522a5615f01e$export$2e2bcd8739ae039)(prefixCls), [
        prefixCls
    ]);
    // We have to debounce here again since somewhere use ErrorList directly still need no shaking
    // ref: https://github.com/ant-design/ant-design/issues/36336
    const debounceErrors = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(warnings);
    const fullKeyList = $acw62.useMemo(()=>{
        if (help !== undefined && help !== null) return [
            $2cd7502dce089e1a$var$toErrorEntity(help, 'help', helpStatus)
        ];
        return [].concat((0, $df4024303de6487a$export$2e2bcd8739ae039)(debounceErrors.map((error, index)=>$2cd7502dce089e1a$var$toErrorEntity(error, 'error', 'error', index))), (0, $df4024303de6487a$export$2e2bcd8739ae039)(debounceWarnings.map((warning, index)=>$2cd7502dce089e1a$var$toErrorEntity(warning, 'warning', 'warning', index))));
    }, [
        help,
        helpStatus,
        debounceErrors,
        debounceWarnings
    ]);
    const filledKeyFullKeyList = $acw62.useMemo(()=>{
        const keysCount = {};
        fullKeyList.forEach(({ key: key })=>{
            keysCount[key] = (keysCount[key] || 0) + 1;
        });
        return fullKeyList.map((entity, index)=>Object.assign(Object.assign({}, entity), {
                key: keysCount[entity.key] > 1 ? `${entity.key}-fallback-${index}` : entity.key
            }));
    }, [
        fullKeyList
    ]);
    const helpProps = {};
    if (fieldId) helpProps.id = `${fieldId}_help`;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $d222a6d97472f88c$export$2e2bcd8739ae039), {
        motionDeadline: collapseMotion.motionDeadline,
        motionName: `${prefixCls}-show-help`,
        visible: !!filledKeyFullKeyList.length,
        onVisibleChanged: onVisibleChanged
    }, (holderProps)=>{
        const { className: holderClassName, style: holderStyle } = holderProps;
        return /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, helpProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(baseClassName, holderClassName, cssVarCls, rootCls, rootClassName, hashId),
            style: holderStyle
        }), /*#__PURE__*/ $acw62.createElement((0, $f36605d1ab9f0a14$export$2e2bcd8739ae039), Object.assign({
            keys: filledKeyFullKeyList
        }, (0, $2efb522a5615f01e$export$2e2bcd8739ae039)(prefixCls), {
            motionName: `${prefixCls}-show-help-item`,
            component: false
        }), (itemProps)=>{
            const { key: key, error: error, errorStatus: errorStatus, className: itemClassName, style: itemStyle } = itemProps;
            return /*#__PURE__*/ $acw62.createElement("div", {
                key: key,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(itemClassName, {
                    [`${baseClassName}-${errorStatus}`]: errorStatus
                }),
                style: itemStyle
            }, error);
        }));
    }));
};
var $2cd7502dce089e1a$export$2e2bcd8739ae039 = $2cd7502dce089e1a$var$ErrorList;



var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $2c7da924f0cbe5bd$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $2c7da924f0cbe5bd$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $112972238ba0eede$export$2e2bcd8739ae039)(node) === 'object' && $2c7da924f0cbe5bd$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($2c7da924f0cbe5bd$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $2c7da924f0cbe5bd$export$2e2bcd8739ae039(node) {
    var domNode = $2c7da924f0cbe5bd$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))), node);
    }
    return null;
}


const $a135099456a3a66d$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $a135099456a3a66d$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $a135099456a3a66d$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $a135099456a3a66d$var$e(o.overflowY, n) || $a135099456a3a66d$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $a135099456a3a66d$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $a135099456a3a66d$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $a135099456a3a66d$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$a135099456a3a66d$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $a135099456a3a66d$var$t(W) && p(W);){
        if (W = $a135099456a3a66d$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $a135099456a3a66d$var$n(W) && !$a135099456a3a66d$var$n(document.documentElement) || null != W && $a135099456a3a66d$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: n, width: l, top: r, right: i, bottom: s, left: d } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= r && I <= s && R >= d && C <= i) return L;
        const h = getComputedStyle(e), a = parseInt(h.borderLeftWidth, 10), g = parseInt(h.borderTopWidth, 10), p = parseInt(h.borderRightWidth, 10), W = parseInt(h.borderBottomWidth, 10);
        let T = 0, B = 0;
        const F = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - a - p : 0, V = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - g - W : 0, S = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : l / e.offsetWidth : 0, X = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : n / e.offsetHeight : 0;
        if (m === e) T = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $a135099456a3a66d$var$o(M, M + H, H, g, W, M + k, M + k + v, v) : k - H / 2, B = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $a135099456a3a66d$var$o(y, y + b, b, a, p, y + D, y + D + E, E), T = Math.max(0, T + M), B = Math.max(0, B + y);
        else {
            T = "start" === f ? k - r - g : "end" === f ? k - s + W + V : "nearest" === f ? $a135099456a3a66d$var$o(r, s, n, g, W + V, k, k + v, v) : k - (r + n / 2) + V / 2, B = "start" === u ? D - d - a : "center" === u ? D - (d + l / 2) + F / 2 : "end" === u ? D - i + p + F : $a135099456a3a66d$var$o(d, i, l, a, p + F, D, D + E, E);
            const { scrollLeft: t, scrollTop: h } = e;
            T = 0 === X ? 0 : Math.max(0, Math.min(h + T / X, e.scrollHeight - n / X + V)), B = 0 === S ? 0 : Math.max(0, Math.min(t + B / S, e.scrollWidth - l / S + F)), k += h - T, D += t - B;
        }
        L.push({
            el: e,
            top: T,
            left: B
        });
    }
    return L;
};


const $b26c6e29c94de039$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $b26c6e29c94de039$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $a135099456a3a66d$export$3b12cb22b12b954b)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $a135099456a3a66d$export$3b12cb22b12b954b)(e, $b26c6e29c94de039$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}


// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const $43291396832d20f3$var$formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
const $43291396832d20f3$var$defaultItemNamePrefixCls = 'form_item';
function $43291396832d20f3$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $43291396832d20f3$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join('_');
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = $43291396832d20f3$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${$43291396832d20f3$var$defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function $43291396832d20f3$export$b70265791d2079d4(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = 'validating';
    else if (errors.length) status = 'error';
    else if (warnings.length) status = 'warning';
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = 'success';
    return status;
}


var $4c36311913591211$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $4c36311913591211$export$368b682c15953eea(name) {
    const namePath = (0, $43291396832d20f3$export$45b10814cc054894)(name);
    return namePath.join('_');
}
function $4c36311913591211$var$getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, $2c7da924f0cbe5bd$export$9aa546fdc20ae5b3)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, $43291396832d20f3$export$f4457e83c74ac000)((0, $43291396832d20f3$export$45b10814cc054894)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function $4c36311913591211$export$2e2bcd8739ae039(form) {
    const [rcForm] = (0, $a1708dc7c20669c0$export$2e2bcd8739ae039)();
    const itemsRef = $acw62.useRef({});
    const wrapForm = $acw62.useMemo(()=>form !== null && form !== void 0 ? form : Object.assign(Object.assign({}, rcForm), {
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = $4c36311913591211$export$368b682c15953eea(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: (name, options = {})=>{
                const { focus: focus } = options, restOpt = $4c36311913591211$var$__rest(options, [
                    "focus"
                ]);
                const node = $4c36311913591211$var$getFieldDOMNode(name, wrapForm);
                if (node) {
                    (0, $b26c6e29c94de039$export$2e2bcd8739ae039)(node, Object.assign({
                        scrollMode: 'if-needed',
                        block: 'nearest'
                    }, restOpt));
                    // Focus if scroll success
                    if (focus) wrapForm.focusField(name);
                }
            },
            focusField: (name)=>{
                var _a, _b;
                const itemRef = wrapForm.getFieldInstance(name);
                if (typeof (itemRef === null || itemRef === void 0 ? void 0 : itemRef.focus) === 'function') itemRef.focus();
                else (_b = (_a = $4c36311913591211$var$getFieldDOMNode(name, wrapForm)) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
            },
            getFieldInstance: (name)=>{
                const namePathStr = $4c36311913591211$export$368b682c15953eea(name);
                return itemsRef.current[namePathStr];
            }
        }), [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}





"use client";
var $69a0bf7fe3d99aff$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $69a0bf7fe3d99aff$var$InternalForm = (props, ref)=>{
    const contextDisabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const { getPrefixCls: getPrefixCls, direction: direction, requiredMark: contextRequiredMark, colon: contextColon, scrollToFirstError: contextScrollToFirstError, className: contextClassName, style: contextStyle } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('form');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, size: size, disabled: disabled = contextDisabled, form: form, colon: colon, labelAlign: labelAlign, labelWrap: labelWrap, labelCol: labelCol, wrapperCol: wrapperCol, hideRequiredMark: hideRequiredMark, layout: layout = 'horizontal', scrollToFirstError: scrollToFirstError, requiredMark: requiredMark, onFinishFailed: onFinishFailed, name: name, style: style, feedbackIcons: feedbackIcons, variant: variant } = props, restFormProps = $69a0bf7fe3d99aff$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "size",
        "disabled",
        "form",
        "colon",
        "labelAlign",
        "labelWrap",
        "labelCol",
        "wrapperCol",
        "hideRequiredMark",
        "layout",
        "scrollToFirstError",
        "requiredMark",
        "onFinishFailed",
        "name",
        "style",
        "feedbackIcons",
        "variant"
    ]);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(size);
    const contextValidateMessages = $acw62.useContext((0, $efabd6732f69a6da$export$2e2bcd8739ae039));
    const mergedRequiredMark = $acw62.useMemo(()=>{
        if (requiredMark !== undefined) return requiredMark;
        if (hideRequiredMark) return false;
        if (contextRequiredMark !== undefined) return contextRequiredMark;
        return true;
    }, [
        hideRequiredMark,
        requiredMark,
        contextRequiredMark
    ]);
    const mergedColon = colon !== null && colon !== void 0 ? colon : contextColon;
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3f17b93d805dc813$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const formClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-${layout}`, {
        [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
        // todo: remove in next major version
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${mergedSize}`]: mergedSize
    }, cssVarCls, rootCls, hashId, contextClassName, className, rootClassName);
    const [wrapForm] = (0, $4c36311913591211$export$2e2bcd8739ae039)(form);
    const { __INTERNAL__: __INTERNAL__ } = wrapForm;
    __INTERNAL__.name = name;
    const formContextValue = $acw62.useMemo(()=>({
            name: name,
            labelAlign: labelAlign,
            labelCol: labelCol,
            labelWrap: labelWrap,
            wrapperCol: wrapperCol,
            vertical: layout === 'vertical',
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm,
            feedbackIcons: feedbackIcons
        }), [
        name,
        labelAlign,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm,
        feedbackIcons
    ]);
    const nativeElementRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>{
        var _a;
        return Object.assign(Object.assign({}, wrapForm), {
            nativeElement: (_a = nativeElementRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement
        });
    });
    const scrollToField = (options, fieldName)=>{
        if (options) {
            let defaultScrollToFirstError = {
                block: 'nearest'
            };
            if (typeof options === 'object') defaultScrollToFirstError = Object.assign(Object.assign({}, defaultScrollToFirstError), options);
            wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
        }
    };
    const onInternalFinishFailed = (errorInfo)=>{
        onFinishFailed === null || onFinishFailed === void 0 || onFinishFailed(errorInfo);
        if (errorInfo.errorFields.length) {
            const fieldName = errorInfo.errorFields[0].name;
            if (scrollToFirstError !== undefined) {
                scrollToField(scrollToFirstError, fieldName);
                return;
            }
            if (contextScrollToFirstError !== undefined) scrollToField(contextScrollToFirstError, fieldName);
        }
    };
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$6f0555dad42725fb).Provider, {
        value: variant
    }, /*#__PURE__*/ $acw62.createElement((0, $6ba6819805fb0a44$export$6adb5f3b918b11bb), {
        disabled: disabled
    }, /*#__PURE__*/ $acw62.createElement((0, $3e100f55cf8f3689$export$2e2bcd8739ae039).Provider, {
        value: mergedSize
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$8ce1ff4f94d08846), {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$c24727297075ec6a).Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $5f1614ae44e69c1b$export$2e2bcd8739ae039), Object.assign({
        id: name
    }, restFormProps, {
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        ref: nativeElementRef,
        style: Object.assign(Object.assign({}, contextStyle), style),
        className: formClassName
    }))))))));
};
const $69a0bf7fe3d99aff$var$Form = /*#__PURE__*/ $acw62.forwardRef($69a0bf7fe3d99aff$var$InternalForm);
var $69a0bf7fe3d99aff$export$2e2bcd8739ae039 = $69a0bf7fe3d99aff$var$Form;




var $acw62 = parcelRequire("acw62");










function $6d72a014848b02ce$export$2e2bcd8739ae039(children) {
    if (typeof children === 'function') return children;
    const childList = (0, $5aa78504b8a12848$export$2e2bcd8739ae039)(children);
    return childList.length <= 1 ? childList[0] : childList;
}



var $acw62 = parcelRequire("acw62");


const $c23052ca479f865f$var$useFormItemStatus = ()=>{
    const { status: status, errors: errors = [], warnings: warnings = [] } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    return {
        status: status,
        errors: errors,
        warnings: warnings
    };
};
// Only used for compatible package. Not promise this will work on future version.
$c23052ca479f865f$var$useFormItemStatus.Context = (0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed);
var $c23052ca479f865f$export$2e2bcd8739ae039 = $c23052ca479f865f$var$useFormItemStatus;



var $acw62 = parcelRequire("acw62");

function $bc695e48262f4f73$export$2e2bcd8739ae039(defaultValue) {
    const [value, setValue] = $acw62.useState(defaultValue);
    const frameRef = $acw62.useRef(null);
    const batchRef = $acw62.useRef([]);
    const destroyRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
            (0, $2b9f066ea00dd1c7$export$2e2bcd8739ae039).cancel(frameRef.current);
            frameRef.current = null;
        };
    }, []);
    function setFrameValue(updater) {
        if (destroyRef.current) return;
        if (frameRef.current === null) {
            batchRef.current = [];
            frameRef.current = (0, $2b9f066ea00dd1c7$export$2e2bcd8739ae039)(()=>{
                frameRef.current = null;
                setValue((prevValue)=>{
                    let current = prevValue;
                    batchRef.current.forEach((func)=>{
                        current = func(current);
                    });
                    return current;
                });
            });
        }
        batchRef.current.push(updater);
    }
    return [
        value,
        setFrameValue
    ];
}



var $acw62 = parcelRequire("acw62");


function $3c7d21c38713ea5c$export$2e2bcd8739ae039() {
    const { itemRef: itemRef } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    const cacheRef = $acw62.useRef({});
    function getRef(name, children) {
        // Outer caller already check the `supportRef`
        const childrenRef = children && typeof children === 'object' && (0, $f1965a9a7a1fe067$export$7465e5c0bf44f19a)(children);
        const nameStr = name.join('_');
        if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
            cacheRef.current.name = nameStr;
            cacheRef.current.originRef = childrenRef;
            cacheRef.current.ref = (0, $f1965a9a7a1fe067$export$ab452c34e8e05029)(itemRef(name), childrenRef);
        }
        return cacheRef.current.ref;
    }
    return getRef;
}





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $ae5760e5a2521b6d$export$33d4bfa367d0ee08 = (mql, handler)=>{
    // Don't delete here, please keep the code compatible
    if (typeof (mql === null || mql === void 0 ? void 0 : mql.addEventListener) !== 'undefined') mql.addEventListener('change', handler);
    else if (typeof (mql === null || mql === void 0 ? void 0 : mql.addListener) !== 'undefined') mql.addListener(handler);
};
const $ae5760e5a2521b6d$export$8b5fab0a56c137c5 = (mql, handler)=>{
    // Don't delete here, please keep the code compatible
    if (typeof (mql === null || mql === void 0 ? void 0 : mql.removeEventListener) !== 'undefined') mql.removeEventListener('change', handler);
    else if (typeof (mql === null || mql === void 0 ? void 0 : mql.removeListener) !== 'undefined') mql.removeListener(handler);
};


const $36689cb123f552b0$export$74c1bf8296b1541f = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $36689cb123f552b0$var$getResponsiveMap = (token)=>({
        xs: `(max-width: ${token.screenXSMax}px)`,
        sm: `(min-width: ${token.screenSM}px)`,
        md: `(min-width: ${token.screenMD}px)`,
        lg: `(min-width: ${token.screenLG}px)`,
        xl: `(min-width: ${token.screenXL}px)`,
        xxl: `(min-width: ${token.screenXXL}px)`
    });
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */ const $36689cb123f552b0$var$validateBreakpoints = (token)=>{
    const indexableToken = token;
    const revBreakpoints = [].concat($36689cb123f552b0$export$74c1bf8296b1541f).reverse();
    revBreakpoints.forEach((breakpoint, i)=>{
        const breakpointUpper = breakpoint.toUpperCase();
        const screenMin = `screen${breakpointUpper}Min`;
        const screen = `screen${breakpointUpper}`;
        if (!(indexableToken[screenMin] <= indexableToken[screen])) throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
        if (i < revBreakpoints.length - 1) {
            const screenMax = `screen${breakpointUpper}Max`;
            if (!(indexableToken[screen] <= indexableToken[screenMax])) throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
            const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
            const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
            if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
        }
    });
    return token;
};
const $36689cb123f552b0$export$862220c15691d248 = (screens, screenSizes)=>{
    if (!screenSizes) return;
    for (const breakpoint of $36689cb123f552b0$export$74c1bf8296b1541f){
        if (screens[breakpoint] && (screenSizes === null || screenSizes === void 0 ? void 0 : screenSizes[breakpoint]) !== undefined) return screenSizes[breakpoint];
    }
};
const $36689cb123f552b0$var$useResponsiveObserver = ()=>{
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const responsiveMap = $36689cb123f552b0$var$getResponsiveMap($36689cb123f552b0$var$validateBreakpoints(token));
    // To avoid repeat create instance, we add `useMemo` here.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const subscribers = new Map();
        let subUid = -1;
        let screens = {};
        return {
            responsiveMap: responsiveMap,
            matchHandlers: {},
            dispatch (pointMap) {
                screens = pointMap;
                subscribers.forEach((func)=>func(screens));
                return subscribers.size >= 1;
            },
            subscribe (func) {
                if (!subscribers.size) this.register();
                subUid += 1;
                subscribers.set(subUid, func);
                func(screens);
                return subUid;
            },
            unsubscribe (paramToken) {
                subscribers.delete(paramToken);
                if (!subscribers.size) this.unregister();
            },
            register () {
                Object.entries(responsiveMap).forEach(([screen, mediaQuery])=>{
                    const listener = ({ matches: matches })=>{
                        this.dispatch(Object.assign(Object.assign({}, screens), {
                            [screen]: matches
                        }));
                    };
                    const mql = window.matchMedia(mediaQuery);
                    (0, $ae5760e5a2521b6d$export$33d4bfa367d0ee08)(mql, listener);
                    this.matchHandlers[mediaQuery] = {
                        mql: mql,
                        listener: listener
                    };
                    listener(mql);
                });
            },
            unregister () {
                Object.values(responsiveMap).forEach((mediaQuery)=>{
                    const handler = this.matchHandlers[mediaQuery];
                    (0, $ae5760e5a2521b6d$export$8b5fab0a56c137c5)(handler === null || handler === void 0 ? void 0 : handler.mql, handler === null || handler === void 0 ? void 0 : handler.listener);
                });
                subscribers.clear();
            }
        };
    }, [
        token
    ]);
};
var $36689cb123f552b0$export$2e2bcd8739ae039 = $36689cb123f552b0$var$useResponsiveObserver;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $dcbb6d0bd42650d6$export$2e2bcd8739ae039() {
    const [, forceUpdate] = $acw62.useReducer((x)=>x + 1, 0);
    return forceUpdate;
}



"use client";
function $b8c04e47cb65d6a9$var$useBreakpoint(refreshOnChange = true, defaultScreens = {}) {
    const screensRef = (0, $acw62.useRef)(defaultScreens);
    const forceUpdate = (0, $dcbb6d0bd42650d6$export$2e2bcd8739ae039)();
    const responsiveObserver = (0, $36689cb123f552b0$export$2e2bcd8739ae039)();
    (0, $16cc62d9173c0916$export$2e2bcd8739ae039)(()=>{
        const token = responsiveObserver.subscribe((supportScreens)=>{
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, []);
    return screensRef.current;
}
var $b8c04e47cb65d6a9$export$2e2bcd8739ae039 = $b8c04e47cb65d6a9$var$useBreakpoint;



function $e931cbd9471a5224$export$2e2bcd8739ae039(gutter, screens) {
    const results = [
        undefined,
        undefined
    ];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [
        gutter,
        undefined
    ];
    // By default use as `xs`
    const mergedScreens = screens || {
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
    };
    normalizedGutter.forEach((g, index)=>{
        if (typeof g === 'object' && g !== null) for(let i = 0; i < (0, $36689cb123f552b0$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $36689cb123f552b0$export$74c1bf8296b1541f)[i];
            if (mergedScreens[breakpoint] && g[breakpoint] !== undefined) {
                results[index] = g[breakpoint];
                break;
            }
        }
        else results[index] = g;
    });
    return results;
}



var $acw62 = parcelRequire("acw62");
const $0664da0d06972591$var$RowContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $0664da0d06972591$export$2e2bcd8739ae039 = $0664da0d06972591$var$RowContext;




// ============================== Row-Shared ==============================
const $ce0ae756d67d6466$var$genGridRowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            display: 'flex',
            flexFlow: 'row wrap',
            minWidth: 0,
            '&::before, &::after': {
                display: 'flex'
            },
            '&-no-wrap': {
                flexWrap: 'nowrap'
            },
            // The origin of the X-axis
            '&-start': {
                justifyContent: 'flex-start'
            },
            // The center of the X-axis
            '&-center': {
                justifyContent: 'center'
            },
            // The opposite of the X-axis
            '&-end': {
                justifyContent: 'flex-end'
            },
            '&-space-between': {
                justifyContent: 'space-between'
            },
            '&-space-around': {
                justifyContent: 'space-around'
            },
            '&-space-evenly': {
                justifyContent: 'space-evenly'
            },
            // Align at the top
            '&-top': {
                alignItems: 'flex-start'
            },
            // Align at the center
            '&-middle': {
                alignItems: 'center'
            },
            '&-bottom': {
                alignItems: 'flex-end'
            }
        }
    };
};
// ============================== Col-Shared ==============================
const $ce0ae756d67d6466$var$genGridColStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            position: 'relative',
            maxWidth: '100%',
            // Prevent columns from collapsing when empty
            minHeight: 1
        }
    };
};
const $ce0ae756d67d6466$var$genLoopGridColumnsStyle = (token, sizeCls)=>{
    const { prefixCls: prefixCls, componentCls: componentCls, gridColumns: gridColumns } = token;
    const gridColumnsStyle = {};
    for(let i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
            display: 'none'
        };
        gridColumnsStyle[`${componentCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: 0
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: 0
        };
    } else {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
            // https://github.com/ant-design/ant-design/issues/44456
            // Form set `display: flex` on Col which will override `display: block`.
            // Let's get it from css variable to support override.
            {
                ['--ant-display']: 'block',
                // Fallback to display if variable not support
                display: 'block'
            },
            {
                display: 'var(--ant-display)',
                flex: `0 0 ${i / gridColumns * 100}%`,
                maxWidth: `${i / gridColumns * 100}%`
            }
        ];
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: i
        };
    }
    // Flex CSS Var
    gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
        flex: `var(--${prefixCls}${sizeCls}-flex)`
    };
    return gridColumnsStyle;
};
const $ce0ae756d67d6466$var$genGridStyle = (token, sizeCls)=>$ce0ae756d67d6466$var$genLoopGridColumnsStyle(token, sizeCls);
const $ce0ae756d67d6466$var$genGridMediaStyle = (token, screenSize, sizeCls)=>({
        [`@media (min-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(screenSize)})`]: Object.assign({}, $ce0ae756d67d6466$var$genGridStyle(token, sizeCls))
    });
const $ce0ae756d67d6466$export$519f4f378a4f8e85 = ()=>({});
const $ce0ae756d67d6466$export$5504d86ab3175593 = ()=>({});
const $ce0ae756d67d6466$export$b0d9c6b8be4e14cd = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Grid', $ce0ae756d67d6466$var$genGridRowStyle, $ce0ae756d67d6466$export$519f4f378a4f8e85);
const $ce0ae756d67d6466$export$6353f655434817c5 = (token)=>{
    const mediaSizesMap = {
        xs: token.screenXSMin,
        sm: token.screenSMMin,
        md: token.screenMDMin,
        lg: token.screenLGMin,
        xl: token.screenXLMin,
        xxl: token.screenXXLMin
    };
    return mediaSizesMap;
};
const $ce0ae756d67d6466$export$4d3e83959861592f = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Grid', (token)=>{
    const gridToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    const gridMediaSizesMap = $ce0ae756d67d6466$export$6353f655434817c5(gridToken);
    delete gridMediaSizesMap.xs;
    return [
        $ce0ae756d67d6466$var$genGridColStyle(gridToken),
        $ce0ae756d67d6466$var$genGridStyle(gridToken, ''),
        $ce0ae756d67d6466$var$genGridStyle(gridToken, '-xs'),
        Object.keys(gridMediaSizesMap).map((key)=>$ce0ae756d67d6466$var$genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur)=>Object.assign(Object.assign({}, pre), cur), {})
    ];
}, $ce0ae756d67d6466$export$5504d86ab3175593);


"use client";
var $50bd634b7bc091a8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $50bd634b7bc091a8$var$_RowAligns = [
    'top',
    'middle',
    'bottom',
    'stretch'
];
const $50bd634b7bc091a8$var$_RowJustify = [
    'start',
    'end',
    'center',
    'space-around',
    'space-between',
    'space-evenly'
];
function $50bd634b7bc091a8$var$useMergedPropByScreen(oriProp, screen) {
    const [prop, setProp] = $acw62.useState(typeof oriProp === 'string' ? oriProp : '');
    const calcMergedAlignOrJustify = ()=>{
        if (typeof oriProp === 'string') setProp(oriProp);
        if (typeof oriProp !== 'object') return;
        for(let i = 0; i < (0, $36689cb123f552b0$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $36689cb123f552b0$export$74c1bf8296b1541f)[i];
            // if do not match, do nothing
            if (!screen || !screen[breakpoint]) continue;
            const curVal = oriProp[breakpoint];
            if (curVal !== undefined) {
                setProp(curVal);
                return;
            }
        }
    };
    $acw62.useEffect(()=>{
        calcMergedAlignOrJustify();
    }, [
        JSON.stringify(oriProp),
        screen
    ]);
    return prop;
}
const $50bd634b7bc091a8$var$Row = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, justify: justify, align: align, className: className, style: style, children: children, gutter: gutter = 0, wrap: wrap } = props, others = $50bd634b7bc091a8$var$__rest(props, [
        "prefixCls",
        "justify",
        "align",
        "className",
        "style",
        "children",
        "gutter",
        "wrap"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const screens = (0, $b8c04e47cb65d6a9$export$2e2bcd8739ae039)(true, null);
    const mergedAlign = $50bd634b7bc091a8$var$useMergedPropByScreen(align, screens);
    const mergedJustify = $50bd634b7bc091a8$var$useMergedPropByScreen(justify, screens);
    const prefixCls = getPrefixCls('row', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $ce0ae756d67d6466$export$b0d9c6b8be4e14cd)(prefixCls);
    const gutters = (0, $e931cbd9471a5224$export$2e2bcd8739ae039)(gutter, screens);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${mergedJustify}`]: mergedJustify,
        [`${prefixCls}-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId, cssVarCls);
    // Add gutter related style
    const rowStyle = {};
    const horizontalGutter = gutters[0] != null && gutters[0] > 0 ? gutters[0] / -2 : undefined;
    if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
    }
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    const [gutterH, gutterV] = gutters;
    rowStyle.rowGap = gutterV;
    const rowContext = $acw62.useMemo(()=>({
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap
        }), [
        gutterH,
        gutterV,
        wrap
    ]);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $0664da0d06972591$export$2e2bcd8739ae039).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, others, {
        className: classes,
        style: Object.assign(Object.assign({}, rowStyle), style),
        ref: ref
    }), children)));
});
var $50bd634b7bc091a8$export$2e2bcd8739ae039 = $50bd634b7bc091a8$var$Row;




var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");




"use client";
var $d153d21e77ee9427$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d153d21e77ee9427$var$parseFlex(flex) {
    if (typeof flex === 'number') return `${flex} ${flex} auto`;
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return `0 0 ${flex}`;
    return flex;
}
const $d153d21e77ee9427$var$sizes = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
];
const $d153d21e77ee9427$var$Col = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { gutter: gutter, wrap: wrap } = $acw62.useContext((0, $0664da0d06972591$export$2e2bcd8739ae039));
    const { prefixCls: customizePrefixCls, span: span, order: order, offset: offset, push: push, pull: pull, className: className, children: children, flex: flex, style: style } = props, others = $d153d21e77ee9427$var$__rest(props, [
        "prefixCls",
        "span",
        "order",
        "offset",
        "push",
        "pull",
        "className",
        "children",
        "flex",
        "style"
    ]);
    const prefixCls = getPrefixCls('col', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $ce0ae756d67d6466$export$4d3e83959861592f)(prefixCls);
    // ===================== Size ======================
    const sizeStyle = {};
    let sizeClassObj = {};
    $d153d21e77ee9427$var$sizes.forEach((size)=>{
        let sizeProps = {};
        const propSize = props[size];
        if (typeof propSize === 'number') sizeProps.span = propSize;
        else if (typeof propSize === 'object') sizeProps = propSize || {};
        delete others[size];
        sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), {
            [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined,
            [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
            [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
            [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
            [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        });
        // Responsive flex layout
        if (sizeProps.flex) {
            sizeClassObj[`${prefixCls}-${size}-flex`] = true;
            sizeStyle[`--${prefixCls}-${size}-flex`] = $d153d21e77ee9427$var$parseFlex(sizeProps.flex);
        }
    });
    // ==================== Normal =====================
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-${span}`]: span !== undefined,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
    }, className, sizeClassObj, hashId, cssVarCls);
    const mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter && gutter[0] > 0) {
        const horizontalGutter = gutter[0] / 2;
        mergedStyle.paddingLeft = horizontalGutter;
        mergedStyle.paddingRight = horizontalGutter;
    }
    if (flex) {
        mergedStyle.flex = $d153d21e77ee9427$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    // ==================== Render =====================
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({}, others, {
        style: Object.assign(Object.assign(Object.assign({}, mergedStyle), style), sizeStyle),
        className: classes,
        ref: ref
    }), children));
});
var $d153d21e77ee9427$export$2e2bcd8739ae039 = $d153d21e77ee9427$var$Col;




/**
 * Fallback of IE.
 * Safe to remove.
 */ // Style as inline component


// ============================= Fallback =============================
const $cf15d29d2c9ecade$var$genFallbackStyle = (token)=>{
    const { formItemCls: formItemCls } = token;
    return {
        '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
            // Fallback for IE, safe to remove we not support it anymore
            [`${formItemCls}-control`]: {
                display: 'flex'
            }
        }
    };
};
var // ============================== Export ==============================
$cf15d29d2c9ecade$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$1537386bc155ea56)([
    'Form',
    'item-item'
], (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = (0, $3f17b93d805dc813$export$362fb92a8f81bbf9)(token, rootPrefixCls);
    return [
        $cf15d29d2c9ecade$var$genFallbackStyle(formToken)
    ];
});


"use client";
var $1c2fb1c8dfed9a89$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $1c2fb1c8dfed9a89$var$GRID_MAX = 24;
const $1c2fb1c8dfed9a89$var$FormItemInput = (props)=>{
    const { prefixCls: prefixCls, status: status, labelCol: labelCol, wrapperCol: wrapperCol, children: children, errors: errors, warnings: warnings, _internalItemRender: formItemRender, extra: extra, help: help, fieldId: fieldId, marginBottom: marginBottom, onErrorVisibleChanged: onErrorVisibleChanged, label: label } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    const mergedWrapperCol = $acw62.useMemo(()=>{
        let mergedWrapper = Object.assign({}, wrapperCol || formContext.wrapperCol || {});
        if (label === null && !labelCol && !wrapperCol && formContext.labelCol) {
            const list = [
                undefined,
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'xxl'
            ];
            list.forEach((size)=>{
                const _size = size ? [
                    size
                ] : [];
                const formLabel = (0, $fa6bae2921213688$export$2e2bcd8739ae039)(formContext.labelCol, _size);
                const formLabelObj = typeof formLabel === 'object' ? formLabel : {};
                const wrapper = (0, $fa6bae2921213688$export$2e2bcd8739ae039)(mergedWrapper, _size);
                const wrapperObj = typeof wrapper === 'object' ? wrapper : {};
                if ('span' in formLabelObj && !('offset' in wrapperObj) && formLabelObj.span < $1c2fb1c8dfed9a89$var$GRID_MAX) mergedWrapper = (0, $3478506a110abe5a$export$2e2bcd8739ae039)(mergedWrapper, [].concat(_size, [
                    'offset'
                ]), formLabelObj.span);
            });
        }
        return mergedWrapper;
    }, [
        wrapperCol,
        formContext
    ]);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${baseClassName}-control`, mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    const subFormContext = $acw62.useMemo(()=>{
        const { labelCol: labelCol, wrapperCol: wrapperCol } = formContext, rest = $1c2fb1c8dfed9a89$var$__rest(formContext, [
            "labelCol",
            "wrapperCol"
        ]);
        return rest;
    }, [
        formContext
    ]);
    const extraRef = $acw62.useRef(null);
    const [extraHeight, setExtraHeight] = $acw62.useState(0);
    (0, $16cc62d9173c0916$export$2e2bcd8739ae039)(()=>{
        if (extra && extraRef.current) setExtraHeight(extraRef.current.clientHeight);
        else setExtraHeight(0);
    }, [
        extra
    ]);
    const inputDom = /*#__PURE__*/ $acw62.createElement("div", {
        className: `${baseClassName}-control-input`
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${baseClassName}-control-input-content`
    }, children));
    const formItemContext = $acw62.useMemo(()=>({
            prefixCls: prefixCls,
            status: status
        }), [
        prefixCls,
        status
    ]);
    const errorListDom = marginBottom !== null || errors.length || warnings.length ? /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$fb6582d3042cc879).Provider, {
        value: formItemContext
    }, /*#__PURE__*/ $acw62.createElement((0, $2cd7502dce089e1a$export$2e2bcd8739ae039), {
        fieldId: fieldId,
        errors: errors,
        warnings: warnings,
        help: help,
        helpStatus: status,
        className: `${baseClassName}-explain-connected`,
        onVisibleChanged: onErrorVisibleChanged
    })) : null;
    const extraProps = {};
    if (fieldId) extraProps.id = `${fieldId}_extra`;
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    const extraDom = extra ? /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, extraProps, {
        className: `${baseClassName}-extra`,
        ref: extraRef
    }), extra) : null;
    const additionalDom = errorListDom || extraDom ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${baseClassName}-additional`,
        style: marginBottom ? {
            minHeight: marginBottom + extraHeight
        } : {}
    }, errorListDom, extraDom) : null;
    const dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
        input: inputDom,
        errorList: errorListDom,
        extra: extraDom
    }) : /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, inputDom, additionalDom);
    return /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$c24727297075ec6a).Provider, {
        value: subFormContext
    }, /*#__PURE__*/ $acw62.createElement((0, $d153d21e77ee9427$export$2e2bcd8739ae039), Object.assign({}, mergedWrapperCol, {
        className: className
    }), dom), /*#__PURE__*/ $acw62.createElement((0, $cf15d29d2c9ecade$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
var $1c2fb1c8dfed9a89$export$2e2bcd8739ae039 = $1c2fb1c8dfed9a89$var$FormItemInput;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $62cc23852a32c921$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
var $62cc23852a32c921$export$2e2bcd8739ae039 = $62cc23852a32c921$var$QuestionCircleOutlined;



var $f894f96f86da23c6$var$QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $62cc23852a32c921$export$2e2bcd8739ae039)
    }));
};
/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ var $f894f96f86da23c6$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f894f96f86da23c6$var$QuestionCircleOutlined);
var $f894f96f86da23c6$export$2e2bcd8739ae039 = $f894f96f86da23c6$var$RefIcon;




var $acw62 = parcelRequire("acw62");
function $9a3c4be1cfc5ed48$var$convertToTooltipProps(tooltip) {
    // isNil
    if (tooltip === undefined || tooltip === null) return null;
    if (typeof tooltip === 'object' && !/*#__PURE__*/ (0, $acw62.isValidElement)(tooltip)) return tooltip;
    return {
        title: tooltip
    };
}
var $9a3c4be1cfc5ed48$export$2e2bcd8739ae039 = $9a3c4be1cfc5ed48$var$convertToTooltipProps;







"use client";
var $e49ae3442c8737f4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e49ae3442c8737f4$var$FormItemLabel = ({ prefixCls: prefixCls, label: label, htmlFor: htmlFor, labelCol: labelCol, labelAlign: labelAlign, colon: colon, required: required, requiredMark: requiredMark, tooltip: tooltip, vertical: vertical })=>{
    var _a;
    const [formLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('Form');
    const { labelAlign: contextLabelAlign, labelCol: contextLabelCol, labelWrap: labelWrap, colon: contextColon } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    if (!label) return null;
    const mergedLabelCol = labelCol || contextLabelCol || {};
    const mergedLabelAlign = labelAlign || contextLabelAlign;
    const labelClsBasic = `${prefixCls}-item-label`;
    const labelColClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(labelClsBasic, mergedLabelAlign === 'left' && `${labelClsBasic}-left`, mergedLabelCol.className, {
        [`${labelClsBasic}-wrap`]: !!labelWrap
    });
    let labelChildren = label;
    // Keep label is original where there should have no colon
    const computedColon = colon === true || contextColon !== false && colon !== false;
    const haveColon = computedColon && !vertical;
    // Remove duplicated user input colon
    if (haveColon && typeof label === 'string' && label.trim()) labelChildren = label.replace(/[:|：]\s*$/, '');
    // Tooltip
    const tooltipProps = (0, $9a3c4be1cfc5ed48$export$2e2bcd8739ae039)(tooltip);
    if (tooltipProps) {
        const { icon: icon = /*#__PURE__*/ $acw62.createElement((0, $f894f96f86da23c6$export$2e2bcd8739ae039), null) } = tooltipProps, restTooltipProps = $e49ae3442c8737f4$var$__rest(tooltipProps, [
            "icon"
        ]);
        const tooltipNode = /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), Object.assign({}, restTooltipProps), /*#__PURE__*/ $acw62.cloneElement(icon, {
            className: `${prefixCls}-item-tooltip`,
            title: '',
            onClick: (e)=>{
                // Prevent label behavior in tooltip icon
                // https://github.com/ant-design/ant-design/issues/46154
                e.preventDefault();
            },
            tabIndex: null
        }));
        labelChildren = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, labelChildren, tooltipNode);
    }
    // Required Mark
    const isOptionalMark = requiredMark === 'optional';
    const isRenderMark = typeof requiredMark === 'function';
    const hideRequiredMark = requiredMark === false;
    if (isRenderMark) labelChildren = requiredMark(labelChildren, {
        required: !!required
    });
    else if (isOptionalMark && !required) labelChildren = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, labelChildren, /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-item-optional`,
        title: ""
    }, (formLocale === null || formLocale === void 0 ? void 0 : formLocale.optional) || ((_a = (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.optional)));
    // https://github.com/ant-design/ant-design/pull/52950#discussion_r1980880316
    let markType;
    if (hideRequiredMark) markType = 'hidden';
    else if (isOptionalMark || isRenderMark) markType = 'optional';
    const labelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-item-required`]: required,
        [`${prefixCls}-item-required-mark-${markType}`]: markType,
        [`${prefixCls}-item-no-colon`]: !computedColon
    });
    return /*#__PURE__*/ $acw62.createElement((0, $d153d21e77ee9427$export$2e2bcd8739ae039), Object.assign({}, mergedLabelCol, {
        className: labelColClassName
    }), /*#__PURE__*/ $acw62.createElement("label", {
        htmlFor: htmlFor,
        className: labelClassName,
        title: typeof label === 'string' ? label : ''
    }, labelChildren));
};
var $e49ae3442c8737f4$export$2e2bcd8739ae039 = $e49ae3442c8737f4$var$FormItemLabel;





var $acw62 = parcelRequire("acw62");







"use client";
const $ba46d4357a9f33ef$var$iconMap = {
    success: (0, $9149fdfb4424d1d9$export$2e2bcd8739ae039),
    warning: (0, $2444f6da62064575$export$2e2bcd8739ae039),
    error: (0, $81ff9dc68eb84eda$export$2e2bcd8739ae039),
    validating: (0, $d8d56e1090f62915$export$2e2bcd8739ae039)
};
function $ba46d4357a9f33ef$export$2e2bcd8739ae039({ children: children, errors: errors, warnings: warnings, hasFeedback: hasFeedback, validateStatus: validateStatus, prefixCls: prefixCls, meta: meta, noStyle: noStyle, name: name }) {
    const itemPrefixCls = `${prefixCls}-item`;
    const { feedbackIcons: feedbackIcons } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    const mergedValidateStatus = (0, $43291396832d20f3$export$b70265791d2079d4)(errors, warnings, meta, null, !!hasFeedback, validateStatus);
    const { isFormItemInput: parentIsFormItemInput, status: parentStatus, hasFeedback: parentHasFeedback, feedbackIcon: parentFeedbackIcon, name: parentName } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    // ====================== Context =======================
    const formItemStatusContext = $acw62.useMemo(()=>{
        var _a;
        let feedbackIcon;
        if (hasFeedback) {
            const customIcons = hasFeedback !== true && hasFeedback.icons || feedbackIcons;
            const customIconNode = mergedValidateStatus && ((_a = customIcons === null || customIcons === void 0 ? void 0 : customIcons({
                status: mergedValidateStatus,
                errors: errors,
                warnings: warnings
            })) === null || _a === void 0 ? void 0 : _a[mergedValidateStatus]);
            const IconNode = mergedValidateStatus && $ba46d4357a9f33ef$var$iconMap[mergedValidateStatus];
            feedbackIcon = customIconNode !== false && IconNode ? /*#__PURE__*/ $acw62.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${itemPrefixCls}-feedback-icon`, `${itemPrefixCls}-feedback-icon-${mergedValidateStatus}`)
            }, customIconNode || /*#__PURE__*/ $acw62.createElement(IconNode, null)) : null;
        }
        const context = {
            status: mergedValidateStatus || '',
            errors: errors,
            warnings: warnings,
            hasFeedback: !!hasFeedback,
            feedbackIcon: feedbackIcon,
            isFormItemInput: true,
            name: name
        };
        // No style will follow parent context
        if (noStyle) {
            context.status = (mergedValidateStatus !== null && mergedValidateStatus !== void 0 ? mergedValidateStatus : parentStatus) || '';
            context.isFormItemInput = parentIsFormItemInput;
            context.hasFeedback = !!(hasFeedback !== null && hasFeedback !== void 0 ? hasFeedback : parentHasFeedback);
            context.feedbackIcon = hasFeedback !== undefined ? context.feedbackIcon : parentFeedbackIcon;
            context.name = name !== null && name !== void 0 ? name : parentName;
        }
        return context;
    }, [
        mergedValidateStatus,
        hasFeedback,
        noStyle,
        parentIsFormItemInput,
        parentStatus
    ]);
    // ======================= Render =======================
    return /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Provider, {
        value: formItemStatusContext
    }, children);
}


"use client";
var $046eb12d049399e0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $046eb12d049399e0$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, className: className, rootClassName: rootClassName, style: style, help: help, errors: errors, warnings: warnings, validateStatus: validateStatus, meta: meta, hasFeedback: hasFeedback, hidden: hidden, children: children, fieldId: fieldId, required: required, isRequired: isRequired, onSubItemMetaChange: onSubItemMetaChange, layout: layout, name: name } = props, restProps = $046eb12d049399e0$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "help",
        "errors",
        "warnings",
        "validateStatus",
        "meta",
        "hasFeedback",
        "hidden",
        "children",
        "fieldId",
        "required",
        "isRequired",
        "onSubItemMetaChange",
        "layout",
        "name"
    ]);
    const itemPrefixCls = `${prefixCls}-item`;
    const { requiredMark: requiredMark, vertical: formVertical } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    const vertical = formVertical || layout === 'vertical';
    // ======================== Margin ========================
    const itemRef = $acw62.useRef(null);
    const debounceErrors = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(warnings);
    const hasHelp = help !== undefined && help !== null;
    const hasError = !!(hasHelp || errors.length || warnings.length);
    const isOnScreen = !!itemRef.current && (0, $f1b50e7ed1ad3c25$export$2e2bcd8739ae039)(itemRef.current);
    const [marginBottom, setMarginBottom] = $acw62.useState(null);
    (0, $16cc62d9173c0916$export$2e2bcd8739ae039)(()=>{
        if (hasError && itemRef.current) {
            // The element must be part of the DOMTree to use getComputedStyle
            // https://stackoverflow.com/questions/35360711/getcomputedstyle-returns-a-cssstyledeclaration-but-all-properties-are-empty-on-a
            const itemStyle = getComputedStyle(itemRef.current);
            setMarginBottom(parseInt(itemStyle.marginBottom, 10));
        }
    }, [
        hasError,
        isOnScreen
    ]);
    const onErrorVisibleChanged = (nextVisible)=>{
        if (!nextVisible) setMarginBottom(null);
    };
    // ======================== Status ========================
    const getValidateState = (isDebounce = false)=>{
        const _errors = isDebounce ? debounceErrors : meta.errors;
        const _warnings = isDebounce ? debounceWarnings : meta.warnings;
        return (0, $43291396832d20f3$export$b70265791d2079d4)(_errors, _warnings, meta, '', !!hasFeedback, validateStatus);
    };
    const mergedValidateStatus = getValidateState();
    // ======================== Render ========================
    const itemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(itemPrefixCls, className, rootClassName, {
        [`${itemPrefixCls}-with-help`]: hasHelp || debounceErrors.length || debounceWarnings.length,
        // Status
        [`${itemPrefixCls}-has-feedback`]: mergedValidateStatus && hasFeedback,
        [`${itemPrefixCls}-has-success`]: mergedValidateStatus === 'success',
        [`${itemPrefixCls}-has-warning`]: mergedValidateStatus === 'warning',
        [`${itemPrefixCls}-has-error`]: mergedValidateStatus === 'error',
        [`${itemPrefixCls}-is-validating`]: mergedValidateStatus === 'validating',
        [`${itemPrefixCls}-hidden`]: hidden,
        // Layout
        [`${itemPrefixCls}-${layout}`]: layout
    });
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: itemClassName,
        style: style,
        ref: itemRef
    }, /*#__PURE__*/ $acw62.createElement((0, $50bd634b7bc091a8$export$2e2bcd8739ae039), Object.assign({
        className: `${itemPrefixCls}-row`
    }, (0, $57c22a5a2f343bca$export$2e2bcd8739ae039)(restProps, [
        '_internalItemRender',
        'colon',
        'dependencies',
        'extra',
        'fieldKey',
        'getValueFromEvent',
        'getValueProps',
        'htmlFor',
        'id',
        // It is deprecated because `htmlFor` is its replacement.
        'initialValue',
        'isListField',
        'label',
        'labelAlign',
        'labelCol',
        'labelWrap',
        'messageVariables',
        'name',
        'normalize',
        'noStyle',
        'preserve',
        'requiredMark',
        'rules',
        'shouldUpdate',
        'trigger',
        'tooltip',
        'validateFirst',
        'validateTrigger',
        'valuePropName',
        'wrapperCol',
        'validateDebounce'
    ])), /*#__PURE__*/ $acw62.createElement((0, $e49ae3442c8737f4$export$2e2bcd8739ae039), Object.assign({
        htmlFor: fieldId
    }, props, {
        requiredMark: requiredMark,
        required: required !== null && required !== void 0 ? required : isRequired,
        prefixCls: prefixCls,
        vertical: vertical
    })), /*#__PURE__*/ $acw62.createElement((0, $1c2fb1c8dfed9a89$export$2e2bcd8739ae039), Object.assign({}, props, meta, {
        errors: debounceErrors,
        warnings: debounceWarnings,
        prefixCls: prefixCls,
        status: mergedValidateStatus,
        help: help,
        marginBottom: marginBottom,
        onErrorVisibleChanged: onErrorVisibleChanged
    }), /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$d718247e9f9b0b9e).Provider, {
        value: onSubItemMetaChange
    }, /*#__PURE__*/ $acw62.createElement((0, $ba46d4357a9f33ef$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        meta: meta,
        errors: meta.errors,
        warnings: meta.warnings,
        hasFeedback: hasFeedback,
        // Already calculated
        validateStatus: mergedValidateStatus,
        name: name
    }, children)))), !!marginBottom && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${itemPrefixCls}-margin-offset`,
        style: {
            marginBottom: -marginBottom
        }
    }));
}



"use client";
const $8713ccd60b7fb61a$var$NAME_SPLIT = '__SPLIT__';
const $8713ccd60b7fb61a$var$_ValidateStatuses = [
    'success',
    'warning',
    'error',
    'validating',
    ''
];
// https://github.com/ant-design/ant-design/issues/46417
// `getValueProps` may modify the value props name,
// we should check if the control is similar.
function $8713ccd60b7fb61a$var$isSimilarControl(a, b) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    return keysA.length === keysB.length && keysA.every((key)=>{
        const propValueA = a[key];
        const propValueB = b[key];
        return propValueA === propValueB || typeof propValueA === 'function' || typeof propValueB === 'function';
    });
}
const $8713ccd60b7fb61a$var$MemoInput = /*#__PURE__*/ $acw62.memo(({ children: children })=>children, (prev, next)=>$8713ccd60b7fb61a$var$isSimilarControl(prev.control, next.control) && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every((value, index)=>value === next.childProps[index]));
function $8713ccd60b7fb61a$var$genEmptyMeta() {
    return {
        errors: [],
        warnings: [],
        touched: false,
        validating: false,
        name: [],
        validated: false
    };
}
function $8713ccd60b7fb61a$var$InternalFormItem(props) {
    const { name: name, noStyle: noStyle, className: className, dependencies: dependencies, prefixCls: customizePrefixCls, shouldUpdate: shouldUpdate, rules: rules, children: children, required: required, label: label, messageVariables: messageVariables, trigger: trigger = 'onChange', validateTrigger: validateTrigger, hidden: hidden, help: help, layout: layout } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { name: formName } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    const mergedChildren = (0, $6d72a014848b02ce$export$2e2bcd8739ae039)(children);
    const isRenderProps = typeof mergedChildren === 'function';
    const notifyParentMetaChange = $acw62.useContext((0, $ad5d550b51ac8abd$export$d718247e9f9b0b9e));
    const { validateTrigger: contextValidateTrigger } = $acw62.useContext((0, $186c9d6ed579317b$export$2e2bcd8739ae039));
    const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : contextValidateTrigger;
    const hasName = !(name === undefined || name === null);
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3f17b93d805dc813$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ========================= Warn =========================
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('Form.Item');
    // ========================= MISC =========================
    // Get `noStyle` required info
    const listContext = $acw62.useContext((0, $f81400e90cbb2e33$export$2e2bcd8739ae039));
    const fieldKeyPathRef = $acw62.useRef(null);
    // ======================== Errors ========================
    // >>>>> Collect sub field errors
    const [subFieldErrors, setSubFieldErrors] = (0, $bc695e48262f4f73$export$2e2bcd8739ae039)({});
    // >>>>> Current field errors
    const [meta, setMeta] = (0, $2afda9bbeda7c3e0$export$2e2bcd8739ae039)(()=>$8713ccd60b7fb61a$var$genEmptyMeta());
    const onMetaChange = (nextMeta)=>{
        // This keyInfo is not correct when field is removed
        // Since origin keyManager no longer keep the origin key anymore
        // Which means we need cache origin one and reuse when removed
        const keyInfo = listContext === null || listContext === void 0 ? void 0 : listContext.getKey(nextMeta.name);
        // Destroy will reset all the meta
        setMeta(nextMeta.destroy ? $8713ccd60b7fb61a$var$genEmptyMeta() : nextMeta, true);
        // Bump to parent since noStyle
        if (noStyle && help !== false && notifyParentMetaChange) {
            let namePath = nextMeta.name;
            if (!nextMeta.destroy) {
                if (keyInfo !== undefined) {
                    const [fieldKey, restPath] = keyInfo;
                    namePath = [
                        fieldKey
                    ].concat((0, $df4024303de6487a$export$2e2bcd8739ae039)(restPath));
                    fieldKeyPathRef.current = namePath;
                }
            } else // Use origin cache data
            namePath = fieldKeyPathRef.current || namePath;
            notifyParentMetaChange(nextMeta, namePath);
        }
    };
    // >>>>> Collect noStyle Field error to the top FormItem
    const onSubItemMetaChange = (subMeta, uniqueKeys)=>{
        // Only `noStyle` sub item will trigger
        setSubFieldErrors((prevSubFieldErrors)=>{
            const clone = Object.assign({}, prevSubFieldErrors);
            // name: ['user', 1] + key: [4] = ['user', 4]
            const mergedNamePath = [].concat((0, $df4024303de6487a$export$2e2bcd8739ae039)(subMeta.name.slice(0, -1)), (0, $df4024303de6487a$export$2e2bcd8739ae039)(uniqueKeys));
            const mergedNameKey = mergedNamePath.join($8713ccd60b7fb61a$var$NAME_SPLIT);
            if (subMeta.destroy) // Remove
            delete clone[mergedNameKey];
            else // Update
            clone[mergedNameKey] = subMeta;
            return clone;
        });
    };
    // >>>>> Get merged errors
    const [mergedErrors, mergedWarnings] = $acw62.useMemo(()=>{
        const errorList = (0, $df4024303de6487a$export$2e2bcd8739ae039)(meta.errors);
        const warningList = (0, $df4024303de6487a$export$2e2bcd8739ae039)(meta.warnings);
        Object.values(subFieldErrors).forEach((subFieldError)=>{
            errorList.push.apply(errorList, (0, $df4024303de6487a$export$2e2bcd8739ae039)(subFieldError.errors || []));
            warningList.push.apply(warningList, (0, $df4024303de6487a$export$2e2bcd8739ae039)(subFieldError.warnings || []));
        });
        return [
            errorList,
            warningList
        ];
    }, [
        subFieldErrors,
        meta.errors,
        meta.warnings
    ]);
    // ===================== Children Ref =====================
    const getItemRef = (0, $3c7d21c38713ea5c$export$2e2bcd8739ae039)();
    // ======================== Render ========================
    function renderLayout(baseChildren, fieldId, isRequired) {
        if (noStyle && !hidden) return /*#__PURE__*/ $acw62.createElement((0, $ba46d4357a9f33ef$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            hasFeedback: props.hasFeedback,
            validateStatus: props.validateStatus,
            meta: meta,
            errors: mergedErrors,
            warnings: mergedWarnings,
            noStyle: true,
            name: name
        }, baseChildren);
        return /*#__PURE__*/ $acw62.createElement((0, $046eb12d049399e0$export$2e2bcd8739ae039), Object.assign({
            key: "row"
        }, props, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, cssVarCls, rootCls, hashId),
            prefixCls: prefixCls,
            fieldId: fieldId,
            isRequired: isRequired,
            errors: mergedErrors,
            warnings: mergedWarnings,
            meta: meta,
            onSubItemMetaChange: onSubItemMetaChange,
            layout: layout,
            name: name
        }), baseChildren);
    }
    if (!hasName && !isRenderProps && !dependencies) return wrapCSSVar(renderLayout(mergedChildren));
    let variables = {};
    if (typeof label === 'string') variables.label = label;
    else if (name) variables.label = String(name);
    if (messageVariables) variables = Object.assign(Object.assign({}, variables), messageVariables);
    // >>>>> With Field
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $3299c229146a7fb5$export$2e2bcd8739ae039), Object.assign({}, props, {
        messageVariables: variables,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange
    }), (control, renderMeta, context)=>{
        const mergedName = (0, $43291396832d20f3$export$45b10814cc054894)(name).length && renderMeta ? renderMeta.name : [];
        const fieldId = (0, $43291396832d20f3$export$f4457e83c74ac000)(mergedName, formName);
        const isRequired = required !== undefined ? required : !!(rules === null || rules === void 0 ? void 0 : rules.some((rule)=>{
            if (rule && typeof rule === 'object' && rule.required && !rule.warningOnly) return true;
            if (typeof rule === 'function') {
                const ruleEntity = rule(context);
                return (ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.required) && !(ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.warningOnly);
            }
            return false;
        }));
        // ======================= Children =======================
        const mergedControl = Object.assign({}, control);
        let childNode = null;
        if (Array.isArray(mergedChildren) && hasName) childNode = mergedChildren;
        else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) ;
        else if (dependencies && !isRenderProps && !hasName) ;
        else if (/*#__PURE__*/ $acw62.isValidElement(mergedChildren)) {
            const childProps = Object.assign(Object.assign({}, mergedChildren.props), mergedControl);
            if (!childProps.id) childProps.id = fieldId;
            if (help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
                const describedbyArr = [];
                if (help || mergedErrors.length > 0) describedbyArr.push(`${fieldId}_help`);
                if (props.extra) describedbyArr.push(`${fieldId}_extra`);
                childProps['aria-describedby'] = describedbyArr.join(' ');
            }
            if (mergedErrors.length > 0) childProps['aria-invalid'] = 'true';
            if (isRequired) childProps['aria-required'] = 'true';
            if ((0, $f1965a9a7a1fe067$export$c1cec34af06bcf7)(mergedChildren)) childProps.ref = getItemRef(mergedName, mergedChildren);
            // We should keep user origin event handler
            const triggers = new Set([].concat((0, $df4024303de6487a$export$2e2bcd8739ae039)((0, $43291396832d20f3$export$45b10814cc054894)(trigger)), (0, $df4024303de6487a$export$2e2bcd8739ae039)((0, $43291396832d20f3$export$45b10814cc054894)(mergedValidateTrigger))));
            triggers.forEach((eventName)=>{
                childProps[eventName] = (...args)=>{
                    var _a2, _c2;
                    var _a, _b, _c;
                    (_a = mergedControl[eventName]) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        mergedControl
                    ].concat(args));
                    (_c = (_b = mergedChildren.props)[eventName]) === null || _c === void 0 || (_c2 = _c).call.apply(_c2, [
                        _b
                    ].concat(args));
                };
            });
            // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
            const watchingChildProps = [
                childProps['aria-required'],
                childProps['aria-invalid'],
                childProps['aria-describedby']
            ];
            childNode = /*#__PURE__*/ $acw62.createElement($8713ccd60b7fb61a$var$MemoInput, {
                control: mergedControl,
                update: mergedChildren,
                childProps: watchingChildProps
            }, (0, $30796c32f374b477$export$e530037191fcd5d7)(mergedChildren, childProps));
        } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) childNode = mergedChildren(context);
        else childNode = mergedChildren;
        return renderLayout(childNode, fieldId, isRequired);
    }));
}
const $8713ccd60b7fb61a$var$FormItem = $8713ccd60b7fb61a$var$InternalFormItem;
$8713ccd60b7fb61a$var$FormItem.useStatus = (0, $c23052ca479f865f$export$2e2bcd8739ae039);
var $8713ccd60b7fb61a$export$2e2bcd8739ae039 = $8713ccd60b7fb61a$var$FormItem;



var $acw62 = parcelRequire("acw62");




"use client";
var $3a42708cb1545f12$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3a42708cb1545f12$var$FormList = (_a)=>{
    var { prefixCls: customizePrefixCls, children: children } = _a, props = $3a42708cb1545f12$var$__rest(_a, [
        "prefixCls",
        "children"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    const contextValue = $acw62.useMemo(()=>({
            prefixCls: prefixCls,
            status: 'error'
        }), [
        prefixCls
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $1ad2b0235e0eb0b7$export$2e2bcd8739ae039), Object.assign({}, props), (fields, operation, meta)=>/*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$fb6582d3042cc879).Provider, {
            value: contextValue
        }, children(fields.map((field)=>Object.assign(Object.assign({}, field), {
                fieldKey: field.key
            })), operation, {
            errors: meta.errors,
            warnings: meta.warnings
        })));
};
var $3a42708cb1545f12$export$2e2bcd8739ae039 = $3a42708cb1545f12$var$FormList;



var $acw62 = parcelRequire("acw62");

function $a4f42b2c91c59125$export$2e2bcd8739ae039() {
    const { form: form } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    return form;
}


"use client";
const $38feeba41dc3d65b$var$Form = (0, $69a0bf7fe3d99aff$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.Item = (0, $8713ccd60b7fb61a$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.List = (0, $3a42708cb1545f12$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.ErrorList = (0, $2cd7502dce089e1a$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.useForm = (0, $4c36311913591211$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.useFormInstance = (0, $a4f42b2c91c59125$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.useWatch = (0, $c40fe08ecbe59c71$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.Provider = (0, $ad5d550b51ac8abd$export$8ce1ff4f94d08846);
$38feeba41dc3d65b$var$Form.create = ()=>{};
var $38feeba41dc3d65b$export$2e2bcd8739ae039 = $38feeba41dc3d65b$var$Form;


var $acw62 = parcelRequire("acw62");





"use client";
/** @deprecated Please use `Space.Compact` */ const $ae15c91e7f32cbed$var$Group = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className } = props;
    const prefixCls = getPrefixCls('input-group', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input');
    const [wrapCSSVar, hashId, cssVarCls] = (0, $232788b5c0fca573$export$2e2bcd8739ae039)(inputPrefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, cssVarCls, {
        [`${prefixCls}-lg`]: props.size === 'large',
        [`${prefixCls}-sm`]: props.size === 'small',
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, className);
    const formItemContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const groupFormItemContext = (0, $acw62.useMemo)(()=>Object.assign(Object.assign({}, formItemContext), {
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("span", {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, props.children)));
};
var $ae15c91e7f32cbed$export$2e2bcd8739ae039 = $ae15c91e7f32cbed$var$Group;



var $acw62 = parcelRequire("acw62");
















var $acw62 = parcelRequire("acw62");
function $e424ea760f35b51a$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $acw62.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute('type')) === 'password' && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute('value'))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute('value');
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, []);
    return removePasswordTimeout;
}



function $23144ccd376634c7$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}


"use client";
var $538df197b854e6d1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $538df197b854e6d1$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classNames, variant: customVariant } = props, rest = $538df197b854e6d1$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "style",
        "styles",
        "rootClassName",
        "onChange",
        "classNames",
        "variant"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('input');
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    const inputRef = (0, $acw62.useRef)(null);
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapSharedCSSVar, hashId, cssVarCls] = (0, $232788b5c0fca573$export$de732caeaad5f68e)(prefixCls, rootClassName);
    const [wrapCSSVar] = (0, $232788b5c0fca573$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customSize !== null && customSize !== void 0 ? customSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $23144ccd376634c7$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    const prevHasPrefixSuffix = (0, $acw62.useRef)(inputHasPrefixSuffix);
    var _a;
    /* eslint-enable */ // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $e424ea760f35b51a$export$2e2bcd8739ae039)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, $f9fe093fa4df8f6d$export$2e2bcd8739ae039)(allowClear !== null && allowClear !== void 0 ? allowClear : contextAllowClear);
    const [variant, enableVariantCls] = (0, $ce4103032ab2fd5e$export$2e2bcd8739ae039)('input', customVariant, bordered);
    return wrapSharedCSSVar(wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93b8a86f8ed15614$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $f1965a9a7a1fe067$export$ab452c34e8e05029)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: contextAutoComplete
    }, rest, {
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: Object.assign(Object.assign({}, contextStyle), style),
        styles: Object.assign(Object.assign({}, contextStyles), styles),
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonAfter),
        classNames: Object.assign(Object.assign(Object.assign({}, classNames), contextClassNames), {
            input: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large',
                [`${prefixCls}-rtl`]: direction === 'rtl'
            }, classNames === null || classNames === void 0 ? void 0 : classNames.input, contextClassNames.input, hashId),
            variant: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl'
            }, hashId),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-group-rtl`]: direction === 'rtl'
            }, hashId),
            groupWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        })
    }))));
});
var $538df197b854e6d1$export$2e2bcd8739ae039 = $538df197b854e6d1$var$Input;




var $acw62 = parcelRequire("acw62");



var $c9d5a0479fbb39e9$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $c9d5a0479fbb39e9$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $c9d5a0479fbb39e9$var$propList = "".concat($c9d5a0479fbb39e9$var$attributes, " ").concat($c9d5a0479fbb39e9$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $c9d5a0479fbb39e9$var$ariaPrefix = 'aria-';
var $c9d5a0479fbb39e9$var$dataPrefix = 'data-';
function $c9d5a0479fbb39e9$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $c9d5a0479fbb39e9$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $784b8130b41ca462$export$2e2bcd8739ae039)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === 'role' || $c9d5a0479fbb39e9$var$match(key, $c9d5a0479fbb39e9$var$ariaPrefix)) || // Data
        mergedConfig.data && $c9d5a0479fbb39e9$var$match(key, $c9d5a0479fbb39e9$var$dataPrefix) || // Attr
        mergedConfig.attr && $c9d5a0479fbb39e9$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}









// =============================== OTP ================================
const $342237063413aff3$var$genOTPStyle = (token)=>{
    const { componentCls: componentCls, paddingXS: paddingXS } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            columnGap: paddingXS,
            [`${componentCls}-input-wrapper`]: {
                position: 'relative',
                [`${componentCls}-mask-icon`]: {
                    position: 'absolute',
                    zIndex: '1',
                    top: '50%',
                    right: '50%',
                    transform: 'translate(50%, -50%)',
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask-input`]: {
                    color: 'transparent',
                    caretColor: 'var(--ant-color-text)'
                },
                [`${componentCls}-mask-input[type=number]::-webkit-inner-spin-button`]: {
                    '-webkit-appearance': 'none',
                    margin: 0
                },
                [`${componentCls}-mask-input[type=number]`]: {
                    '-moz-appearance': 'textfield'
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            [`${componentCls}-input`]: {
                textAlign: 'center',
                paddingInline: token.paddingXXS
            },
            // ================= Size =================
            [`&${componentCls}-sm ${componentCls}-input`]: {
                paddingInline: token.calc(token.paddingXXS).div(2).equal()
            },
            [`&${componentCls}-lg ${componentCls}-input`]: {
                paddingInline: token.paddingXS
            }
        }
    };
};
var // ============================== Export ==============================
$342237063413aff3$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)([
    'Input',
    'OTP'
], (token)=>{
    const inputToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return [
        $342237063413aff3$var$genOTPStyle(inputToken)
    ];
}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781));



var $acw62 = parcelRequire("acw62");




"use client";
var $f02194bc3f3a92de$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f02194bc3f3a92de$var$OTPInput = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { className: className, value: value, onChange: onChange, onActiveChange: onActiveChange, index: index, mask: mask } = props, restProps = $f02194bc3f3a92de$var$__rest(props, [
        "className",
        "value",
        "onChange",
        "onActiveChange",
        "index",
        "mask"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('otp');
    const maskValue = typeof mask === 'string' ? mask : value;
    // ========================== Ref ===========================
    const inputRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>inputRef.current);
    // ========================= Input ==========================
    const onInternalChange = (e)=>{
        onChange(index, e.target.value);
    };
    // ========================= Focus ==========================
    const syncSelection = ()=>{
        (0, $2b9f066ea00dd1c7$export$2e2bcd8739ae039)(()=>{
            var _a;
            const inputEle = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input;
            if (document.activeElement === inputEle && inputEle) inputEle.select();
        });
    };
    // ======================== Keyboard ========================
    const onInternalKeyDown = (event)=>{
        const { key: key, ctrlKey: ctrlKey, metaKey: metaKey } = event;
        if (key === 'ArrowLeft') onActiveChange(index - 1);
        else if (key === 'ArrowRight') onActiveChange(index + 1);
        else if (key === 'z' && (ctrlKey || metaKey)) event.preventDefault();
        syncSelection();
    };
    const onInternalKeyUp = (e)=>{
        if (e.key === 'Backspace' && !value) onActiveChange(index - 1);
        syncSelection();
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-input-wrapper`,
        role: "presentation"
    }, mask && value !== '' && value !== undefined && /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-mask-icon`,
        "aria-hidden": "true"
    }, maskValue), /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), Object.assign({
        "aria-label": `OTP Input ${index + 1}`,
        type: mask === true ? 'password' : 'text'
    }, restProps, {
        ref: inputRef,
        value: value,
        onInput: onInternalChange,
        onFocus: syncSelection,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onMouseDown: syncSelection,
        onMouseUp: syncSelection,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, {
            [`${prefixCls}-mask-input`]: mask
        })
    })));
});
var $f02194bc3f3a92de$export$2e2bcd8739ae039 = $f02194bc3f3a92de$var$OTPInput;


"use client";
var $a41c5ef9ac79dcae$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $a41c5ef9ac79dcae$var$strToArr(str) {
    return (str || '').split('');
}
const $a41c5ef9ac79dcae$var$Separator = (props)=>{
    const { index: index, prefixCls: prefixCls, separator: separator } = props;
    const separatorNode = typeof separator === 'function' ? separator(index) : separator;
    if (!separatorNode) return null;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-separator`
    }, separatorNode);
};
const $a41c5ef9ac79dcae$var$OTP = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, length: length = 6, size: customSize, defaultValue: defaultValue, value: value, onChange: onChange, formatter: formatter, separator: separator, variant: variant, disabled: disabled, status: customStatus, autoFocus: autoFocus, mask: mask, type: type, onInput: onInput, inputMode: inputMode } = props, restProps = $a41c5ef9ac79dcae$var$__rest(props, [
        "prefixCls",
        "length",
        "size",
        "defaultValue",
        "value",
        "onChange",
        "formatter",
        "separator",
        "variant",
        "disabled",
        "status",
        "autoFocus",
        "mask",
        "type",
        "onInput",
        "inputMode"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('otp', customizePrefixCls);
    const domAttrs = (0, $c9d5a0479fbb39e9$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true,
        attr: true
    });
    // ========================= Root =========================
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $342237063413aff3$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Size =========================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customSize !== null && customSize !== void 0 ? customSize : ctx);
    // ======================== Status ========================
    const formContext = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(formContext.status, customStatus);
    const proxyFormContext = $acw62.useMemo(()=>Object.assign(Object.assign({}, formContext), {
            status: mergedStatus,
            hasFeedback: false,
            feedbackIcon: null
        }), [
        formContext,
        mergedStatus
    ]);
    // ========================= Refs =========================
    const containerRef = $acw62.useRef(null);
    const refs = $acw62.useRef({});
    $acw62.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                var _a;
                (_a = refs.current[0]) === null || _a === void 0 || _a.focus();
            },
            blur: ()=>{
                var _a;
                for(let i = 0; i < length; i += 1)(_a = refs.current[i]) === null || _a === void 0 || _a.blur();
            },
            nativeElement: containerRef.current
        }));
    // ======================= Formatter ======================
    const internalFormatter = (txt)=>formatter ? formatter(txt) : txt;
    // ======================== Values ========================
    const [valueCells, setValueCells] = $acw62.useState(()=>$a41c5ef9ac79dcae$var$strToArr(internalFormatter(defaultValue || '')));
    $acw62.useEffect(()=>{
        if (value !== undefined) setValueCells($a41c5ef9ac79dcae$var$strToArr(value));
    }, [
        value
    ]);
    const triggerValueCellsChange = (0, $e294208d67c27cfa$export$2e2bcd8739ae039)((nextValueCells)=>{
        setValueCells(nextValueCells);
        if (onInput) onInput(nextValueCells);
        // Trigger if all cells are filled
        if (onChange && nextValueCells.length === length && nextValueCells.every((c)=>c) && nextValueCells.some((c, index)=>valueCells[index] !== c)) onChange(nextValueCells.join(''));
    });
    const patchValue = (0, $e294208d67c27cfa$export$2e2bcd8739ae039)((index, txt)=>{
        let nextCells = (0, $df4024303de6487a$export$2e2bcd8739ae039)(valueCells);
        // Fill cells till index
        for(let i = 0; i < index; i += 1)if (!nextCells[i]) nextCells[i] = '';
        if (txt.length <= 1) nextCells[index] = txt;
        else nextCells = nextCells.slice(0, index).concat($a41c5ef9ac79dcae$var$strToArr(txt));
        nextCells = nextCells.slice(0, length);
        // Clean the last empty cell
        for(let i = nextCells.length - 1; i >= 0; i -= 1){
            if (nextCells[i]) break;
            nextCells.pop();
        }
        // Format if needed
        const formattedValue = internalFormatter(nextCells.map((c)=>c || ' ').join(''));
        nextCells = $a41c5ef9ac79dcae$var$strToArr(formattedValue).map((c, i)=>{
            if (c === ' ' && !nextCells[i]) return nextCells[i];
            return c;
        });
        return nextCells;
    });
    // ======================== Change ========================
    const onInputChange = (index, txt)=>{
        var _a;
        const nextCells = patchValue(index, txt);
        const nextIndex = Math.min(index + txt.length, length - 1);
        if (nextIndex !== index && nextCells[index] !== undefined) (_a = refs.current[nextIndex]) === null || _a === void 0 || _a.focus();
        triggerValueCellsChange(nextCells);
    };
    const onInputActiveChange = (nextIndex)=>{
        var _a;
        (_a = refs.current[nextIndex]) === null || _a === void 0 || _a.focus();
    };
    // ======================== Render ========================
    const inputSharedProps = {
        variant: variant,
        disabled: disabled,
        status: mergedStatus,
        mask: mask,
        type: type,
        inputMode: inputMode
    };
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({}, domAttrs, {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, cssVarCls, hashId),
        role: "group"
    }), /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Provider, {
        value: proxyFormContext
    }, Array.from({
        length: length
    }).map((_, index)=>{
        const key = `otp-${index}`;
        const singleValue = valueCells[index] || '';
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
            key: key
        }, /*#__PURE__*/ $acw62.createElement((0, $f02194bc3f3a92de$export$2e2bcd8739ae039), Object.assign({
            ref: (inputEle)=>{
                refs.current[index] = inputEle;
            },
            index: index,
            size: mergedSize,
            htmlSize: 1,
            className: `${prefixCls}-input`,
            onChange: onInputChange,
            value: singleValue,
            onActiveChange: onInputActiveChange,
            autoFocus: index === 0 && autoFocus
        }, inputSharedProps)), index < length - 1 && /*#__PURE__*/ $acw62.createElement($a41c5ef9ac79dcae$var$Separator, {
            separator: separator,
            index: index,
            prefixCls: prefixCls
        }));
    }))));
});
var $a41c5ef9ac79dcae$export$2e2bcd8739ae039 = $a41c5ef9ac79dcae$var$OTP;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $70c4e92fea0b3f8a$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $70c4e92fea0b3f8a$export$2e2bcd8739ae039 = $70c4e92fea0b3f8a$var$EyeInvisibleOutlined;



var $48f4fe50ff6ca9c8$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $70c4e92fea0b3f8a$export$2e2bcd8739ae039)
    }));
};
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ var $48f4fe50ff6ca9c8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($48f4fe50ff6ca9c8$var$EyeInvisibleOutlined);
var $48f4fe50ff6ca9c8$export$2e2bcd8739ae039 = $48f4fe50ff6ca9c8$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $b7bc758130af6b02$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $b7bc758130af6b02$export$2e2bcd8739ae039 = $b7bc758130af6b02$var$EyeOutlined;



var $d8a9efd7a074f5f5$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $b7bc758130af6b02$export$2e2bcd8739ae039)
    }));
};
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ var $d8a9efd7a074f5f5$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($d8a9efd7a074f5f5$var$EyeOutlined);
var $d8a9efd7a074f5f5$export$2e2bcd8739ae039 = $d8a9efd7a074f5f5$var$RefIcon;









"use client";
var $27b11b4fcd97a00b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $27b11b4fcd97a00b$var$defaultIconRender = (visible)=>visible ? /*#__PURE__*/ $acw62.createElement((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $48f4fe50ff6ca9c8$export$2e2bcd8739ae039), null);
const $27b11b4fcd97a00b$var$actionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
const $27b11b4fcd97a00b$var$Password = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { disabled: customDisabled, action: action = 'click', visibilityToggle: visibilityToggle = true, iconRender: iconRender = $27b11b4fcd97a00b$var$defaultIconRender } = props;
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const visibilityControlled = typeof visibilityToggle === 'object' && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, $acw62.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, $acw62.useRef)(null);
    $acw62.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, $e424ea760f35b51a$export$2e2bcd8739ae039)(inputRef);
    const onVisibleChange = ()=>{
        var _a;
        if (mergedDisabled) return;
        if (visible) removePasswordTimeout();
        const nextVisible = !visible;
        setVisible(nextVisible);
        if (typeof visibilityToggle === 'object') (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 || _a.call(visibilityToggle, nextVisible);
    };
    const getIcon = (prefixCls)=>{
        const iconTrigger = $27b11b4fcd97a00b$var$actionMap[action] || '';
        const icon = iconRender(visible);
        const iconProps = {
            [iconTrigger]: onVisibleChange,
            className: `${prefixCls}-icon`,
            key: 'passwordIcon',
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            }
        };
        return /*#__PURE__*/ $acw62.cloneElement(/*#__PURE__*/ $acw62.isValidElement(icon) ? icon : /*#__PURE__*/ $acw62.createElement("span", null, icon), iconProps);
    };
    const { className: className, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, size: size } = props, restProps = $27b11b4fcd97a00b$var$__rest(props, [
        "className",
        "prefixCls",
        "inputPrefixCls",
        "size"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const prefixCls = getPrefixCls('input-password', customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, {
        [`${prefixCls}-${size}`]: !!size
    });
    const omittedProps = Object.assign(Object.assign({}, (0, $57c22a5a2f343bca$export$2e2bcd8739ae039)(restProps, [
        'suffix',
        'iconRender',
        'visibilityToggle'
    ])), {
        type: visible ? 'text' : 'password',
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: suffixIcon
    });
    if (size) omittedProps.size = size;
    return /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $f1965a9a7a1fe067$export$ab452c34e8e05029)(ref, inputRef)
    }, omittedProps));
});
var $27b11b4fcd97a00b$export$2e2bcd8739ae039 = $27b11b4fcd97a00b$var$Password;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $86af1367b2b71ab8$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $86af1367b2b71ab8$export$2e2bcd8739ae039 = $86af1367b2b71ab8$var$SearchOutlined;



var $f7392a88184334dd$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $86af1367b2b71ab8$export$2e2bcd8739ae039)
    }));
};
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ var $f7392a88184334dd$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f7392a88184334dd$var$SearchOutlined);
var $f7392a88184334dd$export$2e2bcd8739ae039 = $f7392a88184334dd$var$RefIcon;










"use client";
var $22717f99dfeb0b1a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $22717f99dfeb0b1a$var$Search = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className: className, size: customizeSize, suffix: suffix, enterButton: enterButton = false, addonAfter: addonAfter, loading: loading, disabled: disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, variant: variant, onPressEnter: customOnPressEnter } = props, restProps = $22717f99dfeb0b1a$var$__rest(props, [
        "prefixCls",
        "inputPrefixCls",
        "className",
        "size",
        "suffix",
        "enterButton",
        "addonAfter",
        "loading",
        "disabled",
        "onSearch",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd",
        "variant",
        "onPressEnter"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const composedRef = $acw62.useRef(false);
    const prefixCls = getPrefixCls('input-search', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const { compactSize: compactSize } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const size = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    const inputRef = $acw62.useRef(null);
    const onChange = (e)=>{
        if ((e === null || e === void 0 ? void 0 : e.target) && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e, {
            source: 'clear'
        });
        customOnChange === null || customOnChange === void 0 || customOnChange(e);
    };
    const onMouseDown = (e)=>{
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) e.preventDefault();
    };
    const onSearch = (e)=>{
        var _a, _b;
        if (customOnSearch) customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e, {
            source: 'input'
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        customOnPressEnter === null || customOnPressEnter === void 0 || customOnPressEnter(e);
        onSearch(e);
    };
    const searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/ $acw62.createElement((0, $f7392a88184334dd$export$2e2bcd8739ae039), null) : null;
    const btnClassName = `${prefixCls}-button`;
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') button = (0, $30796c32f374b477$export$e530037191fcd5d7)(enterButtonAsElement, Object.assign({
        onMouseDown: onMouseDown,
        onClick: (e)=>{
            var _a, _b;
            (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            onSearch(e);
        },
        key: 'enterButton'
    }, isAntdButton ? {
        className: btnClassName,
        size: size
    } : {}));
    else button = /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
        className: btnClassName,
        color: enterButton ? 'primary' : 'default',
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon,
        variant: variant === 'borderless' || variant === 'filled' || variant === 'underlined' ? 'text' : enterButton ? 'solid' : undefined
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $30796c32f374b477$export$e530037191fcd5d7)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className);
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    const inputProps = Object.assign(Object.assign({}, restProps), {
        className: cls,
        prefixCls: inputPrefixCls,
        type: 'search',
        size: size,
        variant: variant,
        onPressEnter: onPressEnter,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        addonAfter: button,
        suffix: suffix,
        onChange: onChange,
        disabled: disabled
    });
    return /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $f1965a9a7a1fe067$export$ab452c34e8e05029)(inputRef, ref)
    }, inputProps));
});
var $22717f99dfeb0b1a$export$2e2bcd8739ae039 = $22717f99dfeb0b1a$var$Search;



"use client";
const $ad70426818bb52aa$var$Input = (0, $538df197b854e6d1$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Group = (0, $ae15c91e7f32cbed$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Search = (0, $22717f99dfeb0b1a$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.TextArea = (0, $fc29eec8796e8593$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Password = (0, $27b11b4fcd97a00b$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.OTP = (0, $a41c5ef9ac79dcae$export$2e2bcd8739ae039);
var $ad70426818bb52aa$export$2e2bcd8739ae039 = $ad70426818bb52aa$var$Input;



parcelRequire("acw62");
const { Text: $303f84e1345ee0d8$var$Text } = (0, $69754065fe3b4b60$export$2e2bcd8739ae039);
const $303f84e1345ee0d8$var$Login = (0, $9d5e52e8f220d71a$export$dfb5619354ba860)((props)=>{
    const { store: store } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039), {
        labelCol: {
            span: 8
        },
        wrapperCol: {
            span: 8
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                label: "Server",
                required: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                    onChange: (e)=>{
                        store.server = e.target.value;
                    },
                    value: store.server
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                label: "Client ID",
                required: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                    onChange: (e)=>{
                        store.clientId = e.target.value;
                    },
                    value: store.clientId
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                label: "Client Secret",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).Password, {
                    onChange: (e)=>{
                        store.clientSecret = e.target.value;
                    },
                    value: store.clientSecret
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                wrapperCol: {
                    offset: 8,
                    span: 16
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    type: "primary",
                    onClick: ()=>store.authCodeFlow(),
                    children: "Auth Code Flow"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                wrapperCol: {
                    offset: 8,
                    span: 16
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($303f84e1345ee0d8$var$Text, {
                    type: "secondary",
                    children: [
                        "Note: Set redirect URI to",
                        " ",
                        globalThis.location.origin + globalThis.location.pathname,
                        "callback.html"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                children: "OR"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                label: "JWT Token",
                required: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).Password, {
                    onChange: (e)=>{
                        store.jwtToken = e.target.value;
                    },
                    value: store.jwtToken
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                wrapperCol: {
                    offset: 8,
                    span: 16
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    type: "primary",
                    onClick: ()=>store.jwtFlow(),
                    children: "Personal JWT Flow"
                })
            })
        ]
    });
});
var $303f84e1345ee0d8$export$2e2bcd8739ae039 = $303f84e1345ee0d8$var$Login;




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



"use client";
const $148bd952cb1a5a76$var$Empty = ()=>{
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('Empty');
    const bgColor = new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(token.colorBgBase);
    // Dark Theme need more dark of this
    const themeStyle = bgColor.toHsl().l < 0.5 ? {
        opacity: 0.65
    } : {};
    return /*#__PURE__*/ $acw62.createElement("svg", {
        style: themeStyle,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("title", null, (locale === null || locale === void 0 ? void 0 : locale.description) || 'Empty'), /*#__PURE__*/ $acw62.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        fillOpacity: ".8",
        fill: "#F5F5F7",
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
        fill: "#AEB8C2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        fill: "url(#linearGradient-1)",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
        fill: "#F5F5F7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
        fill: "#DCE0E6"
    })), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
        fill: "#DCE0E6"
    }), /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(149.65 15.383)",
        fill: "#FFF"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $148bd952cb1a5a76$export$2e2bcd8739ae039 = $148bd952cb1a5a76$var$Empty;



var $acw62 = parcelRequire("acw62");



"use client";
const $ae7f97f0fd68830c$var$Simple = ()=>{
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('Empty');
    const { colorFill: colorFill, colorFillTertiary: colorFillTertiary, colorFillQuaternary: colorFillQuaternary, colorBgContainer: colorBgContainer } = token;
    const { borderColor: borderColor, shadowColor: shadowColor, contentColor: contentColor } = (0, $acw62.useMemo)(()=>({
            borderColor: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorFill).onBackground(colorBgContainer).toHexString(),
            shadowColor: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorFillTertiary).onBackground(colorBgContainer).toHexString(),
            contentColor: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(colorFillQuaternary).onBackground(colorBgContainer).toHexString()
        }), [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]);
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("title", null, (locale === null || locale === void 0 ? void 0 : locale.description) || 'Empty'), /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $acw62.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        fill: contentColor
    }))));
};
var $ae7f97f0fd68830c$export$2e2bcd8739ae039 = $ae7f97f0fd68830c$var$Simple;



// ============================== Shared ==============================
const $ee15fc052b6837a1$var$genSharedEmptyStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, marginXS: marginXS, marginXL: marginXL, fontSize: fontSize, lineHeight: lineHeight } = token;
    return {
        [componentCls]: {
            marginInline: marginXS,
            fontSize: fontSize,
            lineHeight: lineHeight,
            textAlign: 'center',
            // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-image`]: {
                height: token.emptyImgHeight,
                marginBottom: marginXS,
                opacity: token.opacityImage,
                img: {
                    height: '100%'
                },
                svg: {
                    maxWidth: '100%',
                    height: '100%',
                    margin: 'auto'
                }
            },
            [`${componentCls}-description`]: {
                color: token.colorTextDescription
            },
            // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-footer`]: {
                marginTop: margin
            },
            '&-normal': {
                marginBlock: marginXL,
                color: token.colorTextDescription,
                [`${componentCls}-description`]: {
                    color: token.colorTextDescription
                },
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightMD
                }
            },
            '&-small': {
                marginBlock: marginXS,
                color: token.colorTextDescription,
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightSM
                }
            }
        }
    };
};
var // ============================== Export ==============================
$ee15fc052b6837a1$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Empty', (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, calc: calc } = token;
    const emptyToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        emptyImgCls: `${componentCls}-img`,
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return [
        $ee15fc052b6837a1$var$genSharedEmptyStyle(emptyToken)
    ];
});



"use client";
var $ec66348328372da5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ec66348328372da5$var$defaultEmptyImg = /*#__PURE__*/ $acw62.createElement((0, $148bd952cb1a5a76$export$2e2bcd8739ae039), null);
const $ec66348328372da5$var$simpleEmptyImg = /*#__PURE__*/ $acw62.createElement((0, $ae7f97f0fd68830c$export$2e2bcd8739ae039), null);
const $ec66348328372da5$var$Empty = (props)=>{
    const { className: className, rootClassName: rootClassName, prefixCls: customizePrefixCls, image: image = $ec66348328372da5$var$defaultEmptyImg, description: description, children: children, imageStyle: imageStyle, style: style, classNames: emptyClassNames, styles: styles } = props, restProps = $ec66348328372da5$var$__rest(props, [
        "className",
        "rootClassName",
        "prefixCls",
        "image",
        "description",
        "children",
        "imageStyle",
        "style",
        "classNames",
        "styles"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('empty');
    const prefixCls = getPrefixCls('empty', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $ee15fc052b6837a1$export$2e2bcd8739ae039)(prefixCls);
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('Empty');
    const des = typeof description !== 'undefined' ? description : locale === null || locale === void 0 ? void 0 : locale.description;
    const alt = typeof des === 'string' ? des : 'empty';
    let imageNode = null;
    if (typeof image === 'string') imageNode = /*#__PURE__*/ $acw62.createElement("img", {
        alt: alt,
        src: image
    });
    else imageNode = image;
    var deprecatedName, newName;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, cssVarCls, prefixCls, contextClassName, {
            [`${prefixCls}-normal`]: image === $ec66348328372da5$var$simpleEmptyImg,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, className, rootClassName, contextClassNames.root, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.root),
        style: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), styles === null || styles === void 0 ? void 0 : styles.root), style)
    }, restProps), /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-image`, contextClassNames.image, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.image),
        style: Object.assign(Object.assign(Object.assign({}, imageStyle), contextStyles.image), styles === null || styles === void 0 ? void 0 : styles.image)
    }, imageNode), des && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-description`, contextClassNames.description, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.description),
        style: Object.assign(Object.assign({}, contextStyles.description), styles === null || styles === void 0 ? void 0 : styles.description)
    }, des), children && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-footer`, contextClassNames.footer, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.footer),
        style: Object.assign(Object.assign({}, contextStyles.footer), styles === null || styles === void 0 ? void 0 : styles.footer)
    }, children)));
};
$ec66348328372da5$var$Empty.PRESENTED_IMAGE_DEFAULT = $ec66348328372da5$var$defaultEmptyImg;
$ec66348328372da5$var$Empty.PRESENTED_IMAGE_SIMPLE = $ec66348328372da5$var$simpleEmptyImg;
var $ec66348328372da5$export$2e2bcd8739ae039 = $ec66348328372da5$var$Empty;


var $acw62 = parcelRequire("acw62");



const $c676d8b8b586adda$export$15e5fca53711d340 = (propValue)=>{
    if (!propValue) return null;
    return typeof propValue === 'function' ? propValue() : propValue;
};







var $acw62 = parcelRequire("acw62");









const $7c34a58b2ba4d17c$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, popoverColor: popoverColor, titleMinWidth: titleMinWidth, fontWeightStrong: fontWeightStrong, innerPadding: innerPadding, boxShadowSecondary: boxShadowSecondary, colorTextHeading: colorTextHeading, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, titleMarginBottom: titleMarginBottom, colorBgElevated: colorBgElevated, popoverBg: popoverBg, titleBorderBottom: titleBorderBottom, innerContentPadding: innerContentPadding, titlePadding: titlePadding } = token;
    return [
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                position: 'absolute',
                top: 0,
                // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
                left: {
                    _skip_check_: true,
                    value: 0
                },
                zIndex: zIndexPopup,
                fontWeight: 'normal',
                whiteSpace: 'normal',
                textAlign: 'start',
                cursor: 'auto',
                userSelect: 'text',
                // When use `autoArrow`, origin will follow the arrow position
                '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
                transformOrigin: [
                    `var(--valid-offset-x, 50%)`,
                    `var(--arrow-y, 50%)`
                ].join(' '),
                '--antd-arrow-background-color': colorBgElevated,
                width: 'max-content',
                maxWidth: '100vw',
                '&-rtl': {
                    direction: 'rtl'
                },
                '&-hidden': {
                    display: 'none'
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                [`${componentCls}-inner`]: {
                    backgroundColor: popoverBg,
                    backgroundClip: 'padding-box',
                    borderRadius: borderRadiusLG,
                    boxShadow: boxShadowSecondary,
                    padding: innerPadding
                },
                [`${componentCls}-title`]: {
                    minWidth: titleMinWidth,
                    marginBottom: titleMarginBottom,
                    color: colorTextHeading,
                    fontWeight: fontWeightStrong,
                    borderBottom: titleBorderBottom,
                    padding: titlePadding
                },
                [`${componentCls}-inner-content`]: {
                    color: popoverColor,
                    padding: innerContentPadding
                }
            })
        },
        // Arrow Style
        (0, $13cd8c878b3c9176$export$2e2bcd8739ae039)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow,
                display: 'inline-block',
                [`${componentCls}-content`]: {
                    display: 'inline-block'
                }
            }
        }
    ];
};
const $7c34a58b2ba4d17c$var$genColorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).map((colorKey)=>{
            const lightColor = token[`${colorKey}6`];
            return {
                [`&${componentCls}-${colorKey}`]: {
                    '--antd-arrow-background-color': lightColor,
                    [`${componentCls}-inner`]: {
                        backgroundColor: lightColor
                    },
                    [`${componentCls}-arrow`]: {
                        background: 'transparent'
                    }
                }
            };
        })
    };
};
const $7c34a58b2ba4d17c$export$9ca1be8807fe0675 = (token)=>{
    const { lineWidth: lineWidth, controlHeight: controlHeight, fontHeight: fontHeight, padding: padding, wireframe: wireframe, zIndexPopupBase: zIndexPopupBase, borderRadiusLG: borderRadiusLG, marginXS: marginXS, lineType: lineType, colorSplit: colorSplit, paddingSM: paddingSM } = token;
    const titlePaddingBlockDist = controlHeight - fontHeight;
    const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
    const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
    const popoverPaddingHorizontal = padding;
    return Object.assign(Object.assign(Object.assign({
        titleMinWidth: 177,
        zIndexPopup: zIndexPopupBase + 30
    }, (0, $0c0596420865f622$export$87e38ee403661ccc)(token)), (0, $13cd8c878b3c9176$export$bddc192327bb9823)({
        contentRadius: borderRadiusLG,
        limitVerticalRadius: true
    })), {
        // internal
        innerPadding: wireframe ? 0 : 12,
        titleMarginBottom: wireframe ? 0 : marginXS,
        titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
        titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : 'none',
        innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
    });
};
var $7c34a58b2ba4d17c$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Popover', (token)=>{
    const { colorBgElevated: colorBgElevated, colorText: colorText } = token;
    const popoverToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        popoverBg: colorBgElevated,
        popoverColor: colorText
    });
    return [
        $7c34a58b2ba4d17c$var$genBaseStyle(popoverToken),
        $7c34a58b2ba4d17c$var$genColorStyle(popoverToken),
        (0, $d2082114d5952afb$export$f5d123412490d9dc)(popoverToken, 'zoom-big')
    ];
}, $7c34a58b2ba4d17c$export$9ca1be8807fe0675, {
    resetStyle: false,
    deprecatedTokens: [
        [
            'width',
            'titleMinWidth'
        ],
        [
            'minWidth',
            'titleMinWidth'
        ]
    ]
});


"use client";
var $b7a2edcc9afcf494$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b7a2edcc9afcf494$export$c6fdb837b070b4ff = ({ title: title, content: content, prefixCls: prefixCls })=>{
    if (!title && !content) return null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, title && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-title`
    }, title), content && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-inner-content`
    }, content));
};
const $b7a2edcc9afcf494$export$c40925af82c95d5b = (props)=>{
    const { hashId: hashId, prefixCls: prefixCls, className: className, style: style, placement: placement = 'top', title: title, content: content, children: children } = props;
    const titleNode = (0, $c676d8b8b586adda$export$15e5fca53711d340)(title);
    const contentNode = (0, $c676d8b8b586adda$export$15e5fca53711d340)(content);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: cls,
        style: style
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $acw62.createElement((0, $576260377b469890$export$2e2bcd8739ae039), Object.assign({}, props, {
        className: hashId,
        prefixCls: prefixCls
    }), children || /*#__PURE__*/ $acw62.createElement($b7a2edcc9afcf494$export$c6fdb837b070b4ff, {
        prefixCls: prefixCls,
        title: titleNode,
        content: contentNode
    })));
};
const $b7a2edcc9afcf494$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className } = props, restProps = $b7a2edcc9afcf494$var$__rest(props, [
        "prefixCls",
        "className"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $7c34a58b2ba4d17c$export$2e2bcd8739ae039)(prefixCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement($b7a2edcc9afcf494$export$c40925af82c95d5b, Object.assign({}, restProps, {
        prefixCls: prefixCls,
        hashId: hashId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, cssVarCls)
    })));
};
var $b7a2edcc9afcf494$export$2e2bcd8739ae039 = $b7a2edcc9afcf494$var$PurePanel;



"use client";
var $50a5b629c434844e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $50a5b629c434844e$var$InternalPopover = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, title: title, content: content, overlayClassName: overlayClassName, placement: placement = 'top', trigger: trigger = 'hover', children: children, mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, onOpenChange: onOpenChange, overlayStyle: overlayStyle = {}, styles: styles, classNames: popoverClassNames } = props, otherProps = $50a5b629c434844e$var$__rest(props, [
        "prefixCls",
        "title",
        "content",
        "overlayClassName",
        "placement",
        "trigger",
        "children",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "onOpenChange",
        "overlayStyle",
        "styles",
        "classNames"
    ]);
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('popover');
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $7c34a58b2ba4d17c$export$2e2bcd8739ae039)(prefixCls);
    const rootPrefixCls = getPrefixCls();
    const rootClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlayClassName, hashId, cssVarCls, contextClassName, contextClassNames.root, popoverClassNames === null || popoverClassNames === void 0 ? void 0 : popoverClassNames.root);
    const bodyClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(contextClassNames.body, popoverClassNames === null || popoverClassNames === void 0 ? void 0 : popoverClassNames.body);
    const [open, setOpen] = (0, $fbd33e1a3c597913$export$2e2bcd8739ae039)(false, {
        value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
        defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
    });
    const settingOpen = (value, e)=>{
        setOpen(value, true);
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(value, e);
    };
    const onKeyDown = (e)=>{
        if (e.keyCode === (0, $8804d91907a0eb43$export$2e2bcd8739ae039).ESC) settingOpen(false, e);
    };
    const onInternalOpenChange = (value)=>{
        settingOpen(value);
    };
    const titleNode = (0, $c676d8b8b586adda$export$15e5fca53711d340)(title);
    const contentNode = (0, $c676d8b8b586adda$export$15e5fca53711d340)(content);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), Object.assign({
        placement: placement,
        trigger: trigger,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay
    }, otherProps, {
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            body: bodyClassNames
        },
        styles: {
            root: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
            body: Object.assign(Object.assign({}, contextStyles.body), styles === null || styles === void 0 ? void 0 : styles.body)
        },
        ref: ref,
        open: open,
        onOpenChange: onInternalOpenChange,
        overlay: titleNode || contentNode ? /*#__PURE__*/ $acw62.createElement((0, $b7a2edcc9afcf494$export$c6fdb837b070b4ff), {
            prefixCls: prefixCls,
            title: titleNode,
            content: contentNode
        }) : null,
        transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, 'zoom-big', otherProps.transitionName),
        "data-popover-inject": true
    }), (0, $30796c32f374b477$export$e530037191fcd5d7)(children, {
        onKeyDown: (e)=>{
            var _a, _b;
            if (/*#__PURE__*/ (0, $acw62.isValidElement)(children)) (_b = children === null || children === void 0 ? void 0 : (_a = children.props).onKeyDown) === null || _b === void 0 || _b.call(_a, e);
            onKeyDown(e);
        }
    })));
});
const $50a5b629c434844e$var$Popover = $50a5b629c434844e$var$InternalPopover;
$50a5b629c434844e$var$Popover._InternalPanelDoNotUseOrYouWillBeFired = (0, $b7a2edcc9afcf494$export$2e2bcd8739ae039);
var $50a5b629c434844e$export$2e2bcd8739ae039 = $50a5b629c434844e$var$Popover;


var $acw62 = parcelRequire("acw62");

function $ff00798002f59629$export$2e2bcd8739ae039() {
    return $ff00798002f59629$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ff00798002f59629$export$2e2bcd8739ae039.apply(null, arguments);
}


function $d6317e030ad8c1a4$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $aebdaa6c5caccefc$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $d6317e030ad8c1a4$export$2e2bcd8739ae039)(r);
}


function $606eb0f614320d5a$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $366999254ccab9d4$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $d6317e030ad8c1a4$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $d6317e030ad8c1a4$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $be88a11f475f9885$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $a58b549eebfe4222$export$2e2bcd8739ae039(r) {
    return (0, $aebdaa6c5caccefc$export$2e2bcd8739ae039)(r) || (0, $606eb0f614320d5a$export$2e2bcd8739ae039)(r) || (0, $366999254ccab9d4$export$2e2bcd8739ae039)(r) || (0, $be88a11f475f9885$export$2e2bcd8739ae039)();
}


function $a027291fe8adf132$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a027291fe8adf132$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a027291fe8adf132$export$2e2bcd8739ae039(o);
}



function $4030f5c95a87ea06$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $a027291fe8adf132$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $a027291fe8adf132$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $5998d31eaa1c525c$export$2e2bcd8739ae039(t) {
    var i = (0, $4030f5c95a87ea06$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $a027291fe8adf132$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f8ce242576312548$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $5998d31eaa1c525c$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



function $f158faa5f7209115$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f158faa5f7209115$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f158faa5f7209115$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f8ce242576312548$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f158faa5f7209115$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $388a4c6bba3ce78e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $4843498a6996d5ad$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $80ae75a81caf04de$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $8f2658428f5feef6$export$2e2bcd8739ae039(r, e) {
    return (0, $388a4c6bba3ce78e$export$2e2bcd8739ae039)(r) || (0, $4843498a6996d5ad$export$2e2bcd8739ae039)(r, e) || (0, $366999254ccab9d4$export$2e2bcd8739ae039)(r, e) || (0, $80ae75a81caf04de$export$2e2bcd8739ae039)();
}


function $a4b806f92fd48bb6$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $30c0e704de7afa7d$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $a4b806f92fd48bb6$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}





var $acw62 = parcelRequire("acw62");
function $1e7bb58384cf00ac$export$2e2bcd8739ae039(callback) {
    var fnRef = $acw62.useRef();
    fnRef.current = callback;
    var memoFn = $acw62.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}



var $acw62 = parcelRequire("acw62");
function $2c3d183b3bf70c7f$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $487b751945641e6d$var$useInternalLayoutEffect = (0, $2c3d183b3bf70c7f$export$2e2bcd8739ae039)() ? $acw62.useLayoutEffect : $acw62.useEffect;
var $487b751945641e6d$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $acw62.useRef(true);
    $487b751945641e6d$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $487b751945641e6d$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $487b751945641e6d$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $487b751945641e6d$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $487b751945641e6d$export$2e2bcd8739ae039 = $487b751945641e6d$var$useLayoutEffect;




var $acw62 = parcelRequire("acw62");
function $95c2fc05dc5c51a6$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $acw62.useRef(false);
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $acw62.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $908b598c9326ab1c$var$hasValue(value) {
    return value !== undefined;
}
function $908b598c9326ab1c$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $95c2fc05dc5c51a6$export$2e2bcd8739ae039)(function() {
        if ($908b598c9326ab1c$var$hasValue(value)) return value;
        else if ($908b598c9326ab1c$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $95c2fc05dc5c51a6$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $487b751945641e6d$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $487b751945641e6d$export$9283e56bae2f7b0f)(function() {
        if (!$908b598c9326ab1c$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}


/* eslint-disable no-console */ var $a62d89528dce911b$var$warned = {};
var $a62d89528dce911b$var$preWarningFns = [];
var $a62d89528dce911b$export$61616f168f0e5a05 = function preMessage(fn) {
    $a62d89528dce911b$var$preWarningFns.push(fn);
};
function $a62d89528dce911b$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $a62d89528dce911b$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $a62d89528dce911b$export$60eef1277fe463e4() {
    $a62d89528dce911b$var$warned = {};
}
function $a62d89528dce911b$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$a62d89528dce911b$var$warned[message]) {
        method(false, message);
        $a62d89528dce911b$var$warned[message] = true;
    }
}
function $a62d89528dce911b$export$82934adf09101657(valid, message) {
    $a62d89528dce911b$export$848feb93d8f32b9b($a62d89528dce911b$export$491112666e282270, valid, message);
}
function $a62d89528dce911b$export$89ff31684837bbbf(valid, message) {
    $a62d89528dce911b$export$848feb93d8f32b9b($a62d89528dce911b$export$a92e4c44d367d0af, valid, message);
}
$a62d89528dce911b$export$82934adf09101657.preMessage = $a62d89528dce911b$export$61616f168f0e5a05;
$a62d89528dce911b$export$82934adf09101657.resetWarned = $a62d89528dce911b$export$60eef1277fe463e4;
$a62d89528dce911b$export$82934adf09101657.noteOnce = $a62d89528dce911b$export$89ff31684837bbbf;
var $a62d89528dce911b$export$2e2bcd8739ae039 = $a62d89528dce911b$export$82934adf09101657;



var $acw62 = parcelRequire("acw62");









var $b1be107f50e802ac$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $09205742e4b1762b$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $acw62.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


var $47c132296b70f4ba$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $a027291fe8adf132$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $47c132296b70f4ba$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $47c132296b70f4ba$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $47c132296b70f4ba$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $09205742e4b1762b$export$2e2bcd8739ae039)(function() {
        return $47c132296b70f4ba$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $47c132296b70f4ba$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $3251146683c5d714$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    return true;
};
function $47c132296b70f4ba$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(node) && !(0, $3251146683c5d714$exports.isFragment)(node);
}
var $47c132296b70f4ba$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $47c132296b70f4ba$var$isReactElement(node) && $47c132296b70f4ba$export$c1cec34af06bcf7(node);
};
var $47c132296b70f4ba$export$7465e5c0bf44f19a = Number((0, $acw62.version).split('.')[0]) >= 19 ? // >= React 19
function(node) {
    if ($47c132296b70f4ba$var$isReactElement(node)) return node.props.ref;
    return null;
} : // < React 19
function(node) {
    if ($47c132296b70f4ba$var$isReactElement(node)) return node.ref;
    return null;
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $e45dd5d9efe99894$var$TransBtn = function TransBtn(props) {
    var className = props.className, customizeIcon = props.customizeIcon, customizeIconProps = props.customizeIconProps, children = props.children, _onMouseDown = props.onMouseDown, onClick = props.onClick;
    var icon = typeof customizeIcon === 'function' ? customizeIcon(customizeIconProps) : customizeIcon;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: className,
        onMouseDown: function onMouseDown(event) {
            event.preventDefault();
            _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(event);
        },
        style: {
            userSelect: 'none',
            WebkitUserSelect: 'none'
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className.split(/\s+/).map(function(cls) {
            return "".concat(cls, "-icon");
        }))
    }, children));
};
var $e45dd5d9efe99894$export$2e2bcd8739ae039 = $e45dd5d9efe99894$var$TransBtn;



var $acw62 = parcelRequire("acw62");
var $83c983ea655ffaa8$export$9ea6397a890aa3e5 = function useAllowClear(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon) {
    var disabled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var mergedSearchValue = arguments.length > 6 ? arguments[6] : undefined;
    var mode = arguments.length > 7 ? arguments[7] : undefined;
    var mergedClearIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        if ((0, $a027291fe8adf132$export$2e2bcd8739ae039)(allowClear) === 'object') return allowClear.clearIcon;
        if (clearIcon) return clearIcon;
    }, [
        allowClear,
        clearIcon
    ]);
    var mergedAllowClear = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        if (!disabled && !!allowClear && (displayValues.length || mergedSearchValue) && !(mode === 'combobox' && mergedSearchValue === '')) return true;
        return false;
    }, [
        allowClear,
        disabled,
        displayValues.length,
        mergedSearchValue,
        mode
    ]);
    return {
        allowClear: mergedAllowClear,
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e45dd5d9efe99894$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-clear"),
            onMouseDown: onClearMouseDown,
            customizeIcon: mergedClearIcon
        }, "\xD7")
    };
};


/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $acw62 = parcelRequire("acw62");
var $138f44227a4e4422$export$8234047c0aea33cf = /*#__PURE__*/ $acw62.createContext(null);
function $138f44227a4e4422$export$2e2bcd8739ae039() {
    return $acw62.useContext($138f44227a4e4422$export$8234047c0aea33cf);
}




var $acw62 = parcelRequire("acw62");
function $a8e0c2247e7f8218$export$2e2bcd8739ae039() {
    var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
    var delayRef = $acw62.useRef(null);
    var cancelLatest = function cancelLatest() {
        window.clearTimeout(delayRef.current);
    };
    $acw62.useEffect(function() {
        return cancelLatest;
    }, []);
    var delaySetBool = function delaySetBool(value, callback) {
        cancelLatest();
        delayRef.current = window.setTimeout(function() {
            setBool(value);
            if (callback) callback();
        }, timeout);
    };
    return [
        bool,
        delaySetBool,
        cancelLatest
    ];
}



var $acw62 = parcelRequire("acw62");
function $d2cdf88fff85fc3a$export$2e2bcd8739ae039() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
    var lockRef = $acw62.useRef(null);
    var timeoutRef = $acw62.useRef(null);
    // Clean up
    $acw62.useEffect(function() {
        return function() {
            window.clearTimeout(timeoutRef.current);
        };
    }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(function() {
            lockRef.current = null;
        }, duration);
    }
    return [
        function() {
            return lockRef.current;
        },
        doLock
    ];
}



var $acw62 = parcelRequire("acw62");
function $78e2d4fdcbaa3edd$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    var propsRef = $acw62.useRef(null);
    propsRef.current = {
        open: open,
        triggerOpen: triggerOpen,
        customizedTrigger: customizedTrigger
    };
    $acw62.useEffect(function() {
        function onGlobalMouseDown(event) {
            var _propsRef$current;
            // If trigger is customized, Trigger will take control of popupVisible
            if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) return;
            var target = event.target;
            if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
            if (propsRef.current.open && elements().filter(function(element) {
                return element;
            }).every(function(element) {
                return !element.contains(target) && element !== target;
            })) // Should trigger close
            propsRef.current.triggerOpen(false);
        }
        window.addEventListener('mousedown', onGlobalMouseDown);
        return function() {
            return window.removeEventListener('mousedown', onGlobalMouseDown);
        };
    }, []);
}




/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $9163ee474d3ac931$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $9163ee474d3ac931$var$KeyCode.F1 && keyCode <= $9163ee474d3ac931$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $9163ee474d3ac931$var$KeyCode.ALT:
            case $9163ee474d3ac931$var$KeyCode.CAPS_LOCK:
            case $9163ee474d3ac931$var$KeyCode.CONTEXT_MENU:
            case $9163ee474d3ac931$var$KeyCode.CTRL:
            case $9163ee474d3ac931$var$KeyCode.DOWN:
            case $9163ee474d3ac931$var$KeyCode.END:
            case $9163ee474d3ac931$var$KeyCode.ESC:
            case $9163ee474d3ac931$var$KeyCode.HOME:
            case $9163ee474d3ac931$var$KeyCode.INSERT:
            case $9163ee474d3ac931$var$KeyCode.LEFT:
            case $9163ee474d3ac931$var$KeyCode.MAC_FF_META:
            case $9163ee474d3ac931$var$KeyCode.META:
            case $9163ee474d3ac931$var$KeyCode.NUMLOCK:
            case $9163ee474d3ac931$var$KeyCode.NUM_CENTER:
            case $9163ee474d3ac931$var$KeyCode.PAGE_DOWN:
            case $9163ee474d3ac931$var$KeyCode.PAGE_UP:
            case $9163ee474d3ac931$var$KeyCode.PAUSE:
            case $9163ee474d3ac931$var$KeyCode.PRINT_SCREEN:
            case $9163ee474d3ac931$var$KeyCode.RIGHT:
            case $9163ee474d3ac931$var$KeyCode.SHIFT:
            case $9163ee474d3ac931$var$KeyCode.UP:
            case $9163ee474d3ac931$var$KeyCode.WIN_KEY:
            case $9163ee474d3ac931$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $9163ee474d3ac931$var$KeyCode.ZERO && keyCode <= $9163ee474d3ac931$var$KeyCode.NINE) return true;
        if (keyCode >= $9163ee474d3ac931$var$KeyCode.NUM_ZERO && keyCode <= $9163ee474d3ac931$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $9163ee474d3ac931$var$KeyCode.A && keyCode <= $9163ee474d3ac931$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $9163ee474d3ac931$var$KeyCode.SPACE:
            case $9163ee474d3ac931$var$KeyCode.QUESTION_MARK:
            case $9163ee474d3ac931$var$KeyCode.NUM_PLUS:
            case $9163ee474d3ac931$var$KeyCode.NUM_MINUS:
            case $9163ee474d3ac931$var$KeyCode.NUM_PERIOD:
            case $9163ee474d3ac931$var$KeyCode.NUM_DIVISION:
            case $9163ee474d3ac931$var$KeyCode.SEMICOLON:
            case $9163ee474d3ac931$var$KeyCode.DASH:
            case $9163ee474d3ac931$var$KeyCode.EQUALS:
            case $9163ee474d3ac931$var$KeyCode.COMMA:
            case $9163ee474d3ac931$var$KeyCode.PERIOD:
            case $9163ee474d3ac931$var$KeyCode.SLASH:
            case $9163ee474d3ac931$var$KeyCode.APOSTROPHE:
            case $9163ee474d3ac931$var$KeyCode.SINGLE_QUOTE:
            case $9163ee474d3ac931$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $9163ee474d3ac931$var$KeyCode.BACKSLASH:
            case $9163ee474d3ac931$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $9163ee474d3ac931$export$2e2bcd8739ae039 = $9163ee474d3ac931$var$KeyCode;



var $acw62 = parcelRequire("acw62");


function $8f2da3bf9ade718f$export$48ac81d4a07c29c(currentKeyCode) {
    return(// Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    currentKeyCode && // Other keys
    ![
        // System function button
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).ESC,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).SHIFT,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).BACKSPACE,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).TAB,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).WIN_KEY,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).ALT,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).META,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).WIN_KEY_RIGHT,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).CTRL,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).SEMICOLON,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).EQUALS,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).CAPS_LOCK,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).CONTEXT_MENU,
        // F1-F12
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F1,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F2,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F3,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F4,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F5,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F6,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F7,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F8,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F9,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F10,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F11,
        (0, $9163ee474d3ac931$export$2e2bcd8739ae039).F12
    ].includes(currentKeyCode));
}





var $acw62 = parcelRequire("acw62");


var $717b45987b2b899b$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $717b45987b2b899b$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $717b45987b2b899b$var$propList = "".concat($717b45987b2b899b$var$attributes, " ").concat($717b45987b2b899b$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $717b45987b2b899b$var$ariaPrefix = 'aria-';
var $717b45987b2b899b$var$dataPrefix = 'data-';
function $717b45987b2b899b$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $717b45987b2b899b$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === 'role' || $717b45987b2b899b$var$match(key, $717b45987b2b899b$var$ariaPrefix)) || // Data
        mergedConfig.data && $717b45987b2b899b$var$match(key, $717b45987b2b899b$var$dataPrefix) || // Attr
        mergedConfig.attr && $717b45987b2b899b$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}







var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");


var $04f5dea65135d084$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $04f5dea65135d084$var$UNDEFINED = undefined;
function $04f5dea65135d084$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $04f5dea65135d084$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $acw62.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $04f5dea65135d084$var$UNDEFINED ? renderItem(item) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $04f5dea65135d084$var$UNDEFINED,
        overflowY: mergedHidden ? 'hidden' : $04f5dea65135d084$var$UNDEFINED,
        order: responsive ? order : $04f5dea65135d084$var$UNDEFINED,
        pointerEvents: mergedHidden ? 'none' : $04f5dea65135d084$var$UNDEFINED,
        position: mergedHidden ? 'absolute' : $04f5dea65135d084$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps['aria-hidden'] = true;
    var itemNode = /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(!invalidate && prefixCls, className),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $04f5dea65135d084$var$Item = /*#__PURE__*/ $acw62.forwardRef($04f5dea65135d084$var$InternalItem);
$04f5dea65135d084$var$Item.displayName = 'Item';
var $04f5dea65135d084$export$2e2bcd8739ae039 = $04f5dea65135d084$var$Item;





var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

function $c36b6a4565c7d957$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === 'undefined') (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}


function $ec426fd785b0196a$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $acw62.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $c36b6a4565c7d957$export$2e2bcd8739ae039)(function() {
                (0, $1u0KT.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $ec426fd785b0196a$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $4364d04fa4ed57d4$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $182a1149db3c9d79$var$_excluded = [
    "component"
], $182a1149db3c9d79$var$_excluded2 = [
    "className"
], $182a1149db3c9d79$var$_excluded3 = [
    "className"
];
var $182a1149db3c9d79$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $acw62.useContext((0, $4364d04fa4ed57d4$export$79f16dd643143c25));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $182a1149db3c9d79$var$_excluded);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(context, $182a1149db3c9d79$var$_excluded2);
    var className = props.className, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $182a1149db3c9d79$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $acw62.createElement((0, $4364d04fa4ed57d4$export$79f16dd643143c25).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $04f5dea65135d084$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(contextClassName, className)
    }, restContext, restProps)));
};
var $182a1149db3c9d79$var$RawItem = /*#__PURE__*/ $acw62.forwardRef($182a1149db3c9d79$var$InternalRawItem);
$182a1149db3c9d79$var$RawItem.displayName = 'RawItem';
var $182a1149db3c9d79$export$2e2bcd8739ae039 = $182a1149db3c9d79$var$RawItem;



var $28a64b28232d3cd3$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $28a64b28232d3cd3$var$RESPONSIVE = 'responsive';
var $28a64b28232d3cd3$var$INVALIDATE = 'invalidate';
function $28a64b28232d3cd3$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $28a64b28232d3cd3$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-overflow' : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $28a64b28232d3cd3$var$_excluded);
    var fullySSR = ssr === 'full';
    var notifyEffectUpdate = (0, $ec426fd785b0196a$export$eedf51fe9d751c7a)();
    var _useEffectState = (0, $ec426fd785b0196a$export$2e2bcd8739ae039)(notifyEffectUpdate, null), _useEffectState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $ec426fd785b0196a$export$2e2bcd8739ae039)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $ec426fd785b0196a$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $ec426fd785b0196a$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $ec426fd785b0196a$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState10 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $acw62.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $28a64b28232d3cd3$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $28a64b28232d3cd3$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
    var mergedData = (0, $acw62.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === 'number') items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $acw62.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $acw62.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === 'function') return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $acw62.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
            var totalWidth = suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: 'absolute',
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $acw62.createElement((0, $4364d04fa4ed57d4$export$79f16dd643143c25).Provider, {
            key: key,
            value: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $acw62.createElement((0, $04f5dea65135d084$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restNode;
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    if (!renderRawRest) {
        var mergedRenderRest = renderRest || $28a64b28232d3cd3$var$defaultRenderRest;
        restNode = /*#__PURE__*/ $acw62.createElement((0, $04f5dea65135d084$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
    } else if (renderRawRest) restNode = /*#__PURE__*/ $acw62.createElement((0, $4364d04fa4ed57d4$export$79f16dd643143c25).Provider, {
        value: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems));
    var overflowNode = /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $acw62.createElement((0, $04f5dea65135d084$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    if (isResponsive) overflowNode = /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode);
    return overflowNode;
}
var $28a64b28232d3cd3$var$ForwardOverflow = /*#__PURE__*/ $acw62.forwardRef($28a64b28232d3cd3$var$Overflow);
$28a64b28232d3cd3$var$ForwardOverflow.displayName = 'Overflow';
$28a64b28232d3cd3$var$ForwardOverflow.Item = (0, $182a1149db3c9d79$export$2e2bcd8739ae039);
$28a64b28232d3cd3$var$ForwardOverflow.RESPONSIVE = $28a64b28232d3cd3$var$RESPONSIVE;
$28a64b28232d3cd3$var$ForwardOverflow.INVALIDATE = $28a64b28232d3cd3$var$INVALIDATE;
var // Convert to generic type
$28a64b28232d3cd3$export$2e2bcd8739ae039 = $28a64b28232d3cd3$var$ForwardOverflow;


var $4863ed3a14942ec4$export$2e2bcd8739ae039 = (0, $28a64b28232d3cd3$export$2e2bcd8739ae039);






var $acw62 = parcelRequire("acw62");




function $004dd7452ca4d8d6$var$composeProps(originProps, patchProps, isAll) {
    var composedProps = (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, originProps), isAll ? patchProps : {});
    Object.keys(patchProps).forEach(function(key) {
        var func = patchProps[key];
        if (typeof func === 'function') composedProps[key] = function() {
            var _originProps$key;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            func.apply(void 0, args);
            return (_originProps$key = originProps[key]) === null || _originProps$key === void 0 ? void 0 : _originProps$key.call.apply(_originProps$key, [
                originProps
            ].concat(args));
        };
    });
    return composedProps;
}
var $004dd7452ca4d8d6$export$2e2bcd8739ae039 = $004dd7452ca4d8d6$var$composeProps;


var $a0219cd33f1abc77$var$_excluded = [
    "prefixCls",
    "id",
    "inputElement",
    "autoFocus",
    "autoComplete",
    "editable",
    "activeDescendantId",
    "value",
    "open",
    "attrs"
];
var $a0219cd33f1abc77$var$Input = function Input(props, ref) {
    var prefixCls = props.prefixCls, id = props.id, inputElement = props.inputElement, autoFocus = props.autoFocus, autoComplete = props.autoComplete, editable = props.editable, activeDescendantId = props.activeDescendantId, value = props.value, open = props.open, attrs = props.attrs, restProps = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(props, $a0219cd33f1abc77$var$_excluded);
    var inputNode = inputElement || /*#__PURE__*/ $acw62.createElement("input", null);
    var _inputNode = inputNode, originRef = _inputNode.ref, originProps = _inputNode.props;
    (0, $a62d89528dce911b$export$491112666e282270)(!('maxLength' in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
    inputNode = /*#__PURE__*/ $acw62.cloneElement(inputNode, (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({
        type: 'search'
    }, (0, $004dd7452ca4d8d6$export$2e2bcd8739ae039)(restProps, originProps, true)), {}, {
        // Override over origin props
        id: id,
        ref: (0, $47c132296b70f4ba$export$ab452c34e8e05029)(ref, originRef),
        autoComplete: autoComplete || 'off',
        autoFocus: autoFocus,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-selection-search-input"), originProps === null || originProps === void 0 ? void 0 : originProps.className),
        role: 'combobox',
        'aria-expanded': open || false,
        'aria-haspopup': 'listbox',
        'aria-owns': "".concat(id, "_list"),
        'aria-autocomplete': 'list',
        'aria-controls': "".concat(id, "_list"),
        'aria-activedescendant': open ? activeDescendantId : undefined
    }, attrs), {}, {
        value: editable ? value : '',
        readOnly: !editable,
        unselectable: !editable ? 'on' : null,
        style: (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, originProps.style), {}, {
            opacity: editable ? null : 0
        })
    }));
    return inputNode;
};
var $a0219cd33f1abc77$var$RefInput = /*#__PURE__*/ $acw62.forwardRef($a0219cd33f1abc77$var$Input);
var $a0219cd33f1abc77$export$2e2bcd8739ae039 = $a0219cd33f1abc77$var$RefInput;


/* eslint-disable react-hooks/rules-of-hooks */ 
var $acw62 = parcelRequire("acw62");

function $b2f2f91bade499fd$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
var $b2f2f91bade499fd$export$7383f122bf48ec30 = typeof window !== 'undefined' && window.document && window.document.documentElement;
var $b2f2f91bade499fd$export$df7146797a248522 = $b2f2f91bade499fd$export$7383f122bf48ec30;
function $b2f2f91bade499fd$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $b2f2f91bade499fd$export$9d186c3672bb89c6(value) {
    return !value && value !== 0;
}
function $b2f2f91bade499fd$var$isTitleType(title) {
    return [
        'string',
        'number'
    ].includes((0, $a027291fe8adf132$export$2e2bcd8739ae039)(title));
}
function $b2f2f91bade499fd$export$70d1bf7729efff40(item) {
    var title = undefined;
    if (item) {
        if ($b2f2f91bade499fd$var$isTitleType(item.title)) title = item.title.toString();
        else if ($b2f2f91bade499fd$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $6256f29c6461d009$export$2e2bcd8739ae039(effect, deps) {
    // Never happen in test env
    if (0, $b2f2f91bade499fd$export$df7146797a248522) /* istanbul ignore next */ $acw62.useLayoutEffect(effect, deps);
    else $acw62.useEffect(effect, deps);
} /* eslint-enable */ 



function $a067193ac8b85423$var$itemKey(value) {
    var _value$key;
    return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var $a067193ac8b85423$var$onPreventMouseDown = function onPreventMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
};
var $a067193ac8b85423$var$SelectSelector = function SelectSelector(props) {
    var id = props.id, prefixCls = props.prefixCls, values = props.values, open = props.open, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues) {
        return "+ ".concat(omittedValues.length, " ...");
    } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onRemove = props.onRemove, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd, onInputBlur = props.onInputBlur;
    var measureRef = $acw62.useRef(null);
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
    var selectionPrefixCls = "".concat(prefixCls, "-selection");
    // ===================== Search ======================
    var inputValue = open || mode === 'multiple' && autoClearSearchValue === false || mode === 'tags' ? searchValue : '';
    var inputEditable = mode === 'tags' || mode === 'multiple' && autoClearSearchValue === false || showSearch && (open || focused);
    // We measure width and set to the input immediately
    (0, $6256f29c6461d009$export$2e2bcd8739ae039)(function() {
        setInputWidth(measureRef.current.scrollWidth);
    }, [
        inputValue
    ]);
    // ===================== Render ======================
    // >>> Render Selector Node. Includes Item & Rest
    var defaultRenderSelector = function defaultRenderSelector(item, content, itemDisabled, closable, onClose) {
        return /*#__PURE__*/ $acw62.createElement("span", {
            title: (0, $b2f2f91bade499fd$export$70d1bf7729efff40)(item),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(selectionPrefixCls, "-item"), (0, $f8ce242576312548$export$2e2bcd8739ae039)({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled))
        }, /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(selectionPrefixCls, "-item-content")
        }, content), closable && /*#__PURE__*/ $acw62.createElement((0, $e45dd5d9efe99894$export$2e2bcd8739ae039), {
            className: "".concat(selectionPrefixCls, "-item-remove"),
            onMouseDown: $a067193ac8b85423$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xD7"));
    };
    var customizeRenderSelector = function customizeRenderSelector(value, content, itemDisabled, closable, onClose, isMaxTag) {
        var onMouseDown = function onMouseDown(e) {
            $a067193ac8b85423$var$onPreventMouseDown(e);
            onToggleOpen(!open);
        };
        return /*#__PURE__*/ $acw62.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose,
            isMaxTag: !!isMaxTag
        }));
    };
    var renderItem = function renderItem(valueItem) {
        var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value;
        var closable = !disabled && !itemDisabled;
        var displayLabel = label;
        if (typeof maxTagTextLength === 'number') {
            if (typeof label === 'string' || typeof label === 'number') {
                var strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
            }
        }
        var onClose = function onClose(event) {
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === 'function' ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    };
    var renderRest = function renderRest(omittedValues) {
        // https://github.com/ant-design/ant-design/issues/48930
        if (!values.length) return null;
        var content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return typeof tagRender === 'function' ? customizeRenderSelector(undefined, content, false, false, undefined, true) : defaultRenderSelector({
            title: content
        }, content, false);
    };
    // >>> Input Node
    var inputNode = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(selectionPrefixCls, "-search"),
        style: {
            width: inputWidth
        },
        onFocus: function onFocus() {
            setFocused(true);
        },
        onBlur: function onBlur() {
            setFocused(false);
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $a0219cd33f1abc77$export$2e2bcd8739ae039), {
        ref: inputRef,
        open: open,
        prefixCls: prefixCls,
        id: id,
        inputElement: null,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: onInputChange,
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        onBlur: onInputBlur,
        tabIndex: tabIndex,
        attrs: (0, $717b45987b2b899b$export$2e2bcd8739ae039)(props, true)
    }), /*#__PURE__*/ $acw62.createElement("span", {
        ref: measureRef,
        className: "".concat(selectionPrefixCls, "-search-mirror"),
        "aria-hidden": true
    }, inputValue, "\xA0"));
    // >>> Selections
    var selectionNode = /*#__PURE__*/ $acw62.createElement((0, $4863ed3a14942ec4$export$2e2bcd8739ae039), {
        prefixCls: "".concat(selectionPrefixCls, "-overflow"),
        data: values,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: inputNode,
        itemKey: $a067193ac8b85423$var$itemKey,
        maxCount: maxTagCount
    });
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(selectionPrefixCls, "-wrap")
    }, selectionNode, !values.length && !inputValue && /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(selectionPrefixCls, "-placeholder")
    }, placeholder));
};
var $a067193ac8b85423$export$2e2bcd8739ae039 = $a067193ac8b85423$var$SelectSelector;




var $acw62 = parcelRequire("acw62");



var $0524ac07f58efed0$var$SingleSelector = function SingleSelector(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, id = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, mode = props.mode, open = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd, onInputBlur = props.onInputBlur, title = props.title;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
    var combobox = mode === 'combobox';
    var inputEditable = combobox || showSearch;
    var item = values[0];
    var inputValue = searchValue || '';
    if (combobox && activeValue && !inputChanged) inputValue = activeValue;
    $acw62.useEffect(function() {
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // Not show text when closed expect combobox mode
    var hasTextInput = mode !== 'combobox' && !open && !showSearch ? false : !!inputValue;
    // Get title of selection item
    var selectionTitle = title === undefined ? (0, $b2f2f91bade499fd$export$70d1bf7729efff40)(item) : title;
    var placeholderNode = $acw62.useMemo(function() {
        if (item) return null;
        return /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-selection-placeholder"),
            style: hasTextInput ? {
                visibility: 'hidden'
            } : undefined
        }, placeholder);
    }, [
        item,
        hasTextInput,
        placeholder,
        prefixCls
    ]);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-selection-wrap")
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-selection-search")
    }, /*#__PURE__*/ $acw62.createElement((0, $a0219cd33f1abc77$export$2e2bcd8739ae039), {
        ref: inputRef,
        prefixCls: prefixCls,
        id: id,
        open: open,
        inputElement: inputElement,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: function onChange(e) {
            setInputChanged(true);
            onInputChange(e);
        },
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        onBlur: onInputBlur,
        tabIndex: tabIndex,
        attrs: (0, $717b45987b2b899b$export$2e2bcd8739ae039)(props, true),
        maxLength: combobox ? maxLength : undefined
    })), !combobox && item ? /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-selection-item"),
        title: selectionTitle,
        style: hasTextInput ? {
            visibility: 'hidden'
        } : undefined
    }, item.label) : null, placeholderNode);
};
var $0524ac07f58efed0$export$2e2bcd8739ae039 = $0524ac07f58efed0$var$SingleSelector;


var $bc7f30d19ac8c9cf$var$Selector = function Selector(props, ref) {
    var inputRef = (0, $acw62.useRef)(null);
    var compositionStatusRef = (0, $acw62.useRef)(false);
    var prefixCls = props.prefixCls, open = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, disabled = props.disabled, prefix = props.prefix, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, onInputBlur = props.onInputBlur, domRef = props.domRef;
    // ======================= Ref =======================
    $acw62.useImperativeHandle(ref, function() {
        return {
            focus: function focus(options) {
                inputRef.current.focus(options);
            },
            blur: function blur() {
                inputRef.current.blur();
            }
        };
    });
    // ====================== Input ======================
    var _useLock = (0, $d2cdf88fff85fc3a$export$2e2bcd8739ae039)(0), _useLock2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
    var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
        var which = event.which;
        // Compatible with multiple lines in TextArea
        var isTextAreaElement = inputRef.current instanceof HTMLTextAreaElement;
        if (!isTextAreaElement && open && (which === (0, $9163ee474d3ac931$export$2e2bcd8739ae039).UP || which === (0, $9163ee474d3ac931$export$2e2bcd8739ae039).DOWN)) event.preventDefault();
        if (onInputKeyDown) onInputKeyDown(event);
        if (which === (0, $9163ee474d3ac931$export$2e2bcd8739ae039).ENTER && mode === 'tags' && !compositionStatusRef.current && !open) // When menu isn't open, OptionList won't trigger a value change
        // So when enter is pressed, the tag's input value should be emitted here to let selector know
        onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
        // Move within the text box
        if (isTextAreaElement && !open && ~[
            (0, $9163ee474d3ac931$export$2e2bcd8739ae039).UP,
            (0, $9163ee474d3ac931$export$2e2bcd8739ae039).DOWN,
            (0, $9163ee474d3ac931$export$2e2bcd8739ae039).LEFT,
            (0, $9163ee474d3ac931$export$2e2bcd8739ae039).RIGHT
        ].indexOf(which)) return;
        if ((0, $8f2da3bf9ade718f$export$48ac81d4a07c29c)(which)) onToggleOpen(true);
    };
    /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */ var onInternalInputMouseDown = function onInternalInputMouseDown() {
        setInputMouseDown(true);
    };
    // When paste come, ignore next onChange
    var pastedTextRef = (0, $acw62.useRef)(null);
    var triggerOnSearch = function triggerOnSearch(value) {
        if (onSearch(value, true, compositionStatusRef.current) !== false) onToggleOpen(true);
    };
    var onInputCompositionStart = function onInputCompositionStart() {
        compositionStatusRef.current = true;
    };
    var onInputCompositionEnd = function onInputCompositionEnd(e) {
        compositionStatusRef.current = false;
        // Trigger search again to support `tokenSeparators` with typewriting
        if (mode !== 'combobox') triggerOnSearch(e.target.value);
    };
    var onInputChange = function onInputChange(event) {
        var value = event.target.value;
        // Pasted text should replace back to origin content
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, '').replace(/\r\n/g, ' ').replace(/[\r\n]/g, ' ');
            value = value.replace(replacedText, pastedTextRef.current);
        }
        pastedTextRef.current = null;
        triggerOnSearch(value);
    };
    var onInputPaste = function onInputPaste(e) {
        var clipboardData = e.clipboardData;
        var value = clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData('text');
        pastedTextRef.current = value || '';
    };
    var onClick = function onClick(_ref) {
        var target = _ref.target;
        if (target !== inputRef.current) {
            // Should focus input if click the selector
            var isIE = document.body.style.msTouchAction !== undefined;
            if (isIE) setTimeout(function() {
                inputRef.current.focus();
            });
            else inputRef.current.focus();
        }
    };
    var onMouseDown = function onMouseDown(event) {
        var inputMouseDown = getInputMouseDown();
        // when mode is combobox and it is disabled, don't prevent default behavior
        // https://github.com/ant-design/ant-design/issues/37320
        // https://github.com/ant-design/ant-design/issues/48281
        if (event.target !== inputRef.current && !inputMouseDown && !(mode === 'combobox' && disabled)) event.preventDefault();
        if (mode !== 'combobox' && (!showSearch || !inputMouseDown) || !open) {
            if (open && autoClearSearchValue !== false) onSearch('', true, false);
            onToggleOpen();
        }
    };
    // ================= Inner Selector ==================
    var sharedProps = {
        inputRef: inputRef,
        onInputKeyDown: onInternalInputKeyDown,
        onInputMouseDown: onInternalInputMouseDown,
        onInputChange: onInputChange,
        onInputPaste: onInputPaste,
        onInputCompositionStart: onInputCompositionStart,
        onInputCompositionEnd: onInputCompositionEnd,
        onInputBlur: onInputBlur
    };
    var selectNode = mode === 'multiple' || mode === 'tags' ? /*#__PURE__*/ $acw62.createElement((0, $a067193ac8b85423$export$2e2bcd8739ae039), (0, $ff00798002f59629$export$2e2bcd8739ae039)({}, props, sharedProps)) : /*#__PURE__*/ $acw62.createElement((0, $0524ac07f58efed0$export$2e2bcd8739ae039), (0, $ff00798002f59629$export$2e2bcd8739ae039)({}, props, sharedProps));
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: domRef,
        className: "".concat(prefixCls, "-selector"),
        onClick: onClick,
        onMouseDown: onMouseDown
    }, prefix && /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-prefix")
    }, prefix), selectNode);
};
var $bc7f30d19ac8c9cf$var$ForwardSelector = /*#__PURE__*/ $acw62.forwardRef($bc7f30d19ac8c9cf$var$Selector);
var $bc7f30d19ac8c9cf$export$2e2bcd8739ae039 = $bc7f30d19ac8c9cf$var$ForwardSelector;













var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $f70deae0a90ffbdd$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($f70deae0a90ffbdd$export$2e2bcd8739ae039(child));
        else if ((0, $3251146683c5d714$exports.isFragment)(child) && child.props) ret = ret.concat($f70deae0a90ffbdd$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}







var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $304570ebe9398ed5$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $304570ebe9398ed5$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $a027291fe8adf132$export$2e2bcd8739ae039)(node) === 'object' && $304570ebe9398ed5$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($304570ebe9398ed5$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $304570ebe9398ed5$export$2e2bcd8739ae039(node) {
    var domNode = $304570ebe9398ed5$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))), node);
    }
    return null;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $6452a33e4b4c1301$export$db36075d98ba73d3 = /*#__PURE__*/ $acw62.createContext(null);
function $6452a33e4b4c1301$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $acw62.useRef(0);
    var resizeInfosRef = $acw62.useRef([]);
    var onCollectionResize = $acw62.useContext($6452a33e4b4c1301$export$db36075d98ba73d3);
    var onResize = $acw62.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $acw62.createElement($6452a33e4b4c1301$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}



// =============================== Const ===============================
var $dd8953c68547fa0d$var$elementListeners = new Map();
function $dd8953c68547fa0d$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $dd8953c68547fa0d$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $dd8953c68547fa0d$var$resizeObserver = new (0, $87c2a74187854fda$export$2e2bcd8739ae039)($dd8953c68547fa0d$var$onResize);
var $dd8953c68547fa0d$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $dd8953c68547fa0d$export$524f0fd3b47831a = null; // eslint-disable-line
function $dd8953c68547fa0d$export$d1203567a167490e(element, callback) {
    if (!$dd8953c68547fa0d$var$elementListeners.has(element)) {
        $dd8953c68547fa0d$var$elementListeners.set(element, new Set());
        $dd8953c68547fa0d$var$resizeObserver.observe(element);
    }
    $dd8953c68547fa0d$var$elementListeners.get(element).add(callback);
}
function $dd8953c68547fa0d$export$23a2283368c55ea2(element, callback) {
    if ($dd8953c68547fa0d$var$elementListeners.has(element)) {
        $dd8953c68547fa0d$var$elementListeners.get(element).delete(callback);
        if (!$dd8953c68547fa0d$var$elementListeners.get(element).size) {
            $dd8953c68547fa0d$var$resizeObserver.unobserve(element);
            $dd8953c68547fa0d$var$elementListeners.delete(element);
        }
    }
}


function $84ba2e72b6987713$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $7a9b55a66186669e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $5998d31eaa1c525c$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $7a9b55a66186669e$export$2e2bcd8739ae039(e, r, t) {
    return r && $7a9b55a66186669e$var$_defineProperties(e.prototype, r), t && $7a9b55a66186669e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $6049d6c7dc0a0215$export$2e2bcd8739ae039(t, e) {
    return $6049d6c7dc0a0215$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $6049d6c7dc0a0215$export$2e2bcd8739ae039(t, e);
}


function $074b47b79b3d28d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $6049d6c7dc0a0215$export$2e2bcd8739ae039)(t, e);
}


function $0f630afb38f82276$export$2e2bcd8739ae039(t) {
    return $0f630afb38f82276$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $0f630afb38f82276$export$2e2bcd8739ae039(t);
}


function $72aa89e9f7547478$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($72aa89e9f7547478$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $bfbafecf40243909$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $35dc2a6996d3df3c$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $a027291fe8adf132$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $bfbafecf40243909$export$2e2bcd8739ae039)(t);
}


function $cca89218a8618991$export$2e2bcd8739ae039(t) {
    var r = (0, $72aa89e9f7547478$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $0f630afb38f82276$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $0f630afb38f82276$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $35dc2a6996d3df3c$export$2e2bcd8739ae039)(this, e);
    };
}



var $acw62 = parcelRequire("acw62");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $e8b4907d257046ac$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $074b47b79b3d28d0$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $cca89218a8618991$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $84ba2e72b6987713$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $7a9b55a66186669e$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);


function $116f40798a8b77e9$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $acw62.useRef(null);
    var wrapperRef = $acw62.useRef(null);
    var onCollectionResize = $acw62.useContext((0, $6452a33e4b4c1301$export$db36075d98ba73d3));
    // =========================== Children ===========================
    var isRenderProps = typeof children === 'function';
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $acw62.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $acw62.isValidElement(mergedChildren) && (0, $47c132296b70f4ba$export$c1cec34af06bcf7)(mergedChildren);
    var originRef = canRef ? mergedChildren.ref : null;
    var mergedRef = (0, $47c132296b70f4ba$export$1d1c999670a1285d)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $304570ebe9398ed5$export$2e2bcd8739ae039)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $a027291fe8adf132$export$2e2bcd8739ae039)(elementRef.current) === 'object' ? (0, $304570ebe9398ed5$export$2e2bcd8739ae039)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $304570ebe9398ed5$export$2e2bcd8739ae039)(wrapperRef.current);
    };
    $acw62.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $acw62.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $acw62.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $acw62.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $dd8953c68547fa0d$export$d1203567a167490e)(currentElement, onInternalResize);
        return function() {
            return (0, $dd8953c68547fa0d$export$23a2283368c55ea2)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement((0, $e8b4907d257046ac$export$2e2bcd8739ae039), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $acw62.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $116f40798a8b77e9$var$RefSingleObserver = /*#__PURE__*/ $acw62.forwardRef($116f40798a8b77e9$var$SingleObserver);
var $116f40798a8b77e9$export$2e2bcd8739ae039 = $116f40798a8b77e9$var$RefSingleObserver;




var $b05fd627f1f68d53$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $b05fd627f1f68d53$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === 'function' ? [
        children
    ] : (0, $f70deae0a90ffbdd$export$2e2bcd8739ae039)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($b05fd627f1f68d53$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $acw62.createElement((0, $116f40798a8b77e9$export$2e2bcd8739ae039), (0, $ff00798002f59629$export$2e2bcd8739ae039)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $b05fd627f1f68d53$var$RefResizeObserver = /*#__PURE__*/ $acw62.forwardRef($b05fd627f1f68d53$var$ResizeObserver);
$b05fd627f1f68d53$var$RefResizeObserver.Collection = (0, $6452a33e4b4c1301$export$fb8073518f34e6ec);
var $b05fd627f1f68d53$export$2e2bcd8739ae039 = $b05fd627f1f68d53$var$RefResizeObserver;



function $7cc75555f3dbd7d9$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function $7cc75555f3dbd7d9$export$cca82218ea4431a(ele) {
    return $7cc75555f3dbd7d9$var$getRoot(ele) instanceof ShadowRoot;
}
function $7cc75555f3dbd7d9$export$70e8259662bb498b(ele) {
    return $7cc75555f3dbd7d9$export$cca82218ea4431a(ele) ? $7cc75555f3dbd7d9$var$getRoot(ele) : null;
}






var $acw62 = parcelRequire("acw62");
function $1f01f3fbc9fc76da$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, $acw62);
    return fullClone.useId;
}
var $1f01f3fbc9fc76da$var$uuid = 0;
function $1f01f3fbc9fc76da$export$2f0435a662835942() {}
var $1f01f3fbc9fc76da$var$useOriginId = $1f01f3fbc9fc76da$var$getUseId();
var $1f01f3fbc9fc76da$export$2e2bcd8739ae039 = $1f01f3fbc9fc76da$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $1f01f3fbc9fc76da$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState('ssr-id'), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        var nextId = $1f01f3fbc9fc76da$var$uuid;
        $1f01f3fbc9fc76da$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};





var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $310357438448c55a$var$_excluded = [
    "children"
];
var $310357438448c55a$export$841858b892ce1f4c = /*#__PURE__*/ $acw62.createContext({});
function $310357438448c55a$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(_ref, $310357438448c55a$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement($310357438448c55a$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $acw62 = parcelRequire("acw62");
var $f2cab49955333197$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $074b47b79b3d28d0$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $cca89218a8618991$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $84ba2e72b6987713$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $7a9b55a66186669e$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);
var $f2cab49955333197$export$2e2bcd8739ae039 = $f2cab49955333197$var$DomWrapper;








function $2ea3192b69fdce13$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}









function $14279cacbad06c51$export$2e2bcd8739ae039(r) {
    return (0, $388a4c6bba3ce78e$export$2e2bcd8739ae039)(r) || (0, $606eb0f614320d5a$export$2e2bcd8739ae039)(r) || (0, $366999254ccab9d4$export$2e2bcd8739ae039)(r) || (0, $80ae75a81caf04de$export$2e2bcd8739ae039)();
}



function $32c382c9a60f204f$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $14279cacbad06c51$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $a58b549eebfe4222$export$2e2bcd8739ae039)(entity);
    else clone = (0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $32c382c9a60f204f$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $32c382c9a60f204f$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $2ea3192b69fdce13$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $32c382c9a60f204f$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $32c382c9a60f204f$var$isObject(obj) {
    return (0, $a027291fe8adf132$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $32c382c9a60f204f$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $32c382c9a60f204f$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $32c382c9a60f204f$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $32c382c9a60f204f$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $2ea3192b69fdce13$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $32c382c9a60f204f$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $2ea3192b69fdce13$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $32c382c9a60f204f$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $a027291fe8adf132$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $32c382c9a60f204f$export$2e2bcd8739ae039(clone, path, $32c382c9a60f204f$var$createEmpty(value));
                    $32c382c9a60f204f$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $a58b549eebfe4222$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $32c382c9a60f204f$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}








var $acw62 = parcelRequire("acw62");

function $755e4a0a1258ca7d$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $acw62.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $acw62.useRef(defaultValue);
    var getValue = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}



var $acw62 = parcelRequire("acw62");
var $deb3a48c4c25c121$export$de71442bbf2143da = 'none';
var $deb3a48c4c25c121$export$4fc3521687bcacd2 = 'appear';
var $deb3a48c4c25c121$export$5d6af549241fe2e8 = 'enter';
var $deb3a48c4c25c121$export$59b1c493d29f68e4 = 'leave';
var $deb3a48c4c25c121$export$40b34dd77d5522bf = 'none';
var $deb3a48c4c25c121$export$1b792916a5fac4fc = 'prepare';
var $deb3a48c4c25c121$export$9563153dd25a3ce8 = 'start';
var $deb3a48c4c25c121$export$e205886172277ec6 = 'active';
var $deb3a48c4c25c121$export$3a846c3d2fac10b8 = 'end';
var $deb3a48c4c25c121$export$98351fa4e6b4f204 = 'prepared';



var $acw62 = parcelRequire("acw62");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $c79454008ece937f$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $c79454008ece937f$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $c79454008ece937f$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $c79454008ece937f$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $c79454008ece937f$var$vendorPrefixes = $c79454008ece937f$export$6e8b350b1a8958a0((0, $2c3d183b3bf70c7f$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
var $c79454008ece937f$var$style = {};
if ((0, $2c3d183b3bf70c7f$export$2e2bcd8739ae039)()) {
    var $c79454008ece937f$var$_document$createEleme = document.createElement('div');
    $c79454008ece937f$var$style = $c79454008ece937f$var$_document$createEleme.style;
}
var $c79454008ece937f$var$prefixedEventNames = {};
function $c79454008ece937f$export$a032e4f39350c1d8(eventName) {
    if ($c79454008ece937f$var$prefixedEventNames[eventName]) return $c79454008ece937f$var$prefixedEventNames[eventName];
    var prefixMap = $c79454008ece937f$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $c79454008ece937f$var$style) {
                $c79454008ece937f$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $c79454008ece937f$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $c79454008ece937f$var$internalAnimationEndName = $c79454008ece937f$export$a032e4f39350c1d8('animationend');
var $c79454008ece937f$var$internalTransitionEndName = $c79454008ece937f$export$a032e4f39350c1d8('transitionend');
var $c79454008ece937f$export$d28133ed3ad06c8b = !!($c79454008ece937f$var$internalAnimationEndName && $c79454008ece937f$var$internalTransitionEndName);
var $c79454008ece937f$export$760cc9769c51b738 = $c79454008ece937f$var$internalAnimationEndName || 'animationend';
var $c79454008ece937f$export$44baea64b8602e3c = $c79454008ece937f$var$internalTransitionEndName || 'transitionend';
function $c79454008ece937f$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $a027291fe8adf132$export$2e2bcd8739ae039)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $56df09c87c062576$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $acw62.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $c79454008ece937f$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $c79454008ece937f$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $c79454008ece937f$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $c79454008ece937f$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $acw62.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $acw62 = parcelRequire("acw62");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $a5d92eb9ef0caea2$var$useIsomorphicLayoutEffect = (0, $2c3d183b3bf70c7f$export$2e2bcd8739ae039)() ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $a5d92eb9ef0caea2$export$2e2bcd8739ae039 = $a5d92eb9ef0caea2$var$useIsomorphicLayoutEffect;





var $acw62 = parcelRequire("acw62");


var $e8a21a223d657761$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $e8a21a223d657761$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $e8a21a223d657761$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $e8a21a223d657761$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $e8a21a223d657761$var$rafUUID = 0;
var $e8a21a223d657761$var$rafIds = new Map();
function $e8a21a223d657761$var$cleanup(id) {
    $e8a21a223d657761$var$rafIds.delete(id);
}
var $e8a21a223d657761$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $e8a21a223d657761$var$rafUUID += 1;
    var id = $e8a21a223d657761$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $e8a21a223d657761$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $e8a21a223d657761$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $e8a21a223d657761$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$e8a21a223d657761$var$wrapperRaf.cancel = function(id) {
    var realId = $e8a21a223d657761$var$rafIds.get(id);
    $e8a21a223d657761$var$cleanup(id);
    return $e8a21a223d657761$var$caf(realId);
};
var $e8a21a223d657761$export$2e2bcd8739ae039 = $e8a21a223d657761$var$wrapperRaf;



var $acw62 = parcelRequire("acw62");
var $205b9cacad28e3c3$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $acw62.useRef(null);
    function cancelNextFrame() {
        (0, $e8a21a223d657761$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $e8a21a223d657761$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $8543e1d05e62ad08$var$FULL_STEP_QUEUE = [
    (0, $deb3a48c4c25c121$export$1b792916a5fac4fc),
    (0, $deb3a48c4c25c121$export$9563153dd25a3ce8),
    (0, $deb3a48c4c25c121$export$e205886172277ec6),
    (0, $deb3a48c4c25c121$export$3a846c3d2fac10b8)
];
var $8543e1d05e62ad08$var$SIMPLE_STEP_QUEUE = [
    (0, $deb3a48c4c25c121$export$1b792916a5fac4fc),
    (0, $deb3a48c4c25c121$export$98351fa4e6b4f204)
];
var $8543e1d05e62ad08$export$c2029bf6cfdbc28a = false;
var $8543e1d05e62ad08$export$dbee1e282e8c4830 = true;
function $8543e1d05e62ad08$export$39e04e72f972b885(step) {
    return step === (0, $deb3a48c4c25c121$export$e205886172277ec6) || step === (0, $deb3a48c4c25c121$export$3a846c3d2fac10b8);
}
var $8543e1d05e62ad08$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $95c2fc05dc5c51a6$export$2e2bcd8739ae039)((0, $deb3a48c4c25c121$export$40b34dd77d5522bf)), _useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $205b9cacad28e3c3$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $deb3a48c4c25c121$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $8543e1d05e62ad08$var$SIMPLE_STEP_QUEUE : $8543e1d05e62ad08$var$FULL_STEP_QUEUE;
    (0, $a5d92eb9ef0caea2$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $deb3a48c4c25c121$export$40b34dd77d5522bf) && step !== (0, $deb3a48c4c25c121$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $8543e1d05e62ad08$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $853a3dfcfcac9163$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $95c2fc05dc5c51a6$export$2e2bcd8739ae039)(), _useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $755e4a0a1258ca7d$export$2e2bcd8739ae039)((0, $deb3a48c4c25c121$export$de71442bbf2143da)), _useSyncState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $95c2fc05dc5c51a6$export$2e2bcd8739ae039)(null), _useState4 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $acw62.useRef)(false);
    var deadlineRef = (0, $acw62.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $acw62.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $deb3a48c4c25c121$export$de71442bbf2143da));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $deb3a48c4c25c121$export$de71442bbf2143da)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $deb3a48c4c25c121$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $deb3a48c4c25c121$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $deb3a48c4c25c121$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $56df09c87c062576$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $deb3a48c4c25c121$export$4fc3521687bcacd2:
                return (0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)({}, (0, $deb3a48c4c25c121$export$1b792916a5fac4fc), onAppearPrepare), (0, $deb3a48c4c25c121$export$9563153dd25a3ce8), onAppearStart), (0, $deb3a48c4c25c121$export$e205886172277ec6), onAppearActive);
            case 0, $deb3a48c4c25c121$export$5d6af549241fe2e8:
                return (0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)({}, (0, $deb3a48c4c25c121$export$1b792916a5fac4fc), onEnterPrepare), (0, $deb3a48c4c25c121$export$9563153dd25a3ce8), onEnterStart), (0, $deb3a48c4c25c121$export$e205886172277ec6), onEnterActive);
            case 0, $deb3a48c4c25c121$export$59b1c493d29f68e4:
                return (0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)({}, (0, $deb3a48c4c25c121$export$1b792916a5fac4fc), onLeavePrepare), (0, $deb3a48c4c25c121$export$9563153dd25a3ce8), onLeaveStart), (0, $deb3a48c4c25c121$export$e205886172277ec6), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $acw62.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $8543e1d05e62ad08$export$2e2bcd8739ae039)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $deb3a48c4c25c121$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $deb3a48c4c25c121$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $8543e1d05e62ad08$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $deb3a48c4c25c121$export$e205886172277ec6) && currentStatus !== (0, $deb3a48c4c25c121$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $deb3a48c4c25c121$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $8543e1d05e62ad08$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $8543e1d05e62ad08$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    // Update with new status
    (0, $a5d92eb9ef0caea2$export$2e2bcd8739ae039)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $deb3a48c4c25c121$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $deb3a48c4c25c121$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $deb3a48c4c25c121$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $deb3a48c4c25c121$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $deb3a48c4c25c121$export$de71442bbf2143da));
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $acw62.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $deb3a48c4c25c121$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $deb3a48c4c25c121$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $deb3a48c4c25c121$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $deb3a48c4c25c121$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $acw62.useRef(false);
    (0, $acw62.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $deb3a48c4c25c121$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $deb3a48c4c25c121$export$1b792916a5fac4fc] && step === (0, $deb3a48c4c25c121$export$9563153dd25a3ce8)) mergedStyle = (0, $f158faa5f7209115$export$2e2bcd8739ae039)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $a26cd1ef7431fb20$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $a027291fe8adf132$export$2e2bcd8739ae039)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $acw62.useContext((0, $310357438448c55a$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $acw62.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $acw62.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $304570ebe9398ed5$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $853a3dfcfcac9163$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $acw62.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $acw62.useCallback(function(node) {
            nodeRef.current = node;
            (0, $47c132296b70f4ba$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $deb3a48c4c25c121$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $deb3a48c4c25c121$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
            else if ((0, $8543e1d05e62ad08$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $deb3a48c4c25c121$export$9563153dd25a3ce8)) statusSuffix = 'start';
            var motionCls = (0, $c79454008ece937f$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $c79454008ece937f$export$27c72201b1d09951)(motionName, status), (0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $acw62.isValidElement(motionChildren) && (0, $47c132296b70f4ba$export$c1cec34af06bcf7)(motionChildren)) {
            var _ref = motionChildren, originNodeRef = _ref.ref;
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $acw62.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $acw62.createElement((0, $f2cab49955333197$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $a26cd1ef7431fb20$export$2e2bcd8739ae039 = $a26cd1ef7431fb20$export$e265d52a86a9f199((0, $c79454008ece937f$export$d28133ed3ad06c8b));












var $acw62 = parcelRequire("acw62");



var $95153f680213aad4$export$3904baa009bc026e = 'add';
var $95153f680213aad4$export$851162f0adad2cbc = 'keep';
var $95153f680213aad4$export$c8b3fb08b68cfc85 = 'remove';
var $95153f680213aad4$export$2ac1bd1808d2e43a = 'removed';
function $95153f680213aad4$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $a027291fe8adf132$export$2e2bcd8739ae039)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $95153f680213aad4$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($95153f680213aad4$export$c47fd798e598c85c);
}
function $95153f680213aad4$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $95153f680213aad4$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $95153f680213aad4$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $95153f680213aad4$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $95153f680213aad4$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $95153f680213aad4$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $95153f680213aad4$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $95153f680213aad4$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $95153f680213aad4$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $63ce251a9520b6b6$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $63ce251a9520b6b6$var$_excluded2 = [
    "status"
];
var $63ce251a9520b6b6$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $63ce251a9520b6b6$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $a26cd1ef7431fb20$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $074b47b79b3d28d0$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $cca89218a8618991$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $84ba2e72b6987713$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $bfbafecf40243909$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $bfbafecf40243909$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                var keyEntities = _this.state.keyEntities;
                var nextKeyEntities = keyEntities.map(function(entity) {
                    if (entity.key !== removeKey) return entity;
                    return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, entity), {}, {
                        status: (0, $95153f680213aad4$export$2ac1bd1808d2e43a)
                    });
                });
                _this.setState({
                    keyEntities: nextKeyEntities
                });
                return nextKeyEntities.filter(function(_ref) {
                    var status = _ref.status;
                    return status !== (0, $95153f680213aad4$export$2ac1bd1808d2e43a);
                }).length;
            });
            return _this;
        }
        (0, $7a9b55a66186669e$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(_this$props, $63ce251a9520b6b6$var$_excluded);
                    var Component = component || $acw62.Fragment;
                    var motionProps = {};
                    $63ce251a9520b6b6$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $acw62.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(_ref2, $63ce251a9520b6b6$var$_excluded2);
                        var visible = status === (0, $95153f680213aad4$export$3904baa009bc026e) || status === (0, $95153f680213aad4$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $acw62.createElement(CSSMotion, (0, $ff00798002f59629$export$2e2bcd8739ae039)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) {
                                    var restKeysCount = _this2.removeKey(eventProps.key);
                                    if (restKeysCount === 0 && onAllRemoved) onAllRemoved();
                                }
                            }
                        }), function(props, ref) {
                            return children((0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $95153f680213aad4$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $95153f680213aad4$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $95153f680213aad4$export$2ac1bd1808d2e43a) && entity.status === (0, $95153f680213aad4$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($acw62.Component);
    (0, $f8ce242576312548$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $63ce251a9520b6b6$export$2e2bcd8739ae039 = $63ce251a9520b6b6$export$fcfc62c1d33d5e2e((0, $c79454008ece937f$export$d28133ed3ad06c8b));



var $775e18c446ef3584$export$2e2bcd8739ae039 = (0, $a26cd1ef7431fb20$export$2e2bcd8739ae039);






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $6394fe1161c86d25$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, align = props.align, arrow = props.arrow, arrowPos = props.arrowPos;
    var _ref = arrow || {}, className = _ref.className, content = _ref.content;
    var _arrowPos$x = arrowPos.x, x = _arrowPos$x === void 0 ? 0 : _arrowPos$x, _arrowPos$y = arrowPos.y, y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
    var arrowRef = $acw62.useRef();
    // Skip if no align
    if (!align || !align.points) return null;
    var alignStyle = {
        position: 'absolute'
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        var popupPoints = align.points[0];
        var targetPoints = align.points[1];
        var popupTB = popupPoints[0];
        var popupLR = popupPoints[1];
        var targetTB = targetPoints[0];
        var targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            't',
            'b'
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === 't') alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            'l',
            'r'
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === 'l') alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: arrowRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-arrow"), className),
        style: alignStyle
    }, content);
}






var $acw62 = parcelRequire("acw62");
function $447fe9312ef9c323$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, open = props.open, zIndex = props.zIndex, mask = props.mask, motion = props.motion;
    if (!mask) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $775e18c446ef3584$export$2e2bcd8739ae039), (0, $ff00798002f59629$export$2e2bcd8739ae039)({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $acw62.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}



var $acw62 = parcelRequire("acw62");
var $57e044a11cb432bd$var$PopupContent = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, next) {
    return next.cache;
});
var $57e044a11cb432bd$export$2e2bcd8739ae039 = $57e044a11cb432bd$var$PopupContent;


var $393bf4595eefb065$var$Popup = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var popup = props.popup, className = props.className, prefixCls = props.prefixCls, style = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open = props.open, keepDom = props.keepDom, fresh = props.fresh, onClick = props.onClick, mask = props.mask, arrow = props.arrow, arrowPos = props.arrowPos, align = props.align, motion = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onPointerEnter = props.onPointerEnter, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, offsetR = props.offsetR, offsetB = props.offsetB, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
    var childNode = typeof popup === 'function' ? popup() : popup;
    // We can not remove holder only when motion finished.
    var isNodeVisible = open || keepDom;
    // ======================= Container ========================
    var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
    var _React$useState = $acw62.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
    // Delay to show since `getPopupContainer` need target element
    (0, $487b751945641e6d$export$2e2bcd8739ae039)(function() {
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Offset
    var AUTO = 'auto';
    var offsetStyle = {
        left: '-1000vw',
        top: '-1000vh',
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (ready || !open) {
        var _experimental;
        var points = align.points;
        var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
        var alignRight = dynamicInset && points[0][1] === 'r';
        var alignBottom = dynamicInset && points[0][0] === 'b';
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    // >>>>> Misc
    var miscStyle = {};
    if (stretch) {
        if (stretch.includes('height') && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes('minHeight') && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes('width') && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes('minWidth') && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = 'none';
    return /*#__PURE__*/ $acw62.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && function() {
            return getPopupContainer(target);
        },
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $acw62.createElement((0, $447fe9312ef9c323$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mask,
        motion: maskMotion
    }), /*#__PURE__*/ $acw62.createElement((0, $b05fd627f1f68d53$export$2e2bcd8739ae039), {
        onResize: onAlign,
        disabled: !open
    }, function(resizeObserverRef) {
        return /*#__PURE__*/ $acw62.createElement((0, $775e18c446ef3584$export$2e2bcd8739ae039), (0, $ff00798002f59629$export$2e2bcd8739ae039)({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: "".concat(prefixCls, "-hidden")
        }, motion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: function onVisibleChanged(nextVisible) {
                var _motion$onVisibleChan;
                motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
                _onVisibleChanged(nextVisible);
            }
        }), function(_ref, motionRef) {
            var motionClassName = _ref.className, motionStyle = _ref.style;
            var cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, motionClassName, className);
            return /*#__PURE__*/ $acw62.createElement("div", {
                ref: (0, $47c132296b70f4ba$export$ab452c34e8e05029)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({
                    '--arrow-x': "".concat(arrowPos.x || 0, "px"),
                    '--arrow-y': "".concat(arrowPos.y || 0, "px")
                }, offsetStyle), miscStyle), motionStyle), {}, {
                    boxSizing: 'border-box',
                    zIndex: zIndex
                }, style),
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick
            }, arrow && /*#__PURE__*/ $acw62.createElement((0, $6394fe1161c86d25$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $acw62.createElement((0, $57e044a11cb432bd$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, childNode));
        });
    }));
});
var $393bf4595eefb065$export$2e2bcd8739ae039 = $393bf4595eefb065$var$Popup;




var $acw62 = parcelRequire("acw62");
var $50097394d516a939$var$TriggerWrapper = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
    var canUseRef = (0, $47c132296b70f4ba$export$c1cec34af06bcf7)(children);
    // When use `getTriggerDOMNode`, we should do additional work to get the real dom
    var setRef = $acw62.useCallback(function(node) {
        (0, $47c132296b70f4ba$export$f17fd18fa51dcb5b)(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
    }, [
        getTriggerDOMNode
    ]);
    var mergedRef = (0, $47c132296b70f4ba$export$1d1c999670a1285d)(setRef, children.ref);
    return canUseRef ? /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    }) : children;
});
var $50097394d516a939$export$2e2bcd8739ae039 = $50097394d516a939$var$TriggerWrapper;



var $acw62 = parcelRequire("acw62");
var $c7524b99a0394f97$var$TriggerContext = /*#__PURE__*/ $acw62.createContext(null);
var $c7524b99a0394f97$export$2e2bcd8739ae039 = $c7524b99a0394f97$var$TriggerContext;



var $acw62 = parcelRequire("acw62");
function $5a4b4e9c6dc1e64b$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $5a4b4e9c6dc1e64b$export$2e2bcd8739ae039(mobile, action, showAction, hideAction) {
    return $acw62.useMemo(function() {
        var mergedShowAction = $5a4b4e9c6dc1e64b$var$toArray(showAction !== null && showAction !== void 0 ? showAction : action);
        var mergedHideAction = $5a4b4e9c6dc1e64b$var$toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
        var showActionSet = new Set(mergedShowAction);
        var hideActionSet = new Set(mergedHideAction);
        if (mobile) {
            if (showActionSet.has('hover')) {
                showActionSet.delete('hover');
                showActionSet.add('click');
            }
            if (hideActionSet.has('hover')) {
                hideActionSet.delete('hover');
                hideActionSet.add('click');
            }
        }
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        mobile,
        action,
        showAction,
        hideAction
    ]);
}





var $7799ba66c9d3d6be$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};





var $acw62 = parcelRequire("acw62");

function $121559bcc5a9425a$var$isPointsEq() {
    var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $121559bcc5a9425a$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var _builtinPlacements$pl;
        var placement = placements[i];
        if ($121559bcc5a9425a$var$isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return '';
}
function $121559bcc5a9425a$export$7b8936ddc277a29a(prefixCls, motion, animation, transitionName) {
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}
function $121559bcc5a9425a$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $121559bcc5a9425a$export$ba21ed9400ca485b(ele) {
    var scrollerList = [];
    var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
    var scrollStyle = [
        'hidden',
        'scroll',
        'clip',
        'auto'
    ];
    while(current){
        var _getWin$getComputedSt = $121559bcc5a9425a$export$9c0584a7cc24d9e(current).getComputedStyle(current), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY, overflow = _getWin$getComputedSt.overflow;
        if ([
            overflowX,
            overflowY,
            overflow
        ].some(function(o) {
            return scrollStyle.includes(o);
        })) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $121559bcc5a9425a$export$34dfc8f73bbb64ae(num) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Number.isNaN(num) ? defaultValue : num;
}
function $121559bcc5a9425a$var$getPxValue(val) {
    return $121559bcc5a9425a$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $121559bcc5a9425a$export$94be9d7985092f2d(initArea, scrollerList) {
    var visibleArea = (0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, initArea);
    (scrollerList || []).forEach(function(ele) {
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        var _getWin$getComputedSt2 = $121559bcc5a9425a$export$9c0584a7cc24d9e(ele).getComputedStyle(ele), overflow = _getWin$getComputedSt2.overflow, overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin, borderTopWidth = _getWin$getComputedSt2.borderTopWidth, borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth, borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth, borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
        var eleRect = ele.getBoundingClientRect();
        var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
        var borderTopNum = $121559bcc5a9425a$var$getPxValue(borderTopWidth);
        var borderBottomNum = $121559bcc5a9425a$var$getPxValue(borderBottomWidth);
        var borderLeftNum = $121559bcc5a9425a$var$getPxValue(borderLeftWidth);
        var borderRightNum = $121559bcc5a9425a$var$getPxValue(borderRightWidth);
        var scaleX = $121559bcc5a9425a$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        var scaleY = $121559bcc5a9425a$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        var scaledBorderTopWidth = borderTopNum * scaleY;
        var scaledBorderBottomWidth = borderBottomNum * scaleY;
        var scaledBorderLeftWidth = borderLeftNum * scaleX;
        var scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        var clipMarginWidth = 0;
        var clipMarginHeight = 0;
        if (overflow === 'clip') {
            var clipNum = $121559bcc5a9425a$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $0d5dced2bd4c9f40$var$getUnitOffset(size) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var offsetStr = "".concat(offset);
    var cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $0d5dced2bd4c9f40$var$getNumberOffset(rect, offset) {
    var _ref = offset || [], _ref2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_ref, 2), offsetX = _ref2[0], offsetY = _ref2[1];
    return [
        $0d5dced2bd4c9f40$var$getUnitOffset(rect.width, offsetX),
        $0d5dced2bd4c9f40$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $0d5dced2bd4c9f40$var$splitPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        points[0],
        points[1]
    ];
}
function $0d5dced2bd4c9f40$var$getAlignPoint(rect, points) {
    var topBottom = points[0];
    var leftRight = points[1];
    var x;
    var y;
    // Top & Bottom
    if (topBottom === 't') y = rect.y;
    else if (topBottom === 'b') y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === 'l') x = rect.x;
    else if (leftRight === 'r') x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $0d5dced2bd4c9f40$var$reversePoints(points, index) {
    var reverseMap = {
        t: 'b',
        b: 't',
        l: 'r',
        r: 'l'
    };
    return points.map(function(point, i) {
        if (i === index) return reverseMap[point] || 'c';
        return point;
    }).join('');
}
function $0d5dced2bd4c9f40$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
    var _React$useState = $acw62.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    }), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
    var alignCountRef = $acw62.useRef(0);
    var scrollerList = $acw62.useMemo(function() {
        if (!popupEle) return [];
        return (0, $121559bcc5a9425a$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    var prevFlipRef = $acw62.useRef({});
    var resetFlipCache = function resetFlipCache() {
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    var onAlign = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function() {
        if (popupEle && target && open) {
            var _popupElement$parentE, _popupElement$parentE2;
            var popupElement = popupEle;
            var doc = popupElement.ownerDocument;
            var win = (0, $121559bcc5a9425a$export$9c0584a7cc24d9e)(popupElement);
            var _win$getComputedStyle = win.getComputedStyle(popupElement), width = _win$getComputedStyle.width, height = _win$getComputedStyle.height, popupPosition = _win$getComputedStyle.position;
            var originLeft = popupElement.style.left;
            var originTop = popupElement.style.top;
            var originRight = popupElement.style.right;
            var originBottom = popupElement.style.bottom;
            var originOverflow = popupElement.style.overflow;
            // Placement
            var placementInfo = (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, builtinPlacements[placement]), popupAlign);
            // placeholder element
            var placeholderElement = doc.createElement('div');
            (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
            placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
            placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
            placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");
            // Reset first
            popupElement.style.left = '0';
            popupElement.style.top = '0';
            popupElement.style.right = 'auto';
            popupElement.style.bottom = 'auto';
            popupElement.style.overflow = 'hidden';
            // Calculate align style, we should consider `transform` case
            var targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                var rect = target.getBoundingClientRect();
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            var popupRect = popupElement.getBoundingClientRect();
            var _doc$documentElement = doc.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight, scrollWidth = _doc$documentElement.scrollWidth, scrollHeight = _doc$documentElement.scrollHeight, scrollTop = _doc$documentElement.scrollTop, scrollLeft = _doc$documentElement.scrollLeft;
            var popupHeight = popupRect.height;
            var popupWidth = popupRect.width;
            var targetHeight = targetRect.height;
            var targetWidth = targetRect.width;
            // Get bounding of visible area
            var visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            var scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            var htmlRegion = placementInfo.htmlRegion;
            var VISIBLE = 'visible';
            var VISIBLE_FIRST = 'visibleFirst';
            if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            var scrollRegionArea = (0, $121559bcc5a9425a$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            var visibleRegionArea = (0, $121559bcc5a9425a$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = 'auto';
            popupElement.style.top = 'auto';
            popupElement.style.right = '0';
            popupElement.style.bottom = '0';
            var popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);
            // Calculate scale
            var _scaleX = (0, $121559bcc5a9425a$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            var _scaleY = (0, $121559bcc5a9425a$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (_scaleX === 0 || _scaleY === 0 || (0, $304570ebe9398ed5$export$41e30d8dd0ba7a50)(target) && !(0, $7799ba66c9d3d6be$export$2e2bcd8739ae039)(target)) return;
            // Offset
            var offset = placementInfo.offset, targetOffset = placementInfo.targetOffset;
            var _getNumberOffset = $0d5dced2bd4c9f40$var$getNumberOffset(popupRect, offset), _getNumberOffset2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_getNumberOffset, 2), popupOffsetX = _getNumberOffset2[0], popupOffsetY = _getNumberOffset2[1];
            var _getNumberOffset3 = $0d5dced2bd4c9f40$var$getNumberOffset(targetRect, targetOffset), _getNumberOffset4 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_getNumberOffset3, 2), targetOffsetX = _getNumberOffset4[0], targetOffsetY = _getNumberOffset4[1];
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            var _ref3 = placementInfo.points || [], _ref4 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_ref3, 2), popupPoint = _ref4[0], targetPoint = _ref4[1];
            var targetPoints = $0d5dced2bd4c9f40$var$splitPoints(targetPoint);
            var popupPoints = $0d5dced2bd4c9f40$var$splitPoints(popupPoint);
            var targetAlignPoint = $0d5dced2bd4c9f40$var$getAlignPoint(targetRect, targetPoints);
            var popupAlignPoint = $0d5dced2bd4c9f40$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            var nextAlignInfo = (0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, placementInfo);
            // Next Offset
            var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY) {
                var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : visibleArea;
                var l = popupRect.x + offsetX;
                var t = popupRect.y + offsetY;
                var r = l + popupWidth;
                var b = t + popupHeight;
                var visibleL = Math.max(l, area.left);
                var visibleT = Math.max(t, area.top);
                var visibleR = Math.min(r, area.right);
                var visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            var targetAlignPointTL = $0d5dced2bd4c9f40$var$getAlignPoint(targetRect, [
                't',
                'l'
            ]);
            var popupAlignPointTL = $0d5dced2bd4c9f40$var$getAlignPoint(popupRect, [
                't',
                'l'
            ]);
            var targetAlignPointBR = $0d5dced2bd4c9f40$var$getAlignPoint(targetRect, [
                'b',
                'r'
            ]);
            var popupAlignPointBR = $0d5dced2bd4c9f40$var$getAlignPoint(popupRect, [
                'b',
                'r'
            ]);
            var overflow = placementInfo.overflow || {};
            var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
            var supportAdjust = function supportAdjust(val) {
                if (typeof val === 'boolean') return val;
                return val >= 0;
            };
            // Prepare position
            var nextPopupY;
            var nextPopupBottom;
            var nextPopupX;
            var nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            var needAdjustY = supportAdjust(adjustY);
            var sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                var tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $0d5dced2bd4c9f40$var$reversePoints(popupPoints, 0),
                        $0d5dced2bd4c9f40$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                var _tmpNextOffsetY = nextOffsetY;
                if (sameTB) _tmpNextOffsetY += popupHeight - targetHeight;
                else _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
                var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = _tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $0d5dced2bd4c9f40$var$reversePoints(popupPoints, 0),
                        $0d5dced2bd4c9f40$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            var needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            var sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                var tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea2 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $0d5dced2bd4c9f40$var$reversePoints(popupPoints, 1),
                        $0d5dced2bd4c9f40$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                var _tmpNextOffsetX = nextOffsetX;
                if (sameLR) _tmpNextOffsetX += popupWidth - targetWidth;
                else _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea3 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = _tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $0d5dced2bd4c9f40$var$reversePoints(popupPoints, 1),
                        $0d5dced2bd4c9f40$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            // ============================ Shift ============================
            syncNextPopupPosition();
            var numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === 'number') {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            var numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === 'number') {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            var popupLeft = popupRect.x + nextOffsetX;
            var popupRight = popupLeft + popupWidth;
            var popupTop = popupRect.y + nextOffsetY;
            var popupBottom = popupTop + popupHeight;
            var targetLeft = targetRect.x;
            var targetRight = targetLeft + targetWidth;
            var targetTop = targetRect.y;
            var targetBottom = targetTop + targetHeight;
            var maxLeft = Math.max(popupLeft, targetLeft);
            var minRight = Math.min(popupRight, targetRight);
            var xCenter = (maxLeft + minRight) / 2;
            var nextArrowX = xCenter - popupLeft;
            var maxTop = Math.max(popupTop, targetTop);
            var minBottom = Math.min(popupBottom, targetBottom);
            var yCenter = (maxTop + minBottom) / 2;
            var nextArrowY = yCenter - popupTop;
            onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (_scaleX === 1) {
                nextOffsetX = Math.round(nextOffsetX);
                offsetX4Right = Math.round(offsetX4Right);
            }
            if (_scaleY === 1) {
                nextOffsetY = Math.round(nextOffsetY);
                offsetY4Bottom = Math.round(offsetY4Bottom);
            }
            var nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / _scaleX,
                offsetY: nextOffsetY / _scaleY,
                offsetR: offsetX4Right / _scaleX,
                offsetB: offsetY4Bottom / _scaleY,
                arrowX: nextArrowX / _scaleX,
                arrowY: nextArrowY / _scaleY,
                scaleX: _scaleX,
                scaleY: _scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    var triggerAlign = function triggerAlign() {
        alignCountRef.current += 1;
        var id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(function() {
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    var resetReady = function resetReady() {
        setOffsetInfo(function(ori) {
            return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, ori), {}, {
                ready: false
            });
        });
    };
    (0, $487b751945641e6d$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $487b751945641e6d$export$2e2bcd8739ae039)(function() {
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}





function $e136af471ba05c80$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $487b751945641e6d$export$2e2bcd8739ae039)(function() {
        if (open && target && popup) {
            var targetElement = target;
            var popupElement = popup;
            var targetScrollList = (0, $121559bcc5a9425a$export$ba21ed9400ca485b)(targetElement);
            var popupScrollList = (0, $121559bcc5a9425a$export$ba21ed9400ca485b)(popupElement);
            var win = (0, $121559bcc5a9425a$export$9c0584a7cc24d9e)(popupElement);
            var mergedList = new Set([
                win
            ].concat((0, $a58b549eebfe4222$export$2e2bcd8739ae039)(targetScrollList), (0, $a58b549eebfe4222$export$2e2bcd8739ae039)(popupScrollList)));
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach(function(scroller) {
                scroller.addEventListener('scroll', notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener('resize', notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return function() {
                mergedList.forEach(function(scroller) {
                    scroller.removeEventListener('scroll', notifyScroll);
                    win.removeEventListener('resize', notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}





var $acw62 = parcelRequire("acw62");

function $4197b9d2a296b9f5$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    var openRef = $acw62.useRef(open);
    openRef.current = open;
    // Click to hide is special action since click popup element should not hide
    $acw62.useEffect(function() {
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            var onTriggerClose = function onTriggerClose(e) {
                var _e$composedPath;
                if (openRef.current && !inPopupOrChild(((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 || (_e$composedPath = _e$composedPath.call(e)) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath[0]) || e.target)) triggerOpen(false);
            };
            var win = (0, $121559bcc5a9425a$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener('mousedown', onTriggerClose, true);
            win.addEventListener('contextmenu', onTriggerClose, true);
            // shadow root
            var targetShadowRoot = (0, $7cc75555f3dbd7d9$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
                targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
            }
            var _targetEle$getRootNod, _popupEle$getRootNode, targetRoot, popupRoot;
            return function() {
                win.removeEventListener('mousedown', onTriggerClose, true);
                win.removeEventListener('contextmenu', onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
                    targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
}



var $6b85088f31d04f27$var$_excluded = [
    "prefixCls",
    "children",
    "action",
    "showAction",
    "hideAction",
    "popupVisible",
    "defaultPopupVisible",
    "onPopupVisibleChange",
    "afterPopupVisibleChange",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "focusDelay",
    "blurDelay",
    "mask",
    "maskClosable",
    "getPopupContainer",
    "forceRender",
    "autoDestroy",
    "destroyPopupOnHide",
    "popup",
    "popupClassName",
    "popupStyle",
    "popupPlacement",
    "builtinPlacements",
    "popupAlign",
    "zIndex",
    "stretch",
    "getPopupClassNameFromAlign",
    "fresh",
    "alignPoint",
    "onPopupClick",
    "onPopupAlign",
    "arrow",
    "popupMotion",
    "maskMotion",
    "popupTransitionName",
    "popupAnimation",
    "maskTransitionName",
    "maskAnimation",
    "className",
    "getTriggerDOMNode"
];
function $6b85088f31d04f27$export$55e99723d7f71b47() {
    var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $5b46218595a40828$export$2e2bcd8739ae039);
    var Trigger = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-trigger-popup' : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? 'hover' : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, fresh = props.fresh, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(props, $6b85088f31d04f27$var$_excluded);
        var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
        // =========================== Mobile ===========================
        var _React$useState = $acw62.useState(false), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
        (0, $487b751945641e6d$export$2e2bcd8739ae039)(function() {
            setMobile((0, $b1be107f50e802ac$export$2e2bcd8739ae039)());
        }, []);
        // ========================== Context ===========================
        var subPopupElements = $acw62.useRef({});
        var parentContext = $acw62.useContext((0, $c7524b99a0394f97$export$2e2bcd8739ae039));
        var context = $acw62.useMemo(function() {
            return {
                registerSubPopup: function registerSubPopup(id, subPopupEle) {
                    subPopupElements.current[id] = subPopupEle;
                    parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // =========================== Popup ============================
        var id = (0, $1f01f3fbc9fc76da$export$2e2bcd8739ae039)();
        var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState3, 2), popupEle = _React$useState4[0], setPopupEle = _React$useState4[1];
        // Used for forwardRef popup. Not use internal
        var externalPopupRef = $acw62.useRef(null);
        var setPopupRef = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function(node) {
            externalPopupRef.current = node;
            if ((0, $304570ebe9398ed5$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
            parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        var _React$useState5 = $acw62.useState(null), _React$useState6 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState5, 2), targetEle = _React$useState6[0], setTargetEle = _React$useState6[1];
        // Used for forwardRef target. Not use internal
        var externalForwardRef = $acw62.useRef(null);
        var setTargetRef = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function(node) {
            if ((0, $304570ebe9398ed5$export$41e30d8dd0ba7a50)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        // ========================== Children ==========================
        var child = $acw62.Children.only(children);
        var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var cloneProps = {};
        var inPopupOrChild = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function(ele) {
            var _getShadowRoot, _getShadowRoot2;
            var childDOM = targetEle;
            return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = (0, $7cc75555f3dbd7d9$export$70e8259662bb498b)(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = (0, $7cc75555f3dbd7d9$export$70e8259662bb498b)(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
                return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
            });
        });
        // =========================== Motion ===========================
        var mergePopupMotion = (0, $121559bcc5a9425a$export$7b8936ddc277a29a)(prefixCls, popupMotion, popupAnimation, popupTransitionName);
        var mergeMaskMotion = (0, $121559bcc5a9425a$export$7b8936ddc277a29a)(prefixCls, maskMotion, maskAnimation, maskTransitionName);
        // ============================ Open ============================
        var _React$useState7 = $acw62.useState(defaultPopupVisible || false), _React$useState8 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState7, 2), internalOpen = _React$useState8[0], setInternalOpen = _React$useState8[1];
        // Render still use props as first priority
        var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;
        // We use effect sync here in case `popupVisible` back to `undefined`
        var setMergedOpen = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function(nextOpen) {
            if (popupVisible === undefined) setInternalOpen(nextOpen);
        });
        (0, $487b751945641e6d$export$2e2bcd8739ae039)(function() {
            setInternalOpen(popupVisible || false);
        }, [
            popupVisible
        ]);
        var openRef = $acw62.useRef(mergedOpen);
        openRef.current = mergedOpen;
        var lastTriggerRef = $acw62.useRef([]);
        lastTriggerRef.current = [];
        var internalTriggerOpen = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function(nextOpen) {
            var _lastTriggerRef$curre;
            setMergedOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
            }
        });
        // Trigger for delay
        var delayRef = $acw62.useRef();
        var clearDelay = function clearDelay() {
            clearTimeout(delayRef.current);
        };
        var triggerOpen = function triggerOpen(nextOpen) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            clearDelay();
            if (delay === 0) internalTriggerOpen(nextOpen);
            else delayRef.current = setTimeout(function() {
                internalTriggerOpen(nextOpen);
            }, delay * 1000);
        };
        $acw62.useEffect(function() {
            return clearDelay;
        }, []);
        // ========================== Motion ============================
        var _React$useState9 = $acw62.useState(false), _React$useState10 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState9, 2), inMotion = _React$useState10[0], setInMotion = _React$useState10[1];
        (0, $487b751945641e6d$export$2e2bcd8739ae039)(function(firstMount) {
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        var _React$useState11 = $acw62.useState(null), _React$useState12 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState11, 2), motionPrepareResolve = _React$useState12[0], setMotionPrepareResolve = _React$useState12[1];
        // =========================== Align ============================
        var _React$useState13 = $acw62.useState([
            0,
            0
        ]), _React$useState14 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState13, 2), mousePos = _React$useState14[0], setMousePos = _React$useState14[1];
        var setMousePosByEvent = function setMousePosByEvent(event) {
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        var _useAlign = (0, $0d5dced2bd4c9f40$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useAlign, 11), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], offsetR = _useAlign2[3], offsetB = _useAlign2[4], arrowX = _useAlign2[5], arrowY = _useAlign2[6], scaleX = _useAlign2[7], scaleY = _useAlign2[8], alignInfo = _useAlign2[9], onAlign = _useAlign2[10];
        var _useAction = (0, $5a4b4e9c6dc1e64b$export$2e2bcd8739ae039)(mobile, action, showAction, hideAction), _useAction2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
        var clickToShow = showActions.has('click');
        var clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
        var triggerAlign = (0, $1e7bb58384cf00ac$export$2e2bcd8739ae039)(function() {
            if (!inMotion) onAlign();
        });
        var onScroll = function onScroll() {
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $e136af471ba05c80$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $487b751945641e6d$export$2e2bcd8739ae039)(function() {
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $487b751945641e6d$export$2e2bcd8739ae039)(function() {
            if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        var alignedClassName = $acw62.useMemo(function() {
            var baseClassName = (0, $121559bcc5a9425a$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $acw62.useImperativeHandle(ref, function() {
            return {
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            };
        });
        // ========================== Stretch ===========================
        var _React$useState15 = $acw62.useState(0), _React$useState16 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState15, 2), targetWidth = _React$useState16[0], setTargetWidth = _React$useState16[1];
        var _React$useState17 = $acw62.useState(0), _React$useState18 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState17, 2), targetHeight = _React$useState18[0], setTargetHeight = _React$useState18[1];
        var syncTargetSize = function syncTargetSize() {
            if (stretch && targetEle) {
                var rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        var onTargetResize = function onTargetResize() {
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        var onVisibleChanged = function onVisibleChanged(visible) {
            setInMotion(false);
            onAlign();
            afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
        };
        // We will trigger align when motion is in prepare
        var onPrepare = function onPrepare() {
            return new Promise(function(resolve) {
                syncTargetSize();
                setMotionPrepareResolve(function() {
                    return resolve;
                });
            });
        };
        (0, $487b751945641e6d$export$2e2bcd8739ae039)(function() {
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     */ function wrapperAction(eventName, nextOpen, delay, preEvent) {
            cloneProps[eventName] = function(event) {
                var _originChildProps$eve;
                preEvent === null || preEvent === void 0 || preEvent(event);
                triggerOpen(nextOpen, delay);
                // Pass to origin
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [
                    originChildProps,
                    event
                ].concat(args));
            };
        }
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = function(event) {
            var _originChildProps$onC;
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [
                originChildProps,
                event
            ].concat(args));
        };
        // Click to hide is special action since click popup element should not hide
        (0, $4197b9d2a296b9f5$export$2e2bcd8739ae039)(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        var hoverToShow = showActions.has('hover');
        var hoverToHide = hideActions.has('hover');
        var onPopupMouseEnter;
        var onPopupMouseLeave;
        if (hoverToShow) {
            // Compatible with old browser which not support pointer event
            wrapperAction('onMouseEnter', true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            wrapperAction('onPointerEnter', true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            onPopupMouseEnter = function onPopupMouseEnter(event) {
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle !== null && popupEle !== void 0 && popupEle.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = function(event) {
                var _originChildProps$onM;
                // setMousePosByEvent(event);
                (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
            };
        }
        if (hoverToHide) {
            wrapperAction('onMouseLeave', false, mouseLeaveDelay);
            wrapperAction('onPointerLeave', false, mouseLeaveDelay);
            onPopupMouseLeave = function onPopupMouseLeave() {
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has('focus')) wrapperAction('onFocus', true, focusDelay);
        if (hideActions.has('focus')) wrapperAction('onBlur', false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has('contextMenu')) cloneProps.onContextMenu = function(event) {
            var _originChildProps$onC2;
            if (openRef.current && hideActions.has('contextMenu')) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [
                originChildProps,
                event
            ].concat(args));
        };
        // ========================= ClassName ==========================
        if (className) cloneProps.className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(originChildProps.className, className);
        // =========================== Render ===========================
        var mergedChildrenProps = (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, originChildProps), cloneProps);
        // Pass props into cloneProps for nest usage
        var passedProps = {};
        var passedEventList = [
            'onContextMenu',
            'onClick',
            'onMouseDown',
            'onTouchStart',
            'onMouseEnter',
            'onMouseLeave',
            'onFocus',
            'onBlur'
        ];
        passedEventList.forEach(function(eventName) {
            if (restProps[eventName]) passedProps[eventName] = function() {
                var _mergedChildrenProps$;
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [
                    mergedChildrenProps
                ].concat(args));
                restProps[eventName].apply(restProps, args);
            };
        });
        // Child Node
        var triggerNode = /*#__PURE__*/ $acw62.cloneElement(child, (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, mergedChildrenProps), passedProps));
        var arrowPos = {
            x: arrowX,
            y: arrowY
        };
        var innerArrow = arrow ? (0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, arrow !== true ? arrow : {}) : null;
        // Render
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $b05fd627f1f68d53$export$2e2bcd8739ae039), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, /*#__PURE__*/ $acw62.createElement((0, $50097394d516a939$export$2e2bcd8739ae039), {
            getTriggerDOMNode: getTriggerDOMNode
        }, triggerNode)), /*#__PURE__*/ $acw62.createElement((0, $c7524b99a0394f97$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $acw62.createElement((0, $393bf4595eefb065$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(popupClassName, alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            mask: mask,
            motion: mergePopupMotion,
            maskMotion: mergeMaskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY
        })));
    });
    return Trigger;
}
var $6b85088f31d04f27$export$2e2bcd8739ae039 = $6b85088f31d04f27$export$55e99723d7f71b47((0, $5b46218595a40828$export$2e2bcd8739ae039));




var $acw62 = parcelRequire("acw62");
var $0585b16d7d6fbb78$var$_excluded = [
    "prefixCls",
    "disabled",
    "visible",
    "children",
    "popupElement",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "direction",
    "placement",
    "builtinPlacements",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "getPopupContainer",
    "empty",
    "getTriggerDOMNode",
    "onPopupVisibleChange",
    "onPopupMouseEnter"
];
var $0585b16d7d6fbb78$var$getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        bottomRight: {
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topLeft: {
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        },
        topRight: {
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: 'scroll'
        }
    };
};
var $0585b16d7d6fbb78$var$SelectTrigger = function SelectTrigger(props, ref) {
    var prefixCls = props.prefixCls, disabled = props.disabled, visible = props.visible, children = props.children, popupElement = props.popupElement, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? 'ltr' : _props$direction, placement = props.placement, builtinPlacements = props.builtinPlacements, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, onPopupMouseEnter = props.onPopupMouseEnter, restProps = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(props, $0585b16d7d6fbb78$var$_excluded);
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var popupNode = popupElement;
    if (dropdownRender) popupNode = dropdownRender(popupElement);
    var mergedBuiltinPlacements = $acw62.useMemo(function() {
        return builtinPlacements || $0585b16d7d6fbb78$var$getBuiltInPlacements(dropdownMatchSelectWidth);
    }, [
        builtinPlacements,
        dropdownMatchSelectWidth
    ]);
    // ===================== Motion ======================
    var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;
    // =================== Popup Width ===================
    var isNumberPopupWidth = typeof dropdownMatchSelectWidth === 'number';
    var stretch = $acw62.useMemo(function() {
        if (isNumberPopupWidth) return null;
        return dropdownMatchSelectWidth === false ? 'minWidth' : 'width';
    }, [
        dropdownMatchSelectWidth,
        isNumberPopupWidth
    ]);
    var popupStyle = dropdownStyle;
    if (isNumberPopupWidth) popupStyle = (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, popupStyle), {}, {
        width: dropdownMatchSelectWidth
    });
    // ======================= Ref =======================
    var triggerPopupRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, function() {
        return {
            getPopupElement: function getPopupElement() {
                var _triggerPopupRef$curr;
                return (_triggerPopupRef$curr = triggerPopupRef.current) === null || _triggerPopupRef$curr === void 0 ? void 0 : _triggerPopupRef$curr.popupElement;
            }
        };
    });
    return /*#__PURE__*/ $acw62.createElement((0, $6b85088f31d04f27$export$2e2bcd8739ae039), (0, $ff00798002f59629$export$2e2bcd8739ae039)({}, restProps, {
        showAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        hideAction: onPopupVisibleChange ? [
            'click'
        ] : [],
        popupPlacement: placement || (direction === 'rtl' ? 'bottomRight' : 'bottomLeft'),
        builtinPlacements: mergedBuiltinPlacements,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: mergedTransitionName,
        popup: /*#__PURE__*/ $acw62.createElement("div", {
            onMouseEnter: onPopupMouseEnter
        }, popupNode),
        ref: triggerPopupRef,
        stretch: stretch,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(dropdownClassName, (0, $f8ce242576312548$export$2e2bcd8739ae039)({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
        popupStyle: popupStyle,
        getTriggerDOMNode: getTriggerDOMNode,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
var $0585b16d7d6fbb78$var$RefSelectTrigger = /*#__PURE__*/ $acw62.forwardRef($0585b16d7d6fbb78$var$SelectTrigger);
var $0585b16d7d6fbb78$export$2e2bcd8739ae039 = $0585b16d7d6fbb78$var$RefSelectTrigger;







function $8dfd2b5394871903$var$getKey(data, index) {
    var key = data.key;
    var value;
    if ('value' in data) value = data.value;
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return "rc-index-key-".concat(index);
}
function $8dfd2b5394871903$export$be48fd776273e509(value) {
    return typeof value !== 'undefined' && !Number.isNaN(value);
}
function $8dfd2b5394871903$export$6c519d302dced239(fieldNames, childrenAsData) {
    var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options, groupLabel = _ref.groupLabel;
    var mergedLabel = label || (childrenAsData ? 'children' : 'label');
    return {
        label: mergedLabel,
        value: value || 'value',
        options: options || 'options',
        groupLabel: groupLabel || mergedLabel
    };
}
function $8dfd2b5394871903$export$7baa7c13b358b002(options) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
    var flattenList = [];
    var _fillFieldNames = $8dfd2b5394871903$export$6c519d302dced239(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options, groupLabel = _fillFieldNames.groupLabel;
    function dig(list, isGroupOption) {
        if (!Array.isArray(list)) return;
        list.forEach(function(data) {
            if (isGroupOption || !(fieldOptions in data)) {
                var value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $8dfd2b5394871903$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: data[fieldLabel],
                    value: value
                });
            } else {
                var grpLabel = data[groupLabel];
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $8dfd2b5394871903$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $8dfd2b5394871903$export$d0b21b213c8c013c(option) {
    var newOption = (0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, option);
    if (!('props' in newOption)) Object.defineProperty(newOption, 'props', {
        get: function get() {
            (0, $a62d89528dce911b$export$2e2bcd8739ae039)(false, 'Return type is option instead of Option instance. Please read value directly instead of reading from `props`.');
            return newOption;
        }
    });
    return newOption;
}
var $8dfd2b5394871903$export$a09ca2a89e052b14 = function getSeparatedContent(text, tokens, end) {
    if (!tokens || !tokens.length) return null;
    var match = false;
    var separate = function separate(str, _ref3) {
        var _ref4 = (0, $14279cacbad06c51$export$2e2bcd8739ae039)(_ref3), token = _ref4[0], restTokens = _ref4.slice(1);
        if (!token) return [
            str
        ];
        var list = str.split(token);
        match = match || list.length > 1;
        return list.reduce(function(prevList, unitStr) {
            return [].concat((0, $a58b549eebfe4222$export$2e2bcd8739ae039)(prevList), (0, $a58b549eebfe4222$export$2e2bcd8739ae039)(separate(unitStr, restTokens)));
        }, []).filter(Boolean);
    };
    var list = separate(text, tokens);
    if (match) return typeof end !== 'undefined' ? list.slice(0, end) : list;
    else return null;
};



var $acw62 = parcelRequire("acw62");
// Use any here since we do not get the type during compilation
var $46e904f7b592b3f3$var$SelectContext = /*#__PURE__*/ $acw62.createContext(null);
var $46e904f7b592b3f3$export$2e2bcd8739ae039 = $46e904f7b592b3f3$var$SelectContext;




var $acw62 = parcelRequire("acw62");
function $a4ed346aebb47f7d$export$2e2bcd8739ae039(props) {
    var visible = props.visible, values = props.values;
    if (!visible) return null;
    // Only cut part of values since it's a screen reader
    var MAX_COUNT = 50;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, "".concat(values.slice(0, MAX_COUNT).map(function(_ref) {
        var label = _ref.label, value = _ref.value;
        return [
            'number',
            'string'
        ].includes((0, $a027291fe8adf132$export$2e2bcd8739ae039)(label)) ? label : value;
    }).join(', ')), values.length > MAX_COUNT ? ', ...' : null);
}


var $bbedbc5316baa190$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "showSearch",
    "tagRender",
    "direction",
    "omitDomProps",
    "displayValues",
    "onDisplayValuesChange",
    "emptyOptions",
    "notFoundContent",
    "onClear",
    "mode",
    "disabled",
    "loading",
    "getInputElement",
    "getRawInputElement",
    "open",
    "defaultOpen",
    "onDropdownVisibleChange",
    "activeValue",
    "onActiveValueChange",
    "activeDescendantId",
    "searchValue",
    "autoClearSearchValue",
    "onSearch",
    "onSearchSplit",
    "tokenSeparators",
    "allowClear",
    "prefix",
    "suffixIcon",
    "clearIcon",
    "OptionList",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "placement",
    "builtinPlacements",
    "getPopupContainer",
    "showAction",
    "onFocus",
    "onBlur",
    "onKeyUp",
    "onKeyDown",
    "onMouseDown"
];
var $bbedbc5316baa190$var$DEFAULT_OMIT_PROPS = [
    'value',
    'onChange',
    'removeIcon',
    'placeholder',
    'autoFocus',
    'maxTagCount',
    'maxTagTextLength',
    'maxTagPlaceholder',
    'choiceTransitionName',
    'onInputKeyDown',
    'onPopupScroll',
    'tabIndex'
];
var $bbedbc5316baa190$export$7f654ad2a77ad2ac = function isMultiple(mode) {
    return mode === 'tags' || mode === 'multiple';
};
var $bbedbc5316baa190$var$BaseSelect = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _customizeRawInputEle;
    var id = props.id, prefixCls = props.prefixCls, className = props.className, showSearch = props.showSearch, tagRender = props.tagRender, direction = props.direction, omitDomProps = props.omitDomProps, displayValues = props.displayValues, onDisplayValuesChange = props.onDisplayValuesChange, emptyOptions = props.emptyOptions, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? 'Not Found' : _props$notFoundConten, onClear = props.onClear, mode = props.mode, disabled = props.disabled, loading = props.loading, getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, open = props.open, defaultOpen = props.defaultOpen, onDropdownVisibleChange = props.onDropdownVisibleChange, activeValue = props.activeValue, onActiveValueChange = props.onActiveValueChange, activeDescendantId = props.activeDescendantId, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSplit = props.onSearchSplit, tokenSeparators = props.tokenSeparators, allowClear = props.allowClear, prefix = props.prefix, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, OptionList = props.OptionList, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, placement = props.placement, builtinPlacements = props.builtinPlacements, getPopupContainer = props.getPopupContainer, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, onFocus = props.onFocus, onBlur = props.onBlur, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, restProps = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(props, $bbedbc5316baa190$var$_excluded);
    // ============================== MISC ==============================
    var multiple = $bbedbc5316baa190$export$7f654ad2a77ad2ac(mode);
    var mergedShowSearch = (showSearch !== undefined ? showSearch : multiple) || mode === 'combobox';
    var domProps = (0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, restProps);
    $bbedbc5316baa190$var$DEFAULT_OMIT_PROPS.forEach(function(propName) {
        delete domProps[propName];
    });
    omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function(propName) {
        delete domProps[propName];
    });
    // ============================= Mobile =============================
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
    $acw62.useEffect(function() {
        // Only update on the client side
        setMobile((0, $b1be107f50e802ac$export$2e2bcd8739ae039)());
    }, []);
    // ============================== Refs ==============================
    var containerRef = $acw62.useRef(null);
    var selectorDomRef = $acw62.useRef(null);
    var triggerRef = $acw62.useRef(null);
    var selectorRef = $acw62.useRef(null);
    var listRef = $acw62.useRef(null);
    var blurRef = $acw62.useRef(false);
    /** Used for component focused management */ var _useDelayReset = (0, $a8e0c2247e7f8218$export$2e2bcd8739ae039)(), _useDelayReset2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    // =========================== Imperative ===========================
    $acw62.useImperativeHandle(ref, function() {
        var _selectorRef$current, _selectorRef$current2;
        return {
            focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
            blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
            scrollTo: function scrollTo(arg) {
                var _listRef$current;
                return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
            },
            nativeElement: containerRef.current || selectorDomRef.current
        };
    });
    // ========================== Search Value ==========================
    var mergedSearchValue = $acw62.useMemo(function() {
        var _displayValues$;
        if (mode !== 'combobox') return searchValue;
        var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
        return typeof val === 'string' || typeof val === 'number' ? String(val) : '';
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    var customizeInputElement = mode === 'combobox' && typeof getInputElement === 'function' && getInputElement() || null;
    // Used for customize replacement for `rc-cascader`
    var customizeRawInputElement = typeof getRawInputElement === 'function' && getRawInputElement();
    var customizeRawInputRef = (0, $47c132296b70f4ba$export$1d1c999670a1285d)(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 || (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);
    // ============================== Open ==============================
    // SSR not support Portal which means we need delay `open` for the first time render
    var _React$useState3 = $acw62.useState(false), _React$useState4 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState3, 2), rendered = _React$useState4[0], setRendered = _React$useState4[1];
    (0, $487b751945641e6d$export$2e2bcd8739ae039)(function() {
        setRendered(true);
    }, []);
    var _useMergedState = (0, $908b598c9326ab1c$export$2e2bcd8739ae039)(false, {
        defaultValue: defaultOpen,
        value: open
    }), _useMergedState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useMergedState, 2), innerOpen = _useMergedState2[0], setInnerOpen = _useMergedState2[1];
    var mergedOpen = rendered ? innerOpen : false;
    // Not trigger `open` in `combobox` when `notFoundContent` is empty
    var emptyListContent = !notFoundContent && emptyOptions;
    if (disabled || emptyListContent && mergedOpen && mode === 'combobox') mergedOpen = false;
    var triggerOpen = emptyListContent ? false : mergedOpen;
    var onToggleOpen = $acw62.useCallback(function(newOpen) {
        var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
        if (!disabled) {
            setInnerOpen(nextOpen);
            if (mergedOpen !== nextOpen) onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
        }
    }, [
        disabled,
        mergedOpen,
        setInnerOpen,
        onDropdownVisibleChange
    ]);
    // ============================= Search =============================
    var tokenWithEnter = $acw62.useMemo(function() {
        return (tokenSeparators || []).some(function(tokenSeparator) {
            return [
                '\n',
                '\r\n'
            ].includes(tokenSeparator);
        });
    }, [
        tokenSeparators
    ]);
    var _ref = $acw62.useContext((0, $46e904f7b592b3f3$export$2e2bcd8739ae039)) || {}, maxCount = _ref.maxCount, rawValues = _ref.rawValues;
    var onInternalSearch = function onInternalSearch(searchText, fromTyping, isCompositing) {
        if (multiple && (0, $8dfd2b5394871903$export$be48fd776273e509)(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount) return;
        var ret = true;
        var newSearchText = searchText;
        onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
        var separatedList = (0, $8dfd2b5394871903$export$a09ca2a89e052b14)(searchText, tokenSeparators, (0, $8dfd2b5394871903$export$be48fd776273e509)(maxCount) ? maxCount - rawValues.size : undefined);
        // Check if match the `tokenSeparators`
        var patchLabels = isCompositing ? null : separatedList;
        // Ignore combobox since it's not split-able
        if (mode !== 'combobox' && patchLabels) {
            newSearchText = '';
            onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);
            // Should close when paste finish
            onToggleOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? 'typing' : 'effect'
        });
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    var onInternalSearchSubmit = function onInternalSearchSubmit(searchText) {
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: 'submit'
        });
    };
    // Close will clean up single mode search text
    $acw62.useEffect(function() {
        if (!mergedOpen && !multiple && mode !== 'combobox') onInternalSearch('', false, false);
    }, [
        mergedOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $acw62.useEffect(function() {
        if (innerOpen && disabled) setInnerOpen(false);
        // After onBlur is triggered, the focused does not need to be reset
        if (disabled && !blurRef.current) setMockFocused(false);
    }, [
        disabled
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ var _useLock = (0, $d2cdf88fff85fc3a$export$2e2bcd8739ae039)(), _useLock2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    var keyLockRef = $acw62.useRef(false);
    // KeyDown
    var onInternalKeyDown = function onInternalKeyDown(event) {
        var clearLock = getClearLock();
        var key = event.key;
        var isEnterKey = key === 'Enter';
        if (isEnterKey) {
            // Do not submit form when type in the input
            if (mode !== 'combobox') event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) onToggleOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (key === 'Backspace' && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            var cloneDisplayValues = (0, $a58b549eebfe4222$export$2e2bcd8739ae039)(displayValues);
            var removedDisplayValue = null;
            for(var i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                var current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: 'remove',
                values: [
                    removedDisplayValue
                ]
            });
        }
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (mergedOpen && (!isEnterKey || !keyLockRef.current)) {
            var _listRef$current2;
            // Lock the Enter key after it is pressed to avoid repeated triggering of the onChange event.
            if (isEnterKey) keyLockRef.current = true;
            (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.onKeyDown.apply(_listRef$current2, [
                event
            ].concat(rest));
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    };
    // KeyUp
    var onInternalKeyUp = function onInternalKeyUp(event) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        if (mergedOpen) {
            var _listRef$current3;
            (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 || _listRef$current3.onKeyUp.apply(_listRef$current3, [
                event
            ].concat(rest));
        }
        if (event.key === 'Enter') keyLockRef.current = false;
        onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [
            event
        ].concat(rest));
    };
    // ============================ Selector ============================
    var onSelectorRemove = function onSelectorRemove(val) {
        var newValues = displayValues.filter(function(i) {
            return i !== val;
        });
        onDisplayValuesChange(newValues, {
            type: 'remove',
            values: [
                val
            ]
        });
    };
    var onInputBlur = function onInputBlur() {
        // Unlock the Enter key after the input blur; otherwise, the Enter key needs to be pressed twice to trigger the correct effect.
        keyLockRef.current = false;
    };
    // ========================== Focus / Blur ==========================
    /** Record real focus status */ var focusRef = $acw62.useRef(false);
    var onContainerFocus = function onContainerFocus() {
        setMockFocused(true);
        if (!disabled) {
            if (onFocus && !focusRef.current) onFocus.apply(void 0, arguments);
            // `showAction` should handle `focus` if set
            if (showAction.includes('focus')) onToggleOpen(true);
        }
        focusRef.current = true;
    };
    var onContainerBlur = function onContainerBlur() {
        blurRef.current = true;
        setMockFocused(false, function() {
            focusRef.current = false;
            blurRef.current = false;
            onToggleOpen(false);
        });
        if (disabled) return;
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === 'tags') onSearch(mergedSearchValue, {
                source: 'submit'
            });
            else if (mode === 'multiple') // `multiple` mode only clean the search value but not trigger event
            onSearch('', {
                source: 'blur'
            });
        }
        if (onBlur) onBlur.apply(void 0, arguments);
    };
    // Give focus back of Select
    var activeTimeoutIds = [];
    $acw62.useEffect(function() {
        return function() {
            activeTimeoutIds.forEach(function(timeoutId) {
                return clearTimeout(timeoutId);
            });
            activeTimeoutIds.splice(0, activeTimeoutIds.length);
        };
    }, []);
    var onInternalMouseDown = function onInternalMouseDown(event) {
        var _triggerRef$current;
        var target = event.target;
        var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement && popupElement.contains(target)) {
            var timeoutId = setTimeout(function() {
                var index = activeTimeoutIds.indexOf(timeoutId);
                if (index !== -1) activeTimeoutIds.splice(index, 1);
                cancelSetMockFocused();
                if (!mobile && !popupElement.contains(document.activeElement)) {
                    var _selectorRef$current3;
                    (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
                }
            });
            activeTimeoutIds.push(timeoutId);
        }
        for(var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)restArgs[_key3 - 1] = arguments[_key3];
        onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [
            event
        ].concat(restArgs));
    };
    // ============================ Dropdown ============================
    var _React$useState5 = $acw62.useState({}), _React$useState6 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState5, 2), forceUpdate = _React$useState6[1];
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    // Used for raw custom input trigger
    var onTriggerVisibleChange;
    if (customizeRawInputElement) onTriggerVisibleChange = function onTriggerVisibleChange(newOpen) {
        onToggleOpen(newOpen);
    };
    // Close when click on non-select element
    (0, $78e2d4fdcbaa3edd$export$2e2bcd8739ae039)(function() {
        var _triggerRef$current2;
        return [
            containerRef.current,
            (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()
        ];
    }, triggerOpen, onToggleOpen, !!customizeRawInputElement);
    // ============================ Context =============================
    var baseSelectContext = $acw62.useMemo(function() {
        return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, props), {}, {
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: triggerOpen,
            id: id,
            showSearch: mergedShowSearch,
            multiple: multiple,
            toggleOpen: onToggleOpen
        });
    }, [
        props,
        notFoundContent,
        triggerOpen,
        mergedOpen,
        id,
        mergedShowSearch,
        multiple,
        onToggleOpen
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Arrow ==============================
    var showSuffixIcon = !!suffixIcon || loading;
    var arrowNode;
    if (showSuffixIcon) arrowNode = /*#__PURE__*/ $acw62.createElement((0, $e45dd5d9efe99894$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-arrow"), (0, $f8ce242576312548$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-arrow-loading"), loading)),
        customizeIcon: suffixIcon,
        customizeIconProps: {
            loading: loading,
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: mockFocused,
            showSearch: mergedShowSearch
        }
    });
    // ============================= Clear ==============================
    var onClearMouseDown = function onClearMouseDown() {
        var _selectorRef$current4;
        onClear === null || onClear === void 0 || onClear();
        (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
        onDisplayValuesChange([], {
            type: 'clear',
            values: displayValues
        });
        onInternalSearch('', false, false);
    };
    var _useAllowClear = (0, $83c983ea655ffaa8$export$9ea6397a890aa3e5)(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode), mergedAllowClear = _useAllowClear.allowClear, clearNode = _useAllowClear.clearIcon;
    // =========================== OptionList ===========================
    var optionList = /*#__PURE__*/ $acw62.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-focused"), mockFocused), "".concat(prefixCls, "-multiple"), multiple), "".concat(prefixCls, "-single"), !multiple), "".concat(prefixCls, "-allow-clear"), allowClear), "".concat(prefixCls, "-show-arrow"), showSuffixIcon), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-open"), mergedOpen), "".concat(prefixCls, "-customize-input"), customizeInputElement), "".concat(prefixCls, "-show-search"), mergedShowSearch));
    // >>> Selector
    var selectorNode = /*#__PURE__*/ $acw62.createElement((0, $0585b16d7d6fbb78$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: triggerOpen,
        popupElement: optionList,
        animation: animation,
        transitionName: transitionName,
        dropdownStyle: dropdownStyle,
        dropdownClassName: dropdownClassName,
        direction: direction,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        dropdownRender: dropdownRender,
        dropdownAlign: dropdownAlign,
        placement: placement,
        builtinPlacements: builtinPlacements,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        getTriggerDOMNode: function getTriggerDOMNode(node) {
            return(// TODO: This is workaround and should be removed in `rc-select`
            // And use new standard `nativeElement` for ref.
            // But we should update `rc-resize-observer` first.
            selectorDomRef.current || node);
        },
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter
    }, customizeRawInputElement ? /*#__PURE__*/ $acw62.cloneElement(customizeRawInputElement, {
        ref: customizeRawInputRef
    }) : /*#__PURE__*/ $acw62.createElement((0, $bc7f30d19ac8c9cf$export$2e2bcd8739ae039), (0, $ff00798002f59629$export$2e2bcd8739ae039)({}, props, {
        domRef: selectorDomRef,
        prefixCls: prefixCls,
        inputElement: customizeInputElement,
        ref: selectorRef,
        id: id,
        prefix: prefix,
        showSearch: mergedShowSearch,
        autoClearSearchValue: autoClearSearchValue,
        mode: mode,
        activeDescendantId: activeDescendantId,
        tagRender: tagRender,
        values: displayValues,
        open: mergedOpen,
        onToggleOpen: onToggleOpen,
        activeValue: activeValue,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter,
        onInputBlur: onInputBlur
    })));
    // >>> Render
    var renderNode;
    // Render raw
    if (customizeRawInputElement) renderNode = selectorNode;
    else renderNode = /*#__PURE__*/ $acw62.createElement("div", (0, $ff00798002f59629$export$2e2bcd8739ae039)({
        className: mergedClassName
    }, domProps, {
        ref: containerRef,
        onMouseDown: onInternalMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onFocus: onContainerFocus,
        onBlur: onContainerBlur
    }), /*#__PURE__*/ $acw62.createElement((0, $a4ed346aebb47f7d$export$2e2bcd8739ae039), {
        visible: mockFocused && !mergedOpen,
        values: displayValues
    }), selectorNode, arrowNode, mergedAllowClear && clearNode);
    return /*#__PURE__*/ $acw62.createElement((0, $138f44227a4e4422$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, renderNode);
});
var $bbedbc5316baa190$export$2e2bcd8739ae039 = $bbedbc5316baa190$var$BaseSelect;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $cce47deea66af7d9$var$OptGroup = function OptGroup() {
    return null;
};
$cce47deea66af7d9$var$OptGroup.isSelectOptGroup = true;
var $cce47deea66af7d9$export$2e2bcd8739ae039 = $cce47deea66af7d9$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $fc0fa2553f97ec55$var$Option = function Option() {
    return null;
};
$fc0fa2553f97ec55$var$Option.isSelectOption = true;
var $fc0fa2553f97ec55$export$2e2bcd8739ae039 = $fc0fa2553f97ec55$var$Option;










function $6850f34d840ba49e$export$2e2bcd8739ae039(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}














var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");




var $acw62 = parcelRequire("acw62");


/**
 * Fill component to provided the scroll content real height.
 */ var $a7c020883d75d0d6$var$Filler = /*#__PURE__*/ $acw62.forwardRef(function(_ref, ref) {
    var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
    var outerStyle = {};
    var innerStyle = {
        display: 'flex',
        flexDirection: 'column'
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: 'relative',
            overflow: 'hidden'
        };
        innerStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, innerStyle), {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({
            transform: "translateY(".concat(offsetY, "px)")
        }, rtl ? 'marginRight' : 'marginLeft', -offsetX), "position", 'absolute'), "left", 0), "right", 0), "top", 0));
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref2) {
            var offsetHeight = _ref2.offsetHeight;
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        style: innerStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
        ref: ref
    }, innerProps), children, extra)));
});
$a7c020883d75d0d6$var$Filler.displayName = 'Filler';
var $a7c020883d75d0d6$export$2e2bcd8739ae039 = $a7c020883d75d0d6$var$Filler;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $cb3ead46d99b2bdd$export$6d08773d2e66f8f2(_ref) {
    var children = _ref.children, setRef = _ref.setRef;
    var refFunc = $acw62.useCallback(function(node) {
        setRef(node);
    }, []);
    return /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: refFunc
    });
}


function $c2cc76a198e74e0d$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
    var getKey = _ref.getKey;
    return list.slice(startIndex, endIndex + 1).map(function(item, index) {
        var eleIndex = startIndex + index;
        var node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        var key = getKey(item);
        return /*#__PURE__*/ $acw62.createElement((0, $cb3ead46d99b2bdd$export$6d08773d2e66f8f2), {
            key: key,
            setRef: function setRef(ele) {
                return setNodeRef(item, ele);
            }
        }, node);
    });
}




var $acw62 = parcelRequire("acw62");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $07ea81b6f4a7cb44$export$38f9023d45dd4a23(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $07ea81b6f4a7cb44$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for(var i = 0; i < longList.length; i += 1){
        var shortKey = getItemKey(shortList[i]);
        var longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $792c44421728f1ca$export$2e2bcd8739ae039(data, getKey, onDiff) {
    var _React$useState = $acw62.useState(data), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
    var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
    $acw62.useEffect(function() {
        var diff = (0, $07ea81b6f4a7cb44$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
            onDiff === null || onDiff === void 0 || onDiff(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}




var $acw62 = parcelRequire("acw62");

var $63d773591ee5124d$var$isFF = (typeof navigator === "undefined" ? "undefined" : (0, $b8f57191916382d3$export$2e2bcd8739ae039)(navigator)) === 'object' && /Firefox/i.test(navigator.userAgent);
var $63d773591ee5124d$export$2e2bcd8739ae039 = $63d773591ee5124d$var$isFF;



var $acw62 = parcelRequire("acw62");
var $3f9e2a044ed7754f$export$2e2bcd8739ae039 = function(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
    // Do lock for a wheel when scrolling
    var lockRef = (0, $acw62.useRef)(false);
    var lockTimeoutRef = (0, $acw62.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(function() {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    var scrollPingRef = (0, $acw62.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return function(isHorizontal, delta) {
        var smoothOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $bc091312f55e72d3$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    var offsetRef = (0, $acw62.useRef)(0);
    var nextFrameRef = (0, $acw62.useRef)(null);
    // Firefox patch
    var wheelValueRef = (0, $acw62.useRef)(null);
    var isMouseScrollRef = (0, $acw62.useRef)(false);
    // Scroll status sync
    var originScroll = (0, $3f9e2a044ed7754f$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(event, deltaY) {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Proxy of scroll events
        if (!(0, $63d773591ee5124d$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            var patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $63d773591ee5124d$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    var wheelDirectionRef = (0, $acw62.useRef)(null);
    var wheelDirectionCleanRef = (0, $acw62.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            wheelDirectionRef.current = null;
        }, 2);
        var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
        var mergedDeltaX = deltaX;
        var mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === 'sx' || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = 'sx';
        }
        var absX = Math.abs(mergedDeltaX);
        var absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? 'x' : 'y';
        if (wheelDirectionRef.current === 'y') onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}




var $acw62 = parcelRequire("acw62");
function $352c687fd82e878a$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    var _React$useMemo = $acw62.useMemo(function() {
        return [
            new Map(),
            []
        ];
    }, [
        mergedData,
        heights.id,
        itemHeight
    ]), _React$useMemo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
    var getSize = function getSize(startKey) {
        var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
        // Get from cache first
        var startIndex = key2Index.get(startKey);
        var endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            var dataLen = mergedData.length;
            for(var i = bottomList.length; i < dataLen; i += 1){
                var _heights$get;
                var item = mergedData[i];
                var key = getKey(item);
                key2Index.set(key, i);
                var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}




var $acw62 = parcelRequire("acw62");





// Firefox has low performance of map.
var $443f2a75671c17cb$var$CacheMap = /*#__PURE__*/ function() {
    function CacheMap() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, CacheMap);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "maps", void 0);
        // Used for cache key
        // `useMemo` no need to update if `id` not change
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "id", 0);
        this.maps = Object.create(null);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(CacheMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.maps[key] = value;
                this.id += 1;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.maps[key];
            }
        }
    ]);
    return CacheMap;
}();
var $443f2a75671c17cb$export$2e2bcd8739ae039 = $443f2a75671c17cb$var$CacheMap;


function $291e20ad7019c1c9$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    var _React$useState = $acw62.useState(0), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
    var instanceRef = (0, $acw62.useRef)(new Map());
    var heightsRef = (0, $acw62.useRef)(new (0, $443f2a75671c17cb$export$2e2bcd8739ae039)());
    var collectRafRef = (0, $acw62.useRef)();
    function cancelRaf() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(collectRafRef.current);
    }
    function collectHeight() {
        var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        cancelRaf();
        var doCollect = function doCollect() {
            instanceRef.current.forEach(function(element, key) {
                if (element && element.offsetParent) {
                    var htmlElement = (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(element);
                    var offsetHeight = htmlElement.offsetHeight;
                    if (heightsRef.current.get(key) !== offsetHeight) heightsRef.current.set(key, htmlElement.offsetHeight);
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            setUpdatedMark(function(c) {
                return c + 1;
            });
        };
        if (sync) doCollect();
        else collectRafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(doCollect);
    }
    function setInstanceRef(item, instance) {
        var key = getKey(item);
        var origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
            else onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
        }
    }
    (0, $acw62.useEffect)(function() {
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}




var $acw62 = parcelRequire("acw62");
var $565f15d1b93ca0eb$var$SMOOTH_PTG = 14 / 15;
function $565f15d1b93ca0eb$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    var touchedRef = (0, $acw62.useRef)(false);
    var touchXRef = (0, $acw62.useRef)(0);
    var touchYRef = (0, $acw62.useRef)(0);
    var elementRef = (0, $acw62.useRef)(null);
    // Smooth scroll
    var intervalRef = (0, $acw62.useRef)(null);
    /* eslint-disable prefer-const */ var cleanUpEvents;
    var onTouchMove = function onTouchMove(e) {
        if (touchedRef.current) {
            var currentX = Math.ceil(e.touches[0].pageX);
            var currentY = Math.ceil(e.touches[0].pageY);
            var offsetX = touchXRef.current - currentX;
            var offsetY = touchYRef.current - currentY;
            var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (_isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            if (callback(_isHorizontal, _isHorizontal ? offsetX : offsetY)) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(function() {
                if (_isHorizontal) offsetX *= $565f15d1b93ca0eb$var$SMOOTH_PTG;
                else offsetY *= $565f15d1b93ca0eb$var$SMOOTH_PTG;
                var offset = Math.floor(_isHorizontal ? offsetX : offsetY);
                if (!callback(_isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    var onTouchEnd = function onTouchEnd() {
        touchedRef.current = false;
        cleanUpEvents();
    };
    var onTouchStart = function onTouchStart(e) {
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener('touchmove', onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener('touchend', onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = function cleanUpEvents() {
        if (elementRef.current) {
            elementRef.current.removeEventListener('touchmove', onTouchMove);
            elementRef.current.removeEventListener('touchend', onTouchEnd);
        }
    };
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (inVirtual) listRef.current.addEventListener('touchstart', onTouchStart, {
            passive: true
        });
        return function() {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener('touchstart', onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}







var $acw62 = parcelRequire("acw62");



var $e77930eb0c8ae9f1$var$MAX_TIMES = 10;
function $e77930eb0c8ae9f1$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    var scrollRef = $acw62.useRef();
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
    // ========================== Sync Scroll ==========================
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (syncState && syncState.times < $e77930eb0c8ae9f1$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState(function(ori) {
                    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, ori);
                });
                return;
            }
            collectHeight();
            var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index = syncState.index, offset = syncState.offset;
            var height = containerRef.current.clientHeight;
            var needCollectHeight = false;
            var newTargetAlign = targetAlign;
            var targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                var mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                var maxLen = Math.min(data.length - 1, index);
                for(var i = 0; i <= maxLen; i += 1){
                    var key = getKey(data[i]);
                    itemTop = stackTop;
                    var cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                var leftHeight = mergedAlign === 'top' ? offset : height - offset;
                for(var _i = maxLen; _i >= 0; _i -= 1){
                    var _key = getKey(data[_i]);
                    var _cacheHeight = heights.get(_key);
                    if (_cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= _cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case 'top':
                        targetTop = itemTop - offset;
                        break;
                    case 'bottom':
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        var scrollTop = containerRef.current.scrollTop;
                        var scrollBottom = scrollTop + height;
                        if (itemTop < scrollTop) newTargetAlign = 'top';
                        else if (itemBottom > scrollBottom) newTargetAlign = 'bottom';
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, syncState), {}, {
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return function(arg) {
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(scrollRef.current);
        if (typeof arg === 'number') syncScrollTop(arg);
        else if (arg && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(arg) === 'object') {
            var index;
            var align = arg.align;
            if ('index' in arg) index = arg.index;
            else index = data.findIndex(function(item) {
                return getKey(item) === arg.key;
            });
            var _arg$offset = arg.offset, offset = _arg$offset === void 0 ? 0 : _arg$offset;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}








var $acw62 = parcelRequire("acw62");
function $2ebd4898b033397e$var$getPageXY(e, horizontal) {
    var obj = 'touches' in e ? e.touches[0] : e;
    return obj[horizontal ? 'pageX' : 'pageY'];
}
var $2ebd4898b033397e$var$ScrollBar = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style = props.style, propsThumbStyle = props.thumbStyle;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
    var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
    var _React$useState5 = $acw62.useState(null), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
    var isLTR = !rtl;
    // ========================= Refs =========================
    var scrollbarRef = $acw62.useRef();
    var thumbRef = $acw62.useRef();
    // ======================= Visible ========================
    var _React$useState7 = $acw62.useState(false), _React$useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
    var visibleTimeoutRef = $acw62.useRef();
    var delayHidden = function delayHidden() {
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(function() {
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    var enableScrollRange = scrollRange - containerSize || 0;
    var enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    var top = $acw62.useMemo(function() {
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        var ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    var onContainerMouseDown = function onContainerMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    var stateRef = $acw62.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    var onThumbMouseDown = function onThumbMouseDown(e) {
        setDragging(true);
        setPageXY($2ebd4898b033397e$var$getPageXY(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $acw62.useEffect(function() {
        var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
            e.preventDefault();
        };
        var scrollbarEle = scrollbarRef.current;
        var thumbEle = thumbRef.current;
        scrollbarEle.addEventListener('touchstart', onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener('touchstart', onThumbMouseDown, {
            passive: false
        });
        return function() {
            scrollbarEle.removeEventListener('touchstart', onScrollbarTouchStart);
            thumbEle.removeEventListener('touchstart', onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    var enableScrollRangeRef = $acw62.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    var enableOffsetRangeRef = $acw62.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $acw62.useEffect(function() {
        if (dragging) {
            var moveRafId;
            var onMouseMove = function onMouseMove(e) {
                var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
                (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(moveRafId);
                var rect = scrollbarRef.current.getBoundingClientRect();
                var scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    var offset = ($2ebd4898b033397e$var$getPageXY(e, horizontal) - statePageY) * scale;
                    var newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    var tmpEnableScrollRange = enableScrollRangeRef.current;
                    var tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            var onMouseUp = function onMouseUp() {
                setDragging(false);
                onStopMove();
            };
            window.addEventListener('mousemove', onMouseMove, {
                passive: true
            });
            window.addEventListener('touchmove', onMouseMove, {
                passive: true
            });
            window.addEventListener('mouseup', onMouseUp, {
                passive: true
            });
            window.addEventListener('touchend', onMouseUp, {
                passive: true
            });
            return function() {
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('touchmove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
                window.removeEventListener('touchend', onMouseUp);
                (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $acw62.useEffect(function() {
        delayHidden();
        return function() {
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $acw62.useImperativeHandle(ref, function() {
        return {
            delayHidden: delayHidden
        };
    });
    // ======================== Render ========================
    var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
    var containerStyle = {
        position: 'absolute',
        visibility: visible ? null : 'hidden'
    };
    var thumbStyle = {
        position: 'absolute',
        background: 'rgba(0, 0, 0, 0.5)',
        borderRadius: 99,
        cursor: 'pointer',
        userSelect: 'none'
    };
    if (horizontal) {
        // Container
        containerStyle.height = 8;
        containerStyle.left = 0;
        containerStyle.right = 0;
        containerStyle.bottom = 0;
        // Thumb
        thumbStyle.height = '100%';
        thumbStyle.width = spinSize;
        if (isLTR) thumbStyle.left = top;
        else thumbStyle.right = top;
    } else {
        // Container
        containerStyle.width = 8;
        containerStyle.top = 0;
        containerStyle.bottom = 0;
        if (isLTR) containerStyle.right = 0;
        else containerStyle.left = 0;
        // Thumb
        thumbStyle.width = '100%';
        thumbStyle.height = spinSize;
        thumbStyle.top = top;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: scrollbarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(scrollbarPrefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, containerStyle), style),
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: thumbRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(scrollbarPrefixCls, "-thumb"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, thumbStyle), propsThumbStyle),
        onMouseDown: onThumbMouseDown
    }));
});
var $2ebd4898b033397e$export$2e2bcd8739ae039 = $2ebd4898b033397e$var$ScrollBar;


var $b4a482bc5e551190$var$MIN_SIZE = 20;
function $b4a482bc5e551190$export$f2ca68955ab35ace() {
    var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $b4a482bc5e551190$var$MIN_SIZE);
    return Math.floor(baseSize);
}


var $919681ceac17068c$var$_excluded = [
    "prefixCls",
    "className",
    "height",
    "itemHeight",
    "fullHeight",
    "style",
    "data",
    "children",
    "itemKey",
    "virtual",
    "direction",
    "scrollWidth",
    "component",
    "onScroll",
    "onVirtualScroll",
    "onVisibleChange",
    "innerProps",
    "extraRender",
    "styles"
];
var $919681ceac17068c$var$EMPTY_DATA = [];
var $919681ceac17068c$var$ScrollStyle = {
    overflowY: 'auto',
    overflowAnchor: 'none'
};
function $919681ceac17068c$export$cc3be4e46e8486ed(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-virtual-list' : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style = props.style, data = props.data, children = props.children, itemKey = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $919681ceac17068c$var$_excluded);
    // =============================== Item Key ===============================
    var getKey = $acw62.useCallback(function(item) {
        if (typeof itemKey === 'function') return itemKey(item);
        return item === null || item === void 0 ? void 0 : item[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    var _useHeights = (0, $291e20ad7019c1c9$export$2e2bcd8739ae039)(getKey, null, null), _useHeights2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
    // ================================= MISC =================================
    var useVirtual = !!(virtual !== false && height && itemHeight);
    var containerHeight = $acw62.useMemo(function() {
        return Object.values(heights.maps).reduce(function(total, curr) {
            return total + curr;
        }, 0);
    }, [
        heights.id,
        heights.maps
    ]);
    var inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    var isRTL = direction === 'rtl';
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
    var mergedData = data || $919681ceac17068c$var$EMPTY_DATA;
    var componentRef = (0, $acw62.useRef)();
    var fillerInnerRef = (0, $acw62.useRef)();
    var containerRef = (0, $acw62.useRef)();
    // =============================== Item Key ===============================
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
    var _useState3 = (0, $acw62.useState)(0), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
    var onScrollbarStartMove = function onScrollbarStartMove() {
        setScrollMoving(true);
    };
    var onScrollbarStopMove = function onScrollbarStopMove() {
        setScrollMoving(false);
    };
    var sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop(function(origin) {
            var value;
            if (typeof newTop === 'function') value = newTop(origin);
            else value = newTop;
            var alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    var rangeRef = (0, $acw62.useRef)({
        start: 0,
        end: mergedData.length
    });
    var diffItemRef = (0, $acw62.useRef)();
    var _useDiffItem = (0, $792c44421728f1ca$export$2e2bcd8739ae039)(mergedData, getKey), _useDiffItem2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDiffItem, 1), diffItem = _useDiffItem2[0];
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    var _React$useMemo = $acw62.useMemo(function() {
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) {
            var _fillerInnerRef$curre;
            return {
                scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
                start: 0,
                end: mergedData.length - 1,
                offset: undefined
            };
        }
        var itemTop = 0;
        var startIndex;
        var startOffset;
        var endIndex;
        var dataLen = mergedData.length;
        for(var i = 0; i < dataLen; i += 1){
            var _item = mergedData[i];
            var key = getKey(_item);
            var cacheHeight = heights.get(key);
            var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // ================================= Size =================================
    var _React$useState = $acw62.useState({
        width: 0,
        height: height
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
    var onHolderResize = function onHolderResize(sizeInfo) {
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    var verticalScrollBarRef = (0, $acw62.useRef)();
    var horizontalScrollBarRef = (0, $acw62.useRef)();
    var horizontalScrollBarSpinSize = $acw62.useMemo(function() {
        return (0, $b4a482bc5e551190$export$f2ca68955ab35ace)(size.width, scrollWidth);
    }, [
        size.width,
        scrollWidth
    ]);
    var verticalScrollBarSpinSize = $acw62.useMemo(function() {
        return (0, $b4a482bc5e551190$export$f2ca68955ab35ace)(size.height, scrollHeight);
    }, [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    var maxScrollHeight = scrollHeight - height;
    var maxScrollHeightRef = (0, $acw62.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        var newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    var isScrollAtTop = offsetTop <= 0;
    var isScrollAtBottom = offsetTop >= maxScrollHeight;
    var isScrollAtLeft = offsetLeft <= 0;
    var isScrollAtRight = offsetLeft >= scrollWidth;
    var originScroll = (0, $3f9e2a044ed7754f$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    var getVirtualScrollInfo = function getVirtualScrollInfo() {
        return {
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        };
    };
    var lastVirtualScrollInfoRef = (0, $acw62.useRef)(getVirtualScrollInfo());
    var triggerScroll = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(params) {
        if (onVirtualScroll) {
            var nextInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, getVirtualScrollInfo()), params);
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        var newOffset = newScrollOffset;
        if (horizontal) {
            (0, $1u0KT.flushSync)(function() {
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        var newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll === null || onScroll === void 0 || onScroll(e);
        triggerScroll();
    }
    var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
        var tmpOffsetLeft = nextOffsetLeft;
        var max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    var onWheelDelta = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(offsetXY, fromHorizontal) {
        if (fromHorizontal) {
            // Horizontal scroll no need sync virtual position
            (0, $1u0KT.flushSync)(function() {
                setOffsetLeft(function(left) {
                    var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop(function(top) {
            var newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    var _useFrameWheel = (0, $bc091312f55e72d3$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta), _useFrameWheel2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    // Mobile touch move
    (0, $565f15d1b93ca0eb$export$2e2bcd8739ae039)(useVirtual, componentRef, function(isHorizontal, delta, smoothOffset) {
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        onRawWheel({
            preventDefault: function preventDefault() {},
            deltaX: isHorizontal ? delta : 0,
            deltaY: isHorizontal ? 0 : delta
        });
        return true;
    });
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        // Firefox only
        function onMozMousePixelScroll(e) {
            if (useVirtual) e.preventDefault();
        }
        var componentEle = componentRef.current;
        componentEle.addEventListener('wheel', onRawWheel, {
            passive: false
        });
        componentEle.addEventListener('DOMMouseScroll', onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener('MozMousePixelScroll', onMozMousePixelScroll, {
            passive: false
        });
        return function() {
            componentEle.removeEventListener('wheel', onRawWheel);
            componentEle.removeEventListener('DOMMouseScroll', onFireFoxScroll);
            componentEle.removeEventListener('MozMousePixelScroll', onMozMousePixelScroll);
        };
    }, [
        useVirtual
    ]);
    // Sync scroll left
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (scrollWidth) {
            var newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    var delayHideScrollBar = function delayHideScrollBar() {
        var _verticalScrollBarRef, _horizontalScrollBarR;
        (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
        (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
    };
    var _scrollTo = (0, $e77930eb0c8ae9f1$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, function() {
        return collectHeight(true);
    }, syncScrollTop, delayHideScrollBar);
    $acw62.useImperativeHandle(ref, function() {
        return {
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: function scrollTo(config) {
                function isPosScroll(arg) {
                    return arg && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(arg) === 'object' && ('left' in arg || 'top' in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    _scrollTo(config.top);
                } else _scrollTo(config);
            }
        };
    });
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (onVisibleChange) {
            var renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    var getSize = (0, $352c687fd82e878a$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    var listChildren = (0, $c2cc76a198e74e0d$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    var componentStyle = null;
    if (height) {
        componentStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, fullHeight ? 'height' : 'maxHeight', height), $919681ceac17068c$var$ScrollStyle);
        if (useVirtual) {
            componentStyle.overflowY = 'hidden';
            if (scrollWidth) componentStyle.overflowX = 'hidden';
            if (scrollMoving) componentStyle.pointerEvents = 'none';
        }
    }
    var containerProps = {};
    if (isRTL) containerProps.dir = 'rtl';
    return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: containerRef,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), {}, {
            position: 'relative'
        }),
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $acw62.createElement(Component, {
        className: "".concat(prefixCls, "-holder"),
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $acw62.createElement((0, $a7c020883d75d0d6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $acw62.createElement((0, $2ebd4898b033397e$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $acw62.createElement((0, $2ebd4898b033397e$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb
    }));
}
var $919681ceac17068c$var$List = /*#__PURE__*/ $acw62.forwardRef($919681ceac17068c$export$cc3be4e46e8486ed);
$919681ceac17068c$var$List.displayName = 'List';
var $919681ceac17068c$export$2e2bcd8739ae039 = $919681ceac17068c$var$List;


var $2f16cd4e45d13ddf$export$2e2bcd8739ae039 = (0, $919681ceac17068c$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");



/* istanbul ignore file */ function $402ebc445f905a6a$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}



var $e9fe715ea6a5df25$var$_excluded = [
    "disabled",
    "title",
    "children",
    "style",
    "className"
];
// export interface OptionListProps<OptionsType extends object[]> {
function $e9fe715ea6a5df25$var$isTitleType(content) {
    return typeof content === 'string' || typeof content === 'number';
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ var $e9fe715ea6a5df25$var$OptionList = function OptionList(_, ref) {
    var _useBaseProps = (0, $138f44227a4e4422$export$2e2bcd8739ae039)(), prefixCls = _useBaseProps.prefixCls, id = _useBaseProps.id, open = _useBaseProps.open, multiple = _useBaseProps.multiple, mode = _useBaseProps.mode, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, notFoundContent = _useBaseProps.notFoundContent, onPopupScroll = _useBaseProps.onPopupScroll;
    var _React$useContext = $acw62.useContext((0, $46e904f7b592b3f3$export$2e2bcd8739ae039)), maxCount = _React$useContext.maxCount, flattenOptions = _React$useContext.flattenOptions, onActiveValue = _React$useContext.onActiveValue, defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption, onSelect = _React$useContext.onSelect, menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon, rawValues = _React$useContext.rawValues, fieldNames = _React$useContext.fieldNames, virtual = _React$useContext.virtual, direction = _React$useContext.direction, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight, optionRender = _React$useContext.optionRender;
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var memoFlattenOptions = (0, $09205742e4b1762b$export$2e2bcd8739ae039)(function() {
        return flattenOptions;
    }, [
        open,
        flattenOptions
    ], function(prev, next) {
        return next[0] && prev[1] !== next[1];
    });
    // =========================== List ===========================
    var listRef = $acw62.useRef(null);
    var overMaxCount = $acw62.useMemo(function() {
        return multiple && (0, $8dfd2b5394871903$export$be48fd776273e509)(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount;
    }, [
        multiple,
        maxCount,
        rawValues === null || rawValues === void 0 ? void 0 : rawValues.size
    ]);
    var onListMouseDown = function onListMouseDown(event) {
        event.preventDefault();
    };
    var scrollIntoView = function scrollIntoView(args) {
        var _listRef$current;
        (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(typeof args === 'number' ? {
            index: args
        } : args);
    };
    // https://github.com/ant-design/ant-design/issues/34975
    var isSelected = $acw62.useCallback(function(value) {
        if (mode === 'combobox') return false;
        return rawValues.has(value);
    }, [
        mode,
        (0, $a58b549eebfe4222$export$2e2bcd8739ae039)(rawValues).toString(),
        rawValues.size
    ]);
    // ========================== Active ==========================
    var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var len = memoFlattenOptions.length;
        for(var i = 0; i < len; i += 1){
            var current = (index + i * offset + len) % len;
            var _ref = memoFlattenOptions[current] || {}, group = _ref.group, data = _ref.data;
            if (!group && !(data !== null && data !== void 0 && data.disabled) && (isSelected(data.value) || !overMaxCount)) return current;
        }
        return -1;
    };
    var _React$useState = $acw62.useState(function() {
        return getEnabledActiveIndex(0);
    }), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var setActive = function setActive(index) {
        var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setActiveIndex(index);
        var info = {
            source: fromKeyboard ? 'keyboard' : 'mouse'
        };
        // Trigger active event
        var flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $acw62.useEffect)(function() {
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/48036
    var isAriaSelected = $acw62.useCallback(function(value) {
        if (mode === 'combobox') return String(value).toLowerCase() === searchValue.toLowerCase();
        return rawValues.has(value);
    }, [
        mode,
        searchValue,
        (0, $a58b549eebfe4222$export$2e2bcd8739ae039)(rawValues).toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $acw62.useEffect)(function() {
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ var timeoutId = setTimeout(function() {
            if (!multiple && open && rawValues.size === 1) {
                var value = Array.from(rawValues)[0];
                // Scroll to the option closest to the searchValue if searching.
                var index = memoFlattenOptions.findIndex(function(_ref2) {
                    var data = _ref2.data;
                    return searchValue ? String(data.value).startsWith(searchValue) : data.value === value;
                });
                if (index !== -1) {
                    setActive(index);
                    scrollIntoView(index);
                }
            }
        });
        // Force trigger scrollbar visible when open
        if (open) {
            var _listRef$current2;
            (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollTo(undefined);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    var onSelectValue = function onSelectValue(value) {
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $acw62.useImperativeHandle(ref, function() {
        return {
            onKeyDown: function onKeyDown(event) {
                var which = event.which, ctrlKey = event.ctrlKey;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $9163ee474d3ac931$export$2e2bcd8739ae039).N:
                    case (0, $9163ee474d3ac931$export$2e2bcd8739ae039).P:
                    case (0, $9163ee474d3ac931$export$2e2bcd8739ae039).UP:
                    case (0, $9163ee474d3ac931$export$2e2bcd8739ae039).DOWN:
                        var offset = 0;
                        if (which === (0, $9163ee474d3ac931$export$2e2bcd8739ae039).UP) offset = -1;
                        else if (which === (0, $9163ee474d3ac931$export$2e2bcd8739ae039).DOWN) offset = 1;
                        else if ((0, $402ebc445f905a6a$export$3bbcfec016973a77)() && ctrlKey) {
                            if (which === (0, $9163ee474d3ac931$export$2e2bcd8739ae039).N) offset = 1;
                            else if (which === (0, $9163ee474d3ac931$export$2e2bcd8739ae039).P) offset = -1;
                        }
                        if (offset !== 0) {
                            var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                            scrollIntoView(nextActiveIndex);
                            setActive(nextActiveIndex, true);
                        }
                        break;
                    // >>> Select (Tab / Enter)
                    case (0, $9163ee474d3ac931$export$2e2bcd8739ae039).TAB:
                    case (0, $9163ee474d3ac931$export$2e2bcd8739ae039).ENTER:
                        var _item$data;
                        // value
                        var item = memoFlattenOptions[activeIndex];
                        if (item && !(item !== null && item !== void 0 && (_item$data = item.data) !== null && _item$data !== void 0 && _item$data.disabled) && !overMaxCount) onSelectValue(item.value);
                        else onSelectValue(undefined);
                        if (open) event.preventDefault();
                        break;
                    // >>> Close
                    case (0, $9163ee474d3ac931$export$2e2bcd8739ae039).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: function onKeyUp() {},
            scrollTo: function scrollTo(index) {
                scrollIntoView(index);
            }
        };
    });
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $acw62.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        className: "".concat(itemPrefixCls, "-empty"),
        onMouseDown: onListMouseDown
    }, notFoundContent);
    var omitFieldNameList = Object.keys(fieldNames).map(function(key) {
        return fieldNames[key];
    });
    var getLabel = function getLabel(item) {
        return item.label;
    };
    function getItemAriaProps(item, index) {
        var group = item.group;
        return {
            role: group ? 'presentation' : 'option',
            id: "".concat(id, "_list_").concat(index)
        };
    }
    var renderItem = function renderItem(index) {
        var item = memoFlattenOptions[index];
        if (!item) return null;
        var itemData = item.data || {};
        var value = itemData.value;
        var group = item.group;
        var attrs = (0, $717b45987b2b899b$export$2e2bcd8739ae039)(itemData, true);
        var mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $acw62.createElement("div", (0, $ff00798002f59629$export$2e2bcd8739ae039)({
            "aria-label": typeof mergedLabel === 'string' && !group ? mergedLabel : null
        }, attrs, {
            key: index
        }, getItemAriaProps(item, index), {
            "aria-selected": isAriaSelected(value)
        }), value) : null;
    };
    var a11yProps = {
        role: 'listbox',
        id: "".concat(id, "_list")
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, virtual && /*#__PURE__*/ $acw62.createElement("div", (0, $ff00798002f59629$export$2e2bcd8739ae039)({}, a11yProps, {
        style: {
            height: 0,
            width: 0,
            overflow: 'hidden'
        }
    }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $acw62.createElement((0, $2f16cd4e45d13ddf$export$2e2bcd8739ae039), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual,
        direction: direction,
        innerProps: virtual ? null : a11yProps
    }, function(item, itemIndex) {
        var group = item.group, groupOption = item.groupOption, data = item.data, label = item.label, value = item.value;
        var key = data.key;
        // Group
        if (group) {
            var _data$title;
            var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : $e9fe715ea6a5df25$var$isTitleType(label) ? label.toString() : undefined;
            return /*#__PURE__*/ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(itemPrefixCls, "".concat(itemPrefixCls, "-group"), data.className),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        var disabled = data.disabled, title = data.title, children = data.children, style = data.style, className = data.className, otherProps = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(data, $e9fe715ea6a5df25$var$_excluded);
        var passedProps = (0, $6850f34d840ba49e$export$2e2bcd8739ae039)(otherProps, omitFieldNameList);
        // Option
        var selected = isSelected(value);
        var mergedDisabled = disabled || !selected && overMaxCount;
        var optionPrefixCls = "".concat(itemPrefixCls, "-option");
        var optionClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(itemPrefixCls, optionPrefixCls, className, (0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)({}, "".concat(optionPrefixCls, "-grouped"), groupOption), "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !mergedDisabled), "".concat(optionPrefixCls, "-disabled"), mergedDisabled), "".concat(optionPrefixCls, "-selected"), selected));
        var mergedLabel = getLabel(item);
        var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === 'function' || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        var content = typeof mergedLabel === 'number' ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        var optionTitle = $e9fe715ea6a5df25$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $ff00798002f59629$export$2e2bcd8739ae039)({}, (0, $717b45987b2b899b$export$2e2bcd8739ae039)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
            "aria-selected": isAriaSelected(value),
            className: optionClassName,
            title: optionTitle,
            onMouseMove: function onMouseMove() {
                if (activeIndex === itemIndex || mergedDisabled) return;
                setActive(itemIndex);
            },
            onClick: function onClick() {
                if (!mergedDisabled) onSelectValue(value);
            },
            style: style
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(optionPrefixCls, "-content")
        }, typeof optionRender === 'function' ? optionRender(item, {
            index: itemIndex
        }) : content), /*#__PURE__*/ $acw62.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $acw62.createElement((0, $e45dd5d9efe99894$export$2e2bcd8739ae039), {
            className: "".concat(itemPrefixCls, "-option-state"),
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                value: value,
                disabled: mergedDisabled,
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
var $e9fe715ea6a5df25$var$RefOptionList = /*#__PURE__*/ $acw62.forwardRef($e9fe715ea6a5df25$var$OptionList);
var $e9fe715ea6a5df25$export$2e2bcd8739ae039 = $e9fe715ea6a5df25$var$RefOptionList;





var $acw62 = parcelRequire("acw62");
var /**
 * Cache `value` related LabeledValue & options.
 */ $cb659b69be5664ca$export$2e2bcd8739ae039 = function(labeledValues, valueOptions) {
    var cacheRef = $acw62.useRef({
        values: new Map(),
        options: new Map()
    });
    var filledLabeledValues = $acw62.useMemo(function() {
        var _cacheRef$current = cacheRef.current, prevValueCache = _cacheRef$current.values, prevOptionCache = _cacheRef$current.options;
        // Fill label by cache
        var patchedValues = labeledValues.map(function(item) {
            if (item.label === undefined) {
                var _prevValueCache$get;
                return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, item), {}, {
                    label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
                });
            }
            return item;
        });
        // Refresh cache
        var valueCache = new Map();
        var optionCache = new Map();
        patchedValues.forEach(function(item) {
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    var getOption = $acw62.useCallback(function(val) {
        return valueOptions.get(val) || cacheRef.current.options.get(val);
    }, [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};





var $acw62 = parcelRequire("acw62");


function $66a8a41eb0906412$var$includes(test, search) {
    return (0, $b2f2f91bade499fd$export$45b10814cc054894)(test).join('').toUpperCase().includes(search);
}
var $66a8a41eb0906412$export$2e2bcd8739ae039 = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
    return $acw62.useMemo(function() {
        if (!searchValue || filterOption === false) return options;
        var fieldOptions = fieldNames.options, fieldLabel = fieldNames.label, fieldValue = fieldNames.value;
        var filteredOptions = [];
        var customizeFilter = typeof filterOption === 'function';
        var upperSearch = searchValue.toUpperCase();
        var filterFunc = customizeFilter ? filterOption : function(_, option) {
            // Use provided `optionFilterProp`
            if (optionFilterProp) return $66a8a41eb0906412$var$includes(option[optionFilterProp], upperSearch);
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $66a8a41eb0906412$var$includes(option[fieldLabel !== 'children' ? fieldLabel : 'label'], upperSearch);
            return $66a8a41eb0906412$var$includes(option[fieldValue], upperSearch);
        };
        var wrapOption = customizeFilter ? function(opt) {
            return (0, $8dfd2b5394871903$export$d0b21b213c8c013c)(opt);
        } : function(opt) {
            return opt;
        };
        options.forEach(function(item) {
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                var matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    var subOptions = item[fieldOptions].filter(function(subItem) {
                        return filterFunc(searchValue, wrapOption(subItem));
                    });
                    if (subOptions.length) filteredOptions.push((0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, item), {}, (0, $f8ce242576312548$export$2e2bcd8739ae039)({}, fieldOptions, subOptions)));
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};




var $acw62 = parcelRequire("acw62");

var $cb8476e7ddef3fed$var$uuid = 0;
var $cb8476e7ddef3fed$export$df7146797a248522 = (0, $2c3d183b3bf70c7f$export$2e2bcd8739ae039)();
function $cb8476e7ddef3fed$export$36ec425867d538d7() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($cb8476e7ddef3fed$export$df7146797a248522) {
        retId = $cb8476e7ddef3fed$var$uuid;
        $cb8476e7ddef3fed$var$uuid += 1;
    } else retId = 'TEST_OR_SSR';
    return retId;
}
function $cb8476e7ddef3fed$export$2e2bcd8739ae039(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        setInnerId("rc_select_".concat($cb8476e7ddef3fed$export$36ec425867d538d7()));
    }, []);
    return id || innerId;
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $33332ff8b4df7580$var$_excluded = [
    "children",
    "value"
], $33332ff8b4df7580$var$_excluded2 = [
    "children"
];
function $33332ff8b4df7580$var$convertNodeToOption(node) {
    var _ref = node, key = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(_ref$props, $33332ff8b4df7580$var$_excluded);
    return (0, $f158faa5f7209115$export$2e2bcd8739ae039)({
        key: key,
        value: value !== undefined ? value : key,
        children: children
    }, restProps);
}
function $33332ff8b4df7580$export$3beca35db74c3985(nodes) {
    var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, $f70deae0a90ffbdd$export$2e2bcd8739ae039)(nodes).map(function(node, index) {
        if (!/*#__PURE__*/ $acw62.isValidElement(node) || !node.type) return null;
        var _ref2 = node, isSelectOptGroup = _ref2.type.isSelectOptGroup, key = _ref2.key, _ref2$props = _ref2.props, children = _ref2$props.children, restProps = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(_ref2$props, $33332ff8b4df7580$var$_excluded2);
        if (optionOnly || !isSelectOptGroup) return $33332ff8b4df7580$var$convertNodeToOption(node);
        return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({
            key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
            label: key
        }, restProps), {}, {
            options: $33332ff8b4df7580$export$3beca35db74c3985(children)
        });
    }).filter(function(data) {
        return data;
    });
}


/**
 * Parse `children` to `options` if `options` is not provided.
 * Then flatten the `options`.
 */ var $197036a1a9b77c2d$var$useOptions = function useOptions(options, children, fieldNames, optionFilterProp, optionLabelProp) {
    return $acw62.useMemo(function() {
        var mergedOptions = options;
        var childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $33332ff8b4df7580$export$3beca35db74c3985)(children);
        var valueOptions = new Map();
        var labelOptions = new Map();
        var setLabelOptions = function setLabelOptions(labelOptionsMap, option, key) {
            if (key && typeof key === 'string') labelOptionsMap.set(option[key], option);
        };
        var dig = function dig(optionList) {
            var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            // for loop to speed up collection speed
            for(var i = 0; i < optionList.length; i += 1){
                var option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    setLabelOptions(labelOptions, option, optionFilterProp);
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        };
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
};
var $197036a1a9b77c2d$export$2e2bcd8739ae039 = $197036a1a9b77c2d$var$useOptions;



var $acw62 = parcelRequire("acw62");
function $b335321667729c98$export$2e2bcd8739ae039(callback) {
    var funcRef = $acw62.useRef();
    funcRef.current = callback;
    var cacheFn = $acw62.useCallback(function() {
        return funcRef.current.apply(funcRef, arguments);
    }, []);
    return cacheFn;
}








var $acw62 = parcelRequire("acw62");



function $53d164ac9af43314$var$warningProps(props) {
    var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
    var multiple = (0, $bbedbc5316baa190$export$7f654ad2a77ad2ac)(mode);
    var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === 'combobox';
    var mergedOptions = options || (0, $33332ff8b4df7580$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $a62d89528dce911b$export$2e2bcd8739ae039)(mode !== 'tags' || mergedOptions.every(function(opt) {
        return !opt.disabled;
    }), 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
    // `combobox` & `tags` should option be `string` type
    if (mode === 'tags' || mode === 'combobox') {
        var hasNumberValue = mergedOptions.some(function(item) {
            if (item.options) return item.options.some(function(opt) {
                return typeof ('value' in opt ? opt.value : opt.key) === 'number';
            });
            return typeof ('value' in item ? item.value : item.key) === 'number';
        });
        (0, $a62d89528dce911b$export$2e2bcd8739ae039)(!hasNumberValue, '`value` of Option should not use number type when `mode` is `tags` or `combobox`.');
    }
    // `combobox` should not use `optionLabelProp`
    (0, $a62d89528dce911b$export$2e2bcd8739ae039)(mode !== 'combobox' || !optionLabelProp, '`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.');
    // Only `combobox` support `backfill`
    (0, $a62d89528dce911b$export$2e2bcd8739ae039)(mode === 'combobox' || !backfill, '`backfill` only works with `combobox` mode.');
    // Only `combobox` support `getInputElement`
    (0, $a62d89528dce911b$export$2e2bcd8739ae039)(mode === 'combobox' || !getInputElement, '`getInputElement` only work with `combobox` mode.');
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $a62d89528dce911b$export$89ff31684837bbbf)(mode !== 'combobox' || !getInputElement || !allowClear || !placeholder, 'Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.');
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== 'combobox' && mode !== 'tags') (0, $a62d89528dce911b$export$2e2bcd8739ae039)(false, '`onSearch` should work with `showSearch` instead of use alone.');
    (0, $a62d89528dce911b$export$89ff31684837bbbf)(!defaultOpen || autoFocus, '`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.');
    if (value !== undefined && value !== null) {
        var values = (0, $b2f2f91bade499fd$export$45b10814cc054894)(value);
        (0, $a62d89528dce911b$export$2e2bcd8739ae039)(!labelInValue || values.every(function(val) {
            return (0, $a027291fe8adf132$export$2e2bcd8739ae039)(val) === 'object' && ('key' in val || 'value' in val);
        }), '`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`');
        (0, $a62d89528dce911b$export$2e2bcd8739ae039)(!multiple || Array.isArray(value), '`value` should be array when `mode` is `multiple` or `tags`');
    }
    // Syntactic sugar should use correct children type
    if (children) {
        var invalidateChildType = null;
        (0, $f70deae0a90ffbdd$export$2e2bcd8739ae039)(children).some(function(node) {
            if (!/*#__PURE__*/ $acw62.isValidElement(node) || !node.type) return false;
            var _ref = node, type = _ref.type;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                var allChildrenValid = (0, $f70deae0a90ffbdd$export$2e2bcd8739ae039)(node.props.children).every(function(subNode) {
                    if (!/*#__PURE__*/ $acw62.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $a62d89528dce911b$export$2e2bcd8739ae039)(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
        (0, $a62d89528dce911b$export$2e2bcd8739ae039)(inputValue === undefined, '`inputValue` is deprecated, please use `searchValue` instead.');
    }
}
function $53d164ac9af43314$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        var recursiveOptions = function recursiveOptions(optionsList) {
            var inGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            for(var i = 0; i < optionsList.length; i++){
                var option = optionsList[i];
                if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
                    (0, $a62d89528dce911b$export$2e2bcd8739ae039)(false, '`value` in Select options should not be `null`.');
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $53d164ac9af43314$export$2e2bcd8739ae039 = $53d164ac9af43314$var$warningProps;


var $76774de202786c40$var$_excluded = [
    "id",
    "mode",
    "prefixCls",
    "backfill",
    "fieldNames",
    "inputValue",
    "searchValue",
    "onSearch",
    "autoClearSearchValue",
    "onSelect",
    "onDeselect",
    "dropdownMatchSelectWidth",
    "filterOption",
    "filterSort",
    "optionFilterProp",
    "optionLabelProp",
    "options",
    "optionRender",
    "children",
    "defaultActiveFirstOption",
    "menuItemSelectedIcon",
    "virtual",
    "direction",
    "listHeight",
    "listItemHeight",
    "labelRender",
    "value",
    "defaultValue",
    "labelInValue",
    "onChange",
    "maxCount"
];
var $76774de202786c40$var$OMIT_DOM_PROPS = [
    'inputValue'
];
function $76774de202786c40$var$isRawValue(value) {
    return !value || (0, $a027291fe8adf132$export$2e2bcd8739ae039)(value) !== 'object';
}
var $76774de202786c40$var$Select = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var id = props.id, mode = props.mode, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-select' : _props$prefixCls, backfill = props.backfill, fieldNames = props.fieldNames, inputValue = props.inputValue, searchValue = props.searchValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSelect = props.onSelect, onDeselect = props.onDeselect, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, filterOption = props.filterOption, filterSort = props.filterSort, optionFilterProp = props.optionFilterProp, optionLabelProp = props.optionLabelProp, options = props.options, optionRender = props.optionRender, children = props.children, defaultActiveFirstOption = props.defaultActiveFirstOption, menuItemSelectedIcon = props.menuItemSelectedIcon, virtual = props.virtual, direction = props.direction, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, labelRender = props.labelRender, value = props.value, defaultValue = props.defaultValue, labelInValue = props.labelInValue, onChange = props.onChange, maxCount = props.maxCount, restProps = (0, $30c0e704de7afa7d$export$2e2bcd8739ae039)(props, $76774de202786c40$var$_excluded);
    var mergedId = (0, $cb8476e7ddef3fed$export$2e2bcd8739ae039)(id);
    var multiple = (0, $bbedbc5316baa190$export$7f654ad2a77ad2ac)(mode);
    var childrenAsData = !!(!options && children);
    var mergedFilterOption = $acw62.useMemo(function() {
        if (filterOption === undefined && mode === 'combobox') return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    var mergedFieldNames = $acw62.useMemo(function() {
        return (0, $8dfd2b5394871903$export$6c519d302dced239)(fieldNames, childrenAsData);
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    var _useMergedState = (0, $908b598c9326ab1c$export$2e2bcd8739ae039)('', {
        value: searchValue !== undefined ? searchValue : inputValue,
        postState: function postState(search) {
            return search || '';
        }
    }), _useMergedState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    // =========================== Option ===========================
    var parsedOptions = (0, $197036a1a9b77c2d$export$2e2bcd8739ae039)(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
    var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
    // ========================= Wrap Value =========================
    var convert2LabelValues = $acw62.useCallback(function(draftValues) {
        // Convert to array
        var valueList = (0, $b2f2f91bade499fd$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map(function(val) {
            var rawValue;
            var rawLabel;
            var rawKey;
            var rawDisabled;
            var rawTitle;
            // Fill label & value
            if ($76774de202786c40$var$isRawValue(val)) rawValue = val;
            else {
                var _val$value;
                rawKey = val.key;
                rawLabel = val.label;
                rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
            }
            var option = valueOptions.get(rawValue);
            if (option) {
                var _option$key;
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
                if (rawKey === undefined) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
                rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
                rawTitle = option === null || option === void 0 ? void 0 : option.title;
                var optionLabel;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawKey,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    var _useMergedState3 = (0, $908b598c9326ab1c$export$2e2bcd8739ae039)(defaultValue, {
        value: value
    }), _useMergedState4 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    // Merged value with LabelValueType
    var rawLabeledValues = $acw62.useMemo(function() {
        var _values$;
        var newInternalValue = multiple && internalValue === null ? [] : internalValue;
        var values = convert2LabelValues(newInternalValue);
        // combobox no need save value when it's no value (exclude value equal 0)
        if (mode === 'combobox' && (0, $b2f2f91bade499fd$export$9d186c3672bb89c6)((_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode,
        multiple
    ]);
    // Fill label with cache to avoid option remove
    var _useCache = (0, $cb659b69be5664ca$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions), _useCache2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
    var displayValues = $acw62.useMemo(function() {
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            var firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map(function(item) {
            var _ref;
            return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, item), {}, {
                label: (_ref = typeof labelRender === 'function' ? labelRender(item) : item.label) !== null && _ref !== void 0 ? _ref : item.value
            });
        });
    }, [
        mode,
        mergedValues,
        labelRender
    ]);
    /** Convert `displayValues` to raw value type set */ var rawValues = $acw62.useMemo(function() {
        return new Set(mergedValues.map(function(val) {
            return val.value;
        }));
    }, [
        mergedValues
    ]);
    $acw62.useEffect(function() {
        if (mode === 'combobox') {
            var _mergedValues$;
            var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
            setSearchValue((0, $b2f2f91bade499fd$export$96bdbc84526f3739)(strValue) ? String(strValue) : '');
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    var createTagOption = (0, $b335321667729c98$export$2e2bcd8739ae039)(function(val, label) {
        var mergedLabel = label !== null && label !== void 0 ? label : val;
        return (0, $f8ce242576312548$export$2e2bcd8739ae039)((0, $f8ce242576312548$export$2e2bcd8739ae039)({}, mergedFieldNames.value, val), mergedFieldNames.label, mergedLabel);
    });
    // Fill tag as option if mode is `tags`
    var filledTagOptions = $acw62.useMemo(function() {
        if (mode !== 'tags') return mergedOptions;
        // >>> Tag mode
        var cloneOptions = (0, $a58b549eebfe4222$export$2e2bcd8739ae039)(mergedOptions);
        // Check if value exist in options (include new patch item)
        var existOptions = function existOptions(val) {
            return valueOptions.has(val);
        };
        // Fill current value as option
        (0, $a58b549eebfe4222$export$2e2bcd8739ae039)(mergedValues).sort(function(a, b) {
            return a.value < b.value ? -1 : 1;
        }).forEach(function(item) {
            var val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    var filteredOptions = (0, $66a8a41eb0906412$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
    // Fill options with search value if needed
    var filledSearchOptions = $acw62.useMemo(function() {
        if (mode !== 'tags' || !mergedSearchValue || filteredOptions.some(function(item) {
            return item[optionFilterProp || 'value'] === mergedSearchValue;
        })) return filteredOptions;
        // ignore when search value equal select input value
        if (filteredOptions.some(function(item) {
            return item[mergedFieldNames.value] === mergedSearchValue;
        })) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue)
        ].concat((0, $a58b549eebfe4222$export$2e2bcd8739ae039)(filteredOptions));
    }, [
        createTagOption,
        optionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue,
        mergedFieldNames
    ]);
    var sorter = function sorter(inputOptions) {
        var sortedOptions = (0, $a58b549eebfe4222$export$2e2bcd8739ae039)(inputOptions).sort(function(a, b) {
            return filterSort(a, b, {
                searchValue: mergedSearchValue
            });
        });
        return sortedOptions.map(function(item) {
            if (Array.isArray(item.options)) return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, item), {}, {
                options: item.options.length > 0 ? sorter(item.options) : item.options
            });
            return item;
        });
    };
    var orderedFilteredOptions = $acw62.useMemo(function() {
        if (!filterSort) return filledSearchOptions;
        return sorter(filledSearchOptions);
    }, [
        filledSearchOptions,
        filterSort,
        mergedSearchValue
    ]);
    var displayOptions = $acw62.useMemo(function() {
        return (0, $8dfd2b5394871903$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        });
    }, [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    var triggerChange = function triggerChange(values) {
        var labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some(function(newVal, index) {
            var _mergedValues$index;
            return ((_mergedValues$index = mergedValues[index]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
        }))) {
            var returnValues = labelInValue ? labeledValues : labeledValues.map(function(v) {
                return v.value;
            });
            var returnOptions = labeledValues.map(function(v) {
                return (0, $8dfd2b5394871903$export$d0b21b213c8c013c)(getMixedOption(v.value));
            });
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState, 2), activeValue = _React$useState2[0], setActiveValue = _React$useState2[1];
    var _React$useState3 = $acw62.useState(0), _React$useState4 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_React$useState3, 2), accessibilityIndex = _React$useState4[0], setAccessibilityIndex = _React$useState4[1];
    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== 'combobox';
    var onActiveValue = $acw62.useCallback(function(active, index) {
        var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref3$source = _ref3.source, source = _ref3$source === void 0 ? 'keyboard' : _ref3$source;
        setAccessibilityIndex(index);
        if (backfill && mode === 'combobox' && active !== null && source === 'keyboard') setActiveValue(String(active));
    }, [
        backfill,
        mode
    ]);
    // ========================= OptionList =========================
    var triggerSelect = function triggerSelect(val, selected, type) {
        var getSelectEnt = function getSelectEnt() {
            var _option$key2;
            var option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
                    value: val,
                    key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
                } : val,
                (0, $8dfd2b5394871903$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], _option = _getSelectEnt2[1];
            onSelect(wrappedValue, _option);
        } else if (!selected && onDeselect && type !== 'clear') {
            var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = (0, $8f2658428f5feef6$export$2e2bcd8739ae039)(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option2 = _getSelectEnt4[1];
            onDeselect(_wrappedValue, _option2);
        }
    };
    // Used for OptionList selection
    var onInternalSelect = (0, $b335321667729c98$export$2e2bcd8739ae039)(function(val, info) {
        var cloneValues;
        // Single mode always trigger select only with option list
        var mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [].concat((0, $a58b549eebfe4222$export$2e2bcd8739ae039)(mergedValues), [
            val
        ]) : [
            val
        ];
        else cloneValues = mergedValues.filter(function(v) {
            return v.value !== val;
        });
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === 'combobox') // setSearchValue(String(val));
        setActiveValue('');
        else if (!(0, $bbedbc5316baa190$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue('');
            setActiveValue('');
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    var onDisplayValuesChange = function onDisplayValuesChange(nextValues, info) {
        triggerChange(nextValues);
        var type = info.type, values = info.values;
        if (type === 'remove' || type === 'clear') values.forEach(function(item) {
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    var onInternalSearch = function onInternalSearch(searchText, info) {
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === 'submit') {
            var formatted = (searchText || '').trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                var newRawValues = Array.from(new Set([].concat((0, $a58b549eebfe4222$export$2e2bcd8739ae039)(rawValues), [
                    formatted
                ])));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue('');
            }
            return;
        }
        if (info.source !== 'blur') {
            if (mode === 'combobox') triggerChange(searchText);
            onSearch === null || onSearch === void 0 || onSearch(searchText);
        }
    };
    var onInternalSearchSplit = function onInternalSearchSplit(words) {
        var patchValues = words;
        if (mode !== 'tags') patchValues = words.map(function(word) {
            var opt = labelOptions.get(word);
            return opt === null || opt === void 0 ? void 0 : opt.value;
        }).filter(function(val) {
            return val !== undefined;
        });
        var newRawValues = Array.from(new Set([].concat((0, $a58b549eebfe4222$export$2e2bcd8739ae039)(rawValues), (0, $a58b549eebfe4222$export$2e2bcd8739ae039)(patchValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function(newRawValue) {
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    var selectContext = $acw62.useMemo(function() {
        var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
        return (0, $f158faa5f7209115$export$2e2bcd8739ae039)((0, $f158faa5f7209115$export$2e2bcd8739ae039)({}, parsedOptions), {}, {
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            direction: direction,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData,
            maxCount: maxCount,
            optionRender: optionRender
        });
    }, [
        maxCount,
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        dropdownMatchSelectWidth,
        direction,
        listHeight,
        listItemHeight,
        childrenAsData,
        optionRender
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $acw62.createElement((0, $46e904f7b592b3f3$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $acw62.createElement((0, $bbedbc5316baa190$export$2e2bcd8739ae039), (0, $ff00798002f59629$export$2e2bcd8739ae039)({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $76774de202786c40$var$OMIT_DOM_PROPS,
        mode: mode,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        direction: direction,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        OptionList: (0, $e9fe715ea6a5df25$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
    })));
});
var $76774de202786c40$var$TypedSelect = $76774de202786c40$var$Select;
$76774de202786c40$var$TypedSelect.Option = (0, $fc0fa2553f97ec55$export$2e2bcd8739ae039);
$76774de202786c40$var$TypedSelect.OptGroup = (0, $cce47deea66af7d9$export$2e2bcd8739ae039);
var $76774de202786c40$export$2e2bcd8739ae039 = $76774de202786c40$var$TypedSelect;






var $f9a033954775cf26$export$2e2bcd8739ae039 = (0, $76774de202786c40$export$2e2bcd8739ae039);






var $acw62 = parcelRequire("acw62");


"use client";
function $91653a8941ab7768$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $acw62.createElement(Component, Object.assign({}, props)));
}
/* istanbul ignore next */ const $91653a8941ab7768$var$genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $acw62.useRef(null);
        const [popupHeight, setPopupHeight] = $acw62.useState(0);
        const [popupWidth, setPopupWidth] = $acw62.useState(0);
        const [open, setOpen] = (0, $fbd33e1a3c597913$export$2e2bcd8739ae039)(false, {
            value: props.open
        });
        const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
        const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
        $acw62.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    var _a;
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, []);
        let mergedProps = Object.assign(Object.assign({}, props), {
            style: Object.assign(Object.assign({}, style), {
                margin: 0
            }),
            open: open,
            visible: open,
            getPopupContainer: ()=>holderRef.current
        });
        if (postProps) mergedProps = postProps(mergedProps);
        if (alignPropName) Object.assign(mergedProps, {
            [alignPropName]: {
                overflow: {
                    adjustX: false,
                    adjustY: false
                }
            }
        });
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: 'relative',
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $acw62.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $acw62.createElement(Component, Object.assign({}, mergedProps)));
    };
    return $91653a8941ab7768$export$29e2a8c3cdb34b03(PurePanel);
};
var $91653a8941ab7768$export$2e2bcd8739ae039 = $91653a8941ab7768$var$genPurePanel;







var $acw62 = parcelRequire("acw62");


"use client";
const $3feb83783705e448$var$DefaultRenderEmpty = (props)=>{
    const { componentName: componentName } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls('empty');
    switch(componentName){
        case 'Table':
        case 'List':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
            });
        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                className: `${prefix}-small`
            });
        /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */ case 'Table.filter':
            // why `null`? legacy react16 node type `undefined` is not allowed.
            return null;
        default:
            // Should never hit if we take all the component into consider.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), null);
    }
};
var $3feb83783705e448$export$2e2bcd8739ae039 = $3feb83783705e448$var$DefaultRenderEmpty;









const $5b1ac51a636fb330$var$getBuiltInPlacements = (popupOverflow)=>{
    const htmlRegion = popupOverflow === 'scroll' ? 'scroll' : 'visible';
    const sharedConfig = {
        overflow: {
            adjustX: true,
            adjustY: true,
            shiftY: true
        },
        htmlRegion: htmlRegion,
        dynamicInset: true
    };
    return {
        bottomLeft: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                'tl',
                'bl'
            ],
            offset: [
                0,
                4
            ]
        }),
        bottomRight: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                'tr',
                'br'
            ],
            offset: [
                0,
                4
            ]
        }),
        topLeft: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                'bl',
                'tl'
            ],
            offset: [
                0,
                -4
            ]
        }),
        topRight: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                'br',
                'tr'
            ],
            offset: [
                0,
                -4
            ]
        })
    };
};
function $5b1ac51a636fb330$var$mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
    return buildInPlacements || $5b1ac51a636fb330$var$getBuiltInPlacements(popupOverflow);
}
var $5b1ac51a636fb330$export$2e2bcd8739ae039 = $5b1ac51a636fb330$var$mergedBuiltinPlacements;








const $103c380d878d9852$export$c81b62e088da1305 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveDownIn', {
    '0%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $103c380d878d9852$export$6c1eca72ac4f6672 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveDownOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $103c380d878d9852$export$8dd54688d033571 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveLeftIn', {
    '0%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $103c380d878d9852$export$be161c4e647bea9b = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveLeftOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $103c380d878d9852$export$a984c43131c7d145 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveRightIn', {
    '0%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $103c380d878d9852$export$e141ac6798b476df = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveRightOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $103c380d878d9852$export$ab676201eaaca05 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveUpIn', {
    '0%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $103c380d878d9852$export$ec1b91b8ec2f6331 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antMoveUpOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $103c380d878d9852$var$moveMotion = {
    'move-up': {
        inKeyframes: $103c380d878d9852$export$ab676201eaaca05,
        outKeyframes: $103c380d878d9852$export$ec1b91b8ec2f6331
    },
    'move-down': {
        inKeyframes: $103c380d878d9852$export$c81b62e088da1305,
        outKeyframes: $103c380d878d9852$export$6c1eca72ac4f6672
    },
    'move-left': {
        inKeyframes: $103c380d878d9852$export$8dd54688d033571,
        outKeyframes: $103c380d878d9852$export$be161c4e647bea9b
    },
    'move-right': {
        inKeyframes: $103c380d878d9852$export$a984c43131c7d145,
        outKeyframes: $103c380d878d9852$export$e141ac6798b476df
    }
};
const $103c380d878d9852$export$913b1b7e3288c319 = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $103c380d878d9852$var$moveMotion[motionName];
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};



const $f8b44896cb986807$export$e801b802b037de6a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideUpIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $f8b44896cb986807$export$f40f41df328ebc38 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideUpOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $f8b44896cb986807$export$dd9f089fa5e819fe = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideDownIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    }
});
const $f8b44896cb986807$export$f7243fdb9c27c3b7 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideDownOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    }
});
const $f8b44896cb986807$export$2ad3a07c3513a54 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideLeftIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $f8b44896cb986807$export$486fbda27512d5a9 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideLeftOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $f8b44896cb986807$export$dd03ad46dbbcd7e0 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideRightIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    }
});
const $f8b44896cb986807$export$db8e3c9b93664f34 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('antSlideRightOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    }
});
const $f8b44896cb986807$var$slideMotion = {
    'slide-up': {
        inKeyframes: $f8b44896cb986807$export$e801b802b037de6a,
        outKeyframes: $f8b44896cb986807$export$f40f41df328ebc38
    },
    'slide-down': {
        inKeyframes: $f8b44896cb986807$export$dd9f089fa5e819fe,
        outKeyframes: $f8b44896cb986807$export$f7243fdb9c27c3b7
    },
    'slide-left': {
        inKeyframes: $f8b44896cb986807$export$2ad3a07c3513a54,
        outKeyframes: $f8b44896cb986807$export$486fbda27512d5a9
    },
    'slide-right': {
        inKeyframes: $f8b44896cb986807$export$dd03ad46dbbcd7e0,
        outKeyframes: $f8b44896cb986807$export$db8e3c9b93664f34
    }
};
const $f8b44896cb986807$export$9018e60daecf7a6c = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $f8b44896cb986807$var$slideMotion[motionName];
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: 'scale(0)',
                transformOrigin: '0% 0%',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                '&-prepare': {
                    transform: 'scale(1)'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};


const $879d950d114a8bdf$var$genItemStyle = (token)=>{
    const { optionHeight: optionHeight, optionFontSize: optionFontSize, optionLineHeight: optionLineHeight, optionPadding: optionPadding } = token;
    return {
        position: 'relative',
        display: 'block',
        minHeight: optionHeight,
        padding: optionPadding,
        color: token.colorText,
        fontWeight: 'normal',
        fontSize: optionFontSize,
        lineHeight: optionLineHeight,
        boxSizing: 'border-box'
    };
};
const $879d950d114a8bdf$var$genSingleStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const selectItemCls = `${componentCls}-item`;
    const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
    const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
    const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
    const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
    const selectedItemCls = `${selectItemCls}-option-selected`;
    return [
        {
            [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                position: 'absolute',
                top: -9999,
                zIndex: token.zIndexPopup,
                boxSizing: 'border-box',
                padding: token.paddingXXS,
                overflow: 'hidden',
                fontSize: token.fontSize,
                // Fix select render lag of long text in chrome
                // https://github.com/ant-design/ant-design/issues/11456
                // https://github.com/ant-design/ant-design/issues/11843
                fontVariant: 'initial',
                backgroundColor: token.colorBgElevated,
                borderRadius: token.borderRadiusLG,
                outline: 'none',
                boxShadow: token.boxShadowSecondary,
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
                    animationName: (0, $f8b44896cb986807$export$e801b802b037de6a)
                },
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $f8b44896cb986807$export$dd9f089fa5e819fe)
                },
                [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
                    animationName: (0, $f8b44896cb986807$export$f40f41df328ebc38)
                },
                [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $f8b44896cb986807$export$f7243fdb9c27c3b7)
                },
                '&-hidden': {
                    display: 'none'
                },
                [selectItemCls]: Object.assign(Object.assign({}, $879d950d114a8bdf$var$genItemStyle(token)), {
                    cursor: 'pointer',
                    transition: `background ${token.motionDurationSlow} ease`,
                    borderRadius: token.borderRadiusSM,
                    // =========== Group ============
                    '&-group': {
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        cursor: 'default'
                    },
                    // =========== Option ===========
                    '&-option': {
                        display: 'flex',
                        '&-content': Object.assign({
                            flex: 'auto'
                        }, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)),
                        '&-state': {
                            flex: 'none',
                            display: 'flex',
                            alignItems: 'center'
                        },
                        [`&-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.optionActiveBg
                        },
                        [`&-selected:not(${selectItemCls}-option-disabled)`]: {
                            color: token.optionSelectedColor,
                            fontWeight: token.optionSelectedFontWeight,
                            backgroundColor: token.optionSelectedBg,
                            [`${selectItemCls}-option-state`]: {
                                color: token.colorPrimary
                            }
                        },
                        '&-disabled': {
                            [`&${selectItemCls}-option-selected`]: {
                                backgroundColor: token.colorBgContainerDisabled
                            },
                            color: token.colorTextDisabled,
                            cursor: 'not-allowed'
                        },
                        '&-grouped': {
                            paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
                        }
                    },
                    '&-empty': Object.assign(Object.assign({}, $879d950d114a8bdf$var$genItemStyle(token)), {
                        color: token.colorTextDisabled
                    })
                }),
                // https://github.com/ant-design/ant-design/pull/46646
                [`${selectedItemCls}:has(+ ${selectedItemCls})`]: {
                    borderEndStartRadius: 0,
                    borderEndEndRadius: 0,
                    [`& + ${selectedItemCls}`]: {
                        borderStartStartRadius: 0,
                        borderStartEndRadius: 0
                    }
                },
                // =========================== RTL ===========================
                '&-rtl': {
                    direction: 'rtl'
                }
            })
        },
        // Follow code may reuse in other components
        (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, 'slide-up'),
        (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, 'slide-down'),
        (0, $103c380d878d9852$export$913b1b7e3288c319)(token, 'move-up'),
        (0, $103c380d878d9852$export$913b1b7e3288c319)(token, 'move-down')
    ];
};
var $879d950d114a8bdf$export$2e2bcd8739ae039 = $879d950d114a8bdf$var$genSingleStyle;





const $4da12f0c4f4b3a28$export$aaa3604bfe071829 = (token)=>{
    const { multipleSelectItemHeight: multipleSelectItemHeight, paddingXXS: paddingXXS, lineWidth: lineWidth, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const basePadding = token.max(token.calc(paddingXXS).sub(lineWidth).equal(), 0);
    const containerPadding = token.max(token.calc(basePadding).sub(INTERNAL_FIXED_ITEM_MARGIN).equal(), 0);
    return {
        basePadding: basePadding,
        containerPadding: containerPadding,
        itemHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(multipleSelectItemHeight),
        itemLineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(multipleSelectItemHeight).sub(token.calc(token.lineWidth).mul(2)).equal())
    };
};
const $4da12f0c4f4b3a28$var$getSelectItemStyle = (token)=>{
    const { multipleSelectItemHeight: multipleSelectItemHeight, selectHeight: selectHeight, lineWidth: lineWidth } = token;
    const selectItemDist = token.calc(selectHeight).sub(multipleSelectItemHeight).div(2).sub(lineWidth).equal();
    return selectItemDist;
};
const $4da12f0c4f4b3a28$export$b4ab9d1500d7d856 = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, borderRadiusSM: borderRadiusSM, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, multipleItemColorDisabled: multipleItemColorDisabled, multipleItemBorderColorDisabled: multipleItemBorderColorDisabled, colorIcon: colorIcon, colorIconHover: colorIconHover, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
    return {
        /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */ // =========================== Overflow ===========================
        [selectOverflowPrefixCls]: {
            position: 'relative',
            display: 'flex',
            flex: 'auto',
            flexWrap: 'wrap',
            maxWidth: '100%',
            '&-item': {
                flex: 'none',
                alignSelf: 'center',
                // https://github.com/ant-design/ant-design/issues/54179
                maxWidth: 'calc(100% - 4px)',
                display: 'inline-flex'
            },
            // ======================== Selections ==========================
            [`${componentCls}-selection-item`]: {
                display: 'flex',
                alignSelf: 'center',
                flex: 'none',
                boxSizing: 'border-box',
                maxWidth: '100%',
                marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                borderRadius: borderRadiusSM,
                cursor: 'default',
                transition: `font-size ${motionDurationSlow}, line-height ${motionDurationSlow}, height ${motionDurationSlow}`,
                marginInlineEnd: token.calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                paddingInlineStart: paddingXS,
                paddingInlineEnd: token.calc(paddingXS).div(2).equal(),
                [`${componentCls}-disabled&`]: {
                    color: multipleItemColorDisabled,
                    borderColor: multipleItemBorderColorDisabled,
                    cursor: 'not-allowed'
                },
                // It's ok not to do this, but 24px makes bottom narrow in view should adjust
                '&-content': {
                    display: 'inline-block',
                    marginInlineEnd: token.calc(paddingXS).div(2).equal(),
                    overflow: 'hidden',
                    whiteSpace: 'pre',
                    // fix whitespace wrapping. custom tags display all whitespace within.
                    textOverflow: 'ellipsis'
                },
                '&-remove': Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$171ccda7bc085e59)()), {
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: colorIcon,
                    fontWeight: 'bold',
                    fontSize: 10,
                    lineHeight: 'inherit',
                    cursor: 'pointer',
                    [`> ${iconCls}`]: {
                        verticalAlign: '-0.2em'
                    },
                    '&:hover': {
                        color: colorIconHover
                    }
                })
            }
        }
    };
};
const $4da12f0c4f4b3a28$var$genSelectionStyle = (token, suffix)=>{
    const { componentCls: componentCls, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
    const selectItemHeight = token.multipleSelectItemHeight;
    const selectItemDist = $4da12f0c4f4b3a28$var$getSelectItemStyle(token);
    const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
    const multipleSelectorUnit = $4da12f0c4f4b3a28$export$aaa3604bfe071829(token);
    return {
        [`${componentCls}-multiple${suffixCls}`]: Object.assign(Object.assign({}, $4da12f0c4f4b3a28$export$b4ab9d1500d7d856(token)), {
            // ========================= Selector =========================
            [`${componentCls}-selector`]: {
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                // Multiple is little different that horizontal is follow the vertical
                paddingInline: multipleSelectorUnit.basePadding,
                paddingBlock: multipleSelectorUnit.containerPadding,
                borderRadius: token.borderRadius,
                [`${componentCls}-disabled&`]: {
                    background: token.multipleSelectorBgDisabled,
                    cursor: 'not-allowed'
                },
                '&:after': {
                    display: 'inline-block',
                    width: 0,
                    margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(INTERNAL_FIXED_ITEM_MARGIN)} 0`,
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(selectItemHeight),
                    visibility: 'hidden',
                    content: '"\\a0"'
                }
            },
            // ======================== Selections ========================
            [`${componentCls}-selection-item`]: {
                height: multipleSelectorUnit.itemHeight,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(multipleSelectorUnit.itemLineHeight)
            },
            // ========================== Wrap ===========================
            [`${componentCls}-selection-wrap`]: {
                alignSelf: 'flex-start',
                '&:after': {
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(selectItemHeight),
                    marginBlock: INTERNAL_FIXED_ITEM_MARGIN
                }
            },
            // ========================== Input ==========================
            [`${componentCls}-prefix`]: {
                marginInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(multipleSelectorUnit.basePadding).equal()
            },
            [`${selectOverflowPrefixCls}-item + ${selectOverflowPrefixCls}-item,
        ${componentCls}-prefix + ${componentCls}-selection-wrap
      `]: {
                [`${componentCls}-selection-search`]: {
                    marginInlineStart: 0
                },
                [`${componentCls}-selection-placeholder`]: {
                    insetInlineStart: 0
                }
            },
            // https://github.com/ant-design/ant-design/issues/44754
            // Same as `wrap:after`
            [`${selectOverflowPrefixCls}-item-suffix`]: {
                minHeight: multipleSelectorUnit.itemHeight,
                marginBlock: INTERNAL_FIXED_ITEM_MARGIN
            },
            [`${componentCls}-selection-search`]: {
                display: 'inline-flex',
                position: 'relative',
                maxWidth: '100%',
                marginInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(selectItemDist).equal(),
                [`
          &-input,
          &-mirror
        `]: {
                    height: selectItemHeight,
                    fontFamily: token.fontFamily,
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(selectItemHeight),
                    transition: `all ${token.motionDurationSlow}`
                },
                '&-input': {
                    width: '100%',
                    minWidth: 4.1 // fix search cursor missing
                },
                '&-mirror': {
                    position: 'absolute',
                    top: 0,
                    insetInlineStart: 0,
                    insetInlineEnd: 'auto',
                    zIndex: 999,
                    whiteSpace: 'pre',
                    // fix whitespace wrapping caused width calculation bug
                    visibility: 'hidden'
                }
            },
            // ======================= Placeholder =======================
            [`${componentCls}-selection-placeholder`]: {
                position: 'absolute',
                top: '50%',
                insetInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(multipleSelectorUnit.basePadding).equal(),
                insetInlineEnd: token.inputPaddingHorizontalBase,
                transform: 'translateY(-50%)',
                transition: `all ${token.motionDurationSlow}`
            }
        })
    };
};
function $4da12f0c4f4b3a28$var$genSizeStyle(token, suffix) {
    const { componentCls: componentCls } = token;
    const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
    const rawStyle = {
        [`${componentCls}-multiple${suffixCls}`]: {
            fontSize: token.fontSize,
            // ========================= Selector =========================
            [`${componentCls}-selector`]: {
                [`${componentCls}-show-search&`]: {
                    cursor: 'text'
                }
            },
            [`
        &${componentCls}-show-arrow ${componentCls}-selector,
        &${componentCls}-allow-clear ${componentCls}-selector
      `]: {
                paddingInlineEnd: token.calc(token.fontSizeIcon).add(token.controlPaddingHorizontal).equal()
            }
        }
    };
    return [
        $4da12f0c4f4b3a28$var$genSelectionStyle(token, suffix),
        rawStyle
    ];
}
const $4da12f0c4f4b3a28$var$genMultipleStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const smallToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        selectHeight: token.controlHeightSM,
        multipleSelectItemHeight: token.multipleItemHeightSM,
        borderRadius: token.borderRadiusSM,
        borderRadiusSM: token.borderRadiusXS
    });
    const largeToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        fontSize: token.fontSizeLG,
        selectHeight: token.controlHeightLG,
        multipleSelectItemHeight: token.multipleItemHeightLG,
        borderRadius: token.borderRadiusLG,
        borderRadiusSM: token.borderRadius
    });
    return [
        $4da12f0c4f4b3a28$var$genSizeStyle(token),
        // ======================== Small ========================
        $4da12f0c4f4b3a28$var$genSizeStyle(smallToken, 'sm'),
        // Padding
        {
            [`${componentCls}-multiple${componentCls}-sm`]: {
                [`${componentCls}-selection-placeholder`]: {
                    insetInline: token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal()
                },
                // https://github.com/ant-design/ant-design/issues/29559
                [`${componentCls}-selection-search`]: {
                    marginInlineStart: 2 // Magic Number
                }
            }
        },
        // ======================== Large ========================
        $4da12f0c4f4b3a28$var$genSizeStyle(largeToken, 'lg')
    ];
};
var $4da12f0c4f4b3a28$export$2e2bcd8739ae039 = $4da12f0c4f4b3a28$var$genMultipleStyle;





function $143140f2aef1b4ae$var$genSizeStyle(token, suffix) {
    const { componentCls: componentCls, inputPaddingHorizontalBase: inputPaddingHorizontalBase, borderRadius: borderRadius } = token;
    const selectHeightWithoutBorder = token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal();
    const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
    return {
        [`${componentCls}-single${suffixCls}`]: {
            fontSize: token.fontSize,
            height: token.controlHeight,
            // ========================= Selector =========================
            [`${componentCls}-selector`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token, true)), {
                display: 'flex',
                borderRadius: borderRadius,
                flex: '1 1 auto',
                [`${componentCls}-selection-wrap:after`]: {
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(selectHeightWithoutBorder)
                },
                [`${componentCls}-selection-search`]: {
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    '&-input': {
                        width: '100%',
                        WebkitAppearance: 'textfield'
                    }
                },
                [`
          ${componentCls}-selection-item,
          ${componentCls}-selection-placeholder
        `]: {
                    display: 'block',
                    padding: 0,
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(selectHeightWithoutBorder),
                    transition: `all ${token.motionDurationSlow}, visibility 0s`,
                    alignSelf: 'center'
                },
                [`${componentCls}-selection-placeholder`]: {
                    transition: 'none',
                    pointerEvents: 'none'
                },
                // For common baseline align
                [[
                    '&:after',
                    /* For '' value baseline align */ `${componentCls}-selection-item:empty:after`,
                    /* For undefined value baseline align */ `${componentCls}-selection-placeholder:empty:after`
                ].join(',')]: {
                    display: 'inline-block',
                    width: 0,
                    visibility: 'hidden',
                    content: '"\\a0"'
                }
            }),
            [`
        &${componentCls}-show-arrow ${componentCls}-selection-item,
        &${componentCls}-show-arrow ${componentCls}-selection-search,
        &${componentCls}-show-arrow ${componentCls}-selection-placeholder
      `]: {
                paddingInlineEnd: token.showArrowPaddingInlineEnd
            },
            // Opacity selection if open
            [`&${componentCls}-open ${componentCls}-selection-item`]: {
                color: token.colorTextPlaceholder
            },
            // ========================== Input ==========================
            // We only change the style of non-customize input which is only support by `combobox` mode.
            // Not customize
            [`&:not(${componentCls}-customize-input)`]: {
                [`${componentCls}-selector`]: {
                    width: '100%',
                    height: '100%',
                    alignItems: 'center',
                    padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(inputPaddingHorizontalBase)}`,
                    [`${componentCls}-selection-search-input`]: {
                        height: selectHeightWithoutBorder,
                        fontSize: token.fontSize
                    },
                    '&:after': {
                        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(selectHeightWithoutBorder)
                    }
                }
            },
            [`&${componentCls}-customize-input`]: {
                [`${componentCls}-selector`]: {
                    '&:after': {
                        display: 'none'
                    },
                    [`${componentCls}-selection-search`]: {
                        position: 'static',
                        width: '100%'
                    },
                    [`${componentCls}-selection-placeholder`]: {
                        position: 'absolute',
                        insetInlineStart: 0,
                        insetInlineEnd: 0,
                        padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(inputPaddingHorizontalBase)}`,
                        '&:after': {
                            display: 'none'
                        }
                    }
                }
            }
        }
    };
}
function $143140f2aef1b4ae$export$2e2bcd8739ae039(token) {
    const { componentCls: componentCls } = token;
    const inputPaddingHorizontalSM = token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal();
    return [
        $143140f2aef1b4ae$var$genSizeStyle(token),
        // ======================== Small ========================
        // Shared
        $143140f2aef1b4ae$var$genSizeStyle((0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
            controlHeight: token.controlHeightSM,
            borderRadius: token.borderRadiusSM
        }), 'sm'),
        // padding
        {
            [`${componentCls}-single${componentCls}-sm`]: {
                [`&:not(${componentCls}-customize-input)`]: {
                    [`${componentCls}-selector`]: {
                        padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(inputPaddingHorizontalSM)}`
                    },
                    // With arrow should provides `padding-right` to show the arrow
                    [`&${componentCls}-show-arrow ${componentCls}-selection-search`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalSM).add(token.calc(token.fontSize).mul(1.5)).equal()
                    },
                    [`
            &${componentCls}-show-arrow ${componentCls}-selection-item,
            &${componentCls}-show-arrow ${componentCls}-selection-placeholder
          `]: {
                        paddingInlineEnd: token.calc(token.fontSize).mul(1.5).equal()
                    }
                }
            }
        },
        // ======================== Large ========================
        // Shared
        $143140f2aef1b4ae$var$genSizeStyle((0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
            controlHeight: token.singleItemHeightLG,
            fontSize: token.fontSizeLG,
            borderRadius: token.borderRadiusLG
        }), 'lg')
    ];
}


const $59698eaa3035fee4$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeight: controlHeight, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, controlPaddingHorizontal: controlPaddingHorizontal, zIndexPopupBase: zIndexPopupBase, colorText: colorText, fontWeightStrong: fontWeightStrong, controlItemBgActive: controlItemBgActive, controlItemBgHover: controlItemBgHover, colorBgContainer: colorBgContainer, colorFillSecondary: colorFillSecondary, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutline: controlOutline } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    return {
        INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN,
        zIndexPopup: zIndexPopupBase + 50,
        optionSelectedColor: colorText,
        optionSelectedFontWeight: fontWeightStrong,
        optionSelectedBg: controlItemBgActive,
        optionActiveBg: controlItemBgHover,
        optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
        optionFontSize: fontSize,
        optionLineHeight: lineHeight,
        optionHeight: controlHeight,
        selectorBg: colorBgContainer,
        clearBg: colorBgContainer,
        singleItemHeightLG: controlHeightLG,
        multipleItemBg: colorFillSecondary,
        multipleItemBorderColor: 'transparent',
        multipleItemHeight: multipleItemHeight,
        multipleItemHeightSM: multipleItemHeightSM,
        multipleItemHeightLG: multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: colorTextDisabled,
        multipleItemBorderColorDisabled: 'transparent',
        showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25),
        hoverBorderColor: colorPrimaryHover,
        activeBorderColor: colorPrimary,
        activeOutlineColor: controlOutline,
        selectAffixPadding: paddingXXS
    };
};



// =====================================================
// ==                  Outlined                       ==
// =====================================================
const $21a514116ba998e4$var$genBaseOutlinedStyle = (token, options)=>{
    const { componentCls: componentCls, antCls: antCls, controlOutlineWidth: controlOutlineWidth } = token;
    return {
        [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${options.borderColor}`,
            background: token.selectorBg
        },
        [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
            [`&:hover ${componentCls}-selector`]: {
                borderColor: options.hoverBorderHover
            },
            [`${componentCls}-focused& ${componentCls}-selector`]: {
                borderColor: options.activeBorderColor,
                boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(controlOutlineWidth)} ${options.activeOutlineColor}`,
                outline: 0
            },
            [`${componentCls}-prefix`]: {
                color: options.color
            }
        }
    };
};
const $21a514116ba998e4$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}`]: Object.assign({}, $21a514116ba998e4$var$genBaseOutlinedStyle(token, options))
    });
const $21a514116ba998e4$var$genOutlinedStyle = (token)=>({
        '&-outlined': Object.assign(Object.assign(Object.assign(Object.assign({}, $21a514116ba998e4$var$genBaseOutlinedStyle(token, {
            borderColor: token.colorBorder,
            hoverBorderHover: token.hoverBorderColor,
            activeBorderColor: token.activeBorderColor,
            activeOutlineColor: token.activeOutlineColor,
            color: token.colorText
        })), $21a514116ba998e4$var$genOutlinedStatusStyle(token, {
            status: 'error',
            borderColor: token.colorError,
            hoverBorderHover: token.colorErrorHover,
            activeBorderColor: token.colorError,
            activeOutlineColor: token.colorErrorOutline,
            color: token.colorError
        })), $21a514116ba998e4$var$genOutlinedStatusStyle(token, {
            status: 'warning',
            borderColor: token.colorWarning,
            hoverBorderHover: token.colorWarningHover,
            activeBorderColor: token.colorWarning,
            activeOutlineColor: token.colorWarningOutline,
            color: token.colorWarning
        })), {
            [`&${token.componentCls}-disabled`]: {
                [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
                    background: token.colorBgContainerDisabled,
                    color: token.colorTextDisabled
                }
            },
            [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
                background: token.multipleItemBg,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
            }
        })
    });
// =====================================================
// ==                   Filled                        ==
// =====================================================
const $21a514116ba998e4$var$genBaseFilledStyle = (token, options)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
            background: options.bg,
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            color: options.color
        },
        [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
            [`&:hover ${componentCls}-selector`]: {
                background: options.hoverBg
            },
            [`${componentCls}-focused& ${componentCls}-selector`]: {
                background: token.selectorBg,
                borderColor: options.activeBorderColor,
                outline: 0
            }
        }
    };
};
const $21a514116ba998e4$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}`]: Object.assign({}, $21a514116ba998e4$var$genBaseFilledStyle(token, options))
    });
const $21a514116ba998e4$var$genFilledStyle = (token)=>({
        '&-filled': Object.assign(Object.assign(Object.assign(Object.assign({}, $21a514116ba998e4$var$genBaseFilledStyle(token, {
            bg: token.colorFillTertiary,
            hoverBg: token.colorFillSecondary,
            activeBorderColor: token.activeBorderColor,
            color: token.colorText
        })), $21a514116ba998e4$var$genFilledStatusStyle(token, {
            status: 'error',
            bg: token.colorErrorBg,
            hoverBg: token.colorErrorBgHover,
            activeBorderColor: token.colorError,
            color: token.colorError
        })), $21a514116ba998e4$var$genFilledStatusStyle(token, {
            status: 'warning',
            bg: token.colorWarningBg,
            hoverBg: token.colorWarningBgHover,
            activeBorderColor: token.colorWarning,
            color: token.colorWarning
        })), {
            [`&${token.componentCls}-disabled`]: {
                [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
                    borderColor: token.colorBorder,
                    background: token.colorBgContainerDisabled,
                    color: token.colorTextDisabled
                }
            },
            [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
                background: token.colorBgContainer,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
            }
        })
    });
// =====================================================
// ==                 Borderless                      ==
// =====================================================
const $21a514116ba998e4$var$genBorderlessStyle = (token)=>({
        '&-borderless': {
            [`${token.componentCls}-selector`]: {
                background: 'transparent',
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`
            },
            [`&${token.componentCls}-disabled`]: {
                [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
                    color: token.colorTextDisabled
                }
            },
            [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
                background: token.multipleItemBg,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
            },
            // Status
            [`&${token.componentCls}-status-error`]: {
                [`${token.componentCls}-prefix, ${token.componentCls}-selection-item`]: {
                    color: token.colorError
                }
            },
            [`&${token.componentCls}-status-warning`]: {
                [`${token.componentCls}-prefix, ${token.componentCls}-selection-item`]: {
                    color: token.colorWarning
                }
            }
        }
    });
// =====================================================
// ==                 Underlined                      ==
// =====================================================
const $21a514116ba998e4$var$genBaseUnderlinedStyle = (token, options)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
            borderWidth: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} 0`,
            borderStyle: `none none ${token.lineType} none`,
            borderColor: options.borderColor,
            background: token.selectorBg,
            borderRadius: 0
        },
        [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
            [`&:hover ${componentCls}-selector`]: {
                borderColor: options.hoverBorderHover
            },
            [`${componentCls}-focused& ${componentCls}-selector`]: {
                borderColor: options.activeBorderColor,
                outline: 0
            },
            [`${componentCls}-prefix`]: {
                color: options.color
            }
        }
    };
};
const $21a514116ba998e4$var$genUnderlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}`]: Object.assign({}, $21a514116ba998e4$var$genBaseUnderlinedStyle(token, options))
    });
const $21a514116ba998e4$var$genUnderlinedStyle = (token)=>({
        '&-underlined': Object.assign(Object.assign(Object.assign(Object.assign({}, $21a514116ba998e4$var$genBaseUnderlinedStyle(token, {
            borderColor: token.colorBorder,
            hoverBorderHover: token.hoverBorderColor,
            activeBorderColor: token.activeBorderColor,
            activeOutlineColor: token.activeOutlineColor,
            color: token.colorText
        })), $21a514116ba998e4$var$genUnderlinedStatusStyle(token, {
            status: 'error',
            borderColor: token.colorError,
            hoverBorderHover: token.colorErrorHover,
            activeBorderColor: token.colorError,
            activeOutlineColor: token.colorErrorOutline,
            color: token.colorError
        })), $21a514116ba998e4$var$genUnderlinedStatusStyle(token, {
            status: 'warning',
            borderColor: token.colorWarning,
            hoverBorderHover: token.colorWarningHover,
            activeBorderColor: token.colorWarning,
            activeOutlineColor: token.colorWarningOutline,
            color: token.colorWarning
        })), {
            [`&${token.componentCls}-disabled`]: {
                [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
                    color: token.colorTextDisabled
                }
            },
            [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
                background: token.multipleItemBg,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
            }
        })
    });
const $21a514116ba998e4$var$genVariantsStyle = (token)=>({
        [token.componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, $21a514116ba998e4$var$genOutlinedStyle(token)), $21a514116ba998e4$var$genFilledStyle(token)), $21a514116ba998e4$var$genBorderlessStyle(token)), $21a514116ba998e4$var$genUnderlinedStyle(token))
    });
var $21a514116ba998e4$export$2e2bcd8739ae039 = $21a514116ba998e4$var$genVariantsStyle;


// ============================= Selector =============================
const $62a9ef7c3b113a0f$var$genSelectorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        position: 'relative',
        transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
        input: {
            cursor: 'pointer'
        },
        [`${componentCls}-show-search&`]: {
            cursor: 'text',
            input: {
                cursor: 'auto',
                color: 'inherit',
                height: '100%'
            }
        },
        [`${componentCls}-disabled&`]: {
            cursor: 'not-allowed',
            input: {
                cursor: 'not-allowed'
            }
        }
    };
};
// ============================== Styles ==============================
// /* Reset search input style */
const $62a9ef7c3b113a0f$var$getSearchInputWithoutBorderStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-selection-search-input`]: {
            margin: 0,
            padding: 0,
            background: 'transparent',
            border: 'none',
            outline: 'none',
            appearance: 'none',
            fontFamily: 'inherit',
            '&::-webkit-search-cancel-button': {
                display: 'none',
                appearance: 'none'
            }
        }
    };
};
// =============================== Base ===============================
const $62a9ef7c3b113a0f$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, inputPaddingHorizontalBase: inputPaddingHorizontalBase, iconCls: iconCls } = token;
    const hoverShowClearStyle = {
        [`${componentCls}-clear`]: {
            opacity: 1,
            background: token.colorBgBase,
            borderRadius: '50%'
        }
    };
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            position: 'relative',
            display: 'inline-flex',
            cursor: 'pointer',
            [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: Object.assign(Object.assign({}, $62a9ef7c3b113a0f$var$genSelectorStyle(token)), $62a9ef7c3b113a0f$var$getSearchInputWithoutBorderStyle(token)),
            // ======================== Selection ========================
            [`${componentCls}-selection-item`]: Object.assign(Object.assign({
                flex: 1,
                fontWeight: 'normal',
                position: 'relative',
                userSelect: 'none'
            }, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
                // https://github.com/ant-design/ant-design/issues/40421
                [`> ${antCls}-typography`]: {
                    display: 'inline'
                }
            }),
            // ======================= Placeholder =======================
            [`${componentCls}-selection-placeholder`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
                flex: 1,
                color: token.colorTextPlaceholder,
                pointerEvents: 'none'
            }),
            // ========================== Arrow ==========================
            [`${componentCls}-arrow`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$171ccda7bc085e59)()), {
                position: 'absolute',
                top: '50%',
                insetInlineStart: 'auto',
                insetInlineEnd: inputPaddingHorizontalBase,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                lineHeight: 1,
                textAlign: 'center',
                pointerEvents: 'none',
                display: 'flex',
                alignItems: 'center',
                transition: `opacity ${token.motionDurationSlow} ease`,
                [iconCls]: {
                    verticalAlign: 'top',
                    transition: `transform ${token.motionDurationSlow}`,
                    '> svg': {
                        verticalAlign: 'top'
                    },
                    [`&:not(${componentCls}-suffix)`]: {
                        pointerEvents: 'auto'
                    }
                },
                [`${componentCls}-disabled &`]: {
                    cursor: 'not-allowed'
                },
                '> *:not(:last-child)': {
                    marginInlineEnd: 8 // FIXME: magic
                }
            }),
            // ========================== Wrap ===========================
            [`${componentCls}-selection-wrap`]: {
                display: 'flex',
                width: '100%',
                position: 'relative',
                minWidth: 0,
                // https://github.com/ant-design/ant-design/issues/51669
                '&:after': {
                    content: '"\\a0"',
                    width: 0,
                    overflow: 'hidden'
                }
            },
            // ========================= Prefix ==========================
            [`${componentCls}-prefix`]: {
                flex: 'none',
                marginInlineEnd: token.selectAffixPadding
            },
            // ========================== Clear ==========================
            [`${componentCls}-clear`]: {
                position: 'absolute',
                top: '50%',
                insetInlineStart: 'auto',
                insetInlineEnd: inputPaddingHorizontalBase,
                zIndex: 1,
                display: 'inline-block',
                width: token.fontSizeIcon,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                fontStyle: 'normal',
                lineHeight: 1,
                textAlign: 'center',
                textTransform: 'none',
                cursor: 'pointer',
                opacity: 0,
                transition: `color ${token.motionDurationMid} ease, opacity ${token.motionDurationSlow} ease`,
                textRendering: 'auto',
                // https://github.com/ant-design/ant-design/issues/54205
                // Force GPU compositing on Safari to prevent flickering on opacity/transform transitions
                transform: 'translateZ(0)',
                '&:before': {
                    display: 'block'
                },
                '&:hover': {
                    color: token.colorIcon
                }
            },
            '@media(hover:none)': hoverShowClearStyle,
            '&:hover': hoverShowClearStyle
        }),
        // ========================= Feedback ==========================
        [`${componentCls}-status`]: {
            '&-error, &-warning, &-success, &-validating': {
                [`&${componentCls}-has-feedback`]: {
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
                    }
                }
            }
        }
    };
};
// ============================== Styles ==============================
const $62a9ef7c3b113a0f$var$genSelectStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [componentCls]: {
                // ==================== In Form ====================
                [`&${componentCls}-in-form-item`]: {
                    width: '100%'
                }
            }
        },
        // =====================================================
        // ==                       LTR                       ==
        // =====================================================
        // Base
        $62a9ef7c3b113a0f$var$genBaseStyle(token),
        // Single
        (0, $143140f2aef1b4ae$export$2e2bcd8739ae039)(token),
        // Multiple
        (0, $4da12f0c4f4b3a28$export$2e2bcd8739ae039)(token),
        // Dropdown
        (0, $879d950d114a8bdf$export$2e2bcd8739ae039)(token),
        // =====================================================
        // ==                       RTL                       ==
        // =====================================================
        {
            [`${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        },
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(token, {
            borderElCls: `${componentCls}-selector`,
            focusElCls: `${componentCls}-focused`
        })
    ];
};
var // ============================== Export ==============================
$62a9ef7c3b113a0f$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Select', (token, { rootPrefixCls: rootPrefixCls })=>{
    const selectToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        rootPrefixCls: rootPrefixCls,
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        $62a9ef7c3b113a0f$var$genSelectStyle(selectToken),
        (0, $21a514116ba998e4$export$2e2bcd8739ae039)(selectToken)
    ];
}, (0, $59698eaa3035fee4$export$9ca1be8807fe0675), {
    unitless: {
        optionLineHeight: true,
        optionSelectedFontWeight: true
    }
});



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4785c2fd6b878d9a$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $4785c2fd6b878d9a$export$2e2bcd8739ae039 = $4785c2fd6b878d9a$var$DownOutlined;



var $9387210f6c0d2379$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4785c2fd6b878d9a$export$2e2bcd8739ae039)
    }));
};
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ var $9387210f6c0d2379$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($9387210f6c0d2379$var$DownOutlined);
var $9387210f6c0d2379$export$2e2bcd8739ae039 = $9387210f6c0d2379$var$RefIcon;





"use client";
function $f15feb4dca87ef73$export$2e2bcd8739ae039({ suffixIcon: suffixIcon, clearIcon: clearIcon, menuItemSelectedIcon: menuItemSelectedIcon, removeIcon: removeIcon, loading: loading, multiple: multiple, hasFeedback: hasFeedback, prefixCls: prefixCls, showSuffixIcon: showSuffixIcon, feedbackIcon: feedbackIcon, showArrow: showArrow, componentName: componentName }) {
    // Clear Icon
    const mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /*#__PURE__*/ $acw62.createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null);
    // Validation Feedback Icon
    const getSuffixIconNode = (arrowIcon)=>{
        if (suffixIcon === null && !hasFeedback && !showArrow) return null;
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), {
        spin: true
    }));
    else {
        const iconCls = `${prefixCls}-suffix`;
        mergedSuffixIcon = ({ open: open, showSearch: showSearch })=>{
            if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $f7392a88184334dd$export$2e2bcd8739ae039), {
                className: iconCls
            }));
            return getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $9387210f6c0d2379$export$2e2bcd8739ae039), {
                className: iconCls
            }));
        };
    }
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $acw62.createElement((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), null);
    else mergedItemIcon = null;
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null);
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}


/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */ function $ce5709ba38c89ca7$export$2e2bcd8739ae039(suffixIcon, showArrow) {
    return showArrow !== undefined ? showArrow : suffixIcon !== null;
}


"use client";
var $1b56c179e5783cdb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
const $1b56c179e5783cdb$var$InternalSelect = (props, ref)=>{
    var _a, _b, _c, _d, _e;
    const { prefixCls: customizePrefixCls, bordered: bordered, className: className, rootClassName: rootClassName, getPopupContainer: getPopupContainer, popupClassName: popupClassName, dropdownClassName: dropdownClassName, listHeight: listHeight = 256, placement: placement, listItemHeight: customListItemHeight, size: customizeSize, disabled: customDisabled, notFoundContent: notFoundContent, status: customStatus, builtinPlacements: builtinPlacements, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, direction: propDirection, style: style, allowClear: allowClear, variant: customizeVariant, dropdownStyle: dropdownStyle, transitionName: transitionName, tagRender: tagRender, maxCount: maxCount, prefix: prefix, dropdownRender: dropdownRender, popupRender: popupRender, onDropdownVisibleChange: onDropdownVisibleChange, onOpenChange: onOpenChange, styles: styles, classNames: classNames } = props, rest = $1b56c179e5783cdb$var$__rest(props, [
        "prefixCls",
        "bordered",
        "className",
        "rootClassName",
        "getPopupContainer",
        "popupClassName",
        "dropdownClassName",
        "listHeight",
        "placement",
        "listItemHeight",
        "size",
        "disabled",
        "notFoundContent",
        "status",
        "builtinPlacements",
        "dropdownMatchSelectWidth",
        "popupMatchSelectWidth",
        "direction",
        "style",
        "allowClear",
        "variant",
        "dropdownStyle",
        "transitionName",
        "tagRender",
        "maxCount",
        "prefix",
        "dropdownRender",
        "popupRender",
        "onDropdownVisibleChange",
        "onOpenChange",
        "styles",
        "classNames"
    ]);
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: contextDirection, virtual: virtual, popupMatchSelectWidth: contextPopupMatchSelectWidth, popupOverflow: popupOverflow } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { showSearch: showSearch, style: contextStyle, styles: contextStyles, className: contextClassName, classNames: contextClassNames } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('select');
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const listItemHeight = customListItemHeight !== null && customListItemHeight !== void 0 ? customListItemHeight : token === null || token === void 0 ? void 0 : token.controlHeight;
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const direction = propDirection !== null && propDirection !== void 0 ? propDirection : contextDirection;
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const [variant, enableVariantCls] = (0, $ce4103032ab2fd5e$export$2e2bcd8739ae039)('select', customizeVariant, bordered);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $62a9ef7c3b113a0f$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mode = $acw62.useMemo(()=>{
        const { mode: m } = props;
        if (m === 'combobox') return undefined;
        if (m === $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return 'combobox';
        return m;
    }, [
        props.mode
    ]);
    const isMultiple = mode === 'multiple' || mode === 'tags';
    const showSuffixIcon = (0, $ce5709ba38c89ca7$export$2e2bcd8739ae039)(props.suffixIcon, props.showArrow);
    const mergedPopupMatchSelectWidth = (_a = popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth) !== null && _a !== void 0 ? _a : contextPopupMatchSelectWidth;
    const mergedPopupStyle = ((_b = styles === null || styles === void 0 ? void 0 : styles.popup) === null || _b === void 0 ? void 0 : _b.root) || ((_c = contextStyles.popup) === null || _c === void 0 ? void 0 : _c.root) || dropdownStyle;
    const mergedPopupRender = popupRender || dropdownRender;
    const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
    // ===================== Form Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    let mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === 'combobox') mergedNotFound = null;
    else mergedNotFound = (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty('Select')) || /*#__PURE__*/ $acw62.createElement((0, $3feb83783705e448$export$2e2bcd8739ae039), {
        componentName: "Select"
    });
    // ===================== Icons =====================
    const { suffixIcon: suffixIcon, itemIcon: itemIcon, removeIcon: removeIcon, clearIcon: clearIcon } = (0, $f15feb4dca87ef73$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, rest), {
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showSuffixIcon: showSuffixIcon,
        prefixCls: prefixCls,
        componentName: 'Select'
    }));
    const mergedAllowClear = allowClear === true ? {
        clearIcon: clearIcon
    } : allowClear;
    const selectProps = (0, $57c22a5a2f343bca$export$2e2bcd8739ae039)(rest, [
        'suffixIcon',
        'itemIcon'
    ]);
    const mergedPopupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(((_d = classNames === null || classNames === void 0 ? void 0 : classNames.popup) === null || _d === void 0 ? void 0 : _d.root) || ((_e = contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.popup) === null || _e === void 0 ? void 0 : _e.root) || popupClassName || dropdownClassName, {
        [`${prefixCls}-dropdown-${direction}`]: direction === 'rtl'
    }, rootClassName, contextClassNames.root, classNames === null || classNames === void 0 ? void 0 : classNames.root, cssVarCls, rootCls, hashId);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-lg`]: mergedSize === 'large',
        [`${prefixCls}-sm`]: mergedSize === 'small',
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${variant}`]: enableVariantCls,
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, contextClassName, className, contextClassNames.root, classNames === null || classNames === void 0 ? void 0 : classNames.root, rootClassName, cssVarCls, rootCls, hashId);
    // ===================== Placement =====================
    const memoPlacement = $acw62.useMemo(()=>{
        if (placement !== undefined) return placement;
        return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
    }, [
        placement,
        direction
    ]);
    var oldProp, newProp;
    // ====================== zIndex =========================
    const [zIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)('SelectLike', mergedPopupStyle === null || mergedPopupStyle === void 0 ? void 0 : mergedPopupStyle.zIndex);
    // ====================== Render =======================
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $f9a033954775cf26$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        virtual: virtual,
        showSearch: showSearch
    }, selectProps, {
        style: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), styles === null || styles === void 0 ? void 0 : styles.root), contextStyle), style),
        dropdownMatchSelectWidth: mergedPopupMatchSelectWidth,
        transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, 'slide-up', transitionName),
        builtinPlacements: (0, $5b1ac51a636fb330$export$2e2bcd8739ae039)(builtinPlacements, popupOverflow),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: memoPlacement,
        direction: direction,
        prefix: prefix,
        suffixIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        allowClear: mergedAllowClear,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        dropdownClassName: mergedPopupClassName,
        disabled: mergedDisabled,
        dropdownStyle: Object.assign(Object.assign({}, mergedPopupStyle), {
            zIndex: zIndex
        }),
        maxCount: isMultiple ? maxCount : undefined,
        tagRender: isMultiple ? tagRender : undefined,
        dropdownRender: mergedPopupRender,
        onDropdownVisibleChange: mergedOnOpenChange
    })));
};
const $1b56c179e5783cdb$var$Select = /*#__PURE__*/ $acw62.forwardRef($1b56c179e5783cdb$var$InternalSelect);
// We don't care debug panel
/* istanbul ignore next */ const $1b56c179e5783cdb$var$PurePanel = (0, $91653a8941ab7768$export$2e2bcd8739ae039)($1b56c179e5783cdb$var$Select, 'dropdownAlign');
$1b56c179e5783cdb$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$1b56c179e5783cdb$var$Select.Option = (0, $fc0fa2553f97ec55$export$2e2bcd8739ae039);
$1b56c179e5783cdb$var$Select.OptGroup = (0, $cce47deea66af7d9$export$2e2bcd8739ae039);
$1b56c179e5783cdb$var$Select._InternalPanelDoNotUseOrYouWillBeFired = $1b56c179e5783cdb$var$PurePanel;
var $1b56c179e5783cdb$export$2e2bcd8739ae039 = $1b56c179e5783cdb$var$Select;


var $acw62 = parcelRequire("acw62");


function $cf0f554ddf4da10f$export$f5153c3888a6824e(size) {
    return [
        'small',
        'middle',
        'large'
    ].includes(size);
}
function $cf0f554ddf4da10f$export$1b502d0a9135d42b(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return typeof size === 'number' && !Number.isNaN(size);
}





var $acw62 = parcelRequire("acw62");
const $68baed55ab318008$export$853f607fd5cc208b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    latestIndex: 0
});
const $68baed55ab318008$export$2bbf36e6e96e17f9 = $68baed55ab318008$export$853f607fd5cc208b.Provider;



var $acw62 = parcelRequire("acw62");

"use client";
const $a9129d7ad0e59df6$var$Item = ({ className: className, index: index, children: children, split: split, style: style })=>{
    const { latestIndex: latestIndex } = $acw62.useContext((0, $68baed55ab318008$export$853f607fd5cc208b));
    if (children === null || children === undefined) return null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && split && /*#__PURE__*/ $acw62.createElement("span", {
        className: `${className}-split`
    }, split));
};
var $a9129d7ad0e59df6$export$2e2bcd8739ae039 = $a9129d7ad0e59df6$var$Item;



"use client";
var $8f666b0c5cd58c95$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $8f666b0c5cd58c95$var$InternalSpace = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a;
    const { getPrefixCls: getPrefixCls, direction: directionConfig, size: contextSize, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $a18b2f6f56546238$export$46f4bd6436a25a31)('space');
    const { size: size = contextSize !== null && contextSize !== void 0 ? contextSize : 'small', align: align, className: className, rootClassName: rootClassName, children: children, direction: direction = 'horizontal', prefixCls: customizePrefixCls, split: split, style: style, wrap: wrap = false, classNames: customClassNames, styles: styles } = props, otherProps = $8f666b0c5cd58c95$var$__rest(props, [
        "size",
        "align",
        "className",
        "rootClassName",
        "children",
        "direction",
        "prefixCls",
        "split",
        "style",
        "wrap",
        "classNames",
        "styles"
    ]);
    const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [
        size,
        size
    ];
    const isPresetVerticalSize = (0, $cf0f554ddf4da10f$export$f5153c3888a6824e)(verticalSize);
    const isPresetHorizontalSize = (0, $cf0f554ddf4da10f$export$f5153c3888a6824e)(horizontalSize);
    const isValidVerticalSize = (0, $cf0f554ddf4da10f$export$1b502d0a9135d42b)(verticalSize);
    const isValidHorizontalSize = (0, $cf0f554ddf4da10f$export$1b502d0a9135d42b)(horizontalSize);
    const childNodes = (0, $5aa78504b8a12848$export$2e2bcd8739ae039)(children, {
        keepEmpty: true
    });
    const mergedAlign = align === undefined && direction === 'horizontal' ? 'center' : align;
    const prefixCls = getPrefixCls('space', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $8c6cd68a6974f2d0$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, contextClassName, hashId, `${prefixCls}-${direction}`, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
        [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
    }, className, rootClassName, cssVarCls);
    const itemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-item`, (_a = customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.item) !== null && _a !== void 0 ? _a : contextClassNames.item);
    // Calculate latest one
    let latestIndex = 0;
    const nodes = childNodes.map((child, i)=>{
        var _a;
        if (child !== null && child !== undefined) latestIndex = i;
        const key = (child === null || child === void 0 ? void 0 : child.key) || `${itemClassName}-${i}`;
        return /*#__PURE__*/ $acw62.createElement((0, $a9129d7ad0e59df6$export$2e2bcd8739ae039), {
            className: itemClassName,
            key: key,
            index: i,
            split: split,
            style: (_a = styles === null || styles === void 0 ? void 0 : styles.item) !== null && _a !== void 0 ? _a : contextStyles.item
        }, child);
    });
    const spaceContext = $acw62.useMemo(()=>({
            latestIndex: latestIndex
        }), [
        latestIndex
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    const gapStyle = {};
    if (wrap) gapStyle.flexWrap = 'wrap';
    if (!isPresetHorizontalSize && isValidHorizontalSize) gapStyle.columnGap = horizontalSize;
    if (!isPresetVerticalSize && isValidVerticalSize) gapStyle.rowGap = verticalSize;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        ref: ref,
        className: cls,
        style: Object.assign(Object.assign(Object.assign({}, gapStyle), contextStyle), style)
    }, otherProps), /*#__PURE__*/ $acw62.createElement((0, $68baed55ab318008$export$2bbf36e6e96e17f9), {
        value: spaceContext
    }, nodes)));
});
const $8f666b0c5cd58c95$var$Space = $8f666b0c5cd58c95$var$InternalSpace;
$8f666b0c5cd58c95$var$Space.Compact = (0, $26050ef76e24a749$export$2e2bcd8739ae039);
var $8f666b0c5cd58c95$export$2e2bcd8739ae039 = $8f666b0c5cd58c95$var$Space;




// deno-lint-ignore-file no-explicit-any


// deno-lint-ignore-file no-explicit-any


const $60c8f995730d23c1$export$73d9c6e26383cd58 = (target, prop)=>{
    const r = Reflect.get(target, prop, target);
    if (typeof r === "function") switch(prop){
        case "get":
            return (key)=>{
                const r = target.get(key);
                (0, $9975527c0402172a$export$2e2bcd8739ae039).emitGet({
                    target: target,
                    prop: key,
                    value: r
                });
                return r;
            };
        case "set":
            return (key, value)=>{
                const has = target.has(key);
                const r = target.set(key, value);
                (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).emit({
                    target: target,
                    prop: key,
                    value: has ? 0 : 1
                });
                return r;
            };
        case "has":
            return (key)=>{
                const r = target.has(key);
                (0, $9975527c0402172a$export$2e2bcd8739ae039).emitHas({
                    target: target,
                    prop: key,
                    value: r
                });
                return r;
            };
        case "delete":
            return (key)=>{
                const r = target.delete(key);
                (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).emit({
                    target: target,
                    prop: key,
                    value: r ? -1 : 0
                });
                return r;
            };
        case "keys":
            return ()=>{
                const r = target.keys();
                (0, $9975527c0402172a$export$2e2bcd8739ae039).emitKeys({
                    target: target
                });
                return r;
            };
        case "clear":
            return ()=>{
                for (const key of target.keys())(0, $3c0e93c0975aa561$export$2e2bcd8739ae039).emit({
                    target: target,
                    prop: key,
                    value: -1
                });
                target.clear();
            };
        case "values":
        case "entries":
        case Symbol.iterator:
        case "forEach":
            return (...args)=>{
                const r = Reflect.get(target, prop).apply(target, args);
                (0, $9975527c0402172a$export$2e2bcd8739ae039).emitKeys({
                    target: target
                });
                for (const key of target.keys())(0, $9975527c0402172a$export$2e2bcd8739ae039).emitGet({
                    target: target,
                    prop: key,
                    value: target.get(key)
                });
                return r;
            };
        default:
            return r.bind(target);
    }
    if (prop === "size") (0, $9975527c0402172a$export$2e2bcd8739ae039).emitKeys({
        target: target
    });
    return r;
};
const $60c8f995730d23c1$export$62f266a18266a7c5 = (target, prop)=>{
    const r = Reflect.get(target, prop, target);
    if (typeof r === "function") switch(prop){
        case "add":
            return (key)=>{
                const has = target.has(key);
                const r = target.add(key);
                (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).emit({
                    target: target,
                    prop: key,
                    value: has ? 0 : 1
                });
                return r;
            };
        case "has":
            return (key)=>{
                const r = target.has(key);
                (0, $9975527c0402172a$export$2e2bcd8739ae039).emitHas({
                    target: target,
                    prop: key,
                    value: r
                });
                return r;
            };
        case "delete":
            return (key)=>{
                const r = target.delete(key);
                (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).emit({
                    target: target,
                    prop: key,
                    value: r ? -1 : 0
                });
                return r;
            };
        case "clear":
            return ()=>{
                for (const key of target.keys())(0, $3c0e93c0975aa561$export$2e2bcd8739ae039).emit({
                    target: target,
                    prop: key,
                    value: -1
                });
                target.clear();
            };
        case "keys":
        case "values":
        case "entries":
        case Symbol.iterator:
        case "forEach":
            return (...args)=>{
                const r = Reflect.get(target, prop).apply(target, args);
                (0, $9975527c0402172a$export$2e2bcd8739ae039).emitKeys({
                    target: target
                });
                return r;
            };
        default:
            return r.bind(target);
    }
    if (prop === "size") (0, $9975527c0402172a$export$2e2bcd8739ae039).emitKeys({
        target: target
    });
    return r;
};


const $b1599b8ade248f1d$var$proxyMap = new WeakMap();
const $b1599b8ade248f1d$export$bb212da7d2b5424b = (target)=>$b1599b8ade248f1d$var$proxyMap.has(target);
const $b1599b8ade248f1d$var$excludeSet = new WeakSet();
const $b1599b8ade248f1d$export$44c361b8ec72ef7f = (target)=>{
    $b1599b8ade248f1d$var$excludeSet.add(target);
    return target;
};
const $b1599b8ade248f1d$var$reactElementSymbol = Symbol.for("react.element");
const $b1599b8ade248f1d$var$canManage = (obj)=>obj && (Array.isArray(obj) || obj.toString() === "[object Object]" || obj.toString() === "[object Map]" || obj.toString() === "[object Set]") && obj["$$typeof"] !== $b1599b8ade248f1d$var$reactElementSymbol && !$b1599b8ade248f1d$var$excludeSet.has(obj);
const $b1599b8ade248f1d$export$aef2f541c13a9f3a = (target, maxDepth = 10)=>{
    if (maxDepth <= 0) return target;
    // return managed if it's already managed
    if ($b1599b8ade248f1d$var$proxyMap.has(target)) return $b1599b8ade248f1d$var$proxyMap.get(target);
    // return target if it cannot be managed
    if (!$b1599b8ade248f1d$var$canManage(target)) return target;
    const managed = new Proxy(target, {
        // read traps
        get: (target, prop, receiver)=>{
            if (target instanceof Map) return (0, $60c8f995730d23c1$export$73d9c6e26383cd58)(target, prop);
            else if (target instanceof Set) return (0, $60c8f995730d23c1$export$62f266a18266a7c5)(target, prop);
            const r = Reflect.get(target, prop, receiver);
            if (typeof r !== "function") (0, $9975527c0402172a$export$2e2bcd8739ae039).emitGet({
                target: target,
                prop: prop,
                value: r
            });
            return r;
        },
        has: (target, prop)=>{
            const r = Reflect.has(target, prop);
            (0, $9975527c0402172a$export$2e2bcd8739ae039).emitHas({
                target: target,
                prop: prop,
                value: r
            });
            return r;
        },
        ownKeys: (target)=>{
            (0, $9975527c0402172a$export$2e2bcd8739ae039).emitKeys({
                target: target
            });
            return Reflect.ownKeys(target);
        },
        // write traps
        defineProperty: (target, prop, descriptor)=>{
            const has = Reflect.has(target, prop);
            const r = Reflect.defineProperty(target, prop, {
                ...descriptor,
                value: $b1599b8ade248f1d$export$aef2f541c13a9f3a(descriptor.value, maxDepth - 1)
            });
            (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).emit({
                target: target,
                prop: prop,
                value: !has && r ? 1 : 0
            });
            return r;
        },
        deleteProperty: (target, prop)=>{
            const has = Reflect.has(target, prop);
            const r = Reflect.deleteProperty(target, prop);
            (0, $3c0e93c0975aa561$export$2e2bcd8739ae039).emit({
                target: target,
                prop: prop,
                value: has && r ? -1 : 0
            });
            return r;
        }
    });
    $b1599b8ade248f1d$var$proxyMap.set(target, managed);
    $b1599b8ade248f1d$var$proxyMap.set(managed, managed);
    // recursively manage all properties
    for (const prop of Reflect.ownKeys(target)){
        const descriptor = Reflect.getOwnPropertyDescriptor(target, prop);
        if (descriptor.value && $b1599b8ade248f1d$var$canManage(descriptor.value)) Reflect.defineProperty(target, prop, {
            ...descriptor,
            value: $b1599b8ade248f1d$export$aef2f541c13a9f3a(descriptor.value, maxDepth - 1)
        });
    }
    // make all functions batched
    const seen = new Set();
    for(let current = target; current && current !== Object.prototype; current = Reflect.getPrototypeOf(current))for (const key of Reflect.ownKeys(current)){
        if (seen.has(key)) continue; // prototype definition should not override instance definition
        const descriptor = Reflect.getOwnPropertyDescriptor(current, key);
        if (typeof descriptor.value !== "function") continue;
        Reflect.defineProperty(target, key, {
            ...descriptor,
            value: Object.defineProperty(function(...args) {
                return (0, $3c0e93c0975aa561$export$f443e47852576b4f)(()=>descriptor.value.apply(this, args))[0];
            }, "name", {
                value: descriptor.value.name
            })
        });
        seen.add(key);
    }
    return managed;
};



const $95b03e31963f077a$export$61fc7d43ac8f84b0 = (delay)=>{
    return (func)=>{
        let timeout = null;
        return (...args)=>{
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                func(...args);
            }, delay);
        };
    };
};






var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




function $be673cd5391dca21$var$mergeProps(...items) {
    const ret = {};
    items.forEach((item)=>{
        if (item) Object.keys(item).forEach((key)=>{
            if (item[key] !== undefined) ret[key] = item[key];
        });
    });
    return ret;
}
var $be673cd5391dca21$export$2e2bcd8739ae039 = $be673cd5391dca21$var$mergeProps;


"use client";
function $91e86e8e8e97dd3f$export$51ad9c30389f050b(context) {
    if (!context) return undefined;
    const { closable: closable, closeIcon: closeIcon } = context;
    return {
        closable: closable,
        closeIcon: closeIcon
    };
}
/** Convert `closable` and `closeIcon` to config object */ function $91e86e8e8e97dd3f$var$useClosableConfig(closableCollection) {
    const { closable: closable, closeIcon: closeIcon } = closableCollection || {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (// If `closable`, whatever rest be should be true
        !closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
        if (closable === undefined && closeIcon === undefined) return null;
        let closableConfig = {
            closeIcon: typeof closeIcon !== 'boolean' && closeIcon !== null ? closeIcon : undefined
        };
        if (closable && typeof closable === 'object') closableConfig = Object.assign(Object.assign({}, closableConfig), closable);
        return closableConfig;
    }, [
        closable,
        closeIcon
    ]);
}
/** Use same object to support `useMemo` optimization */ const $91e86e8e8e97dd3f$var$EmptyFallbackCloseCollection = {};
function $91e86e8e8e97dd3f$export$2e2bcd8739ae039(propCloseCollection, contextCloseCollection, fallbackCloseCollection = $91e86e8e8e97dd3f$var$EmptyFallbackCloseCollection) {
    // Align the `props`, `context` `fallback` to config object first
    const propCloseConfig = $91e86e8e8e97dd3f$var$useClosableConfig(propCloseCollection);
    const contextCloseConfig = $91e86e8e8e97dd3f$var$useClosableConfig(contextCloseCollection);
    const [contextLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)('global', (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).global);
    const closeBtnIsDisabled = typeof propCloseConfig !== 'boolean' ? !!(propCloseConfig === null || propCloseConfig === void 0 ? void 0 : propCloseConfig.disabled) : false;
    const mergedFallbackCloseCollection = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Object.assign({
            closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null)
        }, fallbackCloseCollection), [
        fallbackCloseCollection
    ]);
    // Use fallback logic to fill the config
    const mergedClosableConfig = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        // ================ Props First ================
        // Skip if prop is disabled
        if (propCloseConfig === false) return false;
        if (propCloseConfig) return (0, $be673cd5391dca21$export$2e2bcd8739ae039)(mergedFallbackCloseCollection, contextCloseConfig, propCloseConfig);
        // =============== Context Second ==============
        // Skip if context is disabled
        if (contextCloseConfig === false) return false;
        if (contextCloseConfig) return (0, $be673cd5391dca21$export$2e2bcd8739ae039)(mergedFallbackCloseCollection, contextCloseConfig);
        // ============= Fallback Default ==============
        return !mergedFallbackCloseCollection.closable ? false : mergedFallbackCloseCollection;
    }, [
        propCloseConfig,
        contextCloseConfig,
        mergedFallbackCloseCollection
    ]);
    // Calculate the final closeIcon
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        var _a, _b;
        if (mergedClosableConfig === false) return [
            false,
            null,
            closeBtnIsDisabled,
            {}
        ];
        const { closeIconRender: closeIconRender } = mergedFallbackCloseCollection;
        const { closeIcon: closeIcon } = mergedClosableConfig;
        let mergedCloseIcon = closeIcon;
        // Wrap the closeIcon with aria props
        const ariaOrDataProps = (0, $c9d5a0479fbb39e9$export$2e2bcd8739ae039)(mergedClosableConfig, true);
        if (mergedCloseIcon !== null && mergedCloseIcon !== undefined) {
            // Wrap the closeIcon if needed
            if (closeIconRender) mergedCloseIcon = closeIconRender(closeIcon);
            mergedCloseIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(mergedCloseIcon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(mergedCloseIcon, Object.assign(Object.assign(Object.assign({}, mergedCloseIcon.props), {
                'aria-label': (_b = (_a = mergedCloseIcon.props) === null || _a === void 0 ? void 0 : _a['aria-label']) !== null && _b !== void 0 ? _b : contextLocale.close
            }), ariaOrDataProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
                "aria-label": contextLocale.close
            }, ariaOrDataProps), mergedCloseIcon);
        }
        return [
            true,
            mergedCloseIcon,
            closeBtnIsDisabled,
            ariaOrDataProps
        ];
    }, [
        mergedClosableConfig,
        mergedFallbackCloseCollection
    ]);
}







var $acw62 = parcelRequire("acw62");






// ============================== Styles ==============================
const $bd814ea00a1f65a8$var$genBaseStyle = (token)=>{
    const { paddingXXS: paddingXXS, lineWidth: lineWidth, tagPaddingHorizontal: tagPaddingHorizontal, componentCls: componentCls, calc: calc } = token;
    const paddingInline = calc(tagPaddingHorizontal).sub(lineWidth).equal();
    const iconMarginInline = calc(paddingXXS).sub(lineWidth).equal();
    return {
        // Result
        [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            display: 'inline-block',
            height: 'auto',
            // https://github.com/ant-design/ant-design/pull/47504
            marginInlineEnd: token.marginXS,
            paddingInline: paddingInline,
            fontSize: token.tagFontSize,
            lineHeight: token.tagLineHeight,
            whiteSpace: 'nowrap',
            background: token.defaultBg,
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
            borderRadius: token.borderRadiusSM,
            opacity: 1,
            transition: `all ${token.motionDurationMid}`,
            textAlign: 'start',
            position: 'relative',
            // RTL
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            },
            '&, a, a:hover': {
                color: token.defaultColor
            },
            [`${componentCls}-close-icon`]: {
                marginInlineStart: iconMarginInline,
                fontSize: token.tagIconSize,
                color: token.colorIcon,
                cursor: 'pointer',
                transition: `all ${token.motionDurationMid}`,
                '&:hover': {
                    color: token.colorTextHeading
                }
            },
            [`&${componentCls}-has-color`]: {
                borderColor: 'transparent',
                [`&, a, a:hover, ${token.iconCls}-close, ${token.iconCls}-close:hover`]: {
                    color: token.colorTextLightSolid
                }
            },
            '&-checkable': {
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                cursor: 'pointer',
                [`&:not(${componentCls}-checkable-checked):hover`]: {
                    color: token.colorPrimary,
                    backgroundColor: token.colorFillSecondary
                },
                '&:active, &-checked': {
                    color: token.colorTextLightSolid
                },
                '&-checked': {
                    backgroundColor: token.colorPrimary,
                    '&:hover': {
                        backgroundColor: token.colorPrimaryHover
                    }
                },
                '&:active': {
                    backgroundColor: token.colorPrimaryActive
                }
            },
            '&-hidden': {
                display: 'none'
            },
            // To ensure that a space will be placed between character and `Icon`.
            [`> ${token.iconCls} + span, > span + ${token.iconCls}`]: {
                marginInlineStart: paddingInline
            }
        }),
        [`${componentCls}-borderless`]: {
            borderColor: 'transparent',
            background: token.tagBorderlessBg
        }
    };
};
const $bd814ea00a1f65a8$export$362fb92a8f81bbf9 = (token)=>{
    const { lineWidth: lineWidth, fontSizeIcon: fontSizeIcon, calc: calc } = token;
    const tagFontSize = token.fontSizeSM;
    const tagToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        tagFontSize: tagFontSize,
        tagLineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(token.lineHeightSM).mul(tagFontSize).equal()),
        tagIconSize: calc(fontSizeIcon).sub(calc(lineWidth).mul(2)).equal(),
        // Tag icon is much smaller
        tagPaddingHorizontal: 8,
        // Fixed padding.
        tagBorderlessBg: token.defaultBg
    });
    return tagToken;
};
const $bd814ea00a1f65a8$export$9ca1be8807fe0675 = (token)=>({
        defaultBg: new (0, $ea19b77d77fd8663$export$2c4f38d6c0ecc25a)(token.colorFillQuaternary).onBackground(token.colorBgContainer).toHexString(),
        defaultColor: token.colorText
    });
var $bd814ea00a1f65a8$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Tag', (token)=>{
    const tagToken = $bd814ea00a1f65a8$export$362fb92a8f81bbf9(token);
    return $bd814ea00a1f65a8$var$genBaseStyle(tagToken);
}, $bd814ea00a1f65a8$export$9ca1be8807fe0675);


"use client";
var $8aa648d8fa6484b7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $8aa648d8fa6484b7$var$CheckableTag = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, style: style, className: className, checked: checked, onChange: onChange, onClick: onClick } = props, restProps = $8aa648d8fa6484b7$var$__rest(props, [
        "prefixCls",
        "style",
        "className",
        "checked",
        "onChange",
        "onClick"
    ]);
    const { getPrefixCls: getPrefixCls, tag: tag } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const handleClick = (e)=>{
        onChange === null || onChange === void 0 || onChange(!checked);
        onClick === null || onClick === void 0 || onClick(e);
    };
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $bd814ea00a1f65a8$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-checkable`, {
        [`${prefixCls}-checkable-checked`]: checked
    }, tag === null || tag === void 0 ? void 0 : tag.className, className, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("span", Object.assign({}, restProps, {
        ref: ref,
        style: Object.assign(Object.assign({}, style), tag === null || tag === void 0 ? void 0 : tag.style),
        className: cls,
        onClick: handleClick
    })));
});
var $8aa648d8fa6484b7$export$2e2bcd8739ae039 = $8aa648d8fa6484b7$var$CheckableTag;



// Style as status component


// ============================== Preset ==============================
const $1261c8cdaed9abdc$var$genPresetStyle = (token)=>(0, $69386722b4e8be32$export$2e2bcd8739ae039)(token, (colorKey, { textColor: textColor, lightBorderColor: lightBorderColor, lightColor: lightColor, darkColor: darkColor })=>({
            [`${token.componentCls}${token.componentCls}-${colorKey}`]: {
                color: textColor,
                background: lightColor,
                borderColor: lightBorderColor,
                // Inverse color
                '&-inverse': {
                    color: token.colorTextLightSolid,
                    background: darkColor,
                    borderColor: darkColor
                },
                [`&${token.componentCls}-borderless`]: {
                    borderColor: 'transparent'
                }
            }
        }));
var // ============================== Export ==============================
$1261c8cdaed9abdc$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$1537386bc155ea56)([
    'Tag',
    'preset'
], (token)=>{
    const tagToken = (0, $bd814ea00a1f65a8$export$362fb92a8f81bbf9)(token);
    return $1261c8cdaed9abdc$var$genPresetStyle(tagToken);
}, (0, $bd814ea00a1f65a8$export$9ca1be8807fe0675));



function $95190870cfa49bfc$export$2e2bcd8739ae039(str) {
    if (typeof str !== 'string') return str;
    const ret = str.charAt(0).toUpperCase() + str.slice(1);
    return ret;
}



const $11969e51a90dd42b$var$genTagStatusStyle = (token, status, cssVariableType)=>{
    const capitalizedCssVariableType = (0, $95190870cfa49bfc$export$2e2bcd8739ae039)(cssVariableType);
    return {
        [`${token.componentCls}${token.componentCls}-${status}`]: {
            color: token[`color${cssVariableType}`],
            background: token[`color${capitalizedCssVariableType}Bg`],
            borderColor: token[`color${capitalizedCssVariableType}Border`],
            [`&${token.componentCls}-borderless`]: {
                borderColor: 'transparent'
            }
        }
    };
};
var // ============================== Export ==============================
$11969e51a90dd42b$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$1537386bc155ea56)([
    'Tag',
    'status'
], (token)=>{
    const tagToken = (0, $bd814ea00a1f65a8$export$362fb92a8f81bbf9)(token);
    return [
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, 'success', 'Success'),
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, 'processing', 'Info'),
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, 'error', 'Error'),
        $11969e51a90dd42b$var$genTagStatusStyle(tagToken, 'warning', 'Warning')
    ];
}, (0, $bd814ea00a1f65a8$export$9ca1be8807fe0675));


"use client";
var $91f0876852f6510f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $91f0876852f6510f$var$InternalTag = /*#__PURE__*/ $acw62.forwardRef((tagProps, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, children: children, icon: icon, color: color, onClose: onClose, bordered: bordered = true, visible: deprecatedVisible } = tagProps, props = $91f0876852f6510f$var$__rest(tagProps, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "children",
        "icon",
        "color",
        "onClose",
        "bordered",
        "visible"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, tag: tagContext } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [visible, setVisible] = $acw62.useState(true);
    const domProps = (0, $57c22a5a2f343bca$export$2e2bcd8739ae039)(props, [
        'closeIcon',
        'closable'
    ]);
    $acw62.useEffect(()=>{
        if (deprecatedVisible !== undefined) setVisible(deprecatedVisible);
    }, [
        deprecatedVisible
    ]);
    const isPreset = (0, $1513ceb924eda9b6$export$ee62ebd6a58c4884)(color);
    const isStatus = (0, $1513ceb924eda9b6$export$88a0ba1f7d1ea40e)(color);
    const isInternalColor = isPreset || isStatus;
    const tagStyle = Object.assign(Object.assign({
        backgroundColor: color && !isInternalColor ? color : undefined
    }, tagContext === null || tagContext === void 0 ? void 0 : tagContext.style), style);
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $bd814ea00a1f65a8$export$2e2bcd8739ae039)(prefixCls);
    // Style
    const tagClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, tagContext === null || tagContext === void 0 ? void 0 : tagContext.className, {
        [`${prefixCls}-${color}`]: isInternalColor,
        [`${prefixCls}-has-color`]: color && !isInternalColor,
        [`${prefixCls}-hidden`]: !visible,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-borderless`]: !bordered
    }, className, rootClassName, hashId, cssVarCls);
    const handleCloseClick = (e)=>{
        e.stopPropagation();
        onClose === null || onClose === void 0 || onClose(e);
        if (e.defaultPrevented) return;
        setVisible(false);
    };
    const [, mergedCloseIcon] = (0, $91e86e8e8e97dd3f$export$2e2bcd8739ae039)((0, $91e86e8e8e97dd3f$export$51ad9c30389f050b)(tagProps), (0, $91e86e8e8e97dd3f$export$51ad9c30389f050b)(tagContext), {
        closable: false,
        closeIconRender: (iconNode)=>{
            const replacement = /*#__PURE__*/ $acw62.createElement("span", {
                className: `${prefixCls}-close-icon`,
                onClick: handleCloseClick
            }, iconNode);
            return (0, $30796c32f374b477$export$2dfe578f95754f6a)(iconNode, replacement, (originProps)=>({
                    onClick: (e)=>{
                        var _a;
                        (_a = originProps === null || originProps === void 0 ? void 0 : originProps.onClick) === null || _a === void 0 || _a.call(originProps, e);
                        handleCloseClick(e);
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(originProps === null || originProps === void 0 ? void 0 : originProps.className, `${prefixCls}-close-icon`)
                }));
        }
    });
    const isNeedWave = typeof props.onClick === 'function' || children && children.type === 'a';
    const iconNode = icon || null;
    const kids = iconNode ? /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, iconNode, children && /*#__PURE__*/ $acw62.createElement("span", null, children)) : children;
    const tagNode = /*#__PURE__*/ $acw62.createElement("span", Object.assign({}, domProps, {
        ref: ref,
        className: tagClassName,
        style: tagStyle
    }), kids, mergedCloseIcon, isPreset && /*#__PURE__*/ $acw62.createElement((0, $1261c8cdaed9abdc$export$2e2bcd8739ae039), {
        key: "preset",
        prefixCls: prefixCls
    }), isStatus && /*#__PURE__*/ $acw62.createElement((0, $11969e51a90dd42b$export$2e2bcd8739ae039), {
        key: "status",
        prefixCls: prefixCls
    }));
    return wrapCSSVar(isNeedWave ? /*#__PURE__*/ $acw62.createElement((0, $37e027257ee01609$export$2e2bcd8739ae039), {
        component: "Tag"
    }, tagNode) : tagNode);
});
const $91f0876852f6510f$var$Tag = $91f0876852f6510f$var$InternalTag;
$91f0876852f6510f$var$Tag.CheckableTag = (0, $8aa648d8fa6484b7$export$2e2bcd8739ae039);
var $91f0876852f6510f$export$2e2bcd8739ae039 = $91f0876852f6510f$var$Tag;




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
class $f52fa34d4fef2d39$var$SdkExtension {
    enabled = true;
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
}
var $f52fa34d4fef2d39$export$2e2bcd8739ae039 = $f52fa34d4fef2d39$var$SdkExtension;


var $f3b7c43a7f0c8e85$exports = {};



/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    'use strict';
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if ($f3b7c43a7f0c8e85$exports) // Node
    $f3b7c43a7f0c8e85$exports = factory((parcelRequire("3hCk4")), (parcelRequire("2Nl4L")), (parcelRequire("3PMOQ")));
    else if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([
        './punycode',
        './IPv6',
        './SecondLevelDomains'
    ], factory);
    else // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
})($f3b7c43a7f0c8e85$exports, function(punycode, IPv6, SLD, root) {
    'use strict';
    /*global location, escape, unescape */ // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
    /*jshint camelcase: false */ // save current URI variable, if any
    var _URI = root && root.URI;
    function URI(url, base) {
        var _urlSupplied = arguments.length >= 1;
        var _baseSupplied = arguments.length >= 2;
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof URI)) {
            if (_urlSupplied) {
                if (_baseSupplied) return new URI(url, base);
                return new URI(url);
            }
            return new URI();
        }
        if (url === undefined) {
            if (_urlSupplied) throw new TypeError('undefined is not a valid argument for URI');
            if (typeof location !== 'undefined') url = location.href + '';
            else url = '';
        }
        if (url === null) {
            if (_urlSupplied) throw new TypeError('null is not a valid argument for URI');
        }
        this.href(url);
        // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
        if (base !== undefined) return this.absoluteTo(base);
        return this;
    }
    function isInteger(value) {
        return /^[0-9]+$/.test(value);
    }
    URI.version = '1.19.11';
    var p = URI.prototype;
    var hasOwn = Object.prototype.hasOwnProperty;
    function escapeRegEx(string) {
        // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
        return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    }
    function getType(value) {
        // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
        if (value === undefined) return 'Undefined';
        return String(Object.prototype.toString.call(value)).slice(8, -1);
    }
    function isArray(obj) {
        return getType(obj) === 'Array';
    }
    function filterArrayValues(data, value) {
        var lookup = {};
        var i, length;
        if (getType(value) === 'RegExp') lookup = null;
        else if (isArray(value)) for(i = 0, length = value.length; i < length; i++)lookup[value[i]] = true;
        else lookup[value] = true;
        for(i = 0, length = data.length; i < length; i++){
            /*jshint laxbreak: true */ var _match = lookup && lookup[data[i]] !== undefined || !lookup && value.test(data[i]);
            /*jshint laxbreak: false */ if (_match) {
                data.splice(i, 1);
                length--;
                i--;
            }
        }
        return data;
    }
    function arrayContains(list, value) {
        var i, length;
        // value may be string, number, array, regexp
        if (isArray(value)) {
            // Note: this can be optimized to O(n) (instead of current O(m * n))
            for(i = 0, length = value.length; i < length; i++){
                if (!arrayContains(list, value[i])) return false;
            }
            return true;
        }
        var _type = getType(value);
        for(i = 0, length = list.length; i < length; i++){
            if (_type === 'RegExp') {
                if (typeof list[i] === 'string' && list[i].match(value)) return true;
            } else if (list[i] === value) return true;
        }
        return false;
    }
    function arraysEqual(one, two) {
        if (!isArray(one) || !isArray(two)) return false;
        // arrays can't be equal if they have different amount of content
        if (one.length !== two.length) return false;
        one.sort();
        two.sort();
        for(var i = 0, l = one.length; i < l; i++){
            if (one[i] !== two[i]) return false;
        }
        return true;
    }
    function trimSlashes(text) {
        var trim_expression = /^\/+|\/+$/g;
        return text.replace(trim_expression, '');
    }
    URI._parts = function() {
        return {
            protocol: null,
            username: null,
            password: null,
            hostname: null,
            urn: null,
            port: null,
            path: null,
            query: null,
            fragment: null,
            // state
            preventInvalidHostname: URI.preventInvalidHostname,
            duplicateQueryParameters: URI.duplicateQueryParameters,
            escapeQuerySpace: URI.escapeQuerySpace
        };
    };
    // state: throw on invalid hostname
    // see https://github.com/medialize/URI.js/pull/345
    // and https://github.com/medialize/URI.js/issues/354
    URI.preventInvalidHostname = false;
    // state: allow duplicate query parameters (a=1&a=1)
    URI.duplicateQueryParameters = false;
    // state: replaces + with %20 (space in query strings)
    URI.escapeQuerySpace = true;
    // static properties
    URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
    URI.idn_expression = /[^a-z0-9\._-]/i;
    URI.punycode_expression = /(xn--)/i;
    // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
    URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
    // credits to Rich Brown
    // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
    // specification: http://www.ietf.org/rfc/rfc4291.txt
    URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
    // expression used is "gruber revised" (@gruber v2) determined to be the
    // best solution in a regex-golf we did a couple of ages ago at
    // * http://mathiasbynens.be/demo/url-regex
    // * http://rodneyrehm.de/t/url-regex.html
    URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
    URI.findUri = {
        // valid "scheme://" or "www."
        start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
        // everything up to the next whitespace
        end: /[\s\r\n]|$/,
        // trim trailing punctuation captured by end RegExp
        trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
        // balanced parens inclusion (), [], {}, <>
        parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
    };
    URI.leading_whitespace_expression = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/;
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    URI.ascii_tab_whitespace = /[\u0009\u000A\u000D]+/g;
    // http://www.iana.org/assignments/uri-schemes.html
    // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
    URI.defaultPorts = {
        http: '80',
        https: '443',
        ftp: '21',
        gopher: '70',
        ws: '80',
        wss: '443'
    };
    // list of protocols which always require a hostname
    URI.hostProtocols = [
        'http',
        'https'
    ];
    // allowed hostname characters according to RFC 3986
    // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
    // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
    URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
    // map DOM Elements to their URI attribute
    URI.domAttributes = {
        'a': 'href',
        'blockquote': 'cite',
        'link': 'href',
        'base': 'href',
        'script': 'src',
        'form': 'action',
        'img': 'src',
        'area': 'href',
        'iframe': 'src',
        'embed': 'src',
        'source': 'src',
        'track': 'src',
        'input': 'src',
        'audio': 'src',
        'video': 'src'
    };
    URI.getDomAttribute = function(node) {
        if (!node || !node.nodeName) return undefined;
        var nodeName = node.nodeName.toLowerCase();
        // <input> should only expose src for type="image"
        if (nodeName === 'input' && node.type !== 'image') return undefined;
        return URI.domAttributes[nodeName];
    };
    function escapeForDumbFirefox36(value) {
        // https://github.com/medialize/URI.js/issues/91
        return escape(value);
    }
    // encoding / decoding according to RFC3986
    function strictEncodeURIComponent(string) {
        // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
        return encodeURIComponent(string).replace(/[!'()*]/g, escapeForDumbFirefox36).replace(/\*/g, '%2A');
    }
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
    URI.iso8859 = function() {
        URI.encode = escape;
        URI.decode = unescape;
    };
    URI.unicode = function() {
        URI.encode = strictEncodeURIComponent;
        URI.decode = decodeURIComponent;
    };
    URI.characters = {
        pathname: {
            encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
                map: {
                    // -._~!'()*
                    '%24': '$',
                    '%26': '&',
                    '%2B': '+',
                    '%2C': ',',
                    '%3B': ';',
                    '%3D': '=',
                    '%3A': ':',
                    '%40': '@'
                }
            },
            decode: {
                expression: /[\/\?#]/g,
                map: {
                    '/': '%2F',
                    '?': '%3F',
                    '#': '%23'
                }
            }
        },
        reserved: {
            encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
                map: {
                    // gen-delims
                    '%3A': ':',
                    '%2F': '/',
                    '%3F': '?',
                    '%23': '#',
                    '%5B': '[',
                    '%5D': ']',
                    '%40': '@',
                    // sub-delims
                    '%21': '!',
                    '%24': '$',
                    '%26': '&',
                    '%27': '\'',
                    '%28': '(',
                    '%29': ')',
                    '%2A': '*',
                    '%2B': '+',
                    '%2C': ',',
                    '%3B': ';',
                    '%3D': '='
                }
            }
        },
        urnpath: {
            // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
            // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
            // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
            // note that the colon character is not featured in the encoding map; this is because URI.js
            // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
            // should not appear unencoded in a segment itself.
            // See also the note above about RFC3986 and capitalalized hex digits.
            encode: {
                expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
                map: {
                    '%21': '!',
                    '%24': '$',
                    '%27': '\'',
                    '%28': '(',
                    '%29': ')',
                    '%2A': '*',
                    '%2B': '+',
                    '%2C': ',',
                    '%3B': ';',
                    '%3D': '=',
                    '%40': '@'
                }
            },
            // These characters are the characters called out by RFC2141 as "reserved" characters that
            // should never appear in a URN, plus the colon character (see note above).
            decode: {
                expression: /[\/\?#:]/g,
                map: {
                    '/': '%2F',
                    '?': '%3F',
                    '#': '%23',
                    ':': '%3A'
                }
            }
        }
    };
    URI.encodeQuery = function(string, escapeQuerySpace) {
        var escaped = URI.encode(string + '');
        if (escapeQuerySpace === undefined) escapeQuerySpace = URI.escapeQuerySpace;
        return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
    };
    URI.decodeQuery = function(string, escapeQuerySpace) {
        string += '';
        if (escapeQuerySpace === undefined) escapeQuerySpace = URI.escapeQuerySpace;
        try {
            return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
        } catch (e) {
            // we're not going to mess with weird encodings,
            // give up and return the undecoded original string
            // see https://github.com/medialize/URI.js/issues/87
            // see https://github.com/medialize/URI.js/issues/92
            return string;
        }
    };
    // generate encode/decode path functions
    var _parts = {
        'encode': 'encode',
        'decode': 'decode'
    };
    var _part;
    var generateAccessor = function(_group, _part) {
        return function(string) {
            try {
                return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
                    return URI.characters[_group][_part].map[c];
                });
            } catch (e) {
                // we're not going to mess with weird encodings,
                // give up and return the undecoded original string
                // see https://github.com/medialize/URI.js/issues/87
                // see https://github.com/medialize/URI.js/issues/92
                return string;
            }
        };
    };
    for(_part in _parts){
        URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
        URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
    }
    var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
        return function(string) {
            // Why pass in names of functions, rather than the function objects themselves? The
            // definitions of some functions (but in particular, URI.decode) will occasionally change due
            // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
            // that the functions we use here are "fresh".
            var actualCodingFunc;
            if (!_innerCodingFuncName) actualCodingFunc = URI[_codingFuncName];
            else actualCodingFunc = function(string) {
                return URI[_codingFuncName](URI[_innerCodingFuncName](string));
            };
            var segments = (string + '').split(_sep);
            for(var i = 0, length = segments.length; i < length; i++)segments[i] = actualCodingFunc(segments[i]);
            return segments.join(_sep);
        };
    };
    // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
    URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
    URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
    URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
    URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');
    URI.encodeReserved = generateAccessor('reserved', 'encode');
    URI.parse = function(string, parts) {
        var pos;
        if (!parts) parts = {
            preventInvalidHostname: URI.preventInvalidHostname
        };
        string = string.replace(URI.leading_whitespace_expression, '');
        // https://infra.spec.whatwg.org/#ascii-tab-or-newline
        string = string.replace(URI.ascii_tab_whitespace, '');
        // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]
        // extract fragment
        pos = string.indexOf('#');
        if (pos > -1) {
            // escaping?
            parts.fragment = string.substring(pos + 1) || null;
            string = string.substring(0, pos);
        }
        // extract query
        pos = string.indexOf('?');
        if (pos > -1) {
            // escaping?
            parts.query = string.substring(pos + 1) || null;
            string = string.substring(0, pos);
        }
        // slashes and backslashes have lost all meaning for the web protocols (https, http, wss, ws)
        string = string.replace(/^(https?|ftp|wss?)?:+[/\\]*/i, '$1://');
        // slashes and backslashes have lost all meaning for scheme relative URLs
        string = string.replace(/^[/\\]{2,}/i, '//');
        // extract protocol
        if (string.substring(0, 2) === '//') {
            // relative-scheme
            parts.protocol = null;
            string = string.substring(2);
            // extract "user:pass@host:port"
            string = URI.parseAuthority(string, parts);
        } else {
            pos = string.indexOf(':');
            if (pos > -1) {
                parts.protocol = string.substring(0, pos) || null;
                if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) // : may be within the path
                parts.protocol = undefined;
                else if (string.substring(pos + 1, pos + 3).replace(/\\/g, '/') === '//') {
                    string = string.substring(pos + 3);
                    // extract "user:pass@host:port"
                    string = URI.parseAuthority(string, parts);
                } else {
                    string = string.substring(pos + 1);
                    parts.urn = true;
                }
            }
        }
        // what's left must be the path
        parts.path = string;
        // and we're done
        return parts;
    };
    URI.parseHost = function(string, parts) {
        if (!string) string = '';
        // Copy chrome, IE, opera backslash-handling behavior.
        // Back slashes before the query string get converted to forward slashes
        // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
        // See: https://code.google.com/p/chromium/issues/detail?id=25916
        // https://github.com/medialize/URI.js/pull/233
        string = string.replace(/\\/g, '/');
        // extract host:port
        var pos = string.indexOf('/');
        var bracketPos;
        var t;
        if (pos === -1) pos = string.length;
        if (string.charAt(0) === '[') {
            // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
            // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
            // IPv6+port in the format [2001:db8::1]:80 (for the time being)
            bracketPos = string.indexOf(']');
            parts.hostname = string.substring(1, bracketPos) || null;
            parts.port = string.substring(bracketPos + 2, pos) || null;
            if (parts.port === '/') parts.port = null;
        } else {
            var firstColon = string.indexOf(':');
            var firstSlash = string.indexOf('/');
            var nextColon = string.indexOf(':', firstColon + 1);
            if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
                // IPv6 host contains multiple colons - but no port
                // this notation is actually not allowed by RFC 3986, but we're a liberal parser
                parts.hostname = string.substring(0, pos) || null;
                parts.port = null;
            } else {
                t = string.substring(0, pos).split(':');
                parts.hostname = t[0] || null;
                parts.port = t[1] || null;
            }
        }
        if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
            pos++;
            string = '/' + string;
        }
        if (parts.preventInvalidHostname) URI.ensureValidHostname(parts.hostname, parts.protocol);
        if (parts.port) URI.ensureValidPort(parts.port);
        return string.substring(pos) || '/';
    };
    URI.parseAuthority = function(string, parts) {
        string = URI.parseUserinfo(string, parts);
        return URI.parseHost(string, parts);
    };
    URI.parseUserinfo = function(string, parts) {
        // extract username:password
        var _string = string;
        var firstBackSlash = string.indexOf('\\');
        if (firstBackSlash !== -1) string = string.replace(/\\/g, '/');
        var firstSlash = string.indexOf('/');
        var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
        var t;
        // authority@ must come before /path or \path
        if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
            t = string.substring(0, pos).split(':');
            parts.username = t[0] ? URI.decode(t[0]) : null;
            t.shift();
            parts.password = t[0] ? URI.decode(t.join(':')) : null;
            string = _string.substring(pos + 1);
        } else {
            parts.username = null;
            parts.password = null;
        }
        return string;
    };
    URI.parseQuery = function(string, escapeQuerySpace) {
        if (!string) return {};
        // throw out the funky business - "?"[name"="value"&"]+
        string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');
        if (!string) return {};
        var items = {};
        var splits = string.split('&');
        var length = splits.length;
        var v, name, value;
        for(var i = 0; i < length; i++){
            v = splits[i].split('=');
            name = URI.decodeQuery(v.shift(), escapeQuerySpace);
            // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
            value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;
            if (name === '__proto__') continue;
            else if (hasOwn.call(items, name)) {
                if (typeof items[name] === 'string' || items[name] === null) items[name] = [
                    items[name]
                ];
                items[name].push(value);
            } else items[name] = value;
        }
        return items;
    };
    URI.build = function(parts) {
        var t = '';
        var requireAbsolutePath = false;
        if (parts.protocol) t += parts.protocol + ':';
        if (!parts.urn && (t || parts.hostname)) {
            t += '//';
            requireAbsolutePath = true;
        }
        t += URI.buildAuthority(parts) || '';
        if (typeof parts.path === 'string') {
            if (parts.path.charAt(0) !== '/' && requireAbsolutePath) t += '/';
            t += parts.path;
        }
        if (typeof parts.query === 'string' && parts.query) t += '?' + parts.query;
        if (typeof parts.fragment === 'string' && parts.fragment) t += '#' + parts.fragment;
        return t;
    };
    URI.buildHost = function(parts) {
        var t = '';
        if (!parts.hostname) return '';
        else if (URI.ip6_expression.test(parts.hostname)) t += '[' + parts.hostname + ']';
        else t += parts.hostname;
        if (parts.port) t += ':' + parts.port;
        return t;
    };
    URI.buildAuthority = function(parts) {
        return URI.buildUserinfo(parts) + URI.buildHost(parts);
    };
    URI.buildUserinfo = function(parts) {
        var t = '';
        if (parts.username) t += URI.encode(parts.username);
        if (parts.password) t += ':' + URI.encode(parts.password);
        if (t) t += '@';
        return t;
    };
    URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
        // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
        // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
        // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
        // URI.js treats the query string as being application/x-www-form-urlencoded
        // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type
        var t = '';
        var unique, key, i, length;
        for(key in data){
            if (key === '__proto__') continue;
            else if (hasOwn.call(data, key)) {
                if (isArray(data[key])) {
                    unique = {};
                    for(i = 0, length = data[key].length; i < length; i++)if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
                        t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
                        if (duplicateQueryParameters !== true) unique[data[key][i] + ''] = true;
                    }
                } else if (data[key] !== undefined) t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
            }
        }
        return t.substring(1);
    };
    URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
        // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
        // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
        return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
    };
    URI.addQuery = function(data, name, value) {
        if (typeof name === 'object') {
            for(var key in name)if (hasOwn.call(name, key)) URI.addQuery(data, key, name[key]);
        } else if (typeof name === 'string') {
            if (data[name] === undefined) {
                data[name] = value;
                return;
            } else if (typeof data[name] === 'string') data[name] = [
                data[name]
            ];
            if (!isArray(value)) value = [
                value
            ];
            data[name] = (data[name] || []).concat(value);
        } else throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    };
    URI.setQuery = function(data, name, value) {
        if (typeof name === 'object') {
            for(var key in name)if (hasOwn.call(name, key)) URI.setQuery(data, key, name[key]);
        } else if (typeof name === 'string') data[name] = value === undefined ? null : value;
        else throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
    };
    URI.removeQuery = function(data, name, value) {
        var i, length, key;
        if (isArray(name)) for(i = 0, length = name.length; i < length; i++)data[name[i]] = undefined;
        else if (getType(name) === 'RegExp') {
            for(key in data)if (name.test(key)) data[key] = undefined;
        } else if (typeof name === 'object') {
            for(key in name)if (hasOwn.call(name, key)) URI.removeQuery(data, key, name[key]);
        } else if (typeof name === 'string') {
            if (value !== undefined) {
                if (getType(value) === 'RegExp') {
                    if (!isArray(data[name]) && value.test(data[name])) data[name] = undefined;
                    else data[name] = filterArrayValues(data[name], value);
                } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) data[name] = undefined;
                else if (isArray(data[name])) data[name] = filterArrayValues(data[name], value);
            } else data[name] = undefined;
        } else throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
    };
    URI.hasQuery = function(data, name, value, withinArray) {
        switch(getType(name)){
            case 'String':
                break;
            case 'RegExp':
                for(var key in data)if (hasOwn.call(data, key)) {
                    if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) return true;
                }
                return false;
            case 'Object':
                for(var _key in name)if (hasOwn.call(name, _key)) {
                    if (!URI.hasQuery(data, _key, name[_key])) return false;
                }
                return true;
            default:
                throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
        }
        switch(getType(value)){
            case 'Undefined':
                // true if exists (but may be empty)
                return name in data; // data[name] !== undefined;
            case 'Boolean':
                // true if exists and non-empty
                var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
                return value === _booly;
            case 'Function':
                // allow complex comparison
                return !!value(data[name], name, data);
            case 'Array':
                if (!isArray(data[name])) return false;
                var op = withinArray ? arrayContains : arraysEqual;
                return op(data[name], value);
            case 'RegExp':
                if (!isArray(data[name])) return Boolean(data[name] && data[name].match(value));
                if (!withinArray) return false;
                return arrayContains(data[name], value);
            case 'Number':
                value = String(value);
            /* falls through */ case 'String':
                if (!isArray(data[name])) return data[name] === value;
                if (!withinArray) return false;
                return arrayContains(data[name], value);
            default:
                throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
        }
    };
    URI.joinPaths = function() {
        var input = [];
        var segments = [];
        var nonEmptySegments = 0;
        for(var i = 0; i < arguments.length; i++){
            var url = new URI(arguments[i]);
            input.push(url);
            var _segments = url.segment();
            for(var s = 0; s < _segments.length; s++){
                if (typeof _segments[s] === 'string') segments.push(_segments[s]);
                if (_segments[s]) nonEmptySegments++;
            }
        }
        if (!segments.length || !nonEmptySegments) return new URI('');
        var uri = new URI('').segment(segments);
        if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') uri.path('/' + uri.path());
        return uri.normalize();
    };
    URI.commonPath = function(one, two) {
        var length = Math.min(one.length, two.length);
        var pos;
        // find first non-matching character
        for(pos = 0; pos < length; pos++)if (one.charAt(pos) !== two.charAt(pos)) {
            pos--;
            break;
        }
        if (pos < 1) return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
        // revert to last /
        if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') pos = one.substring(0, pos).lastIndexOf('/');
        return one.substring(0, pos + 1);
    };
    URI.withinString = function(string, callback, options) {
        options || (options = {});
        var _start = options.start || URI.findUri.start;
        var _end = options.end || URI.findUri.end;
        var _trim = options.trim || URI.findUri.trim;
        var _parens = options.parens || URI.findUri.parens;
        var _attributeOpen = /[a-z0-9-]=["']?$/i;
        _start.lastIndex = 0;
        while(true){
            var match = _start.exec(string);
            if (!match) break;
            var start = match.index;
            if (options.ignoreHtml) {
                // attribut(e=["']?$)
                var attributeOpen = string.slice(Math.max(start - 3, 0), start);
                if (attributeOpen && _attributeOpen.test(attributeOpen)) continue;
            }
            var end = start + string.slice(start).search(_end);
            var slice = string.slice(start, end);
            // make sure we include well balanced parens
            var parensEnd = -1;
            while(true){
                var parensMatch = _parens.exec(slice);
                if (!parensMatch) break;
                var parensMatchEnd = parensMatch.index + parensMatch[0].length;
                parensEnd = Math.max(parensEnd, parensMatchEnd);
            }
            if (parensEnd > -1) slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
            else slice = slice.replace(_trim, '');
            if (slice.length <= match[0].length) continue;
            if (options.ignore && options.ignore.test(slice)) continue;
            end = start + slice.length;
            var result = callback(slice, start, end, string);
            if (result === undefined) {
                _start.lastIndex = end;
                continue;
            }
            result = String(result);
            string = string.slice(0, start) + result + string.slice(end);
            _start.lastIndex = start + result.length;
        }
        _start.lastIndex = 0;
        return string;
    };
    URI.ensureValidHostname = function(v, protocol) {
        // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
        // they are not part of DNS and therefore ignored by URI.js
        var hasHostname = !!v; // not null and not an empty string
        var hasProtocol = !!protocol;
        var rejectEmptyHostname = false;
        if (hasProtocol) rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
        if (rejectEmptyHostname && !hasHostname) throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
        else if (v && v.match(URI.invalid_hostname_characters)) {
            // test punycode
            if (!punycode) throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
            if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
        }
    };
    URI.ensureValidPort = function(v) {
        if (!v) return;
        var port = Number(v);
        if (isInteger(port) && port > 0 && port < 65536) return;
        throw new TypeError('Port "' + v + '" is not a valid port');
    };
    // noConflict
    URI.noConflict = function(removeAll) {
        if (removeAll) {
            var unconflicted = {
                URI: this.noConflict()
            };
            if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') unconflicted.URITemplate = root.URITemplate.noConflict();
            if (root.IPv6 && typeof root.IPv6.noConflict === 'function') unconflicted.IPv6 = root.IPv6.noConflict();
            if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
            return unconflicted;
        } else if (root.URI === this) root.URI = _URI;
        return this;
    };
    p.build = function(deferBuild) {
        if (deferBuild === true) this._deferred_build = true;
        else if (deferBuild === undefined || this._deferred_build) {
            this._string = URI.build(this._parts);
            this._deferred_build = false;
        }
        return this;
    };
    p.clone = function() {
        return new URI(this);
    };
    p.valueOf = p.toString = function() {
        return this.build(false)._string;
    };
    function generateSimpleAccessor(_part) {
        return function(v, build) {
            if (v === undefined) return this._parts[_part] || '';
            else {
                this._parts[_part] = v || null;
                this.build(!build);
                return this;
            }
        };
    }
    function generatePrefixAccessor(_part, _key) {
        return function(v, build) {
            if (v === undefined) return this._parts[_part] || '';
            else {
                if (v !== null) {
                    v = v + '';
                    if (v.charAt(0) === _key) v = v.substring(1);
                }
                this._parts[_part] = v;
                this.build(!build);
                return this;
            }
        };
    }
    p.protocol = generateSimpleAccessor('protocol');
    p.username = generateSimpleAccessor('username');
    p.password = generateSimpleAccessor('password');
    p.hostname = generateSimpleAccessor('hostname');
    p.port = generateSimpleAccessor('port');
    p.query = generatePrefixAccessor('query', '?');
    p.fragment = generatePrefixAccessor('fragment', '#');
    p.search = function(v, build) {
        var t = this.query(v, build);
        return typeof t === 'string' && t.length ? '?' + t : t;
    };
    p.hash = function(v, build) {
        var t = this.fragment(v, build);
        return typeof t === 'string' && t.length ? '#' + t : t;
    };
    p.pathname = function(v, build) {
        if (v === undefined || v === true) {
            var res = this._parts.path || (this._parts.hostname ? '/' : '');
            return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
        } else {
            if (this._parts.urn) this._parts.path = v ? URI.recodeUrnPath(v) : '';
            else this._parts.path = v ? URI.recodePath(v) : '/';
            this.build(!build);
            return this;
        }
    };
    p.path = p.pathname;
    p.href = function(href, build) {
        var key;
        if (href === undefined) return this.toString();
        this._string = '';
        this._parts = URI._parts();
        var _URI = href instanceof URI;
        var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
        if (href.nodeName) {
            var attribute = URI.getDomAttribute(href);
            href = href[attribute] || '';
            _object = false;
        }
        // window.location is reported to be an object, but it's not the sort
        // of object we're looking for:
        // * location.protocol ends with a colon
        // * location.query != object.search
        // * location.hash != object.fragment
        // simply serializing the unknown object should do the trick
        // (for location, not for everything...)
        if (!_URI && _object && href.pathname !== undefined) href = href.toString();
        if (typeof href === 'string' || href instanceof String) this._parts = URI.parse(String(href), this._parts);
        else if (_URI || _object) {
            var src = _URI ? href._parts : href;
            for(key in src){
                if (key === 'query') continue;
                if (hasOwn.call(this._parts, key)) this._parts[key] = src[key];
            }
            if (src.query) this.query(src.query, false);
        } else throw new TypeError('invalid input');
        this.build(!build);
        return this;
    };
    // identification accessors
    p.is = function(what) {
        var ip = false;
        var ip4 = false;
        var ip6 = false;
        var name = false;
        var sld = false;
        var idn = false;
        var punycode = false;
        var relative = !this._parts.urn;
        if (this._parts.hostname) {
            relative = false;
            ip4 = URI.ip4_expression.test(this._parts.hostname);
            ip6 = URI.ip6_expression.test(this._parts.hostname);
            ip = ip4 || ip6;
            name = !ip;
            sld = name && SLD && SLD.has(this._parts.hostname);
            idn = name && URI.idn_expression.test(this._parts.hostname);
            punycode = name && URI.punycode_expression.test(this._parts.hostname);
        }
        switch(what.toLowerCase()){
            case 'relative':
                return relative;
            case 'absolute':
                return !relative;
            // hostname identification
            case 'domain':
            case 'name':
                return name;
            case 'sld':
                return sld;
            case 'ip':
                return ip;
            case 'ip4':
            case 'ipv4':
            case 'inet4':
                return ip4;
            case 'ip6':
            case 'ipv6':
            case 'inet6':
                return ip6;
            case 'idn':
                return idn;
            case 'url':
                return !this._parts.urn;
            case 'urn':
                return !!this._parts.urn;
            case 'punycode':
                return punycode;
        }
        return null;
    };
    // component specific input validation
    var _protocol = p.protocol;
    var _port = p.port;
    var _hostname = p.hostname;
    p.protocol = function(v, build) {
        if (v) {
            // accept trailing ://
            v = v.replace(/:(\/\/)?$/, '');
            if (!v.match(URI.protocol_expression)) throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
        }
        return _protocol.call(this, v, build);
    };
    p.scheme = p.protocol;
    p.port = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v !== undefined) {
            if (v === 0) v = null;
            if (v) {
                v += '';
                if (v.charAt(0) === ':') v = v.substring(1);
                URI.ensureValidPort(v);
            }
        }
        return _port.call(this, v, build);
    };
    p.hostname = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v !== undefined) {
            var x = {
                preventInvalidHostname: this._parts.preventInvalidHostname
            };
            var res = URI.parseHost(v, x);
            if (res !== '/') throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            v = x.hostname;
            if (this._parts.preventInvalidHostname) URI.ensureValidHostname(v, this._parts.protocol);
        }
        return _hostname.call(this, v, build);
    };
    // compound accessors
    p.origin = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined) {
            var protocol = this.protocol();
            var authority = this.authority();
            if (!authority) return '';
            return (protocol ? protocol + '://' : '') + this.authority();
        } else {
            var origin = URI(v);
            this.protocol(origin.protocol()).authority(origin.authority()).build(!build);
            return this;
        }
    };
    p.host = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined) return this._parts.hostname ? URI.buildHost(this._parts) : '';
        else {
            var res = URI.parseHost(v, this._parts);
            if (res !== '/') throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            this.build(!build);
            return this;
        }
    };
    p.authority = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined) return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
        else {
            var res = URI.parseAuthority(v, this._parts);
            if (res !== '/') throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            this.build(!build);
            return this;
        }
    };
    p.userinfo = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined) {
            var t = URI.buildUserinfo(this._parts);
            return t ? t.substring(0, t.length - 1) : t;
        } else {
            if (v[v.length - 1] !== '@') v += '@';
            URI.parseUserinfo(v, this._parts);
            this.build(!build);
            return this;
        }
    };
    p.resource = function(v, build) {
        var parts;
        if (v === undefined) return this.path() + this.search() + this.hash();
        parts = URI.parse(v);
        this._parts.path = parts.path;
        this._parts.query = parts.query;
        this._parts.fragment = parts.fragment;
        this.build(!build);
        return this;
    };
    // fraction accessors
    p.subdomain = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        // convenience, return "www" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is('IP')) return '';
            // grab domain and add another segment
            var end = this._parts.hostname.length - this.domain().length - 1;
            return this._parts.hostname.substring(0, end) || '';
        } else {
            var e = this._parts.hostname.length - this.domain().length;
            var sub = this._parts.hostname.substring(0, e);
            var replace = new RegExp('^' + escapeRegEx(sub));
            if (v && v.charAt(v.length - 1) !== '.') v += '.';
            if (v.indexOf(':') !== -1) throw new TypeError('Domains cannot contain colons');
            if (v) URI.ensureValidHostname(v, this._parts.protocol);
            this._parts.hostname = this._parts.hostname.replace(replace, v);
            this.build(!build);
            return this;
        }
    };
    p.domain = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (typeof v === 'boolean') {
            build = v;
            v = undefined;
        }
        // convenience, return "example.org" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is('IP')) return '';
            // if hostname consists of 1 or 2 segments, it must be the domain
            var t = this._parts.hostname.match(/\./g);
            if (t && t.length < 2) return this._parts.hostname;
            // grab tld and add another segment
            var end = this._parts.hostname.length - this.tld(build).length - 1;
            end = this._parts.hostname.lastIndexOf('.', end - 1) + 1;
            return this._parts.hostname.substring(end) || '';
        } else {
            if (!v) throw new TypeError('cannot set domain empty');
            if (v.indexOf(':') !== -1) throw new TypeError('Domains cannot contain colons');
            URI.ensureValidHostname(v, this._parts.protocol);
            if (!this._parts.hostname || this.is('IP')) this._parts.hostname = v;
            else {
                var replace = new RegExp(escapeRegEx(this.domain()) + '$');
                this._parts.hostname = this._parts.hostname.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.tld = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (typeof v === 'boolean') {
            build = v;
            v = undefined;
        }
        // return "org" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is('IP')) return '';
            var pos = this._parts.hostname.lastIndexOf('.');
            var tld = this._parts.hostname.substring(pos + 1);
            if (build !== true && SLD && SLD.list[tld.toLowerCase()]) return SLD.get(this._parts.hostname) || tld;
            return tld;
        } else {
            var replace;
            if (!v) throw new TypeError('cannot set TLD empty');
            else if (v.match(/[^a-zA-Z0-9-]/)) {
                if (SLD && SLD.is(v)) {
                    replace = new RegExp(escapeRegEx(this.tld()) + '$');
                    this._parts.hostname = this._parts.hostname.replace(replace, v);
                } else throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
            } else if (!this._parts.hostname || this.is('IP')) throw new ReferenceError('cannot set TLD on non-domain host');
            else {
                replace = new RegExp(escapeRegEx(this.tld()) + '$');
                this._parts.hostname = this._parts.hostname.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.directory = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined || v === true) {
            if (!this._parts.path && !this._parts.hostname) return '';
            if (this._parts.path === '/') return '/';
            var end = this._parts.path.length - this.filename().length - 1;
            var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');
            return v ? URI.decodePath(res) : res;
        } else {
            var e = this._parts.path.length - this.filename().length;
            var directory = this._parts.path.substring(0, e);
            var replace = new RegExp('^' + escapeRegEx(directory));
            // fully qualifier directories begin with a slash
            if (!this.is('relative')) {
                if (!v) v = '/';
                if (v.charAt(0) !== '/') v = '/' + v;
            }
            // directories always end with a slash
            if (v && v.charAt(v.length - 1) !== '/') v += '/';
            v = URI.recodePath(v);
            this._parts.path = this._parts.path.replace(replace, v);
            this.build(!build);
            return this;
        }
    };
    p.filename = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (typeof v !== 'string') {
            if (!this._parts.path || this._parts.path === '/') return '';
            var pos = this._parts.path.lastIndexOf('/');
            var res = this._parts.path.substring(pos + 1);
            return v ? URI.decodePathSegment(res) : res;
        } else {
            var mutatedDirectory = false;
            if (v.charAt(0) === '/') v = v.substring(1);
            if (v.match(/\.?\//)) mutatedDirectory = true;
            var replace = new RegExp(escapeRegEx(this.filename()) + '$');
            v = URI.recodePath(v);
            this._parts.path = this._parts.path.replace(replace, v);
            if (mutatedDirectory) this.normalizePath(build);
            else this.build(!build);
            return this;
        }
    };
    p.suffix = function(v, build) {
        if (this._parts.urn) return v === undefined ? '' : this;
        if (v === undefined || v === true) {
            if (!this._parts.path || this._parts.path === '/') return '';
            var filename = this.filename();
            var pos = filename.lastIndexOf('.');
            var s, res;
            if (pos === -1) return '';
            // suffix may only contain alnum characters (yup, I made this up.)
            s = filename.substring(pos + 1);
            res = /^[a-z0-9%]+$/i.test(s) ? s : '';
            return v ? URI.decodePathSegment(res) : res;
        } else {
            if (v.charAt(0) === '.') v = v.substring(1);
            var suffix = this.suffix();
            var replace;
            if (!suffix) {
                if (!v) return this;
                this._parts.path += '.' + URI.recodePath(v);
            } else if (!v) replace = new RegExp(escapeRegEx('.' + suffix) + '$');
            else replace = new RegExp(escapeRegEx(suffix) + '$');
            if (replace) {
                v = URI.recodePath(v);
                this._parts.path = this._parts.path.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.segment = function(segment, v, build) {
        var separator = this._parts.urn ? ':' : '/';
        var path = this.path();
        var absolute = path.substring(0, 1) === '/';
        var segments = path.split(separator);
        if (segment !== undefined && typeof segment !== 'number') {
            build = v;
            v = segment;
            segment = undefined;
        }
        if (segment !== undefined && typeof segment !== 'number') throw new Error('Bad segment "' + segment + '", must be 0-based integer');
        if (absolute) segments.shift();
        if (segment < 0) // allow negative indexes to address from the end
        segment = Math.max(segments.length + segment, 0);
        if (v === undefined) /*jshint laxbreak: true */ return segment === undefined ? segments : segments[segment];
        else if (segment === null || segments[segment] === undefined) {
            if (isArray(v)) {
                segments = [];
                // collapse empty elements within array
                for(var i = 0, l = v.length; i < l; i++){
                    if (!v[i].length && (!segments.length || !segments[segments.length - 1].length)) continue;
                    if (segments.length && !segments[segments.length - 1].length) segments.pop();
                    segments.push(trimSlashes(v[i]));
                }
            } else if (v || typeof v === 'string') {
                v = trimSlashes(v);
                if (segments[segments.length - 1] === '') // empty trailing elements have to be overwritten
                // to prevent results such as /foo//bar
                segments[segments.length - 1] = v;
                else segments.push(v);
            }
        } else if (v) segments[segment] = trimSlashes(v);
        else segments.splice(segment, 1);
        if (absolute) segments.unshift('');
        return this.path(segments.join(separator), build);
    };
    p.segmentCoded = function(segment, v, build) {
        var segments, i, l;
        if (typeof segment !== 'number') {
            build = v;
            v = segment;
            segment = undefined;
        }
        if (v === undefined) {
            segments = this.segment(segment, v, build);
            if (!isArray(segments)) segments = segments !== undefined ? URI.decode(segments) : undefined;
            else for(i = 0, l = segments.length; i < l; i++)segments[i] = URI.decode(segments[i]);
            return segments;
        }
        if (!isArray(v)) v = typeof v === 'string' || v instanceof String ? URI.encode(v) : v;
        else for(i = 0, l = v.length; i < l; i++)v[i] = URI.encode(v[i]);
        return this.segment(segment, v, build);
    };
    // mutating query string
    var q = p.query;
    p.query = function(v, build) {
        if (v === true) return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        else if (typeof v === 'function') {
            var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
            var result = v.call(this, data);
            this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            this.build(!build);
            return this;
        } else if (v !== undefined && typeof v !== 'string') {
            this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            this.build(!build);
            return this;
        } else return q.call(this, v, build);
    };
    p.setQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        if (typeof name === 'string' || name instanceof String) data[name] = value !== undefined ? value : null;
        else if (typeof name === 'object') {
            for(var key in name)if (hasOwn.call(name, key)) data[key] = name[key];
        } else throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== 'string') build = value;
        this.build(!build);
        return this;
    };
    p.addQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        URI.addQuery(data, name, value === undefined ? null : value);
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== 'string') build = value;
        this.build(!build);
        return this;
    };
    p.removeQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        URI.removeQuery(data, name, value);
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== 'string') build = value;
        this.build(!build);
        return this;
    };
    p.hasQuery = function(name, value, withinArray) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        return URI.hasQuery(data, name, value, withinArray);
    };
    p.setSearch = p.setQuery;
    p.addSearch = p.addQuery;
    p.removeSearch = p.removeQuery;
    p.hasSearch = p.hasQuery;
    // sanitizing URLs
    p.normalize = function() {
        if (this._parts.urn) return this.normalizeProtocol(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
        return this.normalizeProtocol(false).normalizeHostname(false).normalizePort(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
    };
    p.normalizeProtocol = function(build) {
        if (typeof this._parts.protocol === 'string') {
            this._parts.protocol = this._parts.protocol.toLowerCase();
            this.build(!build);
        }
        return this;
    };
    p.normalizeHostname = function(build) {
        if (this._parts.hostname) {
            if (this.is('IDN') && punycode) this._parts.hostname = punycode.toASCII(this._parts.hostname);
            else if (this.is('IPv6') && IPv6) this._parts.hostname = IPv6.best(this._parts.hostname);
            this._parts.hostname = this._parts.hostname.toLowerCase();
            this.build(!build);
        }
        return this;
    };
    p.normalizePort = function(build) {
        // remove port of it's the protocol's default
        if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
            this._parts.port = null;
            this.build(!build);
        }
        return this;
    };
    p.normalizePath = function(build) {
        var _path = this._parts.path;
        if (!_path) return this;
        if (this._parts.urn) {
            this._parts.path = URI.recodeUrnPath(this._parts.path);
            this.build(!build);
            return this;
        }
        if (this._parts.path === '/') return this;
        _path = URI.recodePath(_path);
        var _was_relative;
        var _leadingParents = '';
        var _parent, _pos;
        // handle relative paths
        if (_path.charAt(0) !== '/') {
            _was_relative = true;
            _path = '/' + _path;
        }
        // handle relative files (as opposed to directories)
        if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') _path += '/';
        // resolve simples
        _path = _path.replace(/(\/(\.\/)+)|(\/\.$)/g, '/').replace(/\/{2,}/g, '/');
        // remember leading parents
        if (_was_relative) {
            _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
            if (_leadingParents) _leadingParents = _leadingParents[0];
        }
        // resolve parents
        while(true){
            _parent = _path.search(/\/\.\.(\/|$)/);
            if (_parent === -1) break;
            else if (_parent === 0) {
                // top level cannot be relative, skip it
                _path = _path.substring(3);
                continue;
            }
            _pos = _path.substring(0, _parent).lastIndexOf('/');
            if (_pos === -1) _pos = _parent;
            _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
        }
        // revert to relative
        if (_was_relative && this.is('relative')) _path = _leadingParents + _path.substring(1);
        this._parts.path = _path;
        this.build(!build);
        return this;
    };
    p.normalizePathname = p.normalizePath;
    p.normalizeQuery = function(build) {
        if (typeof this._parts.query === 'string') {
            if (!this._parts.query.length) this._parts.query = null;
            else this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
            this.build(!build);
        }
        return this;
    };
    p.normalizeFragment = function(build) {
        if (!this._parts.fragment) {
            this._parts.fragment = null;
            this.build(!build);
        }
        return this;
    };
    p.normalizeSearch = p.normalizeQuery;
    p.normalizeHash = p.normalizeFragment;
    p.iso8859 = function() {
        // expect unicode input, iso8859 output
        var e = URI.encode;
        var d = URI.decode;
        URI.encode = escape;
        URI.decode = decodeURIComponent;
        try {
            this.normalize();
        } finally{
            URI.encode = e;
            URI.decode = d;
        }
        return this;
    };
    p.unicode = function() {
        // expect iso8859 input, unicode output
        var e = URI.encode;
        var d = URI.decode;
        URI.encode = strictEncodeURIComponent;
        URI.decode = unescape;
        try {
            this.normalize();
        } finally{
            URI.encode = e;
            URI.decode = d;
        }
        return this;
    };
    p.readable = function() {
        var uri = this.clone();
        // removing username, password, because they shouldn't be displayed according to RFC 3986
        uri.username('').password('').normalize();
        var t = '';
        if (uri._parts.protocol) t += uri._parts.protocol + '://';
        if (uri._parts.hostname) {
            if (uri.is('punycode') && punycode) {
                t += punycode.toUnicode(uri._parts.hostname);
                if (uri._parts.port) t += ':' + uri._parts.port;
            } else t += uri.host();
        }
        if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') t += '/';
        t += uri.path(true);
        if (uri._parts.query) {
            var q = '';
            for(var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++){
                var kv = (qp[i] || '').split('=');
                q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace).replace(/&/g, '%26');
                if (kv[1] !== undefined) q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace).replace(/&/g, '%26');
            }
            t += '?' + q.substring(1);
        }
        t += URI.decodeQuery(uri.hash(), true);
        return t;
    };
    // resolving relative and absolute URLs
    p.absoluteTo = function(base) {
        var resolved = this.clone();
        var properties = [
            'protocol',
            'username',
            'password',
            'hostname',
            'port'
        ];
        var basedir, i, p;
        if (this._parts.urn) throw new Error('URNs do not have any generally defined hierarchical components');
        if (!(base instanceof URI)) base = new URI(base);
        if (resolved._parts.protocol) // Directly returns even if this._parts.hostname is empty.
        return resolved;
        else resolved._parts.protocol = base._parts.protocol;
        if (this._parts.hostname) return resolved;
        for(i = 0; p = properties[i]; i++)resolved._parts[p] = base._parts[p];
        if (!resolved._parts.path) {
            resolved._parts.path = base._parts.path;
            if (!resolved._parts.query) resolved._parts.query = base._parts.query;
        } else {
            if (resolved._parts.path.substring(-2) === '..') resolved._parts.path += '/';
            if (resolved.path().charAt(0) !== '/') {
                basedir = base.directory();
                basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
                resolved._parts.path = (basedir ? basedir + '/' : '') + resolved._parts.path;
                resolved.normalizePath();
            }
        }
        resolved.build();
        return resolved;
    };
    p.relativeTo = function(base) {
        var relative = this.clone().normalize();
        var relativeParts, baseParts, common, relativePath, basePath;
        if (relative._parts.urn) throw new Error('URNs do not have any generally defined hierarchical components');
        base = new URI(base).normalize();
        relativeParts = relative._parts;
        baseParts = base._parts;
        relativePath = relative.path();
        basePath = base.path();
        if (relativePath.charAt(0) !== '/') throw new Error('URI is already relative');
        if (basePath.charAt(0) !== '/') throw new Error('Cannot calculate a URI relative to another relative URI');
        if (relativeParts.protocol === baseParts.protocol) relativeParts.protocol = null;
        if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) return relative.build();
        if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) return relative.build();
        if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
            relativeParts.hostname = null;
            relativeParts.port = null;
        } else return relative.build();
        if (relativePath === basePath) {
            relativeParts.path = '';
            return relative.build();
        }
        // determine common sub path
        common = URI.commonPath(relativePath, basePath);
        // If the paths have nothing in common, return a relative URL with the absolute path.
        if (!common) return relative.build();
        var parents = baseParts.path.substring(common.length).replace(/[^\/]*$/, '').replace(/.*?\//g, '../');
        relativeParts.path = parents + relativeParts.path.substring(common.length) || './';
        return relative.build();
    };
    // comparing URIs
    p.equals = function(uri) {
        var one = this.clone();
        var two = new URI(uri);
        var one_map = {};
        var two_map = {};
        var checked = {};
        var one_query, two_query, key;
        one.normalize();
        two.normalize();
        // exact match
        if (one.toString() === two.toString()) return true;
        // extract query string
        one_query = one.query();
        two_query = two.query();
        one.query('');
        two.query('');
        // definitely not equal if not even non-query parts match
        if (one.toString() !== two.toString()) return false;
        // query parameters have the same length, even if they're permuted
        if (one_query.length !== two_query.length) return false;
        one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
        two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
        for(key in one_map)if (hasOwn.call(one_map, key)) {
            if (!isArray(one_map[key])) {
                if (one_map[key] !== two_map[key]) return false;
            } else if (!arraysEqual(one_map[key], two_map[key])) return false;
            checked[key] = true;
        }
        for(key in two_map)if (hasOwn.call(two_map, key)) {
            if (!checked[key]) // two contains a parameter not present in one
            return false;
        }
        return true;
    };
    // state
    p.preventInvalidHostname = function(v) {
        this._parts.preventInvalidHostname = !!v;
        return this;
    };
    p.duplicateQueryParameters = function(v) {
        this._parts.duplicateQueryParameters = !!v;
        return this;
    };
    p.escapeQuerySpace = function(v) {
        this._parts.escapeQuerySpace = !!v;
        return this;
    };
    return URI;
});


function $dcd0d97cc310fbf6$var$isNode() {
    return false;
}

async function $dcd0d97cc310fbf6$var$generateCodeVerifier() {
    const length = 32;
    if ($dcd0d97cc310fbf6$var$isNode()) {
        const { randomBytes: randomBytes } = await (parcelRequire("i2cYP"));
        return randomBytes(length).toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    } else {
        const array = new Uint8Array(length);
        crypto.getRandomValues(array);
        return btoa(String.fromCharCode(...array)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    }
}

async function $dcd0d97cc310fbf6$var$generateCodeChallenge(verifier) {
    if ($dcd0d97cc310fbf6$var$isNode()) {
        const { createHash: createHash } = await (parcelRequire("i2cYP"));
        const hash = createHash("sha256").update(verifier).digest();
        return hash.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    } else {
        const encoder = new TextEncoder();
        const data = encoder.encode(verifier);
        const hashBuffer = await crypto.subtle.digest("SHA-256", data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashStr = String.fromCharCode(...hashArray);
        return btoa(hashStr).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    }
}
class $dcd0d97cc310fbf6$var$AuthorizeUriExtension extends (0, $f52fa34d4fef2d39$export$2e2bcd8739ae039) {
    rc;
    codeVerifier;
    options;
    constructor(options = {}){
        super();
        this.options = options;
    }
    async install(rc) {
        this.rc = rc;
    }
    async buildUri(_authorizeRequest) {
        const authorizeRequest = _authorizeRequest;
        if (!authorizeRequest.response_type) authorizeRequest.response_type = "code";
        if (!authorizeRequest.client_id) authorizeRequest.client_id = this.rc.rest.clientId;
        // PKCE: https://medium.com/ringcentral-developers/use-authorization-code-pkce-for-ringcentral-api-in-client-app-e9108f04b5f0
        if (authorizeRequest.code_challenge_method === "S256") {
            this.codeVerifier = await $dcd0d97cc310fbf6$var$generateCodeVerifier();
            authorizeRequest.code_challenge = await $dcd0d97cc310fbf6$var$generateCodeChallenge(this.codeVerifier);
        // this.codeVerifier = randomBytes(32).toString("base64").replace(/\+/g, "-")
        //   .replace(/\//g, "_").replace(/=/g, "");
        // authorizeRequest.code_challenge = createHash("sha256")
        //   .update(this.codeVerifier)
        //   .digest()
        //   .toString("base64")
        //   .replace(/\+/g, "-")
        //   .replace(/\//g, "_")
        //   .replace(/=/g, "");
        }
        let uri;
        if (this.options.baseUri) uri = new (0, (/*@__PURE__*/$parcel$interopDefault($f3b7c43a7f0c8e85$exports)))(this.options.baseUri);
        else uri = new (0, (/*@__PURE__*/$parcel$interopDefault($f3b7c43a7f0c8e85$exports)))(this.rc.rest.server).directory("/restapi/oauth/authorize");
        return uri.search(authorizeRequest).toString();
    }
    async revoke() {}
}
var $dcd0d97cc310fbf6$export$2e2bcd8739ae039 = $dcd0d97cc310fbf6$var$AuthorizeUriExtension;


'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(header) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Request aborted', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $e52be20a9fc15e96$var$isReadableStreamSupported = $e52be20a9fc15e96$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $e52be20a9fc15e96$var$encodeText = $e52be20a9fc15e96$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$supportsRequestStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$supportsResponseStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $e52be20a9fc15e96$var$resolvers = {
    stream: $e52be20a9fc15e96$var$supportsResponseStream && ((res)=>res.body)
};
$e52be20a9fc15e96$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$e52be20a9fc15e96$var$resolvers[type] && ($e52be20a9fc15e96$var$resolvers[type] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e52be20a9fc15e96$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await $e52be20a9fc15e96$var$encodeText(body)).byteLength;
};
const $e52be20a9fc15e96$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $e52be20a9fc15e96$var$getBodyLength(body) : length;
};
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $e52be20a9fc15e96$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $e52be20a9fc15e96$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $e52be20a9fc15e96$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($e52be20a9fc15e96$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $e52be20a9fc15e96$var$resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey($e52be20a9fc15e96$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Network Error', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: (0, $e52be20a9fc15e96$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.9.0";



'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('options must be an object', (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



'use strict';
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


var $1c66380376aa2c89$exports = {};
'use strict';
var $e5dd19a945a45bbb$exports = {};
'use strict';
var $08e53d4ef2e1f8ef$exports = {};
'use strict';
var $aaa4be976b2d27a3$exports = {};
'use strict';
/** @type {import('./type')} */ $aaa4be976b2d27a3$exports = TypeError;


var $a48090c7c3dfd2b6$exports = {};
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === 'function' && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === 'function' ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === 'function' && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === 'function' ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, '$&_');
}

var $kjyEk = parcelRequire("kjyEk");
var $a48090c7c3dfd2b6$var$inspectCustom = $kjyEk.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
var $a48090c7c3dfd2b6$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $a48090c7c3dfd2b6$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$a48090c7c3dfd2b6$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, 'quoteStyle') && !$a48090c7c3dfd2b6$var$has($a48090c7c3dfd2b6$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($a48090c7c3dfd2b6$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $a48090c7c3dfd2b6$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $a48090c7c3dfd2b6$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === 'object' && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = '<' + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return '[' + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $a48090c7c3dfd2b6$var$$join.call(xs, ', ') + ' ]';
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $a48090c7c3dfd2b6$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === 'function' && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf('Map', $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf('Set', $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf('WeakMap');
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf('WeakSet');
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf('WeakRef');
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $a48090c7c3dfd2b6$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $a48090c7c3dfd2b6$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, '&quot;');
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Array]' && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === 'object' && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Date]' && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === 'object' && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object RegExp]' && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === 'object' && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Error]' && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === 'object' && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object String]' && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === 'object' && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Number]' && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === 'object' && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Boolean]' && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === 'object' && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $a48090c7c3dfd2b6$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, 'single', opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === 'function' ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $52bc36570c76608b$exports = {};
'use strict';


/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $52bc36570c76608b$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $52bc36570c76608b$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $52bc36570c76608b$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $52bc36570c76608b$var$listSet = function(objects, key, value) {
    var node = $52bc36570c76608b$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $52bc36570c76608b$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$52bc36570c76608b$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $52bc36570c76608b$var$listDelete = function(objects, key) {
    if (objects) return $52bc36570c76608b$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ $52bc36570c76608b$exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $a48090c7c3dfd2b6$exports(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $52bc36570c76608b$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $52bc36570c76608b$var$listGet($o, key);
        },
        has: function(key) {
            return $52bc36570c76608b$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $52bc36570c76608b$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $8043468335131548$exports = {};
'use strict';
var $1258b452ecf218a1$exports = {};
'use strict';
var $1258b452ecf218a1$var$undefined1;
var $68f77cfee0d91ea0$exports = {};
'use strict';
/** @type {import('.')} */ $68f77cfee0d91ea0$exports = Object;


var $41038844aec6eaa2$exports = {};
'use strict';
/** @type {import('.')} */ $41038844aec6eaa2$exports = Error;


var $cd6d4b204c89f4f4$exports = {};
'use strict';
/** @type {import('./eval')} */ $cd6d4b204c89f4f4$exports = EvalError;


var $72e6a4e026a755bb$exports = {};
'use strict';
/** @type {import('./range')} */ $72e6a4e026a755bb$exports = RangeError;


var $1e478fcc3e34e216$exports = {};
'use strict';
/** @type {import('./ref')} */ $1e478fcc3e34e216$exports = ReferenceError;


var $43bb4ccdc6568bcf$exports = {};
'use strict';
/** @type {import('./syntax')} */ $43bb4ccdc6568bcf$exports = SyntaxError;



var $cde0c3ef12944098$exports = {};
'use strict';
/** @type {import('./uri')} */ $cde0c3ef12944098$exports = URIError;


var $829c6ad74b893335$exports = {};
'use strict';
/** @type {import('./abs')} */ $829c6ad74b893335$exports = Math.abs;


var $a0167fb8027efc6c$exports = {};
'use strict';
/** @type {import('./floor')} */ $a0167fb8027efc6c$exports = Math.floor;


var $59437e5dc9fc2c61$exports = {};
'use strict';
/** @type {import('./max')} */ $59437e5dc9fc2c61$exports = Math.max;


var $328f401f1e19f003$exports = {};
'use strict';
/** @type {import('./min')} */ $328f401f1e19f003$exports = Math.min;


var $8560e7c6d4e34f2f$exports = {};
'use strict';
/** @type {import('./pow')} */ $8560e7c6d4e34f2f$exports = Math.pow;


var $10e5f4d8a4a1ed83$exports = {};
'use strict';
/** @type {import('./round')} */ $10e5f4d8a4a1ed83$exports = Math.round;


var $37113bd5f1fb3cc6$exports = {};
'use strict';
var $3327ce1cf537a5ae$exports = {};
'use strict';
/** @type {import('./isNaN')} */ $3327ce1cf537a5ae$exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};


/** @type {import('./sign')} */ $37113bd5f1fb3cc6$exports = function sign(number) {
    if ($3327ce1cf537a5ae$exports(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};


var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $a2d7d74e83f6c3ed$exports = {};
'use strict';
var $985031ced66f900d$exports = {};
'use strict';
/** @type {import('./gOPD')} */ $985031ced66f900d$exports = Object.getOwnPropertyDescriptor;


var $a2d7d74e83f6c3ed$require$$gOPD = $985031ced66f900d$exports;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
$a2d7d74e83f6c3ed$exports = $a2d7d74e83f6c3ed$require$$gOPD;


var $e42bccb64e3fb3fd$exports = {};
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
$e42bccb64e3fb3fd$exports = $e42bccb64e3fb3fd$var$$defineProperty;


var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $aaa4be976b2d27a3$exports();
};
var $1258b452ecf218a1$var$ThrowTypeError = $a2d7d74e83f6c3ed$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $a2d7d74e83f6c3ed$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();
var $2a9ec54411859bd9$exports = {};
'use strict';
var $0a6f5f26ef0609b6$exports = {};
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ $0a6f5f26ef0609b6$exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;


var $a683e9a1df37ed0e$exports = {};
'use strict';

/** @type {import('./Object.getPrototypeOf')} */ $a683e9a1df37ed0e$exports = $68f77cfee0d91ea0$exports.getPrototypeOf || null;


var $55566fcac2c38fe4$exports = {};
'use strict';
var $e3cb45ba87de93fe$exports = {};
'use strict';
var $c0378745895dc03c$exports = {};
'use strict';
var $efd80b1d7fbb2850$exports = {};
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
$efd80b1d7fbb2850$exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$c0378745895dc03c$exports = Function.prototype.bind || $efd80b1d7fbb2850$exports;



var $6da1bf1c46eb4156$exports = {};
'use strict';
/** @type {import('./functionCall')} */ $6da1bf1c46eb4156$exports = Function.prototype.call;


var $2e4f98706b21e7c9$exports = {};
'use strict';

var $0658b6e5d2101996$exports = {};
'use strict';
/** @type {import('./functionApply')} */ $0658b6e5d2101996$exports = Function.prototype.apply;



var $623e642332342b72$exports = {};
'use strict';
/** @type {import('./reflectApply')} */ $623e642332342b72$exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/** @type {import('./actualApply')} */ $2e4f98706b21e7c9$exports = $623e642332342b72$exports || $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, $0658b6e5d2101996$exports);


/** @type {import('.')} */ $e3cb45ba87de93fe$exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $aaa4be976b2d27a3$exports('a function is required');
    return $2e4f98706b21e7c9$exports($c0378745895dc03c$exports, $6da1bf1c46eb4156$exports, args);
};



var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $a2d7d74e83f6c3ed$exports && $a2d7d74e83f6c3ed$exports(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $55566fcac2c38fe4$exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $e3cb45ba87de93fe$exports([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;


/** @type {import('.')} */ $2a9ec54411859bd9$exports = $0a6f5f26ef0609b6$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $0a6f5f26ef0609b6$exports(O);
} : $a683e9a1df37ed0e$exports ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $a683e9a1df37ed0e$exports(O);
} : $55566fcac2c38fe4$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $55566fcac2c38fe4$exports(O);
} : null;






var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $41038844aec6eaa2$exports,
    '%eval%': eval,
    '%EvalError%': $cd6d4b204c89f4f4$exports,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports($2a9ec54411859bd9$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $68f77cfee0d91ea0$exports,
    '%Object.getOwnPropertyDescriptor%': $a2d7d74e83f6c3ed$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $72e6a4e026a755bb$exports,
    '%ReferenceError%': $1e478fcc3e34e216$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$2a9ec54411859bd9$exports ? undefined : $2a9ec54411859bd9$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $2a9ec54411859bd9$exports ? $2a9ec54411859bd9$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $43bb4ccdc6568bcf$exports,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $aaa4be976b2d27a3$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $cde0c3ef12944098$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $6da1bf1c46eb4156$exports,
    '%Function.prototype.apply%': $0658b6e5d2101996$exports,
    '%Object.defineProperty%': $e42bccb64e3fb3fd$exports,
    '%Object.getPrototypeOf%': $a683e9a1df37ed0e$exports,
    '%Math.abs%': $829c6ad74b893335$exports,
    '%Math.floor%': $a0167fb8027efc6c$exports,
    '%Math.max%': $59437e5dc9fc2c61$exports,
    '%Math.min%': $328f401f1e19f003$exports,
    '%Math.pow%': $8560e7c6d4e34f2f$exports,
    '%Math.round%': $10e5f4d8a4a1ed83$exports,
    '%Math.sign%': $37113bd5f1fb3cc6$exports,
    '%Reflect.getPrototypeOf%': $0a6f5f26ef0609b6$exports
};
if ($2a9ec54411859bd9$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $2a9ec54411859bd9$exports($2a9ec54411859bd9$exports(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $2a9ec54411859bd9$exports) value = $2a9ec54411859bd9$exports(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $30dbf79dbae6c725$exports = {};
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

/** @type {import('.')} */ $30dbf79dbae6c725$exports = $c0378745895dc03c$exports.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);


var $1258b452ecf218a1$var$$concat = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $c0378745895dc03c$exports.call($0658b6e5d2101996$exports, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $c0378745895dc03c$exports.call($6da1bf1c46eb4156$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $43bb4ccdc6568bcf$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($30dbf79dbae6c725$exports($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($30dbf79dbae6c725$exports($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $aaa4be976b2d27a3$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $43bb4ccdc6568bcf$exports('intrinsic ' + name + ' does not exist!');
};
$1258b452ecf218a1$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $aaa4be976b2d27a3$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $aaa4be976b2d27a3$exports('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $43bb4ccdc6568bcf$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $43bb4ccdc6568bcf$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($30dbf79dbae6c725$exports($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $aaa4be976b2d27a3$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($a2d7d74e83f6c3ed$exports && i + 1 >= parts.length) {
                var desc = $a2d7d74e83f6c3ed$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $30dbf79dbae6c725$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $adf8ebd7229df60a$exports = {};
'use strict';


/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $e3cb45ba87de93fe$exports([
    $1258b452ecf218a1$exports('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ $adf8ebd7229df60a$exports = function callBoundIntrinsic(name, allowMissing) {
    // eslint-disable-next-line no-extra-parens
    var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ $1258b452ecf218a1$exports(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $e3cb45ba87de93fe$exports([
        intrinsic
    ]);
    return intrinsic;
};




var $8043468335131548$var$$Map = $1258b452ecf218a1$exports('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $8043468335131548$var$$mapGet = $adf8ebd7229df60a$exports('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $8043468335131548$var$$mapSet = $adf8ebd7229df60a$exports('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $8043468335131548$var$$mapHas = $adf8ebd7229df60a$exports('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $8043468335131548$var$$mapDelete = $adf8ebd7229df60a$exports('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $8043468335131548$var$$mapSize = $adf8ebd7229df60a$exports('Map.prototype.size', true);
/** @type {import('.')} */ $8043468335131548$exports = !!$8043468335131548$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $a48090c7c3dfd2b6$exports(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $8043468335131548$var$$mapDelete($m, key);
                if ($8043468335131548$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $8043468335131548$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $8043468335131548$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $8043468335131548$var$$Map();
            $8043468335131548$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};


var $591d8612c5fec170$exports = {};
'use strict';





var $591d8612c5fec170$var$$WeakMap = $1258b452ecf218a1$exports('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $591d8612c5fec170$var$$weakMapGet = $adf8ebd7229df60a$exports('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $591d8612c5fec170$var$$weakMapSet = $adf8ebd7229df60a$exports('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $591d8612c5fec170$var$$weakMapHas = $adf8ebd7229df60a$exports('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $591d8612c5fec170$var$$weakMapDelete = $adf8ebd7229df60a$exports('WeakMap.prototype.delete', true);
/** @type {import('.')} */ $591d8612c5fec170$exports = $591d8612c5fec170$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $a48090c7c3dfd2b6$exports(key));
        },
        'delete': function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapDelete($wm, key);
            } else if ($8043468335131548$exports) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $591d8612c5fec170$var$$WeakMap();
                $591d8612c5fec170$var$$weakMapSet($wm, key, value);
            } else if ($8043468335131548$exports) {
                if (!$m) $m = $8043468335131548$exports();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $8043468335131548$exports;


var $08e53d4ef2e1f8ef$var$makeChannel = $591d8612c5fec170$exports || $8043468335131548$exports || $52bc36570c76608b$exports;
/** @type {import('.')} */ $08e53d4ef2e1f8ef$exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aaa4be976b2d27a3$exports('Side channel does not contain ' + $a48090c7c3dfd2b6$exports(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $08e53d4ef2e1f8ef$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $d8a7e190fdc9c6e7$exports = {};
'use strict';
var $d1f90adf4e1eece6$exports = {};
'use strict';
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$d1f90adf4e1eece6$exports = {
    'default': $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};


var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $d8a7e190fdc9c6e7$var$limit){
        var segment = string.length >= $d8a7e190fdc9c6e7$var$limit ? string.slice(j, j + $d8a7e190fdc9c6e7$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $d1f90adf4e1eece6$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$d8a7e190fdc9c6e7$exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};



var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $d1f90adf4e1eece6$exports.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $d8a7e190fdc9c6e7$exports.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $d1f90adf4e1eece6$exports.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $e5dd19a945a45bbb$var$isArray(obj)) obj = $d8a7e190fdc9c6e7$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $d8a7e190fdc9c6e7$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $d8a7e190fdc9c6e7$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $08e53d4ef2e1f8ef$exports();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $d1f90adf4e1eece6$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$e5dd19a945a45bbb$var$has.call($d1f90adf4e1eece6$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $d1f90adf4e1eece6$exports.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === 'function' || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $e5dd19a945a45bbb$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $e5dd19a945a45bbb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $e5dd19a945a45bbb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
$e5dd19a945a45bbb$exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $08e53d4ef2e1f8ef$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $8ec5fc0fdc198ba4$exports = {};
'use strict';

var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $d8a7e190fdc9c6e7$exports.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'key');
            val = $d8a7e190fdc9c6e7$exports.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options, $8ec5fc0fdc198ba4$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        var existing = $8ec5fc0fdc198ba4$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $d8a7e190fdc9c6e7$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $d8a7e190fdc9c6e7$exports.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $8ec5fc0fdc198ba4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $8ec5fc0fdc198ba4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $8ec5fc0fdc198ba4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $d8a7e190fdc9c6e7$exports.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $8ec5fc0fdc198ba4$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
$8ec5fc0fdc198ba4$exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $d8a7e190fdc9c6e7$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $d8a7e190fdc9c6e7$exports.compact(obj);
};



$1c66380376aa2c89$exports = {
    formats: $d1f90adf4e1eece6$exports,
    parse: $8ec5fc0fdc198ba4$exports,
    stringify: $e5dd19a945a45bbb$exports
};



var $6ZWSX = parcelRequire("6ZWSX");
var $a6fa4c808d405770$require$Buffer = $6ZWSX.Buffer;
async function $a6fa4c808d405770$var$stream2buffer(stream) {
    return new Promise((resolve, reject)=>{
        const buf = Array();
        stream.on("data", (chunk)=>buf.push(chunk));
        stream.on("end", ()=>resolve($a6fa4c808d405770$require$Buffer.concat(buf)));
        stream.on("error", (err)=>reject(new Error(`error converting stream - ${err}`)));
    });
}
const $a6fa4c808d405770$export$63ac3a43cf05fb09 = "ad05fc42-a66d-4a94-b807-f1c91136c17b";
class $a6fa4c808d405770$var$FormData {
    files = [];
    append(formFile) {
        this.files.push(formFile);
    }
    prepend(formFile) {
        this.files.unshift(formFile);
    }
    async getBody() {
        let buffer = $a6fa4c808d405770$require$Buffer.alloc(0);
        for (const formFile of this.files){
            let temp = `--${$a6fa4c808d405770$export$63ac3a43cf05fb09}\r\n`;
            temp += `Content-Type: ${formFile.contentType}\r\n`;
            temp += `Content-Disposition: form-data; name="${formFile.name}"; filename="${formFile.filename}"\r\n\r\n`;
            buffer = $a6fa4c808d405770$require$Buffer.concat([
                buffer,
                $a6fa4c808d405770$require$Buffer.from(temp, "utf-8")
            ]);
            let fileBuffer = $a6fa4c808d405770$require$Buffer.alloc(0);
            if (typeof formFile.content === "string") fileBuffer = $a6fa4c808d405770$require$Buffer.from(`${formFile.content}\r\n`, "utf-8");
            else if ($a6fa4c808d405770$require$Buffer.isBuffer(formFile.content)) fileBuffer = formFile.content;
            else if (formFile.content instanceof Blob) fileBuffer = $a6fa4c808d405770$require$Buffer.from(await formFile.content.arrayBuffer());
            else // NodeJS.ReadableStream
            fileBuffer = await $a6fa4c808d405770$var$stream2buffer(formFile.content);
            buffer = $a6fa4c808d405770$require$Buffer.concat([
                buffer,
                fileBuffer
            ]);
        }
        return $a6fa4c808d405770$require$Buffer.concat([
            buffer,
            $a6fa4c808d405770$require$Buffer.from(`\r\n--${$a6fa4c808d405770$export$63ac3a43cf05fb09}--\r\n`, "utf8")
        ]);
    }
}
var $a6fa4c808d405770$export$2e2bcd8739ae039 = $a6fa4c808d405770$var$FormData;




var $6ZWSX = parcelRequire("6ZWSX");
var $f0364022b419ce8e$require$Buffer = $6ZWSX.Buffer;
class $f0364022b419ce8e$var$Utils {
    static formatTraffic(r) {
        return `HTTP ${r.status} ${r.statusText}${r.data.message ? ` - ${r.data.message}` : ""}

    Response:
    ${JSON.stringify({
            data: r.data,
            status: r.status,
            statusText: r.statusText,
            headers: r.headers
        }, null, 2)}

    Request:
    ${JSON.stringify({
            method: r.config.method,
            baseURL: r.config.baseURL,
            url: r.config.url,
            params: r.config.params,
            data: $f0364022b419ce8e$require$Buffer.isBuffer(r.config.data) ? "<Buffer>" : r.config.data,
            headers: r.config.headers
        }, null, 2)}
    `;
    }
    static isAttachment(obj) {
        return typeof obj === "object" && obj !== null && "filename" in obj && "content" in obj;
    }
    static getFormData(...objects) {
        const formData = new (0, $a6fa4c808d405770$export$2e2bcd8739ae039)();
        const obj = Object.assign({}, ...objects);
        for (const key of Object.keys(obj)){
            const value = obj[key];
            if (value === undefined || value === null) {
                delete obj[key];
                continue;
            }
            if ($f0364022b419ce8e$var$Utils.isAttachment(value)) {
                const attachment = value;
                formData.append({
                    name: key,
                    filename: attachment.filename,
                    contentType: attachment.contentType,
                    content: attachment.content
                });
                delete obj[key];
                continue;
            }
            if (Array.isArray(value) && $f0364022b419ce8e$var$Utils.isAttachment(value[0])) {
                for (const attachment of value)formData.append({
                    name: key,
                    filename: attachment.filename,
                    contentType: attachment.contentType,
                    content: attachment.content
                });
                delete obj[key];
            }
        }
        if (Object.keys(obj).length > 0) formData.prepend({
            name: "request.json",
            filename: "request.json",
            contentType: "application/json",
            content: JSON.stringify(obj)
        });
        return formData.getBody();
    }
}
var $f0364022b419ce8e$export$2e2bcd8739ae039 = $f0364022b419ce8e$var$Utils;


class $83087eca9d7a4702$var$RestException extends Error {
    response;
    message;
    constructor(r){
        const message = (0, $f0364022b419ce8e$export$2e2bcd8739ae039).formatTraffic(r);
        super(message);
        Object.setPrototypeOf(this, $83087eca9d7a4702$var$RestException.prototype);
        this.response = r;
        this.message = message;
    }
}
var $83087eca9d7a4702$export$2e2bcd8739ae039 = $83087eca9d7a4702$var$RestException;



var $6ZWSX = parcelRequire("6ZWSX");
var $ff34a89461abde6f$require$Buffer = $6ZWSX.Buffer;
const $ff34a89461abde6f$var$version = "1.6.x";
class $ff34a89461abde6f$export$2e2bcd8739ae039 {
    static sandboxServer = "https://platform.devtest.ringcentral.com";
    static productionServer = "https://platform.ringcentral.com";
    server;
    clientId;
    clientSecret;
    token;
    appName;
    appVersion;
    httpClient;
    constructor(options){
        this.server = options.server ?? $ff34a89461abde6f$export$2e2bcd8739ae039.productionServer;
        this.clientId = options.clientId ?? "";
        this.clientSecret = options.clientSecret;
        this.token = options.token ?? undefined;
        this.appName = options.appName ?? "Unknown";
        this.appVersion = options.appVersion ?? "0.0.1";
        this.httpClient = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
            headers: {
                "X-User-Agent": `${this.appName}/${this.appVersion} ringcentral-extensible/core/${$ff34a89461abde6f$var$version}`
            },
            validateStatus: ()=>true,
            paramsSerializer: {
                serialize: (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($1c66380376aa2c89$exports))).stringify(params, {
                        arrayFormat: "repeat"
                    })
            }
        });
        this.httpClient.interceptors.request.use((config)=>{
            if ($ff34a89461abde6f$require$Buffer.isBuffer(config.data)) return {
                ...config,
                headers: {
                    ...config.headers,
                    "Content-Type": `multipart/form-data; boundary=${0, $a6fa4c808d405770$export$63ac3a43cf05fb09}`
                }
            };
            return config;
        });
    }
    async request(method, endpoint, content, queryParams, config) {
        const newConfig = {
            baseURL: this.server,
            method: method,
            url: endpoint,
            data: content,
            params: queryParams,
            ...config
        };
        // /restapi/oauth/wstoken uses bearer token
        if (endpoint === "/restapi/oauth/token" || endpoint === "/restapi/oauth/revoke") {
            if (this.clientSecret) // basic token
            newConfig.auth = {
                username: this.clientId,
                password: this.clientSecret
            };
            // else: PKCE: https://medium.com/ringcentral-developers/use-authorization-code-pkce-for-ringcentral-api-in-client-app-e9108f04b5f0
            newConfig.data = (0, (/*@__PURE__*/$parcel$interopDefault($1c66380376aa2c89$exports))).stringify(newConfig.data);
        } else // bearer token
        newConfig.headers = {
            ...newConfig.headers,
            Authorization: `Bearer ${this.token?.access_token}`
        };
        const r = await this.httpClient.request(newConfig);
        if (r.status >= 200 && r.status < 300) return r;
        throw new (0, $83087eca9d7a4702$export$2e2bcd8739ae039)(r);
    }
}


class $8359aac0fe70085f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/parse`;
    }
    /**
     * Returns one or more parsed and/or formatted phone numbers that are passed as strings.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/number-parser/parse
     * Rate Limit Group: Light
     */ async post(parsePhoneNumberRequest, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), parsePhoneNumberRequest, queryParams, restRequestConfig);
        return r.data;
    }
}
var $8359aac0fe70085f$export$2e2bcd8739ae039 = $8359aac0fe70085f$var$Index;


class $8eb542680f8b1193$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/number-parser`;
    }
    parse() {
        return new (0, $8359aac0fe70085f$export$2e2bcd8739ae039)(this);
    }
}
var $8eb542680f8b1193$export$2e2bcd8739ae039 = $8eb542680f8b1193$var$Index;


class $7adb866b50b307a6$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/renew`;
    }
    /**
     * Renews the existing subscription (this request comes with empty body).
     *
     * Please note that `WebSocket` subscriptions are renewed automatically while websocket session is alive.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/subscription/{subscriptionId}/renew
     * Rate Limit Group: Light
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $7adb866b50b307a6$export$2e2bcd8739ae039 = $7adb866b50b307a6$var$Index;


class $97a5e5096894a497$var$Index {
    rc;
    _parent;
    subscriptionId;
    constructor(_parent, subscriptionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.subscriptionId = subscriptionId;
    }
    path(withParameter = true) {
        if (withParameter && this.subscriptionId !== null) return `${this._parent.path()}/subscription/${this.subscriptionId}`;
        return `${this._parent.path()}/subscription`;
    }
    /**
     * Returns a list of subscriptions created by the user for the current authorized client application.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/subscription
     * Rate Limit Group: Light
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * This API allows client applications to register a new subscription so that it
     * can be notified of events when they occur on the platform.
     *
     * A subscription relates to a set of events that a client application would like
     * to be informed of and the delivery channel by which they will be notified of
     * those events. How subscriptions are established depends upon the notification
     * channel the client application would like to use to receive the event
     * notification. For example, to create a webhook a developer would create a
     * subscription via a REST API call, while specifying a list of events or "event
     * filters" to be notified of, a transport type of `WebHook`, and the address or
     * URL to which they would like the webhook delivered.
     *
     * However, developers wishing to subscribe to a set of events via a WebSocket
     * channel, would first connect to the WebSocket gateway, and then issue their
     * subscription request over the WebSocket itself, as opposed to making a REST
     * API call to this endpoint.
     *
     * While the protocol for establishing a subscription may vary depending upon
     * the delivery channel for that subscription, the schemas used for representing
     * a subscription are the same across all delivery modes.
     *
     * Subscriptions are currently limited to 30 subscriptions per user/extension (for particular application).
     *
     * RingCentral currently supports the following delivery modes for event subscriptions:
     *
     * * [WebHook](https://developers.ringcentral.com/guide/notifications/webhooks/quick-start) - to receive event notifications as an HTTP POST to a given URL
     * * [WebSocket](https://developers.ringcentral.com/guide/notifications/websockets/quick-start) - to receive real-time events over a persistent WebSocket connection
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/subscription
     * Rate Limit Group: Medium
     */ async post(createSubscriptionRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createSubscriptionRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the existing subscription by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/subscription/{subscriptionId}
     * Rate Limit Group: Light
     */ async get(restRequestConfig) {
        if (this.subscriptionId === null) throw new Error("subscriptionId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the existing subscription. The client application can extend or narrow
     * the list of events for which it receives notifications within the current subscription.
     * If event filters are specified, calling this method modifies them for the
     * existing subscription. The method also allows one to set an expiration time for the
     * subscription itself.
     *
     * If parameters other than `events` and `expiresIn` are specified in the request they will be ignored.
     * If the request body is empty then the specified subscription will be renewed without any
     * event filter modifications and using the default expiration time.
     *
     * If the request is sent with empty body, it just renews a subscription
     * (so it is an equivalent of the `POST /restapi/v1.0/subscription/{subscriptionId}/renew`).
     *
     * Please note that `WebSocket` subscriptions cannot be updated via HTTP interface.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/subscription/{subscriptionId}
     * Rate Limit Group: Medium
     */ async put(updateSubscriptionRequest, restRequestConfig) {
        if (this.subscriptionId === null) throw new Error("subscriptionId must be specified.");
        const r = await this.rc.put(this.path(), updateSubscriptionRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Cancels the existing subscription.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/subscription/{subscriptionId}
     * Rate Limit Group: Medium
     */ async delete(restRequestConfig) {
        if (this.subscriptionId === null) throw new Error("subscriptionId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    renew() {
        return new (0, $7adb866b50b307a6$export$2e2bcd8739ae039)(this);
    }
}
var $97a5e5096894a497$export$2e2bcd8739ae039 = $97a5e5096894a497$var$Index;


class $cc461134f402cd32$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sip-provision`;
    }
    /**
     * Creates SIP registration of a device/application (WebPhone, Mobile, Softphone).
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/client-info/sip-provision
     * Rate Limit Group: Heavy
     * App Permission: VoipCalling
     */ async post(createSipRegistrationRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), createSipRegistrationRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $cc461134f402cd32$export$2e2bcd8739ae039 = $cc461134f402cd32$var$Index;


class $9ee3885e43133808$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/client-info`;
    }
    sipProvision() {
        return new (0, $cc461134f402cd32$export$2e2bcd8739ae039)(this);
    }
}
var $9ee3885e43133808$export$2e2bcd8739ae039 = $9ee3885e43133808$var$Index;


class $154ada83f45ef6bd$var$Index {
    rc;
    _parent;
    permissionCategoryId;
    constructor(_parent, permissionCategoryId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.permissionCategoryId = permissionCategoryId;
    }
    path(withParameter = true) {
        if (withParameter && this.permissionCategoryId !== null) return `${this._parent.path()}/permission-category/${this.permissionCategoryId}`;
        return `${this._parent.path()}/permission-category`;
    }
    /**
     * Returns a list of permission categories.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/permission-category
     * Rate Limit Group: Light
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a permission category by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/permission-category/{permissionCategoryId}
     * Rate Limit Group: Light
     */ async get(restRequestConfig) {
        if (this.permissionCategoryId === null) throw new Error("permissionCategoryId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $154ada83f45ef6bd$export$2e2bcd8739ae039 = $154ada83f45ef6bd$var$Index;


class $0f2831fdc993dae0$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/fax-cover-page`;
    }
    /**
     * Returns fax cover pages available for the current extension.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/fax-cover-page
     * Rate Limit Group: Light
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $0f2831fdc993dae0$export$2e2bcd8739ae039 = $0f2831fdc993dae0$var$Index;


class $d3234270e0ff0403$var$Index {
    rc;
    _parent;
    permissionId;
    constructor(_parent, permissionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.permissionId = permissionId;
    }
    path(withParameter = true) {
        if (withParameter && this.permissionId !== null) return `${this._parent.path()}/permission/${this.permissionId}`;
        return `${this._parent.path()}/permission`;
    }
    /**
     * Returns a list of extension user permissions.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/permission
     * Rate Limit Group: Light
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a user permission by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/permission/{permissionId}
     * Rate Limit Group: Light
     */ async get(restRequestConfig) {
        if (this.permissionId === null) throw new Error("permissionId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $d3234270e0ff0403$export$2e2bcd8739ae039 = $d3234270e0ff0403$var$Index;


class $84248f091f16d05d$var$Index {
    rc;
    _parent;
    roleId;
    constructor(_parent, roleId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.roleId = roleId;
    }
    path(withParameter = true) {
        if (withParameter && this.roleId !== null) return `${this._parent.path()}/user-role/${this.roleId}`;
        return `${this._parent.path()}/user-role`;
    }
    /**
     * Returns a list of standard user roles.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/user-role
     * Rate Limit Group: Light
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a standard user role by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/user-role/{roleId}
     * Rate Limit Group: Light
     */ async get(restRequestConfig) {
        if (this.roleId === null) throw new Error("roleId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $84248f091f16d05d$export$2e2bcd8739ae039 = $84248f091f16d05d$var$Index;


class $27f6ad9a0be800ff$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/location`;
    }
    /**
     * Returns all available locations for a certain state.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/location
     * Rate Limit Group: Light
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $27f6ad9a0be800ff$export$2e2bcd8739ae039 = $27f6ad9a0be800ff$var$Index;


class $870694708f268ef3$var$Index {
    rc;
    _parent;
    timezoneId;
    constructor(_parent, timezoneId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.timezoneId = timezoneId;
    }
    path(withParameter = true) {
        if (withParameter && this.timezoneId !== null) return `${this._parent.path()}/timezone/${this.timezoneId}`;
        return `${this._parent.path()}/timezone`;
    }
    /**
     * Returns all available timezones.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/timezone
     * Rate Limit Group: Light
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns information on a certain timezone.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/timezone/{timezoneId}
     * Rate Limit Group: Light
     */ async get(restRequestConfig) {
        if (this.timezoneId === null) throw new Error("timezoneId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $870694708f268ef3$export$2e2bcd8739ae039 = $870694708f268ef3$var$Index;


class $9a8736392cc74ee6$var$Index {
    rc;
    _parent;
    greetingId;
    constructor(_parent, greetingId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.greetingId = greetingId;
    }
    path(withParameter = true) {
        if (withParameter && this.greetingId !== null) return `${this._parent.path()}/greeting/${this.greetingId}`;
        return `${this._parent.path()}/greeting`;
    }
    /**
     * Returns the list of predefined standard greetings. Custom greetings
     * recorded by user are not returned in response to this request. See Get Extension
     * Custom Greetings.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/greeting
     * Rate Limit Group: Medium
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a standard greeting by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/greeting/{greetingId}
     * Rate Limit Group: Medium
     */ async get(restRequestConfig) {
        if (this.greetingId === null) throw new Error("greetingId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $9a8736392cc74ee6$export$2e2bcd8739ae039 = $9a8736392cc74ee6$var$Index;


class $50b2800a10a2d343$var$Index {
    rc;
    _parent;
    languageId;
    constructor(_parent, languageId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.languageId = languageId;
    }
    path(withParameter = true) {
        if (withParameter && this.languageId !== null) return `${this._parent.path()}/language/${this.languageId}`;
        return `${this._parent.path()}/language`;
    }
    /**
     * Returns information about the supported languages.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/language
     * Rate Limit Group: Light
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a language by ID.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/language/{languageId}
     * Rate Limit Group: Light
     */ async get(restRequestConfig) {
        if (this.languageId === null) throw new Error("languageId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $50b2800a10a2d343$export$2e2bcd8739ae039 = $50b2800a10a2d343$var$Index;


class $5cb7cee2910eee8d$var$Index {
    rc;
    _parent;
    countryId;
    constructor(_parent, countryId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.countryId = countryId;
    }
    path(withParameter = true) {
        if (withParameter && this.countryId !== null) return `${this._parent.path()}/country/${this.countryId}`;
        return `${this._parent.path()}/country`;
    }
    /**
     * Returns all countries available for calling.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/country
     * Rate Limit Group: Light
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns information on a specific country.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/country/{countryId}
     * Rate Limit Group: Light
     */ async get(restRequestConfig) {
        if (this.countryId === null) throw new Error("countryId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $5cb7cee2910eee8d$export$2e2bcd8739ae039 = $5cb7cee2910eee8d$var$Index;


class $24770d2121029cd4$var$Index {
    rc;
    _parent;
    stateId;
    constructor(_parent, stateId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.stateId = stateId;
    }
    path(withParameter = true) {
        if (withParameter && this.stateId !== null) return `${this._parent.path()}/state/${this.stateId}`;
        return `${this._parent.path()}/state`;
    }
    /**
     * Returns all states of a certain country.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/state
     * Rate Limit Group: Light
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns information on a specific state by ID.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/state/{stateId}
     * Rate Limit Group: Light
     */ async get(restRequestConfig) {
        if (this.stateId === null) throw new Error("stateId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $24770d2121029cd4$export$2e2bcd8739ae039 = $24770d2121029cd4$var$Index;


class $36beec0977173b11$var$Index {
    rc;
    _parent;
    contractedCountryId;
    constructor(_parent, contractedCountryId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.contractedCountryId = contractedCountryId;
    }
    path(withParameter = true) {
        if (withParameter && this.contractedCountryId !== null) return `${this._parent.path()}/contracted-country/${this.contractedCountryId}`;
        return `${this._parent.path()}/contracted-country`;
    }
    /**
     * Returns the list of contracted countries for the given brand.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/brand/{brandId}/contracted-country
     * Rate Limit Group: Light
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the list of domestic countries for account contracted country and brand.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/brand/{brandId}/contracted-country/{contractedCountryId}
     * Rate Limit Group: Light
     */ async get(queryParams, restRequestConfig) {
        if (this.contractedCountryId === null) throw new Error("contractedCountryId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $36beec0977173b11$export$2e2bcd8739ae039 = $36beec0977173b11$var$Index;


class $49ea7ebe083027a7$var$Index {
    rc;
    _parent;
    brandId;
    constructor(_parent, brandId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.brandId = brandId;
    }
    path(withParameter = true) {
        if (withParameter && this.brandId !== null) return `${this._parent.path()}/brand/${this.brandId}`;
        return `${this._parent.path()}/brand`;
    }
    contractedCountry(contractedCountryId = null) {
        return new (0, $36beec0977173b11$export$2e2bcd8739ae039)(this, contractedCountryId);
    }
}
var $49ea7ebe083027a7$export$2e2bcd8739ae039 = $49ea7ebe083027a7$var$Index;


class $44fcfa9d56ccb4b2$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/dictionary`;
    }
    brand(brandId = null) {
        return new (0, $49ea7ebe083027a7$export$2e2bcd8739ae039)(this, brandId);
    }
    state(stateId = null) {
        return new (0, $24770d2121029cd4$export$2e2bcd8739ae039)(this, stateId);
    }
    country(countryId = null) {
        return new (0, $5cb7cee2910eee8d$export$2e2bcd8739ae039)(this, countryId);
    }
    language(languageId = null) {
        return new (0, $50b2800a10a2d343$export$2e2bcd8739ae039)(this, languageId);
    }
    greeting(greetingId = null) {
        return new (0, $9a8736392cc74ee6$export$2e2bcd8739ae039)(this, greetingId);
    }
    timezone(timezoneId = null) {
        return new (0, $870694708f268ef3$export$2e2bcd8739ae039)(this, timezoneId);
    }
    location() {
        return new (0, $27f6ad9a0be800ff$export$2e2bcd8739ae039)(this);
    }
    userRole(roleId = null) {
        return new (0, $84248f091f16d05d$export$2e2bcd8739ae039)(this, roleId);
    }
    permission(permissionId = null) {
        return new (0, $d3234270e0ff0403$export$2e2bcd8739ae039)(this, permissionId);
    }
    faxCoverPage() {
        return new (0, $0f2831fdc993dae0$export$2e2bcd8739ae039)(this);
    }
    permissionCategory(permissionCategoryId = null) {
        return new (0, $154ada83f45ef6bd$export$2e2bcd8739ae039)(this, permissionCategoryId);
    }
}
var $44fcfa9d56ccb4b2$export$2e2bcd8739ae039 = $44fcfa9d56ccb4b2$var$Index;


class $000109a2b040de33$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/wireless-points-bulk-validate`;
    }
    /**
     * Validates wireless points before creation or update. The maximum
     * number of wireless points per request is 10 000.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/wireless-points-bulk-validate
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(validateMultipleWirelessPointsRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), validateMultipleWirelessPointsRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $000109a2b040de33$export$2e2bcd8739ae039 = $000109a2b040de33$var$Index;


class $89d9fff1a338e120$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/wireless-points-bulk-update`;
    }
    /**
     * Updates wireless points in corporate map. The maximum number of
     * wireless points per request is 10 000; limitation for account is 70 000.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/wireless-points-bulk-update
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(updateMultipleWirelessPointsRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), updateMultipleWirelessPointsRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $89d9fff1a338e120$export$2e2bcd8739ae039 = $89d9fff1a338e120$var$Index;


class $89f75c3ec6b3cb0c$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/wireless-points-bulk-create`;
    }
    /**
     * Creates multiple wireless points in a corporate map. The maximum
     * number of wireless points per request is 10 000; limitation for account is
     * 70 000.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/wireless-points-bulk-create
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(createMultipleWirelessPointsRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), createMultipleWirelessPointsRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $89f75c3ec6b3cb0c$export$2e2bcd8739ae039 = $89f75c3ec6b3cb0c$var$Index;


class $b8b7279acf3f7732$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/switches-bulk-validate`;
    }
    /**
     * Validates switches before creation or update. The maximum number
     * of switches per request is 10 000.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/switches-bulk-validate
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(validateMultipleSwitchesRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), validateMultipleSwitchesRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $b8b7279acf3f7732$export$2e2bcd8739ae039 = $b8b7279acf3f7732$var$Index;


class $2f94a190b7da0063$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/switches-bulk-update`;
    }
    /**
     * Updates multiple switches in corporate map. The maximum number
     * of switches per request is 10 000; limitation for account is 10 000.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/switches-bulk-update
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(updateMultipleSwitchesRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), updateMultipleSwitchesRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $2f94a190b7da0063$export$2e2bcd8739ae039 = $2f94a190b7da0063$var$Index;


class $383f8d07f79cf410$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/switches-bulk-create`;
    }
    /**
     * Creates multiple switches in corporate map. The maximum number
     * of switches per request is 10 000; limitation for account is 10 000.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/switches-bulk-create
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(createMultipleSwitchesRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), createMultipleSwitchesRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $383f8d07f79cf410$export$2e2bcd8739ae039 = $383f8d07f79cf410$var$Index;


class $b69a36b9bd7c1acc$var$Index {
    rc;
    _parent;
    pointId;
    constructor(_parent, pointId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.pointId = pointId;
    }
    path(withParameter = true) {
        if (withParameter && this.pointId !== null) return `${this._parent.path()}/wireless-points/${this.pointId}`;
        return `${this._parent.path()}/wireless-points`;
    }
    /**
     * Returns account wireless points configured and used for Automatic
     * Location Updates feature.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/wireless-points
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new wireless point in network configuration with the
     * emergency address assigned.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/wireless-points
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(createWirelessPoint, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createWirelessPoint, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the specified wireless access point of a corporate map
     * with the emergency address assigned.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/wireless-points/{pointId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async get(restRequestConfig) {
        if (this.pointId === null) throw new Error("pointId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the specified wireless access point of a corporate map
     * by ID.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/wireless-points/{pointId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async put(updateWirelessPoint, restRequestConfig) {
        if (this.pointId === null) throw new Error("pointId must be specified.");
        const r = await this.rc.put(this.path(), updateWirelessPoint, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes wireless point(s) of a corporate map by ID(s).
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/wireless-points/{pointId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async delete(restRequestConfig) {
        if (this.pointId === null) throw new Error("pointId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $b69a36b9bd7c1acc$export$2e2bcd8739ae039 = $b69a36b9bd7c1acc$var$Index;


class $77b34d55f99ccf7e$var$Index {
    rc;
    _parent;
    switchId;
    constructor(_parent, switchId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.switchId = switchId;
    }
    path(withParameter = true) {
        if (withParameter && this.switchId !== null) return `${this._parent.path()}/switches/${this.switchId}`;
        return `${this._parent.path()}/switches`;
    }
    /**
     * Returns a corporate map of configured network switches with the assigned
     * emergency addresses for the logged-in account.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/switches
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new switch in corporate map based on chassis ID and used
     * for Automatic Locations Update feature.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/switches
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(createSwitchInfo, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createSwitchInfo, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the specified switch with the assigned emergency address.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/switches/{switchId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async get(restRequestConfig) {
        if (this.switchId === null) throw new Error("switchId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates switch. Partial update is not supported, all switch parameters
     * should be specified. If null value is received or parameter is missing, its
     * value is removed.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/switches/{switchId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async put(updateSwitchInfo, restRequestConfig) {
        if (this.switchId === null) throw new Error("switchId must be specified.");
        const r = await this.rc.put(this.path(), updateSwitchInfo, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes wireless switch(es) in a network configuration for Automatic
     * Location Updates feature.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/switches/{switchId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async delete(restRequestConfig) {
        if (this.switchId === null) throw new Error("switchId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $77b34d55f99ccf7e$export$2e2bcd8739ae039 = $77b34d55f99ccf7e$var$Index;


class $3bdcafc094240db1$var$Index {
    rc;
    _parent;
    networkId;
    constructor(_parent, networkId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.networkId = networkId;
    }
    path(withParameter = true) {
        if (withParameter && this.networkId !== null) return `${this._parent.path()}/networks/${this.networkId}`;
        return `${this._parent.path()}/networks`;
    }
    /**
     * Returns a corporate network map with emergency addresses assigned
     * to the current account.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/networks
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new network in a corporate ethernet map for assignment
     * of emergency addresses to network access points.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/networks
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(createNetworkRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createNetworkRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the specified network with emergency addresses assigned
     * to the current account.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/networks/{networkId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async get(restRequestConfig) {
        if (this.networkId === null) throw new Error("networkId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a network in a corporate ethernet map for assignment of emergency
     * addresses to network access points.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/networks/{networkId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async put(updateNetworkRequest, restRequestConfig) {
        if (this.networkId === null) throw new Error("networkId must be specified.");
        const r = await this.rc.put(this.path(), updateNetworkRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes network(s) in a corporate ethernet map for Automatic Location
     * Updates feature.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/networks/{networkId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async delete(restRequestConfig) {
        if (this.networkId === null) throw new Error("networkId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $3bdcafc094240db1$export$2e2bcd8739ae039 = $3bdcafc094240db1$var$Index;


class $29af8f4b91f902c7$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Enables or disables Automatic Location Updates feature for the
     * specified common phones.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/devices/bulk-assign
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(assignMultipleDevicesAutomaticLocationUpdates, restRequestConfig) {
        const r = await this.rc.post(this.path(), assignMultipleDevicesAutomaticLocationUpdates, undefined, restRequestConfig);
        return r.data;
    }
}
var $29af8f4b91f902c7$export$2e2bcd8739ae039 = $29af8f4b91f902c7$var$Index;


class $45b93c7b52967c9c$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/devices`;
    }
    /**
     * Returns a list of common devices with their status of Automatic
     * Location Updates feature.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/devices
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    bulkAssign() {
        return new (0, $29af8f4b91f902c7$export$2e2bcd8739ae039)(this);
    }
}
var $45b93c7b52967c9c$export$2e2bcd8739ae039 = $45b93c7b52967c9c$var$Index;


class $a0506ee05f7dc47a$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Enables or disables Automatic Location Updates feature for multiple
     * account users.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/users/bulk-assign
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(emergencyAddressAutoUpdateUsersBulkAssignResource, restRequestConfig) {
        const r = await this.rc.post(this.path(), emergencyAddressAutoUpdateUsersBulkAssignResource, undefined, restRequestConfig);
        return r.data;
    }
}
var $a0506ee05f7dc47a$export$2e2bcd8739ae039 = $a0506ee05f7dc47a$var$Index;


class $b422e49a3ff37109$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/users`;
    }
    /**
     * Returns a list of users with their status of Automatic Location
     * Updates feature.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/users
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    bulkAssign() {
        return new (0, $a0506ee05f7dc47a$export$2e2bcd8739ae039)(this);
    }
}
var $b422e49a3ff37109$export$2e2bcd8739ae039 = $b422e49a3ff37109$var$Index;


class $12e366e8627eb3cd$var$Index {
    rc;
    _parent;
    taskId;
    constructor(_parent, taskId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.taskId = taskId;
    }
    path(withParameter = true) {
        if (withParameter && this.taskId !== null) return `${this._parent.path()}/tasks/${this.taskId}`;
        return `${this._parent.path()}/tasks`;
    }
    /**
     * Returns results of the task created within the frame of Automatic
     * Location Updates feature. Currently four task types are supported: 'Wireless
     * Points Bulk Create', 'Wireless Points Bulk Update', 'Switches Bulk Create',
     * 'Switches Bulk Update'.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/tasks/{taskId}
     * Rate Limit Group: Light
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async get(restRequestConfig) {
        if (this.taskId === null) throw new Error("taskId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $12e366e8627eb3cd$export$2e2bcd8739ae039 = $12e366e8627eb3cd$var$Index;


class $9fac17ae93dfb016$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/emergency-address-auto-update`;
    }
    tasks(taskId = null) {
        return new (0, $12e366e8627eb3cd$export$2e2bcd8739ae039)(this, taskId);
    }
    users() {
        return new (0, $b422e49a3ff37109$export$2e2bcd8739ae039)(this);
    }
    devices() {
        return new (0, $45b93c7b52967c9c$export$2e2bcd8739ae039)(this);
    }
    networks(networkId = null) {
        return new (0, $3bdcafc094240db1$export$2e2bcd8739ae039)(this, networkId);
    }
    switches(switchId = null) {
        return new (0, $77b34d55f99ccf7e$export$2e2bcd8739ae039)(this, switchId);
    }
    wirelessPoints(pointId = null) {
        return new (0, $b69a36b9bd7c1acc$export$2e2bcd8739ae039)(this, pointId);
    }
    switchesBulkCreate() {
        return new (0, $383f8d07f79cf410$export$2e2bcd8739ae039)(this);
    }
    switchesBulkUpdate() {
        return new (0, $2f94a190b7da0063$export$2e2bcd8739ae039)(this);
    }
    switchesBulkValidate() {
        return new (0, $b8b7279acf3f7732$export$2e2bcd8739ae039)(this);
    }
    wirelessPointsBulkCreate() {
        return new (0, $89f75c3ec6b3cb0c$export$2e2bcd8739ae039)(this);
    }
    wirelessPointsBulkUpdate() {
        return new (0, $89d9fff1a338e120$export$2e2bcd8739ae039)(this);
    }
    wirelessPointsBulkValidate() {
        return new (0, $000109a2b040de33$export$2e2bcd8739ae039)(this);
    }
}
var $9fac17ae93dfb016$export$2e2bcd8739ae039 = $9fac17ae93dfb016$var$Index;


class $14d9e556ded82472$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/message-store-configuration`;
    }
    /**
     * Returns message store settings.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-configuration
     * Rate Limit Group: Light
     * App Permission: EditAccounts
     * User Permission: AccountAdministration
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates message store settings.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-configuration
     * Rate Limit Group: Light
     * App Permission: EditAccounts
     * User Permission: AccountAdministration
     */ async put(messageStoreConfiguration, restRequestConfig) {
        const r = await this.rc.put(this.path(), messageStoreConfiguration, undefined, restRequestConfig);
        return r.data;
    }
}
var $14d9e556ded82472$export$2e2bcd8739ae039 = $14d9e556ded82472$var$Index;


class $4262e2b4f99245f2$var$Index {
    rc;
    _parent;
    taskId;
    constructor(_parent, taskId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.taskId = taskId;
    }
    path(withParameter = true) {
        if (withParameter && this.taskId !== null) return `${this._parent.path()}/tasks/${this.taskId}`;
        return `${this._parent.path()}/tasks`;
    }
    /**
     * Returns the status of a task on adding multiple contacts to multiple extensions.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/address-book-bulk-upload/tasks/{taskId}
     * Rate Limit Group: Light
     * App Permission: Contacts
     * User Permission: EditPersonalContacts
     */ async get(restRequestConfig) {
        if (this.taskId === null) throw new Error("taskId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $4262e2b4f99245f2$export$2e2bcd8739ae039 = $4262e2b4f99245f2$var$Index;


class $cd64d0aa98d92632$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/address-book-bulk-upload`;
    }
    /**
     * Uploads multiple contacts for multiple extensions at once.
     * Maximum 500 extensions can be uploaded per request. Max amount
     * of contacts that can be uploaded per extension is 10,000.
     * Each contact uploaded for a certain extension is not visible
     * to other extensions.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/address-book-bulk-upload
     * Rate Limit Group: Heavy
     * App Permission: Contacts
     * User Permission: EditPersonalContacts
     */ async post(addressBookBulkUploadRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), addressBookBulkUploadRequest, undefined, restRequestConfig);
        return r.data;
    }
    tasks(taskId = null) {
        return new (0, $4262e2b4f99245f2$export$2e2bcd8739ae039)(this, taskId);
    }
}
var $cd64d0aa98d92632$export$2e2bcd8739ae039 = $cd64d0aa98d92632$var$Index;


class $87649b1926a3a6f5$var$Index {
    rc;
    _parent;
    templateId;
    constructor(_parent, templateId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.templateId = templateId;
    }
    path(withParameter = true) {
        if (withParameter && this.templateId !== null) return `${this._parent.path()}/message-store-templates/${this.templateId}`;
        return `${this._parent.path()}/message-store-templates`;
    }
    /**
     * Returns a list of company text message templates.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-templates
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new text message template on a company level. Maximum number of company templates is 50.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-templates
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     */ async post(messageTemplateRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), messageTemplateRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a company text message template by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-templates/{templateId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        if (this.templateId === null) throw new Error("templateId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a company text message template.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-templates/{templateId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     */ async put(messageTemplateUpdateRequest, restRequestConfig) {
        if (this.templateId === null) throw new Error("templateId must be specified.");
        const r = await this.rc.put(this.path(), messageTemplateUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a company text message template.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-templates/{templateId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     */ async delete(restRequestConfig) {
        if (this.templateId === null) throw new Error("templateId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $87649b1926a3a6f5$export$2e2bcd8739ae039 = $87649b1926a3a6f5$var$Index;


class $2d12d34cd97d5fa4$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Updates a list of call monitoring groups.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-monitoring-groups/{groupId}/bulk-assign
     * Rate Limit Group: Heavy
     * App Permission: EditExtensions
     * User Permission: Groups
     */ async post(callMonitoringBulkAssign, restRequestConfig) {
        const r = await this.rc.post(this.path(), callMonitoringBulkAssign, undefined, restRequestConfig);
        return r.data;
    }
}
var $2d12d34cd97d5fa4$export$2e2bcd8739ae039 = $2d12d34cd97d5fa4$var$Index;


class $e23c3cb5b9859278$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/members`;
    }
    /**
     * Returns a list of members for a call monitoring group specified in path.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-monitoring-groups/{groupId}/members
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $e23c3cb5b9859278$export$2e2bcd8739ae039 = $e23c3cb5b9859278$var$Index;


class $62ec26c333a98521$var$Index {
    rc;
    _parent;
    groupId;
    constructor(_parent, groupId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.groupId = groupId;
    }
    path(withParameter = true) {
        if (withParameter && this.groupId !== null) return `${this._parent.path()}/call-monitoring-groups/${this.groupId}`;
        return `${this._parent.path()}/call-monitoring-groups`;
    }
    /**
     * Returns a list of call monitoring groups filtered by an extension.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-monitoring-groups
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new call monitoring group.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-monitoring-groups
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: Groups
     */ async post(createCallMonitoringGroupRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createCallMonitoringGroupRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a call monitoring group name.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-monitoring-groups/{groupId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: Groups
     */ async put(createCallMonitoringGroupRequest, restRequestConfig) {
        if (this.groupId === null) throw new Error("groupId must be specified.");
        const r = await this.rc.put(this.path(), createCallMonitoringGroupRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Removes information about a call monitoring group specified in path.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-monitoring-groups/{groupId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: Groups
     */ async delete(restRequestConfig) {
        if (this.groupId === null) throw new Error("groupId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    members() {
        return new (0, $e23c3cb5b9859278$export$2e2bcd8739ae039)(this);
    }
    bulkAssign() {
        return new (0, $2d12d34cd97d5fa4$export$2e2bcd8739ae039)(this);
    }
}
var $62ec26c333a98521$export$2e2bcd8739ae039 = $62ec26c333a98521$var$Index;


class $cd5e947169f3b400$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-log-extract-sync`;
    }
    /**
     * Extracts all company's call log records that were updated after the specified time.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-log-extract-sync
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: ReadCallLog
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $cd5e947169f3b400$export$2e2bcd8739ae039 = $cd5e947169f3b400$var$Index;


class $dc91e4f67bba40bf$var$Index {
    rc;
    _parent;
    taskId;
    constructor(_parent, taskId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.taskId = taskId;
    }
    path(withParameter = true) {
        if (withParameter && this.taskId !== null) return `${this._parent.path()}/tasks/${this.taskId}`;
        return `${this._parent.path()}/tasks`;
    }
    /**
     * Returns a status of a task to update multiple extensions.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension-bulk-update/tasks/{taskId}
     * Rate Limit Group: Light
     * App Permission: EditExtensions
     * User Permission: EditExtensionInfo
     */ async get(restRequestConfig) {
        if (this.taskId === null) throw new Error("taskId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $dc91e4f67bba40bf$export$2e2bcd8739ae039 = $dc91e4f67bba40bf$var$Index;


class $5b71dce63b41feeb$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/extension-bulk-update`;
    }
    /**
     * Updates multiple extensions at once. Maximum 500 extensions can be updated per request.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension-bulk-update
     * Rate Limit Group: Heavy
     * App Permission: EditExtensions
     * User Permission: EditExtensionInfo
     */ async post(extensionBulkUpdateRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), extensionBulkUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
    tasks(taskId = null) {
        return new (0, $dc91e4f67bba40bf$export$2e2bcd8739ae039)(this, taskId);
    }
}
var $5b71dce63b41feeb$export$2e2bcd8739ae039 = $5b71dce63b41feeb$var$Index;


class $61b90e067a68ccb5$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/archive`;
    }
    /**
     * Returns the created report with message data not including attachments.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-report/{taskId}/archive
     * Rate Limit Group: Heavy
     * App Permission: ReadMessages
     * User Permission: Users
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $61b90e067a68ccb5$export$2e2bcd8739ae039 = $61b90e067a68ccb5$var$Index;


class $c20e3fc12939cead$var$Index {
    rc;
    _parent;
    taskId;
    constructor(_parent, taskId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.taskId = taskId;
    }
    path(withParameter = true) {
        if (withParameter && this.taskId !== null) return `${this._parent.path()}/message-store-report/${this.taskId}`;
        return `${this._parent.path()}/message-store-report`;
    }
    /**
     * Creates a task to collect all account messages within the specified
     * time interval. Maximum number of simultaneous tasks per account is 2.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-report
     * Rate Limit Group: Heavy
     * App Permission: ReadMessages
     * User Permission: Users
     */ async post(createMessageStoreReportRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createMessageStoreReportRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the current status of a task on report creation.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/message-store-report/{taskId}
     * Rate Limit Group: Heavy
     * App Permission: ReadMessages
     * User Permission: Users
     */ async get(restRequestConfig) {
        if (this.taskId === null) throw new Error("taskId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    archive() {
        return new (0, $61b90e067a68ccb5$export$2e2bcd8739ae039)(this);
    }
}
var $c20e3fc12939cead$export$2e2bcd8739ae039 = $c20e3fc12939cead$var$Index;


class $963f03444a1c6aec$var$Index {
    rc;
    _parent;
    locationId;
    constructor(_parent, locationId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.locationId = locationId;
    }
    path(withParameter = true) {
        if (withParameter && this.locationId !== null) return `${this._parent.path()}/emergency-locations/${this.locationId}`;
        return `${this._parent.path()}/emergency-locations`;
    }
    /**
     * Returns emergency response locations for the current account.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-locations
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new emergency response location for a company.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-locations
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async post(emergencyLocationRequestResource, restRequestConfig) {
        const r = await this.rc.post(this.path(false), emergencyLocationRequestResource, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns emergency response location by ID. Available for Admin users only.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-locations/{locationId}
     * Rate Limit Group: Light
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async get(queryParams, restRequestConfig) {
        if (this.locationId === null) throw new Error("locationId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the specified emergency response location.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-locations/{locationId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async put(emergencyLocationRequestResource, restRequestConfig) {
        if (this.locationId === null) throw new Error("locationId must be specified.");
        const r = await this.rc.put(this.path(), emergencyLocationRequestResource, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the specified emergency response location.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-locations/{locationId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */ async delete(queryParams, restRequestConfig) {
        if (this.locationId === null) throw new Error("locationId must be specified.");
        const r = await this.rc.delete(this.path(), {}, queryParams, restRequestConfig);
        return r.data;
    }
}
var $963f03444a1c6aec$export$2e2bcd8739ae039 = $963f03444a1c6aec$var$Index;


class $44a664b0f9be813b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Adds and/or removes paging group users and devices.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/paging-only-groups/{pagingOnlyGroupId}/bulk-assign
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: Groups
     */ async post(editPagingGroupRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), editPagingGroupRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $44a664b0f9be813b$export$2e2bcd8739ae039 = $44a664b0f9be813b$var$Index;


class $e417e490968a4507$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/devices`;
    }
    /**
     * Returns a list of paging devices assigned to this group.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/paging-only-groups/{pagingOnlyGroupId}/devices
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyDevices
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $e417e490968a4507$export$2e2bcd8739ae039 = $e417e490968a4507$var$Index;


class $3d779b1db0a602d7$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/users`;
    }
    /**
     * Returns a list of users allowed to page this group.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/paging-only-groups/{pagingOnlyGroupId}/users
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserInfo
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $3d779b1db0a602d7$export$2e2bcd8739ae039 = $3d779b1db0a602d7$var$Index;


class $fd67284c51ac8840$var$Index {
    rc;
    _parent;
    pagingOnlyGroupId;
    constructor(_parent, pagingOnlyGroupId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.pagingOnlyGroupId = pagingOnlyGroupId;
    }
    path(withParameter = true) {
        if (withParameter && this.pagingOnlyGroupId !== null) return `${this._parent.path()}/paging-only-groups/${this.pagingOnlyGroupId}`;
        return `${this._parent.path()}/paging-only-groups`;
    }
    users() {
        return new (0, $3d779b1db0a602d7$export$2e2bcd8739ae039)(this);
    }
    devices() {
        return new (0, $e417e490968a4507$export$2e2bcd8739ae039)(this);
    }
    bulkAssign() {
        return new (0, $44a664b0f9be813b$export$2e2bcd8739ae039)(this);
    }
}
var $fd67284c51ac8840$export$2e2bcd8739ae039 = $fd67284c51ac8840$var$Index;


class $3e5f9a05879ea869$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/forward-all-calls`;
    }
    /**
     * Returns information about *Forward All Company Calls* feature setting.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/forward-all-calls
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyAnsweringRules
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates *Forward All Company Calls* feature setting.
     * HTTP Method: patch
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/forward-all-calls
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyAnsweringRules
     */ async patch(forwardAllCompanyCallsRequest, restRequestConfig) {
        const r = await this.rc.patch(this.path(), forwardAllCompanyCallsRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $3e5f9a05879ea869$export$2e2bcd8739ae039 = $3e5f9a05879ea869$var$Index;


class $759df4a3de03e2e3$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/business-address`;
    }
    /**
     * Returns business address of a company.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/business-address
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the business address of a company that account is linked
     * to.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/business-address
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyInfo
     */ async put(modifyAccountBusinessAddressRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), modifyAccountBusinessAddressRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $759df4a3de03e2e3$export$2e2bcd8739ae039 = $759df4a3de03e2e3$var$Index;


class $740555f1f204cf90$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-recordings`;
    }
    /**
     * Deletes company call recordings by their IDs. *Please note:* This method deletes the recording file itself,
     * not the record of it in the call log.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recordings
     * Rate Limit Group: Heavy
     * App Permission: EditCallLog
     * User Permission: EditCompanyCallRecordings
     */ async delete(callRecordingIds, restRequestConfig) {
        const r = await this.rc.delete(this.path(), callRecordingIds, undefined, restRequestConfig);
        return r.data;
    }
}
var $740555f1f204cf90$export$2e2bcd8739ae039 = $740555f1f204cf90$var$Index;


class $9441df33ce7274f6$var$Index {
    rc;
    _parent;
    greetingId;
    constructor(_parent, greetingId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.greetingId = greetingId;
    }
    path(withParameter = true) {
        if (withParameter && this.greetingId !== null) return `${this._parent.path()}/custom-greetings/${this.greetingId}`;
        return `${this._parent.path()}/custom-greetings`;
    }
    /**
     * Returns call recording custom greetings.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording/custom-greetings
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes call recording custom greetings.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording/custom-greetings
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyInfo
     */ async deleteAll(restRequestConfig) {
        const r = await this.rc.delete(this.path(false), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes call recording custom greeting(s).
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording/custom-greetings/{greetingId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyInfo
     */ async delete(restRequestConfig) {
        if (this.greetingId === null) throw new Error("greetingId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $9441df33ce7274f6$export$2e2bcd8739ae039 = $9441df33ce7274f6$var$Index;


class $78ba8e8a2ad5f82f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Creates or updates the list of extensions to be recorded.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording/bulk-assign
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async post(bulkAccountCallRecordingsResource, restRequestConfig) {
        const r = await this.rc.post(this.path(), bulkAccountCallRecordingsResource, undefined, restRequestConfig);
        return r.data;
    }
}
var $78ba8e8a2ad5f82f$export$2e2bcd8739ae039 = $78ba8e8a2ad5f82f$var$Index;


class $9319be5b264e9f9a$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/extensions`;
    }
    /**
     * Returns the list of extensions to be recorded.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording/extensions
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $9319be5b264e9f9a$export$2e2bcd8739ae039 = $9319be5b264e9f9a$var$Index;


class $91e3d89280c1ce78$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-recording`;
    }
    /**
     * Returns call recording settings.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates current call recording settings.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyInfo
     */ async put(callRecordingSettingsResource, restRequestConfig) {
        const r = await this.rc.put(this.path(), callRecordingSettingsResource, undefined, restRequestConfig);
        return r.data;
    }
    extensions() {
        return new (0, $9319be5b264e9f9a$export$2e2bcd8739ae039)(this);
    }
    bulkAssign() {
        return new (0, $78ba8e8a2ad5f82f$export$2e2bcd8739ae039)(this);
    }
    customGreetings(greetingId = null) {
        return new (0, $9441df33ce7274f6$export$2e2bcd8739ae039)(this, greetingId);
    }
}
var $91e3d89280c1ce78$export$2e2bcd8739ae039 = $91e3d89280c1ce78$var$Index;


class $7986981480a23522$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/business-hours`;
    }
    /**
     * Returns the company business hours schedule. Business hours (and After hours - all the remaining time) schedules are commonly used for setting call handling rules - `business-hours-rule` and `after-hours-rule` correspondingly.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/business-hours
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyAnsweringRules
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the company business hours schedule.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/business-hours
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserAnsweringRules
     */ async put(companyBusinessHoursUpdateRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), companyBusinessHoursUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $7986981480a23522$export$2e2bcd8739ae039 = $7986981480a23522$var$Index;


class $52c0d85729c6c003$var$Index {
    rc;
    _parent;
    ruleId;
    constructor(_parent, ruleId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.ruleId = ruleId;
    }
    path(withParameter = true) {
        if (withParameter && this.ruleId !== null) return `${this._parent.path()}/answering-rule/${this.ruleId}`;
        return `${this._parent.path()}/answering-rule`;
    }
    /**
     * Returns a list of company call handling rules.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/answering-rule
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyAnsweringRules
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates call handling rule on account level.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/answering-rule
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyAnsweringRules
     */ async post(companyAnsweringRuleRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), companyAnsweringRuleRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a company call handling rule by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/answering-rule/{ruleId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyAnsweringRules
     */ async get(restRequestConfig) {
        if (this.ruleId === null) throw new Error("ruleId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a company call handling rule.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/answering-rule/{ruleId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyAnsweringRules
     */ async put(companyAnsweringRuleUpdate, restRequestConfig) {
        if (this.ruleId === null) throw new Error("ruleId must be specified.");
        const r = await this.rc.put(this.path(), companyAnsweringRuleUpdate, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a company custom call handling rule by a particular ID.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/answering-rule/{ruleId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyAnsweringRules
     */ async delete(restRequestConfig) {
        if (this.ruleId === null) throw new Error("ruleId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $52c0d85729c6c003$export$2e2bcd8739ae039 = $52c0d85729c6c003$var$Index;


class $e81716e4d5341db0$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/assigned-role`;
    }
    /**
     * Returns a list of roles assigned to the current account.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/assigned-role
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadAssignedRoles
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $e81716e4d5341db0$export$2e2bcd8739ae039 = $e81716e4d5341db0$var$Index;


class $3fe299919cd319a6$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-log-sync`;
    }
    /**
     * Synchronizes company call log records.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-log-sync
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: ReadCallLog
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $3fe299919cd319a6$export$2e2bcd8739ae039 = $3fe299919cd319a6$var$Index;


class $321ba570dec9575a$var$Index {
    rc;
    _parent;
    fieldId;
    constructor(_parent, fieldId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.fieldId = fieldId;
    }
    path(withParameter = true) {
        if (withParameter && this.fieldId !== null) return `${this._parent.path()}/custom-fields/${this.fieldId}`;
        return `${this._parent.path()}/custom-fields`;
    }
    /**
     * Returns the list of created custom fields.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/custom-fields
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserInfo
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Creates custom field attached to the object.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/custom-fields
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: Users
     */ async post(customFieldCreateRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), customFieldCreateRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates custom field by ID specified in path.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/custom-fields/{fieldId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: Users
     */ async put(customFieldUpdateRequest, restRequestConfig) {
        if (this.fieldId === null) throw new Error("fieldId must be specified.");
        const r = await this.rc.put(this.path(), customFieldUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes custom field(s) by ID(s) with the corresponding values.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/custom-fields/{fieldId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: Users
     */ async delete(restRequestConfig) {
        if (this.fieldId === null) throw new Error("fieldId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $321ba570dec9575a$export$2e2bcd8739ae039 = $321ba570dec9575a$var$Index;


class $be00809e291fa5cf$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/active-calls`;
    }
    /**
     * Returns records of all calls that are in progress, ordered by start time in descending order.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/active-calls
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: ReadCallLog
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $be00809e291fa5cf$export$2e2bcd8739ae039 = $be00809e291fa5cf$var$Index;


class $48b1bb025f782639$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/service-info`;
    }
    /**
     * Returns the information about service plan, available features
     * and limitations for a particular RingCentral customer account.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/service-info
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $48b1bb025f782639$export$2e2bcd8739ae039 = $48b1bb025f782639$var$Index;


class $cdb31619b2aa7d43$var$Index {
    rc;
    _parent;
    phoneNumberId;
    constructor(_parent, phoneNumberId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.phoneNumberId = phoneNumberId;
    }
    path(withParameter = true) {
        if (withParameter && this.phoneNumberId !== null) return `${this._parent.path()}/phone-number/${this.phoneNumberId}`;
        return `${this._parent.path()}/phone-number`;
    }
    /**
     * Returns the list of phone numbers assigned to RingCentral customer
     * account. Both company-level and extension-level numbers are returned.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/phone-number
     * Rate Limit Group: Heavy
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyPhoneNumbers
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns phone number(s) belonging to a certain account or extension by phoneNumberId(s).
     * [Batch request syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/phone-number/{phoneNumberId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyPhoneNumbers
     */ async get(restRequestConfig) {
        if (this.phoneNumberId === null) throw new Error("phoneNumberId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $cdb31619b2aa7d43$export$2e2bcd8739ae039 = $cdb31619b2aa7d43$var$Index;


class $c1ca5d846d4cc038$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Assigns multiple call queue members to call queue group.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-queues/{groupId}/bulk-assign
     * Rate Limit Group: Heavy
     * App Permission: EditExtensions
     * User Permission: Groups
     */ async post(callQueueBulkAssignResource, restRequestConfig) {
        const r = await this.rc.post(this.path(), callQueueBulkAssignResource, undefined, restRequestConfig);
        return r.data;
    }
}
var $c1ca5d846d4cc038$export$2e2bcd8739ae039 = $c1ca5d846d4cc038$var$Index;


class $90a1bc89cf0984d5$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/presence`;
    }
    /**
     * Returns presence status of the call queue members.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-queues/{groupId}/presence
     * Rate Limit Group: Light
     * App Permission: ReadPresence
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates presence status of the call queue members in the specified queue.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-queues/{groupId}/presence
     * Rate Limit Group: Medium
     * App Permission: EditPresence
     */ async put(callQueueUpdatePresence, restRequestConfig) {
        const r = await this.rc.put(this.path(), callQueueUpdatePresence, undefined, restRequestConfig);
        return r.data;
    }
}
var $90a1bc89cf0984d5$export$2e2bcd8739ae039 = $90a1bc89cf0984d5$var$Index;


class $70deebfe726736bc$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/members`;
    }
    /**
     * Returns a list of call queue group members.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-queues/{groupId}/members
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $70deebfe726736bc$export$2e2bcd8739ae039 = $70deebfe726736bc$var$Index;


class $c7ad06ad9e5df611$var$Index {
    rc;
    _parent;
    groupId;
    constructor(_parent, groupId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.groupId = groupId;
    }
    path(withParameter = true) {
        if (withParameter && this.groupId !== null) return `${this._parent.path()}/call-queues/${this.groupId}`;
        return `${this._parent.path()}/call-queues`;
    }
    /**
     * Returns a call queue list.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-queues
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns basic information on a call queue group extension.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-queues/{groupId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(restRequestConfig) {
        if (this.groupId === null) throw new Error("groupId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates information on a call queue group extension.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-queues/{groupId}
     * Rate Limit Group: Light
     * App Permission: EditExtensions
     * User Permission: EditUserInfo
     */ async put(callQueueDetailsForUpdate, restRequestConfig) {
        if (this.groupId === null) throw new Error("groupId must be specified.");
        const r = await this.rc.put(this.path(), callQueueDetailsForUpdate, undefined, restRequestConfig);
        return r.data;
    }
    members() {
        return new (0, $70deebfe726736bc$export$2e2bcd8739ae039)(this);
    }
    presence() {
        return new (0, $90a1bc89cf0984d5$export$2e2bcd8739ae039)(this);
    }
    bulkAssign() {
        return new (0, $c1ca5d846d4cc038$export$2e2bcd8739ae039)(this);
    }
}
var $c7ad06ad9e5df611$export$2e2bcd8739ae039 = $c7ad06ad9e5df611$var$Index;


class $abc781102cbf18be$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/content`;
    }
    /**
     * Returns media content of an IVR prompt by ID.
     *
     * **This API must be called via media API entry point, e.g. https://media.ringcentral.com**
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-prompts/{promptId}/content
     * Rate Limit Group: Heavy
     * App Permission: ReadAccounts
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, {
            ...restRequestConfig,
            responseType: "arraybuffer"
        });
        return r.data;
    }
}
var $abc781102cbf18be$export$2e2bcd8739ae039 = $abc781102cbf18be$var$Index;



class $9316828cc2dede32$var$Index {
    rc;
    _parent;
    promptId;
    constructor(_parent, promptId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.promptId = promptId;
    }
    path(withParameter = true) {
        if (withParameter && this.promptId !== null) return `${this._parent.path()}/ivr-prompts/${this.promptId}`;
        return `${this._parent.path()}/ivr-prompts`;
    }
    /**
     * Returns the list of IVR prompts.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-prompts
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyGreetings
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Creates an IVR prompt.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-prompts
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: EditCompanyGreetings
     */ async post(createIVRPromptRequest, restRequestConfig) {
        const formData = await (0, $f0364022b419ce8e$export$2e2bcd8739ae039).getFormData(createIVRPromptRequest);
        const r = await this.rc.post(this.path(false), formData, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns an IVR prompt by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-prompts/{promptId}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyGreetings
     */ async get(restRequestConfig) {
        if (this.promptId === null) throw new Error("promptId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates an IVR prompt by ID
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-prompts/{promptId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyGreetings
     */ async put(updateIVRPromptRequest, restRequestConfig) {
        if (this.promptId === null) throw new Error("promptId must be specified.");
        const r = await this.rc.put(this.path(), updateIVRPromptRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes an IVR prompt by ID.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-prompts/{promptId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: EditCompanyGreetings
     */ async delete(restRequestConfig) {
        if (this.promptId === null) throw new Error("promptId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    content() {
        return new (0, $abc781102cbf18be$export$2e2bcd8739ae039)(this);
    }
}
var $9316828cc2dede32$export$2e2bcd8739ae039 = $9316828cc2dede32$var$Index;


class $f6082ffe860200ab$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/search`;
    }
    /**
     * Returns the audit trail data with specific filters applied.
     * Audit trail searching is limited to the last 10,000 records or last 180 days, whichever comes first.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/audit-trail/search
     * Rate Limit Group: Heavy
     * App Permission: ReadAuditTrail
     */ async post(accountHistorySearchPublicRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), accountHistorySearchPublicRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $f6082ffe860200ab$export$2e2bcd8739ae039 = $f6082ffe860200ab$var$Index;


class $13cd732cbd79b258$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/audit-trail`;
    }
    search() {
        return new (0, $f6082ffe860200ab$export$2e2bcd8739ae039)(this);
    }
}
var $13cd732cbd79b258$export$2e2bcd8739ae039 = $13cd732cbd79b258$var$Index;


class $aae1ceaf4fdc95b9$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Assigns multiple user roles.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/user-role/{roleId}/bulk-assign
     * Rate Limit Group: Heavy
     * App Permission: RoleManagement
     * User Permission: EditUserRoles
     */ async post(bulkRoleAssignResource, restRequestConfig) {
        const r = await this.rc.post(this.path(), bulkRoleAssignResource, undefined, restRequestConfig);
        return r.data;
    }
}
var $aae1ceaf4fdc95b9$export$2e2bcd8739ae039 = $aae1ceaf4fdc95b9$var$Index;


class $f0b9cf6d795f7497$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/default`;
    }
    /**
     * Returns the default user role of the current account.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/user-role/default
     * Rate Limit Group: Light
     * App Permission: RoleManagement
     * User Permission: Roles
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the account default user role.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/user-role/default
     * Rate Limit Group: Medium
     * App Permission: RoleManagement
     * User Permission: Roles
     */ async put(defaultUserRoleRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), defaultUserRoleRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $f0b9cf6d795f7497$export$2e2bcd8739ae039 = $f0b9cf6d795f7497$var$Index;


class $daefdf8bac5d23d7$var$Index {
    rc;
    _parent;
    roleId;
    constructor(_parent, roleId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.roleId = roleId;
    }
    path(withParameter = true) {
        if (withParameter && this.roleId !== null) return `${this._parent.path()}/user-role/${this.roleId}`;
        return `${this._parent.path()}/user-role`;
    }
    /**
     * Returns a list of account user roles.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/user-role
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadUserRoles
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a custom user role.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/user-role
     * Rate Limit Group: Medium
     * App Permission: RoleManagement
     * User Permission: EditUserRoles
     */ async post(roleResource, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(false), roleResource, queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a user role assigned to the current account.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/user-role/{roleId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserRoles
     */ async get(queryParams, restRequestConfig) {
        if (this.roleId === null) throw new Error("roleId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a user role assigned to the current account by ID.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/user-role/{roleId}
     * Rate Limit Group: Medium
     * App Permission: RoleManagement
     * User Permission: EditUserRoles
     */ async put(roleResource, queryParams, restRequestConfig) {
        if (this.roleId === null) throw new Error("roleId must be specified.");
        const r = await this.rc.put(this.path(), roleResource, queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a custom user role by ID.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/user-role/{roleId}
     * Rate Limit Group: Medium
     * App Permission: RoleManagement
     * User Permission: EditUserRoles
     */ async delete(queryParams, restRequestConfig) {
        if (this.roleId === null) throw new Error("roleId must be specified.");
        const r = await this.rc.delete(this.path(), {}, queryParams, restRequestConfig);
        return r.data;
    }
    default() {
        return new (0, $f0b9cf6d795f7497$export$2e2bcd8739ae039)(this);
    }
    bulkAssign() {
        return new (0, $aae1ceaf4fdc95b9$export$2e2bcd8739ae039)(this);
    }
}
var $daefdf8bac5d23d7$export$2e2bcd8739ae039 = $daefdf8bac5d23d7$var$Index;


class $80a75f5dd7d1608e$var$Index {
    rc;
    _parent;
    ivrMenuId;
    constructor(_parent, ivrMenuId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.ivrMenuId = ivrMenuId;
    }
    path(withParameter = true) {
        if (withParameter && this.ivrMenuId !== null) return `${this._parent.path()}/ivr-menus/${this.ivrMenuId}`;
        return `${this._parent.path()}/ivr-menus`;
    }
    /**
     * Returns a company IVR menus.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-menus
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a company IVR menu.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-menus
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: AutoReceptionist
     */ async post(iVRMenuInfo, restRequestConfig) {
        const r = await this.rc.post(this.path(false), iVRMenuInfo, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a company IVR menu by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-menus/{ivrMenuId}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: AutoReceptionist
     */ async get(restRequestConfig) {
        if (this.ivrMenuId === null) throw new Error("ivrMenuId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a company IVR menu by ID.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/ivr-menus/{ivrMenuId}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: AutoReceptionist
     */ async put(iVRMenuInfo, restRequestConfig) {
        if (this.ivrMenuId === null) throw new Error("ivrMenuId must be specified.");
        const r = await this.rc.put(this.path(), iVRMenuInfo, undefined, restRequestConfig);
        return r.data;
    }
}
var $80a75f5dd7d1608e$export$2e2bcd8739ae039 = $80a75f5dd7d1608e$var$Index;


class $7f8458a85e83f6b2$var$Index {
    rc;
    _parent;
    templateId;
    constructor(_parent, templateId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.templateId = templateId;
    }
    path(withParameter = true) {
        if (withParameter && this.templateId !== null) return `${this._parent.path()}/templates/${this.templateId}`;
        return `${this._parent.path()}/templates`;
    }
    /**
     * Returns the list of user templates for the current account.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/templates
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the user template by ID.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/templates/{templateId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async get(restRequestConfig) {
        if (this.templateId === null) throw new Error("templateId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $7f8458a85e83f6b2$export$2e2bcd8739ae039 = $7f8458a85e83f6b2$var$Index;


class $6ab06b6214af6c5c$var$Index {
    rc;
    _parent;
    templateId;
    constructor(_parent, templateId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.templateId = templateId;
    }
    path(withParameter = true) {
        if (withParameter && this.templateId !== null) return `${this._parent.path()}/message-store-templates/${this.templateId}`;
        return `${this._parent.path()}/message-store-templates`;
    }
    /**
     * Returns a list of user's personal text message templates.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store-templates
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a user personal text message template.
     * Maximum number of personal templates is 25 per user.
     * Max length of the `body` property is 1000 symbols (2-byte UTF-16 encoded).
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store-templates
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     */ async post(messageTemplateRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), messageTemplateRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a user personal text message template by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store-templates/{templateId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        if (this.templateId === null) throw new Error("templateId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a user personal text message template.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store-templates/{templateId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     */ async put(messageTemplateUpdateRequest, restRequestConfig) {
        if (this.templateId === null) throw new Error("templateId must be specified.");
        const r = await this.rc.put(this.path(), messageTemplateUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a user personal text message template.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store-templates/{templateId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     */ async delete(restRequestConfig) {
        if (this.templateId === null) throw new Error("templateId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $6ab06b6214af6c5c$export$2e2bcd8739ae039 = $6ab06b6214af6c5c$var$Index;


class $035326feaa6e3b93$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/notification-settings`;
    }
    /**
     * Returns notification settings for the current extension.
     *
     * Knowledge Article: [User Settings - Set Up Message Notifications](https://success.ringcentral.com/articles/RC_Knowledge_Article/9740)
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/notification-settings
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadMessagesNotificationsSettings
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates notification settings for the current extension.
     * Knowledge Article: [User Settings - Set Up Message Notifications](https://success.ringcentral.com/articles/RC_Knowledge_Article/9740)
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/notification-settings
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditMessagesNotificationsSettings
     */ async put(notificationSettingsUpdateRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), notificationSettingsUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $035326feaa6e3b93$export$2e2bcd8739ae039 = $035326feaa6e3b93$var$Index;


class $c454efdb7d2ae622$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-queue-presence`;
    }
    /**
     * Returns a list of agent's call queues with the agent presence status (per queue).
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/call-queue-presence
     * Rate Limit Group: Light
     * App Permission: ReadPresence
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates availability of the agent for the call queues.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/call-queue-presence
     * Rate Limit Group: Medium
     * App Permission: EditPresence
     */ async put(extensionCallQueueUpdatePresenceList, restRequestConfig) {
        const r = await this.rc.put(this.path(), extensionCallQueueUpdatePresenceList, undefined, restRequestConfig);
        return r.data;
    }
}
var $c454efdb7d2ae622$export$2e2bcd8739ae039 = $c454efdb7d2ae622$var$Index;


class $c2b86d98aa0e8e84$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/video-configuration`;
    }
    /**
     * Returns information about video configuration settings of the current user.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/video-configuration
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: Meetings
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $c2b86d98aa0e8e84$export$2e2bcd8739ae039 = $c2b86d98aa0e8e84$var$Index;


class $5ffaf22b7ef8f1f7$var$Index {
    rc;
    _parent;
    locationId;
    constructor(_parent, locationId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.locationId = locationId;
    }
    path(withParameter = true) {
        if (withParameter && this.locationId !== null) return `${this._parent.path()}/emergency-locations/${this.locationId}`;
        return `${this._parent.path()}/emergency-locations`;
    }
    /**
     * Returns a list of emergency response locations available for the particular extension.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/emergency-locations
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a personal emergency response location for the current user.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/emergency-locations
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: EmergencyFramework
     */ async post(createUserEmergencyLocationRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createUserEmergencyLocationRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a personal emergency response location for the current user.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/emergency-locations/{locationId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        if (this.locationId === null) throw new Error("locationId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a personal emergency response location by the current user or admin.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/emergency-locations/{locationId}
     * Rate Limit Group: Light
     * App Permission: EditAccounts
     * User Permission: EmergencyFramework
     */ async put(emergencyLocationRequestResource, restRequestConfig) {
        if (this.locationId === null) throw new Error("locationId must be specified.");
        const r = await this.rc.put(this.path(), emergencyLocationRequestResource, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a personal emergency response location by ID by
     * the current user or admin. Multiple personal emergency response
     * locations can be deleted by single API call.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/emergency-locations/{locationId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: EmergencyFramework
     */ async delete(queryParams, restRequestConfig) {
        if (this.locationId === null) throw new Error("locationId must be specified.");
        const r = await this.rc.delete(this.path(), {}, queryParams, restRequestConfig);
        return r.data;
    }
}
var $5ffaf22b7ef8f1f7$export$2e2bcd8739ae039 = $5ffaf22b7ef8f1f7$var$Index;


class $4cf9ece4803c9572$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/administered-sites`;
    }
    /**
     * Returns a list of sites administered by the current user.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/administered-sites
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the sites administered by the current user.
     * Please note: Only IDs of records are used for update.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/administered-sites
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditAssignedRoles
     */ async put(businessSiteCollectionRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), businessSiteCollectionRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $4cf9ece4803c9572$export$2e2bcd8739ae039 = $4cf9ece4803c9572$var$Index;


class $fe209a5389c31ea5$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/overflow-settings`;
    }
    /**
     * Returns overflow settings for a call queue specified in path.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{callQueueId}/overflow-settings
     * Rate Limit Group: Heavy
     * App Permission: ReadAccounts
     * User Permission: CallQueueToCallQueue
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates overflow settings for a call queue specified in path.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{callQueueId}/overflow-settings
     * Rate Limit Group: Heavy
     * App Permission: EditExtensions
     * User Permission: CallQueueToCallQueue
     */ async put(callQueueOverflowSettingsRequestResource, restRequestConfig) {
        const r = await this.rc.put(this.path(), callQueueOverflowSettingsRequestResource, undefined, restRequestConfig);
        return r.data;
    }
}
var $fe209a5389c31ea5$export$2e2bcd8739ae039 = $fe209a5389c31ea5$var$Index;


class $0fdec99db70fa842$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/address-book-sync`;
    }
    /**
     * Synchronizes user contacts.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/address-book-sync
     * Rate Limit Group: Heavy
     * App Permission: ReadContacts
     * User Permission: ReadPersonalContacts
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $0fdec99db70fa842$export$2e2bcd8739ae039 = $0fdec99db70fa842$var$Index;


class $f12c6b19027a78fb$var$Index {
    rc;
    _parent;
    forwardingNumberId;
    constructor(_parent, forwardingNumberId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.forwardingNumberId = forwardingNumberId;
    }
    path(withParameter = true) {
        if (withParameter && this.forwardingNumberId !== null) return `${this._parent.path()}/forwarding-number/${this.forwardingNumberId}`;
        return `${this._parent.path()}/forwarding-number`;
    }
    /**
     * Returns the list of extension phone numbers used for call forwarding
     * and call flip. The returned list contains all the extension phone numbers
     * used for call forwarding and call flip.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserForwardingFlipNumbers
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Adds a new forwarding number to the forwarding number list.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserForwardingFlipNumbers
     */ async post(createForwardingNumberRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createForwardingNumberRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes multiple forwarding numbers from the forwarding number list by IDs.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserForwardingFlipNumbers
     */ async deleteAll(deleteForwardingNumbersRequest, restRequestConfig) {
        const r = await this.rc.delete(this.path(false), deleteForwardingNumbersRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a specific forwarding number.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number/{forwardingNumberId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserForwardingFlipNumbers
     */ async get(restRequestConfig) {
        if (this.forwardingNumberId === null) throw new Error("forwardingNumberId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the existing forwarding number from the forwarding number list.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number/{forwardingNumberId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserForwardingFlipNumbers
     */ async put(updateForwardingNumberRequest, restRequestConfig) {
        if (this.forwardingNumberId === null) throw new Error("forwardingNumberId must be specified.");
        const r = await this.rc.put(this.path(), updateForwardingNumberRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a forwarding number from the forwarding number list by its ID.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number/{forwardingNumberId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserForwardingFlipNumbers
     */ async delete(restRequestConfig) {
        if (this.forwardingNumberId === null) throw new Error("forwardingNumberId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $f12c6b19027a78fb$export$2e2bcd8739ae039 = $f12c6b19027a78fb$var$Index;


class $febc66dc8cb20d1b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/unified-presence`;
    }
    /**
     * Returns the unified presence status of the requested user(s). The set of parameters returned by this method differs whether you return the requester's presence or any other user presence.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/unified-presence
     * Rate Limit Group: Medium
     * App Permission: ReadPresence
     * User Permission: ReadPresenceStatus
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the unified presence for the current user specified in path.
     * HTTP Method: patch
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/unified-presence
     * Rate Limit Group: Medium
     * App Permission: EditPresence
     * User Permission: EditPresenceStatus
     */ async patch(updateUnifiedPresence, restRequestConfig) {
        const r = await this.rc.patch(this.path(), updateUnifiedPresence, undefined, restRequestConfig);
        return r.data;
    }
}
var $febc66dc8cb20d1b$export$2e2bcd8739ae039 = $febc66dc8cb20d1b$var$Index;


class $ca23faab53e7eb3e$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/assignable-roles`;
    }
    /**
     * Returns a list of roles which can be assigned to a given extension.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/assignable-roles
     * Rate Limit Group: Medium
     * App Permission: RoleManagement
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $ca23faab53e7eb3e$export$2e2bcd8739ae039 = $ca23faab53e7eb3e$var$Index;


class $f8388bb81d98d200$var$Index {
    rc;
    _parent;
    blockedNumberId;
    constructor(_parent, blockedNumberId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.blockedNumberId = blockedNumberId;
    }
    path(withParameter = true) {
        if (withParameter && this.blockedNumberId !== null) return `${this._parent.path()}/phone-numbers/${this.blockedNumberId}`;
        return `${this._parent.path()}/phone-numbers`;
    }
    /**
     * Returns the lists of blocked and allowed phone numbers.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/caller-blocking/phone-numbers
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadBlockedNumbers
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates either blocked or allowed phone number list with a new phone number.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/caller-blocking/phone-numbers
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditBlockedNumbers
     */ async post(addBlockedAllowedPhoneNumber, restRequestConfig) {
        const r = await this.rc.post(this.path(false), addBlockedAllowedPhoneNumber, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns blocked or allowed phone number(s) by their ID(s).
     * [Batch request syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/caller-blocking/phone-numbers/{blockedNumberId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadBlockedNumbers
     */ async get(restRequestConfig) {
        if (this.blockedNumberId === null) throw new Error("blockedNumberId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates blocked or allowed phone number(s) by their ID(s).
     * [Batch request syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/caller-blocking/phone-numbers/{blockedNumberId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditBlockedNumbers
     */ async put(addBlockedAllowedPhoneNumber, restRequestConfig) {
        if (this.blockedNumberId === null) throw new Error("blockedNumberId must be specified.");
        const r = await this.rc.put(this.path(), addBlockedAllowedPhoneNumber, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes blocked or allowed phone number(s) by their ID(s).
     * [Batch request](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/caller-blocking/phone-numbers/{blockedNumberId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditBlockedNumbers
     */ async delete(restRequestConfig) {
        if (this.blockedNumberId === null) throw new Error("blockedNumberId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $f8388bb81d98d200$export$2e2bcd8739ae039 = $f8388bb81d98d200$var$Index;


class $5b88d794d00c51b1$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/caller-blocking`;
    }
    /**
     * Returns the current caller blocking settings of a user.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/caller-blocking
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadBlockedNumbers
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the current caller blocking settings of a user.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/caller-blocking
     * Rate Limit Group: Light
     * App Permission: EditExtensions
     * User Permission: EditBlockedNumbers
     */ async put(callerBlockingSettingsUpdate, restRequestConfig) {
        const r = await this.rc.put(this.path(), callerBlockingSettingsUpdate, undefined, restRequestConfig);
        return r.data;
    }
    phoneNumbers(blockedNumberId = null) {
        return new (0, $f8388bb81d98d200$export$2e2bcd8739ae039)(this, blockedNumberId);
    }
}
var $5b88d794d00c51b1$export$2e2bcd8739ae039 = $5b88d794d00c51b1$var$Index;


class $0a53f5ce1bf590f2$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/business-hours`;
    }
    /**
     * Returns the user business hours schedule. Business hours (and After hours - all the remaining time) schedules are commonly used for setting call handling rules - `business-hours-rule` and `after-hours-rule` correspondingly. **Please note:** If the user business hours are set to 'Custom hours' then a particular schedule is returned; however if set to '24 hours/7 days a week' the schedule will be empty.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/business-hours
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the user business hours schedule.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/business-hours
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserAnsweringRules
     */ async put(userBusinessHoursUpdateRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), userBusinessHoursUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $0a53f5ce1bf590f2$export$2e2bcd8739ae039 = $0a53f5ce1bf590f2$var$Index;


class $53925642edc3b6f2$var$Index {
    rc;
    _parent;
    ruleId;
    constructor(_parent, ruleId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.ruleId = ruleId;
    }
    path(withParameter = true) {
        if (withParameter && this.ruleId !== null) return `${this._parent.path()}/answering-rule/${this.ruleId}`;
        return `${this._parent.path()}/answering-rule`;
    }
    /**
     * Returns call handling rules of an extension.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/answering-rule
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadUserAnsweringRules
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a custom call handling rule for a particular caller ID.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/answering-rule
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserAnsweringRules
     */ async post(createAnsweringRuleRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createAnsweringRuleRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a call handling rule by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/answering-rule/{ruleId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserAnsweringRules
     */ async get(queryParams, restRequestConfig) {
        if (this.ruleId === null) throw new Error("ruleId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a custom call handling rule for a particular caller ID.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/answering-rule/{ruleId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserAnsweringRules
     */ async put(updateAnsweringRuleRequest, restRequestConfig) {
        if (this.ruleId === null) throw new Error("ruleId must be specified.");
        const r = await this.rc.put(this.path(), updateAnsweringRuleRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a custom call handling rule by a particular ID.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/answering-rule/{ruleId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserAnsweringRules
     */ async delete(restRequestConfig) {
        if (this.ruleId === null) throw new Error("ruleId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $53925642edc3b6f2$export$2e2bcd8739ae039 = $53925642edc3b6f2$var$Index;


class $d2abcde59df97484$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/default`;
    }
    /**
     * Assigns the default role to the currently logged-in user extension.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/assigned-role/default
     * Rate Limit Group: Medium
     * App Permission: RoleManagement
     * User Permission: Users
     */ async put(restRequestConfig) {
        const r = await this.rc.put(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $d2abcde59df97484$export$2e2bcd8739ae039 = $d2abcde59df97484$var$Index;


class $7d638e8eb79b237b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/assigned-role`;
    }
    /**
     * Returns a list of roles assigned to the current extension.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/assigned-role
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadAssignedRoles
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a list of roles assigned to the current user.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/assigned-role
     * Rate Limit Group: Medium
     * App Permission: RoleManagement
     * User Permission: EditAssignedRoles
     */ async put(assignedRolesResource, restRequestConfig) {
        const r = await this.rc.put(this.path(), assignedRolesResource, undefined, restRequestConfig);
        return r.data;
    }
    default() {
        return new (0, $d2abcde59df97484$export$2e2bcd8739ae039)(this);
    }
}
var $7d638e8eb79b237b$export$2e2bcd8739ae039 = $7d638e8eb79b237b$var$Index;


class $bee54ae93f1fe58c$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/check`;
    }
    /**
     * Checks if a certain user permission is activated for a particular extension.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/authz-profile/check
     * Rate Limit Group: Light
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $bee54ae93f1fe58c$export$2e2bcd8739ae039 = $bee54ae93f1fe58c$var$Index;


class $42aad0b38e23a432$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/authz-profile`;
    }
    /**
     * Returns a list of user permissions granted at authorization procedure.
     * Please note: Some permissions may be restricted by extension type.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/authz-profile
     * Rate Limit Group: Medium
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    check() {
        return new (0, $bee54ae93f1fe58c$export$2e2bcd8739ae039)(this);
    }
}
var $42aad0b38e23a432$export$2e2bcd8739ae039 = $42aad0b38e23a432$var$Index;


class $161ed82946bf839a$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/company-pager`;
    }
    /**
     * Creates and sends an internal text message (company pager message).
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/company-pager
     * Rate Limit Group: Medium
     * App Permission: InternalMessages
     * User Permission: InternalSMS
     */ async post(createInternalTextMessageRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), createInternalTextMessageRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $161ed82946bf839a$export$2e2bcd8739ae039 = $161ed82946bf839a$var$Index;


class $f6ebd0bebb293296$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-log-sync`;
    }
    /**
     * Synchronizes the user call log records.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/call-log-sync
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: ReadCallLog
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $f6ebd0bebb293296$export$2e2bcd8739ae039 = $f6ebd0bebb293296$var$Index;


class $56bd6570da1cb7f0$var$Index {
    rc;
    _parent;
    attachmentId;
    constructor(_parent, attachmentId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.attachmentId = attachmentId;
    }
    path(withParameter = true) {
        if (withParameter && this.attachmentId !== null) return `${this._parent.path()}/content/${this.attachmentId}`;
        return `${this._parent.path()}/content`;
    }
    /**
     * Returns media content of a message attachment.
     * The content is typically an audio file (`audio/mpeg` or `audio/wav`) for voicemails,
     * TIFF or PDF for faxes and image/audio/video for MMS.
     *
     * **This API must be called via media API entry point, e.g. https://media.ringcentral.com**
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store/{messageId}/content/{attachmentId}
     * Rate Limit Group: Medium
     * App Permission: ReadMessages
     */ async get(queryParams, restRequestConfig) {
        if (this.attachmentId === null) throw new Error("attachmentId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, {
            ...restRequestConfig,
            responseType: "arraybuffer"
        });
        return r.data;
    }
}
var $56bd6570da1cb7f0$export$2e2bcd8739ae039 = $56bd6570da1cb7f0$var$Index;


class $cf141fc5f0758273$var$Index {
    rc;
    _parent;
    messageId;
    constructor(_parent, messageId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.messageId = messageId;
    }
    path(withParameter = true) {
        if (withParameter && this.messageId !== null) return `${this._parent.path()}/message-store/${this.messageId}`;
        return `${this._parent.path()}/message-store`;
    }
    /**
     * Returns a list of messages from an extension mailbox.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store
     * Rate Limit Group: Light
     * App Permission: ReadMessages
     * User Permission: ReadMessages
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes conversation(s) by conversation ID(s).
     * [Batch request syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported - maximum number
     * of IDs passed as query/path parameters is 50. Alternative syntax is supported - the user's conversations can be deleted
     * by passing multiple IDs in request body as an array of string. Maximum number of conversation IDs passed in request body
     * is 100. In this case asterisk '*' is used in the path instead of IDs.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store
     * Rate Limit Group: Medium
     * App Permission: EditMessages
     * User Permission: EditMessages
     */ async deleteAll(queryParams, restRequestConfig) {
        const r = await this.rc.delete(this.path(false), {}, queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns an individual message record or multiple records by the given message ID(s).
     * The length of inbound messages is unlimited. [Bulk syntax](https://developers.ringcentral.com/guide/basics/batch-requests)
     * is supported.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store/{messageId}
     * Rate Limit Group: Light
     * App Permission: ReadMessages
     * User Permission: ReadMessages
     */ async get(restRequestConfig) {
        if (this.messageId === null) throw new Error("messageId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates message(s) by their ID(s). Currently, only the `readStatus`
     * can be updated using this method.
     * [Bulk syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported,
     * maximum number of IDs passed as query/path parameters is 50. Alternative bulk syntax is also
     * supported - the user's messages can be updated by passing multiple IDs in request body as
     * an array of string, maximum number of IDs passed in the body is 1000. In this case asterisk '*'
     * is used in the path instead of IDs.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store/{messageId}
     * Rate Limit Group: Medium
     * App Permission: EditMessages
     * User Permission: EditMessages
     */ async put(updateMessageRequest, restRequestConfig) {
        if (this.messageId === null) throw new Error("messageId must be specified.");
        const r = await this.rc.put(this.path(), updateMessageRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes message(s) by the given message ID(s). The first call of
     * this method transfers the message to the 'Delete' status. The second call
     * transfers the deleted message to the 'Purged' status. If it is required to
     * make the message 'Purged' immediately (from the first call), then set the
     * query parameter purge to `true`.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store/{messageId}
     * Rate Limit Group: Medium
     * App Permission: EditMessages
     * User Permission: EditMessages
     */ async delete(deleteMessageBulkRequest, queryParams, restRequestConfig) {
        if (this.messageId === null) throw new Error("messageId must be specified.");
        const r = await this.rc.delete(this.path(), deleteMessageBulkRequest, queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Patches message(s) by ID(s). Currently, only updating the `readStatus` and
     * restoring deleted messages are supported through this method.
     *
     * For changing status of a message send `readStatus` set to either 'Read' or 'Unread' in request.
     * It is possible to restore a message and its attachments (if message status is 'Deleted') by sending
     * `availability` attribute set to 'Alive' in request body. If a message is already in 'Purged' state
     * then its attachments cannot be restored and the message itself is about to be physically deleted.
     *
     * Bulk syntax (both traditional and alternative one) is supported.
     *
     * HTTP Method: patch
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store/{messageId}
     * Rate Limit Group: Medium
     * App Permission: EditMessages
     * User Permission: EditMessages
     */ async patch(patchMessageRequest, restRequestConfig) {
        if (this.messageId === null) throw new Error("messageId must be specified.");
        const r = await this.rc.patch(this.path(), patchMessageRequest, undefined, restRequestConfig);
        return r.data;
    }
    content(attachmentId = null) {
        return new (0, $56bd6570da1cb7f0$export$2e2bcd8739ae039)(this, attachmentId);
    }
}
var $cf141fc5f0758273$export$2e2bcd8739ae039 = $cf141fc5f0758273$var$Index;



class $08b7a8e3681a06e2$var$Index {
    rc;
    _parent;
    scaleSize;
    constructor(_parent, scaleSize = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.scaleSize = scaleSize;
    }
    path(withParameter = true) {
        if (withParameter && this.scaleSize !== null) return `${this._parent.path()}/profile-image/${this.scaleSize}`;
        return `${this._parent.path()}/profile-image`;
    }
    /**
     * Returns a profile image of an extension.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/profile-image
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, {
            ...restRequestConfig,
            responseType: "arraybuffer"
        });
        return r.data;
    }
    /**
     * Uploads the extension profile image.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/profile-image
     * Rate Limit Group: Heavy
     * App Permission: EditExtensions
     * User Permission: EditUserInfo
     */ async post(createUserProfileImageRequest, restRequestConfig) {
        const formData = await (0, $f0364022b419ce8e$export$2e2bcd8739ae039).getFormData(createUserProfileImageRequest);
        const r = await this.rc.post(this.path(false), formData, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the extension profile image.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/profile-image
     * Rate Limit Group: Heavy
     * App Permission: EditExtensions
     * User Permission: EditUserInfo
     */ async put(updateUserProfileImageRequest, restRequestConfig) {
        const formData = await (0, $f0364022b419ce8e$export$2e2bcd8739ae039).getFormData(updateUserProfileImageRequest);
        const r = await this.rc.put(this.path(false), formData, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the user profile image.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/profile-image
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserInfo
     */ async delete(restRequestConfig) {
        const r = await this.rc.delete(this.path(false), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the scaled profile image of an extension.
     *
     * **This API must be called via media API entry point, e.g. https://media.ringcentral.com**
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/profile-image/{scaleSize}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async get(queryParams, restRequestConfig) {
        if (this.scaleSize === null) throw new Error("scaleSize must be specified.");
        const r = await this.rc.get(this.path(), queryParams, {
            ...restRequestConfig,
            responseType: "arraybuffer"
        });
        return r.data;
    }
}
var $08b7a8e3681a06e2$export$2e2bcd8739ae039 = $08b7a8e3681a06e2$var$Index;


class $3028bea3da840ac8$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sms-configuration`;
    }
    /**
     * Returns SMS configuration for the specified phone number of the extension.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/phone-number/{phoneNumberId}/sms-configuration
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $3028bea3da840ac8$export$2e2bcd8739ae039 = $3028bea3da840ac8$var$Index;


class $e899aee820bedd35$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/phone-number`;
    }
    /**
     * Returns the list of phone numbers that are used by a particular extension,
     * can be filtered by the phone number type. The returned list contains all
     * numbers which are directly mapped to the given extension. Plus the features
     * and company-level numbers that may be used when performing different operations
     * on behalf of this extension.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/phone-number
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserPhoneNumbers
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    smsConfiguration() {
        return new (0, $3028bea3da840ac8$export$2e2bcd8739ae039)(this);
    }
}
var $e899aee820bedd35$export$2e2bcd8739ae039 = $e899aee820bedd35$var$Index;


class $4835ceb79e9529a7$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/active-calls`;
    }
    /**
     * Returns records of all extension calls that are in progress, ordered
     * by start time in descending order.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/active-calls
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: ReadCallLog
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $4835ceb79e9529a7$export$2e2bcd8739ae039 = $4835ceb79e9529a7$var$Index;


class $5d9d2ef65b5ee481$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/message-sync`;
    }
    /**
     * Synchronizes messages.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-sync
     * Rate Limit Group: Light
     * App Permission: ReadMessages
     * User Permission: ReadMessages
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $5d9d2ef65b5ee481$export$2e2bcd8739ae039 = $5d9d2ef65b5ee481$var$Index;


class $ebda0040a68091c4$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/conferencing`;
    }
    /**
     * Returns information on Free Conference Calling (FCC) feature
     * for a given extension.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/conferencing
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: OrganizeConference
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the default conferencing number for the current extension.
     * The number can be selected from conferencing numbers of the current extension.
     * Updates the setting, allowing participants join the conference before host.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/conferencing
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: OrganizeConference
     */ async put(updateConferencingInfoRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), updateConferencingInfoRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $ebda0040a68091c4$export$2e2bcd8739ae039 = $ebda0040a68091c4$var$Index;


class $2e967f56b33a2b32$var$Index {
    rc;
    _parent;
    contactId;
    constructor(_parent, contactId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.contactId = contactId;
    }
    path(withParameter = true) {
        if (withParameter && this.contactId !== null) return `${this._parent.path()}/contact/${this.contactId}`;
        return `${this._parent.path()}/contact`;
    }
    /**
     * Returns the user personal contacts.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/address-book/contact
     * Rate Limit Group: Heavy
     * App Permission: ReadContacts
     * User Permission: ReadPersonalContacts
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates the user personal contact.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/address-book/contact
     * Rate Limit Group: Heavy
     * App Permission: Contacts
     * User Permission: EditPersonalContacts
     */ async post(personalContactRequest, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(false), personalContactRequest, queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the user personal contact(s).
     * [Batch request syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/address-book/contact/{contactId}
     * Rate Limit Group: Heavy
     * App Permission: ReadContacts
     * User Permission: ReadPersonalContacts
     */ async get(restRequestConfig) {
        if (this.contactId === null) throw new Error("contactId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the user personal contact(s) (full resource update).
     * [Batch request syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/address-book/contact/{contactId}
     * Rate Limit Group: Heavy
     * App Permission: Contacts
     * User Permission: EditPersonalContacts
     */ async put(personalContactRequest, queryParams, restRequestConfig) {
        if (this.contactId === null) throw new Error("contactId must be specified.");
        const r = await this.rc.put(this.path(), personalContactRequest, queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the user personal contact(s).
     * [Batch request syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/address-book/contact/{contactId}
     * Rate Limit Group: Heavy
     * App Permission: Contacts
     * User Permission: EditPersonalContacts
     */ async delete(restRequestConfig) {
        if (this.contactId === null) throw new Error("contactId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates particular values of a personal contact attributes specified in request (partial resource update). Omitted attributes will remain unchanged.
     * If any attribute is passed in request body with the null value, then this attribute value will be removed.
     *
     * HTTP Method: patch
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/address-book/contact/{contactId}
     * Rate Limit Group: Heavy
     * App Permission: Contacts
     * User Permission: EditPersonalContacts
     */ async patch(personalContactRequest, queryParams, restRequestConfig) {
        if (this.contactId === null) throw new Error("contactId must be specified.");
        const r = await this.rc.patch(this.path(), personalContactRequest, queryParams, restRequestConfig);
        return r.data;
    }
}
var $2e967f56b33a2b32$export$2e2bcd8739ae039 = $2e967f56b33a2b32$var$Index;


class $7ce5566f049e0e66$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/address-book`;
    }
    contact(contactId = null) {
        return new (0, $2e967f56b33a2b32$export$2e2bcd8739ae039)(this, contactId);
    }
}
var $7ce5566f049e0e66$export$2e2bcd8739ae039 = $7ce5566f049e0e66$var$Index;


class $bc1ae4c455255184$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-queues`;
    }
    /**
     * Updates a list of call queues where the user is an agent. This
     * is a full update request, which means that if any call queue where the user is
     * an agent is not mentioned in request, then the user is automatically removed
     * from this queue.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/call-queues
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCallQueuePresence
     */ async put(userCallQueues, restRequestConfig) {
        const r = await this.rc.put(this.path(), userCallQueues, undefined, restRequestConfig);
        return r.data;
    }
}
var $bc1ae4c455255184$export$2e2bcd8739ae039 = $bc1ae4c455255184$var$Index;


class $678641379dff129f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/caller-id`;
    }
    /**
     * Returns information on an outbound caller ID of an extension.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/caller-id
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCallerIDSettings
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates outbound caller ID information of an extension.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/caller-id
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditCallerIDSettings
     */ async put(extensionCallerIdInfoRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), extensionCallerIdInfoRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $678641379dff129f$export$2e2bcd8739ae039 = $678641379dff129f$var$Index;


class $3d5a48613d67f4a0$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/features`;
    }
    /**
     * Returns a list of supported features and the information on their
     * availability for the current extension. Particular feature(s) can
     * be checked by providing `featureId` query parameter. Multiple values
     * are supported in the format: `?featureId=Feature1&featureId=Feature2`.
     * To get only available features in order to decrease response size,
     * `availableOnly=true` query param can be specified. If a feature
     * is available for the current user, `"available": true` is returned in
     * response for the record with the corresponding feature ID. Otherwise,
     * the additional attribute `reason` is returned with the appropriate code:
     * - `ServicePlanLimitation` -  a feature is not included in account service plan;
     * - `AccountLimitation` - a feature is turned off for account;
     * - `ExtensionTypeLimitation` - a feature is not applicable for extension type;
     * - `ExtensionLimitation` - a feature is not available for extension, e.g., additional license required;
     * - `InsufficientPermissions` - required permission is not granted to the current user (not the one, who is specified in the URL, but the one who is calling this API);
     * - `ConfigurationLimitation` - a feature is turned off for extension, e.g., by account administrator.
     * - `PermissionLimitation` - a feature is unavailable due to a specific permission this extension has.
     *
     * Also, some features may have additional parameters, e.g. limits, which are returned in `params` attribute as a name-value collection:
     *
     *     {
     *       "id": "HUD",
     *       "available": true,
     *       "params": [
     *         {
     *           "name": "limitMax",
     *           "value": "100"
     *         }
     *       ]
     *     }
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/features
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $3d5a48613d67f4a0$export$2e2bcd8739ae039 = $3d5a48613d67f4a0$var$Index;


class $cf824e5c95c3ca0b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/presence`;
    }
    /**
     * Returns the presence status of an extension or several extensions by their ID(s). The `presenceStatus` is returned as Offline
     * (the parameters `telephonyStatus`, `message`, `userStatus` and `dndStatus` are not returned at all) for the following extension types:
     * Department/Announcement Only/Take Messages Only (Voicemail)/Fax User/Paging Only Group/Shared Lines Group/IVR Menu/Application Extension/Park Location.
     * If the user requests his/her own presence status, the response contains actual presence status even if the status publication is turned off.
     * [Batch request syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported. For batch requests the number of extensions
     * in one request is limited to 30. If more extensions are included in the request, the error code 400 Bad Request is returned with the logical error
     * code InvalidMultipartRequest and the corresponding message Extension Presence Info multipart request is limited to 30 extensions.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/presence
     * Rate Limit Group: Light
     * App Permission: ReadPresence
     * User Permission: ReadPresenceStatus
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates user-defined extension presence status, status message and DnD status by extension ID. Supported for regular User extensions only. The extension types listed do not support presence status: Department, Announcement Only, Take Messages Only (Voicemail), Fax User, Paging Only Group, Shared Lines Group, IVR Menu, Application Extension.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/presence
     * Rate Limit Group: Medium
     * App Permission: EditPresence
     */ async put(presenceInfoRequest, restRequestConfig) {
        const r = await this.rc.put(this.path(), presenceInfoRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $cf824e5c95c3ca0b$export$2e2bcd8739ae039 = $cf824e5c95c3ca0b$var$Index;


class $71e86fc268d31f62$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/favorite`;
    }
    /**
     * Returns the list of favorite contacts of the current extension.
     * Favorite contacts include both company contacts (extensions) and personal
     * contacts (address book records).
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/favorite
     * Rate Limit Group: Light
     * App Permission: ReadContacts
     * User Permission: ReadPersonalContacts
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the list of favorite contacts of the current extension.
     * Favorite contacts include both company contacts (extensions) and personal
     * contacts (address book records).**Please note**: Currently personal address
     * book size is limited to 10 000 contacts.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/favorite
     * Rate Limit Group: Medium
     * App Permission: Contacts
     * User Permission: EditPersonalContacts
     */ async put(favoriteCollection, restRequestConfig) {
        const r = await this.rc.put(this.path(), favoriteCollection, undefined, restRequestConfig);
        return r.data;
    }
}
var $71e86fc268d31f62$export$2e2bcd8739ae039 = $71e86fc268d31f62$var$Index;


class $2bf092c5c8ee367d$var$Index {
    rc;
    _parent;
    ringoutId;
    constructor(_parent, ringoutId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.ringoutId = ringoutId;
    }
    path(withParameter = true) {
        if (withParameter && this.ringoutId !== null) return `${this._parent.path()}/ring-out/${this.ringoutId}`;
        return `${this._parent.path()}/ring-out`;
    }
    /**
     * Makes a 2-legged RingOut call.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/ring-out
     * Rate Limit Group: Heavy
     * App Permission: RingOut
     */ async post(makeRingOutRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), makeRingOutRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a status of a 2-legged RingOut call.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/ring-out/{ringoutId}
     * Rate Limit Group: Light
     * App Permission: RingOut
     */ async get(restRequestConfig) {
        if (this.ringoutId === null) throw new Error("ringoutId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Cancels a 2-legged RingOut call.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/ring-out/{ringoutId}
     * Rate Limit Group: Heavy
     * App Permission: RingOut
     */ async delete(restRequestConfig) {
        if (this.ringoutId === null) throw new Error("ringoutId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $2bf092c5c8ee367d$export$2e2bcd8739ae039 = $2bf092c5c8ee367d$var$Index;


class $7a4d3f248d58689f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/content`;
    }
    /**
     * Returns extension-level greeting media contents.
     *
     * **This API must be called via media API entry point, e.g. https://media.ringcentral.com**
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/greeting/{greetingId}/content
     * Rate Limit Group: Heavy
     * App Permission: ReadAccounts
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, {
            ...restRequestConfig,
            responseType: "arraybuffer"
        });
        return r.data;
    }
}
var $7a4d3f248d58689f$export$2e2bcd8739ae039 = $7a4d3f248d58689f$var$Index;



class $22c2f2c6996aeb4b$var$Index {
    rc;
    _parent;
    greetingId;
    constructor(_parent, greetingId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.greetingId = greetingId;
    }
    path(withParameter = true) {
        if (withParameter && this.greetingId !== null) return `${this._parent.path()}/greeting/${this.greetingId}`;
        return `${this._parent.path()}/greeting`;
    }
    /**
     * Creates custom greeting for an extension user.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/greeting
     * Rate Limit Group: Heavy
     * App Permission: EditExtensions
     * User Permission: EditUserAnsweringRules
     */ async post(createCustomUserGreetingRequest, queryParams, restRequestConfig) {
        const formData = await (0, $f0364022b419ce8e$export$2e2bcd8739ae039).getFormData(createCustomUserGreetingRequest);
        const r = await this.rc.post(this.path(false), formData, queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a custom user greeting by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/greeting/{greetingId}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadUserInfo
     */ async get(restRequestConfig) {
        if (this.greetingId === null) throw new Error("greetingId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    content() {
        return new (0, $7a4d3f248d58689f$export$2e2bcd8739ae039)(this);
    }
}
var $22c2f2c6996aeb4b$export$2e2bcd8739ae039 = $22c2f2c6996aeb4b$var$Index;


class $ea24285e2e13fb3e$var$Index {
    rc;
    _parent;
    callRecordId;
    constructor(_parent, callRecordId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.callRecordId = callRecordId;
    }
    path(withParameter = true) {
        if (withParameter && this.callRecordId !== null) return `${this._parent.path()}/call-log/${this.callRecordId}`;
        return `${this._parent.path()}/call-log`;
    }
    /**
     * Returns call log records filtered by parameters specified.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/call-log
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: ReadCallLog
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes filtered call log records.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/call-log
     * Rate Limit Group: Heavy
     * App Permission: EditCallLog
     * User Permission: EditCallLog
     */ async delete(queryParams, restRequestConfig) {
        const r = await this.rc.delete(this.path(false), {}, queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns call log records by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/call-log/{callRecordId}
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: ReadCallLog
     */ async get(queryParams, restRequestConfig) {
        if (this.callRecordId === null) throw new Error("callRecordId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $ea24285e2e13fb3e$export$2e2bcd8739ae039 = $ea24285e2e13fb3e$var$Index;


class $d1c21e341b861b26$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/device`;
    }
    /**
     * Returns devices of an extension or multiple extensions by their ID(s).
     * [Batch request syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/device
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserDevices
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $d1c21e341b861b26$export$2e2bcd8739ae039 = $d1c21e341b861b26$var$Index;


class $71df5e10f5ed4a1c$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/grant`;
    }
    /**
     * Returns a list of extensions including information on grants given to the current extension towards them.
     * Currently the list of grants includes: picking up a call, call monitoring, calling or receiving a call on behalf
     * of somebody, call delegation and calling paging groups.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/grant
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $71df5e10f5ed4a1c$export$2e2bcd8739ae039 = $71df5e10f5ed4a1c$var$Index;



class $0c61877749eb761b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/mms`;
    }
    /**
     * Creates and sends a new media message or multiple messages. Sending MMS
     * messages simultaneously to different recipients is limited up to 50
     * requests per minute; relevant for all client applications.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/mms
     * Rate Limit Group: Medium
     * App Permission: SMS
     * User Permission: OutboundSMS
     */ async post(createMMSMessage, restRequestConfig) {
        const formData = await (0, $f0364022b419ce8e$export$2e2bcd8739ae039).getFormData(createMMSMessage);
        const r = await this.rc.post(this.path(), formData, undefined, restRequestConfig);
        return r.data;
    }
}
var $0c61877749eb761b$export$2e2bcd8739ae039 = $0c61877749eb761b$var$Index;



class $b5fcd3f38eecbdcb$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sms`;
    }
    /**
     * Creates and sends a new text message or multiple messages. You can send SMS
     * messages simultaneously to different recipients up to 40 requests per minute;
     * this limitation is relevant for all client applications. Sending and receiving
     * SMS is available for Toll-Free Numbers within the USA. You can send up to
     * 10 attachments in a single MMS message; the size of all attachments linked
     * is limited up to 1500000 bytes.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/sms
     * Rate Limit Group: Medium
     * App Permission: SMS
     * User Permission: OutboundSMS
     */ async post(createSMSMessage, restRequestConfig) {
        const formData = await (0, $f0364022b419ce8e$export$2e2bcd8739ae039).getFormData(createSMSMessage);
        const r = await this.rc.post(this.path(), formData, undefined, restRequestConfig);
        return r.data;
    }
}
var $b5fcd3f38eecbdcb$export$2e2bcd8739ae039 = $b5fcd3f38eecbdcb$var$Index;



class $6576830d121964fb$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/fax`;
    }
    /**
     * Creates and sends/re-sends a fax message. Re-send can be implemented
     * if sending has failed. Fax attachment size (both single and total) is
     * limited to 50Mb.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/fax
     * Rate Limit Group: Heavy
     * App Permission: Faxes
     * User Permission: OutboundFaxes
     */ async post(createFaxMessageRequest, restRequestConfig) {
        const formData = await (0, $f0364022b419ce8e$export$2e2bcd8739ae039).getFormData(createFaxMessageRequest);
        const r = await this.rc.post(this.path(), formData, undefined, restRequestConfig);
        return r.data;
    }
}
var $6576830d121964fb$export$2e2bcd8739ae039 = $6576830d121964fb$var$Index;


class $ae49820bc9576e3c$var$Index {
    rc;
    _parent;
    extensionId;
    constructor(_parent, extensionId = "~"){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.extensionId = extensionId;
    }
    path(withParameter = true) {
        if (withParameter && this.extensionId !== null) return `${this._parent.path()}/extension/${this.extensionId}`;
        return `${this._parent.path()}/extension`;
    }
    /**
     * Returns the list of extensions created for a particular account.
     * All types of extensions are included in this list.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates an extension.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: AddRemoveUsers
     */ async post(extensionCreationRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), extensionCreationRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns basic information about a particular extension of an account.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(restRequestConfig) {
        if (this.extensionId === null) throw new Error("extensionId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the user settings.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserInfo OR EditUserCredentials
     */ async put(extensionUpdateRequest, restRequestConfig) {
        if (this.extensionId === null) throw new Error("extensionId must be specified.");
        const r = await this.rc.put(this.path(), extensionUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
    fax() {
        return new (0, $6576830d121964fb$export$2e2bcd8739ae039)(this);
    }
    sms() {
        return new (0, $b5fcd3f38eecbdcb$export$2e2bcd8739ae039)(this);
    }
    mms() {
        return new (0, $0c61877749eb761b$export$2e2bcd8739ae039)(this);
    }
    grant() {
        return new (0, $71df5e10f5ed4a1c$export$2e2bcd8739ae039)(this);
    }
    device() {
        return new (0, $d1c21e341b861b26$export$2e2bcd8739ae039)(this);
    }
    callLog(callRecordId = null) {
        return new (0, $ea24285e2e13fb3e$export$2e2bcd8739ae039)(this, callRecordId);
    }
    greeting(greetingId = null) {
        return new (0, $22c2f2c6996aeb4b$export$2e2bcd8739ae039)(this, greetingId);
    }
    ringOut(ringoutId = null) {
        return new (0, $2bf092c5c8ee367d$export$2e2bcd8739ae039)(this, ringoutId);
    }
    favorite() {
        return new (0, $71e86fc268d31f62$export$2e2bcd8739ae039)(this);
    }
    presence() {
        return new (0, $cf824e5c95c3ca0b$export$2e2bcd8739ae039)(this);
    }
    features() {
        return new (0, $3d5a48613d67f4a0$export$2e2bcd8739ae039)(this);
    }
    callerId() {
        return new (0, $678641379dff129f$export$2e2bcd8739ae039)(this);
    }
    callQueues() {
        return new (0, $bc1ae4c455255184$export$2e2bcd8739ae039)(this);
    }
    addressBook() {
        return new (0, $7ce5566f049e0e66$export$2e2bcd8739ae039)(this);
    }
    conferencing() {
        return new (0, $ebda0040a68091c4$export$2e2bcd8739ae039)(this);
    }
    messageSync() {
        return new (0, $5d9d2ef65b5ee481$export$2e2bcd8739ae039)(this);
    }
    activeCalls() {
        return new (0, $4835ceb79e9529a7$export$2e2bcd8739ae039)(this);
    }
    phoneNumber() {
        return new (0, $e899aee820bedd35$export$2e2bcd8739ae039)(this);
    }
    profileImage(scaleSize = null) {
        return new (0, $08b7a8e3681a06e2$export$2e2bcd8739ae039)(this, scaleSize);
    }
    messageStore(messageId = null) {
        return new (0, $cf141fc5f0758273$export$2e2bcd8739ae039)(this, messageId);
    }
    callLogSync() {
        return new (0, $f6ebd0bebb293296$export$2e2bcd8739ae039)(this);
    }
    companyPager() {
        return new (0, $161ed82946bf839a$export$2e2bcd8739ae039)(this);
    }
    authzProfile() {
        return new (0, $42aad0b38e23a432$export$2e2bcd8739ae039)(this);
    }
    assignedRole() {
        return new (0, $7d638e8eb79b237b$export$2e2bcd8739ae039)(this);
    }
    answeringRule(ruleId = null) {
        return new (0, $53925642edc3b6f2$export$2e2bcd8739ae039)(this, ruleId);
    }
    businessHours() {
        return new (0, $0a53f5ce1bf590f2$export$2e2bcd8739ae039)(this);
    }
    callerBlocking() {
        return new (0, $5b88d794d00c51b1$export$2e2bcd8739ae039)(this);
    }
    assignableRoles() {
        return new (0, $ca23faab53e7eb3e$export$2e2bcd8739ae039)(this);
    }
    unifiedPresence() {
        return new (0, $febc66dc8cb20d1b$export$2e2bcd8739ae039)(this);
    }
    forwardingNumber(forwardingNumberId = null) {
        return new (0, $f12c6b19027a78fb$export$2e2bcd8739ae039)(this, forwardingNumberId);
    }
    addressBookSync() {
        return new (0, $0fdec99db70fa842$export$2e2bcd8739ae039)(this);
    }
    overflowSettings() {
        return new (0, $fe209a5389c31ea5$export$2e2bcd8739ae039)(this);
    }
    administeredSites() {
        return new (0, $4cf9ece4803c9572$export$2e2bcd8739ae039)(this);
    }
    emergencyLocations(locationId = null) {
        return new (0, $5ffaf22b7ef8f1f7$export$2e2bcd8739ae039)(this, locationId);
    }
    videoConfiguration() {
        return new (0, $c2b86d98aa0e8e84$export$2e2bcd8739ae039)(this);
    }
    callQueuePresence() {
        return new (0, $c454efdb7d2ae622$export$2e2bcd8739ae039)(this);
    }
    notificationSettings() {
        return new (0, $035326feaa6e3b93$export$2e2bcd8739ae039)(this);
    }
    messageStoreTemplates(templateId = null) {
        return new (0, $6ab06b6214af6c5c$export$2e2bcd8739ae039)(this, templateId);
    }
}
var $ae49820bc9576e3c$export$2e2bcd8739ae039 = $ae49820bc9576e3c$var$Index;


class $d3979dbc1d1661ba$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/content`;
    }
    /**
     * Returns media content of a call recording (`audio/mpeg` or `audio/wav`)
     *
     * **This API must be called via media API entry point, e.g. https://media.ringcentral.com**
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/recording/{recordingId}/content
     * Rate Limit Group: Heavy
     * App Permission: ReadCallRecording
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, {
            ...restRequestConfig,
            responseType: "arraybuffer"
        });
        return r.data;
    }
}
var $d3979dbc1d1661ba$export$2e2bcd8739ae039 = $d3979dbc1d1661ba$var$Index;


class $ca9838ec9283bf46$var$Index {
    rc;
    _parent;
    recordingId;
    constructor(_parent, recordingId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.recordingId = recordingId;
    }
    path(withParameter = true) {
        if (withParameter && this.recordingId !== null) return `${this._parent.path()}/recording/${this.recordingId}`;
        return `${this._parent.path()}/recording`;
    }
    /**
     * Returns call recordings by ID(s).
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/recording/{recordingId}
     * Rate Limit Group: Heavy
     * App Permission: ReadCallRecording
     * User Permission: ReadCallRecording
     */ async get(restRequestConfig) {
        if (this.recordingId === null) throw new Error("recordingId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    content() {
        return new (0, $d3979dbc1d1661ba$export$2e2bcd8739ae039)(this);
    }
}
var $ca9838ec9283bf46$export$2e2bcd8739ae039 = $ca9838ec9283bf46$var$Index;


class $2ac43a84df69cf6d$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/conference`;
    }
    /**
     * Initiates a conference call session.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/conference
     * Rate Limit Group: Heavy
     * App Permission: CallControl
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $2ac43a84df69cf6d$export$2e2bcd8739ae039 = $2ac43a84df69cf6d$var$Index;


class $f89d5435b13f146b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-out`;
    }
    /**
     * Creates a new outbound call out session. Currently this method is supported for Softphone/Hardphone only, since device IDs for WebRTC/Mobile apps cannot be obtained.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/call-out
     * Rate Limit Group: Heavy
     * App Permission: CallControl
     */ async post(makeCallOutRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), makeCallOutRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $f89d5435b13f146b$export$2e2bcd8739ae039 = $f89d5435b13f146b$var$Index;


class $cc4fdd357c2b1570$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/supervise`;
    }
    /**
     * Allows monitoring a call session in 'Listen' mode. Input parameters should contain internal identifiers of a monitored user and a supervisor's device. Call session should be specified in path. Please note that this method supports single channel audio flow, which means that audio of both call participants is mixed and delivered to the supervisor in single audio channel. Currently this method is supported for Softphone/Hardphone only, since device IDs for WebRTC/Mobile apps cannot be obtained.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/supervise
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(superviseCallSessionRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), superviseCallSessionRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $cc4fdd357c2b1570$export$2e2bcd8739ae039 = $cc4fdd357c2b1570$var$Index;


class $9b1c9ab90a154962$var$Index {
    rc;
    _parent;
    recordingId;
    constructor(_parent, recordingId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.recordingId = recordingId;
    }
    path(withParameter = true) {
        if (withParameter && this.recordingId !== null) return `${this._parent.path()}/recordings/${this.recordingId}`;
        return `${this._parent.path()}/recordings`;
    }
    /**
     * Starts a new call recording for a call party.
     * *Please note* this API does not allow conference calls to be recorded.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/recordings
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(false), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Pause/resume recording
     * HTTP Method: patch
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/recordings/{recordingId}
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async patch(callRecordingUpdate, queryParams, restRequestConfig) {
        if (this.recordingId === null) throw new Error("recordingId must be specified.");
        const r = await this.rc.patch(this.path(), callRecordingUpdate, queryParams, restRequestConfig);
        return r.data;
    }
}
var $9b1c9ab90a154962$export$2e2bcd8739ae039 = $9b1c9ab90a154962$var$Index;


class $fc5154a512b4f054$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/supervise`;
    }
    /**
     * Allows to monitor a call party in 'Listen' mode. Input parameters
     * are extension number of a monitored user and internal identifier of a supervisor's
     * device. Call session and party identifiers should be specified in path. Please
     * note that for this method dual channel audio flow is supported, which means
     * that you need to make one more request for monitoring the second participant
     * of a call. And as a result of each monitoring request the client receives
     * SIP invite with the following header `p-rc-api-monitoring-ids` containing
     * IDs of the monitored party and session. The flow is supported for calls with
     * no more than 2 participants. Currently, this method is supported for Softphone/Hardphone devices
     * only, since device IDs for WebRTC/Mobile apps cannot be obtained.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/supervise
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(partySuperviseRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), partySuperviseRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $fc5154a512b4f054$export$2e2bcd8739ae039 = $fc5154a512b4f054$var$Index;


class $ec0009810623a6c6$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bring-in`;
    }
    /**
     * Adds a new party to the call session by bringing in an established
     * SIP call connection. The maximum number of parties to bring in is 10; only
     * 1 call party can be added per request. Currently, the method is supported for
     * sessions of the `Conference` origin only.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/bring-in
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(addPartyRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), addPartyRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $ec0009810623a6c6$export$2e2bcd8739ae039 = $ec0009810623a6c6$var$Index;


class $323a629f39da251c$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/transfer`;
    }
    /**
     * Transfers an answered call to the specified call party. Applicable for a call session in "Answered" or "Hold" state.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/transfer
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(transferTarget, restRequestConfig) {
        const r = await this.rc.post(this.path(), transferTarget, undefined, restRequestConfig);
        return r.data;
    }
}
var $323a629f39da251c$export$2e2bcd8739ae039 = $323a629f39da251c$var$Index;


class $592f15c3637e4dd6$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/forward`;
    }
    /**
     * Forwards a non-answered incoming call to the specified call party. Applicable for a call session in "Setup" or "Proceeding" state.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/forward
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(forwardTarget, restRequestConfig) {
        const r = await this.rc.post(this.path(), forwardTarget, undefined, restRequestConfig);
        return r.data;
    }
}
var $592f15c3637e4dd6$export$2e2bcd8739ae039 = $592f15c3637e4dd6$var$Index;


class $30c5a62c72074e0d$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/pickup`;
    }
    /**
     * Picks up a call parked to the specified park location.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/pickup
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(pickupTarget, restRequestConfig) {
        const r = await this.rc.post(this.path(), pickupTarget, undefined, restRequestConfig);
        return r.data;
    }
}
var $30c5a62c72074e0d$export$2e2bcd8739ae039 = $30c5a62c72074e0d$var$Index;


class $244f40735cf6dd22$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/answer`;
    }
    /**
     * Answers a call on a certain device by passing the corresponding device ID in request body. Supported for call forwarding, call transfer, call flip and call queues.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/answer
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(answerTarget, restRequestConfig) {
        const r = await this.rc.post(this.path(), answerTarget, undefined, restRequestConfig);
        return r.data;
    }
}
var $244f40735cf6dd22$export$2e2bcd8739ae039 = $244f40735cf6dd22$var$Index;


class $6b546c6a7b7e4e5b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/reject`;
    }
    /**
     * Rejects an inbound call in a "Setup" or "Proceeding" state
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/reject
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $6b546c6a7b7e4e5b$export$2e2bcd8739ae039 = $6b546c6a7b7e4e5b$var$Index;


class $5abd4fa29f921452$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/ignore`;
    }
    /**
     * Ignores a call to a call queue agent in `Setup` or `Proceeding` state.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/ignore
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(ignoreRequestBody, restRequestConfig) {
        const r = await this.rc.post(this.path(), ignoreRequestBody, undefined, restRequestConfig);
        return r.data;
    }
}
var $5abd4fa29f921452$export$2e2bcd8739ae039 = $5abd4fa29f921452$var$Index;


class $b7b2b2209f36e7dc$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bridge`;
    }
    /**
     * Allows the user to connect multiple call session participants over a conference call bridge.
     * The current active call session ID and party ID of the user within this session should be specified
     * in path; the bridged call session ID and party ID of the user within that session should be specified
     * in request body. Thus, the user connects participants of two sessions into the one conference call
     * using his/her own party IDs from both sessions."
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/bridge
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(bridgeTargetRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), bridgeTargetRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $b7b2b2209f36e7dc$export$2e2bcd8739ae039 = $b7b2b2209f36e7dc$var$Index;


class $b1ad3d4f08dc4cf2$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/unhold`;
    }
    /**
     * Brings a party back into a call and stops to play Hold Music. There is a known limitation for Hold API - hold via REST API doesn't work with hold placed via RingCentral apps or HardPhone. It means that if you muted participant via Call Control API and RingCentral Desktop app, then you need to un-hold both endpoints to remove Hold Music and bring media back.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/unhold
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $b1ad3d4f08dc4cf2$export$2e2bcd8739ae039 = $b1ad3d4f08dc4cf2$var$Index;


class $40eb469e3c97ecaa$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/reply`;
    }
    /**
     * Replies with text/pattern without picking up a call.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/reply
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(callPartyReply, restRequestConfig) {
        const r = await this.rc.post(this.path(), callPartyReply, undefined, restRequestConfig);
        return r.data;
    }
}
var $40eb469e3c97ecaa$export$2e2bcd8739ae039 = $40eb469e3c97ecaa$var$Index;


class $b18e663ca6888444$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/hold`;
    }
    /**
     * Puts the party to stand-alone mode and starts to play Hold Music according to configuration & state to peers. There is a known limitation for Hold API - hold via REST API doesn't work with hold placed via RingCentral apps or HardPhone. It means that if you muted participant via Call Control API and RingCentral Desktop app, then you need to un-hold both endpoints to remove Hold Music and bring media back.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/hold
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(holdCallPartyRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), holdCallPartyRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $b18e663ca6888444$export$2e2bcd8739ae039 = $b18e663ca6888444$var$Index;


class $f225f8a96177c16d$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/flip`;
    }
    /**
     * Performs call flip procedure by holding opposite party and calling to the specified target
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/flip
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(callPartyFlip, restRequestConfig) {
        const r = await this.rc.post(this.path(), callPartyFlip, undefined, restRequestConfig);
        return r.data;
    }
}
var $f225f8a96177c16d$export$2e2bcd8739ae039 = $f225f8a96177c16d$var$Index;


class $7bbf770d968133e6$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/park`;
    }
    /**
     * Parks a call to a virtual location from where it can further be retrieved by any user from any phone of the system. The call session and call party identifiers should be specified in path. Currently, the users can park only their own incoming calls. Up to 50 calls can be parked simultaneously. Park location starts with asterisk (*) and ranges 801-899.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}/park
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $7bbf770d968133e6$export$2e2bcd8739ae039 = $7bbf770d968133e6$var$Index;


class $8bcfa172b783a713$var$Index {
    rc;
    _parent;
    partyId;
    constructor(_parent, partyId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.partyId = partyId;
    }
    path(withParameter = true) {
        if (withParameter && this.partyId !== null) return `${this._parent.path()}/parties/${this.partyId}`;
        return `${this._parent.path()}/parties`;
    }
    /**
     * Returns a call party status by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async get(restRequestConfig) {
        if (this.partyId === null) throw new Error("partyId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a party from a call session by ID. A party can be deleted only if supervised or parked. It is possible to delete only one conference participant per request.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async delete(restRequestConfig) {
        if (this.partyId === null) throw new Error("partyId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Modifies a call party by ID. There is a known limitation for Mute scenario - mute via REST API doesn't work with mute placed via RingCentral apps or HardPhone. It means that if you muted participant via Call Control API and RingCentral Desktop app you need to unmute both endpoints to bring the media back.
     * HTTP Method: patch
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}/parties/{partyId}
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async patch(partyUpdateRequest, restRequestConfig) {
        if (this.partyId === null) throw new Error("partyId must be specified.");
        const r = await this.rc.patch(this.path(), partyUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
    park() {
        return new (0, $7bbf770d968133e6$export$2e2bcd8739ae039)(this);
    }
    flip() {
        return new (0, $f225f8a96177c16d$export$2e2bcd8739ae039)(this);
    }
    hold() {
        return new (0, $b18e663ca6888444$export$2e2bcd8739ae039)(this);
    }
    reply() {
        return new (0, $40eb469e3c97ecaa$export$2e2bcd8739ae039)(this);
    }
    unhold() {
        return new (0, $b1ad3d4f08dc4cf2$export$2e2bcd8739ae039)(this);
    }
    bridge() {
        return new (0, $b7b2b2209f36e7dc$export$2e2bcd8739ae039)(this);
    }
    ignore() {
        return new (0, $5abd4fa29f921452$export$2e2bcd8739ae039)(this);
    }
    reject() {
        return new (0, $6b546c6a7b7e4e5b$export$2e2bcd8739ae039)(this);
    }
    answer() {
        return new (0, $244f40735cf6dd22$export$2e2bcd8739ae039)(this);
    }
    pickup() {
        return new (0, $30c5a62c72074e0d$export$2e2bcd8739ae039)(this);
    }
    forward() {
        return new (0, $592f15c3637e4dd6$export$2e2bcd8739ae039)(this);
    }
    transfer() {
        return new (0, $323a629f39da251c$export$2e2bcd8739ae039)(this);
    }
    bringIn() {
        return new (0, $ec0009810623a6c6$export$2e2bcd8739ae039)(this);
    }
    supervise() {
        return new (0, $fc5154a512b4f054$export$2e2bcd8739ae039)(this);
    }
    recordings(recordingId = null) {
        return new (0, $9b1c9ab90a154962$export$2e2bcd8739ae039)(this, recordingId);
    }
}
var $8bcfa172b783a713$export$2e2bcd8739ae039 = $8bcfa172b783a713$var$Index;


class $b9c2edc43b9b8138$var$Index {
    rc;
    _parent;
    telephonySessionId;
    constructor(_parent, telephonySessionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.telephonySessionId = telephonySessionId;
    }
    path(withParameter = true) {
        if (withParameter && this.telephonySessionId !== null) return `${this._parent.path()}/sessions/${this.telephonySessionId}`;
        return `${this._parent.path()}/sessions`;
    }
    /**
     * Returns the status of a call session by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async get(queryParams, restRequestConfig) {
        if (this.telephonySessionId === null) throw new Error("telephonySessionId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Drops a call session.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/telephony/sessions/{telephonySessionId}
     * Rate Limit Group: Light
     * App Permission: CallControl
     */ async delete(restRequestConfig) {
        if (this.telephonySessionId === null) throw new Error("telephonySessionId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    parties(partyId = null) {
        return new (0, $8bcfa172b783a713$export$2e2bcd8739ae039)(this, partyId);
    }
    supervise() {
        return new (0, $cc4fdd357c2b1570$export$2e2bcd8739ae039)(this);
    }
}
var $b9c2edc43b9b8138$export$2e2bcd8739ae039 = $b9c2edc43b9b8138$var$Index;


class $be1cbaa9f11055e2$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/telephony`;
    }
    sessions(telephonySessionId = null) {
        return new (0, $b9c2edc43b9b8138$export$2e2bcd8739ae039)(this, telephonySessionId);
    }
    callOut() {
        return new (0, $f89d5435b13f146b$export$2e2bcd8739ae039)(this);
    }
    conference() {
        return new (0, $2ac43a84df69cf6d$export$2e2bcd8739ae039)(this);
    }
}
var $be1cbaa9f11055e2$export$2e2bcd8739ae039 = $be1cbaa9f11055e2$var$Index;


class $e8a6a6331b76ed22$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/federation`;
    }
    /**
     * Returns information on a federation and associated accounts.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/directory/federation
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $e8a6a6331b76ed22$export$2e2bcd8739ae039 = $e8a6a6331b76ed22$var$Index;


class $f3830b30a235fa9d$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/search`;
    }
    /**
     * Returns contact information on corporate users of federated accounts according to the specified filtering and ordering.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/directory/entries/search
     * Rate Limit Group: Heavy
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async post(searchDirectoryEntriesRequest, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), searchDirectoryEntriesRequest, queryParams, restRequestConfig);
        return r.data;
    }
}
var $f3830b30a235fa9d$export$2e2bcd8739ae039 = $f3830b30a235fa9d$var$Index;


class $fad87fc29c2dd7ca$var$Index {
    rc;
    _parent;
    entryId;
    constructor(_parent, entryId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.entryId = entryId;
    }
    path(withParameter = true) {
        if (withParameter && this.entryId !== null) return `${this._parent.path()}/entries/${this.entryId}`;
        return `${this._parent.path()}/entries`;
    }
    /**
     * Returns contact information on corporate users of federated accounts. Please note: 1. `User`, `DigitalUser`, `VirtualUser` and `FaxUser` types are returned as `User` type. 2. `ApplicationExtension` type is not returned. 3. Only extensions in `Enabled`, `Disabled` and `NotActivated` state are returned.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/directory/entries
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns contact information on a particular corporate user of a federated account.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/directory/entries/{entryId}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async get(queryParams, restRequestConfig) {
        if (this.entryId === null) throw new Error("entryId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    search() {
        return new (0, $f3830b30a235fa9d$export$2e2bcd8739ae039)(this);
    }
}
var $fad87fc29c2dd7ca$export$2e2bcd8739ae039 = $fad87fc29c2dd7ca$var$Index;


class $6fac1ed1c882e147$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/directory`;
    }
    entries(entryId = null) {
        return new (0, $fad87fc29c2dd7ca$export$2e2bcd8739ae039)(this, entryId);
    }
    federation() {
        return new (0, $e8a6a6331b76ed22$export$2e2bcd8739ae039)(this);
    }
}
var $6fac1ed1c882e147$export$2e2bcd8739ae039 = $6fac1ed1c882e147$var$Index;


class $579574d21a237181$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/content`;
    }
    /**
     * Returns account-level greeting media contents.
     *
     * **This API must be called via media API entry point, e.g. https://media.ringcentral.com**
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/greeting/{greetingId}/content
     * Rate Limit Group: Heavy
     * App Permission: ReadAccounts
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, {
            ...restRequestConfig,
            responseType: "arraybuffer"
        });
        return r.data;
    }
}
var $579574d21a237181$export$2e2bcd8739ae039 = $579574d21a237181$var$Index;



class $8860aa68de314047$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/greeting`;
    }
    /**
     * Creates a custom company greeting.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/greeting
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: ReadUserInfo
     */ async post(createCompanyGreetingRequest, restRequestConfig) {
        const formData = await (0, $f0364022b419ce8e$export$2e2bcd8739ae039).getFormData(createCompanyGreetingRequest);
        const r = await this.rc.post(this.path(), formData, undefined, restRequestConfig);
        return r.data;
    }
    content() {
        return new (0, $579574d21a237181$export$2e2bcd8739ae039)(this);
    }
}
var $8860aa68de314047$export$2e2bcd8739ae039 = $8860aa68de314047$var$Index;


class $bb497a955492804f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/presence`;
    }
    /**
     * Returns presence status of all extensions of an account. Please note: The presenceStatus is returned as Offline (the parameters telephonyStatus, message, userStatus and dndStatus are not returned at all) for the following extension types: Department, Announcement Only, Voicemail (Take Messages Only), Fax User, Paging Only Group, Shared Lines Group, IVR Menu, Application Extension.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/presence
     * Rate Limit Group: Heavy
     * App Permission: ReadPresence
     * User Permission: ReadPresenceStatus
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $bb497a955492804f$export$2e2bcd8739ae039 = $bb497a955492804f$var$Index;


class $6d2cdc16a91cf99b$var$Index {
    rc;
    _parent;
    callRecordId;
    constructor(_parent, callRecordId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.callRecordId = callRecordId;
    }
    path(withParameter = true) {
        if (withParameter && this.callRecordId !== null) return `${this._parent.path()}/call-log/${this.callRecordId}`;
        return `${this._parent.path()}/call-log`;
    }
    /**
     * Returns call log records filtered by parameters specified.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-log
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: FullCompanyCallLog
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns individual call log record(s) by ID.
     * [Batch syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-log/{callRecordId}
     * Rate Limit Group: Heavy
     * App Permission: ReadCallLog
     * User Permission: FullCompanyCallLog
     */ async get(queryParams, restRequestConfig) {
        if (this.callRecordId === null) throw new Error("callRecordId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $6d2cdc16a91cf99b$export$2e2bcd8739ae039 = $6d2cdc16a91cf99b$var$Index;


class $923cc12695015711$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/statuses`;
    }
    /**
     * Retrieves a set of message counts by message status and error codes filtered by dates, batchId and message direction.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/a2p-sms/statuses
     * Rate Limit Group: Light
     * App Permission: A2PSMS
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $923cc12695015711$export$2e2bcd8739ae039 = $923cc12695015711$var$Index;


class $1cbb0ab16ac456c4$var$Index {
    rc;
    _parent;
    messageId;
    constructor(_parent, messageId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.messageId = messageId;
    }
    path(withParameter = true) {
        if (withParameter && this.messageId !== null) return `${this._parent.path()}/messages/${this.messageId}`;
        return `${this._parent.path()}/messages`;
    }
    /**
     * Returns the list of outbound/inbound A2P messages sent from/to A2P phone numbers of the current account. The list can be filtered by message batch ID and/or phone number.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/a2p-sms/messages
     * Rate Limit Group: Light
     * App Permission: A2PSMS
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the details of an A2P SMS message by ID.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/a2p-sms/messages/{messageId}
     * Rate Limit Group: Light
     * App Permission: A2PSMS
     */ async get(restRequestConfig) {
        if (this.messageId === null) throw new Error("messageId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $1cbb0ab16ac456c4$export$2e2bcd8739ae039 = $1cbb0ab16ac456c4$var$Index;


class $bf5d7233fc09a095$var$Index {
    rc;
    _parent;
    batchId;
    constructor(_parent, batchId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.batchId = batchId;
    }
    path(withParameter = true) {
        if (withParameter && this.batchId !== null) return `${this._parent.path()}/batches/${this.batchId}`;
        return `${this._parent.path()}/batches`;
    }
    /**
     * Returns the list of A2P batches sent from the current account.
     * The list can be filtered by message batch ID and/or from phone number.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/a2p-sms/batches
     * Rate Limit Group: Light
     * App Permission: A2PSMS
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Allows to send high volume of A2P (Application-to-Person) SMS messages
     * (in message batches). Only phone number with the `A2PSmsSender` feature can
     * be used as a sender.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/a2p-sms/batches
     * Rate Limit Group: Light
     * App Permission: A2PSMS
     */ async post(messageBatchCreateRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), messageBatchCreateRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns information on a message batch.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/a2p-sms/batches/{batchId}
     * Rate Limit Group: Light
     * App Permission: A2PSMS
     */ async get(restRequestConfig) {
        if (this.batchId === null) throw new Error("batchId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $bf5d7233fc09a095$export$2e2bcd8739ae039 = $bf5d7233fc09a095$var$Index;


class $28438444b7fc4906$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/a2p-sms`;
    }
    batches(batchId = null) {
        return new (0, $bf5d7233fc09a095$export$2e2bcd8739ae039)(this, batchId);
    }
    messages(messageId = null) {
        return new (0, $1cbb0ab16ac456c4$export$2e2bcd8739ae039)(this, messageId);
    }
    statuses() {
        return new (0, $923cc12695015711$export$2e2bcd8739ae039)(this);
    }
}
var $28438444b7fc4906$export$2e2bcd8739ae039 = $28438444b7fc4906$var$Index;


class $ee4bc81c40793925$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/emergency`;
    }
    /**
     * Updates account device emergency information.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/device/{deviceId}/emergency
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyDevices
     */ async put(accountDeviceUpdate, restRequestConfig) {
        const r = await this.rc.put(this.path(), accountDeviceUpdate, undefined, restRequestConfig);
        return r.data;
    }
}
var $ee4bc81c40793925$export$2e2bcd8739ae039 = $ee4bc81c40793925$var$Index;


class $41601daf0c923f20$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sip-info`;
    }
    /**
     * Returns device SIP information.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/device/{deviceId}/sip-info
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyDevices
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $41601daf0c923f20$export$2e2bcd8739ae039 = $41601daf0c923f20$var$Index;


class $b8156ee5b0360641$var$Index {
    rc;
    _parent;
    deviceId;
    constructor(_parent, deviceId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.deviceId = deviceId;
    }
    path(withParameter = true) {
        if (withParameter && this.deviceId !== null) return `${this._parent.path()}/device/${this.deviceId}`;
        return `${this._parent.path()}/device`;
    }
    /**
     * Returns account device(s) by their ID(s).
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/device/{deviceId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyDevices
     */ async get(queryParams, restRequestConfig) {
        if (this.deviceId === null) throw new Error("deviceId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Updates account device(s) by their ID(s).
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/device/{deviceId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyDevices
     */ async put(accountDeviceUpdate, queryParams, restRequestConfig) {
        if (this.deviceId === null) throw new Error("deviceId must be specified.");
        const r = await this.rc.put(this.path(), accountDeviceUpdate, queryParams, restRequestConfig);
        return r.data;
    }
    sipInfo() {
        return new (0, $41601daf0c923f20$export$2e2bcd8739ae039)(this);
    }
    emergency() {
        return new (0, $ee4bc81c40793925$export$2e2bcd8739ae039)(this);
    }
}
var $b8156ee5b0360641$export$2e2bcd8739ae039 = $b8156ee5b0360641$var$Index;


class $e69336ad9dd8ab5a$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Assigns multiple sites to an account specified in path.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/sites/{siteId}/bulk-assign
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: Sites
     */ async post(siteMembersBulkUpdate, restRequestConfig) {
        const r = await this.rc.post(this.path(), siteMembersBulkUpdate, undefined, restRequestConfig);
        return r.data;
    }
}
var $e69336ad9dd8ab5a$export$2e2bcd8739ae039 = $e69336ad9dd8ab5a$var$Index;


class $a2bb47a556692f55$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/members`;
    }
    /**
     * Returns members of a site specified in path.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/sites/{siteId}/members
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $a2bb47a556692f55$export$2e2bcd8739ae039 = $a2bb47a556692f55$var$Index;


class $485d1791a6e92c73$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/ivr`;
    }
    /**
     * Returns IVR settings for a site specified in path.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/sites/{siteId}/ivr
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates IVR settings for a site specified in path.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/sites/{siteId}/ivr
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: Sites
     */ async put(siteIVRSettingsUpdate, restRequestConfig) {
        const r = await this.rc.put(this.path(), siteIVRSettingsUpdate, undefined, restRequestConfig);
        return r.data;
    }
}
var $485d1791a6e92c73$export$2e2bcd8739ae039 = $485d1791a6e92c73$var$Index;


class $f5bb391938a46e12$var$Index {
    rc;
    _parent;
    siteId;
    constructor(_parent, siteId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.siteId = siteId;
    }
    path(withParameter = true) {
        if (withParameter && this.siteId !== null) return `${this._parent.path()}/sites/${this.siteId}`;
        return `${this._parent.path()}/sites`;
    }
    /**
     * Returns a list of sites for the specified account.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/sites
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a site for the specified account.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/sites
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     */ async post(createSiteRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createSiteRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a site by ID.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/sites/{siteId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadExtensions
     */ async get(restRequestConfig) {
        if (this.siteId === null) throw new Error("siteId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a site specified in path.
     *
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/sites/{siteId}
     * Rate Limit Group: Light
     * App Permission: EditExtensions
     * User Permission: Sites
     */ async put(siteUpdateRequest, restRequestConfig) {
        if (this.siteId === null) throw new Error("siteId must be specified.");
        const r = await this.rc.put(this.path(), siteUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a site specified in path.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/sites/{siteId}
     * Rate Limit Group: Light
     * App Permission: EditAccounts
     * User Permission: Sites
     */ async delete(restRequestConfig) {
        if (this.siteId === null) throw new Error("siteId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    ivr() {
        return new (0, $485d1791a6e92c73$export$2e2bcd8739ae039)(this);
    }
    members() {
        return new (0, $a2bb47a556692f55$export$2e2bcd8739ae039)(this);
    }
    bulkAssign() {
        return new (0, $e69336ad9dd8ab5a$export$2e2bcd8739ae039)(this);
    }
}
var $f5bb391938a46e12$export$2e2bcd8739ae039 = $f5bb391938a46e12$var$Index;


class $aedb0965c8c7aa9f$var$Index {
    rc;
    _parent;
    accountId;
    constructor(_parent, accountId = "~"){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.accountId = accountId;
    }
    path(withParameter = true) {
        if (withParameter && this.accountId !== null) return `${this._parent.path()}/account/${this.accountId}`;
        return `${this._parent.path()}/account`;
    }
    /**
     * Returns basic information about a particular RingCentral customer account.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async get(restRequestConfig) {
        if (this.accountId === null) throw new Error("accountId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    sites(siteId = null) {
        return new (0, $f5bb391938a46e12$export$2e2bcd8739ae039)(this, siteId);
    }
    device(deviceId = null) {
        return new (0, $b8156ee5b0360641$export$2e2bcd8739ae039)(this, deviceId);
    }
    a2pSms() {
        return new (0, $28438444b7fc4906$export$2e2bcd8739ae039)(this);
    }
    callLog(callRecordId = null) {
        return new (0, $6d2cdc16a91cf99b$export$2e2bcd8739ae039)(this, callRecordId);
    }
    presence() {
        return new (0, $bb497a955492804f$export$2e2bcd8739ae039)(this);
    }
    greeting() {
        return new (0, $8860aa68de314047$export$2e2bcd8739ae039)(this);
    }
    directory() {
        return new (0, $6fac1ed1c882e147$export$2e2bcd8739ae039)(this);
    }
    telephony() {
        return new (0, $be1cbaa9f11055e2$export$2e2bcd8739ae039)(this);
    }
    recording(recordingId = null) {
        return new (0, $ca9838ec9283bf46$export$2e2bcd8739ae039)(this, recordingId);
    }
    extension(extensionId = "~") {
        return new (0, $ae49820bc9576e3c$export$2e2bcd8739ae039)(this, extensionId);
    }
    templates(templateId = null) {
        return new (0, $7f8458a85e83f6b2$export$2e2bcd8739ae039)(this, templateId);
    }
    ivrMenus(ivrMenuId = null) {
        return new (0, $80a75f5dd7d1608e$export$2e2bcd8739ae039)(this, ivrMenuId);
    }
    userRole(roleId = null) {
        return new (0, $daefdf8bac5d23d7$export$2e2bcd8739ae039)(this, roleId);
    }
    auditTrail() {
        return new (0, $13cd732cbd79b258$export$2e2bcd8739ae039)(this);
    }
    ivrPrompts(promptId = null) {
        return new (0, $9316828cc2dede32$export$2e2bcd8739ae039)(this, promptId);
    }
    callQueues(groupId = null) {
        return new (0, $c7ad06ad9e5df611$export$2e2bcd8739ae039)(this, groupId);
    }
    phoneNumber(phoneNumberId = null) {
        return new (0, $cdb31619b2aa7d43$export$2e2bcd8739ae039)(this, phoneNumberId);
    }
    serviceInfo() {
        return new (0, $48b1bb025f782639$export$2e2bcd8739ae039)(this);
    }
    activeCalls() {
        return new (0, $be00809e291fa5cf$export$2e2bcd8739ae039)(this);
    }
    customFields(fieldId = null) {
        return new (0, $321ba570dec9575a$export$2e2bcd8739ae039)(this, fieldId);
    }
    callLogSync() {
        return new (0, $3fe299919cd319a6$export$2e2bcd8739ae039)(this);
    }
    assignedRole() {
        return new (0, $e81716e4d5341db0$export$2e2bcd8739ae039)(this);
    }
    answeringRule(ruleId = null) {
        return new (0, $52c0d85729c6c003$export$2e2bcd8739ae039)(this, ruleId);
    }
    businessHours() {
        return new (0, $7986981480a23522$export$2e2bcd8739ae039)(this);
    }
    callRecording() {
        return new (0, $91e3d89280c1ce78$export$2e2bcd8739ae039)(this);
    }
    callRecordings() {
        return new (0, $740555f1f204cf90$export$2e2bcd8739ae039)(this);
    }
    businessAddress() {
        return new (0, $759df4a3de03e2e3$export$2e2bcd8739ae039)(this);
    }
    forwardAllCalls() {
        return new (0, $3e5f9a05879ea869$export$2e2bcd8739ae039)(this);
    }
    pagingOnlyGroups(pagingOnlyGroupId = null) {
        return new (0, $fd67284c51ac8840$export$2e2bcd8739ae039)(this, pagingOnlyGroupId);
    }
    emergencyLocations(locationId = null) {
        return new (0, $963f03444a1c6aec$export$2e2bcd8739ae039)(this, locationId);
    }
    messageStoreReport(taskId = null) {
        return new (0, $c20e3fc12939cead$export$2e2bcd8739ae039)(this, taskId);
    }
    extensionBulkUpdate() {
        return new (0, $5b71dce63b41feeb$export$2e2bcd8739ae039)(this);
    }
    callLogExtractSync() {
        return new (0, $cd5e947169f3b400$export$2e2bcd8739ae039)(this);
    }
    callMonitoringGroups(groupId = null) {
        return new (0, $62ec26c333a98521$export$2e2bcd8739ae039)(this, groupId);
    }
    messageStoreTemplates(templateId = null) {
        return new (0, $87649b1926a3a6f5$export$2e2bcd8739ae039)(this, templateId);
    }
    addressBookBulkUpload() {
        return new (0, $cd64d0aa98d92632$export$2e2bcd8739ae039)(this);
    }
    messageStoreConfiguration() {
        return new (0, $14d9e556ded82472$export$2e2bcd8739ae039)(this);
    }
    emergencyAddressAutoUpdate() {
        return new (0, $9fac17ae93dfb016$export$2e2bcd8739ae039)(this);
    }
}
var $aedb0965c8c7aa9f$export$2e2bcd8739ae039 = $aedb0965c8c7aa9f$var$Index;


class $46840b3378afb362$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/authorize`;
    }
    /**
     * Performs Authentication of the End-User by sending the User Agent to the Authorization Server's
     * Authorization Endpoint for Authentication and Authorization,
     * using request parameters defined by OAuth 2.0 [RFC-6749](https://datatracker.ietf.org/doc/html/rfc6749#section-3.1)
     * and additional parameters and parameter values defined by
     * [OpenID Connect Core 1.0](https://openid.net/specs/openid-connect-core-1_0.html#AuthorizationEndpoint).
     *
     * This is the version that uses HTTP `GET` method.
     *
     * HTTP Method: get
     * Endpoint: /restapi/oauth/authorize
     * Rate Limit Group: Auth
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $46840b3378afb362$export$2e2bcd8739ae039 = $46840b3378afb362$var$Index;


class $0ebf9bb86352e724$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/userinfo`;
    }
    /**
     * OpenID Connect User Info endpoint, as defined by [OpenID Connect Core 1.0](https://openid.net/specs/openid-connect-core-1_0.html#UserInfo) specification.
     * It returns Claims about the authenticated End-User.
     *
     * This is the version that uses HTTP `GET` method.
     *
     * HTTP Method: get
     * Endpoint: /restapi/oauth/userinfo
     * Rate Limit Group: Auth
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $0ebf9bb86352e724$export$2e2bcd8739ae039 = $0ebf9bb86352e724$var$Index;


class $63dec9d72802fc6e$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/wstoken`;
    }
    /**
     * Returns a special short lived token to authorize a dedicated web socket connection between this client
     * and a backend.
     *
     * This API needs to be called if a client plans to use "Websocket" transport to receive
     * RingCentral push notifications. The token returned by this API should be provided when establishing
     * a connection to the RingCentral Websocket Gateway.
     *
     * HTTP Method: post
     * Endpoint: /restapi/oauth/wstoken
     * Rate Limit Group: Auth
     * App Permission: WebSocket
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $63dec9d72802fc6e$export$2e2bcd8739ae039 = $63dec9d72802fc6e$var$Index;


class $3e0d0f8fd83e0dcb$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/revoke`;
    }
    /**
     * Revokes all active access/refresh tokens and invalidates the OAuth session basing on token provided.
     * The `token` parameter may be passed in query string or body and may represent access or refresh token.
     *
     * This endpoint is defined by [RFC-7009 "OAuth 2.0 Token Revocation"](https://datatracker.ietf.org/doc/html/rfc7009)
     *
     * For confidential client application types
     * this endpoint requires client authentication using one of the supported
     * methods:
     *   - `client_secret_basic` - client ID and client secret must be provided via `Authorization` header as described in
     *     [RFC-6749](https://datatracker.ietf.org/doc/html/rfc6749#section-2.3.1).
     *   - `client_secret_jwt` / `private_key_jwt` -- `client_assertion` attribute should be used to pass a signed JWT as described in
     *     [RFC-7523](https://datatracker.ietf.org/doc/html/rfc7523#section-2.2).
     *
     * For non-confidential client application types
     * the client identifier must be provided via `client_id` request attribute.
     *
     * HTTP Method: post
     * Endpoint: /restapi/oauth/revoke
     * Rate Limit Group: Auth
     */ async post(revokeTokenRequest, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), revokeTokenRequest, queryParams, restRequestConfig);
        return r.data;
    }
}
var $3e0d0f8fd83e0dcb$export$2e2bcd8739ae039 = $3e0d0f8fd83e0dcb$var$Index;


class $93a4456af86acabf$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/token`;
    }
    /**
     * Returns access (and potentially refresh) tokens for making API requests.
     *
     * For confidential client application types
     * this endpoint requires client authentication using one of the supported
     * methods:
     *   - `client_secret_basic` - client ID and client secret must be provided via `Authorization` header as described in
     *     [RFC-6749](https://datatracker.ietf.org/doc/html/rfc6749#section-2.3.1).
     *   - `client_secret_jwt` / `private_key_jwt` -- `client_assertion` attribute should be used to pass a signed JWT as described in
     *     [RFC-7523](https://datatracker.ietf.org/doc/html/rfc7523#section-2.2).
     *
     * For non-confidential client application types
     * the client identifier must be provided via `client_id` request attribute.
     *
     * HTTP Method: post
     * Endpoint: /restapi/oauth/token
     * Rate Limit Group: Auth
     */ async post(getTokenRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), getTokenRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $93a4456af86acabf$export$2e2bcd8739ae039 = $93a4456af86acabf$var$Index;


class $f9e12b4863401161$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/jwks`;
    }
    /**
     * Returns the signing key(s) in JWK Set format. Client use it to validate signatures of any JWT
     * (e.g. OpenID Connect ID Token) issued by the Authorization Server
     * (see [RFC-7517](https://www.rfc-editor.org/rfc/rfc7517.html#section-5))
     *
     * HTTP Method: get
     * Endpoint: /restapi/oauth/jwks
     * Rate Limit Group: NoThrottling
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $f9e12b4863401161$export$2e2bcd8739ae039 = $f9e12b4863401161$var$Index;


class $af127fe9e845217a$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/oauth`;
    }
    jwks() {
        return new (0, $f9e12b4863401161$export$2e2bcd8739ae039)(this);
    }
    token() {
        return new (0, $93a4456af86acabf$export$2e2bcd8739ae039)(this);
    }
    revoke() {
        return new (0, $3e0d0f8fd83e0dcb$export$2e2bcd8739ae039)(this);
    }
    wstoken() {
        return new (0, $63dec9d72802fc6e$export$2e2bcd8739ae039)(this);
    }
    userinfo() {
        return new (0, $0ebf9bb86352e724$export$2e2bcd8739ae039)(this);
    }
    authorize() {
        return new (0, $46840b3378afb362$export$2e2bcd8739ae039)(this);
    }
}
var $af127fe9e845217a$export$2e2bcd8739ae039 = $af127fe9e845217a$var$Index;


class $98e8a53a936ecbb7$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/send-activation-email`;
    }
    /**
     * Sends/resends activation email to the system user of unconfirmed account.
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/send-activation-email
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: AccountAdministration
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $98e8a53a936ecbb7$export$2e2bcd8739ae039 = $98e8a53a936ecbb7$var$Index;


class $84effbcb97bc5c61$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/send-welcome-email`;
    }
    /**
     * Sends/resends welcome email to the system user of confirmed account
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/send-welcome-email
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: Users
     */ async post(sendWelcomeEmailV2Request, restRequestConfig) {
        const r = await this.rc.post(this.path(), sendWelcomeEmailV2Request, undefined, restRequestConfig);
        return r.data;
    }
}
var $84effbcb97bc5c61$export$2e2bcd8739ae039 = $84effbcb97bc5c61$var$Index;


class $7c143cb94577388b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/users`;
    }
    /**
     * Creates multiple user extensions with BYOD (customer provided) devices.
     * If "extensionNumber" is not specified, the next available extension number will be assigned.
     *
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/batch-provisioning/users
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */ async post(batchProvisionUsersRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), batchProvisionUsersRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $7c143cb94577388b$export$2e2bcd8739ae039 = $7c143cb94577388b$var$Index;


class $35e8a27abb01dba9$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/batch-provisioning`;
    }
    users() {
        return new (0, $7c143cb94577388b$export$2e2bcd8739ae039)(this);
    }
}
var $35e8a27abb01dba9$export$2e2bcd8739ae039 = $35e8a27abb01dba9$var$Index;


class $872f9bd494b24f88$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/regional-settings`;
    }
    /**
     * Returns information about particular account regional settings
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/regional-settings
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Change information about particular account regional settings
     * HTTP Method: patch
     * Endpoint: /restapi/v2/accounts/{accountId}/regional-settings
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     */ async patch(accountRegionalSettingRequest, restRequestConfig) {
        const r = await this.rc.patch(this.path(), accountRegionalSettingRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $872f9bd494b24f88$export$2e2bcd8739ae039 = $872f9bd494b24f88$var$Index;


class $f1961d31780e24cc$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/device-inventory`;
    }
    /**
     * Adds an existing phone (customer provided device - BYOD) as an unassigned device to the account inventory.
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/device-inventory
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */ async post(addDeviceToInventoryRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), addDeviceToInventoryRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes an existing unassigned (without digital line or phone number) device or multiple devices
     * from the account inventory. It is possible to delete up to 10 devices per request.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/v2/accounts/{accountId}/device-inventory
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */ async delete(deleteDeviceFromInventoryRequest, restRequestConfig) {
        const r = await this.rc.delete(this.path(), deleteDeviceFromInventoryRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $f1961d31780e24cc$export$2e2bcd8739ae039 = $f1961d31780e24cc$var$Index;


class $ee4d8324683e16f3$var$Index {
    rc;
    _parent;
    taskId;
    constructor(_parent, taskId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.taskId = taskId;
    }
    path(withParameter = true) {
        if (withParameter && this.taskId !== null) return `${this._parent.path()}/bulk-add/${this.taskId}`;
        return `${this._parent.path()}/bulk-add`;
    }
    /**
     * Adds phone numbers to the account Inventory as unassigned. Currently, we support the following values: `Inventory`,
     * `InventoryPartnerBusinessMobileNumber` and `PartnerBusinessMobileNumber`. Later we may support some other values like `ForwardedNumber`, etc.
     *
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/phone-numbers/bulk-add
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: EditCompanyPhoneNumbers
     */ async post(addPhoneNumbersRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), addPhoneNumbersRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the result of asynchronous operation which adds phone numbers to the account inventory.
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/phone-numbers/bulk-add/{taskId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: EditCompanyPhoneNumbers
     */ async get(restRequestConfig) {
        if (this.taskId === null) throw new Error("taskId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $ee4d8324683e16f3$export$2e2bcd8739ae039 = $ee4d8324683e16f3$var$Index;


class $e74ec9fac00c4d98$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/replace`;
    }
    /**
     * Replaces (swaps) phone numbers from inventory with the main, company, direct or company fax numbers.
     * This method is used to replace temporary numbers when the porting process is complete.
     *
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/phone-numbers/{phoneNumberId}/replace
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyPhoneNumbers
     */ async post(replacePhoneNumberRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), replacePhoneNumberRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $e74ec9fac00c4d98$export$2e2bcd8739ae039 = $e74ec9fac00c4d98$var$Index;


class $c1920ef6f0c9943a$var$Index {
    rc;
    _parent;
    phoneNumberId;
    constructor(_parent, phoneNumberId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.phoneNumberId = phoneNumberId;
    }
    path(withParameter = true) {
        if (withParameter && this.phoneNumberId !== null) return `${this._parent.path()}/phone-numbers/${this.phoneNumberId}`;
        return `${this._parent.path()}/phone-numbers`;
    }
    /**
     * Returns the list of phone numbers assigned to RingCentral customer
     * account. Both company-level and extension-level numbers are returned.
     * Conferencing numbers, hot desk and ELIN numbers are not returned.
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/phone-numbers
     * Rate Limit Group: Heavy
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyPhoneNumbers
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * This method can only delete numbers that of the following usage types:
     *   - `Inventory`,
     *   - `ForwardedNumber`,
     *   - `ForwardedCompanyNumber`.
     *
     * In other words, this method will not delete numbers which are in use on the account - extension direct numbers,
     * main number, etc. It is possible to indicate phone numbers to be deleted using their IDs or exact string values
     * in e.164 format. However, the same lookup method (by ID or by value) must be used for all numbers within the same API call.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/v2/accounts/{accountId}/phone-numbers
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyPhoneNumbers
     */ async delete(deletePhoneNumbersRequest, restRequestConfig) {
        const r = await this.rc.delete(this.path(false), deletePhoneNumbersRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Assigns or reassigns a phone number as a company or extension number.
     *
     * Assign scenarios supported:
     * - from inventory to a company number;
     * - from inventory to an extension number.
     *
     * Reassign scenarios supported:
     * - from an extension to another extension;
     * - from an extension to a company number;
     * - from a company number to an extension.
     *
     * HTTP Method: patch
     * Endpoint: /restapi/v2/accounts/{accountId}/phone-numbers/{phoneNumberId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyPhoneNumbers
     */ async patch(assignPhoneNumberRequest, restRequestConfig) {
        if (this.phoneNumberId === null) throw new Error("phoneNumberId must be specified.");
        const r = await this.rc.patch(this.path(), assignPhoneNumberRequest, undefined, restRequestConfig);
        return r.data;
    }
    replace() {
        return new (0, $e74ec9fac00c4d98$export$2e2bcd8739ae039)(this);
    }
    bulkAdd(taskId = null) {
        return new (0, $ee4d8324683e16f3$export$2e2bcd8739ae039)(this, taskId);
    }
}
var $c1920ef6f0c9943a$export$2e2bcd8739ae039 = $c1920ef6f0c9943a$var$Index;


class $04540abb943500d8$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/cost-centers`;
    }
    /**
     * Returns the list of cost centers of the account specified in path.
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/cost-centers
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: CostCenterManagement
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $04540abb943500d8$export$2e2bcd8739ae039 = $04540abb943500d8$var$Index;


class $30435af745bc929a$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-flip-numbers`;
    }
    /**
     * Returns call flip settings. Call flip destination is an extension level setting.
     * The following numbers can be used for call flip:
     *
     * * User's DL numbers (added/removed automatically by the System)
     * * PSTN numbers in E.164 format (added/removed manually by User)
     *
     * Call flip list is generally limited up to 10 numbers.
     *
     * **Please note:** This API is only working with the new Communication Handling flow.
     * To ensure that please check if the 'NewCallHandlingAndForwarding' feature is supported.
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/call-flip-numbers
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates call flip settings. Call flip destination is an extension level setting.
     * The following numbers can be used for call flip:
     *
     * * User's DL numbers (added/removed automatically by the System)
     * * PSTN numbers in E.164 format (added/removed manually by User)
     *
     * Call flip list is generally limited up to 10 numbers.
     *
     * **Please note:** This API is only working with the new Communication Handling flow.
     * To ensure that please check if the 'NewCallHandlingAndForwarding' feature is supported.
     *
     * HTTP Method: put
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/call-flip-numbers
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     */ async put(callFlipNumberListResource, restRequestConfig) {
        const r = await this.rc.put(this.path(), callFlipNumberListResource, undefined, restRequestConfig);
        return r.data;
    }
}
var $30435af745bc929a$export$2e2bcd8739ae039 = $30435af745bc929a$var$Index;


class $788707fcaa2c03e2$var$Index {
    rc;
    _parent;
    stateId;
    constructor(_parent, stateId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.stateId = stateId;
    }
    path(withParameter = true) {
        if (withParameter && this.stateId !== null) return `${this._parent.path()}/states/${this.stateId}`;
        return `${this._parent.path()}/states`;
    }
    /**
     * Returns a list of communication handling states.
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/states
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a communication handling state.
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/states/{stateId}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        if (this.stateId === null) throw new Error("stateId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a communication handling state condition.
     * HTTP Method: patch
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/states/{stateId}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async patch(commStateUpdateRequest, restRequestConfig) {
        if (this.stateId === null) throw new Error("stateId must be specified.");
        const r = await this.rc.patch(this.path(), commStateUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $788707fcaa2c03e2$export$2e2bcd8739ae039 = $788707fcaa2c03e2$var$Index;


class $a22a4208a00a06e9$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/extensions`;
    }
    /**
     * Returns a list of extensions which use the specified device as a forwarding target.
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/forwarding-targets/devices/{deviceId}/extensions
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $a22a4208a00a06e9$export$2e2bcd8739ae039 = $a22a4208a00a06e9$var$Index;


class $96645b5bf824e435$var$Index {
    rc;
    _parent;
    deviceId;
    constructor(_parent, deviceId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.deviceId = deviceId;
    }
    path(withParameter = true) {
        if (withParameter && this.deviceId !== null) return `${this._parent.path()}/devices/${this.deviceId}`;
        return `${this._parent.path()}/devices`;
    }
    extensions() {
        return new (0, $a22a4208a00a06e9$export$2e2bcd8739ae039)(this);
    }
}
var $96645b5bf824e435$export$2e2bcd8739ae039 = $96645b5bf824e435$var$Index;


class $6e105a00e7855d22$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/forwarding-targets`;
    }
    /**
     * Returns the extension's forwarding targets.
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/forwarding-targets
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Removes the specified forwarding targets from the extension's communication handling rules.
     * HTTP Method: delete
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/forwarding-targets
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     */ async delete(commRemoveForwardingTargetsRequest, restRequestConfig) {
        const r = await this.rc.delete(this.path(), commRemoveForwardingTargetsRequest, undefined, restRequestConfig);
        return r.data;
    }
    devices(deviceId = null) {
        return new (0, $96645b5bf824e435$export$2e2bcd8739ae039)(this, deviceId);
    }
}
var $6e105a00e7855d22$export$2e2bcd8739ae039 = $6e105a00e7855d22$var$Index;


class $6985e1de3b0f0244$var$Index {
    rc;
    _parent;
    ruleId;
    constructor(_parent, ruleId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.ruleId = ruleId;
    }
    path(withParameter = true) {
        if (withParameter && this.ruleId !== null) return `${this._parent.path()}/interaction-rules/${this.ruleId}`;
        return `${this._parent.path()}/interaction-rules`;
    }
    /**
     * Returns a list of extension's interaction rules with the detailed information on each rule.
     *
     * *Interaction* rule is a call handling rule, managing voice call on the basis
     * of the user's **contact** or a **phone number** which is calling and/or being called.
     *
     * **Please note:** Interaction rules are applicable to the User extension types only: User, DigitalUser,
     * FaxUser, VirtualUser.
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/interaction-rules
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates the extension's interaction rule.
     *
     * *Interaction* rule is a call handling rule, managing voice call on the basis
     * of the user's **contact** or a **phone number** which is calling and/or being called.
     *
     * **Please note:** Interaction rules are applicable to the User extension types only: User, DigitalUser,
     * FaxUser, VirtualUser.
     *
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/interaction-rules
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     */ async post(commInteractionRuleCreateRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), commInteractionRuleCreateRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the extension's interaction rule by ID specified in URL.
     *
     * *Interaction* rule is a call handling rule, managing voice call on the basis
     * of the user's **contact** or a **phone number** which is calling and/or being called.
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/interaction-rules/{ruleId}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        if (this.ruleId === null) throw new Error("ruleId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the extension's interaction rule by ID specified in URL.
     * HTTP Method: delete
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/interaction-rules/{ruleId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     */ async delete(restRequestConfig) {
        if (this.ruleId === null) throw new Error("ruleId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the extension's interaction rule by ID specified in URL.
     * HTTP Method: patch
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/interaction-rules/{ruleId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     */ async patch(commInteractionRuleUpdateRequest, restRequestConfig) {
        if (this.ruleId === null) throw new Error("ruleId must be specified.");
        const r = await this.rc.patch(this.path(), commInteractionRuleUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $6985e1de3b0f0244$export$2e2bcd8739ae039 = $6985e1de3b0f0244$var$Index;


class $8f85f602cc8281b8$var$Index {
    rc;
    _parent;
    stateId;
    constructor(_parent, stateId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.stateId = stateId;
    }
    path(withParameter = true) {
        if (withParameter && this.stateId !== null) return `${this._parent.path()}/state-rules/${this.stateId}`;
        return `${this._parent.path()}/state-rules`;
    }
    /**
     * Returns a list of extension's voice state-based rules.
     *
     * *State-base rule* is a call handling rule, managing voice calls on the basis of the user's **state (status)**:
     * *Forward all calls (FAC), Do not disturb (DND), Work Hours (WH), After Hours (AH), Agent*.
     *
     * **Please note:** State-based rules are applicable to the User extension types only: User, DigitalUser, FaxUser,
     * VirtualUser.
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/state-rules
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the extension's voice state-based rule by ID specified in URL. Each state is assigned
     * with the predefined ID.
     *
     * *State-base rule* is a call handling rule, managing voice calls on the basis of the user's **state (status)**:
     *
     * *Forward all calls (FAC), Do not disturb (DND), Work Hours (WH), After Hours (AH), Agent*.
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/state-rules/{stateId}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        if (this.stateId === null) throw new Error("stateId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the extension's voice state-based rule.
     *
     * **Please note:**  When updating any of objects: `enabled`, `displayName`, `dispatching`, `condition`, etc.
     * all of object parameters should be passed (as in PUT method) - if a parameter is not specified,
     * its value will be set back to default, if any, or deleted.
     *
     * HTTP Method: patch
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/comm-handling/voice/state-rules/{stateId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     */ async patch(commStateBasedRuleUpdateRequest, restRequestConfig) {
        if (this.stateId === null) throw new Error("stateId must be specified.");
        const r = await this.rc.patch(this.path(), commStateBasedRuleUpdateRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $8f85f602cc8281b8$export$2e2bcd8739ae039 = $8f85f602cc8281b8$var$Index;


class $cb40bd2fb6311bf8$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/voice`;
    }
    stateRules(stateId = null) {
        return new (0, $8f85f602cc8281b8$export$2e2bcd8739ae039)(this, stateId);
    }
    interactionRules(ruleId = null) {
        return new (0, $6985e1de3b0f0244$export$2e2bcd8739ae039)(this, ruleId);
    }
    forwardingTargets() {
        return new (0, $6e105a00e7855d22$export$2e2bcd8739ae039)(this);
    }
}
var $cb40bd2fb6311bf8$export$2e2bcd8739ae039 = $cb40bd2fb6311bf8$var$Index;


class $408b34012645f788$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/comm-handling`;
    }
    voice() {
        return new (0, $cb40bd2fb6311bf8$export$2e2bcd8739ae039)(this);
    }
    states(stateId = null) {
        return new (0, $788707fcaa2c03e2$export$2e2bcd8739ae039)(this, stateId);
    }
}
var $408b34012645f788$export$2e2bcd8739ae039 = $408b34012645f788$var$Index;


class $e2fcdfbedc10e337$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/replace`;
    }
    /**
     * Replaces the user device with another device, which is assigned to an extension
     * or is stored in the inventory of the same account.
     * Currently, the following device types can be swapped - `HardPhone` and `OtherPhone`.
     *
     * Please note:
     *
     *  - This method allows replacing a device itself, while a phone number,
     *    a digital Line and an emergency address associated with this device remain unchanged
     *    and will still work together in a chain with the replacement device.
     *  - If a target device is from the inventory, then a source device will be moved
     *    to the inventory, and a target device will be assigned to the current extension.
     *  - If a target device is currently assigned to another extension,
     *    then the devices will be just swapped.
     *
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions/{extensionId}/devices/{deviceId}/replace
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditUserDevices
     */ async post(swapDeviceRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), swapDeviceRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $e2fcdfbedc10e337$export$2e2bcd8739ae039 = $e2fcdfbedc10e337$var$Index;


class $e91cb7d2097b6eb2$var$Index {
    rc;
    _parent;
    deviceId;
    constructor(_parent, deviceId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.deviceId = deviceId;
    }
    path(withParameter = true) {
        if (withParameter && this.deviceId !== null) return `${this._parent.path()}/devices/${this.deviceId}`;
        return `${this._parent.path()}/devices`;
    }
    replace() {
        return new (0, $e2fcdfbedc10e337$export$2e2bcd8739ae039)(this);
    }
}
var $e91cb7d2097b6eb2$export$2e2bcd8739ae039 = $e91cb7d2097b6eb2$var$Index;


class $85baa1c9a3e4fd43$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/extensions`;
    }
    /**
     * Deletes extension(s) of User and Limited types, and depending on device type either keeps or destroys
     * the assets - numbers and devices. If a device is rented or bought in RC, it will be moved to the inventory.
     * A BYOD (Other Phone) device will be deleted. Multiple extensions can be deleted by a single API call.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/v2/accounts/{accountId}/extensions
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: Users
     */ async delete(bulkDeleteUsersRequest, restRequestConfig) {
        const r = await this.rc.delete(this.path(), bulkDeleteUsersRequest, undefined, restRequestConfig);
        return r.data;
    }
    devices(deviceId = null) {
        return new (0, $e91cb7d2097b6eb2$export$2e2bcd8739ae039)(this, deviceId);
    }
    commHandling() {
        return new (0, $408b34012645f788$export$2e2bcd8739ae039)(this);
    }
    callFlipNumbers() {
        return new (0, $30435af745bc929a$export$2e2bcd8739ae039)(this);
    }
}
var $85baa1c9a3e4fd43$export$2e2bcd8739ae039 = $85baa1c9a3e4fd43$var$Index;


class $1895d66b446857be$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-add`;
    }
    /**
     * Adds multiple BYOD (customer provided) devices to an account.
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/devices/bulk-add
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: AddRemoveDevices
     */ async post(bulkAddDevicesRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), bulkAddDevicesRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $1895d66b446857be$export$2e2bcd8739ae039 = $1895d66b446857be$var$Index;


class $f1b7b1e7cb6b85de$var$Index {
    rc;
    _parent;
    deviceId;
    constructor(_parent, deviceId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.deviceId = deviceId;
    }
    path(withParameter = true) {
        if (withParameter && this.deviceId !== null) return `${this._parent.path()}/devices/${this.deviceId}`;
        return `${this._parent.path()}/devices`;
    }
    /**
     * Disassociates a phone line (DL & Device) from an extension:
     *
     *  - if the value of `keepAssetsInInventory` is `true`,
     * the given device is moved to unassigned devices and the number is moved to the number inventory;
     *  - if the value of `keepAssetsInInventory` is `false`, the given device and number is removed from the account;
     *  - if the parameter `keepAssetsInInventory` is not set (empty body), default value `true` is set.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/v2/accounts/{accountId}/devices/{deviceId}
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditAccountDevices
     */ async delete(removeLineRequest, restRequestConfig) {
        if (this.deviceId === null) throw new Error("deviceId must be specified.");
        const r = await this.rc.delete(this.path(), removeLineRequest, undefined, restRequestConfig);
        return r.data;
    }
    bulkAdd() {
        return new (0, $1895d66b446857be$export$2e2bcd8739ae039)(this);
    }
}
var $f1b7b1e7cb6b85de$export$2e2bcd8739ae039 = $f1b7b1e7cb6b85de$var$Index;


class $826d42715d8f2fdc$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/export`;
    }
    /**
     * Returns a list of numbers that are opted out and/or opted in at the account level in CSV format.
     * Header row will define the following columns.
     *
     * | Column name | Data type | Description |
     * | ----------- | --------- | ----------- |
     * | From        | string    | Sender phone number in E.164 or the wildcard |
     * | To          | string    | Recipient phone number in E.164 |
     * | Status      | string    | Either "OptOut" or "OptIn" |
     * | Source      | string    | Source of the opt record   |
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/sms/opt-outs/export
     * Rate Limit Group: Light
     * App Permission: SMS
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $826d42715d8f2fdc$export$2e2bcd8739ae039 = $826d42715d8f2fdc$var$Index;


class $29deb15ae05e87f8$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/opt-outs`;
    }
    /**
     * Returns a list of records with phone numbers that are opted out and/or opted-in for SMS
     * at the account level. The list can be filtered by `to`/`from` phone number query parameters.
     *
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}/sms/opt-outs
     * Rate Limit Group: Light
     * App Permission: SMS
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the opted out/in numbers.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/v2/accounts/{accountId}/sms/opt-outs
     * Rate Limit Group: Light
     * App Permission: SMS
     */ async delete(deleteOptRecordList, restRequestConfig) {
        const r = await this.rc.delete(this.path(), deleteOptRecordList, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Adds or updates the opted out/in numbers.
     *
     * HTTP Method: patch
     * Endpoint: /restapi/v2/accounts/{accountId}/sms/opt-outs
     * Rate Limit Group: Light
     * App Permission: SMS
     */ async patch(updateOptRecordList, restRequestConfig) {
        const r = await this.rc.patch(this.path(), updateOptRecordList, undefined, restRequestConfig);
        return r.data;
    }
    export() {
        return new (0, $826d42715d8f2fdc$export$2e2bcd8739ae039)(this);
    }
}
var $29deb15ae05e87f8$export$2e2bcd8739ae039 = $29deb15ae05e87f8$var$Index;


class $ca0866a80f0fc5d3$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sms`;
    }
    optOuts() {
        return new (0, $29deb15ae05e87f8$export$2e2bcd8739ae039)(this);
    }
}
var $ca0866a80f0fc5d3$export$2e2bcd8739ae039 = $ca0866a80f0fc5d3$var$Index;


class $f39c61f336cfd9e4$var$Index {
    rc;
    _parent;
    accountId;
    constructor(_parent, accountId = "~"){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.accountId = accountId;
    }
    path(withParameter = true) {
        if (withParameter && this.accountId !== null) return `${this._parent.path()}/accounts/${this.accountId}`;
        return `${this._parent.path()}/accounts`;
    }
    /**
     * Returns basic information about particular RingCentral account
     * HTTP Method: get
     * Endpoint: /restapi/v2/accounts/{accountId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */ async get(restRequestConfig) {
        if (this.accountId === null) throw new Error("accountId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    sms() {
        return new (0, $ca0866a80f0fc5d3$export$2e2bcd8739ae039)(this);
    }
    devices(deviceId = null) {
        return new (0, $f1b7b1e7cb6b85de$export$2e2bcd8739ae039)(this, deviceId);
    }
    extensions() {
        return new (0, $85baa1c9a3e4fd43$export$2e2bcd8739ae039)(this);
    }
    costCenters() {
        return new (0, $04540abb943500d8$export$2e2bcd8739ae039)(this);
    }
    phoneNumbers(phoneNumberId = null) {
        return new (0, $c1920ef6f0c9943a$export$2e2bcd8739ae039)(this, phoneNumberId);
    }
    deviceInventory() {
        return new (0, $f1961d31780e24cc$export$2e2bcd8739ae039)(this);
    }
    regionalSettings() {
        return new (0, $872f9bd494b24f88$export$2e2bcd8739ae039)(this);
    }
    batchProvisioning() {
        return new (0, $35e8a27abb01dba9$export$2e2bcd8739ae039)(this);
    }
    sendWelcomeEmail() {
        return new (0, $84effbcb97bc5c61$export$2e2bcd8739ae039)(this);
    }
    sendActivationEmail() {
        return new (0, $98e8a53a936ecbb7$export$2e2bcd8739ae039)(this);
    }
}
var $f39c61f336cfd9e4$export$2e2bcd8739ae039 = $f39c61f336cfd9e4$var$Index;


class $131b03a6ec42269f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v2`;
    }
    accounts(accountId = "~") {
        return new (0, $f39c61f336cfd9e4$export$2e2bcd8739ae039)(this, accountId);
    }
}
var $131b03a6ec42269f$export$2e2bcd8739ae039 = $131b03a6ec42269f$var$Index;


class $602931833ffa73d3$var$Index {
    rc;
    apiVersion;
    constructor(rc, apiVersion = "v1.0"){
        this.rc = rc;
        this.apiVersion = apiVersion;
    }
    path(withParameter = true) {
        if (withParameter && this.apiVersion !== null) return `/restapi/${this.apiVersion}`;
        return "/restapi";
    }
    /**
     * Returns current API version(s) and server info.
     * HTTP Method: get
     * Endpoint: /restapi
     * Rate Limit Group: NoThrottling
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns current API version info by apiVersion.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}
     * Rate Limit Group: NoThrottling
     */ async get(restRequestConfig) {
        if (this.apiVersion === null) throw new Error("apiVersion must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    v2() {
        return new (0, $131b03a6ec42269f$export$2e2bcd8739ae039)(this);
    }
    oauth() {
        return new (0, $af127fe9e845217a$export$2e2bcd8739ae039)(this);
    }
    account(accountId = "~") {
        return new (0, $aedb0965c8c7aa9f$export$2e2bcd8739ae039)(this, accountId);
    }
    dictionary() {
        return new (0, $44fcfa9d56ccb4b2$export$2e2bcd8739ae039)(this);
    }
    clientInfo() {
        return new (0, $9ee3885e43133808$export$2e2bcd8739ae039)(this);
    }
    subscription(subscriptionId = null) {
        return new (0, $97a5e5096894a497$export$2e2bcd8739ae039)(this, subscriptionId);
    }
    numberParser() {
        return new (0, $8eb542680f8b1193$export$2e2bcd8739ae039)(this);
    }
}
var $602931833ffa73d3$export$2e2bcd8739ae039 = $602931833ffa73d3$var$Index;


class $8acb0b1d9457d65f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/ServiceProviderConfig`;
    }
    /**
     * Returns SCIM service provider configuration
     * HTTP Method: get
     * Endpoint: /scim/{version}/ServiceProviderConfig
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $8acb0b1d9457d65f$export$2e2bcd8739ae039 = $8acb0b1d9457d65f$var$Index;


class $df508e82d5a57ab5$var$Index {
    rc;
    _parent;
    type;
    constructor(_parent, type = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.type = type;
    }
    path(withParameter = true) {
        if (withParameter && this.type !== null) return `${this._parent.path()}/ResourceTypes/${this.type}`;
        return `${this._parent.path()}/ResourceTypes`;
    }
    /**
     * Returns the list of supported SCIM resource types
     * HTTP Method: get
     * Endpoint: /scim/{version}/ResourceTypes
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns resource type by ID
     * HTTP Method: get
     * Endpoint: /scim/{version}/ResourceTypes/{type}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        if (this.type === null) throw new Error("type must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $df508e82d5a57ab5$export$2e2bcd8739ae039 = $df508e82d5a57ab5$var$Index;


class $dfe8691cd2deba5d$var$Index {
    rc;
    _parent;
    uri;
    constructor(_parent, uri = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.uri = uri;
    }
    path(withParameter = true) {
        if (withParameter && this.uri !== null) return `${this._parent.path()}/Schemas/${this.uri}`;
        return `${this._parent.path()}/Schemas`;
    }
    /**
     * Returns the list of schemas
     * HTTP Method: get
     * Endpoint: /scim/{version}/Schemas
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns SCIM schema
     * HTTP Method: get
     * Endpoint: /scim/{version}/Schemas/{uri}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        if (this.uri === null) throw new Error("uri must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $dfe8691cd2deba5d$export$2e2bcd8739ae039 = $dfe8691cd2deba5d$var$Index;


class $251abe48104f32b5$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/.search`;
    }
    /**
     * Returns the list of users satisfying search criteria
     * HTTP Method: post
     * Endpoint: /scim/{version}/Users/dotSearch
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async post(scimSearchRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), scimSearchRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $251abe48104f32b5$export$2e2bcd8739ae039 = $251abe48104f32b5$var$Index;


class $e90fa2f53e569417$var$Index {
    rc;
    _parent;
    scimUserId;
    constructor(_parent, scimUserId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.scimUserId = scimUserId;
    }
    path(withParameter = true) {
        if (withParameter && this.scimUserId !== null) return `${this._parent.path()}/Users/${this.scimUserId}`;
        return `${this._parent.path()}/Users`;
    }
    /**
     * Returns the list of users satisfying search criteria
     * HTTP Method: get
     * Endpoint: /scim/{version}/Users
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new user
     * HTTP Method: post
     * Endpoint: /scim/{version}/Users
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */ async post(scimUser, restRequestConfig) {
        const r = await this.rc.post(this.path(false), scimUser, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a user by ID
     * HTTP Method: get
     * Endpoint: /scim/{version}/Users/{scimUserId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     */ async get(restRequestConfig) {
        if (this.scimUserId === null) throw new Error("scimUserId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a user
     * HTTP Method: put
     * Endpoint: /scim/{version}/Users/{scimUserId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */ async put(scimUser, restRequestConfig) {
        if (this.scimUserId === null) throw new Error("scimUserId must be specified.");
        const r = await this.rc.put(this.path(), scimUser, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a user
     * HTTP Method: delete
     * Endpoint: /scim/{version}/Users/{scimUserId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */ async delete(restRequestConfig) {
        if (this.scimUserId === null) throw new Error("scimUserId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a user (partial update)
     * HTTP Method: patch
     * Endpoint: /scim/{version}/Users/{scimUserId}
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     */ async patch(scimUserPatch, restRequestConfig) {
        if (this.scimUserId === null) throw new Error("scimUserId must be specified.");
        const r = await this.rc.patch(this.path(), scimUserPatch, undefined, restRequestConfig);
        return r.data;
    }
    dotSearch() {
        return new (0, $251abe48104f32b5$export$2e2bcd8739ae039)(this);
    }
}
var $e90fa2f53e569417$export$2e2bcd8739ae039 = $e90fa2f53e569417$var$Index;


class $74a24777d716c36e$var$Index {
    rc;
    version;
    constructor(rc, version = "v2"){
        this.rc = rc;
        this.version = version;
    }
    path(withParameter = true) {
        if (withParameter && this.version !== null) return `/scim/${this.version}`;
        return "/scim";
    }
    users(scimUserId = null) {
        return new (0, $e90fa2f53e569417$export$2e2bcd8739ae039)(this, scimUserId);
    }
    schemas(uri = null) {
        return new (0, $dfe8691cd2deba5d$export$2e2bcd8739ae039)(this, uri);
    }
    resourceTypes(type = null) {
        return new (0, $df508e82d5a57ab5$export$2e2bcd8739ae039)(this, type);
    }
    serviceProviderConfig() {
        return new (0, $8acb0b1d9457d65f$export$2e2bcd8739ae039)(this);
    }
}
var $74a24777d716c36e$export$2e2bcd8739ae039 = $74a24777d716c36e$var$Index;


class $0ebc450be51c3c28$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/fetch`;
    }
    /**
     * Returns call aggregations filtered by parameters specified
     * HTTP Method: post
     * Endpoint: /analytics/calls/v1/accounts/{accountId}/aggregation/fetch
     * Rate Limit Group: Light
     * App Permission: Analytics
     */ async post(aggregationRequest, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), aggregationRequest, queryParams, restRequestConfig);
        return r.data;
    }
}
var $0ebc450be51c3c28$export$2e2bcd8739ae039 = $0ebc450be51c3c28$var$Index;


class $eafa33bdc6602528$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/aggregation`;
    }
    fetch() {
        return new (0, $0ebc450be51c3c28$export$2e2bcd8739ae039)(this);
    }
}
var $eafa33bdc6602528$export$2e2bcd8739ae039 = $eafa33bdc6602528$var$Index;


class $06626b0aa6ed184f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/fetch`;
    }
    /**
     * Returns time-value data aggregations filtered by parameters specified
     * HTTP Method: post
     * Endpoint: /analytics/calls/v1/accounts/{accountId}/timeline/fetch
     * Rate Limit Group: Light
     * App Permission: Analytics
     */ async post(timelineRequest, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), timelineRequest, queryParams, restRequestConfig);
        return r.data;
    }
}
var $06626b0aa6ed184f$export$2e2bcd8739ae039 = $06626b0aa6ed184f$var$Index;


class $409d7eff589de41b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/timeline`;
    }
    fetch() {
        return new (0, $06626b0aa6ed184f$export$2e2bcd8739ae039)(this);
    }
}
var $409d7eff589de41b$export$2e2bcd8739ae039 = $409d7eff589de41b$var$Index;


class $116afb6289affb6e$var$Index {
    rc;
    _parent;
    accountId;
    constructor(_parent, accountId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.accountId = accountId;
    }
    path(withParameter = true) {
        if (withParameter && this.accountId !== null) return `${this._parent.path()}/accounts/${this.accountId}`;
        return `${this._parent.path()}/accounts`;
    }
    timeline() {
        return new (0, $409d7eff589de41b$export$2e2bcd8739ae039)(this);
    }
    aggregation() {
        return new (0, $eafa33bdc6602528$export$2e2bcd8739ae039)(this);
    }
}
var $116afb6289affb6e$export$2e2bcd8739ae039 = $116afb6289affb6e$var$Index;


class $79ad2168cfb1f066$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    accounts(accountId = null) {
        return new (0, $116afb6289affb6e$export$2e2bcd8739ae039)(this, accountId);
    }
}
var $79ad2168cfb1f066$export$2e2bcd8739ae039 = $79ad2168cfb1f066$var$Index;


class $61b8ef7c36e4c7cb$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/calls`;
    }
    v1() {
        return new (0, $79ad2168cfb1f066$export$2e2bcd8739ae039)(this);
    }
}
var $61b8ef7c36e4c7cb$export$2e2bcd8739ae039 = $61b8ef7c36e4c7cb$var$Index;


class $518357303770a27e$var$Index {
    rc;
    constructor(rc){
        this.rc = rc;
    }
    path() {
        return "/analytics";
    }
    calls() {
        return new (0, $61b8ef7c36e4c7cb$export$2e2bcd8739ae039)(this);
    }
}
var $518357303770a27e$export$2e2bcd8739ae039 = $518357303770a27e$var$Index;


class $62e5fb3b4e342b78$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/insights`;
    }
    /**
     * Returns the insights of all call recordings in a session
     * HTTP Method: get
     * Endpoint: /ai/ringsense/v1/public/accounts/{accountId}/domains/{domain}/sessions/{sourceSessionId}/insights
     * Rate Limit Group: Light
     * App Permission: RingSense
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $62e5fb3b4e342b78$export$2e2bcd8739ae039 = $62e5fb3b4e342b78$var$Index;


class $24286fddefe9f56a$var$Index {
    rc;
    _parent;
    sourceSessionId;
    constructor(_parent, sourceSessionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.sourceSessionId = sourceSessionId;
    }
    path(withParameter = true) {
        if (withParameter && this.sourceSessionId !== null) return `${this._parent.path()}/sessions/${this.sourceSessionId}`;
        return `${this._parent.path()}/sessions`;
    }
    insights() {
        return new (0, $62e5fb3b4e342b78$export$2e2bcd8739ae039)(this);
    }
}
var $24286fddefe9f56a$export$2e2bcd8739ae039 = $24286fddefe9f56a$var$Index;


class $099c31d69552828e$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/insights`;
    }
    /**
     * Returns the insights of a call recording
     * HTTP Method: get
     * Endpoint: /ai/ringsense/v1/public/accounts/{accountId}/domains/{domain}/records/{sourceRecordId}/insights
     * Rate Limit Group: Light
     * App Permission: RingSense
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $099c31d69552828e$export$2e2bcd8739ae039 = $099c31d69552828e$var$Index;


class $5ee97297805487a2$var$Index {
    rc;
    _parent;
    sourceRecordId;
    constructor(_parent, sourceRecordId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.sourceRecordId = sourceRecordId;
    }
    path(withParameter = true) {
        if (withParameter && this.sourceRecordId !== null) return `${this._parent.path()}/records/${this.sourceRecordId}`;
        return `${this._parent.path()}/records`;
    }
    insights() {
        return new (0, $099c31d69552828e$export$2e2bcd8739ae039)(this);
    }
}
var $5ee97297805487a2$export$2e2bcd8739ae039 = $5ee97297805487a2$var$Index;


class $bf7bc539425bb255$var$Index {
    rc;
    _parent;
    domain;
    constructor(_parent, domain = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.domain = domain;
    }
    path(withParameter = true) {
        if (withParameter && this.domain !== null) return `${this._parent.path()}/domains/${this.domain}`;
        return `${this._parent.path()}/domains`;
    }
    records(sourceRecordId = null) {
        return new (0, $5ee97297805487a2$export$2e2bcd8739ae039)(this, sourceRecordId);
    }
    sessions(sourceSessionId = null) {
        return new (0, $24286fddefe9f56a$export$2e2bcd8739ae039)(this, sourceSessionId);
    }
}
var $bf7bc539425bb255$export$2e2bcd8739ae039 = $bf7bc539425bb255$var$Index;


class $553c6d866bb37552$var$Index {
    rc;
    _parent;
    accountId;
    constructor(_parent, accountId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.accountId = accountId;
    }
    path(withParameter = true) {
        if (withParameter && this.accountId !== null) return `${this._parent.path()}/accounts/${this.accountId}`;
        return `${this._parent.path()}/accounts`;
    }
    domains(domain = null) {
        return new (0, $bf7bc539425bb255$export$2e2bcd8739ae039)(this, domain);
    }
}
var $553c6d866bb37552$export$2e2bcd8739ae039 = $553c6d866bb37552$var$Index;


class $8cc78518d26c91f4$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/public`;
    }
    accounts(accountId = null) {
        return new (0, $553c6d866bb37552$export$2e2bcd8739ae039)(this, accountId);
    }
}
var $8cc78518d26c91f4$export$2e2bcd8739ae039 = $8cc78518d26c91f4$var$Index;


class $1d23aaa16b4ebc57$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    public() {
        return new (0, $8cc78518d26c91f4$export$2e2bcd8739ae039)(this);
    }
}
var $1d23aaa16b4ebc57$export$2e2bcd8739ae039 = $1d23aaa16b4ebc57$var$Index;


class $c6b6bbba381e5c76$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/ringsense`;
    }
    v1() {
        return new (0, $1d23aaa16b4ebc57$export$2e2bcd8739ae039)(this);
    }
}
var $c6b6bbba381e5c76$export$2e2bcd8739ae039 = $c6b6bbba381e5c76$var$Index;


class $f24a7e727215c91e$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/analyze-interaction`;
    }
    /**
     * Returns multiple insights including summaries, emotion, key phrases, questions asked, and more in a single API call.
     *
     * HTTP Method: post
     * Endpoint: /ai/insights/v1/async/analyze-interaction
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async post(interactionInput, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), interactionInput, queryParams, restRequestConfig);
        return r.data;
    }
}
var $f24a7e727215c91e$export$2e2bcd8739ae039 = $f24a7e727215c91e$var$Index;


class $763cb83612117cf4$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/async`;
    }
    analyzeInteraction() {
        return new (0, $f24a7e727215c91e$export$2e2bcd8739ae039)(this);
    }
}
var $763cb83612117cf4$export$2e2bcd8739ae039 = $763cb83612117cf4$var$Index;


class $ee0b5c8eaf666cb8$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    async() {
        return new (0, $763cb83612117cf4$export$2e2bcd8739ae039)(this);
    }
}
var $ee0b5c8eaf666cb8$export$2e2bcd8739ae039 = $ee0b5c8eaf666cb8$var$Index;


class $ddd21951704539f8$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/insights`;
    }
    v1() {
        return new (0, $ee0b5c8eaf666cb8$export$2e2bcd8739ae039)(this);
    }
}
var $ddd21951704539f8$export$2e2bcd8739ae039 = $ddd21951704539f8$var$Index;


class $0933251c7f16e003$var$Index {
    rc;
    _parent;
    jobId;
    constructor(_parent, jobId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.jobId = jobId;
    }
    path(withParameter = true) {
        if (withParameter && this.jobId !== null) return `${this._parent.path()}/jobs/${this.jobId}`;
        return `${this._parent.path()}/jobs`;
    }
    /**
     * Returns async task status by Job ID
     * HTTP Method: get
     * Endpoint: /ai/status/v1/jobs/{jobId}
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async get(restRequestConfig) {
        if (this.jobId === null) throw new Error("jobId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $0933251c7f16e003$export$2e2bcd8739ae039 = $0933251c7f16e003$var$Index;


class $96b1e771c3dee92d$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    jobs(jobId = null) {
        return new (0, $0933251c7f16e003$export$2e2bcd8739ae039)(this, jobId);
    }
}
var $96b1e771c3dee92d$export$2e2bcd8739ae039 = $96b1e771c3dee92d$var$Index;


class $b4a147efca4e25ab$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/status`;
    }
    v1() {
        return new (0, $96b1e771c3dee92d$export$2e2bcd8739ae039)(this);
    }
}
var $b4a147efca4e25ab$export$2e2bcd8739ae039 = $b4a147efca4e25ab$var$Index;


class $cd64337db95ad2d3$var$Index {
    rc;
    _parent;
    speakerId;
    constructor(_parent, speakerId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.speakerId = speakerId;
    }
    path(withParameter = true) {
        if (withParameter && this.speakerId !== null) return `${this._parent.path()}/enrollments/${this.speakerId}`;
        return `${this._parent.path()}/enrollments`;
    }
    /**
     * Returns the List of Enrolled Speakers
     * HTTP Method: get
     * Endpoint: /ai/audio/v1/enrollments
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates Enrollment for the provided Speaker.
     * HTTP Method: post
     * Endpoint: /ai/audio/v1/enrollments
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async post(enrollmentInput, restRequestConfig) {
        const r = await this.rc.post(this.path(false), enrollmentInput, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Get The Status of Enrollment for the provided Speaker.
     * HTTP Method: get
     * Endpoint: /ai/audio/v1/enrollments/{speakerId}
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async get(restRequestConfig) {
        if (this.speakerId === null) throw new Error("speakerId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Delete The Enrollment for the provided Speaker.
     * HTTP Method: delete
     * Endpoint: /ai/audio/v1/enrollments/{speakerId}
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async delete(restRequestConfig) {
        if (this.speakerId === null) throw new Error("speakerId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Add newer audio data to improve an existing speaker enrollment
     * HTTP Method: patch
     * Endpoint: /ai/audio/v1/enrollments/{speakerId}
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async patch(enrollmentPatchInput, restRequestConfig) {
        if (this.speakerId === null) throw new Error("speakerId must be specified.");
        const r = await this.rc.patch(this.path(), enrollmentPatchInput, undefined, restRequestConfig);
        return r.data;
    }
}
var $cd64337db95ad2d3$export$2e2bcd8739ae039 = $cd64337db95ad2d3$var$Index;


class $424408f162bed519$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/speaker-identify`;
    }
    /**
     * Returns Speaker Identification to the provided webhook URI.
     * HTTP Method: post
     * Endpoint: /ai/audio/v1/async/speaker-identify
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async post(identifyInput, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), identifyInput, queryParams, restRequestConfig);
        return r.data;
    }
}
var $424408f162bed519$export$2e2bcd8739ae039 = $424408f162bed519$var$Index;


class $82ea1244c15b6d63$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/speaker-diarize`;
    }
    /**
     * Identifies who said what. Speaker diarization will identify the speaker for each segment
     * so you can tell who spoke the sentence, paragraph, or phrase.
     *
     * HTTP Method: post
     * Endpoint: /ai/audio/v1/async/speaker-diarize
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async post(diarizeInput, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), diarizeInput, queryParams, restRequestConfig);
        return r.data;
    }
}
var $82ea1244c15b6d63$export$2e2bcd8739ae039 = $82ea1244c15b6d63$var$Index;


class $82b04598c6418c74$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/speech-to-text`;
    }
    /**
     * Returns Speech to Text Conversion to the provided webhook URI.
     * HTTP Method: post
     * Endpoint: /ai/audio/v1/async/speech-to-text
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async post(asrInput, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), asrInput, queryParams, restRequestConfig);
        return r.data;
    }
}
var $82b04598c6418c74$export$2e2bcd8739ae039 = $82b04598c6418c74$var$Index;


class $205d3b9679a590a2$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/async`;
    }
    speechToText() {
        return new (0, $82b04598c6418c74$export$2e2bcd8739ae039)(this);
    }
    speakerDiarize() {
        return new (0, $82ea1244c15b6d63$export$2e2bcd8739ae039)(this);
    }
    speakerIdentify() {
        return new (0, $424408f162bed519$export$2e2bcd8739ae039)(this);
    }
}
var $205d3b9679a590a2$export$2e2bcd8739ae039 = $205d3b9679a590a2$var$Index;


class $e8d772c283227815$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    async() {
        return new (0, $205d3b9679a590a2$export$2e2bcd8739ae039)(this);
    }
    enrollments(speakerId = null) {
        return new (0, $cd64337db95ad2d3$export$2e2bcd8739ae039)(this, speakerId);
    }
}
var $e8d772c283227815$export$2e2bcd8739ae039 = $e8d772c283227815$var$Index;


class $8fdce3e2fdbde567$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/audio`;
    }
    v1() {
        return new (0, $e8d772c283227815$export$2e2bcd8739ae039)(this);
    }
}
var $8fdce3e2fdbde567$export$2e2bcd8739ae039 = $8fdce3e2fdbde567$var$Index;


class $1d925827f0dcc93d$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/punctuate`;
    }
    /**
     * Returns Smart Punctuation to the provided webhook URI.
     * HTTP Method: post
     * Endpoint: /ai/text/v1/async/punctuate
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async post(punctuateInput, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), punctuateInput, queryParams, restRequestConfig);
        return r.data;
    }
}
var $1d925827f0dcc93d$export$2e2bcd8739ae039 = $1d925827f0dcc93d$var$Index;


class $f74ba36adc4c8553$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/summarize`;
    }
    /**
     * Returns Conversational Summarization to the webhook URI for segmented transcript of audios
     * with start, end, speakerId, text(alphanumeric and punctuations).
     *
     * HTTP Method: post
     * Endpoint: /ai/text/v1/async/summarize
     * Rate Limit Group: Heavy
     * App Permission: AI
     */ async post(summaryInput, queryParams, restRequestConfig) {
        const r = await this.rc.post(this.path(), summaryInput, queryParams, restRequestConfig);
        return r.data;
    }
}
var $f74ba36adc4c8553$export$2e2bcd8739ae039 = $f74ba36adc4c8553$var$Index;


class $e16ca0ed859cae6b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/async`;
    }
    summarize() {
        return new (0, $f74ba36adc4c8553$export$2e2bcd8739ae039)(this);
    }
    punctuate() {
        return new (0, $1d925827f0dcc93d$export$2e2bcd8739ae039)(this);
    }
}
var $e16ca0ed859cae6b$export$2e2bcd8739ae039 = $e16ca0ed859cae6b$var$Index;


class $dd0a7f7aa58e6920$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    async() {
        return new (0, $e16ca0ed859cae6b$export$2e2bcd8739ae039)(this);
    }
}
var $dd0a7f7aa58e6920$export$2e2bcd8739ae039 = $dd0a7f7aa58e6920$var$Index;


class $e1695c22a8a6e5ca$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/text`;
    }
    v1() {
        return new (0, $dd0a7f7aa58e6920$export$2e2bcd8739ae039)(this);
    }
}
var $e1695c22a8a6e5ca$export$2e2bcd8739ae039 = $e1695c22a8a6e5ca$var$Index;


class $74d82e20f81771f0$var$Index {
    rc;
    constructor(rc){
        this.rc = rc;
    }
    path() {
        return "/ai";
    }
    text() {
        return new (0, $e1695c22a8a6e5ca$export$2e2bcd8739ae039)(this);
    }
    audio() {
        return new (0, $8fdce3e2fdbde567$export$2e2bcd8739ae039)(this);
    }
    status() {
        return new (0, $b4a147efca4e25ab$export$2e2bcd8739ae039)(this);
    }
    insights() {
        return new (0, $ddd21951704539f8$export$2e2bcd8739ae039)(this);
    }
    ringsense() {
        return new (0, $c6b6bbba381e5c76$export$2e2bcd8739ae039)(this);
    }
}
var $74d82e20f81771f0$export$2e2bcd8739ae039 = $74d82e20f81771f0$var$Index;


class $9e59eed2a36aa678$var$Index {
    rc;
    _parent;
    pin;
    constructor(_parent, pin = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.pin = pin;
    }
    path(withParameter = true) {
        if (withParameter && this.pin !== null) return `${this._parent.path()}/pstn/${this.pin}`;
        return `${this._parent.path()}/pstn`;
    }
    /**
     * Finds a bridge by Host or Participant PSTN PIN.
     * HTTP Method: get
     * Endpoint: /rcvideo/v2/bridges/pin/pstn/{pin}
     * Rate Limit Group: Medium
     * App Permission: Video
     */ async get(queryParams, restRequestConfig) {
        if (this.pin === null) throw new Error("pin must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $9e59eed2a36aa678$export$2e2bcd8739ae039 = $9e59eed2a36aa678$var$Index;


class $2620af5501273c3b$var$Index {
    rc;
    _parent;
    pin;
    constructor(_parent, pin = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.pin = pin;
    }
    path(withParameter = true) {
        if (withParameter && this.pin !== null) return `${this._parent.path()}/web/${this.pin}`;
        return `${this._parent.path()}/web`;
    }
    /**
     * Finds a bridge by short identifier (Web PIN). Also it can be used to find a default bridge by the alias
     * (personal meeting name).
     *
     * HTTP Method: get
     * Endpoint: /rcvideo/v2/bridges/pin/web/{pin}
     * Rate Limit Group: Medium
     * App Permission: Video
     */ async get(queryParams, restRequestConfig) {
        if (this.pin === null) throw new Error("pin must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $2620af5501273c3b$export$2e2bcd8739ae039 = $2620af5501273c3b$var$Index;


class $16b5f3569f28b74f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/pin`;
    }
    web(pin = null) {
        return new (0, $2620af5501273c3b$export$2e2bcd8739ae039)(this, pin);
    }
    pstn(pin = null) {
        return new (0, $9e59eed2a36aa678$export$2e2bcd8739ae039)(this, pin);
    }
}
var $16b5f3569f28b74f$export$2e2bcd8739ae039 = $16b5f3569f28b74f$var$Index;


class $be4c49ff36606f16$var$Index {
    rc;
    _parent;
    bridgeId;
    constructor(_parent, bridgeId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.bridgeId = bridgeId;
    }
    path(withParameter = true) {
        if (withParameter && this.bridgeId !== null) return `${this._parent.path()}/bridges/${this.bridgeId}`;
        return `${this._parent.path()}/bridges`;
    }
    /**
     * Returns a bridge by `bridgeId` identifier.
     * HTTP Method: get
     * Endpoint: /rcvideo/v2/bridges/{bridgeId}
     * Rate Limit Group: Medium
     * App Permission: Video
     */ async get(queryParams, restRequestConfig) {
        if (this.bridgeId === null) throw new Error("bridgeId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a bridge by `bridgeId` identifier.
     * Deletion can only be done by the bridge owner, an owner's delegate or any user who has the **Super Admin** privilege.
     *
     * HTTP Method: delete
     * Endpoint: /rcvideo/v2/bridges/{bridgeId}
     * Rate Limit Group: Medium
     * App Permission: Video
     */ async delete(restRequestConfig) {
        if (this.bridgeId === null) throw new Error("bridgeId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a bridge by `bridgeId` identifier. The request body should contain JSON object with updating properties.
     * Update can only be done by the bridge owner, an owner's delegate or any user who has the **Super Admin** privilege.
     *
     * HTTP Method: patch
     * Endpoint: /rcvideo/v2/bridges/{bridgeId}
     * Rate Limit Group: Medium
     * App Permission: Video
     */ async patch(updateBridgeRequest, restRequestConfig) {
        if (this.bridgeId === null) throw new Error("bridgeId must be specified.");
        const r = await this.rc.patch(this.path(), updateBridgeRequest, undefined, restRequestConfig);
        return r.data;
    }
    pin() {
        return new (0, $16b5f3569f28b74f$export$2e2bcd8739ae039)(this);
    }
}
var $be4c49ff36606f16$export$2e2bcd8739ae039 = $be4c49ff36606f16$var$Index;


class $b93ca61ee3eb984a$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/default`;
    }
    /**
     * Returns a default bridge (PMI) for the user specified by `accountId`
     * and `extensionId` identifiers.
     *
     * HTTP Method: get
     * Endpoint: /rcvideo/v2/account/{accountId}/extension/{extensionId}/bridges/default
     * Rate Limit Group: Medium
     * App Permission: Video
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $b93ca61ee3eb984a$export$2e2bcd8739ae039 = $b93ca61ee3eb984a$var$Index;


class $93da3e9dfa9bbb69$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bridges`;
    }
    /**
     * Creates a new bridge for the user specified by `accountId` and `extensionId` identifiers. The request body
     * should contain JSON object which describes properties of the new bridge.
     * The bridge can be created by the owner, a delegate or any user who has the **Super Admin** privilege.
     *
     * HTTP Method: post
     * Endpoint: /rcvideo/v2/account/{accountId}/extension/{extensionId}/bridges
     * Rate Limit Group: Heavy
     * App Permission: Video
     */ async post(createBridgeRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), createBridgeRequest, undefined, restRequestConfig);
        return r.data;
    }
    default() {
        return new (0, $b93ca61ee3eb984a$export$2e2bcd8739ae039)(this);
    }
}
var $93da3e9dfa9bbb69$export$2e2bcd8739ae039 = $93da3e9dfa9bbb69$var$Index;


class $d397f2a8325a1c7b$var$Index {
    rc;
    _parent;
    extensionId;
    constructor(_parent, extensionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.extensionId = extensionId;
    }
    path(withParameter = true) {
        if (withParameter && this.extensionId !== null) return `${this._parent.path()}/extension/${this.extensionId}`;
        return `${this._parent.path()}/extension`;
    }
    bridges() {
        return new (0, $93da3e9dfa9bbb69$export$2e2bcd8739ae039)(this);
    }
}
var $d397f2a8325a1c7b$export$2e2bcd8739ae039 = $d397f2a8325a1c7b$var$Index;


class $0f8ad885752a3b20$var$Index {
    rc;
    _parent;
    accountId;
    constructor(_parent, accountId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.accountId = accountId;
    }
    path(withParameter = true) {
        if (withParameter && this.accountId !== null) return `${this._parent.path()}/account/${this.accountId}`;
        return `${this._parent.path()}/account`;
    }
    extension(extensionId = null) {
        return new (0, $d397f2a8325a1c7b$export$2e2bcd8739ae039)(this, extensionId);
    }
}
var $0f8ad885752a3b20$export$2e2bcd8739ae039 = $0f8ad885752a3b20$var$Index;


class $a9f4ead183fd9d4c$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v2`;
    }
    account(accountId = null) {
        return new (0, $0f8ad885752a3b20$export$2e2bcd8739ae039)(this, accountId);
    }
    bridges(bridgeId = null) {
        return new (0, $be4c49ff36606f16$export$2e2bcd8739ae039)(this, bridgeId);
    }
}
var $a9f4ead183fd9d4c$export$2e2bcd8739ae039 = $a9f4ead183fd9d4c$var$Index;


class $6cd0a9a5e6377f29$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/delegators`;
    }
    /**
     * Returns the list of users who can delegate bridge/meeting creation to the given user.
     * HTTP Method: get
     * Endpoint: /rcvideo/v1/accounts/{accountId}/extensions/{extensionId}/delegators
     * Rate Limit Group: Medium
     * App Permission: Video
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $6cd0a9a5e6377f29$export$2e2bcd8739ae039 = $6cd0a9a5e6377f29$var$Index;


class $9078980a68982ab3$var$Index {
    rc;
    _parent;
    extensionId;
    constructor(_parent, extensionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.extensionId = extensionId;
    }
    path(withParameter = true) {
        if (withParameter && this.extensionId !== null) return `${this._parent.path()}/extensions/${this.extensionId}`;
        return `${this._parent.path()}/extensions`;
    }
    delegators() {
        return new (0, $6cd0a9a5e6377f29$export$2e2bcd8739ae039)(this);
    }
}
var $9078980a68982ab3$export$2e2bcd8739ae039 = $9078980a68982ab3$var$Index;


class $8152d23636dfa479$var$Index {
    rc;
    _parent;
    accountId;
    constructor(_parent, accountId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.accountId = accountId;
    }
    path(withParameter = true) {
        if (withParameter && this.accountId !== null) return `${this._parent.path()}/accounts/${this.accountId}`;
        return `${this._parent.path()}/accounts`;
    }
    extensions(extensionId = null) {
        return new (0, $9078980a68982ab3$export$2e2bcd8739ae039)(this, extensionId);
    }
}
var $8152d23636dfa479$export$2e2bcd8739ae039 = $8152d23636dfa479$var$Index;


class $08b6fcc9407a2b2c$var$Index {
    rc;
    _parent;
    meetingId;
    constructor(_parent, meetingId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.meetingId = meetingId;
    }
    path(withParameter = true) {
        if (withParameter && this.meetingId !== null) return `${this._parent.path()}/meetings/${this.meetingId}`;
        return `${this._parent.path()}/meetings`;
    }
    /**
     * Returns the list of user meetings.
     * HTTP Method: get
     * Endpoint: /rcvideo/v1/history/meetings
     * Rate Limit Group: Light
     * App Permission: Video
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a user meeting by ID.
     * HTTP Method: get
     * Endpoint: /rcvideo/v1/history/meetings/{meetingId}
     * Rate Limit Group: Light
     * App Permission: Video
     */ async get(restRequestConfig) {
        if (this.meetingId === null) throw new Error("meetingId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $08b6fcc9407a2b2c$export$2e2bcd8739ae039 = $08b6fcc9407a2b2c$var$Index;


class $51a44f9ce455edeb$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/meetings`;
    }
    /**
     * Returns the list of completed meetings owned by all users of the account.
     *
     * HTTP Method: get
     * Endpoint: /rcvideo/v1/history/account/{accountId}/meetings
     * Rate Limit Group: Light
     * App Permission: Video
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $51a44f9ce455edeb$export$2e2bcd8739ae039 = $51a44f9ce455edeb$var$Index;


class $59067c7b2da54c65$var$Index {
    rc;
    _parent;
    accountId;
    constructor(_parent, accountId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.accountId = accountId;
    }
    path(withParameter = true) {
        if (withParameter && this.accountId !== null) return `${this._parent.path()}/account/${this.accountId}`;
        return `${this._parent.path()}/account`;
    }
    meetings() {
        return new (0, $51a44f9ce455edeb$export$2e2bcd8739ae039)(this);
    }
}
var $59067c7b2da54c65$export$2e2bcd8739ae039 = $59067c7b2da54c65$var$Index;


class $8c5bf70cbf9c2adb$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/history`;
    }
    account(accountId = null) {
        return new (0, $59067c7b2da54c65$export$2e2bcd8739ae039)(this, accountId);
    }
    meetings(meetingId = null) {
        return new (0, $08b6fcc9407a2b2c$export$2e2bcd8739ae039)(this, meetingId);
    }
}
var $8c5bf70cbf9c2adb$export$2e2bcd8739ae039 = $8c5bf70cbf9c2adb$var$Index;


class $8d7538119e2f7c43$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/recordings`;
    }
    /**
     * Returns the list of meeting recordings owned by all users of the account.
     *
     * HTTP Method: get
     * Endpoint: /rcvideo/v1/account/{accountId}/recordings
     * Rate Limit Group: Light
     * App Permission: Video
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $8d7538119e2f7c43$export$2e2bcd8739ae039 = $8d7538119e2f7c43$var$Index;


class $aa86ffbdaa78b272$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/recordings`;
    }
    /**
     * Returns all recordings owned by a specific extension.
     *
     * HTTP Method: get
     * Endpoint: /rcvideo/v1/account/{accountId}/extension/{extensionId}/recordings
     * Rate Limit Group: Light
     * App Permission: Video
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $aa86ffbdaa78b272$export$2e2bcd8739ae039 = $aa86ffbdaa78b272$var$Index;


class $0cd0c180921316ef$var$Index {
    rc;
    _parent;
    extensionId;
    constructor(_parent, extensionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.extensionId = extensionId;
    }
    path(withParameter = true) {
        if (withParameter && this.extensionId !== null) return `${this._parent.path()}/extension/${this.extensionId}`;
        return `${this._parent.path()}/extension`;
    }
    recordings() {
        return new (0, $aa86ffbdaa78b272$export$2e2bcd8739ae039)(this);
    }
}
var $0cd0c180921316ef$export$2e2bcd8739ae039 = $0cd0c180921316ef$var$Index;


class $aa6e42ce2e6f2985$var$Index {
    rc;
    _parent;
    accountId;
    constructor(_parent, accountId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.accountId = accountId;
    }
    path(withParameter = true) {
        if (withParameter && this.accountId !== null) return `${this._parent.path()}/account/${this.accountId}`;
        return `${this._parent.path()}/account`;
    }
    extension(extensionId = null) {
        return new (0, $0cd0c180921316ef$export$2e2bcd8739ae039)(this, extensionId);
    }
    recordings() {
        return new (0, $8d7538119e2f7c43$export$2e2bcd8739ae039)(this);
    }
}
var $aa6e42ce2e6f2985$export$2e2bcd8739ae039 = $aa6e42ce2e6f2985$var$Index;


class $0059f16fc32c99ec$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    account(accountId = null) {
        return new (0, $aa6e42ce2e6f2985$export$2e2bcd8739ae039)(this, accountId);
    }
    history() {
        return new (0, $8c5bf70cbf9c2adb$export$2e2bcd8739ae039)(this);
    }
    accounts(accountId = null) {
        return new (0, $8152d23636dfa479$export$2e2bcd8739ae039)(this, accountId);
    }
}
var $0059f16fc32c99ec$export$2e2bcd8739ae039 = $0059f16fc32c99ec$var$Index;


class $6d27b572f9549723$var$Index {
    rc;
    constructor(rc){
        this.rc = rc;
    }
    path() {
        return "/rcvideo";
    }
    v1() {
        return new (0, $0059f16fc32c99ec$export$2e2bcd8739ae039)(this);
    }
    v2() {
        return new (0, $a9f4ead183fd9d4c$export$2e2bcd8739ae039)(this);
    }
}
var $6d27b572f9549723$export$2e2bcd8739ae039 = $6d27b572f9549723$var$Index;


class $6f8c6feb8b6891b4$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sessions`;
    }
    /**
     * Returns the list of Webinar Sessions hosted by a current authorized user sorted by
     * 'scheduledStartTime' or 'creationTime' (if 'scheduledStartTime' is not set) in the ascending order
     *
     * HTTP Method: get
     * Endpoint: /webinar/configuration/v1/sessions
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $6f8c6feb8b6891b4$export$2e2bcd8739ae039 = $6f8c6feb8b6891b4$var$Index;


class $bcf1adea8b5b6691$var$Index {
    rc;
    _parent;
    inviteeId;
    constructor(_parent, inviteeId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.inviteeId = inviteeId;
    }
    path(withParameter = true) {
        if (withParameter && this.inviteeId !== null) return `${this._parent.path()}/invitees/${this.inviteeId}`;
        return `${this._parent.path()}/invitees`;
    }
    /**
     * Returns the list of Invitees (co-hosts and panelists in phase 1
     * and also invited attendees in subsequent phases) of a given Webinar Session.
     * An implicit record created for a Webinar 'Host' is always returned.
     *
     * HTTP Method: get
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}/invitees
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Adds, updates and deletes Webinar Session invitees in bulk (co-hosts and panelists in phase 1
     * and also invited attendees in subsequent phases).
     * The payload may contain multiple added, updated or deleted invitees.
     * For each added record 'role' and either 'firstName'/'lastName'/'email' (for non-authenticated users)
     * or 'linkedUser.*' (for authenticated users) must be specified, but not both.
     * For updated invitees 'id'  and 'role' must be specified, 'linkedUser' change is not supported.
     * For deleted invitees only there ids should be specified.
     * The response contains added/updated records (full) and deleted records (ids only).
     *
     * Deleting an invitee for a Session in 'Active' or 'Finished' status is prohibited.
     *
     * HTTP Method: patch
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}/invitees
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async patch(bulkUpdateInviteesRequest, restRequestConfig) {
        const r = await this.rc.patch(this.path(false), bulkUpdateInviteesRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a Session Invitee information by ID
     * HTTP Method: get
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}/invitees/{inviteeId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(restRequestConfig) {
        if (this.inviteeId === null) throw new Error("inviteeId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a Session Invitee. 'role' is required (it can be changed from 'Panelist' to 'CoHost' or vise versa).
     * It is disallowed to update 'linkedUser': it should be done by deleting then adding an invitee.
     * For non-authenticated users 'firstName'/'lastName'/'email' can be specified, but not both.
     * Implicit record created for a Webinar 'Host' cannot be modified.
     * Also it is disallowed to change any other role to 'Host'.
     *
     * HTTP Method: put
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}/invitees/{inviteeId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async put(updateInviteeRequest, restRequestConfig) {
        if (this.inviteeId === null) throw new Error("inviteeId must be specified.");
        const r = await this.rc.put(this.path(), updateInviteeRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a Session Invitee. Implicit record created for a Webinar 'Host' cannot be deleted.
     * Deleting an invitee for a Session in 'Active' or 'Finished' status is prohibited (HTTP 403).
     *
     * HTTP Method: delete
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}/invitees/{inviteeId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async delete(restRequestConfig) {
        if (this.inviteeId === null) throw new Error("inviteeId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $bcf1adea8b5b6691$export$2e2bcd8739ae039 = $bcf1adea8b5b6691$var$Index;


class $e01c38d4e9dc06bd$var$Index {
    rc;
    _parent;
    sessionId;
    constructor(_parent, sessionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.sessionId = sessionId;
    }
    path(withParameter = true) {
        if (withParameter && this.sessionId !== null) return `${this._parent.path()}/sessions/${this.sessionId}`;
        return `${this._parent.path()}/sessions`;
    }
    /**
     * Creates a new Session for a given Webinar
     * HTTP Method: post
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async post(wcsSessionWithLocaleCodeModel, restRequestConfig) {
        const r = await this.rc.post(this.path(false), wcsSessionWithLocaleCodeModel, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a Webinar Session by ID.
     * HTTP Method: get
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(restRequestConfig) {
        if (this.sessionId === null) throw new Error("sessionId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a Webinar Session. All child objects (Invitees) will be also deleted.
     * It is disallowed to delete a Session which is in 'Active' or 'Finished' state
     *
     * HTTP Method: delete
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async delete(restRequestConfig) {
        if (this.sessionId === null) throw new Error("sessionId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a Webinar Session. The payload may contain certain attributes from the Session resource
     * (it is a partial update). Changing the 'status' field usually invokes certain workflow actions.
     * Updating a Session in 'Active' or 'Finished' status is prohibited.
     * Some status transitions (for example, to 'Active" or 'Finished') may be prohibited.
     *
     * HTTP Method: patch
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async patch(wcsSessionWithLocaleCodeModel, restRequestConfig) {
        if (this.sessionId === null) throw new Error("sessionId must be specified.");
        const r = await this.rc.patch(this.path(), wcsSessionWithLocaleCodeModel, undefined, restRequestConfig);
        return r.data;
    }
    invitees(inviteeId = null) {
        return new (0, $bcf1adea8b5b6691$export$2e2bcd8739ae039)(this, inviteeId);
    }
}
var $e01c38d4e9dc06bd$export$2e2bcd8739ae039 = $e01c38d4e9dc06bd$var$Index;


class $8bda800c35ef95dd$var$Index {
    rc;
    _parent;
    webinarId;
    constructor(_parent, webinarId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.webinarId = webinarId;
    }
    path(withParameter = true) {
        if (withParameter && this.webinarId !== null) return `${this._parent.path()}/webinars/${this.webinarId}`;
        return `${this._parent.path()}/webinars`;
    }
    /**
     * Returns the list of Webinars hosted by a current authorized user sorted by 'scheduledStartTime' or 'creationTime' in the ascending order.
     *
     * HTTP Method: get
     * Endpoint: /webinar/configuration/v1/webinars
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new webinar.
     *
     * If "host" parameter is NOT passed then the current authorized user will become a Host.
     * If "host" parameter is passed then the caller must be a company administrator and have "WebinarSettings" permission.
     * "host.linkedUser.accountId" must be the same as authorized user's account ID.
     *
     * The webinar settings which are not mandated at account level or are unlocked can be
     * specified. All other settings are defaulted according to account policy.
     *
     * HTTP Method: post
     * Endpoint: /webinar/configuration/v1/webinars
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async post(webinarCreationRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), webinarCreationRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a Webinar information by ID.
     * Some webinar settings are returned basing on webinar-level overrides, other - from default settings defined at account level.
     *
     * HTTP Method: get
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(restRequestConfig) {
        if (this.webinarId === null) throw new Error("webinarId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a Webinar by ID. All child objects (Sessions, Invitees) will be also deleted.
     * It is disallowed to delete a Webinar which has at least one Session in 'Active' or 'Finished' state.
     *
     * HTTP Method: delete
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async delete(restRequestConfig) {
        if (this.webinarId === null) throw new Error("webinarId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a Webinar. The payload may contain just changed fields of a Webinar resource (it is a partial update):
     * - host cannot be changed, and host user information cannot be updated;
     * - only the settings which are not mandated at account level or are unlocked can be
     * changed;
     * - in order to reset a webinar password it should be passed as an empty string;
     * - "registrationStatus" cannot be changed.
     *
     * HTTP Method: patch
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async patch(webinarBaseModel, restRequestConfig) {
        if (this.webinarId === null) throw new Error("webinarId must be specified.");
        const r = await this.rc.patch(this.path(), webinarBaseModel, undefined, restRequestConfig);
        return r.data;
    }
    sessions(sessionId = null) {
        return new (0, $e01c38d4e9dc06bd$export$2e2bcd8739ae039)(this, sessionId);
    }
}
var $8bda800c35ef95dd$export$2e2bcd8739ae039 = $8bda800c35ef95dd$var$Index;


class $0191971df8dc208d$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sessions`;
    }
    /**
     * Returns the list of Webinar Sessions hosted by all company users or particular user(s) sorted by
     * 'scheduledStartTime' or 'creationTime' (if 'scheduledStartTime' is not set) in the ascending ordered.
     * The user must have "WebinarSettings" permission granted otherwise the API returns HTTP 403.
     *
     * HTTP Method: get
     * Endpoint: /webinar/configuration/v1/company/sessions
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $0191971df8dc208d$export$2e2bcd8739ae039 = $0191971df8dc208d$var$Index;


class $f2e5e468251598bb$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/company`;
    }
    sessions() {
        return new (0, $0191971df8dc208d$export$2e2bcd8739ae039)(this);
    }
}
var $f2e5e468251598bb$export$2e2bcd8739ae039 = $f2e5e468251598bb$var$Index;


class $ee902d0e9c89565b$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    company() {
        return new (0, $f2e5e468251598bb$export$2e2bcd8739ae039)(this);
    }
    webinars(webinarId = null) {
        return new (0, $8bda800c35ef95dd$export$2e2bcd8739ae039)(this, webinarId);
    }
    sessions() {
        return new (0, $6f8c6feb8b6891b4$export$2e2bcd8739ae039)(this);
    }
}
var $ee902d0e9c89565b$export$2e2bcd8739ae039 = $ee902d0e9c89565b$var$Index;


class $c0795c0b5fac7240$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/configuration`;
    }
    v1() {
        return new (0, $ee902d0e9c89565b$export$2e2bcd8739ae039)(this);
    }
}
var $c0795c0b5fac7240$export$2e2bcd8739ae039 = $c0795c0b5fac7240$var$Index;


class $6f88d596cf5a3ada$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/renew`;
    }
    /**
     * Renews the existing webinar subscription.
     * HTTP Method: post
     * Endpoint: /webinar/notifications/v1/subscriptions/{subscriptionId}/renew
     * Rate Limit Group: Light
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $6f88d596cf5a3ada$export$2e2bcd8739ae039 = $6f88d596cf5a3ada$var$Index;


class $f6a583e07fd69ddf$var$Index {
    rc;
    _parent;
    subscriptionId;
    constructor(_parent, subscriptionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.subscriptionId = subscriptionId;
    }
    path(withParameter = true) {
        if (withParameter && this.subscriptionId !== null) return `${this._parent.path()}/subscriptions/${this.subscriptionId}`;
        return `${this._parent.path()}/subscriptions`;
    }
    /**
     * Returns a list of webinar subscriptions created by the user for the current authorized client application.
     * HTTP Method: get
     * Endpoint: /webinar/notifications/v1/subscriptions
     * Rate Limit Group: Light
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new webinar subscription for the current authorized user / client application.
     * HTTP Method: post
     * Endpoint: /webinar/notifications/v1/subscriptions
     * Rate Limit Group: Medium
     */ async post(createWebhookSubscriptionRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createWebhookSubscriptionRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the webinar subscription by ID
     * HTTP Method: get
     * Endpoint: /webinar/notifications/v1/subscriptions/{subscriptionId}
     * Rate Limit Group: Light
     */ async get(restRequestConfig) {
        if (this.subscriptionId === null) throw new Error("subscriptionId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the existing subscription. The client application can extend/narrow
     * the list of events for which it receives notifications within this subscription.
     * If event filters are specified, calling this method modifies them for the
     * existing subscription. The method also allows setting the subscription expiration time.
     * If other than `events` and `expiresIn` parameters are passed in the request they will be ignored.
     * If the request body is empty then the specified subscription will be just renewed without any
     * event filter modifications and with default expiration time.
     *
     * HTTP Method: put
     * Endpoint: /webinar/notifications/v1/subscriptions/{subscriptionId}
     * Rate Limit Group: Medium
     */ async put(updateSubscriptionRequest, restRequestConfig) {
        if (this.subscriptionId === null) throw new Error("subscriptionId must be specified.");
        const r = await this.rc.put(this.path(), updateSubscriptionRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Cancels the existing webinar subscription.
     * HTTP Method: delete
     * Endpoint: /webinar/notifications/v1/subscriptions/{subscriptionId}
     * Rate Limit Group: Medium
     */ async delete(restRequestConfig) {
        if (this.subscriptionId === null) throw new Error("subscriptionId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    renew() {
        return new (0, $6f88d596cf5a3ada$export$2e2bcd8739ae039)(this);
    }
}
var $f6a583e07fd69ddf$export$2e2bcd8739ae039 = $f6a583e07fd69ddf$var$Index;


class $4da8865d9003246d$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    subscriptions(subscriptionId = null) {
        return new (0, $f6a583e07fd69ddf$export$2e2bcd8739ae039)(this, subscriptionId);
    }
}
var $4da8865d9003246d$export$2e2bcd8739ae039 = $4da8865d9003246d$var$Index;


class $8ce2263c7ba83e19$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/notifications`;
    }
    v1() {
        return new (0, $4da8865d9003246d$export$2e2bcd8739ae039)(this);
    }
}
var $8ce2263c7ba83e19$export$2e2bcd8739ae039 = $8ce2263c7ba83e19$var$Index;


class $cbaf085d6c670567$var$Index {
    rc;
    _parent;
    registrantId;
    constructor(_parent, registrantId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.registrantId = registrantId;
    }
    path(withParameter = true) {
        if (withParameter && this.registrantId !== null) return `${this._parent.path()}/registrants/${this.registrantId}`;
        return `${this._parent.path()}/registrants`;
    }
    /**
     * Returns the list of Registrants ordered by "id" ascending.
     *
     * A caller must be an authorized user: either a host of the webinar or an IT Admin:
     * a user from host's account with "WebinarSettings" permission.
     *
     * HTTP Method: get
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}/registrants
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new Registrant for a given session.
     *
     * Registration MUST be open for the session for this call to succeed (otherwise it should return HTTP 403).
     *
     * A caller must be an authorized user: either a host of the webinar or an IT Admin:
     * a user from host's account with "WebinarSettings" permission.
     *
     * HTTP Method: post
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}/registrants
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async post(registrantBaseModelWithQuestionnaire, restRequestConfig) {
        const r = await this.rc.post(this.path(false), registrantBaseModelWithQuestionnaire, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a Registrant by ID.
     *
     * A caller must be an authorized user: either a host of the webinar or an IT Admin:
     * a user from host's account with "WebinarSettings" permission.
     *
     * HTTP Method: get
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}/registrants/{registrantId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(queryParams, restRequestConfig) {
        if (this.registrantId === null) throw new Error("registrantId must be specified.");
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a Registrant by ID.
     *
     * Session must not be in finished state (otherwise it should return HTTP 403).
     *
     * A caller must be an authorized user: either a host of the webinar or an IT Admin:
     * a user from host's account with "WebinarSettings" permission.
     *
     * HTTP Method: delete
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}/registrants/{registrantId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async delete(restRequestConfig) {
        if (this.registrantId === null) throw new Error("registrantId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $cbaf085d6c670567$export$2e2bcd8739ae039 = $cbaf085d6c670567$var$Index;


class $9a73341de7e4551f$var$Index {
    rc;
    _parent;
    sessionId;
    constructor(_parent, sessionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.sessionId = sessionId;
    }
    path(withParameter = true) {
        if (withParameter && this.sessionId !== null) return `${this._parent.path()}/sessions/${this.sessionId}`;
        return `${this._parent.path()}/sessions`;
    }
    /**
     * Returns a registration Session information by ID.
     *
     * A caller must be an authorized user: either a host of the webinar or an IT Admin:
     * a user from host's account with "WebinarSettings" permission.
     *
     * HTTP Method: get
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(restRequestConfig) {
        if (this.sessionId === null) throw new Error("sessionId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a Session by ID.
     *
     * This is a PARTIAL update (PATCH), client may call it providing only attributes which are to be changed.
     *
     * A caller must be an authorized user: either a host of the webinar or an IT Admin:
     * a user from host's account with "WebinarSettings" permission.
     *
     * If a session record with given ID doesn't exist on Registration Service side the API should return HTTP 404.
     *
     * HTTP Method: patch
     * Endpoint: /webinar/registration/v1/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */ async patch(regSessionModel, restRequestConfig) {
        if (this.sessionId === null) throw new Error("sessionId must be specified.");
        const r = await this.rc.patch(this.path(), regSessionModel, undefined, restRequestConfig);
        return r.data;
    }
    registrants(registrantId = null) {
        return new (0, $cbaf085d6c670567$export$2e2bcd8739ae039)(this, registrantId);
    }
}
var $9a73341de7e4551f$export$2e2bcd8739ae039 = $9a73341de7e4551f$var$Index;


class $8c3077849d9e2b21$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    sessions(sessionId = null) {
        return new (0, $9a73341de7e4551f$export$2e2bcd8739ae039)(this, sessionId);
    }
}
var $8c3077849d9e2b21$export$2e2bcd8739ae039 = $8c3077849d9e2b21$var$Index;


class $955175133d2854e8$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/registration`;
    }
    v1() {
        return new (0, $8c3077849d9e2b21$export$2e2bcd8739ae039)(this);
    }
}
var $955175133d2854e8$export$2e2bcd8739ae039 = $955175133d2854e8$var$Index;


class $b7ee6a4e175a04fc$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/download`;
    }
    /**
     * Returns the webinar recording download link (both Webinar host's and admin interface).
     *
     * If called by a webinar host, the API returns error (403) if recording downloading is prohibited by company settings.
     * The admin user who has "WebinarSettings" permission should be able to download recording regardless of current company settings.
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/recordings/{recordingId}/download
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $b7ee6a4e175a04fc$export$2e2bcd8739ae039 = $b7ee6a4e175a04fc$var$Index;


class $527edc5e97c9d912$var$Index {
    rc;
    _parent;
    recordingId;
    constructor(_parent, recordingId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.recordingId = recordingId;
    }
    path(withParameter = true) {
        if (withParameter && this.recordingId !== null) return `${this._parent.path()}/recordings/${this.recordingId}`;
        return `${this._parent.path()}/recordings`;
    }
    /**
     * Returns the list of webinar recordings for a given webinar host user
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/recordings
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the webinar recording by ID (Webinar host's interface).
     * This API also returns sharing link if sharing is enabled.
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/recordings/{recordingId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(restRequestConfig) {
        if (this.recordingId === null) throw new Error("recordingId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    download() {
        return new (0, $b7ee6a4e175a04fc$export$2e2bcd8739ae039)(this);
    }
}
var $527edc5e97c9d912$export$2e2bcd8739ae039 = $527edc5e97c9d912$var$Index;


class $f25b776e76c58660$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sessions`;
    }
    /**
     * Returns the list of historical Webinar Sessions hosted by a current authorized user
     * sorted by 'endTime' in the descending order. Depending on a session status 'endTime' can
     * represent actual end time or scheduled end time.
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/sessions
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $f25b776e76c58660$export$2e2bcd8739ae039 = $f25b776e76c58660$var$Index;


class $b0c61e6273732391$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/self`;
    }
    /**
     * Returns the participant information specific to a webinar session. Accessible by any authenticated participant.
     * For a non-authenticated participant, API returns error.
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/webinars/{webinarId}/sessions/{sessionId}/participants/self
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $b0c61e6273732391$export$2e2bcd8739ae039 = $b0c61e6273732391$var$Index;


class $b6f1b83b6fe204f8$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/participants`;
    }
    /**
     * Returns the list of participants of a given Webinar Session (host interface).
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/webinars/{webinarId}/sessions/{sessionId}/participants
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    self() {
        return new (0, $b0c61e6273732391$export$2e2bcd8739ae039)(this);
    }
}
var $b6f1b83b6fe204f8$export$2e2bcd8739ae039 = $b6f1b83b6fe204f8$var$Index;


class $bf0992bee4bb7225$var$Index {
    rc;
    _parent;
    inviteeId;
    constructor(_parent, inviteeId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.inviteeId = inviteeId;
    }
    path(withParameter = true) {
        if (withParameter && this.inviteeId !== null) return `${this._parent.path()}/invitees/${this.inviteeId}`;
        return `${this._parent.path()}/invitees`;
    }
    /**
     * Returns the list of Invitees (co-hosts and panelists) of a given Webinar Session (host interface).
     * An implicit record created for a Webinar 'Host' is always returned.
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/webinars/{webinarId}/sessions/{sessionId}/invitees
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a historical session invitee information by ID (host interface).
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/webinars/{webinarId}/sessions/{sessionId}/invitees/{inviteeId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(restRequestConfig) {
        if (this.inviteeId === null) throw new Error("inviteeId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $bf0992bee4bb7225$export$2e2bcd8739ae039 = $bf0992bee4bb7225$var$Index;


class $c1f2242340d6383b$var$Index {
    rc;
    _parent;
    sessionId;
    constructor(_parent, sessionId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.sessionId = sessionId;
    }
    path(withParameter = true) {
        if (withParameter && this.sessionId !== null) return `${this._parent.path()}/sessions/${this.sessionId}`;
        return `${this._parent.path()}/sessions`;
    }
    /**
     * Returns a historical webinar Session by ID. Access allowed to participants with original role as Host or CoHost.
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/webinars/{webinarId}/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(restRequestConfig) {
        if (this.sessionId === null) throw new Error("sessionId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    invitees(inviteeId = null) {
        return new (0, $bf0992bee4bb7225$export$2e2bcd8739ae039)(this, inviteeId);
    }
    participants() {
        return new (0, $b6f1b83b6fe204f8$export$2e2bcd8739ae039)(this);
    }
}
var $c1f2242340d6383b$export$2e2bcd8739ae039 = $c1f2242340d6383b$var$Index;


class $f355f7ac4478246b$var$Index {
    rc;
    _parent;
    webinarId;
    constructor(_parent, webinarId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.webinarId = webinarId;
    }
    path(withParameter = true) {
        if (withParameter && this.webinarId !== null) return `${this._parent.path()}/webinars/${this.webinarId}`;
        return `${this._parent.path()}/webinars`;
    }
    /**
     * Returns a historical webinar information by ID (host interface)
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/webinars/{webinarId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(restRequestConfig) {
        if (this.webinarId === null) throw new Error("webinarId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    sessions(sessionId = null) {
        return new (0, $c1f2242340d6383b$export$2e2bcd8739ae039)(this, sessionId);
    }
}
var $f355f7ac4478246b$export$2e2bcd8739ae039 = $f355f7ac4478246b$var$Index;


class $66fc0ac1216135b2$var$Index {
    rc;
    _parent;
    recordingId;
    constructor(_parent, recordingId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.recordingId = recordingId;
    }
    path(withParameter = true) {
        if (withParameter && this.recordingId !== null) return `${this._parent.path()}/recordings/${this.recordingId}`;
        return `${this._parent.path()}/recordings`;
    }
    /**
     * Returns the list of webinar recordings (Administrator's interface).
     * The user must have "WebinarSettings" permission granted otherwise the API returns HTTP 403.
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/company/recordings
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the webinar recording by ID (Administrator's interface).
     *
     * The user must have "WebinarSettings" permission granted otherwise the API returns HTTP 403.
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/company/recordings/{recordingId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(restRequestConfig) {
        if (this.recordingId === null) throw new Error("recordingId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $66fc0ac1216135b2$export$2e2bcd8739ae039 = $66fc0ac1216135b2$var$Index;


class $1eed5e14ce942440$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sessions`;
    }
    /**
     * Returns the list of historical Webinar Sessions hosted by particular user(s) or all company users
     * sorted by 'endTime' in the descending order. Depending on a session status 'endTime' can
     * represent actual end time or scheduled end time.
     * The user must have "WebinarSettings" permission granted otherwise the API returns HTTP 403.
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/company/sessions
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $1eed5e14ce942440$export$2e2bcd8739ae039 = $1eed5e14ce942440$var$Index;


class $c8bde93fcc04bb2c$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/company`;
    }
    sessions() {
        return new (0, $1eed5e14ce942440$export$2e2bcd8739ae039)(this);
    }
    recordings(recordingId = null) {
        return new (0, $66fc0ac1216135b2$export$2e2bcd8739ae039)(this, recordingId);
    }
}
var $c8bde93fcc04bb2c$export$2e2bcd8739ae039 = $c8bde93fcc04bb2c$var$Index;


class $a582a03be2c4546f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    company() {
        return new (0, $c8bde93fcc04bb2c$export$2e2bcd8739ae039)(this);
    }
    webinars(webinarId = null) {
        return new (0, $f355f7ac4478246b$export$2e2bcd8739ae039)(this, webinarId);
    }
    sessions() {
        return new (0, $f25b776e76c58660$export$2e2bcd8739ae039)(this);
    }
    recordings(recordingId = null) {
        return new (0, $527edc5e97c9d912$export$2e2bcd8739ae039)(this, recordingId);
    }
}
var $a582a03be2c4546f$export$2e2bcd8739ae039 = $a582a03be2c4546f$var$Index;


class $d2278144a5f09161$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/history`;
    }
    v1() {
        return new (0, $a582a03be2c4546f$export$2e2bcd8739ae039)(this);
    }
}
var $d2278144a5f09161$export$2e2bcd8739ae039 = $d2278144a5f09161$var$Index;


class $fe45c0605d673c1f$var$Index {
    rc;
    constructor(rc){
        this.rc = rc;
    }
    path() {
        return "/webinar";
    }
    history() {
        return new (0, $d2278144a5f09161$export$2e2bcd8739ae039)(this);
    }
    registration() {
        return new (0, $955175133d2854e8$export$2e2bcd8739ae039)(this);
    }
    notifications() {
        return new (0, $8ce2263c7ba83e19$export$2e2bcd8739ae039)(this);
    }
    configuration() {
        return new (0, $c0795c0b5fac7240$export$2e2bcd8739ae039)(this);
    }
}
var $fe45c0605d673c1f$export$2e2bcd8739ae039 = $fe45c0605d673c1f$var$Index;


class $75bfaa7712243597$var$Index {
    rc;
    _parent;
    cardId;
    constructor(_parent, cardId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.cardId = cardId;
    }
    path(withParameter = true) {
        if (withParameter && this.cardId !== null) return `${this._parent.path()}/adaptive-cards/${this.cardId}`;
        return `${this._parent.path()}/adaptive-cards`;
    }
    /**
     * Returns adaptive card(s) with given id(s).
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/adaptive-cards/{cardId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.cardId === null) throw new Error("cardId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates an adaptive card.
     * HTTP Method: put
     * Endpoint: /team-messaging/v1/adaptive-cards/{cardId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async put(adaptiveCardRequest, restRequestConfig) {
        if (this.cardId === null) throw new Error("cardId must be specified.");
        const r = await this.rc.put(this.path(), adaptiveCardRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes an adaptive card by ID.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/adaptive-cards/{cardId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async delete(restRequestConfig) {
        if (this.cardId === null) throw new Error("cardId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $75bfaa7712243597$export$2e2bcd8739ae039 = $75bfaa7712243597$var$Index;


class $bb91fa1cbf07b74a$var$Index {
    rc;
    _parent;
    chatId;
    constructor(_parent, chatId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.chatId = chatId;
    }
    path(withParameter = true) {
        if (withParameter && this.chatId !== null) return `${this._parent.path()}/conversations/${this.chatId}`;
        return `${this._parent.path()}/conversations`;
    }
    /**
     * Returns the list of conversations where the user is a member. All records in response are sorted by creation time of a conversation in ascending order. Conversation is a chat of the *Group* type.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/conversations
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new conversation or opens the existing one. If the conversation already exists, then its ID will be returned in response. A conversation is an adhoc discussion between a particular set of users, not featuring any specific name or description; it is a chat of 'Group' type. If you add a person to the existing conversation (group), it creates a whole new conversation.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/conversations
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(createConversationRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createConversationRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns information about the specified conversation, including the list of conversation participants. A conversation is an adhoc discussion between a particular set of users, not featuring any specific name or description; it is a chat of 'Group' type. If you add a person to the existing conversation, it creates a whole new conversation.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/conversations/{chatId}
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.chatId === null) throw new Error("chatId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $bb91fa1cbf07b74a$export$2e2bcd8739ae039 = $bb91fa1cbf07b74a$var$Index;


class $9a52072f159c62ce$var$Index {
    rc;
    _parent;
    taskId;
    constructor(_parent, taskId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.taskId = taskId;
    }
    path(withParameter = true) {
        if (withParameter && this.taskId !== null) return `${this._parent.path()}/data-export/${this.taskId}`;
        return `${this._parent.path()}/data-export`;
    }
    /**
     * Returns the list of Glip data export tasks.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/data-export
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     * User Permission: Glip
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a task for Glip data export and returns a link at which the exported data will be available in future once the task is implemented. The exported data can be downloaded by calling Get Data Export Task method with the specified task ID. Simultaneously no more than 2 tasks per company can be created.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/data-export
     * Rate Limit Group: Heavy
     * App Permission: TeamMessaging
     * User Permission: Glip
     */ async post(createDataExportTaskRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createDataExportTaskRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the links for downloading Glip data exported within the specified task. If the export task is still in progress, then only the task status will be returned. If the data is ready for downloading, then the list of URLs will be returned.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/data-export/{taskId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     * User Permission: Glip
     */ async get(restRequestConfig) {
        if (this.taskId === null) throw new Error("taskId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $9a52072f159c62ce$export$2e2bcd8739ae039 = $9a52072f159c62ce$var$Index;


class $217e7df4f0c4fa9d$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/favorites`;
    }
    /**
     * Returns a list of the current user's favorite chats.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/favorites
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $217e7df4f0c4fa9d$export$2e2bcd8739ae039 = $217e7df4f0c4fa9d$var$Index;


class $92121f0571446e9f$var$Index {
    rc;
    _parent;
    companyId;
    constructor(_parent, companyId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.companyId = companyId;
    }
    path(withParameter = true) {
        if (withParameter && this.companyId !== null) return `${this._parent.path()}/companies/${this.companyId}`;
        return `${this._parent.path()}/companies`;
    }
    /**
     * Returns information about one or more companies by their IDs.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/companies/{companyId}
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.companyId === null) throw new Error("companyId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $92121f0571446e9f$export$2e2bcd8739ae039 = $92121f0571446e9f$var$Index;


class $29c68bf83b821d86$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/everyone`;
    }
    /**
     * Returns information about "Everyone" chat (a company level chat which includes all employees).
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/everyone
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates "Everyone" chat information.
     * HTTP Method: patch
     * Endpoint: /team-messaging/v1/everyone
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async patch(updateEveryoneTeamRequest, restRequestConfig) {
        const r = await this.rc.patch(this.path(), updateEveryoneTeamRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $29c68bf83b821d86$export$2e2bcd8739ae039 = $29c68bf83b821d86$var$Index;


class $7854e53b4174dde8$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/activate`;
    }
    /**
     * Activates a webhook by ID.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/webhooks/{webhookId}/activate
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $7854e53b4174dde8$export$2e2bcd8739ae039 = $7854e53b4174dde8$var$Index;


class $e6e028271d7c4be1$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/suspend`;
    }
    /**
     * Suspends a webhook by ID.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/webhooks/{webhookId}/suspend
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $e6e028271d7c4be1$export$2e2bcd8739ae039 = $e6e028271d7c4be1$var$Index;


class $04a67b78e8210925$var$Index {
    rc;
    _parent;
    webhookId;
    constructor(_parent, webhookId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.webhookId = webhookId;
    }
    path(withParameter = true) {
        if (withParameter && this.webhookId !== null) return `${this._parent.path()}/webhooks/${this.webhookId}`;
        return `${this._parent.path()}/webhooks`;
    }
    /**
     * Returns the list of all webhooks associated with the current account.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/webhooks
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns webhooks(s) with the specified id(s).
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/webhooks/{webhookId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.webhookId === null) throw new Error("webhookId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a webhook by ID.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/webhooks/{webhookId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async delete(restRequestConfig) {
        if (this.webhookId === null) throw new Error("webhookId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    suspend() {
        return new (0, $e6e028271d7c4be1$export$2e2bcd8739ae039)(this);
    }
    activate() {
        return new (0, $7854e53b4174dde8$export$2e2bcd8739ae039)(this);
    }
}
var $04a67b78e8210925$export$2e2bcd8739ae039 = $04a67b78e8210925$var$Index;


class $b7a079e47a7e16e1$var$Index {
    rc;
    _parent;
    personId;
    constructor(_parent, personId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.personId = personId;
    }
    path(withParameter = true) {
        if (withParameter && this.personId !== null) return `${this._parent.path()}/persons/${this.personId}`;
        return `${this._parent.path()}/persons`;
    }
    /**
     * Returns a user or multiple users by their ID(s).
     * [Batch requests](https://developers.ringcentral.com/guide/basics/batch-requests) are supported.
     *
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/persons/{personId}
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.personId === null) throw new Error("personId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
var $b7a079e47a7e16e1$export$2e2bcd8739ae039 = $b7a079e47a7e16e1$var$Index;


class $6cfd0c6456200538$var$Index {
    rc;
    _parent;
    eventId;
    constructor(_parent, eventId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.eventId = eventId;
    }
    path(withParameter = true) {
        if (withParameter && this.eventId !== null) return `${this._parent.path()}/events/${this.eventId}`;
        return `${this._parent.path()}/events`;
    }
    /**
     * Returns all calendar events created by the current user.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/events
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new calendar event.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/events
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(tMCreateEventRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), tMCreateEventRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the specified calendar event(s) by ID(s).
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/events/{eventId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.eventId === null) throw new Error("eventId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the specified calendar event.
     * HTTP Method: put
     * Endpoint: /team-messaging/v1/events/{eventId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async put(tMCreateEventRequest, restRequestConfig) {
        if (this.eventId === null) throw new Error("eventId must be specified.");
        const r = await this.rc.put(this.path(), tMCreateEventRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the specified calendar event.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/events/{eventId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async delete(restRequestConfig) {
        if (this.eventId === null) throw new Error("eventId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $6cfd0c6456200538$export$2e2bcd8739ae039 = $6cfd0c6456200538$var$Index;


class $015da22fe51fd3a7$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/chats`;
    }
    /**
     * Returns recent chats where the user is a member. All records in response are sorted by the `lastModifiedTime` in descending order (the latest changed chat is displayed first on page)
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/recent/chats
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
var $015da22fe51fd3a7$export$2e2bcd8739ae039 = $015da22fe51fd3a7$var$Index;


class $82bd5abee41f44e9$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/recent`;
    }
    chats() {
        return new (0, $015da22fe51fd3a7$export$2e2bcd8739ae039)(this);
    }
}
var $82bd5abee41f44e9$export$2e2bcd8739ae039 = $82bd5abee41f44e9$var$Index;


class $e00040ef27d8c0dd$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/webhooks`;
    }
    /**
     * Returns webhooks which are available for the current user by group ID.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/groups/{groupId}/webhooks
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new webhook.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/groups/{groupId}/webhooks
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $e00040ef27d8c0dd$export$2e2bcd8739ae039 = $e00040ef27d8c0dd$var$Index;


class $53bfa3ba85725e3a$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/events`;
    }
    /**
     * Returns a list of calendar events available for the current user within the specified group. Users can only see their personal tasks and public tasks.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/groups/{groupId}/events
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new calendar event within the specified group.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/groups/{groupId}/events
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(tMCreateEventRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), tMCreateEventRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $53bfa3ba85725e3a$export$2e2bcd8739ae039 = $53bfa3ba85725e3a$var$Index;


class $6ed9017ace2d5976$var$Index {
    rc;
    _parent;
    groupId;
    constructor(_parent, groupId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.groupId = groupId;
    }
    path(withParameter = true) {
        if (withParameter && this.groupId !== null) return `${this._parent.path()}/groups/${this.groupId}`;
        return `${this._parent.path()}/groups`;
    }
    events() {
        return new (0, $53bfa3ba85725e3a$export$2e2bcd8739ae039)(this);
    }
    webhooks() {
        return new (0, $e00040ef27d8c0dd$export$2e2bcd8739ae039)(this);
    }
}
var $6ed9017ace2d5976$export$2e2bcd8739ae039 = $6ed9017ace2d5976$var$Index;



class $9d646cfc6b3d61f6$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/files`;
    }
    /**
     * Posts a file or multiple files.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/files
     * Rate Limit Group: Heavy
     * App Permission: TeamMessaging
     */ async post(createGlipFileNewRequest, queryParams, restRequestConfig) {
        const formData = await (0, $f0364022b419ce8e$export$2e2bcd8739ae039).getFormData(createGlipFileNewRequest);
        const r = await this.rc.post(this.path(), formData, queryParams, restRequestConfig);
        return r.data;
    }
}
var $9d646cfc6b3d61f6$export$2e2bcd8739ae039 = $9d646cfc6b3d61f6$var$Index;


class $7f52c6951f122fd2$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/publish`;
    }
    /**
     * Publishes a note making it visible to other users.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/notes/{noteId}/publish
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $7f52c6951f122fd2$export$2e2bcd8739ae039 = $7f52c6951f122fd2$var$Index;


class $6bfbda514fec7524$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/unlock`;
    }
    /**
     * Unlocks a note letting other users edit this note. Once the note is locked (by another user) it cannot be unlocked during 5 hours since the lock datetime.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/notes/{noteId}/unlock
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $6bfbda514fec7524$export$2e2bcd8739ae039 = $6bfbda514fec7524$var$Index;


class $e43e6bd6bbe6dcb3$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/lock`;
    }
    /**
     * Locks a note providing the user with the unique write access for 5 hours.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/notes/{noteId}/lock
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $e43e6bd6bbe6dcb3$export$2e2bcd8739ae039 = $e43e6bd6bbe6dcb3$var$Index;


class $fa236981ada5b795$var$Index {
    rc;
    _parent;
    noteId;
    constructor(_parent, noteId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.noteId = noteId;
    }
    path(withParameter = true) {
        if (withParameter && this.noteId !== null) return `${this._parent.path()}/notes/${this.noteId}`;
        return `${this._parent.path()}/notes`;
    }
    /**
     * Returns the specified note(s). It is possible to fetch up to 50 notes per request.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/notes/{noteId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.noteId === null) throw new Error("noteId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the specified note.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/notes/{noteId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async delete(restRequestConfig) {
        if (this.noteId === null) throw new Error("noteId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Edits a note. Notes can be edited by any user if posted to a chat. the user belongs to.
     * HTTP Method: patch
     * Endpoint: /team-messaging/v1/notes/{noteId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async patch(tMCreateNoteRequest, queryParams, restRequestConfig) {
        if (this.noteId === null) throw new Error("noteId must be specified.");
        const r = await this.rc.patch(this.path(), tMCreateNoteRequest, queryParams, restRequestConfig);
        return r.data;
    }
    lock() {
        return new (0, $e43e6bd6bbe6dcb3$export$2e2bcd8739ae039)(this);
    }
    unlock() {
        return new (0, $6bfbda514fec7524$export$2e2bcd8739ae039)(this);
    }
    publish() {
        return new (0, $7f52c6951f122fd2$export$2e2bcd8739ae039)(this);
    }
}
var $fa236981ada5b795$export$2e2bcd8739ae039 = $fa236981ada5b795$var$Index;


class $530ad938017dbea2$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/unarchive`;
    }
    /**
     * Changes the status of the specified team to 'Active'.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/teams/{chatId}/unarchive
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $530ad938017dbea2$export$2e2bcd8739ae039 = $530ad938017dbea2$var$Index;


class $49f948f480464ca0$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/archive`;
    }
    /**
     * Changes the status of the specified team to 'Archived'.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/teams/{chatId}/archive
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $49f948f480464ca0$export$2e2bcd8739ae039 = $49f948f480464ca0$var$Index;


class $09151b1f9a6887c4$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/remove`;
    }
    /**
     * Removes members from the specified team.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/teams/{chatId}/remove
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(tMRemoveTeamMembersRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), tMRemoveTeamMembersRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $09151b1f9a6887c4$export$2e2bcd8739ae039 = $09151b1f9a6887c4$var$Index;


class $aef7ea55c9938934$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/leave`;
    }
    /**
     * Removes the current user from the specified team.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/teams/{chatId}/leave
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $aef7ea55c9938934$export$2e2bcd8739ae039 = $aef7ea55c9938934$var$Index;


class $3c6b77b9da15629f$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/join`;
    }
    /**
     * Adds the current user to the specified team.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/teams/{chatId}/join
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $3c6b77b9da15629f$export$2e2bcd8739ae039 = $3c6b77b9da15629f$var$Index;


class $dde0982d82c68ba7$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/add`;
    }
    /**
     * Adds members to the specified team.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/teams/{chatId}/add
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(tMAddTeamMembersRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), tMAddTeamMembersRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $dde0982d82c68ba7$export$2e2bcd8739ae039 = $dde0982d82c68ba7$var$Index;


class $9c024a1801f227f8$var$Index {
    rc;
    _parent;
    chatId;
    constructor(_parent, chatId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.chatId = chatId;
    }
    path(withParameter = true) {
        if (withParameter && this.chatId !== null) return `${this._parent.path()}/teams/${this.chatId}`;
        return `${this._parent.path()}/teams`;
    }
    /**
     * Returns the list of teams where the user is a member (both archived and active) combined with a list of public teams that can be joined by the current user. All records in response are sorted by creation time of a chat in ascending order. A team is a chat between 2 and more (unlimited number) participants assigned with specific name.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/teams
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a team, and adds a list of people to the team.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/teams
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(tMCreateTeamRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), tMCreateTeamRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns information about the specified team.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/teams/{chatId}
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.chatId === null) throw new Error("chatId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the specified team.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/teams/{chatId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async delete(restRequestConfig) {
        if (this.chatId === null) throw new Error("chatId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the name and description of the specified team.
     * HTTP Method: patch
     * Endpoint: /team-messaging/v1/teams/{chatId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async patch(tMUpdateTeamRequest, restRequestConfig) {
        if (this.chatId === null) throw new Error("chatId must be specified.");
        const r = await this.rc.patch(this.path(), tMUpdateTeamRequest, undefined, restRequestConfig);
        return r.data;
    }
    add() {
        return new (0, $dde0982d82c68ba7$export$2e2bcd8739ae039)(this);
    }
    join() {
        return new (0, $3c6b77b9da15629f$export$2e2bcd8739ae039)(this);
    }
    leave() {
        return new (0, $aef7ea55c9938934$export$2e2bcd8739ae039)(this);
    }
    remove() {
        return new (0, $09151b1f9a6887c4$export$2e2bcd8739ae039)(this);
    }
    archive() {
        return new (0, $49f948f480464ca0$export$2e2bcd8739ae039)(this);
    }
    unarchive() {
        return new (0, $530ad938017dbea2$export$2e2bcd8739ae039)(this);
    }
}
var $9c024a1801f227f8$export$2e2bcd8739ae039 = $9c024a1801f227f8$var$Index;


class $50a6db5688cb8b00$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/adaptive-cards`;
    }
    /**
     * Creates a new adaptive card in the chat specified in path.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/chats/{chatId}/adaptive-cards
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(adaptiveCardRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), adaptiveCardRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $50a6db5688cb8b00$export$2e2bcd8739ae039 = $50a6db5688cb8b00$var$Index;


class $ef04af665e374522$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/unfavorite`;
    }
    /**
     * Removes the specified chat from the users's list of favorite chats.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/chats/{chatId}/unfavorite
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $ef04af665e374522$export$2e2bcd8739ae039 = $ef04af665e374522$var$Index;


class $e1bcc8a17e9baf0e$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/favorite`;
    }
    /**
     * Adds the specified chat to the users's list of favorite chats.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/chats/{chatId}/favorite
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
var $e1bcc8a17e9baf0e$export$2e2bcd8739ae039 = $e1bcc8a17e9baf0e$var$Index;


class $35bba3027b792a95$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/notes`;
    }
    /**
     * Returns the list of chat notes.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/chats/{chatId}/notes
     * Rate Limit Group: Heavy
     * App Permission: TeamMessaging
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new note in the specified chat.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/chats/{chatId}/notes
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(tMCreateNoteRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), tMCreateNoteRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $35bba3027b792a95$export$2e2bcd8739ae039 = $35bba3027b792a95$var$Index;


class $fb002e2e36d423b1$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/tasks`;
    }
    /**
     * Returns the list of tasks of the specified chat.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/chats/{chatId}/tasks
     * Rate Limit Group: Heavy
     * App Permission: TeamMessaging
     */ async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a task in the specified chat.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/chats/{chatId}/tasks
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(tMCreateTaskRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), tMCreateTaskRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $fb002e2e36d423b1$export$2e2bcd8739ae039 = $fb002e2e36d423b1$var$Index;


class $ae50e3f9a5fe9882$var$Index {
    rc;
    _parent;
    postId;
    constructor(_parent, postId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.postId = postId;
    }
    path(withParameter = true) {
        if (withParameter && this.postId !== null) return `${this._parent.path()}/posts/${this.postId}`;
        return `${this._parent.path()}/posts`;
    }
    /**
     * Returns a list of posts from the specified chat.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/chats/{chatId}/posts
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a post in the chat specified in path. Any mention can be added within the `text` attribute of
     * the request body in .md format - `![:Type](id)`, where `type` is one of (Person, Team, File, Note,
     * Task, Event, Link, Card) and `id` is a unique identifier of the mentioned object of the specified type.
     * Attachments can also be added to a post by passing the type and ID of attachment(s) in request body.
     *
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/chats/{chatId}/posts
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(tMCreatePostRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), tMCreatePostRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns information about the specified post.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/chats/{chatId}/posts/{postId}
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.postId === null) throw new Error("postId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the specified post from the chat.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/chats/{chatId}/posts/{postId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async delete(restRequestConfig) {
        if (this.postId === null) throw new Error("postId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a specific post within a chat.
     * HTTP Method: patch
     * Endpoint: /team-messaging/v1/chats/{chatId}/posts/{postId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async patch(tMUpdatePostRequest, restRequestConfig) {
        if (this.postId === null) throw new Error("postId must be specified.");
        const r = await this.rc.patch(this.path(), tMUpdatePostRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $ae50e3f9a5fe9882$export$2e2bcd8739ae039 = $ae50e3f9a5fe9882$var$Index;


class $7243370858a2ce4c$var$Index {
    rc;
    _parent;
    chatId;
    constructor(_parent, chatId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.chatId = chatId;
    }
    path(withParameter = true) {
        if (withParameter && this.chatId !== null) return `${this._parent.path()}/chats/${this.chatId}`;
        return `${this._parent.path()}/chats`;
    }
    /**
     * Returns the list of chats where the user is a member and also public teams that can be joined.
     *
     * All records in response are sorted by creation time of a chat in ascending order.
     *
     * **Chat types**
     *
     * There are multiple types of chats, including:
     *
     * * **Personal** - each user is given a dedicated "personal chat" in which they are the only member.
     * * **Direct** - a chat between two individuals.
     * * **Group** - a chat between three or more named individuals. A "group" chat has no name.
     * * **Team** - a chat related to a specific topic. Members can come and go freely from this chat type.
     * * **Everyone** - a special chat containing every individual in a company.
     *
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/chats
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns information about a chat by ID.
     *
     * **Note** 'Chat' is a general name for all types of threads including *Personal* (user's own me-chat), *Direct* (one on one chat), *Group* (chat of 3-15 participants without specific name), *Team* (chat of 2 and more participants, with a specific name), *Everyone* (company chat including all employees, with a specific name)."
     *
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/chats/{chatId}
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.chatId === null) throw new Error("chatId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    posts(postId = null) {
        return new (0, $ae50e3f9a5fe9882$export$2e2bcd8739ae039)(this, postId);
    }
    tasks() {
        return new (0, $fb002e2e36d423b1$export$2e2bcd8739ae039)(this);
    }
    notes() {
        return new (0, $35bba3027b792a95$export$2e2bcd8739ae039)(this);
    }
    favorite() {
        return new (0, $e1bcc8a17e9baf0e$export$2e2bcd8739ae039)(this);
    }
    unfavorite() {
        return new (0, $ef04af665e374522$export$2e2bcd8739ae039)(this);
    }
    adaptiveCards() {
        return new (0, $50a6db5688cb8b00$export$2e2bcd8739ae039)(this);
    }
}
var $7243370858a2ce4c$export$2e2bcd8739ae039 = $7243370858a2ce4c$var$Index;


class $c2e2181eaea8fd7c$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/complete`;
    }
    /**
     * Completes a task in the specified chat.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/tasks/{taskId}/complete
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async post(tMCompleteTaskRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), tMCompleteTaskRequest, undefined, restRequestConfig);
        return r.data;
    }
}
var $c2e2181eaea8fd7c$export$2e2bcd8739ae039 = $c2e2181eaea8fd7c$var$Index;


class $5126b12309d361ba$var$Index {
    rc;
    _parent;
    taskId;
    constructor(_parent, taskId = null){
        this._parent = _parent;
        this.rc = _parent.rc;
        this.taskId = taskId;
    }
    path(withParameter = true) {
        if (withParameter && this.taskId !== null) return `${this._parent.path()}/tasks/${this.taskId}`;
        return `${this._parent.path()}/tasks`;
    }
    /**
     * Returns information about the specified task(s) by ID(s).
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/tasks/{taskId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async get(restRequestConfig) {
        if (this.taskId === null) throw new Error("taskId must be specified.");
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes the specified task.
     * HTTP Method: delete
     * Endpoint: /team-messaging/v1/tasks/{taskId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async delete(restRequestConfig) {
        if (this.taskId === null) throw new Error("taskId must be specified.");
        const r = await this.rc.delete(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the specified task by ID.
     * HTTP Method: patch
     * Endpoint: /team-messaging/v1/tasks/{taskId}
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */ async patch(tMUpdateTaskRequest, restRequestConfig) {
        if (this.taskId === null) throw new Error("taskId must be specified.");
        const r = await this.rc.patch(this.path(), tMUpdateTaskRequest, undefined, restRequestConfig);
        return r.data;
    }
    complete() {
        return new (0, $c2e2181eaea8fd7c$export$2e2bcd8739ae039)(this);
    }
}
var $5126b12309d361ba$export$2e2bcd8739ae039 = $5126b12309d361ba$var$Index;


class $b0aebb72441ad072$var$Index {
    rc;
    _parent;
    constructor(_parent){
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path(false)}/v1`;
    }
    tasks(taskId = null) {
        return new (0, $5126b12309d361ba$export$2e2bcd8739ae039)(this, taskId);
    }
    chats(chatId = null) {
        return new (0, $7243370858a2ce4c$export$2e2bcd8739ae039)(this, chatId);
    }
    teams(chatId = null) {
        return new (0, $9c024a1801f227f8$export$2e2bcd8739ae039)(this, chatId);
    }
    notes(noteId = null) {
        return new (0, $fa236981ada5b795$export$2e2bcd8739ae039)(this, noteId);
    }
    files() {
        return new (0, $9d646cfc6b3d61f6$export$2e2bcd8739ae039)(this);
    }
    groups(groupId = null) {
        return new (0, $6ed9017ace2d5976$export$2e2bcd8739ae039)(this, groupId);
    }
    recent() {
        return new (0, $82bd5abee41f44e9$export$2e2bcd8739ae039)(this);
    }
    events(eventId = null) {
        return new (0, $6cfd0c6456200538$export$2e2bcd8739ae039)(this, eventId);
    }
    persons(personId = null) {
        return new (0, $b7a079e47a7e16e1$export$2e2bcd8739ae039)(this, personId);
    }
    webhooks(webhookId = null) {
        return new (0, $04a67b78e8210925$export$2e2bcd8739ae039)(this, webhookId);
    }
    everyone() {
        return new (0, $29c68bf83b821d86$export$2e2bcd8739ae039)(this);
    }
    companies(companyId = null) {
        return new (0, $92121f0571446e9f$export$2e2bcd8739ae039)(this, companyId);
    }
    favorites() {
        return new (0, $217e7df4f0c4fa9d$export$2e2bcd8739ae039)(this);
    }
    dataExport(taskId = null) {
        return new (0, $9a52072f159c62ce$export$2e2bcd8739ae039)(this, taskId);
    }
    conversations(chatId = null) {
        return new (0, $bb91fa1cbf07b74a$export$2e2bcd8739ae039)(this, chatId);
    }
    adaptiveCards(cardId = null) {
        return new (0, $75bfaa7712243597$export$2e2bcd8739ae039)(this, cardId);
    }
}
var $b0aebb72441ad072$export$2e2bcd8739ae039 = $b0aebb72441ad072$var$Index;


class $9fcd3d2f4ec60085$var$Index {
    rc;
    constructor(rc){
        this.rc = rc;
    }
    path() {
        return "/team-messaging";
    }
    v1() {
        return new (0, $b0aebb72441ad072$export$2e2bcd8739ae039)(this);
    }
}
var $9fcd3d2f4ec60085$export$2e2bcd8739ae039 = $9fcd3d2f4ec60085$var$Index;


class $c5c4d7a0138a22c4$var$RingCentral {
    static config = {
        logger: {
            debug: ()=>{},
            log: ()=>{},
            info: ()=>{},
            warn: ()=>{},
            error: ()=>{}
        }
    };
    sdkExtensions = [];
    rest;
    constructor(restOptions){
        this.rest = new (0, $ff34a89461abde6f$export$2e2bcd8739ae039)(restOptions ?? {});
    }
    async installExtension(sdkExtension) {
        await sdkExtension.install(this);
        this.sdkExtensions.push(sdkExtension);
    }
    get token() {
        return this.rest.token;
    }
    set token(token) {
        this.rest.token = token;
    }
    async request(method, endpoint, content, queryParams, config) {
        try {
            const r = await this.rest.request(method, endpoint, content, queryParams, config);
            $c5c4d7a0138a22c4$var$RingCentral.config.logger.info(`[${new Date().toLocaleString()} HTTP ${method} ${r.status} ${r.statusText}] ${this.rest.server} ${endpoint}`);
            return r;
        } catch (e) {
            const re = e;
            if (re.response) {
                const r = re.response;
                $c5c4d7a0138a22c4$var$RingCentral.config.logger.info(`[${new Date().toLocaleString()} HTTP ${method} ${r.status} ${r.statusText}] ${this.rest.server} ${endpoint}`);
            }
            throw e;
        }
    }
    async get(endpoint, queryParams, config) {
        return this.request("GET", endpoint, undefined, queryParams, config);
    }
    async delete(endpoint, content, queryParams, config) {
        return this.request("DELETE", endpoint, content, queryParams, config);
    }
    async post(endpoint, content, queryParams, config) {
        return this.request("POST", endpoint, content, queryParams, config);
    }
    async put(endpoint, content, queryParams, config) {
        return this.request("PUT", endpoint, content, queryParams, config);
    }
    async patch(endpoint, content, queryParams, config) {
        return this.request("PATCH", endpoint, content, queryParams, config);
    }
    async getToken(getTokenRequest) {
        getTokenRequest.client_id = this.rest.clientId;
        this.token = await this.restapi(null).oauth().token().post(getTokenRequest);
        return this.token;
    }
    async authorize(options) {
        const getTokenRequest = {};
        if ("code" in options) {
            getTokenRequest.grant_type = "authorization_code";
            getTokenRequest.code = options.code;
            getTokenRequest.redirect_uri = options.redirect_uri;
            // PKCE: https://medium.com/ringcentral-developers/use-authorization-code-pkce-for-ringcentral-api-in-client-app-e9108f04b5f0
            getTokenRequest.code_verifier = options.code_verifier;
        } else if ("jwt" in options) {
            getTokenRequest.grant_type = "urn:ietf:params:oauth:grant-type:jwt-bearer";
            getTokenRequest.assertion = options.jwt;
        } else throw new Error("Unsupported authorization flow");
        return this.getToken(getTokenRequest);
    }
    /**
     * Just a synonym of authorize
     */ async login(options) {
        return this.authorize(options);
    }
    /**
     * Each time you call token endpoint using this flow, you continue current client session, and receive a new token pair: access token and refresh token in response to this request.
     * The old token pair immediately becomes inactive.
     *
     * https://developers.ringcentral.com/api-reference/Get-Token
     *
     * @param refreshToken Refresh Token
     */ async refresh(refreshToken) {
        const tokenToRefresh = refreshToken ?? this.token?.refresh_token;
        if (!tokenToRefresh) throw new Error("tokenToRefresh must be specified.");
        const getTokenRequest = {};
        getTokenRequest.grant_type = "refresh_token";
        getTokenRequest.refresh_token = tokenToRefresh;
        return this.getToken(getTokenRequest);
    }
    /**
     * Each time you call token endpoint using this flow, you continue current client session, and receive a new token pair: access token and refresh token in response to this request.
     * The old token pair immediately becomes inactive.
     *
     * https://developers.ringcentral.com/api-reference/Revoke-Token
     *
     * @param tokenToRevoke AccessToken
     */ async revoke(tokenToRevoke) {
        for (const sdkExtension of this.sdkExtensions)await sdkExtension.revoke();
        if (!tokenToRevoke && !this.token) // nothing to revoke
        return;
        if (!this.rest.clientId) // if no clientId, the token is from external source, cannot revoke
        // no clientSecret is fine, since PKCE doesn't have clientSecret
        return;
        const temp = tokenToRevoke ?? this.token?.access_token ?? this.token?.refresh_token;
        await this.restapi(null).oauth().revoke().post({
            token: temp,
            client_id: this.rest.clientId
        }); // todo: spec doesn't allow client_id
        this.token = undefined;
    }
    restapi(apiVersion = "v1.0") {
        return new (0, $602931833ffa73d3$export$2e2bcd8739ae039)(this, apiVersion);
    }
    scim(version = "v2") {
        return new (0, $74a24777d716c36e$export$2e2bcd8739ae039)(this, version);
    }
    analytics() {
        return new (0, $518357303770a27e$export$2e2bcd8739ae039)(this);
    }
    teamMessaging() {
        return new (0, $9fcd3d2f4ec60085$export$2e2bcd8739ae039)(this);
    }
    ai() {
        return new (0, $74d82e20f81771f0$export$2e2bcd8739ae039)(this);
    }
    rcvideo() {
        return new (0, $6d27b572f9549723$export$2e2bcd8739ae039)(this);
    }
    webinar() {
        return new (0, $fe45c0605d673c1f$export$2e2bcd8739ae039)(this);
    }
}
var $c5c4d7a0138a22c4$export$2e2bcd8739ae039 = $c5c4d7a0138a22c4$var$RingCentral;




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");













const $3bac234c47ba2af8$var$genMessageStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, boxShadow: boxShadow, colorText: colorText, colorSuccess: colorSuccess, colorError: colorError, colorWarning: colorWarning, colorInfo: colorInfo, fontSizeLG: fontSizeLG, motionEaseInOutCirc: motionEaseInOutCirc, motionDurationSlow: motionDurationSlow, marginXS: marginXS, paddingXS: paddingXS, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, contentPadding: // Custom token
    contentPadding, contentBg: contentBg } = token;
    const noticeCls = `${componentCls}-notice`;
    const messageMoveIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('MessageMoveIn', {
        '0%': {
            padding: 0,
            transform: 'translateY(-100%)',
            opacity: 0
        },
        '100%': {
            padding: paddingXS,
            transform: 'translateY(0)',
            opacity: 1
        }
    });
    const messageMoveOut = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)('MessageMoveOut', {
        '0%': {
            maxHeight: token.height,
            padding: paddingXS,
            opacity: 1
        },
        '100%': {
            maxHeight: 0,
            padding: 0,
            opacity: 0
        }
    });
    const noticeStyle = {
        padding: paddingXS,
        textAlign: 'center',
        [`${componentCls}-custom-content`]: {
            display: 'flex',
            alignItems: 'center'
        },
        [`${componentCls}-custom-content > ${iconCls}`]: {
            marginInlineEnd: marginXS,
            // affected by ltr or rtl
            fontSize: fontSizeLG
        },
        [`${noticeCls}-content`]: {
            display: 'inline-block',
            padding: contentPadding,
            background: contentBg,
            borderRadius: borderRadiusLG,
            boxShadow: boxShadow,
            pointerEvents: 'all'
        },
        [`${componentCls}-success > ${iconCls}`]: {
            color: colorSuccess
        },
        [`${componentCls}-error > ${iconCls}`]: {
            color: colorError
        },
        [`${componentCls}-warning > ${iconCls}`]: {
            color: colorWarning
        },
        [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
            color: colorInfo
        }
    };
    return [
        // ============================ Holder ============================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                color: colorText,
                position: 'fixed',
                top: marginXS,
                width: '100%',
                pointerEvents: 'none',
                zIndex: zIndexPopup,
                [`${componentCls}-move-up`]: {
                    animationFillMode: 'forwards'
                },
                [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
                    animationName: messageMoveIn,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-move-up-leave`]: {
                    animationName: messageMoveOut,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
                    animationPlayState: 'running'
                },
                '&-rtl': {
                    direction: 'rtl',
                    span: {
                        direction: 'rtl'
                    }
                }
            })
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: Object.assign({}, noticeStyle)
            }
        },
        // ============================= Pure =============================
        {
            [`${componentCls}-notice-pure-panel`]: Object.assign(Object.assign({}, noticeStyle), {
                padding: 0,
                textAlign: 'start'
            })
        }
    ];
};
const $3bac234c47ba2af8$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $8552b358f1d5b0a4$export$33ada7d8845f7e5) + 10,
        contentBg: token.colorBgElevated,
        contentPadding: `${(token.controlHeightLG - token.fontSize * token.lineHeight) / 2}px ${token.paddingSM}px`
    });
var // ============================== Export ==============================
$3bac234c47ba2af8$export$2e2bcd8739ae039 = (0, $0f84270bd7498f9c$export$51ec95de45185b42)('Message', (token)=>{
    // Gen-style functions here
    const combinedToken = (0, $6f8035da4ba7a5b0$export$4950aa0f605343fb)(token, {
        height: 150
    });
    return [
        $3bac234c47ba2af8$var$genMessageStyle(combinedToken)
    ];
}, $3bac234c47ba2af8$export$9ca1be8807fe0675);


"use client";
var $c9808e733d97ff6c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c9808e733d97ff6c$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $acw62.createElement((0, $b5d5d018bfa4ba6e$export$2e2bcd8739ae039), null),
    success: /*#__PURE__*/ $acw62.createElement((0, $9149fdfb4424d1d9$export$2e2bcd8739ae039), null),
    error: /*#__PURE__*/ $acw62.createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null),
    warning: /*#__PURE__*/ $acw62.createElement((0, $2444f6da62064575$export$2e2bcd8739ae039), null),
    loading: /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), null)
};
const $c9808e733d97ff6c$export$429c001938db3a78 = ({ prefixCls: prefixCls, type: type, icon: icon, children: children })=>/*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-custom-content`, `${prefixCls}-${type}`)
    }, icon || $c9808e733d97ff6c$export$ad8f8fc3bcd61b4a[type], /*#__PURE__*/ $acw62.createElement("span", null, children));
/** @private Internal Component. Do not use in your production. */ const $c9808e733d97ff6c$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className: className, type: type, icon: icon, content: content } = props, restProps = $c9808e733d97ff6c$var$__rest(props, [
        "prefixCls",
        "className",
        "type",
        "icon",
        "content"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3bac234c47ba2af8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $6be5862818f90611$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
        eventKey: "pure",
        duration: null,
        content: /*#__PURE__*/ $acw62.createElement($c9808e733d97ff6c$export$429c001938db3a78, {
            prefixCls: prefixCls,
            type: type,
            icon: icon
        }, content)
    })));
};
var $c9808e733d97ff6c$export$2e2bcd8739ae039 = $c9808e733d97ff6c$var$PurePanel;



var $acw62 = parcelRequire("acw62");








function $c93f159ca3fa0be1$export$7b8936ddc277a29a(prefixCls, transitionName) {
    return {
        motionName: transitionName !== null && transitionName !== void 0 ? transitionName : `${prefixCls}-move-up`
    };
}
function $c93f159ca3fa0be1$export$52ce770daa307a45(openFn) {
    let closeFn;
    const closePromise = new Promise((resolve)=>{
        closeFn = openFn(()=>{
            resolve(true);
        });
    });
    const result = ()=>{
        closeFn === null || closeFn === void 0 || closeFn();
    };
    result.then = (filled, rejected)=>closePromise.then(filled, rejected);
    result.promise = closePromise;
    return result;
}


"use client";
var $279f9cad32c830f7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $279f9cad32c830f7$var$DEFAULT_OFFSET = 8;
const $279f9cad32c830f7$var$DEFAULT_DURATION = 3;
const $279f9cad32c830f7$var$Wrapper = ({ children: children, prefixCls: prefixCls })=>{
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3bac234c47ba2af8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $189ebb65137099c1$export$2e2bcd8739ae039), {
        classNames: {
            list: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, cssVarCls, rootCls)
        }
    }, children));
};
const $279f9cad32c830f7$var$renderNotifications = (node, { prefixCls: prefixCls, key: key })=>/*#__PURE__*/ $acw62.createElement($279f9cad32c830f7$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
const $279f9cad32c830f7$var$Holder = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { top: top, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, duration: duration = $279f9cad32c830f7$var$DEFAULT_DURATION, rtl: rtl, transitionName: transitionName, onAllRemoved: onAllRemoved } = props;
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, message: message, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    // =============================== Style ===============================
    const getStyle = ()=>({
            left: '50%',
            transform: 'translateX(-50%)',
            top: top !== null && top !== void 0 ? top : $279f9cad32c830f7$var$DEFAULT_OFFSET
        });
    const getClassName = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $c93f159ca3fa0be1$export$7b8936ddc277a29a)(prefixCls, transitionName);
    // ============================ Close Icon =============================
    const mergedCloseIcon = /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-close-x`
    }, /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
    // ============================== Origin ===============================
    const [api, holder] = (0, $4fb0b9c84003ea9f$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        closable: false,
        closeIcon: mergedCloseIcon,
        duration: duration,
        getContainer: ()=>(staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
        maxCount: maxCount,
        onAllRemoved: onAllRemoved,
        renderNotifications: $279f9cad32c830f7$var$renderNotifications
    });
    // ================================ Ref ================================
    $acw62.useImperativeHandle(ref, ()=>Object.assign(Object.assign({}, api), {
            prefixCls: prefixCls,
            message: message
        }));
    return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
let $279f9cad32c830f7$var$keyIndex = 0;
function $279f9cad32c830f7$export$1689db33b6c27d9e(messageConfig) {
    const holderRef = $acw62.useRef(null);
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)('Message');
    // ================================ API ================================
    const wrapAPI = $acw62.useMemo(()=>{
        // Wrap with notification content
        // >>> close
        const close = (key)=>{
            var _a;
            (_a = holderRef.current) === null || _a === void 0 || _a.close(key);
        };
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) {
                const fakeResult = ()=>{};
                fakeResult.then = ()=>{};
                return fakeResult;
            }
            const { open: originOpen, prefixCls: prefixCls, message: message } = holderRef.current;
            const noticePrefixCls = `${prefixCls}-notice`;
            const { content: content, icon: icon, type: type, key: key, className: className, style: style, onClose: onClose } = config, restConfig = $279f9cad32c830f7$var$__rest(config, [
                "content",
                "icon",
                "type",
                "key",
                "className",
                "style",
                "onClose"
            ]);
            let mergedKey = key;
            if (mergedKey === undefined || mergedKey === null) {
                $279f9cad32c830f7$var$keyIndex += 1;
                mergedKey = `antd-message-${$279f9cad32c830f7$var$keyIndex}`;
            }
            return (0, $c93f159ca3fa0be1$export$52ce770daa307a45)((resolve)=>{
                originOpen(Object.assign(Object.assign({}, restConfig), {
                    key: mergedKey,
                    content: /*#__PURE__*/ $acw62.createElement((0, $c9808e733d97ff6c$export$429c001938db3a78), {
                        prefixCls: prefixCls,
                        type: type,
                        icon: icon
                    }, content),
                    placement: 'top',
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(type && `${noticePrefixCls}-${type}`, className, message === null || message === void 0 ? void 0 : message.className),
                    style: Object.assign(Object.assign({}, message === null || message === void 0 ? void 0 : message.style), style),
                    onClose: ()=>{
                        onClose === null || onClose === void 0 || onClose();
                        resolve();
                    }
                }));
                // Return close function
                return ()=>{
                    close(mergedKey);
                };
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            var _a;
            if (key !== undefined) close(key);
            else (_a = holderRef.current) === null || _a === void 0 || _a.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            'info',
            'success',
            'warning',
            'error',
            'loading'
        ];
        keys.forEach((type)=>{
            const typeOpen = (jointContent, duration, onClose)=>{
                let config;
                if (jointContent && typeof jointContent === 'object' && 'content' in jointContent) config = jointContent;
                else config = {
                    content: jointContent
                };
                // Params
                let mergedDuration;
                let mergedOnClose;
                if (typeof duration === 'function') mergedOnClose = duration;
                else {
                    mergedDuration = duration;
                    mergedOnClose = onClose;
                }
                const mergedConfig = Object.assign(Object.assign({
                    onClose: mergedOnClose,
                    duration: mergedDuration
                }, config), {
                    type: type
                });
                return open(mergedConfig);
            };
            clone[type] = typeOpen;
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ $acw62.createElement($279f9cad32c830f7$var$Holder, Object.assign({
            key: "message-holder"
        }, messageConfig, {
            ref: holderRef
        }))
    ];
}
function $279f9cad32c830f7$export$2e2bcd8739ae039(messageConfig) {
    return $279f9cad32c830f7$export$1689db33b6c27d9e(messageConfig);
}



"use client";
let $dc31f36873c2f472$var$message = null;
let $dc31f36873c2f472$var$act = (callback)=>callback();
let $dc31f36873c2f472$var$taskQueue = [];
let $dc31f36873c2f472$var$defaultGlobalConfig = {};
function $dc31f36873c2f472$var$getGlobalContext() {
    const { getContainer: getContainer, duration: duration, rtl: rtl, maxCount: maxCount, top: top } = $dc31f36873c2f472$var$defaultGlobalConfig;
    const mergedContainer = (getContainer === null || getContainer === void 0 ? void 0 : getContainer()) || document.body;
    return {
        getContainer: ()=>mergedContainer,
        duration: duration,
        rtl: rtl,
        maxCount: maxCount,
        top: top
    };
}
const $dc31f36873c2f472$var$GlobalHolder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { messageConfig: messageConfig, sync: sync } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = $dc31f36873c2f472$var$defaultGlobalConfig.prefixCls || getPrefixCls('message');
    const appConfig = (0, $acw62.useContext)((0, $ec30be32576c1d45$export$264c6064649f9206));
    const [api, holder] = (0, $279f9cad32c830f7$export$1689db33b6c27d9e)(Object.assign(Object.assign(Object.assign({}, messageConfig), {
        prefixCls: prefixCls
    }), appConfig.message));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>{
        const instance = Object.assign({}, api);
        Object.keys(instance).forEach((method)=>{
            instance[method] = (...args)=>{
                sync();
                return api[method].apply(api, args);
            };
        });
        return {
            instance: instance,
            sync: sync
        };
    });
    return holder;
});
const $dc31f36873c2f472$var$GlobalHolderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_, ref)=>{
    const [messageConfig, setMessageConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($dc31f36873c2f472$var$getGlobalContext);
    const sync = ()=>{
        setMessageConfig($dc31f36873c2f472$var$getGlobalContext);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(sync, []);
    const global = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dc31f36873c2f472$var$GlobalHolder, {
        ref: ref,
        sync: sync,
        messageConfig: messageConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
function $dc31f36873c2f472$var$flushNotice() {
    if (!$dc31f36873c2f472$var$message) {
        const holderFragment = document.createDocumentFragment();
        const newMessage = {
            fragment: holderFragment
        };
        $dc31f36873c2f472$var$message = newMessage;
        // Delay render to avoid sync issue
        $dc31f36873c2f472$var$act(()=>{
            const reactRender = (0, $f76949e1bc95fa3b$export$4d4bf8843d204cca)();
            reactRender(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dc31f36873c2f472$var$GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance: instance, sync: sync } = node || {};
                    // React 18 test env will throw if call immediately in ref
                    Promise.resolve().then(()=>{
                        if (!newMessage.instance && instance) {
                            newMessage.instance = instance;
                            newMessage.sync = sync;
                            $dc31f36873c2f472$var$flushNotice();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!$dc31f36873c2f472$var$message.instance) return;
    // >>> Execute task
    $dc31f36873c2f472$var$taskQueue.forEach((task)=>{
        const { type: type, skipped: skipped } = task;
        // Only `skipped` when user call notice but cancel it immediately
        // and instance not ready
        if (!skipped) switch(type){
            case 'open':
                $dc31f36873c2f472$var$act(()=>{
                    const closeFn = $dc31f36873c2f472$var$message.instance.open(Object.assign(Object.assign({}, $dc31f36873c2f472$var$defaultGlobalConfig), task.config));
                    closeFn === null || closeFn === void 0 || closeFn.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
                break;
            case 'destroy':
                $dc31f36873c2f472$var$act(()=>{
                    $dc31f36873c2f472$var$message === null || $dc31f36873c2f472$var$message === void 0 || $dc31f36873c2f472$var$message.instance.destroy(task.key);
                });
                break;
            // Other type open
            default:
                $dc31f36873c2f472$var$act(()=>{
                    var _message$instance;
                    const closeFn = (_message$instance = $dc31f36873c2f472$var$message.instance)[type].apply(_message$instance, (0, $df4024303de6487a$export$2e2bcd8739ae039)(task.args));
                    closeFn === null || closeFn === void 0 || closeFn.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
        }
    });
    // Clean up
    $dc31f36873c2f472$var$taskQueue = [];
}
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function $dc31f36873c2f472$var$setMessageGlobalConfig(config) {
    $dc31f36873c2f472$var$defaultGlobalConfig = Object.assign(Object.assign({}, $dc31f36873c2f472$var$defaultGlobalConfig), config);
    // Trigger sync for it
    $dc31f36873c2f472$var$act(()=>{
        var _a;
        (_a = $dc31f36873c2f472$var$message === null || $dc31f36873c2f472$var$message === void 0 ? void 0 : $dc31f36873c2f472$var$message.sync) === null || _a === void 0 || _a.call($dc31f36873c2f472$var$message);
    });
}
function $dc31f36873c2f472$var$open(config) {
    const result = (0, $c93f159ca3fa0be1$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: 'open',
            config: config,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $dc31f36873c2f472$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $dc31f36873c2f472$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $dc31f36873c2f472$var$flushNotice();
    return result;
}
function $dc31f36873c2f472$var$typeOpen(type, args) {
    const global = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)();
    const result = (0, $c93f159ca3fa0be1$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: type,
            args: args,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $dc31f36873c2f472$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $dc31f36873c2f472$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $dc31f36873c2f472$var$flushNotice();
    return result;
}
const $dc31f36873c2f472$var$destroy = (key)=>{
    $dc31f36873c2f472$var$taskQueue.push({
        type: 'destroy',
        key: key
    });
    $dc31f36873c2f472$var$flushNotice();
};
const $dc31f36873c2f472$var$methods = [
    'success',
    'info',
    'warning',
    'error',
    'loading'
];
const $dc31f36873c2f472$var$baseStaticMethods = {
    open: $dc31f36873c2f472$var$open,
    destroy: $dc31f36873c2f472$var$destroy,
    config: $dc31f36873c2f472$var$setMessageGlobalConfig,
    useMessage: $279f9cad32c830f7$export$2e2bcd8739ae039,
    _InternalPanelDoNotUseOrYouWillBeFired: (0, $c9808e733d97ff6c$export$2e2bcd8739ae039)
};
const $dc31f36873c2f472$var$staticMethods = $dc31f36873c2f472$var$baseStaticMethods;
$dc31f36873c2f472$var$methods.forEach((type)=>{
    $dc31f36873c2f472$var$staticMethods[type] = (...args)=>$dc31f36873c2f472$var$typeOpen(type, args);
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const $dc31f36873c2f472$var$noop = ()=>{};
let $dc31f36873c2f472$var$_actWrapper = $dc31f36873c2f472$var$noop;
var $dc31f36873c2f472$var$wrapper;
const $dc31f36873c2f472$export$71ceb3dabb09f455 = $dc31f36873c2f472$var$_actWrapper;
let $dc31f36873c2f472$var$_actDestroy = $dc31f36873c2f472$var$noop;
const $dc31f36873c2f472$export$43de32c50edff050 = $dc31f36873c2f472$var$_actDestroy;
var $dc31f36873c2f472$export$2e2bcd8739ae039 = $dc31f36873c2f472$var$staticMethods;




var $28cb323e84e8519a$exports = {};
'use strict';
var $25110bb0367e2d97$exports = {};
'use strict';
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $712bcec1625ddc16$var$getRandomValues;
var $712bcec1625ddc16$var$rnds8 = new Uint8Array(16);
function $712bcec1625ddc16$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$712bcec1625ddc16$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $712bcec1625ddc16$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$712bcec1625ddc16$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $712bcec1625ddc16$var$getRandomValues($712bcec1625ddc16$var$rnds8);
}


var $46d9dcdf2a1a540c$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $0c7734ec40286728$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $46d9dcdf2a1a540c$export$2e2bcd8739ae039).test(uuid);
}
var $0c7734ec40286728$export$2e2bcd8739ae039 = $0c7734ec40286728$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $08dffb562fcb78ea$var$byteToHex = [];
for(var $08dffb562fcb78ea$var$i = 0; $08dffb562fcb78ea$var$i < 256; ++$08dffb562fcb78ea$var$i)$08dffb562fcb78ea$var$byteToHex.push(($08dffb562fcb78ea$var$i + 0x100).toString(16).substr(1));
function $08dffb562fcb78ea$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($08dffb562fcb78ea$var$byteToHex[arr[offset + 0]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 1]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 2]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 3]] + '-' + $08dffb562fcb78ea$var$byteToHex[arr[offset + 4]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 5]] + '-' + $08dffb562fcb78ea$var$byteToHex[arr[offset + 6]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 7]] + '-' + $08dffb562fcb78ea$var$byteToHex[arr[offset + 8]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 9]] + '-' + $08dffb562fcb78ea$var$byteToHex[arr[offset + 10]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 11]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 12]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 13]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 14]] + $08dffb562fcb78ea$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $0c7734ec40286728$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $08dffb562fcb78ea$export$2e2bcd8739ae039 = $08dffb562fcb78ea$var$stringify;


function $d48ab19b03d57f46$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $712bcec1625ddc16$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $08dffb562fcb78ea$export$2e2bcd8739ae039)(rnds);
}
var $d48ab19b03d57f46$export$2e2bcd8739ae039 = $d48ab19b03d57f46$var$v4;


var $25110bb0367e2d97$require$uuidv4 = $d48ab19b03d57f46$export$2e2bcd8739ae039;
$25110bb0367e2d97$exports = $25110bb0367e2d97$require$uuidv4;


var $4a2d3a5d0d10f162$exports = {};
'use strict';
// Maps for number <-> hex string conversion
var $4a2d3a5d0d10f162$var$_byteToHex = [];
var $4a2d3a5d0d10f162$var$_hexToByte = {};
for(var $4a2d3a5d0d10f162$var$i = 0; $4a2d3a5d0d10f162$var$i < 256; $4a2d3a5d0d10f162$var$i++){
    $4a2d3a5d0d10f162$var$_byteToHex[$4a2d3a5d0d10f162$var$i] = ($4a2d3a5d0d10f162$var$i + 0x100).toString(16).substr(1);
    $4a2d3a5d0d10f162$var$_hexToByte[$4a2d3a5d0d10f162$var$_byteToHex[$4a2d3a5d0d10f162$var$i]] = $4a2d3a5d0d10f162$var$i;
}
// **`parse()` - Parse a UUID into it's component bytes**
function $4a2d3a5d0d10f162$var$parse(s, buf, offset) {
    var i = buf && offset || 0;
    var ii = 0;
    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
        if (ii < 16) buf[i + ii++] = $4a2d3a5d0d10f162$var$_hexToByte[oct];
    });
    // Zero out remaining bytes if string was short
    while(ii < 16)buf[i + ii++] = 0;
    return buf;
}
// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
function $4a2d3a5d0d10f162$var$unparse(buf, offset) {
    var i = offset || 0;
    var bth = $4a2d3a5d0d10f162$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
$4a2d3a5d0d10f162$exports = {
    parse: $4a2d3a5d0d10f162$var$parse,
    unparse: $4a2d3a5d0d10f162$var$unparse
};


const $28cb323e84e8519a$var$Buffer = $28cb323e84e8519a$var$loadBuffer();


function $28cb323e84e8519a$var$loadBuffer() {
    const b = (parcelRequire("am8tN"));
    // use third party module if no buffer module
    return b && b.Buffer ? b.Buffer : (parcelRequire("am8tN")).Buffer;
}
const $28cb323e84e8519a$var$base64Padding = $28cb323e84e8519a$var$Buffer.from('==', 'base64');
function $28cb323e84e8519a$var$hyperid(opts) {
    let fixedLength = false;
    let urlSafe = false;
    // gaurd if instantiated using boolean for fixedLength or with no args
    let maxInt = Math.pow(2, 31) - 1;
    if (typeof opts === 'boolean') fixedLength = opts;
    else {
        opts = opts || {};
        maxInt = opts.maxInt || Math.pow(2, 31) - 1;
        urlSafe = !!opts.urlSafe;
        fixedLength = !!opts.fixedLength;
    }
    generate.uuid = $25110bb0367e2d97$exports();
    generate.decode = $28cb323e84e8519a$var$decode;
    let id = $28cb323e84e8519a$var$baseId(generate.uuid, urlSafe);
    let count = Math.floor(opts.startFrom || 0);
    if (isNaN(maxInt)) throw new Error(`maxInt must be a number. recieved ${opts.maxInt}`);
    if (isNaN(count) || !(maxInt > count && count >= 0)) throw new Error([
        `when passed, opts.startFrom must be a number between 0 and ${maxInt}.`,
        'Only the integer part matters.',
        `- got: ${opts.startFrom}`
    ].join('\n'));
    return generate;
    function generate() {
        let result;
        if (count === maxInt) {
            generate.uuid = $25110bb0367e2d97$exports();
            id = $28cb323e84e8519a$var$baseId(generate.uuid, urlSafe) // rebase
            ;
            count = 0;
        }
        if (fixedLength) result = id + `0000000000${count}`.slice(-10);
        else result = id + count;
        count = count + 1 | 0;
        return result;
    }
}
function $28cb323e84e8519a$var$baseId(id, urlSafe) {
    const base64Id = $28cb323e84e8519a$var$Buffer.concat([
        $28cb323e84e8519a$var$Buffer.from($4a2d3a5d0d10f162$exports.parse(id)),
        $28cb323e84e8519a$var$base64Padding
    ]).toString('base64');
    if (urlSafe) return base64Id.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '-');
    return base64Id.replace(/=+$/, '/');
}
function $28cb323e84e8519a$var$decode(id, opts) {
    opts = opts || {};
    const urlSafe = !!opts.urlSafe;
    if (urlSafe) id = id.replace(/-([^-]*)$/, "/$1").replace(/-/g, '+').replace(/_/g, '/');
    if (id.length < 22) return null;
    const lastSlashIndex = id.lastIndexOf('/');
    if (lastSlashIndex === -1) return null;
    const uuidPart = id.substring(0, lastSlashIndex);
    const countPart = Number(id.substring(lastSlashIndex + 1));
    if (!uuidPart || isNaN(countPart)) return null;
    const result = {
        uuid: $4a2d3a5d0d10f162$exports.unparse($28cb323e84e8519a$var$Buffer.from(uuidPart + '==', 'base64')),
        count: countPart
    };
    return result;
}
$28cb323e84e8519a$exports = $28cb323e84e8519a$var$hyperid;
$28cb323e84e8519a$exports.decode = $28cb323e84e8519a$var$decode;


var $26ce26772c045640$exports = {};
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    $26ce26772c045640$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode('');
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== 'undefined') {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ('document' in global1 && 'onreadystatechange' in global1.document.createElement('script')) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement('script');
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                'use strict';
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    'REJECTED'
                ];
                var FULFILLED = [
                    'FULFILLED'
                ];
                var PENDING = [
                    'PENDING'
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== 'function') throw new TypeError('resolver must be a function');
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== 'function' && this.state === FULFILLED || typeof onRejected !== 'function' && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === 'function') {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === 'function') {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === 'error') return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === 'error') onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = 'success';
                    } catch (e) {
                        out.status = 'error';
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== '[object Array]') return this.reject(new TypeError('must be an array'));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    'use strict';
                    if (typeof global1.Promise !== 'function') global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== 'undefined') return indexedDB;
                        if (typeof webkitIndexedDB !== 'undefined') return webkitIndexedDB;
                        if (typeof mozIndexedDB !== 'undefined') return mozIndexedDB;
                        if (typeof OIndexedDB !== 'undefined') return OIndexedDB;
                        if (typeof msIndexedDB !== 'undefined') return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== 'undefined';
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== 'TypeError') throw e;
                        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === 'undefined') // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === 'function') promise.then(callback);
                    if (typeof errorCallback === 'function') promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== 'string') {
                        console.warn(key + ' used as a key, but it is not a string.');
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = 'readonly';
                var READ_WRITE = 'readwrite';
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ''
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === 'boolean') return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === 'ConstraintError') console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || '');
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === '[object Blob]') return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: 'asyncStorage',
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === 'function';
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
                var BLOB_TYPE_PREFIX = '~~local_forage_type~';
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = '__lfsc__:';
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = 'arbf';
                var TYPE_BLOB = 'blob';
                var TYPE_INT8ARRAY = 'si08';
                var TYPE_UINT8ARRAY = 'ui08';
                var TYPE_UINT8CLAMPEDARRAY = 'uic8';
                var TYPE_INT16ARRAY = 'si16';
                var TYPE_INT32ARRAY = 'si32';
                var TYPE_UINT16ARRAY = 'ur16';
                var TYPE_UINT32ARRAY = 'ui32';
                var TYPE_FLOAT32ARRAY = 'fl32';
                var TYPE_FLOAT64ARRAY = 'fl64';
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === '=') {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === '=') bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = '';
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + '=';
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + '==';
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = '';
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === '[object Int8Array]') marker += TYPE_INT8ARRAY;
                            else if (valueType === '[object Uint8Array]') marker += TYPE_UINT8ARRAY;
                            else if (valueType === '[object Uint8ClampedArray]') marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === '[object Int16Array]') marker += TYPE_INT16ARRAY;
                            else if (valueType === '[object Uint16Array]') marker += TYPE_UINT16ARRAY;
                            else if (valueType === '[object Int32Array]') marker += TYPE_INT32ARRAY;
                            else if (valueType === '[object Uint32Array]') marker += TYPE_UINT32ARRAY;
                            else if (valueType === '[object Float32Array]') marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === '[object Float64Array]') marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error('Failed to get type for BinaryArray'));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === '[object Blob]') {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error('Unkown type: ' + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, '', '', 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: 'webSQLStorage',
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== 'undefined' && 'setItem' in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + '/';
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + '/';
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = '_localforage_support_test';
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== 'function' && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject('Invalid arguments');
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + '/');
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: 'localStorageWrapper',
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === '[object Array]';
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    'dropInstance'
                ];
                var LibraryMethods = [
                    'clear',
                    'getItem',
                    'iterate',
                    'key',
                    'keys',
                    'length',
                    'removeItem',
                    'setItem'
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: '',
                    driver: DefaultDriverOrder.slice(),
                    name: 'localforage',
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: 'keyvaluepairs',
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === 'storeName') options[i] = options[i].replace(/\W/g, '_');
                                if (i === 'version' && typeof options[i] !== 'number') return new Error('Database version must be a number.');
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ('driver' in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === 'string') return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat('_initStorage');
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info('Redefining LocalForage driver: ' + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ('_support' in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === 'function') driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error('No available storage method found.');
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error('No available storage method found.');
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});


// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e6c4a7d216ac78cf$export$a143d493d941bafc;
var $e6c4a7d216ac78cf$export$e4cf37d7f6fb9e0a;
var $e6c4a7d216ac78cf$export$f99ded8fe4b79145;
var $e6c4a7d216ac78cf$export$599f31c3813fae4d;
'use strict';
var $63305e82f7a9dca8$export$a48f0734ac7c2329;
var $63305e82f7a9dca8$export$d622b2ad8d90c771;
var $63305e82f7a9dca8$export$6100ba28696e12de;
'use strict';
$63305e82f7a9dca8$export$a48f0734ac7c2329 = $63305e82f7a9dca8$var$byteLength;
$63305e82f7a9dca8$export$d622b2ad8d90c771 = $63305e82f7a9dca8$var$toByteArray;
$63305e82f7a9dca8$export$6100ba28696e12de = $63305e82f7a9dca8$var$fromByteArray;
var $63305e82f7a9dca8$var$lookup = [];
var $63305e82f7a9dca8$var$revLookup = [];
var $63305e82f7a9dca8$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $63305e82f7a9dca8$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $63305e82f7a9dca8$var$i = 0, $63305e82f7a9dca8$var$len = $63305e82f7a9dca8$var$code.length; $63305e82f7a9dca8$var$i < $63305e82f7a9dca8$var$len; ++$63305e82f7a9dca8$var$i){
    $63305e82f7a9dca8$var$lookup[$63305e82f7a9dca8$var$i] = $63305e82f7a9dca8$var$code[$63305e82f7a9dca8$var$i];
    $63305e82f7a9dca8$var$revLookup[$63305e82f7a9dca8$var$code.charCodeAt($63305e82f7a9dca8$var$i)] = $63305e82f7a9dca8$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$63305e82f7a9dca8$var$revLookup['-'.charCodeAt(0)] = 62;
$63305e82f7a9dca8$var$revLookup['_'.charCodeAt(0)] = 63;
function $63305e82f7a9dca8$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $63305e82f7a9dca8$var$byteLength(b64) {
    var lens = $63305e82f7a9dca8$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $63305e82f7a9dca8$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $63305e82f7a9dca8$var$toByteArray(b64) {
    var tmp;
    var lens = $63305e82f7a9dca8$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $63305e82f7a9dca8$var$Arr($63305e82f7a9dca8$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $63305e82f7a9dca8$var$revLookup[b64.charCodeAt(i)] << 18 | $63305e82f7a9dca8$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $63305e82f7a9dca8$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $63305e82f7a9dca8$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $63305e82f7a9dca8$var$revLookup[b64.charCodeAt(i)] << 2 | $63305e82f7a9dca8$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $63305e82f7a9dca8$var$revLookup[b64.charCodeAt(i)] << 10 | $63305e82f7a9dca8$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $63305e82f7a9dca8$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $63305e82f7a9dca8$var$tripletToBase64(num) {
    return $63305e82f7a9dca8$var$lookup[num >> 18 & 0x3F] + $63305e82f7a9dca8$var$lookup[num >> 12 & 0x3F] + $63305e82f7a9dca8$var$lookup[num >> 6 & 0x3F] + $63305e82f7a9dca8$var$lookup[num & 0x3F];
}
function $63305e82f7a9dca8$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($63305e82f7a9dca8$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $63305e82f7a9dca8$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($63305e82f7a9dca8$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($63305e82f7a9dca8$var$lookup[tmp >> 2] + $63305e82f7a9dca8$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($63305e82f7a9dca8$var$lookup[tmp >> 10] + $63305e82f7a9dca8$var$lookup[tmp >> 4 & 0x3F] + $63305e82f7a9dca8$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a911c4ba5dd8182d$export$aafa59e2e03f2942;
var $a911c4ba5dd8182d$export$68d8715fc104d294;
$a911c4ba5dd8182d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a911c4ba5dd8182d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $e6c4a7d216ac78cf$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$e6c4a7d216ac78cf$export$a143d493d941bafc = $e6c4a7d216ac78cf$var$Buffer;
$e6c4a7d216ac78cf$export$e4cf37d7f6fb9e0a = $e6c4a7d216ac78cf$var$SlowBuffer;
$e6c4a7d216ac78cf$export$f99ded8fe4b79145 = 50;
const $e6c4a7d216ac78cf$var$K_MAX_LENGTH = 0x7fffffff;
$e6c4a7d216ac78cf$export$599f31c3813fae4d = $e6c4a7d216ac78cf$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e6c4a7d216ac78cf$var$Buffer.TYPED_ARRAY_SUPPORT = $e6c4a7d216ac78cf$var$typedArraySupport();
if (!$e6c4a7d216ac78cf$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e6c4a7d216ac78cf$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e6c4a7d216ac78cf$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$e6c4a7d216ac78cf$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e6c4a7d216ac78cf$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$e6c4a7d216ac78cf$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e6c4a7d216ac78cf$var$createBuffer(length) {
    if (length > $e6c4a7d216ac78cf$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e6c4a7d216ac78cf$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e6c4a7d216ac78cf$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e6c4a7d216ac78cf$var$allocUnsafe(arg);
    }
    return $e6c4a7d216ac78cf$var$from(arg, encodingOrOffset, length);
}
$e6c4a7d216ac78cf$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e6c4a7d216ac78cf$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $e6c4a7d216ac78cf$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e6c4a7d216ac78cf$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e6c4a7d216ac78cf$var$isInstance(value, ArrayBuffer) || value && $e6c4a7d216ac78cf$var$isInstance(value.buffer, ArrayBuffer)) return $e6c4a7d216ac78cf$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($e6c4a7d216ac78cf$var$isInstance(value, SharedArrayBuffer) || value && $e6c4a7d216ac78cf$var$isInstance(value.buffer, SharedArrayBuffer))) return $e6c4a7d216ac78cf$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e6c4a7d216ac78cf$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $e6c4a7d216ac78cf$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $e6c4a7d216ac78cf$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e6c4a7d216ac78cf$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e6c4a7d216ac78cf$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e6c4a7d216ac78cf$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e6c4a7d216ac78cf$var$Buffer, Uint8Array);
function $e6c4a7d216ac78cf$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e6c4a7d216ac78cf$var$alloc(size, fill, encoding) {
    $e6c4a7d216ac78cf$var$assertSize(size);
    if (size <= 0) return $e6c4a7d216ac78cf$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $e6c4a7d216ac78cf$var$createBuffer(size).fill(fill, encoding) : $e6c4a7d216ac78cf$var$createBuffer(size).fill(fill);
    return $e6c4a7d216ac78cf$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e6c4a7d216ac78cf$var$Buffer.alloc = function(size, fill, encoding) {
    return $e6c4a7d216ac78cf$var$alloc(size, fill, encoding);
};
function $e6c4a7d216ac78cf$var$allocUnsafe(size) {
    $e6c4a7d216ac78cf$var$assertSize(size);
    return $e6c4a7d216ac78cf$var$createBuffer(size < 0 ? 0 : $e6c4a7d216ac78cf$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e6c4a7d216ac78cf$var$Buffer.allocUnsafe = function(size) {
    return $e6c4a7d216ac78cf$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e6c4a7d216ac78cf$var$Buffer.allocUnsafeSlow = function(size) {
    return $e6c4a7d216ac78cf$var$allocUnsafe(size);
};
function $e6c4a7d216ac78cf$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$e6c4a7d216ac78cf$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $e6c4a7d216ac78cf$var$byteLength(string, encoding) | 0;
    let buf = $e6c4a7d216ac78cf$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e6c4a7d216ac78cf$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $e6c4a7d216ac78cf$var$checked(array.length) | 0;
    const buf = $e6c4a7d216ac78cf$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e6c4a7d216ac78cf$var$fromArrayView(arrayView) {
    if ($e6c4a7d216ac78cf$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $e6c4a7d216ac78cf$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e6c4a7d216ac78cf$var$fromArrayLike(arrayView);
}
function $e6c4a7d216ac78cf$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e6c4a7d216ac78cf$var$Buffer.prototype);
    return buf;
}
function $e6c4a7d216ac78cf$var$fromObject(obj) {
    if ($e6c4a7d216ac78cf$var$Buffer.isBuffer(obj)) {
        const len = $e6c4a7d216ac78cf$var$checked(obj.length) | 0;
        const buf = $e6c4a7d216ac78cf$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $e6c4a7d216ac78cf$var$numberIsNaN(obj.length)) return $e6c4a7d216ac78cf$var$createBuffer(0);
        return $e6c4a7d216ac78cf$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $e6c4a7d216ac78cf$var$fromArrayLike(obj.data);
}
function $e6c4a7d216ac78cf$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e6c4a7d216ac78cf$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e6c4a7d216ac78cf$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $e6c4a7d216ac78cf$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e6c4a7d216ac78cf$var$Buffer.alloc(+length);
}
$e6c4a7d216ac78cf$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e6c4a7d216ac78cf$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e6c4a7d216ac78cf$var$Buffer.compare = function compare(a, b) {
    if ($e6c4a7d216ac78cf$var$isInstance(a, Uint8Array)) a = $e6c4a7d216ac78cf$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e6c4a7d216ac78cf$var$isInstance(b, Uint8Array)) b = $e6c4a7d216ac78cf$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e6c4a7d216ac78cf$var$Buffer.isBuffer(a) || !$e6c4a7d216ac78cf$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e6c4a7d216ac78cf$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$e6c4a7d216ac78cf$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e6c4a7d216ac78cf$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $e6c4a7d216ac78cf$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($e6c4a7d216ac78cf$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$e6c4a7d216ac78cf$var$Buffer.isBuffer(buf)) buf = $e6c4a7d216ac78cf$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e6c4a7d216ac78cf$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e6c4a7d216ac78cf$var$byteLength(string, encoding) {
    if ($e6c4a7d216ac78cf$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e6c4a7d216ac78cf$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $e6c4a7d216ac78cf$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $e6c4a7d216ac78cf$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e6c4a7d216ac78cf$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e6c4a7d216ac78cf$var$Buffer.byteLength = $e6c4a7d216ac78cf$var$byteLength;
function $e6c4a7d216ac78cf$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $e6c4a7d216ac78cf$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $e6c4a7d216ac78cf$var$utf8Slice(this, start, end);
        case 'ascii':
            return $e6c4a7d216ac78cf$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $e6c4a7d216ac78cf$var$latin1Slice(this, start, end);
        case 'base64':
            return $e6c4a7d216ac78cf$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e6c4a7d216ac78cf$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e6c4a7d216ac78cf$var$Buffer.prototype._isBuffer = true;
function $e6c4a7d216ac78cf$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e6c4a7d216ac78cf$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$e6c4a7d216ac78cf$var$swap(this, i, i + 1);
    return this;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $e6c4a7d216ac78cf$var$swap(this, i, i + 3);
        $e6c4a7d216ac78cf$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $e6c4a7d216ac78cf$var$swap(this, i, i + 7);
        $e6c4a7d216ac78cf$var$swap(this, i + 1, i + 6);
        $e6c4a7d216ac78cf$var$swap(this, i + 2, i + 5);
        $e6c4a7d216ac78cf$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $e6c4a7d216ac78cf$var$utf8Slice(this, 0, length);
    return $e6c4a7d216ac78cf$var$slowToString.apply(this, arguments);
};
$e6c4a7d216ac78cf$var$Buffer.prototype.toLocaleString = $e6c4a7d216ac78cf$var$Buffer.prototype.toString;
$e6c4a7d216ac78cf$var$Buffer.prototype.equals = function equals(b) {
    if (!$e6c4a7d216ac78cf$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $e6c4a7d216ac78cf$var$Buffer.compare(this, b) === 0;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $e6c4a7d216ac78cf$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($e6c4a7d216ac78cf$var$customInspectSymbol) $e6c4a7d216ac78cf$var$Buffer.prototype[$e6c4a7d216ac78cf$var$customInspectSymbol] = $e6c4a7d216ac78cf$var$Buffer.prototype.inspect;
$e6c4a7d216ac78cf$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e6c4a7d216ac78cf$var$isInstance(target, Uint8Array)) target = $e6c4a7d216ac78cf$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e6c4a7d216ac78cf$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e6c4a7d216ac78cf$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e6c4a7d216ac78cf$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $e6c4a7d216ac78cf$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e6c4a7d216ac78cf$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e6c4a7d216ac78cf$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e6c4a7d216ac78cf$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $e6c4a7d216ac78cf$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e6c4a7d216ac78cf$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e6c4a7d216ac78cf$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e6c4a7d216ac78cf$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e6c4a7d216ac78cf$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e6c4a7d216ac78cf$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e6c4a7d216ac78cf$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e6c4a7d216ac78cf$var$utf8Write(buf, string, offset, length) {
    return $e6c4a7d216ac78cf$var$blitBuffer($e6c4a7d216ac78cf$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e6c4a7d216ac78cf$var$asciiWrite(buf, string, offset, length) {
    return $e6c4a7d216ac78cf$var$blitBuffer($e6c4a7d216ac78cf$var$asciiToBytes(string), buf, offset, length);
}
function $e6c4a7d216ac78cf$var$base64Write(buf, string, offset, length) {
    return $e6c4a7d216ac78cf$var$blitBuffer($e6c4a7d216ac78cf$var$base64ToBytes(string), buf, offset, length);
}
function $e6c4a7d216ac78cf$var$ucs2Write(buf, string, offset, length) {
    return $e6c4a7d216ac78cf$var$blitBuffer($e6c4a7d216ac78cf$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e6c4a7d216ac78cf$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $e6c4a7d216ac78cf$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $e6c4a7d216ac78cf$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $e6c4a7d216ac78cf$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $e6c4a7d216ac78cf$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e6c4a7d216ac78cf$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e6c4a7d216ac78cf$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e6c4a7d216ac78cf$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $63305e82f7a9dca8$export$6100ba28696e12de(buf);
    else return $63305e82f7a9dca8$export$6100ba28696e12de(buf.slice(start, end));
}
function $e6c4a7d216ac78cf$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e6c4a7d216ac78cf$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $e6c4a7d216ac78cf$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e6c4a7d216ac78cf$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $e6c4a7d216ac78cf$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e6c4a7d216ac78cf$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e6c4a7d216ac78cf$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e6c4a7d216ac78cf$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e6c4a7d216ac78cf$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $e6c4a7d216ac78cf$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e6c4a7d216ac78cf$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e6c4a7d216ac78cf$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e6c4a7d216ac78cf$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e6c4a7d216ac78cf$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$e6c4a7d216ac78cf$var$Buffer.prototype.readUintLE = $e6c4a7d216ac78cf$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readUintBE = $e6c4a7d216ac78cf$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readUint8 = $e6c4a7d216ac78cf$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readUint16LE = $e6c4a7d216ac78cf$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readUint16BE = $e6c4a7d216ac78cf$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readUint32LE = $e6c4a7d216ac78cf$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readUint32BE = $e6c4a7d216ac78cf$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readBigUInt64LE = $e6c4a7d216ac78cf$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $e6c4a7d216ac78cf$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e6c4a7d216ac78cf$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$e6c4a7d216ac78cf$var$Buffer.prototype.readBigUInt64BE = $e6c4a7d216ac78cf$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $e6c4a7d216ac78cf$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e6c4a7d216ac78cf$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$e6c4a7d216ac78cf$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readBigInt64LE = $e6c4a7d216ac78cf$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $e6c4a7d216ac78cf$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e6c4a7d216ac78cf$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$e6c4a7d216ac78cf$var$Buffer.prototype.readBigInt64BE = $e6c4a7d216ac78cf$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $e6c4a7d216ac78cf$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e6c4a7d216ac78cf$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$e6c4a7d216ac78cf$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 4, this.length);
    return $a911c4ba5dd8182d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 4, this.length);
    return $a911c4ba5dd8182d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 8, this.length);
    return $a911c4ba5dd8182d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$e6c4a7d216ac78cf$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkOffset(offset, 8, this.length);
    return $a911c4ba5dd8182d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $e6c4a7d216ac78cf$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e6c4a7d216ac78cf$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$e6c4a7d216ac78cf$var$Buffer.prototype.writeUintLE = $e6c4a7d216ac78cf$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e6c4a7d216ac78cf$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeUintBE = $e6c4a7d216ac78cf$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e6c4a7d216ac78cf$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeUint8 = $e6c4a7d216ac78cf$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeUint16LE = $e6c4a7d216ac78cf$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeUint16BE = $e6c4a7d216ac78cf$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeUint32LE = $e6c4a7d216ac78cf$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeUint32BE = $e6c4a7d216ac78cf$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e6c4a7d216ac78cf$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $e6c4a7d216ac78cf$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $e6c4a7d216ac78cf$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $e6c4a7d216ac78cf$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$e6c4a7d216ac78cf$var$Buffer.prototype.writeBigUInt64LE = $e6c4a7d216ac78cf$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $e6c4a7d216ac78cf$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e6c4a7d216ac78cf$var$Buffer.prototype.writeBigUInt64BE = $e6c4a7d216ac78cf$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $e6c4a7d216ac78cf$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e6c4a7d216ac78cf$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e6c4a7d216ac78cf$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e6c4a7d216ac78cf$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeBigInt64LE = $e6c4a7d216ac78cf$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $e6c4a7d216ac78cf$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$e6c4a7d216ac78cf$var$Buffer.prototype.writeBigInt64BE = $e6c4a7d216ac78cf$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $e6c4a7d216ac78cf$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $e6c4a7d216ac78cf$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $e6c4a7d216ac78cf$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $a911c4ba5dd8182d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e6c4a7d216ac78cf$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e6c4a7d216ac78cf$var$writeFloat(this, value, offset, true, noAssert);
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e6c4a7d216ac78cf$var$writeFloat(this, value, offset, false, noAssert);
};
function $e6c4a7d216ac78cf$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6c4a7d216ac78cf$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $a911c4ba5dd8182d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e6c4a7d216ac78cf$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e6c4a7d216ac78cf$var$writeDouble(this, value, offset, true, noAssert);
};
$e6c4a7d216ac78cf$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e6c4a7d216ac78cf$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e6c4a7d216ac78cf$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e6c4a7d216ac78cf$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e6c4a7d216ac78cf$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$e6c4a7d216ac78cf$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $e6c4a7d216ac78cf$var$Buffer.isBuffer(val) ? val : $e6c4a7d216ac78cf$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $e6c4a7d216ac78cf$var$errors = {};
function $e6c4a7d216ac78cf$var$E(sym, getMessage, Base) {
    $e6c4a7d216ac78cf$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$e6c4a7d216ac78cf$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$e6c4a7d216ac78cf$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$e6c4a7d216ac78cf$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $e6c4a7d216ac78cf$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $e6c4a7d216ac78cf$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $e6c4a7d216ac78cf$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $e6c4a7d216ac78cf$var$checkBounds(buf, offset, byteLength) {
    $e6c4a7d216ac78cf$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $e6c4a7d216ac78cf$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $e6c4a7d216ac78cf$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $e6c4a7d216ac78cf$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $e6c4a7d216ac78cf$var$checkBounds(buf, offset, byteLength);
}
function $e6c4a7d216ac78cf$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $e6c4a7d216ac78cf$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $e6c4a7d216ac78cf$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $e6c4a7d216ac78cf$var$validateNumber(value, type);
        throw new $e6c4a7d216ac78cf$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $e6c4a7d216ac78cf$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $e6c4a7d216ac78cf$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $e6c4a7d216ac78cf$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e6c4a7d216ac78cf$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e6c4a7d216ac78cf$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $e6c4a7d216ac78cf$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $e6c4a7d216ac78cf$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e6c4a7d216ac78cf$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e6c4a7d216ac78cf$var$base64ToBytes(str) {
    return $63305e82f7a9dca8$export$d622b2ad8d90c771($e6c4a7d216ac78cf$var$base64clean(str));
}
function $e6c4a7d216ac78cf$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e6c4a7d216ac78cf$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e6c4a7d216ac78cf$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $e6c4a7d216ac78cf$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $e6c4a7d216ac78cf$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $e6c4a7d216ac78cf$var$BufferBigIntNotDefined : fn;
}
function $e6c4a7d216ac78cf$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $f1b1811a0002602d$require$Buffer = $e6c4a7d216ac78cf$export$a143d493d941bafc;
var $f1b1811a0002602d$var$win;
if (typeof window === 'undefined') {
    var $f1b1811a0002602d$var$loc = {
        hostname: ''
    };
    $f1b1811a0002602d$var$win = {
        crypto: {
            randomUUID: function() {
                throw Error('unsupported');
            }
        },
        navigator: {
            userAgent: '',
            onLine: true
        },
        document: {
            createElement: function() {
                return {};
            },
            location: $f1b1811a0002602d$var$loc,
            referrer: ''
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $f1b1811a0002602d$var$loc,
        addEventListener: function() {},
        removeEventListener: function() {}
    };
} else $f1b1811a0002602d$var$win = window;
function $f1b1811a0002602d$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f1b1811a0002602d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $f1b1811a0002602d$var$_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $f1b1811a0002602d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $f1b1811a0002602d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $f1b1811a0002602d$var$_construct(Parent, args, Class) {
    if ($f1b1811a0002602d$var$_is_native_reflect_construct()) $f1b1811a0002602d$var$_construct = Reflect.construct;
    else $f1b1811a0002602d$var$_construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $f1b1811a0002602d$var$_set_prototype_of(instance, Class.prototype);
        return instance;
    };
    return $f1b1811a0002602d$var$_construct.apply(null, arguments);
}
function $f1b1811a0002602d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f1b1811a0002602d$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $f1b1811a0002602d$var$_defineProperties(Constructor.prototype, protoProps);
    return Constructor;
}
function $f1b1811a0002602d$var$_extends() {
    $f1b1811a0002602d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f1b1811a0002602d$var$_extends.apply(this, arguments);
}
function $f1b1811a0002602d$var$_get_prototype_of(o) {
    $f1b1811a0002602d$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f1b1811a0002602d$var$_get_prototype_of(o);
}
function $f1b1811a0002602d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f1b1811a0002602d$var$_set_prototype_of(subClass, superClass);
}
function $f1b1811a0002602d$var$_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
    else return left instanceof right;
}
function $f1b1811a0002602d$var$_is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $f1b1811a0002602d$var$_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f1b1811a0002602d$var$_set_prototype_of(o, p) {
    $f1b1811a0002602d$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f1b1811a0002602d$var$_set_prototype_of(o, p);
}
function $f1b1811a0002602d$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function $f1b1811a0002602d$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f1b1811a0002602d$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f1b1811a0002602d$var$_array_like_to_array(o, minLen);
}
function $f1b1811a0002602d$var$_wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $f1b1811a0002602d$var$_wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !$f1b1811a0002602d$var$_is_native_function(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $f1b1811a0002602d$var$_construct(Class, arguments, $f1b1811a0002602d$var$_get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $f1b1811a0002602d$var$_set_prototype_of(Wrapper, Class);
    };
    return $f1b1811a0002602d$var$_wrap_native_super(Class);
}
function $f1b1811a0002602d$var$_is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($f1b1811a0002602d$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f1b1811a0002602d$var$_unsupported_iterable_to_array(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f1b1811a0002602d$var$_ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $f1b1811a0002602d$var$_ts_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var $f1b1811a0002602d$var$__defProp = Object.defineProperty;
var $f1b1811a0002602d$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $f1b1811a0002602d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $f1b1811a0002602d$var$__publicField = function(obj, key, value) {
    return $f1b1811a0002602d$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
var $f1b1811a0002602d$var$_a;
var $f1b1811a0002602d$var$__defProp$1 = Object.defineProperty;
var $f1b1811a0002602d$var$__defNormalProp$1 = function(obj, key, value) {
    return key in obj ? $f1b1811a0002602d$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $f1b1811a0002602d$var$__publicField$1 = function(obj, key, value) {
    return $f1b1811a0002602d$var$__defNormalProp$1(obj, (typeof key === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
var $f1b1811a0002602d$var$NodeType$3 = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($f1b1811a0002602d$var$NodeType$3 || {});
var $f1b1811a0002602d$var$testableAccessors$1 = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
var $f1b1811a0002602d$var$testableMethods$1 = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
var $f1b1811a0002602d$var$untaintedBasePrototype$1 = {};
var $f1b1811a0002602d$var$isAngularZonePresent$1 = function() {
    return !!globalThis.Zone;
};
function $f1b1811a0002602d$var$getUntaintedPrototype$1(key) {
    if ($f1b1811a0002602d$var$untaintedBasePrototype$1[key]) return $f1b1811a0002602d$var$untaintedBasePrototype$1[key];
    var defaultObj = globalThis[key];
    var defaultPrototype = defaultObj.prototype;
    var accessorNames = key in $f1b1811a0002602d$var$testableAccessors$1 ? $f1b1811a0002602d$var$testableAccessors$1[key] : void 0;
    var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every(function(accessor) {
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    var methodNames = key in $f1b1811a0002602d$var$testableMethods$1 ? $f1b1811a0002602d$var$testableMethods$1[key] : void 0;
    var isUntaintedMethods = Boolean(methodNames && methodNames.every(function(method) {
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$f1b1811a0002602d$var$isAngularZonePresent$1()) {
        $f1b1811a0002602d$var$untaintedBasePrototype$1[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        var iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        var win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        var untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $f1b1811a0002602d$var$untaintedBasePrototype$1[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
var $f1b1811a0002602d$var$untaintedAccessorCache$1 = {};
function $f1b1811a0002602d$var$getUntaintedAccessor$1(key, instance, accessor) {
    var _a2;
    var cacheKey = key + "." + String(accessor);
    if ($f1b1811a0002602d$var$untaintedAccessorCache$1[cacheKey]) return $f1b1811a0002602d$var$untaintedAccessorCache$1[cacheKey].call(instance);
    var untaintedPrototype = $f1b1811a0002602d$var$getUntaintedPrototype$1(key);
    var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $f1b1811a0002602d$var$untaintedAccessorCache$1[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
var $f1b1811a0002602d$var$untaintedMethodCache$1 = {};
function $f1b1811a0002602d$var$getUntaintedMethod$1(key, instance, method) {
    var cacheKey = key + "." + String(method);
    if ($f1b1811a0002602d$var$untaintedMethodCache$1[cacheKey]) return $f1b1811a0002602d$var$untaintedMethodCache$1[cacheKey].bind(instance);
    var untaintedPrototype = $f1b1811a0002602d$var$getUntaintedPrototype$1(key);
    var untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $f1b1811a0002602d$var$untaintedMethodCache$1[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $f1b1811a0002602d$var$childNodes$1(n2) {
    return $f1b1811a0002602d$var$getUntaintedAccessor$1("Node", n2, "childNodes");
}
function $f1b1811a0002602d$var$parentNode$1(n2) {
    return $f1b1811a0002602d$var$getUntaintedAccessor$1("Node", n2, "parentNode");
}
function $f1b1811a0002602d$var$parentElement$1(n2) {
    return $f1b1811a0002602d$var$getUntaintedAccessor$1("Node", n2, "parentElement");
}
function $f1b1811a0002602d$var$textContent$1(n2) {
    return $f1b1811a0002602d$var$getUntaintedAccessor$1("Node", n2, "textContent");
}
function $f1b1811a0002602d$var$contains$1(n2, other) {
    return $f1b1811a0002602d$var$getUntaintedMethod$1("Node", n2, "contains")(other);
}
function $f1b1811a0002602d$var$getRootNode$1(n2) {
    return $f1b1811a0002602d$var$getUntaintedMethod$1("Node", n2, "getRootNode")();
}
function $f1b1811a0002602d$var$host$1(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $f1b1811a0002602d$var$getUntaintedAccessor$1("ShadowRoot", n2, "host");
}
function $f1b1811a0002602d$var$styleSheets$1(n2) {
    return n2.styleSheets;
}
function $f1b1811a0002602d$var$shadowRoot$1(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $f1b1811a0002602d$var$getUntaintedAccessor$1("Element", n2, "shadowRoot");
}
function $f1b1811a0002602d$var$querySelector$1(n2, selectors) {
    return $f1b1811a0002602d$var$getUntaintedAccessor$1("Element", n2, "querySelector")(selectors);
}
function $f1b1811a0002602d$var$querySelectorAll$1(n2, selectors) {
    return $f1b1811a0002602d$var$getUntaintedAccessor$1("Element", n2, "querySelectorAll")(selectors);
}
function $f1b1811a0002602d$var$mutationObserverCtor$1() {
    return $f1b1811a0002602d$var$getUntaintedPrototype$1("MutationObserver").constructor;
}
var $f1b1811a0002602d$var$index$1 = {
    childNodes: $f1b1811a0002602d$var$childNodes$1,
    parentNode: $f1b1811a0002602d$var$parentNode$1,
    parentElement: $f1b1811a0002602d$var$parentElement$1,
    textContent: $f1b1811a0002602d$var$textContent$1,
    contains: $f1b1811a0002602d$var$contains$1,
    getRootNode: $f1b1811a0002602d$var$getRootNode$1,
    host: $f1b1811a0002602d$var$host$1,
    styleSheets: $f1b1811a0002602d$var$styleSheets$1,
    shadowRoot: $f1b1811a0002602d$var$shadowRoot$1,
    querySelector: $f1b1811a0002602d$var$querySelector$1,
    querySelectorAll: $f1b1811a0002602d$var$querySelectorAll$1,
    mutationObserver: $f1b1811a0002602d$var$mutationObserverCtor$1
};
function $f1b1811a0002602d$var$isElement(n2) {
    return n2.nodeType === n2.ELEMENT_NODE;
}
function $f1b1811a0002602d$var$isShadowRoot(n2) {
    var hostEl = // but only shadow roots have a `mode` property
    n2 && "host" in n2 && "mode" in n2 && $f1b1811a0002602d$var$index$1.host(n2) || null;
    return Boolean(hostEl && "shadowRoot" in hostEl && $f1b1811a0002602d$var$index$1.shadowRoot(hostEl) === n2);
}
function $f1b1811a0002602d$var$isNativeShadowDom(shadowRoot2) {
    return Object.prototype.toString.call(shadowRoot2) === "[object ShadowRoot]";
}
function $f1b1811a0002602d$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $f1b1811a0002602d$var$escapeImportStatement(rule2) {
    var cssText = rule2.cssText;
    if (cssText.split('"').length < 3) return cssText;
    var statement = [
        "@import",
        "url(" + JSON.stringify(rule2.href) + ")"
    ];
    if (rule2.layerName === "") statement.push("layer");
    else if (rule2.layerName) statement.push("layer(" + rule2.layerName + ")");
    if (rule2.supportsText) statement.push("supports(" + rule2.supportsText + ")");
    if (rule2.media.length) statement.push(rule2.media.mediaText);
    return statement.join(" ") + ";";
}
function $f1b1811a0002602d$var$stringifyStylesheet(s2) {
    try {
        var rules2 = s2.rules || s2.cssRules;
        if (!rules2) return null;
        var sheetHref = s2.href;
        if (!sheetHref && s2.ownerNode && s2.ownerNode.ownerDocument) sheetHref = s2.ownerNode.ownerDocument.location.href;
        var stringifiedRules = Array.from(rules2, function(rule2) {
            return $f1b1811a0002602d$var$stringifyRule(rule2, sheetHref);
        }).join("");
        return $f1b1811a0002602d$var$fixBrowserCompatibilityIssuesInCSS(stringifiedRules);
    } catch (error) {
        return null;
    }
}
function $f1b1811a0002602d$var$stringifyRule(rule2, sheetHref) {
    if ($f1b1811a0002602d$var$isCSSImportRule(rule2)) {
        var importStringified;
        try {
            importStringified = $f1b1811a0002602d$var$stringifyStylesheet(rule2.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
            $f1b1811a0002602d$var$escapeImportStatement(rule2);
        } catch (error) {
            importStringified = rule2.cssText;
        }
        if (rule2.styleSheet.href) return $f1b1811a0002602d$var$absolutifyURLs(importStringified, rule2.styleSheet.href);
        return importStringified;
    } else {
        var ruleStringified = rule2.cssText;
        if ($f1b1811a0002602d$var$isCSSStyleRule(rule2) && rule2.selectorText.includes(":")) ruleStringified = $f1b1811a0002602d$var$fixSafariColons(ruleStringified);
        if (sheetHref) return $f1b1811a0002602d$var$absolutifyURLs(ruleStringified, sheetHref);
        return ruleStringified;
    }
}
function $f1b1811a0002602d$var$fixSafariColons(cssStringified) {
    var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $f1b1811a0002602d$var$isCSSImportRule(rule2) {
    return "styleSheet" in rule2;
}
function $f1b1811a0002602d$var$isCSSStyleRule(rule2) {
    return "selectorText" in rule2;
}
var $f1b1811a0002602d$var$Mirror = /*#__PURE__*/ function() {
    function Mirror() {
        $f1b1811a0002602d$var$__publicField$1(this, "idNodeMap", /* @__PURE__ */ new Map());
        $f1b1811a0002602d$var$__publicField$1(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
    }
    var _proto = Mirror.prototype;
    _proto.getId = function getId(n2) {
        var _a2;
        if (!n2) return -1;
        var id = (_a2 = this.getMeta(n2)) == null ? void 0 : _a2.id;
        return id != null ? id : -1;
    };
    _proto.getNode = function getNode(id) {
        return this.idNodeMap.get(id) || null;
    };
    _proto.getIds = function getIds() {
        return Array.from(this.idNodeMap.keys());
    };
    _proto.getMeta = function getMeta(n2) {
        return this.nodeMetaMap.get(n2) || null;
    };
    // removes the node from idNodeMap
    // doesn't remove the node from nodeMetaMap
    _proto.removeNodeFromMap = function removeNodeFromMap(n2) {
        var _this = this;
        var id = this.getId(n2);
        this.idNodeMap.delete(id);
        if (n2.childNodes) n2.childNodes.forEach(function(childNode) {
            return _this.removeNodeFromMap(childNode);
        });
    };
    _proto.has = function has(id) {
        return this.idNodeMap.has(id);
    };
    _proto.hasNode = function hasNode(node2) {
        return this.nodeMetaMap.has(node2);
    };
    _proto.add = function add(n2, meta) {
        var id = meta.id;
        this.idNodeMap.set(id, n2);
        this.nodeMetaMap.set(n2, meta);
    };
    _proto.replace = function replace(id, n2) {
        var oldNode = this.getNode(id);
        if (oldNode) {
            var meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n2, meta);
        }
        this.idNodeMap.set(id, n2);
    };
    _proto.reset = function reset() {
        this.idNodeMap = /* @__PURE__ */ new Map();
        this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
    };
    return Mirror;
}();
function $f1b1811a0002602d$var$createMirror$2() {
    return new $f1b1811a0002602d$var$Mirror();
}
function $f1b1811a0002602d$var$maskInputValue(param) {
    var element = param.element, maskInputOptions = param.maskInputOptions, tagName = param.tagName, type = param.type, value = param.value, maskInputFn = param.maskInputFn;
    var text = value || "";
    var actualType = type && $f1b1811a0002602d$var$toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) text = maskInputFn(text, element);
        else text = "*".repeat(text.length);
    }
    return text;
}
function $f1b1811a0002602d$var$toLowerCase(str) {
    return str.toLowerCase();
}
var $f1b1811a0002602d$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $f1b1811a0002602d$var$is2DCanvasBlank(canvas) {
    var ctx = canvas.getContext("2d");
    if (!ctx) return true;
    var chunkSize = 50;
    for(var x2 = 0; x2 < canvas.width; x2 += chunkSize)for(var y = 0; y < canvas.height; y += chunkSize){
        var getImageData = ctx.getImageData;
        var originalGetImageData = $f1b1811a0002602d$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$f1b1811a0002602d$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        var pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x2, y, Math.min(chunkSize, canvas.width - x2), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some(function(pixel) {
            return pixel !== 0;
        })) return false;
    }
    return true;
}
function $f1b1811a0002602d$var$getInputType(element) {
    var type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $f1b1811a0002602d$var$toLowerCase(type) : null;
}
function $f1b1811a0002602d$var$extractFileExtension(path, baseURL) {
    var url;
    try {
        url = new URL(path, baseURL != null ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    var regex = /\.([0-9a-z]+)(?:$)/i;
    var match = url.pathname.match(regex);
    var _ref;
    return (_ref = match == null ? void 0 : match[1]) != null ? _ref : null;
}
function $f1b1811a0002602d$var$extractOrigin(url) {
    var origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
var $f1b1811a0002602d$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var $f1b1811a0002602d$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var $f1b1811a0002602d$var$URL_WWW_MATCH = /^www\..*/i;
var $f1b1811a0002602d$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $f1b1811a0002602d$var$absolutifyURLs(cssText, href) {
    return (cssText || "").replace($f1b1811a0002602d$var$URL_IN_CSS_REF, function(origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($f1b1811a0002602d$var$URL_PROTOCOL_MATCH.test(filePath) || $f1b1811a0002602d$var$URL_WWW_MATCH.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if ($f1b1811a0002602d$var$DATA_URI.test(filePath)) return "url(" + maybeQuote + filePath + maybeQuote + ")";
        if (filePath[0] === "/") return "url(" + maybeQuote + ($f1b1811a0002602d$var$extractOrigin(href) + filePath) + maybeQuote + ")";
        var stack = href.split("/");
        var parts = filePath.split("/");
        stack.pop();
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(parts), _step; !(_step = _iterator()).done;){
            var part = _step.value;
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return "url(" + maybeQuote + stack.join("/") + maybeQuote + ")";
    });
}
function $f1b1811a0002602d$var$normalizeCssString(cssText) {
    return cssText.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "");
}
function $f1b1811a0002602d$var$splitCssText(cssText, style) {
    var childNodes2 = Array.from(style.childNodes);
    var splits = [];
    if (childNodes2.length > 1 && cssText && typeof cssText === "string") {
        var cssTextNorm = $f1b1811a0002602d$var$normalizeCssString(cssText);
        for(var i2 = 1; i2 < childNodes2.length; i2++)if (childNodes2[i2].textContent && typeof childNodes2[i2].textContent === "string") {
            var textContentNorm = $f1b1811a0002602d$var$normalizeCssString(childNodes2[i2].textContent);
            for(var j = 3; j < textContentNorm.length; j++){
                var bit = textContentNorm.substring(0, j);
                if (cssTextNorm.split(bit).length === 2) {
                    var splitNorm = cssTextNorm.indexOf(bit);
                    for(var k = splitNorm; k < cssText.length; k++)if ($f1b1811a0002602d$var$normalizeCssString(cssText.substring(0, k)).length === splitNorm) {
                        splits.push(cssText.substring(0, k));
                        cssText = cssText.substring(k);
                        break;
                    }
                    break;
                }
            }
        }
    }
    splits.push(cssText);
    return splits;
}
function $f1b1811a0002602d$var$markCssSplits(cssText, style) {
    return $f1b1811a0002602d$var$splitCssText(cssText, style).join("/* rr_split */");
}
var $f1b1811a0002602d$var$_id = 1;
var $f1b1811a0002602d$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
var $f1b1811a0002602d$var$IGNORED_NODE = -2;
function $f1b1811a0002602d$var$genId() {
    return $f1b1811a0002602d$var$_id++;
}
function $f1b1811a0002602d$var$getValidTagName$1(element) {
    if ($f1b1811a0002602d$var$_instanceof(element, HTMLFormElement)) return "form";
    var processedTagName = $f1b1811a0002602d$var$toLowerCase(element.tagName);
    if ($f1b1811a0002602d$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
var $f1b1811a0002602d$var$canvasService;
var $f1b1811a0002602d$var$canvasCtx;
var $f1b1811a0002602d$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var $f1b1811a0002602d$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $f1b1811a0002602d$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    var pos = 0;
    function collectCharacters(regEx) {
        var chars2;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars2 = match[0];
            pos += chars2.length;
            return chars2;
        }
        return "";
    }
    var output = [];
    while(true){
        collectCharacters($f1b1811a0002602d$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        var url = collectCharacters($f1b1811a0002602d$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $f1b1811a0002602d$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            var descriptorsStr = "";
            url = $f1b1811a0002602d$var$absoluteToDoc(doc, url);
            var inParens = false;
            while(true){
                var c2 = attributeValue.charAt(pos);
                if (c2 === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c2 === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c2 === "(") inParens = true;
                } else if (c2 === ")") inParens = false;
                descriptorsStr += c2;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
var $f1b1811a0002602d$var$cachedDocument = /* @__PURE__ */ new WeakMap();
function $f1b1811a0002602d$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    return $f1b1811a0002602d$var$getHref(doc, attributeValue);
}
function $f1b1811a0002602d$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $f1b1811a0002602d$var$getHref(doc, customHref) {
    var a2 = $f1b1811a0002602d$var$cachedDocument.get(doc);
    if (!a2) {
        a2 = doc.createElement("a");
        $f1b1811a0002602d$var$cachedDocument.set(doc, a2);
    }
    if (!customHref) customHref = "";
    else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) return customHref;
    a2.setAttribute("href", customHref);
    return a2.href;
}
function $f1b1811a0002602d$var$transformAttribute(doc, tagName, name, value) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $f1b1811a0002602d$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $f1b1811a0002602d$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $f1b1811a0002602d$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $f1b1811a0002602d$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $f1b1811a0002602d$var$absolutifyURLs(value, $f1b1811a0002602d$var$getHref(doc));
    else if (tagName === "object" && name === "data") return $f1b1811a0002602d$var$absoluteToDoc(doc, value);
    return value;
}
function $f1b1811a0002602d$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $f1b1811a0002602d$var$_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(var eIndex = element.classList.length; eIndex--;){
            var className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e2) {}
    return false;
}
function $f1b1811a0002602d$var$classMatchesRegex(node2, regex, checkAncestors) {
    if (!node2) return false;
    if (node2.nodeType !== node2.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return $f1b1811a0002602d$var$classMatchesRegex($f1b1811a0002602d$var$index$1.parentNode(node2), regex, checkAncestors);
    }
    for(var eIndex = node2.classList.length; eIndex--;){
        var className = node2.classList[eIndex];
        if (regex.test(className)) return true;
    }
    if (!checkAncestors) return false;
    return $f1b1811a0002602d$var$classMatchesRegex($f1b1811a0002602d$var$index$1.parentNode(node2), regex, checkAncestors);
}
function $f1b1811a0002602d$var$needMaskingText(node2, maskTextClass, maskTextSelector, checkAncestors) {
    var el;
    if ($f1b1811a0002602d$var$isElement(node2)) {
        el = node2;
        if (!$f1b1811a0002602d$var$index$1.childNodes(el).length) return false;
    } else if ($f1b1811a0002602d$var$index$1.parentElement(node2) === null) return false;
    else el = $f1b1811a0002602d$var$index$1.parentElement(node2);
    try {
        if (typeof maskTextClass === "string") {
            if (checkAncestors) {
                if (el.closest("." + maskTextClass)) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if ($f1b1811a0002602d$var$classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e2) {}
    return false;
}
function $f1b1811a0002602d$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = iframeEl.contentWindow;
    if (!win) return;
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        var timer = setTimeout(function() {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", function() {
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $f1b1811a0002602d$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    var fired = false;
    var styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    var timer = setTimeout(function() {
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", function() {
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $f1b1811a0002602d$var$serializeNode(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, needsMask = options.needsMask, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, _options_cssCaptured = options.cssCaptured, cssCaptured = _options_cssCaptured === void 0 ? false : _options_cssCaptured;
    var rootId = $f1b1811a0002602d$var$getRootId(doc, mirror2);
    switch(n2.nodeType){
        case n2.DOCUMENT_NODE:
            if (n2.compatMode !== "CSS1Compat") return {
                type: $f1b1811a0002602d$var$NodeType$3.Document,
                childNodes: [],
                compatMode: n2.compatMode
            };
            else return {
                type: $f1b1811a0002602d$var$NodeType$3.Document,
                childNodes: []
            };
        case n2.DOCUMENT_TYPE_NODE:
            return {
                type: $f1b1811a0002602d$var$NodeType$3.DocumentType,
                name: n2.name,
                publicId: n2.publicId,
                systemId: n2.systemId,
                rootId: rootId
            };
        case n2.ELEMENT_NODE:
            return $f1b1811a0002602d$var$serializeElementNode(n2, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId
            });
        case n2.TEXT_NODE:
            return $f1b1811a0002602d$var$serializeTextNode(n2, {
                doc: doc,
                needsMask: needsMask,
                maskTextFn: maskTextFn,
                rootId: rootId,
                cssCaptured: cssCaptured
            });
        case n2.CDATA_SECTION_NODE:
            return {
                type: $f1b1811a0002602d$var$NodeType$3.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n2.COMMENT_NODE:
            return {
                type: $f1b1811a0002602d$var$NodeType$3.Comment,
                textContent: $f1b1811a0002602d$var$index$1.textContent(n2) || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $f1b1811a0002602d$var$getRootId(doc, mirror2) {
    if (!mirror2.hasNode(doc)) return void 0;
    var docId = mirror2.getId(doc);
    return docId === 1 ? void 0 : docId;
}
function $f1b1811a0002602d$var$serializeTextNode(n2, options) {
    var needsMask = options.needsMask, maskTextFn = options.maskTextFn, rootId = options.rootId, cssCaptured = options.cssCaptured;
    var parent = $f1b1811a0002602d$var$index$1.parentNode(n2);
    var parentTagName = parent && parent.tagName;
    var textContent2 = "";
    var isStyle = parentTagName === "STYLE" ? true : void 0;
    var isScript = parentTagName === "SCRIPT" ? true : void 0;
    if (isScript) textContent2 = "SCRIPT_PLACEHOLDER";
    else if (!cssCaptured) {
        textContent2 = $f1b1811a0002602d$var$index$1.textContent(n2);
        if (isStyle && textContent2) textContent2 = $f1b1811a0002602d$var$absolutifyURLs(textContent2, $f1b1811a0002602d$var$getHref(options.doc));
    }
    if (!isStyle && !isScript && textContent2 && needsMask) textContent2 = maskTextFn ? maskTextFn(textContent2, $f1b1811a0002602d$var$index$1.parentElement(n2)) : textContent2.replace(/[\S]/g, "*");
    return {
        type: $f1b1811a0002602d$var$NodeType$3.Text,
        textContent: textContent2 || "",
        rootId: rootId
    };
}
function $f1b1811a0002602d$var$serializeElementNode(n2, options) {
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, rootId = options.rootId;
    var needBlock = $f1b1811a0002602d$var$_isBlockedElement(n2, blockClass, blockSelector);
    var tagName = $f1b1811a0002602d$var$getValidTagName$1(n2);
    var attributes = {};
    var len = n2.attributes.length;
    for(var i2 = 0; i2 < len; i2++){
        var attr = n2.attributes[i2];
        if (!$f1b1811a0002602d$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $f1b1811a0002602d$var$transformAttribute(doc, tagName, $f1b1811a0002602d$var$toLowerCase(attr.name), attr.value);
    }
    if (tagName === "link" && inlineStylesheet) {
        var stylesheet = Array.from(doc.styleSheets).find(function(s2) {
            return s2.href === n2.href;
        });
        var cssText = null;
        if (stylesheet) cssText = $f1b1811a0002602d$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = cssText;
        }
    }
    if (tagName === "style" && n2.sheet) {
        var cssText1 = $f1b1811a0002602d$var$stringifyStylesheet(n2.sheet);
        if (cssText1) {
            if (n2.childNodes.length > 1) cssText1 = $f1b1811a0002602d$var$markCssSplits(cssText1, n2);
            attributes._cssText = cssText1;
        }
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select") {
        var value = n2.value;
        var checked = n2.checked;
        if (attributes.type !== "radio" && attributes.type !== "checkbox" && attributes.type !== "submit" && attributes.type !== "button" && value) attributes.value = $f1b1811a0002602d$var$maskInputValue({
            element: n2,
            type: $f1b1811a0002602d$var$getInputType(n2),
            tagName: tagName,
            value: value,
            maskInputOptions: maskInputOptions,
            maskInputFn: maskInputFn
        });
        else if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n2.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "dialog" && n2.open) attributes.rr_open_mode = n2.matches("dialog:modal") ? "modal" : "non-modal";
    if (tagName === "canvas" && recordCanvas) {
        if (n2.__context === "2d") {
            if (!$f1b1811a0002602d$var$is2DCanvasBlank(n2)) attributes.rr_dataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n2)) {
            var canvasDataURL = n2.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            var blankCanvas = doc.createElement("canvas");
            blankCanvas.width = n2.width;
            blankCanvas.height = n2.height;
            var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$f1b1811a0002602d$var$canvasService) {
            $f1b1811a0002602d$var$canvasService = doc.createElement("canvas");
            $f1b1811a0002602d$var$canvasCtx = $f1b1811a0002602d$var$canvasService.getContext("2d");
        }
        var image = n2;
        var imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
        var priorCrossOrigin = image.crossOrigin;
        var recordInlineImage = function() {
            image.removeEventListener("load", recordInlineImage);
            try {
                $f1b1811a0002602d$var$canvasService.width = image.naturalWidth;
                $f1b1811a0002602d$var$canvasService.height = image.naturalHeight;
                $f1b1811a0002602d$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $f1b1811a0002602d$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                if (image.crossOrigin !== "anonymous") {
                    image.crossOrigin = "anonymous";
                    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                    else image.addEventListener("load", recordInlineImage);
                    return;
                } else console.warn("Cannot inline img src=" + imageSrc + "! Error: " + err);
            }
            if (image.crossOrigin === "anonymous") priorCrossOrigin ? attributes.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        var mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n2.paused ? "paused" : "played";
        mediaAttributes.rr_mediaCurrentTime = n2.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n2.playbackRate;
        mediaAttributes.rr_mediaMuted = n2.muted;
        mediaAttributes.rr_mediaLoop = n2.loop;
        mediaAttributes.rr_mediaVolume = n2.volume;
    }
    if (!newlyAddedElement) {
        if (n2.scrollLeft) attributes.rr_scrollLeft = n2.scrollLeft;
        if (n2.scrollTop) attributes.rr_scrollTop = n2.scrollTop;
    }
    if (needBlock) {
        var _n2_getBoundingClientRect = n2.getBoundingClientRect(), width = _n2_getBoundingClientRect.width, height = _n2_getBoundingClientRect.height;
        attributes = {
            class: attributes.class,
            rr_width: "" + width + "px",
            rr_height: "" + height + "px"
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n2.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    var isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e2) {}
    return {
        type: $f1b1811a0002602d$var$NodeType$3.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $f1b1811a0002602d$var$isSVGElement(n2) || void 0,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $f1b1811a0002602d$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === void 0 || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $f1b1811a0002602d$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $f1b1811a0002602d$var$NodeType$3.Comment) return true;
    else if (sn.type === $f1b1811a0002602d$var$NodeType$3.Element) {
        if (slimDOMOptions.script && // script tag
        (sn.tagName === "script" || // (module)preload link
        sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || // prefetch link
        sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && $f1b1811a0002602d$var$extractFileExtension(sn.attributes.href) === "js")) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($f1b1811a0002602d$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "application-name" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.rel) === "icon" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($f1b1811a0002602d$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
            $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "robots" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "googlebot" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "author" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "generator" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "framework" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "publisher" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "progid" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "verification" || $f1b1811a0002602d$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $f1b1811a0002602d$var$serializeNodeWithId(n2, options) {
    var doc = options.doc, mirror2 = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, maskTextClass = options.maskTextClass, maskTextSelector = options.maskTextSelector, _options_skipChild = options.skipChild, skipChild = _options_skipChild === void 0 ? false : _options_skipChild, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _options_iframeLoadTimeout = options.iframeLoadTimeout, iframeLoadTimeout = _options_iframeLoadTimeout === void 0 ? 5e3 : _options_iframeLoadTimeout, onStylesheetLoad = options.onStylesheetLoad, _options_stylesheetLoadTimeout = options.stylesheetLoadTimeout, stylesheetLoadTimeout = _options_stylesheetLoadTimeout === void 0 ? 5e3 : _options_stylesheetLoadTimeout, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, _options_cssCaptured = options.cssCaptured, cssCaptured = _options_cssCaptured === void 0 ? false : _options_cssCaptured;
    var needsMask = options.needsMask;
    var _options_preserveWhiteSpace = options.preserveWhiteSpace, preserveWhiteSpace = _options_preserveWhiteSpace === void 0 ? true : _options_preserveWhiteSpace;
    if (!needsMask) {
        var checkAncestors = needsMask === void 0;
        needsMask = $f1b1811a0002602d$var$needMaskingText(n2, maskTextClass, maskTextSelector, checkAncestors);
    }
    var _serializedNode = $f1b1811a0002602d$var$serializeNode(n2, {
        doc: doc,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        needsMask: needsMask,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement,
        cssCaptured: cssCaptured
    });
    if (!_serializedNode) {
        console.warn(n2, "not serialized");
        return null;
    }
    var id;
    if (mirror2.hasNode(n2)) id = mirror2.getId(n2);
    else if ($f1b1811a0002602d$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $f1b1811a0002602d$var$NodeType$3.Text && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $f1b1811a0002602d$var$IGNORED_NODE;
    else id = $f1b1811a0002602d$var$genId();
    var serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror2.add(n2, serializedNode);
    if (id === $f1b1811a0002602d$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n2);
    var recordChild = !skipChild;
    if (serializedNode.type === $f1b1811a0002602d$var$NodeType$3.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        var shadowRootEl = $f1b1811a0002602d$var$index$1.shadowRoot(n2);
        if (shadowRootEl && $f1b1811a0002602d$var$isNativeShadowDom(shadowRootEl)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $f1b1811a0002602d$var$NodeType$3.Document || serializedNode.type === $f1b1811a0002602d$var$NodeType$3.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $f1b1811a0002602d$var$NodeType$3.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        var bypassOptions = {
            doc: doc,
            mirror: mirror2,
            blockClass: blockClass,
            blockSelector: blockSelector,
            needsMask: needsMask,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn,
            cssCaptured: false
        };
        if (serializedNode.type === $f1b1811a0002602d$var$NodeType$3.Element && serializedNode.tagName === "textarea" && serializedNode.attributes.value !== void 0) ;
        else {
            if (serializedNode.type === $f1b1811a0002602d$var$NodeType$3.Element && serializedNode.attributes._cssText !== void 0 && typeof serializedNode.attributes._cssText === "string") bypassOptions.cssCaptured = true;
            for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(Array.from($f1b1811a0002602d$var$index$1.childNodes(n2))), _step; !(_step = _iterator()).done;){
                var childN = _step.value;
                var serializedChildNode = $f1b1811a0002602d$var$serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
            }
        }
        var shadowRootEl1 = null;
        if ($f1b1811a0002602d$var$isElement(n2) && (shadowRootEl1 = $f1b1811a0002602d$var$index$1.shadowRoot(n2))) for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(Array.from($f1b1811a0002602d$var$index$1.childNodes(shadowRootEl1))), _step1; !(_step1 = _iterator1()).done;){
            var childN1 = _step1.value;
            var serializedChildNode1 = $f1b1811a0002602d$var$serializeNodeWithId(childN1, bypassOptions);
            if (serializedChildNode1) {
                $f1b1811a0002602d$var$isNativeShadowDom(shadowRootEl1) && (serializedChildNode1.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode1);
            }
        }
    }
    var parent = $f1b1811a0002602d$var$index$1.parentNode(n2);
    if (parent && $f1b1811a0002602d$var$isShadowRoot(parent) && $f1b1811a0002602d$var$isNativeShadowDom(parent)) serializedNode.isShadow = true;
    if (serializedNode.type === $f1b1811a0002602d$var$NodeType$3.Element && serializedNode.tagName === "iframe") $f1b1811a0002602d$var$onceIframeLoaded(n2, function() {
        var iframeDoc = n2.contentDocument;
        if (iframeDoc && onIframeLoad) {
            var serializedIframeNode = $f1b1811a0002602d$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n2, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $f1b1811a0002602d$var$NodeType$3.Element && serializedNode.tagName === "link" && typeof serializedNode.attributes.rel === "string" && (serializedNode.attributes.rel === "stylesheet" || serializedNode.attributes.rel === "preload" && typeof serializedNode.attributes.href === "string" && $f1b1811a0002602d$var$extractFileExtension(serializedNode.attributes.href) === "css")) $f1b1811a0002602d$var$onceStylesheetLoaded(n2, function() {
        if (onStylesheetLoad) {
            var serializedLinkNode = $f1b1811a0002602d$var$serializeNodeWithId(n2, {
                doc: doc,
                mirror: mirror2,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n2, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $f1b1811a0002602d$var$snapshot(n2, options) {
    var _ref = options || {}, tmp = _ref.mirror, mirror2 = tmp === void 0 ? new $f1b1811a0002602d$var$Mirror() : tmp, _ref_blockClass = _ref.blockClass, blockClass = _ref_blockClass === void 0 ? "rr-block" : _ref_blockClass, _ref_blockSelector = _ref.blockSelector, blockSelector = _ref_blockSelector === void 0 ? null : _ref_blockSelector, _ref_maskTextClass = _ref.maskTextClass, maskTextClass = _ref_maskTextClass === void 0 ? "rr-mask" : _ref_maskTextClass, _ref_maskTextSelector = _ref.maskTextSelector, maskTextSelector = _ref_maskTextSelector === void 0 ? null : _ref_maskTextSelector, _ref_inlineStylesheet = _ref.inlineStylesheet, inlineStylesheet = _ref_inlineStylesheet === void 0 ? true : _ref_inlineStylesheet, _ref_inlineImages = _ref.inlineImages, inlineImages = _ref_inlineImages === void 0 ? false : _ref_inlineImages, _ref_recordCanvas = _ref.recordCanvas, recordCanvas = _ref_recordCanvas === void 0 ? false : _ref_recordCanvas, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? false : _ref_maskAllInputs, maskTextFn = _ref.maskTextFn, maskInputFn = _ref.maskInputFn, _ref_slimDOM = _ref.slimDOM, slimDOM = _ref_slimDOM === void 0 ? false : _ref_slimDOM, dataURLOptions = _ref.dataURLOptions, preserveWhiteSpace = _ref.preserveWhiteSpace, onSerialize = _ref.onSerialize, onIframeLoad = _ref.onIframeLoad, iframeLoadTimeout = _ref.iframeLoadTimeout, onStylesheetLoad = _ref.onStylesheetLoad, stylesheetLoadTimeout = _ref.stylesheetLoadTimeout, _ref_keepIframeSrcFn = _ref.keepIframeSrcFn, keepIframeSrcFn = _ref_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _ref_keepIframeSrcFn;
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        // destructive
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $f1b1811a0002602d$var$serializeNodeWithId(n2, {
        doc: n2,
        mirror: mirror2,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $f1b1811a0002602d$var$getDefaultExportFromCjs$1(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $f1b1811a0002602d$var$getAugmentedNamespace$1(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if ($f1b1811a0002602d$var$_instanceof(this, a22)) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $f1b1811a0002602d$var$picocolors_browser$1 = {
    exports: {}
};
var $f1b1811a0002602d$var$x$1 = String;
var $f1b1811a0002602d$var$create$1 = function create$1() {
    return {
        isColorSupported: false,
        reset: $f1b1811a0002602d$var$x$1,
        bold: $f1b1811a0002602d$var$x$1,
        dim: $f1b1811a0002602d$var$x$1,
        italic: $f1b1811a0002602d$var$x$1,
        underline: $f1b1811a0002602d$var$x$1,
        inverse: $f1b1811a0002602d$var$x$1,
        hidden: $f1b1811a0002602d$var$x$1,
        strikethrough: $f1b1811a0002602d$var$x$1,
        black: $f1b1811a0002602d$var$x$1,
        red: $f1b1811a0002602d$var$x$1,
        green: $f1b1811a0002602d$var$x$1,
        yellow: $f1b1811a0002602d$var$x$1,
        blue: $f1b1811a0002602d$var$x$1,
        magenta: $f1b1811a0002602d$var$x$1,
        cyan: $f1b1811a0002602d$var$x$1,
        white: $f1b1811a0002602d$var$x$1,
        gray: $f1b1811a0002602d$var$x$1,
        bgBlack: $f1b1811a0002602d$var$x$1,
        bgRed: $f1b1811a0002602d$var$x$1,
        bgGreen: $f1b1811a0002602d$var$x$1,
        bgYellow: $f1b1811a0002602d$var$x$1,
        bgBlue: $f1b1811a0002602d$var$x$1,
        bgMagenta: $f1b1811a0002602d$var$x$1,
        bgCyan: $f1b1811a0002602d$var$x$1,
        bgWhite: $f1b1811a0002602d$var$x$1
    };
};
$f1b1811a0002602d$var$picocolors_browser$1.exports = $f1b1811a0002602d$var$create$1();
$f1b1811a0002602d$var$picocolors_browser$1.exports.createColors = $f1b1811a0002602d$var$create$1;
var $f1b1811a0002602d$var$picocolors_browserExports$1 = $f1b1811a0002602d$var$picocolors_browser$1.exports;
var $f1b1811a0002602d$var$__viteBrowserExternal$2 = {};
var $f1b1811a0002602d$var$__viteBrowserExternal$1$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $f1b1811a0002602d$var$__viteBrowserExternal$2
}, Symbol.toStringTag, {
    value: "Module"
}));
var $f1b1811a0002602d$var$require$$2$1 = /* @__PURE__ */ $f1b1811a0002602d$var$getAugmentedNamespace$1($f1b1811a0002602d$var$__viteBrowserExternal$1$1);
var $f1b1811a0002602d$var$pico$1 = $f1b1811a0002602d$var$picocolors_browserExports$1;
var $f1b1811a0002602d$var$terminalHighlight$1$1 = $f1b1811a0002602d$var$require$$2$1;
var $f1b1811a0002602d$var$CssSyntaxError$3$1 = /*#__PURE__*/ function(Error1) {
    $f1b1811a0002602d$var$_inherits(CssSyntaxError, Error1);
    function CssSyntaxError(message, line, column, source, file, plugin22) {
        var _this;
        _this = Error1.call(this, message) || this;
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin22) _this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError);
        return _this;
    }
    var _proto = CssSyntaxError.prototype;
    _proto.setMessage = function setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    };
    _proto.showSourceCode = function showSourceCode(color) {
        var _this = this;
        if (!this.source) return "";
        var css = this.source;
        if (color == null) color = $f1b1811a0002602d$var$pico$1.isColorSupported;
        if ($f1b1811a0002602d$var$terminalHighlight$1$1) {
            if (color) css = $f1b1811a0002602d$var$terminalHighlight$1$1(css);
        }
        var lines = css.split(/\r?\n/);
        var start = Math.max(this.line - 3, 0);
        var end = Math.min(this.line + 2, lines.length);
        var maxWidth = String(end).length;
        var mark, aside;
        if (color) {
            var _pico$1_createColors = $f1b1811a0002602d$var$pico$1.createColors(true), bold = _pico$1_createColors.bold, gray = _pico$1_createColors.gray, red = _pico$1_createColors.red;
            mark = function(text) {
                return bold(red(text));
            };
            aside = function(text) {
                return gray(text);
            };
        } else mark = aside = function(str) {
            return str;
        };
        return lines.slice(start, end).map(function(line, index2) {
            var number = start + 1 + index2;
            var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === _this.line) {
                var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    };
    _proto.toString = function toString() {
        var code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    };
    return CssSyntaxError;
}($f1b1811a0002602d$var$_wrap_native_super(Error));
var $f1b1811a0002602d$var$cssSyntaxError$1 = $f1b1811a0002602d$var$CssSyntaxError$3$1;
$f1b1811a0002602d$var$CssSyntaxError$3$1.default = $f1b1811a0002602d$var$CssSyntaxError$3$1;
var $f1b1811a0002602d$var$symbols$1 = {};
$f1b1811a0002602d$var$symbols$1.isClean = Symbol("isClean");
$f1b1811a0002602d$var$symbols$1.my = Symbol("my");
var $f1b1811a0002602d$var$DEFAULT_RAW$1 = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $f1b1811a0002602d$var$capitalize$1(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $f1b1811a0002602d$var$Stringifier$2$1 = /*#__PURE__*/ function() {
    function Stringifier(builder) {
        this.builder = builder;
    }
    var _proto = Stringifier.prototype;
    _proto.atrule = function atrule(node2, semicolon) {
        var name = "@" + node2.name;
        var params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            var end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    };
    _proto.beforeAfter = function beforeAfter(node2, detect) {
        var value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        var buf = node2.parent;
        var depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            var indent = this.raw(node2, null, "indent");
            if (indent.length) for(var step = 0; step < depth; step++)value += indent;
        }
        return value;
    };
    _proto.block = function block(node2, start) {
        var between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        var after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    };
    _proto.body = function body(node2) {
        var last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        var semicolon = this.raw(node2, "semicolon");
        for(var i2 = 0; i2 < node2.nodes.length; i2++){
            var child = node2.nodes[i2];
            var before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    };
    _proto.comment = function comment(node2) {
        var left = this.raw(node2, "left", "commentLeft");
        var right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    };
    _proto.decl = function decl(node2, semicolon) {
        var between = this.raw(node2, "between", "colon");
        var string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    };
    _proto.document = function document1(node2) {
        this.body(node2);
    };
    _proto.raw = function raw(node2, own, detect) {
        var value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        var parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $f1b1811a0002602d$var$DEFAULT_RAW$1[detect];
        var root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            var method = "raw" + $f1b1811a0002602d$var$capitalize$1(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk(function(i2) {
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $f1b1811a0002602d$var$DEFAULT_RAW$1[detect];
        root2.rawCache[detect] = value;
        return value;
    };
    _proto.rawBeforeClose = function rawBeforeClose(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeComment = function rawBeforeComment(root2, node2) {
        var value;
        root2.walkComments(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeDecl = function rawBeforeDecl(root2, node2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeOpen = function rawBeforeOpen(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawBeforeRule = function rawBeforeRule(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawColon = function rawColon(root2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    };
    _proto.rawEmptyBody = function rawEmptyBody(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawIndent = function rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        var value;
        root2.walk(function(i2) {
            var p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    var parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    };
    _proto.rawSemicolon = function rawSemicolon(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawValue = function rawValue(node2, prop) {
        var value = node2[prop];
        var raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    };
    _proto.root = function root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    };
    _proto.rule = function rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    };
    _proto.stringify = function stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    };
    return Stringifier;
}();
var $f1b1811a0002602d$var$stringifier$1 = $f1b1811a0002602d$var$Stringifier$2$1;
$f1b1811a0002602d$var$Stringifier$2$1.default = $f1b1811a0002602d$var$Stringifier$2$1;
var $f1b1811a0002602d$var$Stringifier$1$1 = $f1b1811a0002602d$var$stringifier$1;
function $f1b1811a0002602d$var$stringify$4$1(node2, builder) {
    var str = new $f1b1811a0002602d$var$Stringifier$1$1(builder);
    str.stringify(node2);
}
var $f1b1811a0002602d$var$stringify_1$1 = $f1b1811a0002602d$var$stringify$4$1;
$f1b1811a0002602d$var$stringify$4$1.default = $f1b1811a0002602d$var$stringify$4$1;
var $f1b1811a0002602d$var$isClean$2$1 = $f1b1811a0002602d$var$symbols$1.isClean, $f1b1811a0002602d$var$my$2$1 = $f1b1811a0002602d$var$symbols$1.my;
var $f1b1811a0002602d$var$CssSyntaxError$2$1 = $f1b1811a0002602d$var$cssSyntaxError$1;
var $f1b1811a0002602d$var$Stringifier2$1 = $f1b1811a0002602d$var$stringifier$1;
var $f1b1811a0002602d$var$stringify$3$1 = $f1b1811a0002602d$var$stringify_1$1;
function $f1b1811a0002602d$var$cloneNode$1(obj, parent) {
    var cloned = new obj.constructor();
    for(var i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        var value = obj[i2];
        var type = typeof value === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(value);
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map(function(j) {
            return $f1b1811a0002602d$var$cloneNode$1(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $f1b1811a0002602d$var$cloneNode$1(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
var $f1b1811a0002602d$var$Node$4$1 = /*#__PURE__*/ function() {
    function Node2(defaults) {
        if (defaults === void 0) defaults = {};
        this.raws = {};
        this[$f1b1811a0002602d$var$isClean$2$1] = false;
        this[$f1b1811a0002602d$var$my$2$1] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(defaults[name]), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (typeof node2.clone === "function") this.append(node2.clone());
                else this.append(node2);
            }
        } else this[name] = defaults[name];
    }
    var _proto = Node2.prototype;
    _proto.addToError = function addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            var s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, "$&" + s2.input.from + ":" + s2.start.line + ":" + s2.start.column + "$&");
        }
        return error;
    };
    _proto.after = function after(add) {
        this.parent.insertAfter(this, add);
        return this;
    };
    _proto.assign = function assign(overrides) {
        if (overrides === void 0) overrides = {};
        for(var name in overrides)this[name] = overrides[name];
        return this;
    };
    _proto.before = function before(add) {
        this.parent.insertBefore(this, add);
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $f1b1811a0002602d$var$cloneNode$1(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    };
    _proto.cloneAfter = function cloneAfter(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    };
    _proto.cloneBefore = function cloneBefore(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    };
    _proto.error = function error(message, opts) {
        if (opts === void 0) opts = {};
        if (this.source) {
            var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $f1b1811a0002602d$var$CssSyntaxError$2$1(message);
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    };
    _proto.markDirty = function markDirty() {
        if (this[$f1b1811a0002602d$var$isClean$2$1]) {
            this[$f1b1811a0002602d$var$isClean$2$1] = false;
            var next = this;
            while(next = next.parent)next[$f1b1811a0002602d$var$isClean$2$1] = false;
        }
    };
    _proto.next = function next() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    };
    _proto.positionBy = function positionBy(opts, stringRepresentation) {
        var pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    };
    _proto.positionInside = function positionInside(index2, stringRepresentation) {
        var string = stringRepresentation || this.toString();
        var column = this.source.start.column;
        var line = this.source.start.line;
        for(var i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    };
    _proto.prev = function prev() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    };
    _proto.rangeBy = function rangeBy(opts) {
        var start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        var end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            var stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    };
    _proto.raw = function raw(prop, defaultType) {
        var str = new $f1b1811a0002602d$var$Stringifier2$1();
        return str.raw(this, prop, defaultType);
    };
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        if (this.parent) {
            var bookmark = this;
            var foundSelf = false;
            for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    };
    _proto.root = function root() {
        var result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    };
    _proto.toJSON = function toJSON(_, inputs) {
        var fixed = {};
        var emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        var inputsNextIndex = 0;
        for(var name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            var value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map(function(i2) {
                if ((typeof i2 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(i2)) === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if ((typeof value === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(value)) === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                var inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [].concat(inputs.keys()).map(function(input2) {
            return input2.toJSON();
        });
        return fixed;
    };
    _proto.toProxy = function toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    };
    _proto.toString = function toString(stringifier2) {
        if (stringifier2 === void 0) stringifier2 = $f1b1811a0002602d$var$stringify$3$1;
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        var result2 = "";
        stringifier2(this, function(i2) {
            result2 += i2;
        });
        return result2;
    };
    _proto.warn = function warn(result2, text, opts) {
        var data = {
            node: this
        };
        for(var i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    };
    $f1b1811a0002602d$var$_create_class(Node2, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node2;
}();
var $f1b1811a0002602d$var$node$1 = $f1b1811a0002602d$var$Node$4$1;
$f1b1811a0002602d$var$Node$4$1.default = $f1b1811a0002602d$var$Node$4$1;
var $f1b1811a0002602d$var$Node$3$1 = $f1b1811a0002602d$var$node$1;
var $f1b1811a0002602d$var$Declaration$4$1 = /*#__PURE__*/ function(Node$3$1) {
    $f1b1811a0002602d$var$_inherits(Declaration, Node$3$1);
    function Declaration(defaults) {
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = $f1b1811a0002602d$var$_extends({}, defaults, {
            value: String(defaults.value)
        });
        _this = Node$3$1.call(this, defaults) || this;
        _this.type = "decl";
        return _this;
    }
    $f1b1811a0002602d$var$_create_class(Declaration, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration;
}($f1b1811a0002602d$var$Node$3$1);
var $f1b1811a0002602d$var$declaration$1 = $f1b1811a0002602d$var$Declaration$4$1;
$f1b1811a0002602d$var$Declaration$4$1.default = $f1b1811a0002602d$var$Declaration$4$1;
var $f1b1811a0002602d$var$urlAlphabet$1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $f1b1811a0002602d$var$nanoid$1$1 = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i2 = size;
    while(i2--)id += $f1b1811a0002602d$var$urlAlphabet$1[Math.random() * 64 | 0];
    return id;
};
var $f1b1811a0002602d$var$nonSecure$1 = {
    nanoid: $f1b1811a0002602d$var$nanoid$1$1
};
var $f1b1811a0002602d$var$SourceMapConsumer$2$1 = $f1b1811a0002602d$var$require$$2$1.SourceMapConsumer, $f1b1811a0002602d$var$SourceMapGenerator$2$1 = $f1b1811a0002602d$var$require$$2$1.SourceMapGenerator;
var $f1b1811a0002602d$var$existsSync$1 = $f1b1811a0002602d$var$require$$2$1.existsSync, $f1b1811a0002602d$var$readFileSync$1 = $f1b1811a0002602d$var$require$$2$1.readFileSync;
var $f1b1811a0002602d$var$dirname$1$1 = $f1b1811a0002602d$var$require$$2$1.dirname, $f1b1811a0002602d$var$join$1 = $f1b1811a0002602d$var$require$$2$1.join;
function $f1b1811a0002602d$var$fromBase64$1(str) {
    if ($f1b1811a0002602d$require$Buffer) return $f1b1811a0002602d$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
var $f1b1811a0002602d$var$PreviousMap$2$1 = /*#__PURE__*/ function() {
    function PreviousMap(css, opts) {
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : void 0;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $f1b1811a0002602d$var$dirname$1$1(this.mapFile);
        if (text) this.text = text;
    }
    var _proto = PreviousMap.prototype;
    _proto.consumer = function consumer() {
        if (!this.consumerCache) this.consumerCache = new $f1b1811a0002602d$var$SourceMapConsumer$2$1(this.text);
        return this.consumerCache;
    };
    _proto.decodeInline = function decodeInline(text) {
        var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        var baseUri = /^data:application\/json;base64,/;
        var charsetUri = /^data:application\/json;charset=utf-?8,/;
        var uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $f1b1811a0002602d$var$fromBase64$1(text.substr(RegExp.lastMatch.length));
        var encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    };
    _proto.getAnnotationURL = function getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    };
    _proto.isMap = function isMap(map) {
        if ((typeof map === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(map)) !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    };
    _proto.loadAnnotation = function loadAnnotation(css) {
        var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        var start = css.lastIndexOf(comments.pop());
        var end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    };
    _proto.loadFile = function loadFile(path) {
        this.root = $f1b1811a0002602d$var$dirname$1$1(path);
        if ($f1b1811a0002602d$var$existsSync$1(path)) {
            this.mapFile = path;
            return $f1b1811a0002602d$var$readFileSync$1(path, "utf-8").toString().trim();
        }
    };
    _proto.loadMap = function loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                var prevPath = prev(file);
                if (prevPath) {
                    var map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if ($f1b1811a0002602d$var$_instanceof(prev, $f1b1811a0002602d$var$SourceMapConsumer$2$1)) return $f1b1811a0002602d$var$SourceMapGenerator$2$1.fromSourceMap(prev).toString();
            else if ($f1b1811a0002602d$var$_instanceof(prev, $f1b1811a0002602d$var$SourceMapGenerator$2$1)) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            var map1 = this.annotation;
            if (file) map1 = $f1b1811a0002602d$var$join$1($f1b1811a0002602d$var$dirname$1$1(file), map1);
            return this.loadFile(map1);
        }
    };
    _proto.startWith = function startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    };
    _proto.withContent = function withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    };
    return PreviousMap;
}();
var $f1b1811a0002602d$var$previousMap$1 = $f1b1811a0002602d$var$PreviousMap$2$1;
$f1b1811a0002602d$var$PreviousMap$2$1.default = $f1b1811a0002602d$var$PreviousMap$2$1;
var $f1b1811a0002602d$var$SourceMapConsumer$1$1 = $f1b1811a0002602d$var$require$$2$1.SourceMapConsumer, $f1b1811a0002602d$var$SourceMapGenerator$1$1 = $f1b1811a0002602d$var$require$$2$1.SourceMapGenerator;
var $f1b1811a0002602d$var$fileURLToPath$1 = $f1b1811a0002602d$var$require$$2$1.fileURLToPath, $f1b1811a0002602d$var$pathToFileURL$1$1 = $f1b1811a0002602d$var$require$$2$1.pathToFileURL;
var $f1b1811a0002602d$var$isAbsolute$1 = $f1b1811a0002602d$var$require$$2$1.isAbsolute, $f1b1811a0002602d$var$resolve$1$1 = $f1b1811a0002602d$var$require$$2$1.resolve;
var $f1b1811a0002602d$var$nanoid$2 = $f1b1811a0002602d$var$nonSecure$1.nanoid;
var $f1b1811a0002602d$var$terminalHighlight$2 = $f1b1811a0002602d$var$require$$2$1;
var $f1b1811a0002602d$var$CssSyntaxError$1$1 = $f1b1811a0002602d$var$cssSyntaxError$1;
var $f1b1811a0002602d$var$PreviousMap$1$1 = $f1b1811a0002602d$var$previousMap$1;
var $f1b1811a0002602d$var$fromOffsetCache$1 = Symbol("fromOffsetCache");
var $f1b1811a0002602d$var$sourceMapAvailable$1$1 = Boolean($f1b1811a0002602d$var$SourceMapConsumer$1$1 && $f1b1811a0002602d$var$SourceMapGenerator$1$1);
var $f1b1811a0002602d$var$pathAvailable$1$1 = Boolean($f1b1811a0002602d$var$resolve$1$1 && $f1b1811a0002602d$var$isAbsolute$1);
var $f1b1811a0002602d$var$Input$4$1 = /*#__PURE__*/ function() {
    function Input(css, opts) {
        if (opts === void 0) opts = {};
        if (css === null || typeof css === "undefined" || (typeof css === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(css)) === "object" && !css.toString) throw new Error("PostCSS received " + css + " instead of CSS string");
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$f1b1811a0002602d$var$pathAvailable$1$1 || /^\w+:\/\//.test(opts.from) || $f1b1811a0002602d$var$isAbsolute$1(opts.from)) this.file = opts.from;
            else this.file = $f1b1811a0002602d$var$resolve$1$1(opts.from);
        }
        if ($f1b1811a0002602d$var$pathAvailable$1$1 && $f1b1811a0002602d$var$sourceMapAvailable$1$1) {
            var map = new $f1b1811a0002602d$var$PreviousMap$1$1(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $f1b1811a0002602d$var$nanoid$2(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    var _proto = Input.prototype;
    _proto.error = function error(message, line, column, opts) {
        if (opts === void 0) opts = {};
        var result2, endLine, endColumn;
        if (line && (typeof line === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(line)) === "object") {
            var start = line;
            var end = column;
            if (typeof start.offset === "number") {
                var pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                var pos1 = this.fromOffset(end.offset);
                endLine = pos1.line;
                endColumn = pos1.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            var pos2 = this.fromOffset(line);
            line = pos2.line;
            column = pos2.col;
        }
        var origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $f1b1811a0002602d$var$CssSyntaxError$1$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $f1b1811a0002602d$var$CssSyntaxError$1$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($f1b1811a0002602d$var$pathToFileURL$1$1) result2.input.url = $f1b1811a0002602d$var$pathToFileURL$1$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    };
    _proto.fromOffset = function fromOffset(offset) {
        var lastLine, lineToIndex;
        if (!this[$f1b1811a0002602d$var$fromOffsetCache$1]) {
            var lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            var prevIndex = 0;
            for(var i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$f1b1811a0002602d$var$fromOffsetCache$1] = lineToIndex;
        } else lineToIndex = this[$f1b1811a0002602d$var$fromOffsetCache$1];
        lastLine = lineToIndex[lineToIndex.length - 1];
        var min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            var max = lineToIndex.length - 2;
            var mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    };
    _proto.mapResolve = function mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $f1b1811a0002602d$var$resolve$1$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    };
    _proto.origin = function origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        var consumer = this.map.consumer();
        var from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        var to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        var fromUrl;
        if ($f1b1811a0002602d$var$isAbsolute$1(from.source)) fromUrl = $f1b1811a0002602d$var$pathToFileURL$1$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $f1b1811a0002602d$var$pathToFileURL$1$1(this.map.mapFile));
        var result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($f1b1811a0002602d$var$fileURLToPath$1) result2.file = $f1b1811a0002602d$var$fileURLToPath$1(fromUrl);
            else throw new Error("file: protocol is not available in this PostCSS build");
        }
        var source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    };
    _proto.toJSON = function toJSON() {
        var json = {};
        for(var _i = 0, _iter = [
            "hasBOM",
            "css",
            "file",
            "id"
        ]; _i < _iter.length; _i++){
            var name = _iter[_i];
            if (this[name] != null) json[name] = this[name];
        }
        if (this.map) {
            json.map = $f1b1811a0002602d$var$_extends({}, this.map);
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    };
    $f1b1811a0002602d$var$_create_class(Input, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input;
}();
var $f1b1811a0002602d$var$input$1 = $f1b1811a0002602d$var$Input$4$1;
$f1b1811a0002602d$var$Input$4$1.default = $f1b1811a0002602d$var$Input$4$1;
if ($f1b1811a0002602d$var$terminalHighlight$2 && $f1b1811a0002602d$var$terminalHighlight$2.registerInput) $f1b1811a0002602d$var$terminalHighlight$2.registerInput($f1b1811a0002602d$var$Input$4$1);
var $f1b1811a0002602d$var$SourceMapConsumer$3 = $f1b1811a0002602d$var$require$$2$1.SourceMapConsumer, $f1b1811a0002602d$var$SourceMapGenerator$3 = $f1b1811a0002602d$var$require$$2$1.SourceMapGenerator;
var $f1b1811a0002602d$var$dirname$2 = $f1b1811a0002602d$var$require$$2$1.dirname, $f1b1811a0002602d$var$relative$1 = $f1b1811a0002602d$var$require$$2$1.relative, $f1b1811a0002602d$var$resolve$2 = $f1b1811a0002602d$var$require$$2$1.resolve, $f1b1811a0002602d$var$sep$1 = $f1b1811a0002602d$var$require$$2$1.sep;
var $f1b1811a0002602d$var$pathToFileURL$2 = $f1b1811a0002602d$var$require$$2$1.pathToFileURL;
var $f1b1811a0002602d$var$Input$3$1 = $f1b1811a0002602d$var$input$1;
var $f1b1811a0002602d$var$sourceMapAvailable$2 = Boolean($f1b1811a0002602d$var$SourceMapConsumer$3 && $f1b1811a0002602d$var$SourceMapGenerator$3);
var $f1b1811a0002602d$var$pathAvailable$2 = Boolean($f1b1811a0002602d$var$dirname$2 && $f1b1811a0002602d$var$resolve$2 && $f1b1811a0002602d$var$relative$1 && $f1b1811a0002602d$var$sep$1);
var $f1b1811a0002602d$var$MapGenerator$2$1 = /*#__PURE__*/ function() {
    function MapGenerator(stringify2, root2, opts, cssString) {
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    var _proto = MapGenerator.prototype;
    _proto.addAnnotation = function addAnnotation() {
        var content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        var eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    };
    _proto.applyPrevMaps = function applyPrevMaps() {
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(this.previous()), _step; !(_step = _iterator()).done;){
            var prev = _step.value;
            var from = this.toUrl(this.path(prev.file));
            var root2 = prev.root || $f1b1811a0002602d$var$dirname$2(prev.file);
            var map = void 0;
            if (this.mapOpts.sourcesContent === false) {
                map = new $f1b1811a0002602d$var$SourceMapConsumer$3(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    };
    _proto.clearAnnotation = function clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            var node2;
            for(var i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    };
    _proto.generate = function generate() {
        this.clearAnnotation();
        if ($f1b1811a0002602d$var$pathAvailable$2 && $f1b1811a0002602d$var$sourceMapAvailable$2 && this.isMap()) return this.generateMap();
        else {
            var result2 = "";
            this.stringify(this.root, function(i2) {
                result2 += i2;
            });
            return [
                result2
            ];
        }
    };
    _proto.generateMap = function generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            var prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $f1b1811a0002602d$var$SourceMapGenerator$3.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $f1b1811a0002602d$var$SourceMapGenerator$3({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    };
    _proto.generateString = function generateString() {
        var _this = this;
        this.css = "";
        this.map = new $f1b1811a0002602d$var$SourceMapGenerator$3({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        var line = 1;
        var column = 1;
        var noSource = "<no source>";
        var mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        var lines, last;
        this.stringify(this.root, function(str, node2, type) {
            _this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = _this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    _this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    _this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                var p = node2.parent || {
                    raws: {}
                };
                var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = _this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        _this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        _this.map.addMapping(mapping);
                    }
                }
            }
        });
    };
    _proto.isAnnotation = function isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.annotation;
        });
        return true;
    };
    _proto.isInline = function isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        var annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.inline;
        });
        return true;
    };
    _proto.isMap = function isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    };
    _proto.isSourcesContent = function isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.withContent();
        });
        return true;
    };
    _proto.outputFile = function outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    };
    _proto.path = function path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        var cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        var from = this.opts.to ? $f1b1811a0002602d$var$dirname$2(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $f1b1811a0002602d$var$dirname$2($f1b1811a0002602d$var$resolve$2(from, this.mapOpts.annotation));
        var path = $f1b1811a0002602d$var$relative$1(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    };
    _proto.previous = function previous() {
        var _this = this;
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk(function(node2) {
                if (node2.source && node2.source.input.map) {
                    var map = node2.source.input.map;
                    if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                }
            });
            else {
                var input2 = new $f1b1811a0002602d$var$Input$3$1(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    };
    _proto.setSourcesContent = function setSourcesContent() {
        var _this = this;
        var already = {};
        if (this.root) this.root.walk(function(node2) {
            if (node2.source) {
                var from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                    _this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    };
    _proto.sourcePath = function sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    };
    _proto.toBase64 = function toBase64(str) {
        if ($f1b1811a0002602d$require$Buffer) return $f1b1811a0002602d$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    };
    _proto.toFileUrl = function toFileUrl(path) {
        var cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($f1b1811a0002602d$var$pathToFileURL$2) {
            var fileURL = $f1b1811a0002602d$var$pathToFileURL$2(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    };
    _proto.toUrl = function toUrl(path) {
        var cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($f1b1811a0002602d$var$sep$1 === "\\") path = path.replace(/\\/g, "/");
        var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    };
    return MapGenerator;
}();
var $f1b1811a0002602d$var$mapGenerator$1 = $f1b1811a0002602d$var$MapGenerator$2$1;
var $f1b1811a0002602d$var$Node$2$1 = $f1b1811a0002602d$var$node$1;
var $f1b1811a0002602d$var$Comment$4$1 = /*#__PURE__*/ function(Node$2$1) {
    $f1b1811a0002602d$var$_inherits(Comment, Node$2$1);
    function Comment(defaults) {
        var _this;
        _this = Node$2$1.call(this, defaults) || this;
        _this.type = "comment";
        return _this;
    }
    return Comment;
}($f1b1811a0002602d$var$Node$2$1);
var $f1b1811a0002602d$var$comment$1 = $f1b1811a0002602d$var$Comment$4$1;
$f1b1811a0002602d$var$Comment$4$1.default = $f1b1811a0002602d$var$Comment$4$1;
var $f1b1811a0002602d$var$isClean$1$1 = $f1b1811a0002602d$var$symbols$1.isClean, $f1b1811a0002602d$var$my$1$1 = $f1b1811a0002602d$var$symbols$1.my;
var $f1b1811a0002602d$var$Declaration$3$1 = $f1b1811a0002602d$var$declaration$1;
var $f1b1811a0002602d$var$Comment$3$1 = $f1b1811a0002602d$var$comment$1;
var $f1b1811a0002602d$var$Node$1$1 = $f1b1811a0002602d$var$node$1;
var $f1b1811a0002602d$var$parse$4$1, $f1b1811a0002602d$var$Rule$4$1, $f1b1811a0002602d$var$AtRule$4$1, $f1b1811a0002602d$var$Root$6$1;
function $f1b1811a0002602d$var$cleanSource$1(nodes) {
    return nodes.map(function(i2) {
        if (i2.nodes) i2.nodes = $f1b1811a0002602d$var$cleanSource$1(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $f1b1811a0002602d$var$markDirtyUp$1(node2) {
    node2[$f1b1811a0002602d$var$isClean$1$1] = false;
    if (node2.proxyOf.nodes) for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(node2.proxyOf.nodes), _step; !(_step = _iterator()).done;){
        var i2 = _step.value;
        $f1b1811a0002602d$var$markDirtyUp$1(i2);
    }
}
var $f1b1811a0002602d$var$Container$7$1 = /*#__PURE__*/ function(Node$1$1) {
    $f1b1811a0002602d$var$_inherits(Container, Node$1$1);
    function Container() {
        return Node$1$1.apply(this, arguments) || this;
    }
    var _proto = Container.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.last);
            for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.push(node2);
            }
        }
        this.markDirty();
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        Node$1$1.prototype.cleanRaws.call(this, keepBetween);
        if (this.nodes) for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(this.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.cleanRaws(keepBetween);
        }
    };
    _proto.each = function each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        var iterator = this.getIterator();
        var index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    };
    _proto.every = function every(condition) {
        return this.nodes.every(condition);
    };
    _proto.getIterator = function getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        var iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _node2;
                    return (_node2 = node2)[prop].apply(_node2, [].concat(args.map(function(i2) {
                        if (typeof i2 === "function") return function(child, index2) {
                            return i2(child.toProxy(), index2);
                        };
                        else return i2;
                    })));
                };
                else if (prop === "every" || prop === "some") return function(cb) {
                    return node2[prop](function(child) {
                        for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)other[_key - 1] = arguments[_key];
                        return cb.apply(void 0, [].concat([
                            child.toProxy()
                        ], other));
                    });
                };
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else if (prop === "nodes") return node2.nodes.map(function(i2) {
                    return i2.toProxy();
                });
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    };
    _proto.insertAfter = function insertAfter(exist, add) {
        var existIndex = this.index(exist);
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.insertBefore = function insertBefore(exist, add) {
        var existIndex = this.index(exist);
        var type = existIndex === 0 ? "prepend" : false;
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.normalize = function normalize(nodes, sample) {
        var _this = this;
        if (typeof nodes === "string") nodes = $f1b1811a0002602d$var$cleanSource$1($f1b1811a0002602d$var$parse$4$1(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var i2 = _step.value;
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var i21 = _step1.value;
                if (i21.parent) i21.parent.removeChild(i21, "ignore");
            }
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $f1b1811a0002602d$var$Declaration$3$1(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $f1b1811a0002602d$var$Rule$4$1(nodes)
        ];
        else if (nodes.name) nodes = [
            new $f1b1811a0002602d$var$AtRule$4$1(nodes)
        ];
        else if (nodes.text) nodes = [
            new $f1b1811a0002602d$var$Comment$3$1(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        var processed = nodes.map(function(i2) {
            if (!i2[$f1b1811a0002602d$var$my$1$1]) Container.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$f1b1811a0002602d$var$isClean$1$1]) $f1b1811a0002602d$var$markDirtyUp$1(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = _this.proxyOf;
            return i2;
        });
        return processed;
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        children = children.reverse();
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.first, "prepend").reverse();
            for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.unshift(node2);
            }
            for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.push = function push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(this.proxyOf.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.parent = void 0;
        }
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    };
    _proto.replaceValues = function replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls(function(decl) {
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    };
    _proto.some = function some(condition) {
        return this.nodes.some(condition);
    };
    _proto.walk = function walk(callback) {
        return this.each(function(child, i2) {
            var result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    };
    _proto.walkAtRules = function walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk(function(child, i2) {
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if ($f1b1811a0002602d$var$_instanceof(name, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        return this.walk(function(child, i2) {
            if (child.type === "comment") return callback(child, i2);
        });
    };
    _proto.walkDecls = function walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk(function(child, i2) {
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if ($f1b1811a0002602d$var$_instanceof(prop, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    };
    _proto.walkRules = function walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk(function(child, i2) {
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if ($f1b1811a0002602d$var$_instanceof(selector, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    };
    $f1b1811a0002602d$var$_create_class(Container, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container;
}($f1b1811a0002602d$var$Node$1$1);
$f1b1811a0002602d$var$Container$7$1.registerParse = function(dependant) {
    $f1b1811a0002602d$var$parse$4$1 = dependant;
};
$f1b1811a0002602d$var$Container$7$1.registerRule = function(dependant) {
    $f1b1811a0002602d$var$Rule$4$1 = dependant;
};
$f1b1811a0002602d$var$Container$7$1.registerAtRule = function(dependant) {
    $f1b1811a0002602d$var$AtRule$4$1 = dependant;
};
$f1b1811a0002602d$var$Container$7$1.registerRoot = function(dependant) {
    $f1b1811a0002602d$var$Root$6$1 = dependant;
};
var $f1b1811a0002602d$var$container$1 = $f1b1811a0002602d$var$Container$7$1;
$f1b1811a0002602d$var$Container$7$1.default = $f1b1811a0002602d$var$Container$7$1;
$f1b1811a0002602d$var$Container$7$1.rebuild = function(node2) {
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $f1b1811a0002602d$var$AtRule$4$1.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $f1b1811a0002602d$var$Rule$4$1.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $f1b1811a0002602d$var$Declaration$3$1.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $f1b1811a0002602d$var$Comment$3$1.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $f1b1811a0002602d$var$Root$6$1.prototype);
    node2[$f1b1811a0002602d$var$my$1$1] = true;
    if (node2.nodes) node2.nodes.forEach(function(child) {
        $f1b1811a0002602d$var$Container$7$1.rebuild(child);
    });
};
var $f1b1811a0002602d$var$Container$6$1 = $f1b1811a0002602d$var$container$1;
var $f1b1811a0002602d$var$LazyResult$4$1, $f1b1811a0002602d$var$Processor$3$1;
var $f1b1811a0002602d$var$Document$3$1 = /*#__PURE__*/ function(Container$6$1) {
    $f1b1811a0002602d$var$_inherits(Document2, Container$6$1);
    function Document2(defaults) {
        var _this;
        _this = Container$6$1.call(this, $f1b1811a0002602d$var$_extends({
            type: "document"
        }, defaults)) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Document2.prototype;
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $f1b1811a0002602d$var$LazyResult$4$1(new $f1b1811a0002602d$var$Processor$3$1(), this, opts);
        return lazy.stringify();
    };
    return Document2;
}($f1b1811a0002602d$var$Container$6$1);
$f1b1811a0002602d$var$Document$3$1.registerLazyResult = function(dependant) {
    $f1b1811a0002602d$var$LazyResult$4$1 = dependant;
};
$f1b1811a0002602d$var$Document$3$1.registerProcessor = function(dependant) {
    $f1b1811a0002602d$var$Processor$3$1 = dependant;
};
var $f1b1811a0002602d$var$document$1$1 = $f1b1811a0002602d$var$Document$3$1;
$f1b1811a0002602d$var$Document$3$1.default = $f1b1811a0002602d$var$Document$3$1;
var $f1b1811a0002602d$var$printed$1 = {};
var $f1b1811a0002602d$var$warnOnce$2$1 = function warnOnce(message) {
    if ($f1b1811a0002602d$var$printed$1[message]) return;
    $f1b1811a0002602d$var$printed$1[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
var $f1b1811a0002602d$var$Warning$2$1 = /*#__PURE__*/ function() {
    function Warning(text, opts) {
        if (opts === void 0) opts = {};
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    var _proto = Warning.prototype;
    _proto.toString = function toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    };
    return Warning;
}();
var $f1b1811a0002602d$var$warning$1 = $f1b1811a0002602d$var$Warning$2$1;
$f1b1811a0002602d$var$Warning$2$1.default = $f1b1811a0002602d$var$Warning$2$1;
var $f1b1811a0002602d$var$Warning$1$1 = $f1b1811a0002602d$var$warning$1;
var $f1b1811a0002602d$var$Result$3$1 = /*#__PURE__*/ function() {
    function Result(processor2, root2, opts) {
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    var _proto = Result.prototype;
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.warn = function warn(text, opts) {
        if (opts === void 0) opts = {};
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        var warning2 = new $f1b1811a0002602d$var$Warning$1$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    };
    _proto.warnings = function warnings() {
        return this.messages.filter(function(i2) {
            return i2.type === "warning";
        });
    };
    $f1b1811a0002602d$var$_create_class(Result, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result;
}();
var $f1b1811a0002602d$var$result$1 = $f1b1811a0002602d$var$Result$3$1;
$f1b1811a0002602d$var$Result$3$1.default = $f1b1811a0002602d$var$Result$3$1;
var $f1b1811a0002602d$var$SINGLE_QUOTE$1 = "'".charCodeAt(0);
var $f1b1811a0002602d$var$DOUBLE_QUOTE$1 = '"'.charCodeAt(0);
var $f1b1811a0002602d$var$BACKSLASH$1 = "\\".charCodeAt(0);
var $f1b1811a0002602d$var$SLASH$1 = "/".charCodeAt(0);
var $f1b1811a0002602d$var$NEWLINE$1 = "\n".charCodeAt(0);
var $f1b1811a0002602d$var$SPACE$1 = " ".charCodeAt(0);
var $f1b1811a0002602d$var$FEED$1 = "\f".charCodeAt(0);
var $f1b1811a0002602d$var$TAB$1 = "	".charCodeAt(0);
var $f1b1811a0002602d$var$CR$1 = "\r".charCodeAt(0);
var $f1b1811a0002602d$var$OPEN_SQUARE$1 = "[".charCodeAt(0);
var $f1b1811a0002602d$var$CLOSE_SQUARE$1 = "]".charCodeAt(0);
var $f1b1811a0002602d$var$OPEN_PARENTHESES$1 = "(".charCodeAt(0);
var $f1b1811a0002602d$var$CLOSE_PARENTHESES$1 = ")".charCodeAt(0);
var $f1b1811a0002602d$var$OPEN_CURLY$1 = "{".charCodeAt(0);
var $f1b1811a0002602d$var$CLOSE_CURLY$1 = "}".charCodeAt(0);
var $f1b1811a0002602d$var$SEMICOLON$1 = ";".charCodeAt(0);
var $f1b1811a0002602d$var$ASTERISK$1 = "*".charCodeAt(0);
var $f1b1811a0002602d$var$COLON$1 = ":".charCodeAt(0);
var $f1b1811a0002602d$var$AT$1 = "@".charCodeAt(0);
var $f1b1811a0002602d$var$RE_AT_END$1 = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $f1b1811a0002602d$var$RE_WORD_END$1 = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $f1b1811a0002602d$var$RE_BAD_BRACKET$1 = /.[\r\n"'(/\\]/;
var $f1b1811a0002602d$var$RE_HEX_ESCAPE$1 = /[\da-f]/i;
var $f1b1811a0002602d$var$tokenize$1 = function tokenizer(input2, options) {
    if (options === void 0) options = {};
    var css = input2.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n2, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $f1b1811a0002602d$var$NEWLINE$1:
            case $f1b1811a0002602d$var$SPACE$1:
            case $f1b1811a0002602d$var$TAB$1:
            case $f1b1811a0002602d$var$CR$1:
            case $f1b1811a0002602d$var$FEED$1:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $f1b1811a0002602d$var$SPACE$1 || code === $f1b1811a0002602d$var$NEWLINE$1 || code === $f1b1811a0002602d$var$TAB$1 || code === $f1b1811a0002602d$var$CR$1 || code === $f1b1811a0002602d$var$FEED$1);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $f1b1811a0002602d$var$OPEN_SQUARE$1:
            case $f1b1811a0002602d$var$CLOSE_SQUARE$1:
            case $f1b1811a0002602d$var$OPEN_CURLY$1:
            case $f1b1811a0002602d$var$CLOSE_CURLY$1:
            case $f1b1811a0002602d$var$COLON$1:
            case $f1b1811a0002602d$var$SEMICOLON$1:
            case $f1b1811a0002602d$var$CLOSE_PARENTHESES$1:
                var controlChar = String.fromCharCode(code);
                currentToken = [
                    controlChar,
                    controlChar,
                    pos
                ];
                break;
            case $f1b1811a0002602d$var$OPEN_PARENTHESES$1:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $f1b1811a0002602d$var$SINGLE_QUOTE$1 && n2 !== $f1b1811a0002602d$var$DOUBLE_QUOTE$1 && n2 !== $f1b1811a0002602d$var$SPACE$1 && n2 !== $f1b1811a0002602d$var$NEWLINE$1 && n2 !== $f1b1811a0002602d$var$TAB$1 && n2 !== $f1b1811a0002602d$var$FEED$1 && n2 !== $f1b1811a0002602d$var$CR$1) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $f1b1811a0002602d$var$BACKSLASH$1){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $f1b1811a0002602d$var$RE_BAD_BRACKET$1.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $f1b1811a0002602d$var$SINGLE_QUOTE$1:
            case $f1b1811a0002602d$var$DOUBLE_QUOTE$1:
                quote = code === $f1b1811a0002602d$var$SINGLE_QUOTE$1 ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $f1b1811a0002602d$var$BACKSLASH$1){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $f1b1811a0002602d$var$AT$1:
                $f1b1811a0002602d$var$RE_AT_END$1.lastIndex = pos + 1;
                $f1b1811a0002602d$var$RE_AT_END$1.test(css);
                if ($f1b1811a0002602d$var$RE_AT_END$1.lastIndex === 0) next = css.length - 1;
                else next = $f1b1811a0002602d$var$RE_AT_END$1.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $f1b1811a0002602d$var$BACKSLASH$1:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $f1b1811a0002602d$var$BACKSLASH$1){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $f1b1811a0002602d$var$SLASH$1 && code !== $f1b1811a0002602d$var$SPACE$1 && code !== $f1b1811a0002602d$var$NEWLINE$1 && code !== $f1b1811a0002602d$var$TAB$1 && code !== $f1b1811a0002602d$var$CR$1 && code !== $f1b1811a0002602d$var$FEED$1) {
                    next += 1;
                    if ($f1b1811a0002602d$var$RE_HEX_ESCAPE$1.test(css.charAt(next))) {
                        while($f1b1811a0002602d$var$RE_HEX_ESCAPE$1.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $f1b1811a0002602d$var$SPACE$1) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $f1b1811a0002602d$var$SLASH$1 && css.charCodeAt(pos + 1) === $f1b1811a0002602d$var$ASTERISK$1) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $f1b1811a0002602d$var$RE_WORD_END$1.lastIndex = pos + 1;
                    $f1b1811a0002602d$var$RE_WORD_END$1.test(css);
                    if ($f1b1811a0002602d$var$RE_WORD_END$1.lastIndex === 0) next = css.length - 1;
                    else next = $f1b1811a0002602d$var$RE_WORD_END$1.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
var $f1b1811a0002602d$var$Container$5$1 = $f1b1811a0002602d$var$container$1;
var $f1b1811a0002602d$var$AtRule$3$1 = /*#__PURE__*/ function(Container$5$1) {
    $f1b1811a0002602d$var$_inherits(AtRule, Container$5$1);
    function AtRule(defaults) {
        var _this;
        _this = Container$5$1.call(this, defaults) || this;
        _this.type = "atrule";
        return _this;
    }
    var _proto = AtRule.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5$1_prototype_append;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5$1_prototype_append = Container$5$1.prototype.append).call.apply(_Container$5$1_prototype_append, [].concat([
            this
        ], children));
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5$1_prototype_prepend;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5$1_prototype_prepend = Container$5$1.prototype.prepend).call.apply(_Container$5$1_prototype_prepend, [].concat([
            this
        ], children));
    };
    return AtRule;
}($f1b1811a0002602d$var$Container$5$1);
var $f1b1811a0002602d$var$atRule$1 = $f1b1811a0002602d$var$AtRule$3$1;
$f1b1811a0002602d$var$AtRule$3$1.default = $f1b1811a0002602d$var$AtRule$3$1;
$f1b1811a0002602d$var$Container$5$1.registerAtRule($f1b1811a0002602d$var$AtRule$3$1);
var $f1b1811a0002602d$var$Container$4$1 = $f1b1811a0002602d$var$container$1;
var $f1b1811a0002602d$var$LazyResult$3$1, $f1b1811a0002602d$var$Processor$2$1;
var $f1b1811a0002602d$var$Root$5$1 = /*#__PURE__*/ function(Container$4$1) {
    $f1b1811a0002602d$var$_inherits(Root, Container$4$1);
    function Root(defaults) {
        var _this;
        _this = Container$4$1.call(this, defaults) || this;
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Root.prototype;
    _proto.normalize = function normalize(child, sample, type) {
        var nodes = Container$4$1.prototype.normalize.call(this, child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                node2.raws.before = sample.raws.before;
            }
        }
        return nodes;
    };
    _proto.removeChild = function removeChild(child, ignore) {
        var index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return Container$4$1.prototype.removeChild.call(this, child);
    };
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $f1b1811a0002602d$var$LazyResult$3$1(new $f1b1811a0002602d$var$Processor$2$1(), this, opts);
        return lazy.stringify();
    };
    return Root;
}($f1b1811a0002602d$var$Container$4$1);
$f1b1811a0002602d$var$Root$5$1.registerLazyResult = function(dependant) {
    $f1b1811a0002602d$var$LazyResult$3$1 = dependant;
};
$f1b1811a0002602d$var$Root$5$1.registerProcessor = function(dependant) {
    $f1b1811a0002602d$var$Processor$2$1 = dependant;
};
var $f1b1811a0002602d$var$root$1 = $f1b1811a0002602d$var$Root$5$1;
$f1b1811a0002602d$var$Root$5$1.default = $f1b1811a0002602d$var$Root$5$1;
$f1b1811a0002602d$var$Container$4$1.registerRoot($f1b1811a0002602d$var$Root$5$1);
var $f1b1811a0002602d$var$list$2$1 = {
    comma: function comma(string) {
        return $f1b1811a0002602d$var$list$2$1.split(string, [
            ","
        ], true);
    },
    space: function space(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $f1b1811a0002602d$var$list$2$1.split(string, spaces);
    },
    split: function split(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(string), _step; !(_step = _iterator()).done;){
            var letter = _step.value;
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $f1b1811a0002602d$var$list_1$1 = $f1b1811a0002602d$var$list$2$1;
$f1b1811a0002602d$var$list$2$1.default = $f1b1811a0002602d$var$list$2$1;
var $f1b1811a0002602d$var$Container$3$1 = $f1b1811a0002602d$var$container$1;
var $f1b1811a0002602d$var$list$1$1 = $f1b1811a0002602d$var$list_1$1;
var $f1b1811a0002602d$var$Rule$3$1 = /*#__PURE__*/ function(Container$3$1) {
    $f1b1811a0002602d$var$_inherits(Rule, Container$3$1);
    function Rule(defaults) {
        var _this;
        _this = Container$3$1.call(this, defaults) || this;
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    $f1b1811a0002602d$var$_create_class(Rule, [
        {
            key: "selectors",
            get: function get() {
                return $f1b1811a0002602d$var$list$1$1.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep2);
            }
        }
    ]);
    return Rule;
}($f1b1811a0002602d$var$Container$3$1);
var $f1b1811a0002602d$var$rule$1 = $f1b1811a0002602d$var$Rule$3$1;
$f1b1811a0002602d$var$Rule$3$1.default = $f1b1811a0002602d$var$Rule$3$1;
$f1b1811a0002602d$var$Container$3$1.registerRule($f1b1811a0002602d$var$Rule$3$1);
var $f1b1811a0002602d$var$Declaration$2$1 = $f1b1811a0002602d$var$declaration$1;
var $f1b1811a0002602d$var$tokenizer2$1 = $f1b1811a0002602d$var$tokenize$1;
var $f1b1811a0002602d$var$Comment$2$1 = $f1b1811a0002602d$var$comment$1;
var $f1b1811a0002602d$var$AtRule$2$1 = $f1b1811a0002602d$var$atRule$1;
var $f1b1811a0002602d$var$Root$4$1 = $f1b1811a0002602d$var$root$1;
var $f1b1811a0002602d$var$Rule$2$1 = $f1b1811a0002602d$var$rule$1;
var $f1b1811a0002602d$var$SAFE_COMMENT_NEIGHBOR$1 = {
    empty: true,
    space: true
};
function $f1b1811a0002602d$var$findLastWithPosition$1(tokens) {
    for(var i2 = tokens.length - 1; i2 >= 0; i2--){
        var token = tokens[i2];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $f1b1811a0002602d$var$Parser$1$1 = /*#__PURE__*/ function() {
    function Parser(input2) {
        this.input = input2;
        this.root = new $f1b1811a0002602d$var$Root$4$1();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    var _proto = Parser.prototype;
    _proto.atrule = function atrule(token) {
        var node2 = new $f1b1811a0002602d$var$AtRule$2$1();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        var type;
        var prev;
        var shift;
        var last = false;
        var open = false;
        var params = [];
        var brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    };
    _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
        var colon = this.colon(tokens);
        if (colon === false) return;
        var founded = 0;
        var token;
        for(var j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    };
    _proto.colon = function colon(tokens) {
        var brackets = 0;
        var token, type, prev;
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(tokens.entries()), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, i2 = _step_value[0], element = _step_value[1];
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    };
    _proto.comment = function comment(token) {
        var node2 = new $f1b1811a0002602d$var$Comment$2$1();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        var text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    };
    _proto.createTokenizer = function createTokenizer() {
        this.tokenizer = $f1b1811a0002602d$var$tokenizer2$1(this.input);
    };
    _proto.decl = function decl(tokens, customProperty) {
        var node2 = new $f1b1811a0002602d$var$Declaration$2$1();
        this.init(node2, tokens[0][2]);
        var last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $f1b1811a0002602d$var$findLastWithPosition$1(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            var type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        var token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        var firstSpaces = [];
        var next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(var i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                var string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                var cache = tokens.slice(0);
                var str = "";
                for(var j = i2; j > 0; j--){
                    var type1 = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        var hasWord = tokens.some(function(i2) {
            return i2[0] !== "space" && i2[0] !== "comment";
        });
        if (hasWord) {
            node2.raws.between += firstSpaces.map(function(i2) {
                return i2[1];
            }).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    };
    _proto.doubleColon = function doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    _proto.emptyRule = function emptyRule(token) {
        var node2 = new $f1b1811a0002602d$var$Rule$2$1();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    };
    _proto.end = function end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    };
    _proto.endFile = function endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    };
    _proto.freeSemicolon = function freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            var prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    };
    // Helpers
    _proto.getPosition = function getPosition(offset) {
        var pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    };
    _proto.init = function init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    };
    _proto.other = function other(start) {
        var end = false;
        var type = null;
        var colon = false;
        var bracket = null;
        var brackets = [];
        var customProperty = start[1].startsWith("--");
        var tokens = [];
        var token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    };
    _proto.parse = function parse() {
        var token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    };
    _proto.precheckMissedSemicolon = function precheckMissedSemicolon() {};
    _proto.raw = function raw(node2, prop, tokens, customProperty) {
        var token, type;
        var length = tokens.length;
        var value = "";
        var clean = true;
        var next, prev;
        for(var i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$f1b1811a0002602d$var$SAFE_COMMENT_NEIGHBOR$1[prev] && !$f1b1811a0002602d$var$SAFE_COMMENT_NEIGHBOR$1[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            var raw = tokens.reduce(function(all, i2) {
                return all + i2[1];
            }, "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    };
    _proto.rule = function rule(tokens) {
        tokens.pop();
        var node2 = new $f1b1811a0002602d$var$Rule$2$1();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    };
    _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    // Errors
    _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
        var next;
        var spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    };
    _proto.spacesFromEnd = function spacesFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    _proto.stringFrom = function stringFrom(tokens, from) {
        var result2 = "";
        for(var i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    };
    _proto.unclosedBlock = function unclosedBlock() {
        var pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    };
    _proto.unclosedBracket = function unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    };
    _proto.unexpectedClose = function unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    };
    _proto.unknownWord = function unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    };
    _proto.unnamedAtrule = function unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    return Parser;
}();
var $f1b1811a0002602d$var$parser$1 = $f1b1811a0002602d$var$Parser$1$1;
var $f1b1811a0002602d$var$Container$2$1 = $f1b1811a0002602d$var$container$1;
var $f1b1811a0002602d$var$Parser2$1 = $f1b1811a0002602d$var$parser$1;
var $f1b1811a0002602d$var$Input$2$1 = $f1b1811a0002602d$var$input$1;
function $f1b1811a0002602d$var$parse$3$1(css, opts) {
    var input2 = new $f1b1811a0002602d$var$Input$2$1(css, opts);
    var parser2 = new $f1b1811a0002602d$var$Parser2$1(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $f1b1811a0002602d$var$parse_1$1 = $f1b1811a0002602d$var$parse$3$1;
$f1b1811a0002602d$var$parse$3$1.default = $f1b1811a0002602d$var$parse$3$1;
$f1b1811a0002602d$var$Container$2$1.registerParse($f1b1811a0002602d$var$parse$3$1);
var $f1b1811a0002602d$var$isClean$3 = $f1b1811a0002602d$var$symbols$1.isClean, $f1b1811a0002602d$var$my$3 = $f1b1811a0002602d$var$symbols$1.my;
var $f1b1811a0002602d$var$MapGenerator$1$1 = $f1b1811a0002602d$var$mapGenerator$1;
var $f1b1811a0002602d$var$stringify$2$1 = $f1b1811a0002602d$var$stringify_1$1;
var $f1b1811a0002602d$var$Container$1$1 = $f1b1811a0002602d$var$container$1;
var $f1b1811a0002602d$var$Document$2$1 = $f1b1811a0002602d$var$document$1$1;
var $f1b1811a0002602d$var$warnOnce$1$1 = $f1b1811a0002602d$var$warnOnce$2$1;
var $f1b1811a0002602d$var$Result$2$1 = $f1b1811a0002602d$var$result$1;
var $f1b1811a0002602d$var$parse$2$1 = $f1b1811a0002602d$var$parse_1$1;
var $f1b1811a0002602d$var$Root$3$1 = $f1b1811a0002602d$var$root$1;
var $f1b1811a0002602d$var$TYPE_TO_CLASS_NAME$1 = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $f1b1811a0002602d$var$PLUGIN_PROPS$1 = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $f1b1811a0002602d$var$NOT_VISITORS$1 = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $f1b1811a0002602d$var$CHILDREN$1 = 0;
function $f1b1811a0002602d$var$isPromise$1(obj) {
    return (typeof obj === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(obj)) === "object" && typeof obj.then === "function";
}
function $f1b1811a0002602d$var$getEvents$1(node2) {
    var key = false;
    var type = $f1b1811a0002602d$var$TYPE_TO_CLASS_NAME$1[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $f1b1811a0002602d$var$CHILDREN$1,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $f1b1811a0002602d$var$CHILDREN$1,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $f1b1811a0002602d$var$toStack$1(node2) {
    var events;
    if (node2.type === "document") events = [
        "Document",
        $f1b1811a0002602d$var$CHILDREN$1,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $f1b1811a0002602d$var$CHILDREN$1,
        "RootExit"
    ];
    else events = $f1b1811a0002602d$var$getEvents$1(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $f1b1811a0002602d$var$cleanMarks$1(node2) {
    node2[$f1b1811a0002602d$var$isClean$3] = false;
    if (node2.nodes) node2.nodes.forEach(function(i2) {
        return $f1b1811a0002602d$var$cleanMarks$1(i2);
    });
    return node2;
}
var $f1b1811a0002602d$var$postcss$2$1 = {};
var $f1b1811a0002602d$var$LazyResult$2$1 = /*#__PURE__*/ function() {
    function LazyResult(processor2, css, opts) {
        var _this = this;
        this.stringified = false;
        this.processed = false;
        var root2;
        if ((typeof css === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(css)) === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $f1b1811a0002602d$var$cleanMarks$1(css);
        else if ($f1b1811a0002602d$var$_instanceof(css, LazyResult) || $f1b1811a0002602d$var$_instanceof(css, $f1b1811a0002602d$var$Result$2$1)) {
            root2 = $f1b1811a0002602d$var$cleanMarks$1(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser2 = $f1b1811a0002602d$var$parse$2$1;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$f1b1811a0002602d$var$my$3]) $f1b1811a0002602d$var$Container$1$1.rebuild(root2);
        }
        this.result = new $f1b1811a0002602d$var$Result$2$1(processor2, root2, opts);
        this.helpers = $f1b1811a0002602d$var$_extends({}, $f1b1811a0002602d$var$postcss$2$1, {
            postcss: $f1b1811a0002602d$var$postcss$2$1,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin22) {
            if ((typeof plugin22 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(plugin22)) === "object" && plugin22.prepare) return $f1b1811a0002602d$var$_extends({}, plugin22, plugin22.prepare(_this.result));
            else return plugin22;
        });
    }
    var _proto = LazyResult.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.getAsyncError = function getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    };
    _proto.handleError = function handleError(error, node2) {
        var plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) var pluginName, pluginVer, runtimeVer, a2, b;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    };
    _proto.prepareVisitors = function prepareVisitors() {
        var _this = this;
        this.listeners = {};
        var add = function(plugin22, type, cb) {
            if (!_this.listeners[type]) _this.listeners[type] = [];
            _this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            if ((typeof plugin22 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(plugin22)) === "object") for(var event in plugin22){
                if (!$f1b1811a0002602d$var$PLUGIN_PROPS$1[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event " + event + " in " + plugin22.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
                if (!$f1b1811a0002602d$var$NOT_VISITORS$1[event]) {
                    if ($f1b1811a0002602d$var$_type_of(plugin22[event]) === "object") {
                        for(var filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    };
    _proto.runAsync = function runAsync() {
        var _this = this;
        return $f1b1811a0002602d$var$_async_to_generator(function() {
            var i2, plugin22, promise, error, root2, stack, promise1, e2, node2, _loop, _iterator, _step;
            return $f1b1811a0002602d$var$_ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.plugin = 0;
                        i2 = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i2 < _this.plugins.length)) return [
                            3,
                            6
                        ];
                        plugin22 = _this.plugins[i2];
                        promise = _this.runOnRoot(plugin22);
                        if (!$f1b1811a0002602d$var$isPromise$1(promise)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        throw _this.handleError(error);
                    case 5:
                        i2++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this.prepareVisitors();
                        if (!_this.hasListener) return [
                            3,
                            18
                        ];
                        root2 = _this.result.root;
                        _state.label = 7;
                    case 7:
                        if (!!root2[$f1b1811a0002602d$var$isClean$3]) return [
                            3,
                            14
                        ];
                        root2[$f1b1811a0002602d$var$isClean$3] = true;
                        stack = [
                            $f1b1811a0002602d$var$toStack$1(root2)
                        ];
                        _state.label = 8;
                    case 8:
                        if (!(stack.length > 0)) return [
                            3,
                            13
                        ];
                        promise1 = _this.visitTick(stack);
                        if (!$f1b1811a0002602d$var$isPromise$1(promise1)) return [
                            3,
                            12
                        ];
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            promise1
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        node2 = stack[stack.length - 1].node;
                        throw _this.handleError(e2, node2);
                    case 12:
                        return [
                            3,
                            8
                        ];
                    case 13:
                        return [
                            3,
                            7
                        ];
                    case 14:
                        if (!_this.listeners.OnceExit) return [
                            3,
                            18
                        ];
                        _loop = function() {
                            var _step_value, plugin22, visitor, roots, e2;
                            return $f1b1811a0002602d$var$_ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
                                        _this.result.lastPlugin = plugin22;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(root2.type === "document")) return [
                                            3,
                                            3
                                        ];
                                        roots = root2.nodes.map(function(subRoot) {
                                            return visitor(subRoot, _this.helpers);
                                        });
                                        return [
                                            4,
                                            Promise.all(roots)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            visitor(root2, _this.helpers)
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        e2 = _state.sent();
                                        throw _this.handleError(e2);
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(_this.listeners.OnceExit);
                        _state.label = 15;
                    case 15:
                        if (!!(_step = _iterator()).done) return [
                            3,
                            18
                        ];
                        return [
                            5,
                            $f1b1811a0002602d$var$_ts_values(_loop())
                        ];
                    case 16:
                        _state.sent();
                        _state.label = 17;
                    case 17:
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _this.processed = true;
                        return [
                            2,
                            _this.stringify()
                        ];
                }
            });
        })();
    };
    _proto.runOnRoot = function runOnRoot(plugin22) {
        var _this = this;
        this.result.lastPlugin = plugin22;
        try {
            if ((typeof plugin22 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(plugin22)) === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    var roots = this.result.root.nodes.map(function(root2) {
                        return plugin22.Once(root2, _this.helpers);
                    });
                    if ($f1b1811a0002602d$var$isPromise$1(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    };
    _proto.stringify = function stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        var opts = this.result.opts;
        var str = $f1b1811a0002602d$var$stringify$2$1;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        var map = new $f1b1811a0002602d$var$MapGenerator$1$1(str, this.result.root, this.result.opts);
        var data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            var promise = this.runOnRoot(plugin22);
            if ($f1b1811a0002602d$var$isPromise$1(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            var root2 = this.result.root;
            while(!root2[$f1b1811a0002602d$var$isClean$3]){
                root2[$f1b1811a0002602d$var$isClean$3] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(root2.nodes), _step1; !(_step1 = _iterator1()).done;){
                    var subRoot = _step1.value;
                    this.visitSync(this.listeners.OnceExit, subRoot);
                }
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.visitSync = function visitSync(visitors, node2) {
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(visitors), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
            this.result.lastPlugin = plugin22;
            var promise = void 0;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($f1b1811a0002602d$var$isPromise$1(promise)) throw this.getAsyncError();
        }
    };
    _proto.visitTick = function visitTick(stack) {
        var visit2 = stack[stack.length - 1];
        var node2 = visit2.node, visitors = visit2.visitors;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            var _visitors_visit2_visitorIndex = visitors[visit2.visitorIndex], plugin22 = _visitors_visit2_visitorIndex[0], visitor = _visitors_visit2_visitorIndex[1];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            var iterator = visit2.iterator;
            var child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$f1b1811a0002602d$var$isClean$3]) {
                    child[$f1b1811a0002602d$var$isClean$3] = true;
                    stack.push($f1b1811a0002602d$var$toStack$1(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        var events = visit2.events;
        while(visit2.eventIndex < events.length){
            var event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $f1b1811a0002602d$var$CHILDREN$1) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$f1b1811a0002602d$var$isClean$3] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    };
    _proto.walkSync = function walkSync(node2) {
        var _this = this;
        node2[$f1b1811a0002602d$var$isClean$3] = true;
        var events = $f1b1811a0002602d$var$getEvents$1(node2);
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(events), _step; !(_step = _iterator()).done;){
            var event = _step.value;
            if (event === $f1b1811a0002602d$var$CHILDREN$1) {
                if (node2.nodes) node2.each(function(child) {
                    if (!child[$f1b1811a0002602d$var$isClean$3]) _this.walkSync(child);
                });
            } else {
                var visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    };
    _proto.warnings = function warnings() {
        return this.sync().warnings();
    };
    $f1b1811a0002602d$var$_create_class(LazyResult, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult;
}();
$f1b1811a0002602d$var$LazyResult$2$1.registerPostcss = function(dependant) {
    $f1b1811a0002602d$var$postcss$2$1 = dependant;
};
var $f1b1811a0002602d$var$lazyResult$1 = $f1b1811a0002602d$var$LazyResult$2$1;
$f1b1811a0002602d$var$LazyResult$2$1.default = $f1b1811a0002602d$var$LazyResult$2$1;
$f1b1811a0002602d$var$Root$3$1.registerLazyResult($f1b1811a0002602d$var$LazyResult$2$1);
$f1b1811a0002602d$var$Document$2$1.registerLazyResult($f1b1811a0002602d$var$LazyResult$2$1);
var $f1b1811a0002602d$var$MapGenerator2$1 = $f1b1811a0002602d$var$mapGenerator$1;
var $f1b1811a0002602d$var$stringify$1$1 = $f1b1811a0002602d$var$stringify_1$1;
var $f1b1811a0002602d$var$warnOnce2$1 = $f1b1811a0002602d$var$warnOnce$2$1;
var $f1b1811a0002602d$var$parse$1$1 = $f1b1811a0002602d$var$parse_1$1;
var $f1b1811a0002602d$var$Result$1$1 = $f1b1811a0002602d$var$result$1;
var $f1b1811a0002602d$var$NoWorkResult$1$1 = /*#__PURE__*/ function() {
    function NoWorkResult(processor2, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        var root2;
        var str = $f1b1811a0002602d$var$stringify$1$1;
        this.result = new $f1b1811a0002602d$var$Result$1$1(this._processor, root2, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function get() {
                return self.root;
            }
        });
        var map = new $f1b1811a0002602d$var$MapGenerator2$1(str, root2, this._opts, css);
        if (map.isMap()) {
            var _map_generate = map.generate(), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    var _proto = NoWorkResult.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this._css;
    };
    _proto.warnings = function warnings() {
        return [];
    };
    $f1b1811a0002602d$var$_create_class(NoWorkResult, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root2;
                var parser2 = $f1b1811a0002602d$var$parse$1$1;
                try {
                    root2 = parser2(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root2;
                    return root2;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult;
}();
var $f1b1811a0002602d$var$noWorkResult$1 = $f1b1811a0002602d$var$NoWorkResult$1$1;
$f1b1811a0002602d$var$NoWorkResult$1$1.default = $f1b1811a0002602d$var$NoWorkResult$1$1;
var $f1b1811a0002602d$var$NoWorkResult2$1 = $f1b1811a0002602d$var$noWorkResult$1;
var $f1b1811a0002602d$var$LazyResult$1$1 = $f1b1811a0002602d$var$lazyResult$1;
var $f1b1811a0002602d$var$Document$1$1 = $f1b1811a0002602d$var$document$1$1;
var $f1b1811a0002602d$var$Root$2$1 = $f1b1811a0002602d$var$root$1;
var $f1b1811a0002602d$var$Processor$1$1 = /*#__PURE__*/ function() {
    function Processor(plugins) {
        if (plugins === void 0) plugins = [];
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    var _proto = Processor.prototype;
    _proto.normalize = function normalize(plugins) {
        var normalized = [];
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(plugins), _step; !(_step = _iterator()).done;){
            var i2 = _step.value;
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if ((typeof i2 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(i2)) === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if ((typeof i2 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(i2)) === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if ((typeof i2 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(i2)) === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    };
    _proto.process = function process1(css, opts) {
        if (opts === void 0) opts = {};
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $f1b1811a0002602d$var$NoWorkResult2$1(this, css, opts);
        else return new $f1b1811a0002602d$var$LazyResult$1$1(this, css, opts);
    };
    _proto.use = function use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    };
    return Processor;
}();
var $f1b1811a0002602d$var$processor$1 = $f1b1811a0002602d$var$Processor$1$1;
$f1b1811a0002602d$var$Processor$1$1.default = $f1b1811a0002602d$var$Processor$1$1;
$f1b1811a0002602d$var$Root$2$1.registerProcessor($f1b1811a0002602d$var$Processor$1$1);
$f1b1811a0002602d$var$Document$1$1.registerProcessor($f1b1811a0002602d$var$Processor$1$1);
var $f1b1811a0002602d$var$Declaration$1$1 = $f1b1811a0002602d$var$declaration$1;
var $f1b1811a0002602d$var$PreviousMap2$1 = $f1b1811a0002602d$var$previousMap$1;
var $f1b1811a0002602d$var$Comment$1$1 = $f1b1811a0002602d$var$comment$1;
var $f1b1811a0002602d$var$AtRule$1$1 = $f1b1811a0002602d$var$atRule$1;
var $f1b1811a0002602d$var$Input$1$1 = $f1b1811a0002602d$var$input$1;
var $f1b1811a0002602d$var$Root$1$1 = $f1b1811a0002602d$var$root$1;
var $f1b1811a0002602d$var$Rule$1$1 = $f1b1811a0002602d$var$rule$1;
function $f1b1811a0002602d$var$fromJSON$1$1(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n2) {
        return $f1b1811a0002602d$var$fromJSON$1$1(n2);
    });
    var ownInputs = json.inputs, defaults = $f1b1811a0002602d$var$_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(ownInputs), _step; !(_step = _iterator()).done;){
            var input2 = _step.value;
            var inputHydrated = $f1b1811a0002602d$var$_extends({}, input2, {
                __proto__: $f1b1811a0002602d$var$Input$1$1.prototype
            });
            if (inputHydrated.map) inputHydrated.map = $f1b1811a0002602d$var$_extends({}, inputHydrated.map, {
                __proto__: $f1b1811a0002602d$var$PreviousMap2$1.prototype
            });
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n2) {
        return $f1b1811a0002602d$var$fromJSON$1$1(n2, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = $f1b1811a0002602d$var$_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $f1b1811a0002602d$var$Root$1$1(defaults);
    else if (defaults.type === "decl") return new $f1b1811a0002602d$var$Declaration$1$1(defaults);
    else if (defaults.type === "rule") return new $f1b1811a0002602d$var$Rule$1$1(defaults);
    else if (defaults.type === "comment") return new $f1b1811a0002602d$var$Comment$1$1(defaults);
    else if (defaults.type === "atrule") return new $f1b1811a0002602d$var$AtRule$1$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $f1b1811a0002602d$var$fromJSON_1$1 = $f1b1811a0002602d$var$fromJSON$1$1;
$f1b1811a0002602d$var$fromJSON$1$1.default = $f1b1811a0002602d$var$fromJSON$1$1;
var $f1b1811a0002602d$var$CssSyntaxError2$1 = $f1b1811a0002602d$var$cssSyntaxError$1;
var $f1b1811a0002602d$var$Declaration2$1 = $f1b1811a0002602d$var$declaration$1;
var $f1b1811a0002602d$var$LazyResult2$1 = $f1b1811a0002602d$var$lazyResult$1;
var $f1b1811a0002602d$var$Container2$1 = $f1b1811a0002602d$var$container$1;
var $f1b1811a0002602d$var$Processor2$1 = $f1b1811a0002602d$var$processor$1;
var $f1b1811a0002602d$var$stringify$5 = $f1b1811a0002602d$var$stringify_1$1;
var $f1b1811a0002602d$var$fromJSON$2 = $f1b1811a0002602d$var$fromJSON_1$1;
var $f1b1811a0002602d$var$Document22 = $f1b1811a0002602d$var$document$1$1;
var $f1b1811a0002602d$var$Warning2$1 = $f1b1811a0002602d$var$warning$1;
var $f1b1811a0002602d$var$Comment2$1 = $f1b1811a0002602d$var$comment$1;
var $f1b1811a0002602d$var$AtRule2$1 = $f1b1811a0002602d$var$atRule$1;
var $f1b1811a0002602d$var$Result2$1 = $f1b1811a0002602d$var$result$1;
var $f1b1811a0002602d$var$Input2$1 = $f1b1811a0002602d$var$input$1;
var $f1b1811a0002602d$var$parse$5 = $f1b1811a0002602d$var$parse_1$1;
var $f1b1811a0002602d$var$list$3 = $f1b1811a0002602d$var$list_1$1;
var $f1b1811a0002602d$var$Rule2$1 = $f1b1811a0002602d$var$rule$1;
var $f1b1811a0002602d$var$Root2$1 = $f1b1811a0002602d$var$root$1;
var $f1b1811a0002602d$var$Node2$1 = $f1b1811a0002602d$var$node$1;
function $f1b1811a0002602d$var$postcss$3() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $f1b1811a0002602d$var$Processor2$1(plugins);
}
$f1b1811a0002602d$var$postcss$3.plugin = function plugin(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, [].concat(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $f1b1811a0002602d$var$Processor2$1().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function get() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $f1b1811a0002602d$var$postcss$3([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$f1b1811a0002602d$var$postcss$3.stringify = $f1b1811a0002602d$var$stringify$5;
$f1b1811a0002602d$var$postcss$3.parse = $f1b1811a0002602d$var$parse$5;
$f1b1811a0002602d$var$postcss$3.fromJSON = $f1b1811a0002602d$var$fromJSON$2;
$f1b1811a0002602d$var$postcss$3.list = $f1b1811a0002602d$var$list$3;
$f1b1811a0002602d$var$postcss$3.comment = function(defaults) {
    return new $f1b1811a0002602d$var$Comment2$1(defaults);
};
$f1b1811a0002602d$var$postcss$3.atRule = function(defaults) {
    return new $f1b1811a0002602d$var$AtRule2$1(defaults);
};
$f1b1811a0002602d$var$postcss$3.decl = function(defaults) {
    return new $f1b1811a0002602d$var$Declaration2$1(defaults);
};
$f1b1811a0002602d$var$postcss$3.rule = function(defaults) {
    return new $f1b1811a0002602d$var$Rule2$1(defaults);
};
$f1b1811a0002602d$var$postcss$3.root = function(defaults) {
    return new $f1b1811a0002602d$var$Root2$1(defaults);
};
$f1b1811a0002602d$var$postcss$3.document = function(defaults) {
    return new $f1b1811a0002602d$var$Document22(defaults);
};
$f1b1811a0002602d$var$postcss$3.CssSyntaxError = $f1b1811a0002602d$var$CssSyntaxError2$1;
$f1b1811a0002602d$var$postcss$3.Declaration = $f1b1811a0002602d$var$Declaration2$1;
$f1b1811a0002602d$var$postcss$3.Container = $f1b1811a0002602d$var$Container2$1;
$f1b1811a0002602d$var$postcss$3.Processor = $f1b1811a0002602d$var$Processor2$1;
$f1b1811a0002602d$var$postcss$3.Document = $f1b1811a0002602d$var$Document22;
$f1b1811a0002602d$var$postcss$3.Comment = $f1b1811a0002602d$var$Comment2$1;
$f1b1811a0002602d$var$postcss$3.Warning = $f1b1811a0002602d$var$Warning2$1;
$f1b1811a0002602d$var$postcss$3.AtRule = $f1b1811a0002602d$var$AtRule2$1;
$f1b1811a0002602d$var$postcss$3.Result = $f1b1811a0002602d$var$Result2$1;
$f1b1811a0002602d$var$postcss$3.Input = $f1b1811a0002602d$var$Input2$1;
$f1b1811a0002602d$var$postcss$3.Rule = $f1b1811a0002602d$var$Rule2$1;
$f1b1811a0002602d$var$postcss$3.Root = $f1b1811a0002602d$var$Root2$1;
$f1b1811a0002602d$var$postcss$3.Node = $f1b1811a0002602d$var$Node2$1;
$f1b1811a0002602d$var$LazyResult2$1.registerPostcss($f1b1811a0002602d$var$postcss$3);
var $f1b1811a0002602d$var$postcss_1$1 = $f1b1811a0002602d$var$postcss$3;
$f1b1811a0002602d$var$postcss$3.default = $f1b1811a0002602d$var$postcss$3;
var $f1b1811a0002602d$var$postcss$1$1 = /* @__PURE__ */ $f1b1811a0002602d$var$getDefaultExportFromCjs$1($f1b1811a0002602d$var$postcss_1$1);
$f1b1811a0002602d$var$postcss$1$1.stringify;
$f1b1811a0002602d$var$postcss$1$1.fromJSON;
$f1b1811a0002602d$var$postcss$1$1.plugin;
$f1b1811a0002602d$var$postcss$1$1.parse;
$f1b1811a0002602d$var$postcss$1$1.list;
$f1b1811a0002602d$var$postcss$1$1.document;
$f1b1811a0002602d$var$postcss$1$1.comment;
$f1b1811a0002602d$var$postcss$1$1.atRule;
$f1b1811a0002602d$var$postcss$1$1.rule;
$f1b1811a0002602d$var$postcss$1$1.decl;
$f1b1811a0002602d$var$postcss$1$1.root;
$f1b1811a0002602d$var$postcss$1$1.CssSyntaxError;
$f1b1811a0002602d$var$postcss$1$1.Declaration;
$f1b1811a0002602d$var$postcss$1$1.Container;
$f1b1811a0002602d$var$postcss$1$1.Processor;
$f1b1811a0002602d$var$postcss$1$1.Document;
$f1b1811a0002602d$var$postcss$1$1.Comment;
$f1b1811a0002602d$var$postcss$1$1.Warning;
$f1b1811a0002602d$var$postcss$1$1.AtRule;
$f1b1811a0002602d$var$postcss$1$1.Result;
$f1b1811a0002602d$var$postcss$1$1.Input;
$f1b1811a0002602d$var$postcss$1$1.Rule;
$f1b1811a0002602d$var$postcss$1$1.Root;
$f1b1811a0002602d$var$postcss$1$1.Node;
var $f1b1811a0002602d$var$__defProp2 = Object.defineProperty;
var $f1b1811a0002602d$var$__defNormalProp2 = function(obj, key, value) {
    return key in obj ? $f1b1811a0002602d$var$__defProp2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $f1b1811a0002602d$var$__publicField2 = function(obj, key, value) {
    return $f1b1811a0002602d$var$__defNormalProp2(obj, (typeof key === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(key)) !== "symbol" ? key + "" : key, value);
};
function $f1b1811a0002602d$var$getDefaultExportFromCjs(x2) {
    return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function $f1b1811a0002602d$var$getAugmentedNamespace(n2) {
    if (n2.__esModule) return n2;
    var f2 = n2.default;
    if (typeof f2 == "function") {
        var a2 = function a22() {
            if ($f1b1811a0002602d$var$_instanceof(this, a22)) return Reflect.construct(f2, arguments, this.constructor);
            return f2.apply(this, arguments);
        };
        a2.prototype = f2.prototype;
    } else a2 = {};
    Object.defineProperty(a2, "__esModule", {
        value: true
    });
    Object.keys(n2).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n2, k);
        Object.defineProperty(a2, k, d.get ? d : {
            enumerable: true,
            get: function get() {
                return n2[k];
            }
        });
    });
    return a2;
}
var $f1b1811a0002602d$var$picocolors_browser = {
    exports: {}
};
var $f1b1811a0002602d$var$x = String;
var $f1b1811a0002602d$var$create = function create() {
    return {
        isColorSupported: false,
        reset: $f1b1811a0002602d$var$x,
        bold: $f1b1811a0002602d$var$x,
        dim: $f1b1811a0002602d$var$x,
        italic: $f1b1811a0002602d$var$x,
        underline: $f1b1811a0002602d$var$x,
        inverse: $f1b1811a0002602d$var$x,
        hidden: $f1b1811a0002602d$var$x,
        strikethrough: $f1b1811a0002602d$var$x,
        black: $f1b1811a0002602d$var$x,
        red: $f1b1811a0002602d$var$x,
        green: $f1b1811a0002602d$var$x,
        yellow: $f1b1811a0002602d$var$x,
        blue: $f1b1811a0002602d$var$x,
        magenta: $f1b1811a0002602d$var$x,
        cyan: $f1b1811a0002602d$var$x,
        white: $f1b1811a0002602d$var$x,
        gray: $f1b1811a0002602d$var$x,
        bgBlack: $f1b1811a0002602d$var$x,
        bgRed: $f1b1811a0002602d$var$x,
        bgGreen: $f1b1811a0002602d$var$x,
        bgYellow: $f1b1811a0002602d$var$x,
        bgBlue: $f1b1811a0002602d$var$x,
        bgMagenta: $f1b1811a0002602d$var$x,
        bgCyan: $f1b1811a0002602d$var$x,
        bgWhite: $f1b1811a0002602d$var$x
    };
};
$f1b1811a0002602d$var$picocolors_browser.exports = $f1b1811a0002602d$var$create();
$f1b1811a0002602d$var$picocolors_browser.exports.createColors = $f1b1811a0002602d$var$create;
var $f1b1811a0002602d$var$picocolors_browserExports = $f1b1811a0002602d$var$picocolors_browser.exports;
var $f1b1811a0002602d$var$__viteBrowserExternal = {};
var $f1b1811a0002602d$var$__viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $f1b1811a0002602d$var$__viteBrowserExternal
}, Symbol.toStringTag, {
    value: "Module"
}));
var $f1b1811a0002602d$var$require$$2 = /* @__PURE__ */ $f1b1811a0002602d$var$getAugmentedNamespace($f1b1811a0002602d$var$__viteBrowserExternal$1);
var $f1b1811a0002602d$var$pico = $f1b1811a0002602d$var$picocolors_browserExports;
var $f1b1811a0002602d$var$terminalHighlight$1 = $f1b1811a0002602d$var$require$$2;
var $f1b1811a0002602d$var$CssSyntaxError$3 = /*#__PURE__*/ function(Error1) {
    $f1b1811a0002602d$var$_inherits(CssSyntaxError2, Error1);
    function CssSyntaxError2(message, line, column, source, file, plugin22) {
        var _this;
        _this = Error1.call(this, message) || this;
        _this.name = "CssSyntaxError";
        _this.reason = message;
        if (file) _this.file = file;
        if (source) _this.source = source;
        if (plugin22) _this.plugin = plugin22;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                _this.line = line;
                _this.column = column;
            } else {
                _this.line = line.line;
                _this.column = line.column;
                _this.endLine = column.line;
                _this.endColumn = column.column;
            }
        }
        _this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(_this, CssSyntaxError2);
        return _this;
    }
    var _proto = CssSyntaxError2.prototype;
    _proto.setMessage = function setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    };
    _proto.showSourceCode = function showSourceCode(color) {
        var _this = this;
        if (!this.source) return "";
        var css = this.source;
        if (color == null) color = $f1b1811a0002602d$var$pico.isColorSupported;
        if ($f1b1811a0002602d$var$terminalHighlight$1) {
            if (color) css = $f1b1811a0002602d$var$terminalHighlight$1(css);
        }
        var lines = css.split(/\r?\n/);
        var start = Math.max(this.line - 3, 0);
        var end = Math.min(this.line + 2, lines.length);
        var maxWidth = String(end).length;
        var mark, aside;
        if (color) {
            var _pico_createColors = $f1b1811a0002602d$var$pico.createColors(true), bold = _pico_createColors.bold, gray = _pico_createColors.gray, red = _pico_createColors.red;
            mark = function(text) {
                return bold(red(text));
            };
            aside = function(text) {
                return gray(text);
            };
        } else mark = aside = function(str) {
            return str;
        };
        return lines.slice(start, end).map(function(line, index2) {
            var number = start + 1 + index2;
            var gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === _this.line) {
                var spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, _this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    };
    _proto.toString = function toString() {
        var code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    };
    return CssSyntaxError2;
}($f1b1811a0002602d$var$_wrap_native_super(Error));
var $f1b1811a0002602d$var$cssSyntaxError = $f1b1811a0002602d$var$CssSyntaxError$3;
$f1b1811a0002602d$var$CssSyntaxError$3.default = $f1b1811a0002602d$var$CssSyntaxError$3;
var $f1b1811a0002602d$var$symbols = {};
$f1b1811a0002602d$var$symbols.isClean = Symbol("isClean");
$f1b1811a0002602d$var$symbols.my = Symbol("my");
var $f1b1811a0002602d$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $f1b1811a0002602d$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
var $f1b1811a0002602d$var$Stringifier$2 = /*#__PURE__*/ function() {
    function Stringifier2(builder) {
        this.builder = builder;
    }
    var _proto = Stringifier2.prototype;
    _proto.atrule = function atrule(node2, semicolon) {
        var name = "@" + node2.name;
        var params = node2.params ? this.rawValue(node2, "params") : "";
        if (typeof node2.raws.afterName !== "undefined") name += node2.raws.afterName;
        else if (params) name += " ";
        if (node2.nodes) this.block(node2, name + params);
        else {
            var end = (node2.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node2);
        }
    };
    _proto.beforeAfter = function beforeAfter(node2, detect) {
        var value;
        if (node2.type === "decl") value = this.raw(node2, null, "beforeDecl");
        else if (node2.type === "comment") value = this.raw(node2, null, "beforeComment");
        else if (detect === "before") value = this.raw(node2, null, "beforeRule");
        else value = this.raw(node2, null, "beforeClose");
        var buf = node2.parent;
        var depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            var indent = this.raw(node2, null, "indent");
            if (indent.length) for(var step = 0; step < depth; step++)value += indent;
        }
        return value;
    };
    _proto.block = function block(node2, start) {
        var between = this.raw(node2, "between", "beforeOpen");
        this.builder(start + between + "{", node2, "start");
        var after;
        if (node2.nodes && node2.nodes.length) {
            this.body(node2);
            after = this.raw(node2, "after");
        } else after = this.raw(node2, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node2, "end");
    };
    _proto.body = function body(node2) {
        var last = node2.nodes.length - 1;
        while(last > 0){
            if (node2.nodes[last].type !== "comment") break;
            last -= 1;
        }
        var semicolon = this.raw(node2, "semicolon");
        for(var i2 = 0; i2 < node2.nodes.length; i2++){
            var child = node2.nodes[i2];
            var before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i2 || semicolon);
        }
    };
    _proto.comment = function comment(node2) {
        var left = this.raw(node2, "left", "commentLeft");
        var right = this.raw(node2, "right", "commentRight");
        this.builder("/*" + left + node2.text + right + "*/", node2);
    };
    _proto.decl = function decl(node2, semicolon) {
        var between = this.raw(node2, "between", "colon");
        var string = node2.prop + between + this.rawValue(node2, "value");
        if (node2.important) string += node2.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node2);
    };
    _proto.document = function document1(node2) {
        this.body(node2);
    };
    _proto.raw = function raw(node2, own, detect) {
        var value;
        if (!detect) detect = own;
        if (own) {
            value = node2.raws[own];
            if (typeof value !== "undefined") return value;
        }
        var parent = node2.parent;
        if (detect === "before") {
            if (!parent || parent.type === "root" && parent.first === node2) return "";
            if (parent && parent.type === "document") return "";
        }
        if (!parent) return $f1b1811a0002602d$var$DEFAULT_RAW[detect];
        var root2 = node2.root();
        if (!root2.rawCache) root2.rawCache = {};
        if (typeof root2.rawCache[detect] !== "undefined") return root2.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node2, detect);
        else {
            var method = "raw" + $f1b1811a0002602d$var$capitalize(detect);
            if (this[method]) value = this[method](root2, node2);
            else root2.walk(function(i2) {
                value = i2.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $f1b1811a0002602d$var$DEFAULT_RAW[detect];
        root2.rawCache[detect] = value;
        return value;
    };
    _proto.rawBeforeClose = function rawBeforeClose(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length > 0) {
                if (typeof i2.raws.after !== "undefined") {
                    value = i2.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeComment = function rawBeforeComment(root2, node2) {
        var value;
        root2.walkComments(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeDecl = function rawBeforeDecl(root2, node2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.before !== "undefined") {
                value = i2.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node2, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawBeforeOpen = function rawBeforeOpen(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.type !== "decl") {
                value = i2.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawBeforeRule = function rawBeforeRule(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
                if (typeof i2.raws.before !== "undefined") {
                    value = i2.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    };
    _proto.rawColon = function rawColon(root2) {
        var value;
        root2.walkDecls(function(i2) {
            if (typeof i2.raws.between !== "undefined") {
                value = i2.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    };
    _proto.rawEmptyBody = function rawEmptyBody(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length === 0) {
                value = i2.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawIndent = function rawIndent(root2) {
        if (root2.raws.indent) return root2.raws.indent;
        var value;
        root2.walk(function(i2) {
            var p = i2.parent;
            if (p && p !== root2 && p.parent && p.parent === root2) {
                if (typeof i2.raws.before !== "undefined") {
                    var parts = i2.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    };
    _proto.rawSemicolon = function rawSemicolon(root2) {
        var value;
        root2.walk(function(i2) {
            if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
                value = i2.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    };
    _proto.rawValue = function rawValue(node2, prop) {
        var value = node2[prop];
        var raw = node2.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    };
    _proto.root = function root(node2) {
        this.body(node2);
        if (node2.raws.after) this.builder(node2.raws.after);
    };
    _proto.rule = function rule(node2) {
        this.block(node2, this.rawValue(node2, "selector"));
        if (node2.raws.ownSemicolon) this.builder(node2.raws.ownSemicolon, node2, "end");
    };
    _proto.stringify = function stringify(node2, semicolon) {
        if (!this[node2.type]) throw new Error("Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier.");
        this[node2.type](node2, semicolon);
    };
    return Stringifier2;
}();
var $f1b1811a0002602d$var$stringifier = $f1b1811a0002602d$var$Stringifier$2;
$f1b1811a0002602d$var$Stringifier$2.default = $f1b1811a0002602d$var$Stringifier$2;
var $f1b1811a0002602d$var$Stringifier$1 = $f1b1811a0002602d$var$stringifier;
function $f1b1811a0002602d$var$stringify$4(node2, builder) {
    var str = new $f1b1811a0002602d$var$Stringifier$1(builder);
    str.stringify(node2);
}
var $f1b1811a0002602d$var$stringify_1 = $f1b1811a0002602d$var$stringify$4;
$f1b1811a0002602d$var$stringify$4.default = $f1b1811a0002602d$var$stringify$4;
var $f1b1811a0002602d$var$isClean$2 = $f1b1811a0002602d$var$symbols.isClean, $f1b1811a0002602d$var$my$2 = $f1b1811a0002602d$var$symbols.my;
var $f1b1811a0002602d$var$CssSyntaxError$2 = $f1b1811a0002602d$var$cssSyntaxError;
var $f1b1811a0002602d$var$Stringifier22 = $f1b1811a0002602d$var$stringifier;
var $f1b1811a0002602d$var$stringify$3 = $f1b1811a0002602d$var$stringify_1;
function $f1b1811a0002602d$var$cloneNode(obj, parent) {
    var cloned = new obj.constructor();
    for(var i2 in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i2)) continue;
        if (i2 === "proxyCache") continue;
        var value = obj[i2];
        var type = typeof value === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(value);
        if (i2 === "parent" && type === "object") {
            if (parent) cloned[i2] = parent;
        } else if (i2 === "source") cloned[i2] = value;
        else if (Array.isArray(value)) cloned[i2] = value.map(function(j) {
            return $f1b1811a0002602d$var$cloneNode(j, cloned);
        });
        else {
            if (type === "object" && value !== null) value = $f1b1811a0002602d$var$cloneNode(value);
            cloned[i2] = value;
        }
    }
    return cloned;
}
var $f1b1811a0002602d$var$Node$4 = /*#__PURE__*/ function() {
    function Node3(defaults) {
        if (defaults === void 0) defaults = {};
        this.raws = {};
        this[$f1b1811a0002602d$var$isClean$2] = false;
        this[$f1b1811a0002602d$var$my$2] = true;
        for(var name in defaults)if (name === "nodes") {
            this.nodes = [];
            for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(defaults[name]), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (typeof node2.clone === "function") this.append(node2.clone());
                else this.append(node2);
            }
        } else this[name] = defaults[name];
    }
    var _proto = Node3.prototype;
    _proto.addToError = function addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            var s2 = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, "$&" + s2.input.from + ":" + s2.start.line + ":" + s2.start.column + "$&");
        }
        return error;
    };
    _proto.after = function after(add) {
        this.parent.insertAfter(this, add);
        return this;
    };
    _proto.assign = function assign(overrides) {
        if (overrides === void 0) overrides = {};
        for(var name in overrides)this[name] = overrides[name];
        return this;
    };
    _proto.before = function before(add) {
        this.parent.insertBefore(this, add);
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $f1b1811a0002602d$var$cloneNode(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    };
    _proto.cloneAfter = function cloneAfter(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    };
    _proto.cloneBefore = function cloneBefore(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    };
    _proto.error = function error(message, opts) {
        if (opts === void 0) opts = {};
        if (this.source) {
            var _this_rangeBy = this.rangeBy(opts), end = _this_rangeBy.end, start = _this_rangeBy.start;
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $f1b1811a0002602d$var$CssSyntaxError$2(message);
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node2.markDirty();
                return true;
            }
        };
    };
    _proto.markDirty = function markDirty() {
        if (this[$f1b1811a0002602d$var$isClean$2]) {
            this[$f1b1811a0002602d$var$isClean$2] = false;
            var next = this;
            while(next = next.parent)next[$f1b1811a0002602d$var$isClean$2] = false;
        }
    };
    _proto.next = function next() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 + 1];
    };
    _proto.positionBy = function positionBy(opts, stringRepresentation) {
        var pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) pos = this.positionInside(index2, stringRepresentation);
        }
        return pos;
    };
    _proto.positionInside = function positionInside(index2, stringRepresentation) {
        var string = stringRepresentation || this.toString();
        var column = this.source.start.column;
        var line = this.source.start.line;
        for(var i2 = 0; i2 < index2; i2++)if (string[i2] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    };
    _proto.prev = function prev() {
        if (!this.parent) return void 0;
        var index2 = this.parent.index(this);
        return this.parent.nodes[index2 - 1];
    };
    _proto.rangeBy = function rangeBy(opts) {
        var start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        var end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            var stringRepresentation = this.toString();
            var index2 = stringRepresentation.indexOf(opts.word);
            if (index2 !== -1) {
                start = this.positionInside(index2, stringRepresentation);
                end = this.positionInside(index2 + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    };
    _proto.raw = function raw(prop, defaultType) {
        var str = new $f1b1811a0002602d$var$Stringifier22();
        return str.raw(this, prop, defaultType);
    };
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = void 0;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++)nodes[_key] = arguments[_key];
        if (this.parent) {
            var bookmark = this;
            var foundSelf = false;
            for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                if (node2 === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node2);
                    bookmark = node2;
                } else this.parent.insertBefore(bookmark, node2);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    };
    _proto.root = function root() {
        var result2 = this;
        while(result2.parent && result2.parent.type !== "document")result2 = result2.parent;
        return result2;
    };
    _proto.toJSON = function toJSON(_, inputs) {
        var fixed = {};
        var emitInputs = inputs == null;
        inputs = inputs || /* @__PURE__ */ new Map();
        var inputsNextIndex = 0;
        for(var name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            var value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map(function(i2) {
                if ((typeof i2 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(i2)) === "object" && i2.toJSON) return i2.toJSON(null, inputs);
                else return i2;
            });
            else if ((typeof value === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(value)) === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                var inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [].concat(inputs.keys()).map(function(input2) {
            return input2.toJSON();
        });
        return fixed;
    };
    _proto.toProxy = function toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    };
    _proto.toString = function toString(stringifier2) {
        if (stringifier2 === void 0) stringifier2 = $f1b1811a0002602d$var$stringify$3;
        if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
        var result2 = "";
        stringifier2(this, function(i2) {
            result2 += i2;
        });
        return result2;
    };
    _proto.warn = function warn(result2, text, opts) {
        var data = {
            node: this
        };
        for(var i2 in opts)data[i2] = opts[i2];
        return result2.warn(text, data);
    };
    $f1b1811a0002602d$var$_create_class(Node3, [
        {
            key: "proxyOf",
            get: function get() {
                return this;
            }
        }
    ]);
    return Node3;
}();
var $f1b1811a0002602d$var$node = $f1b1811a0002602d$var$Node$4;
$f1b1811a0002602d$var$Node$4.default = $f1b1811a0002602d$var$Node$4;
var $f1b1811a0002602d$var$Node$3 = $f1b1811a0002602d$var$node;
var $f1b1811a0002602d$var$Declaration$4 = /*#__PURE__*/ function(Node$3) {
    $f1b1811a0002602d$var$_inherits(Declaration2, Node$3);
    function Declaration2(defaults) {
        var _this;
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = $f1b1811a0002602d$var$_extends({}, defaults, {
            value: String(defaults.value)
        });
        _this = Node$3.call(this, defaults) || this;
        _this.type = "decl";
        return _this;
    }
    $f1b1811a0002602d$var$_create_class(Declaration2, [
        {
            key: "variable",
            get: function get() {
                return this.prop.startsWith("--") || this.prop[0] === "$";
            }
        }
    ]);
    return Declaration2;
}($f1b1811a0002602d$var$Node$3);
var $f1b1811a0002602d$var$declaration = $f1b1811a0002602d$var$Declaration$4;
$f1b1811a0002602d$var$Declaration$4.default = $f1b1811a0002602d$var$Declaration$4;
var $f1b1811a0002602d$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var $f1b1811a0002602d$var$nanoid$1 = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i2 = size;
    while(i2--)id += $f1b1811a0002602d$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
var $f1b1811a0002602d$var$nonSecure = {
    nanoid: $f1b1811a0002602d$var$nanoid$1
};
var $f1b1811a0002602d$var$SourceMapConsumer$2 = $f1b1811a0002602d$var$require$$2.SourceMapConsumer, $f1b1811a0002602d$var$SourceMapGenerator$2 = $f1b1811a0002602d$var$require$$2.SourceMapGenerator;
var $f1b1811a0002602d$var$existsSync = $f1b1811a0002602d$var$require$$2.existsSync, $f1b1811a0002602d$var$readFileSync = $f1b1811a0002602d$var$require$$2.readFileSync;
var $f1b1811a0002602d$var$dirname$1 = $f1b1811a0002602d$var$require$$2.dirname, $f1b1811a0002602d$var$join = $f1b1811a0002602d$var$require$$2.join;
function $f1b1811a0002602d$var$fromBase64(str) {
    if ($f1b1811a0002602d$require$Buffer) return $f1b1811a0002602d$require$Buffer.from(str, "base64").toString();
    else return window.atob(str);
}
var $f1b1811a0002602d$var$PreviousMap$2 = /*#__PURE__*/ function() {
    function PreviousMap2(css, opts) {
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        var prev = opts.map ? opts.map.prev : void 0;
        var text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $f1b1811a0002602d$var$dirname$1(this.mapFile);
        if (text) this.text = text;
    }
    var _proto = PreviousMap2.prototype;
    _proto.consumer = function consumer() {
        if (!this.consumerCache) this.consumerCache = new $f1b1811a0002602d$var$SourceMapConsumer$2(this.text);
        return this.consumerCache;
    };
    _proto.decodeInline = function decodeInline(text) {
        var baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        var baseUri = /^data:application\/json;base64,/;
        var charsetUri = /^data:application\/json;charset=utf-?8,/;
        var uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $f1b1811a0002602d$var$fromBase64(text.substr(RegExp.lastMatch.length));
        var encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    };
    _proto.getAnnotationURL = function getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    };
    _proto.isMap = function isMap(map) {
        if ((typeof map === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(map)) !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    };
    _proto.loadAnnotation = function loadAnnotation(css) {
        var comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        var start = css.lastIndexOf(comments.pop());
        var end = css.indexOf("*/", start);
        if (start > -1 && end > -1) this.annotation = this.getAnnotationURL(css.substring(start, end));
    };
    _proto.loadFile = function loadFile(path) {
        this.root = $f1b1811a0002602d$var$dirname$1(path);
        if ($f1b1811a0002602d$var$existsSync(path)) {
            this.mapFile = path;
            return $f1b1811a0002602d$var$readFileSync(path, "utf-8").toString().trim();
        }
    };
    _proto.loadMap = function loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                var prevPath = prev(file);
                if (prevPath) {
                    var map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if ($f1b1811a0002602d$var$_instanceof(prev, $f1b1811a0002602d$var$SourceMapConsumer$2)) return $f1b1811a0002602d$var$SourceMapGenerator$2.fromSourceMap(prev).toString();
            else if ($f1b1811a0002602d$var$_instanceof(prev, $f1b1811a0002602d$var$SourceMapGenerator$2)) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            var map1 = this.annotation;
            if (file) map1 = $f1b1811a0002602d$var$join($f1b1811a0002602d$var$dirname$1(file), map1);
            return this.loadFile(map1);
        }
    };
    _proto.startWith = function startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    };
    _proto.withContent = function withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    };
    return PreviousMap2;
}();
var $f1b1811a0002602d$var$previousMap = $f1b1811a0002602d$var$PreviousMap$2;
$f1b1811a0002602d$var$PreviousMap$2.default = $f1b1811a0002602d$var$PreviousMap$2;
var $f1b1811a0002602d$var$SourceMapConsumer$1 = $f1b1811a0002602d$var$require$$2.SourceMapConsumer, $f1b1811a0002602d$var$SourceMapGenerator$1 = $f1b1811a0002602d$var$require$$2.SourceMapGenerator;
var $f1b1811a0002602d$var$fileURLToPath = $f1b1811a0002602d$var$require$$2.fileURLToPath, $f1b1811a0002602d$var$pathToFileURL$1 = $f1b1811a0002602d$var$require$$2.pathToFileURL;
var $f1b1811a0002602d$var$isAbsolute = $f1b1811a0002602d$var$require$$2.isAbsolute, $f1b1811a0002602d$var$resolve$1 = $f1b1811a0002602d$var$require$$2.resolve;
var $f1b1811a0002602d$var$nanoid = $f1b1811a0002602d$var$nonSecure.nanoid;
var $f1b1811a0002602d$var$terminalHighlight = $f1b1811a0002602d$var$require$$2;
var $f1b1811a0002602d$var$CssSyntaxError$1 = $f1b1811a0002602d$var$cssSyntaxError;
var $f1b1811a0002602d$var$PreviousMap$1 = $f1b1811a0002602d$var$previousMap;
var $f1b1811a0002602d$var$fromOffsetCache = Symbol("fromOffsetCache");
var $f1b1811a0002602d$var$sourceMapAvailable$1 = Boolean($f1b1811a0002602d$var$SourceMapConsumer$1 && $f1b1811a0002602d$var$SourceMapGenerator$1);
var $f1b1811a0002602d$var$pathAvailable$1 = Boolean($f1b1811a0002602d$var$resolve$1 && $f1b1811a0002602d$var$isAbsolute);
var $f1b1811a0002602d$var$Input$4 = /*#__PURE__*/ function() {
    function Input2(css, opts) {
        if (opts === void 0) opts = {};
        if (css === null || typeof css === "undefined" || (typeof css === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(css)) === "object" && !css.toString) throw new Error("PostCSS received " + css + " instead of CSS string");
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$f1b1811a0002602d$var$pathAvailable$1 || /^\w+:\/\//.test(opts.from) || $f1b1811a0002602d$var$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $f1b1811a0002602d$var$resolve$1(opts.from);
        }
        if ($f1b1811a0002602d$var$pathAvailable$1 && $f1b1811a0002602d$var$sourceMapAvailable$1) {
            var map = new $f1b1811a0002602d$var$PreviousMap$1(this.css, opts);
            if (map.text) {
                this.map = map;
                var file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $f1b1811a0002602d$var$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    var _proto = Input2.prototype;
    _proto.error = function error(message, line, column, opts) {
        if (opts === void 0) opts = {};
        var result2, endLine, endColumn;
        if (line && (typeof line === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(line)) === "object") {
            var start = line;
            var end = column;
            if (typeof start.offset === "number") {
                var pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                var pos1 = this.fromOffset(end.offset);
                endLine = pos1.line;
                endColumn = pos1.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            var pos2 = this.fromOffset(line);
            line = pos2.line;
            column = pos2.col;
        }
        var origin = this.origin(line, column, endLine, endColumn);
        if (origin) result2 = new $f1b1811a0002602d$var$CssSyntaxError$1(message, origin.endLine === void 0 ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === void 0 ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result2 = new $f1b1811a0002602d$var$CssSyntaxError$1(message, endLine === void 0 ? line : {
            column: column,
            line: line
        }, endLine === void 0 ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result2.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($f1b1811a0002602d$var$pathToFileURL$1) result2.input.url = $f1b1811a0002602d$var$pathToFileURL$1(this.file).toString();
            result2.input.file = this.file;
        }
        return result2;
    };
    _proto.fromOffset = function fromOffset(offset) {
        var lastLine, lineToIndex;
        if (!this[$f1b1811a0002602d$var$fromOffsetCache]) {
            var lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            var prevIndex = 0;
            for(var i2 = 0, l2 = lines.length; i2 < l2; i2++){
                lineToIndex[i2] = prevIndex;
                prevIndex += lines[i2].length + 1;
            }
            this[$f1b1811a0002602d$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$f1b1811a0002602d$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        var min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            var max = lineToIndex.length - 2;
            var mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    };
    _proto.mapResolve = function mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $f1b1811a0002602d$var$resolve$1(this.map.consumer().sourceRoot || this.map.root || ".", file);
    };
    _proto.origin = function origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        var consumer = this.map.consumer();
        var from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        var to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        var fromUrl;
        if ($f1b1811a0002602d$var$isAbsolute(from.source)) fromUrl = $f1b1811a0002602d$var$pathToFileURL$1(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $f1b1811a0002602d$var$pathToFileURL$1(this.map.mapFile));
        var result2 = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($f1b1811a0002602d$var$fileURLToPath) result2.file = $f1b1811a0002602d$var$fileURLToPath(fromUrl);
            else throw new Error("file: protocol is not available in this PostCSS build");
        }
        var source = consumer.sourceContentFor(from.source);
        if (source) result2.source = source;
        return result2;
    };
    _proto.toJSON = function toJSON() {
        var json = {};
        for(var _i = 0, _iter = [
            "hasBOM",
            "css",
            "file",
            "id"
        ]; _i < _iter.length; _i++){
            var name = _iter[_i];
            if (this[name] != null) json[name] = this[name];
        }
        if (this.map) {
            json.map = $f1b1811a0002602d$var$_extends({}, this.map);
            if (json.map.consumerCache) json.map.consumerCache = void 0;
        }
        return json;
    };
    $f1b1811a0002602d$var$_create_class(Input2, [
        {
            key: "from",
            get: function get() {
                return this.file || this.id;
            }
        }
    ]);
    return Input2;
}();
var $f1b1811a0002602d$var$input = $f1b1811a0002602d$var$Input$4;
$f1b1811a0002602d$var$Input$4.default = $f1b1811a0002602d$var$Input$4;
if ($f1b1811a0002602d$var$terminalHighlight && $f1b1811a0002602d$var$terminalHighlight.registerInput) $f1b1811a0002602d$var$terminalHighlight.registerInput($f1b1811a0002602d$var$Input$4);
var $f1b1811a0002602d$var$SourceMapConsumer = $f1b1811a0002602d$var$require$$2.SourceMapConsumer, $f1b1811a0002602d$var$SourceMapGenerator = $f1b1811a0002602d$var$require$$2.SourceMapGenerator;
var $f1b1811a0002602d$var$dirname = $f1b1811a0002602d$var$require$$2.dirname, $f1b1811a0002602d$var$relative = $f1b1811a0002602d$var$require$$2.relative, $f1b1811a0002602d$var$resolve$3 = $f1b1811a0002602d$var$require$$2.resolve, $f1b1811a0002602d$var$sep = $f1b1811a0002602d$var$require$$2.sep;
var $f1b1811a0002602d$var$pathToFileURL = $f1b1811a0002602d$var$require$$2.pathToFileURL;
var $f1b1811a0002602d$var$Input$3 = $f1b1811a0002602d$var$input;
var $f1b1811a0002602d$var$sourceMapAvailable = Boolean($f1b1811a0002602d$var$SourceMapConsumer && $f1b1811a0002602d$var$SourceMapGenerator);
var $f1b1811a0002602d$var$pathAvailable = Boolean($f1b1811a0002602d$var$dirname && $f1b1811a0002602d$var$resolve$3 && $f1b1811a0002602d$var$relative && $f1b1811a0002602d$var$sep);
var $f1b1811a0002602d$var$MapGenerator$2 = /*#__PURE__*/ function() {
    function MapGenerator2(stringify2, root2, opts, cssString) {
        this.stringify = stringify2;
        this.mapOpts = opts.map || {};
        this.root = root2;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = /* @__PURE__ */ new Map();
        this.memoizedPaths = /* @__PURE__ */ new Map();
        this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    var _proto = MapGenerator2.prototype;
    _proto.addAnnotation = function addAnnotation() {
        var content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        var eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    };
    _proto.applyPrevMaps = function applyPrevMaps() {
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(this.previous()), _step; !(_step = _iterator()).done;){
            var prev = _step.value;
            var from = this.toUrl(this.path(prev.file));
            var root2 = prev.root || $f1b1811a0002602d$var$dirname(prev.file);
            var map = void 0;
            if (this.mapOpts.sourcesContent === false) {
                map = new $f1b1811a0002602d$var$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
        }
    };
    _proto.clearAnnotation = function clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            var node2;
            for(var i2 = this.root.nodes.length - 1; i2 >= 0; i2--){
                node2 = this.root.nodes[i2];
                if (node2.type !== "comment") continue;
                if (node2.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i2);
            }
        } else if (this.css) this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, "");
    };
    _proto.generate = function generate() {
        this.clearAnnotation();
        if ($f1b1811a0002602d$var$pathAvailable && $f1b1811a0002602d$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            var result2 = "";
            this.stringify(this.root, function(i2) {
                result2 += i2;
            });
            return [
                result2
            ];
        }
    };
    _proto.generateMap = function generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            var prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $f1b1811a0002602d$var$SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $f1b1811a0002602d$var$SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    };
    _proto.generateString = function generateString() {
        var _this = this;
        this.css = "";
        this.map = new $f1b1811a0002602d$var$SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        var line = 1;
        var column = 1;
        var noSource = "<no source>";
        var mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        var lines, last;
        this.stringify(this.root, function(str, node2, type) {
            _this.css += str;
            if (node2 && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node2.source && node2.source.start) {
                    mapping.source = _this.sourcePath(node2);
                    mapping.original.line = node2.source.start.line;
                    mapping.original.column = node2.source.start.column - 1;
                    _this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    _this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node2 && type !== "start") {
                var p = node2.parent || {
                    raws: {}
                };
                var childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
                if (!childless || node2 !== p.last || p.raws.semicolon) {
                    if (node2.source && node2.source.end) {
                        mapping.source = _this.sourcePath(node2);
                        mapping.original.line = node2.source.end.line;
                        mapping.original.column = node2.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        _this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        _this.map.addMapping(mapping);
                    }
                }
            }
        });
    };
    _proto.isAnnotation = function isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.annotation;
        });
        return true;
    };
    _proto.isInline = function isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        var annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.inline;
        });
        return true;
    };
    _proto.isMap = function isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    };
    _proto.isSourcesContent = function isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some(function(i2) {
            return i2.withContent();
        });
        return true;
    };
    _proto.outputFile = function outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    };
    _proto.path = function path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60) return file;
        if (/^\w+:\/\//.test(file)) return file;
        var cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        var from = this.opts.to ? $f1b1811a0002602d$var$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $f1b1811a0002602d$var$dirname($f1b1811a0002602d$var$resolve$3(from, this.mapOpts.annotation));
        var path = $f1b1811a0002602d$var$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    };
    _proto.previous = function previous() {
        var _this = this;
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk(function(node2) {
                if (node2.source && node2.source.input.map) {
                    var map = node2.source.input.map;
                    if (!_this.previousMaps.includes(map)) _this.previousMaps.push(map);
                }
            });
            else {
                var input2 = new $f1b1811a0002602d$var$Input$3(this.originalCSS, this.opts);
                if (input2.map) this.previousMaps.push(input2.map);
            }
        }
        return this.previousMaps;
    };
    _proto.setSourcesContent = function setSourcesContent() {
        var _this = this;
        var already = {};
        if (this.root) this.root.walk(function(node2) {
            if (node2.source) {
                var from = node2.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    var fromUrl = _this.usesFileUrls ? _this.toFileUrl(from) : _this.toUrl(_this.path(from));
                    _this.map.setSourceContent(fromUrl, node2.source.input.css);
                }
            }
        });
        else if (this.css) {
            var from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    };
    _proto.sourcePath = function sourcePath(node2) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node2.source.input.from);
        else return this.toUrl(this.path(node2.source.input.from));
    };
    _proto.toBase64 = function toBase64(str) {
        if ($f1b1811a0002602d$require$Buffer) return $f1b1811a0002602d$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    };
    _proto.toFileUrl = function toFileUrl(path) {
        var cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($f1b1811a0002602d$var$pathToFileURL) {
            var fileURL = $f1b1811a0002602d$var$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    };
    _proto.toUrl = function toUrl(path) {
        var cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($f1b1811a0002602d$var$sep === "\\") path = path.replace(/\\/g, "/");
        var url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    };
    return MapGenerator2;
}();
var $f1b1811a0002602d$var$mapGenerator = $f1b1811a0002602d$var$MapGenerator$2;
var $f1b1811a0002602d$var$Node$2 = $f1b1811a0002602d$var$node;
var $f1b1811a0002602d$var$Comment$4 = /*#__PURE__*/ function(Node$2) {
    $f1b1811a0002602d$var$_inherits(Comment2, Node$2);
    function Comment2(defaults) {
        var _this;
        _this = Node$2.call(this, defaults) || this;
        _this.type = "comment";
        return _this;
    }
    return Comment2;
}($f1b1811a0002602d$var$Node$2);
var $f1b1811a0002602d$var$comment = $f1b1811a0002602d$var$Comment$4;
$f1b1811a0002602d$var$Comment$4.default = $f1b1811a0002602d$var$Comment$4;
var $f1b1811a0002602d$var$isClean$1 = $f1b1811a0002602d$var$symbols.isClean, $f1b1811a0002602d$var$my$1 = $f1b1811a0002602d$var$symbols.my;
var $f1b1811a0002602d$var$Declaration$3 = $f1b1811a0002602d$var$declaration;
var $f1b1811a0002602d$var$Comment$3 = $f1b1811a0002602d$var$comment;
var $f1b1811a0002602d$var$Node$1 = $f1b1811a0002602d$var$node;
var $f1b1811a0002602d$var$parse$4, $f1b1811a0002602d$var$Rule$4, $f1b1811a0002602d$var$AtRule$4, $f1b1811a0002602d$var$Root$6;
function $f1b1811a0002602d$var$cleanSource(nodes) {
    return nodes.map(function(i2) {
        if (i2.nodes) i2.nodes = $f1b1811a0002602d$var$cleanSource(i2.nodes);
        delete i2.source;
        return i2;
    });
}
function $f1b1811a0002602d$var$markDirtyUp(node2) {
    node2[$f1b1811a0002602d$var$isClean$1] = false;
    if (node2.proxyOf.nodes) for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(node2.proxyOf.nodes), _step; !(_step = _iterator()).done;){
        var i2 = _step.value;
        $f1b1811a0002602d$var$markDirtyUp(i2);
    }
}
var $f1b1811a0002602d$var$Container$7 = /*#__PURE__*/ function(Node$1) {
    $f1b1811a0002602d$var$_inherits(Container2, Node$1);
    function Container2() {
        return Node$1.apply(this, arguments) || this;
    }
    var _proto = Container2.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.last);
            for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.push(node2);
            }
        }
        this.markDirty();
        return this;
    };
    _proto.cleanRaws = function cleanRaws(keepBetween) {
        Node$1.prototype.cleanRaws.call(this, keepBetween);
        if (this.nodes) for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(this.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.cleanRaws(keepBetween);
        }
    };
    _proto.each = function each(callback) {
        if (!this.proxyOf.nodes) return void 0;
        var iterator = this.getIterator();
        var index2, result2;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index2 = this.indexes[iterator];
            result2 = callback(this.proxyOf.nodes[index2], index2);
            if (result2 === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result2;
    };
    _proto.every = function every(condition) {
        return this.nodes.every(condition);
    };
    _proto.getIterator = function getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        var iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    };
    _proto.getProxyProcessor = function getProxyProcessor() {
        return {
            get: function get(node2, prop) {
                if (prop === "proxyOf") return node2;
                else if (!node2[prop]) return node2[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _node2;
                    return (_node2 = node2)[prop].apply(_node2, [].concat(args.map(function(i2) {
                        if (typeof i2 === "function") return function(child, index2) {
                            return i2(child.toProxy(), index2);
                        };
                        else return i2;
                    })));
                };
                else if (prop === "every" || prop === "some") return function(cb) {
                    return node2[prop](function(child) {
                        for(var _len = arguments.length, other = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)other[_key - 1] = arguments[_key];
                        return cb.apply(void 0, [].concat([
                            child.toProxy()
                        ], other));
                    });
                };
                else if (prop === "root") return function() {
                    return node2.root().toProxy();
                };
                else if (prop === "nodes") return node2.nodes.map(function(i2) {
                    return i2.toProxy();
                });
                else if (prop === "first" || prop === "last") return node2[prop].toProxy();
                else return node2[prop];
            },
            set: function set(node2, prop, value) {
                if (node2[prop] === value) return true;
                node2[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node2.markDirty();
                return true;
            }
        };
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    };
    _proto.insertAfter = function insertAfter(exist, add) {
        var existIndex = this.index(exist);
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex < index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.insertBefore = function insertBefore(exist, add) {
        var existIndex = this.index(exist);
        var type = existIndex === 0 ? "prepend" : false;
        var nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            this.proxyOf.nodes.splice(existIndex, 0, node2);
        }
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (existIndex <= index2) this.indexes[id] = index2 + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.normalize = function normalize(nodes, sample) {
        var _this = this;
        if (typeof nodes === "string") nodes = $f1b1811a0002602d$var$cleanSource($f1b1811a0002602d$var$parse$4(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var i2 = _step.value;
                if (i2.parent) i2.parent.removeChild(i2, "ignore");
            }
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var i21 = _step1.value;
                if (i21.parent) i21.parent.removeChild(i21, "ignore");
            }
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $f1b1811a0002602d$var$Declaration$3(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $f1b1811a0002602d$var$Rule$4(nodes)
        ];
        else if (nodes.name) nodes = [
            new $f1b1811a0002602d$var$AtRule$4(nodes)
        ];
        else if (nodes.text) nodes = [
            new $f1b1811a0002602d$var$Comment$3(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        var processed = nodes.map(function(i2) {
            if (!i2[$f1b1811a0002602d$var$my$1]) Container2.rebuild(i2);
            i2 = i2.proxyOf;
            if (i2.parent) i2.parent.removeChild(i2);
            if (i2[$f1b1811a0002602d$var$isClean$1]) $f1b1811a0002602d$var$markDirtyUp(i2);
            if (typeof i2.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i2.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i2.parent = _this.proxyOf;
            return i2;
        });
        return processed;
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        children = children.reverse();
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(children), _step; !(_step = _iterator()).done;){
            var child = _step.value;
            var nodes = this.normalize(child, this.first, "prepend").reverse();
            for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step1; !(_step1 = _iterator1()).done;){
                var node2 = _step1.value;
                this.proxyOf.nodes.unshift(node2);
            }
            for(var id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    };
    _proto.push = function push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(this.proxyOf.nodes), _step; !(_step = _iterator()).done;){
            var node2 = _step.value;
            node2.parent = void 0;
        }
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = void 0;
        this.proxyOf.nodes.splice(child, 1);
        var index2;
        for(var id in this.indexes){
            index2 = this.indexes[id];
            if (index2 >= child) this.indexes[id] = index2 - 1;
        }
        this.markDirty();
        return this;
    };
    _proto.replaceValues = function replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls(function(decl) {
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    };
    _proto.some = function some(condition) {
        return this.nodes.some(condition);
    };
    _proto.walk = function walk(callback) {
        return this.each(function(child, i2) {
            var result2;
            try {
                result2 = callback(child, i2);
            } catch (e2) {
                throw child.addToError(e2);
            }
            if (result2 !== false && child.walk) result2 = child.walk(callback);
            return result2;
        });
    };
    _proto.walkAtRules = function walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk(function(child, i2) {
                if (child.type === "atrule") return callback(child, i2);
            });
        }
        if ($f1b1811a0002602d$var$_instanceof(name, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "atrule" && child.name === name) return callback(child, i2);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        return this.walk(function(child, i2) {
            if (child.type === "comment") return callback(child, i2);
        });
    };
    _proto.walkDecls = function walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk(function(child, i2) {
                if (child.type === "decl") return callback(child, i2);
            });
        }
        if ($f1b1811a0002602d$var$_instanceof(prop, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "decl" && child.prop === prop) return callback(child, i2);
        });
    };
    _proto.walkRules = function walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk(function(child, i2) {
                if (child.type === "rule") return callback(child, i2);
            });
        }
        if ($f1b1811a0002602d$var$_instanceof(selector, RegExp)) return this.walk(function(child, i2) {
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i2);
        });
        return this.walk(function(child, i2) {
            if (child.type === "rule" && child.selector === selector) return callback(child, i2);
        });
    };
    $f1b1811a0002602d$var$_create_class(Container2, [
        {
            key: "first",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[0];
            }
        },
        {
            key: "last",
            get: function get() {
                if (!this.proxyOf.nodes) return void 0;
                return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
            }
        }
    ]);
    return Container2;
}($f1b1811a0002602d$var$Node$1);
$f1b1811a0002602d$var$Container$7.registerParse = function(dependant) {
    $f1b1811a0002602d$var$parse$4 = dependant;
};
$f1b1811a0002602d$var$Container$7.registerRule = function(dependant) {
    $f1b1811a0002602d$var$Rule$4 = dependant;
};
$f1b1811a0002602d$var$Container$7.registerAtRule = function(dependant) {
    $f1b1811a0002602d$var$AtRule$4 = dependant;
};
$f1b1811a0002602d$var$Container$7.registerRoot = function(dependant) {
    $f1b1811a0002602d$var$Root$6 = dependant;
};
var $f1b1811a0002602d$var$container = $f1b1811a0002602d$var$Container$7;
$f1b1811a0002602d$var$Container$7.default = $f1b1811a0002602d$var$Container$7;
$f1b1811a0002602d$var$Container$7.rebuild = function(node2) {
    if (node2.type === "atrule") Object.setPrototypeOf(node2, $f1b1811a0002602d$var$AtRule$4.prototype);
    else if (node2.type === "rule") Object.setPrototypeOf(node2, $f1b1811a0002602d$var$Rule$4.prototype);
    else if (node2.type === "decl") Object.setPrototypeOf(node2, $f1b1811a0002602d$var$Declaration$3.prototype);
    else if (node2.type === "comment") Object.setPrototypeOf(node2, $f1b1811a0002602d$var$Comment$3.prototype);
    else if (node2.type === "root") Object.setPrototypeOf(node2, $f1b1811a0002602d$var$Root$6.prototype);
    node2[$f1b1811a0002602d$var$my$1] = true;
    if (node2.nodes) node2.nodes.forEach(function(child) {
        $f1b1811a0002602d$var$Container$7.rebuild(child);
    });
};
var $f1b1811a0002602d$var$Container$6 = $f1b1811a0002602d$var$container;
var $f1b1811a0002602d$var$LazyResult$4, $f1b1811a0002602d$var$Processor$3;
var $f1b1811a0002602d$var$Document$3 = /*#__PURE__*/ function(Container$6) {
    $f1b1811a0002602d$var$_inherits(Document23, Container$6);
    function Document23(defaults) {
        var _this;
        _this = Container$6.call(this, $f1b1811a0002602d$var$_extends({
            type: "document"
        }, defaults)) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Document23.prototype;
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $f1b1811a0002602d$var$LazyResult$4(new $f1b1811a0002602d$var$Processor$3(), this, opts);
        return lazy.stringify();
    };
    return Document23;
}($f1b1811a0002602d$var$Container$6);
$f1b1811a0002602d$var$Document$3.registerLazyResult = function(dependant) {
    $f1b1811a0002602d$var$LazyResult$4 = dependant;
};
$f1b1811a0002602d$var$Document$3.registerProcessor = function(dependant) {
    $f1b1811a0002602d$var$Processor$3 = dependant;
};
var $f1b1811a0002602d$var$document$1$2 = $f1b1811a0002602d$var$Document$3;
$f1b1811a0002602d$var$Document$3.default = $f1b1811a0002602d$var$Document$3;
var $f1b1811a0002602d$var$printed = {};
var $f1b1811a0002602d$var$warnOnce$2 = function warnOnce2(message) {
    if ($f1b1811a0002602d$var$printed[message]) return;
    $f1b1811a0002602d$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};
var $f1b1811a0002602d$var$Warning$2 = /*#__PURE__*/ function() {
    function Warning2(text, opts) {
        if (opts === void 0) opts = {};
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            var range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(var opt in opts)this[opt] = opts[opt];
    }
    var _proto = Warning2.prototype;
    _proto.toString = function toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    };
    return Warning2;
}();
var $f1b1811a0002602d$var$warning = $f1b1811a0002602d$var$Warning$2;
$f1b1811a0002602d$var$Warning$2.default = $f1b1811a0002602d$var$Warning$2;
var $f1b1811a0002602d$var$Warning$1 = $f1b1811a0002602d$var$warning;
var $f1b1811a0002602d$var$Result$3 = /*#__PURE__*/ function() {
    function Result2(processor2, root2, opts) {
        this.processor = processor2;
        this.messages = [];
        this.root = root2;
        this.opts = opts;
        this.css = void 0;
        this.map = void 0;
    }
    var _proto = Result2.prototype;
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.warn = function warn(text, opts) {
        if (opts === void 0) opts = {};
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        var warning2 = new $f1b1811a0002602d$var$Warning$1(text, opts);
        this.messages.push(warning2);
        return warning2;
    };
    _proto.warnings = function warnings() {
        return this.messages.filter(function(i2) {
            return i2.type === "warning";
        });
    };
    $f1b1811a0002602d$var$_create_class(Result2, [
        {
            key: "content",
            get: function get() {
                return this.css;
            }
        }
    ]);
    return Result2;
}();
var $f1b1811a0002602d$var$result = $f1b1811a0002602d$var$Result$3;
$f1b1811a0002602d$var$Result$3.default = $f1b1811a0002602d$var$Result$3;
var $f1b1811a0002602d$var$SINGLE_QUOTE = "'".charCodeAt(0);
var $f1b1811a0002602d$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
var $f1b1811a0002602d$var$BACKSLASH = "\\".charCodeAt(0);
var $f1b1811a0002602d$var$SLASH = "/".charCodeAt(0);
var $f1b1811a0002602d$var$NEWLINE = "\n".charCodeAt(0);
var $f1b1811a0002602d$var$SPACE = " ".charCodeAt(0);
var $f1b1811a0002602d$var$FEED = "\f".charCodeAt(0);
var $f1b1811a0002602d$var$TAB = "	".charCodeAt(0);
var $f1b1811a0002602d$var$CR = "\r".charCodeAt(0);
var $f1b1811a0002602d$var$OPEN_SQUARE = "[".charCodeAt(0);
var $f1b1811a0002602d$var$CLOSE_SQUARE = "]".charCodeAt(0);
var $f1b1811a0002602d$var$OPEN_PARENTHESES = "(".charCodeAt(0);
var $f1b1811a0002602d$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
var $f1b1811a0002602d$var$OPEN_CURLY = "{".charCodeAt(0);
var $f1b1811a0002602d$var$CLOSE_CURLY = "}".charCodeAt(0);
var $f1b1811a0002602d$var$SEMICOLON = ";".charCodeAt(0);
var $f1b1811a0002602d$var$ASTERISK = "*".charCodeAt(0);
var $f1b1811a0002602d$var$COLON = ":".charCodeAt(0);
var $f1b1811a0002602d$var$AT = "@".charCodeAt(0);
var $f1b1811a0002602d$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
var $f1b1811a0002602d$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
var $f1b1811a0002602d$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
var $f1b1811a0002602d$var$RE_HEX_ESCAPE = /[\da-f]/i;
var $f1b1811a0002602d$var$tokenize = function tokenizer2(input2, options) {
    if (options === void 0) options = {};
    var css = input2.css.valueOf();
    var ignore = options.ignoreErrors;
    var code, next, quote, content, escape;
    var escaped, escapePos, prev, n2, currentToken;
    var length = css.length;
    var pos = 0;
    var buffer = [];
    var returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        var ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $f1b1811a0002602d$var$NEWLINE:
            case $f1b1811a0002602d$var$SPACE:
            case $f1b1811a0002602d$var$TAB:
            case $f1b1811a0002602d$var$CR:
            case $f1b1811a0002602d$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $f1b1811a0002602d$var$SPACE || code === $f1b1811a0002602d$var$NEWLINE || code === $f1b1811a0002602d$var$TAB || code === $f1b1811a0002602d$var$CR || code === $f1b1811a0002602d$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $f1b1811a0002602d$var$OPEN_SQUARE:
            case $f1b1811a0002602d$var$CLOSE_SQUARE:
            case $f1b1811a0002602d$var$OPEN_CURLY:
            case $f1b1811a0002602d$var$CLOSE_CURLY:
            case $f1b1811a0002602d$var$COLON:
            case $f1b1811a0002602d$var$SEMICOLON:
            case $f1b1811a0002602d$var$CLOSE_PARENTHESES:
                var controlChar = String.fromCharCode(code);
                currentToken = [
                    controlChar,
                    controlChar,
                    pos
                ];
                break;
            case $f1b1811a0002602d$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n2 = css.charCodeAt(pos + 1);
                if (prev === "url" && n2 !== $f1b1811a0002602d$var$SINGLE_QUOTE && n2 !== $f1b1811a0002602d$var$DOUBLE_QUOTE && n2 !== $f1b1811a0002602d$var$SPACE && n2 !== $f1b1811a0002602d$var$NEWLINE && n2 !== $f1b1811a0002602d$var$TAB && n2 !== $f1b1811a0002602d$var$FEED && n2 !== $f1b1811a0002602d$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $f1b1811a0002602d$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $f1b1811a0002602d$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $f1b1811a0002602d$var$SINGLE_QUOTE:
            case $f1b1811a0002602d$var$DOUBLE_QUOTE:
                quote = code === $f1b1811a0002602d$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $f1b1811a0002602d$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $f1b1811a0002602d$var$AT:
                $f1b1811a0002602d$var$RE_AT_END.lastIndex = pos + 1;
                $f1b1811a0002602d$var$RE_AT_END.test(css);
                if ($f1b1811a0002602d$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $f1b1811a0002602d$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $f1b1811a0002602d$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $f1b1811a0002602d$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $f1b1811a0002602d$var$SLASH && code !== $f1b1811a0002602d$var$SPACE && code !== $f1b1811a0002602d$var$NEWLINE && code !== $f1b1811a0002602d$var$TAB && code !== $f1b1811a0002602d$var$CR && code !== $f1b1811a0002602d$var$FEED) {
                    next += 1;
                    if ($f1b1811a0002602d$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($f1b1811a0002602d$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $f1b1811a0002602d$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $f1b1811a0002602d$var$SLASH && css.charCodeAt(pos + 1) === $f1b1811a0002602d$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $f1b1811a0002602d$var$RE_WORD_END.lastIndex = pos + 1;
                    $f1b1811a0002602d$var$RE_WORD_END.test(css);
                    if ($f1b1811a0002602d$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $f1b1811a0002602d$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};
var $f1b1811a0002602d$var$Container$5 = $f1b1811a0002602d$var$container;
var $f1b1811a0002602d$var$AtRule$3 = /*#__PURE__*/ function(Container$5) {
    $f1b1811a0002602d$var$_inherits(AtRule2, Container$5);
    function AtRule2(defaults) {
        var _this;
        _this = Container$5.call(this, defaults) || this;
        _this.type = "atrule";
        return _this;
    }
    var _proto = AtRule2.prototype;
    _proto.append = function append() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5_prototype_append;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5_prototype_append = Container$5.prototype.append).call.apply(_Container$5_prototype_append, [].concat([
            this
        ], children));
    };
    _proto.prepend = function prepend() {
        for(var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++)children[_key] = arguments[_key];
        var _Container$5_prototype_prepend;
        if (!this.proxyOf.nodes) this.nodes = [];
        return (_Container$5_prototype_prepend = Container$5.prototype.prepend).call.apply(_Container$5_prototype_prepend, [].concat([
            this
        ], children));
    };
    return AtRule2;
}($f1b1811a0002602d$var$Container$5);
var $f1b1811a0002602d$var$atRule = $f1b1811a0002602d$var$AtRule$3;
$f1b1811a0002602d$var$AtRule$3.default = $f1b1811a0002602d$var$AtRule$3;
$f1b1811a0002602d$var$Container$5.registerAtRule($f1b1811a0002602d$var$AtRule$3);
var $f1b1811a0002602d$var$Container$4 = $f1b1811a0002602d$var$container;
var $f1b1811a0002602d$var$LazyResult$3, $f1b1811a0002602d$var$Processor$2;
var $f1b1811a0002602d$var$Root$5 = /*#__PURE__*/ function(Container$4) {
    $f1b1811a0002602d$var$_inherits(Root2, Container$4);
    function Root2(defaults) {
        var _this;
        _this = Container$4.call(this, defaults) || this;
        _this.type = "root";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Root2.prototype;
    _proto.normalize = function normalize(child, sample, type) {
        var nodes = Container$4.prototype.normalize.call(this, child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(nodes), _step; !(_step = _iterator()).done;){
                var node2 = _step.value;
                node2.raws.before = sample.raws.before;
            }
        }
        return nodes;
    };
    _proto.removeChild = function removeChild(child, ignore) {
        var index2 = this.index(child);
        if (!ignore && index2 === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index2].raws.before;
        return Container$4.prototype.removeChild.call(this, child);
    };
    _proto.toResult = function toResult(opts) {
        if (opts === void 0) opts = {};
        var lazy = new $f1b1811a0002602d$var$LazyResult$3(new $f1b1811a0002602d$var$Processor$2(), this, opts);
        return lazy.stringify();
    };
    return Root2;
}($f1b1811a0002602d$var$Container$4);
$f1b1811a0002602d$var$Root$5.registerLazyResult = function(dependant) {
    $f1b1811a0002602d$var$LazyResult$3 = dependant;
};
$f1b1811a0002602d$var$Root$5.registerProcessor = function(dependant) {
    $f1b1811a0002602d$var$Processor$2 = dependant;
};
var $f1b1811a0002602d$var$root = $f1b1811a0002602d$var$Root$5;
$f1b1811a0002602d$var$Root$5.default = $f1b1811a0002602d$var$Root$5;
$f1b1811a0002602d$var$Container$4.registerRoot($f1b1811a0002602d$var$Root$5);
var $f1b1811a0002602d$var$list$2 = {
    comma: function comma(string) {
        return $f1b1811a0002602d$var$list$2.split(string, [
            ","
        ], true);
    },
    space: function space(string) {
        var spaces = [
            " ",
            "\n",
            "	"
        ];
        return $f1b1811a0002602d$var$list$2.split(string, spaces);
    },
    split: function split(string, separators, last) {
        var array = [];
        var current = "";
        var split = false;
        var func = 0;
        var inQuote = false;
        var prevQuote = "";
        var escape = false;
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(string), _step; !(_step = _iterator()).done;){
            var letter = _step.value;
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
var $f1b1811a0002602d$var$list_1 = $f1b1811a0002602d$var$list$2;
$f1b1811a0002602d$var$list$2.default = $f1b1811a0002602d$var$list$2;
var $f1b1811a0002602d$var$Container$3 = $f1b1811a0002602d$var$container;
var $f1b1811a0002602d$var$list$1 = $f1b1811a0002602d$var$list_1;
var $f1b1811a0002602d$var$Rule$3 = /*#__PURE__*/ function(Container$3) {
    $f1b1811a0002602d$var$_inherits(Rule2, Container$3);
    function Rule2(defaults) {
        var _this;
        _this = Container$3.call(this, defaults) || this;
        _this.type = "rule";
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    $f1b1811a0002602d$var$_create_class(Rule2, [
        {
            key: "selectors",
            get: function get() {
                return $f1b1811a0002602d$var$list$1.comma(this.selector);
            },
            set: function set(values) {
                var match = this.selector ? this.selector.match(/,\s*/) : null;
                var sep2 = match ? match[0] : "," + this.raw("between", "beforeOpen");
                this.selector = values.join(sep2);
            }
        }
    ]);
    return Rule2;
}($f1b1811a0002602d$var$Container$3);
var $f1b1811a0002602d$var$rule = $f1b1811a0002602d$var$Rule$3;
$f1b1811a0002602d$var$Rule$3.default = $f1b1811a0002602d$var$Rule$3;
$f1b1811a0002602d$var$Container$3.registerRule($f1b1811a0002602d$var$Rule$3);
var $f1b1811a0002602d$var$Declaration$2 = $f1b1811a0002602d$var$declaration;
var $f1b1811a0002602d$var$tokenizer22 = $f1b1811a0002602d$var$tokenize;
var $f1b1811a0002602d$var$Comment$2 = $f1b1811a0002602d$var$comment;
var $f1b1811a0002602d$var$AtRule$2 = $f1b1811a0002602d$var$atRule;
var $f1b1811a0002602d$var$Root$4 = $f1b1811a0002602d$var$root;
var $f1b1811a0002602d$var$Rule$2 = $f1b1811a0002602d$var$rule;
var $f1b1811a0002602d$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $f1b1811a0002602d$var$findLastWithPosition(tokens) {
    for(var i2 = tokens.length - 1; i2 >= 0; i2--){
        var token = tokens[i2];
        var pos = token[3] || token[2];
        if (pos) return pos;
    }
}
var $f1b1811a0002602d$var$Parser$1 = /*#__PURE__*/ function() {
    function Parser2(input2) {
        this.input = input2;
        this.root = new $f1b1811a0002602d$var$Root$4();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input2,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    var _proto = Parser2.prototype;
    _proto.atrule = function atrule(token) {
        var node2 = new $f1b1811a0002602d$var$AtRule$2();
        node2.name = token[1].slice(1);
        if (node2.name === "") this.unnamedAtrule(node2, token);
        this.init(node2, token[2]);
        var type;
        var prev;
        var shift;
        var last = false;
        var open = false;
        var params = [];
        var brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node2.source.end = this.getPosition(token[2]);
                    node2.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node2.source.end = this.getPosition(prev[3] || prev[2]);
                            node2.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node2.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node2.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node2, "params", params);
            if (last) {
                token = params[params.length - 1];
                node2.source.end = this.getPosition(token[3] || token[2]);
                node2.source.end.offset++;
                this.spaces = node2.raws.between;
                node2.raws.between = "";
            }
        } else {
            node2.raws.afterName = "";
            node2.params = "";
        }
        if (open) {
            node2.nodes = [];
            this.current = node2;
        }
    };
    _proto.checkMissedSemicolon = function checkMissedSemicolon(tokens) {
        var colon = this.colon(tokens);
        if (colon === false) return;
        var founded = 0;
        var token;
        for(var j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    };
    _proto.colon = function colon(tokens) {
        var brackets = 0;
        var token, type, prev;
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(tokens.entries()), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, i2 = _step_value[0], element = _step_value[1];
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i2;
            }
            prev = token;
        }
        return false;
    };
    _proto.comment = function comment(token) {
        var node2 = new $f1b1811a0002602d$var$Comment$2();
        this.init(node2, token[2]);
        node2.source.end = this.getPosition(token[3] || token[2]);
        node2.source.end.offset++;
        var text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node2.text = "";
            node2.raws.left = text;
            node2.raws.right = "";
        } else {
            var match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node2.text = match[2];
            node2.raws.left = match[1];
            node2.raws.right = match[3];
        }
    };
    _proto.createTokenizer = function createTokenizer() {
        this.tokenizer = $f1b1811a0002602d$var$tokenizer22(this.input);
    };
    _proto.decl = function decl(tokens, customProperty) {
        var node2 = new $f1b1811a0002602d$var$Declaration$2();
        this.init(node2, tokens[0][2]);
        var last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node2.source.end = this.getPosition(last[3] || last[2] || $f1b1811a0002602d$var$findLastWithPosition(tokens));
        node2.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node2.raws.before += tokens.shift()[1];
        }
        node2.source.start = this.getPosition(tokens[0][2]);
        node2.prop = "";
        while(tokens.length){
            var type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node2.prop += tokens.shift()[1];
        }
        node2.raws.between = "";
        var token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node2.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node2.raws.between += token[1];
            }
        }
        if (node2.prop[0] === "_" || node2.prop[0] === "*") {
            node2.raws.before += node2.prop[0];
            node2.prop = node2.prop.slice(1);
        }
        var firstSpaces = [];
        var next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(var i2 = tokens.length - 1; i2 >= 0; i2--){
            token = tokens[i2];
            if (token[1].toLowerCase() === "!important") {
                node2.important = true;
                var string = this.stringFrom(tokens, i2);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node2.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                var cache = tokens.slice(0);
                var str = "";
                for(var j = i2; j > 0; j--){
                    var type1 = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type1 !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node2.important = true;
                    node2.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        var hasWord = tokens.some(function(i2) {
            return i2[0] !== "space" && i2[0] !== "comment";
        });
        if (hasWord) {
            node2.raws.between += firstSpaces.map(function(i2) {
                return i2[1];
            }).join("");
            firstSpaces = [];
        }
        this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
        if (node2.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    };
    _proto.doubleColon = function doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    _proto.emptyRule = function emptyRule(token) {
        var node2 = new $f1b1811a0002602d$var$Rule$2();
        this.init(node2, token[2]);
        node2.selector = "";
        node2.raws.between = "";
        this.current = node2;
    };
    _proto.end = function end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    };
    _proto.endFile = function endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    };
    _proto.freeSemicolon = function freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            var prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    };
    // Helpers
    _proto.getPosition = function getPosition(offset) {
        var pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    };
    _proto.init = function init(node2, offset) {
        this.current.push(node2);
        node2.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node2.raws.before = this.spaces;
        this.spaces = "";
        if (node2.type !== "comment") this.semicolon = false;
    };
    _proto.other = function other(start) {
        var end = false;
        var type = null;
        var colon = false;
        var bracket = null;
        var brackets = [];
        var customProperty = start[1].startsWith("--");
        var tokens = [];
        var token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    };
    _proto.parse = function parse() {
        var token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    };
    _proto.precheckMissedSemicolon = function precheckMissedSemicolon() {};
    _proto.raw = function raw(node2, prop, tokens, customProperty) {
        var token, type;
        var length = tokens.length;
        var value = "";
        var clean = true;
        var next, prev;
        for(var i2 = 0; i2 < length; i2 += 1){
            token = tokens[i2];
            type = token[0];
            if (type === "space" && i2 === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
                next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
                if (!$f1b1811a0002602d$var$SAFE_COMMENT_NEIGHBOR[prev] && !$f1b1811a0002602d$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            var raw = tokens.reduce(function(all, i2) {
                return all + i2[1];
            }, "");
            node2.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node2[prop] = value;
    };
    _proto.rule = function rule(tokens) {
        tokens.pop();
        var node2 = new $f1b1811a0002602d$var$Rule$2();
        this.init(node2, tokens[0][2]);
        node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node2, "selector", tokens);
        this.current = node2;
    };
    _proto.spacesAndCommentsFromEnd = function spacesAndCommentsFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    // Errors
    _proto.spacesAndCommentsFromStart = function spacesAndCommentsFromStart(tokens) {
        var next;
        var spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    };
    _proto.spacesFromEnd = function spacesFromEnd(tokens) {
        var lastTokenType;
        var spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    };
    _proto.stringFrom = function stringFrom(tokens, from) {
        var result2 = "";
        for(var i2 = from; i2 < tokens.length; i2++)result2 += tokens[i2][1];
        tokens.splice(from, tokens.length - from);
        return result2;
    };
    _proto.unclosedBlock = function unclosedBlock() {
        var pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    };
    _proto.unclosedBracket = function unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    };
    _proto.unexpectedClose = function unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    };
    _proto.unknownWord = function unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    };
    _proto.unnamedAtrule = function unnamedAtrule(node2, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    };
    return Parser2;
}();
var $f1b1811a0002602d$var$parser = $f1b1811a0002602d$var$Parser$1;
var $f1b1811a0002602d$var$Container$2 = $f1b1811a0002602d$var$container;
var $f1b1811a0002602d$var$Parser22 = $f1b1811a0002602d$var$parser;
var $f1b1811a0002602d$var$Input$2 = $f1b1811a0002602d$var$input;
function $f1b1811a0002602d$var$parse$3(css, opts) {
    var input2 = new $f1b1811a0002602d$var$Input$2(css, opts);
    var parser2 = new $f1b1811a0002602d$var$Parser22(input2);
    try {
        parser2.parse();
    } catch (e2) {
        throw e2;
    }
    return parser2.root;
}
var $f1b1811a0002602d$var$parse_1 = $f1b1811a0002602d$var$parse$3;
$f1b1811a0002602d$var$parse$3.default = $f1b1811a0002602d$var$parse$3;
$f1b1811a0002602d$var$Container$2.registerParse($f1b1811a0002602d$var$parse$3);
var $f1b1811a0002602d$var$isClean = $f1b1811a0002602d$var$symbols.isClean, $f1b1811a0002602d$var$my = $f1b1811a0002602d$var$symbols.my;
var $f1b1811a0002602d$var$MapGenerator$1 = $f1b1811a0002602d$var$mapGenerator;
var $f1b1811a0002602d$var$stringify$2 = $f1b1811a0002602d$var$stringify_1;
var $f1b1811a0002602d$var$Container$1 = $f1b1811a0002602d$var$container;
var $f1b1811a0002602d$var$Document$2 = $f1b1811a0002602d$var$document$1$2;
var $f1b1811a0002602d$var$warnOnce$1 = $f1b1811a0002602d$var$warnOnce$2;
var $f1b1811a0002602d$var$Result$2 = $f1b1811a0002602d$var$result;
var $f1b1811a0002602d$var$parse$2 = $f1b1811a0002602d$var$parse_1;
var $f1b1811a0002602d$var$Root$3 = $f1b1811a0002602d$var$root;
var $f1b1811a0002602d$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
var $f1b1811a0002602d$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
var $f1b1811a0002602d$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
var $f1b1811a0002602d$var$CHILDREN = 0;
function $f1b1811a0002602d$var$isPromise(obj) {
    return (typeof obj === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(obj)) === "object" && typeof obj.then === "function";
}
function $f1b1811a0002602d$var$getEvents(node2) {
    var key = false;
    var type = $f1b1811a0002602d$var$TYPE_TO_CLASS_NAME[node2.type];
    if (node2.type === "decl") key = node2.prop.toLowerCase();
    else if (node2.type === "atrule") key = node2.name.toLowerCase();
    if (key && node2.append) return [
        type,
        type + "-" + key,
        $f1b1811a0002602d$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node2.append) return [
        type,
        $f1b1811a0002602d$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $f1b1811a0002602d$var$toStack(node2) {
    var events;
    if (node2.type === "document") events = [
        "Document",
        $f1b1811a0002602d$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node2.type === "root") events = [
        "Root",
        $f1b1811a0002602d$var$CHILDREN,
        "RootExit"
    ];
    else events = $f1b1811a0002602d$var$getEvents(node2);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node2,
        visitorIndex: 0,
        visitors: []
    };
}
function $f1b1811a0002602d$var$cleanMarks(node2) {
    node2[$f1b1811a0002602d$var$isClean] = false;
    if (node2.nodes) node2.nodes.forEach(function(i2) {
        return $f1b1811a0002602d$var$cleanMarks(i2);
    });
    return node2;
}
var $f1b1811a0002602d$var$postcss$2 = {};
var $f1b1811a0002602d$var$LazyResult$2 = /*#__PURE__*/ function() {
    function LazyResult2(processor2, css, opts) {
        var _this = this;
        this.stringified = false;
        this.processed = false;
        var root2;
        if ((typeof css === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(css)) === "object" && css !== null && (css.type === "root" || css.type === "document")) root2 = $f1b1811a0002602d$var$cleanMarks(css);
        else if ($f1b1811a0002602d$var$_instanceof(css, LazyResult2) || $f1b1811a0002602d$var$_instanceof(css, $f1b1811a0002602d$var$Result$2)) {
            root2 = $f1b1811a0002602d$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            var parser2 = $f1b1811a0002602d$var$parse$2;
            if (opts.syntax) parser2 = opts.syntax.parse;
            if (opts.parser) parser2 = opts.parser;
            if (parser2.parse) parser2 = parser2.parse;
            try {
                root2 = parser2(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root2 && !root2[$f1b1811a0002602d$var$my]) $f1b1811a0002602d$var$Container$1.rebuild(root2);
        }
        this.result = new $f1b1811a0002602d$var$Result$2(processor2, root2, opts);
        this.helpers = $f1b1811a0002602d$var$_extends({}, $f1b1811a0002602d$var$postcss$2, {
            postcss: $f1b1811a0002602d$var$postcss$2,
            result: this.result
        });
        this.plugins = this.processor.plugins.map(function(plugin22) {
            if ((typeof plugin22 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(plugin22)) === "object" && plugin22.prepare) return $f1b1811a0002602d$var$_extends({}, plugin22, plugin22.prepare(_this.result));
            else return plugin22;
        });
    }
    var _proto = LazyResult2.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.getAsyncError = function getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    };
    _proto.handleError = function handleError(error, node2) {
        var plugin22 = this.result.lastPlugin;
        try {
            if (node2) node2.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin22.postcssPlugin;
                error.setMessage();
            } else if (plugin22.postcssVersion) var pluginName, pluginVer, runtimeVer, a2, b;
        } catch (err) {
            if (console && console.error) console.error(err);
        }
        return error;
    };
    _proto.prepareVisitors = function prepareVisitors() {
        var _this = this;
        this.listeners = {};
        var add = function(plugin22, type, cb) {
            if (!_this.listeners[type]) _this.listeners[type] = [];
            _this.listeners[type].push([
                plugin22,
                cb
            ]);
        };
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            if ((typeof plugin22 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(plugin22)) === "object") for(var event in plugin22){
                if (!$f1b1811a0002602d$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error("Unknown event " + event + " in " + plugin22.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
                if (!$f1b1811a0002602d$var$NOT_VISITORS[event]) {
                    if ($f1b1811a0002602d$var$_type_of(plugin22[event]) === "object") {
                        for(var filter in plugin22[event])if (filter === "*") add(plugin22, event, plugin22[event][filter]);
                        else add(plugin22, event + "-" + filter.toLowerCase(), plugin22[event][filter]);
                    } else if (typeof plugin22[event] === "function") add(plugin22, event, plugin22[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    };
    _proto.runAsync = function runAsync() {
        var _this = this;
        return $f1b1811a0002602d$var$_async_to_generator(function() {
            var i2, plugin22, promise, error, root2, stack, promise1, e2, node2, _loop, _iterator, _step;
            return $f1b1811a0002602d$var$_ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.plugin = 0;
                        i2 = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i2 < _this.plugins.length)) return [
                            3,
                            6
                        ];
                        plugin22 = _this.plugins[i2];
                        promise = _this.runOnRoot(plugin22);
                        if (!$f1b1811a0002602d$var$isPromise(promise)) return [
                            3,
                            5
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        throw _this.handleError(error);
                    case 5:
                        i2++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        _this.prepareVisitors();
                        if (!_this.hasListener) return [
                            3,
                            18
                        ];
                        root2 = _this.result.root;
                        _state.label = 7;
                    case 7:
                        if (!!root2[$f1b1811a0002602d$var$isClean]) return [
                            3,
                            14
                        ];
                        root2[$f1b1811a0002602d$var$isClean] = true;
                        stack = [
                            $f1b1811a0002602d$var$toStack(root2)
                        ];
                        _state.label = 8;
                    case 8:
                        if (!(stack.length > 0)) return [
                            3,
                            13
                        ];
                        promise1 = _this.visitTick(stack);
                        if (!$f1b1811a0002602d$var$isPromise(promise1)) return [
                            3,
                            12
                        ];
                        _state.label = 9;
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            promise1
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        node2 = stack[stack.length - 1].node;
                        throw _this.handleError(e2, node2);
                    case 12:
                        return [
                            3,
                            8
                        ];
                    case 13:
                        return [
                            3,
                            7
                        ];
                    case 14:
                        if (!_this.listeners.OnceExit) return [
                            3,
                            18
                        ];
                        _loop = function() {
                            var _step_value, plugin22, visitor, roots, e2;
                            return $f1b1811a0002602d$var$_ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
                                        _this.result.lastPlugin = plugin22;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]);
                                        if (!(root2.type === "document")) return [
                                            3,
                                            3
                                        ];
                                        roots = root2.nodes.map(function(subRoot) {
                                            return visitor(subRoot, _this.helpers);
                                        });
                                        return [
                                            4,
                                            Promise.all(roots)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            visitor(root2, _this.helpers)
                                        ];
                                    case 4:
                                        _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        e2 = _state.sent();
                                        throw _this.handleError(e2);
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(_this.listeners.OnceExit);
                        _state.label = 15;
                    case 15:
                        if (!!(_step = _iterator()).done) return [
                            3,
                            18
                        ];
                        return [
                            5,
                            $f1b1811a0002602d$var$_ts_values(_loop())
                        ];
                    case 16:
                        _state.sent();
                        _state.label = 17;
                    case 17:
                        return [
                            3,
                            15
                        ];
                    case 18:
                        _this.processed = true;
                        return [
                            2,
                            _this.stringify()
                        ];
                }
            });
        })();
    };
    _proto.runOnRoot = function runOnRoot(plugin22) {
        var _this = this;
        this.result.lastPlugin = plugin22;
        try {
            if ((typeof plugin22 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(plugin22)) === "object" && plugin22.Once) {
                if (this.result.root.type === "document") {
                    var roots = this.result.root.nodes.map(function(root2) {
                        return plugin22.Once(root2, _this.helpers);
                    });
                    if ($f1b1811a0002602d$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin22.Once(this.result.root, this.helpers);
            } else if (typeof plugin22 === "function") return plugin22(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    };
    _proto.stringify = function stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        var opts = this.result.opts;
        var str = $f1b1811a0002602d$var$stringify$2;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        var map = new $f1b1811a0002602d$var$MapGenerator$1(str, this.result.root, this.result.opts);
        var data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(this.plugins), _step; !(_step = _iterator()).done;){
            var plugin22 = _step.value;
            var promise = this.runOnRoot(plugin22);
            if ($f1b1811a0002602d$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            var root2 = this.result.root;
            while(!root2[$f1b1811a0002602d$var$isClean]){
                root2[$f1b1811a0002602d$var$isClean] = true;
                this.walkSync(root2);
            }
            if (this.listeners.OnceExit) {
                if (root2.type === "document") for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(root2.nodes), _step1; !(_step1 = _iterator1()).done;){
                    var subRoot = _step1.value;
                    this.visitSync(this.listeners.OnceExit, subRoot);
                }
                else this.visitSync(this.listeners.OnceExit, root2);
            }
        }
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this.css;
    };
    _proto.visitSync = function visitSync(visitors, node2) {
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(visitors), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, plugin22 = _step_value[0], visitor = _step_value[1];
            this.result.lastPlugin = plugin22;
            var promise = void 0;
            try {
                promise = visitor(node2, this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2.proxyOf);
            }
            if (node2.type !== "root" && node2.type !== "document" && !node2.parent) return true;
            if ($f1b1811a0002602d$var$isPromise(promise)) throw this.getAsyncError();
        }
    };
    _proto.visitTick = function visitTick(stack) {
        var visit2 = stack[stack.length - 1];
        var node2 = visit2.node, visitors = visit2.visitors;
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit2.visitorIndex < visitors.length) {
            var _visitors_visit2_visitorIndex = visitors[visit2.visitorIndex], plugin22 = _visitors_visit2_visitorIndex[0], visitor = _visitors_visit2_visitorIndex[1];
            visit2.visitorIndex += 1;
            if (visit2.visitorIndex === visitors.length) {
                visit2.visitors = [];
                visit2.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin22;
            try {
                return visitor(node2.toProxy(), this.helpers);
            } catch (e2) {
                throw this.handleError(e2, node2);
            }
        }
        if (visit2.iterator !== 0) {
            var iterator = visit2.iterator;
            var child;
            while(child = node2.nodes[node2.indexes[iterator]]){
                node2.indexes[iterator] += 1;
                if (!child[$f1b1811a0002602d$var$isClean]) {
                    child[$f1b1811a0002602d$var$isClean] = true;
                    stack.push($f1b1811a0002602d$var$toStack(child));
                    return;
                }
            }
            visit2.iterator = 0;
            delete node2.indexes[iterator];
        }
        var events = visit2.events;
        while(visit2.eventIndex < events.length){
            var event = events[visit2.eventIndex];
            visit2.eventIndex += 1;
            if (event === $f1b1811a0002602d$var$CHILDREN) {
                if (node2.nodes && node2.nodes.length) {
                    node2[$f1b1811a0002602d$var$isClean] = true;
                    visit2.iterator = node2.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit2.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    };
    _proto.walkSync = function walkSync(node2) {
        var _this = this;
        node2[$f1b1811a0002602d$var$isClean] = true;
        var events = $f1b1811a0002602d$var$getEvents(node2);
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(events), _step; !(_step = _iterator()).done;){
            var event = _step.value;
            if (event === $f1b1811a0002602d$var$CHILDREN) {
                if (node2.nodes) node2.each(function(child) {
                    if (!child[$f1b1811a0002602d$var$isClean]) _this.walkSync(child);
                });
            } else {
                var visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node2.toProxy())) return;
                }
            }
        }
    };
    _proto.warnings = function warnings() {
        return this.sync().warnings();
    };
    $f1b1811a0002602d$var$_create_class(LazyResult2, [
        {
            key: "content",
            get: function get() {
                return this.stringify().content;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.stringify().css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.stringify().map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return this.sync().messages;
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                return this.sync().root;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "LazyResult";
            }
        }
    ]);
    return LazyResult2;
}();
$f1b1811a0002602d$var$LazyResult$2.registerPostcss = function(dependant) {
    $f1b1811a0002602d$var$postcss$2 = dependant;
};
var $f1b1811a0002602d$var$lazyResult = $f1b1811a0002602d$var$LazyResult$2;
$f1b1811a0002602d$var$LazyResult$2.default = $f1b1811a0002602d$var$LazyResult$2;
$f1b1811a0002602d$var$Root$3.registerLazyResult($f1b1811a0002602d$var$LazyResult$2);
$f1b1811a0002602d$var$Document$2.registerLazyResult($f1b1811a0002602d$var$LazyResult$2);
var $f1b1811a0002602d$var$MapGenerator22 = $f1b1811a0002602d$var$mapGenerator;
var $f1b1811a0002602d$var$stringify$1 = $f1b1811a0002602d$var$stringify_1;
var $f1b1811a0002602d$var$warnOnce22 = $f1b1811a0002602d$var$warnOnce$2;
var $f1b1811a0002602d$var$parse$1 = $f1b1811a0002602d$var$parse_1;
var $f1b1811a0002602d$var$Result$1 = $f1b1811a0002602d$var$result;
var $f1b1811a0002602d$var$NoWorkResult$1 = /*#__PURE__*/ function() {
    function NoWorkResult2(processor2, css, opts) {
        css = css.toString();
        this.stringified = false;
        this._processor = processor2;
        this._css = css;
        this._opts = opts;
        this._map = void 0;
        var root2;
        var str = $f1b1811a0002602d$var$stringify$1;
        this.result = new $f1b1811a0002602d$var$Result$1(this._processor, root2, this._opts);
        this.result.css = css;
        var self = this;
        Object.defineProperty(this.result, "root", {
            get: function get() {
                return self.root;
            }
        });
        var map = new $f1b1811a0002602d$var$MapGenerator22(str, root2, this._opts, css);
        if (map.isMap()) {
            var _map_generate = map.generate(), generatedCSS = _map_generate[0], generatedMap = _map_generate[1];
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    var _proto = NoWorkResult2.prototype;
    _proto.async = function async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    };
    _proto.catch = function _catch(onRejected) {
        return this.async().catch(onRejected);
    };
    _proto.finally = function _finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    };
    _proto.sync = function sync() {
        if (this.error) throw this.error;
        return this.result;
    };
    _proto.then = function then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    };
    _proto.toString = function toString() {
        return this._css;
    };
    _proto.warnings = function warnings() {
        return [];
    };
    $f1b1811a0002602d$var$_create_class(NoWorkResult2, [
        {
            key: "content",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "css",
            get: function get() {
                return this.result.css;
            }
        },
        {
            key: "map",
            get: function get() {
                return this.result.map;
            }
        },
        {
            key: "messages",
            get: function get() {
                return [];
            }
        },
        {
            key: "opts",
            get: function get() {
                return this.result.opts;
            }
        },
        {
            key: "processor",
            get: function get() {
                return this.result.processor;
            }
        },
        {
            key: "root",
            get: function get() {
                if (this._root) return this._root;
                var root2;
                var parser2 = $f1b1811a0002602d$var$parse$1;
                try {
                    root2 = parser2(this._css, this._opts);
                } catch (error) {
                    this.error = error;
                }
                if (this.error) throw this.error;
                else {
                    this._root = root2;
                    return root2;
                }
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "NoWorkResult";
            }
        }
    ]);
    return NoWorkResult2;
}();
var $f1b1811a0002602d$var$noWorkResult = $f1b1811a0002602d$var$NoWorkResult$1;
$f1b1811a0002602d$var$NoWorkResult$1.default = $f1b1811a0002602d$var$NoWorkResult$1;
var $f1b1811a0002602d$var$NoWorkResult22 = $f1b1811a0002602d$var$noWorkResult;
var $f1b1811a0002602d$var$LazyResult$1 = $f1b1811a0002602d$var$lazyResult;
var $f1b1811a0002602d$var$Document$1 = $f1b1811a0002602d$var$document$1$2;
var $f1b1811a0002602d$var$Root$2 = $f1b1811a0002602d$var$root;
var $f1b1811a0002602d$var$Processor$1 = /*#__PURE__*/ function() {
    function Processor2(plugins) {
        if (plugins === void 0) plugins = [];
        this.version = "8.4.38";
        this.plugins = this.normalize(plugins);
    }
    var _proto = Processor2.prototype;
    _proto.normalize = function normalize(plugins) {
        var normalized = [];
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(plugins), _step; !(_step = _iterator()).done;){
            var i2 = _step.value;
            if (i2.postcss === true) i2 = i2();
            else if (i2.postcss) i2 = i2.postcss;
            if ((typeof i2 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(i2)) === "object" && Array.isArray(i2.plugins)) normalized = normalized.concat(i2.plugins);
            else if ((typeof i2 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(i2)) === "object" && i2.postcssPlugin) normalized.push(i2);
            else if (typeof i2 === "function") normalized.push(i2);
            else if ((typeof i2 === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(i2)) === "object" && (i2.parse || i2.stringify)) ;
            else throw new Error(i2 + " is not a PostCSS plugin");
        }
        return normalized;
    };
    _proto.process = function process1(css, opts) {
        if (opts === void 0) opts = {};
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $f1b1811a0002602d$var$NoWorkResult22(this, css, opts);
        else return new $f1b1811a0002602d$var$LazyResult$1(this, css, opts);
    };
    _proto.use = function use(plugin22) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin22
        ]));
        return this;
    };
    return Processor2;
}();
var $f1b1811a0002602d$var$processor = $f1b1811a0002602d$var$Processor$1;
$f1b1811a0002602d$var$Processor$1.default = $f1b1811a0002602d$var$Processor$1;
$f1b1811a0002602d$var$Root$2.registerProcessor($f1b1811a0002602d$var$Processor$1);
$f1b1811a0002602d$var$Document$1.registerProcessor($f1b1811a0002602d$var$Processor$1);
var $f1b1811a0002602d$var$Declaration$1 = $f1b1811a0002602d$var$declaration;
var $f1b1811a0002602d$var$PreviousMap22 = $f1b1811a0002602d$var$previousMap;
var $f1b1811a0002602d$var$Comment$1 = $f1b1811a0002602d$var$comment;
var $f1b1811a0002602d$var$AtRule$1 = $f1b1811a0002602d$var$atRule;
var $f1b1811a0002602d$var$Input$1 = $f1b1811a0002602d$var$input;
var $f1b1811a0002602d$var$Root$1 = $f1b1811a0002602d$var$root;
var $f1b1811a0002602d$var$Rule$1 = $f1b1811a0002602d$var$rule;
function $f1b1811a0002602d$var$fromJSON$1(json, inputs) {
    if (Array.isArray(json)) return json.map(function(n2) {
        return $f1b1811a0002602d$var$fromJSON$1(n2);
    });
    var ownInputs = json.inputs, defaults = $f1b1811a0002602d$var$_object_without_properties_loose(json, [
        "inputs"
    ]);
    if (ownInputs) {
        inputs = [];
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(ownInputs), _step; !(_step = _iterator()).done;){
            var input2 = _step.value;
            var inputHydrated = $f1b1811a0002602d$var$_extends({}, input2, {
                __proto__: $f1b1811a0002602d$var$Input$1.prototype
            });
            if (inputHydrated.map) inputHydrated.map = $f1b1811a0002602d$var$_extends({}, inputHydrated.map, {
                __proto__: $f1b1811a0002602d$var$PreviousMap22.prototype
            });
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map(function(n2) {
        return $f1b1811a0002602d$var$fromJSON$1(n2, inputs);
    });
    if (defaults.source) {
        var _defaults_source = defaults.source, inputId = _defaults_source.inputId, source = $f1b1811a0002602d$var$_object_without_properties_loose(_defaults_source, [
            "inputId"
        ]);
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $f1b1811a0002602d$var$Root$1(defaults);
    else if (defaults.type === "decl") return new $f1b1811a0002602d$var$Declaration$1(defaults);
    else if (defaults.type === "rule") return new $f1b1811a0002602d$var$Rule$1(defaults);
    else if (defaults.type === "comment") return new $f1b1811a0002602d$var$Comment$1(defaults);
    else if (defaults.type === "atrule") return new $f1b1811a0002602d$var$AtRule$1(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
var $f1b1811a0002602d$var$fromJSON_1 = $f1b1811a0002602d$var$fromJSON$1;
$f1b1811a0002602d$var$fromJSON$1.default = $f1b1811a0002602d$var$fromJSON$1;
var $f1b1811a0002602d$var$CssSyntaxError22 = $f1b1811a0002602d$var$cssSyntaxError;
var $f1b1811a0002602d$var$Declaration22 = $f1b1811a0002602d$var$declaration;
var $f1b1811a0002602d$var$LazyResult22 = $f1b1811a0002602d$var$lazyResult;
var $f1b1811a0002602d$var$Container22 = $f1b1811a0002602d$var$container;
var $f1b1811a0002602d$var$Processor22 = $f1b1811a0002602d$var$processor;
var $f1b1811a0002602d$var$stringify = $f1b1811a0002602d$var$stringify_1;
var $f1b1811a0002602d$var$fromJSON = $f1b1811a0002602d$var$fromJSON_1;
var $f1b1811a0002602d$var$Document222 = $f1b1811a0002602d$var$document$1$2;
var $f1b1811a0002602d$var$Warning22 = $f1b1811a0002602d$var$warning;
var $f1b1811a0002602d$var$Comment22 = $f1b1811a0002602d$var$comment;
var $f1b1811a0002602d$var$AtRule22 = $f1b1811a0002602d$var$atRule;
var $f1b1811a0002602d$var$Result22 = $f1b1811a0002602d$var$result;
var $f1b1811a0002602d$var$Input22 = $f1b1811a0002602d$var$input;
var $f1b1811a0002602d$var$parse = $f1b1811a0002602d$var$parse_1;
var $f1b1811a0002602d$var$list = $f1b1811a0002602d$var$list_1;
var $f1b1811a0002602d$var$Rule22 = $f1b1811a0002602d$var$rule;
var $f1b1811a0002602d$var$Root22 = $f1b1811a0002602d$var$root;
var $f1b1811a0002602d$var$Node22 = $f1b1811a0002602d$var$node;
function $f1b1811a0002602d$var$postcss() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $f1b1811a0002602d$var$Processor22(plugins);
}
$f1b1811a0002602d$var$postcss.plugin = function plugin2(name, initializer) {
    var warningPrinted = false;
    function creator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        var transformer = initializer.apply(void 0, [].concat(args));
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $f1b1811a0002602d$var$Processor22().version;
        return transformer;
    }
    var cache;
    Object.defineProperty(creator, "postcss", {
        get: function get() {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $f1b1811a0002602d$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$f1b1811a0002602d$var$postcss.stringify = $f1b1811a0002602d$var$stringify;
$f1b1811a0002602d$var$postcss.parse = $f1b1811a0002602d$var$parse;
$f1b1811a0002602d$var$postcss.fromJSON = $f1b1811a0002602d$var$fromJSON;
$f1b1811a0002602d$var$postcss.list = $f1b1811a0002602d$var$list;
$f1b1811a0002602d$var$postcss.comment = function(defaults) {
    return new $f1b1811a0002602d$var$Comment22(defaults);
};
$f1b1811a0002602d$var$postcss.atRule = function(defaults) {
    return new $f1b1811a0002602d$var$AtRule22(defaults);
};
$f1b1811a0002602d$var$postcss.decl = function(defaults) {
    return new $f1b1811a0002602d$var$Declaration22(defaults);
};
$f1b1811a0002602d$var$postcss.rule = function(defaults) {
    return new $f1b1811a0002602d$var$Rule22(defaults);
};
$f1b1811a0002602d$var$postcss.root = function(defaults) {
    return new $f1b1811a0002602d$var$Root22(defaults);
};
$f1b1811a0002602d$var$postcss.document = function(defaults) {
    return new $f1b1811a0002602d$var$Document222(defaults);
};
$f1b1811a0002602d$var$postcss.CssSyntaxError = $f1b1811a0002602d$var$CssSyntaxError22;
$f1b1811a0002602d$var$postcss.Declaration = $f1b1811a0002602d$var$Declaration22;
$f1b1811a0002602d$var$postcss.Container = $f1b1811a0002602d$var$Container22;
$f1b1811a0002602d$var$postcss.Processor = $f1b1811a0002602d$var$Processor22;
$f1b1811a0002602d$var$postcss.Document = $f1b1811a0002602d$var$Document222;
$f1b1811a0002602d$var$postcss.Comment = $f1b1811a0002602d$var$Comment22;
$f1b1811a0002602d$var$postcss.Warning = $f1b1811a0002602d$var$Warning22;
$f1b1811a0002602d$var$postcss.AtRule = $f1b1811a0002602d$var$AtRule22;
$f1b1811a0002602d$var$postcss.Result = $f1b1811a0002602d$var$Result22;
$f1b1811a0002602d$var$postcss.Input = $f1b1811a0002602d$var$Input22;
$f1b1811a0002602d$var$postcss.Rule = $f1b1811a0002602d$var$Rule22;
$f1b1811a0002602d$var$postcss.Root = $f1b1811a0002602d$var$Root22;
$f1b1811a0002602d$var$postcss.Node = $f1b1811a0002602d$var$Node22;
$f1b1811a0002602d$var$LazyResult22.registerPostcss($f1b1811a0002602d$var$postcss);
var $f1b1811a0002602d$var$postcss_1 = $f1b1811a0002602d$var$postcss;
$f1b1811a0002602d$var$postcss.default = $f1b1811a0002602d$var$postcss;
var $f1b1811a0002602d$var$postcss$1 = /* @__PURE__ */ $f1b1811a0002602d$var$getDefaultExportFromCjs($f1b1811a0002602d$var$postcss_1);
$f1b1811a0002602d$var$postcss$1.stringify;
$f1b1811a0002602d$var$postcss$1.fromJSON;
$f1b1811a0002602d$var$postcss$1.plugin;
$f1b1811a0002602d$var$postcss$1.parse;
$f1b1811a0002602d$var$postcss$1.list;
$f1b1811a0002602d$var$postcss$1.document;
$f1b1811a0002602d$var$postcss$1.comment;
$f1b1811a0002602d$var$postcss$1.atRule;
$f1b1811a0002602d$var$postcss$1.rule;
$f1b1811a0002602d$var$postcss$1.decl;
$f1b1811a0002602d$var$postcss$1.root;
$f1b1811a0002602d$var$postcss$1.CssSyntaxError;
$f1b1811a0002602d$var$postcss$1.Declaration;
$f1b1811a0002602d$var$postcss$1.Container;
$f1b1811a0002602d$var$postcss$1.Processor;
$f1b1811a0002602d$var$postcss$1.Document;
$f1b1811a0002602d$var$postcss$1.Comment;
$f1b1811a0002602d$var$postcss$1.Warning;
$f1b1811a0002602d$var$postcss$1.AtRule;
$f1b1811a0002602d$var$postcss$1.Result;
$f1b1811a0002602d$var$postcss$1.Input;
$f1b1811a0002602d$var$postcss$1.Rule;
$f1b1811a0002602d$var$postcss$1.Root;
$f1b1811a0002602d$var$postcss$1.Node;
var $f1b1811a0002602d$var$BaseRRNode = /*#__PURE__*/ function() {
    function BaseRRNode() {
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        $f1b1811a0002602d$var$__publicField2(this, "parentElement", null);
        $f1b1811a0002602d$var$__publicField2(this, "parentNode", null);
        $f1b1811a0002602d$var$__publicField2(this, "ownerDocument");
        $f1b1811a0002602d$var$__publicField2(this, "firstChild", null);
        $f1b1811a0002602d$var$__publicField2(this, "lastChild", null);
        $f1b1811a0002602d$var$__publicField2(this, "previousSibling", null);
        $f1b1811a0002602d$var$__publicField2(this, "nextSibling", null);
        $f1b1811a0002602d$var$__publicField2(this, "ELEMENT_NODE", 1);
        $f1b1811a0002602d$var$__publicField2(this, "TEXT_NODE", 3);
        $f1b1811a0002602d$var$__publicField2(this, "nodeType");
        $f1b1811a0002602d$var$__publicField2(this, "nodeName");
        $f1b1811a0002602d$var$__publicField2(this, "RRNodeType");
    }
    var _proto = BaseRRNode.prototype;
    _proto.contains = function contains(node2) {
        if (!$f1b1811a0002602d$var$_instanceof(node2, BaseRRNode)) return false;
        else if (node2.ownerDocument !== this.ownerDocument) return false;
        else if (node2 === this) return true;
        while(node2.parentNode){
            if (node2.parentNode === this) return true;
            node2 = node2.parentNode;
        }
        return false;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.appendChild = function appendChild(_newChild) {
        throw new Error("RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method.");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.insertBefore = function insertBefore(_newChild, _refChild) {
        throw new Error("RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method.");
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.removeChild = function removeChild(_node) {
        throw new Error("RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method.");
    };
    _proto.toString = function toString() {
        return "RRNode";
    };
    $f1b1811a0002602d$var$_create_class(BaseRRNode, [
        {
            key: "childNodes",
            get: function get() {
                var childNodes2 = [];
                var childIterator = this.firstChild;
                while(childIterator){
                    childNodes2.push(childIterator);
                    childIterator = childIterator.nextSibling;
                }
                return childNodes2;
            }
        }
    ]);
    return BaseRRNode;
}();
var $f1b1811a0002602d$var$testableAccessors = {
    Node: [
        "childNodes",
        "parentNode",
        "parentElement",
        "textContent"
    ],
    ShadowRoot: [
        "host",
        "styleSheets"
    ],
    Element: [
        "shadowRoot",
        "querySelector",
        "querySelectorAll"
    ],
    MutationObserver: []
};
var $f1b1811a0002602d$var$testableMethods = {
    Node: [
        "contains",
        "getRootNode"
    ],
    ShadowRoot: [
        "getSelection"
    ],
    Element: [],
    MutationObserver: [
        "constructor"
    ]
};
var $f1b1811a0002602d$var$untaintedBasePrototype = {};
var $f1b1811a0002602d$var$isAngularZonePresent = function() {
    return !!globalThis.Zone;
};
function $f1b1811a0002602d$var$getUntaintedPrototype(key) {
    if ($f1b1811a0002602d$var$untaintedBasePrototype[key]) return $f1b1811a0002602d$var$untaintedBasePrototype[key];
    var defaultObj = globalThis[key];
    var defaultPrototype = defaultObj.prototype;
    var accessorNames = key in $f1b1811a0002602d$var$testableAccessors ? $f1b1811a0002602d$var$testableAccessors[key] : void 0;
    var isUntaintedAccessors = Boolean(accessorNames && // @ts-expect-error 2345
    accessorNames.every(function(accessor) {
        var _a2, _b;
        return Boolean((_b = (_a2 = Object.getOwnPropertyDescriptor(defaultPrototype, accessor)) == null ? void 0 : _a2.get) == null ? void 0 : _b.toString().includes("[native code]"));
    }));
    var methodNames = key in $f1b1811a0002602d$var$testableMethods ? $f1b1811a0002602d$var$testableMethods[key] : void 0;
    var isUntaintedMethods = Boolean(methodNames && methodNames.every(function(method) {
        var _a2;
        return typeof defaultPrototype[method] === "function" && ((_a2 = defaultPrototype[method]) == null ? void 0 : _a2.toString().includes("[native code]"));
    }));
    if (isUntaintedAccessors && isUntaintedMethods && !$f1b1811a0002602d$var$isAngularZonePresent()) {
        $f1b1811a0002602d$var$untaintedBasePrototype[key] = defaultObj.prototype;
        return defaultObj.prototype;
    }
    try {
        var iframeEl = document.createElement("iframe");
        document.body.appendChild(iframeEl);
        var win = iframeEl.contentWindow;
        if (!win) return defaultObj.prototype;
        var untaintedObject = win[key].prototype;
        document.body.removeChild(iframeEl);
        if (!untaintedObject) return defaultPrototype;
        return $f1b1811a0002602d$var$untaintedBasePrototype[key] = untaintedObject;
    } catch (e) {
        return defaultPrototype;
    }
}
var $f1b1811a0002602d$var$untaintedAccessorCache = {};
function $f1b1811a0002602d$var$getUntaintedAccessor(key, instance, accessor) {
    var _a2;
    var cacheKey = key + "." + String(accessor);
    if ($f1b1811a0002602d$var$untaintedAccessorCache[cacheKey]) return $f1b1811a0002602d$var$untaintedAccessorCache[cacheKey].call(instance);
    var untaintedPrototype = $f1b1811a0002602d$var$getUntaintedPrototype(key);
    var untaintedAccessor = (_a2 = Object.getOwnPropertyDescriptor(untaintedPrototype, accessor)) == null ? void 0 : _a2.get;
    if (!untaintedAccessor) return instance[accessor];
    $f1b1811a0002602d$var$untaintedAccessorCache[cacheKey] = untaintedAccessor;
    return untaintedAccessor.call(instance);
}
var $f1b1811a0002602d$var$untaintedMethodCache = {};
function $f1b1811a0002602d$var$getUntaintedMethod(key, instance, method) {
    var cacheKey = key + "." + String(method);
    if ($f1b1811a0002602d$var$untaintedMethodCache[cacheKey]) return $f1b1811a0002602d$var$untaintedMethodCache[cacheKey].bind(instance);
    var untaintedPrototype = $f1b1811a0002602d$var$getUntaintedPrototype(key);
    var untaintedMethod = untaintedPrototype[method];
    if (typeof untaintedMethod !== "function") return instance[method];
    $f1b1811a0002602d$var$untaintedMethodCache[cacheKey] = untaintedMethod;
    return untaintedMethod.bind(instance);
}
function $f1b1811a0002602d$var$childNodes(n2) {
    return $f1b1811a0002602d$var$getUntaintedAccessor("Node", n2, "childNodes");
}
function $f1b1811a0002602d$var$parentNode(n2) {
    return $f1b1811a0002602d$var$getUntaintedAccessor("Node", n2, "parentNode");
}
function $f1b1811a0002602d$var$parentElement(n2) {
    return $f1b1811a0002602d$var$getUntaintedAccessor("Node", n2, "parentElement");
}
function $f1b1811a0002602d$var$textContent(n2) {
    return $f1b1811a0002602d$var$getUntaintedAccessor("Node", n2, "textContent");
}
function $f1b1811a0002602d$var$contains(n2, other) {
    return $f1b1811a0002602d$var$getUntaintedMethod("Node", n2, "contains")(other);
}
function $f1b1811a0002602d$var$getRootNode(n2) {
    return $f1b1811a0002602d$var$getUntaintedMethod("Node", n2, "getRootNode")();
}
function $f1b1811a0002602d$var$host(n2) {
    if (!n2 || !("host" in n2)) return null;
    return $f1b1811a0002602d$var$getUntaintedAccessor("ShadowRoot", n2, "host");
}
function $f1b1811a0002602d$var$styleSheets(n2) {
    return n2.styleSheets;
}
function $f1b1811a0002602d$var$shadowRoot(n2) {
    if (!n2 || !("shadowRoot" in n2)) return null;
    return $f1b1811a0002602d$var$getUntaintedAccessor("Element", n2, "shadowRoot");
}
function $f1b1811a0002602d$var$querySelector(n2, selectors) {
    return $f1b1811a0002602d$var$getUntaintedAccessor("Element", n2, "querySelector")(selectors);
}
function $f1b1811a0002602d$var$querySelectorAll(n2, selectors) {
    return $f1b1811a0002602d$var$getUntaintedAccessor("Element", n2, "querySelectorAll")(selectors);
}
function $f1b1811a0002602d$var$mutationObserverCtor() {
    return $f1b1811a0002602d$var$getUntaintedPrototype("MutationObserver").constructor;
}
var $f1b1811a0002602d$var$index = {
    childNodes: $f1b1811a0002602d$var$childNodes,
    parentNode: $f1b1811a0002602d$var$parentNode,
    parentElement: $f1b1811a0002602d$var$parentElement,
    textContent: $f1b1811a0002602d$var$textContent,
    contains: $f1b1811a0002602d$var$contains,
    getRootNode: $f1b1811a0002602d$var$getRootNode,
    host: $f1b1811a0002602d$var$host,
    styleSheets: $f1b1811a0002602d$var$styleSheets,
    shadowRoot: $f1b1811a0002602d$var$shadowRoot,
    querySelector: $f1b1811a0002602d$var$querySelector,
    querySelectorAll: $f1b1811a0002602d$var$querySelectorAll,
    mutationObserver: $f1b1811a0002602d$var$mutationObserverCtor
};
function $f1b1811a0002602d$var$on(type, fn, target) {
    if (target === void 0) target = document;
    var options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return function() {
        return target.removeEventListener(type, fn, options);
    };
}
var $f1b1811a0002602d$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var $f1b1811a0002602d$var$_mirror = {
    map: {},
    getId: function getId() {
        console.error($f1b1811a0002602d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function getNode() {
        console.error($f1b1811a0002602d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function removeNodeFromMap() {
        console.error($f1b1811a0002602d$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function has() {
        console.error($f1b1811a0002602d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function reset() {
        console.error($f1b1811a0002602d$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $f1b1811a0002602d$var$_mirror = new Proxy($f1b1811a0002602d$var$_mirror, {
    get: function get(target, prop, receiver) {
        if (prop === "map") console.error($f1b1811a0002602d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $f1b1811a0002602d$var$throttle(func, wait, options) {
    if (options === void 0) options = {};
    var timeout = null;
    var previous = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        var context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $f1b1811a0002602d$var$hookSetter(target, key, d, isRevoked, win) {
    if (win === void 0) win = window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function set(value) {
            var _this = this;
            setTimeout(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return $f1b1811a0002602d$var$hookSetter(target, key, original || {}, true);
    };
}
function $f1b1811a0002602d$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e) {
        return function() {};
    }
}
var $f1b1811a0002602d$var$nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) $f1b1811a0002602d$var$nowTimestamp = function() {
    return /* @__PURE__ */ new Date().getTime();
};
function $f1b1811a0002602d$var$getWindowScroll(win) {
    var _a2, _b, _c, _d;
    var doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc.documentElement.scrollLeft || (doc == null ? void 0 : doc.body) && ((_a2 = $f1b1811a0002602d$var$index.parentElement(doc.body)) == null ? void 0 : _a2.scrollLeft) || ((_b = doc == null ? void 0 : doc.body) == null ? void 0 : _b.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : (doc == null ? void 0 : doc.documentElement.scrollTop) || (doc == null ? void 0 : doc.body) && ((_c = $f1b1811a0002602d$var$index.parentElement(doc.body)) == null ? void 0 : _c.scrollTop) || ((_d = doc == null ? void 0 : doc.body) == null ? void 0 : _d.scrollTop) || 0
    };
}
function $f1b1811a0002602d$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $f1b1811a0002602d$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $f1b1811a0002602d$var$closestElementOfNode(node2) {
    if (!node2) return null;
    var el = node2.nodeType === node2.ELEMENT_NODE ? node2 : $f1b1811a0002602d$var$index.parentElement(node2);
    return el;
}
function $f1b1811a0002602d$var$isBlocked(node2, blockClass, blockSelector, checkAncestors) {
    if (!node2) return false;
    var el = $f1b1811a0002602d$var$closestElementOfNode(node2);
    if (!el) return false;
    try {
        if (typeof blockClass === "string") {
            if (el.classList.contains(blockClass)) return true;
            if (checkAncestors && el.closest("." + blockClass) !== null) return true;
        } else {
            if ($f1b1811a0002602d$var$classMatchesRegex(el, blockClass, checkAncestors)) return true;
        }
    } catch (e2) {}
    if (blockSelector) {
        if (el.matches(blockSelector)) return true;
        if (checkAncestors && el.closest(blockSelector) !== null) return true;
    }
    return false;
}
function $f1b1811a0002602d$var$isSerialized(n2, mirror2) {
    return mirror2.getId(n2) !== -1;
}
function $f1b1811a0002602d$var$isIgnored(n2, mirror2, slimDOMOptions) {
    if (n2.tagName === "TITLE" && slimDOMOptions.headTitleMutations) return true;
    return mirror2.getId(n2) === $f1b1811a0002602d$var$IGNORED_NODE;
}
function $f1b1811a0002602d$var$isAncestorRemoved(target, mirror2) {
    if ($f1b1811a0002602d$var$isShadowRoot(target)) return false;
    var id = mirror2.getId(target);
    if (!mirror2.has(id)) return true;
    var parent = $f1b1811a0002602d$var$index.parentNode(target);
    if (parent && parent.nodeType === target.DOCUMENT_NODE) return false;
    if (!parent) return true;
    return $f1b1811a0002602d$var$isAncestorRemoved(parent, mirror2);
}
function $f1b1811a0002602d$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $f1b1811a0002602d$var$polyfill$1(win) {
    if (win === void 0) win = window;
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
}
function $f1b1811a0002602d$var$isSerializedIframe(n2, mirror2) {
    return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function $f1b1811a0002602d$var$isSerializedStylesheet(n2, mirror2) {
    return Boolean(n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2));
}
function $f1b1811a0002602d$var$hasShadowRoot(n2) {
    if (!n2) return false;
    if ($f1b1811a0002602d$var$_instanceof(n2, $f1b1811a0002602d$var$BaseRRNode) && "shadowRoot" in n2) return Boolean(n2.shadowRoot);
    return Boolean($f1b1811a0002602d$var$index.shadowRoot(n2));
}
var $f1b1811a0002602d$var$StyleSheetMirror = /*#__PURE__*/ function() {
    function StyleSheetMirror() {
        $f1b1811a0002602d$var$__publicField(this, "id", 1);
        $f1b1811a0002602d$var$__publicField(this, "styleIDMap", /* @__PURE__ */ new WeakMap());
        $f1b1811a0002602d$var$__publicField(this, "idStyleMap", /* @__PURE__ */ new Map());
    }
    var _proto = StyleSheetMirror.prototype;
    _proto.getId = function getId(stylesheet) {
        var _this_styleIDMap_get;
        return (_this_styleIDMap_get = this.styleIDMap.get(stylesheet)) != null ? _this_styleIDMap_get : -1;
    };
    _proto.has = function has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    };
    /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */ _proto.add = function add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        var newId;
        if (id === void 0) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    };
    _proto.getStyle = function getStyle(id) {
        return this.idStyleMap.get(id) || null;
    };
    _proto.reset = function reset() {
        this.styleIDMap = /* @__PURE__ */ new WeakMap();
        this.idStyleMap = /* @__PURE__ */ new Map();
        this.id = 1;
    };
    _proto.generateId = function generateId() {
        return this.id++;
    };
    return StyleSheetMirror;
}();
function $f1b1811a0002602d$var$getShadowHost(n2) {
    var _a2;
    var shadowHost = null;
    if ("getRootNode" in n2 && ((_a2 = $f1b1811a0002602d$var$index.getRootNode(n2)) == null ? void 0 : _a2.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && $f1b1811a0002602d$var$index.host($f1b1811a0002602d$var$index.getRootNode(n2))) shadowHost = $f1b1811a0002602d$var$index.host($f1b1811a0002602d$var$index.getRootNode(n2));
    return shadowHost;
}
function $f1b1811a0002602d$var$getRootShadowHost(n2) {
    var rootShadowHost = n2;
    var shadowHost;
    while(shadowHost = $f1b1811a0002602d$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $f1b1811a0002602d$var$shadowHostInDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    var shadowHost = $f1b1811a0002602d$var$getRootShadowHost(n2);
    return $f1b1811a0002602d$var$index.contains(doc, shadowHost);
}
function $f1b1811a0002602d$var$inDom(n2) {
    var doc = n2.ownerDocument;
    if (!doc) return false;
    return $f1b1811a0002602d$var$index.contains(doc, n2) || $f1b1811a0002602d$var$shadowHostInDom(n2);
}
var $f1b1811a0002602d$var$EventType = /* @__PURE__ */ function(EventType2) {
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
}($f1b1811a0002602d$var$EventType || {});
var $f1b1811a0002602d$var$IncrementalSource = /* @__PURE__ */ function(IncrementalSource2) {
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
}($f1b1811a0002602d$var$IncrementalSource || {});
var $f1b1811a0002602d$var$MouseInteractions = /* @__PURE__ */ function(MouseInteractions2) {
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
}($f1b1811a0002602d$var$MouseInteractions || {});
var $f1b1811a0002602d$var$PointerTypes = /* @__PURE__ */ function(PointerTypes2) {
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
}($f1b1811a0002602d$var$PointerTypes || {});
var $f1b1811a0002602d$var$CanvasContext = /* @__PURE__ */ function(CanvasContext2) {
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
}($f1b1811a0002602d$var$CanvasContext || {});
var $f1b1811a0002602d$var$MediaInteractions = /* @__PURE__ */ function(MediaInteractions2) {
    MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
    MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
    MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
    MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
    MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
    return MediaInteractions2;
}($f1b1811a0002602d$var$MediaInteractions || {});
var $f1b1811a0002602d$var$NodeType = /* @__PURE__ */ function(NodeType2) {
    NodeType2[NodeType2["Document"] = 0] = "Document";
    NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
    NodeType2[NodeType2["Element"] = 2] = "Element";
    NodeType2[NodeType2["Text"] = 3] = "Text";
    NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
    NodeType2[NodeType2["Comment"] = 5] = "Comment";
    return NodeType2;
}($f1b1811a0002602d$var$NodeType || {});
function $f1b1811a0002602d$var$isNodeInLinkedList(n2) {
    return "__ln" in n2;
}
var $f1b1811a0002602d$var$DoubleLinkedList = /*#__PURE__*/ function() {
    function DoubleLinkedList() {
        $f1b1811a0002602d$var$__publicField(this, "length", 0);
        $f1b1811a0002602d$var$__publicField(this, "head", null);
        $f1b1811a0002602d$var$__publicField(this, "tail", null);
    }
    var _proto = DoubleLinkedList.prototype;
    _proto.get = function get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        var current = this.head;
        for(var index2 = 0; index2 < position; index2++)current = (current == null ? void 0 : current.next) || null;
        return current;
    };
    _proto.addNode = function addNode(n2) {
        var node2 = {
            value: n2,
            previous: null,
            next: null
        };
        n2.__ln = node2;
        if (n2.previousSibling && $f1b1811a0002602d$var$isNodeInLinkedList(n2.previousSibling)) {
            var current = n2.previousSibling.__ln.next;
            node2.next = current;
            node2.previous = n2.previousSibling.__ln;
            n2.previousSibling.__ln.next = node2;
            if (current) current.previous = node2;
        } else if (n2.nextSibling && $f1b1811a0002602d$var$isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
            var current1 = n2.nextSibling.__ln.previous;
            node2.previous = current1;
            node2.next = n2.nextSibling.__ln;
            n2.nextSibling.__ln.previous = node2;
            if (current1) current1.next = node2;
        } else {
            if (this.head) this.head.previous = node2;
            node2.next = this.head;
            this.head = node2;
        }
        if (node2.next === null) this.tail = node2;
        this.length++;
    };
    _proto.removeNode = function removeNode(n2) {
        var current = n2.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n2.__ln) delete n2.__ln;
        this.length--;
    };
    return DoubleLinkedList;
}();
var $f1b1811a0002602d$var$moveKey = function(id, parentId) {
    return id + "@" + parentId;
};
var $f1b1811a0002602d$var$MutationBuffer = /*#__PURE__*/ function() {
    function MutationBuffer() {
        var _this = this;
        $f1b1811a0002602d$var$__publicField(this, "frozen", false);
        $f1b1811a0002602d$var$__publicField(this, "locked", false);
        $f1b1811a0002602d$var$__publicField(this, "texts", []);
        $f1b1811a0002602d$var$__publicField(this, "attributes", []);
        $f1b1811a0002602d$var$__publicField(this, "attributeMap", /* @__PURE__ */ new WeakMap());
        $f1b1811a0002602d$var$__publicField(this, "removes", []);
        $f1b1811a0002602d$var$__publicField(this, "mapRemoves", []);
        $f1b1811a0002602d$var$__publicField(this, "movedMap", {});
        /**
     * the browser MutationObserver emits multiple mutations after
     * a delay for performance reasons, making tracing added nodes hard
     * in our `processMutations` callback function.
     * For example, if we append an element el_1 into body, and then append
     * another element el_2 into el_1, these two mutations may be passed to the
     * callback function together when the two operations were done.
     * Generally we need to trace child nodes of newly added nodes, but in this
     * case if we count el_2 as el_1's child node in the first mutation record,
     * then we will count el_2 again in the second mutation record which was
     * duplicated.
     * To avoid of duplicate counting added nodes, we use a Set to store
     * added nodes and its child nodes during iterate mutation records. Then
     * collect added nodes from the Set which have no duplicate copy. But
     * this also causes newly added nodes will not be serialized with id ASAP,
     * which means all the id related calculation should be lazy too.
     */ $f1b1811a0002602d$var$__publicField(this, "addedSet", /* @__PURE__ */ new Set());
        $f1b1811a0002602d$var$__publicField(this, "movedSet", /* @__PURE__ */ new Set());
        $f1b1811a0002602d$var$__publicField(this, "droppedSet", /* @__PURE__ */ new Set());
        $f1b1811a0002602d$var$__publicField(this, "removesSubTreeCache", /* @__PURE__ */ new Set());
        $f1b1811a0002602d$var$__publicField(this, "mutationCb");
        $f1b1811a0002602d$var$__publicField(this, "blockClass");
        $f1b1811a0002602d$var$__publicField(this, "blockSelector");
        $f1b1811a0002602d$var$__publicField(this, "maskTextClass");
        $f1b1811a0002602d$var$__publicField(this, "maskTextSelector");
        $f1b1811a0002602d$var$__publicField(this, "inlineStylesheet");
        $f1b1811a0002602d$var$__publicField(this, "maskInputOptions");
        $f1b1811a0002602d$var$__publicField(this, "maskTextFn");
        $f1b1811a0002602d$var$__publicField(this, "maskInputFn");
        $f1b1811a0002602d$var$__publicField(this, "keepIframeSrcFn");
        $f1b1811a0002602d$var$__publicField(this, "recordCanvas");
        $f1b1811a0002602d$var$__publicField(this, "inlineImages");
        $f1b1811a0002602d$var$__publicField(this, "slimDOMOptions");
        $f1b1811a0002602d$var$__publicField(this, "dataURLOptions");
        $f1b1811a0002602d$var$__publicField(this, "doc");
        $f1b1811a0002602d$var$__publicField(this, "mirror");
        $f1b1811a0002602d$var$__publicField(this, "iframeManager");
        $f1b1811a0002602d$var$__publicField(this, "stylesheetManager");
        $f1b1811a0002602d$var$__publicField(this, "shadowDomManager");
        $f1b1811a0002602d$var$__publicField(this, "canvasManager");
        $f1b1811a0002602d$var$__publicField(this, "processedNodeManager");
        $f1b1811a0002602d$var$__publicField(this, "unattachedDoc");
        $f1b1811a0002602d$var$__publicField(this, "processMutations", function(mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        });
        $f1b1811a0002602d$var$__publicField(this, "emit", function() {
            if (_this.frozen || _this.locked) return;
            var adds = [];
            var addedIds = /* @__PURE__ */ new Set();
            var addList = new $f1b1811a0002602d$var$DoubleLinkedList();
            var getNextId = function(n2) {
                var ns = n2;
                var nextId = $f1b1811a0002602d$var$IGNORED_NODE;
                while(nextId === $f1b1811a0002602d$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function(n2) {
                var parent = $f1b1811a0002602d$var$index.parentNode(n2);
                if (!parent || !$f1b1811a0002602d$var$inDom(n2)) return;
                var cssCaptured = false;
                if (n2.nodeType === Node.TEXT_NODE) {
                    var parentTag = parent.tagName;
                    if (parentTag === "TEXTAREA") return;
                    else if (parentTag === "STYLE" && _this.addedSet.has(parent)) cssCaptured = true;
                }
                var parentId = $f1b1811a0002602d$var$isShadowRoot(parent) ? _this.mirror.getId($f1b1811a0002602d$var$getShadowHost(n2)) : _this.mirror.getId(parent);
                var nextId = getNextId(n2);
                if (parentId === -1 || nextId === -1) return addList.addNode(n2);
                var sn = $f1b1811a0002602d$var$serializeNodeWithId(n2, {
                    doc: _this.doc,
                    mirror: _this.mirror,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskTextClass: _this.maskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    dataURLOptions: _this.dataURLOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function(currentN) {
                        if ($f1b1811a0002602d$var$isSerializedIframe(currentN, _this.mirror)) _this.iframeManager.addIframe(currentN);
                        if ($f1b1811a0002602d$var$isSerializedStylesheet(currentN, _this.mirror)) _this.stylesheetManager.trackLinkElement(currentN);
                        if ($f1b1811a0002602d$var$hasShadowRoot(n2)) _this.shadowDomManager.addShadowRoot($f1b1811a0002602d$var$index.shadowRoot(n2), _this.doc);
                    },
                    onIframeLoad: function(iframe, childSn) {
                        _this.iframeManager.attachIframe(iframe, childSn);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: function(link, childSn) {
                        _this.stylesheetManager.attachLinkElement(link, childSn);
                    },
                    cssCaptured: cssCaptured
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(_this.mapRemoves.length)_this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(_this.movedSet), _step; !(_step = _iterator()).done;){
                var n2 = _step.value;
                if ($f1b1811a0002602d$var$isParentRemoved(_this.removesSubTreeCache, n2, _this.mirror) && !_this.movedSet.has($f1b1811a0002602d$var$index.parentNode(n2))) continue;
                pushAdd(n2);
            }
            for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(_this.addedSet), _step1; !(_step1 = _iterator1()).done;){
                var n21 = _step1.value;
                if (!$f1b1811a0002602d$var$isAncestorInSet(_this.droppedSet, n21) && !$f1b1811a0002602d$var$isParentRemoved(_this.removesSubTreeCache, n21, _this.mirror)) pushAdd(n21);
                else if ($f1b1811a0002602d$var$isAncestorInSet(_this.movedSet, n21)) pushAdd(n21);
                else _this.droppedSet.add(n21);
            }
            var candidate = null;
            while(addList.length){
                var node2 = null;
                if (candidate) {
                    var parentId = _this.mirror.getId($f1b1811a0002602d$var$index.parentNode(candidate.value));
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node2 = candidate;
                }
                if (!node2) {
                    var tailNode = addList.tail;
                    while(tailNode){
                        var _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            var parentId1 = _this.mirror.getId($f1b1811a0002602d$var$index.parentNode(_node.value));
                            var nextId1 = getNextId(_node.value);
                            if (nextId1 === -1) continue;
                            else if (parentId1 !== -1) {
                                node2 = _node;
                                break;
                            } else {
                                var unhandledNode = _node.value;
                                var parent = $f1b1811a0002602d$var$index.parentNode(unhandledNode);
                                if (parent && parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    var shadowHost = $f1b1811a0002602d$var$index.host(parent);
                                    var parentId2 = _this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node2 = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node2) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node2.previous;
                addList.removeNode(node2.value);
                pushAdd(node2.value);
            }
            var payload = {
                texts: _this.texts.map(function(text) {
                    var n2 = text.node;
                    var parent = $f1b1811a0002602d$var$index.parentNode(n2);
                    if (parent && parent.tagName === "TEXTAREA") _this.genTextAreaValueMutation(parent);
                    return {
                        id: _this.mirror.getId(n2),
                        value: text.value
                    };
                }).filter(function(text) {
                    return !addedIds.has(text.id);
                }).filter(function(text) {
                    return _this.mirror.has(text.id);
                }),
                attributes: _this.attributes.map(function(attribute) {
                    var attributes = attribute.attributes;
                    if (typeof attributes.style === "string") {
                        var diffAsStr = JSON.stringify(attribute.styleDiff);
                        var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: _this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter(function(attribute) {
                    return !addedIds.has(attribute.id);
                }).filter(function(attribute) {
                    return _this.mirror.has(attribute.id);
                }),
                removes: _this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            _this.texts = [];
            _this.attributes = [];
            _this.attributeMap = /* @__PURE__ */ new WeakMap();
            _this.removes = [];
            _this.addedSet = /* @__PURE__ */ new Set();
            _this.movedSet = /* @__PURE__ */ new Set();
            _this.droppedSet = /* @__PURE__ */ new Set();
            _this.removesSubTreeCache = /* @__PURE__ */ new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        });
        $f1b1811a0002602d$var$__publicField(this, "genTextAreaValueMutation", function(textarea) {
            var item = _this.attributeMap.get(textarea);
            if (!item) {
                item = {
                    node: textarea,
                    attributes: {},
                    styleDiff: {},
                    _unchangedStyles: {}
                };
                _this.attributes.push(item);
                _this.attributeMap.set(textarea, item);
            }
            item.attributes.value = Array.from($f1b1811a0002602d$var$index.childNodes(textarea), function(cn) {
                return $f1b1811a0002602d$var$index.textContent(cn) || "";
            }).join("");
        });
        $f1b1811a0002602d$var$__publicField(this, "processMutation", function(m) {
            if ($f1b1811a0002602d$var$isIgnored(m.target, _this.mirror, _this.slimDOMOptions)) return;
            switch(m.type){
                case "characterData":
                    var value = $f1b1811a0002602d$var$index.textContent(m.target);
                    if (!$f1b1811a0002602d$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) && value !== m.oldValue) _this.texts.push({
                        value: $f1b1811a0002602d$var$needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, true) && value ? _this.maskTextFn ? _this.maskTextFn(value, $f1b1811a0002602d$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                        node: m.target
                    });
                    break;
                case "attributes":
                    var target = m.target;
                    var attributeName = m.attributeName;
                    var value1 = m.target.getAttribute(attributeName);
                    if (attributeName === "value") {
                        var type = $f1b1811a0002602d$var$getInputType(target);
                        value1 = $f1b1811a0002602d$var$maskInputValue({
                            element: target,
                            maskInputOptions: _this.maskInputOptions,
                            tagName: target.tagName,
                            type: type,
                            value: value1,
                            maskInputFn: _this.maskInputFn
                        });
                    }
                    if ($f1b1811a0002602d$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || value1 === m.oldValue) return;
                    var item = _this.attributeMap.get(m.target);
                    if (target.tagName === "IFRAME" && attributeName === "src" && !_this.keepIframeSrcFn(value1)) {
                        if (!target.contentDocument) attributeName = "rr_src";
                        else return;
                    }
                    if (!item) {
                        item = {
                            node: m.target,
                            attributes: {},
                            styleDiff: {},
                            _unchangedStyles: {}
                        };
                        _this.attributes.push(item);
                        _this.attributeMap.set(m.target, item);
                    }
                    if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                    if (!$f1b1811a0002602d$var$ignoreAttribute(target.tagName, attributeName)) {
                        item.attributes[attributeName] = $f1b1811a0002602d$var$transformAttribute(_this.doc, $f1b1811a0002602d$var$toLowerCase(target.tagName), $f1b1811a0002602d$var$toLowerCase(attributeName), value1);
                        if (attributeName === "style") {
                            if (!_this.unattachedDoc) try {
                                _this.unattachedDoc = document.implementation.createHTMLDocument();
                            } catch (e2) {
                                _this.unattachedDoc = _this.doc;
                            }
                            var old = _this.unattachedDoc.createElement("span");
                            if (m.oldValue) old.setAttribute("style", m.oldValue);
                            for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(Array.from(target.style)), _step; !(_step = _iterator()).done;){
                                var pname = _step.value;
                                var newValue = target.style.getPropertyValue(pname);
                                var newPriority = target.style.getPropertyPriority(pname);
                                if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                    if (newPriority === "") item.styleDiff[pname] = newValue;
                                    else item.styleDiff[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                } else item._unchangedStyles[pname] = [
                                    newValue,
                                    newPriority
                                ];
                            }
                            for(var _iterator1 = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(Array.from(old.style)), _step1; !(_step1 = _iterator1()).done;){
                                var pname1 = _step1.value;
                                if (target.style.getPropertyValue(pname1) === "") item.styleDiff[pname1] = false;
                            }
                        } else if (attributeName === "open" && target.tagName === "DIALOG") {
                            if (target.matches("dialog:modal")) item.attributes["rr_open_mode"] = "modal";
                            else item.attributes["rr_open_mode"] = "non-modal";
                        }
                    }
                    break;
                case "childList":
                    if ($f1b1811a0002602d$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, true)) return;
                    if (m.target.tagName === "TEXTAREA") {
                        _this.genTextAreaValueMutation(m.target);
                        return;
                    }
                    m.addedNodes.forEach(function(n2) {
                        return _this.genAdds(n2, m.target);
                    });
                    m.removedNodes.forEach(function(n2) {
                        var nodeId = _this.mirror.getId(n2);
                        var parentId = $f1b1811a0002602d$var$isShadowRoot(m.target) ? _this.mirror.getId($f1b1811a0002602d$var$index.host(m.target)) : _this.mirror.getId(m.target);
                        if ($f1b1811a0002602d$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || $f1b1811a0002602d$var$isIgnored(n2, _this.mirror, _this.slimDOMOptions) || !$f1b1811a0002602d$var$isSerialized(n2, _this.mirror)) return;
                        if (_this.addedSet.has(n2)) {
                            $f1b1811a0002602d$var$deepDelete(_this.addedSet, n2);
                            _this.droppedSet.add(n2);
                        } else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($f1b1811a0002602d$var$isAncestorRemoved(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n2) && _this.movedMap[$f1b1811a0002602d$var$moveKey(nodeId, parentId)]) $f1b1811a0002602d$var$deepDelete(_this.movedSet, n2);
                        else {
                            _this.removes.push({
                                parentId: parentId,
                                id: nodeId,
                                isShadow: $f1b1811a0002602d$var$isShadowRoot(m.target) && $f1b1811a0002602d$var$isNativeShadowDom(m.target) ? true : void 0
                            });
                            $f1b1811a0002602d$var$processRemoves(n2, _this.removesSubTreeCache);
                        }
                        _this.mapRemoves.push(n2);
                    });
                    break;
            }
        });
        /**
     * Make sure you check if `n`'s parent is blocked before calling this function
     * */ $f1b1811a0002602d$var$__publicField(this, "genAdds", function(n2, target) {
            if (_this.processedNodeManager.inOtherBuffer(n2, _this)) return;
            if (_this.addedSet.has(n2) || _this.movedSet.has(n2)) return;
            if (_this.mirror.hasNode(n2)) {
                if ($f1b1811a0002602d$var$isIgnored(n2, _this.mirror, _this.slimDOMOptions)) return;
                _this.movedSet.add(n2);
                var targetId = null;
                if (target && _this.mirror.hasNode(target)) targetId = _this.mirror.getId(target);
                if (targetId && targetId !== -1) _this.movedMap[$f1b1811a0002602d$var$moveKey(_this.mirror.getId(n2), targetId)] = true;
            } else {
                _this.addedSet.add(n2);
                _this.droppedSet.delete(n2);
            }
            if (!$f1b1811a0002602d$var$isBlocked(n2, _this.blockClass, _this.blockSelector, false)) {
                $f1b1811a0002602d$var$index.childNodes(n2).forEach(function(childN) {
                    return _this.genAdds(childN);
                });
                if ($f1b1811a0002602d$var$hasShadowRoot(n2)) $f1b1811a0002602d$var$index.childNodes($f1b1811a0002602d$var$index.shadowRoot(n2)).forEach(function(childN) {
                    _this.processedNodeManager.add(childN, _this);
                    _this.genAdds(childN, n2);
                });
            }
        });
    }
    var _proto = MutationBuffer.prototype;
    _proto.init = function init(options) {
        var _this = this;
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "maskTextClass",
            "maskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach(function(key) {
            _this[key] = options[key];
        });
    };
    _proto.freeze = function freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    };
    _proto.unfreeze = function unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    };
    _proto.isFrozen = function isFrozen() {
        return this.frozen;
    };
    _proto.lock = function lock() {
        this.locked = true;
        this.canvasManager.lock();
    };
    _proto.unlock = function unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    };
    _proto.reset = function reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    };
    return MutationBuffer;
}();
function $f1b1811a0002602d$var$deepDelete(addsSet, n2) {
    addsSet.delete(n2);
    $f1b1811a0002602d$var$index.childNodes(n2).forEach(function(childN) {
        return $f1b1811a0002602d$var$deepDelete(addsSet, childN);
    });
}
function $f1b1811a0002602d$var$processRemoves(n2, cache) {
    var queue = [
        n2
    ];
    while(queue.length){
        var next = queue.pop();
        if (cache.has(next)) continue;
        cache.add(next);
        $f1b1811a0002602d$var$index.childNodes(next).forEach(function(n22) {
            return queue.push(n22);
        });
    }
    return;
}
function $f1b1811a0002602d$var$isParentRemoved(removes, n2, mirror2) {
    if (removes.size === 0) return false;
    return $f1b1811a0002602d$var$_isParentRemoved(removes, n2);
}
function $f1b1811a0002602d$var$_isParentRemoved(removes, n2, _mirror2) {
    var node2 = $f1b1811a0002602d$var$index.parentNode(n2);
    if (!node2) return false;
    return removes.has(node2);
}
function $f1b1811a0002602d$var$isAncestorInSet(set, n2) {
    if (set.size === 0) return false;
    return $f1b1811a0002602d$var$_isAncestorInSet(set, n2);
}
function $f1b1811a0002602d$var$_isAncestorInSet(set, n2) {
    var parent = $f1b1811a0002602d$var$index.parentNode(n2);
    if (!parent) return false;
    if (set.has(parent)) return true;
    return $f1b1811a0002602d$var$_isAncestorInSet(set, parent);
}
var $f1b1811a0002602d$var$errorHandler;
function $f1b1811a0002602d$var$registerErrorHandler(handler) {
    $f1b1811a0002602d$var$errorHandler = handler;
}
function $f1b1811a0002602d$var$unregisterErrorHandler() {
    $f1b1811a0002602d$var$errorHandler = void 0;
}
var $f1b1811a0002602d$var$callbackWrapper = function(cb) {
    if (!$f1b1811a0002602d$var$errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
        try {
            return cb.apply(void 0, [].concat(rest));
        } catch (error) {
            if ($f1b1811a0002602d$var$errorHandler && $f1b1811a0002602d$var$errorHandler(error) === true) return;
            throw error;
        }
    };
    return rrwebWrapped;
};
var $f1b1811a0002602d$var$mutationBuffers = [];
function $f1b1811a0002602d$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            var path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e) {}
    return event && event.target;
}
function $f1b1811a0002602d$var$initMutationObserver(options, rootEl) {
    var mutationBuffer = new $f1b1811a0002602d$var$MutationBuffer();
    $f1b1811a0002602d$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    var observer = new ($f1b1811a0002602d$var$mutationObserverCtor())($f1b1811a0002602d$var$callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $f1b1811a0002602d$var$initMoveObserver(param) {
    var mousemoveCb = param.mousemoveCb, sampling = param.sampling, doc = param.doc, mirror2 = param.mirror;
    if (sampling.mousemove === false) return function() {};
    var threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = $f1b1811a0002602d$var$throttle($f1b1811a0002602d$var$callbackWrapper(function(source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function(p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    var updatePosition = $f1b1811a0002602d$var$callbackWrapper($f1b1811a0002602d$var$throttle($f1b1811a0002602d$var$callbackWrapper(function(evt) {
        var target = $f1b1811a0002602d$var$getEventTarget(evt);
        var _ref = $f1b1811a0002602d$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt, clientX = _ref.clientX, clientY = _ref.clientY;
        if (!timeBaseline) timeBaseline = $f1b1811a0002602d$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror2.getId(target),
            timeOffset: $f1b1811a0002602d$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && $f1b1811a0002602d$var$_instanceof(evt, DragEvent) ? $f1b1811a0002602d$var$IncrementalSource.Drag : $f1b1811a0002602d$var$_instanceof(evt, MouseEvent) ? $f1b1811a0002602d$var$IncrementalSource.MouseMove : $f1b1811a0002602d$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    var handlers = [
        $f1b1811a0002602d$var$on("mousemove", updatePosition, doc),
        $f1b1811a0002602d$var$on("touchmove", updatePosition, doc),
        $f1b1811a0002602d$var$on("drag", updatePosition, doc)
    ];
    return $f1b1811a0002602d$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $f1b1811a0002602d$var$initMouseInteractionObserver(param) {
    var mouseInteractionCb = param.mouseInteractionCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    if (sampling.mouseInteraction === false) return function() {};
    var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
    var handlers = [];
    var currentPointerType = null;
    var getHandler = function(eventKey) {
        return function(event) {
            var target = $f1b1811a0002602d$var$getEventTarget(event);
            if ($f1b1811a0002602d$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var pointerType = null;
            var thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $f1b1811a0002602d$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $f1b1811a0002602d$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $f1b1811a0002602d$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $f1b1811a0002602d$var$PointerTypes.Touch) {
                    if ($f1b1811a0002602d$var$MouseInteractions[eventKey] === $f1b1811a0002602d$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($f1b1811a0002602d$var$MouseInteractions[eventKey] === $f1b1811a0002602d$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $f1b1811a0002602d$var$PointerTypes.Pen;
            } else if ($f1b1811a0002602d$var$legacy_isTouchEvent(event)) pointerType = $f1b1811a0002602d$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $f1b1811a0002602d$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $f1b1811a0002602d$var$PointerTypes.Mouse) pointerType = null;
            } else if ($f1b1811a0002602d$var$MouseInteractions[eventKey] === $f1b1811a0002602d$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            var e2 = $f1b1811a0002602d$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e2) return;
            var id = mirror2.getId(target);
            var clientX = e2.clientX, clientY = e2.clientY;
            $f1b1811a0002602d$var$callbackWrapper(mouseInteractionCb)($f1b1811a0002602d$var$_extends({
                type: $f1b1811a0002602d$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys($f1b1811a0002602d$var$MouseInteractions).filter(function(key) {
        return Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false;
    }).forEach(function(eventKey) {
        var eventName = $f1b1811a0002602d$var$toLowerCase(eventKey);
        var handler = getHandler(eventKey);
        if (window.PointerEvent) switch($f1b1811a0002602d$var$MouseInteractions[eventKey]){
            case $f1b1811a0002602d$var$MouseInteractions.MouseDown:
            case $f1b1811a0002602d$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $f1b1811a0002602d$var$MouseInteractions.TouchStart:
            case $f1b1811a0002602d$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($f1b1811a0002602d$var$on(eventName, handler, doc));
    });
    return $f1b1811a0002602d$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $f1b1811a0002602d$var$initScrollObserver(param) {
    var scrollCb = param.scrollCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    var updatePosition = $f1b1811a0002602d$var$callbackWrapper($f1b1811a0002602d$var$throttle($f1b1811a0002602d$var$callbackWrapper(function(evt) {
        var target = $f1b1811a0002602d$var$getEventTarget(evt);
        if (!target || $f1b1811a0002602d$var$isBlocked(target, blockClass, blockSelector, true)) return;
        var id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
            var scrollLeftTop = $f1b1811a0002602d$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $f1b1811a0002602d$var$on("scroll", updatePosition, doc);
}
function $f1b1811a0002602d$var$initViewportResizeObserver(param, param1) {
    var viewportResizeCb = param.viewportResizeCb;
    var win = param1.win;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = $f1b1811a0002602d$var$callbackWrapper($f1b1811a0002602d$var$throttle($f1b1811a0002602d$var$callbackWrapper(function() {
        var height = $f1b1811a0002602d$var$getWindowHeight();
        var width = $f1b1811a0002602d$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $f1b1811a0002602d$var$on("resize", updateDimension, win);
}
var $f1b1811a0002602d$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
var $f1b1811a0002602d$var$lastInputValueMap = /* @__PURE__ */ new WeakMap();
function $f1b1811a0002602d$var$initInputObserver(param) {
    var inputCb = param.inputCb, doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, ignoreClass = param.ignoreClass, ignoreSelector = param.ignoreSelector, maskInputOptions = param.maskInputOptions, maskInputFn = param.maskInputFn, sampling = param.sampling, userTriggeredOnInput = param.userTriggeredOnInput;
    function eventHandler(event) {
        var target = $f1b1811a0002602d$var$getEventTarget(event);
        var userTriggered = event.isTrusted;
        var tagName = target && target.tagName;
        if (target && tagName === "OPTION") target = $f1b1811a0002602d$var$index.parentElement(target);
        if (!target || !tagName || $f1b1811a0002602d$var$INPUT_TAGS.indexOf(tagName) < 0 || $f1b1811a0002602d$var$isBlocked(target, blockClass, blockSelector, true)) return;
        if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) return;
        var text = target.value;
        var isChecked = false;
        var type = $f1b1811a0002602d$var$getInputType(target) || "";
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) text = $f1b1811a0002602d$var$maskInputValue({
            element: target,
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        var name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll('input[type="radio"][name="' + name + '"]').forEach(function(el) {
            if (el !== target) {
                var text2 = el.value;
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text2,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text2,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v2) {
        var lastInputValue = $f1b1811a0002602d$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
            $f1b1811a0002602d$var$lastInputValueMap.set(target, v2);
            var id = mirror2.getId(target);
            $f1b1811a0002602d$var$callbackWrapper(inputCb)($f1b1811a0002602d$var$_extends({}, v2, {
                id: id
            }));
        }
    }
    var events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    var handlers = events.map(function(eventName) {
        return $f1b1811a0002602d$var$on(eventName, $f1b1811a0002602d$var$callbackWrapper(eventHandler), doc);
    });
    var currentWindow = doc.defaultView;
    if (!currentWindow) return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
    var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    var hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        // Some UI library use selectedIndex to set select value
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) {
        var _handlers;
        (_handlers = handlers).push.apply(_handlers, [].concat(hookProperties.map(function(p) {
            return $f1b1811a0002602d$var$hookSetter(p[0], p[1], {
                set: function set() {
                    $f1b1811a0002602d$var$callbackWrapper(eventHandler)({
                        target: this,
                        isTrusted: false
                    });
                }
            }, false, currentWindow);
        })));
    }
    return $f1b1811a0002602d$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $f1b1811a0002602d$var$getNestedCSSRulePositions(rule2) {
    var positions = [];
    function recurse(childRule, pos) {
        if ($f1b1811a0002602d$var$hasNestedCSSRule("CSSGroupingRule") && $f1b1811a0002602d$var$_instanceof(childRule.parentRule, CSSGroupingRule) || $f1b1811a0002602d$var$hasNestedCSSRule("CSSMediaRule") && $f1b1811a0002602d$var$_instanceof(childRule.parentRule, CSSMediaRule) || $f1b1811a0002602d$var$hasNestedCSSRule("CSSSupportsRule") && $f1b1811a0002602d$var$_instanceof(childRule.parentRule, CSSSupportsRule) || $f1b1811a0002602d$var$hasNestedCSSRule("CSSConditionRule") && $f1b1811a0002602d$var$_instanceof(childRule.parentRule, CSSConditionRule)) {
            var rules2 = Array.from(childRule.parentRule.cssRules);
            var index2 = rules2.indexOf(childRule);
            pos.unshift(index2);
        } else if (childRule.parentStyleSheet) {
            var rules21 = Array.from(childRule.parentStyleSheet.cssRules);
            var index21 = rules21.indexOf(childRule);
            pos.unshift(index21);
        }
        return pos;
    }
    return recurse(rule2, positions);
}
function $f1b1811a0002602d$var$getIdAndStyleId(sheet, mirror2, styleMirror) {
    var id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $f1b1811a0002602d$var$initStyleSheetObserver(param, param1) {
    var styleSheetRuleCb = param.styleSheetRuleCb, mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var win = param1.win;
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return function() {};
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $f1b1811a0002602d$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var rule2 = argumentsList[0], index2 = argumentsList[1];
            var _getIdAndStyleId = $f1b1811a0002602d$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule2,
                        index: index2
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    win.CSSStyleSheet.prototype.addRule = function(selector, styleBlock, index2) {
        if (index2 === void 0) index2 = this.cssRules.length;
        var rule2 = selector + " { " + styleBlock + " }";
        return win.CSSStyleSheet.prototype.insertRule.apply(this, [
            rule2,
            index2
        ]);
    };
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $f1b1811a0002602d$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var index2 = argumentsList[0];
            var _getIdAndStyleId = $f1b1811a0002602d$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index2
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    win.CSSStyleSheet.prototype.removeRule = function(index2) {
        return win.CSSStyleSheet.prototype.deleteRule.apply(this, [
            index2
        ]);
    };
    var replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $f1b1811a0002602d$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var text = argumentsList[0];
                var _getIdAndStyleId = $f1b1811a0002602d$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $f1b1811a0002602d$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var text = argumentsList[0];
                var _getIdAndStyleId = $f1b1811a0002602d$var$getIdAndStyleId(thisArg, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var supportedNestedCSSRuleTypes = {};
    if ($f1b1811a0002602d$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($f1b1811a0002602d$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($f1b1811a0002602d$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($f1b1811a0002602d$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
        var typeKey = param[0], type = param[1];
        unmodifiedFunctions[typeKey] = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            insertRule: type.prototype.insertRule,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $f1b1811a0002602d$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var rule2 = argumentsList[0], index2 = argumentsList[1];
                var _getIdAndStyleId = $f1b1811a0002602d$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule2,
                            index: [].concat($f1b1811a0002602d$var$getNestedCSSRulePositions(thisArg), [
                                index2 || 0
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $f1b1811a0002602d$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var index2 = argumentsList[0];
                var _getIdAndStyleId = $f1b1811a0002602d$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [].concat($f1b1811a0002602d$var$getNestedCSSRulePositions(thisArg), [
                                index2
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $f1b1811a0002602d$var$callbackWrapper(function() {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
            var typeKey = param[0], type = param[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $f1b1811a0002602d$var$initAdoptedStyleSheetObserver(param, host2) {
    var mirror2 = param.mirror, stylesheetManager = param.stylesheetManager;
    var _a2, _b, _c;
    var hostId = null;
    if (host2.nodeName === "#document") hostId = mirror2.getId(host2);
    else hostId = mirror2.getId($f1b1811a0002602d$var$index.host(host2));
    var patchTarget = host2.nodeName === "#document" ? (_a2 = host2.defaultView) == null ? void 0 : _a2.Document : (_c = (_b = host2.ownerDocument) == null ? void 0 : _b.defaultView) == null ? void 0 : _c.ShadowRoot;
    var originalPropertyDescriptor = (patchTarget == null ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget == null ? void 0 : patchTarget.prototype, "adoptedStyleSheets") : void 0;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function() {};
    Object.defineProperty(host2, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get: function get() {
            var _a3;
            return (_a3 = originalPropertyDescriptor.get) == null ? void 0 : _a3.call(this);
        },
        set: function set(sheets) {
            var _a3;
            var result2 = (_a3 = originalPropertyDescriptor.set) == null ? void 0 : _a3.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e2) {}
            return result2;
        }
    });
    return $f1b1811a0002602d$var$callbackWrapper(function() {
        Object.defineProperty(host2, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            get: originalPropertyDescriptor.get,
            // eslint-disable-next-line @typescript-eslint/unbound-method
            set: originalPropertyDescriptor.set
        });
    });
}
function $f1b1811a0002602d$var$initStyleDeclarationObserver(param, param1) {
    var styleDeclarationCb = param.styleDeclarationCb, mirror2 = param.mirror, ignoreCSSAttributes = param.ignoreCSSAttributes, stylesheetManager = param.stylesheetManager;
    var win = param1.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $f1b1811a0002602d$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a2;
            var property = argumentsList[0], value = argumentsList[1], priority = argumentsList[2];
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            var _getIdAndStyleId = $f1b1811a0002602d$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $f1b1811a0002602d$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $f1b1811a0002602d$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a2;
            var property = argumentsList[0];
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            var _getIdAndStyleId = $f1b1811a0002602d$var$getIdAndStyleId((_a2 = thisArg.parentRule) == null ? void 0 : _a2.parentStyleSheet, mirror2, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                index: $f1b1811a0002602d$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $f1b1811a0002602d$var$callbackWrapper(function() {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $f1b1811a0002602d$var$initMediaInteractionObserver(param) {
    var mediaInteractionCb = param.mediaInteractionCb, blockClass = param.blockClass, blockSelector = param.blockSelector, mirror2 = param.mirror, sampling = param.sampling, doc = param.doc;
    var handler = $f1b1811a0002602d$var$callbackWrapper(function(type) {
        return $f1b1811a0002602d$var$throttle($f1b1811a0002602d$var$callbackWrapper(function(event) {
            var target = $f1b1811a0002602d$var$getEventTarget(event);
            if (!target || $f1b1811a0002602d$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var currentTime = target.currentTime, volume = target.volume, muted = target.muted, playbackRate = target.playbackRate, loop = target.loop;
            mediaInteractionCb({
                type: type,
                id: mirror2.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate,
                loop: loop
            });
        }), sampling.media || 500);
    });
    var handlers = [
        $f1b1811a0002602d$var$on("play", handler($f1b1811a0002602d$var$MediaInteractions.Play), doc),
        $f1b1811a0002602d$var$on("pause", handler($f1b1811a0002602d$var$MediaInteractions.Pause), doc),
        $f1b1811a0002602d$var$on("seeked", handler($f1b1811a0002602d$var$MediaInteractions.Seeked), doc),
        $f1b1811a0002602d$var$on("volumechange", handler($f1b1811a0002602d$var$MediaInteractions.VolumeChange), doc),
        $f1b1811a0002602d$var$on("ratechange", handler($f1b1811a0002602d$var$MediaInteractions.RateChange), doc)
    ];
    return $f1b1811a0002602d$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $f1b1811a0002602d$var$initFontObserver(param) {
    var fontCb = param.fontCb, doc = param.doc;
    var win = doc.defaultView;
    if (!win) return function() {};
    var handlers = [];
    var fontMap = /* @__PURE__ */ new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace2(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    var restoreHandler = $f1b1811a0002602d$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($f1b1811a0002602d$var$callbackWrapper(function() {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(function() {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $f1b1811a0002602d$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $f1b1811a0002602d$var$initSelectionObserver(param) {
    var doc = param.doc, mirror2 = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, selectionCb = param.selectionCb;
    var collapsed = true;
    var updateSelection = $f1b1811a0002602d$var$callbackWrapper(function() {
        var selection = doc.getSelection();
        if (!selection || collapsed && (selection == null ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        var ranges = [];
        var count = selection.rangeCount || 0;
        for(var i2 = 0; i2 < count; i2++){
            var range = selection.getRangeAt(i2);
            var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
            var blocked = $f1b1811a0002602d$var$isBlocked(startContainer, blockClass, blockSelector, true) || $f1b1811a0002602d$var$isBlocked(endContainer, blockClass, blockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror2.getId(startContainer),
                startOffset: startOffset,
                end: mirror2.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $f1b1811a0002602d$var$on("selectionchange", updateSelection);
}
function $f1b1811a0002602d$var$initCustomElementObserver(param) {
    var doc = param.doc, customElementCb = param.customElementCb;
    var win = doc.defaultView;
    if (!win || !win.customElements) return function() {};
    var restoreHandler = $f1b1811a0002602d$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e2) {
                console.warn("Custom element callback failed for " + name);
            }
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $f1b1811a0002602d$var$mergeHooks(o2, hooks) {
    var mutationCb = o2.mutationCb, mousemoveCb = o2.mousemoveCb, mouseInteractionCb = o2.mouseInteractionCb, scrollCb = o2.scrollCb, viewportResizeCb = o2.viewportResizeCb, inputCb = o2.inputCb, mediaInteractionCb = o2.mediaInteractionCb, styleSheetRuleCb = o2.styleSheetRuleCb, styleDeclarationCb = o2.styleDeclarationCb, canvasMutationCb = o2.canvasMutationCb, fontCb = o2.fontCb, selectionCb = o2.selectionCb, customElementCb = o2.customElementCb;
    o2.mutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mutation) {
            var _hooks;
            (_hooks = hooks).mutation.apply(_hooks, [].concat(p));
        }
        mutationCb.apply(void 0, [].concat(p));
    };
    o2.mousemoveCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mousemove) {
            var _hooks;
            (_hooks = hooks).mousemove.apply(_hooks, [].concat(p));
        }
        mousemoveCb.apply(void 0, [].concat(p));
    };
    o2.mouseInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mouseInteraction) {
            var _hooks;
            (_hooks = hooks).mouseInteraction.apply(_hooks, [].concat(p));
        }
        mouseInteractionCb.apply(void 0, [].concat(p));
    };
    o2.scrollCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.scroll) {
            var _hooks;
            (_hooks = hooks).scroll.apply(_hooks, [].concat(p));
        }
        scrollCb.apply(void 0, [].concat(p));
    };
    o2.viewportResizeCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.viewportResize) {
            var _hooks;
            (_hooks = hooks).viewportResize.apply(_hooks, [].concat(p));
        }
        viewportResizeCb.apply(void 0, [].concat(p));
    };
    o2.inputCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.input) {
            var _hooks;
            (_hooks = hooks).input.apply(_hooks, [].concat(p));
        }
        inputCb.apply(void 0, [].concat(p));
    };
    o2.mediaInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.mediaInteaction) {
            var _hooks;
            (_hooks = hooks).mediaInteaction.apply(_hooks, [].concat(p));
        }
        mediaInteractionCb.apply(void 0, [].concat(p));
    };
    o2.styleSheetRuleCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.styleSheetRule) {
            var _hooks;
            (_hooks = hooks).styleSheetRule.apply(_hooks, [].concat(p));
        }
        styleSheetRuleCb.apply(void 0, [].concat(p));
    };
    o2.styleDeclarationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.styleDeclaration) {
            var _hooks;
            (_hooks = hooks).styleDeclaration.apply(_hooks, [].concat(p));
        }
        styleDeclarationCb.apply(void 0, [].concat(p));
    };
    o2.canvasMutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.canvasMutation) {
            var _hooks;
            (_hooks = hooks).canvasMutation.apply(_hooks, [].concat(p));
        }
        canvasMutationCb.apply(void 0, [].concat(p));
    };
    o2.fontCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.font) {
            var _hooks;
            (_hooks = hooks).font.apply(_hooks, [].concat(p));
        }
        fontCb.apply(void 0, [].concat(p));
    };
    o2.selectionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
        if (hooks.selection) {
            var _hooks;
            (_hooks = hooks).selection.apply(_hooks, [].concat(p));
        }
        selectionCb.apply(void 0, [].concat(p));
    };
    o2.customElementCb = function() {
        for(var _len = arguments.length, c2 = new Array(_len), _key = 0; _key < _len; _key++)c2[_key] = arguments[_key];
        if (hooks.customElement) {
            var _hooks;
            (_hooks = hooks).customElement.apply(_hooks, [].concat(c2));
        }
        customElementCb.apply(void 0, [].concat(c2));
    };
}
function $f1b1811a0002602d$var$initObservers(o2, hooks) {
    if (hooks === void 0) hooks = {};
    var currentWindow = o2.doc.defaultView;
    if (!currentWindow) return function() {};
    $f1b1811a0002602d$var$mergeHooks(o2, hooks);
    var mutationObserver;
    if (o2.recordDOM) mutationObserver = $f1b1811a0002602d$var$initMutationObserver(o2, o2.doc);
    var mousemoveHandler = $f1b1811a0002602d$var$initMoveObserver(o2);
    var mouseInteractionHandler = $f1b1811a0002602d$var$initMouseInteractionObserver(o2);
    var scrollHandler = $f1b1811a0002602d$var$initScrollObserver(o2);
    var viewportResizeHandler = $f1b1811a0002602d$var$initViewportResizeObserver(o2, {
        win: currentWindow
    });
    var inputHandler = $f1b1811a0002602d$var$initInputObserver(o2);
    var mediaInteractionHandler = $f1b1811a0002602d$var$initMediaInteractionObserver(o2);
    var styleSheetObserver = function() {};
    var adoptedStyleSheetObserver = function() {};
    var styleDeclarationObserver = function() {};
    var fontObserver = function() {};
    if (o2.recordDOM) {
        styleSheetObserver = $f1b1811a0002602d$var$initStyleSheetObserver(o2, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $f1b1811a0002602d$var$initAdoptedStyleSheetObserver(o2, o2.doc);
        styleDeclarationObserver = $f1b1811a0002602d$var$initStyleDeclarationObserver(o2, {
            win: currentWindow
        });
        if (o2.collectFonts) fontObserver = $f1b1811a0002602d$var$initFontObserver(o2);
    }
    var selectionObserver = $f1b1811a0002602d$var$initSelectionObserver(o2);
    var customElementObserver = $f1b1811a0002602d$var$initCustomElementObserver(o2);
    var pluginHandlers = [];
    for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(o2.plugins), _step; !(_step = _iterator()).done;){
        var plugin3 = _step.value;
        pluginHandlers.push(plugin3.observer(plugin3.callback, currentWindow, plugin3.options));
    }
    return $f1b1811a0002602d$var$callbackWrapper(function() {
        $f1b1811a0002602d$var$mutationBuffers.forEach(function(b) {
            return b.reset();
        });
        mutationObserver == null || mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach(function(h) {
            return h();
        });
    });
}
function $f1b1811a0002602d$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $f1b1811a0002602d$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
var $f1b1811a0002602d$var$CrossOriginIframeMirror = /*#__PURE__*/ function() {
    function CrossOriginIframeMirror(generateIdFn) {
        $f1b1811a0002602d$var$__publicField(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap());
        $f1b1811a0002602d$var$__publicField(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap());
        this.generateIdFn = generateIdFn;
    }
    var _proto = CrossOriginIframeMirror.prototype;
    _proto.getId = function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        var id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    };
    _proto.getIds = function getIds(iframe, remoteId) {
        var _this = this;
        var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map(function(id) {
            return _this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
        });
    };
    _proto.getRemoteId = function getRemoteId(iframe, id, map) {
        var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        var remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    };
    _proto.getRemoteIds = function getRemoteIds(iframe, ids) {
        var _this = this;
        var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map(function(id) {
            return _this.getRemoteId(iframe, id, remoteIdToIdMap);
        });
    };
    _proto.reset = function reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
            this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    };
    _proto.getIdToRemoteIdMap = function getIdToRemoteIdMap(iframe) {
        var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = /* @__PURE__ */ new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    };
    _proto.getRemoteIdToIdMap = function getRemoteIdToIdMap(iframe) {
        var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = /* @__PURE__ */ new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    };
    return CrossOriginIframeMirror;
}();
var $f1b1811a0002602d$var$IframeManager = /*#__PURE__*/ function() {
    function IframeManager(options) {
        $f1b1811a0002602d$var$__publicField(this, "iframes", /* @__PURE__ */ new WeakMap());
        $f1b1811a0002602d$var$__publicField(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap());
        $f1b1811a0002602d$var$__publicField(this, "crossOriginIframeMirror", new $f1b1811a0002602d$var$CrossOriginIframeMirror($f1b1811a0002602d$var$genId));
        $f1b1811a0002602d$var$__publicField(this, "crossOriginIframeStyleMirror");
        $f1b1811a0002602d$var$__publicField(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap());
        $f1b1811a0002602d$var$__publicField(this, "mirror");
        $f1b1811a0002602d$var$__publicField(this, "mutationCb");
        $f1b1811a0002602d$var$__publicField(this, "wrappedEmit");
        $f1b1811a0002602d$var$__publicField(this, "loadListener");
        $f1b1811a0002602d$var$__publicField(this, "stylesheetManager");
        $f1b1811a0002602d$var$__publicField(this, "recordCrossOriginIframes");
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $f1b1811a0002602d$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    var _proto = IframeManager.prototype;
    _proto.addIframe = function addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    };
    _proto.addLoadListener = function addLoadListener(cb) {
        this.loadListener = cb;
    };
    _proto.attachIframe = function attachIframe(iframeEl, childSn) {
        var _a2, _b;
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        if (this.recordCrossOriginIframes) (_a2 = iframeEl.contentWindow) == null || _a2.addEventListener("message", this.handleMessage.bind(this));
        (_b = this.loadListener) == null || _b.call(this, iframeEl);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    };
    _proto.handleMessage = function handleMessage(message) {
        var crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
        crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        var iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        var iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    };
    _proto.transformCrossOriginEvent = function transformCrossOriginEvent(iframeEl, e2) {
        var _this = this;
        var _a2;
        switch(e2.type){
            case $f1b1811a0002602d$var$EventType.FullSnapshot:
                this.crossOriginIframeMirror.reset(iframeEl);
                this.crossOriginIframeStyleMirror.reset(iframeEl);
                this.replaceIdOnNode(e2.data.node, iframeEl);
                var rootId = e2.data.node.id;
                this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                this.patchRootIdOnNode(e2.data.node, rootId);
                return {
                    timestamp: e2.timestamp,
                    type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                    data: {
                        source: $f1b1811a0002602d$var$IncrementalSource.Mutation,
                        adds: [
                            {
                                parentId: this.mirror.getId(iframeEl),
                                nextId: null,
                                node: e2.data.node
                            }
                        ],
                        removes: [],
                        texts: [],
                        attributes: [],
                        isAttachIframe: true
                    }
                };
            case $f1b1811a0002602d$var$EventType.Meta:
            case $f1b1811a0002602d$var$EventType.Load:
            case $f1b1811a0002602d$var$EventType.DomContentLoaded:
                return false;
            case $f1b1811a0002602d$var$EventType.Plugin:
                return e2;
            case $f1b1811a0002602d$var$EventType.Custom:
                this.replaceIds(e2.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e2;
            case $f1b1811a0002602d$var$EventType.IncrementalSnapshot:
                switch(e2.data.source){
                    case $f1b1811a0002602d$var$IncrementalSource.Mutation:
                        e2.data.adds.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            _this.replaceIdOnNode(n2.node, iframeEl);
                            var rootId = _this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && _this.patchRootIdOnNode(n2.node, rootId);
                        });
                        e2.data.removes.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e2.data.attributes.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        e2.data.texts.forEach(function(n2) {
                            _this.replaceIds(n2, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $f1b1811a0002602d$var$IncrementalSource.Drag:
                    case $f1b1811a0002602d$var$IncrementalSource.TouchMove:
                    case $f1b1811a0002602d$var$IncrementalSource.MouseMove:
                        e2.data.positions.forEach(function(p) {
                            _this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e2;
                    case $f1b1811a0002602d$var$IncrementalSource.ViewportResize:
                        return false;
                    case $f1b1811a0002602d$var$IncrementalSource.MediaInteraction:
                    case $f1b1811a0002602d$var$IncrementalSource.MouseInteraction:
                    case $f1b1811a0002602d$var$IncrementalSource.Scroll:
                    case $f1b1811a0002602d$var$IncrementalSource.CanvasMutation:
                    case $f1b1811a0002602d$var$IncrementalSource.Input:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        return e2;
                    case $f1b1811a0002602d$var$IncrementalSource.StyleSheetRule:
                    case $f1b1811a0002602d$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleId"
                        ]);
                        return e2;
                    case $f1b1811a0002602d$var$IncrementalSource.Font:
                        return e2;
                    case $f1b1811a0002602d$var$IncrementalSource.Selection:
                        e2.data.ranges.forEach(function(range) {
                            _this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e2;
                    case $f1b1811a0002602d$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e2.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e2.data, iframeEl, [
                            "styleIds"
                        ]);
                        (_a2 = e2.data.styles) == null || _a2.forEach(function(style) {
                            _this.replaceStyleIds(style, iframeEl, [
                                "styleId"
                            ]);
                        });
                        return e2;
                }
        }
        return false;
    };
    _proto.replace = function replace(iframeMirror, obj, iframeEl, keys) {
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(keys), _step; !(_step = _iterator()).done;){
            var key = _step.value;
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    };
    _proto.replaceIds = function replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    };
    _proto.replaceStyleIds = function replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    };
    _proto.replaceIdOnNode = function replaceIdOnNode(node2, iframeEl) {
        var _this = this;
        this.replaceIds(node2, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node2) node2.childNodes.forEach(function(child) {
            _this.replaceIdOnNode(child, iframeEl);
        });
    };
    _proto.patchRootIdOnNode = function patchRootIdOnNode(node2, rootId) {
        var _this = this;
        if (node2.type !== $f1b1811a0002602d$var$NodeType.Document && !node2.rootId) node2.rootId = rootId;
        if ("childNodes" in node2) node2.childNodes.forEach(function(child) {
            _this.patchRootIdOnNode(child, rootId);
        });
    };
    return IframeManager;
}();
var $f1b1811a0002602d$var$ShadowDomManager = /*#__PURE__*/ function() {
    function ShadowDomManager(options) {
        $f1b1811a0002602d$var$__publicField(this, "shadowDoms", /* @__PURE__ */ new WeakSet());
        $f1b1811a0002602d$var$__publicField(this, "mutationCb");
        $f1b1811a0002602d$var$__publicField(this, "scrollCb");
        $f1b1811a0002602d$var$__publicField(this, "bypassOptions");
        $f1b1811a0002602d$var$__publicField(this, "mirror");
        $f1b1811a0002602d$var$__publicField(this, "restoreHandlers", []);
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    var _proto = ShadowDomManager.prototype;
    _proto.init = function init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    };
    _proto.addShadowRoot = function addShadowRoot(shadowRoot2, doc) {
        var _this = this;
        if (!$f1b1811a0002602d$var$isNativeShadowDom(shadowRoot2)) return;
        if (this.shadowDoms.has(shadowRoot2)) return;
        this.shadowDoms.add(shadowRoot2);
        var observer = $f1b1811a0002602d$var$initMutationObserver($f1b1811a0002602d$var$_extends({}, this.bypassOptions, {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot2);
        this.restoreHandlers.push(function() {
            return observer.disconnect();
        });
        this.restoreHandlers.push($f1b1811a0002602d$var$initScrollObserver($f1b1811a0002602d$var$_extends({}, this.bypassOptions, {
            scrollCb: this.scrollCb,
            // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
            // scroll is not allowed to pass the boundary, so we need to listen the shadow document
            doc: shadowRoot2,
            mirror: this.mirror
        })));
        setTimeout(function() {
            if (shadowRoot2.adoptedStyleSheets && shadowRoot2.adoptedStyleSheets.length > 0) _this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot2.adoptedStyleSheets, _this.mirror.getId($f1b1811a0002602d$var$index.host(shadowRoot2)));
            _this.restoreHandlers.push($f1b1811a0002602d$var$initAdoptedStyleSheetObserver({
                mirror: _this.mirror,
                stylesheetManager: _this.bypassOptions.stylesheetManager
            }, shadowRoot2));
        }, 0);
    };
    /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */ _proto.observeAttachShadow = function observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    };
    /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */ _proto.patchAttachShadow = function patchAttachShadow(element, doc) {
        var manager = this;
        this.restoreHandlers.push($f1b1811a0002602d$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                var sRoot = original.call(this, option);
                var shadowRootEl = $f1b1811a0002602d$var$index.shadowRoot(this);
                if (shadowRootEl && $f1b1811a0002602d$var$inDom(this)) manager.addShadowRoot(shadowRootEl, doc);
                return sRoot;
            };
        }));
    };
    _proto.reset = function reset() {
        this.restoreHandlers.forEach(function(handler) {
            try {
                handler();
            } catch (e2) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = /* @__PURE__ */ new WeakSet();
    };
    return ShadowDomManager;
}();
var $f1b1811a0002602d$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $f1b1811a0002602d$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $f1b1811a0002602d$var$i$1 = 0; $f1b1811a0002602d$var$i$1 < $f1b1811a0002602d$var$chars.length; $f1b1811a0002602d$var$i$1++)$f1b1811a0002602d$var$lookup[$f1b1811a0002602d$var$chars.charCodeAt($f1b1811a0002602d$var$i$1)] = $f1b1811a0002602d$var$i$1;
var $f1b1811a0002602d$var$encode = function encode(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i2, len = bytes.length, base64 = "";
    for(i2 = 0; i2 < len; i2 += 3){
        base64 += $f1b1811a0002602d$var$chars[bytes[i2] >> 2];
        base64 += $f1b1811a0002602d$var$chars[(bytes[i2] & 3) << 4 | bytes[i2 + 1] >> 4];
        base64 += $f1b1811a0002602d$var$chars[(bytes[i2 + 1] & 15) << 2 | bytes[i2 + 2] >> 6];
        base64 += $f1b1811a0002602d$var$chars[bytes[i2 + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var $f1b1811a0002602d$var$canvasVarMap = /* @__PURE__ */ new Map();
function $f1b1811a0002602d$var$variableListFor$1(ctx, ctor) {
    var contextMap = $f1b1811a0002602d$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = /* @__PURE__ */ new Map();
        $f1b1811a0002602d$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
var $f1b1811a0002602d$var$saveWebGLVar = function(value, win, ctx) {
    if (!value || !($f1b1811a0002602d$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(value)) === "object")) return;
    var name = value.constructor.name;
    var list2 = $f1b1811a0002602d$var$variableListFor$1(ctx, name);
    var index2 = list2.indexOf(value);
    if (index2 === -1) {
        index2 = list2.length;
        list2.push(value);
    }
    return index2;
};
function $f1b1811a0002602d$var$serializeArg(value, win, ctx) {
    if ($f1b1811a0002602d$var$_instanceof(value, Array)) return value.map(function(arg) {
        return $f1b1811a0002602d$var$serializeArg(arg, win, ctx);
    });
    else if (value === null) return value;
    else if ($f1b1811a0002602d$var$_instanceof(value, Float32Array) || $f1b1811a0002602d$var$_instanceof(value, Float64Array) || $f1b1811a0002602d$var$_instanceof(value, Int32Array) || $f1b1811a0002602d$var$_instanceof(value, Uint32Array) || $f1b1811a0002602d$var$_instanceof(value, Uint8Array) || $f1b1811a0002602d$var$_instanceof(value, Uint16Array) || $f1b1811a0002602d$var$_instanceof(value, Int16Array) || $f1b1811a0002602d$var$_instanceof(value, Int8Array) || $f1b1811a0002602d$var$_instanceof(value, Uint8ClampedArray)) {
        var name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (// More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    $f1b1811a0002602d$var$_instanceof(value, ArrayBuffer)) {
        var name1 = value.constructor.name;
        var base64 = $f1b1811a0002602d$var$encode(value);
        return {
            rr_type: name1,
            base64: base64
        };
    } else if ($f1b1811a0002602d$var$_instanceof(value, DataView)) {
        var name2 = value.constructor.name;
        return {
            rr_type: name2,
            args: [
                $f1b1811a0002602d$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if ($f1b1811a0002602d$var$_instanceof(value, HTMLImageElement)) {
        var name3 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name3,
            src: src
        };
    } else if ($f1b1811a0002602d$var$_instanceof(value, HTMLCanvasElement)) {
        var name4 = "HTMLImageElement";
        var src1 = value.toDataURL();
        return {
            rr_type: name4,
            src: src1
        };
    } else if ($f1b1811a0002602d$var$_instanceof(value, ImageData)) {
        var name5 = value.constructor.name;
        return {
            rr_type: name5,
            args: [
                $f1b1811a0002602d$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($f1b1811a0002602d$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : $f1b1811a0002602d$var$_type_of(value)) === "object") {
        var name6 = value.constructor.name;
        var index2 = $f1b1811a0002602d$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name6,
            index: index2
        };
    }
    return value;
}
var $f1b1811a0002602d$var$serializeArgs = function(args, win, ctx) {
    return args.map(function(arg) {
        return $f1b1811a0002602d$var$serializeArg(arg, win, ctx);
    });
};
var $f1b1811a0002602d$var$isInstanceOfWebGLObject = function(value, win) {
    var webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
        "WebGLVertexArrayObjectOES"
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function(name) {
        return typeof win[name] === "function";
    });
    return Boolean(supportedWebGLConstructorNames.find(function(name) {
        return $f1b1811a0002602d$var$_instanceof(value, win[name]);
    }));
};
function $f1b1811a0002602d$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
    var _loop = function() {
        var prop = _step.value;
        try {
            if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") return "continue";
            var restoreHandler = $f1b1811a0002602d$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                return function() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    if (!$f1b1811a0002602d$var$isBlocked(this.canvas, blockClass, blockSelector, true)) setTimeout(function() {
                        var recordArgs = $f1b1811a0002602d$var$serializeArgs(args, win, _this);
                        cb(_this.canvas, {
                            type: $f1b1811a0002602d$var$CanvasContext["2D"],
                            property: prop,
                            args: recordArgs
                        });
                    }, 0);
                    return original.apply(this, args);
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            var hookHandler = $f1b1811a0002602d$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                set: function set(v2) {
                    cb(this.canvas, {
                        type: $f1b1811a0002602d$var$CanvasContext["2D"],
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(props2D), _step; !(_step = _iterator()).done;)_loop();
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $f1b1811a0002602d$var$getNormalizedContextName(contextType) {
    return contextType === "experimental-webgl" ? "webgl" : contextType;
}
function $f1b1811a0002602d$var$initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
    var handlers = [];
    try {
        var restoreHandler = $f1b1811a0002602d$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (!$f1b1811a0002602d$var$isBlocked(this, blockClass, blockSelector, true)) {
                    var ctxName = $f1b1811a0002602d$var$getNormalizedContextName(contextType);
                    if (!("__context" in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        "webgl",
                        "webgl2"
                    ].includes(ctxName)) {
                        if (args[0] && $f1b1811a0002602d$var$_type_of(args[0]) === "object") {
                            var contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [].concat([
                    contextType
                ], args));
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $f1b1811a0002602d$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, win) {
    var _loop = function() {
        var prop = _step.value;
        if ([
            "isContextLost",
            "canvas",
            "drawingBufferWidth",
            "drawingBufferHeight"
        ].includes(prop)) return "continue";
        try {
            if (typeof prototype[prop] !== "function") return "continue";
            var restoreHandler = $f1b1811a0002602d$var$patch(prototype, prop, function(original) {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var result2 = original.apply(this, args);
                    $f1b1811a0002602d$var$saveWebGLVar(result2, win, this);
                    if ("tagName" in this.canvas && !$f1b1811a0002602d$var$isBlocked(this.canvas, blockClass, blockSelector, true)) {
                        var recordArgs = $f1b1811a0002602d$var$serializeArgs(args, win, this);
                        var mutation = {
                            type: type,
                            property: prop,
                            args: recordArgs
                        };
                        cb(this.canvas, mutation);
                    }
                    return result2;
                };
            });
            handlers.push(restoreHandler);
        } catch (e) {
            var hookHandler = $f1b1811a0002602d$var$hookSetter(prototype, prop, {
                set: function set(v2) {
                    cb(this.canvas, {
                        type: type,
                        property: prop,
                        args: [
                            v2
                        ],
                        setter: true
                    });
                }
            });
            handlers.push(hookHandler);
        }
    };
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(props), _step; !(_step = _iterator()).done;)_loop();
    return handlers;
}
function $f1b1811a0002602d$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector) {
    var _handlers;
    var handlers = [];
    (_handlers = handlers).push.apply(_handlers, [].concat($f1b1811a0002602d$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $f1b1811a0002602d$var$CanvasContext.WebGL, cb, blockClass, blockSelector, win)));
    if (typeof win.WebGL2RenderingContext !== "undefined") {
        var _handlers1;
        (_handlers1 = handlers).push.apply(_handlers1, [].concat($f1b1811a0002602d$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $f1b1811a0002602d$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, win)));
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var $f1b1811a0002602d$var$encodedJs = "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";
var $f1b1811a0002602d$var$decodeBase64 = function(base64) {
    return Uint8Array.from(atob(base64), function(c2) {
        return c2.charCodeAt(0);
    });
};
var $f1b1811a0002602d$var$blob = typeof window !== "undefined" && window.Blob && new Blob([
    $f1b1811a0002602d$var$decodeBase64($f1b1811a0002602d$var$encodedJs)
], {
    type: "text/javascript;charset=utf-8"
});
function $f1b1811a0002602d$var$WorkerWrapper(options) {
    var objURL;
    try {
        objURL = $f1b1811a0002602d$var$blob && (window.URL || window.webkitURL).createObjectURL($f1b1811a0002602d$var$blob);
        if (!objURL) throw "";
        var worker = new Worker(objURL, {
            name: options == null ? void 0 : options.name
        });
        worker.addEventListener("error", function() {
            (window.URL || window.webkitURL).revokeObjectURL(objURL);
        });
        return worker;
    } catch (e2) {
        return new Worker("data:text/javascript;base64," + $f1b1811a0002602d$var$encodedJs, {
            name: options == null ? void 0 : options.name
        });
    } finally{
        objURL && (window.URL || window.webkitURL).revokeObjectURL(objURL);
    }
}
var $f1b1811a0002602d$var$CanvasManager = /*#__PURE__*/ function() {
    function CanvasManager(options) {
        var _this = this;
        $f1b1811a0002602d$var$__publicField(this, "pendingCanvasMutations", /* @__PURE__ */ new Map());
        $f1b1811a0002602d$var$__publicField(this, "rafStamps", {
            latestId: 0,
            invokeId: null
        });
        $f1b1811a0002602d$var$__publicField(this, "mirror");
        $f1b1811a0002602d$var$__publicField(this, "mutationCb");
        $f1b1811a0002602d$var$__publicField(this, "resetObservers");
        $f1b1811a0002602d$var$__publicField(this, "frozen", false);
        $f1b1811a0002602d$var$__publicField(this, "locked", false);
        $f1b1811a0002602d$var$__publicField(this, "processMutation", function(target, mutation) {
            var newFrame = _this.rafStamps.invokeId && _this.rafStamps.latestId !== _this.rafStamps.invokeId;
            if (newFrame || !_this.rafStamps.invokeId) _this.rafStamps.invokeId = _this.rafStamps.latestId;
            if (!_this.pendingCanvasMutations.has(target)) _this.pendingCanvasMutations.set(target, []);
            _this.pendingCanvasMutations.get(target).push(mutation);
        });
        var _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? "all" : _options_sampling, win = options.win, blockClass = options.blockClass, blockSelector = options.blockSelector, recordCanvas = options.recordCanvas, dataURLOptions = options.dataURLOptions;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (recordCanvas && sampling === "all") this.initCanvasMutationObserver(win, blockClass, blockSelector);
        if (recordCanvas && typeof sampling === "number") this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
            dataURLOptions: dataURLOptions
        });
    }
    var _proto = CanvasManager.prototype;
    _proto.reset = function reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    };
    _proto.freeze = function freeze() {
        this.frozen = true;
    };
    _proto.unfreeze = function unfreeze() {
        this.frozen = false;
    };
    _proto.lock = function lock() {
        this.locked = true;
    };
    _proto.unlock = function unlock() {
        this.locked = false;
    };
    _proto.initCanvasFPSObserver = function initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
        var _this = this;
        var canvasContextReset = $f1b1811a0002602d$var$initCanvasContextObserver(win, blockClass, blockSelector, true);
        var snapshotInProgressMap = /* @__PURE__ */ new Map();
        var worker = new $f1b1811a0002602d$var$WorkerWrapper();
        worker.onmessage = function(e2) {
            var id = e2.data.id;
            snapshotInProgressMap.set(id, false);
            if (!("base64" in e2.data)) return;
            var _e2_data = e2.data, base64 = _e2_data.base64, type = _e2_data.type, width = _e2_data.width, height = _e2_data.height;
            _this.mutationCb({
                id: id,
                type: $f1b1811a0002602d$var$CanvasContext["2D"],
                commands: [
                    {
                        property: "clearRect",
                        // wipe canvas
                        args: [
                            0,
                            0,
                            width,
                            height
                        ]
                    },
                    {
                        property: "drawImage",
                        // draws (semi-transparent) image
                        args: [
                            {
                                rr_type: "ImageBitmap",
                                args: [
                                    {
                                        rr_type: "Blob",
                                        data: [
                                            {
                                                rr_type: "ArrayBuffer",
                                                base64: base64
                                            }
                                        ],
                                        type: type
                                    }
                                ]
                            },
                            0,
                            0
                        ]
                    }
                ]
            });
        };
        var timeBetweenSnapshots = 1e3 / fps;
        var lastSnapshotTime = 0;
        var rafId;
        var getCanvas = function() {
            var matchedCanvas = [];
            win.document.querySelectorAll("canvas").forEach(function(canvas) {
                if (!$f1b1811a0002602d$var$isBlocked(canvas, blockClass, blockSelector, true)) matchedCanvas.push(canvas);
            });
            return matchedCanvas;
        };
        var takeCanvasSnapshots = function(timestamp) {
            if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                rafId = requestAnimationFrame(takeCanvasSnapshots);
                return;
            }
            lastSnapshotTime = timestamp;
            var _this1 = _this;
            getCanvas().forEach(/*#__PURE__*/ $f1b1811a0002602d$var$_async_to_generator(function(canvas) {
                var _a2, id, context, bitmap;
                return $f1b1811a0002602d$var$_ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = _this1.mirror.getId(canvas);
                            if (snapshotInProgressMap.get(id)) return [
                                2
                            ];
                            if (canvas.width === 0 || canvas.height === 0) return [
                                2
                            ];
                            snapshotInProgressMap.set(id, true);
                            if ([
                                "webgl",
                                "webgl2"
                            ].includes(canvas.__context)) {
                                context = canvas.getContext(canvas.__context);
                                if (((_a2 = context == null ? void 0 : context.getContextAttributes()) == null ? void 0 : _a2.preserveDrawingBuffer) === false) context.clear(context.COLOR_BUFFER_BIT);
                            }
                            return [
                                4,
                                createImageBitmap(canvas)
                            ];
                        case 1:
                            bitmap = _state.sent();
                            worker.postMessage({
                                id: id,
                                bitmap: bitmap,
                                width: canvas.width,
                                height: canvas.height,
                                dataURLOptions: options.dataURLOptions
                            }, [
                                bitmap
                            ]);
                            return [
                                2
                            ];
                    }
                });
            }));
            rafId = requestAnimationFrame(takeCanvasSnapshots);
        };
        rafId = requestAnimationFrame(takeCanvasSnapshots);
        this.resetObservers = function() {
            canvasContextReset();
            cancelAnimationFrame(rafId);
        };
    };
    _proto.initCanvasMutationObserver = function initCanvasMutationObserver(win, blockClass, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        var canvasContextReset = $f1b1811a0002602d$var$initCanvasContextObserver(win, blockClass, blockSelector, false);
        var canvas2DReset = $f1b1811a0002602d$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        var canvasWebGL1and2Reset = $f1b1811a0002602d$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
        this.resetObservers = function() {
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    };
    _proto.startPendingCanvasMutationFlusher = function startPendingCanvasMutationFlusher() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    _proto.startRAFTimestamping = function startRAFTimestamping() {
        var _this = this;
        var setLatestRAFTimestamp = function(timestamp) {
            _this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    };
    _proto.flushPendingCanvasMutations = function flushPendingCanvasMutations() {
        var _this = this;
        this.pendingCanvasMutations.forEach(function(_values, canvas) {
            var id = _this.mirror.getId(canvas);
            _this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(function() {
            return _this.flushPendingCanvasMutations();
        });
    };
    _proto.flushPendingCanvasMutationFor = function flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        var valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        var values = valuesWithType.map(function(value) {
            value.type;
            var rest = $f1b1811a0002602d$var$_object_without_properties_loose(value, [
                "type"
            ]);
            return rest;
        });
        var type = valuesWithType[0].type;
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    };
    return CanvasManager;
}();
var $f1b1811a0002602d$var$StylesheetManager = /*#__PURE__*/ function() {
    function StylesheetManager(options) {
        $f1b1811a0002602d$var$__publicField(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet());
        $f1b1811a0002602d$var$__publicField(this, "mutationCb");
        $f1b1811a0002602d$var$__publicField(this, "adoptedStyleSheetCb");
        $f1b1811a0002602d$var$__publicField(this, "styleMirror", new $f1b1811a0002602d$var$StyleSheetMirror());
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    var _proto = StylesheetManager.prototype;
    _proto.attachLinkElement = function attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    };
    _proto.trackLinkElement = function trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    };
    _proto.adoptStyleSheets = function adoptStyleSheets(sheets, hostId) {
        var _this, _loop = function() {
            var sheet = _step.value;
            var styleId = void 0;
            if (!_this.styleMirror.has(sheet)) {
                styleId = _this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, function(r2, index2) {
                        return {
                            rule: $f1b1811a0002602d$var$stringifyRule(r2, sheet.href),
                            index: index2
                        };
                    })
                });
            } else styleId = _this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        };
        if (sheets.length === 0) return;
        var adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        var styles = [];
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(sheets), _step; !(_step = _iterator()).done;)_this = this, _loop();
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    };
    _proto.reset = function reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    };
    // TODO: take snapshot on stylesheet reload by applying event listener
    _proto.trackStylesheetInLinkElement = function trackStylesheetInLinkElement(_linkEl) {};
    return StylesheetManager;
}();
var $f1b1811a0002602d$var$ProcessedNodeManager = /*#__PURE__*/ function() {
    function ProcessedNodeManager() {
        $f1b1811a0002602d$var$__publicField(this, "nodeMap", /* @__PURE__ */ new WeakMap());
        $f1b1811a0002602d$var$__publicField(this, "active", false);
    }
    var _proto = ProcessedNodeManager.prototype;
    _proto.inOtherBuffer = function inOtherBuffer(node2, thisBuffer) {
        var buffers = this.nodeMap.get(node2);
        return buffers && Array.from(buffers).some(function(buffer) {
            return buffer !== thisBuffer;
        });
    };
    _proto.add = function add(node2, buffer) {
        var _this = this;
        if (!this.active) {
            this.active = true;
            requestAnimationFrame(function() {
                _this.nodeMap = /* @__PURE__ */ new WeakMap();
                _this.active = false;
            });
        }
        this.nodeMap.set(node2, (this.nodeMap.get(node2) || /* @__PURE__ */ new Set()).add(buffer));
    };
    _proto.destroy = function destroy() {};
    return ProcessedNodeManager;
}();
var $f1b1811a0002602d$var$wrappedEmit;
var $f1b1811a0002602d$var$takeFullSnapshot$1;
var $f1b1811a0002602d$var$canvasManager;
var $f1b1811a0002602d$var$recording = false;
try {
    if (Array.from([
        1
    ], function(x2) {
        return x2 * 2;
    })[0] !== 2) {
        var $f1b1811a0002602d$var$cleanFrame = document.createElement("iframe");
        document.body.appendChild($f1b1811a0002602d$var$cleanFrame);
        Array.from = (($f1b1811a0002602d$var$_a = $f1b1811a0002602d$var$cleanFrame.contentWindow) == null ? void 0 : $f1b1811a0002602d$var$_a.Array.from) || Array.from;
        document.body.removeChild($f1b1811a0002602d$var$cleanFrame);
    }
} catch (err) {
    console.debug("Unable to override Array.from", err);
}
var $f1b1811a0002602d$var$mirror = $f1b1811a0002602d$var$createMirror$2();
function $f1b1811a0002602d$var$record(options) {
    if (options === void 0) options = {};
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _options_blockClass = options.blockClass, blockClass = _options_blockClass === void 0 ? "rr-block" : _options_blockClass, _options_blockSelector = options.blockSelector, blockSelector = _options_blockSelector === void 0 ? null : _options_blockSelector, _options_ignoreClass = options.ignoreClass, ignoreClass = _options_ignoreClass === void 0 ? "rr-ignore" : _options_ignoreClass, _options_ignoreSelector = options.ignoreSelector, ignoreSelector = _options_ignoreSelector === void 0 ? null : _options_ignoreSelector, _options_maskTextClass = options.maskTextClass, maskTextClass = _options_maskTextClass === void 0 ? "rr-mask" : _options_maskTextClass, _options_maskTextSelector = options.maskTextSelector, maskTextSelector = _options_maskTextSelector === void 0 ? null : _options_maskTextSelector, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, hooks = options.hooks, packFn = options.packFn, _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? {} : _options_sampling, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, mousemoveWait = options.mousemoveWait, _options_recordDOM = options.recordDOM, recordDOM = _options_recordDOM === void 0 ? true : _options_recordDOM, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, _options_recordCrossOriginIframes = options.recordCrossOriginIframes, recordCrossOriginIframes = _options_recordCrossOriginIframes === void 0 ? false : _options_recordCrossOriginIframes, _options_recordAfter = options.recordAfter, recordAfter = _options_recordAfter === void 0 ? options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load" : _options_recordAfter, _options_userTriggeredOnInput = options.userTriggeredOnInput, userTriggeredOnInput = _options_userTriggeredOnInput === void 0 ? false : _options_userTriggeredOnInput, _options_collectFonts = options.collectFonts, collectFonts = _options_collectFonts === void 0 ? false : _options_collectFonts, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, plugins = options.plugins, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_ignoreCSSAttributes = options.ignoreCSSAttributes, ignoreCSSAttributes = _options_ignoreCSSAttributes === void 0 ? /* @__PURE__ */ new Set([]) : _options_ignoreCSSAttributes, errorHandler2 = options.errorHandler;
    $f1b1811a0002602d$var$registerErrorHandler(errorHandler2);
    var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    var passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e2) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (!inEmittingFrame && !passEmitsToParent) return function() {};
    if (mousemoveWait !== void 0 && sampling.mousemove === void 0) sampling.mousemove = mousemoveWait;
    $f1b1811a0002602d$var$mirror.reset();
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : _maskInputOptions !== void 0 ? _maskInputOptions : {
        password: true
    };
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        // the following are off for slimDOMOptions === true,
        // as they destroy some (hidden) info:
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all",
        headTitleMutations: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $f1b1811a0002602d$var$polyfill$1();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function(e2) {
        for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(plugins || []), _step; !(_step = _iterator()).done;){
            var plugin3 = _step.value;
            if (plugin3.eventProcessor) e2 = plugin3.eventProcessor(e2);
        }
        if (packFn && // Disable packing events which will be emitted to parent frames.
        !passEmitsToParent) e2 = packFn(e2);
        return e2;
    };
    $f1b1811a0002602d$var$wrappedEmit = function(r2, isCheckout) {
        var _a2;
        var e2 = r2;
        e2.timestamp = $f1b1811a0002602d$var$nowTimestamp();
        if (((_a2 = $f1b1811a0002602d$var$mutationBuffers[0]) == null ? void 0 : _a2.isFrozen()) && e2.type !== $f1b1811a0002602d$var$EventType.FullSnapshot && !(e2.type === $f1b1811a0002602d$var$EventType.IncrementalSnapshot && e2.data.source === $f1b1811a0002602d$var$IncrementalSource.Mutation)) $f1b1811a0002602d$var$mutationBuffers.forEach(function(buf) {
            return buf.unfreeze();
        });
        if (inEmittingFrame) emit == null || emit(eventProcessor(e2), isCheckout);
        else if (passEmitsToParent) {
            var message = {
                type: "rrweb",
                event: eventProcessor(e2),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e2.type === $f1b1811a0002602d$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e2;
            incrementalSnapshotCount = 0;
        } else if (e2.type === $f1b1811a0002602d$var$EventType.IncrementalSnapshot) {
            if (e2.data.source === $f1b1811a0002602d$var$IncrementalSource.Mutation && e2.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $f1b1811a0002602d$var$takeFullSnapshot$1(true);
        }
    };
    var wrappedMutationEmit = function(m) {
        $f1b1811a0002602d$var$wrappedEmit({
            type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
            data: $f1b1811a0002602d$var$_extends({
                source: $f1b1811a0002602d$var$IncrementalSource.Mutation
            }, m)
        });
    };
    var wrappedScrollEmit = function(p) {
        return $f1b1811a0002602d$var$wrappedEmit({
            type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
            data: $f1b1811a0002602d$var$_extends({
                source: $f1b1811a0002602d$var$IncrementalSource.Scroll
            }, p)
        });
    };
    var wrappedCanvasMutationEmit = function(p) {
        return $f1b1811a0002602d$var$wrappedEmit({
            type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
            data: $f1b1811a0002602d$var$_extends({
                source: $f1b1811a0002602d$var$IncrementalSource.CanvasMutation
            }, p)
        });
    };
    var wrappedAdoptedStyleSheetEmit = function(a2) {
        return $f1b1811a0002602d$var$wrappedEmit({
            type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
            data: $f1b1811a0002602d$var$_extends({
                source: $f1b1811a0002602d$var$IncrementalSource.AdoptedStyleSheet
            }, a2)
        });
    };
    var stylesheetManager = new $f1b1811a0002602d$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    var iframeManager = new $f1b1811a0002602d$var$IframeManager({
        mirror: $f1b1811a0002602d$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $f1b1811a0002602d$var$wrappedEmit
    });
    for(var _iterator = $f1b1811a0002602d$var$_create_for_of_iterator_helper_loose(plugins || []), _step; !(_step = _iterator()).done;){
        var plugin3 = _step.value;
        if (plugin3.getMirror) plugin3.getMirror({
            nodeMirror: $f1b1811a0002602d$var$mirror,
            crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
            crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
        });
    }
    var processedNodeManager = new $f1b1811a0002602d$var$ProcessedNodeManager();
    $f1b1811a0002602d$var$canvasManager = new $f1b1811a0002602d$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        mirror: $f1b1811a0002602d$var$mirror,
        sampling: sampling.canvas,
        dataURLOptions: dataURLOptions
    });
    var shadowDomManager = new $f1b1811a0002602d$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: $f1b1811a0002602d$var$canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $f1b1811a0002602d$var$mirror
    });
    $f1b1811a0002602d$var$takeFullSnapshot$1 = function(isCheckout) {
        if (isCheckout === void 0) isCheckout = false;
        if (!recordDOM) return;
        $f1b1811a0002602d$var$wrappedEmit({
            type: $f1b1811a0002602d$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $f1b1811a0002602d$var$getWindowWidth(),
                height: $f1b1811a0002602d$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $f1b1811a0002602d$var$mutationBuffers.forEach(function(buf) {
            return buf.lock();
        });
        var node2 = $f1b1811a0002602d$var$snapshot(document, {
            mirror: $f1b1811a0002602d$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function(n2) {
                if ($f1b1811a0002602d$var$isSerializedIframe(n2, $f1b1811a0002602d$var$mirror)) iframeManager.addIframe(n2);
                if ($f1b1811a0002602d$var$isSerializedStylesheet(n2, $f1b1811a0002602d$var$mirror)) stylesheetManager.trackLinkElement(n2);
                if ($f1b1811a0002602d$var$hasShadowRoot(n2)) shadowDomManager.addShadowRoot($f1b1811a0002602d$var$index.shadowRoot(n2), document);
            },
            onIframeLoad: function(iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: function(linkEl, childSn) {
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node2) return console.warn("Failed to snapshot the document");
        $f1b1811a0002602d$var$wrappedEmit({
            type: $f1b1811a0002602d$var$EventType.FullSnapshot,
            data: {
                node: node2,
                initialOffset: $f1b1811a0002602d$var$getWindowScroll(window)
            }
        }, isCheckout);
        $f1b1811a0002602d$var$mutationBuffers.forEach(function(buf) {
            return buf.unlock();
        });
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $f1b1811a0002602d$var$mirror.getId(document));
    };
    try {
        var handlers = [];
        var observe = function(doc) {
            var _a2;
            return $f1b1811a0002602d$var$callbackWrapper($f1b1811a0002602d$var$initObservers)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function(positions, source) {
                    return $f1b1811a0002602d$var$wrappedEmit({
                        type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    });
                },
                mouseInteractionCb: function(d) {
                    return $f1b1811a0002602d$var$wrappedEmit({
                        type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                        data: $f1b1811a0002602d$var$_extends({
                            source: $f1b1811a0002602d$var$IncrementalSource.MouseInteraction
                        }, d)
                    });
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function(d) {
                    return $f1b1811a0002602d$var$wrappedEmit({
                        type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                        data: $f1b1811a0002602d$var$_extends({
                            source: $f1b1811a0002602d$var$IncrementalSource.ViewportResize
                        }, d)
                    });
                },
                inputCb: function(v2) {
                    return $f1b1811a0002602d$var$wrappedEmit({
                        type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                        data: $f1b1811a0002602d$var$_extends({
                            source: $f1b1811a0002602d$var$IncrementalSource.Input
                        }, v2)
                    });
                },
                mediaInteractionCb: function(p) {
                    return $f1b1811a0002602d$var$wrappedEmit({
                        type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                        data: $f1b1811a0002602d$var$_extends({
                            source: $f1b1811a0002602d$var$IncrementalSource.MediaInteraction
                        }, p)
                    });
                },
                styleSheetRuleCb: function(r2) {
                    return $f1b1811a0002602d$var$wrappedEmit({
                        type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                        data: $f1b1811a0002602d$var$_extends({
                            source: $f1b1811a0002602d$var$IncrementalSource.StyleSheetRule
                        }, r2)
                    });
                },
                styleDeclarationCb: function(r2) {
                    return $f1b1811a0002602d$var$wrappedEmit({
                        type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                        data: $f1b1811a0002602d$var$_extends({
                            source: $f1b1811a0002602d$var$IncrementalSource.StyleDeclaration
                        }, r2)
                    });
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function(p) {
                    return $f1b1811a0002602d$var$wrappedEmit({
                        type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                        data: $f1b1811a0002602d$var$_extends({
                            source: $f1b1811a0002602d$var$IncrementalSource.Font
                        }, p)
                    });
                },
                selectionCb: function(p) {
                    $f1b1811a0002602d$var$wrappedEmit({
                        type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                        data: $f1b1811a0002602d$var$_extends({
                            source: $f1b1811a0002602d$var$IncrementalSource.Selection
                        }, p)
                    });
                },
                customElementCb: function(c2) {
                    $f1b1811a0002602d$var$wrappedEmit({
                        type: $f1b1811a0002602d$var$EventType.IncrementalSnapshot,
                        data: $f1b1811a0002602d$var$_extends({
                            source: $f1b1811a0002602d$var$IncrementalSource.CustomElement
                        }, c2)
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $f1b1811a0002602d$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: $f1b1811a0002602d$var$canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: ((_a2 = plugins == null ? void 0 : plugins.filter(function(p) {
                    return p.observer;
                })) == null ? void 0 : _a2.map(function(p) {
                    return {
                        observer: p.observer,
                        options: p.options,
                        callback: function(payload) {
                            return $f1b1811a0002602d$var$wrappedEmit({
                                type: $f1b1811a0002602d$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            });
                        }
                    };
                })) || []
            }, hooks);
        };
        iframeManager.addLoadListener(function(iframeEl) {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        var init = function() {
            $f1b1811a0002602d$var$takeFullSnapshot$1();
            handlers.push(observe(document));
            $f1b1811a0002602d$var$recording = true;
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($f1b1811a0002602d$var$on("DOMContentLoaded", function() {
                $f1b1811a0002602d$var$wrappedEmit({
                    type: $f1b1811a0002602d$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($f1b1811a0002602d$var$on("load", function() {
                $f1b1811a0002602d$var$wrappedEmit({
                    type: $f1b1811a0002602d$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return function() {
            handlers.forEach(function(h) {
                return h();
            });
            processedNodeManager.destroy();
            $f1b1811a0002602d$var$recording = false;
            $f1b1811a0002602d$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
$f1b1811a0002602d$var$record.addCustomEvent = function(tag, payload) {
    if (!$f1b1811a0002602d$var$recording) throw new Error("please add custom event after start recording");
    $f1b1811a0002602d$var$wrappedEmit({
        type: $f1b1811a0002602d$var$EventType.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    });
};
$f1b1811a0002602d$var$record.freezePage = function() {
    $f1b1811a0002602d$var$mutationBuffers.forEach(function(buf) {
        return buf.freeze();
    });
};
$f1b1811a0002602d$var$record.takeFullSnapshot = function(isCheckout) {
    if (!$f1b1811a0002602d$var$recording) throw new Error("please take full snapshot after start recording");
    $f1b1811a0002602d$var$takeFullSnapshot$1(isCheckout);
};
$f1b1811a0002602d$var$record.mirror = $f1b1811a0002602d$var$mirror;
var $f1b1811a0002602d$var$n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}($f1b1811a0002602d$var$n || ($f1b1811a0002602d$var$n = {}));
$f1b1811a0002602d$var$record.addCustomEvent;
$f1b1811a0002602d$var$record.freezePage;
$f1b1811a0002602d$var$record.takeFullSnapshot;
var $f1b1811a0002602d$var$setImmediate = $f1b1811a0002602d$var$win['setImmediate'];
var $f1b1811a0002602d$var$builtInProp, $f1b1811a0002602d$var$cycle, $f1b1811a0002602d$var$schedulingQueue, $f1b1811a0002602d$var$ToString = Object.prototype.toString, $f1b1811a0002602d$var$timer = typeof $f1b1811a0002602d$var$setImmediate !== 'undefined' ? function timer(fn) {
    return $f1b1811a0002602d$var$setImmediate(fn);
} : setTimeout;
// dammit, IE8.
try {
    Object.defineProperty({}, 'x', {});
    $f1b1811a0002602d$var$builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
            value: val,
            writable: true,
            configurable: config !== false
        });
    };
} catch (err) {
    $f1b1811a0002602d$var$builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
    };
}
// Note: using a queue instead of array for efficiency
$f1b1811a0002602d$var$schedulingQueue = function Queue() {
    var first, last, item;
    function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
    }
    return {
        add: function add(fn, self) {
            item = new Item(fn, self);
            if (last) last.next = item;
            else first = item;
            last = item;
            item = void 0;
        },
        drain: function drain() {
            var f = first;
            first = last = $f1b1811a0002602d$var$cycle = void 0;
            while(f){
                f.fn.call(f.self);
                f = f.next;
            }
        }
    };
}();
function $f1b1811a0002602d$var$schedule(fn, self) {
    $f1b1811a0002602d$var$schedulingQueue.add(fn, self);
    if (!$f1b1811a0002602d$var$cycle) $f1b1811a0002602d$var$cycle = $f1b1811a0002602d$var$timer($f1b1811a0002602d$var$schedulingQueue.drain);
}
// promise duck typing
function $f1b1811a0002602d$var$isThenable(o) {
    var _then, oType = typeof o;
    if (o !== null && (oType === 'object' || oType === 'function')) _then = o.then;
    return typeof _then === 'function' ? _then : false;
}
function $f1b1811a0002602d$var$notify() {
    for(var i = 0; i < this.chain.length; i++)$f1b1811a0002602d$var$notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    this.chain.length = 0;
}
// NOTE: This is a separate function to isolate
// the `try..catch` so that other code can be
// optimized better
function $f1b1811a0002602d$var$notifyIsolated(self, cb, chain) {
    var ret, _then;
    try {
        if (cb === false) chain.reject(self.msg);
        else {
            if (cb === true) ret = self.msg;
            else ret = cb.call(void 0, self.msg);
            if (ret === chain.promise) chain.reject(TypeError('Promise-chain cycle'));
            else if (_then = $f1b1811a0002602d$var$isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
            else chain.resolve(ret);
        }
    } catch (err) {
        chain.reject(err);
    }
}
function $f1b1811a0002602d$var$resolve(msg) {
    var _then, self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    try {
        // eslint-disable-next-line no-cond-assign
        if (_then = $f1b1811a0002602d$var$isThenable(msg)) $f1b1811a0002602d$var$schedule(function() {
            var defWrapper = new $f1b1811a0002602d$var$MakeDefWrapper(self);
            try {
                _then.call(msg, function $resolve$() {
                    $f1b1811a0002602d$var$resolve.apply(defWrapper, arguments);
                }, function $reject$() {
                    $f1b1811a0002602d$var$reject.apply(defWrapper, arguments);
                });
            } catch (err) {
                $f1b1811a0002602d$var$reject.call(defWrapper, err);
            }
        });
        else {
            self.msg = msg;
            self.state = 1;
            if (self.chain.length > 0) $f1b1811a0002602d$var$schedule($f1b1811a0002602d$var$notify, self);
        }
    } catch (err) {
        $f1b1811a0002602d$var$reject.call(new $f1b1811a0002602d$var$MakeDefWrapper(self), err);
    }
}
function $f1b1811a0002602d$var$reject(msg) {
    var self = this;
    // already triggered?
    if (self.triggered) return;
    self.triggered = true;
    // unwrap
    if (self.def) self = self.def;
    self.msg = msg;
    self.state = 2;
    if (self.chain.length > 0) $f1b1811a0002602d$var$schedule($f1b1811a0002602d$var$notify, self);
}
function $f1b1811a0002602d$var$iteratePromises(Constructor, arr, resolver, rejecter) {
    for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
        }, rejecter);
    })(idx);
}
function $f1b1811a0002602d$var$MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
}
function $f1b1811a0002602d$var$MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
}
function $f1b1811a0002602d$var$NpoPromise(executor) {
    if (typeof executor !== 'function') throw TypeError('Not a function');
    if (this['__NPO__'] !== 0) throw TypeError('Not a promise');
    // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise
    this['__NPO__'] = 1;
    var def = new $f1b1811a0002602d$var$MakeDef(this);
    this['then'] = function then(success, failure) {
        var o = {
            success: typeof success === 'function' ? success : true,
            failure: typeof failure === 'function' ? failure : false
        };
        // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.
        o.promise = new this.constructor(function extractChain(resolve, reject) {
            if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
            o.resolve = resolve;
            o.reject = reject;
        });
        def.chain.push(o);
        if (def.state !== 0) $f1b1811a0002602d$var$schedule($f1b1811a0002602d$var$notify, def);
        return o.promise;
    };
    this['catch'] = function $catch$(failure) {
        return this.then(void 0, failure);
    };
    try {
        executor.call(void 0, function publicResolve(msg) {
            $f1b1811a0002602d$var$resolve.call(def, msg);
        }, function publicReject(msg) {
            $f1b1811a0002602d$var$reject.call(def, msg);
        });
    } catch (err) {
        $f1b1811a0002602d$var$reject.call(def, err);
    }
}
var $f1b1811a0002602d$var$PromisePrototype = $f1b1811a0002602d$var$builtInProp({}, 'constructor', $f1b1811a0002602d$var$NpoPromise, /*configurable=*/ false);
// Note: Android 4 cannot use `Object.defineProperty(..)` here
$f1b1811a0002602d$var$NpoPromise.prototype = $f1b1811a0002602d$var$PromisePrototype;
// built-in "brand" to signal an "uninitialized" promise
$f1b1811a0002602d$var$builtInProp($f1b1811a0002602d$var$PromisePrototype, '__NPO__', 0, /*configurable=*/ false);
$f1b1811a0002602d$var$builtInProp($f1b1811a0002602d$var$NpoPromise, 'resolve', function Promise$resolve(msg) {
    var Constructor = this;
    // spec mandated checks
    // note: best "isPromise" check that's practical for now
    if (msg && typeof msg === 'object' && msg['__NPO__'] === 1) return msg;
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        resolve(msg);
    });
});
$f1b1811a0002602d$var$builtInProp($f1b1811a0002602d$var$NpoPromise, 'reject', function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        reject(msg);
    });
});
$f1b1811a0002602d$var$builtInProp($f1b1811a0002602d$var$NpoPromise, 'all', function Promise$all(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($f1b1811a0002602d$var$ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    if (arr.length === 0) return Constructor.resolve([]);
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        var len = arr.length, msgs = Array(len), count = 0;
        $f1b1811a0002602d$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            msgs[idx] = msg;
            if (++count === len) resolve(msgs);
        }, reject);
    });
});
$f1b1811a0002602d$var$builtInProp($f1b1811a0002602d$var$NpoPromise, 'race', function Promise$race(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($f1b1811a0002602d$var$ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        $f1b1811a0002602d$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            resolve(msg);
        }, reject);
    });
});
var $f1b1811a0002602d$var$PromisePolyfill;
if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) $f1b1811a0002602d$var$PromisePolyfill = Promise;
else $f1b1811a0002602d$var$PromisePolyfill = $f1b1811a0002602d$var$NpoPromise;
var $f1b1811a0002602d$var$Config = {
    DEBUG: false,
    LIB_VERSION: '2.67.0'
};
/* eslint camelcase: "off", eqeqeq: "off" */ // Maximum allowed session recording length
var $f1b1811a0002602d$var$MAX_RECORDING_MS = 86400000; // 24 hours
// Maximum allowed value for minimum session recording length
var $f1b1811a0002602d$var$MAX_VALUE_FOR_MIN_RECORDING_MS = 8000; // 8 seconds
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $f1b1811a0002602d$var$ArrayProto = Array.prototype, $f1b1811a0002602d$var$FuncProto = Function.prototype, $f1b1811a0002602d$var$ObjProto = Object.prototype, $f1b1811a0002602d$var$slice = $f1b1811a0002602d$var$ArrayProto.slice, $f1b1811a0002602d$var$toString = $f1b1811a0002602d$var$ObjProto.toString, $f1b1811a0002602d$var$hasOwnProperty = $f1b1811a0002602d$var$ObjProto.hasOwnProperty, $f1b1811a0002602d$var$windowConsole = $f1b1811a0002602d$var$win.console, $f1b1811a0002602d$var$navigator = $f1b1811a0002602d$var$win.navigator, $f1b1811a0002602d$var$document$1 = $f1b1811a0002602d$var$win.document, $f1b1811a0002602d$var$windowOpera = $f1b1811a0002602d$var$win.opera, $f1b1811a0002602d$var$screen = $f1b1811a0002602d$var$win.screen, $f1b1811a0002602d$var$userAgent = $f1b1811a0002602d$var$navigator.userAgent;
var $f1b1811a0002602d$var$nativeBind = $f1b1811a0002602d$var$FuncProto.bind, $f1b1811a0002602d$var$nativeForEach = $f1b1811a0002602d$var$ArrayProto.forEach, $f1b1811a0002602d$var$nativeIndexOf = $f1b1811a0002602d$var$ArrayProto.indexOf, $f1b1811a0002602d$var$nativeMap = $f1b1811a0002602d$var$ArrayProto.map, $f1b1811a0002602d$var$nativeIsArray = Array.isArray, $f1b1811a0002602d$var$breaker = {};
var $f1b1811a0002602d$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};
// Console override
var $f1b1811a0002602d$var$console$1 = {
    /** @type {function(...*)} */ log: function() {
        if ($f1b1811a0002602d$var$Config.DEBUG && !$f1b1811a0002602d$var$_.isUndefined($f1b1811a0002602d$var$windowConsole) && $f1b1811a0002602d$var$windowConsole) try {
            $f1b1811a0002602d$var$windowConsole.log.apply($f1b1811a0002602d$var$windowConsole, arguments);
        } catch (err) {
            $f1b1811a0002602d$var$_.each(arguments, function(arg) {
                $f1b1811a0002602d$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($f1b1811a0002602d$var$Config.DEBUG && !$f1b1811a0002602d$var$_.isUndefined($f1b1811a0002602d$var$windowConsole) && $f1b1811a0002602d$var$windowConsole) {
            var args = [
                'Mixpanel warning:'
            ].concat($f1b1811a0002602d$var$_.toArray(arguments));
            try {
                $f1b1811a0002602d$var$windowConsole.warn.apply($f1b1811a0002602d$var$windowConsole, args);
            } catch (err) {
                $f1b1811a0002602d$var$_.each(args, function(arg) {
                    $f1b1811a0002602d$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($f1b1811a0002602d$var$Config.DEBUG && !$f1b1811a0002602d$var$_.isUndefined($f1b1811a0002602d$var$windowConsole) && $f1b1811a0002602d$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($f1b1811a0002602d$var$_.toArray(arguments));
            try {
                $f1b1811a0002602d$var$windowConsole.error.apply($f1b1811a0002602d$var$windowConsole, args);
            } catch (err) {
                $f1b1811a0002602d$var$_.each(args, function(arg) {
                    $f1b1811a0002602d$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$f1b1811a0002602d$var$_.isUndefined($f1b1811a0002602d$var$windowConsole) && $f1b1811a0002602d$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($f1b1811a0002602d$var$_.toArray(arguments));
            try {
                $f1b1811a0002602d$var$windowConsole.error.apply($f1b1811a0002602d$var$windowConsole, args);
            } catch (err) {
                $f1b1811a0002602d$var$_.each(args, function(arg) {
                    $f1b1811a0002602d$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $f1b1811a0002602d$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply($f1b1811a0002602d$var$console$1, arguments);
    };
};
var $f1b1811a0002602d$var$console_with_prefix = function(prefix) {
    return {
        log: $f1b1811a0002602d$var$log_func_with_prefix($f1b1811a0002602d$var$console$1.log, prefix),
        error: $f1b1811a0002602d$var$log_func_with_prefix($f1b1811a0002602d$var$console$1.error, prefix),
        critical: $f1b1811a0002602d$var$log_func_with_prefix($f1b1811a0002602d$var$console$1.critical, prefix)
    };
};
var $f1b1811a0002602d$var$safewrap = function(f) {
    return function() {
        try {
            return f.apply(this, arguments);
        } catch (e) {
            $f1b1811a0002602d$var$console$1.critical('Implementation error. Please turn on debug and contact support@mixpanel.com.');
            if ($f1b1811a0002602d$var$Config.DEBUG) $f1b1811a0002602d$var$console$1.critical(e);
        }
    };
};
var $f1b1811a0002602d$var$safewrapClass = function(klass) {
    var proto = klass.prototype;
    for(var func in proto)if (typeof proto[func] === 'function') proto[func] = $f1b1811a0002602d$var$safewrap(proto[func]);
};
// UNDERSCORE
// Embed part of the Underscore Library
$f1b1811a0002602d$var$_.bind = function(func, context) {
    var args, bound;
    if ($f1b1811a0002602d$var$nativeBind && func.bind === $f1b1811a0002602d$var$nativeBind) return $f1b1811a0002602d$var$nativeBind.apply(func, $f1b1811a0002602d$var$slice.call(arguments, 1));
    if (!$f1b1811a0002602d$var$_.isFunction(func)) throw new TypeError();
    args = $f1b1811a0002602d$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($f1b1811a0002602d$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat($f1b1811a0002602d$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $f1b1811a0002602d$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($f1b1811a0002602d$var$nativeForEach && obj.forEach === $f1b1811a0002602d$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $f1b1811a0002602d$var$breaker) return;
    }
    else {
        for(var key in obj)if ($f1b1811a0002602d$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $f1b1811a0002602d$var$breaker) return;
        }
    }
};
$f1b1811a0002602d$var$_.extend = function(obj) {
    $f1b1811a0002602d$var$_.each($f1b1811a0002602d$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$f1b1811a0002602d$var$_.isArray = $f1b1811a0002602d$var$nativeIsArray || function(obj) {
    return $f1b1811a0002602d$var$toString.call(obj) === '[object Array]';
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$f1b1811a0002602d$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$f1b1811a0002602d$var$_.isArguments = function(obj) {
    return !!(obj && $f1b1811a0002602d$var$hasOwnProperty.call(obj, 'callee'));
};
$f1b1811a0002602d$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($f1b1811a0002602d$var$_.isArray(iterable)) return $f1b1811a0002602d$var$slice.call(iterable);
    if ($f1b1811a0002602d$var$_.isArguments(iterable)) return $f1b1811a0002602d$var$slice.call(iterable);
    return $f1b1811a0002602d$var$_.values(iterable);
};
$f1b1811a0002602d$var$_.map = function(arr, callback, context) {
    if ($f1b1811a0002602d$var$nativeMap && arr.map === $f1b1811a0002602d$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $f1b1811a0002602d$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$f1b1811a0002602d$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $f1b1811a0002602d$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$f1b1811a0002602d$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $f1b1811a0002602d$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$f1b1811a0002602d$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($f1b1811a0002602d$var$nativeIndexOf && obj.indexOf === $f1b1811a0002602d$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $f1b1811a0002602d$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $f1b1811a0002602d$var$breaker;
    });
    return found;
};
$f1b1811a0002602d$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$f1b1811a0002602d$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$f1b1811a0002602d$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$f1b1811a0002602d$var$_.isArray(obj);
};
$f1b1811a0002602d$var$_.isEmptyObject = function(obj) {
    if ($f1b1811a0002602d$var$_.isObject(obj)) {
        for(var key in obj){
            if ($f1b1811a0002602d$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$f1b1811a0002602d$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$f1b1811a0002602d$var$_.isString = function(obj) {
    return $f1b1811a0002602d$var$toString.call(obj) == '[object String]';
};
$f1b1811a0002602d$var$_.isDate = function(obj) {
    return $f1b1811a0002602d$var$toString.call(obj) == '[object Date]';
};
$f1b1811a0002602d$var$_.isNumber = function(obj) {
    return $f1b1811a0002602d$var$toString.call(obj) == '[object Number]';
};
$f1b1811a0002602d$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$f1b1811a0002602d$var$_.encodeDates = function(obj) {
    $f1b1811a0002602d$var$_.each(obj, function(v, k) {
        if ($f1b1811a0002602d$var$_.isDate(v)) obj[k] = $f1b1811a0002602d$var$_.formatDate(v);
        else if ($f1b1811a0002602d$var$_.isObject(v)) obj[k] = $f1b1811a0002602d$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$f1b1811a0002602d$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$f1b1811a0002602d$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds());
};
$f1b1811a0002602d$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $f1b1811a0002602d$var$_.each(p, function(v, k) {
        if ($f1b1811a0002602d$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $f1b1811a0002602d$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === 'string') ret = obj.slice(0, length);
    else if ($f1b1811a0002602d$var$_.isArray(obj)) {
        ret = [];
        $f1b1811a0002602d$var$_.each(obj, function(val) {
            ret.push($f1b1811a0002602d$var$_.truncate(val, length));
        });
    } else if ($f1b1811a0002602d$var$_.isObject(obj)) {
        ret = {};
        $f1b1811a0002602d$var$_.each(obj, function(val, key) {
            ret[key] = $f1b1811a0002602d$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$f1b1811a0002602d$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' && typeof value.toJSON === 'function') value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case 'string':
                    return quote(value);
                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';
                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return 'null';
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($f1b1811a0002602d$var$toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || 'null';
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($f1b1811a0002602d$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ': ' : ':') + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $f1b1811a0002602d$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        '\\': '\\',
        '/': '/',
        'b': '\b',
        'f': '\f',
        'n': '\n',
        'r': '\r',
        't': '\t'
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error('Expected \'' + c + '\' instead of \'' + ch + '\'');
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = '';
        if (ch === '-') {
            string = '-';
            next('-');
        }
        while(ch >= '0' && ch <= '9'){
            string += ch;
            next();
        }
        if (ch === '.') {
            string += '.';
            while(next() && ch >= '0' && ch <= '9')string += ch;
        }
        if (ch === 'e' || ch === 'E') {
            string += ch;
            next();
            if (ch === '-' || ch === '+') {
                string += ch;
                next();
            }
            while(ch >= '0' && ch <= '9'){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error('Bad number');
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = '', uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === '\\') {
                next();
                if (ch === 'u') {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === 'string') string += escapee[ch];
                else break;
            } else string += ch;
        }
        error('Bad string');
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= ' ')next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === '[') {
            next('[');
            white();
            if (ch === ']') {
                next(']');
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === ']') {
                    next(']');
                    return array;
                }
                next(',');
                white();
            }
        }
        error('Bad array');
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === '{') {
            next('{');
            white();
            if (ch === '}') {
                next('}');
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(':');
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === '}') {
                    next('}');
                    return object;
                }
                next(',');
                white();
            }
        }
        error('Bad object');
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) error('Syntax error');
        return result;
    };
}();
$f1b1811a0002602d$var$_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];
    if (!data) return data;
    data = $f1b1811a0002602d$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join('');
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }
    return enc;
};
$f1b1811a0002602d$var$_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var utftext = '', start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$f1b1811a0002602d$var$_.UUID = function() {
    try {
        // use native Crypto API when available
        return $f1b1811a0002602d$var$win['crypto']['randomUUID']();
    } catch (err) {
        // fall back to generating our own UUID
        // based on https://gist.github.com/scwood/3bff42cc005cc20ab7ec98f0d8e1d59d
        var uuid = new Array(36);
        for(var i = 0; i < 36; i++)uuid[i] = Math.floor(Math.random() * 16);
        uuid[14] = 4; // set bits 12-15 of time-high-and-version to 0100
        uuid[19] = uuid[19] &= -5; // set bit 6 of clock-seq-and-reserved to zero
        uuid[19] = uuid[19] |= 8; // set bit 7 of clock-seq-and-reserved to one
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        return $f1b1811a0002602d$var$_.map(uuid, function(x) {
            return x.toString(16);
        }).join('');
    }
};
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $f1b1811a0002602d$var$BLOCKED_UA_STRS = [
    'ahrefsbot',
    'ahrefssiteaudit',
    'amazonbot',
    'baiduspider',
    'bingbot',
    'bingpreview',
    'chrome-lighthouse',
    'facebookexternal',
    'petalbot',
    'pinterest',
    'screaming frog',
    'yahoo! slurp',
    'yandex',
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    'adsbot-google',
    'apis-google',
    'duplexweb-google',
    'feedfetcher-google',
    'google favicon',
    'google web preview',
    'google-read-aloud',
    'googlebot',
    'googleweblight',
    'mediapartners-google',
    'storebot-google'
];
$f1b1811a0002602d$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $f1b1811a0002602d$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($f1b1811a0002602d$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $f1b1811a0002602d$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($f1b1811a0002602d$var$_.isUndefined(arg_separator)) arg_separator = '&';
    $f1b1811a0002602d$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$f1b1811a0002602d$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/g, '\\[').replace(/[\]]/g, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)', regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== 'string' && results[1].length) return '';
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $f1b1811a0002602d$var$console$1.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$f1b1811a0002602d$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = $f1b1811a0002602d$var$document$1.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $f1b1811a0002602d$var$_.JSONDecode($f1b1811a0002602d$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $f1b1811a0002602d$var$extract_domain($f1b1811a0002602d$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        $f1b1811a0002602d$var$document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $f1b1811a0002602d$var$extract_domain($f1b1811a0002602d$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        $f1b1811a0002602d$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $f1b1811a0002602d$var$_.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $f1b1811a0002602d$var$_testStorageSupported = function(storage) {
    var supported = true;
    try {
        var key = '__mplss_' + $f1b1811a0002602d$var$cheap_guid(8), val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    return supported;
};
var $f1b1811a0002602d$var$_localStorageSupported = null;
var $f1b1811a0002602d$var$localStorageSupported = function(storage, forceCheck) {
    if ($f1b1811a0002602d$var$_localStorageSupported !== null && !forceCheck) return $f1b1811a0002602d$var$_localStorageSupported;
    return $f1b1811a0002602d$var$_localStorageSupported = $f1b1811a0002602d$var$_testStorageSupported(storage || $f1b1811a0002602d$var$win.localStorage);
};
var $f1b1811a0002602d$var$_sessionStorageSupported = null;
var $f1b1811a0002602d$var$sessionStorageSupported = function(storage, forceCheck) {
    if ($f1b1811a0002602d$var$_sessionStorageSupported !== null && !forceCheck) return $f1b1811a0002602d$var$_sessionStorageSupported;
    return $f1b1811a0002602d$var$_sessionStorageSupported = $f1b1811a0002602d$var$_testStorageSupported(storage || $f1b1811a0002602d$var$win.sessionStorage);
};
function $f1b1811a0002602d$var$_storageWrapper(storage, name, is_supported_fn) {
    var log_error = function(msg) {
        $f1b1811a0002602d$var$console$1.error(name + ' error: ' + msg);
    };
    return {
        is_supported: function(forceCheck) {
            var supported = is_supported_fn(storage, forceCheck);
            if (!supported) $f1b1811a0002602d$var$console$1.error(name + ' unsupported');
            return supported;
        },
        error: log_error,
        get: function(key) {
            try {
                return storage.getItem(key);
            } catch (err) {
                log_error(err);
            }
            return null;
        },
        parse: function(key) {
            try {
                return $f1b1811a0002602d$var$_.JSONDecode(storage.getItem(key)) || {};
            } catch (err) {
            // noop
            }
            return null;
        },
        set: function(key, value) {
            try {
                storage.setItem(key, value);
            } catch (err) {
                log_error(err);
            }
        },
        remove: function(key) {
            try {
                storage.removeItem(key);
            } catch (err) {
                log_error(err);
            }
        }
    };
}
$f1b1811a0002602d$var$_.localStorage = $f1b1811a0002602d$var$_storageWrapper($f1b1811a0002602d$var$win.localStorage, 'localStorage', $f1b1811a0002602d$var$localStorageSupported);
$f1b1811a0002602d$var$_.sessionStorage = $f1b1811a0002602d$var$_storageWrapper($f1b1811a0002602d$var$win.sessionStorage, 'sessionStorage', $f1b1811a0002602d$var$sessionStorageSupported);
$f1b1811a0002602d$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $f1b1811a0002602d$var$console$1.error('No valid element provided to register_event');
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent($f1b1811a0002602d$var$win.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($f1b1811a0002602d$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $f1b1811a0002602d$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$f1b1811a0002602d$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return (' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$f1b1811a0002602d$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $f1b1811a0002602d$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = $f1b1811a0002602d$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = '*';
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $f1b1811a0002602d$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($f1b1811a0002602d$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = '*';
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case '=':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case '~':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b'));
                        };
                        break;
                    case '|':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?'));
                        };
                        break;
                    case '^':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case '$':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case '*':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($f1b1811a0002602d$var$_.isElement(query)) return [
            query
        ];
        else if ($f1b1811a0002602d$var$_.isObject(query) && !$f1b1811a0002602d$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $f1b1811a0002602d$var$CAMPAIGN_KEYWORDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'utm_source_platform',
    'utm_campaign_id',
    'utm_creative_format',
    'utm_marketing_tactic'
];
var $f1b1811a0002602d$var$CLICK_IDS = [
    'dclid',
    'fbclid',
    'gclid',
    'ko_click_id',
    'li_fat_id',
    'msclkid',
    'sccid',
    'ttclid',
    'twclid',
    'wbraid'
];
$f1b1811a0002602d$var$_.info = {
    campaignParams: function(default_value) {
        var kw = '', params = {};
        $f1b1811a0002602d$var$_.each($f1b1811a0002602d$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $f1b1811a0002602d$var$_.getQueryParam($f1b1811a0002602d$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = '', params = {};
        $f1b1811a0002602d$var$_.each($f1b1811a0002602d$var$CLICK_IDS, function(idkey) {
            id = $f1b1811a0002602d$var$_.getQueryParam($f1b1811a0002602d$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return $f1b1811a0002602d$var$_.extend($f1b1811a0002602d$var$_.info.campaignParams(), $f1b1811a0002602d$var$_.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) return 'google';
        else if (referrer.search('https?://(.*)bing.com') === 0) return 'bing';
        else if (referrer.search('https?://(.*)yahoo.com') === 0) return 'yahoo';
        else if (referrer.search('https?://(.*)duckduckgo.com') === 0) return 'duckduckgo';
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $f1b1811a0002602d$var$_.info.searchEngine(referrer), param = search != 'yahoo' ? 'q' : 'p', ret = {};
        if (search !== null) {
            ret['$search_engine'] = search;
            var keyword = $f1b1811a0002602d$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret['mp_keyword'] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || $f1b1811a0002602d$var$_.includes(user_agent, ' OPR/')) {
            if ($f1b1811a0002602d$var$_.includes(user_agent, 'Mini')) return 'Opera Mini';
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'IEMobile') || $f1b1811a0002602d$var$_.includes(user_agent, 'WPDesktop')) return 'Internet Explorer Mobile';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'SamsungBrowser/')) // https://developer.samsung.com/internet/user-agent-string-format
        return 'Samsung Internet';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'Edge') || $f1b1811a0002602d$var$_.includes(user_agent, 'Edg/')) return 'Microsoft Edge';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'FBIOS')) return 'Facebook Mobile';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'Whale/')) // https://user-agents.net/browsers/whale-browser
        return 'Whale Browser';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'Chrome')) return 'Chrome';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'CriOS')) return 'Chrome iOS';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'UCWEB') || $f1b1811a0002602d$var$_.includes(user_agent, 'UCBrowser')) return 'UC Browser';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'FxiOS')) return 'Firefox iOS';
        else if ($f1b1811a0002602d$var$_.includes(vendor, 'Apple')) {
            if ($f1b1811a0002602d$var$_.includes(user_agent, 'Mobile')) return 'Mobile Safari';
            return 'Safari';
        } else if ($f1b1811a0002602d$var$_.includes(user_agent, 'Android')) return 'Android Mobile';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'Konqueror')) return 'Konqueror';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'Firefox')) return 'Firefox';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'MSIE') || $f1b1811a0002602d$var$_.includes(user_agent, 'Trident/')) return 'Internet Explorer';
        else if ($f1b1811a0002602d$var$_.includes(user_agent, 'Gecko')) return 'Mozilla';
        else return '';
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $f1b1811a0002602d$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/,
            'Whale Browser': /Whale\/(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $f1b1811a0002602d$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return 'Windows Phone';
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) return 'iOS';
        else if (/Android/.test(a)) return 'Android';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return 'BlackBerry';
        else if (/Mac/i.test(a)) return 'Mac OS X';
        else if (/Linux/.test(a)) return 'Linux';
        else if (/CrOS/.test(a)) return 'Chrome OS';
        else return '';
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return 'Windows Phone';
        else if (/iPad/.test(user_agent)) return 'iPad';
        else if (/iPod/.test(user_agent)) return 'iPod Touch';
        else if (/iPhone/.test(user_agent)) return 'iPhone';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if (/Android/.test(user_agent)) return 'Android';
        else return '';
    },
    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) return split[2];
        return '';
    },
    currentUrl: function() {
        return $f1b1811a0002602d$var$win.location.href;
    },
    properties: function(extra_props) {
        if (typeof extra_props !== 'object') extra_props = {};
        return $f1b1811a0002602d$var$_.extend($f1b1811a0002602d$var$_.strip_empty_properties({
            '$os': $f1b1811a0002602d$var$_.info.os(),
            '$browser': $f1b1811a0002602d$var$_.info.browser($f1b1811a0002602d$var$userAgent, $f1b1811a0002602d$var$navigator.vendor, $f1b1811a0002602d$var$windowOpera),
            '$referrer': $f1b1811a0002602d$var$document$1.referrer,
            '$referring_domain': $f1b1811a0002602d$var$_.info.referringDomain($f1b1811a0002602d$var$document$1.referrer),
            '$device': $f1b1811a0002602d$var$_.info.device($f1b1811a0002602d$var$userAgent)
        }), {
            '$current_url': $f1b1811a0002602d$var$_.info.currentUrl(),
            '$browser_version': $f1b1811a0002602d$var$_.info.browserVersion($f1b1811a0002602d$var$userAgent, $f1b1811a0002602d$var$navigator.vendor, $f1b1811a0002602d$var$windowOpera),
            '$screen_height': $f1b1811a0002602d$var$screen.height,
            '$screen_width': $f1b1811a0002602d$var$screen.width,
            'mp_lib': 'web',
            '$lib_version': $f1b1811a0002602d$var$Config.LIB_VERSION,
            '$insert_id': $f1b1811a0002602d$var$cheap_guid(),
            'time': $f1b1811a0002602d$var$_.timestamp() / 1000 // epoch time in seconds
        }, $f1b1811a0002602d$var$_.strip_empty_properties(extra_props));
    },
    people_properties: function() {
        return $f1b1811a0002602d$var$_.extend($f1b1811a0002602d$var$_.strip_empty_properties({
            '$os': $f1b1811a0002602d$var$_.info.os(),
            '$browser': $f1b1811a0002602d$var$_.info.browser($f1b1811a0002602d$var$userAgent, $f1b1811a0002602d$var$navigator.vendor, $f1b1811a0002602d$var$windowOpera)
        }), {
            '$browser_version': $f1b1811a0002602d$var$_.info.browserVersion($f1b1811a0002602d$var$userAgent, $f1b1811a0002602d$var$navigator.vendor, $f1b1811a0002602d$var$windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return $f1b1811a0002602d$var$_.strip_empty_properties({
            'current_page_title': $f1b1811a0002602d$var$document$1.title,
            'current_domain': $f1b1811a0002602d$var$win.location.hostname,
            'current_url_path': $f1b1811a0002602d$var$win.location.pathname,
            'current_url_protocol': $f1b1811a0002602d$var$win.location.protocol,
            'current_url_search': $f1b1811a0002602d$var$win.location.search
        });
    }
};
/**
 * Returns a throttled function that will only run at most every `waitMs` and returns a promise that resolves with the next invocation.
 * Throttled calls will build up a batch of args and invoke the callback with all args since the last invocation.
 */ var $f1b1811a0002602d$var$batchedThrottle = function(fn, waitMs) {
    var timeoutPromise = null;
    var throttledItems = [];
    return function(item) {
        var self = this;
        throttledItems.push(item);
        if (!timeoutPromise) timeoutPromise = new $f1b1811a0002602d$var$PromisePolyfill(function(resolve) {
            setTimeout(function() {
                var returnValue = fn.apply(self, [
                    throttledItems
                ]);
                timeoutPromise = null;
                throttledItems = [];
                resolve(returnValue);
            }, waitMs);
        });
        return timeoutPromise;
    };
};
var $f1b1811a0002602d$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $f1b1811a0002602d$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $f1b1811a0002602d$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $f1b1811a0002602d$var$extract_domain = function(hostname) {
    var domain_regex = $f1b1811a0002602d$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') domain_regex = $f1b1811a0002602d$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};
/**
 * Check whether we have network connection. default to true for browsers that don't support navigator.onLine (IE)
 * @returns {boolean}
 */ var $f1b1811a0002602d$var$isOnline = function() {
    var onLine = $f1b1811a0002602d$var$win.navigator['onLine'];
    return $f1b1811a0002602d$var$_.isUndefined(onLine) || onLine;
};
var $f1b1811a0002602d$var$NOOP_FUNC = function() {};
var $f1b1811a0002602d$var$JSONStringify = null, $f1b1811a0002602d$var$JSONParse = null;
if (typeof JSON !== 'undefined') {
    $f1b1811a0002602d$var$JSONStringify = JSON.stringify;
    $f1b1811a0002602d$var$JSONParse = JSON.parse;
}
$f1b1811a0002602d$var$JSONStringify = $f1b1811a0002602d$var$JSONStringify || $f1b1811a0002602d$var$_.JSONEncode;
$f1b1811a0002602d$var$JSONParse = $f1b1811a0002602d$var$JSONParse || $f1b1811a0002602d$var$_.JSONDecode;
// UNMINIFIED EXPORTS (for closure compiler)
$f1b1811a0002602d$var$_['info'] = $f1b1811a0002602d$var$_.info;
$f1b1811a0002602d$var$_['info']['browser'] = $f1b1811a0002602d$var$_.info.browser;
$f1b1811a0002602d$var$_['info']['browserVersion'] = $f1b1811a0002602d$var$_.info.browserVersion;
$f1b1811a0002602d$var$_['info']['device'] = $f1b1811a0002602d$var$_.info.device;
$f1b1811a0002602d$var$_['info']['properties'] = $f1b1811a0002602d$var$_.info.properties;
$f1b1811a0002602d$var$_['isBlockedUA'] = $f1b1811a0002602d$var$_.isBlockedUA;
$f1b1811a0002602d$var$_['isEmptyObject'] = $f1b1811a0002602d$var$_.isEmptyObject;
$f1b1811a0002602d$var$_['isObject'] = $f1b1811a0002602d$var$_.isObject;
$f1b1811a0002602d$var$_['JSONDecode'] = $f1b1811a0002602d$var$_.JSONDecode;
$f1b1811a0002602d$var$_['JSONEncode'] = $f1b1811a0002602d$var$_.JSONEncode;
$f1b1811a0002602d$var$_['toArray'] = $f1b1811a0002602d$var$_.toArray;
$f1b1811a0002602d$var$_['NPO'] = $f1b1811a0002602d$var$NpoPromise;
var $f1b1811a0002602d$var$MIXPANEL_DB_NAME = 'mixpanelBrowserDb';
var $f1b1811a0002602d$var$RECORDING_EVENTS_STORE_NAME = 'mixpanelRecordingEvents';
var $f1b1811a0002602d$var$RECORDING_REGISTRY_STORE_NAME = 'mixpanelRecordingRegistry';
// note: increment the version number when adding new object stores
var $f1b1811a0002602d$var$DB_VERSION = 1;
var $f1b1811a0002602d$var$OBJECT_STORES = [
    $f1b1811a0002602d$var$RECORDING_EVENTS_STORE_NAME,
    $f1b1811a0002602d$var$RECORDING_REGISTRY_STORE_NAME
];
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var $f1b1811a0002602d$var$IDBStorageWrapper = function(storeName) {
    /**
     * @type {Promise<IDBDatabase>|null}
     */ this.dbPromise = null;
    this.storeName = storeName;
};
$f1b1811a0002602d$var$IDBStorageWrapper.prototype._openDb = function() {
    return new $f1b1811a0002602d$var$PromisePolyfill(function(resolve, reject) {
        var openRequest = $f1b1811a0002602d$var$win.indexedDB.open($f1b1811a0002602d$var$MIXPANEL_DB_NAME, $f1b1811a0002602d$var$DB_VERSION);
        openRequest['onerror'] = function() {
            reject(openRequest.error);
        };
        openRequest['onsuccess'] = function() {
            resolve(openRequest.result);
        };
        openRequest['onupgradeneeded'] = function(ev) {
            var db = ev.target.result;
            $f1b1811a0002602d$var$OBJECT_STORES.forEach(function(storeName) {
                db.createObjectStore(storeName);
            });
        };
    });
};
$f1b1811a0002602d$var$IDBStorageWrapper.prototype.init = function() {
    if (!$f1b1811a0002602d$var$win.indexedDB) return $f1b1811a0002602d$var$PromisePolyfill.reject('indexedDB is not supported in this browser');
    if (!this.dbPromise) this.dbPromise = this._openDb();
    return this.dbPromise.then(function(dbOrError) {
        if (dbOrError instanceof $f1b1811a0002602d$var$win['IDBDatabase']) return $f1b1811a0002602d$var$PromisePolyfill.resolve();
        else return $f1b1811a0002602d$var$PromisePolyfill.reject(dbOrError);
    });
};
/**
 * @param {IDBTransactionMode} mode
 * @param {function(IDBObjectStore): void} storeCb
 */ $f1b1811a0002602d$var$IDBStorageWrapper.prototype.makeTransaction = function(mode, storeCb) {
    var storeName = this.storeName;
    var doTransaction = function(db) {
        return new $f1b1811a0002602d$var$PromisePolyfill(function(resolve, reject) {
            var transaction = db.transaction(storeName, mode);
            transaction.oncomplete = function() {
                resolve(transaction);
            };
            transaction.onabort = transaction.onerror = function() {
                reject(transaction.error);
            };
            storeCb(transaction.objectStore(storeName));
        });
    };
    return this.dbPromise.then(doTransaction).catch((function(err) {
        if (err && err['name'] === 'InvalidStateError') {
            // try reopening the DB if the connection is closed
            this.dbPromise = this._openDb();
            return this.dbPromise.then(doTransaction);
        } else return $f1b1811a0002602d$var$PromisePolyfill.reject(err);
    }).bind(this));
};
$f1b1811a0002602d$var$IDBStorageWrapper.prototype.setItem = function(key, value) {
    return this.makeTransaction('readwrite', function(objectStore) {
        objectStore.put(value, key);
    });
};
$f1b1811a0002602d$var$IDBStorageWrapper.prototype.getItem = function(key) {
    var req;
    return this.makeTransaction('readonly', function(objectStore) {
        req = objectStore.get(key);
    }).then(function() {
        return req.result;
    });
};
$f1b1811a0002602d$var$IDBStorageWrapper.prototype.removeItem = function(key) {
    return this.makeTransaction('readwrite', function(objectStore) {
        objectStore.delete(key);
    });
};
$f1b1811a0002602d$var$IDBStorageWrapper.prototype.getAll = function() {
    var req;
    return this.makeTransaction('readonly', function(objectStore) {
        req = objectStore.getAll();
    }).then(function() {
        return req.result;
    });
};
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ /**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $f1b1811a0002602d$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $f1b1811a0002602d$var$optIn(token, options) {
    $f1b1811a0002602d$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $f1b1811a0002602d$var$optOut(token, options) {
    $f1b1811a0002602d$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $f1b1811a0002602d$var$hasOptedIn(token, options) {
    return $f1b1811a0002602d$var$_getStorageValue(token, options) === '1';
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $f1b1811a0002602d$var$hasOptedOut(token, options) {
    if ($f1b1811a0002602d$var$_hasDoNotTrackFlagOn(options)) {
        $f1b1811a0002602d$var$console$1.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $f1b1811a0002602d$var$_getStorageValue(token, options) === '0';
    if (optedOut) $f1b1811a0002602d$var$console$1.warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $f1b1811a0002602d$var$addOptOutCheckMixpanelLib(method) {
    return $f1b1811a0002602d$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $f1b1811a0002602d$var$addOptOutCheckMixpanelPeople(method) {
    return $f1b1811a0002602d$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $f1b1811a0002602d$var$addOptOutCheckMixpanelGroup(method) {
    return $f1b1811a0002602d$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $f1b1811a0002602d$var$clearOptInOut(token, options) {
    options = options || {};
    $f1b1811a0002602d$var$_getStorage(options).remove($f1b1811a0002602d$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $f1b1811a0002602d$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? $f1b1811a0002602d$var$_.localStorage : $f1b1811a0002602d$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $f1b1811a0002602d$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $f1b1811a0002602d$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $f1b1811a0002602d$var$_getStorageValue(token, options) {
    return $f1b1811a0002602d$var$_getStorage(options).get($f1b1811a0002602d$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $f1b1811a0002602d$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win$1 = options && options.window || $f1b1811a0002602d$var$win;
    var nav = win$1['navigator'] || {};
    var hasDntOn = false;
    $f1b1811a0002602d$var$_.each([
        nav['doNotTrack'],
        nav['msDoNotTrack'],
        win$1['doNotTrack']
    ], function(dntValue) {
        if ($f1b1811a0002602d$var$_.includes([
            true,
            1,
            '1',
            'yes'
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $f1b1811a0002602d$var$_optInOut(optValue, token, options) {
    if (!$f1b1811a0002602d$var$_.isString(token) || !token.length) {
        $f1b1811a0002602d$var$console$1.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }
    options = options || {};
    $f1b1811a0002602d$var$_getStorage(options).set($f1b1811a0002602d$var$_getStorageKey(token, options), optValue ? 1 : 0, $f1b1811a0002602d$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || '$opt_in', options.trackProperties, {
        'send_immediately': true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $f1b1811a0002602d$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests
            if (token) optedOut = $f1b1811a0002602d$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $f1b1811a0002602d$var$console$1.error('Unexpected error when checking tracking opt-out status: ' + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === 'function') callback(0);
        return;
    };
}
var $f1b1811a0002602d$var$logger$6 = $f1b1811a0002602d$var$console_with_prefix('lock');
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $f1b1811a0002602d$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || $f1b1811a0002602d$var$win.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
    // dependency-inject promise implementation for testing purposes
    this.promiseImpl = options.promiseImpl || $f1b1811a0002602d$var$PromisePolyfill;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$f1b1811a0002602d$var$SharedLock.prototype.withLock = function(lockedCB, pid) {
    var Promise1 = this.promiseImpl;
    return new Promise1($f1b1811a0002602d$var$_.bind(function(resolve, reject) {
        var i = pid || new Date().getTime() + '|' + Math.random();
        var startTime = new Date().getTime();
        var key = this.storageKey;
        var pollIntervalMS = this.pollIntervalMS;
        var timeoutMS = this.timeoutMS;
        var storage = this.storage;
        var keyX = key + ':X';
        var keyY = key + ':Y';
        var keyZ = key + ':Z';
        var delay = function(cb) {
            if (new Date().getTime() - startTime > timeoutMS) {
                $f1b1811a0002602d$var$logger$6.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
                storage.removeItem(keyZ);
                storage.removeItem(keyY);
                loop();
                return;
            }
            setTimeout(function() {
                try {
                    cb();
                } catch (err) {
                    reject(err);
                }
            }, pollIntervalMS * (Math.random() + 0.1));
        };
        var waitFor = function(predicate, cb) {
            if (predicate()) cb();
            else delay(function() {
                waitFor(predicate, cb);
            });
        };
        var getSetY = function() {
            var valY = storage.getItem(keyY);
            if (valY && valY !== i) return false;
            else {
                storage.setItem(keyY, i);
                if (storage.getItem(keyY) === i) return true;
                else {
                    if (!$f1b1811a0002602d$var$localStorageSupported(storage, true)) reject(new Error('localStorage support dropped while acquiring lock'));
                    return false;
                }
            }
        };
        var loop = function() {
            storage.setItem(keyX, i);
            waitFor(getSetY, function() {
                if (storage.getItem(keyX) === i) {
                    criticalSection();
                    return;
                }
                delay(function() {
                    if (storage.getItem(keyY) !== i) {
                        loop();
                        return;
                    }
                    waitFor(function() {
                        return !storage.getItem(keyZ);
                    }, criticalSection);
                });
            });
        };
        var criticalSection = function() {
            storage.setItem(keyZ, '1');
            var removeLock = function() {
                storage.removeItem(keyZ);
                if (storage.getItem(keyY) === i) storage.removeItem(keyY);
                if (storage.getItem(keyX) === i) storage.removeItem(keyX);
            };
            lockedCB().then(function(ret) {
                removeLock();
                resolve(ret);
            }).catch(function(err) {
                removeLock();
                reject(err);
            });
        };
        try {
            if ($f1b1811a0002602d$var$localStorageSupported(storage, true)) loop();
            else throw new Error('localStorage support check failed');
        } catch (err) {
            reject(err);
        }
    }, this));
};
/**
 * @type {import('./wrapper').StorageWrapper}
 */ var $f1b1811a0002602d$var$LocalStorageWrapper = function(storageOverride) {
    this.storage = storageOverride || $f1b1811a0002602d$var$win.localStorage;
};
$f1b1811a0002602d$var$LocalStorageWrapper.prototype.init = function() {
    return $f1b1811a0002602d$var$PromisePolyfill.resolve();
};
$f1b1811a0002602d$var$LocalStorageWrapper.prototype.setItem = function(key, value) {
    return new $f1b1811a0002602d$var$PromisePolyfill($f1b1811a0002602d$var$_.bind(function(resolve, reject) {
        try {
            this.storage.setItem(key, $f1b1811a0002602d$var$JSONStringify(value));
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
$f1b1811a0002602d$var$LocalStorageWrapper.prototype.getItem = function(key) {
    return new $f1b1811a0002602d$var$PromisePolyfill($f1b1811a0002602d$var$_.bind(function(resolve, reject) {
        var item;
        try {
            item = $f1b1811a0002602d$var$JSONParse(this.storage.getItem(key));
        } catch (e) {
            reject(e);
        }
        resolve(item);
    }, this));
};
$f1b1811a0002602d$var$LocalStorageWrapper.prototype.removeItem = function(key) {
    return new $f1b1811a0002602d$var$PromisePolyfill($f1b1811a0002602d$var$_.bind(function(resolve, reject) {
        try {
            this.storage.removeItem(key);
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
var $f1b1811a0002602d$var$logger$5 = $f1b1811a0002602d$var$console_with_prefix('batch');
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $f1b1811a0002602d$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.usePersistence = options.usePersistence;
    if (this.usePersistence) {
        this.queueStorage = options.queueStorage || new $f1b1811a0002602d$var$LocalStorageWrapper();
        this.lock = new $f1b1811a0002602d$var$SharedLock(storageKey, {
            storage: options.sharedLockStorage || $f1b1811a0002602d$var$win.localStorage,
            timeoutMS: options.sharedLockTimeoutMS
        });
    }
    this.reportError = options.errorReporter || $f1b1811a0002602d$var$_.bind($f1b1811a0002602d$var$logger$5.error, $f1b1811a0002602d$var$logger$5);
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
    this.initialized = false;
    if (options.enqueueThrottleMs) this.enqueuePersisted = $f1b1811a0002602d$var$batchedThrottle($f1b1811a0002602d$var$_.bind(this._enqueuePersisted, this), options.enqueueThrottleMs);
    else this.enqueuePersisted = $f1b1811a0002602d$var$_.bind(function(queueEntry) {
        return this._enqueuePersisted([
            queueEntry
        ]);
    }, this);
};
$f1b1811a0002602d$var$RequestQueue.prototype.ensureInit = function() {
    if (this.initialized) return $f1b1811a0002602d$var$PromisePolyfill.resolve();
    return this.queueStorage.init().then($f1b1811a0002602d$var$_.bind(function() {
        this.initialized = true;
    }, this)).catch($f1b1811a0002602d$var$_.bind(function(err) {
        this.reportError('Error initializing queue persistence. Disabling persistence', err);
        this.initialized = true;
        this.usePersistence = false;
    }, this));
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $f1b1811a0002602d$var$RequestQueue.prototype.enqueue = function(item, flushInterval) {
    var queueEntry = {
        'id': $f1b1811a0002602d$var$cheap_guid(),
        'flushAfter': new Date().getTime() + flushInterval * 2,
        'payload': item
    };
    if (!this.usePersistence) {
        this.memQueue.push(queueEntry);
        return $f1b1811a0002602d$var$PromisePolyfill.resolve(true);
    } else return this.enqueuePersisted(queueEntry);
};
$f1b1811a0002602d$var$RequestQueue.prototype._enqueuePersisted = function(queueEntries) {
    var enqueueItem = $f1b1811a0002602d$var$_.bind(function() {
        return this.ensureInit().then($f1b1811a0002602d$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($f1b1811a0002602d$var$_.bind(function(storedQueue) {
            return this.saveToStorage(storedQueue.concat(queueEntries));
        }, this)).then($f1b1811a0002602d$var$_.bind(function(succeeded) {
            // only add to in-memory queue when storage succeeds
            if (succeeded) this.memQueue = this.memQueue.concat(queueEntries);
            return succeeded;
        }, this)).catch($f1b1811a0002602d$var$_.bind(function(err) {
            this.reportError('Error enqueueing items', err, queueEntries);
            return false;
        }, this));
    }, this);
    return this.lock.withLock(enqueueItem, this.pid).catch($f1b1811a0002602d$var$_.bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $f1b1811a0002602d$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (this.usePersistence && batch.length < batchSize) // don't need lock just to read events; localStorage is thread-safe
    // and the worst that could happen is a duplicate send of some
    // orphaned events, which will be deduplicated on the server side
    return this.ensureInit().then($f1b1811a0002602d$var$_.bind(function() {
        return this.readFromStorage();
    }, this)).then($f1b1811a0002602d$var$_.bind(function(storedQueue) {
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $f1b1811a0002602d$var$_.each(batch, function(item) {
                idsInBatch[item['id']] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
        return batch;
    }, this));
    else return $f1b1811a0002602d$var$PromisePolyfill.resolve(batch);
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $f1b1811a0002602d$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $f1b1811a0002602d$var$_.each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $f1b1811a0002602d$var$RequestQueue.prototype.removeItemsByID = function(ids) {
    var idSet = {}; // poor man's Set
    $f1b1811a0002602d$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $f1b1811a0002602d$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    if (!this.usePersistence) return $f1b1811a0002602d$var$PromisePolyfill.resolve(true);
    else {
        var removeFromStorage = $f1b1811a0002602d$var$_.bind(function() {
            return this.ensureInit().then($f1b1811a0002602d$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($f1b1811a0002602d$var$_.bind(function(storedQueue) {
                storedQueue = $f1b1811a0002602d$var$filterOutIDsAndInvalid(storedQueue, idSet);
                return this.saveToStorage(storedQueue);
            }, this)).then($f1b1811a0002602d$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($f1b1811a0002602d$var$_.bind(function(storedQueue) {
                // an extra check: did storage report success but somehow
                // the items are still there?
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item['id'] && !!idSet[item['id']]) throw new Error('Item not removed from storage');
                }
                return true;
            }, this)).catch($f1b1811a0002602d$var$_.bind(function(err) {
                this.reportError('Error removing items', err, ids);
                return false;
            }, this));
        }, this);
        return this.lock.withLock(removeFromStorage, this.pid).catch($f1b1811a0002602d$var$_.bind(function(err) {
            this.reportError('Error acquiring storage lock', err);
            if (!$f1b1811a0002602d$var$localStorageSupported(this.lock.storage, true)) // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            return removeFromStorage().then($f1b1811a0002602d$var$_.bind(function(success) {
                if (!success) // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                return this.queueStorage.removeItem(this.storageKey).then(function() {
                    return success;
                });
                return success;
            }, this)).catch($f1b1811a0002602d$var$_.bind(function(err) {
                this.reportError('Error clearing queue', err);
                return false;
            }, this));
            else return false;
        }, this));
    }
};
// internal helper for RequestQueue.updatePayloads
var $f1b1811a0002602d$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $f1b1811a0002602d$var$_.each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $f1b1811a0002602d$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate) {
    this.memQueue = $f1b1811a0002602d$var$updatePayloads(this.memQueue, itemsToUpdate);
    if (!this.usePersistence) return $f1b1811a0002602d$var$PromisePolyfill.resolve(true);
    else return this.lock.withLock($f1b1811a0002602d$var$_.bind(function lockAcquired() {
        return this.ensureInit().then($f1b1811a0002602d$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($f1b1811a0002602d$var$_.bind(function(storedQueue) {
            storedQueue = $f1b1811a0002602d$var$updatePayloads(storedQueue, itemsToUpdate);
            return this.saveToStorage(storedQueue);
        }, this)).catch($f1b1811a0002602d$var$_.bind(function(err) {
            this.reportError('Error updating items', itemsToUpdate, err);
            return false;
        }, this));
    }, this), this.pid).catch($f1b1811a0002602d$var$_.bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $f1b1811a0002602d$var$RequestQueue.prototype.readFromStorage = function() {
    return this.ensureInit().then($f1b1811a0002602d$var$_.bind(function() {
        return this.queueStorage.getItem(this.storageKey);
    }, this)).then($f1b1811a0002602d$var$_.bind(function(storageEntry) {
        if (storageEntry) {
            if (!$f1b1811a0002602d$var$_.isArray(storageEntry)) {
                this.reportError('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
        return storageEntry || [];
    }, this)).catch($f1b1811a0002602d$var$_.bind(function(err) {
        this.reportError('Error retrieving queue', err);
        return [];
    }, this));
};
/**
 * Serialize the given items array to localStorage.
 */ $f1b1811a0002602d$var$RequestQueue.prototype.saveToStorage = function(queue) {
    return this.ensureInit().then($f1b1811a0002602d$var$_.bind(function() {
        return this.queueStorage.setItem(this.storageKey, queue);
    }, this)).then(function() {
        return true;
    }).catch($f1b1811a0002602d$var$_.bind(function(err) {
        this.reportError('Error saving queue', err);
        return false;
    }, this));
};
/**
 * Clear out queues (memory and localStorage).
 */ $f1b1811a0002602d$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    if (this.usePersistence) return this.ensureInit().then($f1b1811a0002602d$var$_.bind(function() {
        return this.queueStorage.removeItem(this.storageKey);
    }, this));
    else return $f1b1811a0002602d$var$PromisePolyfill.resolve();
};
// maximum interval between request retries after exponential backoff
var $f1b1811a0002602d$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $f1b1811a0002602d$var$logger$4 = $f1b1811a0002602d$var$console_with_prefix('batch');
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $f1b1811a0002602d$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $f1b1811a0002602d$var$RequestQueue(storageKey, {
        errorReporter: $f1b1811a0002602d$var$_.bind(this.reportError, this),
        queueStorage: options.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        sharedLockTimeoutMS: options.sharedLockTimeoutMS,
        usePersistence: options.usePersistence,
        enqueueThrottleMs: options.enqueueThrottleMs
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];
    this.stopped = !this.libConfig['batch_autostart'];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
    // Make the flush occur at the interval specified by flushIntervalMs, default behavior will attempt consecutive flushes
    // as long as the queue is not empty. This is useful for high-frequency events like Session Replay where we might end up
    // in a request loop and get ratelimited by the server.
    this.flushOnlyOnInterval = options.flushOnlyOnInterval || false;
    this._flushPromise = null;
};
/**
 * Add one item to queue.
 */ $f1b1811a0002602d$var$RequestBatcher.prototype.enqueue = function(item) {
    return this.queue.enqueue(item, this.flushInterval);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $f1b1811a0002602d$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    return this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $f1b1811a0002602d$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $f1b1811a0002602d$var$RequestBatcher.prototype.clear = function() {
    return this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $f1b1811a0002602d$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $f1b1811a0002602d$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $f1b1811a0002602d$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($f1b1811a0002602d$var$_.bind(function() {
        if (!this.stopped) this._flushPromise = this.flush();
    }, this), this.flushInterval);
};
/**
 * Send a request using the sendRequest callback, but promisified.
 * TODO: sendRequest should be promisified in the first place.
 */ $f1b1811a0002602d$var$RequestBatcher.prototype.sendRequestPromise = function(data, options) {
    return new $f1b1811a0002602d$var$PromisePolyfill($f1b1811a0002602d$var$_.bind(function(resolve) {
        this.sendRequest(data, options, resolve);
    }, this));
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $f1b1811a0002602d$var$RequestBatcher.prototype.flush = function(options) {
    if (this.requestInProgress) {
        $f1b1811a0002602d$var$logger$4.log('Flush: Request already in progress');
        return $f1b1811a0002602d$var$PromisePolyfill.resolve();
    }
    this.requestInProgress = true;
    options = options || {};
    var timeoutMS = this.libConfig['batch_request_timeout_ms'];
    var startTime = new Date().getTime();
    var currentBatchSize = this.batchSize;
    return this.queue.fillBatch(currentBatchSize).then($f1b1811a0002602d$var$_.bind(function(batch) {
        // if there's more items in the queue than the batch size, attempt
        // to flush again after the current batch is done.
        var attemptSecondaryFlush = batch.length === currentBatchSize;
        var dataForRequest = [];
        var transformedItems = {};
        $f1b1811a0002602d$var$_.each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload['event'] && payload['properties']) payload['properties'] = $f1b1811a0002602d$var$_.extend({}, payload['properties'], {
                    'mp_sent_by_lib_version': $f1b1811a0002602d$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item['id'];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError('[dupe] item ID sent too many times, not sending', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError('[dupe] found item with no ID', {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.requestInProgress = false;
            this.resetFlush();
            return $f1b1811a0002602d$var$PromisePolyfill.resolve(); // nothing to do
        }
        var removeItemsFromQueue = $f1b1811a0002602d$var$_.bind(function() {
            return this.queue.removeItemsByID($f1b1811a0002602d$var$_.map(batch, function(item) {
                return item['id'];
            })).then($f1b1811a0002602d$var$_.bind(function(succeeded) {
                // client-side dedupe
                $f1b1811a0002602d$var$_.each(batch, $f1b1811a0002602d$var$_.bind(function(item) {
                    var itemId = item['id'];
                    if (itemId) {
                        this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                        this.itemIdsSentSuccessfully[itemId]++;
                        if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError('[dupe] item ID sent too many times', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                    } else this.reportError('[dupe] found item with no ID while removing', {
                        item: item
                    });
                }, this));
                if (succeeded) {
                    this.consecutiveRemovalFailures = 0;
                    if (this.flushOnlyOnInterval && !attemptSecondaryFlush) {
                        this.resetFlush(); // schedule next batch with a delay
                        return $f1b1811a0002602d$var$PromisePolyfill.resolve();
                    } else return this.flush(); // handle next batch if the queue isn't empty
                } else {
                    if (++this.consecutiveRemovalFailures > 5) {
                        this.reportError('Too many queue failures; disabling batching system.');
                        this.stopAllBatching();
                    } else this.resetFlush();
                    return $f1b1811a0002602d$var$PromisePolyfill.resolve();
                }
            }, this));
        }, this);
        var batchSendCallback = $f1b1811a0002602d$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                if (options.unloading) // update persisted data to include hook transformations
                return this.queue.updatePayloads(transformedItems);
                else if ($f1b1811a0002602d$var$_.isObject(res) && res.error === 'timeout' && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError('Network timeout; retrying');
                    return this.flush();
                } else if ($f1b1811a0002602d$var$_.isObject(res) && (res.httpStatusCode >= 500 || res.httpStatusCode === 429 || res.httpStatusCode <= 0 && !$f1b1811a0002602d$var$isOnline() || res.error === 'timeout')) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    if (res.retryAfter) retryMS = parseInt(res.retryAfter, 10) * 1000 || retryMS;
                    retryMS = Math.min($f1b1811a0002602d$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                    return $f1b1811a0002602d$var$PromisePolyfill.resolve();
                } else if ($f1b1811a0002602d$var$_.isObject(res) && res.httpStatusCode === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                        return $f1b1811a0002602d$var$PromisePolyfill.resolve();
                    } else {
                        this.reportError('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        return removeItemsFromQueue();
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                return removeItemsFromQueue();
            } catch (err) {
                this.reportError('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = 'sendBeacon';
        $f1b1811a0002602d$var$logger$4.log('MIXPANEL REQUEST:', dataForRequest);
        return this.sendRequestPromise(dataForRequest, requestOptions).then(batchSendCallback);
    }, this)).catch($f1b1811a0002602d$var$_.bind(function(err) {
        this.reportError('Error flushing request queue', err);
        this.resetFlush();
    }, this));
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $f1b1811a0002602d$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $f1b1811a0002602d$var$logger$4.error.apply($f1b1811a0002602d$var$logger$4.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $f1b1811a0002602d$var$logger$4.error(err);
    }
};
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 * @returns {boolean}
 */ var $f1b1811a0002602d$var$isRecordingExpired = function(serializedRecording) {
    var now = Date.now();
    return !serializedRecording || now > serializedRecording['maxExpires'] || now > serializedRecording['idleExpires'];
};
var $f1b1811a0002602d$var$RECORD_ENQUEUE_THROTTLE_MS = 250;
var $f1b1811a0002602d$var$logger$3 = $f1b1811a0002602d$var$console_with_prefix('recorder');
var $f1b1811a0002602d$var$CompressionStream = $f1b1811a0002602d$var$win['CompressionStream'];
var $f1b1811a0002602d$var$RECORDER_BATCHER_LIB_CONFIG = {
    'batch_size': 1000,
    'batch_flush_interval_ms': 10000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true
};
var $f1b1811a0002602d$var$ACTIVE_SOURCES = new Set([
    $f1b1811a0002602d$var$IncrementalSource.MouseMove,
    $f1b1811a0002602d$var$IncrementalSource.MouseInteraction,
    $f1b1811a0002602d$var$IncrementalSource.Scroll,
    $f1b1811a0002602d$var$IncrementalSource.ViewportResize,
    $f1b1811a0002602d$var$IncrementalSource.Input,
    $f1b1811a0002602d$var$IncrementalSource.TouchMove,
    $f1b1811a0002602d$var$IncrementalSource.MediaInteraction,
    $f1b1811a0002602d$var$IncrementalSource.Drag,
    $f1b1811a0002602d$var$IncrementalSource.Selection
]);
function $f1b1811a0002602d$var$isUserEvent(ev) {
    return ev.type === $f1b1811a0002602d$var$EventType.IncrementalSnapshot && $f1b1811a0002602d$var$ACTIVE_SOURCES.has(ev.data.source);
}
/**
 * @typedef {Object} SerializedRecording
 * @property {number} idleExpires
 * @property {number} maxExpires
 * @property {number} replayStartTime
 * @property {number} seqNo
 * @property {string} batchStartUrl
 * @property {string} replayId
 * @property {string} tabId
 * @property {string} replayStartUrl
 */ /**
 * @typedef {Object} SessionRecordingOptions
 * @property {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
 * @property {String} [options.replayId] - unique uuid for a single replay
 * @property {Function} [options.onIdleTimeout] - callback when a recording reaches idle timeout
 * @property {Function} [options.onMaxLengthReached] - callback when a recording reaches its maximum length
 * @property {Function} [options.rrwebRecord] - rrweb's `record` function
 * @property {Function} [options.onBatchSent] - callback when a batch of events is sent to the server
 * @property {Storage} [options.sharedLockStorage] - optional storage for shared lock, used for test dependency injection
 * optional properties for deserialization:
 * @property {number} idleExpires
 * @property {number} maxExpires
 * @property {number} replayStartTime
 * @property {number} seqNo
 * @property {string} batchStartUrl
 * @property {string} replayStartUrl
 */ /**
 * @typedef {Object} UserIdInfo
 * @property {string} distinct_id
 * @property {string} user_id
 * @property {string} device_id
 */ /**
 * This class encapsulates a single session recording and its lifecycle.
 * @param {SessionRecordingOptions} options
 */ var $f1b1811a0002602d$var$SessionRecording = function(options) {
    this._mixpanel = options.mixpanelInstance;
    this._onIdleTimeout = options.onIdleTimeout || $f1b1811a0002602d$var$NOOP_FUNC;
    this._onMaxLengthReached = options.onMaxLengthReached || $f1b1811a0002602d$var$NOOP_FUNC;
    this._onBatchSent = options.onBatchSent || $f1b1811a0002602d$var$NOOP_FUNC;
    this._rrwebRecord = options.rrwebRecord || null;
    // internal rrweb stopRecording function
    this._stopRecording = null;
    this.replayId = options.replayId;
    this.batchStartUrl = options.batchStartUrl || null;
    this.replayStartUrl = options.replayStartUrl || null;
    this.idleExpires = options.idleExpires || null;
    this.maxExpires = options.maxExpires || null;
    this.replayStartTime = options.replayStartTime || null;
    this.seqNo = options.seqNo || 0;
    this.idleTimeoutId = null;
    this.maxTimeoutId = null;
    this.recordMaxMs = $f1b1811a0002602d$var$MAX_RECORDING_MS;
    this.recordMinMs = 0;
    // disable persistence if localStorage is not supported
    // request-queue will automatically disable persistence if indexedDB fails to initialize
    var usePersistence = $f1b1811a0002602d$var$localStorageSupported(options.sharedLockStorage, true);
    // each replay has its own batcher key to avoid conflicts between rrweb events of different recordings
    // this will be important when persistence is introduced
    this.batcherKey = '__mprec_' + this.getConfig('name') + '_' + this.getConfig('token') + '_' + this.replayId;
    this.queueStorage = new $f1b1811a0002602d$var$IDBStorageWrapper($f1b1811a0002602d$var$RECORDING_EVENTS_STORE_NAME);
    this.batcher = new $f1b1811a0002602d$var$RequestBatcher(this.batcherKey, {
        errorReporter: this.reportError.bind(this),
        flushOnlyOnInterval: true,
        libConfig: $f1b1811a0002602d$var$RECORDER_BATCHER_LIB_CONFIG,
        sendRequestFunc: this.flushEventsWithOptOut.bind(this),
        queueStorage: this.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        usePersistence: usePersistence,
        stopAllBatchingFunc: this.stopRecording.bind(this),
        // increased throttle and shared lock timeout because recording events are very high frequency.
        // this will minimize the amount of lock contention between enqueued events.
        // for session recordings there is a lock for each tab anyway, so there's no risk of deadlock between tabs.
        enqueueThrottleMs: $f1b1811a0002602d$var$RECORD_ENQUEUE_THROTTLE_MS,
        sharedLockTimeoutMS: 10000
    });
};
/**
 * @returns {UserIdInfo}
 */ $f1b1811a0002602d$var$SessionRecording.prototype.getUserIdInfo = function() {
    if (this.finalFlushUserIdInfo) return this.finalFlushUserIdInfo;
    var userIdInfo = {
        'distinct_id': String(this._mixpanel.get_distinct_id())
    };
    // send ID management props if they exist
    var deviceId = this._mixpanel.get_property('$device_id');
    if (deviceId) userIdInfo['$device_id'] = deviceId;
    var userId = this._mixpanel.get_property('$user_id');
    if (userId) userIdInfo['$user_id'] = userId;
    return userIdInfo;
};
$f1b1811a0002602d$var$SessionRecording.prototype.unloadPersistedData = function() {
    this.batcher.stop();
    return this.batcher.flush().then((function() {
        return this.queueStorage.removeItem(this.batcherKey);
    }).bind(this));
};
$f1b1811a0002602d$var$SessionRecording.prototype.getConfig = function(configVar) {
    return this._mixpanel.get_config(configVar);
};
// Alias for getConfig, used by the common addOptOutCheckMixpanelLib function which
// reaches into this class instance and expects the snake case version of the function.
// eslint-disable-next-line camelcase
$f1b1811a0002602d$var$SessionRecording.prototype.get_config = function(configVar) {
    return this.getConfig(configVar);
};
$f1b1811a0002602d$var$SessionRecording.prototype.startRecording = function(shouldStopBatcher) {
    if (this._rrwebRecord === null) {
        this.reportError('rrweb record function not provided. ');
        return;
    }
    if (this._stopRecording !== null) {
        $f1b1811a0002602d$var$logger$3.log('Recording already in progress, skipping startRecording.');
        return;
    }
    this.recordMaxMs = this.getConfig('record_max_ms');
    if (this.recordMaxMs > $f1b1811a0002602d$var$MAX_RECORDING_MS) {
        this.recordMaxMs = $f1b1811a0002602d$var$MAX_RECORDING_MS;
        $f1b1811a0002602d$var$logger$3.critical('record_max_ms cannot be greater than ' + $f1b1811a0002602d$var$MAX_RECORDING_MS + 'ms. Capping value.');
    }
    if (!this.maxExpires) this.maxExpires = new Date().getTime() + this.recordMaxMs;
    this.recordMinMs = this.getConfig('record_min_ms');
    if (this.recordMinMs > $f1b1811a0002602d$var$MAX_VALUE_FOR_MIN_RECORDING_MS) {
        this.recordMinMs = $f1b1811a0002602d$var$MAX_VALUE_FOR_MIN_RECORDING_MS;
        $f1b1811a0002602d$var$logger$3.critical('record_min_ms cannot be greater than ' + $f1b1811a0002602d$var$MAX_VALUE_FOR_MIN_RECORDING_MS + 'ms. Capping value.');
    }
    if (!this.replayStartTime) {
        this.replayStartTime = new Date().getTime();
        this.batchStartUrl = $f1b1811a0002602d$var$_.info.currentUrl();
        this.replayStartUrl = $f1b1811a0002602d$var$_.info.currentUrl();
    }
    if (shouldStopBatcher || this.recordMinMs > 0) // the primary case for shouldStopBatcher is when we're starting recording after a reset
    // and don't want to send anything over the network until there's
    // actual user activity
    // this also applies if the minimum recording length has not been hit yet
    // so that we don't send data until we know the recording will be long enough
    this.batcher.stop();
    else this.batcher.start();
    var resetIdleTimeout = (function() {
        clearTimeout(this.idleTimeoutId);
        var idleTimeoutMs = this.getConfig('record_idle_timeout_ms');
        this.idleTimeoutId = setTimeout(this._onIdleTimeout, idleTimeoutMs);
        this.idleExpires = new Date().getTime() + idleTimeoutMs;
    }).bind(this);
    resetIdleTimeout();
    var blockSelector = this.getConfig('record_block_selector');
    if (blockSelector === '' || blockSelector === null) blockSelector = undefined;
    try {
        this._stopRecording = this._rrwebRecord({
            'emit': (function(ev) {
                if (this.idleExpires && this.idleExpires < ev.timestamp) {
                    this._onIdleTimeout();
                    return;
                }
                if ($f1b1811a0002602d$var$isUserEvent(ev)) {
                    if (this.batcher.stopped && new Date().getTime() - this.replayStartTime >= this.recordMinMs) // start flushing again after user activity
                    this.batcher.start();
                    resetIdleTimeout();
                }
                // promise only used to await during tests
                this.__enqueuePromise = this.batcher.enqueue(ev);
            }).bind(this),
            'blockClass': this.getConfig('record_block_class'),
            'blockSelector': blockSelector,
            'collectFonts': this.getConfig('record_collect_fonts'),
            'dataURLOptions': {
                'type': 'image/webp',
                'quality': 0.6
            },
            'maskAllInputs': true,
            'maskTextClass': this.getConfig('record_mask_text_class'),
            'maskTextSelector': this.getConfig('record_mask_text_selector'),
            'recordCanvas': this.getConfig('record_canvas'),
            'sampling': {
                'canvas': 15
            }
        });
    } catch (err) {
        this.reportError('Unexpected error when starting rrweb recording.', err);
    }
    if (typeof this._stopRecording !== 'function') {
        this.reportError('rrweb failed to start, skipping this recording.');
        this._stopRecording = null;
        this.stopRecording(); // stop batcher looping and any timeouts
        return;
    }
    var maxTimeoutMs = this.maxExpires - new Date().getTime();
    this.maxTimeoutId = setTimeout(this._onMaxLengthReached.bind(this), maxTimeoutMs);
};
$f1b1811a0002602d$var$SessionRecording.prototype.stopRecording = function(skipFlush) {
    // store the user ID info in case this is getting called in mixpanel.reset()
    this.finalFlushUserIdInfo = this.getUserIdInfo();
    if (!this.isRrwebStopped()) {
        try {
            this._stopRecording();
        } catch (err) {
            this.reportError('Error with rrweb stopRecording', err);
        }
        this._stopRecording = null;
    }
    var flushPromise;
    if (this.batcher.stopped) // never got user activity to flush after reset, so just clear the batcher
    flushPromise = this.batcher.clear();
    else if (!skipFlush) // flush any remaining events from running batcher
    flushPromise = this.batcher.flush();
    this.batcher.stop();
    clearTimeout(this.idleTimeoutId);
    clearTimeout(this.maxTimeoutId);
    return flushPromise;
};
$f1b1811a0002602d$var$SessionRecording.prototype.isRrwebStopped = function() {
    return this._stopRecording === null;
};
/**
 * Flushes the current batch of events to the server, but passes an opt-out callback to make sure
 * we stop recording and dump any queued events if the user has opted out.
 */ $f1b1811a0002602d$var$SessionRecording.prototype.flushEventsWithOptOut = function(data, options, cb) {
    var onOptOut = (function(code) {
        // addOptOutCheckMixpanelLib invokes this function with code=0 when the user has opted out
        if (code === 0) {
            this.stopRecording();
            cb({
                error: 'Tracking has been opted out, stopping recording.'
            });
        }
    }).bind(this);
    this._flushEvents(data, options, cb, onOptOut);
};
/**
 * @returns {SerializedRecording}
 */ $f1b1811a0002602d$var$SessionRecording.prototype.serialize = function() {
    // don't break if mixpanel instance was destroyed at some point
    var tabId;
    try {
        tabId = this._mixpanel.get_tab_id();
    } catch (e) {
        this.reportError('Error getting tab ID for serialization ', e);
        tabId = null;
    }
    return {
        'replayId': this.replayId,
        'seqNo': this.seqNo,
        'replayStartTime': this.replayStartTime,
        'batchStartUrl': this.batchStartUrl,
        'replayStartUrl': this.replayStartUrl,
        'idleExpires': this.idleExpires,
        'maxExpires': this.maxExpires,
        'tabId': tabId
    };
};
/**
 * @static
 * @param {SerializedRecording} serializedRecording
 * @param {SessionRecordingOptions} options
 * @returns {SessionRecording}
 */ $f1b1811a0002602d$var$SessionRecording.deserialize = function(serializedRecording, options) {
    var recording = new $f1b1811a0002602d$var$SessionRecording($f1b1811a0002602d$var$_.extend({}, options, {
        replayId: serializedRecording['replayId'],
        batchStartUrl: serializedRecording['batchStartUrl'],
        replayStartUrl: serializedRecording['replayStartUrl'],
        idleExpires: serializedRecording['idleExpires'],
        maxExpires: serializedRecording['maxExpires'],
        replayStartTime: serializedRecording['replayStartTime'],
        seqNo: serializedRecording['seqNo'],
        sharedLockStorage: options.sharedLockStorage
    }));
    return recording;
};
$f1b1811a0002602d$var$SessionRecording.prototype._sendRequest = function(currentReplayId, reqParams, reqBody, callback) {
    var onSuccess = (function(response, responseBody) {
        // Update batch specific props only if the request was successful to guarantee ordering.
        // RequestBatcher will always flush the next batch after the previous one succeeds.
        // extra check to see if the replay ID has changed so that we don't increment the seqNo on the wrong replay
        if (response.status === 200 && this.replayId === currentReplayId) {
            this.seqNo++;
            this.batchStartUrl = $f1b1811a0002602d$var$_.info.currentUrl();
        }
        this._onBatchSent();
        callback({
            status: 0,
            httpStatusCode: response.status,
            responseBody: responseBody,
            retryAfter: response.headers.get('Retry-After')
        });
    }).bind(this);
    var apiHost = this._mixpanel.get_api_host && this._mixpanel.get_api_host('record') || this.getConfig('api_host');
    $f1b1811a0002602d$var$win['fetch'](apiHost + '/' + this.getConfig('api_routes')['record'] + '?' + new URLSearchParams(reqParams), {
        'method': 'POST',
        'headers': {
            'Authorization': 'Basic ' + btoa(this.getConfig('token') + ':'),
            'Content-Type': 'application/octet-stream'
        },
        'body': reqBody
    }).then(function(response) {
        response.json().then(function(responseBody) {
            onSuccess(response, responseBody);
        }).catch(function(error) {
            callback({
                error: error
            });
        });
    }).catch(function(error) {
        callback({
            error: error,
            httpStatusCode: 0
        });
    });
};
$f1b1811a0002602d$var$SessionRecording.prototype._flushEvents = $f1b1811a0002602d$var$addOptOutCheckMixpanelLib(function(data, options, callback) {
    var numEvents = data.length;
    if (numEvents > 0) {
        var replayId = this.replayId;
        // each rrweb event has a timestamp - leverage those to get time properties
        var batchStartTime = Infinity;
        var batchEndTime = -Infinity;
        var hasFullSnapshot = false;
        for(var i = 0; i < numEvents; i++){
            batchStartTime = Math.min(batchStartTime, data[i].timestamp);
            batchEndTime = Math.max(batchEndTime, data[i].timestamp);
            if (data[i].type === $f1b1811a0002602d$var$EventType.FullSnapshot) hasFullSnapshot = true;
        }
        if (this.seqNo === 0) {
            if (!hasFullSnapshot) {
                callback({
                    error: 'First batch does not contain a full snapshot. Aborting recording.'
                });
                this.stopRecording(true);
                return;
            }
            this.replayStartTime = batchStartTime;
        } else if (!this.replayStartTime) {
            this.reportError('Replay start time not set but seqNo is not 0. Using current batch start time as a fallback.');
            this.replayStartTime = batchStartTime;
        }
        var replayLengthMs = batchEndTime - this.replayStartTime;
        var reqParams = {
            '$current_url': this.batchStartUrl,
            '$lib_version': $f1b1811a0002602d$var$Config.LIB_VERSION,
            'batch_start_time': batchStartTime / 1000,
            'mp_lib': 'web',
            'replay_id': replayId,
            'replay_length_ms': replayLengthMs,
            'replay_start_time': this.replayStartTime / 1000,
            'replay_start_url': this.replayStartUrl,
            'seq': this.seqNo
        };
        var eventsJson = JSON.stringify(data);
        Object.assign(reqParams, this.getUserIdInfo());
        if ($f1b1811a0002602d$var$CompressionStream) {
            var jsonStream = new Blob([
                eventsJson
            ], {
                type: 'application/json'
            }).stream();
            var gzipStream = jsonStream.pipeThrough(new $f1b1811a0002602d$var$CompressionStream('gzip'));
            new Response(gzipStream).blob().then((function(compressedBlob) {
                reqParams['format'] = 'gzip';
                this._sendRequest(replayId, reqParams, compressedBlob, callback);
            }).bind(this));
        } else {
            reqParams['format'] = 'body';
            this._sendRequest(replayId, reqParams, eventsJson, callback);
        }
    }
});
$f1b1811a0002602d$var$SessionRecording.prototype.reportError = function(msg, err) {
    $f1b1811a0002602d$var$logger$3.error.apply($f1b1811a0002602d$var$logger$3.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.getConfig('error_reporter')(msg, err);
    } catch (err) {
        $f1b1811a0002602d$var$logger$3.error(err);
    }
};
/**
 * Module for handling the storage and retrieval of recording metadata as well as any active recordings.
 * Makes sure that only one tab can be recording at a time.
 */ var $f1b1811a0002602d$var$RecordingRegistry = function(options) {
    this.idb = new $f1b1811a0002602d$var$IDBStorageWrapper($f1b1811a0002602d$var$RECORDING_REGISTRY_STORE_NAME);
    this.errorReporter = options.errorReporter;
    this.mixpanelInstance = options.mixpanelInstance;
    this.sharedLockStorage = options.sharedLockStorage;
};
$f1b1811a0002602d$var$RecordingRegistry.prototype.handleError = function(err) {
    this.errorReporter('IndexedDB error: ', err);
};
/**
 * @param {import('./session-recording').SerializedRecording} serializedRecording
 */ $f1b1811a0002602d$var$RecordingRegistry.prototype.setActiveRecording = function(serializedRecording) {
    var tabId = serializedRecording['tabId'];
    if (!tabId) {
        console.warn('No tab ID is set, cannot persist recording metadata.');
        return $f1b1811a0002602d$var$PromisePolyfill.resolve();
    }
    return this.idb.init().then((function() {
        return this.idb.setItem(tabId, serializedRecording);
    }).bind(this)).catch(this.handleError.bind(this));
};
/**
 * @returns {Promise<import('./session-recording').SerializedRecording>}
 */ $f1b1811a0002602d$var$RecordingRegistry.prototype.getActiveRecording = function() {
    return this.idb.init().then((function() {
        return this.idb.getItem(this.mixpanelInstance.get_tab_id());
    }).bind(this)).then((function(serializedRecording) {
        return $f1b1811a0002602d$var$isRecordingExpired(serializedRecording) ? null : serializedRecording;
    }).bind(this)).catch(this.handleError.bind(this));
};
$f1b1811a0002602d$var$RecordingRegistry.prototype.clearActiveRecording = function() {
    // mark recording as expired instead of deleting it in case the page unloads mid-flush and doesn't make it to ingestion.
    // this will ensure the next pageload will flush the remaining events, but not try to continue the recording.
    return this.getActiveRecording().then((function(serializedRecording) {
        if (serializedRecording) {
            serializedRecording['maxExpires'] = 0;
            return this.setActiveRecording(serializedRecording);
        }
    }).bind(this)).catch(this.handleError.bind(this));
};
/**
 * Flush any inactive recordings from the registry to minimize data loss.
 * The main idea here is that we can flush remaining rrweb events on the next page load if a tab is closed mid-batch.
 */ $f1b1811a0002602d$var$RecordingRegistry.prototype.flushInactiveRecordings = function() {
    return this.idb.init().then((function() {
        return this.idb.getAll();
    }).bind(this)).then((function(serializedRecordings) {
        // clean up any expired recordings from the registry, non-expired ones may be active in other tabs
        var unloadPromises = serializedRecordings.filter(function(serializedRecording) {
            return $f1b1811a0002602d$var$isRecordingExpired(serializedRecording);
        }).map((function(serializedRecording) {
            var sessionRecording = $f1b1811a0002602d$var$SessionRecording.deserialize(serializedRecording, {
                mixpanelInstance: this.mixpanelInstance,
                sharedLockStorage: this.sharedLockStorage
            });
            return sessionRecording.unloadPersistedData().then((function() {
                // expired recording was successfully flushed, we can clean it up from the registry
                return this.idb.removeItem(serializedRecording['tabId']);
            }).bind(this)).catch(this.handleError.bind(this));
        }).bind(this));
        return $f1b1811a0002602d$var$PromisePolyfill.all(unloadPromises);
    }).bind(this)).catch(this.handleError.bind(this));
};
var $f1b1811a0002602d$var$logger$2 = $f1b1811a0002602d$var$console_with_prefix('recorder');
/**
 * Recorder API: bundles rrweb and and exposes methods to start and stop recordings.
 * @param {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
*/ var $f1b1811a0002602d$var$MixpanelRecorder = function(mixpanelInstance, rrwebRecord, sharedLockStorage) {
    this.mixpanelInstance = mixpanelInstance;
    this.rrwebRecord = rrwebRecord || $f1b1811a0002602d$var$record;
    this.sharedLockStorage = sharedLockStorage;
    /**
     * @member {import('./registry').RecordingRegistry}
     */ this.recordingRegistry = new $f1b1811a0002602d$var$RecordingRegistry({
        mixpanelInstance: this.mixpanelInstance,
        errorReporter: $f1b1811a0002602d$var$logger$2.error,
        sharedLockStorage: sharedLockStorage
    });
    this._flushInactivePromise = this.recordingRegistry.flushInactiveRecordings();
    this.activeRecording = null;
    this.stopRecordingInProgress = false;
};
$f1b1811a0002602d$var$MixpanelRecorder.prototype.startRecording = function(options) {
    options = options || {};
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) {
        $f1b1811a0002602d$var$logger$2.log('Recording already in progress, skipping startRecording.');
        return;
    }
    var onIdleTimeout = (function() {
        $f1b1811a0002602d$var$logger$2.log('Idle timeout reached, restarting recording.');
        this.resetRecording();
    }).bind(this);
    var onMaxLengthReached = (function() {
        $f1b1811a0002602d$var$logger$2.log('Max recording length reached, stopping recording.');
        this.resetRecording();
    }).bind(this);
    var onBatchSent = (function() {
        this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
        this['__flushPromise'] = this.activeRecording.batcher._flushPromise;
    }).bind(this);
    /**
     * @type {import('./session-recording').SessionRecordingOptions}
     */ var sessionRecordingOptions = {
        mixpanelInstance: this.mixpanelInstance,
        onBatchSent: onBatchSent,
        onIdleTimeout: onIdleTimeout,
        onMaxLengthReached: onMaxLengthReached,
        replayId: $f1b1811a0002602d$var$_.UUID(),
        rrwebRecord: this.rrwebRecord,
        sharedLockStorage: this.sharedLockStorage
    };
    if (options.activeSerializedRecording) this.activeRecording = $f1b1811a0002602d$var$SessionRecording.deserialize(options.activeSerializedRecording, sessionRecordingOptions);
    else this.activeRecording = new $f1b1811a0002602d$var$SessionRecording(sessionRecordingOptions);
    this.activeRecording.startRecording(options.shouldStopBatcher);
    return this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
};
$f1b1811a0002602d$var$MixpanelRecorder.prototype.stopRecording = function() {
    // Prevents activeSerializedRecording from being reused when stopping the recording.
    this.stopRecordingInProgress = true;
    return this._stopCurrentRecording(false, true).then((function() {
        return this.recordingRegistry.clearActiveRecording();
    }).bind(this)).then((function() {
        this.stopRecordingInProgress = false;
    }).bind(this));
};
$f1b1811a0002602d$var$MixpanelRecorder.prototype.pauseRecording = function() {
    return this._stopCurrentRecording(false);
};
$f1b1811a0002602d$var$MixpanelRecorder.prototype._stopCurrentRecording = function(skipFlush, disableActiveRecording) {
    if (this.activeRecording) {
        var stopRecordingPromise = this.activeRecording.stopRecording(skipFlush);
        if (disableActiveRecording) this.activeRecording = null;
        return stopRecordingPromise;
    }
    return $f1b1811a0002602d$var$PromisePolyfill.resolve();
};
$f1b1811a0002602d$var$MixpanelRecorder.prototype.resumeRecording = function(startNewIfInactive) {
    if (this.activeRecording && this.activeRecording.isRrwebStopped()) {
        this.activeRecording.startRecording(false);
        return $f1b1811a0002602d$var$PromisePolyfill.resolve(null);
    }
    return this.recordingRegistry.getActiveRecording().then((function(activeSerializedRecording) {
        if (activeSerializedRecording && !this.stopRecordingInProgress) return this.startRecording({
            activeSerializedRecording: activeSerializedRecording
        });
        else if (startNewIfInactive) return this.startRecording({
            shouldStopBatcher: false
        });
        else {
            $f1b1811a0002602d$var$logger$2.log('No resumable recording found.');
            return null;
        }
    }).bind(this));
};
$f1b1811a0002602d$var$MixpanelRecorder.prototype.resetRecording = function() {
    this.stopRecording();
    this.startRecording({
        shouldStopBatcher: true
    });
};
$f1b1811a0002602d$var$MixpanelRecorder.prototype.getActiveReplayId = function() {
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) return this.activeRecording.replayId;
    else return null;
};
// getter so that older mixpanel-core versions can still retrieve the replay ID
// when pulling the latest recorder bundle from the CDN
Object.defineProperty($f1b1811a0002602d$var$MixpanelRecorder.prototype, 'replayId', {
    get: function() {
        return this.getActiveReplayId();
    }
});
$f1b1811a0002602d$var$win['__mp_recorder'] = $f1b1811a0002602d$var$MixpanelRecorder;
// stateless utils
// mostly from https://github.com/mixpanel/mixpanel-js/blob/989ada50f518edab47b9c4fd9535f9fbd5ec5fc0/src/autotrack-utils.js
var $f1b1811a0002602d$var$EV_CHANGE = 'change';
var $f1b1811a0002602d$var$EV_CLICK = 'click';
var $f1b1811a0002602d$var$EV_HASHCHANGE = 'hashchange';
var $f1b1811a0002602d$var$EV_MP_LOCATION_CHANGE = 'mp_locationchange';
var $f1b1811a0002602d$var$EV_POPSTATE = 'popstate';
// TODO scrollend isn't available in Safari: document or polyfill?
var $f1b1811a0002602d$var$EV_SCROLLEND = 'scrollend';
var $f1b1811a0002602d$var$EV_SUBMIT = 'submit';
var $f1b1811a0002602d$var$CLICK_EVENT_PROPS = [
    'clientX',
    'clientY',
    'offsetX',
    'offsetY',
    'pageX',
    'pageY',
    'screenX',
    'screenY',
    'x',
    'y'
];
var $f1b1811a0002602d$var$OPT_IN_CLASSES = [
    'mp-include'
];
var $f1b1811a0002602d$var$OPT_OUT_CLASSES = [
    'mp-no-track'
];
var $f1b1811a0002602d$var$SENSITIVE_DATA_CLASSES = $f1b1811a0002602d$var$OPT_OUT_CLASSES.concat([
    'mp-sensitive'
]);
var $f1b1811a0002602d$var$TRACKED_ATTRS = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'href',
    'name',
    'role',
    'title',
    'type'
];
var $f1b1811a0002602d$var$logger$1 = $f1b1811a0002602d$var$console_with_prefix('autocapture');
function $f1b1811a0002602d$var$getClasses(el) {
    var classes = {};
    var classList = $f1b1811a0002602d$var$getClassName(el).split(' ');
    for(var i = 0; i < classList.length; i++){
        var cls = classList[i];
        if (cls) classes[cls] = true;
    }
    return classes;
}
/*
 * Get the className of an element, accounting for edge cases where element.className is an object
 * @param {Element} el - element to get the className of
 * @returns {string} the element's class
 */ function $f1b1811a0002602d$var$getClassName(el) {
    switch(typeof el.className){
        case 'string':
            return el.className;
        case 'object':
            return el.className.baseVal || el.getAttribute('class') || '';
        default:
            return '';
    }
}
function $f1b1811a0002602d$var$getPreviousElementSibling(el) {
    if (el.previousElementSibling) return el.previousElementSibling;
    else {
        do el = el.previousSibling;
        while (el && !$f1b1811a0002602d$var$isElementNode(el));
        return el;
    }
}
function $f1b1811a0002602d$var$getPropertiesFromElement(el, ev, blockAttrsSet, extraAttrs, allowElementCallback, allowSelectors) {
    var props = {
        '$classes': $f1b1811a0002602d$var$getClassName(el).split(' '),
        '$tag_name': el.tagName.toLowerCase()
    };
    var elId = el.id;
    if (elId) props['$id'] = elId;
    if ($f1b1811a0002602d$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors)) $f1b1811a0002602d$var$_.each($f1b1811a0002602d$var$TRACKED_ATTRS.concat(extraAttrs), function(attr) {
        if (el.hasAttribute(attr) && !blockAttrsSet[attr]) {
            var attrVal = el.getAttribute(attr);
            if ($f1b1811a0002602d$var$shouldTrackValue(attrVal)) props['$attr-' + attr] = attrVal;
        }
    });
    var nthChild = 1;
    var nthOfType = 1;
    var currentElem = el;
    while(currentElem = $f1b1811a0002602d$var$getPreviousElementSibling(currentElem)){
        nthChild++;
        if (currentElem.tagName === el.tagName) nthOfType++;
    }
    props['$nth_child'] = nthChild;
    props['$nth_of_type'] = nthOfType;
    return props;
}
function $f1b1811a0002602d$var$getPropsForDOMEvent(ev, config) {
    var allowElementCallback = config.allowElementCallback;
    var allowSelectors = config.allowSelectors || [];
    var blockAttrs = config.blockAttrs || [];
    var blockElementCallback = config.blockElementCallback;
    var blockSelectors = config.blockSelectors || [];
    var captureTextContent = config.captureTextContent || false;
    var captureExtraAttrs = config.captureExtraAttrs || [];
    var capturedForHeatMap = config.capturedForHeatMap || false;
    // convert array to set every time, as the config may have changed
    var blockAttrsSet = {};
    $f1b1811a0002602d$var$_.each(blockAttrs, function(attr) {
        blockAttrsSet[attr] = true;
    });
    var props = null;
    var target = typeof ev.target === 'undefined' ? ev.srcElement : ev.target;
    if ($f1b1811a0002602d$var$isTextNode(target)) target = target.parentNode;
    if ($f1b1811a0002602d$var$shouldTrackDomEvent(target, ev) && $f1b1811a0002602d$var$isElementAllowed(target, ev, allowElementCallback, allowSelectors) && !$f1b1811a0002602d$var$isElementBlocked(target, ev, blockElementCallback, blockSelectors)) {
        var targetElementList = [
            target
        ];
        var curEl = target;
        while(curEl.parentNode && !$f1b1811a0002602d$var$isTag(curEl, 'body')){
            targetElementList.push(curEl.parentNode);
            curEl = curEl.parentNode;
        }
        var elementsJson = [];
        var href, explicitNoTrack = false;
        $f1b1811a0002602d$var$_.each(targetElementList, function(el) {
            var shouldTrackDetails = $f1b1811a0002602d$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors);
            // if the element or a parent element is an anchor tag
            // include the href as a property
            if (!blockAttrsSet['href'] && el.tagName.toLowerCase() === 'a') {
                href = el.getAttribute('href');
                href = shouldTrackDetails && $f1b1811a0002602d$var$shouldTrackValue(href) && href;
            }
            if ($f1b1811a0002602d$var$isElementBlocked(el, ev, blockElementCallback, blockSelectors)) explicitNoTrack = true;
            elementsJson.push($f1b1811a0002602d$var$getPropertiesFromElement(el, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors));
        }, this);
        if (!explicitNoTrack) {
            var docElement = $f1b1811a0002602d$var$document$1['documentElement'];
            props = {
                '$event_type': ev.type,
                '$host': $f1b1811a0002602d$var$win.location.host,
                '$pathname': $f1b1811a0002602d$var$win.location.pathname,
                '$elements': elementsJson,
                '$el_attr__href': href,
                '$viewportHeight': Math.max(docElement['clientHeight'], $f1b1811a0002602d$var$win['innerHeight'] || 0),
                '$viewportWidth': Math.max(docElement['clientWidth'], $f1b1811a0002602d$var$win['innerWidth'] || 0),
                '$pageHeight': $f1b1811a0002602d$var$document$1['body']['offsetHeight'] || 0,
                '$pageWidth': $f1b1811a0002602d$var$document$1['body']['offsetWidth'] || 0
            };
            $f1b1811a0002602d$var$_.each(captureExtraAttrs, function(attr) {
                if (!blockAttrsSet[attr] && target.hasAttribute(attr)) {
                    var attrVal = target.getAttribute(attr);
                    if ($f1b1811a0002602d$var$shouldTrackValue(attrVal)) props['$el_attr__' + attr] = attrVal;
                }
            });
            if (captureTextContent) {
                elementText = $f1b1811a0002602d$var$getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props['$el_text'] = elementText;
            }
            if (ev.type === $f1b1811a0002602d$var$EV_CLICK) {
                $f1b1811a0002602d$var$_.each($f1b1811a0002602d$var$CLICK_EVENT_PROPS, function(prop) {
                    if (prop in ev) props['$' + prop] = ev[prop];
                });
                if (capturedForHeatMap) props['$captured_for_heatmap'] = true;
                target = $f1b1811a0002602d$var$guessRealClickTarget(ev);
            }
            // prioritize text content from "real" click target if different from original target
            if (captureTextContent) {
                var elementText = $f1b1811a0002602d$var$getSafeText(target, ev, allowElementCallback, allowSelectors);
                if (elementText && elementText.length) props['$el_text'] = elementText;
            }
            if (target) {
                // target may have been recalculated; check allowlists and blocklists again
                if (!$f1b1811a0002602d$var$isElementAllowed(target, ev, allowElementCallback, allowSelectors) || $f1b1811a0002602d$var$isElementBlocked(target, ev, blockElementCallback, blockSelectors)) return null;
                var targetProps = $f1b1811a0002602d$var$getPropertiesFromElement(target, ev, blockAttrsSet, captureExtraAttrs, allowElementCallback, allowSelectors);
                props['$target'] = targetProps;
                // pull up more props onto main event props
                props['$el_classes'] = targetProps['$classes'];
                $f1b1811a0002602d$var$_.extend(props, $f1b1811a0002602d$var$_.strip_empty_properties({
                    '$el_id': targetProps['$id'],
                    '$el_tag_name': targetProps['$tag_name']
                }));
            }
        }
    }
    return props;
}
/**
 * Get the direct text content of an element, protecting against sensitive data collection.
 * Concats textContent of each of the element's text node children; this avoids potential
 * collection of sensitive data that could happen if we used element.textContent and the
 * element had sensitive child elements, since element.textContent includes child content.
 * Scrubs values that look like they could be sensitive (i.e. cc or ssn number).
 * @param {Element} el - element to get the text of
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {string} the element's direct text content
 */ function $f1b1811a0002602d$var$getSafeText(el, ev, allowElementCallback, allowSelectors) {
    var elText = '';
    if ($f1b1811a0002602d$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) && el.childNodes && el.childNodes.length) $f1b1811a0002602d$var$_.each(el.childNodes, function(child) {
        if ($f1b1811a0002602d$var$isTextNode(child) && child.textContent) elText += $f1b1811a0002602d$var$_.trim(child.textContent)// scrub potentially sensitive values
        .split(/(\s+)/).filter($f1b1811a0002602d$var$shouldTrackValue).join('')// normalize whitespace
        .replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ')// truncate
        .substring(0, 255);
    });
    return $f1b1811a0002602d$var$_.trim(elText);
}
function $f1b1811a0002602d$var$guessRealClickTarget(ev) {
    var target = ev.target;
    var composedPath = ev['composedPath']();
    for(var i = 0; i < composedPath.length; i++){
        var node = composedPath[i];
        if ($f1b1811a0002602d$var$isTag(node, 'a') || $f1b1811a0002602d$var$isTag(node, 'button') || $f1b1811a0002602d$var$isTag(node, 'input') || $f1b1811a0002602d$var$isTag(node, 'select') || node.getAttribute && node.getAttribute('role') === 'button') {
            target = node;
            break;
        }
        if (node === target) break;
    }
    return target;
}
function $f1b1811a0002602d$var$isElementAllowed(el, ev, allowElementCallback, allowSelectors) {
    if (allowElementCallback) try {
        if (!allowElementCallback(el, ev)) return false;
    } catch (err) {
        $f1b1811a0002602d$var$logger$1.critical('Error while checking element in allowElementCallback', err);
        return false;
    }
    if (!allowSelectors.length) // no allowlist; all elements are fair game
    return true;
    for(var i = 0; i < allowSelectors.length; i++){
        var sel = allowSelectors[i];
        try {
            if (el['matches'](sel)) return true;
        } catch (err) {
            $f1b1811a0002602d$var$logger$1.critical('Error while checking selector: ' + sel, err);
        }
    }
    return false;
}
function $f1b1811a0002602d$var$isElementBlocked(el, ev, blockElementCallback, blockSelectors) {
    var i;
    if (blockElementCallback) try {
        if (blockElementCallback(el, ev)) return true;
    } catch (err) {
        $f1b1811a0002602d$var$logger$1.critical('Error while checking element in blockElementCallback', err);
        return true;
    }
    if (blockSelectors && blockSelectors.length) // programmatically prevent tracking of elements that match CSS selectors
    for(i = 0; i < blockSelectors.length; i++){
        var sel = blockSelectors[i];
        try {
            if (el['matches'](sel)) return true;
        } catch (err) {
            $f1b1811a0002602d$var$logger$1.critical('Error while checking selector: ' + sel, err);
        }
    }
    // allow users to programmatically prevent tracking of elements by adding default classes such as 'mp-no-track'
    var classes = $f1b1811a0002602d$var$getClasses(el);
    for(i = 0; i < $f1b1811a0002602d$var$OPT_OUT_CLASSES.length; i++){
        if (classes[$f1b1811a0002602d$var$OPT_OUT_CLASSES[i]]) return true;
    }
    return false;
}
/*
 * Check whether a DOM node has nodeType Node.ELEMENT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of the correct nodeType
 */ function $f1b1811a0002602d$var$isElementNode(node) {
    return node && node.nodeType === 1; // Node.ELEMENT_NODE - use integer constant for browser portability
}
/*
 * Check whether an element is of a given tag type.
 * Due to potential reference discrepancies (such as the webcomponents.js polyfill),
 * we want to match tagNames instead of specific references because something like
 * element === document.body won't always work because element might not be a native
 * element.
 * @param {Element} el - element to check
 * @param {string} tag - tag name (e.g., "div")
 * @returns {boolean} whether el is of the given tag type
 */ function $f1b1811a0002602d$var$isTag(el, tag) {
    return el && el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
}
/*
 * Check whether a DOM node is a TEXT_NODE
 * @param {Node} node - node to check
 * @returns {boolean} whether node is of type Node.TEXT_NODE
 */ function $f1b1811a0002602d$var$isTextNode(node) {
    return node && node.nodeType === 3; // Node.TEXT_NODE - use integer constant for browser portability
}
function $f1b1811a0002602d$var$minDOMApisSupported() {
    try {
        var testEl = $f1b1811a0002602d$var$document$1.createElement('div');
        return !!testEl['matches'];
    } catch (err) {
        return false;
    }
}
/*
 * Check whether a DOM event should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Event} ev - event to check
 * @returns {boolean} whether the event should be tracked
 */ function $f1b1811a0002602d$var$shouldTrackDomEvent(el, ev) {
    if (!el || $f1b1811a0002602d$var$isTag(el, 'html') || !$f1b1811a0002602d$var$isElementNode(el)) return false;
    var tag = el.tagName.toLowerCase();
    switch(tag){
        case 'form':
            return ev.type === $f1b1811a0002602d$var$EV_SUBMIT;
        case 'input':
            if ([
                'button',
                'submit'
            ].indexOf(el.getAttribute('type')) === -1) return ev.type === $f1b1811a0002602d$var$EV_CHANGE;
            else return ev.type === $f1b1811a0002602d$var$EV_CLICK;
        case 'select':
        case 'textarea':
            return ev.type === $f1b1811a0002602d$var$EV_CHANGE;
        default:
            return ev.type === $f1b1811a0002602d$var$EV_CLICK;
    }
}
/*
 * Check whether a DOM element should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Array<string>} allowSelectors - CSS selectors for elements that should be included
 * @returns {boolean} whether the element should be tracked
 */ function $f1b1811a0002602d$var$shouldTrackElementDetails(el, ev, allowElementCallback, allowSelectors) {
    var i;
    if (!$f1b1811a0002602d$var$isElementAllowed(el, ev, allowElementCallback, allowSelectors)) return false;
    for(var curEl = el; curEl.parentNode && !$f1b1811a0002602d$var$isTag(curEl, 'body'); curEl = curEl.parentNode){
        var classes = $f1b1811a0002602d$var$getClasses(curEl);
        for(i = 0; i < $f1b1811a0002602d$var$SENSITIVE_DATA_CLASSES.length; i++){
            if (classes[$f1b1811a0002602d$var$SENSITIVE_DATA_CLASSES[i]]) return false;
        }
    }
    var elClasses = $f1b1811a0002602d$var$getClasses(el);
    for(i = 0; i < $f1b1811a0002602d$var$OPT_IN_CLASSES.length; i++){
        if (elClasses[$f1b1811a0002602d$var$OPT_IN_CLASSES[i]]) return true;
    }
    // don't send data from inputs or similar elements since there will always be
    // a risk of clientside javascript placing sensitive data in attributes
    if ($f1b1811a0002602d$var$isTag(el, 'input') || $f1b1811a0002602d$var$isTag(el, 'select') || $f1b1811a0002602d$var$isTag(el, 'textarea') || el.getAttribute('contenteditable') === 'true') return false;
    // don't include hidden or password fields
    var type = el.type || '';
    if (typeof type === 'string') switch(type.toLowerCase()){
        case 'hidden':
            return false;
        case 'password':
            return false;
    }
    // filter out data from fields that look like sensitive fields
    var name = el.name || el.id || '';
    if (typeof name === 'string') {
        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ''))) return false;
    }
    return true;
}
/*
 * Check whether a string value should be "tracked" or if it may contain sensitive data
 * using a variety of heuristics.
 * @param {string} value - string value to check
 * @returns {boolean} whether the element should be tracked
 */ function $f1b1811a0002602d$var$shouldTrackValue(value) {
    if (value === null || $f1b1811a0002602d$var$_.isUndefined(value)) return false;
    if (typeof value === 'string') {
        value = $f1b1811a0002602d$var$_.trim(value);
        // check to see if input value looks like a credit card number
        // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((value || '').replace(/[- ]/g, ''))) return false;
        // check to see if input value looks like a social security number
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(value)) return false;
    }
    return true;
}
var $f1b1811a0002602d$var$AUTOCAPTURE_CONFIG_KEY = 'autocapture';
var $f1b1811a0002602d$var$LEGACY_PAGEVIEW_CONFIG_KEY = 'track_pageview';
var $f1b1811a0002602d$var$PAGEVIEW_OPTION_FULL_URL = 'full-url';
var $f1b1811a0002602d$var$PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING = 'url-with-path-and-query-string';
var $f1b1811a0002602d$var$PAGEVIEW_OPTION_URL_WITH_PATH = 'url-with-path';
var $f1b1811a0002602d$var$CONFIG_ALLOW_ELEMENT_CALLBACK = 'allow_element_callback';
var $f1b1811a0002602d$var$CONFIG_ALLOW_SELECTORS = 'allow_selectors';
var $f1b1811a0002602d$var$CONFIG_ALLOW_URL_REGEXES = 'allow_url_regexes';
var $f1b1811a0002602d$var$CONFIG_BLOCK_ATTRS = 'block_attrs';
var $f1b1811a0002602d$var$CONFIG_BLOCK_ELEMENT_CALLBACK = 'block_element_callback';
var $f1b1811a0002602d$var$CONFIG_BLOCK_SELECTORS = 'block_selectors';
var $f1b1811a0002602d$var$CONFIG_BLOCK_URL_REGEXES = 'block_url_regexes';
var $f1b1811a0002602d$var$CONFIG_CAPTURE_EXTRA_ATTRS = 'capture_extra_attrs';
var $f1b1811a0002602d$var$CONFIG_CAPTURE_TEXT_CONTENT = 'capture_text_content';
var $f1b1811a0002602d$var$CONFIG_SCROLL_CAPTURE_ALL = 'scroll_capture_all';
var $f1b1811a0002602d$var$CONFIG_SCROLL_CHECKPOINTS = 'scroll_depth_percent_checkpoints';
var $f1b1811a0002602d$var$CONFIG_TRACK_CLICK = 'click';
var $f1b1811a0002602d$var$CONFIG_TRACK_INPUT = 'input';
var $f1b1811a0002602d$var$CONFIG_TRACK_PAGEVIEW = 'pageview';
var $f1b1811a0002602d$var$CONFIG_TRACK_SCROLL = 'scroll';
var $f1b1811a0002602d$var$CONFIG_TRACK_SUBMIT = 'submit';
var $f1b1811a0002602d$var$CONFIG_DEFAULTS$1 = {};
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_ALLOW_SELECTORS] = [];
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_ALLOW_URL_REGEXES] = [];
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_BLOCK_ATTRS] = [];
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_BLOCK_ELEMENT_CALLBACK] = null;
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_BLOCK_SELECTORS] = [];
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_BLOCK_URL_REGEXES] = [];
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_CAPTURE_EXTRA_ATTRS] = [];
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_CAPTURE_TEXT_CONTENT] = false;
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_SCROLL_CAPTURE_ALL] = false;
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_SCROLL_CHECKPOINTS] = [
    25,
    50,
    75,
    100
];
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_TRACK_CLICK] = true;
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_TRACK_INPUT] = true;
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_TRACK_PAGEVIEW] = $f1b1811a0002602d$var$PAGEVIEW_OPTION_FULL_URL;
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_TRACK_SCROLL] = true;
$f1b1811a0002602d$var$CONFIG_DEFAULTS$1[$f1b1811a0002602d$var$CONFIG_TRACK_SUBMIT] = true;
var $f1b1811a0002602d$var$DEFAULT_PROPS = {
    '$mp_autocapture': true
};
var $f1b1811a0002602d$var$MP_EV_CLICK = '$mp_click';
var $f1b1811a0002602d$var$MP_EV_INPUT = '$mp_input_change';
var $f1b1811a0002602d$var$MP_EV_SCROLL = '$mp_scroll';
var $f1b1811a0002602d$var$MP_EV_SUBMIT = '$mp_submit';
/**
 * Autocapture: manages automatic event tracking
 * @constructor
 */ var $f1b1811a0002602d$var$Autocapture = function(mp) {
    this.mp = mp;
};
$f1b1811a0002602d$var$Autocapture.prototype.init = function() {
    if (!$f1b1811a0002602d$var$minDOMApisSupported()) {
        $f1b1811a0002602d$var$logger$1.critical('Autocapture unavailable: missing required DOM APIs');
        return;
    }
    this.initPageviewTracking();
    this.initClickTracking();
    this.initInputTracking();
    this.initScrollTracking();
    this.initSubmitTracking();
};
$f1b1811a0002602d$var$Autocapture.prototype.getFullConfig = function() {
    var autocaptureConfig = this.mp.get_config($f1b1811a0002602d$var$AUTOCAPTURE_CONFIG_KEY);
    if (!autocaptureConfig) // Autocapture is completely off
    return {};
    else if ($f1b1811a0002602d$var$_.isObject(autocaptureConfig)) return $f1b1811a0002602d$var$_.extend({}, $f1b1811a0002602d$var$CONFIG_DEFAULTS$1, autocaptureConfig);
    else // Autocapture config is non-object truthy value, return default
    return $f1b1811a0002602d$var$CONFIG_DEFAULTS$1;
};
$f1b1811a0002602d$var$Autocapture.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
$f1b1811a0002602d$var$Autocapture.prototype.currentUrlBlocked = function() {
    var i;
    var currentUrl = $f1b1811a0002602d$var$_.info.currentUrl();
    var allowUrlRegexes = this.getConfig($f1b1811a0002602d$var$CONFIG_ALLOW_URL_REGEXES) || [];
    if (allowUrlRegexes.length) {
        // we're using an allowlist, only track if current URL matches
        var allowed = false;
        for(i = 0; i < allowUrlRegexes.length; i++){
            var allowRegex = allowUrlRegexes[i];
            try {
                if (currentUrl.match(allowRegex)) {
                    allowed = true;
                    break;
                }
            } catch (err) {
                $f1b1811a0002602d$var$logger$1.critical('Error while checking block URL regex: ' + allowRegex, err);
                return true;
            }
        }
        if (!allowed) // wasn't allowed by any regex
        return true;
    }
    var blockUrlRegexes = this.getConfig($f1b1811a0002602d$var$CONFIG_BLOCK_URL_REGEXES) || [];
    if (!blockUrlRegexes || !blockUrlRegexes.length) return false;
    for(i = 0; i < blockUrlRegexes.length; i++)try {
        if (currentUrl.match(blockUrlRegexes[i])) return true;
    } catch (err) {
        $f1b1811a0002602d$var$logger$1.critical('Error while checking block URL regex: ' + blockUrlRegexes[i], err);
        return true;
    }
    return false;
};
$f1b1811a0002602d$var$Autocapture.prototype.pageviewTrackingConfig = function() {
    // supports both autocapture config and old track_pageview config
    if (this.mp.get_config($f1b1811a0002602d$var$AUTOCAPTURE_CONFIG_KEY)) return this.getConfig($f1b1811a0002602d$var$CONFIG_TRACK_PAGEVIEW);
    else return this.mp.get_config($f1b1811a0002602d$var$LEGACY_PAGEVIEW_CONFIG_KEY);
};
// helper for event handlers
$f1b1811a0002602d$var$Autocapture.prototype.trackDomEvent = function(ev, mpEventName) {
    if (this.currentUrlBlocked()) return;
    var props = $f1b1811a0002602d$var$getPropsForDOMEvent(ev, {
        allowElementCallback: this.getConfig($f1b1811a0002602d$var$CONFIG_ALLOW_ELEMENT_CALLBACK),
        allowSelectors: this.getConfig($f1b1811a0002602d$var$CONFIG_ALLOW_SELECTORS),
        blockAttrs: this.getConfig($f1b1811a0002602d$var$CONFIG_BLOCK_ATTRS),
        blockElementCallback: this.getConfig($f1b1811a0002602d$var$CONFIG_BLOCK_ELEMENT_CALLBACK),
        blockSelectors: this.getConfig($f1b1811a0002602d$var$CONFIG_BLOCK_SELECTORS),
        captureExtraAttrs: this.getConfig($f1b1811a0002602d$var$CONFIG_CAPTURE_EXTRA_ATTRS),
        captureTextContent: this.getConfig($f1b1811a0002602d$var$CONFIG_CAPTURE_TEXT_CONTENT),
        capturedForHeatMap: mpEventName === $f1b1811a0002602d$var$MP_EV_CLICK && !this.getConfig($f1b1811a0002602d$var$CONFIG_TRACK_CLICK) && this.mp.is_recording_heatmap_data()
    });
    if (props) {
        $f1b1811a0002602d$var$_.extend(props, $f1b1811a0002602d$var$DEFAULT_PROPS);
        this.mp.track(mpEventName, props);
    }
};
$f1b1811a0002602d$var$Autocapture.prototype.initClickTracking = function() {
    $f1b1811a0002602d$var$win.removeEventListener($f1b1811a0002602d$var$EV_CLICK, this.listenerClick);
    if (!this.getConfig($f1b1811a0002602d$var$CONFIG_TRACK_CLICK) && !this.mp.get_config('record_heatmap_data')) return;
    $f1b1811a0002602d$var$logger$1.log('Initializing click tracking');
    this.listenerClick = $f1b1811a0002602d$var$win.addEventListener($f1b1811a0002602d$var$EV_CLICK, (function(ev) {
        if (!this.getConfig($f1b1811a0002602d$var$CONFIG_TRACK_CLICK) && !this.mp.is_recording_heatmap_data()) return;
        this.trackDomEvent(ev, $f1b1811a0002602d$var$MP_EV_CLICK);
    }).bind(this));
};
$f1b1811a0002602d$var$Autocapture.prototype.initInputTracking = function() {
    $f1b1811a0002602d$var$win.removeEventListener($f1b1811a0002602d$var$EV_CHANGE, this.listenerChange);
    if (!this.getConfig($f1b1811a0002602d$var$CONFIG_TRACK_INPUT)) return;
    $f1b1811a0002602d$var$logger$1.log('Initializing input tracking');
    this.listenerChange = $f1b1811a0002602d$var$win.addEventListener($f1b1811a0002602d$var$EV_CHANGE, (function(ev) {
        if (!this.getConfig($f1b1811a0002602d$var$CONFIG_TRACK_INPUT)) return;
        this.trackDomEvent(ev, $f1b1811a0002602d$var$MP_EV_INPUT);
    }).bind(this));
};
$f1b1811a0002602d$var$Autocapture.prototype.initPageviewTracking = function() {
    $f1b1811a0002602d$var$win.removeEventListener($f1b1811a0002602d$var$EV_POPSTATE, this.listenerPopstate);
    $f1b1811a0002602d$var$win.removeEventListener($f1b1811a0002602d$var$EV_HASHCHANGE, this.listenerHashchange);
    $f1b1811a0002602d$var$win.removeEventListener($f1b1811a0002602d$var$EV_MP_LOCATION_CHANGE, this.listenerLocationchange);
    if (!this.pageviewTrackingConfig()) return;
    $f1b1811a0002602d$var$logger$1.log('Initializing pageview tracking');
    var previousTrackedUrl = '';
    var tracked = false;
    if (!this.currentUrlBlocked()) tracked = this.mp.track_pageview($f1b1811a0002602d$var$DEFAULT_PROPS);
    if (tracked) previousTrackedUrl = $f1b1811a0002602d$var$_.info.currentUrl();
    this.listenerPopstate = $f1b1811a0002602d$var$win.addEventListener($f1b1811a0002602d$var$EV_POPSTATE, function() {
        $f1b1811a0002602d$var$win.dispatchEvent(new Event($f1b1811a0002602d$var$EV_MP_LOCATION_CHANGE));
    });
    this.listenerHashchange = $f1b1811a0002602d$var$win.addEventListener($f1b1811a0002602d$var$EV_HASHCHANGE, function() {
        $f1b1811a0002602d$var$win.dispatchEvent(new Event($f1b1811a0002602d$var$EV_MP_LOCATION_CHANGE));
    });
    var nativePushState = $f1b1811a0002602d$var$win.history.pushState;
    if (typeof nativePushState === 'function') $f1b1811a0002602d$var$win.history.pushState = function(state, unused, url) {
        nativePushState.call($f1b1811a0002602d$var$win.history, state, unused, url);
        $f1b1811a0002602d$var$win.dispatchEvent(new Event($f1b1811a0002602d$var$EV_MP_LOCATION_CHANGE));
    };
    var nativeReplaceState = $f1b1811a0002602d$var$win.history.replaceState;
    if (typeof nativeReplaceState === 'function') $f1b1811a0002602d$var$win.history.replaceState = function(state, unused, url) {
        nativeReplaceState.call($f1b1811a0002602d$var$win.history, state, unused, url);
        $f1b1811a0002602d$var$win.dispatchEvent(new Event($f1b1811a0002602d$var$EV_MP_LOCATION_CHANGE));
    };
    this.listenerLocationchange = $f1b1811a0002602d$var$win.addEventListener($f1b1811a0002602d$var$EV_MP_LOCATION_CHANGE, $f1b1811a0002602d$var$safewrap((function() {
        if (this.currentUrlBlocked()) return;
        var currentUrl = $f1b1811a0002602d$var$_.info.currentUrl();
        var shouldTrack = false;
        var didPathChange = currentUrl.split('#')[0].split('?')[0] !== previousTrackedUrl.split('#')[0].split('?')[0];
        var trackPageviewOption = this.pageviewTrackingConfig();
        if (trackPageviewOption === $f1b1811a0002602d$var$PAGEVIEW_OPTION_FULL_URL) shouldTrack = currentUrl !== previousTrackedUrl;
        else if (trackPageviewOption === $f1b1811a0002602d$var$PAGEVIEW_OPTION_URL_WITH_PATH_AND_QUERY_STRING) shouldTrack = currentUrl.split('#')[0] !== previousTrackedUrl.split('#')[0];
        else if (trackPageviewOption === $f1b1811a0002602d$var$PAGEVIEW_OPTION_URL_WITH_PATH) shouldTrack = didPathChange;
        if (shouldTrack) {
            var tracked = this.mp.track_pageview($f1b1811a0002602d$var$DEFAULT_PROPS);
            if (tracked) previousTrackedUrl = currentUrl;
            if (didPathChange) {
                this.lastScrollCheckpoint = 0;
                $f1b1811a0002602d$var$logger$1.log('Path change: re-initializing scroll depth checkpoints');
            }
        }
    }).bind(this)));
};
$f1b1811a0002602d$var$Autocapture.prototype.initScrollTracking = function() {
    $f1b1811a0002602d$var$win.removeEventListener($f1b1811a0002602d$var$EV_SCROLLEND, this.listenerScroll);
    if (!this.getConfig($f1b1811a0002602d$var$CONFIG_TRACK_SCROLL)) return;
    $f1b1811a0002602d$var$logger$1.log('Initializing scroll tracking');
    this.lastScrollCheckpoint = 0;
    this.listenerScroll = $f1b1811a0002602d$var$win.addEventListener($f1b1811a0002602d$var$EV_SCROLLEND, $f1b1811a0002602d$var$safewrap((function() {
        if (!this.getConfig($f1b1811a0002602d$var$CONFIG_TRACK_SCROLL)) return;
        if (this.currentUrlBlocked()) return;
        var shouldTrack = this.getConfig($f1b1811a0002602d$var$CONFIG_SCROLL_CAPTURE_ALL);
        var scrollCheckpoints = (this.getConfig($f1b1811a0002602d$var$CONFIG_SCROLL_CHECKPOINTS) || []).slice().sort(function(a, b) {
            return a - b;
        });
        var scrollTop = $f1b1811a0002602d$var$win.scrollY;
        var props = $f1b1811a0002602d$var$_.extend({
            '$scroll_top': scrollTop
        }, $f1b1811a0002602d$var$DEFAULT_PROPS);
        try {
            var scrollHeight = $f1b1811a0002602d$var$document$1.body.scrollHeight;
            var scrollPercentage = Math.round(scrollTop / (scrollHeight - $f1b1811a0002602d$var$win.innerHeight) * 100);
            props['$scroll_height'] = scrollHeight;
            props['$scroll_percentage'] = scrollPercentage;
            if (scrollPercentage > this.lastScrollCheckpoint) for(var i = 0; i < scrollCheckpoints.length; i++){
                var checkpoint = scrollCheckpoints[i];
                if (scrollPercentage >= checkpoint && this.lastScrollCheckpoint < checkpoint) {
                    props['$scroll_checkpoint'] = checkpoint;
                    this.lastScrollCheckpoint = checkpoint;
                    shouldTrack = true;
                }
            }
        } catch (err) {
            $f1b1811a0002602d$var$logger$1.critical('Error while calculating scroll percentage', err);
        }
        if (shouldTrack) this.mp.track($f1b1811a0002602d$var$MP_EV_SCROLL, props);
    }).bind(this)));
};
$f1b1811a0002602d$var$Autocapture.prototype.initSubmitTracking = function() {
    $f1b1811a0002602d$var$win.removeEventListener($f1b1811a0002602d$var$EV_SUBMIT, this.listenerSubmit);
    if (!this.getConfig($f1b1811a0002602d$var$CONFIG_TRACK_SUBMIT)) return;
    $f1b1811a0002602d$var$logger$1.log('Initializing submit tracking');
    this.listenerSubmit = $f1b1811a0002602d$var$win.addEventListener($f1b1811a0002602d$var$EV_SUBMIT, (function(ev) {
        if (!this.getConfig($f1b1811a0002602d$var$CONFIG_TRACK_SUBMIT)) return;
        this.trackDomEvent(ev, $f1b1811a0002602d$var$MP_EV_SUBMIT);
    }).bind(this));
};
// TODO integrate error_reporter from mixpanel instance
$f1b1811a0002602d$var$safewrapClass($f1b1811a0002602d$var$Autocapture);
var $f1b1811a0002602d$var$fetch = $f1b1811a0002602d$var$win['fetch'];
var $f1b1811a0002602d$var$logger = $f1b1811a0002602d$var$console_with_prefix('flags');
var $f1b1811a0002602d$var$FLAGS_CONFIG_KEY = 'flags';
var $f1b1811a0002602d$var$CONFIG_CONTEXT = 'context';
var $f1b1811a0002602d$var$CONFIG_DEFAULTS = {};
$f1b1811a0002602d$var$CONFIG_DEFAULTS[$f1b1811a0002602d$var$CONFIG_CONTEXT] = {};
/**
 * FeatureFlagManager: support for Mixpanel's feature flagging product
 * @constructor
 */ var $f1b1811a0002602d$var$FeatureFlagManager = function(initOptions) {
    this.getFullApiRoute = initOptions.getFullApiRoute;
    this.getMpConfig = initOptions.getConfigFunc;
    this.getMpProperty = initOptions.getPropertyFunc;
    this.track = initOptions.trackingFunc;
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.init = function() {
    if (!$f1b1811a0002602d$var$minApisSupported()) {
        $f1b1811a0002602d$var$logger.critical('Feature Flags unavailable: missing minimum required APIs');
        return;
    }
    this.flags = null;
    this.fetchFlags();
    this.trackedFeatures = new Set();
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.getFullConfig = function() {
    var ffConfig = this.getMpConfig($f1b1811a0002602d$var$FLAGS_CONFIG_KEY);
    if (!ffConfig) // flags are completely off
    return {};
    else if ($f1b1811a0002602d$var$_.isObject(ffConfig)) return $f1b1811a0002602d$var$_.extend({}, $f1b1811a0002602d$var$CONFIG_DEFAULTS, ffConfig);
    else // config is non-object truthy value, return default
    return $f1b1811a0002602d$var$CONFIG_DEFAULTS;
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.getConfig = function(key) {
    return this.getFullConfig()[key];
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.isSystemEnabled = function() {
    return !!this.getMpConfig($f1b1811a0002602d$var$FLAGS_CONFIG_KEY);
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.areFlagsReady = function() {
    if (!this.isSystemEnabled()) $f1b1811a0002602d$var$logger.error('Feature Flags not enabled');
    return !!this.flags;
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.fetchFlags = function() {
    if (!this.isSystemEnabled()) return;
    var distinctId = this.getMpProperty('distinct_id');
    var deviceId = this.getMpProperty('$device_id');
    $f1b1811a0002602d$var$logger.log('Fetching flags for distinct ID: ' + distinctId);
    var reqParams = {
        'context': $f1b1811a0002602d$var$_.extend({
            'distinct_id': distinctId,
            'device_id': deviceId
        }, this.getConfig($f1b1811a0002602d$var$CONFIG_CONTEXT))
    };
    this._fetchInProgressStartTime = Date.now();
    this.fetchPromise = $f1b1811a0002602d$var$win['fetch'](this.getFullApiRoute(), {
        'method': 'POST',
        'headers': {
            'Authorization': 'Basic ' + btoa(this.getMpConfig('token') + ':'),
            'Content-Type': 'application/octet-stream'
        },
        'body': JSON.stringify(reqParams)
    }).then((function(response) {
        this.markFetchComplete();
        return response.json().then((function(responseBody) {
            var responseFlags = responseBody['flags'];
            if (!responseFlags) throw new Error('No flags in API response');
            var flags = new Map();
            $f1b1811a0002602d$var$_.each(responseFlags, function(data, key) {
                flags.set(key, {
                    'key': data['variant_key'],
                    'value': data['variant_value']
                });
            });
            this.flags = flags;
        }).bind(this)).catch((function(error) {
            this.markFetchComplete();
            $f1b1811a0002602d$var$logger.error(error);
        }).bind(this));
    }).bind(this)).catch((function(error) {
        this.markFetchComplete();
        $f1b1811a0002602d$var$logger.error(error);
    }).bind(this));
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.markFetchComplete = function() {
    if (!this._fetchInProgressStartTime) {
        $f1b1811a0002602d$var$logger.error('Fetch in progress started time not set, cannot mark fetch complete');
        return;
    }
    this._fetchStartTime = this._fetchInProgressStartTime;
    this._fetchCompleteTime = Date.now();
    this._fetchLatency = this._fetchCompleteTime - this._fetchStartTime;
    this._fetchInProgressStartTime = null;
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.getVariant = function(featureName, fallback) {
    if (!this.fetchPromise) return new Promise(function(resolve) {
        $f1b1811a0002602d$var$logger.critical('Feature Flags not initialized');
        resolve(fallback);
    });
    return this.fetchPromise.then((function() {
        return this.getVariantSync(featureName, fallback);
    }).bind(this)).catch(function(error) {
        $f1b1811a0002602d$var$logger.error(error);
        return fallback;
    });
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.getVariantSync = function(featureName, fallback) {
    if (!this.areFlagsReady()) {
        $f1b1811a0002602d$var$logger.log('Flags not loaded yet');
        return fallback;
    }
    var feature = this.flags.get(featureName);
    if (!feature) {
        $f1b1811a0002602d$var$logger.log('No flag found: "' + featureName + '"');
        return fallback;
    }
    this.trackFeatureCheck(featureName, feature);
    return feature;
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.getVariantValue = function(featureName, fallbackValue) {
    return this.getVariant(featureName, {
        'value': fallbackValue
    }).then(function(feature) {
        return feature['value'];
    }).catch(function(error) {
        $f1b1811a0002602d$var$logger.error(error);
        return fallbackValue;
    });
};
// TODO remove deprecated method
$f1b1811a0002602d$var$FeatureFlagManager.prototype.getFeatureData = function(featureName, fallbackValue) {
    $f1b1811a0002602d$var$logger.critical('mixpanel.flags.get_feature_data() is deprecated and will be removed in a future release. Use mixpanel.flags.get_variant_value() instead.');
    return this.getVariantValue(featureName, fallbackValue);
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.getVariantValueSync = function(featureName, fallbackValue) {
    return this.getVariantSync(featureName, {
        'value': fallbackValue
    })['value'];
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.isEnabled = function(featureName, fallbackValue) {
    return this.getVariantValue(featureName).then((function() {
        return this.isEnabledSync(featureName, fallbackValue);
    }).bind(this)).catch(function(error) {
        $f1b1811a0002602d$var$logger.error(error);
        return fallbackValue;
    });
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.isEnabledSync = function(featureName, fallbackValue) {
    fallbackValue = fallbackValue || false;
    var val = this.getVariantValueSync(featureName, fallbackValue);
    if (val !== true && val !== false) {
        $f1b1811a0002602d$var$logger.error('Feature flag "' + featureName + '" value: ' + val + ' is not a boolean; returning fallback value: ' + fallbackValue);
        val = fallbackValue;
    }
    return val;
};
$f1b1811a0002602d$var$FeatureFlagManager.prototype.trackFeatureCheck = function(featureName, feature) {
    if (this.trackedFeatures.has(featureName)) return;
    this.trackedFeatures.add(featureName);
    this.track('$experiment_started', {
        'Experiment name': featureName,
        'Variant name': feature['key'],
        '$experiment_type': 'feature_flag',
        'Variant fetch start time': new Date(this._fetchStartTime).toISOString(),
        'Variant fetch complete time': new Date(this._fetchCompleteTime).toISOString(),
        'Variant fetch latency (ms)': this._fetchLatency
    });
};
function $f1b1811a0002602d$var$minApisSupported() {
    return !!$f1b1811a0002602d$var$fetch && typeof Promise !== 'undefined' && typeof Map !== 'undefined' && typeof Set !== 'undefined';
}
$f1b1811a0002602d$var$safewrapClass($f1b1811a0002602d$var$FeatureFlagManager);
$f1b1811a0002602d$var$FeatureFlagManager.prototype['are_flags_ready'] = $f1b1811a0002602d$var$FeatureFlagManager.prototype.areFlagsReady;
$f1b1811a0002602d$var$FeatureFlagManager.prototype['get_variant'] = $f1b1811a0002602d$var$FeatureFlagManager.prototype.getVariant;
$f1b1811a0002602d$var$FeatureFlagManager.prototype['get_variant_sync'] = $f1b1811a0002602d$var$FeatureFlagManager.prototype.getVariantSync;
$f1b1811a0002602d$var$FeatureFlagManager.prototype['get_variant_value'] = $f1b1811a0002602d$var$FeatureFlagManager.prototype.getVariantValue;
$f1b1811a0002602d$var$FeatureFlagManager.prototype['get_variant_value_sync'] = $f1b1811a0002602d$var$FeatureFlagManager.prototype.getVariantValueSync;
$f1b1811a0002602d$var$FeatureFlagManager.prototype['is_enabled'] = $f1b1811a0002602d$var$FeatureFlagManager.prototype.isEnabled;
$f1b1811a0002602d$var$FeatureFlagManager.prototype['is_enabled_sync'] = $f1b1811a0002602d$var$FeatureFlagManager.prototype.isEnabledSync;
// Deprecated method
$f1b1811a0002602d$var$FeatureFlagManager.prototype['get_feature_data'] = $f1b1811a0002602d$var$FeatureFlagManager.prototype.getFeatureData;
/* eslint camelcase: "off" */ /**
 * DomTracker Object
 * @constructor
 */ var $f1b1811a0002602d$var$DomTracker = function() {};
// interface
$f1b1811a0002602d$var$DomTracker.prototype.create_properties = function() {};
$f1b1811a0002602d$var$DomTracker.prototype.event_handler = function() {};
$f1b1811a0002602d$var$DomTracker.prototype.after_track_handler = function() {};
$f1b1811a0002602d$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $f1b1811a0002602d$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $f1b1811a0002602d$var$_.dom_query(query);
    if (elements.length === 0) {
        $f1b1811a0002602d$var$console$1.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }
    $f1b1811a0002602d$var$_.each(elements, function(element) {
        $f1b1811a0002602d$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $f1b1811a0002602d$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$f1b1811a0002602d$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === 'function') props = properties(element);
    else props = $f1b1811a0002602d$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $f1b1811a0002602d$var$LinkTracker = function() {
    this.override_event = 'click';
};
$f1b1811a0002602d$var$_.inherit($f1b1811a0002602d$var$LinkTracker, $f1b1811a0002602d$var$DomTracker);
$f1b1811a0002602d$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $f1b1811a0002602d$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props['url'] = element.href;
    return props;
};
$f1b1811a0002602d$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$f1b1811a0002602d$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $f1b1811a0002602d$var$FormTracker = function() {
    this.override_event = 'submit';
};
$f1b1811a0002602d$var$_.inherit($f1b1811a0002602d$var$FormTracker, $f1b1811a0002602d$var$DomTracker);
$f1b1811a0002602d$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$f1b1811a0002602d$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
/* eslint camelcase: "off" */ /** @const */ var $f1b1811a0002602d$var$SET_ACTION = '$set';
/** @const */ var $f1b1811a0002602d$var$SET_ONCE_ACTION = '$set_once';
/** @const */ var $f1b1811a0002602d$var$UNSET_ACTION = '$unset';
/** @const */ var $f1b1811a0002602d$var$ADD_ACTION = '$add';
/** @const */ var $f1b1811a0002602d$var$APPEND_ACTION = '$append';
/** @const */ var $f1b1811a0002602d$var$UNION_ACTION = '$union';
/** @const */ var $f1b1811a0002602d$var$REMOVE_ACTION = '$remove';
/** @const */ var $f1b1811a0002602d$var$DELETE_ACTION = '$delete';
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $f1b1811a0002602d$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($f1b1811a0002602d$var$_.isObject(prop)) $f1b1811a0002602d$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$f1b1811a0002602d$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$f1b1811a0002602d$var$_.isArray(prop)) prop = [
            prop
        ];
        $f1b1811a0002602d$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$f1b1811a0002602d$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($f1b1811a0002602d$var$_.isObject(prop)) $f1b1811a0002602d$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$f1b1811a0002602d$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($f1b1811a0002602d$var$_.isObject(list_name)) $f1b1811a0002602d$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $f1b1811a0002602d$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $f1b1811a0002602d$var$_.isArray(values) ? values : [
            values
        ];
        data[$f1b1811a0002602d$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($f1b1811a0002602d$var$_.isObject(list_name)) $f1b1811a0002602d$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$f1b1811a0002602d$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($f1b1811a0002602d$var$_.isObject(list_name)) $f1b1811a0002602d$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$f1b1811a0002602d$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$f1b1811a0002602d$var$DELETE_ACTION] = '';
        return data;
    }
};
/* eslint camelcase: "off" */ /**
 * Mixpanel Group Object
 * @constructor
 */ var $f1b1811a0002602d$var$MixpanelGroup = function() {};
$f1b1811a0002602d$var$_.extend($f1b1811a0002602d$var$MixpanelGroup.prototype, $f1b1811a0002602d$var$apiActions);
$f1b1811a0002602d$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f1b1811a0002602d$var$MixpanelGroup.prototype.set = $f1b1811a0002602d$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($f1b1811a0002602d$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f1b1811a0002602d$var$MixpanelGroup.prototype.set_once = $f1b1811a0002602d$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($f1b1811a0002602d$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f1b1811a0002602d$var$MixpanelGroup.prototype.unset = $f1b1811a0002602d$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f1b1811a0002602d$var$MixpanelGroup.prototype.union = $f1b1811a0002602d$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($f1b1811a0002602d$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f1b1811a0002602d$var$MixpanelGroup.prototype['delete'] = $f1b1811a0002602d$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $f1b1811a0002602d$var$MixpanelGroup.prototype.remove = $f1b1811a0002602d$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$f1b1811a0002602d$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');
    var date_encoded_data = $f1b1811a0002602d$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._mixpanel.get_api_host('groups') + '/' + this._get_config('api_routes')['groups'],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$f1b1811a0002602d$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};
$f1b1811a0002602d$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$f1b1811a0002602d$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};
// MixpanelGroup Exports
$f1b1811a0002602d$var$MixpanelGroup.prototype['remove'] = $f1b1811a0002602d$var$MixpanelGroup.prototype.remove;
$f1b1811a0002602d$var$MixpanelGroup.prototype['set'] = $f1b1811a0002602d$var$MixpanelGroup.prototype.set;
$f1b1811a0002602d$var$MixpanelGroup.prototype['set_once'] = $f1b1811a0002602d$var$MixpanelGroup.prototype.set_once;
$f1b1811a0002602d$var$MixpanelGroup.prototype['union'] = $f1b1811a0002602d$var$MixpanelGroup.prototype.union;
$f1b1811a0002602d$var$MixpanelGroup.prototype['unset'] = $f1b1811a0002602d$var$MixpanelGroup.prototype.unset;
$f1b1811a0002602d$var$MixpanelGroup.prototype['toString'] = $f1b1811a0002602d$var$MixpanelGroup.prototype.toString;
/* eslint camelcase: "off" */ /**
 * Mixpanel People Object
 * @constructor
 */ var $f1b1811a0002602d$var$MixpanelPeople = function() {};
$f1b1811a0002602d$var$_.extend($f1b1811a0002602d$var$MixpanelPeople.prototype, $f1b1811a0002602d$var$apiActions);
$f1b1811a0002602d$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f1b1811a0002602d$var$MixpanelPeople.prototype.set = $f1b1811a0002602d$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($f1b1811a0002602d$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) this._mixpanel['persistence'].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$f1b1811a0002602d$var$SET_ACTION] = $f1b1811a0002602d$var$_.extend({}, $f1b1811a0002602d$var$_.info.people_properties(), data[$f1b1811a0002602d$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f1b1811a0002602d$var$MixpanelPeople.prototype.set_once = $f1b1811a0002602d$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($f1b1811a0002602d$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f1b1811a0002602d$var$MixpanelPeople.prototype.unset = $f1b1811a0002602d$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f1b1811a0002602d$var$MixpanelPeople.prototype.increment = $f1b1811a0002602d$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($f1b1811a0002602d$var$_.isObject(prop)) {
        $f1b1811a0002602d$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $f1b1811a0002602d$var$console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($f1b1811a0002602d$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$f1b1811a0002602d$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f1b1811a0002602d$var$MixpanelPeople.prototype.append = $f1b1811a0002602d$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($f1b1811a0002602d$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f1b1811a0002602d$var$MixpanelPeople.prototype.remove = $f1b1811a0002602d$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($f1b1811a0002602d$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $f1b1811a0002602d$var$MixpanelPeople.prototype.union = $f1b1811a0002602d$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($f1b1811a0002602d$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $f1b1811a0002602d$var$MixpanelPeople.prototype.track_charge = $f1b1811a0002602d$var$addOptOutCheckMixpanelPeople(function() {
    $f1b1811a0002602d$var$console$1.error('mixpanel.people.track_charge() is deprecated and no longer has any effect.');
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $f1b1811a0002602d$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $f1b1811a0002602d$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $f1b1811a0002602d$var$console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {
        '$delete': this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$f1b1811a0002602d$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};
$f1b1811a0002602d$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) data['$device_id'] = device_id;
    if (user_id) data['$user_id'] = user_id;
    if (had_persisted_distinct_id) data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    var date_encoded_data = $f1b1811a0002602d$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$f1b1811a0002602d$var$_.isUndefined(callback)) {
            if (this._get_config('verbose')) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $f1b1811a0002602d$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._mixpanel.get_api_host('people') + '/' + this._get_config('api_routes')['engage'],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$f1b1811a0002602d$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$f1b1811a0002602d$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$f1b1811a0002602d$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($f1b1811a0002602d$var$SET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($f1b1811a0002602d$var$SET_ACTION, data);
    else if ($f1b1811a0002602d$var$SET_ONCE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($f1b1811a0002602d$var$SET_ONCE_ACTION, data);
    else if ($f1b1811a0002602d$var$UNSET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($f1b1811a0002602d$var$UNSET_ACTION, data);
    else if ($f1b1811a0002602d$var$ADD_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($f1b1811a0002602d$var$ADD_ACTION, data);
    else if ($f1b1811a0002602d$var$APPEND_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($f1b1811a0002602d$var$APPEND_ACTION, data);
    else if ($f1b1811a0002602d$var$REMOVE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($f1b1811a0002602d$var$REMOVE_ACTION, data);
    else if ($f1b1811a0002602d$var$UNION_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($f1b1811a0002602d$var$UNION_ACTION, data);
    else $f1b1811a0002602d$var$console$1.error('Invalid call to _enqueue():', data);
};
$f1b1811a0002602d$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $f1b1811a0002602d$var$_.extend({}, this._mixpanel['persistence'].load_queue(action));
    var action_params = queued_data;
    if (!$f1b1811a0002602d$var$_.isUndefined(queued_data) && $f1b1811a0002602d$var$_.isObject(queued_data) && !$f1b1811a0002602d$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        _this._mixpanel['persistence'].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            if (!$f1b1811a0002602d$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$f1b1811a0002602d$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue($f1b1811a0002602d$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($f1b1811a0002602d$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($f1b1811a0002602d$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $f1b1811a0002602d$var$_.keys(queue);
    });
    this._flush_one_queue($f1b1811a0002602d$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($f1b1811a0002602d$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel['persistence'].load_queue($f1b1811a0002602d$var$APPEND_ACTION);
    if (!$f1b1811a0002602d$var$_.isUndefined($append_queue) && $f1b1811a0002602d$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($f1b1811a0002602d$var$APPEND_ACTION, $append_item);
            if (!$f1b1811a0002602d$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel['persistence'].load_queue($f1b1811a0002602d$var$APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$f1b1811a0002602d$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel['persistence'].load_queue($f1b1811a0002602d$var$REMOVE_ACTION);
    if (!$f1b1811a0002602d$var$_.isUndefined($remove_queue) && $f1b1811a0002602d$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($f1b1811a0002602d$var$REMOVE_ACTION, $remove_item);
            if (!$f1b1811a0002602d$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel['persistence'].load_queue($f1b1811a0002602d$var$REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$f1b1811a0002602d$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
$f1b1811a0002602d$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};
// MixpanelPeople Exports
$f1b1811a0002602d$var$MixpanelPeople.prototype['set'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.set;
$f1b1811a0002602d$var$MixpanelPeople.prototype['set_once'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.set_once;
$f1b1811a0002602d$var$MixpanelPeople.prototype['unset'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.unset;
$f1b1811a0002602d$var$MixpanelPeople.prototype['increment'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.increment;
$f1b1811a0002602d$var$MixpanelPeople.prototype['append'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.append;
$f1b1811a0002602d$var$MixpanelPeople.prototype['remove'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.remove;
$f1b1811a0002602d$var$MixpanelPeople.prototype['union'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.union;
$f1b1811a0002602d$var$MixpanelPeople.prototype['track_charge'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.track_charge;
$f1b1811a0002602d$var$MixpanelPeople.prototype['clear_charges'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.clear_charges;
$f1b1811a0002602d$var$MixpanelPeople.prototype['delete_user'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.delete_user;
$f1b1811a0002602d$var$MixpanelPeople.prototype['toString'] = $f1b1811a0002602d$var$MixpanelPeople.prototype.toString;
/* eslint camelcase: "off" */ /*
 * Constants
 */ /** @const */ var $f1b1811a0002602d$var$SET_QUEUE_KEY = '__mps';
/** @const */ var $f1b1811a0002602d$var$SET_ONCE_QUEUE_KEY = '__mpso';
/** @const */ var $f1b1811a0002602d$var$UNSET_QUEUE_KEY = '__mpus';
/** @const */ var $f1b1811a0002602d$var$ADD_QUEUE_KEY = '__mpa';
/** @const */ var $f1b1811a0002602d$var$APPEND_QUEUE_KEY = '__mpap';
/** @const */ var $f1b1811a0002602d$var$REMOVE_QUEUE_KEY = '__mpr';
/** @const */ var $f1b1811a0002602d$var$UNION_QUEUE_KEY = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $f1b1811a0002602d$var$PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var $f1b1811a0002602d$var$ALIAS_ID_KEY = '__alias';
/** @const */ var $f1b1811a0002602d$var$EVENT_TIMERS_KEY = '__timers';
/** @const */ var $f1b1811a0002602d$var$RESERVED_PROPERTIES = [
    $f1b1811a0002602d$var$SET_QUEUE_KEY,
    $f1b1811a0002602d$var$SET_ONCE_QUEUE_KEY,
    $f1b1811a0002602d$var$UNSET_QUEUE_KEY,
    $f1b1811a0002602d$var$ADD_QUEUE_KEY,
    $f1b1811a0002602d$var$APPEND_QUEUE_KEY,
    $f1b1811a0002602d$var$REMOVE_QUEUE_KEY,
    $f1b1811a0002602d$var$UNION_QUEUE_KEY,
    $f1b1811a0002602d$var$PEOPLE_DISTINCT_ID_KEY,
    $f1b1811a0002602d$var$ALIAS_ID_KEY,
    $f1b1811a0002602d$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $f1b1811a0002602d$var$MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;
    if (config['persistence_name']) this.name = 'mp_' + config['persistence_name'];
    else this.name = 'mp_' + config['token'] + '_mixpanel';
    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        $f1b1811a0002602d$var$console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }
    if (storage_type === 'localStorage' && $f1b1811a0002602d$var$_.localStorage.is_supported()) this.storage = $f1b1811a0002602d$var$_.localStorage;
    else this.storage = $f1b1811a0002602d$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade();
    this.save();
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    $f1b1811a0002602d$var$_.each(this['props'], function(v, k) {
        if (!$f1b1811a0002602d$var$_.include($f1b1811a0002602d$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this['props'] = $f1b1811a0002602d$var$_.extend({}, entry);
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.upgrade = function() {
    var old_cookie, old_localstorage;
    // if transferring from cookie to localStorage or vice-versa, copy existing
    // super properties over to new storage mode
    if (this.storage === $f1b1811a0002602d$var$_.localStorage) {
        old_cookie = $f1b1811a0002602d$var$_.cookie.parse(this.name);
        $f1b1811a0002602d$var$_.cookie.remove(this.name);
        $f1b1811a0002602d$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    } else if (this.storage === $f1b1811a0002602d$var$_.cookie) {
        old_localstorage = $f1b1811a0002602d$var$_.localStorage.parse(this.name);
        $f1b1811a0002602d$var$_.localStorage.remove(this.name);
        if (old_localstorage) this.register_once(old_localstorage);
    }
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $f1b1811a0002602d$var$JSONStringify(this['props']), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this['props'][key];
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$f1b1811a0002602d$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $f1b1811a0002602d$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($f1b1811a0002602d$var$_.isObject(props)) {
        if (typeof default_value === 'undefined') default_value = 'None';
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $f1b1811a0002602d$var$_.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) this['props'][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $f1b1811a0002602d$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($f1b1811a0002602d$var$_.isObject(props)) {
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $f1b1811a0002602d$var$_.extend(this['props'], props);
        this.save();
        return true;
    }
    return false;
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($f1b1811a0002602d$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$f1b1811a0002602d$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': $f1b1811a0002602d$var$_.info.referringDomain(referrer) || '$direct'
    }, '');
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $f1b1811a0002602d$var$_.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($f1b1811a0002602d$var$SET_ACTION), set_once_q = this._get_or_create_queue($f1b1811a0002602d$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($f1b1811a0002602d$var$UNSET_ACTION), add_q = this._get_or_create_queue($f1b1811a0002602d$var$ADD_ACTION), union_q = this._get_or_create_queue($f1b1811a0002602d$var$UNION_ACTION), remove_q = this._get_or_create_queue($f1b1811a0002602d$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($f1b1811a0002602d$var$APPEND_ACTION, []);
    if (q_key === $f1b1811a0002602d$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $f1b1811a0002602d$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($f1b1811a0002602d$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($f1b1811a0002602d$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($f1b1811a0002602d$var$UNSET_ACTION, q_data);
    } else if (q_key === $f1b1811a0002602d$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $f1b1811a0002602d$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($f1b1811a0002602d$var$UNSET_ACTION, q_data);
    } else if (q_key === $f1b1811a0002602d$var$UNSET_QUEUE_KEY) $f1b1811a0002602d$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $f1b1811a0002602d$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $f1b1811a0002602d$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $f1b1811a0002602d$var$ADD_QUEUE_KEY) {
        $f1b1811a0002602d$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($f1b1811a0002602d$var$UNSET_ACTION, q_data);
    } else if (q_key === $f1b1811a0002602d$var$UNION_QUEUE_KEY) {
        $f1b1811a0002602d$var$_.each(q_data, function(v, k) {
            if ($f1b1811a0002602d$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // Prevent duplicate values
                $f1b1811a0002602d$var$_.each(v, function(item) {
                    if (!$f1b1811a0002602d$var$_.include(union_q[k], item)) union_q[k].push(item);
                });
            }
        });
        this._pop_from_people_queue($f1b1811a0002602d$var$UNSET_ACTION, q_data);
    } else if (q_key === $f1b1811a0002602d$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($f1b1811a0002602d$var$APPEND_ACTION, q_data);
    } else if (q_key === $f1b1811a0002602d$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($f1b1811a0002602d$var$UNSET_ACTION, q_data);
    }
    $f1b1811a0002602d$var$console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    $f1b1811a0002602d$var$console$1.log(data);
    this.save();
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this['props'][this._get_queue_key(queue)];
    if (!$f1b1811a0002602d$var$_.isUndefined(q)) $f1b1811a0002602d$var$_.each(data, function(v, k) {
        if (queue === $f1b1811a0002602d$var$APPEND_ACTION || queue === $f1b1811a0002602d$var$REMOVE_ACTION) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        $f1b1811a0002602d$var$_.each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $f1b1811a0002602d$var$SET_ACTION) return $f1b1811a0002602d$var$SET_QUEUE_KEY;
    else if (queue === $f1b1811a0002602d$var$SET_ONCE_ACTION) return $f1b1811a0002602d$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $f1b1811a0002602d$var$UNSET_ACTION) return $f1b1811a0002602d$var$UNSET_QUEUE_KEY;
    else if (queue === $f1b1811a0002602d$var$ADD_ACTION) return $f1b1811a0002602d$var$ADD_QUEUE_KEY;
    else if (queue === $f1b1811a0002602d$var$APPEND_ACTION) return $f1b1811a0002602d$var$APPEND_QUEUE_KEY;
    else if (queue === $f1b1811a0002602d$var$REMOVE_ACTION) return $f1b1811a0002602d$var$REMOVE_QUEUE_KEY;
    else if (queue === $f1b1811a0002602d$var$UNION_ACTION) return $f1b1811a0002602d$var$UNION_QUEUE_KEY;
    else $f1b1811a0002602d$var$console$1.error('Invalid queue:', queue);
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $f1b1811a0002602d$var$_.isUndefined(default_val) ? {} : default_val;
    return this['props'][key] || (this['props'][key] = default_val);
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop($f1b1811a0002602d$var$EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this['props'][$f1b1811a0002602d$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$f1b1811a0002602d$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop($f1b1811a0002602d$var$EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!$f1b1811a0002602d$var$_.isUndefined(timestamp)) {
        delete this['props'][$f1b1811a0002602d$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/* eslint camelcase: "off" */ /*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ /*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $f1b1811a0002602d$var$init_type; // MODULE or SNIPPET loader
// allow bundlers to specify how extra code (recorder bundle) should be loaded
// eslint-disable-next-line no-unused-vars
var $f1b1811a0002602d$var$load_extra_bundle = function(src, _onload) {
    throw new Error(src + ' not available in this build.');
};
var $f1b1811a0002602d$var$mixpanel_master; // main mixpanel instance / object
var $f1b1811a0002602d$var$INIT_MODULE = 0;
var $f1b1811a0002602d$var$INIT_SNIPPET = 1;
var $f1b1811a0002602d$var$IDENTITY_FUNC = function(x) {
    return x;
};
/** @const */ var $f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */ var $f1b1811a0002602d$var$PAYLOAD_TYPE_BASE64 = 'base64';
/** @const */ var $f1b1811a0002602d$var$PAYLOAD_TYPE_JSON = 'json';
/** @const */ var $f1b1811a0002602d$var$DEVICE_ID_PREFIX = '$device:';
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $f1b1811a0002602d$var$USE_XHR = $f1b1811a0002602d$var$win.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $f1b1811a0002602d$var$ENQUEUE_REQUESTS = !$f1b1811a0002602d$var$USE_XHR && $f1b1811a0002602d$var$userAgent.indexOf('MSIE') === -1 && $f1b1811a0002602d$var$userAgent.indexOf('Mozilla') === -1;
// save reference to navigator.sendBeacon so it can be minified
var $f1b1811a0002602d$var$sendBeacon = null;
if ($f1b1811a0002602d$var$navigator['sendBeacon']) $f1b1811a0002602d$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $f1b1811a0002602d$var$navigator['sendBeacon'].apply($f1b1811a0002602d$var$navigator, arguments);
};
var $f1b1811a0002602d$var$DEFAULT_API_ROUTES = {
    'track': 'track/',
    'engage': 'engage/',
    'groups': 'groups/',
    'record': 'record/',
    'flags': 'flags/'
};
/*
 * Module-level globals
 */ var $f1b1811a0002602d$var$DEFAULT_CONFIG = {
    'api_host': 'https://api-js.mixpanel.com',
    'api_hosts': {},
    'api_routes': $f1b1811a0002602d$var$DEFAULT_API_ROUTES,
    'api_extra_query_params': {},
    'api_method': 'POST',
    'api_transport': 'XHR',
    'api_payload_format': $f1b1811a0002602d$var$PAYLOAD_TYPE_BASE64,
    'app_host': 'https://mixpanel.com',
    'autocapture': false,
    'cdn': 'https://cdn.mxpnl.com',
    'cross_site_cookie': false,
    'cross_subdomain_cookie': true,
    'error_reporter': $f1b1811a0002602d$var$NOOP_FUNC,
    'flags': false,
    'persistence': 'cookie',
    'persistence_name': '',
    'cookie_domain': '',
    'cookie_name': '',
    'loaded': $f1b1811a0002602d$var$NOOP_FUNC,
    'mp_loader': null,
    'track_marketing': true,
    'track_pageview': false,
    'skip_first_touch_marketing': false,
    'store_google': true,
    'stop_utm_persistence': false,
    'save_referrer': true,
    'test': false,
    'verbose': false,
    'img': false,
    'debug': false,
    'track_links_timeout': 300,
    'cookie_expiration': 365,
    'upgrade': false,
    'disable_persistence': false,
    'disable_cookie': false,
    'secure_cookie': false,
    'ip': true,
    'opt_out_tracking_by_default': false,
    'opt_out_persistence_by_default': false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix': null,
    'property_blacklist': [],
    'xhr_headers': {},
    'ignore_dnt': false,
    'batch_requests': true,
    'batch_size': 50,
    'batch_flush_interval_ms': 5000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true,
    'hooks': {},
    'record_block_class': new RegExp('^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$'),
    'record_block_selector': 'img, video',
    'record_canvas': false,
    'record_collect_fonts': false,
    'record_heatmap_data': false,
    'record_idle_timeout_ms': 1800000,
    'record_mask_text_class': new RegExp('^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$'),
    'record_mask_text_selector': '*',
    'record_max_ms': $f1b1811a0002602d$var$MAX_RECORDING_MS,
    'record_min_ms': 0,
    'record_sessions_percent': 0,
    'recorder_src': 'https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js'
};
var $f1b1811a0002602d$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $f1b1811a0002602d$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $f1b1811a0002602d$var$create_mplib = function(token, config, name) {
    var instance, target = name === $f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME ? $f1b1811a0002602d$var$mixpanel_master : $f1b1811a0002602d$var$mixpanel_master[name];
    if (target && $f1b1811a0002602d$var$init_type === $f1b1811a0002602d$var$INIT_MODULE) instance = target;
    else {
        if (target && !$f1b1811a0002602d$var$_.isArray(target)) {
            $f1b1811a0002602d$var$console$1.error('You have already initialized ' + name);
            return;
        }
        instance = new $f1b1811a0002602d$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance['people'] = new $f1b1811a0002602d$var$MixpanelPeople();
    instance['people']._init(instance);
    if (!instance.get_config('skip_first_touch_marketing')) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $f1b1811a0002602d$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $f1b1811a0002602d$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params['initial_' + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance['people'].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $f1b1811a0002602d$var$Config.DEBUG = $f1b1811a0002602d$var$Config.DEBUG || instance.get_config('debug');
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$f1b1811a0002602d$var$_.isUndefined(target) && $f1b1811a0002602d$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($f1b1811a0002602d$var$_.isUndefined(name)) {
        this.report_error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === $f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME) {
        this.report_error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }
    var instance = $f1b1811a0002602d$var$create_mplib(token, config, name);
    $f1b1811a0002602d$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$f1b1811a0002602d$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this['__loaded'] = true;
    this['config'] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!('api_payload_format' in config)) {
        var api_host = config['api_host'] || $f1b1811a0002602d$var$DEFAULT_CONFIG['api_host'];
        if (api_host.match(/\.mixpanel\.com/)) variable_features['api_payload_format'] = $f1b1811a0002602d$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($f1b1811a0002602d$var$_.extend({}, $f1b1811a0002602d$var$DEFAULT_CONFIG, variable_features, config, {
        'name': name,
        'token': token,
        'callback_fn': (name === $f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME ? name : $f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));
    this['_jsc'] = $f1b1811a0002602d$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!$f1b1811a0002602d$var$_.localStorage.is_supported(true) || !$f1b1811a0002602d$var$USE_XHR) {
            this._batch_requests = false;
            $f1b1811a0002602d$var$console$1.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
            $f1b1811a0002602d$var$_.each(this.get_batcher_configs(), function(batcher_config) {
                $f1b1811a0002602d$var$console$1.log('Clearing batch queue ' + batcher_config.queue_key);
                $f1b1811a0002602d$var$_.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if ($f1b1811a0002602d$var$sendBeacon && $f1b1811a0002602d$var$win.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $f1b1811a0002602d$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $f1b1811a0002602d$var$win.addEventListener('pagehide', function(ev) {
                    if (ev['persisted']) flush_on_unload();
                });
                $f1b1811a0002602d$var$win.addEventListener('visibilitychange', function() {
                    if ($f1b1811a0002602d$var$document$1['visibilityState'] === 'hidden') flush_on_unload();
                });
            }
        }
    }
    this['persistence'] = this['cookie'] = new $f1b1811a0002602d$var$MixpanelPersistence(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $f1b1811a0002602d$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        'distinct_id': $f1b1811a0002602d$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
    this.flags = new $f1b1811a0002602d$var$FeatureFlagManager({
        getFullApiRoute: $f1b1811a0002602d$var$_.bind(function() {
            return this.get_api_host('flags') + '/' + this.get_config('api_routes')['flags'];
        }, this),
        getConfigFunc: $f1b1811a0002602d$var$_.bind(this.get_config, this),
        getPropertyFunc: $f1b1811a0002602d$var$_.bind(this.get_property, this),
        trackingFunc: $f1b1811a0002602d$var$_.bind(this.track, this)
    });
    this.flags.init();
    this['flags'] = this.flags;
    this.autocapture = new $f1b1811a0002602d$var$Autocapture(this);
    this.autocapture.init();
    this._init_tab_id();
    this._check_and_start_session_recording();
};
/**
 * Assigns a unique UUID to this tab / window by leveraging sessionStorage.
 * This is primarily used for session recording, where data must be isolated to the current tab.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype._init_tab_id = function() {
    if ($f1b1811a0002602d$var$_.sessionStorage.is_supported()) try {
        var key_suffix = this.get_config('name') + '_' + this.get_config('token');
        var tab_id_key = 'mp_tab_id_' + key_suffix;
        // A flag is used to determine if sessionStorage is copied over and we need to generate a new tab ID.
        // This enforces a unique ID in the cases like duplicated tab, window.open(...)
        var should_generate_new_tab_id_key = 'mp_gen_new_tab_id_' + key_suffix;
        if ($f1b1811a0002602d$var$_.sessionStorage.get(should_generate_new_tab_id_key) || !$f1b1811a0002602d$var$_.sessionStorage.get(tab_id_key)) $f1b1811a0002602d$var$_.sessionStorage.set(tab_id_key, '$tab-' + $f1b1811a0002602d$var$_.UUID());
        $f1b1811a0002602d$var$_.sessionStorage.set(should_generate_new_tab_id_key, '1');
        this.tab_id = $f1b1811a0002602d$var$_.sessionStorage.get(tab_id_key);
        // Remove the flag when the tab is unloaded to indicate the stored tab ID can be reused. This event is not reliable to detect all page unloads,
        // but reliable in cases where the user remains in the tab e.g. a refresh or href navigation.
        // If the flag is absent, this indicates to the next SDK instance that we can reuse the stored tab_id.
        $f1b1811a0002602d$var$win.addEventListener('beforeunload', function() {
            $f1b1811a0002602d$var$_.sessionStorage.remove(should_generate_new_tab_id_key);
        });
    } catch (err) {
        this.report_error('Error initializing tab id', err);
    }
    else this.report_error('Session storage is not supported, cannot keep track of unique tab ID.');
};
$f1b1811a0002602d$var$MixpanelLib.prototype.get_tab_id = function() {
    return this.tab_id || null;
};
$f1b1811a0002602d$var$MixpanelLib.prototype._should_load_recorder = function() {
    var recording_registry_idb = new $f1b1811a0002602d$var$IDBStorageWrapper($f1b1811a0002602d$var$RECORDING_REGISTRY_STORE_NAME);
    var tab_id = this.get_tab_id();
    return recording_registry_idb.init().then(function() {
        return recording_registry_idb.getAll();
    }).then(function(recordings) {
        for(var i = 0; i < recordings.length; i++){
            // if there are expired recordings in the registry, we should load the recorder to flush them
            // if there's a recording for this tab id, we should load the recorder to continue the recording
            if ($f1b1811a0002602d$var$isRecordingExpired(recordings[i]) || recordings[i]['tabId'] === tab_id) return true;
        }
        return false;
    }).catch($f1b1811a0002602d$var$_.bind(function(err) {
        this.report_error('Error checking recording registry', err);
    }, this));
};
$f1b1811a0002602d$var$MixpanelLib.prototype._check_and_start_session_recording = $f1b1811a0002602d$var$addOptOutCheckMixpanelLib(function(force_start) {
    if (!$f1b1811a0002602d$var$win['MutationObserver']) {
        $f1b1811a0002602d$var$console$1.critical('Browser does not support MutationObserver; skipping session recording');
        return;
    }
    var loadRecorder = $f1b1811a0002602d$var$_.bind(function(startNewIfInactive) {
        var handleLoadedRecorder = $f1b1811a0002602d$var$_.bind(function() {
            this._recorder = this._recorder || new $f1b1811a0002602d$var$win['__mp_recorder'](this);
            this._recorder['resumeRecording'](startNewIfInactive);
        }, this);
        if ($f1b1811a0002602d$var$_.isUndefined($f1b1811a0002602d$var$win['__mp_recorder'])) $f1b1811a0002602d$var$load_extra_bundle(this.get_config('recorder_src'), handleLoadedRecorder);
        else handleLoadedRecorder();
    }, this);
    /**
     * If the user is sampled or start_session_recording is called, we always load the recorder since it's guaranteed a recording should start.
     * Otherwise, if the recording registry has any records then it's likely there's a recording in progress or orphaned data that needs to be flushed.
     */ var is_sampled = this.get_config('record_sessions_percent') > 0 && Math.random() * 100 <= this.get_config('record_sessions_percent');
    if (force_start || is_sampled) loadRecorder(true);
    else this._should_load_recorder().then(function(shouldLoad) {
        if (shouldLoad) loadRecorder(false);
    });
});
$f1b1811a0002602d$var$MixpanelLib.prototype.start_session_recording = function() {
    this._check_and_start_session_recording(true);
};
$f1b1811a0002602d$var$MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) return this._recorder['stopRecording']();
    return Promise.resolve();
};
$f1b1811a0002602d$var$MixpanelLib.prototype.pause_session_recording = function() {
    if (this._recorder) return this._recorder['pauseRecording']();
    return Promise.resolve();
};
$f1b1811a0002602d$var$MixpanelLib.prototype.resume_session_recording = function() {
    if (this._recorder) return this._recorder['resumeRecording']();
    return Promise.resolve();
};
$f1b1811a0002602d$var$MixpanelLib.prototype.is_recording_heatmap_data = function() {
    return this._get_session_replay_id() && this.get_config('record_heatmap_data');
};
$f1b1811a0002602d$var$MixpanelLib.prototype.get_session_recording_properties = function() {
    var props = {};
    var replay_id = this._get_session_replay_id();
    if (replay_id) props['$mp_replay_id'] = replay_id;
    return props;
};
$f1b1811a0002602d$var$MixpanelLib.prototype.get_session_replay_url = function() {
    var replay_url = null;
    var replay_id = this._get_session_replay_id();
    if (replay_id) {
        var query_params = $f1b1811a0002602d$var$_.HTTPBuildQuery({
            'replay_id': replay_id,
            'distinct_id': this.get_distinct_id(),
            'token': this.get_config('token')
        });
        replay_url = 'https://mixpanel.com/projects/replay-redirect?' + query_params;
    }
    return replay_url;
};
$f1b1811a0002602d$var$MixpanelLib.prototype._get_session_replay_id = function() {
    var replay_id = null;
    if (this._recorder) replay_id = this._recorder['replayId'];
    return replay_id || null;
};
// "private" public method to reach into the recorder in test cases
$f1b1811a0002602d$var$MixpanelLib.prototype.__get_recorder = function() {
    return this._recorder;
};
// Private methods
$f1b1811a0002602d$var$MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
    this['people'].set_once(this['persistence'].get_referrer_info());
    // `store_google` is now deprecated and previously stored UTM parameters are cleared
    // from persistence by default.
    if (this.get_config('store_google') && this.get_config('stop_utm_persistence')) {
        var utm_params = $f1b1811a0002602d$var$_.info.campaignParams(null);
        $f1b1811a0002602d$var$_.each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
$f1b1811a0002602d$var$MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword($f1b1811a0002602d$var$document$1.referrer);
    // Registering super properties for UTM persistence by 'store_google' is deprecated.
    if (this.get_config('store_google') && !this.get_config('stop_utm_persistence')) this.register($f1b1811a0002602d$var$_.info.campaignParams());
    if (this.get_config('save_referrer')) this['persistence'].update_referrer_info($f1b1811a0002602d$var$document$1.referrer);
};
$f1b1811a0002602d$var$MixpanelLib.prototype._dom_loaded = function() {
    $f1b1811a0002602d$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $f1b1811a0002602d$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$f1b1811a0002602d$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        this.report_error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }
    if (!$f1b1811a0002602d$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($f1b1811a0002602d$var$_.isUndefined(callback)) return null;
    if ($f1b1811a0002602d$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$f1b1811a0002602d$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($f1b1811a0002602d$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;
    if (!callback && ($f1b1811a0002602d$var$_.isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = $f1b1811a0002602d$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$f1b1811a0002602d$var$USE_XHR) options.method = 'GET';
    var use_post = options.method === 'POST';
    var use_sendBeacon = $f1b1811a0002602d$var$sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) verbose_mode = true;
    if (this.get_config('test')) data['test'] = 1;
    if (verbose_mode) data['verbose'] = 1;
    if (this.get_config('img')) data['img'] = 1;
    if (!$f1b1811a0002602d$var$USE_XHR) {
        if (callback) data['callback'] = callback;
        else if (verbose_mode || this.get_config('test')) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data['callback'] = '(function(){})';
    }
    data['ip'] = this.get_config('ip') ? 1 : 0;
    data['_'] = new Date().getTime().toString();
    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }
    $f1b1811a0002602d$var$_.extend(data, this.get_config('api_extra_query_params'));
    url += '?' + $f1b1811a0002602d$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ('img' in data) {
        var img = $f1b1811a0002602d$var$document$1.createElement('img');
        img.src = url;
        $f1b1811a0002602d$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $f1b1811a0002602d$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($f1b1811a0002602d$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config('xhr_headers');
        if (use_post) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        $f1b1811a0002602d$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== 'undefined') {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $f1b1811a0002602d$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = 'timeout';
                    else error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) {
                            var response_headers = req['responseHeaders'] || {};
                            callback({
                                status: 0,
                                httpStatusCode: req['status'],
                                error: error,
                                retryAfter: response_headers['Retry-After']
                            });
                        } else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $f1b1811a0002602d$var$document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $f1b1811a0002602d$var$document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $f1b1811a0002602d$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $f1b1811a0002602d$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($f1b1811a0002602d$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === 'function') item.call(this);
            else if ($f1b1811a0002602d$var$_.isArray(item) && fn_name === 'alias') alias_calls.push(item);
            else if ($f1b1811a0002602d$var$_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof this[fn_name] === 'function') tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $f1b1811a0002602d$var$_.each(calls, function(item) {
            if ($f1b1811a0002602d$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $f1b1811a0002602d$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$f1b1811a0002602d$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$f1b1811a0002602d$var$MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = '__mpq_' + this.get_config('token');
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: 'events',
            api_name: 'track',
            queue_key: queue_prefix + '_ev'
        },
        people: {
            type: 'people',
            api_name: 'engage',
            queue_key: queue_prefix + '_pp'
        },
        groups: {
            type: 'groups',
            api_name: 'groups',
            queue_key: queue_prefix + '_gr'
        }
    };
    return this._batcher_configs;
};
$f1b1811a0002602d$var$MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = $f1b1811a0002602d$var$_.bind(function(attrs) {
            return new $f1b1811a0002602d$var$RequestBatcher(attrs.queue_key, {
                libConfig: this['config'],
                errorReporter: this.get_config('error_reporter'),
                sendRequestFunc: $f1b1811a0002602d$var$_.bind(function(data, options, cb) {
                    var api_routes = this.get_config('api_routes');
                    this._send_request(this.get_api_host(attrs.api_name) + '/' + api_routes[attrs.api_name], this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $f1b1811a0002602d$var$_.bind(function(item) {
                    return this._run_hook('before_send_' + attrs.type, item);
                }, this),
                stopAllBatchingFunc: $f1b1811a0002602d$var$_.bind(this.stop_batch_senders, this),
                usePersistence: true
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config('batch_autostart')) this.start_batch_senders();
};
$f1b1811a0002602d$var$MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $f1b1811a0002602d$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$f1b1811a0002602d$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $f1b1811a0002602d$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === 'undefined') this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$f1b1811a0002602d$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $f1b1811a0002602d$var$JSONStringify(data);
    if (this.get_config('api_payload_format') === $f1b1811a0002602d$var$PAYLOAD_TYPE_BASE64) encoded_data = $f1b1811a0002602d$var$_.base64Encode(encoded_data);
    return {
        'data': encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$f1b1811a0002602d$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $f1b1811a0002602d$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $f1b1811a0002602d$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $f1b1811a0002602d$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        if (truncated_data) {
            $f1b1811a0002602d$var$console$1.log('MIXPANEL REQUEST:');
            $f1b1811a0002602d$var$console$1.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data).then(function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.track = $f1b1811a0002602d$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') callback = $f1b1811a0002602d$var$NOOP_FUNC;
    if ($f1b1811a0002602d$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.track');
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = $f1b1811a0002602d$var$_.extend({}, properties);
    properties['token'] = this.get_config('token');
    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!$f1b1811a0002602d$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config('track_marketing') ? $f1b1811a0002602d$var$_.info.marketingParams() : {};
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $f1b1811a0002602d$var$_.extend({}, $f1b1811a0002602d$var$_.info.properties({
        'mp_loader': this.get_config('mp_loader')
    }), marketing_properties, this['persistence'].properties(), this.unpersisted_superprops, this.get_session_recording_properties(), properties);
    var property_blacklist = this.get_config('property_blacklist');
    if ($f1b1811a0002602d$var$_.isArray(property_blacklist)) $f1b1811a0002602d$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error('Invalid value for property_blacklist config: ' + property_blacklist);
    var data = {
        'event': event_name,
        'properties': properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_api_host('events') + '/' + this.get_config('api_routes')['track'],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.set_group = $f1b1811a0002602d$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$f1b1811a0002602d$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.add_group = $f1b1811a0002602d$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this['people'].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.remove_group = $f1b1811a0002602d$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this['people'].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.track_with_groups = $f1b1811a0002602d$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $f1b1811a0002602d$var$_.extend({}, properties || {});
    $f1b1811a0002602d$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$f1b1811a0002602d$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};
$f1b1811a0002602d$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $f1b1811a0002602d$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.track_pageview = $f1b1811a0002602d$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== 'object') properties = {};
    options = options || {};
    var event_name = options['event_name'] || '$mp_web_page_view';
    var default_page_properties = $f1b1811a0002602d$var$_.extend($f1b1811a0002602d$var$_.info.mpPageViewProperties(), $f1b1811a0002602d$var$_.info.campaignParams(), $f1b1811a0002602d$var$_.info.clickParams());
    var event_properties = $f1b1811a0002602d$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $f1b1811a0002602d$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $f1b1811a0002602d$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($f1b1811a0002602d$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.time_event');
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this['persistence'].set_event_timer(event_name, new Date().getTime());
};
var $f1b1811a0002602d$var$REGISTER_DEFAULTS = {
    'persistent': true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $f1b1811a0002602d$var$options_for_register = function(days_or_options) {
    var options;
    if ($f1b1811a0002602d$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$f1b1811a0002602d$var$_.isUndefined(days_or_options)) options = {
        'days': days_or_options
    };
    else options = {};
    return $f1b1811a0002602d$var$_.extend({}, $f1b1811a0002602d$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $f1b1811a0002602d$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register(props, options['days']);
    else $f1b1811a0002602d$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $f1b1811a0002602d$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register_once(props, default_value, options['days']);
    else {
        if (typeof default_value === 'undefined') default_value = 'None';
        $f1b1811a0002602d$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $f1b1811a0002602d$var$options_for_register(options);
    if (options['persistent']) this['persistence'].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$f1b1811a0002602d$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === 'string' && new_distinct_id.indexOf($f1b1811a0002602d$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error('distinct_id cannot have $device: prefix');
            return -1;
        }
        this.register({
            '$user_id': new_distinct_id
        });
    }
    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            '$had_persisted_distinct_id': true,
            '$device_id': device_id
        }, '');
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($f1b1811a0002602d$var$ALIAS_ID_KEY)) {
        this.unregister($f1b1811a0002602d$var$ALIAS_ID_KEY);
        this.register({
            'distinct_id': new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track('$identify', {
        'distinct_id': new_distinct_id,
        '$anon_distinct_id': previous_distinct_id
    }, {
        skip_hooks: true
    });
    // check feature flags again if distinct id has changed
    if (new_distinct_id !== previous_distinct_id) this.flags.fetchFlags();
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.reset = function() {
    this.stop_session_recording();
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = $f1b1811a0002602d$var$_.UUID();
    this.register_once({
        'distinct_id': $f1b1811a0002602d$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
    this._check_and_start_session_recording();
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($f1b1811a0002602d$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error('Attempting to create alias for existing People user - aborting.');
        return -2;
    }
    var _this = this;
    if ($f1b1811a0002602d$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($f1b1811a0002602d$var$ALIAS_ID_KEY, alias);
        return this.track('$create_alias', {
            'alias': alias,
            'distinct_id': original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.set_config = function(config) {
    if ($f1b1811a0002602d$var$_.isObject(config)) {
        $f1b1811a0002602d$var$_.extend(this['config'], config);
        var new_batch_size = config['batch_size'];
        if (new_batch_size) $f1b1811a0002602d$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config('persistence_name')) this['config']['persistence_name'] = this['config']['cookie_name'];
        if (!this.get_config('disable_persistence')) this['config']['disable_persistence'] = this['config']['disable_cookie'];
        if (this['persistence']) this['persistence'].update_config(this['config']);
        $f1b1811a0002602d$var$Config.DEBUG = $f1b1811a0002602d$var$Config.DEBUG || this.get_config('debug');
        if (('autocapture' in config || 'record_heatmap_data' in config) && this.autocapture) this.autocapture.init();
    }
};
/**
 * returns the current config object for the library.
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $f1b1811a0002602d$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || $f1b1811a0002602d$var$IDENTITY_FUNC).apply(this, $f1b1811a0002602d$var$slice.call(arguments, 1));
    if (typeof ret === 'undefined') {
        this.report_error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence'].load_prop([
        property_name
    ]);
};
/**
 * Get the API host for a specific endpoint type, falling back to the default api_host if not specified
 *
 * @param {String} endpoint_type The type of endpoint (e.g., "events", "people", "groups")
 * @returns {String} The API host to use for this endpoint
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.get_api_host = function(endpoint_type) {
    return this.get_config('api_hosts')[endpoint_type] || this.get_config('api_host');
};
$f1b1811a0002602d$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== $f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME) name = $f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME + '.' + name;
    return name;
};
$f1b1811a0002602d$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $f1b1811a0002602d$var$_.isBlockedUA($f1b1811a0002602d$var$userAgent) || this._flags.disable_all_events || $f1b1811a0002602d$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$f1b1811a0002602d$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $f1b1811a0002602d$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            'persistence_type': 'cookie'
        })) this.opt_in_tracking({
            'enable_persistence': false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            'persistence_type': 'cookie'
        })) this.opt_out_tracking({
            'clear_persistence': false
        });
        this.clear_opt_in_out_tracking({
            'persistence_type': 'cookie',
            'enable_persistence': false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        'clear_persistence': true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config('opt_out_tracking_by_default') || $f1b1811a0002602d$var$_.cookie.get('mp_optout'))) {
        $f1b1811a0002602d$var$_.cookie.remove('mp_optout');
        this.opt_out_tracking({
            'clear_persistence': this.get_config('opt_out_persistence_by_default')
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $f1b1811a0002602d$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) disabled = true;
    else if (options && options['enable_persistence']) disabled = false;
    else return;
    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) this['persistence'].set_disabled(disabled);
    if (disabled) {
        this.stop_batch_senders();
        this.stop_session_recording();
    } else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
$f1b1811a0002602d$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $f1b1811a0002602d$var$_.extend({
        'track': $f1b1811a0002602d$var$_.bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_site_cookie': this.get_config('cross_site_cookie'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'cookie_domain': this.get_config('cookie_domain'),
        'secure_cookie': this.get_config('secure_cookie'),
        'ignore_dnt': this.get_config('ignore_dnt')
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$f1b1811a0002602d$var$_.localStorage.is_supported()) options['persistence_type'] = 'cookie';
    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $f1b1811a0002602d$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($f1b1811a0002602d$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $f1b1811a0002602d$var$_.extend({
        'clear_persistence': true,
        'delete_user': true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }
    this._gdpr_call_func($f1b1811a0002602d$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($f1b1811a0002602d$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($f1b1811a0002602d$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $f1b1811a0002602d$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $f1b1811a0002602d$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($f1b1811a0002602d$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$f1b1811a0002602d$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $f1b1811a0002602d$var$console$1.error.apply($f1b1811a0002602d$var$console$1.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config('error_reporter')(msg, err);
    } catch (err) {
        $f1b1811a0002602d$var$console$1.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$f1b1811a0002602d$var$MixpanelLib.prototype['init'] = $f1b1811a0002602d$var$MixpanelLib.prototype.init;
$f1b1811a0002602d$var$MixpanelLib.prototype['reset'] = $f1b1811a0002602d$var$MixpanelLib.prototype.reset;
$f1b1811a0002602d$var$MixpanelLib.prototype['disable'] = $f1b1811a0002602d$var$MixpanelLib.prototype.disable;
$f1b1811a0002602d$var$MixpanelLib.prototype['time_event'] = $f1b1811a0002602d$var$MixpanelLib.prototype.time_event;
$f1b1811a0002602d$var$MixpanelLib.prototype['track'] = $f1b1811a0002602d$var$MixpanelLib.prototype.track;
$f1b1811a0002602d$var$MixpanelLib.prototype['track_links'] = $f1b1811a0002602d$var$MixpanelLib.prototype.track_links;
$f1b1811a0002602d$var$MixpanelLib.prototype['track_forms'] = $f1b1811a0002602d$var$MixpanelLib.prototype.track_forms;
$f1b1811a0002602d$var$MixpanelLib.prototype['track_pageview'] = $f1b1811a0002602d$var$MixpanelLib.prototype.track_pageview;
$f1b1811a0002602d$var$MixpanelLib.prototype['register'] = $f1b1811a0002602d$var$MixpanelLib.prototype.register;
$f1b1811a0002602d$var$MixpanelLib.prototype['register_once'] = $f1b1811a0002602d$var$MixpanelLib.prototype.register_once;
$f1b1811a0002602d$var$MixpanelLib.prototype['unregister'] = $f1b1811a0002602d$var$MixpanelLib.prototype.unregister;
$f1b1811a0002602d$var$MixpanelLib.prototype['identify'] = $f1b1811a0002602d$var$MixpanelLib.prototype.identify;
$f1b1811a0002602d$var$MixpanelLib.prototype['alias'] = $f1b1811a0002602d$var$MixpanelLib.prototype.alias;
$f1b1811a0002602d$var$MixpanelLib.prototype['name_tag'] = $f1b1811a0002602d$var$MixpanelLib.prototype.name_tag;
$f1b1811a0002602d$var$MixpanelLib.prototype['set_config'] = $f1b1811a0002602d$var$MixpanelLib.prototype.set_config;
$f1b1811a0002602d$var$MixpanelLib.prototype['get_config'] = $f1b1811a0002602d$var$MixpanelLib.prototype.get_config;
$f1b1811a0002602d$var$MixpanelLib.prototype['get_api_host'] = $f1b1811a0002602d$var$MixpanelLib.prototype.get_api_host;
$f1b1811a0002602d$var$MixpanelLib.prototype['get_property'] = $f1b1811a0002602d$var$MixpanelLib.prototype.get_property;
$f1b1811a0002602d$var$MixpanelLib.prototype['get_distinct_id'] = $f1b1811a0002602d$var$MixpanelLib.prototype.get_distinct_id;
$f1b1811a0002602d$var$MixpanelLib.prototype['toString'] = $f1b1811a0002602d$var$MixpanelLib.prototype.toString;
$f1b1811a0002602d$var$MixpanelLib.prototype['opt_out_tracking'] = $f1b1811a0002602d$var$MixpanelLib.prototype.opt_out_tracking;
$f1b1811a0002602d$var$MixpanelLib.prototype['opt_in_tracking'] = $f1b1811a0002602d$var$MixpanelLib.prototype.opt_in_tracking;
$f1b1811a0002602d$var$MixpanelLib.prototype['has_opted_out_tracking'] = $f1b1811a0002602d$var$MixpanelLib.prototype.has_opted_out_tracking;
$f1b1811a0002602d$var$MixpanelLib.prototype['has_opted_in_tracking'] = $f1b1811a0002602d$var$MixpanelLib.prototype.has_opted_in_tracking;
$f1b1811a0002602d$var$MixpanelLib.prototype['clear_opt_in_out_tracking'] = $f1b1811a0002602d$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$f1b1811a0002602d$var$MixpanelLib.prototype['get_group'] = $f1b1811a0002602d$var$MixpanelLib.prototype.get_group;
$f1b1811a0002602d$var$MixpanelLib.prototype['set_group'] = $f1b1811a0002602d$var$MixpanelLib.prototype.set_group;
$f1b1811a0002602d$var$MixpanelLib.prototype['add_group'] = $f1b1811a0002602d$var$MixpanelLib.prototype.add_group;
$f1b1811a0002602d$var$MixpanelLib.prototype['remove_group'] = $f1b1811a0002602d$var$MixpanelLib.prototype.remove_group;
$f1b1811a0002602d$var$MixpanelLib.prototype['track_with_groups'] = $f1b1811a0002602d$var$MixpanelLib.prototype.track_with_groups;
$f1b1811a0002602d$var$MixpanelLib.prototype['start_batch_senders'] = $f1b1811a0002602d$var$MixpanelLib.prototype.start_batch_senders;
$f1b1811a0002602d$var$MixpanelLib.prototype['stop_batch_senders'] = $f1b1811a0002602d$var$MixpanelLib.prototype.stop_batch_senders;
$f1b1811a0002602d$var$MixpanelLib.prototype['start_session_recording'] = $f1b1811a0002602d$var$MixpanelLib.prototype.start_session_recording;
$f1b1811a0002602d$var$MixpanelLib.prototype['stop_session_recording'] = $f1b1811a0002602d$var$MixpanelLib.prototype.stop_session_recording;
$f1b1811a0002602d$var$MixpanelLib.prototype['pause_session_recording'] = $f1b1811a0002602d$var$MixpanelLib.prototype.pause_session_recording;
$f1b1811a0002602d$var$MixpanelLib.prototype['resume_session_recording'] = $f1b1811a0002602d$var$MixpanelLib.prototype.resume_session_recording;
$f1b1811a0002602d$var$MixpanelLib.prototype['get_session_recording_properties'] = $f1b1811a0002602d$var$MixpanelLib.prototype.get_session_recording_properties;
$f1b1811a0002602d$var$MixpanelLib.prototype['get_session_replay_url'] = $f1b1811a0002602d$var$MixpanelLib.prototype.get_session_replay_url;
$f1b1811a0002602d$var$MixpanelLib.prototype['get_tab_id'] = $f1b1811a0002602d$var$MixpanelLib.prototype.get_tab_id;
$f1b1811a0002602d$var$MixpanelLib.prototype['DEFAULT_API_ROUTES'] = $f1b1811a0002602d$var$DEFAULT_API_ROUTES;
// Exports intended only for testing
$f1b1811a0002602d$var$MixpanelLib.prototype['__get_recorder'] = $f1b1811a0002602d$var$MixpanelLib.prototype.__get_recorder;
// MixpanelPersistence Exports
$f1b1811a0002602d$var$MixpanelPersistence.prototype['properties'] = $f1b1811a0002602d$var$MixpanelPersistence.prototype.properties;
$f1b1811a0002602d$var$MixpanelPersistence.prototype['update_search_keyword'] = $f1b1811a0002602d$var$MixpanelPersistence.prototype.update_search_keyword;
$f1b1811a0002602d$var$MixpanelPersistence.prototype['update_referrer_info'] = $f1b1811a0002602d$var$MixpanelPersistence.prototype.update_referrer_info;
$f1b1811a0002602d$var$MixpanelPersistence.prototype['get_cross_subdomain'] = $f1b1811a0002602d$var$MixpanelPersistence.prototype.get_cross_subdomain;
$f1b1811a0002602d$var$MixpanelPersistence.prototype['clear'] = $f1b1811a0002602d$var$MixpanelPersistence.prototype.clear;
var $f1b1811a0002602d$var$instances = {};
var $f1b1811a0002602d$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $f1b1811a0002602d$var$_.each($f1b1811a0002602d$var$instances, function(instance, name) {
        if (name !== $f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME) $f1b1811a0002602d$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $f1b1811a0002602d$var$mixpanel_master['_'] = $f1b1811a0002602d$var$_;
};
var $f1b1811a0002602d$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $f1b1811a0002602d$var$mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$f1b1811a0002602d$var$mixpanel_master[name]) {
                $f1b1811a0002602d$var$mixpanel_master[name] = $f1b1811a0002602d$var$instances[name] = $f1b1811a0002602d$var$create_mplib(token, config, name);
                $f1b1811a0002602d$var$mixpanel_master[name]._loaded();
            }
            return $f1b1811a0002602d$var$mixpanel_master[name];
        } else {
            var instance = $f1b1811a0002602d$var$mixpanel_master;
            if ($f1b1811a0002602d$var$instances[$f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $f1b1811a0002602d$var$instances[$f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $f1b1811a0002602d$var$create_mplib(token, config, $f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $f1b1811a0002602d$var$instances[$f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $f1b1811a0002602d$var$mixpanel_master = instance;
            if ($f1b1811a0002602d$var$init_type === $f1b1811a0002602d$var$INIT_SNIPPET) $f1b1811a0002602d$var$win[$f1b1811a0002602d$var$PRIMARY_INSTANCE_NAME] = $f1b1811a0002602d$var$mixpanel_master;
            $f1b1811a0002602d$var$extend_mp();
        }
    };
};
var $f1b1811a0002602d$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $f1b1811a0002602d$var$DOM_LOADED = true;
        $f1b1811a0002602d$var$ENQUEUE_REQUESTS = false;
        $f1b1811a0002602d$var$_.each($f1b1811a0002602d$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $f1b1811a0002602d$var$document$1.documentElement.doScroll('left');
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($f1b1811a0002602d$var$document$1.addEventListener) {
        if ($f1b1811a0002602d$var$document$1.readyState === 'complete') // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $f1b1811a0002602d$var$document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
    } else if ($f1b1811a0002602d$var$document$1.attachEvent) {
        // IE
        $f1b1811a0002602d$var$document$1.attachEvent('onreadystatechange', dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $f1b1811a0002602d$var$win.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($f1b1811a0002602d$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $f1b1811a0002602d$var$_.register_event($f1b1811a0002602d$var$win, 'load', dom_loaded_handler, true);
};
function $f1b1811a0002602d$var$init_as_module(bundle_loader) {
    $f1b1811a0002602d$var$load_extra_bundle = bundle_loader;
    $f1b1811a0002602d$var$init_type = $f1b1811a0002602d$var$INIT_MODULE;
    $f1b1811a0002602d$var$mixpanel_master = new $f1b1811a0002602d$var$MixpanelLib();
    $f1b1811a0002602d$var$override_mp_init_func();
    $f1b1811a0002602d$var$mixpanel_master['init']();
    $f1b1811a0002602d$var$add_dom_loaded_handler();
    return $f1b1811a0002602d$var$mixpanel_master;
}
// For loading separate bundles asynchronously via script tag
// so that we don't load them until they are needed at runtime.
// For builds that have everything in one bundle, no extra work.
function $f1b1811a0002602d$var$loadNoop(_src, onload) {
    onload();
}
/* eslint camelcase: "off" */ var $f1b1811a0002602d$export$2e2bcd8739ae039 = $f1b1811a0002602d$var$init_as_module($f1b1811a0002602d$var$loadNoop);


const $8d14ffad040e6e00$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $8d14ffad040e6e00$export$2e2bcd8739ae039 = {
    randomUUID: $8d14ffad040e6e00$var$randomUUID
};


let $0aed7c0bbbe9e0ff$var$getRandomValues;
const $0aed7c0bbbe9e0ff$var$rnds8 = new Uint8Array(16);
function $0aed7c0bbbe9e0ff$export$2e2bcd8739ae039() {
    if (!$0aed7c0bbbe9e0ff$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $0aed7c0bbbe9e0ff$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $0aed7c0bbbe9e0ff$var$getRandomValues($0aed7c0bbbe9e0ff$var$rnds8);
}


var $e8c64d091b35eb8d$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $bf0ab40ea1eab15d$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $e8c64d091b35eb8d$export$2e2bcd8739ae039).test(uuid);
}
var $bf0ab40ea1eab15d$export$2e2bcd8739ae039 = $bf0ab40ea1eab15d$var$validate;


const $6c77676f8bf877cb$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$6c77676f8bf877cb$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $6c77676f8bf877cb$export$8fb373d660548968(arr, offset = 0) {
    return ($6c77676f8bf877cb$var$byteToHex[arr[offset + 0]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 1]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 2]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 3]] + '-' + $6c77676f8bf877cb$var$byteToHex[arr[offset + 4]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 5]] + '-' + $6c77676f8bf877cb$var$byteToHex[arr[offset + 6]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 7]] + '-' + $6c77676f8bf877cb$var$byteToHex[arr[offset + 8]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 9]] + '-' + $6c77676f8bf877cb$var$byteToHex[arr[offset + 10]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 11]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 12]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 13]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 14]] + $6c77676f8bf877cb$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $6c77676f8bf877cb$var$stringify(arr, offset = 0) {
    const uuid = $6c77676f8bf877cb$export$8fb373d660548968(arr, offset);
    if (!(0, $bf0ab40ea1eab15d$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $6c77676f8bf877cb$export$2e2bcd8739ae039 = $6c77676f8bf877cb$var$stringify;


function $b1f04e21bfe75146$var$v4(options, buf, offset) {
    if ((0, $8d14ffad040e6e00$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $8d14ffad040e6e00$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $0aed7c0bbbe9e0ff$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $6c77676f8bf877cb$export$8fb373d660548968)(rnds);
}
var $b1f04e21bfe75146$export$2e2bcd8739ae039 = $b1f04e21bfe75146$var$v4;


var $1628340e44d9a835$exports = {};
/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ /* global define */ /* eslint-disable strict */ (function($) {
    'use strict';
    /**
   * Add integers, wrapping at 2^32.
   * This uses 16-bit operations internally to work around bugs in interpreters.
   *
   * @param {number} x First integer
   * @param {number} y Second integer
   * @returns {number} Sum
   */ function safeAdd(x, y) {
        var lsw = (x & 0xffff) + (y & 0xffff);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xffff;
    }
    /**
   * Bitwise rotate a 32-bit number to the left.
   *
   * @param {number} num 32-bit number
   * @param {number} cnt Rotation count
   * @returns {number} Rotated number
   */ function bitRotateLeft(num, cnt) {
        return num << cnt | num >>> 32 - cnt;
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} q q
   * @param {number} a a
   * @param {number} b b
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5cmn(q, a, b, x, s, t) {
        return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5ff(a, b, c, d, x, s, t) {
        return md5cmn(b & c | ~b & d, a, b, x, s, t);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5gg(a, b, c, d, x, s, t) {
        return md5cmn(b & d | c & ~d, a, b, x, s, t);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5hh(a, b, c, d, x, s, t) {
        return md5cmn(b ^ c ^ d, a, b, x, s, t);
    }
    /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */ function md5ii(a, b, c, d, x, s, t) {
        return md5cmn(c ^ (b | ~d), a, b, x, s, t);
    }
    /**
   * Calculate the MD5 of an array of little-endian words, and a bit length.
   *
   * @param {Array} x Array of little-endian words
   * @param {number} len Bit length
   * @returns {Array<number>} MD5 Array
   */ function binlMD5(x, len) {
        /* append padding */ x[len >> 5] |= 0x80 << len % 32;
        x[(len + 64 >>> 9 << 4) + 14] = len;
        var i;
        var olda;
        var oldb;
        var oldc;
        var oldd;
        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;
        for(i = 0; i < x.length; i += 16){
            olda = a;
            oldb = b;
            oldc = c;
            oldd = d;
            a = md5ff(a, b, c, d, x[i], 7, -680876936);
            d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
            c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
            b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
            a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
            d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
            c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
            b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
            a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
            d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
            c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
            b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
            d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
            a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
            d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
            c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
            b = md5gg(b, c, d, a, x[i], 20, -373897302);
            a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
            d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
            c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
            a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
            d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
            c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
            b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
            a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
            d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
            c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
            b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
            a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
            d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
            c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
            b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
            d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
            c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
            b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
            d = md5hh(d, a, b, c, x[i], 11, -358537222);
            c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
            b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
            a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
            d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
            b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
            a = md5ii(a, b, c, d, x[i], 6, -198630844);
            d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
            c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
            a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
            d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
            c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
            a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
            d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
            b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
            a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
            d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
            b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
            a = safeAdd(a, olda);
            b = safeAdd(b, oldb);
            c = safeAdd(c, oldc);
            d = safeAdd(d, oldd);
        }
        return [
            a,
            b,
            c,
            d
        ];
    }
    /**
   * Convert an array of little-endian words to a string
   *
   * @param {Array<number>} input MD5 Array
   * @returns {string} MD5 string
   */ function binl2rstr(input) {
        var i;
        var output = '';
        var length32 = input.length * 32;
        for(i = 0; i < length32; i += 8)output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
        return output;
    }
    /**
   * Convert a raw string to an array of little-endian words
   * Characters >255 have their high-byte silently ignored.
   *
   * @param {string} input Raw input string
   * @returns {Array<number>} Array of little-endian words
   */ function rstr2binl(input) {
        var i;
        var output = [];
        output[(input.length >> 2) - 1] = undefined;
        for(i = 0; i < output.length; i += 1)output[i] = 0;
        var length8 = input.length * 8;
        for(i = 0; i < length8; i += 8)output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
        return output;
    }
    /**
   * Calculate the MD5 of a raw string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */ function rstrMD5(s) {
        return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
    }
    /**
   * Calculates the HMAC-MD5 of a key and some data (raw strings)
   *
   * @param {string} key HMAC key
   * @param {string} data Raw input string
   * @returns {string} Raw MD5 string
   */ function rstrHMACMD5(key, data) {
        var i;
        var bkey = rstr2binl(key);
        var ipad = [];
        var opad = [];
        var hash;
        ipad[15] = opad[15] = undefined;
        if (bkey.length > 16) bkey = binlMD5(bkey, key.length * 8);
        for(i = 0; i < 16; i += 1){
            ipad[i] = bkey[i] ^ 0x36363636;
            opad[i] = bkey[i] ^ 0x5c5c5c5c;
        }
        hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
        return binl2rstr(binlMD5(opad.concat(hash), 640));
    }
    /**
   * Convert a raw string to a hex string
   *
   * @param {string} input Raw input string
   * @returns {string} Hex encoded string
   */ function rstr2hex(input) {
        var hexTab = '0123456789abcdef';
        var output = '';
        var x;
        var i;
        for(i = 0; i < input.length; i += 1){
            x = input.charCodeAt(i);
            output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
        }
        return output;
    }
    /**
   * Encode a string as UTF-8
   *
   * @param {string} input Input string
   * @returns {string} UTF8 string
   */ function str2rstrUTF8(input) {
        return unescape(encodeURIComponent(input));
    }
    /**
   * Encodes input string as raw MD5 string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */ function rawMD5(s) {
        return rstrMD5(str2rstrUTF8(s));
    }
    /**
   * Encodes input string as Hex encoded string
   *
   * @param {string} s Input string
   * @returns {string} Hex encoded string
   */ function hexMD5(s) {
        return rstr2hex(rawMD5(s));
    }
    /**
   * Calculates the raw HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */ function rawHMACMD5(k, d) {
        return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
    }
    /**
   * Calculates the Hex encoded HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */ function hexHMACMD5(k, d) {
        return rstr2hex(rawHMACMD5(k, d));
    }
    /**
   * Calculates MD5 value for a given string.
   * If a key is provided, calculates the HMAC-MD5 value.
   * Returns a Hex encoded string unless the raw argument is given.
   *
   * @param {string} string Input string
   * @param {string} [key] HMAC key
   * @param {boolean} [raw] Raw output switch
   * @returns {string} MD5 output
   */ function md5(string, key, raw) {
        if (!key) {
            if (!raw) return hexMD5(string);
            return rawMD5(string);
        }
        if (!raw) return hexHMACMD5(key, string);
        return rawHMACMD5(key, string);
    }
    if (typeof define === 'function' && define.amd) define(function() {
        return md5;
    });
    else if ($1628340e44d9a835$exports) $1628340e44d9a835$exports = md5;
    else $.md5 = md5;
})($1628340e44d9a835$exports);


const $52309f5c74e590bd$export$31b40729666a4ae0 = ()=>(0, $b1f04e21bfe75146$export$2e2bcd8739ae039)();
const $52309f5c74e590bd$export$7b927fb32d8824c0 = ()=>"z9hG4bK-" + $52309f5c74e590bd$export$31b40729666a4ae0();
const $52309f5c74e590bd$var$generateResponse = (sipInfo, endpoint, nonce)=>{
    const ha1 = (0, (/*@__PURE__*/$parcel$interopDefault($1628340e44d9a835$exports)))(`${sipInfo.authorizationId}:${sipInfo.domain}:${sipInfo.password}`);
    const ha2 = (0, (/*@__PURE__*/$parcel$interopDefault($1628340e44d9a835$exports)))(endpoint);
    const response = (0, (/*@__PURE__*/$parcel$interopDefault($1628340e44d9a835$exports)))(`${ha1}:${nonce}:${ha2}`);
    return response;
};
const $52309f5c74e590bd$export$4111abda236aeb46 = (sipInfo, nonce, method)=>{
    const authObj = {
        "Digest algorithm": "MD5",
        username: sipInfo.authorizationId,
        realm: sipInfo.domain,
        nonce: nonce,
        uri: `sip:${sipInfo.domain}`,
        response: $52309f5c74e590bd$var$generateResponse(sipInfo, `${method}:sip:${sipInfo.domain}`, nonce)
    };
    return Object.keys(authObj).map((key)=>`${key}="${authObj[key]}"`).join(", ");
};
const $52309f5c74e590bd$export$ad9200c3e391715b = (s)=>s.replace(/;tag=.*$/, "");
const $52309f5c74e590bd$export$d429661f837c42a9 = (s)=>s.match(/<(sip:.+?)>/)[1];
const $52309f5c74e590bd$export$ee2b54e92bdbaa0c = (s)=>s.match(/<sip:(.+?)@/)[1];
const $52309f5c74e590bd$export$962a8da34cf78a4f = (peer)=>peer.match(/;tag=(.*)/)[1];
const $52309f5c74e590bd$export$48c97aba3132ee25 = $52309f5c74e590bd$export$31b40729666a4ae0() + ".invalid";
const $52309f5c74e590bd$export$f254005f6b69b424 = $52309f5c74e590bd$export$31b40729666a4ae0() + "@" + $52309f5c74e590bd$export$48c97aba3132ee25;


class $326843f02ccd2b80$var$SipMessage {
    static fromString(str) {
        const sipMessage = new $326843f02ccd2b80$var$SipMessage();
        const [init, ...body] = str.split("\r\n\r\n");
        sipMessage.body = body.join("\r\n\r\n");
        const [subject, ...headers] = init.split("\r\n");
        sipMessage.subject = subject;
        sipMessage.headers = Object.fromEntries(headers.map((line)=>line.split(": ")));
        if (sipMessage.headers.To && !sipMessage.headers.To.includes(";tag=")) sipMessage.headers.To += ";tag=" + (0, $52309f5c74e590bd$export$31b40729666a4ae0)(); // generate local tag
        return sipMessage;
    }
    subject;
    headers;
    body;
    direction;
    constructor(subject = "", headers = {}, body = ""){
        this.subject = subject;
        this.headers = headers;
        this.body = body.trim().split(/[\r\n]+/).join("\r\n");
        if (this.body.length > 0) this.body += "\r\n";
    }
    toString() {
        const r = [
            this.subject,
            ...Object.keys(this.headers).map((key)=>`${key}: ${this.headers[key]}`),
            "",
            this.body
        ].join("\r\n");
        return r;
    }
    get shortString() {
        return `${this.direction} - ${this.subject}`;
    }
}
var $326843f02ccd2b80$export$2e2bcd8739ae039 = $326843f02ccd2b80$var$SipMessage;


class $70fa36b6dfa01b44$var$OutboundMessage extends (0, $326843f02ccd2b80$export$2e2bcd8739ae039) {
    static fromString(str) {
        const sipMessage = (0, $326843f02ccd2b80$export$2e2bcd8739ae039).fromString(str);
        sipMessage.direction = "outbound";
        return sipMessage;
    }
    constructor(subject = "", headers = {}, body = ""){
        super(subject, headers, body);
        this.direction = "outbound";
        this.headers["Content-Length"] = this.body.length.toString();
        this.headers["User-Agent"] = "ringcentral-web-phone-2";
        this.headers["Max-Forwards"] = "70";
    }
}
var $70fa36b6dfa01b44$export$2e2bcd8739ae039 = $70fa36b6dfa01b44$var$OutboundMessage;


// Ref: https://en.wikipedia.org/wiki/List_of_SIP_response_codes'
const $79785f4785da38ae$var$responseCodes = {
    100: "Trying",
    180: "Ringing",
    181: "Call is Being Forwarded",
    182: "Queued",
    183: "Session Progress",
    199: "Early Dialog Terminated",
    200: "OK",
    202: "Accepted",
    204: "No Notification",
    300: "Multiple Choices",
    301: "Moved Permanently",
    302: "Moved Temporarily",
    305: "Use Proxy",
    380: "Alternative Service",
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Conditional Request Failed",
    413: "Request Entity Too Large",
    414: "Request-URI Too Long",
    415: "Unsupported Media Type",
    416: "Unsupported URI Scheme",
    417: "Unknown Resource-Priority",
    420: "Bad Extension",
    421: "Extension Required",
    422: "Session Interval Too Small",
    423: "Interval Too Brief",
    424: "Bad Location Information",
    425: "Bad Alert Message",
    428: "Use Identity Header",
    429: "Provide Referrer Identity",
    430: "Flow Failed",
    433: "Anonymity Disallowed",
    436: "Bad Identity-Info",
    437: "Unsupported Certificate",
    438: "Invalid Identity Header",
    439: "First Hop Lacks Outbound Support",
    440: "Max-Breadth Exceeded",
    469: "Bad Info Package",
    470: "Consent Needed",
    480: "Temporarily Unavailable",
    481: "Call/Transaction Does Not Exist",
    482: "Loop Detected",
    483: "Too Many Hops",
    484: "Address Incomplete",
    485: "Ambiguous",
    486: "Busy Here",
    487: "Request Terminated",
    488: "Not Acceptable Here",
    489: "Bad Event",
    491: "Request Pending",
    493: "Undecipherable",
    494: "Security Agreement Required",
    500: "Server Internal Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Server Time-out",
    505: "Version Not Supported",
    513: "Message Too Large",
    555: "Push Notification Service Not Supported",
    580: "Precondition Failure",
    600: "Busy Everywhere",
    603: "Decline",
    604: "Does Not Exist Anywhere",
    606: "Not Acceptable",
    607: "Unwanted",
    608: "Rejected"
};
var $79785f4785da38ae$export$2e2bcd8739ae039 = $79785f4785da38ae$var$responseCodes;


class $a452ed8adb11ed02$var$ResponseMessage extends (0, $70fa36b6dfa01b44$export$2e2bcd8739ae039) {
    constructor(inboundMessage, { responseCode: responseCode, headers: headers = {}, body: body = "" }){
        super(undefined, {
            ...headers
        }, body);
        this.subject = `SIP/2.0 ${responseCode} ${(0, $79785f4785da38ae$export$2e2bcd8739ae039)[responseCode]}`;
        const keys = [
            "Via",
            "From",
            "To",
            "Call-Id",
            "CSeq"
        ];
        for (const key of keys)if (inboundMessage.headers[key]) this.headers[key] = inboundMessage.headers[key];
    }
}
var $a452ed8adb11ed02$export$2e2bcd8739ae039 = $a452ed8adb11ed02$var$ResponseMessage;




let $e650efb9cb671aab$var$cseq = Math.floor(Math.random() * 10000);
class $e650efb9cb671aab$var$RequestMessage extends (0, $70fa36b6dfa01b44$export$2e2bcd8739ae039) {
    constructor(subject = "", headers = {}, body = ""){
        super(subject, headers, body);
        if (this.headers.CSeq === undefined) this.newCseq();
    }
    newCseq() {
        this.headers.CSeq = `${++$e650efb9cb671aab$var$cseq} ${this.subject.split(" ")[0]}`;
    }
    fork() {
        const newMessage = new $e650efb9cb671aab$var$RequestMessage(this.subject, {
            ...this.headers
        }, this.body);
        newMessage.newCseq();
        if (newMessage.headers.Via) newMessage.headers.Via = newMessage.headers.Via.replace(/;branch=.+?$/, `;branch=${(0, $52309f5c74e590bd$export$7b927fb32d8824c0)()}`);
        return newMessage;
    }
}
var $e650efb9cb671aab$export$2e2bcd8739ae039 = $e650efb9cb671aab$var$RequestMessage;



var $262790252e2ab8fe$exports = {};

$parcel$export($262790252e2ab8fe$exports, "grammar", () => $262790252e2ab8fe$export$b3a6900b22e4209, (v) => $262790252e2ab8fe$export$b3a6900b22e4209 = v);
$parcel$export($262790252e2ab8fe$exports, "write", () => $262790252e2ab8fe$export$68d8715fc104d294, (v) => $262790252e2ab8fe$export$68d8715fc104d294 = v);
$parcel$export($262790252e2ab8fe$exports, "parse", () => $262790252e2ab8fe$export$98e6a39c04603d36, (v) => $262790252e2ab8fe$export$98e6a39c04603d36 = v);
$parcel$export($262790252e2ab8fe$exports, "parseParams", () => $262790252e2ab8fe$export$ef804106d1571703, (v) => $262790252e2ab8fe$export$ef804106d1571703 = v);
$parcel$export($262790252e2ab8fe$exports, "parseFmtpConfig", () => $262790252e2ab8fe$export$dfeb1045bffe1ff8, (v) => $262790252e2ab8fe$export$dfeb1045bffe1ff8 = v);
$parcel$export($262790252e2ab8fe$exports, "parsePayloads", () => $262790252e2ab8fe$export$326874e595fb968b, (v) => $262790252e2ab8fe$export$326874e595fb968b = v);
$parcel$export($262790252e2ab8fe$exports, "parseRemoteCandidates", () => $262790252e2ab8fe$export$705b3971a35c200, (v) => $262790252e2ab8fe$export$705b3971a35c200 = v);
$parcel$export($262790252e2ab8fe$exports, "parseImageAttributes", () => $262790252e2ab8fe$export$1ca60456d3287987, (v) => $262790252e2ab8fe$export$1ca60456d3287987 = v);
$parcel$export($262790252e2ab8fe$exports, "parseSimulcastStreamList", () => $262790252e2ab8fe$export$c61d0126da4c310f, (v) => $262790252e2ab8fe$export$c61d0126da4c310f = v);
var $262790252e2ab8fe$export$b3a6900b22e4209;
var $262790252e2ab8fe$export$68d8715fc104d294;
var $262790252e2ab8fe$export$98e6a39c04603d36;
var $262790252e2ab8fe$export$ef804106d1571703;
var $262790252e2ab8fe$export$dfeb1045bffe1ff8;
var $262790252e2ab8fe$export$326874e595fb968b;
var $262790252e2ab8fe$export$705b3971a35c200;
var $262790252e2ab8fe$export$1ca60456d3287987;
var $262790252e2ab8fe$export$c61d0126da4c310f;
var $709b05ad7b0823d7$export$98e6a39c04603d36;
var $709b05ad7b0823d7$export$ef804106d1571703;
// For backward compatibility - alias will be removed in 3.0.0
var $709b05ad7b0823d7$export$dfeb1045bffe1ff8;
var $709b05ad7b0823d7$export$326874e595fb968b;
var $709b05ad7b0823d7$export$705b3971a35c200;
var $709b05ad7b0823d7$export$1ca60456d3287987;
var $709b05ad7b0823d7$export$c61d0126da4c310f;
var $709b05ad7b0823d7$var$toIntIfInt = function(v) {
    return String(Number(v)) === v ? Number(v) : v;
};
var $709b05ad7b0823d7$var$attachProperties = function(match, location, names, rawName) {
    if (rawName && !names) location[rawName] = $709b05ad7b0823d7$var$toIntIfInt(match[1]);
    else {
        for(var i = 0; i < names.length; i += 1)if (match[i + 1] != null) location[names[i]] = $709b05ad7b0823d7$var$toIntIfInt(match[i + 1]);
    }
};
var $709b05ad7b0823d7$var$parseReg = function(obj, location, content) {
    var needsBlank = obj.name && obj.names;
    if (obj.push && !location[obj.push]) location[obj.push] = [];
    else if (needsBlank && !location[obj.name]) location[obj.name] = {};
    var keyLocation = obj.push ? {} : needsBlank ? location[obj.name] : location; // otherwise, named location or root
    $709b05ad7b0823d7$var$attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);
    if (obj.push) location[obj.push].push(keyLocation);
};
var $fc251465b17b1ab1$exports = {};
var $fc251465b17b1ab1$var$grammar = $fc251465b17b1ab1$exports = {
    v: [
        {
            name: 'version',
            reg: /^(\d*)$/
        }
    ],
    o: [
        {
            // o=- 20518 0 IN IP4 203.0.113.1
            // NB: sessionId will be a String in most cases because it is huge
            name: 'origin',
            reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
            names: [
                'username',
                'sessionId',
                'sessionVersion',
                'netType',
                'ipVer',
                'address'
            ],
            format: '%s %s %d %s IP%d %s'
        }
    ],
    // default parsing of these only (though some of these feel outdated)
    s: [
        {
            name: 'name'
        }
    ],
    i: [
        {
            name: 'description'
        }
    ],
    u: [
        {
            name: 'uri'
        }
    ],
    e: [
        {
            name: 'email'
        }
    ],
    p: [
        {
            name: 'phone'
        }
    ],
    z: [
        {
            name: 'timezones'
        }
    ],
    r: [
        {
            name: 'repeats'
        }
    ],
    // k: [{}], // outdated thing ignored
    t: [
        {
            // t=0 0
            name: 'timing',
            reg: /^(\d*) (\d*)/,
            names: [
                'start',
                'stop'
            ],
            format: '%d %d'
        }
    ],
    c: [
        {
            // c=IN IP4 10.47.197.26
            name: 'connection',
            reg: /^IN IP(\d) (\S*)/,
            names: [
                'version',
                'ip'
            ],
            format: 'IN IP%d %s'
        }
    ],
    b: [
        {
            // b=AS:4000
            push: 'bandwidth',
            reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
            names: [
                'type',
                'limit'
            ],
            format: '%s:%s'
        }
    ],
    m: [
        {
            // m=video 51744 RTP/AVP 126 97 98 34 31
            // NB: special - pushes to session
            // TODO: rtp/fmtp should be filtered by the payloads found here?
            reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
            names: [
                'type',
                'port',
                'protocol',
                'payloads'
            ],
            format: '%s %d %s %s'
        }
    ],
    a: [
        {
            // a=rtpmap:110 opus/48000/2
            push: 'rtp',
            reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
            names: [
                'payload',
                'codec',
                'rate',
                'encoding'
            ],
            format: function(o) {
                return o.encoding ? 'rtpmap:%d %s/%s/%s' : o.rate ? 'rtpmap:%d %s/%s' : 'rtpmap:%d %s';
            }
        },
        {
            // a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
            // a=fmtp:111 minptime=10; useinbandfec=1
            push: 'fmtp',
            reg: /^fmtp:(\d*) ([\S| ]*)/,
            names: [
                'payload',
                'config'
            ],
            format: 'fmtp:%d %s'
        },
        {
            // a=control:streamid=0
            name: 'control',
            reg: /^control:(.*)/,
            format: 'control:%s'
        },
        {
            // a=rtcp:65179 IN IP4 193.84.77.194
            name: 'rtcp',
            reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
            names: [
                'port',
                'netType',
                'ipVer',
                'address'
            ],
            format: function(o) {
                return o.address != null ? 'rtcp:%d %s IP%d %s' : 'rtcp:%d';
            }
        },
        {
            // a=rtcp-fb:98 trr-int 100
            push: 'rtcpFbTrrInt',
            reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
            names: [
                'payload',
                'value'
            ],
            format: 'rtcp-fb:%s trr-int %d'
        },
        {
            // a=rtcp-fb:98 nack rpsi
            push: 'rtcpFb',
            reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
            names: [
                'payload',
                'type',
                'subtype'
            ],
            format: function(o) {
                return o.subtype != null ? 'rtcp-fb:%s %s %s' : 'rtcp-fb:%s %s';
            }
        },
        {
            // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
            // a=extmap:1/recvonly URI-gps-string
            // a=extmap:3 urn:ietf:params:rtp-hdrext:encrypt urn:ietf:params:rtp-hdrext:smpte-tc 25@600/24
            push: 'ext',
            reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
            names: [
                'value',
                'direction',
                'encrypt-uri',
                'uri',
                'config'
            ],
            format: function(o) {
                return 'extmap:%d' + (o.direction ? '/%s' : '%v') + (o['encrypt-uri'] ? ' %s' : '%v') + ' %s' + (o.config ? ' %s' : '');
            }
        },
        {
            // a=extmap-allow-mixed
            name: 'extmapAllowMixed',
            reg: /^(extmap-allow-mixed)/
        },
        {
            // a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
            push: 'crypto',
            reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
            names: [
                'id',
                'suite',
                'config',
                'sessionConfig'
            ],
            format: function(o) {
                return o.sessionConfig != null ? 'crypto:%d %s %s %s' : 'crypto:%d %s %s';
            }
        },
        {
            // a=setup:actpass
            name: 'setup',
            reg: /^setup:(\w*)/,
            format: 'setup:%s'
        },
        {
            // a=connection:new
            name: 'connectionType',
            reg: /^connection:(new|existing)/,
            format: 'connection:%s'
        },
        {
            // a=mid:1
            name: 'mid',
            reg: /^mid:([^\s]*)/,
            format: 'mid:%s'
        },
        {
            // a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
            name: 'msid',
            reg: /^msid:(.*)/,
            format: 'msid:%s'
        },
        {
            // a=ptime:20
            name: 'ptime',
            reg: /^ptime:(\d*(?:\.\d*)*)/,
            format: 'ptime:%d'
        },
        {
            // a=maxptime:60
            name: 'maxptime',
            reg: /^maxptime:(\d*(?:\.\d*)*)/,
            format: 'maxptime:%d'
        },
        {
            // a=sendrecv
            name: 'direction',
            reg: /^(sendrecv|recvonly|sendonly|inactive)/
        },
        {
            // a=ice-lite
            name: 'icelite',
            reg: /^(ice-lite)/
        },
        {
            // a=ice-ufrag:F7gI
            name: 'iceUfrag',
            reg: /^ice-ufrag:(\S*)/,
            format: 'ice-ufrag:%s'
        },
        {
            // a=ice-pwd:x9cml/YzichV2+XlhiMu8g
            name: 'icePwd',
            reg: /^ice-pwd:(\S*)/,
            format: 'ice-pwd:%s'
        },
        {
            // a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
            name: 'fingerprint',
            reg: /^fingerprint:(\S*) (\S*)/,
            names: [
                'type',
                'hash'
            ],
            format: 'fingerprint:%s %s'
        },
        {
            // a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
            // a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
            // a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
            // a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
            // a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
            push: 'candidates',
            reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
            names: [
                'foundation',
                'component',
                'transport',
                'priority',
                'ip',
                'port',
                'type',
                'raddr',
                'rport',
                'tcptype',
                'generation',
                'network-id',
                'network-cost'
            ],
            format: function(o) {
                var str = 'candidate:%s %d %s %d %s %d typ %s';
                str += o.raddr != null ? ' raddr %s rport %d' : '%v%v';
                // NB: candidate has three optional chunks, so %void middles one if it's missing
                str += o.tcptype != null ? ' tcptype %s' : '%v';
                if (o.generation != null) str += ' generation %d';
                str += o['network-id'] != null ? ' network-id %d' : '%v';
                str += o['network-cost'] != null ? ' network-cost %d' : '%v';
                return str;
            }
        },
        {
            // a=end-of-candidates (keep after the candidates line for readability)
            name: 'endOfCandidates',
            reg: /^(end-of-candidates)/
        },
        {
            // a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
            name: 'remoteCandidates',
            reg: /^remote-candidates:(.*)/,
            format: 'remote-candidates:%s'
        },
        {
            // a=ice-options:google-ice
            name: 'iceOptions',
            reg: /^ice-options:(\S*)/,
            format: 'ice-options:%s'
        },
        {
            // a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
            push: 'ssrcs',
            reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
            names: [
                'id',
                'attribute',
                'value'
            ],
            format: function(o) {
                var str = 'ssrc:%d';
                if (o.attribute != null) {
                    str += ' %s';
                    if (o.value != null) str += ':%s';
                }
                return str;
            }
        },
        {
            // a=ssrc-group:FEC 1 2
            // a=ssrc-group:FEC-FR 3004364195 1080772241
            push: 'ssrcGroups',
            // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
            reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
            names: [
                'semantics',
                'ssrcs'
            ],
            format: 'ssrc-group:%s %s'
        },
        {
            // a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
            name: 'msidSemantic',
            reg: /^msid-semantic:\s?(\w*) (\S*)/,
            names: [
                'semantic',
                'token'
            ],
            format: 'msid-semantic: %s %s' // space after ':' is not accidental
        },
        {
            // a=group:BUNDLE audio video
            push: 'groups',
            reg: /^group:(\w*) (.*)/,
            names: [
                'type',
                'mids'
            ],
            format: 'group:%s %s'
        },
        {
            // a=rtcp-mux
            name: 'rtcpMux',
            reg: /^(rtcp-mux)/
        },
        {
            // a=rtcp-rsize
            name: 'rtcpRsize',
            reg: /^(rtcp-rsize)/
        },
        {
            // a=sctpmap:5000 webrtc-datachannel 1024
            name: 'sctpmap',
            reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
            names: [
                'sctpmapNumber',
                'app',
                'maxMessageSize'
            ],
            format: function(o) {
                return o.maxMessageSize != null ? 'sctpmap:%s %s %s' : 'sctpmap:%s %s';
            }
        },
        {
            // a=x-google-flag:conference
            name: 'xGoogleFlag',
            reg: /^x-google-flag:([^\s]*)/,
            format: 'x-google-flag:%s'
        },
        {
            // a=rid:1 send max-width=1280;max-height=720;max-fps=30;depend=0
            push: 'rids',
            reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
            names: [
                'id',
                'direction',
                'params'
            ],
            format: function(o) {
                return o.params ? 'rid:%s %s %s' : 'rid:%s %s';
            }
        },
        {
            // a=imageattr:97 send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320] recv [x=330,y=250]
            // a=imageattr:* send [x=800,y=640] recv *
            // a=imageattr:100 recv [x=320,y=240]
            push: 'imageattrs',
            reg: new RegExp(// a=imageattr:97
            "^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),
            names: [
                'pt',
                'dir1',
                'attrs1',
                'dir2',
                'attrs2'
            ],
            format: function(o) {
                return 'imageattr:%s %s %s' + (o.dir2 ? ' %s %s' : '');
            }
        },
        {
            // a=simulcast:send 1,2,3;~4,~5 recv 6;~7,~8
            // a=simulcast:recv 1;4,5 send 6;7
            name: 'simulcast',
            reg: new RegExp(// a=simulcast:
            "^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),
            names: [
                'dir1',
                'list1',
                'dir2',
                'list2'
            ],
            format: function(o) {
                return 'simulcast:%s %s' + (o.dir2 ? ' %s %s' : '');
            }
        },
        {
            // old simulcast draft 03 (implemented by Firefox)
            //   https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
            // a=simulcast: recv pt=97;98 send pt=97
            // a=simulcast: send rid=5;6;7 paused=6,7
            name: 'simulcast_03',
            reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
            names: [
                'value'
            ],
            format: 'simulcast: %s'
        },
        {
            // a=framerate:25
            // a=framerate:29.97
            name: 'framerate',
            reg: /^framerate:(\d+(?:$|\.\d+))/,
            format: 'framerate:%s'
        },
        {
            // RFC4570
            // a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
            name: 'sourceFilter',
            reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
            names: [
                'filterMode',
                'netType',
                'addressTypes',
                'destAddress',
                'srcList'
            ],
            format: 'source-filter: %s %s %s %s %s'
        },
        {
            // a=bundle-only
            name: 'bundleOnly',
            reg: /^(bundle-only)/
        },
        {
            // a=label:1
            name: 'label',
            reg: /^label:(.+)/,
            format: 'label:%s'
        },
        {
            // RFC version 26 for SCTP over DTLS
            // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-5
            name: 'sctpPort',
            reg: /^sctp-port:(\d+)$/,
            format: 'sctp-port:%s'
        },
        {
            // RFC version 26 for SCTP over DTLS
            // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-6
            name: 'maxMessageSize',
            reg: /^max-message-size:(\d+)$/,
            format: 'max-message-size:%s'
        },
        {
            // RFC7273
            // a=ts-refclk:ptp=IEEE1588-2008:39-A7-94-FF-FE-07-CB-D0:37
            push: 'tsRefClocks',
            reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
            names: [
                'clksrc',
                'clksrcExt'
            ],
            format: function(o) {
                return 'ts-refclk:%s' + (o.clksrcExt != null ? '=%s' : '');
            }
        },
        {
            // RFC7273
            // a=mediaclk:direct=963214424
            name: 'mediaClk',
            reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
            names: [
                'id',
                'mediaClockName',
                'mediaClockValue',
                'rateNumerator',
                'rateDenominator'
            ],
            format: function(o) {
                var str = 'mediaclk:';
                str += o.id != null ? 'id=%s %s' : '%v%s';
                str += o.mediaClockValue != null ? '=%s' : '';
                str += o.rateNumerator != null ? ' rate=%s' : '';
                str += o.rateDenominator != null ? '/%s' : '';
                return str;
            }
        },
        {
            // a=keywds:keywords
            name: 'keywords',
            reg: /^keywds:(.+)$/,
            format: 'keywds:%s'
        },
        {
            // a=content:main
            name: 'content',
            reg: /^content:(.+)/,
            format: 'content:%s'
        },
        // BFCP https://tools.ietf.org/html/rfc4583
        {
            // a=floorctrl:c-s
            name: 'bfcpFloorCtrl',
            reg: /^floorctrl:(c-only|s-only|c-s)/,
            format: 'floorctrl:%s'
        },
        {
            // a=confid:1
            name: 'bfcpConfId',
            reg: /^confid:(\d+)/,
            format: 'confid:%s'
        },
        {
            // a=userid:1
            name: 'bfcpUserId',
            reg: /^userid:(\d+)/,
            format: 'userid:%s'
        },
        {
            // a=floorid:1
            name: 'bfcpFloorId',
            reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
            names: [
                'id',
                'mStream'
            ],
            format: 'floorid:%s mstrm:%s'
        },
        {
            // any a= that we don't understand is kept verbatim on media.invalid
            push: 'invalid',
            names: [
                'value'
            ]
        }
    ]
};
// set sensible defaults to avoid polluting the grammar with boring details
Object.keys($fc251465b17b1ab1$var$grammar).forEach(function(key) {
    var objs = $fc251465b17b1ab1$var$grammar[key];
    objs.forEach(function(obj) {
        if (!obj.reg) obj.reg = /(.*)/;
        if (!obj.format) obj.format = '%s';
    });
});


var $709b05ad7b0823d7$var$validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
$709b05ad7b0823d7$export$98e6a39c04603d36 = function(sdp) {
    var session = {}, media = [], location = session; // points at where properties go under (one of the above)
    // parse lines we understand
    sdp.split(/(\r\n|\r|\n)/).filter($709b05ad7b0823d7$var$validLine).forEach(function(l) {
        var type = l[0];
        var content = l.slice(2);
        if (type === 'm') {
            media.push({
                rtp: [],
                fmtp: []
            });
            location = media[media.length - 1]; // point at latest media line
        }
        for(var j = 0; j < ($fc251465b17b1ab1$exports[type] || []).length; j += 1){
            var obj = $fc251465b17b1ab1$exports[type][j];
            if (obj.reg.test(content)) return $709b05ad7b0823d7$var$parseReg(obj, location, content);
        }
    });
    session.media = media; // link it up
    return session;
};
var $709b05ad7b0823d7$var$paramReducer = function(acc, expr) {
    var s = expr.split(/=(.+)/, 2);
    if (s.length === 2) acc[s[0]] = $709b05ad7b0823d7$var$toIntIfInt(s[1]);
    else if (s.length === 1 && expr.length > 1) acc[s[0]] = undefined;
    return acc;
};
$709b05ad7b0823d7$export$ef804106d1571703 = function(str) {
    return str.split(/;\s?/).reduce($709b05ad7b0823d7$var$paramReducer, {});
};
$709b05ad7b0823d7$export$dfeb1045bffe1ff8 = $709b05ad7b0823d7$export$ef804106d1571703;
$709b05ad7b0823d7$export$326874e595fb968b = function(str) {
    return str.toString().split(' ').map(Number);
};
$709b05ad7b0823d7$export$705b3971a35c200 = function(str) {
    var candidates = [];
    var parts = str.split(' ').map($709b05ad7b0823d7$var$toIntIfInt);
    for(var i = 0; i < parts.length; i += 3)candidates.push({
        component: parts[i],
        ip: parts[i + 1],
        port: parts[i + 2]
    });
    return candidates;
};
$709b05ad7b0823d7$export$1ca60456d3287987 = function(str) {
    return str.split(' ').map(function(item) {
        return item.substring(1, item.length - 1).split(',').reduce($709b05ad7b0823d7$var$paramReducer, {});
    });
};
$709b05ad7b0823d7$export$c61d0126da4c310f = function(str) {
    return str.split(';').map(function(stream) {
        return stream.split(',').map(function(format) {
            var scid, paused = false;
            if (format[0] !== '~') scid = $709b05ad7b0823d7$var$toIntIfInt(format);
            else {
                scid = $709b05ad7b0823d7$var$toIntIfInt(format.substring(1, format.length));
                paused = true;
            }
            return {
                scid: scid,
                paused: paused
            };
        });
    });
};


var $153693c6cd13dc1f$exports = {};

// customized util.format - discards excess arguments and can void middle ones
var $153693c6cd13dc1f$var$formatRegExp = /%[sdv%]/g;
var $153693c6cd13dc1f$var$format = function(formatStr) {
    var i = 1;
    var args = arguments;
    var len = args.length;
    return formatStr.replace($153693c6cd13dc1f$var$formatRegExp, function(x) {
        if (i >= len) return x; // missing argument
        var arg = args[i];
        i += 1;
        switch(x){
            case '%%':
                return '%';
            case '%s':
                return String(arg);
            case '%d':
                return Number(arg);
            case '%v':
                return '';
        }
    });
// NB: we discard excess arguments - they are typically undefined from makeLine
};
var $153693c6cd13dc1f$var$makeLine = function(type, obj, location) {
    var str = obj.format instanceof Function ? obj.format(obj.push ? location : location[obj.name]) : obj.format;
    var args = [
        type + '=' + str
    ];
    if (obj.names) for(var i = 0; i < obj.names.length; i += 1){
        var n = obj.names[i];
        if (obj.name) args.push(location[obj.name][n]);
        else args.push(location[obj.names[i]]);
    }
    else args.push(location[obj.name]);
    return $153693c6cd13dc1f$var$format.apply(null, args);
};
// RFC specified order
// TODO: extend this with all the rest
var $153693c6cd13dc1f$var$defaultOuterOrder = [
    'v',
    'o',
    's',
    'i',
    'u',
    'e',
    'p',
    'c',
    'b',
    't',
    'r',
    'z',
    'a'
];
var $153693c6cd13dc1f$var$defaultInnerOrder = [
    'i',
    'c',
    'b',
    'a'
];
$153693c6cd13dc1f$exports = function(session, opts) {
    opts = opts || {};
    // ensure certain properties exist
    if (session.version == null) session.version = 0; // 'v=0' must be there (only defined version atm)
    if (session.name == null) session.name = ' '; // 's= ' must be there if no meaningful name set
    session.media.forEach(function(mLine) {
        if (mLine.payloads == null) mLine.payloads = '';
    });
    var outerOrder = opts.outerOrder || $153693c6cd13dc1f$var$defaultOuterOrder;
    var innerOrder = opts.innerOrder || $153693c6cd13dc1f$var$defaultInnerOrder;
    var sdp = [];
    // loop through outerOrder for matching properties on session
    outerOrder.forEach(function(type) {
        $fc251465b17b1ab1$exports[type].forEach(function(obj) {
            if (obj.name in session && session[obj.name] != null) sdp.push($153693c6cd13dc1f$var$makeLine(type, obj, session));
            else if (obj.push in session && session[obj.push] != null) session[obj.push].forEach(function(el) {
                sdp.push($153693c6cd13dc1f$var$makeLine(type, obj, el));
            });
        });
    });
    // then for each media line, follow the innerOrder
    session.media.forEach(function(mLine) {
        sdp.push($153693c6cd13dc1f$var$makeLine('m', $fc251465b17b1ab1$exports.m[0], mLine));
        innerOrder.forEach(function(type) {
            $fc251465b17b1ab1$exports[type].forEach(function(obj) {
                if (obj.name in mLine && mLine[obj.name] != null) sdp.push($153693c6cd13dc1f$var$makeLine(type, obj, mLine));
                else if (obj.push in mLine && mLine[obj.push] != null) mLine[obj.push].forEach(function(el) {
                    sdp.push($153693c6cd13dc1f$var$makeLine(type, obj, el));
                });
            });
        });
    });
    return sdp.join('\r\n') + '\r\n';
};



$262790252e2ab8fe$export$b3a6900b22e4209 = $fc251465b17b1ab1$exports;
$262790252e2ab8fe$export$68d8715fc104d294 = $153693c6cd13dc1f$exports;
$262790252e2ab8fe$export$98e6a39c04603d36 = $709b05ad7b0823d7$export$98e6a39c04603d36;
$262790252e2ab8fe$export$ef804106d1571703 = $709b05ad7b0823d7$export$ef804106d1571703;
$262790252e2ab8fe$export$dfeb1045bffe1ff8 = $709b05ad7b0823d7$export$dfeb1045bffe1ff8; // Alias of parseParams().
$262790252e2ab8fe$export$326874e595fb968b = $709b05ad7b0823d7$export$326874e595fb968b;
$262790252e2ab8fe$export$705b3971a35c200 = $709b05ad7b0823d7$export$705b3971a35c200;
$262790252e2ab8fe$export$1ca60456d3287987 = $709b05ad7b0823d7$export$1ca60456d3287987;
$262790252e2ab8fe$export$c61d0126da4c310f = $709b05ad7b0823d7$export$c61d0126da4c310f;


class $565780c60ea1e116$var$EventEmitter {
    // deno-lint-ignore no-explicit-any
    listeners = new Map();
    // This is used to store temporary listeners that are only called once
    // deno-lint-ignore no-explicit-any
    tempListeners = new Map();
    // deno-lint-ignore no-explicit-any
    on(eventName, listener) {
        if (!this.listeners.has(eventName)) this.listeners.set(eventName, []);
        this.listeners.get(eventName).push(listener);
    }
    // deno-lint-ignore no-explicit-any
    once(eventName, listener) {
        if (!this.tempListeners.has(eventName)) this.tempListeners.set(eventName, []);
        this.tempListeners.get(eventName).push(listener);
    }
    // deno-lint-ignore no-explicit-any
    off(eventName, listener) {
        let list = this.listeners.get(eventName);
        if (list) this.listeners.set(eventName, list.filter((l)=>l !== listener));
        list = this.tempListeners.get(eventName);
        if (list) this.tempListeners.set(eventName, list.filter((l)=>l !== listener));
    }
    // deno-lint-ignore no-explicit-any
    emit(eventName, ...args) {
        (this.listeners.get(eventName) ?? []).forEach((listener)=>listener(...args));
        (this.tempListeners.get(eventName) ?? []).forEach((listener)=>listener(...args));
        this.tempListeners.delete(eventName);
    }
    removeAllListeners() {
        this.listeners.clear();
        this.tempListeners.clear();
    }
}
var $565780c60ea1e116$export$2e2bcd8739ae039 = $565780c60ea1e116$var$EventEmitter;





class $16bf732a0ad5f687$var$CallSession extends (0, $565780c60ea1e116$export$2e2bcd8739ae039) {
    webPhone;
    sipMessage;
    localPeer;
    remotePeer;
    rtcPeerConnection;
    mediaStream;
    audioElement;
    state = "init";
    direction;
    inputDeviceId;
    outputDeviceId;
    reqid = 1;
    sdpVersion = 1;
    constructor(webPhone){
        super();
        this.webPhone = webPhone;
    }
    // for inbound call, this.sipMessage?.headers["Call-Id"] will be the call id
    // for outbound call, this._callId will be the call id. Once the call session is out of "init" state, this.sipMessage will be set
    _callId = (0, $52309f5c74e590bd$export$31b40729666a4ae0)();
    get callId() {
        return this.sipMessage?.headers["Call-Id"] ?? this._callId;
    }
    get sessionId() {
        return this.sipMessage?.headers["p-rc-api-ids"].match(/session-id=(s-[0-9a-fz]+?)$/)?.[1];
    }
    get partyId() {
        return this.sipMessage?.headers["p-rc-api-ids"].match(/party-id=(p-[0-9a-fz]+?-\d);/)?.[1];
    }
    get remoteNumber() {
        return (0, $52309f5c74e590bd$export$ee2b54e92bdbaa0c)(this.remotePeer);
    }
    get localNumber() {
        return this.localPeer ? (0, $52309f5c74e590bd$export$ee2b54e92bdbaa0c)(this.localPeer) : this.webPhone.sipInfo.username;
    }
    get remoteTag() {
        return (0, $52309f5c74e590bd$export$962a8da34cf78a4f)(this.remotePeer);
    }
    get localTag() {
        return (0, $52309f5c74e590bd$export$962a8da34cf78a4f)(this.localPeer);
    }
    get isConference() {
        return this.remotePeer ? (0, $52309f5c74e590bd$export$ee2b54e92bdbaa0c)(this.remotePeer).startsWith("conf_") : false;
    }
    async init() {
        this.rtcPeerConnection = new RTCPeerConnection({
            iceServers: this.webPhone.sipInfo.stunServers?.map((url)=>({
                    urls: `stun:${url}`
                })) ?? []
        });
        // line below is to make sure that you have the permission to access the microphone
        const tempStream = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false
        });
        tempStream.getTracks().forEach((track)=>track.stop()); // 🔥 Stop immediately!
        this.inputDeviceId = await this.webPhone.deviceManager.getInputDeviceId();
        this.mediaStream = await navigator.mediaDevices.getUserMedia({
            video: false,
            audio: {
                deviceId: {
                    exact: this.inputDeviceId
                }
            }
        });
        this.mediaStream.getAudioTracks().forEach((track)=>{
            const rtcRtpSender = this.rtcPeerConnection.addTrack(track);
            // ref: https://github.com/ringcentral/ringcentral-web-phone/issues/257
            const params = rtcRtpSender.getParameters();
            if (!params.encodings || params.encodings.length === 0) params.encodings = [
                {}
            ];
            params.encodings.forEach((encoding)=>{
                encoding.priority = "high";
            });
            rtcRtpSender.setParameters(params);
        });
        this.rtcPeerConnection.ontrack = async (event)=>{
            const remoteStream = event.streams[0];
            this.audioElement = document.createElement("audio");
            this.audioElement.hidden = true;
            this.audioElement.autoplay = true;
            this.audioElement.srcObject = remoteStream;
            // this code should be run last
            this.outputDeviceId = await this.webPhone.deviceManager.getOutputDeviceId();
            if (this.outputDeviceId) this.audioElement.setSinkId(this.outputDeviceId);
        };
    }
    async changeInputDevice(deviceId) {
        this.inputDeviceId = deviceId;
        this.mediaStream?.getAudioTracks().forEach((track)=>track.stop());
        this.mediaStream = await navigator.mediaDevices.getUserMedia({
            video: false,
            audio: {
                deviceId: {
                    exact: deviceId
                }
            }
        });
        const newAudioTrack = this.mediaStream.getAudioTracks()[0];
        const sender = this.rtcPeerConnection.getSenders().find((sender)=>sender.track?.kind === "audio");
        if (sender) sender.replaceTrack(newAudioTrack);
    }
    async changeOutputDevice(deviceId) {
        this.outputDeviceId = deviceId;
        if (deviceId) await this.audioElement.setSinkId(deviceId);
    }
    async transfer(target) {
        return await this._transfer(`sip:${target}@sip.ringcentral.com`);
    }
    async warmTransfer(target) {
        await this.hold();
        // create a new session and user needs to talk to the target before transfer
        const newSession = await this.webPhone.call(target);
        return {
            // complete the transfer
            complete: async ()=>{
                await this.completeWarmTransfer(newSession);
            },
            // cancel the transfer
            cancel: async ()=>{
                await newSession.hangup();
                await this.unhold();
            },
            newSession: newSession
        };
    }
    async completeWarmTransfer(existingSession) {
        const target = existingSession.remoteNumber;
        await this._transfer(`"${target}@sip.ringcentral.com" <sip:${target}@sip.ringcentral.com;transport=wss?Replaces=${existingSession.callId}%3Bto-tag%3D${existingSession.remoteTag}%3Bfrom-tag%3D${existingSession.localTag}>`);
    }
    async hangup() {
        const requestMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`BYE sip:${this.webPhone.sipInfo.domain} SIP/2.0`, {
            "Call-Id": this.callId,
            From: this.localPeer,
            To: this.remotePeer,
            Via: `SIP/2.0/WSS ${(0, $52309f5c74e590bd$export$48c97aba3132ee25)};branch=${(0, $52309f5c74e590bd$export$7b927fb32d8824c0)()}`
        });
        await this.webPhone.sipClient.request(requestMessage);
    }
    async startRecording() {
        return await this.sendJsonMessage("startcallrecord");
    }
    async stopRecording() {
        return await this.sendJsonMessage("stopcallrecord");
    }
    async flip(target) {
        const flipResult = await this.sendJsonMessage("callflip", {
            target: target
        });
        // note: we can't dispose the call session here
        // otherwise the caller will not be able to talk to the flip target
        // after the flip target answers the call, manually dispose the call session
        return flipResult;
    }
    async park() {
        const parkResult = await this.sendJsonMessage("callpark");
        if (parkResult.code === 0) await this.hangup();
        return parkResult;
    }
    async hold() {
        await this.toggleReceive(false);
    }
    async unhold() {
        await this.toggleReceive(true);
    }
    mute() {
        this.toggleTrack(false);
    }
    unmute() {
        this.toggleTrack(true);
    }
    sendDtmf(tones, duration, interToneGap) {
        for (const sender of this.rtcPeerConnection.getSenders())if (sender.dtmf?.canInsertDTMF) sender.dtmf?.insertDTMF(tones, duration, interToneGap);
    }
    dispose() {
        this.rtcPeerConnection?.close();
        this.mediaStream?.getTracks().forEach((track)=>track.stop());
        if (this.audioElement) this.audioElement.srcObject = null;
        this.state = "disposed";
        this.emit("disposed");
        this.removeAllListeners();
    }
    // for mute/unmute
    toggleTrack(enabled) {
        this.rtcPeerConnection.getSenders().forEach((sender)=>{
            if (sender.track) sender.track.enabled = enabled;
        });
    }
    // send re-INVITE.
    // If the call is on hold and you don't want to unhold it, set toReceive to false
    async reInvite(toReceive = true) {
        const offer = await this.rtcPeerConnection.createOffer({
            iceRestart: true
        });
        await this.rtcPeerConnection.setLocalDescription(offer);
        // wait for ICE gathering to complete
        await new Promise((resolve)=>{
            this.rtcPeerConnection.onicecandidate = (event)=>{
                if (event.candidate === null) resolve(true);
            };
            setTimeout(()=>resolve(false), 2000);
        });
        let sdp = this.rtcPeerConnection.localDescription.sdp;
        // default value is `a=sendrecv`
        if (!toReceive) sdp = sdp.replace(/a=sendrecv/g, "a=sendonly");
        const requestMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`INVITE ${(0, $52309f5c74e590bd$export$d429661f837c42a9)(this.remotePeer)} SIP/2.0`, {
            "Call-Id": this.callId,
            From: this.localPeer,
            To: this.remotePeer,
            Via: `SIP/2.0/WSS ${(0, $52309f5c74e590bd$export$48c97aba3132ee25)};branch=${(0, $52309f5c74e590bd$export$7b927fb32d8824c0)()}`,
            "Content-Type": "application/sdp"
        }, sdp);
        const replyMessage = await this.webPhone.sipClient.request(requestMessage);
        await this.rtcPeerConnection.setRemoteDescription({
            type: "answer",
            sdp: replyMessage.body
        });
        const ackMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`ACK ${(0, $52309f5c74e590bd$export$d429661f837c42a9)(this.remotePeer)} SIP/2.0`, {
            "Call-Id": this.callId,
            From: this.localPeer,
            To: this.remotePeer,
            Via: replyMessage.headers.Via,
            CSeq: replyMessage.headers.CSeq.replace(" INVITE", " ACK")
        });
        await this.webPhone.sipClient.reply(ackMessage);
    }
    // handle re-INVITE from SIP server
    async handleReInvite(reInviteMessage) {
        this.sipMessage = reInviteMessage;
        await this.rtcPeerConnection.setRemoteDescription({
            type: "offer",
            sdp: reInviteMessage.body
        });
        const answer = await this.rtcPeerConnection.createAnswer();
        await this.rtcPeerConnection.setLocalDescription(answer);
        // wait for ICE gathering to complete
        await new Promise((resolve)=>{
            this.rtcPeerConnection.onicecandidate = (event)=>{
                if (event.candidate === null) resolve(true);
            };
            setTimeout(()=>resolve(false), 2000);
        });
        const newMessage = new (0, $a452ed8adb11ed02$export$2e2bcd8739ae039)(this.sipMessage, {
            responseCode: 200,
            headers: {
                "Content-Type": "application/sdp"
            },
            body: this.rtcPeerConnection.localDescription.sdp
        });
        await this.webPhone.sipClient.reply(newMessage);
    // note: no need to wait for the final SIP message (refer to inbound call answer function)
    // because nobody is supposed to proactively invoke this function.
    }
    // for hold/unhold
    // toggle between a=sendrecv and a=sendonly
    async toggleReceive(toReceive) {
        if (!this.rtcPeerConnection?.localDescription) return;
        let sdp = this.rtcPeerConnection.localDescription.sdp;
        // default value is `a=sendrecv`
        if (!toReceive) sdp = sdp.replace(/a=sendrecv/g, "a=sendonly");
        // increase the sdp version
        const res = (0, (/*@__PURE__*/$parcel$interopDefault($262790252e2ab8fe$exports))).parse(sdp);
        this.sdpVersion = Math.max(this.sdpVersion, res.origin.sessionVersion + 1);
        res.origin.sessionVersion = this.sdpVersion++;
        sdp = (0, (/*@__PURE__*/$parcel$interopDefault($262790252e2ab8fe$exports))).write(res);
        const requestMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`INVITE ${(0, $52309f5c74e590bd$export$d429661f837c42a9)(this.remotePeer)} SIP/2.0`, {
            "Call-Id": this.callId,
            From: this.localPeer,
            To: this.remotePeer,
            Via: `SIP/2.0/WSS ${(0, $52309f5c74e590bd$export$48c97aba3132ee25)};branch=${(0, $52309f5c74e590bd$export$7b927fb32d8824c0)()}`,
            "Content-Type": "application/sdp"
        }, sdp);
        const replyMessage = await this.webPhone.sipClient.request(requestMessage);
        const ackMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`ACK ${(0, $52309f5c74e590bd$export$d429661f837c42a9)(this.remotePeer)} SIP/2.0`, {
            "Call-Id": this.callId,
            From: this.localPeer,
            To: this.remotePeer,
            Via: replyMessage.headers.Via,
            CSeq: replyMessage.headers.CSeq.replace(" INVITE", " ACK")
        });
        await this.webPhone.sipClient.reply(ackMessage);
    }
    async sendJsonMessage(command, args = {}) {
        const reqid = this.reqid++;
        const jsonBody = JSON.stringify({
            request: {
                reqid: reqid,
                command: command,
                ...args
            }
        });
        const requestMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`INFO sip:${this.webPhone.sipInfo.domain} SIP/2.0`, {
            "Call-Id": this.callId,
            From: this.localPeer,
            To: this.remotePeer,
            Via: `SIP/2.0/WSS ${(0, $52309f5c74e590bd$export$48c97aba3132ee25)};branch=${(0, $52309f5c74e590bd$export$7b927fb32d8824c0)()}`,
            "Content-Type": "application/json;charset=utf-8"
        }, jsonBody);
        await this.webPhone.sipClient.request(requestMessage);
        return new Promise((resolve)=>{
            const resultHandler = (inboundMessage)=>{
                if (!inboundMessage.subject.startsWith("INFO sip:")) return;
                const response = JSON.parse(inboundMessage.body).response;
                if (!response || response.reqid !== reqid || response.command !== command) return;
                this.webPhone.sipClient.off("inboundMessage", resultHandler);
                resolve(response.result);
            };
            this.webPhone.sipClient.on("inboundMessage", resultHandler);
        });
    }
    async _transfer(uri) {
        const requestMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`REFER ${(0, $52309f5c74e590bd$export$d429661f837c42a9)(this.remotePeer)} SIP/2.0`, {
            "Call-Id": this.callId,
            From: this.localPeer,
            To: this.remotePeer,
            Via: `SIP/2.0/WSS ${(0, $52309f5c74e590bd$export$48c97aba3132ee25)};branch=${(0, $52309f5c74e590bd$export$7b927fb32d8824c0)()}`,
            "Refer-To": uri,
            "Referred-By": `<${(0, $52309f5c74e590bd$export$d429661f837c42a9)(this.localPeer)}>`
        });
        await this.webPhone.sipClient.request(requestMessage);
        // wait for the final SIP message
        return new Promise((resolve)=>{
            const handler = (inboundMessage)=>{
                if (inboundMessage.subject.startsWith("BYE sip:") && inboundMessage.headers["Call-Id"] === this.callId) {
                    this.webPhone.sipClient.off("inboundMessage", handler);
                    resolve();
                }
            };
            this.webPhone.sipClient.on("inboundMessage", handler);
        });
    }
}
var $16bf732a0ad5f687$export$2e2bcd8739ae039 = $16bf732a0ad5f687$var$CallSession;



const $d6017206f3cf5ac4$var$EOL = "\n";
function $d6017206f3cf5ac4$export$2e2bcd8739ae039(jArray, options) {
    let indentation = "";
    if (options.format && options.indentBy.length > 0) indentation = $d6017206f3cf5ac4$var$EOL;
    return $d6017206f3cf5ac4$var$arrToStr(jArray, options, "", indentation);
}
function $d6017206f3cf5ac4$var$arrToStr(arr, options, jPath, indentation) {
    let xmlStr = "";
    let isPreviousElementTag = false;
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const tagName = $d6017206f3cf5ac4$var$propName(tagObj);
        if (tagName === undefined) continue;
        let newJPath = "";
        if (jPath.length === 0) newJPath = tagName;
        else newJPath = `${jPath}.${tagName}`;
        if (tagName === options.textNodeName) {
            let tagText = tagObj[tagName];
            if (!$d6017206f3cf5ac4$var$isStopNode(newJPath, options)) {
                tagText = options.tagValueProcessor(tagName, tagText);
                tagText = $d6017206f3cf5ac4$var$replaceEntitiesValue(tagText, options);
            }
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += tagText;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.cdataPropName) {
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += `<![CDATA[${tagObj[tagName][0][options.textNodeName]}]]>`;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.commentPropName) {
            xmlStr += indentation + `<!--${tagObj[tagName][0][options.textNodeName]}-->`;
            isPreviousElementTag = true;
            continue;
        } else if (tagName[0] === "?") {
            const attStr = $d6017206f3cf5ac4$var$attr_to_str(tagObj[":@"], options);
            const tempInd = tagName === "?xml" ? "" : indentation;
            let piTextNodeName = tagObj[tagName][0][options.textNodeName];
            piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing
            xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr}?>`;
            isPreviousElementTag = true;
            continue;
        }
        let newIdentation = indentation;
        if (newIdentation !== "") newIdentation += options.indentBy;
        const attStr = $d6017206f3cf5ac4$var$attr_to_str(tagObj[":@"], options);
        const tagStart = indentation + `<${tagName}${attStr}`;
        const tagValue = $d6017206f3cf5ac4$var$arrToStr(tagObj[tagName], options, newJPath, newIdentation);
        if (options.unpairedTags.indexOf(tagName) !== -1) {
            if (options.suppressUnpairedNode) xmlStr += tagStart + ">";
            else xmlStr += tagStart + "/>";
        } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) xmlStr += tagStart + "/>";
        else if (tagValue && tagValue.endsWith(">")) xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>`;
        else {
            xmlStr += tagStart + ">";
            if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) xmlStr += indentation + options.indentBy + tagValue + indentation;
            else xmlStr += tagValue;
            xmlStr += `</${tagName}>`;
        }
        isPreviousElementTag = true;
    }
    return xmlStr;
}
function $d6017206f3cf5ac4$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (!obj.hasOwnProperty(key)) continue;
        if (key !== ":@") return key;
    }
}
function $d6017206f3cf5ac4$var$attr_to_str(attrMap, options) {
    let attrStr = "";
    if (attrMap && !options.ignoreAttributes) for(let attr in attrMap){
        if (!attrMap.hasOwnProperty(attr)) continue;
        let attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
        attrVal = $d6017206f3cf5ac4$var$replaceEntitiesValue(attrVal, options);
        if (attrVal === true && options.suppressBooleanAttributes) attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}`;
        else attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}="${attrVal}"`;
    }
    return attrStr;
}
function $d6017206f3cf5ac4$var$isStopNode(jPath, options) {
    jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
    let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
    for(let index in options.stopNodes){
        if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName) return true;
    }
    return false;
}
function $d6017206f3cf5ac4$var$replaceEntitiesValue(textValue, options) {
    if (textValue && textValue.length > 0 && options.processEntities) for(let i = 0; i < options.entities.length; i++){
        const entity = options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
}


function $99fe9da60dde6c19$export$2e2bcd8739ae039(ignoreAttributes) {
    if (typeof ignoreAttributes === 'function') return ignoreAttributes;
    if (Array.isArray(ignoreAttributes)) return (attrName)=>{
        for (const pattern of ignoreAttributes){
            if (typeof pattern === 'string' && attrName === pattern) return true;
            if (pattern instanceof RegExp && pattern.test(attrName)) return true;
        }
    };
    return ()=>false;
}


'use strict';
const $af6cf4d40183b1fb$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataPropName: false,
    format: false,
    indentBy: '  ',
    suppressEmptyNode: false,
    suppressUnpairedNode: true,
    suppressBooleanAttributes: true,
    tagValueProcessor: function(key, a) {
        return a;
    },
    attributeValueProcessor: function(attrName, a) {
        return a;
    },
    preserveOrder: false,
    commentPropName: false,
    unpairedTags: [],
    entities: [
        {
            regex: new RegExp("&", "g"),
            val: "&amp;"
        },
        {
            regex: new RegExp(">", "g"),
            val: "&gt;"
        },
        {
            regex: new RegExp("<", "g"),
            val: "&lt;"
        },
        {
            regex: new RegExp("\'", "g"),
            val: "&apos;"
        },
        {
            regex: new RegExp("\"", "g"),
            val: "&quot;"
        }
    ],
    processEntities: true,
    stopNodes: [],
    // transformTagName: false,
    // transformAttributeName: false,
    oneListGroup: false
};
function $af6cf4d40183b1fb$export$2e2bcd8739ae039(options) {
    this.options = Object.assign({}, $af6cf4d40183b1fb$var$defaultOptions, options);
    if (this.options.ignoreAttributes === true || this.options.attributesGroupName) this.isAttribute = function() {
        return false;
    };
    else {
        this.ignoreAttributesFn = (0, $99fe9da60dde6c19$export$2e2bcd8739ae039)(this.options.ignoreAttributes);
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $af6cf4d40183b1fb$var$isAttribute;
    }
    this.processTextOrObjNode = $af6cf4d40183b1fb$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $af6cf4d40183b1fb$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
}
$af6cf4d40183b1fb$export$2e2bcd8739ae039.prototype.build = function(jObj) {
    if (this.options.preserveOrder) return (0, $d6017206f3cf5ac4$export$2e2bcd8739ae039)(jObj, this.options);
    else {
        if (Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1) jObj = {
            [this.options.arrayNodeName]: jObj
        };
        return this.j2x(jObj, 0, []).val;
    }
};
$af6cf4d40183b1fb$export$2e2bcd8739ae039.prototype.j2x = function(jObj, level, ajPath) {
    let attrStr = '';
    let val = '';
    const jPath = ajPath.join('.');
    for(let key in jObj){
        if (!Object.prototype.hasOwnProperty.call(jObj, key)) continue;
        if (typeof jObj[key] === 'undefined') // supress undefined node only if it is not an attribute
        {
            if (this.isAttribute(key)) val += '';
        } else if (jObj[key] === null) {
            // null attribute should be ignored by the attribute list, but should not cause the tag closing
            if (this.isAttribute(key)) val += '';
            else if (key === this.options.cdataPropName) val += '';
            else if (key[0] === '?') val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
            else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        } else if (jObj[key] instanceof Date) val += this.buildTextValNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr && !this.ignoreAttributesFn(attr, jPath)) attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
            else if (!attr) {
                //tag value
                if (key === this.options.textNodeName) {
                    let newval = this.options.tagValueProcessor(key, '' + jObj[key]);
                    val += this.replaceEntitiesValue(newval);
                } else val += this.buildTextValNode(jObj[key], key, '', level);
            }
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            const arrLen = jObj[key].length;
            let listTagVal = "";
            let listTagAttr = "";
            for(let j = 0; j < arrLen; j++){
                const item = jObj[key][j];
                if (typeof item === 'undefined') ;
                else if (item === null) {
                    if (key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
                    else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                } else if (typeof item === 'object') {
                    if (this.options.oneListGroup) {
                        const result = this.j2x(item, level + 1, ajPath.concat(key));
                        listTagVal += result.val;
                        if (this.options.attributesGroupName && item.hasOwnProperty(this.options.attributesGroupName)) listTagAttr += result.attrStr;
                    } else listTagVal += this.processTextOrObjNode(item, key, level, ajPath);
                } else if (this.options.oneListGroup) {
                    let textValue = this.options.tagValueProcessor(key, item);
                    textValue = this.replaceEntitiesValue(textValue);
                    listTagVal += textValue;
                } else listTagVal += this.buildTextValNode(item, key, '', level);
            }
            if (this.options.oneListGroup) listTagVal = this.buildObjectNode(listTagVal, key, listTagAttr, level);
            val += listTagVal;
        } else //nested node
        if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += this.buildAttrPairStr(Ks[j], '' + jObj[key][Ks[j]]);
        } else val += this.processTextOrObjNode(jObj[key], key, level, ajPath);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
$af6cf4d40183b1fb$export$2e2bcd8739ae039.prototype.buildAttrPairStr = function(attrName, val) {
    val = this.options.attributeValueProcessor(attrName, '' + val);
    val = this.replaceEntitiesValue(val);
    if (this.options.suppressBooleanAttributes && val === "true") return ' ' + attrName;
    else return ' ' + attrName + '="' + val + '"';
};
function $af6cf4d40183b1fb$var$processTextOrObjNode(object, key, level, ajPath) {
    const result = this.j2x(object, level + 1, ajPath.concat(key));
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextValNode(object[this.options.textNodeName], key, result.attrStr, level);
    else return this.buildObjectNode(result.val, key, result.attrStr, level);
}
$af6cf4d40183b1fb$export$2e2bcd8739ae039.prototype.buildObjectNode = function(val, key, attrStr, level) {
    if (val === "") {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
    } else {
        let tagEndExp = '</' + key + this.tagEndChar;
        let piClosingChar = "";
        if (key[0] === "?") {
            piClosingChar = "?";
            tagEndExp = "";
        }
        // attrStr is an empty string in case the attribute came as undefined or null
        if ((attrStr || attrStr === '') && val.indexOf('<') === -1) return this.indentate(level) + '<' + key + attrStr + piClosingChar + '>' + val + tagEndExp;
        else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) return this.indentate(level) + `<!--${val}-->` + this.newLine;
        else return this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar + val + this.indentate(level) + tagEndExp;
    }
};
$af6cf4d40183b1fb$export$2e2bcd8739ae039.prototype.closeTag = function(key) {
    let closeTag = "";
    if (this.options.unpairedTags.indexOf(key) !== -1) {
        if (!this.options.suppressUnpairedNode) closeTag = "/";
    } else if (this.options.suppressEmptyNode) closeTag = "/";
    else closeTag = `></${key}`;
    return closeTag;
};
function $af6cf4d40183b1fb$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
    }
}
$af6cf4d40183b1fb$export$2e2bcd8739ae039.prototype.buildTextValNode = function(val, key, attrStr, level) {
    if (this.options.cdataPropName !== false && key === this.options.cdataPropName) return this.indentate(level) + `<![CDATA[${val}]]>` + this.newLine;
    else if (this.options.commentPropName !== false && key === this.options.commentPropName) return this.indentate(level) + `<!--${val}-->` + this.newLine;
    else if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
    else {
        let textValue = this.options.tagValueProcessor(key, val);
        textValue = this.replaceEntitiesValue(textValue);
        if (textValue === '') return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '>' + textValue + '</' + key + this.tagEndChar;
    }
};
$af6cf4d40183b1fb$export$2e2bcd8739ae039.prototype.replaceEntitiesValue = function(textValue) {
    if (textValue && textValue.length > 0 && this.options.processEntities) for(let i = 0; i < this.options.entities.length; i++){
        const entity = this.options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
};
function $af6cf4d40183b1fb$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $af6cf4d40183b1fb$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix) && name !== this.options.textNodeName) return name.substr(this.attrPrefixLen);
    else return false;
}

const $ca5eabf2cbffb6ca$export$ba43bf67f3d48107 = {
    preserveOrder: false,
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    removeNSPrefix: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseTagValue: true,
    parseAttributeValue: false,
    trimValues: true,
    cdataPropName: false,
    numberParseOptions: {
        hex: true,
        leadingZeros: true,
        eNotation: true
    },
    tagValueProcessor: function(tagName, val) {
        return val;
    },
    attributeValueProcessor: function(attrName, val) {
        return val;
    },
    stopNodes: [],
    alwaysCreateTextNode: false,
    isArray: ()=>false,
    commentPropName: false,
    unpairedTags: [],
    processEntities: true,
    htmlEntities: false,
    ignoreDeclaration: false,
    ignorePiTags: false,
    transformTagName: false,
    transformAttributeName: false,
    updateTag: function(tagName, jPath, attrs) {
        return tagName;
    },
    // skipEmptyListItem: false
    captureMetaData: false
};
const $ca5eabf2cbffb6ca$export$ecbd7d678ac4909b = function(options) {
    return Object.assign({}, $ca5eabf2cbffb6ca$export$ba43bf67f3d48107, options);
};


'use strict';
const $5c67d3573813703a$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $5c67d3573813703a$var$nameChar = $5c67d3573813703a$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $5c67d3573813703a$export$e8f2644f7085b4b1 = '[' + $5c67d3573813703a$var$nameStartChar + '][' + $5c67d3573813703a$var$nameChar + ']*';
const $5c67d3573813703a$var$regexName = new RegExp('^' + $5c67d3573813703a$export$e8f2644f7085b4b1 + '$');
function $5c67d3573813703a$export$aaa9734c55cb7a19(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
}
const $5c67d3573813703a$export$998d7ff9801e90bb = function(string) {
    const match = $5c67d3573813703a$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
function $5c67d3573813703a$export$a5edf3f35b6dd392(v) {
    return typeof v !== 'undefined';
}
function $5c67d3573813703a$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $5c67d3573813703a$export$4950aa0f605343fb(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
}
function $5c67d3573813703a$export$bf7199a9ebcb84a9(v) {
    if ($5c67d3573813703a$export$a5edf3f35b6dd392(v)) return v;
    else return '';
} // const fakeCall = function(a) {return a;};
 // const fakeCallNoReturn = function() {};


'use strict';
let $37f0fb515c7fd438$var$METADATA_SYMBOL;
if (typeof Symbol !== "function") $37f0fb515c7fd438$var$METADATA_SYMBOL = "@@xmlMetadata";
else $37f0fb515c7fd438$var$METADATA_SYMBOL = Symbol("XML Node Metadata");
class $37f0fb515c7fd438$export$2e2bcd8739ae039 {
    constructor(tagname){
        this.tagname = tagname;
        this.child = []; //nested tags, text, cdata, comments in order
        this[":@"] = {}; //attributes map
    }
    add(key, val) {
        // this.child.push( {name : key, val: val, isCdata: isCdata });
        if (key === "__proto__") key = "#__proto__";
        this.child.push({
            [key]: val
        });
    }
    addChild(node, startIndex) {
        if (node.tagname === "__proto__") node.tagname = "#__proto__";
        if (node[":@"] && Object.keys(node[":@"]).length > 0) this.child.push({
            [node.tagname]: node.child,
            [":@"]: node[":@"]
        });
        else this.child.push({
            [node.tagname]: node.child
        });
        // if requested, add the startIndex
        if (startIndex !== undefined) // Note: for now we just overwrite the metadata. If we had more complex metadata,
        // we might need to do an object append here:  metadata = { ...metadata, startIndex }
        this.child[this.child.length - 1][$37f0fb515c7fd438$var$METADATA_SYMBOL] = {
            startIndex: startIndex
        };
    }
    /** symbol used for metadata */ static getMetaDataSymbol() {
        return $37f0fb515c7fd438$var$METADATA_SYMBOL;
    }
}



function $d1f8a05ca163b12f$export$2e2bcd8739ae039(xmlData, i) {
    const entities = {};
    if (xmlData[i + 3] === 'O' && xmlData[i + 4] === 'C' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'Y' && xmlData[i + 7] === 'P' && xmlData[i + 8] === 'E') {
        i = i + 9;
        let angleBracketsCount = 1;
        let hasBody = false, comment = false;
        let exp = "";
        for(; i < xmlData.length; i++){
            if (xmlData[i] === '<' && !comment) {
                if (hasBody && $d1f8a05ca163b12f$var$hasSeq(xmlData, "!ENTITY", i)) {
                    i += 7;
                    let entityName, val;
                    [entityName, val, i] = $d1f8a05ca163b12f$var$readEntityExp(xmlData, i + 1);
                    if (val.indexOf("&") === -1) entities[entityName] = {
                        regx: RegExp(`&${entityName};`, "g"),
                        val: val
                    };
                } else if (hasBody && $d1f8a05ca163b12f$var$hasSeq(xmlData, "!ELEMENT", i)) {
                    i += 8; //Not supported
                    const { index: index } = $d1f8a05ca163b12f$var$readElementExp(xmlData, i + 1);
                    i = index;
                } else if (hasBody && $d1f8a05ca163b12f$var$hasSeq(xmlData, "!ATTLIST", i)) i += 8; //Not supported
                else if (hasBody && $d1f8a05ca163b12f$var$hasSeq(xmlData, "!NOTATION", i)) {
                    i += 9; //Not supported
                    const { index: index } = $d1f8a05ca163b12f$var$readNotationExp(xmlData, i + 1);
                    i = index;
                } else if ($d1f8a05ca163b12f$var$hasSeq(xmlData, "!--", i)) comment = true;
                else throw new Error(`Invalid DOCTYPE`);
                angleBracketsCount++;
                exp = "";
            } else if (xmlData[i] === '>') {
                if (comment) {
                    if (xmlData[i - 1] === "-" && xmlData[i - 2] === "-") {
                        comment = false;
                        angleBracketsCount--;
                    }
                } else angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            } else if (xmlData[i] === '[') hasBody = true;
            else exp += xmlData[i];
        }
        if (angleBracketsCount !== 0) throw new Error(`Unclosed DOCTYPE`);
    } else throw new Error(`Invalid Tag instead of DOCTYPE`);
    return {
        entities: entities,
        i: i
    };
}
const $d1f8a05ca163b12f$var$skipWhitespace = (data, index)=>{
    while(index < data.length && /\s/.test(data[index]))index++;
    return index;
};
function $d1f8a05ca163b12f$var$readEntityExp(xmlData, i) {
    //External entities are not supported
    //    <!ENTITY ext SYSTEM "http://normal-website.com" >
    //Parameter entities are not supported
    //    <!ENTITY entityname "&anotherElement;">
    //Internal entities are supported
    //    <!ENTITY entityname "replacement text">
    // Skip leading whitespace after <!ENTITY
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    // Read entity name
    let entityName = "";
    while(i < xmlData.length && !/\s/.test(xmlData[i]) && xmlData[i] !== '"' && xmlData[i] !== "'"){
        entityName += xmlData[i];
        i++;
    }
    $d1f8a05ca163b12f$var$validateEntityName(entityName);
    // Skip whitespace after entity name
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    // Check for unsupported constructs (external entities or parameter entities)
    if (xmlData.substring(i, i + 6).toUpperCase() === "SYSTEM") throw new Error("External entities are not supported");
    else if (xmlData[i] === "%") throw new Error("Parameter entities are not supported");
    // Read entity value (internal entity)
    let entityValue = "";
    [i, entityValue] = $d1f8a05ca163b12f$var$readIdentifierVal(xmlData, i, "entity");
    i--;
    return [
        entityName,
        entityValue,
        i
    ];
}
function $d1f8a05ca163b12f$var$readNotationExp(xmlData, i) {
    // Skip leading whitespace after <!NOTATION
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    // Read notation name
    let notationName = "";
    while(i < xmlData.length && !/\s/.test(xmlData[i])){
        notationName += xmlData[i];
        i++;
    }
    $d1f8a05ca163b12f$var$validateEntityName(notationName);
    // Skip whitespace after notation name
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    // Check identifier type (SYSTEM or PUBLIC)
    const identifierType = xmlData.substring(i, i + 6).toUpperCase();
    if (identifierType !== "SYSTEM" && identifierType !== "PUBLIC") throw new Error(`Expected SYSTEM or PUBLIC, found "${identifierType}"`);
    i += identifierType.length;
    // Skip whitespace after identifier type
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    // Read public identifier (if PUBLIC)
    let publicIdentifier = null;
    let systemIdentifier = null;
    if (identifierType === "PUBLIC") {
        [i, publicIdentifier] = $d1f8a05ca163b12f$var$readIdentifierVal(xmlData, i, "publicIdentifier");
        // Skip whitespace after public identifier
        i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
        // Optionally read system identifier
        if (xmlData[i] === '"' || xmlData[i] === "'") [i, systemIdentifier] = $d1f8a05ca163b12f$var$readIdentifierVal(xmlData, i, "systemIdentifier");
    } else if (identifierType === "SYSTEM") {
        // Read system identifier (mandatory for SYSTEM)
        [i, systemIdentifier] = $d1f8a05ca163b12f$var$readIdentifierVal(xmlData, i, "systemIdentifier");
        if (!systemIdentifier) throw new Error("Missing mandatory system identifier for SYSTEM notation");
    }
    return {
        notationName: notationName,
        publicIdentifier: publicIdentifier,
        systemIdentifier: systemIdentifier,
        index: --i
    };
}
function $d1f8a05ca163b12f$var$readIdentifierVal(xmlData, i, type) {
    let identifierVal = "";
    const startChar = xmlData[i];
    if (startChar !== '"' && startChar !== "'") throw new Error(`Expected quoted string, found "${startChar}"`);
    i++;
    while(i < xmlData.length && xmlData[i] !== startChar){
        identifierVal += xmlData[i];
        i++;
    }
    if (xmlData[i] !== startChar) throw new Error(`Unterminated ${type} value`);
    i++;
    return [
        i,
        identifierVal
    ];
}
function $d1f8a05ca163b12f$var$readElementExp(xmlData, i) {
    // <!ELEMENT br EMPTY>
    // <!ELEMENT div ANY>
    // <!ELEMENT title (#PCDATA)>
    // <!ELEMENT book (title, author+)>
    // <!ELEMENT name (content-model)>
    // Skip leading whitespace after <!ELEMENT
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    // Read element name
    let elementName = "";
    while(i < xmlData.length && !/\s/.test(xmlData[i])){
        elementName += xmlData[i];
        i++;
    }
    // Validate element name
    if (!$d1f8a05ca163b12f$var$validateEntityName(elementName)) throw new Error(`Invalid element name: "${elementName}"`);
    // Skip whitespace after element name
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    let contentModel = "";
    // Expect '(' to start content model
    if (xmlData[i] === "E" && $d1f8a05ca163b12f$var$hasSeq(xmlData, "MPTY", i)) i += 4;
    else if (xmlData[i] === "A" && $d1f8a05ca163b12f$var$hasSeq(xmlData, "NY", i)) i += 2;
    else if (xmlData[i] === "(") {
        i++; // Move past '('
        // Read content model
        while(i < xmlData.length && xmlData[i] !== ")"){
            contentModel += xmlData[i];
            i++;
        }
        if (xmlData[i] !== ")") throw new Error("Unterminated content model");
    } else throw new Error(`Invalid Element Expression, found "${xmlData[i]}"`);
    return {
        elementName: elementName,
        contentModel: contentModel.trim(),
        index: i
    };
}
function $d1f8a05ca163b12f$var$readAttlistExp(xmlData, i) {
    // Skip leading whitespace after <!ATTLIST
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    // Read element name
    let elementName = "";
    while(i < xmlData.length && !/\s/.test(xmlData[i])){
        elementName += xmlData[i];
        i++;
    }
    // Validate element name
    $d1f8a05ca163b12f$var$validateEntityName(elementName);
    // Skip whitespace after element name
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    // Read attribute name
    let attributeName = "";
    while(i < xmlData.length && !/\s/.test(xmlData[i])){
        attributeName += xmlData[i];
        i++;
    }
    // Validate attribute name
    if (!$d1f8a05ca163b12f$var$validateEntityName(attributeName)) throw new Error(`Invalid attribute name: "${attributeName}"`);
    // Skip whitespace after attribute name
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    // Read attribute type
    let attributeType = "";
    if (xmlData.substring(i, i + 8).toUpperCase() === "NOTATION") {
        attributeType = "NOTATION";
        i += 8; // Move past "NOTATION"
        // Skip whitespace after "NOTATION"
        i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
        // Expect '(' to start the list of notations
        if (xmlData[i] !== "(") throw new Error(`Expected '(', found "${xmlData[i]}"`);
        i++; // Move past '('
        // Read the list of allowed notations
        let allowedNotations = [];
        while(i < xmlData.length && xmlData[i] !== ")"){
            let notation = "";
            while(i < xmlData.length && xmlData[i] !== "|" && xmlData[i] !== ")"){
                notation += xmlData[i];
                i++;
            }
            // Validate notation name
            notation = notation.trim();
            if (!$d1f8a05ca163b12f$var$validateEntityName(notation)) throw new Error(`Invalid notation name: "${notation}"`);
            allowedNotations.push(notation);
            // Skip '|' separator or exit loop
            if (xmlData[i] === "|") {
                i++; // Move past '|'
                i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i); // Skip optional whitespace after '|'
            }
        }
        if (xmlData[i] !== ")") throw new Error("Unterminated list of notations");
        i++; // Move past ')'
        // Store the allowed notations as part of the attribute type
        attributeType += " (" + allowedNotations.join("|") + ")";
    } else {
        // Handle simple types (e.g., CDATA, ID, IDREF, etc.)
        while(i < xmlData.length && !/\s/.test(xmlData[i])){
            attributeType += xmlData[i];
            i++;
        }
        // Validate simple attribute type
        const validTypes = [
            "CDATA",
            "ID",
            "IDREF",
            "IDREFS",
            "ENTITY",
            "ENTITIES",
            "NMTOKEN",
            "NMTOKENS"
        ];
        if (!validTypes.includes(attributeType.toUpperCase())) throw new Error(`Invalid attribute type: "${attributeType}"`);
    }
    // Skip whitespace after attribute type
    i = $d1f8a05ca163b12f$var$skipWhitespace(xmlData, i);
    // Read default value
    let defaultValue = "";
    if (xmlData.substring(i, i + 8).toUpperCase() === "#REQUIRED") {
        defaultValue = "#REQUIRED";
        i += 8;
    } else if (xmlData.substring(i, i + 7).toUpperCase() === "#IMPLIED") {
        defaultValue = "#IMPLIED";
        i += 7;
    } else [i, defaultValue] = $d1f8a05ca163b12f$var$readIdentifierVal(xmlData, i, "ATTLIST");
    return {
        elementName: elementName,
        attributeName: attributeName,
        attributeType: attributeType,
        defaultValue: defaultValue,
        index: i
    };
}
function $d1f8a05ca163b12f$var$hasSeq(data, seq, i) {
    for(let j = 0; j < seq.length; j++){
        if (seq[j] !== data[i + j + 1]) return false;
    }
    return true;
}
function $d1f8a05ca163b12f$var$validateEntityName(name) {
    if ((0, $5c67d3573813703a$export$998d7ff9801e90bb)(name)) return name;
    else throw new Error(`Invalid entity name ${name}`);
}


const $752e094baf69c979$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $752e094baf69c979$var$numRegex = /^([\-\+])?(0*)([0-9]*(\.[0-9]*)?)$/;
// const octRegex = /^0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
const $752e094baf69c979$var$consider = {
    hex: true,
    // oct: false,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
};
function $752e094baf69c979$export$2e2bcd8739ae039(str, options = {}) {
    options = Object.assign({}, $752e094baf69c979$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (str === "0") return 0;
    else if (options.hex && $752e094baf69c979$var$hexRegex.test(trimmedStr)) return $752e094baf69c979$var$parse_int(trimmedStr, 16);
    else if (trimmedStr.search(/.+[eE].+/) !== -1) return $752e094baf69c979$var$resolveEnotation(str, trimmedStr, options);
    else {
        //separate negative sign, leading zeros, and rest number
        const match = $752e094baf69c979$var$numRegex.exec(trimmedStr);
        // +00.123 => [ , '+', '00', '.123', ..
        if (match) {
            const sign = match[1] || "";
            const leadingZeros = match[2];
            let numTrimmedByZeros = $752e094baf69c979$var$trimZeros(match[3]); //complete num without leading zeros
            const decimalAdjacentToLeadingZeros = sign ? str[leadingZeros.length + 1] === "." : str[leadingZeros.length] === ".";
            //trim ending zeros for floating number
            if (!options.leadingZeros //leading zeros are not allowed
             && (leadingZeros.length > 1 || leadingZeros.length === 1 && !decimalAdjacentToLeadingZeros)) // 00, 00.3, +03.24, 03, 03.24
            return str;
            else {
                const num = Number(trimmedStr);
                const parsedStr = String(num);
                if (num === 0) return num;
                if (parsedStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    if (parsedStr === "0") return num; //0.0
                    else if (parsedStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (parsedStr === `${sign}${numTrimmedByZeros}`) return num;
                    else return str;
                }
                let n = leadingZeros ? numTrimmedByZeros : trimmedStr;
                if (leadingZeros) // -009 => -9
                return n === parsedStr || sign + n === parsedStr ? num : str;
                else // +9
                return n === parsedStr || n === sign + parsedStr ? num : str;
            }
        } else return str;
    }
}
const $752e094baf69c979$var$eNotationRegx = /^([-+])?(0*)(\d*(\.\d*)?[eE][-\+]?\d+)$/;
function $752e094baf69c979$var$resolveEnotation(str, trimmedStr, options) {
    if (!options.eNotation) return str;
    const notation = trimmedStr.match($752e094baf69c979$var$eNotationRegx);
    if (notation) {
        let sign = notation[1] || "";
        const eChar = notation[3].indexOf("e") === -1 ? "E" : "e";
        const leadingZeros = notation[2];
        const eAdjacentToLeadingZeros = sign ? str[leadingZeros.length + 1] === eChar : str[leadingZeros.length] === eChar;
        if (leadingZeros.length > 1 && eAdjacentToLeadingZeros) return str;
        else if (leadingZeros.length === 1 && (notation[3].startsWith(`.${eChar}`) || notation[3][0] === eChar)) return Number(trimmedStr);
        else if (options.leadingZeros && !eAdjacentToLeadingZeros) {
            //remove leading 0s
            trimmedStr = (notation[1] || "") + notation[3];
            return Number(trimmedStr);
        } else return str;
    } else return str;
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $752e094baf69c979$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substring(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
function $752e094baf69c979$var$parse_int(numStr, base) {
    //polyfill
    if (parseInt) return parseInt(numStr, base);
    else if (Number.parseInt) return Number.parseInt(numStr, base);
    else if (window && window.parseInt) return window.parseInt(numStr, base);
    else throw new Error("parseInt, Number.parseInt, window.parseInt are not supported");
}



'use strict';
class $f8735708124c073a$export$2e2bcd8739ae039 {
    constructor(options){
        this.options = options;
        this.currentNode = null;
        this.tagsNodeStack = [];
        this.docTypeEntities = {};
        this.lastEntities = {
            "apos": {
                regex: /&(apos|#39|#x27);/g,
                val: "'"
            },
            "gt": {
                regex: /&(gt|#62|#x3E);/g,
                val: ">"
            },
            "lt": {
                regex: /&(lt|#60|#x3C);/g,
                val: "<"
            },
            "quot": {
                regex: /&(quot|#34|#x22);/g,
                val: "\""
            }
        };
        this.ampEntity = {
            regex: /&(amp|#38|#x26);/g,
            val: "&"
        };
        this.htmlEntities = {
            "space": {
                regex: /&(nbsp|#160);/g,
                val: " "
            },
            // "lt" : { regex: /&(lt|#60);/g, val: "<" },
            // "gt" : { regex: /&(gt|#62);/g, val: ">" },
            // "amp" : { regex: /&(amp|#38);/g, val: "&" },
            // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
            // "apos" : { regex: /&(apos|#39);/g, val: "'" },
            "cent": {
                regex: /&(cent|#162);/g,
                val: "\xa2"
            },
            "pound": {
                regex: /&(pound|#163);/g,
                val: "\xa3"
            },
            "yen": {
                regex: /&(yen|#165);/g,
                val: "\xa5"
            },
            "euro": {
                regex: /&(euro|#8364);/g,
                val: "\u20AC"
            },
            "copyright": {
                regex: /&(copy|#169);/g,
                val: "\xa9"
            },
            "reg": {
                regex: /&(reg|#174);/g,
                val: "\xae"
            },
            "inr": {
                regex: /&(inr|#8377);/g,
                val: "\u20B9"
            },
            "num_dec": {
                regex: /&#([0-9]{1,7});/g,
                val: (_, str)=>String.fromCodePoint(Number.parseInt(str, 10))
            },
            "num_hex": {
                regex: /&#x([0-9a-fA-F]{1,6});/g,
                val: (_, str)=>String.fromCodePoint(Number.parseInt(str, 16))
            }
        };
        this.addExternalEntities = $f8735708124c073a$var$addExternalEntities;
        this.parseXml = $f8735708124c073a$var$parseXml;
        this.parseTextData = $f8735708124c073a$var$parseTextData;
        this.resolveNameSpace = $f8735708124c073a$var$resolveNameSpace;
        this.buildAttributesMap = $f8735708124c073a$var$buildAttributesMap;
        this.isItStopNode = $f8735708124c073a$var$isItStopNode;
        this.replaceEntitiesValue = $f8735708124c073a$var$replaceEntitiesValue;
        this.readStopNodeData = $f8735708124c073a$var$readStopNodeData;
        this.saveTextToParentTag = $f8735708124c073a$var$saveTextToParentTag;
        this.addChild = $f8735708124c073a$var$addChild;
        this.ignoreAttributesFn = (0, $99fe9da60dde6c19$export$2e2bcd8739ae039)(this.options.ignoreAttributes);
    }
}
function $f8735708124c073a$var$addExternalEntities(externalEntities) {
    const entKeys = Object.keys(externalEntities);
    for(let i = 0; i < entKeys.length; i++){
        const ent = entKeys[i];
        this.lastEntities[ent] = {
            regex: new RegExp("&" + ent + ";", "g"),
            val: externalEntities[ent]
        };
    }
}
/**
 * @param {string} val
 * @param {string} tagName
 * @param {string} jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */ function $f8735708124c073a$var$parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
    if (val !== undefined) {
        if (this.options.trimValues && !dontTrim) val = val.trim();
        if (val.length > 0) {
            if (!escapeEntities) val = this.replaceEntitiesValue(val);
            const newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
            if (newval === null || newval === undefined) //don't parse
            return val;
            else if (typeof newval !== typeof val || newval !== val) //overwrite
            return newval;
            else if (this.options.trimValues) return $f8735708124c073a$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
            else {
                const trimmedVal = val.trim();
                if (trimmedVal === val) return $f8735708124c073a$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
                else return val;
            }
        }
    }
}
function $f8735708124c073a$var$resolveNameSpace(tagname) {
    if (this.options.removeNSPrefix) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $f8735708124c073a$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');
function $f8735708124c073a$var$buildAttributesMap(attrStr, jPath, tagName) {
    if (this.options.ignoreAttributes !== true && typeof attrStr === 'string') {
        // attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = (0, $5c67d3573813703a$export$aaa9734c55cb7a19)(attrStr, $f8735708124c073a$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = this.resolveNameSpace(matches[i][1]);
            if (this.ignoreAttributesFn(attrName, jPath)) continue;
            let oldVal = matches[i][4];
            let aName = this.options.attributeNamePrefix + attrName;
            if (attrName.length) {
                if (this.options.transformAttributeName) aName = this.options.transformAttributeName(aName);
                if (aName === "__proto__") aName = "#__proto__";
                if (oldVal !== undefined) {
                    if (this.options.trimValues) oldVal = oldVal.trim();
                    oldVal = this.replaceEntitiesValue(oldVal);
                    const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
                    if (newVal === null || newVal === undefined) //don't parse
                    attrs[aName] = oldVal;
                    else if (typeof newVal !== typeof oldVal || newVal !== oldVal) //overwrite
                    attrs[aName] = newVal;
                    else //parse
                    attrs[aName] = $f8735708124c073a$var$parseValue(oldVal, this.options.parseAttributeValue, this.options.numberParseOptions);
                } else if (this.options.allowBooleanAttributes) attrs[aName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (this.options.attributesGroupName) {
            const attrCollection = {};
            attrCollection[this.options.attributesGroupName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $f8735708124c073a$var$parseXml = function(xmlData) {
    xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
    const xmlObj = new (0, $37f0fb515c7fd438$export$2e2bcd8739ae039)('!xml');
    let currentNode = xmlObj;
    let textData = "";
    let jPath = "";
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            // const nextIndex = i+1;
            // const _2ndChar = xmlData[nextIndex];
            if (xmlData[i + 1] === '/') {
                const closeIndex = $f8735708124c073a$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (this.options.removeNSPrefix) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                if (currentNode) textData = this.saveTextToParentTag(textData, currentNode, jPath);
                //check if last tag of nested tag was unpaired tag
                const lastTagName = jPath.substring(jPath.lastIndexOf(".") + 1);
                if (tagName && this.options.unpairedTags.indexOf(tagName) !== -1) throw new Error(`Unpaired tag can not be used as closing tag: </${tagName}>`);
                let propIndex = 0;
                if (lastTagName && this.options.unpairedTags.indexOf(lastTagName) !== -1) {
                    propIndex = jPath.lastIndexOf('.', jPath.lastIndexOf('.') - 1);
                    this.tagsNodeStack.pop();
                } else propIndex = jPath.lastIndexOf(".");
                jPath = jPath.substring(0, propIndex);
                currentNode = this.tagsNodeStack.pop(); //avoid recursion, set the parent tag scope
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') {
                let tagData = $f8735708124c073a$var$readTagExp(xmlData, i, false, "?>");
                if (!tagData) throw new Error("Pi Tag is not closed.");
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                if (this.options.ignoreDeclaration && tagData.tagName === "?xml" || this.options.ignorePiTags) ;
                else {
                    const childNode = new (0, $37f0fb515c7fd438$export$2e2bcd8739ae039)(tagData.tagName);
                    childNode.add(this.options.textNodeName, "");
                    if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath, tagData.tagName);
                    this.addChild(currentNode, childNode, jPath, i);
                }
                i = tagData.closeIndex + 1;
            } else if (xmlData.substr(i + 1, 3) === '!--') {
                const endIndex = $f8735708124c073a$var$findClosingIndex(xmlData, "-->", i + 4, "Comment is not closed.");
                if (this.options.commentPropName) {
                    const comment = xmlData.substring(i + 4, endIndex - 2);
                    textData = this.saveTextToParentTag(textData, currentNode, jPath);
                    currentNode.add(this.options.commentPropName, [
                        {
                            [this.options.textNodeName]: comment
                        }
                    ]);
                }
                i = endIndex;
            } else if (xmlData.substr(i + 1, 2) === '!D') {
                const result = (0, $d1f8a05ca163b12f$export$2e2bcd8739ae039)(xmlData, i);
                this.docTypeEntities = result.entities;
                i = result.i;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $f8735708124c073a$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                let val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true, true);
                if (val == undefined) val = "";
                //cdata should be set even if it is 0 length string
                if (this.options.cdataPropName) currentNode.add(this.options.cdataPropName, [
                    {
                        [this.options.textNodeName]: tagExp
                    }
                ]);
                else currentNode.add(this.options.textNodeName, val);
                i = closeIndex + 2;
            } else {
                let result = $f8735708124c073a$var$readTagExp(xmlData, i, this.options.removeNSPrefix);
                let tagName = result.tagName;
                const rawTagName = result.rawTagName;
                let tagExp = result.tagExp;
                let attrExpPresent = result.attrExpPresent;
                let closeIndex = result.closeIndex;
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                //save text as child node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') //when nested tag is found
                    textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
                }
                //check if last tag was unpaired tag
                const lastTag = currentNode;
                if (lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1) {
                    currentNode = this.tagsNodeStack.pop();
                    jPath = jPath.substring(0, jPath.lastIndexOf("."));
                }
                if (tagName !== xmlObj.tagname) jPath += jPath ? "." + tagName : tagName;
                const startIndex = i;
                if (this.isItStopNode(this.options.stopNodes, jPath, tagName)) {
                    let tagContent = "";
                    //self-closing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            jPath = jPath.substr(0, jPath.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        i = result.closeIndex;
                    } else if (this.options.unpairedTags.indexOf(tagName) !== -1) i = result.closeIndex;
                    else {
                        //read until closing tag is found
                        const result = this.readStopNodeData(xmlData, rawTagName, closeIndex + 1);
                        if (!result) throw new Error(`Unexpected end of ${rawTagName}`);
                        i = result.i;
                        tagContent = result.tagContent;
                    }
                    const childNode = new (0, $37f0fb515c7fd438$export$2e2bcd8739ae039)(tagName);
                    if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                    if (tagContent) tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
                    jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    childNode.add(this.options.textNodeName, tagContent);
                    this.addChild(currentNode, childNode, jPath, startIndex);
                } else {
                    //selfClosing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            jPath = jPath.substr(0, jPath.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                        const childNode = new (0, $37f0fb515c7fd438$export$2e2bcd8739ae039)(tagName);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath, startIndex);
                        jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    } else {
                        const childNode = new (0, $37f0fb515c7fd438$export$2e2bcd8739ae039)(tagName);
                        this.tagsNodeStack.push(currentNode);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath, startIndex);
                        currentNode = childNode;
                    }
                    textData = "";
                    i = closeIndex;
                }
            }
        } else textData += xmlData[i];
    }
    return xmlObj.child;
};
function $f8735708124c073a$var$addChild(currentNode, childNode, jPath, startIndex) {
    // unset startIndex if not requested
    if (!this.options.captureMetaData) startIndex = undefined;
    const result = this.options.updateTag(childNode.tagname, jPath, childNode[":@"]);
    if (result === false) ;
    else if (typeof result === "string") {
        childNode.tagname = result;
        currentNode.addChild(childNode, startIndex);
    } else currentNode.addChild(childNode, startIndex);
}
const $f8735708124c073a$var$replaceEntitiesValue = function(val) {
    if (this.options.processEntities) {
        for(let entityName in this.docTypeEntities){
            const entity = this.docTypeEntities[entityName];
            val = val.replace(entity.regx, entity.val);
        }
        for(let entityName in this.lastEntities){
            const entity = this.lastEntities[entityName];
            val = val.replace(entity.regex, entity.val);
        }
        if (this.options.htmlEntities) for(let entityName in this.htmlEntities){
            const entity = this.htmlEntities[entityName];
            val = val.replace(entity.regex, entity.val);
        }
        val = val.replace(this.ampEntity.regex, this.ampEntity.val);
    }
    return val;
};
function $f8735708124c073a$var$saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
    if (textData) {
        if (isLeafNode === undefined) isLeafNode = currentNode.child.length === 0;
        textData = this.parseTextData(textData, currentNode.tagname, jPath, false, currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false, isLeafNode);
        if (textData !== undefined && textData !== "") currentNode.add(this.options.textNodeName, textData);
        textData = "";
    }
    return textData;
}
//TODO: use jPath to simplify the logic
/**
 * 
 * @param {string[]} stopNodes 
 * @param {string} jPath
 * @param {string} currentTagName 
 */ function $f8735708124c073a$var$isItStopNode(stopNodes, jPath, currentTagName) {
    const allNodesExp = "*." + currentTagName;
    for(const stopNodePath in stopNodes){
        const stopNodeExp = stopNodes[stopNodePath];
        if (allNodesExp === stopNodeExp || jPath === stopNodeExp) return true;
    }
    return false;
}
/**
 * Returns the tag Expression and where it is ending handling single-double quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */ function $f8735708124c073a$var$tagExpWithClosingIndex(xmlData, i, closingChar = ">") {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < xmlData.length; index++){
        let ch = xmlData[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === closingChar[0]) {
            if (closingChar[1]) {
                if (xmlData[index + 1] === closingChar[1]) return {
                    data: tagExp,
                    index: index
                };
            } else return {
                data: tagExp,
                index: index
            };
        } else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $f8735708124c073a$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
function $f8735708124c073a$var$readTagExp(xmlData, i, removeNSPrefix, closingChar = ">") {
    const result = $f8735708124c073a$var$tagExpWithClosingIndex(xmlData, i + 1, closingChar);
    if (!result) return;
    let tagExp = result.data;
    const closeIndex = result.index;
    const separatorIndex = tagExp.search(/\s/);
    let tagName = tagExp;
    let attrExpPresent = true;
    if (separatorIndex !== -1) {
        tagName = tagExp.substring(0, separatorIndex);
        tagExp = tagExp.substring(separatorIndex + 1).trimStart();
    }
    const rawTagName = tagName;
    if (removeNSPrefix) {
        const colonIndex = tagName.indexOf(":");
        if (colonIndex !== -1) {
            tagName = tagName.substr(colonIndex + 1);
            attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
        }
    }
    return {
        tagName: tagName,
        tagExp: tagExp,
        closeIndex: closeIndex,
        attrExpPresent: attrExpPresent,
        rawTagName: rawTagName
    };
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */ function $f8735708124c073a$var$readStopNodeData(xmlData, tagName, i) {
    const startIndex = i;
    // Starting at 1 since we already have an open tag
    let openTagCount = 1;
    for(; i < xmlData.length; i++)if (xmlData[i] === "<") {
        if (xmlData[i + 1] === "/") {
            const closeIndex = $f8735708124c073a$var$findClosingIndex(xmlData, ">", i, `${tagName} is not closed`);
            let closeTagName = xmlData.substring(i + 2, closeIndex).trim();
            if (closeTagName === tagName) {
                openTagCount--;
                if (openTagCount === 0) return {
                    tagContent: xmlData.substring(startIndex, i),
                    i: closeIndex
                };
            }
            i = closeIndex;
        } else if (xmlData[i + 1] === '?') {
            const closeIndex = $f8735708124c073a$var$findClosingIndex(xmlData, "?>", i + 1, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 3) === '!--') {
            const closeIndex = $f8735708124c073a$var$findClosingIndex(xmlData, "-->", i + 3, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 2) === '![') {
            const closeIndex = $f8735708124c073a$var$findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
            i = closeIndex;
        } else {
            const tagData = $f8735708124c073a$var$readTagExp(xmlData, i, '>');
            if (tagData) {
                const openTagName = tagData && tagData.tagName;
                if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") openTagCount++;
                i = tagData.closeIndex;
            }
        }
    }
     //end for loop
}
function $f8735708124c073a$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return (0, $752e094baf69c979$export$2e2bcd8739ae039)(val, options);
    } else {
        if ((0, $5c67d3573813703a$export$a5edf3f35b6dd392)(val)) return val;
        else return '';
    }
}



'use strict';
const $43aaebc302e55e6d$var$METADATA_SYMBOL = (0, $37f0fb515c7fd438$export$2e2bcd8739ae039).getMetaDataSymbol();
function $43aaebc302e55e6d$export$2e2bcd8739ae039(node, options) {
    return $43aaebc302e55e6d$var$compress(node, options);
}
/**
 * 
 * @param {array} arr 
 * @param {object} options 
 * @param {string} jPath 
 * @returns object
 */ function $43aaebc302e55e6d$var$compress(arr, options, jPath) {
    let text;
    const compressedObj = {};
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const property = $43aaebc302e55e6d$var$propName(tagObj);
        let newJpath = "";
        if (jPath === undefined) newJpath = property;
        else newJpath = jPath + "." + property;
        if (property === options.textNodeName) {
            if (text === undefined) text = tagObj[property];
            else text += "" + tagObj[property];
        } else if (property === undefined) continue;
        else if (tagObj[property]) {
            let val = $43aaebc302e55e6d$var$compress(tagObj[property], options, newJpath);
            const isLeaf = $43aaebc302e55e6d$var$isLeafTag(val, options);
            if (tagObj[$43aaebc302e55e6d$var$METADATA_SYMBOL] !== undefined) val[$43aaebc302e55e6d$var$METADATA_SYMBOL] = tagObj[$43aaebc302e55e6d$var$METADATA_SYMBOL]; // copy over metadata
            if (tagObj[":@"]) $43aaebc302e55e6d$var$assignAttributes(val, tagObj[":@"], newJpath, options);
            else if (Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode) val = val[options.textNodeName];
            else if (Object.keys(val).length === 0) {
                if (options.alwaysCreateTextNode) val[options.textNodeName] = "";
                else val = "";
            }
            if (compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
                if (!Array.isArray(compressedObj[property])) compressedObj[property] = [
                    compressedObj[property]
                ];
                compressedObj[property].push(val);
            } else //TODO: if a node is not an array, then check if it should be an array
            //also determine if it is a leaf node
            if (options.isArray(property, newJpath, isLeaf)) compressedObj[property] = [
                val
            ];
            else compressedObj[property] = val;
        }
    }
    // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
    if (typeof text === "string") {
        if (text.length > 0) compressedObj[options.textNodeName] = text;
    } else if (text !== undefined) compressedObj[options.textNodeName] = text;
    return compressedObj;
}
function $43aaebc302e55e6d$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (key !== ":@") return key;
    }
}
function $43aaebc302e55e6d$var$assignAttributes(obj, attrMap, jpath, options) {
    if (attrMap) {
        const keys = Object.keys(attrMap);
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++){
            const atrrName = keys[i];
            if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) obj[atrrName] = [
                attrMap[atrrName]
            ];
            else obj[atrrName] = attrMap[atrrName];
        }
    }
}
function $43aaebc302e55e6d$var$isLeafTag(obj, options) {
    const { textNodeName: textNodeName } = options;
    const propCount = Object.keys(obj).length;
    if (propCount === 0) return true;
    if (propCount === 1 && (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)) return true;
    return false;
}



'use strict';
const $5d336cd31593c9e1$var$defaultOptions = {
    allowBooleanAttributes: false,
    unpairedTags: []
};
function $5d336cd31593c9e1$export$a22775fa5e2eebd9(xmlData, options) {
    options = Object.assign({}, $5d336cd31593c9e1$var$defaultOptions, options);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $5d336cd31593c9e1$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $5d336cd31593c9e1$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$5d336cd31593c9e1$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $5d336cd31593c9e1$var$getErrorObject('InvalidTag', msg, $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $5d336cd31593c9e1$var$readAttributeStr(xmlData, i);
                if (result === false) return $5d336cd31593c9e1$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $5d336cd31593c9e1$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $5d336cd31593c9e1$var$getErrorObject(isValid.err.code, isValid.err.msg, $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $5d336cd31593c9e1$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $5d336cd31593c9e1$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else if (tags.length === 0) return $5d336cd31593c9e1$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' has not been opened.", $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $5d336cd31593c9e1$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $5d336cd31593c9e1$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $5d336cd31593c9e1$var$getErrorObject(isValid.err.code, isValid.err.msg, $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $5d336cd31593c9e1$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, i));
                    else if (options.unpairedTags.indexOf(tagName) !== -1) ;
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $5d336cd31593c9e1$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $5d336cd31593c9e1$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $5d336cd31593c9e1$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $5d336cd31593c9e1$var$getErrorObject('InvalidChar', "char '&' is not expected.", $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    } else {
                        if (reachedRoot === true && !$5d336cd31593c9e1$var$isWhiteSpace(xmlData[i])) return $5d336cd31593c9e1$var$getErrorObject('InvalidXml', "Extra text at the end", $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, i));
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if ($5d336cd31593c9e1$var$isWhiteSpace(xmlData[i])) continue;
            return $5d336cd31593c9e1$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $5d336cd31593c9e1$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $5d336cd31593c9e1$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $5d336cd31593c9e1$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
}
function $5d336cd31593c9e1$var$isWhiteSpace(char) {
    return char === ' ' || char === '\t' || char === '\n' || char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $5d336cd31593c9e1$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $5d336cd31593c9e1$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $5d336cd31593c9e1$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $5d336cd31593c9e1$var$doubleQuote = '"';
const $5d336cd31593c9e1$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $5d336cd31593c9e1$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $5d336cd31593c9e1$var$doubleQuote || xmlData[i] === $5d336cd31593c9e1$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $5d336cd31593c9e1$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $5d336cd31593c9e1$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = (0, $5c67d3573813703a$export$aaa9734c55cb7a19)(attrStr, $5d336cd31593c9e1$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $5d336cd31593c9e1$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $5d336cd31593c9e1$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] !== undefined && matches[i][4] === undefined) return $5d336cd31593c9e1$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' is without value.", $5d336cd31593c9e1$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $5d336cd31593c9e1$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $5d336cd31593c9e1$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$5d336cd31593c9e1$var$validateAttrName(attrName)) return $5d336cd31593c9e1$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $5d336cd31593c9e1$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $5d336cd31593c9e1$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $5d336cd31593c9e1$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $5d336cd31593c9e1$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $5d336cd31593c9e1$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $5d336cd31593c9e1$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $5d336cd31593c9e1$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $5d336cd31593c9e1$var$validateAttrName(attrName) {
    return (0, $5c67d3573813703a$export$998d7ff9801e90bb)(attrName);
}
// const startsWithXML = /^xml/i;
function $5d336cd31593c9e1$var$validateTagName(tagname) {
    return (0, $5c67d3573813703a$export$998d7ff9801e90bb)(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $5d336cd31593c9e1$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $5d336cd31593c9e1$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}



class $5ce3088d8ef97dea$export$2e2bcd8739ae039 {
    constructor(options){
        this.externalEntities = {};
        this.options = (0, $ca5eabf2cbffb6ca$export$ecbd7d678ac4909b)(options);
    }
    /**
     * Parse XML dats to JS object 
     * @param {string|Buffer} xmlData 
     * @param {boolean|Object} validationOption 
     */ parse(xmlData, validationOption) {
        if (typeof xmlData === "string") ;
        else if (xmlData.toString) xmlData = xmlData.toString();
        else throw new Error("XML data is accepted in String or Bytes[] form.");
        if (validationOption) {
            if (validationOption === true) validationOption = {}; //validate with default options
            const result = (0, $5d336cd31593c9e1$export$a22775fa5e2eebd9)(xmlData, validationOption);
            if (result !== true) throw Error(`${result.err.msg}:${result.err.line}:${result.err.col}`);
        }
        const orderedObjParser = new (0, $f8735708124c073a$export$2e2bcd8739ae039)(this.options);
        orderedObjParser.addExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if (this.options.preserveOrder || orderedResult === undefined) return orderedResult;
        else return (0, $43aaebc302e55e6d$export$2e2bcd8739ae039)(orderedResult, this.options);
    }
    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */ addEntity(key, value) {
        if (value.indexOf("&") !== -1) throw new Error("Entity value can't have '&'");
        else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
        else if (value === "&") throw new Error("An entity with value '&' is not permitted");
        else this.externalEntities[key] = value;
    }
    /**
     * Returns a Symbol that can be used to access the metadata
     * property on a node.
     * 
     * If Symbol is not available in the environment, an ordinary property is used
     * and the name of the property is here returned.
     * 
     * The XMLMetaData property is only present when `captureMetaData`
     * is true in the options.
     */ static getMetaDataSymbol() {
        return (0, $37f0fb515c7fd438$export$2e2bcd8739ae039).getMetaDataSymbol();
    }
}


class $f776a6c0a4c26253$var$RcMessage {
    static xmlOptions = {
        ignoreAttributes: false,
        attributeNamePrefix: "",
        attributesGroupName: "$",
        format: false,
        suppressEmptyNode: true
    };
    static fromXml(_xmlStr) {
        let xmlStr = _xmlStr;
        if (xmlStr.startsWith("P-rc: ")) xmlStr = xmlStr.substring(6);
        const parser = new (0, $5ce3088d8ef97dea$export$2e2bcd8739ae039)($f776a6c0a4c26253$var$RcMessage.xmlOptions);
        const parsed = parser.parse(xmlStr);
        return new $f776a6c0a4c26253$var$RcMessage(parsed.Msg.Hdr.$, parsed.Msg.Bdy.$);
    }
    headers;
    body;
    constructor(headers, body){
        this.headers = headers;
        this.body = body;
    }
    toXml() {
        const builder = new (0, $af6cf4d40183b1fb$export$2e2bcd8739ae039)($f776a6c0a4c26253$var$RcMessage.xmlOptions);
        const obj = {
            Msg: {
                Hdr: {
                    $: this.headers
                },
                Bdy: {
                    $: this.body
                }
            }
        };
        return builder.build(obj);
    }
}
var $f776a6c0a4c26253$export$2e2bcd8739ae039 = $f776a6c0a4c26253$var$RcMessage;


const $3703a02669f2055e$var$callControlCommands = {
    // one way messages from server to client
    ChangeMessage: 1,
    ServerFreeResources: 2,
    NewMsg: 3,
    ReLogin: 4,
    ChangePhones: 5,
    // Call control messages from server to client
    IncomingCall: 6,
    AlreadyProcessed: 7,
    ClientMinimize: 8,
    SessionClose: 9,
    // Call control messages from client to server
    ClientForward: 10,
    ClientVoicemail: 11,
    ClientReject: 12,
    ClientStartReply: 13,
    ClientReply: 14,
    ClientNotProcessed: 15,
    ClientClosed: 16,
    ClientReceiveConfirm: 17
};
var $3703a02669f2055e$export$2e2bcd8739ae039 // ref: https://git.ringcentral.com/pjac/pjac/-/blob/master/pjac_fw/bl/telco/call_control_sip.py
 // ref: https://git.ringcentral.com/pjac/pjac/-/blob/master/pjac_fw/bl/telco/call_control/commands.py
 = $3703a02669f2055e$var$callControlCommands;


class $7b7a3e78869a6e83$var$InboundCallSession extends (0, $16bf732a0ad5f687$export$2e2bcd8739ae039) {
    constructor(webPhone, inviteMessage){
        super(webPhone);
        this.sipMessage = inviteMessage;
        this.localPeer = inviteMessage.headers.To;
        this.remotePeer = inviteMessage.headers.From;
        this.direction = "inbound";
        this.state = "ringing";
        this.emit("ringing");
    }
    // for inbound calls from call queue, there will be p-rc-api-call-info header:
    // p-rc-api-call-info: callAttributes=queue-call,reject;callerIdName=WIRELESS CALLER;displayInfo=queueName;displayInfoSub=callerIdName;queueName=Tyler's call queue
    get rcApiCallInfo() {
        return Object.fromEntries(this.sipMessage.headers["p-rc-api-call-info"].split(";").map((pair)=>pair.trim()).filter(Boolean).map((pair)=>{
            const [key, ...rest] = pair.split("=");
            return [
                key,
                rest.join("=")
            ]; // Handles '=' in value
        }));
    }
    async confirmReceive() {
        await this.sendRcMessage((0, $3703a02669f2055e$export$2e2bcd8739ae039).ClientReceiveConfirm);
    }
    async toVoicemail() {
        await this.sendRcMessage((0, $3703a02669f2055e$export$2e2bcd8739ae039).ClientVoicemail);
        // wait for outbound reply to CANCEL
        return new Promise((resolve)=>{
            const handler = (outboundMessage)=>{
                if (outboundMessage.headers["Call-Id"] === this.callId && outboundMessage.headers.CSeq.endsWith(" CANCEL")) {
                    this.webPhone.sipClient.off("outboundMessage", handler);
                    resolve();
                }
            };
            this.webPhone.sipClient.on("outboundMessage", handler);
        });
    }
    async decline() {
        await this.sendRcMessage((0, $3703a02669f2055e$export$2e2bcd8739ae039).ClientReject);
        // wait for outbound reply to CANCEL
        return new Promise((resolve)=>{
            const handler = (outboundMessage)=>{
                if (outboundMessage.headers["Call-Id"] === this.callId && outboundMessage.headers.CSeq.endsWith(" CANCEL")) {
                    this.webPhone.sipClient.off("outboundMessage", handler);
                    resolve();
                }
            };
            this.webPhone.sipClient.on("outboundMessage", handler);
        });
    }
    async forward(target) {
        await this.sendRcMessage((0, $3703a02669f2055e$export$2e2bcd8739ae039).ClientForward, {
            FwdDly: "0",
            Phn: target,
            PhnTp: "3"
        });
        // wait for the final SIP message
        return new Promise((resolve)=>{
            const handler = (inboundMessage)=>{
                if (inboundMessage.subject.startsWith("CANCEL sip:")) {
                    this.webPhone.sipClient.off("inboundMessage", handler);
                    resolve();
                }
            };
            this.webPhone.sipClient.on("inboundMessage", handler);
        });
    }
    async startReply() {
        await this.sendRcMessage((0, $3703a02669f2055e$export$2e2bcd8739ae039).ClientStartReply);
    }
    async reply(text) {
        await this.sendRcMessage((0, $3703a02669f2055e$export$2e2bcd8739ae039).ClientReply, {
            RepTp: "0",
            Bdy: text
        });
        return new Promise((resolve)=>{
            const sessionCloseHandler = async (inboundMessage)=>{
                if (inboundMessage.subject.startsWith("MESSAGE sip:")) {
                    const rcMessage = await (0, $f776a6c0a4c26253$export$2e2bcd8739ae039).fromXml(inboundMessage.body);
                    if (rcMessage.headers.Cmd === (0, $3703a02669f2055e$export$2e2bcd8739ae039).SessionClose.toString()) {
                        this.webPhone.sipClient.off("inboundMessage", sessionCloseHandler);
                        resolve(rcMessage);
                    // no need to dispose session here, session will dispose unpon CANCEL or BYE
                    }
                }
            };
            this.webPhone.sipClient.on("inboundMessage", sessionCloseHandler);
        });
    }
    async answer() {
        await this.init();
        await this.rtcPeerConnection.setRemoteDescription({
            type: "offer",
            sdp: this.sipMessage.body
        });
        const answer = await this.rtcPeerConnection.createAnswer();
        await this.rtcPeerConnection.setLocalDescription(answer);
        // wait for ICE gathering to complete
        await new Promise((resolve)=>{
            this.rtcPeerConnection.onicecandidate = (event)=>{
                if (event.candidate === null) resolve(true);
            };
            setTimeout(()=>resolve(false), 2000);
        });
        const newMessage = new (0, $a452ed8adb11ed02$export$2e2bcd8739ae039)(this.sipMessage, {
            responseCode: 200,
            headers: {
                "Content-Type": "application/sdp"
            },
            body: this.rtcPeerConnection.localDescription.sdp
        });
        await this.webPhone.sipClient.reply(newMessage);
        this.state = "answered";
        this.emit("answered");
        // wait for the final SIP message
        return new Promise((resolve)=>{
            const handler = async (inboundMessage)=>{
                if (inboundMessage.subject.startsWith("MESSAGE sip:")) {
                    const rcMessage = await (0, $f776a6c0a4c26253$export$2e2bcd8739ae039).fromXml(inboundMessage.body);
                    if (rcMessage.headers.Cmd === (0, $3703a02669f2055e$export$2e2bcd8739ae039).AlreadyProcessed.toString()) {
                        this.webPhone.sipClient.off("inboundMessage", handler);
                        resolve();
                    }
                }
            };
            this.webPhone.sipClient.on("inboundMessage", handler);
        });
    }
    async sendRcMessage(cmd, body = {}) {
        if (!this.sipMessage.headers["P-rc"]) return;
        const rcMessage = await (0, $f776a6c0a4c26253$export$2e2bcd8739ae039).fromXml(this.sipMessage.headers["P-rc"]);
        const newRcMessage = new (0, $f776a6c0a4c26253$export$2e2bcd8739ae039)({
            SID: rcMessage.headers.SID,
            Req: rcMessage.headers.Req,
            From: rcMessage.headers.To,
            To: rcMessage.headers.From,
            Cmd: cmd.toString()
        }, {
            Cln: this.webPhone.sipInfo.authorizationId,
            ...body
        });
        const requestSipMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`MESSAGE sip:${newRcMessage.headers.To} SIP/2.0`, {
            Via: `SIP/2.0/WSS ${(0, $52309f5c74e590bd$export$48c97aba3132ee25)};branch=${(0, $52309f5c74e590bd$export$7b927fb32d8824c0)()}`,
            To: `<sip:${newRcMessage.headers.To}>`,
            From: `<sip:${this.webPhone.sipInfo.username}@${this.webPhone.sipInfo.domain}>;tag=${(0, $52309f5c74e590bd$export$31b40729666a4ae0)()}`,
            "Call-Id": this.callId,
            "Content-Type": "x-rc/agent"
        }, newRcMessage.toXml());
        await this.webPhone.sipClient.request(requestSipMessage);
    }
}
var $7b7a3e78869a6e83$export$2e2bcd8739ae039 = $7b7a3e78869a6e83$var$InboundCallSession;





class $2558b0bb772ad55e$var$OutboundCallSession extends (0, $16bf732a0ad5f687$export$2e2bcd8739ae039) {
    constructor(webPhone, callee){
        super(webPhone);
        this.callee = callee;
        this.direction = "outbound";
    }
    callee;
    get remoteNumber() {
        return this.remotePeer ? super.remoteNumber : this.callee;
    }
    async call(callerId, options) {
        const offer = await this.rtcPeerConnection.createOffer({
            iceRestart: true
        });
        await this.rtcPeerConnection.setLocalDescription(offer);
        // wait for srflx ICE candidate or timeout after 2 seconds
        await new Promise((resolve)=>{
            const timeout = setTimeout(()=>{
                if (this.webPhone.options.debug) console.warn("srflx candidate not found within 2 seconds \u2014 proceeding anyway.");
                cleanup();
                resolve();
            }, 2000);
            const onIceCandidate = (event)=>{
                const candidate = event.candidate?.candidate;
                if (!candidate) return;
                if (candidate.includes("typ srflx")) {
                    cleanup();
                    setTimeout(()=>{
                        resolve();
                    }, 500); // extra 500ms after got srflx candidate
                }
            };
            const cleanup = ()=>{
                clearTimeout(timeout);
                this.rtcPeerConnection.removeEventListener("icecandidate", onIceCandidate);
            };
            this.rtcPeerConnection.addEventListener("icecandidate", onIceCandidate);
        });
        const inviteMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`INVITE sip:${this.callee}@${this.webPhone.sipInfo.domain} SIP/2.0`, {
            "Call-Id": this.callId,
            Contact: `<sip:${(0, $52309f5c74e590bd$export$f254005f6b69b424)};transport=wss>;expires=60`,
            From: `<sip:${this.webPhone.sipInfo.username}@${this.webPhone.sipInfo.domain}>;tag=${(0, $52309f5c74e590bd$export$31b40729666a4ae0)()}`,
            To: `<sip:${this.callee}@${this.webPhone.sipInfo.domain}>`,
            Via: `SIP/2.0/WSS ${(0, $52309f5c74e590bd$export$48c97aba3132ee25)};branch=${(0, $52309f5c74e590bd$export$7b927fb32d8824c0)()}`,
            "Content-Type": "application/sdp"
        }, this.rtcPeerConnection.localDescription.sdp);
        if (callerId) inviteMessage.headers["P-Asserted-Identity"] = `sip:${callerId}@${this.webPhone.sipInfo.domain}`;
        if (options?.headers) for (const [key, value] of Object.entries(options.headers))inviteMessage.headers[key] = value;
        const inboundMessage = await this.webPhone.sipClient.request(inviteMessage);
        if (inboundMessage.subject.startsWith("SIP/2.0 403 ")) // for exmaple, webPhone.sipRegister(0) has been called
        return;
        const proxyAuthenticate = inboundMessage.headers["Proxy-Authenticate"];
        const nonce = proxyAuthenticate.match(/, nonce="(.+?)"/)[1];
        const newMessage = inviteMessage.fork();
        newMessage.headers["Proxy-Authorization"] = (0, $52309f5c74e590bd$export$4111abda236aeb46)(this.webPhone.sipInfo, nonce, "INVITE");
        const progressMessage = await this.webPhone.sipClient.request(newMessage);
        this.sipMessage = progressMessage;
        this.state = "ringing";
        this.emit("ringing");
        this.localPeer = progressMessage.headers.From;
        this.remotePeer = progressMessage.headers.To;
        // wait for the call to be answered
        // by SIP server design, this happens immediately, even if the callee has not received the INVITE
        return new Promise((resolve)=>{
            const answerHandler = async (message)=>{
                if (message.headers.CSeq === this.sipMessage.headers.CSeq) {
                    this.webPhone.sipClient.off("inboundMessage", answerHandler);
                    // outbound call failed, for example, invalid number
                    // or emergency address is not configured properly
                    if (message.subject !== "SIP/2.0 200 OK") {
                        this.state = "failed";
                        this.emit("failed", message.subject);
                        const index = this.webPhone.callSessions.findIndex((callSession)=>callSession.callId === message.headers["Call-Id"]);
                        if (index !== -1) this.webPhone.callSessions.splice(index, 1);
                        this.dispose();
                        resolve(false);
                        return;
                    }
                    this.state = "answered";
                    this.emit("answered");
                    this.rtcPeerConnection.setRemoteDescription({
                        type: "answer",
                        sdp: message.body
                    });
                    const ackMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`ACK ${(0, $52309f5c74e590bd$export$d429661f837c42a9)(this.remotePeer)} SIP/2.0`, {
                        "Call-Id": this.callId,
                        From: this.localPeer,
                        To: this.remotePeer,
                        Via: this.sipMessage.headers.Via,
                        CSeq: this.sipMessage.headers.CSeq.replace(" INVITE", " ACK")
                    });
                    await this.webPhone.sipClient.reply(ackMessage);
                    resolve(true);
                }
            };
            this.webPhone.sipClient.on("inboundMessage", answerHandler);
        });
    }
    async cancel() {
        const requestMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`CANCEL ${(0, $52309f5c74e590bd$export$d429661f837c42a9)(this.remotePeer)} SIP/2.0`, {
            "Call-Id": this.callId,
            From: this.localPeer,
            To: (0, $52309f5c74e590bd$export$ad9200c3e391715b)(this.remotePeer),
            Via: this.sipMessage.headers.Via,
            CSeq: this.sipMessage.headers.CSeq.replace(" INVITE", " CANCEL")
        });
        await this.webPhone.sipClient.request(requestMessage);
    }
}
var $2558b0bb772ad55e$export$2e2bcd8739ae039 = $2558b0bb772ad55e$var$OutboundCallSession;






class $92ed019c192e88f8$var$InboundMessage extends (0, $326843f02ccd2b80$export$2e2bcd8739ae039) {
    static fromString(str) {
        const sipMessage = (0, $326843f02ccd2b80$export$2e2bcd8739ae039).fromString(str);
        sipMessage.direction = "inbound";
        return sipMessage;
    }
}
var $92ed019c192e88f8$export$2e2bcd8739ae039 = $92ed019c192e88f8$var$InboundMessage;





const $82532831765006b4$var$maxExpires = 60;
class $82532831765006b4$export$74fd6c9f12f878c9 extends (0, $565780c60ea1e116$export$2e2bcd8739ae039) {
    disposed = false;
    wsc;
    sipInfo;
    instanceId;
    debug;
    timeoutHandle;
    constructor(options){
        super();
        this.sipInfo = options.sipInfo;
        this.instanceId = options.instanceId ?? this.sipInfo.authorizationId;
        this.debug = options.debug ?? false;
    }
    async start() {
        await this.connect();
        if (this.timeoutHandle) clearInterval(this.timeoutHandle);
        await this.register($82532831765006b4$var$maxExpires);
    }
    useBackupOutboundProxy = false;
    toggleBackupOutboundProxy(enabled = true) {
        this.useBackupOutboundProxy = enabled;
    }
    connect() {
        this.wsc = new WebSocket("wss://" + (this.useBackupOutboundProxy ? this.sipInfo.outboundProxyBackup : this.sipInfo.outboundProxy), "sip");
        if (this.debug) {
            const wscSend = this.wsc.send.bind(this.wsc);
            this.wsc.send = (message)=>{
                console.log(`Sending...(${new Date()})\n` + message);
                return wscSend(message);
            };
        }
        this.wsc.addEventListener("message", async (event)=>{
            const inboundMessage = (0, $92ed019c192e88f8$export$2e2bcd8739ae039).fromString(event.data);
            if (inboundMessage.subject.startsWith("MESSAGE sip:")) {
                const rcMessage = await (0, $f776a6c0a4c26253$export$2e2bcd8739ae039).fromXml(inboundMessage.body);
                if (rcMessage.body.Cln && rcMessage.body.Cln !== this.sipInfo.authorizationId) return; // the message is not for this instance
            }
            if (this.debug) console.log(`Receiving...(${new Date()})\n` + event.data);
            this.emit("inboundMessage", inboundMessage);
            if (inboundMessage.subject.startsWith("MESSAGE sip:") || inboundMessage.subject.startsWith("BYE sip:") || inboundMessage.subject.startsWith("CANCEL sip:") || inboundMessage.subject.startsWith("INFO sip:") || inboundMessage.subject.startsWith("NOTIFY sip:")) // Auto reply 200 OK to MESSAGE, BYE, CANCEL, INFO, NOTIFY
            await this.reply(new (0, $a452ed8adb11ed02$export$2e2bcd8739ae039)(inboundMessage, {
                responseCode: 200
            }));
        });
        return new Promise((resolve, reject)=>{
            const openEventHandler = ()=>{
                this.wsc.removeEventListener("open", openEventHandler);
                resolve();
            };
            this.wsc.addEventListener("open", openEventHandler);
            const errorEventHandler = (e)=>{
                this.wsc.removeEventListener("error", errorEventHandler);
                reject(e);
            };
            this.wsc.addEventListener("error", errorEventHandler);
        });
    }
    async dispose() {
        this.disposed = true;
        clearInterval(this.timeoutHandle);
        this.removeAllListeners();
        await this.unregister();
        this.wsc.close();
    }
    async register(expires) {
        const requestMessage = new (0, $e650efb9cb671aab$export$2e2bcd8739ae039)(`REGISTER sip:${this.sipInfo.domain} SIP/2.0`, {
            "Call-Id": (0, $52309f5c74e590bd$export$31b40729666a4ae0)(),
            Contact: `<sip:${(0, $52309f5c74e590bd$export$f254005f6b69b424)};transport=wss>;+sip.instance="<urn:uuid:${this.instanceId}>";expires=${expires}`,
            From: `<sip:${this.sipInfo.username}@${this.sipInfo.domain}>;tag=${(0, $52309f5c74e590bd$export$31b40729666a4ae0)()}`,
            To: `<sip:${this.sipInfo.username}@${this.sipInfo.domain}>`,
            Via: `SIP/2.0/WSS ${(0, $52309f5c74e590bd$export$48c97aba3132ee25)};branch=${(0, $52309f5c74e590bd$export$7b927fb32d8824c0)()}`
        });
        // if cannot get response in 5 seconds, we close the connection
        const closeHandle = setTimeout(()=>this.wsc.close(), 5000);
        let inboundMessage = await this.request(requestMessage);
        clearTimeout(closeHandle);
        const wwwAuth = inboundMessage.headers["Www-Authenticate"] || inboundMessage.headers["WWW-Authenticate"];
        if (wwwAuth) {
            const nonce = wwwAuth.match(/, nonce="(.+?)"/)[1];
            const newMessage = requestMessage.fork();
            newMessage.headers.Authorization = (0, $52309f5c74e590bd$export$4111abda236aeb46)(this.sipInfo, nonce, "REGISTER");
            inboundMessage = await this.request(newMessage);
        } else if (inboundMessage.subject.startsWith("SIP/2.0 603 ")) throw new Error("Registration failed: " + inboundMessage.subject);
        if (expires > 0) {
            const serverExpires = Number(inboundMessage.headers.Contact.match(/;expires=(\d+)/)[1]);
            this.timeoutHandle = setTimeout(()=>{
                this.register(expires);
            }, (serverExpires - 3) * 1000);
        }
    }
    async unregister() {
        await this.register(0);
    }
    async request(message) {
        return await this.send(message, true);
    }
    async reply(message) {
        await this.send(message, false);
    }
    send(message, waitForReply = false) {
        this.wsc.send(message.toString());
        this.emit("outboundMessage", message);
        if (!waitForReply) return new Promise((resolve)=>{
            resolve(new (0, $92ed019c192e88f8$export$2e2bcd8739ae039)());
        });
        return new Promise((resolve)=>{
            const messageListerner = (inboundMessage)=>{
                if (inboundMessage.headers.CSeq !== message.headers.CSeq) return;
                if (inboundMessage.subject.startsWith("SIP/2.0 100 ")) return; // ignore
                this.off("inboundMessage", messageListerner);
                resolve(inboundMessage);
            };
            this.on("inboundMessage", messageListerner);
        });
    }
}
class $82532831765006b4$export$522641d9c156bd3b extends (0, $565780c60ea1e116$export$2e2bcd8739ae039) {
    static inboundMessage = new (0, $92ed019c192e88f8$export$2e2bcd8739ae039)();
    disposed = false;
    wsc;
    constructor(){
        super();
    }
    async start() {}
    request() {
        return Promise.resolve($82532831765006b4$export$522641d9c156bd3b.inboundMessage);
    }
    async reply() {}
    dispose() {
        this.disposed = true;
        return Promise.resolve();
    }
}


class $ebff31a317454e83$export$dbdb65e3a3669dea {
    async getInputDeviceId() {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const defaultInputDevice = devices.find((device)=>device.kind === "audioinput");
        return defaultInputDevice.deviceId;
    }
    async getOutputDeviceId() {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const defaultOutputDevice = devices.find((device)=>device.kind === "audiooutput");
        return defaultOutputDevice?.deviceId;
    }
}


(0, $f1b1811a0002602d$export$2e2bcd8739ae039).init("8d34a0fbc54a5560463ea7b72f235629", {
    autocapture: false
});
class $b6655b667f48e5f0$var$WebPhone extends (0, $565780c60ea1e116$export$2e2bcd8739ae039) {
    sipInfo;
    sipClient;
    deviceManager;
    callSessions = [];
    autoAnswer = false;
    options;
    disposed = false;
    constructor(options){
        (0, $f1b1811a0002602d$export$2e2bcd8739ae039).identify(options.sipInfo.username);
        (0, $f1b1811a0002602d$export$2e2bcd8739ae039).track("init", {
            distinct_id: options.sipInfo.username,
            version: "2.2.3"
        });
        super();
        this.options = options;
        this.sipInfo = options.sipInfo;
        this.sipClient = options.sipClient ?? new (0, $82532831765006b4$export$74fd6c9f12f878c9)(options);
        this.deviceManager = options.deviceManager ?? new (0, $ebff31a317454e83$export$dbdb65e3a3669dea)();
        this.autoAnswer = options.autoAnswer ?? false;
        this.sipClient.on("inboundMessage", async (inboundMessage)=>{
            // either inbound BYE/CANCEL or server reply to outbound BYE/CANCEL
            if (inboundMessage.headers.CSeq.endsWith(" BYE") || inboundMessage.headers.CSeq.endsWith(" CANCEL")) {
                const index = this.callSessions.findIndex((callSession)=>callSession.callId === inboundMessage.headers["Call-Id"]);
                if (index !== -1) {
                    const callSession = this.callSessions[index];
                    this.callSessions.splice(index, 1);
                    callSession.dispose();
                }
            }
            // listen for incoming calls
            if (!inboundMessage.subject.startsWith("INVITE sip:")) return;
            // re-INVITE
            const callSession = this.callSessions.find((callSession)=>{
                return callSession.callId === inboundMessage.headers["Call-Id"] && callSession.localPeer === inboundMessage.headers.To && callSession.remotePeer === inboundMessage.headers.From;
            });
            if (callSession) {
                callSession.handleReInvite(inboundMessage);
                return;
            }
            this.callSessions.push(new (0, $7b7a3e78869a6e83$export$2e2bcd8739ae039)(this, inboundMessage));
            // write it this way so that it will be compatible with manate, inboundCallSession will be managed
            const inboundCallSession = this.callSessions[this.callSessions.length - 1];
            this.emit("inboundCall", inboundCallSession);
            // tell SIP server that we are ringing
            let tempMesage = new (0, $a452ed8adb11ed02$export$2e2bcd8739ae039)(inboundMessage, {
                responseCode: 100
            });
            await this.sipClient.reply(tempMesage);
            tempMesage = new (0, $a452ed8adb11ed02$export$2e2bcd8739ae039)(inboundMessage, {
                responseCode: 180
            });
            await this.sipClient.reply(tempMesage);
            // if we don't send this, toVoicemail() will not work
            await inboundCallSession.confirmReceive();
            // auto answer
            if (!this.autoAnswer) return;
            if (inboundCallSession.sipMessage.headers["Alert-Info"] !== "Auto Answer") return;
            let delay = 0;
            const callInfoHeader = inboundCallSession.sipMessage.headers["Call-Info"];
            if (callInfoHeader) {
                const match = callInfoHeader.match(/Answer-After=(\d+)/);
                if (match) delay = parseInt(match[1], 10); // Convert the captured value to an integer
            }
            setTimeout(()=>{
                inboundCallSession.answer();
            }, delay);
        });
    }
    async start() {
        await this.sipClient.start();
    }
    async dispose() {
        this.disposed = true;
        // properly dispose all call sessions
        for (const callSession of this.callSessions){
            if (callSession.state === "answered") await callSession.hangup();
            else if (callSession.direction === "inbound") await callSession.decline();
            else await callSession.cancel();
        // callSession.dispose() will be auto triggered by the above methods
        }
        this.removeAllListeners();
        await this.sipClient.dispose();
    }
    // make an outbound call
    async call(callee, callerId, options) {
        this.callSessions.push(new (0, $2558b0bb772ad55e$export$2e2bcd8739ae039)(this, callee));
        // write it this way so that it will be compatible with manate, outboundCallSession will be managed
        const outboundCallSession = this.callSessions[this.callSessions.length - 1];
        this.emit("outboundCall", outboundCallSession);
        await outboundCallSession.init();
        await outboundCallSession.call(callerId, options);
        return outboundCallSession;
    }
}
var $b6655b667f48e5f0$export$2e2bcd8739ae039 = $b6655b667f48e5f0$var$WebPhone;


const $1554c0e3d026a77f$var$defaultOptions = {
    interval: 100,
    condition: ()=>true,
    times: Infinity
};
/**
 * Wait for `condition()` to be `true`.
 * Its value is checked every `interval` milliseconds,
 * check no more than `times` intervals in total.
 * @param waitForOptions check the docs for `WaitForOptions`.
 * @returns Whenever `condition()` becomes `true`, return `true`.
 * If `condition()` never becomes `true` until `times` intervals passed, return `false`.
 */ const $1554c0e3d026a77f$var$waitFor = (waitForOptions)=>{
    const { interval: interval, condition: condition, times: times } = {
        ...$1554c0e3d026a77f$var$defaultOptions,
        ...waitForOptions
    };
    return new Promise((resolve)=>{
        let count = 0;
        const handle = setInterval(()=>{
            if (condition()) {
                clearInterval(handle);
                resolve(true);
            }
            count += 1;
            if (count >= times) {
                clearInterval(handle);
                resolve(false);
            }
        }, interval);
    });
};
var $1554c0e3d026a77f$export$2e2bcd8739ae039 = $1554c0e3d026a77f$var$waitFor;



class $3620b7457624a119$export$17aca3242e29300c {
    setPreferredInputDeviceKeyword(keyword = "AirPods") {
        this._preferredInputDeviceKeyword = keyword;
    }
    setPreferredOutputDeviceKeyword(keyword = "AirPods") {
        this._preferredOutputDeviceKeyword = keyword;
    }
    async getInputDeviceId() {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioDevices = devices.filter((device)=>device.kind === "audioinput");
        let preferredDevice = audioDevices.find((device)=>device.label.includes(this._preferredInputDeviceKeyword));
        if (!preferredDevice && audioDevices.length > 0) preferredDevice = audioDevices[0];
        return preferredDevice.deviceId;
    }
    async getOutputDeviceId() {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioDevices = devices.filter((device)=>device.kind === "audiooutput");
        let preferredDevice = audioDevices.find((device)=>device.label.includes(this._preferredOutputDeviceKeyword));
        if (!preferredDevice && audioDevices.length > 0) preferredDevice = audioDevices[0];
        return preferredDevice?.deviceId;
    }
    constructor(){
        this._preferredInputDeviceKeyword = "AirPods";
        this._preferredOutputDeviceKeyword = "AirPods";
    }
}



const $b4ef3299fe14c7b5$var$uuid = (0, (/*@__PURE__*/$parcel$interopDefault($28cb323e84e8519a$exports)))();
// local utility function
const $b4ef3299fe14c7b5$var$trimPrefix = (s, prefix)=>{
    if (s.startsWith(prefix)) return s.slice(prefix.length);
    return s;
};
const $b4ef3299fe14c7b5$var$afterLogin = async ()=>{
    if ((0, $505741c010a7fc0c$export$2e2bcd8739ae039).rcToken === "") return;
    const rc = new (0, $c5c4d7a0138a22c4$export$2e2bcd8739ae039)();
    rc.token = {
        access_token: (0, $505741c010a7fc0c$export$2e2bcd8739ae039).rcToken,
        refresh_token: (0, $505741c010a7fc0c$export$2e2bcd8739ae039).refreshToken
    };
    // fetch extension and phone number info
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).extInfo = await rc.restapi().account().extension().get();
    const numberList = await rc.restapi().account().extension().phoneNumber().get();
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).primaryNumber = $b4ef3299fe14c7b5$var$trimPrefix(numberList.records?.find((n)=>n.primary)?.phoneNumber ?? "", "+");
    if ((0, $505741c010a7fc0c$export$2e2bcd8739ae039).primaryNumber !== "") (0, $505741c010a7fc0c$export$2e2bcd8739ae039).callerIds.push((0, $505741c010a7fc0c$export$2e2bcd8739ae039).primaryNumber);
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).callerIds = [
        ...(0, $505741c010a7fc0c$export$2e2bcd8739ae039).callerIds,
        ...numberList.records?.filter((n)=>!n.primary).filter((n)=>n.features?.includes("CallerId")).map((n)=>$b4ef3299fe14c7b5$var$trimPrefix(n.phoneNumber, "+")) ?? []
    ];
    // create and initialize a web phone
    const cacheKey = `rc-${(0, $505741c010a7fc0c$export$2e2bcd8739ae039).extInfo.id}`;
    let sipInfo = await (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).getItem(`${cacheKey}-sipInfo`);
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).deviceId = await (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).getItem(`${cacheKey}-deviceId`) ?? "";
    if (sipInfo === null) {
        console.log("Genereate new sipInfo");
        const r = await rc.restapi().clientInfo().sipProvision().post({
            sipInfo: [
                {
                    transport: "WSS"
                }
            ]
        });
        sipInfo = r.sipInfo[0];
        (0, $505741c010a7fc0c$export$2e2bcd8739ae039).deviceId = r.device.id;
        await (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).setItem(`${cacheKey}-sipInfo`, sipInfo);
        await (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).setItem(`${cacheKey}-deviceId`, (0, $505741c010a7fc0c$export$2e2bcd8739ae039).deviceId);
    } else console.log("Use cached sipInfo");
    console.log("deviceId:", (0, $505741c010a7fc0c$export$2e2bcd8739ae039).deviceId);
    const deviceManager = new (0, $3620b7457624a119$export$17aca3242e29300c)();
    deviceManager.setPreferredInputDeviceKeyword("MacBook"); // or AirPods, Headphones, etc.
    deviceManager.setPreferredOutputDeviceKeyword("MacBook"); // or AirPods, Headphones, etc.
    class MySipClient extends (0, $82532831765006b4$export$74fd6c9f12f878c9) {
        constructor(options){
            super(options);
        }
        send(message, waitForReply = false) {
            message.headers["Custom-Header"] = "CustomHeaderValue";
            return super.send(message, waitForReply);
        }
    }
    const options = {
        sipInfo: sipInfo,
        instanceId: "a-static-instance-id",
        // instanceId: uuid(), // It may not be the best way to always specify a new instanceId, please read https://github.com/ringcentral/ringcentral-web-phone?tab=readme-ov-file#instanceid
        debug: true,
        autoAnswer: true,
        deviceManager: deviceManager
    };
    options.sipClient = new MySipClient(options);
    const webPhone = new (0, $b6655b667f48e5f0$export$2e2bcd8739ae039)(options);
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).webPhone = webPhone;
    await webPhone.start();
    // display a message when outbound call failed:
    webPhone.on("outboundCall", (callSession)=>{
        callSession.once("failed", (message)=>{
            globalThis.notifier.error({
                message: "Outbound call failed",
                description: message,
                duration: 10
            });
        });
    });
    const recover = async ()=>{
        await webPhone.start();
        webPhone.callSessions.forEach((callSession)=>{
            if (callSession.state === "answered") // in case network switches from one to another
            callSession.reInvite();
        });
    };
    // handle network outage
    globalThis.addEventListener("online", async ()=>{
        await recover();
    });
    // handle network issues
    const closeListener = async (e)=>{
        webPhone.sipClient.wsc.removeEventListener("close", closeListener);
        if (webPhone.disposed) // webPhone.dispose() has been called, no need to reconnect
        return;
        console.log("WebSocket disconnected unexpectedly", e);
        let connected = false;
        let delay = 2000; // initial delay
        while(!connected){
            console.log(`Reconnect WebSocket in ${delay / 1000} seconds`);
            await (0, $1554c0e3d026a77f$export$2e2bcd8739ae039)({
                interval: delay
            });
            try {
                await recover();
                connected = true;
            } catch (e) {
                console.log("Error connecting to WebSocket", e);
                delay *= 2; // exponential backoff
                delay = Math.min(delay, 60000); // max delay 60s
            }
        }
        // because webPhone.start() will create a new webPhone.sipClient.wsc
        webPhone.sipClient.wsc.addEventListener("close", closeListener);
    };
    webPhone.sipClient.wsc.addEventListener("close", closeListener);
};
var $b4ef3299fe14c7b5$export$2e2bcd8739ae039 = $b4ef3299fe14c7b5$var$afterLogin;


class $505741c010a7fc0c$export$390f32400eaf98c9 {
    async logout() {
        const rc = new (0, $c5c4d7a0138a22c4$export$2e2bcd8739ae039)({
            server: this.server,
            clientId: this.clientId,
            clientSecret: this.clientSecret
        });
        rc.token = {
            access_token: this.rcToken,
            refresh_token: this.refreshToken
        };
        await rc.revoke();
        this.rcToken = "";
        this.refreshToken = "";
        location.reload();
    }
    async jwtFlow() {
        if (this.server === "" || this.clientId === "" || this.clientSecret === "" || this.jwtToken === "") {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Please input server, client ID, client secret and JWT token");
            return;
        }
        const rc = new (0, $c5c4d7a0138a22c4$export$2e2bcd8739ae039)({
            server: this.server,
            clientId: this.clientId,
            clientSecret: this.clientSecret
        });
        try {
            const token = await rc.authorize({
                jwt: this.jwtToken
            });
            this.rcToken = token.access_token;
            this.refreshToken = token.refresh_token;
            (0, $b4ef3299fe14c7b5$export$2e2bcd8739ae039)();
        } catch (e) {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).open({
                duration: 10,
                type: "error",
                content: e.message
            });
        }
    }
    async authCodeFlow() {
        if (this.server === "" || this.clientId === "") {
            (0, $dc31f36873c2f472$export$2e2bcd8739ae039).error("Please input server and client ID");
            return;
        }
        const rc = new (0, $c5c4d7a0138a22c4$export$2e2bcd8739ae039)({
            server: this.server,
            clientId: this.clientId,
            clientSecret: this.clientSecret
        });
        const authorizeUriExtension = new (0, $dcd0d97cc310fbf6$export$2e2bcd8739ae039)();
        await rc.installExtension(authorizeUriExtension);
        const authorizeUri = await authorizeUriExtension.buildUri({
            code_challenge_method: "S256",
            redirect_uri: globalThis.location.origin + globalThis.location.pathname + "callback.html"
        });
        globalThis.open(authorizeUri, "popupWindow", `width=600,height=600,left=${globalThis.screenX + 256},top=${globalThis.screenY + 128}`);
        globalThis.addEventListener("message", async (event)=>{
            if (event.data.source === "oauth-callback") {
                const token = await rc.authorize({
                    code: event.data.code,
                    redirect_uri: globalThis.location.origin + globalThis.location.pathname + "callback.html",
                    code_verifier: authorizeUriExtension.codeVerifier
                });
                this.rcToken = token.access_token;
                this.refreshToken = token.refresh_token;
                (0, $b4ef3299fe14c7b5$export$2e2bcd8739ae039)();
            }
        });
    }
    // start a new conference
    async startConference() {
        const rc = new (0, $c5c4d7a0138a22c4$export$2e2bcd8739ae039)({
            server: this.server
        });
        rc.token = {
            access_token: this.rcToken
        };
        const r = await rc.restapi().account().telephony().conference().post();
        await this.webPhone.call(r.session.voiceCallToken);
    }
    // invite a number to an existing conference
    async inviteToConference(targetNumber) {
        const confSession = this.webPhone.callSessions.find((cs)=>cs.isConference);
        if (!confSession) return;
        const callSession = await this.webPhone.call(targetNumber);
        const rc = new (0, $c5c4d7a0138a22c4$export$2e2bcd8739ae039)({
            server: this.server
        });
        rc.token = {
            access_token: this.rcToken
        };
        await rc.restapi().account().telephony().sessions(confSession.sessionId).parties().bringIn().post({
            sessionId: callSession.sessionId,
            partyId: callSession.partyId
        });
    }
    // merge an existing call session to an existing conference
    async mergeToConference(callSession) {
        const confSession = this.webPhone.callSessions.find((cs)=>cs.isConference);
        if (!confSession) return;
        const rc = new (0, $c5c4d7a0138a22c4$export$2e2bcd8739ae039)({
            server: this.server
        });
        rc.token = {
            access_token: this.rcToken
        };
        await rc.restapi().account().telephony().sessions(confSession.sessionId).parties().bringIn().post({
            sessionId: callSession.sessionId,
            partyId: callSession.partyId
        });
    }
    //***************************
    // Below are control APIs
    // they are for demonstration only
    // they are not part of WebPhone SDK
    //***************************
    // use call control API to answer an incoming call
    // this is not needed. because you can simply call session.answer()
    // so this is for demonstration only
    async callControlAnswer(session) {
        const rc = new (0, $c5c4d7a0138a22c4$export$2e2bcd8739ae039)({
            server: this.server
        });
        rc.token = {
            access_token: this.rcToken
        };
        await rc.restapi().account().telephony().sessions(session.sessionId).parties(session.partyId).answer().post({
            deviceId: this.deviceId
        });
    }
    // use call control API to make a call out
    // this is not needed. because you can simply call webPhone.call(toNumber)
    // so this is for demonstration only
    async callout(toNumber) {
        const rc = new (0, $c5c4d7a0138a22c4$export$2e2bcd8739ae039)({
            server: this.server
        });
        rc.token = {
            access_token: this.rcToken
        };
        await rc.restapi().account().telephony().callOut().post({
            from: {
                deviceId: this.deviceId
            },
            to: {
                phoneNumber: toNumber
            }
        });
    }
    constructor(){
        this.rcToken = "";
        this.refreshToken = "";
        this.server = "https://platform.ringcentral.com";
        this.clientId = "";
        this.clientSecret = "";
        this.jwtToken = "";
        this.primaryNumber = "";
        this.callerIds = [];
        this.deviceId = "";
    }
}
const $505741c010a7fc0c$var$store = (0, $b1599b8ade248f1d$export$aef2f541c13a9f3a)(new $505741c010a7fc0c$export$390f32400eaf98c9());
globalThis.store = $505741c010a7fc0c$var$store; // for debugging
var $505741c010a7fc0c$export$2e2bcd8739ae039 = $505741c010a7fc0c$var$store;


const $79b64517cc489373$var$AnsweredSession = (0, $9d5e52e8f220d71a$export$dfb5619354ba860)((props)=>{
    const { session: session } = props;
    const [transferPopoverVisible, setTransferPopoverVisible] = (0, $acw62.useState)(false);
    const [transferToNumber, setTransferToNumber] = (0, $acw62.useState)("");
    const [flipPopoverVisible, setFlipPopoverVisible] = (0, $acw62.useState)(false);
    const [flipToNumber, setFlipToNumber] = (0, $acw62.useState)("");
    const [dtmfPopoverVisible, setDtmfPopoverVisible] = (0, $acw62.useState)(false);
    const [dtmfString, setDtmfString] = (0, $acw62.useState)("");
    const [inviteToConfPopoverVisible, setInviteToConfPopoverVisible] = (0, $acw62.useState)(false);
    const [inviteToConfNumber, setInviteToConfNumber] = (0, $acw62.useState)("");
    const [warmTransferMethods, setWarmTransferMethods] = (0, $acw62.useState)(undefined);
    const [devices, setDevices] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        const fetchDevices = async ()=>{
            const newDevices = await navigator.mediaDevices.enumerateDevices();
            if (newDevices.map((d)=>d.deviceId).join("|") !== devices.map((d)=>d.deviceId).join("|")) setDevices(newDevices);
        };
        fetchDevices();
        const handler = setInterval(fetchDevices, 10000);
        return ()=>clearInterval(handler);
    }, [
        devices
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
        wrap: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                onClick: ()=>session.hangup(),
                danger: true,
                children: session.isConference ? "End Conference" : "Hang up"
            }),
            !session.isConference && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50a5b629c434844e$export$2e2bcd8739ae039), {
                open: transferPopoverVisible,
                onOpenChange: (visible)=>setTransferPopoverVisible(visible),
                trigger: "click",
                placement: "top",
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                    direction: "vertical",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                            placeholder: "16501234567",
                            value: transferToNumber,
                            onChange: (e)=>setTransferToNumber(e.target.value.trim())
                        }),
                        warmTransferMethods && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        warmTransferMethods.complete();
                                        setWarmTransferMethods(undefined);
                                        setTransferPopoverVisible(false);
                                    },
                                    children: "Complete"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        warmTransferMethods.cancel();
                                        setWarmTransferMethods(undefined);
                                        setTransferPopoverVisible(false);
                                    },
                                    children: "Cancel"
                                })
                            ]
                        }),
                        !warmTransferMethods && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        session.transfer(transferToNumber);
                                        setTransferPopoverVisible(false);
                                    },
                                    children: "Transfer"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    onClick: async ()=>{
                                        const { complete: complete, cancel: cancel } = await session.warmTransfer(transferToNumber);
                                        setWarmTransferMethods({
                                            complete: complete,
                                            cancel: cancel
                                        });
                                    },
                                    children: "Warm Transer"
                                })
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    children: "Transfer"
                })
            }),
            !session.isConference && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50a5b629c434844e$export$2e2bcd8739ae039), {
                open: flipPopoverVisible,
                onOpenChange: (visible)=>setFlipPopoverVisible(visible),
                trigger: "click",
                placement: "top",
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                    direction: "vertical",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                            placeholder: "16501234567",
                            value: flipToNumber,
                            onChange: (e)=>setFlipToNumber(e.target.value.trim())
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                session.flip(flipToNumber);
                                setFlipPopoverVisible(false);
                            },
                            children: "Flip"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    children: "Flip"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                onClick: ()=>session.startRecording(),
                children: "Start Recording"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                onClick: ()=>session.stopRecording(),
                children: "Stop Recording"
            }),
            !session.isConference && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        onClick: ()=>session.hold(),
                        children: "Hold"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        onClick: ()=>session.unhold(),
                        children: "Unhold"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                onClick: ()=>session.mute(),
                children: "Mute"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                onClick: ()=>session.unmute(),
                children: "Unmute"
            }),
            !session.isConference && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                onClick: async ()=>{
                    const result = await session.park();
                    globalThis.notifier.info({
                        message: "Call Park Result",
                        description: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                            children: JSON.stringify(result, null, 2)
                        }),
                        duration: 10
                    });
                },
                children: "Park"
            }),
            !session.isConference && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50a5b629c434844e$export$2e2bcd8739ae039), {
                open: dtmfPopoverVisible,
                onOpenChange: (visible)=>setDtmfPopoverVisible(visible),
                trigger: "click",
                placement: "top",
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                    direction: "vertical",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                            placeholder: "123#",
                            value: dtmfString,
                            onChange: (e)=>setDtmfString(e.target.value.trim())
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                session.sendDtmf(dtmfString);
                                setDtmfString("");
                                setDtmfPopoverVisible(false);
                            },
                            children: "Send"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    children: "Send DTMF"
                })
            }),
            !session.isConference && (0, $505741c010a7fc0c$export$2e2bcd8739ae039).webPhone.callSessions.find((s)=>s.isConference) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).mergeToConference(session);
                },
                children: "Merge to Conference"
            }),
            session.isConference && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50a5b629c434844e$export$2e2bcd8739ae039), {
                open: inviteToConfPopoverVisible,
                onOpenChange: (visible)=>setInviteToConfPopoverVisible(visible),
                trigger: "click",
                placement: "top",
                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                    direction: "vertical",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                            placeholder: "16506668888",
                            value: inviteToConfNumber,
                            onChange: (e)=>setInviteToConfNumber(e.target.value.trim())
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                (0, $505741c010a7fc0c$export$2e2bcd8739ae039).inviteToConference(inviteToConfNumber);
                                setInviteToConfNumber("");
                                setInviteToConfPopoverVisible(false);
                            },
                            children: "Invite"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    type: "primary",
                    children: "Invite to Conference"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                options: devices.filter((d)=>d.kind === "audioinput").map((d)=>({
                        value: d.deviceId,
                        label: d.label
                    })),
                value: session.inputDeviceId,
                onChange: (value)=>{
                    session.changeInputDevice(value);
                },
                style: {
                    width: 256
                }
            }),
            devices.filter((d)=>d.kind === "audiooutput").length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                options: devices.filter((d)=>d.kind === "audiooutput").map((d)=>({
                        value: d.deviceId,
                        label: d.label
                    })),
                value: session.outputDeviceId,
                onChange: (value)=>{
                    session.changeOutputDevice(value);
                },
                style: {
                    width: 256
                }
            })
        ]
    });
});
var $79b64517cc489373$export$2e2bcd8739ae039 = $79b64517cc489373$var$AnsweredSession;


const $3991fb5e9958a897$var$InboundSession = (0, $9d5e52e8f220d71a$export$dfb5619354ba860)((props)=>{
    const { session: session } = props;
    const [forwardPopoverVisible, setForwardPopoverVisible] = (0, $acw62.useState)(false);
    const [forwardToNumber, setForwardToNumber] = (0, $acw62.useState)("");
    const [replyPopoverVisible, setReplyPopoverVisible] = (0, $acw62.useState)(false);
    const [replyText, setReplyText] = (0, $acw62.useState)("On my way");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
        direction: "vertical",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: session.direction
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "call from"
                    }),
                    session.remoteNumber,
                    " to",
                    session.localNumber,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91f0876852f6510f$export$2e2bcd8739ae039), {
                        color: "blue",
                        children: session.state
                    })
                ]
            }),
            session.state === "ringing" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        onClick: ()=>session.answer(),
                        type: "primary",
                        children: "Answer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        onClick: ()=>session.toVoicemail(),
                        children: "To Voicemail"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50a5b629c434844e$export$2e2bcd8739ae039), {
                        open: forwardPopoverVisible,
                        onOpenChange: (visible)=>setForwardPopoverVisible(visible),
                        trigger: "click",
                        placement: "top",
                        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            direction: "vertical",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                    placeholder: "16501234567",
                                    value: forwardToNumber,
                                    onChange: (e)=>setForwardToNumber(e.target.value.trim())
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        session.forward(forwardToNumber);
                                        setForwardPopoverVisible(false);
                                    },
                                    children: "Forward"
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            children: "Forward"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50a5b629c434844e$export$2e2bcd8739ae039), {
                        open: replyPopoverVisible,
                        onOpenChange: (visible)=>{
                            setReplyPopoverVisible(visible);
                            if (visible) session.startReply();
                        },
                        trigger: "click",
                        placement: "top",
                        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            direction: "vertical",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                    placeholder: "16501234567",
                                    value: replyText,
                                    onChange: (e)=>setReplyText(e.target.value.trim())
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    onClick: async ()=>{
                                        setReplyPopoverVisible(false);
                                        const response = await session.reply(replyText);
                                        if (response.body.Sts === "0") {
                                            const message = `${response.body.Phn} ${response.body.Nm}`;
                                            let description = "";
                                            switch(response.body.Resp){
                                                case "1":
                                                    description = "Yes";
                                                    break;
                                                case "2":
                                                    description = "No";
                                                    break;
                                                case "3":
                                                    description = `Urgent, please call ${response.body.ExtNfo} immediately!`;
                                                    break;
                                                default:
                                                    break;
                                            }
                                            globalThis.notifier.info({
                                                message: message,
                                                description: description,
                                                duration: 0
                                            });
                                        }
                                    },
                                    children: "Reply"
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            children: "Reply"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        onClick: ()=>session.decline(),
                        danger: true,
                        children: "Decline"
                    })
                ]
            }) : null,
            session.state === "answered" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79b64517cc489373$export$2e2bcd8739ae039), {
                session: session
            }) : null
        ]
    });
});
var $3991fb5e9958a897$export$2e2bcd8739ae039 = $3991fb5e9958a897$var$InboundSession;





parcelRequire("acw62");

const $2026755982c9c08d$var$OutboundSession = (0, $9d5e52e8f220d71a$export$dfb5619354ba860)((props)=>{
    const { session: session } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
        direction: "vertical",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        children: session.direction
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "call from"
                    }),
                    session.localNumber,
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "to"
                    }),
                    session.isConference ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91f0876852f6510f$export$2e2bcd8739ae039), {
                        color: "red",
                        children: "Conference"
                    }) : session.remoteNumber,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91f0876852f6510f$export$2e2bcd8739ae039), {
                        color: "blue",
                        children: session.state
                    })
                ]
            }),
            session.state === "answered" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79b64517cc489373$export$2e2bcd8739ae039), {
                session: session
            }) : null
        ]
    });
});
var $2026755982c9c08d$export$2e2bcd8739ae039 = $2026755982c9c08d$var$OutboundSession;


const $c98ebc86ec71d41a$var$Session = (0, $9d5e52e8f220d71a$export$dfb5619354ba860)((props)=>{
    const { callSession: callSession } = props;
    return callSession.direction === "inbound" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3991fb5e9958a897$export$2e2bcd8739ae039), {
        session: callSession
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2026755982c9c08d$export$2e2bcd8739ae039), {
        session: callSession
    });
});
var $c98ebc86ec71d41a$export$2e2bcd8739ae039 = $c98ebc86ec71d41a$var$Session;


const $338fbb5c0bbf24ff$var$Phone = (0, $9d5e52e8f220d71a$export$dfb5619354ba860)((props)=>{
    const { store: store } = props;
    const [callee, setCallee] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [callerId, setCallerId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [calloutPopoverVisible, setCalloutPopoverVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [calloutToNumber, setCalloutToNumber] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    (0, $acw62.useEffect)(()=>{
        const { start: start, stop: stop } = (0, $19c7c91c3db9a28d$export$a73b5fdcdd74f27d)(()=>{
            if (callerId === "" && store.callerIds.length > 0) setCallerId(store.callerIds[0]);
        });
        start();
        return ()=>stop();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                id: "logout-btn",
                onClick: ()=>store.logout(),
                children: "Log out"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                direction: "vertical",
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                        children: "Inbound Call"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $69754065fe3b4b60$export$2e2bcd8739ae039).Text, {
                        children: [
                            "Logged in as",
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    store.extInfo?.contact?.firstName,
                                    " ",
                                    store.extInfo?.contact?.lastName
                                ]
                            }),
                            ". You may dial ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: store.primaryNumber
                            }),
                            " ",
                            "to reach this web phone."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                        children: "Outbound Call"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039), {
                            labelCol: {
                                span: 8
                            },
                            wrapperCol: {
                                span: 16
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                    label: "From",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                        value: callerId,
                                        onChange: (value)=>setCallerId(value),
                                        style: {
                                            width: "10rem"
                                        },
                                        options: store.callerIds.map((n)=>({
                                                value: n,
                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: n
                                                })
                                            }))
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                    label: "To",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                        placeholder: "16501234567",
                                        style: {
                                            width: "10rem"
                                        },
                                        onChange: (e)=>setCallee(e.target.value.trim()),
                                        value: callee
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                    wrapperCol: {
                                        offset: 8,
                                        span: 16
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        onClick: ()=>store.webPhone.call(callee, callerId),
                                        disabled: callee.trim().length < 3,
                                        block: true,
                                        children: "Call"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                        children: "Call Sessions"
                    }),
                    store.webPhone && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            store.webPhone.callSessions.map((callSession)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c98ebc86ec71d41a$export$2e2bcd8739ae039), {
                                        callSession: callSession
                                    })
                                }, callSession.callId)),
                            store.webPhone.callSessions.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: "No sessions"
                            }),
                            !store.webPhone.callSessions.find((s)=>s.isConference) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                        children: "Conference"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                        onClick: ()=>store.startConference(),
                                        children: "Start a conference"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                        children: "Call Control API"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "This part is for demonstration only.",
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://developers.ringcentral.com/api-reference/Call-Control/createCallOutCallSession",
                                target: "_blank",
                                children: "Call Control API"
                            }),
                            " ",
                            "is RESTful API, which is out of scope of WebPhone SDK."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50a5b629c434844e$export$2e2bcd8739ae039), {
                        open: calloutPopoverVisible,
                        onOpenChange: (visible)=>setCalloutPopoverVisible(visible),
                        trigger: "click",
                        placement: "top",
                        content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                            direction: "vertical",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                    placeholder: "16501234567",
                                    value: calloutToNumber,
                                    onChange: (e)=>setCalloutToNumber(e.target.value.trim())
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        // todo: make call out to calloutToNumber
                                        store.callout(calloutToNumber);
                                        setCalloutPopoverVisible(false);
                                    },
                                    children: "Make CallOut"
                                }),
                                "Ref:",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "https://developers.ringcentral.com/api-reference/Call-Control/createCallOutCallSession",
                                    target: "_blank",
                                    children: "Documentation"
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            children: "Call out"
                        })
                    })
                ]
            })
        ]
    });
});
var $338fbb5c0bbf24ff$export$2e2bcd8739ae039 = $338fbb5c0bbf24ff$var$Phone;


const $f449f0b23fbc743a$var$App = (0, $9d5e52e8f220d71a$export$dfb5619354ba860)((props)=>{
    const { store: store } = props;
    const [api, contextHolder] = (0, $b5c555d97e03a3da$export$2e2bcd8739ae039).useNotification();
    globalThis.notifier = api;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69754065fe3b4b60$export$2e2bcd8739ae039).Title, {
                children: "RingCentral Web Phone Demo for latest SDK"
            }),
            store.rcToken === "" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $303f84e1345ee0d8$export$2e2bcd8739ae039), {
                store: store
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $338fbb5c0bbf24ff$export$2e2bcd8739ae039), {
                store: store
            })
        ]
    });
});
var $f449f0b23fbc743a$export$2e2bcd8739ae039 = $f449f0b23fbc743a$var$App;








const $c262c51f2f04b114$var$init = async ()=>{
    // load credentials from local
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).rcToken = await (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).getItem("rcToken") ?? "";
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).refreshToken = await (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).getItem("refreshToken") ?? "";
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).server = await (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).getItem("server") ?? "https://platform.ringcentral.com";
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).clientId = await (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).getItem("clientId") ?? "";
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).clientSecret = await (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).getItem("clientSecret") ?? "";
    (0, $505741c010a7fc0c$export$2e2bcd8739ae039).jwtToken = await (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).getItem("jwtToken") ?? "";
    // auto save credentials to local
    const { start: start } = (0, $19c7c91c3db9a28d$export$a73b5fdcdd74f27d)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).setItem("rcToken", (0, $505741c010a7fc0c$export$2e2bcd8739ae039).rcToken);
        (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).setItem("refreshToken", (0, $505741c010a7fc0c$export$2e2bcd8739ae039).refreshToken);
        (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).setItem("server", (0, $505741c010a7fc0c$export$2e2bcd8739ae039).server);
        (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).setItem("clientId", (0, $505741c010a7fc0c$export$2e2bcd8739ae039).clientId);
        (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).setItem("clientSecret", (0, $505741c010a7fc0c$export$2e2bcd8739ae039).clientSecret);
        (0, (/*@__PURE__*/$parcel$interopDefault($26ce26772c045640$exports))).setItem("jwtToken", (0, $505741c010a7fc0c$export$2e2bcd8739ae039).jwtToken);
    });
    start();
    const refreshToken = async ()=>{
        if ((0, $505741c010a7fc0c$export$2e2bcd8739ae039).rcToken !== "") {
            const rc = new (0, $c5c4d7a0138a22c4$export$2e2bcd8739ae039)({
                server: (0, $505741c010a7fc0c$export$2e2bcd8739ae039).server,
                clientId: (0, $505741c010a7fc0c$export$2e2bcd8739ae039).clientId,
                clientSecret: (0, $505741c010a7fc0c$export$2e2bcd8739ae039).clientSecret
            });
            rc.token = {
                access_token: (0, $505741c010a7fc0c$export$2e2bcd8739ae039).rcToken,
                refresh_token: (0, $505741c010a7fc0c$export$2e2bcd8739ae039).refreshToken
            };
            try {
                await rc.refresh();
                (0, $505741c010a7fc0c$export$2e2bcd8739ae039).rcToken = rc.token.access_token;
                (0, $505741c010a7fc0c$export$2e2bcd8739ae039).refreshToken = rc.token.refresh_token;
            } catch  {
                (0, $505741c010a7fc0c$export$2e2bcd8739ae039).rcToken = "";
                (0, $505741c010a7fc0c$export$2e2bcd8739ae039).refreshToken = "";
            }
        }
    };
    // auto refresh token every 30 minutes
    await refreshToken();
    setInterval(()=>refreshToken(), 1800000);
    // in case there is a valid token from local storage
    (0, $b4ef3299fe14c7b5$export$2e2bcd8739ae039)();
};
var $c262c51f2f04b114$export$2e2bcd8739ae039 = $c262c51f2f04b114$var$init;


const $70fc9a727fa662ae$var$container = document.createElement("div");
document.body.appendChild($70fc9a727fa662ae$var$container);
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f449f0b23fbc743a$export$2e2bcd8739ae039), {
        store: (0, $505741c010a7fc0c$export$2e2bcd8739ae039)
    })
}));
(0, $c262c51f2f04b114$export$2e2bcd8739ae039)();


//# sourceMappingURL=web-phone-demo.c0e8d088.js.map
